import { useEffect, useRef, useState, useMemo } from "react";
import { io } from "socket.io-client";
import { NavLink, useLocation } from "react-router-dom";
import Loader from "../Loader/Loader";
import axios from "axios";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";
import "../utils.css"; 

import { 
	Page, Close, Input, MissionTemplate, MesComptes, useScrollInfini, sauvegarderDansIndexedDB,
	ModifierTemplate, ConfirmationTemplate, ComptesRecentsTemplate, PageTemplate, PopupDuBasTemplate, VideosPageTemplate, VideoMiniatureTemplate, MesComptesTemplate,
	PopupBasTextareaTemplate, MenuPopupTemplate, MenuBasTemplate, MenuAvecIconeTemplate, MessageTemplate, PagesGererTemplate, GestionPageTemplate, ProfilTemplate,
	SeeVideoTemplate, SeePhotoTemplate, AnnoncesTemplate, AfficherAnnonceTemplate, InfosTemplate, MonetizationEntrer, PortefeuilleSortie,
	GenererMiniatureVideo, SpeedMessages, envoyerPOST, envoyerPUT, getAllData, rechercherAvecFuse, useScrollIndexedDB, AdapterLien
	} from "../utils";
		
import { missions } from "../missions";
import BackSansUseNavigate from "../Back/BackSansUseNavigate";

import {
  SvgAdd, SvgAdd3, SvgAdd5, SvgAngryAA, SvgBottom2, SvgBottom4, SvgBottom5, SvgBadge,
  SvgCheckbox, SvgCheckboxNoActive, SvgClose2, SvgClose3, SvgClose4, SvgCamera, SvgCamera3, SvgCommentAA, SvgDash3, SvgDislove, SvgDislike, SvgDissad,
  SvgExit, SvgExplore, SvgFile, SvgFire, SvgFavoris, SvgFullScreen2, SvgGlobeAfricaAA, 
  SvgHome, SvgHome2, SvgHome3, SvgHome4, SvgHorizontal, SvgHorizontal3, SvgInfos, SvgInfos2, SvgInfos3, SvgInfos4, SvgImage, SvgOneImage3,
  SvgLogin, SvgLogout, SvgLogout2, SvgLogout3, SvgLogout4, SvgLeft, SvgLeft2, SvgLeft3, SvgLeft4, SvgLike, SvgLove, SvgLove2, SvgLaughAA,
  SvgMaps, SvgMaps2, SvgMark1, SvgMark2, SvgMenu, SvgMenu2, SvgMenu3, SvgMenu4, SvgMenu5, SvgMoneyBag, SvgMessage, SvgMessage01, SvgMessage3, SvgMessage4, SvgMessage10, 
  SvgMessage11, SvgNewOnglet, SvgNotification,
  SvgPopularity, SvgPointsHorizontal, SvgPointsHorizontal2, SvgPointsVertical, SvgProfil, SvgProfil2, SvgProfil3, SvgProfil4, SvgProfil5, SvgPay, SvgPlay2, SvgPlay3, 
  SvgPlay6, SvgPause2, SvgPhoneNumber, SvgPencil3, Svg1Photo3, Svg3Photo3, SvgQuestionMark3,
  SvgRefresh, SvgRight, SvgRight2, SvgRight3, SvgRight4, SvgRight5, SvgSearch, SvgSearch2, SvgSearch3, SvgSearch5, SvgSad, SvgSend, SvgShare, SvgSettings, SvgSurprisedAA,
  SvgTranslation, SvgTranslate, SvgToggleActive, SvgToggleInactive, SvgText, SvgText3,
  SvgVirtualNumber, SvgVirtualNumber2, SvgValidate3, SvgValidate4, SvgValidate5, SvgValidate6, SvgVertical, SvgVideo3, SvgVideo5, SvgVideo6, SvgVideo7, SvgVideo8, 
  SvgVideo9, SvgVideo10, SvgVolumeOn2, SvgVolumeOff2
} from "../Svg/Svg";


// image, logo
import photoBlanche from "../img/photoBlanche.jpg";
import tictac from "../img/tictac.jpg";
import chaussure from "../img/chaussure.jpg";
import hotel from "../img/hotel.jpg";
import chambre from "../img/chambre.jpg";
import investir from "../img/investir.jpg";
import investirPhotoProfil from "../img/investir.jpg";
import voiture from "../img/voiture.jpg";
import nourriture from "../img/nourriture.jpg";
import imageLivre from "../img/book2.jpg";
import alraniLogo from "../img/alraniLogo.png";
//import alraniEcranDemarrage from "../img/alraniEcranDemarrage.png";
//import donaziaEcranDemarrage from "../img/donaziaEcranDemarrage.png";
import donaziaLogo from "../img/donaziaLogo.png"; //d
import donaziaLogoAccueil from "../img/donaziaLogoAccueil.png";
import florinatoLogo from "../img/florinatoLogo.png";
import florinatoEcranDemarrage from "../img/florinatoEcranDemarrage.png";
import xLogo from "../img/xLogo.jpg";
import flagCongo from "../img/flagCongo.jpg";
import izocashLogo from "../img/izocashLogo.jpg"; //i
import izocashWhite from "../img/izocashWhite.png";
import izocashEcranDemmarrage from "../img/izocashEcranDemmarage.png";
import izocashLogoAccueil from "../img/izocashLogoAccueil.png";
import izocashLogoConnexion from "../img/izocashLogoConnexion.png";
import izocashLogoJaune from "../img/izocashLogoJaune.png";
import vbLogo from "../img/vbLogo.jpg";
import vixinolLogo from "../img/vixinolLogo.png";
import vixinolLogoEcranDemarrage from "../img/vixinolLogoEcranDemarrage.png";
import zimagicLogo from "../img/zimagicLogo.jpg";
import weidLogo from "../img/weidLogo.png";
import ertidenLogo from "../img/ertidenLogo.png";
import officialLogo from "../img/officialLogo.png";
import settingsLogo from "../img/settingsLogo.jpg";
import bavardageLogo from "../img/bavardageLogo.png";



/* convertir une date au format local (on convertit en fonction des parametres de l'horaire 
du téléphone de l'utilisateur) */
// ici c'est dateParser qui est en chiffres uniquement (ex: 10/02/2000)
const dateParser = (date) => {
  let newDate = new Date(date).toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
  return newDate;
};

// dateParserLong
// ici c'est dateParser qui est long (ex: 10 février 2000, 20:58)
const dateParserLong = (date) => {
  let newDate = new Date(date).toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
  return newDate;
};

/* l'id developpeur va nous permettre d'afficher certaines fonctionnaliter seulement 
  a celui qui a un compte developpeur */
  const developer = localStorage.getItem("dev");
  const dev = developer === "1";



//ChildApi 66florinatoApp
function ChildApi66florinatoApp({ api, onlineUsers, utilisateursQuiEcrivent, idCompteConnecter, profilMap, messageMap }) {
  //const idPersonConnectedFA = localStorage.getItem("idPersonConnectedFA");

  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const idOther = api.idOther;
    if(idOther) { 
      localStorage.setItem("idOther", idOther); 
      localStorage.setItem("idAccountChef", idOther);
    }

    const idGroupOther = api.idGroupOther;
    if(idGroupOther) { localStorage.setItem("idGroupChef", idGroupOther); }


    if (api.idAccount === idCompteConnecter) {  //logique pour obtenir l'id de la personne qui va recevoir mon message
      const id = api.idOther;
      const idUser = api.idUserOther;
      localStorage.setItem("idOther", id);      
      localStorage.setItem("idUser", idUser);
    } else {
      const id = api.idAccount;
      const idUser = api.idUser;
      localStorage.setItem("idOther", id);
      localStorage.setItem("idUser", idUser);
      localStorage.setItem("idAccountChef", id);
    }
  }


  // afficher le groupe
  async function GoTogroupOtherFA() {
    const one = "1";
    const zero = "0";
    localStorage.setItem("GoTogroupOtherFA", one);
    localStorage.setItem("GoTomessageFA", zero);
  }

  // aller vers la page du message
  async function GoTomessageFA() {
    const one = "1";
    const zero = "0";
    localStorage.setItem("GoTomessageFA", one);
    localStorage.setItem("GoTogroupOtherFA", zero);
  }
  
  //afficher les messages uniquement aux personnes concernées (cette logique nous permet d'éviter que les messages que j'ai envoyé ou recu puissent s'afficher a tout le monde)
  const idAccount = api.idAccount === idCompteConnecter;
  const idOther = api.idOther === idCompteConnecter;
  
  // pour obtenir les informations du profil
  const idUtiliser = idAccount ? api.idOther:idOther ? api.idAccount : null; // logique pour savoir si c'est l'id de l'expediteur ou du destinataire
  const profil = idUtiliser ? profilMap[idUtiliser] : null;
  
  const photo = profil?.photoProfile ?? photoBlanche;
  const nom = profil?.nameAccount ?? "";
  

  // On récupère le message récent pour chaque conversation
  const messageRecent = api._id ? messageMap[api._id] : null;
  
  /*
    api._id = l’ID de la conversation
	messageMap[api._id] = le dernier message lié à cette conversation
	messageRecent.message = le texte à afficher */
	

  const id = api.idAccount === idCompteConnecter && api.follow === "1";
  
  const isOnline = onlineUsers.includes(idUtiliser);
  const idConversation = api._id;
  
  
  return (<>
    <div className="child" onClick={Checked}>
      {api.type === "30" && idAccount && (<> {/* type=30 , (conversation que j'ai envoyé à Other) */}
      <div className="type30" onClick={GoTomessageFA}>
        <div className="A"> <img src={photo} alt=""/> </div>

        <div className="B">
          <div className="a"> <p>{nom}</p> </div>
          <div className="b"> <p>{messageRecent?.message || ""}</p> </div>

		  {isOnline && (
		  <div className="connecter"> <p>En Ligne</p> <SvgMark1/> </div>)}
		  {utilisateursQuiEcrivent[idConversation] && (<div className="b"> <p>✍️ Écris ..</p> </div>)}
        </div>
        {/* B */}
      </div></>)}
      {/* type=30 , Account */}

      {api.type === "30" && idOther && (<> {/* type=30 , (conversation que Other à reçu) */}
      <div className="type30" onClick={GoTomessageFA}>
        <div className="A"> <img src={photo} alt=""/> </div>

        <div className="B">
			<div className="a"> <p>{nom}</p> </div>
			<div className="b"> <p>{messageRecent?.message || ""}</p> </div>

			{isOnline && (
			<div className="connecter"> <p>En Ligne</p> <SvgMark1/> </div>)}
			{utilisateursQuiEcrivent[idConversation] && (<div className="b"> <p>✍️ Écris ..</p> </div>)}
        </div>
        {/* B */}
      </div></>)}
      {/* type=30 , Other */}

    
      {api.type === "50" && id && (<> {/* type=50 , je me suis abonné */}
      <div className="type50" onClick={GoTogroupOtherFA}>
        <div className="A"> <img src={photo} alt=""/> </div>

        <div className="B">
          <div className="a"> <pre>{nom}</pre> </div>
          <div className="a"> <pre>{api.lastMessage}</pre> </div>
          <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
        </div>
        {/* B */}		
      </div></>)}
      {/* type=50 , je me suis abonné */}
    </div>
    {/* child */}
    </>
  );
} 
//ChildApi 66florinatoApp


//ChildApi 66delivrerNumeroVirtuelAf (on affiche la liste des numeros virtuels délivrés)
function ChildApi66delivrerNumeroVirtuelAf({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
  }

  return (
    <>
    <div className="child" onClick={Checked}>
      
      {api.type === "1" && (<> {/* type=1, on affiche la liste des numeros virtuels délivrés */}
      <div className="type1">
        <div className="a"> <p>{api.virtualNumber}</p> </div>
        <div className="b"> <pre>{api.name}</pre> </div>
        <div className="c"> <p>{api.sex}</p> </div>
        <div className="d"> <p>{api.country}</p> </div>
      </div></>)}
      {/* type=1 */}
    </div>
    {/* child */}
    </>
  );
}
//ChildApi 66delivrerNumeroVirtuelAf



//ChildApi66accountsFA
export function ChildApi66accountsFA({ api, idCompteConnecter }) {
  const [checked, setChecked] = useState(false);
  async function Checked() { setChecked(!checked); }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  const idUserConnectedFA = localStorage.getItem("idUserConnectedFA");
  const id = api.idUser === idUserConnectedFA;

  const id2 = api._id === idCompteConnecter;

  return (<>
    {id2 && api.type === "10" && id && (<> {/* on affiche mon compte florinato connecté */}
    <div className="child" onClick={Checked}>
      <div className="type10">
        <div className="connecter"> <p>Connecté</p> <SvgMark1/> </div>

        <div className="block">
          <div className="block-un"><img src={api.photoProfile} alt=""/></div>

          <div className="block-deux">
            <div className="a"> <p>{api.nameAccount}</p> </div>
            <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
            <div className="c"> <p>Date de création</p> </div>
          </div>
          {/* block-deux */}
        </div>
        {/* block */}
      </div>
      {/* type10 */}
    </div>
    {/* child */}
	</>)}
	
</>)}
//ChildApi66accountsFA


//ChildApi266accountsFA
export function ChildApi266accountsFA({ api2, idCompteConnecter }) {	
  const [checked, setChecked] = useState(false);
  async function Checked() { setChecked(!checked); }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  const idUserConnectedFA = localStorage.getItem("idUserConnectedFA");
  const id = api2.idUser === idUserConnectedFA;

  const id2 = api2._id === idCompteConnecter;

  return (
    <>
    <div className="child" onClick={Checked}>
      {!id2 && api2.type === "10" && id && (<> {/* on affiche mes comptes florinato (non connecté) */}
      <div className="type10">
        <div className="block-un"> <img src={api2.photoProfile} alt=""/> </div>

        <div className="block-deux">
          <div className="a"> <p>{api2.nameAccount}</p> </div>
          <div className="b"> <p>{dateParser(api2.createdAt)}</p> </div>
          <div className="c"> <p>Date de création</p> </div>
        </div>
        {/* block-deux */}
      </div>
      {/* type10 */}
      </>)} 
      {/* on affiche mes comptes florinato */}
    </div>
    {/* child */}
    </>
  );
} 
//ChildApi266accountsFA


// ChildApi 66favoriteFA
//on affiche tout ce qu'on a ajouter dans nos favoris florinato
function ChildApi66favoriteFA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const type = api.type;
    const id = api._id;
    if(id) { 
      localStorage.setItem("id", id); 
      localStorage.setItem("idreq", id); 
      localStorage.setItem("type", type); 
      localStorage.setItem("idFavorite", id); 
      localStorage.setItem("idFavoritereq", id); 
    }
    
    const urlVideo = api.urlVideo;
    if(urlVideo) { 
      localStorage.setItem("urlVideo", urlVideo); 
      localStorage.setItem("urlVideoreq", urlVideo); 
    }

    const urlPhoto = api.urlPhoto; // url de la photo
    if (urlPhoto) { 
      localStorage.setItem("urlPhoto", urlPhoto); 
      localStorage.setItem("urlPhotoreq", urlPhoto);
    }
  }

  // go to writeMessagePage (ca va afficher la page pour ecrire un message et envoyer la photo)
  async function GoToWriteMessagePage() {
    const writeMessagePage = "1";
    localStorage.setItem("GoToWriteMessagePageFA", writeMessagePage);
  }


  return (
    <>
    <div onClick={Checked}>
      {api.type === "20" && (<>
      <div className="block-one">
        <div className="b"> <img onClick={GoToWriteMessagePage} src={api.urlPhoto} alt=""/> </div>
      </div>
        </>)}
      {/* block-one */}

        {api.type === "21" && (<>
        <div className="block-one">
          <div className="b"> <img onClick={GoToWriteMessagePage} src={api.urlPhoto} alt=""/> </div>
        </div>
        video
        </>)}
      {/* block-one */}
    </div>
    </>
  );
}
//ChildApi66favoriteFA


// ChildApi 66favorite66selectedFA
//on affiche tout ce qu'on a ajouter dans nos favoris florinato
function ChildApi66favorite66selectedFA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const id = api._id;
    if(id) { 
      localStorage.setItem("id", id); 
      localStorage.setItem("idreq", id); 
      localStorage.setItem("idFavorite", id); 
      localStorage.setItem("idFavoritereq", id); 
    }
    
    const urlVideo = api.urlVideo;
    if(urlVideo) { localStorage.setItem("urlVideoreq", urlVideo); }

    const urlPhoto = api.urlPhoto; // url de la photo
    if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }
  }

  // go to writeMessagePage (ca va afficher la page pour ecrire un message et envoyer la photo)
  async function photoGoToWriteMessagePage() {
    const one = "1";
    const type = "42";
    localStorage.setItem("GoToWriteMessagePage66selectedFA", one);
    localStorage.setItem("typereq", type);
  }

  async function videoGoToWriteMessagePage() {
    const one = "1";
    const type = "43";
    localStorage.setItem("GoToWriteMessagePage66selectedFA", one);
    localStorage.setItem("typereq", type);
  }

  return (
    <>
    <div onClick={Checked}>
      {api.type === "20" && (<>
      <div className="block-one">
        <div className="b"> <img onClick={photoGoToWriteMessagePage} src={api.urlPhoto} alt=""/> </div>
      </div> </>)}
      {/* block-one */}

        {api.type === "21" && (<>
        <div className="block-one">
          <div className="b"> <img onClick={videoGoToWriteMessagePage} src={api.urlPhoto} alt=""/> </div>
        </div>
        video
        </>)}
      {/* block-one */}
    </div>
    </>
  );
}
//ChildApi66favorite66selectedFA


//ChildApi 66jeuxFA
function ChildApi66jeuxFA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
  }

  const idOther = localStorage.getItem("idAccountChef");
  const id = api.idOther === idOther;

  return (
    <>
    <div className="child" onClick={Checked}>
      
      {api.type === "100" && id && (<> {/* type=100 , jeux */}
      <div className="type100">
        <div className="a"> <img src={api.urlPhoto} alt=""/> </div>
        <div className="b"> <p>{api.typeOther}</p> </div>              
      </div></>)} 
      {/* type=100 */}
    </div>
    </>
  );
} 
//ChildApi 66jeuxFA
    


//ChildApi 66groupOtherFA
function ChildApi66groupOtherFA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const idOther = api.idAccount;
    const idMessageOther = api._id;

    if(idOther) { 
      localStorage.setItem("idOther", idOther); 
      localStorage.setItem("idAccount", idOther);  //on a ajouter ça à cause du filtre des informations de l'autre qui se fait en bas-labas, pour que ça puisse filtrer nameOther, photoOther, badgeOther
      localStorage.setItem("idMessageOther", idMessageOther); 
    }
  }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  //afficher ce que j'ai cliqué
  async function GoToselectedFA() {
    const one = "1";
    const gettype = "41";
    const urlPhoto = api.urlPhoto;
    const urlVideo = api.urlVideo;
    const message = api.message;
    const typeOther = api.typeOther;
    const type = api.type;
    const id = api._id;
    localStorage.setItem("GoToselectedFA", one);
    localStorage.setItem("typereq", gettype); 
    localStorage.setItem("id", id); 
    localStorage.setItem("idreq", id); 
    localStorage.setItem("type", type); 
    localStorage.setItem("typeOtherreq", type); 
    localStorage.setItem("typeOther", typeOther); //typeOther c'est le type de la personne qu'il a répondu, c'est pas le type de la personne qu'on a selectionner (cest utilisé 66selectedFA pour afficher le message de la personne qu'il a répondu)
    localStorage.setItem("message", message); 
    localStorage.setItem("messageOther", message); 
    localStorage.setItem("urlPhoto", urlPhoto);
    localStorage.setItem("urlPhotoOther", urlPhoto);
    localStorage.setItem("urlPhotoreq", urlPhoto); 
    localStorage.setItem("urlVideo", urlVideo);
    localStorage.setItem("urlVideoOther", urlVideo);
    localStorage.setItem("urlVideoreq", urlVideo); 
  }

  async function otherGoToselectedFA() {
    const one = "1";
    const type = "41";
    const urlPhotoOther = api.urlPhotoOther;
    const urlVideoOther = api.urlVideoOther;
    const messageOther = api.messageOther;
    const typeOther = api.typeOther;
    const id = api._id;
    localStorage.setItem("GoToselectedFA", one);
    localStorage.setItem("id", id); 
    localStorage.setItem("idreq", id); 
    localStorage.setItem("type", typeOther); //on a mis ça pour afficher la photo ou vidéo de l'autre 66selectedFA
    localStorage.setItem("typeOtherreq", typeOther); 
    localStorage.setItem("typeOther", typeOther); //typeOther c'est le type de la personne qu'il a répondu, c'est pas le type de la personne qu'on a selectionner (cest utilisé 66selectedFA pour afficher le message de la personne qu'il a répondu)
    localStorage.setItem("typereq", type);
    localStorage.setItem("message", messageOther); 
    localStorage.setItem("messageOther", messageOther); 
    localStorage.setItem("urlPhoto", urlPhotoOther);
    localStorage.setItem("urlPhotoOther", urlPhotoOther);
    localStorage.setItem("urlPhotoreq", urlPhotoOther); 
    localStorage.setItem("urlVideo", urlVideoOther);
    localStorage.setItem("urlVideoOther", urlVideoOther);
    localStorage.setItem("urlVideoreq", urlVideoOther); 
  }
  
  //const idAccount = localStorage.getItem("idAccountChef");
  const idGroup = localStorage.getItem("idGroupChef");
  const idOther = localStorage.getItem("idOther");
  //const id = api.idAccount === idAccount && api.group === "1";
  const id = api.idGroupChef === idGroup && api.group === "1";
  const id2 = api.idAccount === idOther && api.group === "1";
  //const id2 = api.idAccount && api.group === "1";

  return (
    <>
    <div className="child" onClick={Checked}>
      {api.type === "1" && id && (<> {/* type=1 , message text*/}
      <div className="type1" onClick={GoToselectedFA}>
        <div className="block-un"> <img src={api.photoAccount} alt=""/> </div>

        <div className="block-deux">
          <div className="a"> <pre>{api.nameAccount}</pre> </div>
          <div className="b"> <pre>{api.message}</pre> </div>
          <div className="c"> <p></p> <p>{dateParser(api.createdAt)}</p> </div>
        </div>
        {/* block-deux */}
      </div> </>)}
      {/* type=1 , message text  */}


      {api.type === "2" && id && (<> {/* type=2 , photo*/}
      <div className="type2" onClick={GoToselectedFA}>
        <div className="block-un"> <img src={api.photoAccount} alt=""/> </div>

        <div className="block-deux"> 
          <div className="a"> <pre>{api.nameAccount}</pre> </div>
          <div className="b"> <img src={api.urlPhoto} alt=""/> </div>
          <div className="c"> <pre>{api.message}</pre> </div>
          <div className="d"> <p></p> <p>{dateParser(api.createdAt)}</p> </div>
        </div>
        {/* block-deux */}
      </div> </>)}
      {/* type=2 , photo  */}


    {api.type === "3" && id && (<> {/* type=3 , video*/}
    <div className="type3" onClick={GoToselectedFA}>
      <div className="block-un"> <img src={api.photoAccount} alt=""/> </div>

      <div className="block-deux">
        <div className="a"> <pre>{api.nameAccount}</pre> </div>

        <div className="b">
          <div className="aa"> <img src={api.urlPhoto} alt=""/> </div>
          <div className="bb"> <button><SvgPlay6/></button> </div>
        </div>

        <div className="c"> <pre>{api.message}</pre> </div>
        <div className="d"> <p></p> <p>{dateParser(api.createdAt)}</p> </div>
      </div>
      {/* block-deux */}
    </div> </>)}
    {/* type=3 , video  */}


    {api.type === "41" && id && (<> {/* type=41, reponse text */} 
    <div className="type40">
      <div className="A" onClick={otherGoToselectedFA}> 
        <div className="block-un"> <img src={api.photoOther} alt=""/> <pre>{api.nameOther}</pre> </div>

        {api.typeOther === "1" && (<>
        <div className="block-deux"> <pre>{api.messageOther}</pre> </div></>)}

        {api.typeOther === "41" && (<>
        <div className="block-deux"> <pre>{api.messageOther}</pre> </div></>)}


        {api.typeOther === "2" && (<>
        <div className="block-trois"> <img src={api.urlPhotoOther} alt=""/> <pre>{api.messageOther}</pre> </div></>)}

        {api.typeOther === "42" && (<>
        <div className="block-trois"> <img src={api.urlPhotoOther} alt=""/> <pre>{api.messageOther}</pre> </div></>)}


        {api.typeOther === "3" && (<>
        <div className="block-quatre">
          <div className="a">
            <div className="aa"> <img src={api.urlPhotoOther} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.messageOther}</pre> </div>
        </div></>)}

        {api.typeOther === "43" && (<>
        <div className="block-quatre">
          <div className="a">
            <div className="aa"> <img src={api.urlPhotoOther} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.messageOther}</pre> </div>
        </div></>)}
        {/* block-quatre */}
      </div>
      {/* A */}

      <div className="B" onClick={GoToselectedFA}>
        <div className="block-un"> <pre>{api.message}</pre> </div>

        <div className="block-quatre">
          <div className="a"> <img src={api.photoAccount} alt=""/> </div>

          <div className="b">
            <div className="aa"> <pre>{api.nameAccount}</pre> </div>
            <div className="bb"> <p>{dateParser(api.createdAt)}</p> </div>
          </div>
          {/* b */}
        </div>
        {/* block-quatre */}
      </div>
      {/* B */}
    </div></>)}
    {/* type=41, reponse text */}


    {api.type === "42" && id && (<> {/* type=42, reponse photo */}
    <div className="type40">
      <div className="A" onClick={otherGoToselectedFA}> 
        <div className="block-un"> <img src={api.photoOther} alt=""/> <pre>{api.nameOther}</pre> </div>

        {api.typeOther === "1" && (<>
        <div className="block-deux"> <pre>{api.messageOther}</pre> </div></>)}

        {api.typeOther === "41" && (<>
        <div className="block-deux"> <pre>{api.messageOther}</pre> </div></>)}


        {api.typeOther === "2" && (<>
        <div className="block-trois"> <img src={api.urlPhotoOther} alt=""/> <pre>{api.messageOther}</pre> </div></>)}

        {api.typeOther === "42" && (<>
        <div className="block-trois"> <img src={api.urlPhotoOther} alt=""/> <pre>{api.messageOther}</pre> </div></>)}


        {api.typeOther === "3" && (<>
        <div className="block-quatre">
          <div className="a">
            <div className="aa"> <img src={api.urlPhotoOther} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.messageOther}</pre> </div>
        </div></>)}

        {api.typeOther === "43" && (<>
        <div className="block-quatre">
          <div className="a">
            <div className="aa"> <img src={api.urlPhotoOther} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.messageOther}</pre> </div>
        </div></>)}
        {/* block-quatre */}
      </div>
      {/* A */}

      <div className="B" onClick={GoToselectedFA}>
        <div className="block-deux">
          <div className="a"> <img src={api.urlPhoto} alt=""/> </div>
          <div className="b"> <pre>{api.message}</pre> </div>
        </div>

        <div className="block-quatre">
          <div className="a"> <img src={api.photoAccount} alt=""/> </div>

          <div className="b">
            <div className="aa"> <pre>{api.nameAccount}</pre> </div>
            <div className="bb"> <p>{dateParser(api.createdAt)}</p> </div>
          </div>
          {/* b */}
        </div>
        {/* block-quatre */}
      </div>
      {/* B */}
    </div> </>)}
    {/* type=42, reponse photo */}


    {api.type === "43" && id && (<> {/* type=43, reponse video */}
    <div className="type40">
      <div className="A" onClick={otherGoToselectedFA}> 
        <div className="block-un"> <img src={api.photoOther} alt=""/> <pre>{api.nameOther}</pre> </div>

        {api.typeOther === "1" && (<> {/* je peux repondre par video à un message text */}
        <div className="block-deux"> <pre>{api.messageOther}</pre> </div></>)}

        {api.typeOther === "41" && (<> {/* je peux repondre par video à une réponse text */}
        <div className="block-deux"> <pre>{api.messageOther}</pre> </div></>)}


        {api.typeOther === "2" && (<> {/* je peux repondre par video à un message photo */}
        <div className="block-trois"> <img src={api.urlPhotoOther} alt=""/> <pre>{api.messageOther}</pre> </div></>)}

        {api.typeOther === "42" && (<> {/* je peux repondre par video à une réponse photo */}
        <div className="block-trois"> <img src={api.urlPhotoOther} alt=""/> <pre>{api.messageOther}</pre> </div></>)}


        {api.typeOther === "3" && (<> {/* je peux repondre par video à un message video */}
        <div className="block-quatre">
          <div className="a">
            <div className="aa"> <img src={api.urlPhotoOther} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.messageOther}</pre> </div>
        </div></>)}

        {api.typeOther === "43" && (<> {/* je peux repondre par video à une réponse video */}
        <div className="block-quatre">
          <div className="a">
            <div className="aa"> <img src={api.urlPhotoOther} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.messageOther}</pre> </div>
        </div></>)}
        {/* block-quatre */}
      </div>
      {/* A */}

      <div className="B"  onClick={GoToselectedFA}>
        <div className="block-trois">
          <div className="a">
            <div className="aa"> <img src={api.urlPhoto} alt=""/> </div>
            <div className="bb"> <button><SvgPlay2/></button> </div>
          </div>

          <div className="b"> <pre>{api.message}</pre> </div>
        </div>
        {/* block-trois */}

        <div className="block-quatre">
          <div className="a"> <img src={api.photoAccount} alt=""/> </div>

          <div className="b">
            <div className="aa"> <pre>{api.nameAccount}</pre> </div>
            <div className="bb"> <p>{dateParser(api.createdAt)}</p> </div>
          </div>
          {/* b */}
        </div>
        {/* block-quatre */}
      </div>
      {/* B */}
    </div> </>)}
    {/* type=43, reponse video */}


      {/*
      {api.type === "201" && (<> {/* type=201 , xxx a visité le groupe 
      <div className="type201" onClick={GoToselectedFA}>
        <div className="block-un"> <img src={api.photoAccount} alt=""/> </div>

        <div className="block-deux">
          <div className="a"> <pre>{api.nameAccount} a visité le groupe</pre> </div>
          <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
        </div>
        {/* block-deux 
      </div> </>)}
      {/* type=201 , xxx a visité le groupe  */}

      {api.type === "203" && id2 && (<> {/* type=203 , xxx a cliqué sur cette photo */}
      <div className="type203" onClick={GoToselectedFA}>
        <div className="block-un"> <img src={api.photoAccount} alt=""/> </div>

        <div className="block-deux">
          <div className="a"> <pre>{api.nameAccount} a cliqué sur cette video</pre> </div>
          <div className="b"> <p>{dateParser(api.createdAt)}</p> </div> 
        </div>

        <div className="block-trois"> <img src={api.urlPhoto} alt=""/> </div>
      </div> </>)}
      {/* type=203 , xxx a cliqué sur cette photo */}


      {api.type === "204" && id2 && (<> {/* type=204 , xxx a cliqué sur cette video */}
      <div className="type204" onClick={GoToselectedFA}>
        <div className="block-un"> <img src={api.photoAccount} alt=""/> </div>

        <div className="block-deux">
          <div className="a"> <pre>{api.nameAccount} a cliqué sur cette video</pre> </div>
          <div className="b"> <p>{dateParser(api.createdAt)}</p> </div> 
        </div>

        <div className="block-trois"> <img src={api.urlPhoto} alt=""/> </div>
      </div> </>)}
      {/* type=204 , xxx a cliqué sur cette video */}
    </div>
    </>
  );
}
//ChildApi 66groupOtherFA



//ChildApi2 66profilFA
export function ChildApi266profilFA({ api2 }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
  }

  const idPersonConnectedFA = localStorage.getItem("idPersonConnectedFA");
  const id = api2.idAccountChef === idPersonConnectedFA

  return (
    <>
    <div className="child" onClick={Checked}>
            {api2.type === "200" && id && (<> {/* type=200 , xxx a visité votre compte */}
            <div className="type200">
              <div className="a"> <img src={api2.photoAccount} alt=""/> </div>
              <div className="b"> <pre>{api2.nameAccount} a visité votre compte</pre> </div>
              <div className="c"> <p>{dateParser(api2.createdAt)}</p> </div>
              {/* b */}
            </div>
            {/* type200 */}
          </>)}
          {/* type=200 , xxx  a visité votre compte  */}
    </div>
    {/* child */}
    </>
  );
}
//ChildApi2 66profilFA


//ChildApi2 66profilOtherFA
function ChildApi266profilOtherFA({ api2 }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
  }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };


  const idAccount = localStorage.getItem("idAccountChef");
  const id = api2.idAccountChef === idAccount;

  return (
    <>
    <div className="child" onClick={Checked}>
      {api2.type === "200" && id && (<> {/* type=200 , xxx a visité le compte */}
      <div className="type200">
        <div className="a"> <img src={api2.photoAccount} alt=""/> </div>

        <div className="b">
          <div className="aa"> <pre>{api2.nameAccount} a visité le compte</pre> </div>
          <div className="bb"> <p>{dateParser(api2.createdAt)}</p> </div>
        </div>
      </div> </>)} 
      {/* type=200 , xxx a visité le compte */}
    </div>
    {/* child */}
    </>
  );
} 
//ChildApi2 66profilOtherFA


//ChildApi 66profilOtherFA
function ChildApi66profilOtherFA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const message = api.message;
    const type = api.type;
    const id = api._id;
    if(id) { 
      localStorage.setItem("id", id); 
      localStorage.setItem("idreq", id); 
      localStorage.setItem("type", type); 
      localStorage.setItem("message", message); 
    }

    const urlVideo = api.urlVideo;
    if(urlVideo) { 
      localStorage.setItem("urlVideo", urlVideo); 
      localStorage.setItem("urlVideoreq", urlVideo); 
    }

    const image = api.urlPhoto;
    if(image) { 
      localStorage.setItem("urlPhoto", image); 
      localStorage.setItem("urlPhotoreq", image); 
    }
  }

   // GoToselectedFA (page pour afficher la photo sur laquelle on a cliquer)
   /*
   async function GoToselectedFA() {
    const selected = "1";
    localStorage.setItem("GoToselectedFA", selected);
  } */
  
  //redirect vers la page pour afficher la video
   async function GotoVideo() {
    const video = "1";
    const photo = "0";
	localStorage.setItem("gotoVideo", video);
    localStorage.setItem("gotoPhoto", photo);
  }
  
  //redirect vers la page pour afficher la photo
   async function GotoPhoto() {
    const video = "0";
    const photo = "1";
	localStorage.setItem("gotoVideo", video);
    localStorage.setItem("gotoPhoto", photo);
  }

  const idAccount = localStorage.getItem("idAccountChef");
  const id = api.idAccountChef === idAccount && api.account === "1";

  return (
    <>
    <div className="child" onClick={Checked}>
      {api.type === "3" && id && (<> {/* type=3 , video */}
      <div className="type3">
        <div className="a"> <img onClick={GotoVideo} src={api.urlPhoto} alt=""/> </div>
        <div className="b"> <button onClick={GotoVideo}><SvgPlay2/></button> </div>
      </div>
      {/* type3 */}
      </>)}
      {/* type=3 , video */}

      {api.type === "2" && id && (<> {/* type=2 , photo */}
      <div className="type2"> <img onClick={GotoPhoto} src={api.urlPhoto} alt=""/> </div>
      </>)}
      {/* type=2 , photo */}
    </div>
    {/* child */}
    </>
  );
}
//ChildApi2 66profilOtherFA


//ChildApi 66popularityAccountsPageFA
function ChildApi66popularityAccountsPageFA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const idAccount = api._id;
    if(idAccount) { 
      localStorage.setItem("idAccountChef", idAccount); 
      localStorage.setItem("idOther", idAccount); 
    }

    const photo = api.photoProfile;
    if(photo) { 
      localStorage.setItem("urlPhoto", photo); 
      localStorage.setItem("urlPhotoreq", photo); 
    }

    const idGroup = api.idGroup;
    if(idGroup) { localStorage.setItem("idGroupChef", idGroup); }
  }

  // GoToProfilOther (page pour afficher le compte sur laquelle j'ai cliqué)
  async function GoToProfilOther() {
    const go = "1";
    localStorage.setItem("GoToProfilOther", go);
  }

  return (
    <>
    <div className="child" onClick={Checked}>
      
      {api.type === "10" && (<> {/* type=10, on affiche les comptes populaires */}
      <div className="type10" onClick={GoToProfilOther}>
        <div className="a"> <p>{api.popularity}</p> </div>
        <div className="b"> <img src={api.photoProfile} alt=""/> </div>
        <div className="c"> <pre>{api.nameAccount}</pre> </div>
      </div></>)}
      {/* type=10 */}
    </div>
    {/* child */}
    </>
  );
}
//ChildApi 66popularityAccountsPageFA




//on affiche les messages privés dans l'application x
function ChildApiMessageXA({ api }) {
  const idPersonConnectedXA = localStorage.getItem("idPersonConnectedFA");
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const image = api.urlPhoto;
    if(image) { 
      localStorage.setItem("urlPhoto", image); 
      localStorage.setItem("urlPhotoreq", image); 
    }
    
    const date = api.createdAt;
    if(date) { localStorage.setItem("dateXA", date); }

    const idAccount = api.idAccount;
    if(idAccount) { localStorage.setItem("idOther", idAccount); }
  }

  const personConnected = api.idOwner === idPersonConnectedXA && api.type === "1";  //si idOwner egale idPersonConnectedXA cela veut dire c'est mon message, sinon cela veut dire que c'est le message de l'autre

  const [ladate, setDate] = useState(false);
  async function laDate() {
    setDate(!ladate);
  }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };


  // GoToDisplayPhotoXA (page pour afficher la photo sur laquelle on a cliquer)
  async function GoToDisplayPhotoXA() {
    const displayPhoto = "1";
    localStorage.setItem("GoToDisplayPhotoXA", displayPhoto);
  }


  const dev = localStorage.getItem("dev");

  return (
    <>
    <div onClick={Checked}>

        {/* son message (message que j'ai recu) */}
        {!personConnected && (<>
          <div onClick={laDate} className="receiver">

          {api.message && (<> {/* text */}
            <div className="block-one"> <pre>{api.message}</pre> </div>
          </>)} 
          
          {api.photo1 && (<> {/* photo */}
            <div className="block-two"> <img onClick={GoToDisplayPhotoXA} src={api.photo1} alt="" /> </div>
          </>)} 

          {api.urlVideo && (<> {/* video */}
            <div className="block-three">
              <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4" /></video>
              <hr />
            </div>
          </>)}
        </div>
        {/* receiver */}
        {ladate && (<><div className="date-denvoi-de-votre-message"> <p>{dateParser(api.createdAt)}</p> </div></>)}
        </>)}
        {/* son message (message que j'ai recu) */}


        {/* mon message (message que j'ai envoyé) */}
        {personConnected && (<>
          <div onClick={laDate} className="sender">

          {api.message && (<> {/* text */}
            <div className="block-one"> <pre>{api.message}</pre> </div>
          </>)} 
          
          {api.photo1 && (<> {/* photo */}
            <div className="block-two"> <img onClick={GoToDisplayPhotoXA} src={api.photo1} alt="" /> </div>
            <pre>{api.message}</pre>
          </>)} 

          {api.urlVideo && (<> {/* video */}
            <div className="block-three">
              <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4" /></video>
              <div className="hr"> <p></p> <hr /> </div>
            </div>
          </>)}

          
          {api.type === "101" && (<> {/* type=101 , xxx a clqué sur cette photo */}
            <div className="notification">
            <div className="block-trois">
              <div className="a"> <p>{api.nameOwner} a cliqué sur cette photo</p> </div>
              <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
              {/* b */}

              <div className="block-two"> <img onClick={GoToDisplayPhotoXA} src={api.photo1} alt="" /> </div>
            </div>
            {/* block-trois */}
            </div>
            {/* notification */}
          </>)}
          {/* type=101 , xxx a clqué sur cette photo */}

          {api.type === "102" && (<> {/* type=102 , aaa est dans X */}
            <div className="notification">
            <div className="block-trois">
              <div className="a"> <img onClick={GoToDisplayPhotoXA} src={api.photoOwner} alt="" /> </div>
              <div className="a"> <p>{api.nameOwner} est dans Découverte</p> </div>
              <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
            </div>
            {/* block-trois */}
            </div>
            {/* notification */}
          </>)} 
          {/* type=102 , aaa est dans X */}
      
          {dev && (<> 
          {api.read === "1" && (<> {/* on affiche les traits bleu si le message a ete lu */}
            <div className="read"> 
              <div className="a"></div>
              <div className="b"> <div className="aa"><SvgValidate5 /></div> <div className="bb"><SvgValidate5 /></div> </div> 
            </div> 
            {/* read */}
          </>)}

          {api.read === "0" && (<> 
            <div className="read"> 
              <div className="a"></div>
              <div className="b"> <div className="aa"><SvgValidate6 /></div> <div className="bb"><SvgValidate6 /></div> </div> 
            </div> 
            {/* read */}
          </>)} </>)}
        </div>
        {/* sender */}
        {ladate && (<><div className="date-denvoi-de-mon-message"> <p>{dateParser(api.createdAt)}</p> </div></>)}
        </>)}
        {/* mon message ( message que j'ai envoyé ) */}

    </div>
    </>
  );
}
//on affiche les messages privés dans l'application x


//on affiche les messages de l'application zimagic
function ChildApiMessageZA({ api }) {
  const idPersonConnectedAA = localStorage.getItem("idPersonConnectedAA");
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const image = api.urlPhoto;
    if(image) { localStorage.setItem("urlPhotoAA", image); }
    
    const date = api.createdAt;
    if(date) { localStorage.setItem("dateAA", date); }
  }

  const personConnected = api.idOwner === idPersonConnectedAA;  //si idOwner egale idPersonConnectedAA cela veut dire c'est mon message, sinon cela veut dire que c'est le message de l'autre


  const [ladate, setDate] = useState(false);
  async function laDate() {
    setDate(!ladate);
  }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };


  // GoToSeePhotoAA (page pour voir la photo que j'ai recu ou envoyé par message)
  async function GoToSeePhotoAA() {
    const seePhoto = "1";
    localStorage.setItem("GoToSeePhoto666ChildApiMessageAA", seePhoto);
  }
 
  const dev = localStorage.getItem("dev");

  return (
    <>
    <div onClick={Checked}>

        {/* son message (message que j'ai recu) */}
        {!personConnected && (<>
          <div onClick={laDate} className="receiver">

          {api.message && (<> {/* text */}
            <div className="block-one"> <pre>{api.message}</pre> </div>
          </>)} 
          
          {api.urlPhoto && (<> {/* photo */}
            <div className="block-two"> <img onClick={GoToSeePhotoAA} src={api.urlPhoto} alt="" /> </div>
          </>)} 

          {api.urlVideo && (<> {/* video */}
            <div className="block-three">
              <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4" /></video>
              <hr />
            </div>
          </>)}
        </div>
        {/* receiver */}
        {ladate && (<><div className="date-denvoi-de-votre-message"> <p>{dateParser(api.createdAt)}</p> </div></>)}
        </>)}
        {/* son message (message que j'ai recu) */}


        {/* mon message (message que j'ai envoyé) */}
        {personConnected && (<>
          <div onClick={laDate} className="sender">

          {api.message && (<> {/* text */}
            <div className="block-one"> <pre>{api.message}</pre> </div>
          </>)} 
          
          {api.urlPhoto && (<> {/* photo */}
            <div className="block-two"> <img onClick={GoToSeePhotoAA} src={api.urlPhoto} alt="" /> </div>
          </>)} 

          {api.urlVideo && (<> {/* video */}
            <div className="block-three">
              <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4" /></video>
              <div className="hr"> <p></p> <hr /> </div>
            </div>
          </>)}
      
          {dev && (<> 
          {api.read === "1" && (<> {/* on affiche les traits bleu si le message a ete lu */}
            <div className="read"> 
              <div className="a"></div>
              <div className="b"> <div className="aa"><SvgValidate5 /></div> <div className="bb"><SvgValidate5 /></div> </div> 
            </div> 
            {/* read */}
          </>)}

          {api.read === "0" && (<> 
            <div className="read"> 
              <div className="a"></div>
              <div className="b"> <div className="aa"><SvgValidate6 /></div> <div className="bb"><SvgValidate6 /></div> </div> 
            </div> 
            {/* read */}
          </>)} </>)}
        </div>
        {/* sender */}
        {ladate && (<><div className="date-denvoi-de-mon-message"> <p>{dateParser(api.createdAt)}</p> </div></>)}
        </>)}
        {/* mon message ( message que j'ai envoyé ) */}

    </div>
    </>
  );
}
//on affiche les messages de l'application zimagic


// ChildApi QuarterIA
// on affiche la liste des quartiers au niveau de la liste des points retraits - IA
function ChildApiQuarterIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    const id = api._id; //id
    if (id) { localStorage.setItem("idQuarter", id); }

    const quarter = api.quarter; //quarter
    if (quarter) { localStorage.setItem("quarter", quarter); }

    const language = api.language; //language
    if (language) { localStorage.setItem("language", language); }

    const languageInEnglish = api.languageInEnglish; //language in english
    if (languageInEnglish) { localStorage.setItem("languageInEnglish", languageInEnglish); }

    const country = api.country; //country
    if (country) { localStorage.setItem("country", country); }

    const city = api.city; //city
    if (city) { localStorage.setItem("city", city); }
  }

  return (
    <>
    <div onClick={Checked} className="language">
      <button>{api.quarter}</button>
    </div>
    {/* language */}
  </>)
}


// ChildApi CityIA
// on affiche la liste des villes au niveau de la liste des points retraits - IA
function ChildApiCityIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    const id = api._id; //id
    if (id) { localStorage.setItem("idCity", id); }

    const city = api.city; //city
    if (city) { localStorage.setItem("city", city); }

    const language = api.language; //language
    if (language) { localStorage.setItem("language", language); }

    const languageInEnglish = api.languageInEnglish; //language in english
    if (languageInEnglish) { localStorage.setItem("languageInEnglish", languageInEnglish); }

    const country = api.country; //country
    if (country) { localStorage.setItem("country", country); }
  }

  return (
    <>
    <div onClick={Checked} className="language">
      <button>{api.city}</button>
    </div>
    {/* language */}
  </>)
}

// ChildApi CountryIA
// on affiche les pays au niveau de la liste des points retraits - IA
function ChildApiCountryIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    const id = api._id; //id
    if (id) { localStorage.setItem("idCountry", id); }

    const country = api.country; //country
    if (country) { localStorage.setItem("country", country); }

    const language = api.language; //language
    if (language) { localStorage.setItem("language", language); }

    const languageInEnglish = api.languageInEnglish; //language in english
    if (languageInEnglish) { localStorage.setItem("languageInEnglish", languageInEnglish); }
  }

  return (
    <>
    <div onClick={Checked} className="language">
      <button>{api.country}</button>
    </div>
    {/* language */}
  </>)
}

// ChildApi LanguageIA
// on affiche les langues au niveau de la liste des points retraits - IA
function ChildApiLanguageIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    const id = api._id; //id
    if (id) { localStorage.setItem("idLanguage", id); }

    const language = api.language; //language
    if (language) { localStorage.setItem("language", language); }

    const languageInEnglish = api.languageInEnglish; //language in english
    if (languageInEnglish) { localStorage.setItem("languageInEnglish", languageInEnglish); }
  }

  return (
    <>
    <div onClick={Checked} className="language">
      <button>{api.language}</button>
    </div>
    {/* language */}
  </>)
}


// ChildApi WithdrawalPointIA
// ChildApi WithdrawalPointIA
// on affiche les points retraits izocash
function ChildApiWithdrawalPointIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    const id = api._id; //id
    if (id) { localStorage.setItem("id", id); }
  }

  // page - voir photo
  async function GoToPageSeePhoto() {
    const photo = "1";
    localStorage.setItem("GoToPageSeePhoto666WithdrawalPointIA", photo);
    //
    const infos = "0";
    localStorage.setItem("GoToPageSeeInfos666WithdrawalPointIA", infos);
  }

  // page - voir infos
  async function GoToPageSeeInfos() {
    const infos = "1";
    localStorage.setItem("GoToPageSeeInfos666WithdrawalPointIA", infos);
    //
    const photo = "0";
    localStorage.setItem("GoToPageSeePhoto666WithdrawalPointIA", photo);
  }

  return (
    <>
    {/* au niveau du css, j'ai mis block-one, ensuite au niveau de l'enfant api j'ai mis block-un car il y'avait un 
    petit probleme. ca prenait le css de block-one et ca le mettait au niveau du block-one de l'enfant api donc pour
    resoudre ce probleme il fallait changer le nom block-one et le remplacer par block-un */}
    <div onClick={Checked} className="withdrawalPoint">
      <div className="block-un">
        <div onClick={GoToPageSeePhoto} className="a"> <img src={api.photo} alt="" /> </div>
        {/* a */}

        <div onClick={GoToPageSeeInfos} className="b">
          <div className="aa"> <p>{api.name}</p> </div>
          <div className="bb"> <p>{api.addressPoint}</p> </div>
        </div>
        {/* b */}
      </div>
      {/* block-un */}

      <div onClick={GoToPageSeeInfos} className="block-deux">
        <div className="a"> <SvgVirtualNumber /> <p>{api.virtualNumber}</p> </div> {/* numero virtuel */}
        <div className="a"> <SvgPhoneNumber /> <p>{api.phoneNumber}</p> </div> {/* numero de telephone */}
      </div>
      {/* block-deux */}
    </div>
    {/* withdrawalPoint */}
  </>)
}
// ChildApi WithdrawalPointIA


// ChildApi SearchVB
// ChildApi SearchVB
// on affiche les resultats de la recherche (comptes, videos.)
function ChildApiSearchVB({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    //id
    const idProfilOther = api.idOwner;
    if (idProfilOther) { localStorage.setItem("idOwnerVB", idProfilOther); }

    // id post
    const idPost = api._id;
    if (idPost) { localStorage.setItem("idVideoVB", idPost); }
  }

   // page - profil other
   async function GoToProfilOtherAA() {
    const ProfilOther = "1";
    localStorage.setItem("GoToProfilOtherVB", ProfilOther);
    //
    const SeePost = "0";
    localStorage.setItem("GoToSeeVideoVB", SeePost);
  }

  // page - voir video
  async function GoToPageSeePostAA() {
    const SeePost = "1";
    localStorage.setItem("GoToSeeVideoVB", SeePost);
    //
    const ProfilOther = "0";
    localStorage.setItem("GoToProfilOtherVB", ProfilOther);
  }

  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  return (
    <>
    <div onClick={Checked}>

        <div className="search">
          <div className="block-un">
            <div className="a"> <img src={api.coverVideo} alt="" /> </div>
            <div className="b"> <p></p> <button>{api.duration}</button> </div>
          </div>
          {/* block-un */}
        </div>
        {/* search */}

        {/* postStyle 1 */}
        {/* postStyle 1 */}
        <div className="post">
          {/* ici on affiche: photo + nom, en haut de chaque posts */}
          <div className="infos">
            <div onClick={GoToProfilOtherAA} className="block-one">
              <div className="a"> <img src={api.photoOwner} alt="" /> </div>
              {/* a */}

              <div className="b">
                <div className="aa"> <p>{api.nameOwner}</p> </div>
                <div className="bb"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
              </div>
              {/* b */}
            </div>
            {/* block-one */}

            {dev && (<><div className="block-two"> <SvgPointsHorizontal /> </div></>)}
            {/* block-two */}
          </div>
          {/* infos */}   

          <div onClick={GoToPageSeePostAA} className="block-two"> <p>{api.description}</p> </div>
          {/* block-two */}

          <div onClick={GoToPageSeePostAA} className="block-three"> <img src={api.urlPhoto} alt="" /> </div>
          {/* block-three */}

          {dev && (<>
          <div className="block-four"> <p>Envoyer un message</p> </div></>)}
          {/* block-four */}

          <div className="block-five"> <p>{api.view} personnes ont vues cette vidéo</p> </div>
          {/* block-five */}

          {dev && (<>
          <div className="block-six">
            <div className="a">
              <div className="aa"> <SvgLike /> </div> {/* svg like (like) */}
              <div className="aa"> <SvgLove /> </div> {/* svg love (adore) */}
              <div className="aa"> <SvgSad /> </div> {/* svg sad (triste) */}
              <div className="aa"> <SvgSurprisedAA /> </div> {/* svg surprised (surpris) */}
              <div className="aa"> <SvgLaughAA /> </div> {/* svg laugh (rire) */}
              <div className="aa"> <SvgAngryAA /> </div> {/* svg angry (faché) */}
            </div>
            {/* a */}

            <div className="b">
              <div className="aa">
                <p>Voir</p>
              </div>
              {/* aa */}

              {/* svg SignSuperior (signe superieure) */}
              <div className="bb">
                <SvgRight3 />
              </div>
              {/* bb */}
            </div>
            {/* b */}
          </div>
          {/* block-six */}

          <div className="block-seven">
            <div className="a">
              {/* svg like */}
              <SvgDislike />
              <p>{api.reaction}</p>
            </div>
            {/* a */}

            <div className="b">
              {/* svg comment (commentaire) */}
              <SvgCommentAA />
              <p>{api.comment}</p>
            </div>
            {/* b */}

            <div className="c">
              {/* svg share (partage) */}
              <SvgShare />
              <p>{api.share}</p>
            </div>
            {/* c */}
          </div> </>)}
          {/* block-seven */}
        </div>
        {/* post */}
      </div>
    </>
  );
}
// ChildApi SearchVB


//ChildApi FollowerOtherAA
//ChildApi FollowerOtherAA
function ChildApiFollowerAA({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    const idSender = api.idSender;
    localStorage.setItem("idOther666ChildApiFollowerAA", idSender);
  }

  return (
    <>
      <div onClick={Checked} className="display-image">
        <div className="block-un">
          <div className="a">
            {api.photoSender ? (<>
            <img style={{cursor: "pointer"}} src={api.photoSender} alt=""/> </>
            ):(<>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  cursor="pointer"
                  width="40px"
                  enableBackground="new 0 0 481.613 481.613"
                  version="1.1"
                  viewBox="0 0 481.613 481.613"
                  xmlSpace="preserve"
                >
                  <path d="M12.331 253.313c6.6 0 12-5.4 12-12v-.2-.3c0-6.6-5.4-12-12-12s-12 5.4-12 12v.6c0 6.6 5.3 11.9 12 11.9zM467.931 205.413c-6.6.7-11.4 6.6-10.7 13.2.6 6.2 5.8 10.8 11.9 10.8.4 0 .8 0 1.2-.1 6.6-.7 11.4-6.6 10.7-13.1-.6-6.6-6.4-11.4-13.1-10.8zM14.531 206.513c.8.2 1.6.3 2.4.3 5.6 0 10.6-3.9 11.8-9.6 1.3-6.5-2.9-12.8-9.4-14.2-6.5-1.3-12.8 2.9-14.2 9.4-1.3 6.4 2.9 12.7 9.4 14.1zM208.831 455.413c-6.5-1-12.7 3.5-13.6 10.1-1 6.6 3.5 12.7 10.1 13.6.6.1 1.2.1 1.8.1 5.8 0 11-4.3 11.8-10.2.9-6.5-3.6-12.6-10.1-13.6zM161.631 38.013c1.4 0 2.8-.3 4.2-.8 6.2-2.3 9.4-9.2 7.1-15.4-2.3-6.2-9.2-9.4-15.4-7.1s-9.4 9.2-7.1 15.4c1.8 4.9 6.4 7.9 11.2 7.9zM295.631 30.613c1 .3 2 .4 3 .4 5.3 0 10.2-3.6 11.6-9 1.7-6.4-2.2-13-8.6-14.6-6.4-1.7-13 2.2-14.6 8.6-1.7 6.4 2.2 12.9 8.6 14.6zM126.831 425.213c-5.6-3.5-13-1.8-16.5 3.9-3.5 5.6-1.8 13 3.8 16.5 2 1.2 4.2 1.8 6.3 1.8 4 0 7.9-2 10.2-5.7 3.6-5.6 1.8-13-3.8-16.5zM120.131 58.413c2.2 0 4.4-.6 6.3-1.8 5.6-3.5 7.3-10.9 3.8-16.5s-10.9-7.3-16.5-3.8-7.3 10.9-3.8 16.5c2.3 3.6 6.2 5.6 10.2 5.6zM46.731 362.213c-5.4 3.8-6.8 11.3-2.9 16.7 2.3 3.3 6.1 5.1 9.8 5.1 2.4 0 4.8-.7 6.9-2.2 5.4-3.8 6.8-11.3 2.9-16.7-3.8-5.4-11.3-6.7-16.7-2.9zM252.231 24.013h.6c6.4 0 11.7-5 12-11.4.3-6.6-4.8-12.3-11.4-12.6-6.6-.3-12.3 4.8-12.6 11.4-.3 6.7 4.8 12.3 11.4 12.6zM423.131 380.613c-5-4.3-12.6-3.7-16.9 1.3s-3.7 12.6 1.3 16.9c2.3 1.9 5 2.9 7.8 2.9 3.4 0 6.7-1.4 9.1-4.2 4.3-5 3.7-12.5-1.3-16.9zM415.031 103.513c2.8 0 5.6-1 7.8-2.9 5-4.3 5.6-11.9 1.3-16.9-4.3-5-11.9-5.6-16.9-1.3-5 4.3-5.6 11.9-1.3 16.9 2.4 2.7 5.7 4.2 9.1 4.2zM252.731 457.613c-6.6.3-11.7 6-11.4 12.6.3 6.4 5.6 11.4 12 11.4h.6c6.6-.3 11.7-6 11.4-12.6s-6-11.8-12.6-11.4zM470.431 251.813c-6.6-.7-12.5 4.2-13.1 10.8-.7 6.6 4.2 12.5 10.8 13.1.4 0 .8.1 1.2.1 6.1 0 11.3-4.6 11.9-10.8.6-6.7-4.2-12.6-10.8-13.2zM75.131 398.913c-4.6 4.8-4.4 12.4.5 17 2.3 2.2 5.3 3.3 8.3 3.3 3.2 0 6.3-1.3 8.7-3.7 4.6-4.8 4.3-12.4-.5-17-4.8-4.7-12.5-4.4-17 .4zM374.431 412.313c-5.2 4.1-6.2 11.6-2.1 16.8 2.4 3 5.9 4.6 9.5 4.6 2.6 0 5.2-.8 7.3-2.5 5.2-4.1 6.2-11.6 2.1-16.9-4-5.2-11.6-6.1-16.8-2zM336.831 45.813c1.7.8 3.5 1.2 5.3 1.2 4.4 0 8.7-2.5 10.8-6.7 2.9-6 .5-13.1-5.5-16s-13.1-.5-16.1 5.5c-3 5.9-.5 13.1 5.5 16zM206.531 26.413c.6 0 1.2 0 1.8-.1 6.5-1 11-7.1 10-13.7s-7.1-11-13.7-10.1c-6.5 1-11 7.1-10 13.7.9 5.9 6.1 10.2 11.9 10.2zM448.431 175.613c1.6 5.1 6.3 8.4 11.4 8.4 1.2 0 2.4-.2 3.6-.6 6.3-2 9.8-8.7 7.8-15s-8.7-9.8-15-7.8c-6.3 1.9-9.8 8.7-7.8 15zM441.531 141.413c2 0 4-.5 5.8-1.5 5.8-3.2 7.9-10.5 4.6-16.3-3.2-5.8-10.5-7.9-16.3-4.6-5.8 3.2-7.9 10.5-4.6 16.3 2.2 3.9 6.3 6.1 10.5 6.1zM83.431 86.813c3 0 6-1.1 8.3-3.3 4.8-4.6 5-12.2.4-17s-12.2-5-17-.4-5 12.2-.4 17c2.4 2.5 5.6 3.7 8.7 3.7zM296.131 450.913c-6.4 1.7-10.3 8.2-8.6 14.6 1.4 5.4 6.3 9 11.6 9 1 0 2-.1 3-.4 6.4-1.7 10.3-8.2 8.6-14.6-1.7-6.4-8.2-10.3-14.6-8.6zM463.631 297.713c-6.3-2-13.1 1.6-15 7.9-2 6.3 1.6 13.1 7.9 15 1.2.4 2.4.5 3.6.5 5.1 0 9.9-3.3 11.5-8.4 1.8-6.3-1.7-13.1-8-15zM447.631 341.213c-5.8-3.2-13.1-1.1-16.3 4.7-3.2 5.8-1.1 13.1 4.7 16.3 1.8 1 3.8 1.5 5.8 1.5 4.2 0 8.3-2.2 10.5-6.2 3.2-5.8 1.1-13.1-4.7-16.3zM337.231 435.613c-6 2.9-8.4 10.1-5.5 16.1 2.1 4.2 6.4 6.7 10.8 6.7 1.8 0 3.6-.4 5.3-1.2 6-2.9 8.4-10.1 5.5-16.1-3-6-10.2-8.5-16.1-5.5zM166.331 444.513c-6.2-2.3-13.1.9-15.4 7.1s.9 13.1 7.1 15.4c1.4.5 2.8.8 4.1.8 4.9 0 9.5-3 11.3-7.9 2.3-6.2-.9-13.1-7.1-15.4zM46.431 119.813c2.1 1.4 4.5 2.1 6.9 2.1 3.8 0 7.5-1.8 9.8-5.1 3.8-5.4 2.5-12.9-3-16.7-5.4-3.8-12.9-2.5-16.7 3-3.8 5.5-2.4 12.9 3 16.7zM26.031 161.513c1.5.7 3.1 1 4.7 1 4.7 0 9.1-2.7 11-7.3 2.6-6.1-.2-13.2-6.3-15.8s-13.1.2-15.8 6.3c-2.5 6.1.3 13.2 6.4 15.8zM28.831 285.013c-1.4-6.5-7.7-10.7-14.2-9.3-6.5 1.3-10.7 7.7-9.3 14.2 1.2 5.7 6.2 9.6 11.7 9.6.8 0 1.6-.1 2.4-.3 6.5-1.4 10.7-7.7 9.4-14.2zM42.031 326.813c-2.6-6.1-9.7-8.9-15.8-6.3s-8.9 9.7-6.3 15.8c2 4.5 6.4 7.2 11 7.2 1.6 0 3.2-.3 4.8-1 6.1-2.5 8.9-9.6 6.3-15.7zM374.031 69.113c2.2 1.7 4.8 2.5 7.3 2.5 3.6 0 7.1-1.6 9.5-4.7 4-5.2 3.1-12.8-2.1-16.8-5.2-4.1-12.8-3.1-16.8 2.1-4.1 5.2-3.1 12.8 2.1 16.9zM241.331 221.613c32.2 0 58.5-26.2 58.5-58.5s-26.2-58.5-58.5-58.5-58.5 26.2-58.5 58.5 26.3 58.5 58.5 58.5zm0-93c19 0 34.5 15.5 34.5 34.5s-15.5 34.5-34.5 34.5-34.5-15.5-34.5-34.5 15.5-34.5 34.5-34.5zM327.531 281.713c-20-27-49-40.7-86.2-40.7s-66.2 13.7-86.2 40.7c-15 20.3-24.6 47.9-28.5 81.9-.7 6.6 4 12.5 10.6 13.3s12.5-4 13.3-10.6c7.6-67.2 38.2-101.3 90.8-101.3s83.2 34.1 90.8 101.3c.7 6.1 5.9 10.7 11.9 10.7.4 0 .9 0 1.4-.1 6.6-.7 11.3-6.7 10.6-13.3-3.9-34-13.5-61.6-28.5-81.9z"></path>
                </svg>
              </>)}
          </div>
          {/* a */}

          <div className="b">
            {api.badgeSender > 0 ? (<>
                <div style={{display: "flex", alignItems: "center"}}>
                  <p style={{color: "#000", cursor: "pointer"}}>{api.nameSender}</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="blue"
                      fillRule="evenodd"
                      d="M15.418 5.643a1.25 1.25 0 00-1.34-.555l-1.798.413a1.25 1.25 0
01-.56 0l-1.798-.413a1.25 1.25 0 00-1.34.555l-.98
1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 00-.555 1.338l.413
1.8a1.25 1.25 0 010 .559l-.413 1.799a1.25 1.25 0 00.555
1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674
1.339.555l1.798-.413a1.25 1.25 0 01.56 0l1.799.413a1.25 1.25 0
001.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0
00.554-1.34L18.5 12.28a1.25 1.25 0 010-.56l.413-1.799a1.25 1.25 0
00-.554-1.339l-1.565-.98a1.25 1.25 0 01-.395-.395l-.98-1.564zm-.503
4.127a.5.5 0 00-.86-.509l-2.615 4.426-1.579-1.512a.5.5 0 10-.691.722l2.034
1.949a.5.5 0 00.776-.107l2.935-4.97z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <p style={{fontSize: "13px", color: "#a6a6a6", paddingTop: "3px", cursor: "pointer"}}>{api.countrySender}</p> </>
            ):(<>
                <p style={{color: "#000", cursor: "pointer"}}>{api.nameSender}</p>
                <p style={{fontSize: "13px", color: "#a6a6a6", paddingTop: "3px", cursor: "pointer"}}>{api.countrySender}</p>
              </>)}
          </div>
          {/* b */}
        </div>
        {/* block-un */}
      </div>
      {/* display-image */}
    </>
  );
}
//ChildApi FollowerAA


//ChildApi FollowingAA
//ChildApi FollowingAA
function ChildApiFollowingAA({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    const idReceiver = api.idReceiver; //id de celui qui a recu l'abonnement de la personne connecter
    localStorage.setItem("idOther666ChildApiFollowingAA", idReceiver);
  }

  return (
    <>
      <div onClick={Checked} className="display-image">
        <div className="block-un">
          <div className="a">
            {api.photoReceiver ? (<>
            <img style={{cursor: "pointer"}} src={api.photoReceiver} alt=""/> </>
            ):(<>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  cursor="pointer"
                  width="40px"
                  enableBackground="new 0 0 481.613 481.613"
                  version="1.1"
                  viewBox="0 0 481.613 481.613"
                  xmlSpace="preserve"
                >
                  <path d="M12.331 253.313c6.6 0 12-5.4 12-12v-.2-.3c0-6.6-5.4-12-12-12s-12 5.4-12 12v.6c0 6.6 5.3 11.9 12 11.9zM467.931 205.413c-6.6.7-11.4 6.6-10.7 13.2.6 6.2 5.8 10.8 11.9 10.8.4 0 .8 0 1.2-.1 6.6-.7 11.4-6.6 10.7-13.1-.6-6.6-6.4-11.4-13.1-10.8zM14.531 206.513c.8.2 1.6.3 2.4.3 5.6 0 10.6-3.9 11.8-9.6 1.3-6.5-2.9-12.8-9.4-14.2-6.5-1.3-12.8 2.9-14.2 9.4-1.3 6.4 2.9 12.7 9.4 14.1zM208.831 455.413c-6.5-1-12.7 3.5-13.6 10.1-1 6.6 3.5 12.7 10.1 13.6.6.1 1.2.1 1.8.1 5.8 0 11-4.3 11.8-10.2.9-6.5-3.6-12.6-10.1-13.6zM161.631 38.013c1.4 0 2.8-.3 4.2-.8 6.2-2.3 9.4-9.2 7.1-15.4-2.3-6.2-9.2-9.4-15.4-7.1s-9.4 9.2-7.1 15.4c1.8 4.9 6.4 7.9 11.2 7.9zM295.631 30.613c1 .3 2 .4 3 .4 5.3 0 10.2-3.6 11.6-9 1.7-6.4-2.2-13-8.6-14.6-6.4-1.7-13 2.2-14.6 8.6-1.7 6.4 2.2 12.9 8.6 14.6zM126.831 425.213c-5.6-3.5-13-1.8-16.5 3.9-3.5 5.6-1.8 13 3.8 16.5 2 1.2 4.2 1.8 6.3 1.8 4 0 7.9-2 10.2-5.7 3.6-5.6 1.8-13-3.8-16.5zM120.131 58.413c2.2 0 4.4-.6 6.3-1.8 5.6-3.5 7.3-10.9 3.8-16.5s-10.9-7.3-16.5-3.8-7.3 10.9-3.8 16.5c2.3 3.6 6.2 5.6 10.2 5.6zM46.731 362.213c-5.4 3.8-6.8 11.3-2.9 16.7 2.3 3.3 6.1 5.1 9.8 5.1 2.4 0 4.8-.7 6.9-2.2 5.4-3.8 6.8-11.3 2.9-16.7-3.8-5.4-11.3-6.7-16.7-2.9zM252.231 24.013h.6c6.4 0 11.7-5 12-11.4.3-6.6-4.8-12.3-11.4-12.6-6.6-.3-12.3 4.8-12.6 11.4-.3 6.7 4.8 12.3 11.4 12.6zM423.131 380.613c-5-4.3-12.6-3.7-16.9 1.3s-3.7 12.6 1.3 16.9c2.3 1.9 5 2.9 7.8 2.9 3.4 0 6.7-1.4 9.1-4.2 4.3-5 3.7-12.5-1.3-16.9zM415.031 103.513c2.8 0 5.6-1 7.8-2.9 5-4.3 5.6-11.9 1.3-16.9-4.3-5-11.9-5.6-16.9-1.3-5 4.3-5.6 11.9-1.3 16.9 2.4 2.7 5.7 4.2 9.1 4.2zM252.731 457.613c-6.6.3-11.7 6-11.4 12.6.3 6.4 5.6 11.4 12 11.4h.6c6.6-.3 11.7-6 11.4-12.6s-6-11.8-12.6-11.4zM470.431 251.813c-6.6-.7-12.5 4.2-13.1 10.8-.7 6.6 4.2 12.5 10.8 13.1.4 0 .8.1 1.2.1 6.1 0 11.3-4.6 11.9-10.8.6-6.7-4.2-12.6-10.8-13.2zM75.131 398.913c-4.6 4.8-4.4 12.4.5 17 2.3 2.2 5.3 3.3 8.3 3.3 3.2 0 6.3-1.3 8.7-3.7 4.6-4.8 4.3-12.4-.5-17-4.8-4.7-12.5-4.4-17 .4zM374.431 412.313c-5.2 4.1-6.2 11.6-2.1 16.8 2.4 3 5.9 4.6 9.5 4.6 2.6 0 5.2-.8 7.3-2.5 5.2-4.1 6.2-11.6 2.1-16.9-4-5.2-11.6-6.1-16.8-2zM336.831 45.813c1.7.8 3.5 1.2 5.3 1.2 4.4 0 8.7-2.5 10.8-6.7 2.9-6 .5-13.1-5.5-16s-13.1-.5-16.1 5.5c-3 5.9-.5 13.1 5.5 16zM206.531 26.413c.6 0 1.2 0 1.8-.1 6.5-1 11-7.1 10-13.7s-7.1-11-13.7-10.1c-6.5 1-11 7.1-10 13.7.9 5.9 6.1 10.2 11.9 10.2zM448.431 175.613c1.6 5.1 6.3 8.4 11.4 8.4 1.2 0 2.4-.2 3.6-.6 6.3-2 9.8-8.7 7.8-15s-8.7-9.8-15-7.8c-6.3 1.9-9.8 8.7-7.8 15zM441.531 141.413c2 0 4-.5 5.8-1.5 5.8-3.2 7.9-10.5 4.6-16.3-3.2-5.8-10.5-7.9-16.3-4.6-5.8 3.2-7.9 10.5-4.6 16.3 2.2 3.9 6.3 6.1 10.5 6.1zM83.431 86.813c3 0 6-1.1 8.3-3.3 4.8-4.6 5-12.2.4-17s-12.2-5-17-.4-5 12.2-.4 17c2.4 2.5 5.6 3.7 8.7 3.7zM296.131 450.913c-6.4 1.7-10.3 8.2-8.6 14.6 1.4 5.4 6.3 9 11.6 9 1 0 2-.1 3-.4 6.4-1.7 10.3-8.2 8.6-14.6-1.7-6.4-8.2-10.3-14.6-8.6zM463.631 297.713c-6.3-2-13.1 1.6-15 7.9-2 6.3 1.6 13.1 7.9 15 1.2.4 2.4.5 3.6.5 5.1 0 9.9-3.3 11.5-8.4 1.8-6.3-1.7-13.1-8-15zM447.631 341.213c-5.8-3.2-13.1-1.1-16.3 4.7-3.2 5.8-1.1 13.1 4.7 16.3 1.8 1 3.8 1.5 5.8 1.5 4.2 0 8.3-2.2 10.5-6.2 3.2-5.8 1.1-13.1-4.7-16.3zM337.231 435.613c-6 2.9-8.4 10.1-5.5 16.1 2.1 4.2 6.4 6.7 10.8 6.7 1.8 0 3.6-.4 5.3-1.2 6-2.9 8.4-10.1 5.5-16.1-3-6-10.2-8.5-16.1-5.5zM166.331 444.513c-6.2-2.3-13.1.9-15.4 7.1s.9 13.1 7.1 15.4c1.4.5 2.8.8 4.1.8 4.9 0 9.5-3 11.3-7.9 2.3-6.2-.9-13.1-7.1-15.4zM46.431 119.813c2.1 1.4 4.5 2.1 6.9 2.1 3.8 0 7.5-1.8 9.8-5.1 3.8-5.4 2.5-12.9-3-16.7-5.4-3.8-12.9-2.5-16.7 3-3.8 5.5-2.4 12.9 3 16.7zM26.031 161.513c1.5.7 3.1 1 4.7 1 4.7 0 9.1-2.7 11-7.3 2.6-6.1-.2-13.2-6.3-15.8s-13.1.2-15.8 6.3c-2.5 6.1.3 13.2 6.4 15.8zM28.831 285.013c-1.4-6.5-7.7-10.7-14.2-9.3-6.5 1.3-10.7 7.7-9.3 14.2 1.2 5.7 6.2 9.6 11.7 9.6.8 0 1.6-.1 2.4-.3 6.5-1.4 10.7-7.7 9.4-14.2zM42.031 326.813c-2.6-6.1-9.7-8.9-15.8-6.3s-8.9 9.7-6.3 15.8c2 4.5 6.4 7.2 11 7.2 1.6 0 3.2-.3 4.8-1 6.1-2.5 8.9-9.6 6.3-15.7zM374.031 69.113c2.2 1.7 4.8 2.5 7.3 2.5 3.6 0 7.1-1.6 9.5-4.7 4-5.2 3.1-12.8-2.1-16.8-5.2-4.1-12.8-3.1-16.8 2.1-4.1 5.2-3.1 12.8 2.1 16.9zM241.331 221.613c32.2 0 58.5-26.2 58.5-58.5s-26.2-58.5-58.5-58.5-58.5 26.2-58.5 58.5 26.3 58.5 58.5 58.5zm0-93c19 0 34.5 15.5 34.5 34.5s-15.5 34.5-34.5 34.5-34.5-15.5-34.5-34.5 15.5-34.5 34.5-34.5zM327.531 281.713c-20-27-49-40.7-86.2-40.7s-66.2 13.7-86.2 40.7c-15 20.3-24.6 47.9-28.5 81.9-.7 6.6 4 12.5 10.6 13.3s12.5-4 13.3-10.6c7.6-67.2 38.2-101.3 90.8-101.3s83.2 34.1 90.8 101.3c.7 6.1 5.9 10.7 11.9 10.7.4 0 .9 0 1.4-.1 6.6-.7 11.3-6.7 10.6-13.3-3.9-34-13.5-61.6-28.5-81.9z"></path>
                </svg>
            </>)}
          </div>
          {/* a */}

          <div className="b">
            {api.badgeReceiver > 0 ? (
              <>
                <div style={{display: "flex", alignItems: "center"}}>
                  <p style={{color: "#000", cursor: "pointer"}}>{api.nameReceiver}</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="blue"
                      fillRule="evenodd"
                      d="M15.418 5.643a1.25 1.25 0 00-1.34-.555l-1.798.413a1.25 1.25 0
01-.56 0l-1.798-.413a1.25 1.25 0 00-1.34.555l-.98
1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 00-.555 1.338l.413
1.8a1.25 1.25 0 010 .559l-.413 1.799a1.25 1.25 0 00.555
1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674
1.339.555l1.798-.413a1.25 1.25 0 01.56 0l1.799.413a1.25 1.25 0
001.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0
00.554-1.34L18.5 12.28a1.25 1.25 0 010-.56l.413-1.799a1.25 1.25 0
00-.554-1.339l-1.565-.98a1.25 1.25 0 01-.395-.395l-.98-1.564zm-.503
4.127a.5.5 0 00-.86-.509l-2.615 4.426-1.579-1.512a.5.5 0 10-.691.722l2.034
1.949a.5.5 0 00.776-.107l2.935-4.97z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>

            <p style={{fontSize: "13px", color: "#a6a6a6", paddingTop: "3px", cursor: "pointer"}}>{api.countryReceiver}</p> </>
            ):(<>
                <p style={{color: "#000", cursor: "pointer"}}>{api.nameReceiver}</p>
                <p style={{fontSize: "13px", color: "#a6a6a6", paddingTop: "3px", cursor: "pointer"}}>{api.countryReceiver}</p>
            </>)}
          </div>
          {/* b */}
        </div>
        {/* block-un */}
      </div>
      {/* display-image */}
  </>);
}
//ChildApi FollowingAA


//on affiche les messages
function ChildApiMessageAA({ api }) {
  const idPersonConnectedAA = localStorage.getItem("idPersonConnectedAA");
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const image = api.urlPhoto;
    if(image) { localStorage.setItem("urlPhotoAA", image); }
    
    const date = api.createdAt;
    if(date) { localStorage.setItem("dateAA", date); }
  }

  const personConnected = api.idOwner === idPersonConnectedAA;  //si idOwner egale idPersonConnectedAA cela veut dire c'est mon message, sinon cela veut dire que c'est le message de l'autre


  const [ladate, setDate] = useState(false);
  async function laDate() {
    setDate(!ladate);
  }

  // date envoie message
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };


  // GoToSeePhotoAA (page pour voir la photo que j'ai recu ou envoyé par message)
  async function GoToSeePhotoAA() {
    const seePhoto = "1";
    localStorage.setItem("GoToSeePhoto666ChildApiMessageAA", seePhoto);
  }
 
  const dev = localStorage.getItem("dev");

  return (<>
    <div onClick={Checked}>

        {/* son message (message que j'ai recu) */}
        {!personConnected && (<>
          <div onClick={laDate} className="receiver">

          {api.message && (<> {/* text */}
            <div className="block-one"> <pre>{api.message}</pre> </div>
          </>)} 
          
          {api.urlPhoto && (<> {/* photo */}
            <div className="block-two"> <img onClick={GoToSeePhotoAA} src={api.urlPhoto} alt="" /> </div>
          </>)} 

          {api.urlVideo && (<> {/* video */}
            <div className="block-three">
              <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4" /></video>
              <hr />
            </div>
          </>)}
        </div>
        {/* receiver */}
        {ladate && (<><div className="date-denvoi-de-votre-message"> <p>{dateParser(api.createdAt)}</p> </div></>)}
        </>)}
        {/* son message (message que j'ai recu) */}


        {/* mon message (message que j'ai envoyé) */}
        {personConnected && (<>
          <div onClick={laDate} className="sender">

          {api.message && (<> {/* text */}
            <div className="block-one"> <pre>{api.message}</pre> </div>
          </>)} 
          
          {api.urlPhoto && (<> {/* photo */}
            <div className="block-two"> <img onClick={GoToSeePhotoAA} src={api.urlPhoto} alt="" /> </div>
          </>)} 

          {api.urlVideo && (<> {/* video */}
            <div className="block-three">
              <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4" /></video>
              <div className="hr"> <p></p> <hr /> </div>
            </div>
          </>)}
      
          {dev && (<> 
          {api.read === "1" && (<> {/* on affiche les traits bleu si le message a ete lu */}
            <div className="read"> 
              <div className="a"></div>
              <div className="b"> <div className="aa"><SvgValidate5 /></div> <div className="bb"><SvgValidate5 /></div> </div> 
            </div> 
            {/* read */}
          </>)}

          {api.read === "0" && (<> 
            <div className="read"> 
              <div className="a"></div>
              <div className="b"> <div className="aa"><SvgValidate6 /></div> <div className="bb"><SvgValidate6 /></div> </div> 
            </div> 
            {/* read */}
          </>)} </>)}
        </div>
        {/* sender */}
        {ladate && (<><div className="date-denvoi-de-mon-message"> <p>{dateParser(api.createdAt)}</p> </div></>)}
        </>)}
        {/* mon message ( message que j'ai envoyé ) */}

    </div>
    </>
  );
}


//on affiche les conversations 
function ChildApiConversationAA({ api }) {
  const idPersonConnectedAA = localStorage.getItem("idPersonConnectedAA");

  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const idConversation = api._id; // id
    localStorage.setItem("idConversationAA", idConversation);

    const idLastMessage = api.idLastMessage; // idLastMessage (id du dernier message)
    if (idLastMessage) { localStorage.setItem("idLastMessageAA", idLastMessage) }
    
    if (api.idOwner === idPersonConnectedAA) {  //logique pour obtenir l'id de la personne qui va recevoir mon message
      const idOwnerAA = api.idOther;
      localStorage.setItem("idOwnerAA", idOwnerAA);

      const idUser = api.idUserOther;
      localStorage.setItem("idUserOwnerAA", idUser);
    } else {
      const idOwner = api.idOwner;
      localStorage.setItem("idOwnerAA", idOwner);

      const idUser = api.idUserOwner;
      localStorage.setItem("idUserOwnerAA", idUser);
    }
  }

  // allons vers la page du message
  async function GoToPageMessage() {
    const pageMessage = "1";
    localStorage.setItem("GoToPageMessageAA", pageMessage);
  }


  //afficher les messages uniquement aux personnes concernées (cette logique nous permet d'éviter que les messages que j'ai envoyé ou recu puissent s'afficher a tout le monde)
  const idOwner = api.idOwner === idPersonConnectedAA;
  const idOther = api.idOther === idPersonConnectedAA;

  return (
    <>
      <div onClick={Checked} className="conversation">
        {idOther && (<>
        <div onClick={GoToPageMessage} className="display">
          <div className="a">
            {api.photoOwner === "0" ? (<><SvgProfil /></>
            ) : (<><img src={api.photoOwner} alt="" /></>)}
          </div>
          {/* a */}

          <div className="b">
            <div className="p1">
              <p>{api.nameOwner}</p> 
              {api.badgeOwner > 0 && (<><SvgBadge /></>)}
            </div>

            <div className="p2">
              {api.lastMessage.length > 65 ? (<><p>{api.lastMessage.slice(0, 65)}...</p></>
              ) : (<><p>{api.lastMessage}</p></>)}
            </div>
          </div>
          {/* b */}
        </div> </>)}

        {idOwner && (<>
        <div onClick={GoToPageMessage} className="display">
          <div className="a">
            {api.photoOther === "0" ? (<><SvgProfil /></>
            ) : (<><img src={api.photoOther} alt="" /></>)}
          </div>
          {/* a */}

          <div className="b">
            <div className="p1">
              <p>{api.nameOther}</p> 
              {api.badgeOther > 0 && (<><SvgBadge /></>)}
            </div>

            <div className="p2">
              {dev && (<>
              <div className="a">
                <div className="aa"><SvgValidate6 /></div>
                <div className="bb"><SvgValidate6 /></div>
              </div> </>)}

              {api.lastMessage.length > 65 ? (<><div className="b"> <p>{api.lastMessage.slice(0, 65)}...</p> </div>
              </>) : (<><div className="b"> <p>{api.lastMessage}</p> </div></>)}
            </div>
          </div>
          {/* b */}

          {dev && (<><div className="c"> <SvgMessage01 /> </div></>)}
         {/* c */}
        </div> </>)}
        {/* display */}
      </div>
    </>
  );
}


// ChildApi SearchAccountAA
// ChildApi SearchAccountAA
// on affiche les resultats de la recherche (les comptes, les pages ... )
function ChildApiSearchAccountAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const idOwner = api._id; //idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }

    const idUser = api.idUser; //idUser
    if (idUser) { localStorage.setItem("idUserOwnerAA", idUser); }

    const nameOwner = api.nameAccount; //nameOwner
    if (nameOwner) { localStorage.setItem("nameOwnerAA", nameOwner); }

    const photoOwner = api.photoProfile; //photoOwner
    if (photoOwner) { localStorage.setItem("photoOwnerAA", photoOwner); }

    const badgeOwner = api.badge; //badgeOwner
    if (badgeOwner) { localStorage.setItem("badgeOwnerAA", badgeOwner); }
  }

  // page - profil de l'autre
  async function GoToProfilOther() {
   const ProfilOther = "1";
   const MoreOptions = "0";
   localStorage.setItem("GoToProfilOtherAA", ProfilOther);
   localStorage.setItem("GoToMoreOptionsAccountAA", MoreOptions);
  }

  // page - Plus d'options du compte
  async function GoToMoreOptionsAccount() {
   const MoreOptions = "1";
   const ProfilOther = "0";
   localStorage.setItem("GoToMoreOptionsAccountAA", MoreOptions);
   localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }
  
  return (
    <>
      <div onClick={Checked} className="searchAccount"> 
        <div className="block-one">
          {api.badge === "1" ? (<>
          <div onClick={GoToProfilOther} className="a"> <img src={api.photoProfile} alt="" /> <p>{api.nameAccount}</p> <SvgBadge /> </div>
          </>):(<>
          <div onClick={GoToProfilOther} className="a"> <img src={api.photoProfile} alt="" /> <p>{api.nameAccount}</p> </div>
          </>)}
        </div>
        {/* block-one */}

        <div onClick={GoToMoreOptionsAccount} className="block-two">
          <p>...</p>
        </div>
        {/* block-two */}
      </div>
      {/* searchAccount */}
    </>
  );
}
// ChildApi SearchAccountAA


// ChildApi SearchAA
// ChildApi SearchAA
// on affiche les resultats de la recherche (les posts)
function ChildApiSearchAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    const idPost = api._id; // id post
    if (idPost) { localStorage.setItem("idPostAA", idPost); }

    const idOwner = api.idOwner; //idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }

    const nameOwner = api.nameOwner; //nameOwner
    if (nameOwner) { localStorage.setItem("nameOwnerAA", nameOwner); }

    const photoOwner = api.photoOwner; //photoOwner
    if (photoOwner) { localStorage.setItem("photoOwnerAA", photoOwner); }

    const badgeOwner = api.badgeOwner; //badgeOwner
    if (badgeOwner) { localStorage.setItem("badgeOwnerAA", badgeOwner); }
  }

  // voir plus
  const [seeMore, setSeeMore] = useState(false);
  async function SeeMore() {
    setSeeMore(!seeMore);

    localStorage.removeItem("GoToProfilOtherAA");
    localStorage.removeItem("GoToPageSeePost666homeAA");
  }

   // page - profil de l'autre
   async function GoToProfilOther() {
    const ProfilOther = "1";
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
    
    const SeePost = "0";
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
  }

  // page - voir un post
  async function GoToPageSeePost() {
    const SeePost = "1";
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    
    const ProfilOther = "0";
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }

  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  const postStyle = api.type;
  const postStyle1 = postStyle === "1";
  const postStyle6 = postStyle === "6";
  const postStyle30 = postStyle === "30";

  return (
    <>
      <div onClick={Checked} className="post">
          {/* ici on affiche: photo + nom, en haut de chaque posts */}
          <div className="infos">
            <div onClick={GoToProfilOther} className="block-one">
              <div className="a"> <img src={api.photoOwner} alt="" /> </div>

              <div className="b">
                {api.badge === "1" ? (<><div className="aa"> <p>{api.nameOwner}</p> <SvgBadge /> </div>
                </>) : (<><div className="aa"> <p>{api.nameOwner}</p> </div></>)}

                {api.ad === "1" ? (<><div className="bb"> <p>Sponsorisée</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
                </>) : (<><div className="bb"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div></>)}
              </div>
            </div>
            {/* block-one */}

            {dev && (<><div className="block-two"> <SvgPointsHorizontal /> </div></>)}
            {/* block-two */}
          </div>
          {/* infos */}   

        {/* postStyle1 */}
        {postStyle1 && (<>
        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>

        {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}

        <div onClick={GoToPageSeePost} className="block-three"> <img src={api.urlPhoto} alt="" /> </div>
        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div></>)} {/* postStyle1 */}


        {/* postStyle6 */}
        {postStyle6 && (<>
        {api.description.length > 140 ? (<><div onClick={GoToPageSeePost} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={GoToPageSeePost} className="block-two"> <pre>{api.description}</pre> </div></>)}

        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div></>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div></>)} {/* postStyle6 */}
       
       {/* postStyle30 (video) */}
       {postStyle30 && (<>
        <div onClick={GoToPageSeePost} className="video">
          <div className="a"> <img src={api.coverVideo} alt="" /> </div>
          <div className="b"> <button><SvgPlay3 /></button> </div>
        </div>
        {/* video */}

        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
        {api.description?.length > 65 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}
        <div className="block-five"> <p>{api.view} personnes ont vues cette vidéo</p> </div>
        </>)} {/* postStyle30 */}

        {dev && (<>
          <div className="block-six">
            <div className="a">
              <div className="aa"> <SvgLike /> </div> {/* svg like (like) */}
              <div className="aa"> <SvgLove /> </div> {/* svg love (adore) */}
              <div className="aa"> <SvgSad /> </div> {/* svg sad (triste) */}
              <div className="aa"> <SvgSurprisedAA /> </div> {/* svg surprised (surpris) */}
              <div className="aa"> <SvgLaughAA /> </div> {/* svg laugh (rire) */}
              <div className="aa"> <SvgAngryAA /> </div> {/* svg angry (faché) */}
            </div>
            {/* a */}

            <div className="b">
              <div className="aa">
                <p>Voir</p>
              </div>
              {/* aa */}

              {/* svg SignSuperior (signe superieure) */}
              <div className="bb">
                <SvgRight3 />
              </div>
              {/* bb */}
            </div>
            {/* b */}
          </div>
          {/* block-six */}

          <div className="block-seven">
            <div className="a">
              {/* svg like */}
              <SvgDislike />
              <p>107</p>
            </div>
            {/* a */}

            <div className="b">
              {/* svg comment (commentaire) */}
              <SvgCommentAA />
              <p>6</p>
            </div>
            {/* b */}

            <div className="c">
              {/* svg share (partage) */}
              <SvgShare />
              <p>11</p>
            </div>
            {/* c */}
          </div> </>)}
          {/* block-seven */}
        </div>
        {/* post */}
    </>
  );
}
// ChildApi SearchAA

				  
// ChildApi ReplyAA
// ChildApi ReplyAA
// on affiche les réponses du commentaire
function ChildApiReplyAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    
    const idReply = api._id; //id
    if (idReply) { localStorage.setItem("idReplyAA", idReply); }

    const idOwner = api.idOwner; //idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }
  }

  return (
    <>
      <div onClick={Checked}>

        <div className="reply">
          <div className="block-one"> <img src={api.photoOwner} alt="" /> </div>
          {/* block-one */}

          <div className="block-two">
            <div className="a"> <p>{api.nameOwner}</p> </div>
            <div className="b"> <pre>{api.reply}</pre> </div>
          </div>
          {/* block-two */}
        </div>
        {/* reply */}

      </div>
    </>
  );
}
// ChildApi ReplyAA

// ChildApi CommentAA
// ChildApi CommentAA
// on affiche les commentaires
function ChildApiCommentAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    const idComment = api._id; //id
    if (idComment) { localStorage.setItem("idCommentAA", idComment); }

    const idOwner = api.idOwner; //idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }
  }

  return (
    <>
      <div onClick={Checked}>

        <div className="comment">
          <div className="block-one"> <img src={api.photoOwner} alt="" /> </div>
          {/* block-one */}

          <div className="block-two">
            <div className="a"> <p>{api.nameOwner}</p> </div>
            <div className="b"> <pre>{api.comment}</pre> </div>
          </div>
          {/* block-two */}
        </div>
        {/* comment */}

      </div>
    </>
  );
}
// ChildApi CommentAA


// ChildApi Video666favoriteAA
//on affiche toutes les videos qu'on a ajouter dans nos favoris - AA
function ChildApiVideo666favoriteAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const id = api._id; // id
    localStorage.setItem("idFavoriteAA", id);
    localStorage.setItem("idFavoriteAAreq", id);

    const urlVideo = api.urlVideo; // url de la video
    if (urlVideo) { 
      localStorage.setItem("urlVideoAA", urlVideo); 
      localStorage.setItem("urlVideoAAreq", urlVideo); 
    }

    const urlPhoto = api.urlPhoto; // url de la photo
    if (urlPhoto) { 
      localStorage.setItem("urlPhotoAA", urlPhoto); 
      localStorage.setItem("urlPhotoAAreq", urlPhoto); 
    }
  }

  // go to seePhoto (ca va afficher la photo)
  async function GoToSeePhoto() {
    const seePhoto = "1";
    localStorage.setItem("GoToSeePhoto666favoriteAA", seePhoto);

    const seeVideo = "0";
    localStorage.setItem("GoToSeeVideo666favoriteAA", seeVideo);
  }

  // go to seeVideo (au niveau des favoris AA, ca va afficher la video)
  async function GoToSeeVideo() {
    const seeVideo = "1";
    localStorage.setItem("GoToSeeVideo666favoriteAA", seeVideo);

    const seePhoto = "0";
    localStorage.setItem("GoToSeePhoto666favoriteAA", seePhoto);
  }

  return (
    <>
      <div onClick={Checked} className="videos">
        <div className="block-un">

          {api.urlVideo === "0" ? (<>
          <div className="b">
            <img onClick={GoToSeePhoto} src={api.urlPhoto} alt="" />
            <p>{api.title}</p>
          </div>
          
          </>):(<>
          <div className="b">
            <img onClick={GoToSeeVideo} src={api.urlPhoto} alt="" />
            <p>{api.title}</p>
          </div>
          {/* b */}
          </>)}

        </div>
        {/* block-un */}
      </div>
      {/* videos */}
    </>
  );
}
// ChildApi Video666FavoriteAA


// ChildApi SeePostAA
// ChildApi SeePostAA
// on affiche le post sur laquelle on a cliquer (666 ProfilOtherAA)
function ChildApiSeePostAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);   
  }

   // voir plus
   const [seeMore, setSeeMore] = useState(false);
   async function SeeMore() {
     setSeeMore(!seeMore);
     localStorage.removeItem("GotoSeePhotoAA");
   }

   //goto seePhotoAA (page pour voir la photo sur laquelle on a cliquer)
   async function GotoSeePhoto() {
    const seePhoto = "1";
    localStorage.setItem("GotoSeePhotoAA", seePhoto);
  }

   const postStyle = api.type;
    const postStyle1 = postStyle === "1";
    const postStyle6 = postStyle === "6";
    const postStyle30 = postStyle === "30";


  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  return (
    <>
      <div onClick={Checked} className="post">
        <div className="block-one"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
        {/* block-one */}

        {/* postStyle1 */}
        {postStyle1 && (<>
        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>

        {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}

        <div className="block-three"> <img onClick={GotoSeePhoto} src={api.urlPhoto} alt="" /> </div>
        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div></>)} {/* postStyle1 */}


        {/* postStyle6 */}
        {postStyle6 && (<> 
        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>

        {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}
        
        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div></>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div></>)} {/* postStyle6 */}


        {/* postStyle30 (video) */}
        {postStyle30 && (<>
          {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
          {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
          ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
          </>)} {/* seeMore  */}

          {/* on affiche la video */}
          <div className="block-video">
            <video autoPlay={"autoplay"} muted loop controls> <source src={api.urlVideo} type="video/mp4"/> </video>
          </div></>)} {/* postStyle30 */}
          {/* block-video */}

        {dev && (<>
        <div className="block-six">
          <div className="a">
            <div className="aa"> <SvgLike /> </div> {/* svg like (like) */}
            <div className="aa"> <SvgLove /> </div> {/* svg love (adore) */}
            <div className="aa"> <SvgSad /> </div> {/* svg sad (triste) */}
            <div className="aa"> <SvgSurprisedAA /> </div> {/* svg surprised (surpris) */}
            <div className="aa"> <SvgLaughAA /> </div> {/* svg laugh (rire) */}
            <div className="aa"> <SvgAngryAA /> </div> {/* svg angry (faché) */}
          </div>
          {/* a */}

          <div className="b">
            <div className="aa">
              <p>Voir</p>
            </div>
            {/* aa */}

            {/* svg SignSuperior (signe superieure) */}
            <div className="bb">
              <SvgRight3 />
            </div>
            {/* bb */}
          </div>
          {/* b */}
        </div>
        {/* block-six */}

        <div className="block-seven">
          <div className="a">
            {/* svg like */}
            <SvgDislike />
            <p>{api.reaction}</p>
          </div>
          {/* a */}

          <div className="b">
            {/* svg comment (commentaire) */}
            <SvgCommentAA />
            <p>{api.comment}</p>
          </div>
          {/* b */}

          <div className="c">
            {/* svg share (partage) */}
            <SvgShare />
            <p>{api.share}</p>
          </div>
          {/* c */}
        </div></>)} {/* dev se ferme ici */}
        {/* block-seven */}
      </div>
      {/* post */}
    </>
  );
}
// ChildApi seePostAA

// ChildApi ProfilAA
// ChildApi ProfilAA
// on affiche les posts de la personne connecter
function ChildApiProfilAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const idPost = api._id; //id
    if (idPost) { localStorage.setItem("idPostAA", idPost); }

    const idOwner = api.idOwner; //idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }

    const clic = api.clic; // clic
    if (clic) { localStorage.setItem("oldClicAA", clic); }

    const view = api.view; // view
    if (view) { localStorage.setItem("oldViewAA", view); }
  }

  // convertir la date a laquelle le post a été publié
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return newDate;
  };

  // voir plus
  const [seeMore, setSeeMore] = useState(false);
  async function SeeMore() {
    setSeeMore(!seeMore);

    localStorage.removeItem("GoToPageBoosterPageAA");
    localStorage.removeItem("GoToPageSeePostAA");
  }

  //page - publicité
  async function GoToPageBoosterPage() {
    const boosterPage = "1";
    const seePost = "0";
    localStorage.setItem("GoToPageBoosterPageAA", boosterPage);
    localStorage.setItem("GoToPageSeePostAA", seePost);
  }

  //page - voir un post
  async function GoToPageSeePost() {
    const seePost = "1";
    const boosterPage = "0";
    localStorage.setItem("GoToPageSeePostAA", seePost);
    localStorage.setItem("GoToPageBoosterPageAA", boosterPage);
  }

  const postStyle = api.type;
  const postStyle1 = postStyle === "1";
  const postStyle6 = postStyle === "6";
  const postStyle30 = postStyle === "30";

  return (
    <>
      <div onClick={Checked} className="post">
        <div className="block-one"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
        {/* block-one */}

        {dev && (<>
        <div className="block"> <SvgPointsHorizontal /> </div></>)}
        {/* block */}

        {/* postStyle1 */}
        {postStyle1 && (<>
        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
        {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}

        <div onClick={GoToPageSeePost} className="block-three"> <img src={api.urlPhoto} alt="" /> </div>
        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}

        <div className="block-five">
          <p>{api.view} personnes ont vues cette publication</p>
          <p>{api.clic} clics</p>
        </div>
        </>)} {/* postStyle1 */}


        {/* postStyle6 */}
        {postStyle6 && (<>
        {api.description.length > 140 ? (<><div onClick={GoToPageSeePost} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={GoToPageSeePost} className="block-two"> <pre>{api.description}</pre> </div></>)}

        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div></>)}
        <div className="block-five">
          <p>{api.view} personnes ont vues cette publication</p>
          <p>{api.clic} clics</p>
        </div>
        </>)} {/* postStyle6 */}


        {/* postStyle30 (video) */}
        {postStyle30 && (<>
          <div onClick={GoToPageSeePost} className="video">
            <div className="a"> <img src={api.coverVideo} alt="" /> </div>
            <div className="b"> <button><SvgPlay6 /></button> </div>
          </div>
          {/* video */}

          {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
          {api.description?.length > 65 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
          ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
          </>)} {/* seeMore  */}

        <div className="block-five">
          <p>{api.view} personnes ont vues cette vidéo</p>
          <p>{api.clic} clics</p>
        </div></>)} {/* postStyle30 */}

        {dev && (<>
        <div className="block-six">
          <div className="a">
            <SvgLike /> {/* svg like (like) */}
            <SvgLove /> {/* svg love (adore) */}
            <SvgDissad /> {/* svg sad (triste) */}
            <SvgSurprisedAA /> {/* svg surprised (surpris) */}
            <SvgLaughAA /> {/* svg laugh (rire) */}
            <SvgAngryAA /> {/* svg angry (faché) */}
          </div>
          {/* a */}

          <div className="b">
            <div className="aa"> <p>Voir</p> </div>
            <div className="bb"> <SvgRight3 /> </div>
          </div>
          {/* b */}
        </div>
        {/* block-six */}

        <div className="block-seven">
          <div className="a"> <SvgDislike /> <p>{api.reaction}</p> </div> {/* svg like */}
          <div className="b"> <SvgCommentAA /> <p>{api.comment}</p> </div> {/* svg comment */}
          <div className="c"> <SvgShare /> <p>{api.share}</p> </div> {/* svg share */}
        </div>
        {/* block-seven */}
        </>)} {/* dev */}

        <div className="ad">
        {api.ad === "1" ? (<>
          <div style={{ paddingTop: "10px", paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px", display: "flex", justifyContent: "center"  }}>
            <p style={{ color: "#444", fontSize: "14px", paddingRight: "5px" }}>Sponsorisée</p>
            <SvgRight4 />
          </div>

          </>) : (<>

          <div className="block-two">
            <p>Booster la Publication pour obtenir Plus de clics</p>
            <button onClick={GoToPageBoosterPage}>Booster la Publication</button>
          </div></>)}
        </div>
        {/* ad */}
      </div>
      {/* post */}
    </>
  );
}
// ChildApi ProfilAA


// ChildApi ProfilOtherAA
// ChildApi ProfilOtherAA
// on affiche les posts sur le profil
function ChildApiProfilOtherAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const idPost = api._id; //id
    if (idPost) { localStorage.setItem("idPostAA", idPost); }

    const clic = api.clic; // clic
    if (clic) { localStorage.setItem("oldClicAA", clic); }

    const view = api.view; // view
    if (view) { localStorage.setItem("oldViewAA", view); }
  }

   // voir plus
   const [seeMore, setSeeMore] = useState(false);
   async function SeeMore() {
     setSeeMore(!seeMore);
     localStorage.removeItem("GoToSeePostAA");
   }


   //go to seePost (page pour voir le post sur laquelle on a cliquer)
   async function GoToSeePost() {
    const seePost = "1";
    localStorage.setItem("GoToSeePostAA", seePost);
  }

  // convertir la date a laquelle le post a été publié; convertir la date au format local (c-a-d en fonction des parametres de l'horaire du téléphone de l'utilisateur)
  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return newDate;
  };

  const postStyle = api.type;
  const postStyle1 = postStyle === "1";
  const postStyle6 = postStyle === "6";
  const postStyle30 = postStyle === "30";

  return (
    <>
      <div onClick={Checked} className="post">
        <div className="block-one"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
        {/* block-one */}

        {dev && (<><div className="block"> <SvgPointsHorizontal /> </div></>)}
        {/* block */}


        {/* postStyle1 */}
        {postStyle1 && (<>
        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
        {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}

        <div className="block-three"> <img onClick={GoToSeePost} src={api.urlPhoto} alt="" /> </div>
        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div>
        </>)} {/* postStyle1 */}


        {/* postStyle6 */}
        {postStyle6 && (<>
        {api.description.length > 140 ? (<><div onClick={GoToSeePost} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={GoToSeePost} className="block-two"> <pre>{api.description}</pre> </div></>)}

        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div></>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div>
        </>)} {/* postStyle6 */}


        {/* postStyle30 (video) */}
        {postStyle30 && (<>
          <div onClick={GoToSeePost} className="video">
            <div className="a"> <img src={api.coverVideo} alt="" /> </div>
            <div className="b"> <button><SvgPlay6 /></button> </div>
          </div>
          {/* video */}

          {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
          {api.description?.length > 65 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
          ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
          </>)} {/* seeMore  */}
          <div className="block-five"><p>{api.view} personnes ont vues cette vidéo</p></div>
          </>)} {/* postStyle30 */}

        {dev && (<>
        <div className="block-six">
          <div className="a">
            <SvgLike /> {/* svg like (like) */}
            <SvgLove /> {/* svg love (adore) */}
            <SvgSad /> {/* svg sad (triste) */}
            <SvgSurprisedAA /> {/* svg surprised (surpris) */}
            <SvgLaughAA /> {/* svg laugh (rire) */}
            <SvgAngryAA /> {/* svg angry (faché) */}
          </div>
          {/* a */}

          <div className="b">
            <div className="aa"> <p>Voir</p> </div>
            <div className="bb"> <SvgRight3 /> </div>
          </div>
          {/* b */}
        </div>
        {/* block-six */}

        <div className="block-seven">
          <div className="a"> <SvgDislike /> <p>{api.reaction}</p> </div> {/* svg like */}
          <div className="b"> <SvgCommentAA /> <p>{api.comment}</p> </div> {/* svg comment (commentaire) */}
          <div className="c"> <SvgShare /> <p>{api.share}</p> </div> {/* svg share (partage) */}
        </div>
        {/* block-seven */}
        </>)} {/* dev */}
      </div>
      {/* post */}
    </>
  );
}


// ChildApi videoAA
// ChildApi videoAA
// (sur la page videos, on affiche les videos).
function ChildApi666videoAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const idPost = api._id; // id post
    if (idPost) { localStorage.setItem("idPostAA", idPost); }

    const idOwner = api.idOwner; // idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }

    const nameOwner = api.nameOwner; // nameOwner
    if (nameOwner) { localStorage.setItem("nameOwnerAA", nameOwner); }

    const photoOwner = api.photoOwner; // photoOwner
    if (photoOwner) { localStorage.setItem("photoOwnerAA", photoOwner); }

    const badgeOwner = api.badgeOwner; // badgeOwner
    if (badgeOwner) { localStorage.setItem("badgeOwnerAA", badgeOwner); }

    const countryOwner = api.countryOwner; // countryOwner
    if (countryOwner) { localStorage.setItem("countryOwnerAA", countryOwner); }

    const clic = api.clic; // clic
    if (clic) { localStorage.setItem("oldClicAA", clic); }

    const view = api.view; // view
    if (view) { localStorage.setItem("oldViewAA", view); }

    const urlVideo = api.urlVideo; // urlVideo
    if (urlVideo) { localStorage.setItem("urlVideoAA", urlVideo); }
  }

    // voir plus
    const [seeMore, setSeeMore] = useState(false);
    async function SeeMore() {
      setSeeMore(!seeMore);
  
      /*localStorage.removeItem("GoToProfilOtherAA");
      localStorage.removeItem("GoToPageSharePostAA");
      localStorage.removeItem("GoToPageSeePost666homeAA");
      localStorage.removeItem("GoToPageAddReactionAA");
      localStorage.removeItem("GoToPageSeeReactionAA"); */
    }

  // page - profil de l'autre
  async function GoToPageProfilOther() {
    const ProfilOther = "1";
    const AddReaction = "0";
    const SeeReaction = "0";
    const SharePost = "0";
    const SeePost = "0";
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
  }

  // page seeVideo (sur la page, il a cliquer pour une video. là on le redirige vers)
  async function GoToPageSeeVideo() {
    const SeeVideo = "1";
    const SharePost = "0";
    const AddReaction = "0";
    const SeeReaction = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageSeeVideo666videoAA", SeeVideo);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }

  // page - ajouter une reaction
  async function GoToPageAddReaction() {
    /*const AddReaction = "1";
    const SeeReaction = "0";
    const SharePost = "0";
    const SeePost = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);*/
  }

  // page - partager un post
  async function GoToPageSharePost() {
    /*const SharePost = "1";
    const SeePost = "0";
    const AddReaction = "0";
    const SeeReaction = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);*/
  }

  // page - voir les reactions
  async function GoToPageSeeReaction() {
    /*const SeeReaction = "1";
    const AddReaction = "0";
    const SharePost = "0";
    const SeePost = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);*/
  }

  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  const postStyle = api.type;
  const postStyle30 = postStyle === "30";

  return (
    <>
      <div onClick={Checked} className="post">
          {/* ici on affiche: photo + nom, en haut de chaque posts */}
          <div className="infos">
            <div onClick={GoToPageProfilOther} className="block-one">
              <div className="a"> <img src={api.photoOwner} alt="" /> </div>
              {/* a */}

              <div className="b">
                {api.badge === "1" ? (<><div className="aa"> <p>{api.nameOwner}</p> <SvgBadge /> </div>
                </>) : (<><div className="aa"> <p>{api.nameOwner}</p> </div></>)}

                {api.ad === "1" ? (<><div className="bb"> <p>Sponsorisée</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
                </>) : (<><div className="bb"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div></>)}
              </div>
              {/* b */}
            </div>
            {/* block-one */}

            {dev && (<><div className="block-two"> <SvgPointsHorizontal /> </div></>)}
            {/* block-two */}
          </div>
          {/* infos */}

        {/* postStyle30 */}
        {postStyle30 && (<>
        {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
        {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
        ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
        </>)} {/* seeMore  */}

        <div onClick={GoToPageSeeVideo} className="video">
          <div className="a"> <img src={api.coverVideo} alt="" /> </div>
          <div className="b"> <p></p> <button><SvgPlay3 /></button> </div>
        </div>
        {/* video */}

        {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}
        <div className="block-five"> <p>{api.view} personnes ont vues cette vidéo</p> </div></>)} {/* postStyle30 */}


          <div onClick={GoToPageSeeReaction} className="block-six">
            <div className="a">
              <div className="aa"> <SvgLike /> </div> {/* svg like (like) */}
              <div className="aa"> <SvgLove /> </div> {/* svg love (adore) */}
              <div className="aa"> <SvgSad /> </div> {/* svg sad (triste) */}
              <div className="aa"> <SvgSurprisedAA /> </div> {/* svg surprised (surpris) */}
              <div className="aa"> <SvgLaughAA /> </div> {/* svg laugh (rire) */}
              <div className="aa"> <SvgAngryAA /> </div> {/* svg angry (faché) */}
            </div>
            {/* a */}

            <div className="b">
              <div className="aa"> <p>Voir</p> </div>
              <div className="bb"> <SvgRight3 /> </div> {/* svg SignSuperior (signe superieure) */}
            </div>
            {/* b */}
          </div>
          {/* block-six */}

          <div className="block-seven">
            <div onClick={GoToPageAddReaction} className="a"> <SvgDislike /><p>{api.reaction}</p> </div> {/* svg like */}
            <div onClick={GoToPageSeeVideo} className="b"> <SvgCommentAA /><p>{api.comment}</p> </div> {/* svg comment (commentaire) */}
            <div onClick={GoToPageSharePost} className="c"> <SvgShare /><p>{api.share}</p> </div> {/* svg share (partage) */}
          </div>
          {/* block-seven */}
        </div>
        {/* post */}
    </>)}
    // ChildApi 666videoAA


// ChildApi 666homeAA
// ChildApi 666homeAA
// (sur la page d'accueil, on affiche les posts).
function ChildApi666homeAA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const idPost = api._id; // id post
    if (idPost) { localStorage.setItem("idPostAA", idPost); }

    const idOwner = api.idOwner; // idOwner
    if (idOwner) { localStorage.setItem("idOwnerAA", idOwner); }

    const nameOwner = api.nameOwner; // nameOwner
    if (nameOwner) { localStorage.setItem("nameOwnerAA", nameOwner); }

    const photoOwner = api.photoOwner; // photoOwner
    if (photoOwner) { localStorage.setItem("photoOwnerAA", photoOwner); }

    const badgeOwner = api.badgeOwner; // badgeOwner
    if (badgeOwner) { localStorage.setItem("badgeOwnerAA", badgeOwner); }

    const countryOwner = api.countryOwner; // countryOwner
    if (countryOwner) { localStorage.setItem("countryOwnerAA", countryOwner); }

    const clic = api.clic; // clic
    if (clic) { localStorage.setItem("oldClicAA", clic); }

    const view = api.view; // view
    if (view) { localStorage.setItem("oldViewAA", view); }

    const urlPhoto = api.urlPhoto; // urlPhoto
    if (urlPhoto) { localStorage.setItem("urlPhotoAA", urlPhoto); }

    const urlVideo = api.urlVideo; // urlVideo
    if (urlVideo) { localStorage.setItem("urlVideoAA", urlVideo); }

    const ad = api.ad; // ad
    if (ad) { localStorage.setItem("adAA", ad); }
  
    const createdAt = api.createdAt; // view
    if (createdAt) { localStorage.setItem("createdAtAA", createdAt); }

    const description = api.description; // description
    if (description) { localStorage.setItem("descriptionAA", description); }

    const postStyle = api.type;
    const postStyle1 = postStyle === "1";
    const postStyle6 = postStyle === "6";
    const postStyle30 = postStyle === "30";
    
    if (postStyle1) { 
      const rien6 = "0";
      const rien30 = "0";
      localStorage.setItem("postStyle1AA", postStyle1); 
      localStorage.setItem("postStyle6AA", rien6); 
      localStorage.setItem("postStyle30AA", rien30); 
    }

    if (postStyle6) { 
      const rien1 = "0";
      const rien30 = "0";
      localStorage.setItem("postStyle1AA", rien1); 
      localStorage.setItem("postStyle6AA", postStyle6); 
      localStorage.setItem("postStyle30AA", rien30); 
    }

    if (postStyle30) { 
      const rien1 = "0";
      const rien6 = "0";
      localStorage.setItem("postStyle1AA", rien1); 
      localStorage.setItem("postStyle6AA", rien6); 
      localStorage.setItem("postStyle30AA", postStyle30); 
    }
  }

  // voir plus
  const [seeMore, setSeeMore] = useState(false);
  async function SeeMore() {
    setSeeMore(!seeMore);

    localStorage.removeItem("GoToProfilOtherAA");
    localStorage.removeItem("GoToPageSharePostAA");
    localStorage.removeItem("GoToPageSeePost666homeAA");
    localStorage.removeItem("GoToPageAddReactionAA");
    localStorage.removeItem("GoToPageSeeReactionAA");
  }

  // page - profil de l'autre
  async function GoToPageProfilOther() {
    const ProfilOther = "1";
    const AddReaction = "0";
    const SeeReaction = "0";
    const SharePost = "0";
    const SeePost = "0";
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
  }

  // page - voir un post
  async function GoToPageSeePost() {
    const SeePost = "1";
    const SharePost = "0";
    const AddReaction = "0";
    const SeeReaction = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }

  // page - ajouter une reaction
  async function GoToPageAddReaction() {
    const AddReaction = "1";
    const SeeReaction = "0";
    const SharePost = "0";
    const SeePost = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }

  // page - partager un post
  async function GoToPageSharePost() {
    const SharePost = "1";
    const SeePost = "0";
    const AddReaction = "0";
    const SeeReaction = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }

  // page - voir les reactions
  async function GoToPageSeeReaction() {
    const SeeReaction = "1";
    const AddReaction = "0";
    const SharePost = "0";
    const SeePost = "0";
    const ProfilOther = "0";
    localStorage.setItem("GoToPageAddReactionAA", AddReaction);
    localStorage.setItem("GoToPageSeeReactionAA", SeeReaction);
    localStorage.setItem("GoToPageSharePostAA", SharePost);
    localStorage.setItem("GoToPageSeePost666homeAA", SeePost);
    localStorage.setItem("GoToProfilOtherAA", ProfilOther);
  }

  const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  };

  const postStyle = api.type;
  const postStyle1 = postStyle === "1";
  const postStyle2 = postStyle === "2";
  const postStyle3 = postStyle === "3";

  const postStyle6 = postStyle === "6";
  const postStyle30 = postStyle === "30";

  return (
    <>
      <div onClick={Checked} className="post">
          {/* ici on affiche: photo + nom, en haut de chaque posts */}
          <div className="infos">
            <div onClick={GoToPageProfilOther} className="block-one">
              {api.photoProfile === "0" ? (<><div className="a"> <SvgProfil /> </div></>):(<>
              <div className="a"> <img src={api.photoOwner} alt="" /> </div></>)}

              <div className="b">
                {api.badge === "1" ? (<><div className="aa"> <p>{api.nameOwner}</p> <SvgBadge /> </div>
                </>):(<><div className="aa"> <p>{api.nameOwner}</p> </div></>)}

                {api.ad === "1" ? (<><div className="bb"> <p>Sponsorisée</p> <p>•</p> <SvgGlobeAfricaAA /> </div>
                </>):(<><div className="bb"> <p>{dateParser(api.createdAt)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div></>)}
              </div>
            </div>
            {/* block-one */}

            {dev && (<><div className="block-two"> <SvgPointsHorizontal /> </div></>)}
            {/* block-two */}
          </div>
          {/* infos */}

          {/* postStyle1 */}
          {postStyle1 && (<>
          {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
          {api.description?.length > 140 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
          ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
          </>)} {/* seeMore  */}
          
          <div onClick={GoToPageSeePost} className="block-three"> <img src={api.urlPhoto} alt="" /> </div>
          {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}
          <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div> 
          </>)} {/* postStyle1 */}

           {/* postStyle 2 */}
           {postStyle2 && (<>
            <div className="publication-deux-photos">
              <div className="card">
                <pre>{api.description}</pre>

                <div className="display">
                  <div className="a"> <img src={api.urlImage1} alt="" /> </div>
                  <div className="b"> <img src={api.urlImage2} alt="" /> </div>
                </div>
                {/* display */}

                {api.buttonActiver > 0 && (<><div className="section-btn"> <p>Envoyer un message</p> </div> 
                <p style={{ paddingBottom: "5px" }}></p> </>)}
              </div>
              {/* card */}
            </div> </>)} {/* postStyle 2 */}
           
            {/* postStyle 3 */}
            {postStyle3 && (<>
            <div className="publication-trois-photos">
              <div className="card">
                <pre>{api.description}</pre>

                <div className="display">
                  <div className="block-un"> <img src={api.urlImage1} alt="" /> </div>
                  {/* block-un */}

                  <div className="block-deux">
                    <div className="a"> <img src={api.urlImage2} alt="" /> </div>
                    <div className="b"> <img src={api.urlImage3} alt="" /> </div>
                  </div>
                  {/* block-deux */}
                </div>
                {/* display */}
              </div>
              {/* card */}
            </div> </>)} {/* postStyle 3 */}

          {/* postStyle6 */}
          {postStyle6 && (<>
          {api.description.length > 140 ? (<><div onClick={GoToPageSeePost} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
          ):(<><div onClick={GoToPageSeePost} className="block-two"> <pre>{api.description}</pre> </div></>)}

          {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div></>)}
          <div className="block-five"> <p>{api.view} personnes ont vues cette publication</p> </div>
          </>)} {/* postStyle6 */}


          {/* postStyle30 */}
          {postStyle30 && (<>
          <div onClick={GoToPageSeePost} className="video">
            <div className="a"> <img src={api.coverVideo} alt="" /> </div>
            <div className="b"> <button><SvgPlay6 /></button> </div>
          </div>

          {seeMore ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div> </>):(<>
          {api.description?.length > 65 ? (<><div onClick={SeeMore} className="block-two"> <pre>{api.description.slice(0, 140)}..</pre> </div></>
          ):(<><div onClick={SeeMore} className="block-two"> <pre>{api.description}</pre> </div></>)} {/* api.description.length */}
          </>)} {/* seeMore  */}
          <div className="block-five"> <p>{api.view} personnes ont vues cette vidéo</p> </div>
          </>)} {/* postStyle30 */}
          
          <div onClick={GoToPageSeeReaction} className="block-six">
            <div className="a">
              <div className="aa"> <SvgLike /> </div> {/* svg like (like) */}
              <div className="aa"> <SvgLove /> </div> {/* svg love (adore) */}
              <div className="aa"> <SvgSad /> </div> {/* svg sad (triste) */}
              <div className="aa"> <SvgSurprisedAA /> </div> {/* svg surprised (surpris) */}
              <div className="aa"> <SvgLaughAA /> </div> {/* svg laugh (rire) */}
              <div className="aa"> <SvgAngryAA /> </div> {/* svg angry (faché) */}
            </div>

            <div className="b">
              <div className="aa"> <p>Voir</p> </div>
              <div className="bb"> <SvgRight3 /> </div> {/* svg SignSuperior (signe superieure) */}
            </div>
          </div>
          {/* block-six */}

          <div className="block-seven">
            <div onClick={GoToPageAddReaction} className="a"> <SvgDislike /><p>{api.reaction}</p> </div> {/* svg like */}
            <div onClick={GoToPageSeePost} className="b"> <SvgCommentAA /><p>{api.comment}</p> </div> {/* svg comment (commentaire) */}
            {dev && (<><div onClick={GoToPageSharePost} className="c"> <SvgShare /><p>{api.share}</p> </div></>)} {/* svg share (partage) */}
          </div>
          {/* block-seven */}
        </div> 
        {/* post */}
    </>)}
    //ChildApi 666homeAA


// HistoryIzocashBuyIA - (commissions)
/* il s'agit de l'historique des commissions recues. par exemple lorsqu'une personne active 
 IzocashBuy avec mon super code ou lorsqu'une personne achete son numero virtuel avec mon super code */
function ChildApiHistoryIzocashBuyIA() {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    /*quand l'utilisateur effectue une transaction, il recoit une notification; alors on
    enregistre l'id de la transaction qu'il a effectuer et le type de notification qu'il a recu */
    //id de la transaction
    /* const idTransactionIA = api._id;
    localStorage.setItem("https://alrani.com/idTransactionIA", idTransactionIA);*/

    //type de notification
    /*const typeNotificationIA = api.typeNotification;
    localStorage.setItem(
      "https://alrani.com/typeNotificationIA",
      typeNotificationIA
    );*/
  }

  return (
    <>
      <div onClick={Checked} className="commission">
        <div className="block-un">
          <div className="a"> <p>Achat numéro virtuel</p> </div>
          <div className="b"> <p>Desty Rose</p> </div>
        </div>
        {/* block-un */}

        <div className="block-deux">
          <div className="a"> <p>10/11/2024</p> </div>
          <div className="b"> <p>10000 FCFA</p> </div>
        </div>
        {/* block-deux */}

        <hr />
      </div>
      {/* commission */}
    </>
  );
}

//on affiche plus de photos publique - ( 666 historyIA 666 InfosAgencePageIA)
function EnfantApiMorePhotoPublicIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    //id de la Photo Publique
    const idPhotoPublic = api._id;
    localStorage.setItem("https://alrani.com/idPhotoPublicIA", idPhotoPublic);

    //url de la Photo Publique
    const urlPhotoPublic = api.photoPublic;
    localStorage.setItem("https://alrani.com/seePhotoIA", urlPhotoPublic);
  }

  return (
    <>
      <div onClick={Checked} className="morePhotoPublic">
        <div>
          <img src={api.photoPublic} alt="" />
        </div>
      </div>
      {/* morePhotoPublic */}
    </>
  );
}

//on affiche l'historique - IA
function EnfantApiHistoryIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const id = api._id;
    localStorage.setItem("idNotification", id);
    localStorage.setItem("idNotification000", id);

    // notification
    const notification = api.notification;
    localStorage.setItem("notification", notification);

    const date = api.createdAt; // date
    if (date) { 
      localStorage.setItem("date", date); 
      localStorage.setItem("date000", date); 
    }

    const amount = api.amount; // montant
    if (amount) { 
      localStorage.setItem("amount", amount); 
      localStorage.setItem("amount000", amount); 
    } 

    const price = api.price; // prix
    if (price) { 
      localStorage.setItem("price", price); 
      localStorage.setItem("price000", price); 
    } 

    const fees = api.fees; // frais
    if (fees) { 
      localStorage.setItem("fees", fees); 
      localStorage.setItem("fees000", fees); 
    } 

    const total = api.total; // total
    if (total) { 
      localStorage.setItem("total", total); 
      localStorage.setItem("total000", total); 
    } 

    const virtualNumber = api.virtualNumber; // virtualNumber
    if (virtualNumber) { 
      localStorage.setItem("virtualNumber", virtualNumber); 
      localStorage.setItem("virtualNumber000", virtualNumber); 
    }

    const nameOwnerVirtualNumber = api.nameOwnerVirtualNumber; // nameOwnerVirtualNumber
    if (nameOwnerVirtualNumber) { 
      localStorage.setItem("nameOwnerVirtualNumber", nameOwnerVirtualNumber); 
      localStorage.setItem("nameOwnerVirtualNumber000", nameOwnerVirtualNumber); 
    }

    const commission = api.commission;
    if (commission) { localStorage.setItem("commission", commission); }

    const stockRequired = api.stockRequired; // stockRequired
    if (stockRequired) { localStorage.setItem("stockRequired", stockRequired); }

    // Owner (celui qui envoie la notification)
    const idOwner = api.idOwner; // idOwner
    if (idOwner) { localStorage.setItem("idOwner", idOwner); }

    const nameOwner = api.nameOwner; // nameOwner
    if (nameOwner) { 
      localStorage.setItem("nameOwner", nameOwner); 
      localStorage.setItem("nameOwner000", nameOwner); 
    }

    const phoneNumber = api.phoneNumberOwner; // phoneNumber
    if (phoneNumber) { 
      localStorage.setItem("phoneNumber", phoneNumber); 
      localStorage.setItem("phoneNumber000", phoneNumber); 
    }

    const oldBalanceOwner = api.oldBalanceOwner; // old balance sender (ancien solde de l'envoyeur)
    if (oldBalanceOwner) { localStorage.setItem("oldBalanceOwner", oldBalanceOwner); }

    const newBalanceOwner = api.newBalanceOwner; // new balance sender (nouveau solde de l'envoyeur)
    if (newBalanceOwner) { localStorage.setItem("newBalanceOwner", newBalanceOwner); }

    const oldStockOwner = api.oldStockOwner;
    if (oldStockOwner) { localStorage.setItem("oldStockOwner", oldStockOwner); }

    const newStockOwner = api.newStockOwner;
    if (newStockOwner) { localStorage.setItem("newStockOwner", newStockOwner); }

    // Other (celui qui recoit la notification)
    const idOther = api.idOther; // idOther
    if (idOther) { localStorage.setItem("idOther", idOther); }

    const nameOther = api.nameOther; // nameOther
    if (nameOther) { 
      localStorage.setItem("nameOther", nameOther); 
      localStorage.setItem("nameOther000", nameOther); 
    }

    const oldBalanceOther = api.oldBalanceOther; // old balance receiver (ancien solde du beneficiaire)
    if (oldBalanceOther) { localStorage.setItem("oldBalanceOther", oldBalanceOther); }

    const newBalanceOther = api.newBalanceOther; // new balance receiver (nouveau solde du beneficiaire)
    if (newBalanceOther) { localStorage.setItem("newBalanceOther", newBalanceOther); }

    const oldStockOther = api.oldStockOther;
    if (oldStockOther) { localStorage.setItem("oldStockOther", oldStockOther); }

    const newStockOther = api.newStockOther;
    if (newStockOther) { localStorage.setItem("newStockOther", newStockOther); }
  }

  // page - infos notification - IA 
  async function GoToPageInfosNotificationIA() {
    const infosTransaction = "1";
    localStorage.setItem("GoToPageInfosNotificationIA", infosTransaction);
    //
    const infosAgence = "0";
    localStorage.setItem("GoToPageInfosOtherIA", infosAgence); 
  }

  // page - infos other
  async function GoToPageInfosOtherIA() {
    const infosAgence = "1";
    localStorage.setItem("GoToPageInfosOtherIA", infosAgence);
    //
    const infosTransaction = "0";
    localStorage.setItem("GoToPageInfosNotificationIA", infosTransaction);
  }

  const idPersonConnectedIA = localStorage.getItem("idPersonConnectedIA");

  //filtre
  //filtre
  //filtre
  //ca c'est pour filtrer, on veut que chaque type de notification soit afficher avec son propre design
  const idOwner = api.idOwner === idPersonConnectedIA; //idOwner (Owner, celui qui envoie la notification)
  const idOther = api.idOther === idPersonConnectedIA; //idOther (Other, celui qui recoit la notification)

  const notification = api.notification;


  // documents
  //identiter incomplete (documents d'identiter manquants) - IA
  /*l'utilisateur recoit cette notification s'il n'a pas envoyer les documents d'identiter 
  de son entreprise */
  const identityIncompleteDocumentMissingIA = notification === "131";

  // informations
  //identiter incomplete (Informations de l'entreprise manquantes) - IA
  /*l'utilisateur recoit cette notification s'il n'a pas envoyer les informations d'identiter 
  de son entreprise */
  const identityIncompleteInformationMissingIA = notification === "31";

  // logo
  //identiter incomplete (logo de l'entreprise manquant) - IA
  //l'utilisateur recoit cette notification s'il n'a pas envoyer le logo de son entreprise
  const identityIncompleteLogoMissingIA = notification === "41";

  // photos
  //identiter incomplete (photos de l'entreprise manquantes) - IA
  //l'utilisateur recoit cette notification s'il n'a pas envoyer les photos de son entreprise
  const identityIncompletePhotoMissingIA = notification === "51";

  // Réseaux
  //identiter incomplete - Réseaux sociaux manquants - IA
  /*l'utilisateur recoit cette notification s'il n'a pas ajouter les réseaux sociaux de 
  son entreprise */
  const identityIncompleteSocialNetworkMissingIA = notification === "61";

  //identiter valider - IA
  /*l'utilisateur recoit cette notification si ses informations d'identiter ont été validées 
  par izocash Business */
  const identityValidateIA = notification === "71";

  //Stock Recharge presque épuisé - IA
  //l'agence recoit cette notification si son stock recharge est presque epuiser
  const stockRefillAlmostExhaustedIA = notification === "118";

  //Stock Retrait presque épuisé - IA
  //l'agence recoit cette notification si son stock retrait est presque epuiser
  const stockWithdrawalAlmostExhaustedIA = notification === "119";

  //recharge
  //l'utilisateur recoit cette notification apres avoir effectuer une recharge a l'agence
  const recharge = notification === "110";

  //retrait
  //l'utilisateur recoit cette notification apres avoir effectuer un retrait a l'agence
  const retrait = notification === "111";

  //licence
  //l'utilisateur recoit cette notification si une licence lui a ete offert
  const licence = notification === "131";

  //compte devalider
  //l'utilisateur recoit cette notification si son compte izocash est devalider
  const compteDevalider = notification === "114";

  return (
    <>
      <div onClick={Checked} className="notification">

        {/* notification=2 (identification reussie) */}
        {/* l'utilisateur recoit cette notification si le numero virtuel a ete identifier */}
        {api.notification === "2" && idOwner && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identification réussie</p>
              </div>

              <div className="b">
                <p>{dateParser(api.createdAt)}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* identification reussie */}

        {/* notification=4 (transfert national envoyer) */}
        {/* l'utilisateur recoit cette notification s'il a envoyer de l'argent */}
        {api.notification === "4" && idOwner && (
          <>
            <div className="block-un">
              <div onClick={GoToPageInfosNotificationIA} className="a">
                <p>{api.description}</p>
                <p>Transfert d'argent</p>
              </div>
              {/* a */}

              {/* nameOther = nameReceiver */}

              <div onClick={GoToPageInfosNotificationIA} className="b"> <p>{api.nameOther}</p> </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux"> 
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div onClick={GoToPageInfosNotificationIA} className="c"> <p>{api.amount} FCFA</p> </div>
            </div>
            {/* block-deux */}
          </>
        )}
        {/* transfert national envoyer */}

        {/* notification=4 (transfert national recu) */}
        {/* l'utilisateur recoit cette notification s'il a recu un transfert d'argent */}
        {api.notification === "4" && idOther && (<>
            <div className="block-un">
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>Transfert reçu</p> </div>
              <div onClick={GoToPageInfosNotificationIA} className="b"> <p>{api.nameOwner}</p> </div>
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div onClick={GoToPageInfosNotificationIA} className="b"> <p>{api.amount} FCFA</p> </div>
            </div>
            {/* block-deux */}

            <hr />
          </>)}
        {/* transfert national recu  */}

        {/* notification=5 (retrait reussie) */}
        {/* l'utilisateur recoit cette notification apres avoir effectuer un retrait */}
        {api.notification === "5" && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Retrait réussie</p>
              </div>

              <div className="b">
                <p>{dateParser(api.createdAt)}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* retrait reussie */}


        {/* notification=6 (versement National) */}
        {api.notification === "6" && idOwner && (
          <>
            <div className="block-un">
              <div onClick={GoToPageInfosNotificationIA} className="a">
                <p>{api.description}</p>
                <p>VERSEMENT National</p>
              </div>

              {/* nameOther = nameReceiver */}

              <div className="b"> <p>{api.nameOther}</p> </div>
            </div>
            {/* block-un */}

            <div className="block-deux"> 
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div className="c"> <p>{api.amount} FCFA</p> </div>
            </div>
            {/* block-deux */}
          </>
        )}
        {/* versement national */}


        {/* notification=6 (versement national) */}
        {api.notification === "6" && idOther && (
          <>
            <div className="block-un">
              <div onClick={GoToPageInfosNotificationIA} className="a">
                <p>{api.description}</p>
                <p>VERSEMENT National</p>
              </div>

              {/* nameOther = nameReceiver */}

              <div className="b"> <p>{api.nameOwner}</p> </div>
            </div>
            {/* block-un */}

            <div className="block-deux"> 
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div className="c"> <p>{api.amount} FCFA</p> </div>
            </div>
            {/* block-deux */}
          </>
        )}
        {/* versement national */}

        {/* notification=7 (versement International recu) */}
        {/* l'utilisateur recoit cette notification s'il a recu un versement */}
        {api.notification === "7" && idOther && (
          <>
            <div className="block-un">
              <div onClick={GoToPageInfosNotificationIA} className="a">
                <p>VERSEMENT International</p>
              </div>
              {/* a */}

              {/* nameOwner = nameSender */}

              <div onClick={GoToPageInfosOtherIA} className="b">
                <p>{api.nameOwner}</p>
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div onClick={GoToPageInfosNotificationIA} className="a">
                <p>{dateParser(api.createdAt)}</p>
              </div>
              {/* a */}

              <div onClick={GoToPageInfosOtherIA} className="b">
                <p>{api.amount} FCFA</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* versement International recu  */}

        {/* notification=8 (Commission achat Numéro virtuel) */}
        {/* il va recevoir cette notification si une personne a acheter son numero virtuel avec son super code */}
        {api.notification === "8" && idOwner && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Commission achat Numéro virtuel</p>
              </div>

              <div className="b">
                <p>{dateParser(api.createdAt)}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Commission achat Numéro virtuel */}

        {/* notification=9 (Identités envoyées) */}
        {/* informations d'identiter de l'entreprise envoyé */}
        {api.notification === "9" && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identités envoyées</p>
              </div>

              <div className="b">
                <p>{api.dateDevalidateAccount}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Identités envoyées */}

        {/* notification=10 (Votre Recharge national a réussie) */}
        {/* recharger mon compte national depuis mon compte international - IA */}
        {api.notification === "10" && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Votre Recharge national a réussie</p>
              </div>

              <div className="b">
                <p>{api.dateDevalidateAccount}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Votre Recharge national a réussie */} 


        {/* notification=11 (stock national gratuit) */}
        {api.notification === "11" && idOther && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a"> <p>Vous avez reçu gratuitement un Stock National de {api.amount} FCFA</p> </div>
              <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* stock national gratuit */}


        {/* notification=12 (Transfert réussie: izocash Buy vers izocash international) */}
        {api.notification === "12" && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Transfert réussie: izocash Buy vers izocash international</p>
              </div>

              <div className="b">
                <p>{api.dateDevalidateAccount}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Transfert réussie: izocash Buy vers izocash international */}


        {/* notification=13 (numero virtuel delivrer) */}
        {api.notification === "13" && idOwner && (
          <>
            <div onClick={GoToPageInfosNotificationIA} style={{ cursor: "pointer" }} className="block-un">
              <div className="a"> <p>Numéro virtuel délivré</p> </div>
              <div className="c"> <p>{api.virtualNumber}</p> </div>
            </div>
            {/* block-un */}

            <div onClick={GoToPageInfosNotificationIA} style={{ cursor: "pointer" }} className="block-deux">
              <div className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div className="b"> <p>{api.amount} FCFA</p> </div>
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* numero virtuel delivrer */}


        {/* notification=14 (rappel pour aller identifier le numero virtuel) */}
        {api.notification === "14" && idOwner && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a"> <p>Chèr(e) Client(e), votre Numéro virtuel n'est point identifier</p> </div>
              <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* rappel pour aller identifier le numero virtuel */}


        {/* notification=15 (stock national payant) */}
        {api.notification === "15" && idOther && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a"> <p>Votre Stock National a été rechargé de {api.amount} FCFA</p> </div>
              <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* stock national payant */}

       
        {/* notification=16 (identification reussie) */}
        {api.notification === "16" && idOwner && (
          <>
            <div onClick={GoToPageInfosNotificationIA} style={{ cursor: "pointer" }} className="block-un">
              <div className="a"> <p>Identification réussie</p> </div>
              <div className="c"> <p>{api.virtualNumber}</p> </div>
            </div>
            {/* block-un */}

            <div onClick={GoToPageInfosNotificationIA} style={{ cursor: "pointer" }} className="block-deux">
              <div className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div className="b"> <p></p> </div>
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* identification reussie */}


         {/* notification=16 (identification reussie) */}
         {api.notification === "16" && idOther && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a"> <p>Bienvenue sur izocash, Votre Numéro virtuel a été identifié !</p> </div>
              <div className="b"> <p>{dateParser(api.createdAt)}</p> </div>
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* identification reussie */}


        {/* notification=17 (Recharge Alrani Pay) */}
        {/* l'utilisateur recoit cette notification s'il a recharger son compte alrani pay */}
        {api.notification === "17" && idOwner && (
        <>
            <div className="block-un">
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>Recharge Alrani Pay</p> </div>
              <div onClick={GoToPageInfosNotificationIA} className="b"> <p>{api.nameOther}</p> </div>
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div onClick={GoToPageInfosNotificationIA} className="a"> <p>{dateParser(api.createdAt)}</p> </div>
              <div onClick={GoToPageInfosNotificationIA} className="b"> <p>{api.amount} FCFA</p> </div>
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* Recharge Alrani Pay  */}


        {/* documents */}
        {/* documents */}
        {/* identiter incomplete (documents d'identiter manquants) - IA */}
        {/* l'utilisateur recoit cette notification s'il n'a pas envoyer les documents 
        d'identiter de son entreprise */}
        {identityIncompleteDocumentMissingIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identitées incomplètes</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* documents */}

        {/* informations */}
        {/* informations */}
        {/* identiter incomplete (Informations de l'entreprise manquantes) - IA */}
        {/* l'utilisateur recoit cette notification s'il n'a pas envoyer les informations 
        d'identiter de son entreprise */}
        {identityIncompleteInformationMissingIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identitées incomplètes</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* informations */}

        {/* logo */}
        {/* logo */}
        {/* identiter incomplete (logo de l'entreprise manquant) - IA */}
        {/* l'utilisateur recoit cette notification s'il n'a pas envoyer le logo de son entreprise */}
        {identityIncompleteLogoMissingIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identitées incomplètes</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* logo */}

        {/* photos */}
        {/* photos */}
        {/* identiter incomplete (photos de l'entreprise manquantes) - IA */}
        {/* l'utilisateur recoit cette notification s'il n'a pas envoyer les photos de son entreprise */}
        {identityIncompletePhotoMissingIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identitées incomplètes</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* photos */}

        {/* Réseaux */}
        {/* Réseaux */}
        {/* identiter incomplete - Réseaux sociaux manquants - IA */}
        {/* l'utilisateur recoit cette notification s'il n'a pas ajouter les réseaux sociaux 
        de son entreprise */}
        {identityIncompleteSocialNetworkMissingIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identitées incomplètes</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Réseaux */}

        {/* identiter valider - IA */}
        {/* identiter valider - IA */}
        {/* l'utilisateur recoit cette notification si ses informations d'identiter ont été 
        validées par izocash Business */}
        {identityValidateIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Identitées valider</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* identiter valider - IA */}

        {/* Stock Recharge presque épuisé - IA */}
        {/* Stock Recharge presque épuisé - IA */}
        {/* l'agence recoit cette notification si son stock recharge est presque epuiser */}
        {stockRefillAlmostExhaustedIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Stock Recharge presque épuisé</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Stock Recharge presque épuisé - IA */}

        {/* Stock Retrait presque épuisé - IA */}
        {/* Stock Retrait presque épuisé - IA */}
        {/* l'agence recoit cette notification si son stock Retrait est presque epuiser */}
        {stockWithdrawalAlmostExhaustedIA && (
          <>
            <div onClick={GoToPageInfosNotificationIA} className="block-trois">
              <div className="a">
                <p>Stock Retrait presque épuisé</p>
              </div>

              <div className="b">
                <p>{api.date}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* Stock Recharge presque épuisé - IA */}

        {/* recharge - (notification client) */}
        {/* recharge - (notification client) */}
        {/* l'utilisateur recoit cette notification apres avoir effectuer une recharge a l'agence */}
        {recharge && (
          <>
            <div className="block-un">
              <div className="a">
                <p onClick={GoToPageInfosNotificationIA}>Recharge éffectuée</p>
              </div>
              {/* a */}

              <div className="b">
                <p onClick={GoToPageInfosOtherIA}>{api.nameAgency}</p>
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a">
                <p onClick={GoToPageInfosNotificationIA}>
                  {api.dateTransaction}
                </p>
              </div>
              {/* a */}

              <div className="b">
                <p onClick={GoToPageInfosOtherIA}>
                  {api.amountTransaction} FCFA
                </p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}
          </>
        )}
        {/* recharge - (notification client) */}

        {/* recharge - (notification agence) */}
        {/* recharge - (notification agence) */}
        {/* l'agence recoit cette notification apres avoir effectuer une recharge a un client */}
        {recharge && (
          <>
            <div className="block-un">
              <div className="a">
                <p>Recharge éffectuée</p>
              </div>
              {/* a */}

              <div className="b">
                <p>{api.nameClient}</p>
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a">
                <p>{api.dateTransaction}</p>
              </div>
              {/* a */}

              <div className="b">
                <p>{api.amountTransaction} FCFA</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* recharge - (notification agence) */}

        {/* retrait - (notification client) */}
        {/* retrait - (notification client) */}
        {/* l'utilisateur recoit cette notification apres avoir effectuer un retrait a l'agence */}
        {retrait && (
          <>
            <div className="block-un">
              <div className="a">
                <p>Retrait réussi</p>
              </div>
              {/* a */}

              <div className="b">
                <p>{api.nameAgency}</p>
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a">
                <p>{api.dateTransaction}</p>
              </div>
              {/* a */}

              <div className="c">
                <p>{api.amountTransaction} FCFA</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}
          </>
        )}
        {/* retrait - (notification client) */}

        {/* retrait - (notification agence) */}
        {/* retrait - (notification agence) */}
        {/* l'agence recoit cette notification apres avoir effectuer un retrait a un client */}
        {retrait && (
          <>
            <div className="block-un">
              <div className="a">
                <p>Retrait réussi</p>
              </div>
              {/* a */}

              <div className="b">
                <p>{api.nameClient}</p>
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a">
                <p>{api.dateTransaction}</p>
              </div>
              {/* a */}

              <div className="c">
                <p>{api.amountTransaction} FCFA</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* retrait - (notification agence) */}

        {/* licence - (notification) */}
        {/* licence - (notification) */}
        {/* l'utilisateur recoit cette notification si une licence lui a ete offert */}
        {licence && (
          <>
            <div className="block-un">
              <div className="a">
                <p>Licence Mini</p>
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a">
                <p>{api.dateOfferLicence}</p>
              </div>
              {/* a */}

              <div className="b">
                <p>Offerte</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}

            <hr />
          </>
        )}
        {/* licence - (notification) */}

        {/* compte devalider - (notification) */}
        {/* compte devalider - (notification) */}
        {/* l'utilisateur recoit cette notification si son compte izocash est devalider */}
        {compteDevalider && (
          <>
            <div className="block-trois">
              <div className="a">
                <p>
                  Rapprochez-vous d'une agence izocash pour la validation de
                  votre compte
                </p>
              </div>

              <div className="b">
                <p>{api.dateDevalidateAccount}</p>
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <hr />
          </>
        )}
        {/* compte devalider - (notification) */}
      </div>
      {/* notification (666 historiquePage) - IA */}
    </>
  );
}

/* EnfantApi au niveau de IMPORTER_DOCUMENT_ENTREPRISE,
dès que le partenaire importe les photos on va les afficher ici pour qu'ils voient
à l'instant t les photos qu'il à importer */
/*function EnfantApiPhotoIdentiterEntrepriseIMPORTERooDOCUMENTooENTREPRISEooIA({
  api,
}) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    //id de la Photo d'identiter
    const idPhotoDidentiter = api._id;
    localStorage.setItem(
      "https://alrani.com/idPhotoDidentiterEntrepriseIA",
      idPhotoDidentiter
    );

    //url de la Photo d'identiter
    const urlPhotoIdentiter = api.photoIdentiter;
    localStorage.setItem(
      "https://alrani.com/urlPhotoDidentiterEntrepriseIA",
      urlPhotoIdentiter
    );
  }

  return (
    <>
      <div onClick={Checked} className="photosDidentiter">
        <div>
          <img src={api.photoIdentiter} alt="" />
        </div>
      </div>
    </>
  );
}*/

//on affiche les photos Didentiter de l'entreprise (verificationDidentiterEntrepriseIA)
/*function EnfantApiPhotoIdentiterEntrepriseIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    //id de la Photo d'identiter
    const idPhotoDidentiter = api._id;
    localStorage.setItem(
      "https://alrani.com/idPhotoDidentiterEntrepriseIA",
      idPhotoDidentiter
    );

    //url de la Photo d'identiter
    const urlPhotoIdentiter = api.photoIdentiter;
    localStorage.setItem(
      "https://alrani.com/urlPhotoDidentiterEntrepriseIA",
      urlPhotoIdentiter
    );
  }

  return (
    <>
      <div onClick={Checked} className="photosDidentiter">
        <div>
          <img src={api.photoIdentiter} alt="" />
        </div>
      </div>
    </>
  );
}*/

//on affiche la liste des zones - IA
function EnfantApiListeDesZonesIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    //id
    const idZone = api._id;
    localStorage.setItem("idZone", idZone);

    //nom
    const nomZone = api.zone;
    localStorage.setItem("nameZone", nomZone);
  }

  return (
    <>
      <div onClick={Checked} className="liste">
        <div> <button>{api.zone}</button> </div>
      </div>
      {/* liste */}
    </>
  );
}

//on affiche la liste des quartiers - IA
function EnfantApiListeDesQuartiersIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre:
    //id
    const idQuartier = api._id;
    localStorage.setItem("idQuarter", idQuartier);

    //nom
    const nomQuartier = api.quarter;
    localStorage.setItem("nameQuarter", nomQuartier);
  }

  return (
    <>
      <div onClick={Checked} className="liste">
        <div> <button>{api.quarter}</button> </div>
      </div>
      {/* liste */}
    </>
  );
}

//on affiche la liste des villes - IA
function EnfantApiListeDesVillesIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    
    //on enregistre:
    const idVille = api._id; //id
    localStorage.setItem("idCity", idVille);

    const nomVille = api.city; //nom
    localStorage.setItem("nameCity", nomVille);
  }

  return (
    <>
      <div onClick={Checked} className="liste">
        <div> <button>{api.city}</button> </div>
      </div>
      {/* liste */}
    </>
  );
}

//on affiche la liste des pays - IA
function EnfantApiListeDesPaysIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    //on enregistre
    const idPays = api._id; //id du pays
    localStorage.setItem("idCountrySelected", idPays);
   
    const nomPays = api.country; //nom du Pays
    localStorage.setItem("countrySelected", nomPays);
  }

  async function ListeVilles() {
    const liste = "1";
    localStorage.setItem("clicListeVilles", liste);
    //
    const masquer = "0";
    localStorage.setItem("clicMasquerVille", masquer);
  }

  async function MasquerVille() {
    const masquer = "1";
    localStorage.setItem("clicMasquerVille", masquer);
    //
    const liste = "0";
    localStorage.setItem("clicListeVilles", liste);
  }

  return (
    <>
      <div onClick={Checked} className="liste">
        <div>
          <button onClick={ListeVilles}>{api.country}</button>
          <svg
            onClick={MasquerVille}
            width="20px"
            cursor="pointer"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 30 30"
          >
            <g transform="translate(0 -289.063)">
              <path
                fill="#ccc"
                fillOpacity="1"
                stroke="none"
                strokeDasharray="none"
                strokeMiterlimit="4"
                strokeOpacity="1"
                strokeWidth="2"
                d="M22.824 296.239a11.986 11.986 0 00-1.542-1.287l-2.665 2.665 2.828 2.828 2.666-2.665a11.986 11.986 0 00-1.287-1.541zm-5.621 2.792L6.596 309.638l-.707 3.535 3.536-.707L20.03 301.86z"
                opacity="0.93"
              ></path>
            </g>
          </svg>
        </div>
      </div>
      {/* liste */}
    </>
  );
}

//on affiche la liste des langues - IA
function EnfantApiListeDesLanguesIA({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);

    // on enregistre:
    const idLangue = api._id; // id
    if (idLangue) { localStorage.setItem("idLanguage", idLangue); }
    
    const nameLanguage = api.language; // nom
    if (nameLanguage) { localStorage.setItem("nameLanguage", nameLanguage);}

    const nameLanguageInEnglish = api.inEnglish; // inEnglish
    if (nameLanguageInEnglish) { localStorage.setItem("nameLanguageInEnglish", nameLanguageInEnglish);}
  }

  return (
    <>
      <div onClick={Checked} className="liste">
        <div> <button>{api.language}</button> </div>
      </div>
      {/* liste */}
    </>
  );
}

//on affiche les modules - VS
function EnfantApiModule({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre :
    //l'id du Module
    const idModule = api._id;
    localStorage.setItem("https://alrani.com/idModule", idModule);
    localStorage.setItem("https://alrani.com/idModuleGeneral", idModule);

    //nom du module
    const nom = api.nomModule;
    localStorage.setItem("https://alrani.com/nomModule", nom);
    localStorage.setItem("https://alrani.com/nomModuleGeneral", nom);

    //url du module
    const url = api.url;
    localStorage.setItem("https://alrani.com/urlModule", url);

    //mini description du module
    /*const miniDesc = api.miniDesc;
    localStorage.setItem("https://alrani.com/miniDesc", miniDesc);*/

    //description du module
    const desc = api.desc;
    localStorage.setItem("https://alrani.com/descModule", desc);

    //description annuel
    const descAnnuel = api.descAnnuel;
    if (descAnnuel) {
      localStorage.setItem("https://alrani.com/descAnnuelModule", descAnnuel);
    }

    //prix du module
    const prix = api.prix;
    localStorage.setItem("https://alrani.com/prixModule", prix);

    //prix annuel
    const prixAnnuel = api.prixAnnuel;
    if (prixAnnuel) {
      localStorage.setItem("https://alrani.com/prixAnnuelModule", prixAnnuel);
    }

    /*valeur du Prix. c'est la valeur du prix qui va nous permettre d'effectuer le calcul pour
    debiter le compte */
    const valeurPrix = api.valeurPrix;
    if (valeurPrix) {
      localStorage.setItem("https://alrani.com/valeurPrix", valeurPrix);
    }

    //valeur Prix Annuel
    const valeurPrixAnnuel = api.valeurPrixAnnuel;
    if (valeurPrixAnnuel) {
      localStorage.setItem(
        "https://alrani.com/valeurPrixAnnuel",
        valeurPrixAnnuel
      );
    }

    //monnaie FCFA
    const monnaieFCFA = api.monnaieFCFA;
    if (monnaieFCFA) {
      localStorage.setItem("https://alrani.com/monnaieFCFA", monnaieFCFA);
    }

    //type
    /* si le type=1, cela veut dire qu'il y'a plusieurs types d'abonnement 
    si le type=0, cela veut dire qu'il y'a 1 seul type d'abonnements */
    const type = api.type;
    if (type) {
      localStorage.setItem("https://alrani.com/typeDabonnement", type);
    }
  }

  return (
    <>
      <div onClick={Checked} className="card">
        <div className="a">
          <button>{api.nomModule}</button>
        </div>

        <div className="b">
          <p>{api.miniDesc}</p>
        </div>
        {/* b */}
      </div>
      {/* card */}
    </>
  );
}

//on affiche les super modules par application - VS
//on affiche les super modules par application - VS
function EnfantApiSuperModule({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre :
    //l'id du superModule
    const idSuperModule = api._id;
    localStorage.setItem("https://alrani.com/idSuperModule", idSuperModule);
    localStorage.setItem("https://alrani.com/idModuleGeneral", idSuperModule);
    localStorage.setItem(
      "https://alrani.com/idSuperModuleReserve",
      idSuperModule
    );

    //nom du super module
    const nom = api.nomSuperModule;
    localStorage.setItem("https://alrani.com/nomSuperModule", nom);
    localStorage.setItem("https://alrani.com/nomModuleGeneral", nom);
    localStorage.setItem("https://alrani.com/nomSuperModuleReserve", nom);

    //l'url du super module
    const url = api.url;
    localStorage.setItem("https://alrani.com/urlModule", url);

    //description du super module
    const desc = api.desc;
    localStorage.setItem("https://alrani.com/descSuperModule", desc);

    /*on enregistre ca car ca va nous permettre d'afficher Gratuit si le super module à
    est Gratuit */
    const gratuit = api.gratuit;
    localStorage.setItem("https://alrani.com/gratuitSuperModule", gratuit);
  }

  return (
    <>
      <div onClick={Checked} className="card">
        <div className="a">
          <p>{api.nomSuperModule}</p>
        </div>

        <div className="b">
          <p>{api.desc}</p>
        </div>
        {/* b */}
      </div>
      {/* card */}
    </>
  );
}

//on affiche les applications de Vixinol Store - VS
//on affiche les applications de Vixinol Store - VS
function EnfantApiListeApp({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre :
    //l'id de l'app
    const idApp = api._id;
    localStorage.setItem("https://alrani.com/idApp", idApp);

    //nom de l'app
    const nomApp = api.nomApp;
    localStorage.setItem("https://alrani.com/nomApp", nomApp);

    //description de l'app
    const descApp = api.desc;
    localStorage.setItem("https://alrani.com/descApp", descApp);

    /*l'url de L'app
    const url = api.url;
    if (url) {
      localStorage.setItem("https://alrani.com/urlModule", url);
    }*/
  }

  return (
    <>
      <div onClick={Checked} className="blockApp">
        <div className="alignCard">
          <div className="card">
            <div className="image-et-nom">
              <div className="image">
                <img src={api.logo} alt="" />
              </div>
              {/* image */}

              <div className="nom">
                <div className="a">
                  <p>{api.nomApp}</p>
                </div>
                {/* a */}

                <div className="b">
                  <p>{api.desc}</p>
                </div>
                {/* b */}
              </div>
              {/* nom */}
            </div>
            {/* image-et-nom */}
          </div>
          {/* card */}
        </div>
        {/* alignCard */}
      </div>
      {/* blockApp */}
    </>
  );
} 


// ChildApi Video666favoriteVB
//on affiche toutes les videos qu'on a ajouter dans nos favoris - VB
function ChildApiVideo666favoriteVB({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    const id = api._id; // id
    localStorage.setItem("idFavoriteVB", id);
    localStorage.setItem("idFavoriteVBreq", id);

    const urlVideo = api.urlVideo; // url de la video
    if (urlVideo) { 
      localStorage.setItem("urlVideoVB", urlVideo); 
      localStorage.setItem("urlVideoVBreq", urlVideo); 
    }

    const urlPhoto = api.urlPhoto; // url de la photo
    if (urlPhoto) { 
      localStorage.setItem("urlPhotoVB", urlPhoto); 
      localStorage.setItem("urlPhotoVBreq", urlPhoto); 
    }
  }

  // go to seePhoto (ca va afficher la photo)
  async function GoToSeePhoto() {
    const seePhoto = "1";
    localStorage.setItem("GoToSeePhoto666favoriteVB", seePhoto);

    const seeVideo = "0";
    localStorage.setItem("GoToSeeVideo666favoriteVB", seeVideo);
  }

  // go to seeVideo (au niveau des favoris VB, ca va afficher la video)
  async function GoToSeeVideo() {
    const seeVideo = "1";
    localStorage.setItem("GoToSeeVideo666favoriteVB", seeVideo);

    const seePhoto = "0";
    localStorage.setItem("GoToSeePhoto666favoriteVB", seePhoto);
  }

  return (
    <>
      <div onClick={Checked} className="videos">
        <div className="block-un">

          {api.urlVideo === "0" ? (<>
          <div className="b">
            <img onClick={GoToSeePhoto} src={api.urlPhoto} alt="" />
            <p>{api.title}</p>
          </div>
          
          </>):(<>  
          <div className="b">
            <img onClick={GoToSeeVideo} src={api.urlPhoto} alt="" />
            <p>{api.title}</p>
          </div>
          {/* b */}
          </>)}

        </div>
        {/* block-un */}
      </div>
      {/* videos */}
    </>
  );
}
// ChildApi Video666FavoriteVB


//on affiche les videos suggérées - SuggestedVideo2 (666SeeVideo2 666homeVB)
function ChildApiSuggestedVideo2666SeeVideo2666homeVB({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    //on enregistre :
   
    const idVideo = api._id; // id de la video
    localStorage.setItem("idVideo666urlVideo3", idVideo);
   
    const urlVideoVB = api.urlVideo; // url de la video
    if (urlVideoVB) { localStorage.setItem("urlVideo3", urlVideoVB); }


    // photo de couverture de la video suggérée
    /*const coverSuggestedVideoVB = api.urlCoverVideo;
    if (coverSuggestedVideoVB) {
      localStorage.setItem(
        "https://alrani.com/coverSuggestedVideoVB",
        coverSuggestedVideoVB
      );
    }*/

    // id du proprietaire de la video suggérée
    /*
    const idOwnerSuggestedVideoVB = api.idOwnerVideo;
    localStorage.setItem(
      "https://alrani.com/idOwnerSuggestedVideoVB",
      idOwnerSuggestedVideoVB
    );*/

    // nom du proprietaire de la video suggérée
    /*const nameOwnerSuggestedVideoVB = api.nameOwnerVideo;
    if (nameOwnerSuggestedVideoVB) {
      localStorage.setItem("https://alrani.com/nameOwnerSuggestedVideoVB", nameOwnerSuggestedVideoVB);
    } */

    // titre de la video suggérée
    /*const title = api.title;
    if (title) {
      localStorage.setItem("https://alrani.com/titleSuggestedVideoVB", title);
    }*/

    //le nombre de personnes qui ont acheter de la video
    /*const nbreVentes = api.nbreVentes;
    if (nbreVentes) {
      localStorage.setItem("https://alrani.com/nbreVentesVB", nbreVentes);
    }*/
  }

  return (
    <>
      <div onClick={Checked} className="suggestedVideo">
        <div className="cover">
          <div className="block-un">
            <div className="a"> <img src={api.coverVideo} alt="" /> </div>

            <div className="b">
              <p></p>
              <button>{api.duration}</button>
            </div>
            {/* b */}
          </div>
          {/* block-un */}
        </div>
        {/* cover */}

        <div className="detail">
          <div className="partOne">
            <div className="block-un"> <img src={api.photoOwner} alt="" /> </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a"> <p>{api.title}</p> </div>
              <div className="b"> <p>{api.nameOwner}</p> </div>
            </div>
            {/* block-deux */}
          </div>
          {/* partOne */}

          <div className="partTwo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15px"
              cursor="pointer"
              fill="#000"
              fillRule="evenodd"
              strokeLinejoin="round"
              strokeMiterlimit="2"
              clipRule="evenodd"
              viewBox="0 0 64 64"
            >
              <path fill="none" d="M-256 -64H1024V736H-256z"></path>
              <g>
                <g>
                  <circle cx="32.026" cy="12.028" r="4"></circle>
                  <circle cx="32.026" cy="52.028" r="4"></circle>
                  <circle cx="32.026" cy="32.028" r="4"></circle>
                </g>
              </g>
            </svg>
          </div>
          {/* partTwo */}
        </div>
        {/* detail */}
      </div>
      {/* suggestedVideo */}
    </>
  );
}

//on affiche toutes les videos de l'utilisateur - AllVideos1 (666Profil1 666homeVB)
function ChildApiAllVideos1666Profil1666homeVB({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    //on enregistre :
    
    const idVideo = api._id; // id de la video
    localStorage.setItem("idVideo666urlVideo3", idVideo);
    
    const urlVideoVB = api.urlVideo; // url de la video
    if (urlVideoVB) { localStorage.setItem("urlVideo3", urlVideoVB); }

    const idOwnerSuggestedVideoVB = api.idOwner; // id du proprietaire de la video suggérée
    if (idOwnerSuggestedVideoVB) { localStorage.setItem("idOwnerSuggestedVideo", idOwnerSuggestedVideoVB); }


    // photo de couverture de la video suggérée
    /*const coverSuggestedVideoVB = api.urlCoverVideo;
    if (coverSuggestedVideoVB) {
      localStorage.setItem(
        "https://alrani.com/coverSuggestedVideoVB",
        coverSuggestedVideoVB
      );
    }*/

    // nom du proprietaire de la video suggérée
    /*const nameOwnerSuggestedVideoVB = api.nameOwnerVideo;
    if (nameOwnerSuggestedVideoVB) {
      localStorage.setItem("https://alrani.com/nameOwnerSuggestedVideoVB", nameOwnerSuggestedVideoVB);
    } */

    // titre de la video suggérée
    /*const title = api.title;
    if (title) {
      localStorage.setItem("https://alrani.com/titleSuggestedVideoVB", title);
    }*/

    //le nombre de personnes qui ont acheter de la video
    /*const nbreVentes = api.nbreVentes;
    if (nbreVentes) {
      localStorage.setItem("https://alrani.com/nbreVentesVB", nbreVentes);
    }*/
  }

  return (
    <>
      <div onClick={Checked} className="video">
        <div className="block-un">
          <div className="a"> <img src={api.coverVideo} alt="" /> </div>

          <div className="b">
            <p></p>
            <button>{api.duration}</button>
          </div>
          {/* b */}
        </div>
        {/* block-un */}

        <div className="block-deux">
          <div className="a"> <p>{api.nameOwner}</p> </div>
          <hr />

          <div className="b"> <p>{api.title}</p> </div>
          <hr />

          <div className="d"> <p>{api.view} personnes ont vues cette vidéo</p> </div>
          <div className="e"> <SvgPlay3 /> </div>
          {/* e */}
        </div>
        {/* block-deux */}
      </div>
      {/* video */}
    </>
  );
}


//on affiche les videos suggérées - VB
function ChildApiSuggestedVideoVB({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    //on enregistre :
   
    const idVideo = api._id; // id de la video suggérée
    localStorage.setItem("idSuggestedVideo", idVideo);

    const urlSuggestedVideoVB = api.urlVideo; // url de la video suggérée
    if (urlSuggestedVideoVB) { localStorage.setItem("urlSuggestedVideo", urlSuggestedVideoVB); }

    const idOwnerSuggestedVideoVB = api.idOwner; // id du proprietaire de la video suggérée
    if (idOwnerSuggestedVideoVB) { localStorage.setItem("idOwnerSuggestedVideo", idOwnerSuggestedVideoVB); }


    // photo de couverture de la video suggérée
    /*const coverSuggestedVideoVB = api.urlCoverVideo;
    if (coverSuggestedVideoVB) {
      localStorage.setItem(
        "https://alrani.com/coverSuggestedVideoVB",
        coverSuggestedVideoVB
      );
    }*/

    // nom du proprietaire de la video suggérée
    /*const nameOwnerSuggestedVideoVB = api.nameOwnerVideo;
    if (nameOwnerSuggestedVideoVB) {
      localStorage.setItem("https://alrani.com/nameOwnerSuggestedVideoVB", nameOwnerSuggestedVideoVB);
    } */

    // titre de la video suggérée
    /*const title = api.title;
    if (title) {
      localStorage.setItem("https://alrani.com/titleSuggestedVideoVB", title);
    }*/

    //le nombre de personnes qui ont acheter de la video
    /*const nbreVentes = api.nbreVentes;
    if (nbreVentes) {
      localStorage.setItem("https://alrani.com/nbreVentesVB", nbreVentes);
    }*/
  }

  return (
    <>
      <div onClick={Checked} className="suggestedVideo">
        <div className="cover">
          <div className="block-un">
            <div className="a"> <img src={api.coverVideo} alt="" /> </div>

            <div className="b">
              <p></p>
              <button>{api.duration}</button>
            </div>
            {/* b */}
          </div>
          {/* block-un */}
        </div>
        {/* cover */}

        <div className="detail">
          <div className="partOne">
            <div className="block-un"> <img src={api.photoOwner} alt="" /> </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a"> <p>{api.title}</p> </div>
              <div className="b"> <p>{api.nameOwner}</p> </div>
            </div>
            {/* block-deux */}
          </div>
          {/* partOne */}

          <div className="partTwo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15px"
              cursor="pointer"
              fill="#000"
              fillRule="evenodd"
              strokeLinejoin="round"
              strokeMiterlimit="2"
              clipRule="evenodd"
              viewBox="0 0 64 64"
            >
              <path fill="none" d="M-256 -64H1024V736H-256z"></path>
              <g>
                <g>
                  <circle cx="32.026" cy="12.028" r="4"></circle>
                  <circle cx="32.026" cy="52.028" r="4"></circle>
                  <circle cx="32.026" cy="32.028" r="4"></circle>
                </g>
              </g>
            </svg>
          </div>
          {/* partTwo */}
        </div>
        {/* detail */}
      </div>
      {/* suggestedVideo */}
    </>
  );
}

//ici on affiche les videos. (nous sommes au niveau de la page d'accueil, Onglet videos) - VB
function EnfantApiVideoVB({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    //on enregistre :

    const idVideo = api._id; // id de la video
    localStorage.setItem("idVideo", idVideo);
    
    const urlVideo = api.urlVideo; // url de la video
    if (urlVideo) { localStorage.setItem("urlVideo", urlVideo); }

    const idOwnerVideoVB = api.idOwner; // id du proprietaire de la video
    if (idOwnerVideoVB) { localStorage.setItem("idOwnerVideo", idOwnerVideoVB); }

    // nom du proprietaire de la video
    /*const nameOwnerVideoVB = api.nameOwnerVideo;
    if (nameOwnerVideoVB) {
      localStorage.setItem("https://alrani.com/nameOwnerVideoVB", nameOwnerVideoVB);
    }*/

    // photo de couverture de la video
    /*const coverVideoVB = api.coverVideo;
    if (coverVideoVB) {
      localStorage.setItem("https://alrani.com/coverVideoVB", coverVideoVB);
    }*/

    // titre de la video
    /*const title = api.title;
    if (title) {
      localStorage.setItem("https://alrani.com/titleVideoVB", title);
    }

    //le nombre de personnes qui ont acheter de la video
    const nbreVentes = api.nbreVentes;
    if (nbreVentes) {
      localStorage.setItem("https://alrani.com/nbreVentesVB", nbreVentes);
    }*/
  }

  const idPersonConnectedVB = localStorage.getItem("idPersonConnectedVB");

  return (
    <>
      <div onClick={Checked} className="video">
        <div className="block-un">
          <div className="a"> <img src={api.coverVideo} alt="" /> </div>

          <div className="b">
            <p></p>
            <button>{api.duration}</button>
          </div>
          {/* b */}
        </div>
        {/* block-un */}

        <div className="block-deux">
          <div className="a"> <p>{api.nameOwner}</p> </div>
          <hr />

          <div className="b"> <p>{api.title}</p> </div>
          <hr />

          {idPersonConnectedVB && (<><div className="d"> <p>{api.view} personnes ont vues cette vidéo</p> </div></>)}
          {!idPersonConnectedVB && (<><div className="d"> <p>{api.viewDemo} personnes ont vues cette vidéo</p> </div></>)}
          <div className="e"> <SvgPlay3 /> </div>
          {/* e */}
        </div>
        {/* block-deux */}
      </div>
      {/* video */}
    </>
  );
}

//on affiche la photo d'identiter du client dans une popup
/* ici on enregistre l'url de la photo d'identiter dans le localStorage pour pouvoir
 visionner la photo d'identiter dans la popup */
function EnfantApiPhotoIdentiterClientIA({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    //on enregistre l'url de la photo d'identiter dans le localStorage
    const photo = api.photo;
    if (photo) { localStorage.setItem("photo", photo); }
  }

  // photo d'identiter dans la popup - IA
  //nous sommes au niveau de verification d'identiter(etape2)/recharge compte izocash,
  //ici on affiche la photo d'identiter du client dans la popup
  const [popupPhotoIdentiterIA, setPopupPhotoIdentiterIA] = useState(false);
  async function PopupPhotoIdentiterIA() {
    setPopupPhotoIdentiterIA(true);
  }
  //fermer le card
  async function ClosePopupPhotoIdentiterIA() {
    setPopupPhotoIdentiterIA(false);
  }

  //on recupere la photo d'identiter du client
  const nameAccount = localStorage.getItem("nameAccount");
  const photo = localStorage.getItem("photo");

  return ( 
    <>
      <div onClick={Checked} className="photoDidentiter">
        <img onClick={PopupPhotoIdentiterIA} src={api.photo} alt="" />
      </div>
      {/* photoDidentiter */} 

      {/* photo d'identiter dans la popup - IA */}
      {/*nous sommes au niveau de verification d'identiter(etape2)/recharge compte izocash,
         ici on affiche la photo d'identiter dans la popup */}
      {popupPhotoIdentiterIA && (
        <>
          <div
            onClick={ClosePopupPhotoIdentiterIA}
            className="popupPhotoIdentiterIA"
          >
            <div className="logo">
              <div className="a">
                <img src={izocashLogoJaune} alt="" />
              </div>

              <div className="b">
                <p>{nameAccount}</p>
              </div>
              {/* b */}
            </div>
            {/* logo */}

            <div style={{ paddingBottom: "20px" }}></div>

            <div className="align">
              <div className="image">
                <img src={photo} alt="" />
              </div>
              {/* image */}
            </div>
            {/* align */}
          </div>
          {/* popupPhotoIdentiterIA */}
        </>
      )}
      {/* photo d'identiter dans la popup - IA */}
    </>
  );
}

function EnfantApiPageBooster({ api }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
    // on enregistre l'id de la page dans le localStorage
    const idAuteur = api._id;
    localStorage.setItem("https://alrani.com/idAuteur", idAuteur);
  }

  /* quand on va cliquer sur la fleche qui est a coter de la phrase d'accroche, alors la popup
  de details va s'ouvrir */
  /* Dans cette popup il y'aura les details que l'entreprenur va mettre, par exemple les 
  endroits ou il fait la livraison, ... */
  const [details, setDetails] = useState(false);
  async function Details() {
    setDetails(!details);
  }

  //ce code va permettre d'afficher les pages par modele
  const modele = api.modele;
  const modele1 = modele === "1";
  const modele2 = modele === "2";
  const modele3 = modele === "3";
  // modele 20 et 10 c'est pour les videos
  /* le modele 3 et 20 c'est la meme chose, la seule chose qui les diffferencie c'est que 
  l'autre a une video et a l'autre une image */
  const modele10 = modele === "10";
  const modele20 = modele === "20";

  return (
    <>
      <div className="page-booster" onClick={Checked}>
        {/* modele 1 */}
        {/* modele 1 */}
        {/* modele 1 */}
        {modele1 && (
          <>
            <div className="modele-un">
              <div className="theme-et-citation">
                <div className="theme">
                  <p>{api.theme}</p>
                </div>
                {/* theme */}

                <div className="citation">
                  <p>{api.citation}</p>
                </div>
                {/* citation */}
              </div>
              {/* theme-et-citation */}

              <div className="photo">
                <img src={api.image} alt="" />
              </div>
              {/* photo */}

              <div className="description-et-nom">
                {/* phrase Daccroche pour attirer l'attention du client */}
                <div className="description">
                  <div className="a">
                    <p onClick={Details}>{api.phraseDaccroche}</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <svg
                      onClick={Details}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      cursor="pointer"
                      width="10px"
                      fill="blue"
                      enableBackground="new 0 0 477.175 477.175"
                      version="1.1"
                      viewBox="0 0 477.175 477.175"
                      xmlSpace="preserve"
                    >
                      <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                    </svg>
                  </div>
                  {/* b */}
                </div>
                {/* description */}

                <div className="display">
                  <div className="nom">
                    <p>{api.nom}</p>
                  </div>
                  {/* nom */}

                  <div className="sabonner">
                    <button>S'abonner</button>
                  </div>
                  {/* sabonner */}
                </div>
                {/* display */}
              </div>
              {/* description-et-nom */}
            </div>
            {/* modele-un */}
          </>
        )}
        {/* modele 1 */}

        {/* modele 2 */}
        {/* modele 2 */}
        {/* modele 2 */}
        {modele2 && (
          <>
            <div className="modele-deux">
              <div className="photo">
                <img src={api.image} alt="" />
              </div>
              {/* photo */}

              <div className="nom">
                <p>{api.nom}</p>
              </div>
              {/* nom */}

              <div className="phraseDaccroche">
                <div className="a">
                  <p onClick={Details}>{api.phraseDaccroche}</p>
                </div>
                {/* a */}

                <div className="b">
                  <svg
                    onClick={Details}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    fill="blue"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div>
                {/* b */}
              </div>
              {/* phraseDaccroche */}

              <div className="sabonner">
                <button>S'abonner</button>
              </div>
              {/* sabonner */}
            </div>
            {/* modele-deux */}
          </>
        )}
        {/* modele 2 */}

        {/* modele 3 */}
        {/* modele 3 */}
        {/* modele 3 */}
        {modele3 && (
          <>
            <div className="modele-trois">
              <div className="card">
                <div className="display">
                  <div className="photo">
                    <img src={api.photoProfil} alt="" />
                  </div>
                  {/* photo */}

                  <div className="nom-et-service">
                    <div className="nom">
                      <p>{api.nom}</p>
                    </div>
                    {/* nom */}

                    <div className="service">
                      <p>{api.serviceOuOccupation}</p>
                    </div>
                    {/* service */}
                  </div>
                  {/* nom-et-service */}
                </div>
                {/* display */}

                <div className="text">
                  <p>{api.text1}</p>
                  <p>{api.text2}</p>
                </div>
                {/* text */}

                <div className="image">
                  <img src={api.image} alt="" />
                </div>
                {/* image */}

                <div className="sabonner">
                  <p></p>
                  <button>S'abonner</button>
                </div>
                {/* sabonner */}
              </div>
              {/* card */}

              <div className="phraseDaccroche">
                <div className="a">
                  <p onClick={Details}>{api.phraseDaccroche}</p>
                </div>
                {/* a */}

                <div className="b">
                  <svg
                    onClick={Details}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    fill="blue"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div>
                {/* b */}
              </div>
              {/* phraseDaccroche */}
            </div>
            {/* modele-trois */}
          </>
        )}
        {/* modele 3 */}

        {/* modele 10 */}
        {/* modele 10 */}
        {/* modele 10 */}
        {modele10 && (
          <>
            <div className="modele-un">
              <div className="theme-et-citation">
                <div className="theme">
                  <p>{api.theme}</p>
                </div>
                {/* theme */}

                <div className="citation">
                  <p>{api.citation}</p>
                </div>
                {/* citation */}
              </div>
              {/* theme-et-citation */}

              <div className="video">
                <video autoPlay={"autoplay"} muted loop controls>
                  <source
                    src="https://res.cloudinary.com/rasivyy/video/upload/v1680563470/Alrani%20-%20Video/Black%20M%20-%20Tic-Tac%20%28Clip%20officiel%29.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              {/* video */}

              <div className="description-et-nom">
                {/* phrase Daccroche pour attirer l'attention du client */}
                <div className="description">
                  <div className="a">
                    <p onClick={Details}>{api.phraseDaccroche}</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <svg
                      onClick={Details}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      cursor="pointer"
                      width="10px"
                      fill="blue"
                      enableBackground="new 0 0 477.175 477.175"
                      version="1.1"
                      viewBox="0 0 477.175 477.175"
                      xmlSpace="preserve"
                    >
                      <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                    </svg>
                  </div>
                  {/* b */}
                </div>
                {/* description */}

                <div className="display">
                  <div className="nom">
                    <p>{api.nom}</p>
                  </div>
                  {/* nom */}

                  <div className="sabonner">
                    <button>S'abonner</button>
                  </div>
                  {/* sabonner */}
                </div>
                {/* display */}
              </div>
              {/* description-et-nom */}
            </div>
            {/* modele-un */}
          </>
        )}
        {/* modele 10 */}

        {/* modele 20 */}
        {/* modele 20 */}
        {/* modele 20 */}
        {/* le modele 20 et 10 c'est pour les video */}
        {/* le modele 20 et le modele 3 c'est la meme chose. c'est juste que pour le modele 20
        j'ai remplacer la photo a la place de l'image */}
        {modele20 && (
          <>
            <div className="modele-trois">
              <div className="card">
                <div className="display">
                  <div className="photo">
                    <img src={api.photoProfil} alt="" />
                  </div>
                  {/* photo */}

                  <div className="nom-et-service">
                    <div className="nom">
                      <p>{api.nom}</p>
                    </div>
                    {/* nom */}

                    <div className="service">
                      <p>{api.serviceOuOccupation}</p>
                    </div>
                    {/* service */}
                  </div>
                  {/* nom-et-service */}
                </div>
                {/* display */}

                <div className="text">
                  <p>{api.text1}</p>
                  <p>{api.text2}</p>
                </div>
                {/* text */}

                <div className="video">
                  <video autoPlay={"autoplay"} muted loop controls>
                    <source
                      src="https://res.cloudinary.com/rasivyy/video/upload/v1680563470/Alrani%20-%20Video/Black%20M%20-%20Tic-Tac%20%28Clip%20officiel%29.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
                {/* video */}

                <div className="sabonner">
                  <p></p>
                  <button>S'abonner</button>
                </div>
                {/* sabonner */}
              </div>
              {/* card */}

              <div className="phraseDaccroche">
                <div className="a">
                  <p onClick={Details}>{api.phraseDaccroche}</p>
                </div>
                {/* a */}

                <div className="b">
                  <svg
                    onClick={Details}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    fill="blue"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div>
              </div>
              {/* phraseDaccroche */}
            </div>
            {/* modele-trois */}
          </>
        )}
        {/* modele 20 */}
      </div>
      {/* page-booster */}

      {/* details ajouter */}
      {/* details ajouter */}
      {/* ici il s'agit des details que l'entrepreneur a ajouter */}
      {/* Dans cette popup il y'aura les details que l'entreprenur va mettre, par exemple les 
      endroits ou il fait la livraison */}
      {details && (
        <>
          <div className="details-ajouter-opacity">
            {/* barre du btn Retour */}
            <div onClick={Details} className="barre-btn-retour">
              <BackSansUseNavigate />
              <p style={{ padding: "10px" }}>
                {api.serviceOuOccupation} • {api.nom}
              </p>
            </div>

            {/* align c'est ce qui met de l'espace en haut et en bas */}
            <div className="align">
              {/* ici ce sont les details que l'entrepreneur a ajouter */}

              <div className="pc-one-book">
                <div className="desc-book">
                  {/* description */}
                  <div className="desc">
                    <p>{api.titre}</p>
                  </div>

                  {/* intro */}
                  <div className="intro">
                    <p>{api.intro}</p>
                  </div>

                  {/* 1er paragraphe */}
                  <div className="paragraph">
                    <p>{api.paragraph1}</p>
                  </div>

                  {/* 2e paragraphe */}
                  <div className="paragraph">
                    <p>{api.paragraph2}</p>
                  </div>

                  {/* 3e paragraphe */}
                  <div className="paragraph">
                    <p>{api.paragraph3}</p>
                  </div>

                  {/* phrase d'appel avant les points forts */}
                  {/* la phrase d'appel est une phrase qui dit au cerveau de rester 
                      concentrer car ce qui est important */}
                  <div className="before-strong-point">
                    <p>{api.phraseDappel}</p>
                  </div>

                  {/* 1er point fort */}
                  <div className="strong-point">
                    <li>{api.element1}</li>
                  </div>

                  {/* 2e point fort */}
                  <div className="strong-point">
                    <li>{api.element2}</li>
                  </div>

                  {/* 3e point fort */}
                  <div className="strong-point">
                    <li>{api.element3}</li>
                  </div>

                  {/* 4e point fort */}
                  <div className="strong-point">
                    <li>{api.element4}</li>
                  </div>

                  {/* 5e point fort */}
                  <div className="strong-point">
                    <li>{api.element5}</li>
                  </div>

                  {/* phrase d'appel apres les points forts */}
                  <div className="after-strong-point">
                    <p>{api.elementFinal}</p>
                  </div>

                  {/* mot de la fin */}
                  <div className="last-word">
                    <p>{api.motDeLaFin}</p>
                  </div>
                  {/* last-word */}
                </div>
                {/* desc-book */}
              </div>
              {/* pc-one-book */}
              {/* */}
              {/* */}
            </div>
            {/* align */}
          </div>
          {/* details-ajouter-opacity */}
        </>
      )}
      {/* details ajouter */}
    </>
  );
}

// notification aux abonnés plumes
// notification aux abonnés plumes
/*
function EnfantApiNotificationAuxAbonnesPlume({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre l'id de la notification dans le localStorage
    const idNotificationPlume = api._id;
    localStorage.setItem(
      "https://alrani.com/idNotificationPlume",
      idNotificationPlume
    );
  }

  return (
    <>
      <div onClick={Checked}>
        <p>{api.notification}</p>
      </div>
    </>
  );
}
*/

// on affiche les notifications
// on affiche les notifications
function EnfantApiNotification({ api }) {
  // opacity
  // opacity
  const [opacity, setOpacity] = useState(false);
  // erreur
  const [erreur, setErreur] = useState(false);
  async function CloseErreur() {
    setErreur(false);
  }
  // message de success - notification supprimer
  const [notificationSupprimerSuccess, setNotificationSupprimerSuccess] =
    useState(false);
  async function CloseNotificationSupprimerSuccess() {
    setNotificationSupprimerSuccess(false);
  }

  /*quand on clique sur une notification, cette popup va s'ouvrir, ensuite on
    pourra lire la notification dans la popup */
  const [lu, setLu] = useState(false);
  async function CloseLu() {
    setLu(false);
  }

  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre l'id de la notification dans le localStorage
    const idPost = api._id;
    localStorage.setItem("https://alrani.com/idNotification", idPost);

    // Ces infos vont permettre d'entrer dans le message
    // l'id
    const idDeLaPersonneQuiInforme = api.idDeLaPersonneQuiInforme;
    if (idDeLaPersonneQuiInforme) {
      localStorage.setItem(
        "https://alrani.com/idDestinataireMessage",
        idDeLaPersonneQuiInforme
      );
    }
    // le nom
    const nomDeLaPersonneQuiInforme = api.nomDeLaPersonneQuiInforme;
    if (nomDeLaPersonneQuiInforme) {
      localStorage.setItem(
        "https://alrani.com/nomDestinataireMessage",
        nomDeLaPersonneQuiInforme
      );
    }
    // la photo
    const photoProfilDeLaPersonneQuiInforme =
      api.photoProfilDeLaPersonneQuiInforme;
    if (photoProfilDeLaPersonneQuiInforme) {
      localStorage.setItem(
        "https://alrani.com/photoProfilDestinataireMessage",
        photoProfilDeLaPersonneQuiInforme
      );
    }
    // le badgeVerified
    const badgeVerifiedDeLaPersonneQuiInforme =
      api.badgeVerifiedDeLaPersonneQuiInforme;
    if (badgeVerifiedDeLaPersonneQuiInforme) {
      localStorage.setItem(
        "https://alrani.com/badgeVerifiedDestinataireMessage",
        badgeVerifiedDeLaPersonneQuiInforme
      );
    }
    // l'idConversation
    const idConversation = api.idConversation;
    if (idConversation) {
      localStorage.setItem("https://alrani.com/idConversation", idConversation);
    }
    // l'idInitieur
    const idInitieur = api.idInitieur;
    if (idInitieur) {
      localStorage.setItem("https://alrani.com/idInitieur", idInitieur);
    }
    // Toutes ces infos vont permettre d'entrer dans le message

    setLu(true);
  }

  async function SupprimerNotification() {
    setOpacity(true);
    setNotificationSupprimerSuccess(true);
    /*await axios({
      method: "delete",
      url: `${process.env.REACT_APP_BACKEND}/api/notificationAA/delete/${idNotification}`,
    })
      .then((res) => {
        setOpacity(false);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });*/
  }

  // avec dateParser on affiche la date a laquelle la personne a mis la photo sur son profil
  // là c'est au niveau des notifications qu'on va afficher cette date
  /* const dateParser = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return newDate;
  }; */

  return (
    <>
      <div onClick={Checked}>
        {/* si lu=0, cela veut dire que la notification n'a pas encore été lu */}
        {api.lu === "0" && (
          <>
            {/* notification=1 (David vous a envoyer un message) */}
            {api.notification === "1" && (
              <>
                <div className="new">
                  <p>
                    {dateParser(api.createdAt)} -{" "}
                    {api.nomDeLaPersonneQuiInforme} vous à envoyer un message
                  </p>
                </div>
                {/* new */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}
              </>
            )}

            {/* notification=2 (la photo a bien ete mise sur le profil) */}
            {api.notification === "2" && (
              <>
                <div className="new">
                  <p>
                    {dateParser(api.createdAt)} - La photo a bien été mise sur
                    le profil
                  </p>
                </div>
                {/* new */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}
              </>
            )}
          </>
        )}

        {/* si lu=1, cela veut dire que la notification a déjà été lu */}
        {api.lu === "1" && (
          <>
            {/* notification=1 (David vous a envoyer un message) */}
            {api.notification === "1" && (
              <>
                <div className="a">
                  <p>
                    {dateParser(api.createdAt)} -{" "}
                    {api.nomDeLaPersonneQuiInforme} vous à envoyer un message
                  </p>
                </div>
                {/* a */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}
              </>
            )}

            {/* notification=2 (la photo a bien ete mise sur le profil) */}
            {api.notification === "2" && (
              <>
                <div className="a">
                  <p>
                    {dateParser(api.createdAt)} - La photo a bien été mise sur
                    le profil
                  </p>
                </div>
                {/* a */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}
              </>
            )}
          </>
        )}
      </div>

      {/* voir notification */}
      {/* quand on clique sur une notification, cette popup va s'ouvrir, ensuite on
        pourra lire la notification dans la popup */}
      {lu && (
        <>
          <div onClick={CloseLu} className="popup-historic-opacity">
            <div className="align">
              <div className="card">
                {/* notification=1 (David vous a envoyer un message) */}
                {api.notification === "1" && (
                  <>
                    <p>
                      {api.nomDeLaPersonneQuiInforme} vous à envoyer un message
                    </p>
                  </>
                )}

                {/* notification=2 (la photo a bien ete mise sur le profil) */}
                {api.notification === "2" && (
                  <>
                    <p>La photo a bien été mise sur le profil</p>
                  </>
                )}

                <div className="a">
                  <p>{dateParser(api.createdAt)}</p>
                </div>
                {/* a */}

                {/* on va utiliser une variable qui va s'appeler parle, pour permettre par exemple, 
                si la notification parle de message, lorsque l'utilisateur clique sur En savoir plus
                ca va le rediriger dans l'onglet message.
                Si la notification parle de photo de profil, lorsqu'il clique cava le rediriger
                dans la partie profil.
                Si la notification parle de publication, lorsqu'il clique cava le rediriger
                dans la partie des posts.
                Bon! pour 
                message c'est 1
                photoProfil c'est 2
                posts c'est 3
                 */}
                {/* si la notification parle de message, message=1 */}
                {api.parle === "1" && (
                  <>
                    <div className="b">
                      <NavLink style={{ textDecoration: "none" }} to="/message">
                        <p>Voir le message</p>
                      </NavLink>

                      {/* svg pour supprimer la notification */}
                      <svg
                        onClick={SupprimerNotification}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        viewBox="0 0 72 72"
                      >
                        <g>
                          <path
                            fill="#FFF"
                            d="M51.76 17H20.153v37.65c0 4.06 3.29 5.62 7.35 5.62H44.41c4.06 0 7.35-1.56 7.35-5.62V17z"
                          ></path>
                          <path
                            fill="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M31 16L31 12 41 12 41 16"
                          ></path>
                          <path
                            fill="#9b9b9a"
                            d="M51 37L51 46.5172 51 57.6207 48.3 60 33 60z"
                          ></path>
                          <path
                            fill="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M17 16H55V20H17z"
                          ></path>
                        </g>
                        <g
                          fill="none"
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          strokeWidth="2"
                        >
                          <path d="M31 16L31 12 41 12 41 16"></path>
                          <path d="M51 25v31a4 4 0 01-4 4H25a4 4 0 01-4-4V25"></path>
                          <path d="M17 16H55V20H17z"></path>
                          <path d="M41 28.25L41 55"></path>
                          <path d="M31 28.25L31 55"></path>
                        </g>
                      </svg>
                    </div>
                  </>
                )}

                {/* si la notification parle de photoProfil, photoProfil=2 */}
                {api.parle === "2" && (
                  <>
                    <div className="b">
                      <NavLink style={{ textDecoration: "none" }} to="/profil">
                        <p>Voir la photo</p>
                      </NavLink>

                      {/* svg pour supprimer la notification */}
                      <svg
                        onClick={SupprimerNotification}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        viewBox="0 0 72 72"
                      >
                        <g>
                          <path
                            fill="#FFF"
                            d="M51.76 17H20.153v37.65c0 4.06 3.29 5.62 7.35 5.62H44.41c4.06 0 7.35-1.56 7.35-5.62V17z"
                          ></path>
                          <path
                            fill="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M31 16L31 12 41 12 41 16"
                          ></path>
                          <path
                            fill="#9b9b9a"
                            d="M51 37L51 46.5172 51 57.6207 48.3 60 33 60z"
                          ></path>
                          <path
                            fill="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M17 16H55V20H17z"
                          ></path>
                        </g>
                        <g
                          fill="none"
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          strokeWidth="2"
                        >
                          <path d="M31 16L31 12 41 12 41 16"></path>
                          <path d="M51 25v31a4 4 0 01-4 4H25a4 4 0 01-4-4V25"></path>
                          <path d="M17 16H55V20H17z"></path>
                          <path d="M41 28.25L41 55"></path>
                          <path d="M31 28.25L31 55"></path>
                        </g>
                      </svg>
                    </div>
                  </>
                )}

                {/* si la notification parle de post, posts=3 */}
                {api.parle === "3" && (
                  <>
                    <div className="b">
                      <NavLink
                        style={{ textDecoration: "none" }}
                        to="/user-posts"
                      >
                        <p>En savoir plus</p>
                      </NavLink>

                      {/* svg pour supprimer la notification */}
                      <svg
                        onClick={SupprimerNotification}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        viewBox="0 0 72 72"
                      >
                        <g>
                          <path
                            fill="#FFF"
                            d="M51.76 17H20.153v37.65c0 4.06 3.29 5.62 7.35 5.62H44.41c4.06 0 7.35-1.56 7.35-5.62V17z"
                          ></path>
                          <path
                            fill="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M31 16L31 12 41 12 41 16"
                          ></path>
                          <path
                            fill="#9b9b9a"
                            d="M51 37L51 46.5172 51 57.6207 48.3 60 33 60z"
                          ></path>
                          <path
                            fill="#FFF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M17 16H55V20H17z"
                          ></path>
                        </g>
                        <g
                          fill="none"
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          strokeWidth="2"
                        >
                          <path d="M31 16L31 12 41 12 41 16"></path>
                          <path d="M51 25v31a4 4 0 01-4 4H25a4 4 0 01-4-4V25"></path>
                          <path d="M17 16H55V20H17z"></path>
                          <path d="M41 28.25L41 55"></path>
                          <path d="M31 28.25L31 55"></path>
                        </g>
                      </svg>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-historic-opacity */}
        </>
      )}
      {/* voir notification */}

      {/* notification Supprimer */}
      {/* notification Supprimer */}
      {/* ce message de success s'affiche lorsque la notification a été supprimé */}
      {notificationSupprimerSuccess && (
        <>
          <div
            onClick={CloseNotificationSupprimerSuccess}
            className="page-general-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="center">
                  <p style={{ color: "black", textAlign: "center" }}>
                    Notification supprimée! Vous pouvez cliquer sur Actualiser
                  </p>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>
      )}
      {/* notification Supprimer */}

      {/* erreur */}
      {/* erreur */}
      {/* api deconne ou utilisateur a entrer des mauvaises donnees ou aucune 
      connexion internet */}
      {erreur && (
        <>
          <div onClick={CloseErreur} className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div className="center">
                  <p>Vérifier votre connexion internet !</p>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>
      )}
      {/* erreur */}

      {/* opacity */}
      {/* opacity */}
      {opacity && (
        <>
          <div className="popup-notice-background">
            <div className="align">
              <p></p>
            </div>
          </div>
        </>
      )}
      {/* opacity */}
    </>
  );
}

// on affiche les posts sur la page alrani business
// on affiche les posts sur la page alrani business
// on affiche les posts sur la page alrani business
function EnfantApiPost({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre l'id du post dans le localStorage
    const idPost = api._id;
    localStorage.setItem("https://alrani.com/idPost", idPost);
  }

  const postStyle = api.postStyle;
  const postStyle1 = postStyle === "1";
  const postStyle2 = postStyle === "2";
  const postStyle3 = postStyle === "3";
  const postStyle4 = postStyle === "4";
  const postStyle5 = postStyle === "5";
  const postStyle10 = postStyle === "10";
  const postStyle20 = postStyle === "20";
  /* postApprouver nous permet d'afficher uniquement des publications qui ont ete approuver par 
le proprietaire de la page ou approuver par l'admin suppreme */
  const getPostApprouver = api.postApprouver;
  const postApprouver = getPostApprouver === "1";

  return (
    <>
      <div onClick={Checked} className="post-page">
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {postApprouver && (
          <>
            {postStyle1 && (
              <>
                {/* 1ere partie - postStyle 1 */}
                <div className="publication-text">
                  <div className="description">
                    <p>{api.descriptionPost}</p>

                    <div className="hr">
                      <hr />
                    </div>

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="btn">
                          <button>Envoyer un message</button>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* description */}
                </div>
                {/* publication-text */}

                {/* 2e partie - postStyle 1 */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p style={{ textAlign: "center" }}>
                            {api.nbreDeVue} personnes ont vues cette publication
                          </p>
                        </>
                      ) : (
                        <>
                          <p style={{ textAlign: "center" }}>
                            {api.nbreDeVue} personne a vue cette publication
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p style={{ textAlign: "center" }}>
                            Publier par {api.nomAdmin}
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p style={{ textAlign: "center" }}>
                            Publier par {api.nomAdmin}
                          </p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 1 */}
          </>
        )}
        {/* postApprouver */}

        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {postApprouver && (
          <>
            {postStyle2 && (
              <>
                {/* 1ere partie - postStyle 2 */}
                <div className="publication-box-shadow">
                  <div className="description">
                    <p style={{ color: "#000" }}>{api.descriptionPost}</p>

                    {api.buttonActiver > 0 && (
                      <>
                        <p style={{ paddingBottom: "20px" }}></p>

                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        {/* section-btn */}
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* description */}
                </div>
                {/* publication-box-shadow */}

                {/* 2e partie - postStyle 2 */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p style={{ textAlign: "center" }}>
                            {api.nbreDeVue} personnes ont vues cette publication
                          </p>
                        </>
                      ) : (
                        <>
                          <p style={{ textAlign: "center" }}>
                            {api.nbreDeVue} personne a vue cette publication
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p style={{ textAlign: "center" }}>
                            Publier par {api.nomAdmin}
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p style={{ textAlign: "center" }}>
                            Publier par {api.nomAdmin}
                          </p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 2 */}
          </>
        )}
        {/* postApprouver */}

        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {postApprouver && (
          <>
            {postStyle3 && (
              <>
                {/* 1ere partie - postStyle 3 */}
                <div className="post">
                  <div className="image">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <img src={api.urlImagePost} alt="" />

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}

                {/* 2e partie - postStyle 3 */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p>
                            {api.nbreDeVue} personnes ont vues cette publication
                          </p>
                        </>
                      ) : (
                        <>
                          <p>
                            {api.nbreDeVue} personne a vue cette publication
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 3 */}
          </>
        )}
        {/* postApprouver */}

        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {postApprouver && (
          <>
            {postStyle4 && (
              <>
                {/* 1ere partie - postStyle 4 */}
                <div className="publication-deux-photos">
                  <div className="card">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <div className="display">
                      <div className="a">
                        <img src={api.urlImage1} alt="" />
                      </div>

                      <div className="b">
                        <img src={api.urlImage2} alt="" />
                      </div>
                      {/* b */}
                    </div>
                    {/* display */}

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* card */}
                </div>
                {/* publication-deux-photos */}

                {/* 2e partie - postStyle 4 */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p>
                            {api.nbreDeVue} personnes ont vues cette publication
                          </p>
                        </>
                      ) : (
                        <>
                          <p>
                            {api.nbreDeVue} personne a vue cette publication
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 4 */}
          </>
        )}
        {/* postApprouver */}

        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {postApprouver && (
          <>
            {postStyle5 && (
              <>
                {/* 1ere partie - postStyle 5 */}
                <div className="publication-trois-photos">
                  <div className="card">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <div className="display">
                      <div className="block-un">
                        <img src={api.urlImage1} alt="" />
                      </div>
                      {/* block-un */}

                      <div className="block-deux">
                        <div className="a">
                          <img src={api.urlImage2} alt="" />
                        </div>

                        <div className="b">
                          <img src={api.urlImage3} alt="" />
                        </div>
                        {/* b */}
                      </div>
                      {/* block-deux */}
                    </div>
                    {/* display */}

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* card */}
                </div>
                {/* publication-trois-photos */}

                {/* 2e partie - postStyle 5 */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p>
                            {api.nbreDeVue} personnes ont vues cette publication
                          </p>
                        </>
                      ) : (
                        <>
                          <p>
                            {api.nbreDeVue} personne a vue cette publication
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 5 */}
          </>
        )}
        {/* postApprouver */}

        {/* postStyle 10 */}
        {/* postStyle 10 */}
        {/* postStyle 10 */}
        {postApprouver && (
          <>
            {postStyle10 && (
              <>
                {/* 1ere partie */}
                <div className="center-video">
                  <div className="video">
                    <p style={{ padding: "3px" }}>{api.descriptionPost}</p>

                    <video autoPlay={"autoplay"} muted loop controls>
                      <source src={api.urlVideo} type="video/mp4" />
                    </video>

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* video */}
                </div>
                {/* center-video */}

                {/* 2e partie */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p style={{ color: "#00cc00" }}>
                            {api.nbreDeVue} personnes ont vues cette vidéo
                          </p>
                        </>
                      ) : (
                        <>
                          <p style={{ color: "#00cc00" }}>
                            {api.nbreDeVue} personne a vue cette vidéo
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 10 */}
          </>
        )}
        {/* postApprouver */}

        {/* postStyle 20 */}
        {/* postStyle 20 */}
        {/* postStyle 20 */}
        {postApprouver && (
          <>
            {postStyle20 && (
              <>
                {/* 1ere partie */}
                {/* espace, on met un peu d'espace en haut, pour separer avec les 
            autres publications, pour que ca ne soit pas trop coller */}
                <div style={{ paddingTop: "5px" }}></div>

                <div className="post">
                  <div className="image">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <img src={api.photoCouvertureVideo} alt="" />

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}

                {/* 2e partie */}
                <div className="post">
                  <div className="image">
                    <div className="nbre-de-vue">
                      {api.nbreDeVue > 1 ? (
                        <>
                          <p style={{ color: "#00cc00" }}>
                            {api.nbreDeVue} personnes ont vues cette vidéo
                          </p>
                        </>
                      ) : (
                        <>
                          <p style={{ color: "#00cc00" }}>
                            {api.nbreDeVue} personne a vue cette vidéo
                          </p>
                        </>
                      )}

                      {api.roleAdmin === "2" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}

                      {api.roleAdmin === "3" && (
                        <>
                          <p>Publier par {api.nomAdmin}</p>
                        </>
                      )}
                    </div>
                    {/* nbre-de-vue */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}
              </>
            )}
            {/* postStyle 20 */}
          </>
        )}
        {/* postApprouver */}
      </div>
      {/* post-page */}
    </>
  );
}

// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
// on affiche les publications en attente
function EnfantPublicationEnAttente({ api }) {
  const [opacity, setOpacity] = useState(false);
  const [erreur, setErreur] = useState(false);
  async function CloseErreur() {
    setErreur(false);
  }
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre l'id du post dans le localStorage
    const idPostEnAttente = api._id;
    localStorage.setItem("https://alrani.com/idPostEnAttente", idPostEnAttente);
  }

  // ce toggle nous permet de changer entre la photo de couverture et la video
  // là nous sommes au niveau de publication en attente
  const [toggleCouverture, setToggleCouverture] = useState(true);
  async function ToggleCouverture() {
    setToggleCouverture(!toggleCouverture);
  }
  // message de success - publication rejeter
  const [rejeterSuccess, setRejeterSuccess] = useState(false);
  async function CloseRejeterSuccess() {
    setRejeterSuccess(false);
  }
  // message de success - publication approuver
  const [approuverSuccess, setApprouverSuccess] = useState(false);
  async function CloseApprouverSuccess() {
    setApprouverSuccess(false);
  }
  /* la logique ci c'est pour afficher la popup qui va permettre de cliquer sur Approuver pour 
  Approuver la publication */
  const [approuver, setApprouver] = useState(false);
  async function Approuver() {
    setApprouver(!approuver);
  }
  /* la logique ci c'est pour afficher la popup qui va permettre de cliquer sur Rejeter pour 
  Rejeter la publication */
  const [rejeter, setRejeter] = useState(false);
  async function Rejeter() {
    setRejeter(!rejeter);
  }
  // quand on clique c'est pour approuver la publication
  //quand on clique, ca remplace postApprouver a 1 (parceque avant s'etait 3, pour postEnAttente)
  async function ApprouverPost(e) {
    e.preventDefault();
    setApprouver(true);
    setOpacity(true);
    const approuver = "1";
    const idPostEnAttente = localStorage.getItem(
      "https://alrani.com/idPostEnAttente"
    );

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPostEnAttente}`,
      data: {
        postApprouver: approuver,
      },
    })
      .then((res) => {
        setOpacity(false);
        setApprouverSuccess(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // quand on clique c'est pour rejeter la publication
  //quand on clique, postApprouver passe a 0 (parceque avant s'etait 3, pour postEnAttente)
  async function RejeterPost(e) {
    e.preventDefault();
    setRejeter(true);
    setOpacity(true);
    const rejeter = "0";
    const idPostEnAttente = localStorage.getItem(
      "https://alrani.com/idPostEnAttente"
    );

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPostEnAttente}`,
      data: {
        postApprouver: rejeter,
      },
    })
      .then((res) => {
        setOpacity(false);
        setRejeterSuccess(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }

  const postStyle = api.postStyle;
  const postStyle1 = postStyle === "1";
  const postStyle2 = postStyle === "2";
  const postStyle3 = postStyle === "3";
  const postStyle4 = postStyle === "4";
  const postStyle5 = postStyle === "5";
  // pour les post approuver
  const post = api.postApprouver;
  // post approuver c'est 1
  // post en attente d'approbation c'est 3
  const postEnAttente = post === "3";
  // post rejeter c'est 0
  // post supprimer c'est 9

  /* ici avec le roleAdmin on va masquer le bouton approuver et le bouton Rejeter,
   si c'est un admin lombda il ne verra pas ces 2 boutons, le bouton sera visible uniquement 
   par l'admin supreme et par le proprietaire de la page */
  const roleAdmin = localStorage.getItem("https://alrani.com/roleAdmin");

  return (
    <>
      <div onClick={Checked} className="publication">
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* ca c'est pour les posts en attente */}
        {postEnAttente && (
          <>
            {/* ca c'est pour le style de post, avec 2 images, 3 images... */}
            {postStyle1 && (
              <>
                <div className="publication-text">
                  <div className="description">
                    <p>{api.descriptionPost}</p>

                    <div className="hr">
                      <hr />
                    </div>

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="btn">
                          <button>Envoyer un message</button>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* description */}
                </div>
                {/* publication-text */}

                {/* avec roleAdmin on va masquer le btn Approuver et le btn Rejeter, 
                si c'est un admin lombda il ne verra pas ces 2 boutons, ces boutons seront 
                visible uniquement par l'admin supreme et par le proprietaire de la page */}
                {roleAdmin === "1" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}

                {roleAdmin === "2" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}
                {/* btn */}
              </>
            )}
            {/* postStyle 1 */}
          </>
        )}
        {/* postEnAttente */}

        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* ca c'est pour les posts en attente */}
        {postEnAttente && (
          <>
            {/* ca c'est pour le style de post, avec 2 images, 3 images... */}
            {postStyle2 && (
              <>
                <div className="publication-box-shadow">
                  <div className="description">
                    <p style={{ color: "#000" }}>{api.descriptionPost}</p>

                    {api.buttonActiver > 0 && (
                      <>
                        <p style={{ paddingBottom: "20px" }}></p>

                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        {/* section-btn */}
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* description */}
                </div>
                {/* publication-box-shadow */}

                {/* avec roleAdmin on va masquer le btn Approuver et le btn Rejeter, 
                si c'est un admin lombda il ne verra pas ces 2 boutons, ces boutons seront 
                visible uniquement par l'admin supreme et par le proprietaire de la page */}
                {roleAdmin === "1" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}

                {roleAdmin === "2" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}
                {/* btn */}
              </>
            )}
            {/* postStyle 2 */}
          </>
        )}
        {/* postEnAttente */}

        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* ca c'est pour les posts en attente */}
        {postEnAttente && (
          <>
            {/* ca c'est pour le style de post, avec 2 images, 3 images... */}
            {postStyle3 && (
              <>
                <div className="post">
                  <div className="image">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <img src={api.urlImagePost} alt="" />

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}

                {/* avec roleAdmin on va masquer le btn Approuver et le btn Rejeter, 
                si c'est un admin lombda il ne verra pas ces 2 boutons, ces boutons seront 
                visible uniquement par l'admin supreme et par le proprietaire de la page */}
                {roleAdmin === "1" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}

                {roleAdmin === "2" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}
                {/* btn */}
              </>
            )}
            {/* postStyle 3 */}
          </>
        )}
        {/* postEnAttente */}

        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* ca c'est pour les posts en attente */}
        {postEnAttente && (
          <>
            {/* ca c'est pour le style de post, avec 2 images, 3 images... */}
            {postStyle4 && (
              <>
                <div className="publication-deux-photos">
                  <div className="card">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <div className="display">
                      <div className="a">
                        <img src={api.urlImage1} alt="" />
                      </div>

                      <div className="b">
                        <img src={api.urlImage2} alt="" />
                      </div>
                      {/* b */}
                    </div>
                    {/* display */}

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* card */}
                </div>
                {/* publication-deux-photos */}

                {/* avec roleAdmin on va masquer le btn Approuver et le btn Rejeter, 
                si c'est un admin lombda il ne verra pas ces 2 boutons, ces boutons seront 
                visible uniquement par l'admin supreme et par le proprietaire de la page */}
                {roleAdmin === "1" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}

                {roleAdmin === "2" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}
                {/* btn */}
              </>
            )}
            {/* postStyle 4 */}
          </>
        )}
        {/* postEnAttente */}

        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* ca c'est pour les posts en attente */}
        {postEnAttente && (
          <>
            {/* ca c'est pour le style de post, avec 2 images, 3 images... */}
            {postStyle5 && (
              <>
                <div className="publication-trois-photos">
                  <div className="card">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <div className="display">
                      <div className="block-un">
                        <img src={api.urlImage1} alt="" />
                      </div>
                      {/* block-un */}

                      <div className="block-deux">
                        <div className="a">
                          <img src={api.urlImage2} alt="" />
                        </div>

                        <div className="b">
                          <img src={api.urlImage3} alt="" />
                        </div>
                        {/* b */}
                      </div>
                      {/* block-deux */}
                    </div>
                    {/* display */}

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* card */}
                </div>
                {/* publication-trois-photos */}

                {/* avec roleAdmin on va masquer le btn Approuver et le btn Rejeter, 
                si c'est un admin lombda il ne verra pas ces 2 boutons, ces boutons seront 
                visible uniquement par l'admin supreme et par le proprietaire de la page */}
                {roleAdmin === "1" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}

                {roleAdmin === "2" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}
                {/* btn */}
              </>
            )}
            {/* postStyle 5 */}
          </>
        )}
        {/* postEnAttente */}

        {/* video en attente de validation */}
        {postEnAttente && (
          <>
            {/* approuver ou rejeter */}
            {/* si l'admin a publier une video, ici on va soit approuver ou rejeter la video */}
            {api.urlVideo && (
              <>
                {/* Pas de photo de couverture a la video,
               ici c'est le cas ou l'admin lombda n'a pas ajouter une photo de couverture
                 a la video,
              quand ya pas une photo de couverture a la video, on affiche directement la video */}
                {toggleCouverture ? (
                  <>
                    <div className="center-video">
                      <div className="video">
                        <p style={{ padding: "3px" }}>{api.descriptionPost}</p>

                        <video autoPlay={"autoplay"} muted loop controls>
                          <source src={api.urlVideo} type="video/mp4" />
                        </video>

                        {api.buttonActiver > 0 && (
                          <>
                            <div className="section-btn">
                              <p>Envoyer un message</p>
                            </div>
                            <p style={{ paddingBottom: "5px" }}></p>
                          </>
                        )}
                        {/* button activer */}

                        {/* ca va s'afficher seulement si une photo de couverture a ete ajouter
                      a la video */}
                        {api.photoCouvertureVideo && (
                          <>
                            <div className="photo-couverture-video">
                              <p onClick={ToggleCouverture}>
                                Photo de couverture de la vidéo
                              </p>
                            </div>
                          </>
                        )}
                        {/*  */}
                      </div>
                      {/* video */}
                    </div>
                    {/* center-video */}
                  </>
                ) : (
                  <>
                    {/* ici c'est le cas ou l'admin lombda a ajouter une photo de couverture
                 a la video */}
                    <div className="post">
                      <div className="image">
                        <p
                          style={{
                            paddingTop: "3px",
                            paddingBottom: "5px",
                            paddingLeft: "3px",
                            color: "#000",
                          }}
                        >
                          {api.descriptionPost}
                        </p>

                        <img src={api.photoCouvertureVideo} alt="" />

                        {api.buttonActiver > 0 && (
                          <>
                            <div className="section-btn">
                              <p>Envoyer un message</p>
                            </div>
                            <p style={{ paddingBottom: "5px" }}></p>
                          </>
                        )}
                        {/* button activer */}
                      </div>
                      {/* image */}
                    </div>
                    {/* post */}
                    <div className="photo-couverture-video">
                      <p onClick={ToggleCouverture}>Voir la vidéo</p>
                    </div>
                  </>
                )}
                {/* le togglePhotoCouvertureVideo se ferme ici */}

                {/* avec roleAdmin on va masquer le btn Approuver et le btn Rejeter, 
                si c'est un admin lombda il ne verra pas ces 2 boutons, ces boutons seront 
                visible uniquement par l'admin supreme et par le proprietaire de la page */}
                {roleAdmin === "1" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}

                {roleAdmin === "2" && (
                  <>
                    <div className="btn">
                      <button onClick={Approuver}>Approuver</button>
                      <button onClick={Rejeter}>Rejeter</button>
                    </div>
                  </>
                )}
                {/* btn */}
              </>
            )}
            {/* approuver ou rejeter */}
          </>
        )}
        {/* video en attente de validation */}
      </div>
      {/* publication */}

      {/* message de success - Publication rejeté */}
      {/* message de success - Publication rejeté */}
      {rejeterSuccess && (
        <>
          <div onClick={CloseRejeterSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Publication rejetée! Vous pouvez actualiser la page</p>
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* message de success - Publication approuvé */}
      {/* message de success - Publication approuvé */}
      {approuverSuccess && (
        <>
          <div onClick={CloseApprouverSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Publication Approuvée! Vous pouvez actualiser la page</p>
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}
      {/* message de success - Publication approuvé */}

      {/* on a mis ca parce que qu'on on clique directement sur Approuver, idPostAttente qu'on
      enregistre dans le localStorage n'etait pas pris en compte  */}
      {/* Quand on clique sur Approuver, 
      premierement ca enregistre idPostAttente dans le localStorage, 
      deuxiemement quand la popup de Approuver la publication s'affiche, là on clique sur
      Approuver, puis ca envoie la valeur dans la bdd */}
      {approuver && (
        <>
          <div onClick={Approuver} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Approuver la publication !</p>

                    <div className="btn-bleu-transparent">
                      <button onClick={ApprouverPost}>Approuver</button>
                    </div>
                    {/* btn-bleu-transparent */}
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* Quand on clique sur Rejeter, 
      premierement ca enregistre idPostAttente dans le localStorage, 
      deuxiemement quand la popup de Rejeter la publication s'affiche, là on clique sur
      Rejeter, puis ca envoie la valeur dans la bdd */}
      {rejeter && (
        <>
          <div onClick={Rejeter} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Rejeter la publication !</p>

                    <div className="btn-bleu-transparent">
                      <button onClick={RejeterPost}>Rejeter</button>
                    </div>
                    {/* btn-bleu-transparent */}
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* erreur */}
      {/* api deconne ou utilisateur a entrer des mauvaises donnees ou aucune connexion internet */}
      {erreur && (<>
          <div onClick={CloseErreur} className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div className="center"> <p>Vérifier votre connexion internet !</p> </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>)}
      {/* erreur */}

      {/* opacity */}
      {/* opacity */}
      {opacity && (<>
          <div className="popup-notice-background">
            <div className="align">
              <p></p>
            </div>
          </div>
        </>)}
      {/* opacity */}
    </>
  );
}

// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
// on affiche les publications rejeter
function EnfantPublicationRejeter({ api }) {
  const [isLoading, setIsLoading] = useState(false);
  const [opacity, setOpacity] = useState(false);
  const [erreur, setErreur] = useState(false);
  async function CloseErreur() {
    setErreur(false);
  }
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre l'id du post rejeter dans le localStorage
    const idPostRejeter = api._id;
    localStorage.setItem("https://alrani.com/idPostRejeter", idPostRejeter);
    /* on enregistre la description du post, ca c'est au niveau de 
    publication rejeter pour permettre a l'administrateur lombda/supreme ou au
    proprietaire de la page de modifier la description du post */
    /* si le proprietaire de la page ou l'admin supreme veut modifier la 
    description du post de l'admin, il doit d'abord rejeter le post, ensuite il va
    dans l'onglet publication rejeter pour modifier la description */
    const getDescriptionPost = api.descriptionPost;
    localStorage.setItem(
      "https://alrani.com/modifierDescriptionPost",
      getDescriptionPost
    );
  }

  // ce toggle nous permet de changer entre la photo de couverture et la video
  // là nous sommes au niveau de Publication rejetée
  const [toggleCouverture, setToggleCouverture] = useState(true);
  async function ToggleCouverture() {
    setToggleCouverture(!toggleCouverture);
  }

  // message de success - publication supprimer
  const [supprimerSuccess, setSupprimerSuccess] = useState(false);
  async function CloseSupprimerSuccess() {
    setSupprimerSuccess(false);
  }
  // message de success - publication approuver
  const [approuverSuccess, setApprouverSuccess] = useState(false);
  async function CloseApprouverSuccess() {
    setApprouverSuccess(false);
  }
  // message de success - publication modifier
  const [modifierSuccess, setModifierSuccess] = useState(false);
  async function CloseModifierSuccess() {
    setModifierSuccess(false);
    setModifier(false);
  }
  /* la logique ci c'est pour afficher la popup qui va permettre de cliquer sur Approuver pour 
  Approuver la publication */
  const [approuver, setApprouver] = useState(false);
  async function Approuver() {
    setApprouver(!approuver);
  }
  /* la logique ci c'est pour afficher la popup qui va permettre de cliquer sur Supprimer pour 
  Supprimer la publication */
  const [supprimer, setSupprimer] = useState(false);
  async function Supprimer() {
    setSupprimer(!supprimer);
  }
  /* la logique ci c'est pour afficher la popup qui va permettre de cliquer sur Modifier pour 
  Modifier la publication */
  const [modifier, setModifier] = useState(false);
  async function Modifier() {
    setModifier(!modifier);
  }
  // quand on clique c'est pour approuver la publication
  //quand on clique, ca remplace postApprouver a 1 (parceque avant s'etait 3, pour postEnAttente)
  async function ApprouverPost(e) {
    e.preventDefault();
    setApprouver(true);
    setOpacity(true);
    const approuver = "1";
    const idPostRejeter = localStorage.getItem(
      "https://alrani.com/idPostRejeter"
    );

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPostRejeter}`,
      data: {
        postApprouver: approuver,
      },
    })
      .then((res) => {
        setOpacity(false);
        setApprouverSuccess(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // quand on clique c'est pour supprimer la publication
  //quand on clique pour supprimer, postApprouver passe a 9
  async function SupprimerPost(e) {
    e.preventDefault();
    setSupprimer(true);
    setOpacity(true);
    const supprimer = "9";
    const idPostRejeter = localStorage.getItem(
      "https://alrani.com/idPostRejeter"
    );

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPostRejeter}`,
      data: {
        postApprouver: supprimer,
      },
    })
      .then((res) => {
        setOpacity(false);
        setSupprimerSuccess(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }

  // ici, quand on clique c'est pour modifier la publication
  //quand on clique sur Modifier, une popup s'ouvre, puis on modifie la description du post
  const getDescriptionPost = api.descriptionPost;
  const [descriptionPost, setDescriptionPost] = useState(getDescriptionPost);
  async function ModifierPost(e) {
    e.preventDefault();
    setIsLoading(true);
    setModifier(true);
    setOpacity(true);
    const idPostRejeter = localStorage.getItem(
      "https://alrani.com/idPostRejeter"
    );
    /* le postApprouver est important ici car si c'est un admin suppreme ou si c'est 
    le proprietaire de la page qui a modifier la publication, la publication sera directement 
    publier mais si c'est un admin lombda, la publication sera basculer dans publication en 
    attente de validation, car là nous sommes dans la partie des publications rejeter */
    const postApprouver = localStorage.getItem(
      "https://alrani.com/postApprouverAdmin"
    );

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPostRejeter}`,
      data: {
        descriptionPost: descriptionPost,
        postApprouver: postApprouver,
      },
    })
      .then((res) => {
        setIsLoading(false);
        setOpacity(false);
        setModifierSuccess(true);
      })
      .catch((err) => {
        setIsLoading(false);
        setOpacity(false);
        setErreur(true);
      });
  }

  const postStyle = api.postStyle;
  const postStyle1 = postStyle === "1";
  const postStyle2 = postStyle === "2";
  const postStyle3 = postStyle === "3";
  const postStyle4 = postStyle === "4";
  const postStyle5 = postStyle === "5";
  // pour les post approuver
  const post = api.postApprouver;
  // post approuver c'est 1
  // post en attente d'approbation c'est 3
  // post rejeter c'est 0
  // post supprimer c'est 9
  const postRejeter = post === "0";

  /* ici avec le roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */
  const roleAdmin = localStorage.getItem("https://alrani.com/roleAdmin");

  return (
    <>
      <div onClick={Checked} className="publication">
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* postStyle 1 */}
        {/* ca c'est pour les posts rejeter */}
        {postRejeter && (
          <>
            {/* ca c'est pour le Style de post, avec 2 images, 3 images... */}
            {postStyle1 && (
              <>
                <div className="publication-text">
                  <div className="description">
                    <p>{api.descriptionPost}</p>

                    <div className="hr">
                      <hr />
                    </div>

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="btn">
                          <button>Envoyer un message</button>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* description */}
                </div>
                {/* publication-text */}

                <div className="btn">
                  {/* avec roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */}
                  {roleAdmin === "1" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}
                  <button onClick={Modifier}>Modifier la publication</button>
                  <button onClick={Supprimer}>Supprimer la publication</button>
                </div>
                {/* btn */}
              </>
            )}
            {/* postStyle 1 */}
          </>
        )}
        {/* postRejeter */}

        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* postStyle 2 */}
        {/* ca c'est pour les posts rejeter */}
        {postRejeter && (
          <>
            {/* ca c'est pour le Style de post, avec 2 images, 3 images... */}
            {postStyle2 && (
              <>
                <div className="publication-box-shadow">
                  <div className="description">
                    <p style={{ color: "#000" }}>{api.descriptionPost}</p>

                    {api.buttonActiver > 0 && (
                      <>
                        <p style={{ paddingBottom: "20px" }}></p>

                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        {/* section-btn */}
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* description */}
                </div>
                {/* publication-box-shadow */}

                <div className="btn">
                  {/* avec roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */}
                  {roleAdmin === "1" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}
                  <button onClick={Modifier}>Modifier la publication</button>
                  <button onClick={Supprimer}>Supprimer la publication</button>
                </div>
                {/* btn */}
              </>
            )}
            {/* postStyle 2 */}
          </>
        )}
        {/* postRejeter */}

        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* postStyle 3 */}
        {/* ca c'est pour les posts rejeter */}
        {postRejeter && (
          <>
            {/* ca c'est pour le Style de post, avec 2 images, 3 images... */}
            {postStyle3 && (
              <>
                <div className="post">
                  <div className="image">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <img src={api.urlImagePost} alt="" />

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer */}
                  </div>
                  {/* image */}
                </div>
                {/* post */}

                <div className="btn">
                  {/* avec roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */}
                  {roleAdmin === "1" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}
                  <button onClick={Modifier}>Modifier la publication</button>
                  <button onClick={Supprimer}>Supprimer la publication</button>
                </div>
                {/* btn */}
              </>
            )}
            {/* postStyle 3 */}
          </>
        )}
        {/* postRejeter */}

        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* postStyle 4 */}
        {/* ca c'est pour les posts rejeter */}
        {postRejeter && (
          <>
            {/* ca c'est pour le Style de post, avec 2 images, 3 images... */}
            {postStyle4 && (
              <>
                <div className="publication-deux-photos">
                  <div className="card">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <div className="display">
                      <div className="a">
                        <img src={api.urlImage1} alt="" />
                      </div>

                      <div className="b">
                        <img src={api.urlImage2} alt="" />
                      </div>
                      {/* b */}
                    </div>
                    {/* display */}

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* card */}
                </div>
                {/* publication-deux-photos */}

                <div className="btn">
                  {/* avec roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */}
                  {roleAdmin === "1" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}
                  <button onClick={Modifier}>Modifier la publication</button>
                  <button onClick={Supprimer}>Supprimer la publication</button>
                </div>
                {/* btn */}
              </>
            )}
            {/* postStyle 4 */}
          </>
        )}
        {/* postRejeter */}

        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* postStyle 5 */}
        {/* ca c'est pour les posts rejeter */}
        {postRejeter && (
          <>
            {/* ca c'est pour le Style de post, avec 2 images, 3 images... */}
            {postStyle5 && (
              <>
                <div className="publication-trois-photos">
                  <div className="card">
                    <p
                      style={{
                        paddingTop: "3px",
                        paddingBottom: "5px",
                        paddingLeft: "3px",
                        color: "#000",
                      }}
                    >
                      {api.descriptionPost}
                    </p>

                    <div className="display">
                      <div className="block-un">
                        <img src={api.urlImage1} alt="" />
                      </div>
                      {/* block-un */}

                      <div className="block-deux">
                        <div className="a">
                          <img src={api.urlImage2} alt="" />
                        </div>

                        <div className="b">
                          <img src={api.urlImage3} alt="" />
                        </div>
                        {/* b */}
                      </div>
                      {/* block-deux */}
                    </div>
                    {/* display */}

                    {api.buttonActiver > 0 && (
                      <>
                        <div className="section-btn">
                          <p>Envoyer un message</p>
                        </div>
                        <p style={{ paddingBottom: "5px" }}></p>
                      </>
                    )}
                    {/* button activer*/}
                  </div>
                  {/* card */}
                </div>
                {/* publication-trois-photos */}

                <div className="btn">
                  {/* avec roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */}
                  {roleAdmin === "1" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}
                  <button onClick={Modifier}>Modifier la publication</button>
                  <button onClick={Supprimer}>Supprimer la publication</button>
                </div>
                {/* btn */}
              </>
            )}
            {/* postStyle 5 */}
          </>
        )}
        {/* postRejeter */}

        {/* video rejeter */}
        {postRejeter && (
          <>
            {/* approuver ou rejeter */}
            {/* si l'admin a publier une video, ici on va soit approuver, rejeter ou supprimer
             la video */}
            {/* mais on rejette */}
            {api.urlVideo && (
              <>
                {/* Pas de photo de couverture a la video,
               ici c'est le cas ou l'admin lombda n'a pas ajouter une photo de couverture
                 a la video,
              quand ya pas une photo de couverture a la video, on affiche directement la video */}
                {toggleCouverture ? (
                  <>
                    <div className="center-video">
                      <div className="video">
                        <p style={{ padding: "3px" }}>{api.descriptionPost}</p>

                        <video autoPlay={"autoplay"} muted loop controls>
                          <source src={api.urlVideo} type="video/mp4" />
                        </video>

                        {api.buttonActiver > 0 && (
                          <>
                            <div className="section-btn">
                              <p>Envoyer un message</p>
                            </div>
                            <p style={{ paddingBottom: "5px" }}></p>
                          </>
                        )}
                        {/* button activer */}

                        {/* ca va s'afficher seulement si une photo de couverture a ete ajouter
                      a la video */}
                        {api.photoCouvertureVideo && (
                          <>
                            <div className="photo-couverture-video">
                              <p onClick={ToggleCouverture}>
                                Photo de couverture de la vidéo
                              </p>
                            </div>
                          </>
                        )}
                        {/*  */}
                      </div>
                      {/* video */}
                    </div>
                    {/* center-video */}
                  </>
                ) : (
                  <>
                    {/* ici c'est le cas ou l'admin lombda a ajouter une photo de couverture
                 a la video */}
                    <div className="post">
                      <div className="image">
                        <p
                          style={{
                            paddingTop: "3px",
                            paddingBottom: "5px",
                            paddingLeft: "3px",
                            color: "#000",
                          }}
                        >
                          {api.descriptionPost}
                        </p>

                        <img src={api.photoCouvertureVideo} alt="" />

                        {api.buttonActiver > 0 && (
                          <>
                            <div className="section-btn">
                              <p>Envoyer un message</p>
                            </div>
                            <p style={{ paddingBottom: "5px" }}></p>
                          </>
                        )}
                        {/* button activer */}
                      </div>
                      {/* image */}
                    </div>
                    {/* post */}
                    <div className="photo-couverture-video">
                      <p onClick={ToggleCouverture}>Voir la vidéo</p>
                    </div>
                  </>
                )}
                {/* le togglePhotoCouvertureVideo se ferme ici */}

                <div className="btn">
                  {/* avec roleAdmin on va masquer le bouton approuver la pubication, si c'est un 
  admin lombda il ne verra pas ce bouton, le bouton sera visible uniquement par l'admin supreme
  et par le proprietaire de la page */}
                  {roleAdmin === "1" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <button onClick={Approuver}>
                        Approuver la publication
                      </button>
                    </>
                  )}
                  <button onClick={Modifier}>Modifier la publication</button>
                  <button onClick={Supprimer}>Supprimer la publication</button>
                </div>
                {/* btn */}
              </>
            )}
            {/* approuver ou rejeter */}
          </>
        )}
        {/* video rejeter */}
      </div>
      {/* publication */}

      {/* message de success - Publication supprimée */}
      {/* message de success - Publication supprimée */}
      {supprimerSuccess && (
        <>
          <div onClick={CloseSupprimerSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Publication supprimée! Vous pouvez actualiser la page</p>
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* message de success - Publication approuvée */}
      {/* message de success - Publication approuvée */}
      {approuverSuccess && (
        <>
          <div onClick={CloseApprouverSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Publication Approuvée! Vous pouvez actualiser la page</p>
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}
      {/* message de success - Publication approuvée */}

      {/* on a mis ca parce que qu'on on clique directement sur Approuver, idPostAttente qu'on
      enregistre dans le localStorage n'etait pas pris en compte  */}
      {/* Quand on clique sur Approuver, 
      premierement ca enregistre idPostAttente dans le localStorage, 
      deuxiemement quand la popup de Approuver la publication s'affiche, là on clique sur
      Approuver, puis ca envoie la valeur dans la bdd */}
      {approuver && (
        <>
          <div onClick={Approuver} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Approuver la publication !</p>

                    <div className="btn-bleu-transparent">
                      <button onClick={ApprouverPost}>Approuver</button>
                    </div>
                    {/* btn-bleu-transparent */}
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* Quand on clique sur Supprimer,  
      premierement ca enregistre idPostAttente dans le localStorage, 
      deuxiemement quand la popup de Supprimer la publication s'affiche, là on clique sur
      Supprimer, puis ca envoie la valeur dans la bdd */}
      {supprimer && (
        <>
          <div onClick={Supprimer} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Supprimer la publication !</p>

                    <div className="btn-bleu-transparent">
                      <button onClick={SupprimerPost}>Supprimer</button>
                    </div>
                    {/* btn-bleu-transparent */}
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* Quand on clique sur Modifier, 
      premierement ca enregistre idPostAttente dans le localStorage, 
      deuxiemement quand la popup de Modifier la publication s'affiche, là on clique sur
      Modifier, puis ca envoie la valeur dans la bdd */}
      {modifier && (
        <>
          <div className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p style={{ color: "blue" }} onClick={Modifier}>
                      Modifier la publication
                    </p>

                    <div className="textarea">
                      <textarea
                        value={descriptionPost}
                        onChange={(e) => setDescriptionPost(e.target.value)}
                      ></textarea>
                    </div>
                    {/* textarea */}

                    {isLoading ? (
                      <div className="loader-display-flex">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <div className="btn-bleu-transparent">
                          <button onClick={ModifierPost}>Valider</button>
                        </div>
                        {/* btn-bleu-transparent */}
                      </>
                    )}
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
          {/* modifier la description du post - page */}

          {/* message de success - Publication approuvée */}
          {/* message de success - Publication approuvée */}
          {modifierSuccess && (
            <>
              <div
                onClick={CloseModifierSuccess}
                className="page-general-opacity"
              >
                <div className="align">
                  <div className="card">
                    <div className="center">
                      <p>
                        Publication Modifiée! Vous pouvez actualiser la page
                      </p>
                    </div>
                    {/* center */}
                  </div>
                  {/* card */}
                </div>
                {/* align */}
              </div>
              {/* page-general-opacity */}
            </>
          )}
          {/* message de success - Publication approuvée */}
        </>
      )}

      {/* erreur */}
      {/* api deconne ou utilisateur a entrer des mauvaises donnees ou aucune 
      connexion internet */}
      {erreur && (
        <>
          <div onClick={CloseErreur} className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div className="center">
                  <p>Vérifier votre connexion internet !</p>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>
      )}
      {/* erreur */}

      {/* opacity */}
      {/* opacity */}
      {opacity && (
        <>
          <div className="popup-notice-background">
            <div className="align">
              <p></p>
            </div>
          </div>
        </>
      )}
      {/* opacity */}
    </>
  );
}


// on affiche la liste des pages que vous gerer
// on affiche la liste des pages que vous gerer
export function EnfantApiAdmin({ api }) {
  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // ici on enregistre l'idPage dans le localStorage
    const idPage = api.idPage;
    localStorage.setItem("https://alrani.com/idPage", idPage);

    const idAdmin = api.idAdmin;
    localStorage.setItem("https://alrani.com/idAdmin", idAdmin);

    const nomAdmin = api.nomAdmin;
    localStorage.setItem("https://alrani.com/nomAdmin", nomAdmin);

    const roleAdmin = api.roleAdmin;
    localStorage.setItem("https://alrani.com/roleAdmin", roleAdmin);
    /* quand on clique sur la page qu'on gere, on enregistre le postApprouver dans 
    le localStorage, le postApprouver va nous servir lorsqu'on voudra publier une publication,
    quand on publie avec le postApprouver 3, cela veut dire que cette publication a ete 
    publier par un admin lombda, si c'est 1, cela veut dire que c'est un admin suppreme*/
    const postApprouver = api.postApprouverAdmin;
    localStorage.setItem(
      "https://alrani.com/postApprouverAdmin",
      postApprouver
    );

    // cette requete nous permet de recuperer visible, et d'enregistrer le buttonActiver
    /* visible c'est cette variable qui se trouve sur le profil de chaque utilisateur
     si visible=1, cela veut dire que la page de l'utilisateur a ete mise en avant, 
    si visible=3, cela veut dire que la page n'a pas ete mise en avant.
    le buttonActiver, on l'enregistre tout simplement pour dire que par defaut le btn
    Envoyer un message est desactiver, si le buttonActiver=0, cela veut dire que le btn
    Envoyer un message est desactiver sur le post, buttonActiver=1 cela veut dire que le
    btn Envoyer un message est activé sur le post */
    const getIdPage = localStorage.getItem("https://alrani.com/idPage");
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA/${getIdPage}`)
      .then((res) => {
        const visible = res.data.visible;
        if (visible) {
          localStorage.setItem("https://alrani.com/visible", visible);
        }

        const buttonActiver = "0";
        localStorage.setItem("https://alrani.com/buttonActiver", buttonActiver);
      });
  }

  return (
    <>
      <div onClick={Checked} className="display">
        {/* si photoProfil=0, on affiche le svg, mais si photoProfil n'est pas egale a 0,
        cela veut dire qu'il y'a l'url de la photo de profil, alors on affiche la photo de profil */}
        <div className="block">
          {api.photoProfilPage === "0" ? (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                cursor="pointer"
                width="35px"
                enableBackground="new 0 0 481.613 481.613"
                version="1.1"
                viewBox="0 0 481.613 481.613"
                xmlSpace="preserve"
              >
                <path d="M12.331 253.313c6.6 0 12-5.4 12-12v-.2-.3c0-6.6-5.4-12-12-12s-12 5.4-12 12v.6c0 6.6 5.3 11.9 12 11.9zM467.931 205.413c-6.6.7-11.4 6.6-10.7 13.2.6 6.2 5.8 10.8 11.9 10.8.4 0 .8 0 1.2-.1 6.6-.7 11.4-6.6 10.7-13.1-.6-6.6-6.4-11.4-13.1-10.8zM14.531 206.513c.8.2 1.6.3 2.4.3 5.6 0 10.6-3.9 11.8-9.6 1.3-6.5-2.9-12.8-9.4-14.2-6.5-1.3-12.8 2.9-14.2 9.4-1.3 6.4 2.9 12.7 9.4 14.1zM208.831 455.413c-6.5-1-12.7 3.5-13.6 10.1-1 6.6 3.5 12.7 10.1 13.6.6.1 1.2.1 1.8.1 5.8 0 11-4.3 11.8-10.2.9-6.5-3.6-12.6-10.1-13.6zM161.631 38.013c1.4 0 2.8-.3 4.2-.8 6.2-2.3 9.4-9.2 7.1-15.4-2.3-6.2-9.2-9.4-15.4-7.1s-9.4 9.2-7.1 15.4c1.8 4.9 6.4 7.9 11.2 7.9zM295.631 30.613c1 .3 2 .4 3 .4 5.3 0 10.2-3.6 11.6-9 1.7-6.4-2.2-13-8.6-14.6-6.4-1.7-13 2.2-14.6 8.6-1.7 6.4 2.2 12.9 8.6 14.6zM126.831 425.213c-5.6-3.5-13-1.8-16.5 3.9-3.5 5.6-1.8 13 3.8 16.5 2 1.2 4.2 1.8 6.3 1.8 4 0 7.9-2 10.2-5.7 3.6-5.6 1.8-13-3.8-16.5zM120.131 58.413c2.2 0 4.4-.6 6.3-1.8 5.6-3.5 7.3-10.9 3.8-16.5s-10.9-7.3-16.5-3.8-7.3 10.9-3.8 16.5c2.3 3.6 6.2 5.6 10.2 5.6zM46.731 362.213c-5.4 3.8-6.8 11.3-2.9 16.7 2.3 3.3 6.1 5.1 9.8 5.1 2.4 0 4.8-.7 6.9-2.2 5.4-3.8 6.8-11.3 2.9-16.7-3.8-5.4-11.3-6.7-16.7-2.9zM252.231 24.013h.6c6.4 0 11.7-5 12-11.4.3-6.6-4.8-12.3-11.4-12.6-6.6-.3-12.3 4.8-12.6 11.4-.3 6.7 4.8 12.3 11.4 12.6zM423.131 380.613c-5-4.3-12.6-3.7-16.9 1.3s-3.7 12.6 1.3 16.9c2.3 1.9 5 2.9 7.8 2.9 3.4 0 6.7-1.4 9.1-4.2 4.3-5 3.7-12.5-1.3-16.9zM415.031 103.513c2.8 0 5.6-1 7.8-2.9 5-4.3 5.6-11.9 1.3-16.9-4.3-5-11.9-5.6-16.9-1.3-5 4.3-5.6 11.9-1.3 16.9 2.4 2.7 5.7 4.2 9.1 4.2zM252.731 457.613c-6.6.3-11.7 6-11.4 12.6.3 6.4 5.6 11.4 12 11.4h.6c6.6-.3 11.7-6 11.4-12.6s-6-11.8-12.6-11.4zM470.431 251.813c-6.6-.7-12.5 4.2-13.1 10.8-.7 6.6 4.2 12.5 10.8 13.1.4 0 .8.1 1.2.1 6.1 0 11.3-4.6 11.9-10.8.6-6.7-4.2-12.6-10.8-13.2zM75.131 398.913c-4.6 4.8-4.4 12.4.5 17 2.3 2.2 5.3 3.3 8.3 3.3 3.2 0 6.3-1.3 8.7-3.7 4.6-4.8 4.3-12.4-.5-17-4.8-4.7-12.5-4.4-17 .4zM374.431 412.313c-5.2 4.1-6.2 11.6-2.1 16.8 2.4 3 5.9 4.6 9.5 4.6 2.6 0 5.2-.8 7.3-2.5 5.2-4.1 6.2-11.6 2.1-16.9-4-5.2-11.6-6.1-16.8-2zM336.831 45.813c1.7.8 3.5 1.2 5.3 1.2 4.4 0 8.7-2.5 10.8-6.7 2.9-6 .5-13.1-5.5-16s-13.1-.5-16.1 5.5c-3 5.9-.5 13.1 5.5 16zM206.531 26.413c.6 0 1.2 0 1.8-.1 6.5-1 11-7.1 10-13.7s-7.1-11-13.7-10.1c-6.5 1-11 7.1-10 13.7.9 5.9 6.1 10.2 11.9 10.2zM448.431 175.613c1.6 5.1 6.3 8.4 11.4 8.4 1.2 0 2.4-.2 3.6-.6 6.3-2 9.8-8.7 7.8-15s-8.7-9.8-15-7.8c-6.3 1.9-9.8 8.7-7.8 15zM441.531 141.413c2 0 4-.5 5.8-1.5 5.8-3.2 7.9-10.5 4.6-16.3-3.2-5.8-10.5-7.9-16.3-4.6-5.8 3.2-7.9 10.5-4.6 16.3 2.2 3.9 6.3 6.1 10.5 6.1zM83.431 86.813c3 0 6-1.1 8.3-3.3 4.8-4.6 5-12.2.4-17s-12.2-5-17-.4-5 12.2-.4 17c2.4 2.5 5.6 3.7 8.7 3.7zM296.131 450.913c-6.4 1.7-10.3 8.2-8.6 14.6 1.4 5.4 6.3 9 11.6 9 1 0 2-.1 3-.4 6.4-1.7 10.3-8.2 8.6-14.6-1.7-6.4-8.2-10.3-14.6-8.6zM463.631 297.713c-6.3-2-13.1 1.6-15 7.9-2 6.3 1.6 13.1 7.9 15 1.2.4 2.4.5 3.6.5 5.1 0 9.9-3.3 11.5-8.4 1.8-6.3-1.7-13.1-8-15zM447.631 341.213c-5.8-3.2-13.1-1.1-16.3 4.7-3.2 5.8-1.1 13.1 4.7 16.3 1.8 1 3.8 1.5 5.8 1.5 4.2 0 8.3-2.2 10.5-6.2 3.2-5.8 1.1-13.1-4.7-16.3zM337.231 435.613c-6 2.9-8.4 10.1-5.5 16.1 2.1 4.2 6.4 6.7 10.8 6.7 1.8 0 3.6-.4 5.3-1.2 6-2.9 8.4-10.1 5.5-16.1-3-6-10.2-8.5-16.1-5.5zM166.331 444.513c-6.2-2.3-13.1.9-15.4 7.1s.9 13.1 7.1 15.4c1.4.5 2.8.8 4.1.8 4.9 0 9.5-3 11.3-7.9 2.3-6.2-.9-13.1-7.1-15.4zM46.431 119.813c2.1 1.4 4.5 2.1 6.9 2.1 3.8 0 7.5-1.8 9.8-5.1 3.8-5.4 2.5-12.9-3-16.7-5.4-3.8-12.9-2.5-16.7 3-3.8 5.5-2.4 12.9 3 16.7zM26.031 161.513c1.5.7 3.1 1 4.7 1 4.7 0 9.1-2.7 11-7.3 2.6-6.1-.2-13.2-6.3-15.8s-13.1.2-15.8 6.3c-2.5 6.1.3 13.2 6.4 15.8zM28.831 285.013c-1.4-6.5-7.7-10.7-14.2-9.3-6.5 1.3-10.7 7.7-9.3 14.2 1.2 5.7 6.2 9.6 11.7 9.6.8 0 1.6-.1 2.4-.3 6.5-1.4 10.7-7.7 9.4-14.2zM42.031 326.813c-2.6-6.1-9.7-8.9-15.8-6.3s-8.9 9.7-6.3 15.8c2 4.5 6.4 7.2 11 7.2 1.6 0 3.2-.3 4.8-1 6.1-2.5 8.9-9.6 6.3-15.7zM374.031 69.113c2.2 1.7 4.8 2.5 7.3 2.5 3.6 0 7.1-1.6 9.5-4.7 4-5.2 3.1-12.8-2.1-16.8-5.2-4.1-12.8-3.1-16.8 2.1-4.1 5.2-3.1 12.8 2.1 16.9zM241.331 221.613c32.2 0 58.5-26.2 58.5-58.5s-26.2-58.5-58.5-58.5-58.5 26.2-58.5 58.5 26.3 58.5 58.5 58.5zm0-93c19 0 34.5 15.5 34.5 34.5s-15.5 34.5-34.5 34.5-34.5-15.5-34.5-34.5 15.5-34.5 34.5-34.5zM327.531 281.713c-20-27-49-40.7-86.2-40.7s-66.2 13.7-86.2 40.7c-15 20.3-24.6 47.9-28.5 81.9-.7 6.6 4 12.5 10.6 13.3s12.5-4 13.3-10.6c7.6-67.2 38.2-101.3 90.8-101.3s83.2 34.1 90.8 101.3c.7 6.1 5.9 10.7 11.9 10.7.4 0 .9 0 1.4-.1 6.6-.7 11.3-6.7 10.6-13.3-3.9-34-13.5-61.6-28.5-81.9z"></path>
              </svg>
            </>
          ) : (
            <>
              <img src={api.photoProfilPage} alt="" />
            </>
          )}
        </div>
        {/* block */}

        <div className="block-deux">
          {/* si badgeVerifiedPage=1, alors le badge va s'afficher a coter du nom */}
          <div className="a">
            <p>{api.nomPage}</p>
            {api.badgeVerifiedPage === "1" && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="blue"
                    fillRule="evenodd"
                    d="M15.418 5.643a1.25 1.25 0 00-1.34-.555l-1.798.413a1.25 1.25 0
01-.56 0l-1.798-.413a1.25 1.25 0 00-1.34.555l-.98
1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 00-.555 1.338l.413
1.8a1.25 1.25 0 010 .559l-.413 1.799a1.25 1.25 0 00.555
1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674
1.339.555l1.798-.413a1.25 1.25 0 01.56 0l1.799.413a1.25 1.25 0
001.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0
00.554-1.34L18.5 12.28a1.25 1.25 0 010-.56l.413-1.799a1.25 1.25 0
00-.554-1.339l-1.565-.98a1.25 1.25 0 01-.395-.395l-.98-1.564zm-.503
4.127a.5.5 0 00-.86-.509l-2.615 4.426-1.579-1.512a.5.5 0 10-.691.722l2.034
1.949a.5.5 0 00.776-.107l2.935-4.97z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </>
            )}
          </div>

          {/* si serviceOuOccupationPage=undefined ca va rien afficher
           sinon ca va afficher le service/occupation que l'utilisateur a entrer */}
          {api.serviceOuOccupationPage === "undefined" ? (
            <>
              <p></p>
            </>
          ) : (
            <>
              <div className="b">
                <p>{api.serviceOuOccupationPage}</p>
              </div>
              {/* b */}
            </>
          )}
        </div>
        {/* block-deux */}
      </div>
      {/* display */}
    </>
  );
}


// lorsqu'on lance la recherche et apres on clique sur l'administrateur a ajouter
export function EnfantSearchAdministrateur({ api }) {
  //const [opacity, setOpacity] = useState(false);
  const [erreur, setErreur] = useState(false);
  async function CloseErreur() {
    setErreur(false);
  }

  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);
  }

  // Administrateur ajouter avec Success
  /* ceci va etre declencher une fois que l'Administrateur a été
  ajouté c'est un message de success */
  const [administrateurSuccess, setAdministrateurSuccess] = useState(false);
  async function AdministrateurSuccess() {
    setAdministrateurSuccess(!administrateurSuccess);
  }

  return (
    <>
      <div onClick={Checked}>
        <div className="search-administrateur">
          <div className="compte">
            {/* si photoProfil=0, on affiche le svg, mais si photoProfil n'est pas egale a 0,
             cela veut dire qu'il y'a l'url de la photo de profil, alors on affiche la photo de profil */}
            <div className="display">
              {api.photoProfil === "0" ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="35px"
                    enableBackground="new 0 0 481.613 481.613"
                    version="1.1"
                    viewBox="0 0 481.613 481.613"
                    xmlSpace="preserve"
                  >
                    <path d="M12.331 253.313c6.6 0 12-5.4 12-12v-.2-.3c0-6.6-5.4-12-12-12s-12 5.4-12 12v.6c0 6.6 5.3 11.9 12 11.9zM467.931 205.413c-6.6.7-11.4 6.6-10.7 13.2.6 6.2 5.8 10.8 11.9 10.8.4 0 .8 0 1.2-.1 6.6-.7 11.4-6.6 10.7-13.1-.6-6.6-6.4-11.4-13.1-10.8zM14.531 206.513c.8.2 1.6.3 2.4.3 5.6 0 10.6-3.9 11.8-9.6 1.3-6.5-2.9-12.8-9.4-14.2-6.5-1.3-12.8 2.9-14.2 9.4-1.3 6.4 2.9 12.7 9.4 14.1zM208.831 455.413c-6.5-1-12.7 3.5-13.6 10.1-1 6.6 3.5 12.7 10.1 13.6.6.1 1.2.1 1.8.1 5.8 0 11-4.3 11.8-10.2.9-6.5-3.6-12.6-10.1-13.6zM161.631 38.013c1.4 0 2.8-.3 4.2-.8 6.2-2.3 9.4-9.2 7.1-15.4-2.3-6.2-9.2-9.4-15.4-7.1s-9.4 9.2-7.1 15.4c1.8 4.9 6.4 7.9 11.2 7.9zM295.631 30.613c1 .3 2 .4 3 .4 5.3 0 10.2-3.6 11.6-9 1.7-6.4-2.2-13-8.6-14.6-6.4-1.7-13 2.2-14.6 8.6-1.7 6.4 2.2 12.9 8.6 14.6zM126.831 425.213c-5.6-3.5-13-1.8-16.5 3.9-3.5 5.6-1.8 13 3.8 16.5 2 1.2 4.2 1.8 6.3 1.8 4 0 7.9-2 10.2-5.7 3.6-5.6 1.8-13-3.8-16.5zM120.131 58.413c2.2 0 4.4-.6 6.3-1.8 5.6-3.5 7.3-10.9 3.8-16.5s-10.9-7.3-16.5-3.8-7.3 10.9-3.8 16.5c2.3 3.6 6.2 5.6 10.2 5.6zM46.731 362.213c-5.4 3.8-6.8 11.3-2.9 16.7 2.3 3.3 6.1 5.1 9.8 5.1 2.4 0 4.8-.7 6.9-2.2 5.4-3.8 6.8-11.3 2.9-16.7-3.8-5.4-11.3-6.7-16.7-2.9zM252.231 24.013h.6c6.4 0 11.7-5 12-11.4.3-6.6-4.8-12.3-11.4-12.6-6.6-.3-12.3 4.8-12.6 11.4-.3 6.7 4.8 12.3 11.4 12.6zM423.131 380.613c-5-4.3-12.6-3.7-16.9 1.3s-3.7 12.6 1.3 16.9c2.3 1.9 5 2.9 7.8 2.9 3.4 0 6.7-1.4 9.1-4.2 4.3-5 3.7-12.5-1.3-16.9zM415.031 103.513c2.8 0 5.6-1 7.8-2.9 5-4.3 5.6-11.9 1.3-16.9-4.3-5-11.9-5.6-16.9-1.3-5 4.3-5.6 11.9-1.3 16.9 2.4 2.7 5.7 4.2 9.1 4.2zM252.731 457.613c-6.6.3-11.7 6-11.4 12.6.3 6.4 5.6 11.4 12 11.4h.6c6.6-.3 11.7-6 11.4-12.6s-6-11.8-12.6-11.4zM470.431 251.813c-6.6-.7-12.5 4.2-13.1 10.8-.7 6.6 4.2 12.5 10.8 13.1.4 0 .8.1 1.2.1 6.1 0 11.3-4.6 11.9-10.8.6-6.7-4.2-12.6-10.8-13.2zM75.131 398.913c-4.6 4.8-4.4 12.4.5 17 2.3 2.2 5.3 3.3 8.3 3.3 3.2 0 6.3-1.3 8.7-3.7 4.6-4.8 4.3-12.4-.5-17-4.8-4.7-12.5-4.4-17 .4zM374.431 412.313c-5.2 4.1-6.2 11.6-2.1 16.8 2.4 3 5.9 4.6 9.5 4.6 2.6 0 5.2-.8 7.3-2.5 5.2-4.1 6.2-11.6 2.1-16.9-4-5.2-11.6-6.1-16.8-2zM336.831 45.813c1.7.8 3.5 1.2 5.3 1.2 4.4 0 8.7-2.5 10.8-6.7 2.9-6 .5-13.1-5.5-16s-13.1-.5-16.1 5.5c-3 5.9-.5 13.1 5.5 16zM206.531 26.413c.6 0 1.2 0 1.8-.1 6.5-1 11-7.1 10-13.7s-7.1-11-13.7-10.1c-6.5 1-11 7.1-10 13.7.9 5.9 6.1 10.2 11.9 10.2zM448.431 175.613c1.6 5.1 6.3 8.4 11.4 8.4 1.2 0 2.4-.2 3.6-.6 6.3-2 9.8-8.7 7.8-15s-8.7-9.8-15-7.8c-6.3 1.9-9.8 8.7-7.8 15zM441.531 141.413c2 0 4-.5 5.8-1.5 5.8-3.2 7.9-10.5 4.6-16.3-3.2-5.8-10.5-7.9-16.3-4.6-5.8 3.2-7.9 10.5-4.6 16.3 2.2 3.9 6.3 6.1 10.5 6.1zM83.431 86.813c3 0 6-1.1 8.3-3.3 4.8-4.6 5-12.2.4-17s-12.2-5-17-.4-5 12.2-.4 17c2.4 2.5 5.6 3.7 8.7 3.7zM296.131 450.913c-6.4 1.7-10.3 8.2-8.6 14.6 1.4 5.4 6.3 9 11.6 9 1 0 2-.1 3-.4 6.4-1.7 10.3-8.2 8.6-14.6-1.7-6.4-8.2-10.3-14.6-8.6zM463.631 297.713c-6.3-2-13.1 1.6-15 7.9-2 6.3 1.6 13.1 7.9 15 1.2.4 2.4.5 3.6.5 5.1 0 9.9-3.3 11.5-8.4 1.8-6.3-1.7-13.1-8-15zM447.631 341.213c-5.8-3.2-13.1-1.1-16.3 4.7-3.2 5.8-1.1 13.1 4.7 16.3 1.8 1 3.8 1.5 5.8 1.5 4.2 0 8.3-2.2 10.5-6.2 3.2-5.8 1.1-13.1-4.7-16.3zM337.231 435.613c-6 2.9-8.4 10.1-5.5 16.1 2.1 4.2 6.4 6.7 10.8 6.7 1.8 0 3.6-.4 5.3-1.2 6-2.9 8.4-10.1 5.5-16.1-3-6-10.2-8.5-16.1-5.5zM166.331 444.513c-6.2-2.3-13.1.9-15.4 7.1s.9 13.1 7.1 15.4c1.4.5 2.8.8 4.1.8 4.9 0 9.5-3 11.3-7.9 2.3-6.2-.9-13.1-7.1-15.4zM46.431 119.813c2.1 1.4 4.5 2.1 6.9 2.1 3.8 0 7.5-1.8 9.8-5.1 3.8-5.4 2.5-12.9-3-16.7-5.4-3.8-12.9-2.5-16.7 3-3.8 5.5-2.4 12.9 3 16.7zM26.031 161.513c1.5.7 3.1 1 4.7 1 4.7 0 9.1-2.7 11-7.3 2.6-6.1-.2-13.2-6.3-15.8s-13.1.2-15.8 6.3c-2.5 6.1.3 13.2 6.4 15.8zM28.831 285.013c-1.4-6.5-7.7-10.7-14.2-9.3-6.5 1.3-10.7 7.7-9.3 14.2 1.2 5.7 6.2 9.6 11.7 9.6.8 0 1.6-.1 2.4-.3 6.5-1.4 10.7-7.7 9.4-14.2zM42.031 326.813c-2.6-6.1-9.7-8.9-15.8-6.3s-8.9 9.7-6.3 15.8c2 4.5 6.4 7.2 11 7.2 1.6 0 3.2-.3 4.8-1 6.1-2.5 8.9-9.6 6.3-15.7zM374.031 69.113c2.2 1.7 4.8 2.5 7.3 2.5 3.6 0 7.1-1.6 9.5-4.7 4-5.2 3.1-12.8-2.1-16.8-5.2-4.1-12.8-3.1-16.8 2.1-4.1 5.2-3.1 12.8 2.1 16.9zM241.331 221.613c32.2 0 58.5-26.2 58.5-58.5s-26.2-58.5-58.5-58.5-58.5 26.2-58.5 58.5 26.3 58.5 58.5 58.5zm0-93c19 0 34.5 15.5 34.5 34.5s-15.5 34.5-34.5 34.5-34.5-15.5-34.5-34.5 15.5-34.5 34.5-34.5zM327.531 281.713c-20-27-49-40.7-86.2-40.7s-66.2 13.7-86.2 40.7c-15 20.3-24.6 47.9-28.5 81.9-.7 6.6 4 12.5 10.6 13.3s12.5-4 13.3-10.6c7.6-67.2 38.2-101.3 90.8-101.3s83.2 34.1 90.8 101.3c.7 6.1 5.9 10.7 11.9 10.7.4 0 .9 0 1.4-.1 6.6-.7 11.3-6.7 10.6-13.3-3.9-34-13.5-61.6-28.5-81.9z"></path>
                  </svg>
                </>
              ) : (
                <>
                  <div className="block">
                    <img src={api.photoProfil} alt="" />
                  </div>
                  {/* block */}
                </>
              )}

              <div className="block-deux">
                <div className="a">
                  <p>{api.nomAuteur}</p>
                  {/* si badgeVerified=1, on affiche le badge a cote du nom */}
                  {api.badgeVerified === "1" && (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="blue"
                          fillRule="evenodd"
                          d="M15.418 5.643a1.25 1.25 0 00-1.34-.555l-1.798.413a1.25 1.25 0
01-.56 0l-1.798-.413a1.25 1.25 0 00-1.34.555l-.98
1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 00-.555 1.338l.413
1.8a1.25 1.25 0 010 .559l-.413 1.799a1.25 1.25 0 00.555
1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674
1.339.555l1.798-.413a1.25 1.25 0 01.56 0l1.799.413a1.25 1.25 0
001.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0
00.554-1.34L18.5 12.28a1.25 1.25 0 010-.56l.413-1.799a1.25 1.25 0
00-.554-1.339l-1.565-.98a1.25 1.25 0 01-.395-.395l-.98-1.564zm-.503
4.127a.5.5 0 00-.86-.509l-2.615 4.426-1.579-1.512a.5.5 0 10-.691.722l2.034
1.949a.5.5 0 00.776-.107l2.935-4.97z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </>
                  )}
                </div>

                <div className="b">
                  <p>{api.serviceOuOccupation}</p>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            {/* display */}
          </div>
          {/* compte */}
        </div>
        {/* search-administrateur */}
      </div>

      {/* administrateur */}
      {administrateurSuccess && (
        <>
          <div className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Un administrateur a été ajouté.</p>

                    <div className="center">
                      <button onClick={AdministrateurSuccess}>Terminer</button>
                    </div>
                    {/* center */}
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}

      {/* erreur */}
      {/* erreur */}
      {/* erreur */}
      {/* api deconne ou utilisateur a entrer des mauvaises donnees ou aucune 
      connexion internet */}
      {erreur && (
        <>
          <div onClick={CloseErreur} className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div className="center">
                  <p>Vérifier votre connexion internet !</p>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>
      )}
      {/* erreur */}
    </>
  );
}

// administrateur supreme
// administrateur supreme
// administrateur supreme
// administrateur supreme
// administrateur supreme
// administrateur supreme
// administrateur supreme
export function EnfantAdministrateurSupreme({ api }) {
  const [erreur, setErreur] = useState(false);
  async function CloseErreur() {
    setErreur(false);
  }

  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre ca, on va utiliser ca dans la requete pour retirer l'administrateur
    const idDataAdmin = api._id;
    localStorage.setItem("https://alrani.com/idDataAdmin", idDataAdmin);
  }

  // administrateur retirer avec success
  const [retirerSuccess, setRetirerSuccess] = useState(false);
  // CloseRetirerSuccess me permet de fermer la popup retirerSuccess
  async function CloseRetirerSuccess() {
    setRetirerSuccess(false);
  }
  // logique pour retirer un administrateur
  async function RetirerAdmin(e) {
    e.preventDefault();
    setRetirerSuccess(true);
    setErreur(true);
  }

  // pour acceder a infos Admin
  const [infosAdmin, setInfosAdmin] = useState(false);
  async function InfosAdmin() {
    setInfosAdmin(!infosAdmin);
  }
  // afficher l'accord entre un administrateur et un propriétaire
  const [accord, setAccord] = useState(false);
  async function Accord() {
    setAccord(!accord);
  }
  // role de l'administrateur
  const [role, setRole] = useState(false);
  async function Role() {
    setRole(!role);
  }
  // pour imprimer l'accord
  async function Imprimer(e) {
    e.preventDefault();
    window.print();
  }

  // roleAdmin ici nous permet de masquer certains choses a l'admin supreme/lombda
  /* par exemple on va masquer le btn Retirer l'administrateur a l'admin lombda */
  const roleAdmin = localStorage.getItem("https://alrani.com/roleAdmin");

  return (
    <>
      {api.roleAdmin === "2" && (
        <>
          <div onClick={Checked} className="admin-supeme">
            <div className="display">
              <div className="a">
                <p onClick={InfosAdmin}>{api.nomAdmin}</p>
              </div>

              <div className="b">
                <p onClick={InfosAdmin}>(Administrateur Suprême)</p>
              </div>
            </div>
            {/* display */}
          </div>
          {/* admin */}
        </>
      )}

      {/* infosadmin */}
      {/* infosadmin */}
      {/* infosadmin */}
      {infosAdmin && (
        <>
          <div onClick={InfosAdmin} className="infosadmin-opacity">
            <div className="align">
              <div className="card">
                <div className="a">
                  <p>{api.nomAdmin} (Administrateur Suprême)</p>
                </div>

                <div className="b">
                  {roleAdmin === "1" && (
                    <>
                      <p onClick={RetirerAdmin}>Retirer l'administrateur</p>
                    </>
                  )}

                  <p onClick={Role}>Rôle de l'administrateur</p>
                  <p onClick={Accord}>Note importante</p>
                </div>
                {/* b */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* infosadmin-opacity */}
        </>
      )}
      {/* infosadmin */}

      {/* Accord */}
      {/* Accord */}
      {/* Accord - administrateur supreme */}
      {/* afficher l'Accord entre un administrateur et un propriétaire */}
      {accord && (
        <>
          <div onClick={Accord} className="accord-opacity">
            <div className="align">
              <div className="card">
                <div className="title">
                  <p>Note importante</p>
                </div>
                {/* title */}

                <div className="objet">
                  <div className="a">
                    <p>Objet</p>
                  </div>

                  <div className="c">
                    <p>:</p>
                  </div>

                  <div className="b">
                    <p>Gestion de la page</p>
                  </div>
                </div>
                {/* objet */}

                <div className="detail">
                  <p>
                    Ce contrat a pour but de gérer la page de l'artiste
                    musicien, rappeur Black M. La page sera gérer par Monsieur
                    Diallo Aboubakar du 25/03/2024 au 17/09/2024
                  </p>
                </div>
                {/* detail */}

                <div className="date">
                  <p>Fait le 19/03/2024</p>
                </div>
                {/* date */}

                <div className="center-imprimer">
                  <div className="imprimer">
                    <svg
                      onClick={Imprimer}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      viewBox="0 0 48 48"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        stroke="none"
                        strokeWidth="1"
                      >
                        <g fill="#ccc" fillRule="nonzero">
                          <path d="M16.25 8h15.5a3.25 3.25 0 013.245 3.066l.005.184v2.749l1.75.001c2.9 0 5.25 2.35 5.25 5.25v13.5A3.25 3.25 0 0138.75 36L35 35.999v1.751A3.25 3.25 0 0131.75 41h-15.5A3.25 3.25 0 0113 37.75v-1.751L9.25 36A3.25 3.25 0 016 32.75v-13.5C6 16.35 8.35 14 11.25 14l1.75-.001V11.25a3.25 3.25 0 013.066-3.245L16.25 8h15.5-15.5zm15.5 20.5h-15.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h15.5a.75.75 0 00.75-.75v-8.5a.75.75 0 00-.75-.75zm5-12h-25.5a2.75 2.75 0 00-2.75 2.75v13.5c0 .414.336.75.75.75l3.75-.001V29.25A3.25 3.25 0 0116.25 26h15.5A3.25 3.25 0 0135 29.25v4.249l3.75.001a.75.75 0 00.75-.75v-13.5a2.75 2.75 0 00-2.75-2.75zm-5-6h-15.5a.75.75 0 00-.743.648l-.007.102v2.749h17V11.25a.75.75 0 00-.648-.743l-.102-.007z"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  {/* center-imprimer */}
                </div>
                {/* imprimer */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* accord-opacity */}
        </>
      )}
      {/* Accord - administrateur supreme */}

      {/* Role  */}
      {/* Role  */}
      {/* Role de l'administrateur supreme */}
      {role && (
        <>
          <div className="role-opacity">
            <div className="block">
              <div
                style={{ background: "#eee", position: "fixed", width: "100%" }}
              >
                <div className="display">
                  <svg
                    onClick={Role}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>

                  <p>Rôle</p>
                </div>
                {/* display  */}
              </div>
            </div>
            {/* block */}

            <div className="block-deux">
              <div className="role">
                <li>Ajouter un Administrateur Lombda</li>
                <li>Retirer un Administrateur Lombda</li>
                <li>Approuver une publication</li>
                <li>Rejeter une publication</li>
                <li>Publier une publication</li>
                <li>Modifier une publication</li>
                <li>Supprimer une publication</li>
              </div>
              {/* role */}

              <div className="action">
                <p>Type d'action : </p>
                <button>Sans approbation</button>
              </div>
              {/* action */}

              <div className="admin">
                <p>Administrateur Suprême</p>
              </div>
              {/* admin */}
            </div>
            {/* block-deux */}
          </div>
          {/* role-opacity */}
        </>
      )}
      {/* Role de l'administrateur supreme */}

      {/* retirer success */}
      {/* retirer success */}
      {/* administrateur retirer avec success */}
      {retirerSuccess && (
        <>
          <div onClick={CloseRetirerSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>
                      Administrateur retirer! N'oubliez pas d'actualiser la page
                    </p>
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}
      {/* retirer success */}

      {/* erreur */}
      {/* erreur */}
      {/* erreur */}
      {/* api deconne ou utilisateur a entrer des mauvaises donnees ou aucune 
      connexion internet */}
      {erreur && (
        <>
          <div onClick={CloseErreur} className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div className="center">
                  <p>Vérifier votre connexion internet !</p>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>
      )}
      {/* erreur */}

     
      {/* signaler */}
      {/* signaler */}
      {/* pour signaler un administrateur 
      {signaler && (
        <>
          <div onClick={Signaler} className="signaler-opacity">
            <p>Signaler l'administrateur</p>
          </div>
          {/* signaler-opacity 
        </>
      )}
   signaler */}
    </>
  );
}

// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
// administrateur lombda
export function EnfantAdministrateurLombda({ api }) {
  const [erreur, setErreur] = useState(false);
  async function CloseErreur() {
    setErreur(false);
  }

  const [checked, setChecked] = useState(false);
  async function Checked() {
    setChecked(!checked);
    // on enregistre ca, on va utiliser ca dans la requete pour retirer l'administrateur
    const idDataAdmin = api._id;
    localStorage.setItem("https://alrani.com/idDataAdmin", idDataAdmin);
  }
  // administrateur retirer avec success
  const [retirerSuccess, setRetirerSuccess] = useState(false);
  // CloseRetirerSuccess me permet de fermer la popup retirerSuccess
  async function CloseRetirerSuccess() {
    setRetirerSuccess(false);
  }
  // logique pour retirer un administrateur
  async function RetirerAdmin(e) {
    e.preventDefault();
    setRetirerSuccess(true);
    setErreur(true);
  }

  // pour acceder a infos Admin
  const [infosAdmin, setInfosAdmin] = useState(false);
  async function InfosAdmin() {
    setInfosAdmin(!infosAdmin);
  }
  // afficher l'accord entre un administrateur et un propriétaire
  const [accord, setAccord] = useState(false);
  async function Accord() {
    setAccord(!accord);
  }
  // role de l'administrateur
  const [role, setRole] = useState(false);
  async function Role() {
    setRole(!role);
  }

  // pour imprimer l'accord
  async function Imprimer(e) {
    e.preventDefault();
    window.print();
  }

  // roleAdmin ici nous permet de masquer certains choses a l'admin supreme/lombda
  /* par exemple on va masquer le btn Retirer l'administrateur a l'admin lombda */
  const roleAdmin = localStorage.getItem("https://alrani.com/roleAdmin");

  return (
    <>
      {api.roleAdmin === "3" && (
        <>
          <div onClick={Checked} className="admin-lombda">
            <div className="display">
              <div className="a">
                <p onClick={InfosAdmin}>{api.nomAdmin}</p>
              </div>

              <div className="b">
                <p onClick={InfosAdmin}>(Administrateur Lombda)</p>
              </div>
            </div>
            {/* display */}
          </div>
          {/* admin */}
        </>
      )}

      {/* infosadmin */}
      {/* infosadmin */}
      {/* infosadmin */}
      {infosAdmin && (
        <>
          <div onClick={InfosAdmin} className="infosadmin-opacity">
            <div className="align">
              <div className="card">
                <div className="a">
                  <p>{api.nomAdmin} (Administrateur Lombda)</p>
                </div>

                <div className="b">
                  {roleAdmin === "1" && (
                    <>
                      <p onClick={RetirerAdmin}>Retirer l'administrateur</p>
                    </>
                  )}

                  {roleAdmin === "2" && (
                    <>
                      <p onClick={RetirerAdmin}>Retirer l'administrateur</p>
                    </>
                  )}

                  <p onClick={Role}>Rôle de l'administrateur</p>
                  <p onClick={Accord}>Note importante</p>
                </div>
                {/* b */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* infosadmin-opacity */}
        </>
      )}
      {/* infosadmin */}

      {/* Accord */}
      {/* Accord */}
      {/* Accord - administrateur lombda */}
      {/* afficher l'Accord entre un administrateur et un propriétaire */}
      {accord && (
        <>
          <div onClick={Accord} className="accord-opacity">
            <div className="align">
              <div className="card">
                <div className="title">
                  <p>Note importante</p>
                </div>
                {/* title */}

                <div className="objet">
                  <div className="a">
                    <p>Objet</p>
                  </div>

                  <div className="c">
                    <p>:</p>
                  </div>

                  <div className="b">
                    <p>Gestion de la page</p>
                  </div>
                </div>
                {/* objet */}

                <div className="detail">
                  <p>
                    Ce contrat a pour but de gérer la page de l'artiste
                    musicien, rappeur Black M. La page sera gérer par Monsieur
                    Diallo Aboubakar du 25/03/2024 au 17/09/2024
                  </p>
                </div>
                {/* detail */}

                <div className="date">
                  <p>Fait le 19/03/2024</p>
                </div>
                {/* date */}
                <div className="center-imprimer">
                  <div className="imprimer">
                    <svg
                      onClick={Imprimer}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      viewBox="0 0 48 48"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        stroke="none"
                        strokeWidth="1"
                      >
                        <g fill="#ccc" fillRule="nonzero">
                          <path d="M16.25 8h15.5a3.25 3.25 0 013.245 3.066l.005.184v2.749l1.75.001c2.9 0 5.25 2.35 5.25 5.25v13.5A3.25 3.25 0 0138.75 36L35 35.999v1.751A3.25 3.25 0 0131.75 41h-15.5A3.25 3.25 0 0113 37.75v-1.751L9.25 36A3.25 3.25 0 016 32.75v-13.5C6 16.35 8.35 14 11.25 14l1.75-.001V11.25a3.25 3.25 0 013.066-3.245L16.25 8h15.5-15.5zm15.5 20.5h-15.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h15.5a.75.75 0 00.75-.75v-8.5a.75.75 0 00-.75-.75zm5-12h-25.5a2.75 2.75 0 00-2.75 2.75v13.5c0 .414.336.75.75.75l3.75-.001V29.25A3.25 3.25 0 0116.25 26h15.5A3.25 3.25 0 0135 29.25v4.249l3.75.001a.75.75 0 00.75-.75v-13.5a2.75 2.75 0 00-2.75-2.75zm-5-6h-15.5a.75.75 0 00-.743.648l-.007.102v2.749h17V11.25a.75.75 0 00-.648-.743l-.102-.007z"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  {/* imprimer */}
                </div>
                {/* center-imprimer */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* accord-opacity */}
        </>
      )}
      {/* Accord - administrateur lombda */}

      {/* Role  */}
      {/* Role  */}
      {/* Role de l'administrateur lombda */}
      {role && (
        <>
          <div className="role-opacity">
            <div className="block">
              <div
                style={{ background: "#eee", position: "fixed", width: "100%" }}
              >
                <div className="display">
                  <svg
                    onClick={Role}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>
                  <p>Rôle</p>
                </div>
                {/* display */}
              </div>
              {/*  */}
            </div>
            {/* block */}

            <div className="block-deux">
              <div className="role">
                <li>Publier une publication</li>
                <li>Modifier une publication</li>
              </div>
              {/* role */}

              <div className="action">
                <p>Type d'action :</p>
                <button>Avec approbation</button>
              </div>
              {/* action */}

              <div className="admin-lombda">
                <p>Administrateur Lombda</p>
              </div>
              {/* admin-lombda */}
            </div>
            {/* block-deux */}
          </div>
          {/* role-opacity */}
        </>
      )}

      {/* retirer success */}
      {/* retirer success */}
      {/* administrateur retirer avec success */}
      {retirerSuccess && (
        <>
          <div onClick={CloseRetirerSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>
                      Administrateur retirer! N'oubliez pas d'actualiser la page
                    </p>
                  </div>
                  {/* a */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}
      {/* retirer success */}

      {/* erreur */}
      {/* erreur */}
      {/* erreur */}
      {/* api deconne ou utilisateur a entrer des mauvaises donnees ou aucune 
      connexion internet */}
      {erreur && (
        <>
          <div onClick={CloseErreur} className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div className="center">
                  <p>Vérifier votre connexion internet !</p>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-general-opacity */}
        </>
      )}
      {/* erreur */}
    </>
  );
}

// Cameroun
// Cameroun
// Cameroun
// Cameroun
// Cameroun
// Cameroun
// Cameroun
function EnfantApiAuteurCameroun({ apiAuteurCameroun }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);

    const id = apiAuteurCameroun.idLivre;
    localStorage.setItem("https://alrani.com/idLivre", id);

    const idAuteur = apiAuteurCameroun.idAuteur;
    localStorage.setItem("https://alrani.com/idAuteur", idAuteur);
  }

  return (
    <>
      <div onClick={Checked} className="b">
        <img src={imageLivre} alt="" />
        <div className="nom-livre-bold">
          <p>{apiAuteurCameroun.nomLivre}</p>
        </div>

        <div className="nom-auteur-bold">
          <p>{apiAuteurCameroun.nomAuteur}</p>
        </div>

        <div className="stars">
          <p>4.5</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="20px"
            fill="#fcff07"
            enableBackground="new 0 0 55.867 55.867"
            version="1.1"
            viewBox="0 0 55.867 55.867"
            xmlSpace="preserve"
          >
            <path d="M55.818 21.578a1.002 1.002 0 00-.808-.681l-18.09-2.629-8.09-16.392a.998.998 0 00-1.792 0l-8.091 16.393-18.09 2.629a1.002 1.002 0 00-.555 1.705l13.091 12.76-3.091 18.018c-.064.375.09.754.397.978a.992.992 0 001.053.076l16.182-8.506 16.18 8.506a1 1 0 001.451-1.054l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"></path>
          </svg>
        </div>
      </div>
      {/* b */}
    </>
  );
}

// Livre en Français
// Livre en Français
// Livre en Français
// Livre en Français
// Livre en Français
// Livre en Français
function EnfantApiLivreEnFrancais({ apiLivreEnFrancais }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);

    const id = apiLivreEnFrancais.idLivre;
    localStorage.setItem("https://alrani.com/idLivre", id);

    const idAuteur = apiLivreEnFrancais.idAuteur;
    localStorage.setItem("https://alrani.com/idAuteur", idAuteur);
  }

  return (
    <>
      <div onClick={Checked} className="b">
        <img src={imageLivre} alt="" />
        <div className="nom-livre">
          <p>{apiLivreEnFrancais.nomLivre}</p>
        </div>

        <div className="nom-auteur">
          <p>{apiLivreEnFrancais.nomAuteur}</p>
        </div>

        <div className="saison">
          <p>Saison 4</p>
          <p>Episode 1</p>
        </div>
      </div>
      {/* b */}
    </>
  );
}

// Investir en Afrique
// Investir en Afrique
// Investir en Afrique
// Investir en Afrique
// Investir en Afrique
// Investir en Afrique
function EnfantApiInvestirEnAfrique({ apiInvestirEnAfrique }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);

    const id = apiInvestirEnAfrique.idLivre;
    localStorage.setItem("https://alrani.com/idLivre", id);

    const idAuteur = apiInvestirEnAfrique.idAuteur;
    localStorage.setItem("https://alrani.com/idAuteur", idAuteur);
  }

  return (
    <>
      <div onClick={Checked} className="b">
        <img src={imageLivre} alt="" />
        <div className="nom-livre">
          <p>{apiInvestirEnAfrique.nomLivre}</p>
        </div>

        <div className="nom-auteur">
          <p>{apiInvestirEnAfrique.nomAuteur}</p>
        </div>

        <div className="stars">
          <p>4.5</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="20px"
            fill="#fcff07"
            enableBackground="new 0 0 55.867 55.867"
            version="1.1"
            viewBox="0 0 55.867 55.867"
            xmlSpace="preserve"
          >
            <path d="M55.818 21.578a1.002 1.002 0 00-.808-.681l-18.09-2.629-8.09-16.392a.998.998 0 00-1.792 0l-8.091 16.393-18.09 2.629a1.002 1.002 0 00-.555 1.705l13.091 12.76-3.091 18.018c-.064.375.09.754.397.978a.992.992 0 001.053.076l16.182-8.506 16.18 8.506a1 1 0 001.451-1.054l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"></path>
          </svg>
        </div>
      </div>
      {/* b */}
    </>
  );
}

// Afrique Francophone
// Afrique Francophone
// Afrique Francophone
// Afrique Francophone
// Afrique Francophone
function EnfantApiAfriqueFrancophone({ apiAfriqueFrancophone }) {
  const [checked, setChecked] = useState(false);

  async function Checked() {
    setChecked(!checked);

    const id = apiAfriqueFrancophone.idLivre;
    localStorage.setItem("https://alrani.com/idLivre", id);

    const idAuteur = apiAfriqueFrancophone.idAuteur;
    localStorage.setItem("https://alrani.com/idAuteur", idAuteur);
  }

  return (
    <>
      <div onClick={Checked} className="b">
        <img src={imageLivre} alt="" />
        <div className="nom-livre">
          <p>{apiAfriqueFrancophone.nomLivre}</p>
        </div>

        <div className="nom-auteur">
          <p>{apiAfriqueFrancophone.nomAuteur}</p>
        </div>

        <div className="telecharger">
          <button>Télécharger</button>
        </div>
      </div>
      {/* b */}
    </>
  );
}

//
//
//
//
//
//
//
//
//
export default function VirtualPhone() {
  const apiMorePhotoPublicIA = [
    {
      _id: "17",
      photoPublic:
        "https://res.cloudinary.com/rasivyy/image/upload/v1660877983/Mes%20images/magic-fille_ivhge0.jpg",
      idCompte: "IA000222",
    },

    {
      _id: "18",
      photoPublic:
        "https://res.cloudinary.com/rasivyy/image/upload/v1660878006/Mes%20images/magic-policiere_qxjkag.jpg",
      idCompte: "IA000222",
    },

    {
      _id: "19",
      photoPublic:
        "https://res.cloudinary.com/rasivyy/image/upload/v1660878007/Mes%20images/magic-photo1_cy9ftf.jpg",
      idCompte: "IA000222",
    },
  ];

  const apiListeApp = [
    {
      _id: "125",
      nomApp: "Alrani",
      logo: alraniLogo,
      desc: "Suivez vos pages préférées sur Alrani",
      disponible: "1",
      installer: "1",
    },

    {
      _id: "005",
      nomApp: "Veil Brillant",
      logo: vbLogo,
      desc: "Abonnez-vous à des chaines intéréssantes dans l'application Veil Brillant",
      disponible: "1",
      installer: "1",
    },

    {
      _id: "666",
      nomApp: "izocash",
      logo: izocashLogo,
      desc: "Acheter tout dans votre téléphone virtuel grace à izocash",
      disponible: "0",
      installer: "0",
    },
  ];

  const apiSuperModule = [
    {
      _id: "8864",
      url: "https://alrani.com/ModuleAlraniAA",
      nomSuperModule: "Alrani",
      desc: "Effectuer des recherches, Commenter des publications et bien plus...",
      gratuit: "1",
      idApp: "125",
      nomApp: "Alrani",
    },

    {
      _id: "9644",
      url: "https://alrani.com/ModuleAlraniBusinessAA",
      nomSuperModule: "Alrani Business",
      desc: "Publier des photos, Publier des vidéos, Répondre aux commentaires, Monétiser la page, ...",
      gratuit: "0",
      idApp: "125",
      nomApp: "Alrani",
    },

    {
      _id: "4411",
      url: "https://alrani.com/ModuleAlraniDealsAA",
      nomSuperModule: "Alrani Deals",
      desc: "Gagnez de l'argent avec Alrani Deals",
      gratuit: "0",
      idApp: "125",
      nomApp: "Alrani",
    },

    {
      _id: "0233",
      url: "https://alrani.com/ModuleAlraniPlusAA",
      nomSuperModule: "Alrani Plus",
      desc: "Expérimenter le Merveilleux module d'Alrani Plus",
      gratuit: "0",
      idApp: "125",
      nomApp: "Alrani",
    },

    {
      _id: "2211",
      url: "https://alrani.com/ModuleVBbusinessVB",
      nomSuperModule: "VB Business",
      desc: "Publier et vender vos vidéos avec le Grand Module Veil Brillant Business, Monétisez votre compte, ...",
      gratuit: "0",
      idApp: "005",
      nomApp: "Veil Brillant",
    },
  ];

  const apiModule = [
    {
      _id: "03232",
      url: "https://alrani.com/ModuleRechercheAA",
      nomModule: "Recherche",
      miniDesc: "Effectuer des recherches",
      desc: "Acheter le module recherche pour effectuer des recherches sur Alrani",
      descAnnuel: "Votre module Recherche pour 2 années",
      idApp: "125",
      idSuperModule: "8864",
      nomSuperModule: "Alrani",
      prix: "900FCFA / mois",
      prixAnnuel: "7200 FCFA / 2 ans",
      valeurPrix: "900",
      valeurPrixAnnuel: "7200",
      monnaieFCFA: "1",
      type: "1",
    },

    {
      _id: "14477",
      url: "https://alrani.com/ModuleCommentaireAA",
      nomModule: "Commentaire",
      miniDesc: "Commenter des publications, répondre à des commentaires",
      desc: "Acheter le module Commentaire pour commenter et répondre à des commentaires dans l'application Alrani",
      descAnnuel:
        "Acheter le module Commentaire à 4800FCFA. Valable pendant 02 ans",
      idApp: "125",
      idSuperModule: "8864",
      nomSuperModule: "Alrani",
      prix: "600FCFA / mois",
      prixAnnuel: "4800 FCFA / 2 ans",
      valeurPrix: "600",
      valeurPrixAnnuel: "4800",
      monnaieFCFA: "1",
      type: "1",
    },

    {
      _id: "14700",
      url: "https://alrani.com/ModulePublicationAA",
      nomModule: "Publications",
      miniDesc: "Publier vos photos/vidéos",
      desc: "Faites des publications textes, Publier des photos et Publier des vidéos",
      idApp: "125",
      idSuperModule: "9644",
      nomSuperModule: "Alrani Business",
      prix: "20.000FCFA / 2 ans",
      valeurPrix: "20000",
      monnaieFCFA: "1",
      type: "0",
    },

    {
      _id: "02366",
      url: "https://alrani.com/ModulePublicationVideoVB",
      nomModule: "Publications vidéos",
      miniDesc: "Publier vos vidéos dans l'App Veil Brillant",
      desc: "Acheter le module Publications vidéos pour Publier et Vendre vos vidéos",
      idApp: "005",
      idSuperModule: "2211",
      nomSuperModule: "VB Business",
      prix: "30000FCFA / 2 ans",
      valeurPrix: "30000",
      monnaieFCFA: "1",
      type: "0",
    },
  ];

  const apiModuleAcheter = [
    {
      _id: "11",
      idAuteur: "000111",
      nomAuteur: "Kilendo Dingha Veil Brillant",
      validiter: "2 ans VB Business",
      terminer: "1",
      idApp: "005",
      id: "2211",
      nom: "VB Business",
      url: "https://alrani.com/ModuleVBbusinessVB",
    },

    {
      _id: "11",
      idAuteur: "000111",
      nomAuteur: "Kilendo Dingha Veil Brillant",
      validiter: "2 ans Publications vidéos",
      terminer: "1",
      idApp: "005",
      id: "02366",
      nom: "Publications vidéos",
      url: "https://alrani.com/ModulePublicationVideoVB",
    },

    {
      _id: "14",
      idAuteur: "000111",
      nomAuteur: "Kilendo Dingha Veil Brillant",
      validiter: "1 an",
      terminer: "1",
      idApp: "125",
      id: "14477",
      nom: "Commentaire",
      url: "https://alrani.com/ModuleCommentaireAA",
    },

    {
      _id: "15",
      idAuteur: "000222",
      nomAuteur: "Laura Labelle",
      validiter: "1 an",
      terminer: "1",
      idApp: "125",
      id: "14700",
      nom: "Publications",
      url: "https://alrani.com/ModulePublicationAA",
    },
  ];

  const apiPageBooster = [
    {
      _id: "254",
      phraseDaccroche:
        "Une chaussure résistante à l'eau et confortable à porter",
      nom: "Shoes Good Store",
      image: chaussure,
      theme: "Magasin de vente en ligne de chaussures",
      citation: "Les chaussures heureuses vous rendent heureux",
      modele: "1",
    },

    {
      _id: "366",
      phraseDaccroche:
        "Des chaussures de qualité résistante à toute les intemperies",
      nom: "Shoes Good Store",
      video:
        "https://res.cloudinary.com/rasivyy/video/upload/v1680563470/Alrani%20-%20Video/Black%20M%20-%20Tic-Tac%20%28Clip%20officiel%29.mp4",
      theme: "Les pieds couverts",
      citation: "La chaussure existe avant J-C",
      modele: "10",
    },

    {
      _id: "154",
      phraseDaccroche: "Nelson Mandela a passé la nuit dans cet hotel",
      nom: "Marina Hotel",
      image: hotel,
      modele: "1",
    },

    {
      _id: "147",
      phraseDaccroche: "Expérimenter le bonheur de bien dormir",
      nom: "Le Dortoir Pur",
      image: chambre,
      modele: "2",
    },

    {
      _id: "02694",
      text1: "Tout les riches savent que tout le monde peut devenir riche",
      text2:
        "Tout les riches savent que si vous faites ce qu'ils ont fait vous allez vous aussi réussir",
      phraseDaccroche:
        "Avant de commencer à investir il faut apprendre à investir",
      serviceOuOccupation: "Entreprise de trading",
      nom: "Business & Invest Group",
      photoProfil: investirPhotoProfil,
      image: investir,
      theme: "Investir en Afrique",
      citation: "Avant de commencer à investir il faut apprendre à investir",
      modele: "1",
    },

    {
      _id: "02694",
      text1: "Tout les riches savent que tout le monde peut devenir riche",
      text2:
        "Tout les riches savent que si vous faites ce qu'ils ont fait vous allez vous aussi réussir",
      phraseDaccroche:
        "Avant de commencer à investir il faut apprendre à investir",
      serviceOuOccupation: "Entreprise de trading",
      nom: "Business & Invest Group",
      photoProfil: investirPhotoProfil,
      image: investir,
      theme: "Investir en Afrique",
      citation: "Avant de commencer à investir il faut apprendre à investir",
      modele: "2",
    },

    {
      _id: "03694",
      text1: "Tout les riches savent que tout le monde peut devenir riche",
      text2:
        "Tout les riches savent que si vous faites ce qu'ils ont fait vous allez vous aussi réussir",
      phraseDaccroche: "Construisez-vous chaque jour",
      serviceOuOccupation: "Entreprise de trading",
      nom: "Business & Invest Group",
      photoProfil: investirPhotoProfil,
      image: investir,
      theme: "Investir en Afrique",
      citation: "Avant de commencer à investir il faut apprendre à investir",
      modele: "3",
    },

    {
      _id: "03694",
      text1: "Tout les riches savent que tout le monde peut devenir riche",
      text2:
        "Tout les riches savent que si vous faites ce qu'ils ont fait vous allez vous aussi réussir",
      phraseDaccroche: "Les règles de l'argent à savoir avant de mourir pauvre",
      serviceOuOccupation: "Entreprise de trading",
      nom: "Business & Invest Group",
      photoProfil: investirPhotoProfil,
      video:
        "https://res.cloudinary.com/rasivyy/video/upload/v1680563470/Alrani%20-%20Video/Black%20M%20-%20Tic-Tac%20%28Clip%20officiel%29.mp4",
      theme: "Investir en Afrique",
      citation: "Avant de commencer à investir il faut apprendre à investir",
      modele: "20",
    },

    {
      _id: "228",
      phraseDaccroche: "Votre clé pour une voiture de location",
      nom: "Auto 243",
      image: voiture,
      modele: "2",
    },

    {
      _id: "0183",
      phraseDaccroche: "Ta nourriture sera ton médicament",
      nom: "Moni Food",
      serviceOuOccupation: "Restaurant",
      idPage: "0124",
      image: nourriture,
      modele: "1",
      intro: "La livraison à domicile est gratuite à Abidjan",
      titre: "Information sur la livraison",
      paragraph1: "Livraison à Cocody : 1000 FCFA",
      paragraph2: "Livraison à Bingerville : 3000 FCFA!",
      paragraph3: "Paiement réfléchi par Izocash",
      phraseDappel: "Votre commande aura :",
      element1: "Du Poulet",
      element2: "De la Pate d'arachide",
      element3: "Du Foumbou",
      element4: "Du Gombo",
      element5: "Et du Foufou bien Chaud, hummm c'est bon !",
      elementFinal:
        "En cadeau, vous bénéficiez d'une bouteille d'eau minérale et Bon appétit !",
      motDeLaFin: "Commander et faites vous livrer partout en Cote d'Ivoire",
    },

    {
      _id: "9611",
      phraseDaccroche: "Ta nourriture sera ton médicament",
      nom: "Moni Food",
      serviceOuOccupation: "Restaurant",
      idPage: "0124",
      image: nourriture,
      modele: "2",
      intro: "La livraison à domicile est gratuite à Abidjan",
    },
  ];

  const apiAfriqueFrancophone = [
    {
      nomLivre:
        "Ce que tout entrepreneur doit savoir avant d'investir au Cameroun",
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "55",
      idLivre: "555",
      idAuteur: "723845621",
    },

    {
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "35",
      idLivre: "585",
      idAuteur: "723845621",
    },

    {
      nomLivre: "Entreprendre ou la mort",
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "35",
      idLivre: "585",
      idAuteur: "723845621",
    },

    {
      nomLivre: "Les règles du jeu de l'argent",
      descLivre: "Avant d'entreprendre lisez ce livre si vous voulez réussir",
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "63",
      idLivre: "258",
      idAuteur: "723845621",
    },

    {
      nomLivre: "Obtenir une rentabilité de 100% avec son projet agricole",
      nomAuteur: "Ouedraogo Ismael",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "45",
      idLivre: "415",
      idAuteur: "147023654",
    },

    {
      afriqueFrancophone: "Afrique Francophone",
      nomLivre: "Les bases pour devenir le prochain Amazon Africain",
      nomAuteur: "Christoph Zirovich",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "64",
      idLivre: "666",
      idAuteur: "100732568",
    },

    {
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "35",
      idLivre: "585",
      idAuteur: "723845621",
    },
  ];

  const apiInvestirEnAfrique = [
    {
      investirEnAfrique: "Investir en Afrique",
      nomLivre:
        "Ce que tout entrepreneur doit savoir avant d'investir au Cameroun",
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "8",
      idLivre: "555",
      idAuteur: "723845621",
    },

    {
      investirEnAfrique: "Investir en Afrique",
      nomLivre: "Obtenir une rentabilité de 100% avec son projet agricole",
      nomAuteur: "Ouedraogo Ismael",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "9",
      idLivre: "415",
      idAuteur: "147023654",
    },

    {
      afriqueFrancophone: "Afrique Francophone",
      nomLivre: "Les bases pour devenir le prochain Amazon Africain",
      nomAuteur: "Christoph Zirovich",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "64",
      idLivre: "666",
      idAuteur: "100732568",
    },
  ];

  const apiLivreEnFrancais = [
    {
      livreEnFrancais: "Livre en Français",
      nomLivre:
        "Ce que tout entrepreneur doit savoir avant d'investir au Cameroun",
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "14",
      idLivre: "555",
      idAuteur: "723845621",
    },

    {
      livreEnFrancais: "Livre en Français",
      nomLivre: "Obtenir une rentabilité de 100% avec son projet agricole",
      nomAuteur: "Ouedraogo Ismael",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "15",
      idLivre: "415",
      idAuteur: "147023654",
    },
  ];

  const apiAuteurCameroun = [
    {
      paysAuteur: "Auteur Cameroun",
      nomLivre:
        "Ce que tout entrepreneur doit savoir avant d'investir au Cameroun",
      nomAuteur: "Kameni So",
      imageLivre:
        "https://res.cloudinary.com/rasivyy/image/upload/v1668836770/alrani/book1_vv3bkg.jpg",
      id: "7",
      idLivre: "555",
      idAuteur: "723845621",
    },
  ];

  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  // navbar home
  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  async function OpenMobileMenu() {
    setOpenMobileMenu(!openMobileMenu);
  }

  // menu
  const [menu, setMenu] = useState(false);
  async function Menu() {
    setMenu(!menu);
  }

  // theme
  const [theme, setTheme] = useState(false);
  async function Theme() {
    setTheme(!theme);
  }

  // theme page
  const [themePage, setThemePage] = useState(false);
  async function ThemePage() {
    setThemePage(!themePage);
  }

  // theme 1
  // theme 1
  const gettheme1 = localStorage.getItem("theme1");
  const [theme1, setTheme1] = useState(gettheme1);
  async function Theme1() {
    const theme1 = true;
    localStorage.setItem("theme1", theme1);
    localStorage.removeItem("theme2");
    localStorage.removeItem("theme3");
    setTheme1(true);
    setTheme2(false);
    setTheme3(false);
  }

  // theme 2
  // theme 2
  const gettheme2 = localStorage.getItem("theme2");
  const [theme2, setTheme2] = useState(gettheme2);
  async function Theme2() {
    const theme2 = true;
    localStorage.setItem("theme2", theme2);
    localStorage.removeItem("theme1");
    localStorage.removeItem("theme3");
    setTheme2(true);
    setTheme1(false);
    setTheme3(false);
    setOpenMobileMenu(false);
  }

  // theme 3
  // theme 3
  const gettheme3 = localStorage.getItem("theme3");
  const [theme3, setTheme3] = useState(gettheme3);
  async function Theme3() {
    const theme3 = true;
    localStorage.setItem("theme3", theme3);
    localStorage.removeItem("theme1");
    localStorage.removeItem("theme2");
    setTheme3(true);
    setTheme1(false);
    setTheme2(false);
    setOpenMobileMenu(false);
  }

  /* ici on recupere les valeurs des monnaies dans le localStorage pour pouvoir mettre la
  monnaie active lorsqu'elle est egale a 1, si la valeur c'est 0 (la monnaie ne sera pas active)*/
  /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
  const monnaieSwaziLilangeni = localStorage.getItem(
    "https://alrani.com/SwaziLilangeni"
  );
  const monnaieEuro = localStorage.getItem("https://alrani.com/Euro");
  const monnaieDollarAmericain = localStorage.getItem(
    "https://alrani.com/DollarAmericain"
  );
  const monnaieFrancCFA = localStorage.getItem("https://alrani.com/FrancCFA");
  const monnaieFrancCongolais = localStorage.getItem(
    "https://alrani.com/FrancCongolais"
  );
  const monnaieRealBresilien = localStorage.getItem(
    "https://alrani.com/RealBresilien"
  );
  const monnaieFrancSuisse = localStorage.getItem(
    "https://alrani.com/FrancSuisse"
  );
  const monnaieFrancGuineen = localStorage.getItem(
    "https://alrani.com/FrancGuineen"
  );
  const monnaieFrancBurundais = localStorage.getItem(
    "https://alrani.com/FrancBurundais"
  );
  const monnaieDinarAlgerien = localStorage.getItem(
    "https://alrani.com/DinarAlgerien"
  );
  const monnaieDinarTunisien = localStorage.getItem(
    "https://alrani.com/DinarTunisien"
  );
  const monnaieDirhamMarocain = localStorage.getItem(
    "https://alrani.com/DirhamMarocain"
  );

 
  /*si on a aucune monnaie dans le localStorage, alors on enregistre la monnaie d'eswatini
dans le localStorage */
  if (
    !monnaieSwaziLilangeni &&
    !monnaieEuro &&
    !monnaieDollarAmericain &&
    !monnaieFrancCFA &&
    !monnaieFrancCongolais &&
    !monnaieRealBresilien &&
    !monnaieFrancSuisse &&
    !monnaieFrancGuineen &&
    !monnaieFrancBurundais &&
    !monnaieDinarAlgerien &&
    !monnaieDinarTunisien &&
    !monnaieDirhamMarocain
  ) {
    const addMonnaie = 1;
    localStorage.setItem("https://alrani.com/SwaziLilangeni", addMonnaie);
  }

  // profil others
  // profil others
  // profil others
  // profil others
  // profil others
  // profil others
  // profil others
  /* quand on clique sur une page qu'on gere (la logique, on a juste repris la logique qui se
  trouve dans profil others) */

  // la photo de profil a afficher sur la page Alrani
  const photoProfilPage = localStorage.getItem(
    "https://alrani.com/photoProfilPage"
  );
  const nomPage = localStorage.getItem("https://alrani.com/nomPage");
  const serviceOuOccupationPage = localStorage.getItem(
    "https://alrani.com/serviceOuOccupation"
  );
  const badgeVerifiedPage = localStorage.getItem(
    "https://alrani.com/badgeVerifiedPage"
  );

  // profil others
  // profil others
  // profil others
  // profil others
  // profil others

  // on affiche les posts de la page alrani business
  /* avec la meme api, on va aussi profiter d'afficher les posts en attente et
   les posts rejeter */
  const [apiPosts, setApiPosts] = useState([]);

  // erreur
  const [erreur, setErreur] = useState(false);
  async function Erreur() {
    setErreur(false);
  }

  // compte lier
  // compte lier
  async function Delier() {
    /* 
    ici on va envoyer 0 dans la requete de l'utilisateur,
    car si c'est 0, ca veut dire que c'est lier,
    si c'est 1, ca veut dire que ce n'est pas lier
    */
  }

  const [compteLier, setCompteLier] = useState(false);
  async function CompteLier() {
    setCompteLier(!compteLier);
  }

  // compte lier omisify popup help
  const [compteLierOmisifyPopupHelp, setCompteLierOmisifyPopupHelp] =
    useState(false);

  async function CompteLierOmisifyPopupHelp() {
    setCompteLierOmisifyPopupHelp(!compteLierOmisifyPopupHelp);
  }

  // verify compte lier
  const verifyCompteLier = localStorage.getItem(
    "https://alrani.com/verifyCompteLier"
  );

  // delier Compte Omisify
  const [delierCompteOmisify, setDelierCompteOmisify] = useState(false);

  async function DelierCompteOmisify() {
    setDelierCompteOmisify(!delierCompteOmisify);
  }

  // logout page
  // logout page
  const [logoutPageAA, setLogoutPageAA] = useState(false);
  async function LogoutPageAA() {
    setLogoutPageAA(true);
  }
  async function CloseLogoutPageAA() { //fermer
    setLogoutPageAA(false);
  }

  // logout - AA
  // logout - AA
  // logique pour se deconnecter
  async function LogoutAA() {
    localStorage.removeItem("idUserConnectedAA");
    localStorage.removeItem("idPersonConnectedAA");
    localStorage.removeItem("namePersonConnectedAA");
    localStorage.removeItem("photoPersonConnectedAA");
    localStorage.removeItem("badgePersonConnectedAA");
    localStorage.removeItem("virtualNumberPersonConnectedAA");
    localStorage.removeItem("monetizationAA");
    localStorage.removeItem("monetizationBalanceAA");
    localStorage.removeItem("monetizationCommissionAA");
    localStorage.removeItem("createIdReactionAA");
    localStorage.removeItem("GoToMoreOptionsAccountAA");
    localStorage.removeItem("GoToProfilOtherAA");
    localStorage.removeItem("urlPhotoAA");
    localStorage.removeItem("dateAA");
    localStorage.removeItem("idOwnerAA");
    localStorage.removeItem("nameOwnerAA");
    localStorage.removeItem("photoOwnerAA");
    localStorage.removeItem("newViewAA");
    localStorage.removeItem("newClicAA");
    localStorage.removeItem("badgeOwnerAA");
    localStorage.removeItem("writeMessageAA");
    localStorage.removeItem("createIdConversationAA");
    localStorage.removeItem("createIdMessageAA");
    localStorage.removeItem("idConversationAA");
    localStorage.removeItem("idPostAA");
    localStorage.removeItem("reactionPostAA");
    localStorage.removeItem("createIdCommentAA");
    localStorage.removeItem("createIdReplyAA");
    localStorage.removeItem("urlPhoto");
    localStorage.removeItem("description");
    localStorage.removeItem("myAccountAA");
    localStorage.removeItem("countryPersonConnectedAA");
    localStorage.removeItem("ClicOnLikeAA");
    localStorage.removeItem("idProfilOtherAA");
    localStorage.removeItem("idPostAA");
    localStorage.removeItem("searchAA");
    localStorage.removeItem("idNewPost");
    localStorage.removeItem("lastPost");
    localStorage.removeItem("oldBalanceAlraniPay");
    localStorage.removeItem("newBalanceAlraniPay");
    localStorage.removeItem("GoToPageBoosterPageAA");
    localStorage.removeItem("GoToPageSeePostAA");
    localStorage.removeItem("GoToPageSharePostAA");
    localStorage.removeItem("GoToPageAddReactionAA");
    localStorage.removeItem("GoToPageSeeReactionAA");
    localStorage.removeItem("idOwnerAA");
    localStorage.removeItem("createIdPostAA");
    localStorage.removeItem("newBalanceAlraniPay");
    localStorage.removeItem("oldBalanceAlraniPay");
    localStorage.removeItem("monetizationPercentage");
    localStorage.removeItem("monetizationCommission");
    localStorage.removeItem("newBalanceMonetization");
    setConnexionPageAA(true);
    setLogoutPageAA(false);
  }

  // on recupere les infos en temps reel 
  const idPersonConnectedAA = localStorage.getItem("idPersonConnectedAA");

  // requete pour obtenir toutes les reactions
  const [apiReactionAA, setApiReactionAA] = useState([]);


  //creer un id pour chaque reaction - AA
  const numberReactionAA = apiReactionAA.filter((api) => api._id); 
  const totalReactionAA = numberReactionAA.length;

  const createIdReactionAA = totalReactionAA + 1;
  if (createIdReactionAA) { localStorage.setItem("createIdReactionAA", createIdReactionAA) }



  // requete pour obtenir toutes les navigations
  const [apiNavigationAA, setApiNavigationAA] = useState([]);

  //creer un id pour chaque navigation - AA
  const numberNavigationAA = apiNavigationAA.filter((api) => api._id);
  const totalNavigationAA = numberNavigationAA.length;

  const createIdNavigationAA = totalNavigationAA + 1;
  if (createIdNavigationAA) { localStorage.setItem("createIdNavigationAA", createIdNavigationAA) }



  // requete pour obtenir toutes les notifications
  const [apiNotificationAA, setApiNotificationAA] = useState([]);

  //creer un id pour chaque notification créer - AA
  const numberNotificationAA = apiNotificationAA.filter((api) => api.notification);
  const totalNotificationAA = numberNotificationAA.length;

  const createIdNotificationAA = totalNotificationAA + 1;
  if (createIdNotificationAA) { localStorage.setItem("createIdNotificationAA", createIdNotificationAA) }


  // infos userAA
  const idUserConnectedAA = localStorage.getItem("idUserConnectedFA");
  const balanceAlraniPayAA = localStorage.getItem("balanceFlorinatoPayFA");

  // requete pour obtenir tout les utilisateurs Alrani - AA
  const [apiUserAA, setApiUserAA] = useState([]);
  /* // useEffect(() => {
    async function get() {
      //console.log("aa1");
      await axios
      .get(`${process.env.REACT_APP_UserAA}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);
        //console.log("aa2");

        //verificationLogin 
        // on verifie si le mot de passe est toujours le meme pour le garder connecter ou pour l'ejecter
        async function verificationLogin() {
          //console.log("aa3");
          const writeVirtualNumber = localStorage.getItem("writeVirtualNumberAAforVerificationLoginAA");
          const writePassword = localStorage.getItem("writePasswordAAforVerificationLoginAA");
          
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_VerificationLoginAA}/api/userAA/login`,
            data: {
              virtualNumber: writeVirtualNumber,
              password: writePassword,
            },
          })
          .then((res) => {
             //si le mot de passe enregistré dans le localStorage est different du mot de passe qui se trouve dans la bdd, alors on le deconnecte, cela veut dire que le mot de passe a ete changé
             const incorrectPassword = res.data.incorrectPassword;
             if (incorrectPassword === "1") { localStorage.removeItem("idPersonConnectedFA"); } 
          })
          }
          verificationLogin();
          //verificationLogin
      });
    }
    get();
  }, []); */

  // filtre dans l'apiUserAA (on affiche les infos de l'utilisateur connecter)
 const userConnectedAA = apiUserAA.filter((api) => api._id === idUserConnectedAA);

 const getBalanceAlraniPayAA = userConnectedAA.map((api) => api.balanceAlraniPay); // solde alrani pay
 if (getBalanceAlraniPayAA) { localStorage.setItem("balanceFlorinatoPayA", getBalanceAlraniPayAA); }

 const getDisplayOtherAA = userConnectedAA.map((api) => api.displayOther); // displayOther 
 if (getDisplayOtherAA) { localStorage.setItem("displayOtherA", getDisplayOtherAA); }

 const gethomeAA = userConnectedAA.map((api) => api.home); // home 
 if (gethomeAA) { localStorage.setItem("homeA", gethomeAA); }

 const gethomeVideoAA = userConnectedAA.map((api) => api.homeVideo); // homeVideo 
 if (gethomeVideoAA) { localStorage.setItem("homeVideoA", gethomeVideoAA); }

 const getblockAA = userConnectedAA.map((api) => api.block); // block 
 if (getblockAA) { localStorage.setItem("blockA", getblockAA); }

 const getNewMessageAA = userConnectedAA.map((api) => api.newMessage); // newMessage 
 if (getNewMessageAA) { localStorage.setItem("newMessageA", getNewMessageAA); }

 const getNewNotificationAA = userConnectedAA.map((api) => api.newNotification); // newNotification 
 if (getNewNotificationAA) { localStorage.setItem("newNotificationA", getNewNotificationAA); }


  const idOwnerAA = localStorage.getItem("idOwnerAA");
  // requete pour obtenir tout les comptes Alrani - AA
  const [apiAccountAA, setApiAccountAA] = useState([]);



  const idPostAA = localStorage.getItem("idPostAA");  
  // requete pour obtenir tout les posts sur Alrani - AA
  const [apiPostAA, setApiPostAA] = useState([]);

  // message - AA
  // message - AA
  // obtenir tout les messages envoyer sur Alrani
  const [apiMessageAA, setApiMessageAA] = useState([]);


  
   // voir 1 post (on veut voir le post sur laquelle on a cliquer) - AA
   const filterPostAA = apiPostAA.filter((api) => api._id === idPostAA);


  // page d'accueil d'Alrani (on affiche tout les posts sur la page d'accueil d'Alrani)
  const getAllPostAA = apiPostAA.filter((api) => api.home === "1" && api.display === "1" && api.displayOther === "1" && api.approved === "1" && api.visible === "1");
  const filterPost666homeAA = getAllPostAA.sort((a, b) => b.id - a.id); 

  // page d'accueil homeVideoAA (on affiche les videos sur la page d'accueil des videos)
  const filterVideo666videoAA = apiPostAA.filter((api) => api.homeVideo === "1" && api.type === "30" && api.display === "1" && api.displayOther === "1" && api.approved === "1" && api.visible === "1");
  const allVideo666videoAA = filterVideo666videoAA.sort((a, b) => b.id - a.id); 


  // profilOtherAA 
  // filtre dans l'apiPostAA (on affiche tout les posts de l'autre)
  const allPost666profilOtherAA = apiPostAA.filter((api) => api.idOwner === idOwnerAA && api.displayOther === "1" && api.approved === "1" && api.visible === "1");
  const filterPost666profilOtherAA = allPost666profilOtherAA.sort((a, b) => b.id - a.id);

 
  const accountOtherAA = apiAccountAA.filter((api) => api._id === idOwnerAA);
  const idOtherAA = accountOtherAA.map((api) => api._id); // id
  const nameOtherAA = accountOtherAA.map((api) => api.nameAccount); // name
  const photoOtherAA = accountOtherAA.map((api) => api.photoProfile); // photo
  const badgeOtherAA = accountOtherAA.map((api) => api.badge); // badge
  const onlineOtherAA = accountOtherAA.map((api) => api.online); // online (pour savoir sa date de derniere connexion)


  //infos profilAA 
  const namePersonConnectedFA = localStorage.getItem("namePersonConnectedFA");
  const photoPersonConnectedFA = localStorage.getItem("photoPersonConnectedFA"); 
  const badgePersonConnectedFA = localStorage.getItem("badgePersonConnectedFA");

  const namePersonConnectedAA = localStorage.getItem("namePersonConnectedFA");
  const photoPersonConnectedAA = localStorage.getItem("photoPersonConnectedFA"); 
  const badgePersonConnectedAA = localStorage.getItem("badgePersonConnectedFA");
  const virtualNumberPersonConnectedAA = localStorage.getItem("virtualNumberPersonConnectedFA");
  const countryPersonConnectedAA = localStorage.getItem("countryPersonConnectedFA");
  const monetizationAA = localStorage.getItem("monetizationFA");
  const monetizationBalanceAA = localStorage.getItem("monetizationBalanceFA");
  const newMessageAA = localStorage.getItem("newMessageFA");
  const newNotificationAA = localStorage.getItem("newNotificationAA");
  const donaziaFA = localStorage.getItem("donaziaFA");
  const freeDonaziaFA = localStorage.getItem("freeDonaziaFA");
  const subscriptionDonaziaFA = localStorage.getItem("subscriptionDonaziaFA");

 
  // profilAA 
  // filtre dans l'apiPostAA (on affiche tout les posts de la personne connecter)
  const allPost666profilAA = apiPostAA.filter((api) => api.idOwner === idPersonConnectedAA && api.visible === "1" && api.display === "1");
  const filterPost666profilAA = allPost666profilAA.sort((a, b) => b.id - a.id);

  // filtre dans l'apiMessageAA (on affiche les infos de la personne connecter) 
  const accountConnectedAA = apiMessageAA.filter((api) => api._id === idPersonConnectedFA);

  const getIdUserConnectedAA = accountConnectedAA.map((api) => api.idUser); // idUser
  if (getIdUserConnectedAA) { localStorage.setItem("idUserConnectedF", getIdUserConnectedAA); }

  const getNamePersonConnectedAA = accountConnectedAA.map((api) => api.nameAccount); // name
  if (getNamePersonConnectedAA) { localStorage.setItem("namePersonConnectedF", getNamePersonConnectedAA); }

  const getPhotoPersonConnectedAA = accountConnectedAA.map((api) => api.photoProfile); // photo
  if (getPhotoPersonConnectedAA) { localStorage.setItem("photoPersonConnectedF", getPhotoPersonConnectedAA); }

  const getBadgePersonConnectedAA = accountConnectedAA.map((api) => api.badge); // badge
  if (getBadgePersonConnectedAA) { localStorage.setItem("badgePersonConnectedF", getBadgePersonConnectedAA); }

  const getVirtualNumberPersonConnectedAA = accountConnectedAA.map((api) => api.virtualNumber); // virtual number
  if (getVirtualNumberPersonConnectedAA) { localStorage.setItem("virtualNumberPersonConnectedFA", getVirtualNumberPersonConnectedAA); }

  const getCountryPersonConnectedAA = accountConnectedAA.map((api) => api.country); // country (pays)
  if (getCountryPersonConnectedAA) { localStorage.setItem("countryPersonConnectedFA", getCountryPersonConnectedAA); }

  const getMonetizationAA = accountConnectedAA.map((api) => api.monetization); // monetisation 
  if (getMonetizationAA) { localStorage.setItem("monetizationFA", getMonetizationAA); }

  const getMonetizationBalanceAA = accountConnectedAA.map((api) => api.monetizationBalance); // solde 
  if (getMonetizationBalanceAA) { localStorage.setItem("monetizationBalanceFA", getMonetizationBalanceAA); }

  const getDonaziaFA = accountConnectedAA.map((api) => api.donazia); 
  if (getDonaziaFA) { localStorage.setItem("donaziaFA", getDonaziaFA); }

  const getFreeDonaziaFA = accountConnectedAA.map((api) => api.freeDonazia); 
  if (getFreeDonaziaFA) { localStorage.setItem("freeDonaziaFA", getFreeDonaziaFA); }

  const getSubscriptionDonaziaFA = accountConnectedAA.map((api) => api.subscriptionDonazia); 
  if (getSubscriptionDonaziaFA) { localStorage.setItem("subscriptionDonaziaFA", getSubscriptionDonaziaFA); }


  // requete pour obtenir tout les abonnés - AA
  const [apiFollowerAA, setApiFollowerAA] = useState([]);


  // liste abonner
  const listFollowerAA = apiFollowerAA.filter((item) => item.idReceiver === idPersonConnectedAA); // filtre Pour Voir La Liste Des Abonnés de la personne connecter
  const listFollowerOtherAA = apiFollowerAA.filter((item) => item.idReceiver === idOtherAA); //pour l'autre

  // compter le nbre d'abonner
  const countFollowerAA = listFollowerAA.length;
  const countFollowerOtherAA = listFollowerOtherAA.length;



  // liste abonnement
  const listFollowingAA = apiFollowerAA.filter((item) => item.idSender === idPersonConnectedAA); // filtre Pour Voir La Liste Des Abonnements de la personne connecter
  const listFollowingOtherAA = apiFollowerAA.filter((item) => item.idSender === idOtherAA); //pour l'autre

  // compter le nombre d'abonnements
  const countFollowingAA = listFollowingAA.length;
  const countFollowingOtherAA = listFollowingOtherAA.length;


  // information personnelle
  // information personnelle
  const [informationPersonnelle, setInformationPersonnelle] = useState(false);
  async function InformationPersonnelle() {
    setInformationPersonnelle(!informationPersonnelle);

    console.log(apiNotificationAA, "apiNotificationAA");
    console.log(apiNavigationAA, "apiNavigationAA");
  }

  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  // nom
  const [nom, setNom] = useState(false);
  async function Nom() {
    setInformationPersonnelle(true);
    setNom(!nom);
  }

  // nomSuccess
  /* ceci va etre declencher une fois que le nom a été
  enregistré, c'est un message de success */
  const [nomSuccess, setNomSuccess] = useState(false);
  async function nomSuccessBtnTerminer() {
    setNomSuccess(false);
    setInformationPersonnelle(true);
  }

  // modifier le nom
  // modifier le nom
  // modifier le nom
  // cette requete permet a l'utilisateur de modifier son nom
  const [modifierNom, setModifierNom] = useState(namePersonConnectedAA);
  async function ModifierNom(e) {
    setOpacity(true);
    e.preventDefault();

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        nomAuteur: modifierNom,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour recuperer le nouveau nom qu'on a enregistrer
        async function deuxiemeReq() {
          // ici on ferme la popup du nom
          setNom(false);
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              // ici on prend le nom recuperer de la bdd, on enregistre ca dans le localStorage
              const nomAuteur = res.data.nomAuteur;
              if (nomAuteur) {
                localStorage.setItem("https://alrani.com/nomAuteur", nomAuteur);

                localStorage.setItem(
                  "https://alrani.com/nomPersonneConnecterAA",
                  nomAuteur
                );
              }
              setNomSuccess(true);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // modifier le nom

  // age
  // age
  // age
  // age
  // age
  // age
  // age
  // age
  // age
  // age
  // age
  // age
  const [age, setAge] = useState(false);
  async function Age() {
    setInformationPersonnelle(true);
    setAge(!age);
  }

  // popup age
  const [popupAge, setPopupAge] = useState(false);
  async function PopupAge() {
    setPopupAge(!popupAge);
  }

  const [dixseptans, setdixseptans] = useState(true);
  async function Dixseptans() {
    setdixseptans(true);
    setdixhuitans(false);
    const age = "17";
    localStorage.setItem("https://alrani.com/age", age);
  }

  const [dixhuitans, setdixhuitans] = useState(false);
  async function Dixhuitans() {
    setdixseptans(false);
    setdixhuitans(true);
    const age = "18";
    localStorage.setItem("https://alrani.com/age", age);
  }

  // ageSuccess
  /* ceci va etre declencher une fois que l'age a éé
  enregistré, c'est un message de succès */
  const [ageSuccess, setAgeSuccess] = useState(false);
  async function ageSuccessBtnTerminer() {
    setAgeSuccess(false);
    setInformationPersonnelle(true);
  }

  // modifier l'age
  // modifier l'age
  // modifier l'age
  // cette requete permet a l'utilisateur de modifier son age
  async function ModifierAge(e) {
    setOpacity(true);
    e.preventDefault();

    const getAge = localStorage.getItem("https://alrani.com/age");

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        ageAuteur: getAge,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour recuperer le nouveau age qu'on a enregistrer
        async function deuxiemeReq() {
          // ici on ferme la popup de l'age
          setAge(false);
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              // ici on prend l'age depuis la bdd, puis on enregistre ca dans le localStorage
              const ageAuteur = res.data.ageAuteur;
              if (ageAuteur) {
                localStorage.setItem(
                  "https://alrani.com/agePersonneConnecter",
                  ageAuteur
                );
              }
              setAgeSuccess(true);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // modifier l'age

  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  // genre
  const [genre, setGenre] = useState(false);
  async function Genre() {
    setInformationPersonnelle(true);
    setGenre(!genre);
  }

  // popup genre
  const [popupGenre, setPopupGenre] = useState(false);
  async function PopupGenre() {
    setPopupGenre(!popupGenre);
  }

  const [homme, sethomme] = useState(true);
  async function Homme() {
    sethomme(true);
    setfemme(false);
    settrans(false);
    /* ici on met le genre dans le localStorage, on a mit
    homme = 1;
    femme = 2;
    trans = 3;
    parceque au niveau des traductions, ca sera compliquer pour traduire Homme qui est
    enregistrer dans la bdd, voila pourquoi on met 1, pourque la traduction se fait coté
    */
    const setHomme = "1";
    localStorage.setItem("https://alrani.com/genre", setHomme);
  }

  const [femme, setfemme] = useState(false);
  async function Femme() {
    sethomme(false);
    setfemme(true);
    settrans(false);
    const setFemme = "2";
    localStorage.setItem("https://alrani.com/genre", setFemme);
  }

  const [trans, settrans] = useState(false);
  async function Trans() {
    sethomme(false);
    setfemme(false);
    settrans(true);
    const setTrans = "3";
    localStorage.setItem("https://alrani.com/genre", setTrans);
  }

  // genreSuccess
  /* ceci va etre declencher une fois que le genre a éé
  enregistré, c'est un message de succès */
  const [genreSuccess, setGenreSuccess] = useState(false);
  async function genreSuccessBtnTerminer() {
    setGenreSuccess(false);
    setInformationPersonnelle(true);
  }

  // modifier le genre
  // modifier le genre
  // modifier le genre
  // cette requete permet a l'utilisateur de modifier son genre
  async function ModifierGenre(e) {
    setOpacity(true);
    e.preventDefault();

    const getGenre = localStorage.getItem("https://alrani.com/genre");

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        genreAuteur: getGenre,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour recuperer le nouveau genre qu'on a enregistrer
        async function deuxiemeReq() {
          // ici on ferme la popup du genre
          setGenre(false);
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              // ici on prend le genre depuis la bdd, puis on enregistre ca dans le localStorage
              const genreAuteur = res.data.genreAuteur;
              if (genreAuteur) {
                localStorage.setItem(
                  "https://alrani.com/genrePersonneConnecter",
                  genreAuteur
                );
              }
              setGenreSuccess(true);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // modifier le genre

  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  // pays
  const [country, setCountry] = useState(false);
  async function Country() {
    setInformationPersonnelle(true);
    setCountry(!country);
  }

  const [popupCountry, setPopupCountry] = useState(false);
  async function PopupCountry() {
    setPopupCountry(!popupCountry);
  }

  // Afghanistan
  // Afghanistan
  const [afghanistan, setAfghanistan] = useState(true);
  async function Afghanistan() {
    //
    setAfghanistan(true);
    //
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "1";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Afghanistan

  // Afrique Du Sud
  // Afrique Du Sud
  const [afriqueDuSud, setAfriqueDuSud] = useState(false);
  async function AfriqueDuSud() {
    setAfghanistan(false);
    //
    setAfriqueDuSud(true);
    //
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "2";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Afrique Du Sud

  // Albanie
  // Albanie
  const [albanie, setAlbanie] = useState(false);
  async function Albanie() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    //
    setAlbanie(true);
    //
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "3";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Albanie

  // Algerie
  // Algerie
  const [algerie, setAlgerie] = useState(false);
  async function Algerie() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    //
    setAlgerie(true);
    //
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "4";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Algerie

  // Allemagne
  // Allemagne
  const [allemagne, setAllemagne] = useState(false);
  async function Allemagne() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    //
    setAllemagne(true);
    //
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "5";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Allemagne

  // Andorre
  // Andorre
  const [andorre, setAndorre] = useState(false);
  async function Andorre() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    //
    setAndorre(true);
    //
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "6";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Andorre

  // Angola
  // Angola
  const [angola, setAngola] = useState(false);
  async function Angola() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    //
    setAngola(true);
    //
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "7";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Angola

  // Antigua
  // Antigua
  const [antigua, setAntigua] = useState(false);
  async function Antigua() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    //
    setAntigua(true);
    //
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "8";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Antigua

  // Arabie
  // Arabie
  const [arabie, setArabie] = useState(false);
  async function Arabie() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    //
    setArabie(true);
    //
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "9";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Arabie

  // Argentine
  // Argentine
  const [argentine, setArgentine] = useState(false);
  async function Argentine() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    //
    setArgentine(true);
    //
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "10";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Argentine

  // Armenie
  // Armenie
  const [armenie, setArmenie] = useState(false);
  async function Armenie() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    //
    setArmenie(true);
    //
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "11";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Armenie

  // Australie
  // Australie
  const [australie, setAustralie] = useState(false);
  async function Australie() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    //
    setAustralie(true);
    //
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "12";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Australie

  // Autriche
  // Autriche
  const [autriche, setAutriche] = useState(false);
  async function Autriche() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    //
    setAutriche(true);
    //
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "13";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Autriche

  // Azerbaidjan
  // Azerbaidjan
  const [azerbaidjan, setAzerbaidjan] = useState(false);
  async function Azerbaidjan() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    //
    setAzerbaidjan(true);
    //
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "14";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Azebaidjan

  // Bahamas
  // Bahamas
  const [bahamas, setBahamas] = useState(false);
  async function Bahamas() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    //
    setBahamas(true);
    //
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "15";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Bahamas

  // Bahrein
  // Bahrein
  const [bahrein, setBahrein] = useState(false);
  async function Bahrein() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    //
    setBahrein(true);
    //
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "16";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Bahrein

  // Bangladesh
  // Bangladesh
  const [bangladesh, setBangladesh] = useState(false);
  async function Bangladesh() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    //
    setBangladesh(true);
    //
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "17";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Bangladesh

  // Barbade
  // Barbade
  const [barbade, setBarbade] = useState(false);
  async function Barbade() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    //
    setBarbade(true);
    //
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "18";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Barbade

  // Belgique
  // Belgique
  const [belgique, setBelgique] = useState(false);
  async function Belgique() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    //
    setBelgique(true);
    //
    setBelize(false);
    setCongo(false);
    setGuineeE(false);
    const pays = "19";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Belgique

  // Belize
  // Belize
  const [belize, setBelize] = useState(false);
  async function Belize() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    //
    setBelize(true);
    //
    setCongo(false);
    setGuineeE(false);
    const pays = "20";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // Belize

  // congo
  // congo
  const [congo, setCongo] = useState(false);
  async function Congo() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    //
    setCongo(true);
    //
    setGuineeE(false);
    const pays = "50";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // congo

  // guinee equatoriale
  // guinee equatoriale
  const [guineeE, setGuineeE] = useState(false);
  async function GuineeE() {
    setAfghanistan(false);
    setAfriqueDuSud(false);
    setAlbanie(false);
    setAlgerie(false);
    setAllemagne(false);
    setAndorre(false);
    setAngola(false);
    setAntigua(false);
    setArabie(false);
    setArgentine(false);
    setArmenie(false);
    setAustralie(false);
    setAutriche(false);
    setAzerbaidjan(false);
    setBahamas(false);
    setBahrein(false);
    setBangladesh(false);
    setBarbade(false);
    setBelgique(false);
    setBelize(false);
    setCongo(false);
    //
    setGuineeE(true);
    //
    const pays = "100";
    localStorage.setItem("https://alrani.com/pays", pays);
  }
  // guinee equatoriale

  // countrySuccess
  /* ceci va etre declencher une fois que le pays a éé
  enregistré, c'est un message de succès */
  const [countrySuccess, setCountrySuccess] = useState(false);
  async function countrySuccessBtnTerminer() {
    setCountrySuccess(false);
    setInformationPersonnelle(true);
  }

  // modifier le pays
  // cette requete permet a l'utilisateur de modifier son pays
  async function ModifierPays(e) {
    setOpacity(true);
    e.preventDefault();

    const getPays = localStorage.getItem("https://alrani.com/pays");

    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        paysAuteur: getPays,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour recuperer le nouveau pays qu'on a enregistrer
        async function deuxiemeReq() {
          // ici on ferme la popup qui permet de choisir le pays
          setCountry(false);
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              // ici on prend le pays depuis la bdd, puis on enregistre ca dans le localStorage
              const paysAuteur = res.data.paysAuteur;
              if (paysAuteur) {
                localStorage.setItem(
                  "https://alrani.com/paysPersonneConnecter",
                  paysAuteur
                );
              }
              setCountrySuccess(true);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // modifier le pays

  const badgeVerifiedPersonneConnecter = localStorage.getItem(
    "https://alrani.com/badgePersonConnectedAA"
  );
  const photoProfilPersonneConnecter = localStorage.getItem(
    "https://alrani.com/photoPersonConnectedAA"
  );

  // plus d'options
  // plus d'options
  const [plusOptions, setPlusOptions] = useState(false);
  async function PlusOptions() {
    setPlusOptions(!plusOptions);

    localStorage.setItem("https://alrani.com/idPage", idPersonConnectedAA);
    localStorage.setItem("https://alrani.com/nomPage", namePersonConnectedAA);
    localStorage.setItem(
      "https://alrani.com/photoProfilPage",
      photoProfilPersonneConnecter
    );
    localStorage.setItem(
      "https://alrani.com/badgeVerifiedPage",
      badgeVerifiedPersonneConnecter
    );

    /* apres avoir cliquer sur Plus d'options, ca veut dire que la personne va publier sur 
    son compte, donc on retire les fonctionnalites d'administrateur. 
    car les fonctionnalites d'administrateur c'est seulement si la personne clique sur business 
    , il va dans gestionnaire de pages, ca veut dire qu'il va publier dans la page qu'il gere */
    localStorage.removeItem("https://alrani.com/idAdmin");
    localStorage.removeItem("https://alrani.com/nomAdmin");
    // On ajoute le roleAdmin
    /* ici le roleAdmin=1, on l'ajoute juste pour dire que c'est le proprietaire du compte qui
    a publier tel publication, bon! ici nous sommes au niveau de Plus d'Options, quand on 
    clique sur Plus d'Options, ensuite si on veut on pourra publier quelque chose */
    const roleAdmin = "1";
    localStorage.setItem("https://alrani.com/roleAdmin", roleAdmin);
  }

  
  // choisir la photo a mettre sur le profil (page) - AA 
  const [choosePhotoProfilePageAA, setChoosePhotoProfilePageAA] = useState(false);
  async function ChoosePhotoProfilePageAA() {
    setChoosePhotoProfilePageAA(true);
  }
  async function CloseChoosePhotoProfilePageAA() { //fermer
    setChoosePhotoProfilePageAA(false);
  }

  // photo de profil ajoutée (message de success) - AA 
  const [photoProfileSuccessAA, setPhotoProfileSuccessAA] = useState(false);
  async function ClosePhotoProfileSuccessAA() {
    setPhotoProfileSuccessAA(false);
  }

  // infos - mettre Photo Profil
  const [infosMettrePhotoProfil, setInfosMettrePhotoProfil] = useState(false);
  async function InfosMettrePhotoProfil() {
    setInfosMettrePhotoProfil(!infosMettrePhotoProfil);
  }

  const [isLoading, setIsLoading] = useState(false);

  // logique pour mettre la photo sur son profil Alrani - AA
  const [file, setFile] = useState();
  const [isLoadingPhotoProfileAA, setIsLoadingPhotoProfileAA] = useState(false);

  async function PhotoProfileAA() { 
    if (idPersonConnectedAA) {

      const block = localStorage.getItem("blockAA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoadingPhotoProfileAA(true);

      //1ere requete
      //1ere requete
      // on envoie la photo sur cloudinary
      async function premiereReq() {
        const data = new FormData();
        data.append("image", file);
        await axios
        .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendPhoto`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          const urlPhoto = res.data.urlPhoto;
          if (urlPhoto) { localStorage.setItem("urlPhotoAAreq", urlPhoto); }

      //2e requete
      //2e requete
      // on enregistre l'url de la photo dans la bdd
      async function deuxiemeReq() {
        const urlPhoto = localStorage.getItem("urlPhotoAAreq");
        await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
        data: {
          photoProfile: urlPhoto,
        },
        })
        .then((res) => {
              
      //3e requete
      //3e requete
      //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
        .then((res) => {
          setApiAccountAA(res.data);
          setPhotoProfileSuccessAA(true);
          setChoosePhotoProfilePageAA(false);
          setIsLoadingPhotoProfileAA(false);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Photo de profil remplacée! (il a réussi à mettre sa nouvelle photo de profil) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileAA(false);
          setErrorAA(true);
        });
        }
        troisiemeReq();
        //3e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileAA(false);
          setErrorAA(true);
        });
        }
        deuxiemeReq();
        //2e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileAA(false);
          setErrorAA(true);
        });
      }
      premiereReq();
      //1ere requete
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }


  //logique pour mettre une photo sur son profil en passant par les favoris
  async function PhotoProfileAA666favoriteAA() {
    if (idPersonConnectedAA) {

      const block = localStorage.getItem("blockAA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoadingPhotoProfileAA(true);

      //2e requete
      //2e requete
      // on enregistre l'url de la photo dans la bdd
      async function deuxiemeReq() {
        const urlPhoto = localStorage.getItem("urlPhotoAAreq");
        await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
        data: {
          photoProfile: urlPhoto,
        },
        })
        .then((res) => {
              
      //3e requete
      //3e requete
      //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
        .then((res) => {
          setApiAccountAA(res.data);
          setPhotoProfileSuccessAA(true);
          setPhotoProfile666favoriteAA(false);
          setIsLoadingPhotoProfileAA(false);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Photo de profil remplacée! (666favoriteAA) (il a mis une photo sur son profil en passant par les favoris)";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileAA(false);
          setErrorAA(true);
        });
        }
        troisiemeReq();
        //3e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileAA(false);
          setErrorAA(true);
        });
      }
      deuxiemeReq();
      //2e requete
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }


  // publication
  // publication
  const [publierPublication, setPublierPublication] = useState(false);
  async function PublierPublication() {
    //setPlusOptions(true);
    setPublierPublication(!publierPublication);
  }

  // text
  const [text, setText] = useState(true);
  async function TextPublierQuelqueChose() {
    setText(true);
    setImage(false);
    setPublicationText(true);
    setPublicationTextBoxShadow(false);
    setPublicationImageUnPhoto(false);
    setPublicationImageDeuxPhotos(false);
    setPublicationImageTroisPhotos(false);
  }

  // image
  const [image, setImage] = useState(false);
  async function ImagePublierQuelqueChose() {
    setText(false);
    setImage(true);
    setPublicationText(false);
    setPublicationTextBoxShadow(false);
    setPublicationImageUnPhoto(true);
    setPublicationImageDeuxPhotos(false);
    setPublicationImageTroisPhotos(false);
  }

  // publier video - page
  async function Video() {
    // on retire la photo de couverture si y'en a dans le locaStorage
    /* on la retirer car ca causait un probleme, lorsqu'on publiait une video sans photo
    de couverture, ca prenait la photo de couverture d'une ancienne video qu'on avait deja
    publier, donc on la retire lorsqu'on clique sur publier une video, de toute les facon si on
    veut ajouter une photo de couverture a la video, il y'a la procedure a suivre qu'on on 
    est dans /video, et ensuite on a ajoute une photo de couverture a la video si on la desire */
    localStorage.removeItem(
      "https://alrani.com/EnAttenteUrlPhotoCouvjertureVideo"
    );
  }
  // ici quand on va cliquer ca va maintenant envoyer la video sur cloudinary
  async function PublierVideo(e) {
    e.preventDefault();
    setOpacity(true);
    setIsLoading(true);
    // ici on enregistre le postStyle de la video dans le localStorage
    const postStyle = "10";
    localStorage.setItem("https://alrani.com/EnAttentePostStyle", postStyle);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/postAA/publierVideo`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const urlVideo = res.data.secure_url;
        localStorage.setItem("https://alrani.com/urlVideo", urlVideo);
        /* une fois que la video a ete envoyer sur cloudinary, on redirige l'utilisateur
        sur la page /video , sur cette page on va maintenant enregistrer le poste dans 
        mongodb */
        window.location = "/video";
      })
      .catch((err) => {
        setIsLoading(false);
        setOpacity(false);
        setErreur(true);
      });
  }
  // ici on afffiche la page qui dit qu'il peut seulement publier des videos de 1MB maximum
  // informationImportante
  const [informationImportante, setInformationImportante] = useState(false);
  async function InformationImportante() {
    setInformationImportante(!informationImportante);
    /* on enregistre idAuteur, c'est tout simplement l'id de Alrani (c'est ce qui va nous 
    permettre plus tard d'entrer en contact avec Alrani) */
    // on contacte Alrani dans le cas par exemple, si on veut publier une video de 10MB
    const idDeAlrani = "6438067dbcaf721255c08df3";
    localStorage.setItem("https://alrani.com/idAuteur", idDeAlrani);
  }
  // lien video - page
  // quand on clique sur j'ai un lien, ici on affiche la page ou on va coller le lien
  const [lienVideo, setLienVideo] = useState(false);
  async function LienVideo() {
    setLienVideo(!lienVideo);
  }

  //const [urlVideoo, setUrlVideo] = useState("");
  // quand on clique ca va rediriger l'utilisateur dans /video
  async function CollerLienContinuer(e) {
    e.preventDefault();
    setOpacity(true);
    // avant de rediriger, ca va d'abord enregistrer le lien dans le localstorage
    //localStorage.setItem("https://alrani.com/urlVideo", urlVideoo);
    // postStyle de la video
    /* le postStyle c'est 10 car c'est une urlVideo, mais si c'est une urlPhotoCouvertureVideo
    là le postStyle sera 20 */
    const postStyle = "10";
    localStorage.setItem("https://alrani.com/EnAttentePostStyle", postStyle);

    window.location = "/video";
  }

  const dernierMessage = "Click to start the conversation..";
  const idAuteur = localStorage.getItem("https://alrani.com/idAuteur");
  const nomAuteur = "Alrani.com";
  const photoProfil =
    "https://res.cloudinary.com/rasivyy/image/upload/v1681394904/Alrani%20-%20Photo%20Profil/h3xedseutej35nelpybp.webp";
  const badgeVerified = "1";
  // ici c'est pour contacter alrani
  // par exemple, si on veut publier une video qui pese plus de 10MB
  // id de alrani 6438067dbcaf721255c08df3
  //
  // initier la conversation
  /* envoyer un message en cliquant sur le bouton envoyer un message */
  async function ContacterAlrani(e) {
    setOpacity(true);
    e.preventDefault();

    // utilisateur connecter
    // avec idPersonneConnecter, on verifie si l'utilisateur est connecter
    // si y'a idPersonneConnecter dans le localStorage ca veut dire que l'utilisateur est connecté
    if (idPersonConnectedAA) {
      // verification
      // verifier s'il existe deja une conversation entre les deux utilisateurs
      await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/conversation/`)
        .then((res) => {
          const api = res.data;
          // possibiliterUn
          // possibiliterUn
          // possibiliterUn
          const possibiliterUn = api.filter(
            (api) =>
              api.idInitieur === idPersonConnectedAA &&
              api.idDestinataire === idAuteur
          );
          const verified1 = possibiliterUn.length > 0;

          // possibiliterUn - suite
          if (verified1) {
            const idConversation1 = possibiliterUn.map((api) => api._id);
            const idAuteurMessage1 = possibiliterUn.map(
              (api) => api.idDestinataire
            );
            const nomAuteurMessage1 = possibiliterUn.map(
              (api) => api.nomDestinataire
            );
            const photoProfilAuteurMessage1 = possibiliterUn.map(
              (api) => api.photoProfilDestinataire
            );
            const badgeVerifiedAuteurMessage1 = possibiliterUn.map(
              (api) => api.badgeVerifiedDestinataire
            );
            localStorage.setItem(
              "https://alrani.com/idConversation",
              idConversation1
            );
            localStorage.setItem(
              "https://alrani.com/idDestinataireMessage",
              idAuteurMessage1
            );
            localStorage.setItem(
              "https://alrani.com/nomDestinataireMessage",
              nomAuteurMessage1
            );
            localStorage.setItem(
              "https://alrani.com/photoProfilDestinataireMessage",
              photoProfilAuteurMessage1
            );
            localStorage.setItem(
              "https://alrani.com/badgeVerifiedDestinataireMessage",
              badgeVerifiedAuteurMessage1
            );

            window.location = "/message";
          }

          // possibiliterDeux
          // possibiliterDeux
          // possibiliterDeux
          const possibiliterDeux = api.filter(
            (api) =>
              api.idInitieur === idAuteur &&
              api.idDestinataire === idPersonConnectedAA
          );
          const verified2 = possibiliterDeux.length > 0;

          // possibiliterDeux - suite
          if (verified2) {
            const idConversation2 = possibiliterDeux.map((api) => api._id);
            const idAuteurMessage2 = possibiliterDeux.map(
              (api) => api.idInitieur
            );
            const nomAuteurMessage2 = possibiliterDeux.map(
              (api) => api.nomInitieur
            );
            const photoProfilAuteurMessage2 = possibiliterDeux.map(
              (api) => api.photoProfilInitieur
            );
            const badgeVerifiedAuteurMessage2 = possibiliterDeux.map(
              (api) => api.badgeVerifiedInitieur
            );
            localStorage.setItem(
              "https://alrani.com/idConversation",
              idConversation2
            );
            localStorage.setItem(
              "https://alrani.com/idDestinataireMessage",
              idAuteurMessage2
            );
            localStorage.setItem(
              "https://alrani.com/nomDestinataireMessage",
              nomAuteurMessage2
            );
            localStorage.setItem(
              "https://alrani.com/photoProfilDestinataireMessage",
              photoProfilAuteurMessage2
            );
            localStorage.setItem(
              "https://alrani.com/badgeVerifiedDestinataireMessage",
              badgeVerifiedAuteurMessage2
            );

            window.location = "/message";
          }

          // possibiliterTrois
          // possibiliterTrois
          if (!verified1 && !verified2) {
            // 2e requete
            // requete pour initier la conversation
            async function deuxiemeReq() {
              await axios({
                method: "post",
                url: `${process.env.REACT_APP_BACKEND}/api/conversation/create`,
                data: {
                  // l'autre personne
                  //idDestinataire: id,
                  nomDestinataire: nomAuteur,
                  photoProfilDestinataire: photoProfil,
                  badgeVerifiedDestinataire: badgeVerified,
                  dernierMessage: dernierMessage,
                  // personne connecter
                  idInitieur: idPersonConnectedAA,
                  nomInitieur: namePersonConnectedAA,
                  photoProfilInitieur: photoProfilPersonneConnecter,
                  badgeVerifiedInitieur: badgeVerifiedPersonneConnecter,
                },
              })
                .then((res) => {
                  const idConversation = res.data._id;
                  if (idConversation) {
                    localStorage.setItem(
                      "https://alrani.com/idConversation",
                      idConversation
                    );
                  }

                  const idDestinataire = res.data.idDestinataire;
                  if (idDestinataire) {
                    localStorage.setItem(
                      "https://alrani.com/idDestinataireMessage",
                      idDestinataire
                    );
                  }

                  const nomDestinataire = res.data.nomDestinataire;
                  if (nomDestinataire) {
                    localStorage.setItem(
                      "https://alrani.com/nomDestinataireMessage",
                      nomDestinataire
                    );
                  }

                  const badgeVerifiedDestinataire =
                    res.data.badgeVerifiedDestinataire;
                  if (badgeVerifiedDestinataire) {
                    localStorage.setItem(
                      "https://alrani.com/badgeVerifiedDestinataireMessage",
                      badgeVerifiedDestinataire
                    );
                  }

                  const photoProfilDestinataire =
                    res.data.photoProfilDestinataire;
                  localStorage.setItem(
                    "https://alrani.com/photoProfilDestinataireMessage",
                    photoProfilDestinataire
                  );
                  window.location = "/message";
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreur(true);
                });
            }
            deuxiemeReq();
            // 2e requete
          }
          // possibiliterTrois
        });
      // verification
    } else {
      /* on balance ce message d'erreur si l'utilisateur n'est pas connecter
  a son compte */
      setSansEtreConnecter(true);
      setOpacity(false);
    }
    // utilisateur connecter
  }
  // initier la conversation

  // publication text
  // publication text
  // publication text
  const [publicationText, setPublicationText] = useState(true);
  async function PublicationText() {
    setPublicationText(true);
    setPublicationTextBoxShadow(false);
    setPublicationImageUnPhoto(false);
    setPublicationImageDeuxPhotos(false);
    setPublicationImageTroisPhotos(false);
  }

  // publication text box shadow
  // publication text box shadow
  // publication text box shadow
  const [publicationTextBoxShadow, setPublicationTextBoxShadow] =
    useState(false);
  async function PublicationTextBoxShadow() {
    setPublicationText(false);
    setPublicationTextBoxShadow(true);
    setPublicationImageUnPhoto(false);
    setPublicationImageDeuxPhotos(false);
    setPublicationImageTroisPhotos(false);
  }

  // publication Image Un Photo
  // publication Image Un Photo
  // publication Image Un Photo
  const [publicationImageUnPhoto, setPublicationImageUnPhoto] = useState(false);
  async function PublicationImageUnPhoto() {
    setPublicationText(false);
    setPublicationTextBoxShadow(false);
    setPublicationImageUnPhoto(true);
    setPublicationImageDeuxPhotos(false);
    setPublicationImageTroisPhotos(false);
  }

  // publication Image Deux Photos
  // publication Image Deux Photos
  // publication Image Deux Photos
  const [publicationImageDeuxPhotos, setPublicationImageDeuxPhotos] =
    useState(false);
  async function PublicationImageDeuxPhotos() {
    setPublicationText(false);
    setPublicationTextBoxShadow(false);
    setPublicationImageUnPhoto(false);
    setPublicationImageDeuxPhotos(true);
    setPublicationImageTroisPhotos(false);
  }

  // publication Image Trois Photos
  // publication Image Trois Photos
  // publication Image Trois Photos
  const [publicationImageTroisPhotos, setPublicationImageTroisPhotos] =
    useState(false);
  async function PublicationImageTroisPhotos() {
    setPublicationText(false);
    setPublicationTextBoxShadow(false);
    setPublicationImageUnPhoto(false);
    setPublicationImageDeuxPhotos(false);
    setPublicationImageTroisPhotos(true);
  }

  // opacity
  // opacity
  const [opacity, setOpacity] = useState(false);

  // text btn
  // text btn
  // publication text btn
  const [descriptionTextBtn, setDescriptionTextBtn] = useState("");

  async function PublierTextBtn(e) {
    e.preventDefault();
    setOpacity(true);
    setIsLoading(true);
    localStorage.setItem(
      "https://alrani.com/descriptionTextBtn",
      descriptionTextBtn
    );
    window.location = "/text-btn";
  }

  // box shadow
  // box shadow
  // publication box shadow
  const [descriptionBoxShadow, setDescriptionBoxShadow] = useState("");

  async function PublierBoxShadow(e) {
    e.preventDefault();
    setOpacity(true);
    setIsLoading(true);
    localStorage.setItem(
      "https://alrani.com/descriptionBoxShadow",
      descriptionBoxShadow
    );
    window.location = "/box-shadow";
  }


  // page pour faire une publication text - AA
  const [postTextPageAA, setPostTextPageAA] = useState(false);
  async function PostTextPageAA() {
    setPostTextPageAA(true);
    localStorage.removeItem("writeDescriptionAA");
  }
  async function ClosePostTextPageAA() { //fermer
    setPostTextPageAA(false);
  }

  // logique pour publier une publication text sur sa page Alrani
  async function PostTextAA() {
    if (idPersonConnectedAA) { 

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
    setIsLoading(true);

      // AllPostReq
      async function AllPostReq() { //on a refait la requete car il y'avait des posts ou le createIdPostAA ratait
        await axios
        .get(`${process.env.REACT_APP_PostTextAA}/api/postAA`)
        .then((res) => {
          setApiPostAA(res.data);
          const api = res.data;

      //creer un id pour chaque post publié - AA
      const numberPostsAA = api.filter((api) => api._id); //on a mis au pluriel car numberPostAA est deja pris
      const totalPostAA = numberPostsAA.length;

      const createIdPostAA = totalPostAA + 1;
      if (createIdPostAA) { localStorage.setItem("createIdPostAA", createIdPostAA) 
    
    //1ere requete
    //1ere requete 
    // on publie la photo sur Alrani
    async function premiereReq() {
      const id = localStorage.getItem("createIdPostAA");
      const reaction = "0";
      const comment = "0";
      const share = "0";
      const view = "0";
      const clic = "0";
      const clicMyAccount = "0";
      const description = localStorage.getItem("writeDescriptionAA");
      const buttonActivated = "0";
      const connection = "1";
      const type = "6";
      const filter = localStorage.getItem("countryPersonConnectedAA");
      const monetization = "1";
      const monetizationBalance = "0";
      const display = "1";
      const displayOther = localStorage.getItem("displayOtherAA");
      const home = localStorage.getItem("homeAA");
      const hide = "0";
      const deleted = "0";
      const best = "0";
      const visible = "1";
      const approved = "1";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_PostTextAA}/api/postAA/new`,
      data: {
        id,
        idOwner: idPersonConnectedAA,
        idUserOwner: idUserConnectedAA,
        nameOwner: namePersonConnectedAA,
        photoOwner: photoPersonConnectedAA,
        badgeOwner: badgePersonConnectedAA,
        reaction,
        comment,
        share,
        view,
        clic,
        clicMyAccount,
        description,
        buttonActivated,
        connection,
        type,
        filter,
        monetization,
        monetizationBalance,
        display,
        displayOther,
        home,
        visible,
        hide,
        deleted,
        best,
        approved,
      },
    })
    .then((res) => {
      //on prend l'id du nouveau Post, on va l'ajouter au niveau du compte comme etant le dernier post
      const idNewPost = res.data._id;
      if (idNewPost) { localStorage.setItem("idNewPost", idNewPost); }
      console.log("a6");

      //2e requete
      //2e requete
      // obtenir de nouvelles donnees
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostTextAA}/api/postAA`)
        .then((res) => {
          setApiPostAA(res.data);
          setPostTextPageAA(false);
          setIsLoading(false);
          console.log("a7");

        //ici on affiche le message de succes
        setPostSuccessAA(true);
        //ici on le fait disparaitre
        async function ClosePostSuccess() {
          setPostSuccessAA(false);
        }
        setTimeout(ClosePostSuccess, 1400);

      //3e requete
      //3e requete
      // on prend l'id du dernier post (pour retirer le dernier post du fil d'actualité)
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostTextAA}/api/accountAA`)
        .then((res) => {
          console.log("a8");
        const api = res.data;
        const filtreApiUser = api.filter((api) => api._id === idPersonConnectedAA);
        
        const lastPost = filtreApiUser.map((api) => api.lastPost); //id du dernier post
        if (lastPost) { localStorage.setItem("lastPost", lastPost); }

        const post = api.filter((api) => api._id === idPersonConnectedAA && api.lastPost === "0"); //on vérifie si sur le fil d'actualité 1 post a déjà été publié
        const verifyLastPost = post.length > 0;

        if (verifyLastPost) {
          //dans ce cas: dernier post non present sur le fil d'actualité
          console.log("a9");

          //4e requete
          //4e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function quatriemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostTextAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {

          //5e requete
          //5e requete
          // obtenir de nouvelles donnees
          async function cinquiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_PostTextAA}/api/postAA`)
            .then((res) => {
              setApiPostAA(res.data);

          //6e requete
          //6e requete
          // on obtiens la localisation de l'utilisateur
          async function sixiemeReq() {
            await axios
            .get("https://ip.nf/me.json")
            .then((res) => {
              const getcountryip = res.data.ip.country; //country
              if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

              const getcityip = res.data.ip.city; //city
              if (getcityip) { localStorage.setItem("cityIp", getcityip) }

              const getuserip = res.data.ip.ip; //ip
              if (getuserip) { localStorage.setItem("addressIp", getuserip) }

          //7e requete
          //7e requete
          // on enregistre la localisation et la navigation de l'utilisateur
          async function septiemeReq() {
            const id = localStorage.getItem("createIdNavigationAA");
            const addressIp = localStorage.getItem("addressIp");
            const countryIp = localStorage.getItem("countryIp");
            const cityIp = localStorage.getItem("cityIp");
            const page = "Post text publiée! (il a réussi à publier une publication text) - AA";
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_PostTextAA}/api/navigationAA/new`,
              data: {
                id,
                idAccount: idPersonConnectedAA,
                nameAccount: namePersonConnectedAA,
                addressIp,
                countryIp,
                cityIp,
                page,
              },
            })
            .then((res) => {
              console.log("a13");
            const online = res.data.createdAt; //on recupere la date de derniere connexion
            if (online) { localStorage.setItem("onlineAA", online) }

          //8e requete
          //8e requete
          // on enregistre la date de derniere connexion
          async function huitiemeReq() {
            const online = localStorage.getItem("onlineAA");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostTextAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                online,
              },
            })
            .then((res) => {
              console.log("a14");
            })
            }
            huitiemeReq();
            //8e requete
            });
            }
            septiemeReq();
            //7e requete
            });
            }
            sixiemeReq();
            //6e requete
            })
            }
            cinquiemeReq();
            //5e requete
            })
          }
          quatriemeReq();
          //4e requete
        } else {
          //dans ce cas: dernier post present sur le fil d'actualité
          console.log("a15");

          //4e requete
          //4e requete
          // on retire le dernier post du fil d'actualité
          async function quatriemeReq() {
            const id = localStorage.getItem("lastPost");
            const home = "0";
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostTextAA}/api/postAA/update/${id}`,
              data: {
                home,
              },
            })
            .then((res) => {
              console.log("a16");

          //5e requete
          //5e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function cinquiemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostTextAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {

            //6e requete
            //6e requete
            // obtenir de nouvelles donnees
            async function sixiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_PostTextAA}/api/postAA`)
              .then((res) => {
                setApiPostAA(res.data);
              })
              }
              sixiemeReq();
              //6e requete
              })
              }
              cinquiemeReq();
              //5e requete
              })
              }
              quatriemeReq();
              //4e requete
            }
            //if (verifyLastPost) 
            })
          }
          troisiemeReq();
          //3e requete
      })
      .catch((err) => {

        // ici nous sommes au niveau du .catch de la deuxiemeReq()
        //la 2e requete c'est pour obtenir de nouvelles donnees, si ca rate, alors on va encore insister, on va refaire la requete pour obtenir de nouvelles donnees, ensuite on va l'afficher le message que le post avait deja ete publié
        // get
        async function get() {
          await axios
          .get(`${process.env.REACT_APP_PostTextAA}/api/postAA`)
          .then((res) => {
            setApiPostAA(res.data);
            setBeforePostPhotoPageAA(false);
            setPostTextPageAA(false);
            setIsLoading(false);
            //ici on affiche le message de succes
            setPostSuccessAA(true);

          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessAA(false);
          }
          setTimeout(ClosePostSuccess, 1400);
        })
        .catch((err) => {
          //si on arrive pas a obtenir tout les posts, alors on lui affiche juste le message que sa photo avait deja ete publié
          setPostTextPageAA(false);
          setIsLoading(false);
          //ici on affiche le message de succes
          setPostSuccessAA(true);
          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessAA(false);
          }
          setTimeout(ClosePostSuccess, 1400);
        })
        }
        get();
        //get
      });
      }
      deuxiemeReq();
      //2e requete
      })
      .catch((err) => {
        console.log("a22");
        setErrorAA(true);
        setIsLoading(false);
      });
    }
    premiereReq();
    //1ere requete
    } //if (createIdPostAA)
    })
    .catch((err) => {
      console.log("a23");
      setErreur(true);
      setIsLoading(false);
    })
    }
    AllPostReq();
    // AllPostReq
  }// if (block === "0")
  }//if(idPersonConnectedAA)
}


  // sur cette page, on selectionnes la photo a publier - AA 
  const [beforePostPhotoPageAA, setBeforePostPhotoPageAA] = useState(false);
  async function BeforePostPhotoPageAA() {
    setBeforePostPhotoPageAA(true);
    localStorage.removeItem("writeDescriptionAA");
  }
  async function CloseBeforePostPhotoPageAA() { //fermer
    setBeforePostPhotoPageAA(false);
  }


  const [filePhotoAA, setFilePhotoAA] = useState();
  
  // logique pour envoyer une image sur cloudinary - AA
  async function SendPhotoToCloudinaryAA() { 
    console.log("a1");
    if (idPersonConnectedAA) {
      console.log("a2");

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
    setIsLoading(true);
    console.log("a3");

    //1ere requete
    //1ere requete
    // on envoie l'image sur cloudinary
    async function premiereReq() {
      const data = new FormData();
      data.append("image", filePhotoAA);

      await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("a4");
        const photo = res.data.urlPhoto;
        if (photo) { localStorage.setItem("urlPhotoAAreq", photo); }

        setIsLoading(false);
        setPostPhotoPageAA(true);
      })
      .catch((err) => {
        console.log("a5");
        setIsLoading(false);
        setErreur(true);
      });
    }
    premiereReq();
    //1ere requete
    }// if (block === "0")
    }// if(idPersonConnectedAA)
  }

  // post publié (message de success) - AA 
  const [postSuccessAA, setPostSuccessAA] = useState(false);
  async function ClosePostSuccessAA() {
    setPostSuccessAA(false);
  }

  // seePhotoAAreq (lors des requetes, page pour afficher la photo sur laquelle on a cliquer)
  const [seePhotoAAreq, setSeePhotoAAreq] = useState(false);
  async function SeePhotoAAreq() {
    setSeePhotoAAreq(true);
  }
  async function CloseSeePhotoAAreq() {
    setSeePhotoAAreq(false);
  }
  // on affiche la photo qu'on veut publier
  const urlPhotoAAreq = localStorage.getItem("urlPhotoAAreq");
  

  // page pour ecrire la description et publier la photo - AA
  const [postPhotoPageAA, setPostPhotoPageAA] = useState(false);
  async function PostPhotoPageAA() {
    setPostPhotoPageAA(true);
  }
  async function ClosePostPhotoPageAA() { //fermer
    setPostPhotoPageAA(false);
  }

  const [writeDescriptionAA, setWriteDescriptionAA] = useState(""); //saisir la description de la publication
  if (writeDescriptionAA) { localStorage.setItem("writeDescriptionAA", writeDescriptionAA); }


  // logique pour publier une photo sur Alrani
  const [isLoading666postPhotoPageAA, setIsLoading666postPhotoPageAA] = useState(false);

  async function PostPhotoAA() {
    console.log("a0");
    if (idPersonConnectedAA) { 
      setIsLoading666postPhotoPageAA(true);
      console.log("a1");

      // AllPostReq
      async function AllPostReq() { //on a refait la requete car il y'avait des posts ou le createIdPostAA ratait
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
        .then((res) => {
          console.log("a2");
          setApiMessageAA(res.data);
		      const api = res.data;

      //creer un id pour chaque post publié - AA
      const numberMessagesAA = api.filter((api) => api._id); //on a mis au pluriel car numberPostAA est deja pris
      const totalMessageAA = numberMessagesAA.length;

      const createIdMessageAA = totalMessageAA + 1;
      if (createIdMessageAA) { localStorage.setItem("createIdMessageAA", createIdMessageAA)
      console.log("a3");

    //1ere requete
    //1ere requete 
    // on publie la photo sur Alrani
    async function premiereReq() {
      const id = localStorage.getItem("createIdMessageAA");
      const reaction = "0";
      const comment = "0";
      const share = "0";
      const view = "0";
      const clic = "0";
      const clicMyAccount = "0";
      const urlPhoto = localStorage.getItem("urlPhotoAAreq");
      const description = localStorage.getItem("writeDescriptionAA");
      const buttonActivated = "0";
      const monetization = "1";
      const monetizationBalance = "0";
      const connection = "1";
      const type = "1";
      const filter = localStorage.getItem("countryPersonConnectedAA");
      const display = "1";
      const displayOther = localStorage.getItem("displayOtherAA");
      const home = localStorage.getItem("homeAA");
      const hide = "0";
      const deleted = "0";
      const best = "0";
      const visible = "1";
      const approved = "1";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_PostPhotoAA}/api/postAA/new`,
      data: {
        id,
        idOwner: idPersonConnectedAA,
        idUserOwner: idUserConnectedAA,
        nameOwner: namePersonConnectedAA,
        photoOwner: photoPersonConnectedAA,
        badgeOwner: badgePersonConnectedAA,
        reaction,
        comment,
        share,
        view,
        clic,
        clicMyAccount,
        urlPhoto,
        description,
        buttonActivated,
        monetization,
        monetizationBalance,
        connection,
        type,
        filter,
        display,
        displayOther,
        home,
        hide,
        deleted,
        best,
        visible,
        approved,
      },
    })
    .then((res) => {
      console.log("a4");
      //on prend l'id du nouveau Post, on va l'ajouter au niveau du compte comme etant le dernier post
      const idNewPost = res.data._id;
      if (idNewPost) { localStorage.setItem("idNewPost", idNewPost); }

      //2e requete
      //2e requete
      // obtenir de nouvelles donnees
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
        .then((res) => {
        setApiPostAA(res.data);
        setBeforePostPhotoPageAA(false);
        setPostPhotoPageAA(false);
        setIsLoading666postPhotoPageAA(false);

        //ici on affiche le message de succes
        setPostSuccessAA(true);
        //ici on le fait disparaitre
        async function ClosePostSuccess() {
          setPostSuccessAA(false);
        }
        setTimeout(ClosePostSuccess, 1400);

      //3e requete
      //3e requete
      // on prend l'id du dernier post (pour retirer le dernier post du fil d'actualité)
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostPhotoAA}/api/accountAA`)
        .then((res) => {
          console.log("a6");
        const api = res.data;
        const filtreApiUser = api.filter((api) => api._id === idPersonConnectedAA);
        
        const lastPost = filtreApiUser.map((api) => api.lastPost); //id du dernier post
        if (lastPost) { localStorage.setItem("lastPost", lastPost); }

        const post = api.filter((api) => api._id === idPersonConnectedAA && api.lastPost === "0"); //on vérifie si sur le fil d'actualité 1 post a déjà été publié
        const verifyLastPost = post.length > 0;

        if (verifyLastPost) {
          //dans ce cas: dernier post non present sur le fil d'actualité
          console.log("a7");

          //4e requete
          //4e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function quatriemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {

          //5e requete
          //5e requete
          // obtenir de nouvelles donnees
          async function cinquiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
            .then((res) => {
              setApiPostAA(res.data);

          //6e requete
          //6e requete
          // on obtiens la localisation de l'utilisateur
          async function sixiemeReq() {
            await axios
            .get("https://ip.nf/me.json")
            .then((res) => {
              const getcountryip = res.data.ip.country; //country
              if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

              const getcityip = res.data.ip.city; //city
              if (getcityip) { localStorage.setItem("cityIp", getcityip) }

              const getuserip = res.data.ip.ip; //ip
              if (getuserip) { localStorage.setItem("addressIp", getuserip) }

          //7e requete
          //7e requete
          // on enregistre la localisation et la navigation de l'utilisateur
          async function septiemeReq() {
            const id = localStorage.getItem("createIdNavigationAA");
            const addressIp = localStorage.getItem("addressIp");
            const countryIp = localStorage.getItem("countryIp");
            const cityIp = localStorage.getItem("cityIp");
            const page = "Photo publiée! (il a réussi à publier une photo) - AA";
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/navigationAA/new`,
              data: {
                id,
                idAccount: idPersonConnectedAA,
                nameAccount: namePersonConnectedAA,
                addressIp,
                countryIp,
                cityIp,
                page,
              },
            })
            .then((res) => {
              console.log("a11");
            const online = res.data.createdAt; //on recupere la date de derniere connexion
            if (online) { localStorage.setItem("onlineAA", online) }

          //8e requete
          //8e requete
          // on enregistre la date de derniere connexion
          async function huitiemeReq() {
            const online = localStorage.getItem("onlineAA");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                online,
              },
            })
            .then((res) => {
              console.log("a12");
            })
            }
            huitiemeReq();
            //8e requete
            });
            }
            septiemeReq();
            //7e requete
            });
            }
            sixiemeReq();
            //6e requete
            })
            }
            cinquiemeReq();
            //5e requete
            })
          }
          quatriemeReq();
          //4e requete
        } else {
          //dans ce cas: dernier post present sur le fil d'actualité
          console.log("a13");

          //4e requete
          //4e requete
          // on retire le dernier post du fil d'actualité
          async function quatriemeReq() {
            const id = localStorage.getItem("lastPost");
            const home = "0";
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/postAA/update/${id}`,
              data: {
                home,
              },
            })
            .then((res) => {
              console.log("a14");

          //5e requete
          //5e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function cinquiemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {
              console.log("a15");

            //6e requete
            //6e requete
            // obtenir de nouvelles donnees
            async function sixiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
              .then((res) => {
                setApiPostAA(res.data);
              })
              .then((res) => {
                console.log("a16");
              })
              }
              sixiemeReq();
              //6e requete
              })
              }
              cinquiemeReq();
              //5e requete
              })
              }
              quatriemeReq();
              //4e requete
            }
            //if (verifyLastPost) 
            })
          }
          troisiemeReq();
          //3e requete
      })
      .catch((err) => {
        console.log("a17");

        // ici nous sommes au niveau du .catch de la deuxiemeReq()
        //la 2e requete c'est pour obtenir de nouvelles donnees, si ca rate, alors on va encore insister, on va refaire la requete pour obtenir de nouvelles donnees, ensuite on va l'afficher le message que le post avait deja ete publié
        // get
        async function get() {
          await axios
          .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
          .then((res) => {
          setApiPostAA(res.data);
          
          setBeforePostPhotoPageAA(false);
          setPostPhotoPageAA(false);
          setIsLoading666postPhotoPageAA(false);
          //ici on affiche le message de succes
          setPostSuccessAA(true);
          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessAA(false);
          }
          setTimeout(ClosePostSuccess, 1400);
        })
        .catch((err) => {
          console.log("a19");
          //si on arrive pas a obtenir tout les posts, alors on lui affiche juste le message que sa photo avait deja ete publié
          setBeforePostPhotoPageAA(false);
          setPostPhotoPageAA(false);
          setIsLoading666postPhotoPageAA(false);
          //ici on affiche le message de succes
          setPostSuccessAA(true);
          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessAA(false);
          }
          setTimeout(ClosePostSuccess, 1400);
        })
        }
        get();
        //get
      });
      }
      deuxiemeReq();
      //2e requete
      })
      .catch((err) => {
        console.log("a20");
        setErrorAA(true);
        setIsLoading666postPhotoPageAA(false);
      });
    }
    premiereReq();
    //1ere requete
    } //if (createIdPostAA)
  })
  .catch((err) => {
    console.log("a21");
    setErreur(true);
    setIsLoading666postPhotoPageAA(false);
  })
  }
  AllPostReq();
  // AllPostReq
  }//if(idPersonConnectedAA)
}


  // 2 photos - image 1
  // 2 photos - image 1
  // 2 photos - image 1
  const [deuxPhotosImage1, setDeuxPhotosImage1] = useState(true);
  const [fileDeuxPhotosImage1, setFileDeuxPhotosImage1] = useState();

  async function DeuxPhotosImage1(e) {
    setOpacity(true);
    setIsLoading(true);
    e.preventDefault();

    const data = new FormData();
    data.append("image", fileDeuxPhotosImage1);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/userAA/upload`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        //console.log(res);
        const deuxPhotosImage1 = res.data.urlPhotoProfil;

        if (deuxPhotosImage1) {
          localStorage.setItem(
            "https://alrani.com/deuxPhotosImage1",
            deuxPhotosImage1
          );
        }

        setOpacity(false);
        setIsLoading(false);
        setDeuxPhotosImage1(false);
        setDeuxPhotosImage2(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // 2 photos - image 1

  // 2 photos - image 2
  // 2 photos - image 2
  // 2 photos - image 2
  const [deuxPhotosImage2, setDeuxPhotosImage2] = useState(false);
  const [fileDeuxPhotosImage2, setFileDeuxPhotosImage2] = useState();

  async function DeuxPhotosImage2(e) {
    setOpacity(true);
    setIsLoading(true);
    e.preventDefault();

    const data = new FormData();
    data.append("image", fileDeuxPhotosImage2);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/userAA/upload`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const deuxPhotosImage2 = res.data.urlPhotoProfil;

        if (deuxPhotosImage2) {
          localStorage.setItem(
            "https://alrani.com/deuxPhotosImage2",
            deuxPhotosImage2
          );
        }
        window.location = "/deux-photos";
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // 2 photos - image 2

  // 3 photos - image 1
  // 3 photos - image 1
  // 3 photos - image 1
  const [troisPhotosImage1, setTroisPhotosImage1] = useState(true);
  const [fileTroisPhotosImage1, setFileTroisPhotosImage1] = useState();

  async function TroisPhotosImage1(e) {
    setOpacity(true);
    setIsLoading(true);
    e.preventDefault();

    const data = new FormData();
    data.append("image", fileTroisPhotosImage1);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/userAA/upload`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const troisPhotosImage1 = res.data.urlPhotoProfil;

        if (troisPhotosImage1) {
          localStorage.setItem(
            "https://alrani.com/troisPhotosImage1",
            troisPhotosImage1
          );
        }

        setOpacity(false);
        setIsLoading(false);
        setTroisPhotosImage1(false);
        setTroisPhotosImage2(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // 3 photos - image 1

  // 3 photos - image 2
  // 3 photos - image 2
  // 3 photos - image 2
  const [troisPhotosImage2, setTroisPhotosImage2] = useState(false);
  const [fileTroisPhotosImage2, setFileTroisPhotosImage2] = useState();

  async function TroisPhotosImage2(e) {
    setOpacity(true);
    setIsLoading(true);
    e.preventDefault();

    const data = new FormData();
    data.append("image", fileTroisPhotosImage2);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/userAA/upload`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const troisPhotosImage2 = res.data.urlPhotoProfil;

        if (troisPhotosImage2) {
          localStorage.setItem(
            "https://alrani.com/troisPhotosImage2",
            troisPhotosImage2
          );
        }

        setOpacity(false);
        setIsLoading(false);
        setTroisPhotosImage1(false);
        setTroisPhotosImage2(false);
        setTroisPhotosImage3(true);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // 3 photos - image 2

  // 3 photos - image 3
  // 3 photos - image 3
  // 3 photos - image 3
  const [troisPhotosImage3, setTroisPhotosImage3] = useState(false);
  const [fileTroisPhotosImage3, setFileTroisPhotosImage3] = useState();

  async function TroisPhotosImage3(e) {
    setOpacity(true);
    setIsLoading(true);
    e.preventDefault();

    const data = new FormData();
    data.append("image", fileTroisPhotosImage3);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/userAA/upload`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const troisPhotosImage3 = res.data.urlPhotoProfil;

        if (troisPhotosImage3) {
          localStorage.setItem(
            "https://alrani.com/troisPhotosImage3",
            troisPhotosImage3
          );
        }

        window.location = "/trois-photos";
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }
  // 3 photos - image 3

  
  // dans les parametres, ce sont les informations personnelles de l'utilisateur
  const genrePersonneConnecter = localStorage.getItem(
    "https://alrani.com/genrePersonneConnecter"
  );
  const agePersonneConnecter = localStorage.getItem(
    "https://alrani.com/agePersonneConnecter"
  );
  const paysPersonneConnecter = localStorage.getItem(
    "https://alrani.com/paysPersonneConnecter"
  );

  // bouton principal - page
  // ceci c'est pour afficher la page qui va permettre d'activer le bouton principal
  const [boutonPrincipal, setBoutonPrincipal] = useState(false);
  async function BoutonPrincipal() {
    setBoutonPrincipal(true);
  }
  // ceci c'est pour fermer la popup de cette page ci-dessus
  async function CloseBoutonPrincipal() {
    setBoutonPrincipal(false);
    setPlusOptions(true);
  }

  // btn desactiver
  // btn desactiver
  // btn desactiver
  // ceci c'est pour lorsqu'on clique sur le switch pour desactiver le btn EnvoyerUnMessage
  async function BoutonEnvoyerUnMessageDesactiver() {
    const btn = "0";
    localStorage.setItem("https://alrani.com/buttonActiverSurLeProfil", btn);
    setEnvoyerUnMessageError(true);

    // logique pour enregistrer le bouton activer dans la bdd
    const buttonActiver = localStorage.getItem(
      "https://alrani.com/buttonActiverSurLeProfil"
    );
    // avec cette logique on enregistre la valeur du bouton desactiver dans la bdd
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        buttonActiverSurLeProfil: buttonActiver,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour obtenir le btn qu'on a enregistrer dans la bdd
        async function deuxiemeReq() {
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              // ensuite on enregistre sa valeur dans le localStorage
              const buttonActiverSurLeProfil =
                res.data.buttonActiverSurLeProfil;
              if (buttonActiverSurLeProfil) {
                localStorage.setItem(
                  "https://alrani.com/buttonActiverSurLeProfil",
                  buttonActiverSurLeProfil
                );
              }
            })
            .catch((err) => console.log(err));
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => console.log(err));
  }

  // btn activer
  // btn activer
  // btn activer
  // ceci c'est pour lorsqu'on clique sur le switch pour activer le btn EnvoyerUnMessage
  async function BoutonEnvoyerUnMessageActiver() {
    const btn = "1";
    localStorage.setItem("https://alrani.com/buttonActiverSurLeProfil", btn);
    setEnvoyerUnMessageSuccess(true);
    // on recupere la valeur du bouton activer depuis le localStorage
    const buttonActiver = localStorage.getItem(
      "https://alrani.com/buttonActiverSurLeProfil"
    );
    // avec cette logique on enregistre la valeur du bouton activer dans la bdd
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        buttonActiverSurLeProfil: buttonActiver,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour obtenir le btn qu'on a enregistrer dans la bdd
        async function deuxiemeReq() {
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              // ensuite on enregistre sa valeur dans le localStorage
              const buttonActiverSurLeProfil =
                res.data.buttonActiverSurLeProfil;
              if (buttonActiverSurLeProfil) {
                localStorage.setItem(
                  "https://alrani.com/buttonActiverSurLeProfil",
                  buttonActiverSurLeProfil
                );
              }
            })
            .catch((err) => console.log(err));
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => console.log(err));
  }

  // ici on recupere le btn qu'on a activer
  // si buttonActiverSurLeProfil = 0, aucun btn n'est activer
  // si buttonActiverSurLeProfil = 1, le btn Envoyer un message est activer
  const buttonActiverSurLeProfil = localStorage.getItem(
    "https://alrani.com/buttonActiverSurLeProfil"
  );

  // btn activé
  // ceci va declencher un message de succès disant que le btnEnvoyerUnMessage a été activé
  const [envoyerUnMessageSuccess, setEnvoyerUnMessageSuccess] = useState(false);
  async function CloseEnvoyerUnMessageSuccess() {
    setEnvoyerUnMessageSuccess(false);
    setBoutonPrincipal(true);
  }

  // btn désactivé
  // ceci va declencher un message d'erreur disant que le btnEnvoyerUnMessage a été désactivé
  const [envoyerUnMessageError, setEnvoyerUnMessageError] = useState(false);
  async function CloseEnvoyerUnMessageError() {
    setEnvoyerUnMessageError(false);
    setBoutonPrincipal(true);
  }

  /* apres business */
  // quand on clique sur l'onglet business, cette popup va etre declencher  */
  const [business, setBusiness] = useState(false);
  async function Business() {
    setBusiness(!business);
  }
  // on affiche la liste des Pages que vous gérer
  /* const [pageGerer, setPageGerer] = useState(false);
  async function PageGerer() {
    setPageGerer(true);
  }
  async function ClosePageGerer() {
    setPageGerer(false);
    setBusiness(true);
  }*/


  // presentation
  // ici c'est pour presenter c'est quoi une Page Alrani Business
  const [presentation, setPresentation] = useState(false);
  /* async function Presentation() {
    setPresentation(true);
    localStorage.setItem("https://alrani.com/idPage", idPersonConnectedAA);
    // on enregistre le roleAdmin
    /* ca va nous servir par exemple, si le proprietaire de la page veut voir les boutons
    Approuver/Rejeter ou encore le btn Approuver la publication, ces boutons sont visible
    uniquement par l'admin suppreme(roleAdmin=2) et par le proprietaire de la page(roleAdmin=1) //
    const roleAdmin = "1";
    localStorage.setItem("https://alrani.com/roleAdmin", roleAdmin);
    /* ce postApprouverAdmin va etre utile dans le cas ou le proprietaire de la page veut
    publier une publication, la publication sera publier sans necessiter d'approbation
    car postApprouverAdmin=1, 
    (mais si postApprouverAdmin=3, là la publication va necessiter
    une approbation, ca c'est dans le cas ou c'est l'admin lombda qui publie) //
    const postApprouverAdmin = "1";
    localStorage.setItem(
      "https://alrani.com/postApprouverAdmin",
      postApprouverAdmin
    );

    // cette requete nous permet de recuperer visible, et d'enregistrer le buttonActiver
    /* visible c'est cette variable qui se trouve sur le profil de chaque utilisateur
     si visible=1, cela veut dire que la page de l'utilisateur a ete mise en avant, 
    si visible=3, cela veut dire que la page n'a pas ete mise en avant.
    le buttonActiver, on l'enregistre tout simplement pour dire que par defaut le btn
    Envoyer un message est desactiver, si le buttonActiver=0, cela veut dire que le btn
    Envoyer un message est desactiver sur le post, buttonActiver=1 cela veut dire que le
    btn Envoyer un message est activé sur le post //
    const getIdPage = localStorage.getItem("https://alrani.com/idPage");
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA/${getIdPage}`)
      .then((res) => {
        const visible = res.data.visible;
        if (visible) {
          localStorage.setItem("https://alrani.com/visible", visible);
        }

        const buttonActiver = "0";
        localStorage.setItem("https://alrani.com/buttonActiver", buttonActiver);
      });
  } */

  // ca c'est pour fermer la page presentation
  async function ClosePresentation() {
    setPresentation(false);
  }

  // avertissement
  /* ici c'est pour prevenir que s'il bascule vers un compte professionnel il ne pourra plus
  faire marche arrière */
  const [avertissement, setAvertissement] = useState(false);
  async function Avertissement() {
    setAvertissement(true);
  }
  // logique pour fermer la page Avertissement
  async function CloseAvertissement() {
    setAvertissement(false);
    setPresentation(true);
  }

  // cette logique c'est pour passer a un compte professionnel
  // on enregistre la valeur dans le localStorage
  async function Transformer() {
    setOpacity(true);
    const professionnel = "0";
    // ici on enregistre la valeur du compte professionnel dans le localStorage
    localStorage.setItem("https://alrani.com/utilisateur", professionnel);
    // on recupere la valeur qui a ete enregistrer dans le localStorage
    const getProfessionnel = localStorage.getItem(
      "https://alrani.com/utilisateur"
    );
    /* on active le btn envoyer un message parceque la personne est passer
    a un compte professionnel */
    const buttonActiver = "1";
    // on enregistre cette valeur dans la bdd
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
      data: {
        utilisateur: getProfessionnel,
        buttonActiverSurLeProfil: buttonActiver,
      },
    })
      .then((res) => {
        // 2e requete
        // cette requete c'est pour recuperer la valeur du compte professionnel depuis la bdd
        async function deuxiemeReq() {
          // ici on ferme la popup de la presentation
          setPresentation(false);
          await axios
            .get(
              `${process.env.REACT_APP_BACKEND}/api/userAA/${idPersonConnectedAA}`
            )
            .then((res) => {
              const utilisateur = res.data.utilisateur;
              if (utilisateur) {
                localStorage.setItem(
                  "https://alrani.com/utilisateur",
                  utilisateur
                );
              }

              const buttonActiverSurLeProfil =
                res.data.buttonActiverSurLeProfil;
              if (buttonActiverSurLeProfil) {
                localStorage.setItem(
                  "https://alrani.com/buttonActiverSurLeProfil",
                  buttonActiverSurLeProfil
                );
              }

              setOpacity(false);
              setAvertissement(false);
              setPresentation(true);
            })
            .catch((err) => {
              setOpacity(false);
              setAvertissement(false);
              setPresentation(true);
              setErreur(true);
            });
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setAvertissement(false);
        setPresentation(true);
        setErreur(true);
      });
    //setOpacity(false);
  }

  // ca c'est pour voir la page Alrani Business
  const [pageAlrani, setPageAlrani] = useState(false);
  async function PageAlrani() {
    setPageAlrani(true);
  }
  // ca c'est pour fermer la page Alrani Business
  /* async function ClosePageAlrani() {
    setPageAlrani(false);
    setBusiness(true);
  } */
  // ca c'est pour afficher un mini menu
  const [miniMenuPageAlrani, setMiniMenuPageAlrani] = useState(false);
  async function MiniMenuPageAlrani() {
    setMiniMenuPageAlrani(!miniMenuPageAlrani);
  }

  //saisir montant a recevoir (page) (666 MonetizationPageAA)
  //sur cette page l'utilisateur va saisir le montant a recevoir dans son moyen de paiement virtuel
  const [
    writeAmountReceivePage666MonetizationPageAA,
    setWriteAmountReceivePage666MonetizationPageAA,
  ] = useState(false);
  async function WriteAmountReceivePage666MonetizationPageAA() {
    setWriteAmountReceivePage666MonetizationPageAA(true);
  }
  //fermer
  async function CloseWriteAmountReceivePage666MonetizationPageAA() {
    setWriteAmountReceivePage666MonetizationPageAA(false);
  }

  //choisir moyen de paiement (666 MonetizationPageAA)
  //il choisit le moyen de paiement ou il veut verser son argent
  const [
    choosePaymentMethod666MonetizationPageAA,
    setChoosePaymentMethod666MonetizationPageAA,
  ] = useState(false);
  async function ChoosePaymentMethod666MonetizationPageAA() {
    setChoosePaymentMethod666MonetizationPageAA(true);
  }
  //fermer
  async function CloseChoosePaymentMethod666MonetizationPageAA() {
    setChoosePaymentMethod666MonetizationPageAA(false);
  }

  //confirmer versement (666 MonetizationPageAA)
  /* sur cette page il va confirmer s'il veut vraiment verser son argent dans son moyen de 
  paiement */
  const [
    confirmDeposit666MonetizationPageAA,
    setConfirmDeposit666MonetizationPageAA,
  ] = useState(false);
  async function ConfirmDeposit666MonetizationPageAA() {
    setConfirmDeposit666MonetizationPageAA(true);
  }
  //fermer
  async function CloseConfirmDeposit666MonetizationPageAA() {
    setConfirmDeposit666MonetizationPageAA(false);
  }

  //Statistiques de la page - AA
  //Statistiques de la page - AA
  //on affiche les Statistiques de la page - page Alrani Business
  const [statistiquePageAA, setStatistiquePageAA] = useState(false);
  /* async function StatistiquePageAA() {
    setStatistiquePageAA(true);
  } */
  //fermer
  async function CloseStatistiquePageAA() {
    setStatistiquePageAA(false);
  }

  // pour acceder a la partie Gestion de la Page
  /* const [gestionPage, setGestionPage] = useState(false);
  async function GestionPage() {
    setGestionPage(true);
  }
  // fermer Gestion de la Page
  async function CloseGestionPage() {
    setGestionPage(false);
    setMiniMenuPageAlrani(true);
  }
  // fermer uniquement Gestion de la Page
  async function JustCloseGestionPage() {
    setGestionPage(false);
  } */
  

  //on clique pour afficher le prix dans une autre monnaie
  const [autresMonnaies, setAutresMonnaies] = useState(false);
  async function AutresMonnaies() {
    setAutresMonnaies(!autresMonnaies);
  }

  // selectionnerPreference
  // selectionnerPreference
  // selectionnerPreference
  /* on va selectionner une ou plusieurs preferences, par exemple football, contenus pour 
  adultes,... */
  const [selectionnerPreference, setSelectionnerPreference] = useState(false);
  async function SelectionnerPreference() {
    setSelectionnerPreference(!selectionnerPreference);
  }
  // football
  /* quand on clique sur football, Football sera cocher */
  const [football, setFootball] = useState(false);
  async function Football() {
    setFootball(!football);
  }
  // Produits Cosmetiques
  /* quand on clique sur Produits Cosmetiques, Produits Cosmetiques sera cocher */
  const [produitsCosmetiques, setProduitsCosmetiques] = useState(false);
  async function ProduitsCosmetiques() {
    setProduitsCosmetiques(!produitsCosmetiques);
  }
  // Soins de visage
  /* quand on clique sur Soins de visage, Soins de visage sera cocher */
  const [soinsDeVisage, setSoinsDeVisage] = useState(false);
  async function SoinsDeVisage() {
    setSoinsDeVisage(!soinsDeVisage);
  }
  // MadeInAfrica
  /* quand on clique sur MadeInAfrica, MadeInAfrica sera cocher */
  const [madeInAfrica, setMadeInAfrica] = useState(false);
  async function MadeInAfrica() {
    setMadeInAfrica(!madeInAfrica);
  }

  // selectionnerPays
  // selectionnerPays
  // selectionnerPays
  /* on va selectionner un pays ou une zone, par exemple Afrique Centrale, Afrique Australe,
  Gabon, Congo,... */
  const [selectionnerPays, setSelectionnerPays] = useState(false);
  async function SelectionnerPays() {
    setSelectionnerPays(!selectionnerPays);
  }
  // Afrique Centrale
  /* quand on clique sur Afrique Centrale, Afrique Centrale sera cocher */
  const [afriqueCentralePP, setAfriqueCentralePP] = useState(false);
  async function AfriqueCentralePP() {
    setAfriqueCentralePP(!afriqueCentralePP);
  }
  // Congo
  /* quand on clique sur Congo, Congo sera cocher */
  const [congoPP, setCongoPP] = useState(false);
  async function CongoPP() {
    setCongoPP(!congoPP);
  }
  // Gabon
  /* quand on clique sur Gabon, Gabon sera cocher */
  const [gabonPP, setGabonPP] = useState(false);
  async function GabonPP() {
    setGabonPP(!gabonPP);
  }
  // Afrique Australe
  /* quand on clique sur MadeInAfrica, MadeInAfrica sera cocher */
  const [afriqueAustralePP, setAfriqueAustralePP] = useState(false);
  async function AfriqueAustralePP() {
    setAfriqueAustralePP(!afriqueAustralePP);
  }
  // Afrique du Sud
  /* quand on clique sur AfriqueDuSud, AfriqueDuSud sera cocher */
  const [afriqueDuSudPP, setAfriqueDuSudPP] = useState(false);
  async function AfriqueDuSudPP() {
    setAfriqueDuSudPP(!afriqueDuSudPP);
  }
  // Eswatini
  /* quand on clique sur Eswatini, Eswatini sera cocher */
  const [eswatiniPP, setEswatiniPP] = useState(false);
  async function EswatiniPP() {
    setEswatiniPP(!eswatiniPP);
  }

  // selectionnerAge
  // selectionnerAge
  // selectionnerAge
  // on va selectionner la tranche d'age, par exemple 10-20 ans, 20-30 ans, ...
  const [selectionnerAge, setSelectionnerAge] = useState(false);
  async function SelectionnerAge() {
    setSelectionnerAge(!selectionnerAge);
  }
  // moins de 10 ans
  /* quand on clique sur moins de 10 ans, moins de 10 ans sera cocher */
  const [dixMoins, setDixMoins] = useState(false);
  async function DixMoins() {
    setDixMoins(!dixMoins);
  }
  // 10 - 20 ans
  /* quand on clique sur 10 - 20 ans, 10 - 20 ans sera cocher */
  const [dixVingt, setDixVingt] = useState(false);
  async function DixVingt() {
    setDixVingt(!dixVingt);
  }
  // 20 - 30 ans
  /* quand on clique sur 20 - 30 ans, 20 - 30 ans sera cocher */
  const [vingtTrente, setVingtTrente] = useState(false);
  async function VingtTrente() {
    setVingtTrente(!vingtTrente);
  }
  // 30 - 40 ans
  /* quand on clique sur 30 - 40 ans, 30 - 40 ans sera cocher */
  const [trenteQuarante, setTrenteQuarante] = useState(false);
  async function TrenteQuarante() {
    setTrenteQuarante(!trenteQuarante);
  }
  // 40 - 50 ans
  /* quand on clique sur 40 - 50 ans, 40 - 50 ans sera cocher */
  const [quaranteCinquante, setQuaranteCinquante] = useState(false);
  async function QuaranteCinquante() {
    setQuaranteCinquante(!quaranteCinquante);
  }
  // 50 - 60 ans
  /* quand on clique sur 50 - 60 ans, 50 - 60 ans sera cocher */
  const [cinquanteSoixante, setCinquanteSoixante] = useState(false);
  async function CinquanteSoixante() {
    setCinquanteSoixante(!cinquanteSoixante);
  }
  // plus de 60 ans
  /* quand on clique sur plus de 60 ans, plus de 60 ans sera cocher */
  const [soixantePlus, setSoixantePlus] = useState(false);
  async function SoixantePlus() {
    setSoixantePlus(!soixantePlus);
  }

  // selectionnerSexe
  // selectionnerSexe
  // on va selectionner le sexe, par exemple: masculin, feminin ou Trans
  const [selectionnerSexe, setSelectionnerSexe] = useState(false);
  async function SelectionnerSexe() {
    setSelectionnerSexe(!selectionnerSexe);
  }
  // masculin
  /* quand on clique sur masculin, masculin sera cocher */
  const [masculinPP, setMasculinPP] = useState(false);
  async function MasculinPP() {
    setMasculinPP(!masculinPP);
  }
  // feminin
  /* quand on clique sur feminin, feminin sera cocher */
  const [femininPP, setFemininPP] = useState(false);
  async function FemininPP() {
    setFemininPP(!femininPP);
  }
  // trans
  /* quand on clique sur trans, trans sera cocher */
  /* transPP veut dire Trans au niveau de Personnaliser Publiciter oubien ca veut dire Trans 
  au niveau de Booster la page - page */
  const [transPP, setTransPP] = useState(false);
  async function TransPP() {
    setTransPP(!transPP);
  }
 
  // PP veut dire Personnaliser Publiciter
  /* quand on clique, la page qui va permettre de selectionner un moyen de paiement va 
  s'afficher(c'est au niveau de booster la page - PP) */
  //la page en question c'est un bottom
  const [selectionnerMoyenDePaiement, setSelectionnerMoyenDePaiement] =
    useState(false);
  async function SelectionnerMoyenDePaiement() {
    setSelectionnerMoyenDePaiement(!selectionnerMoyenDePaiement);
  }
  // izocash
  // izocash
  /* quand on clique sur izocash, le moyen de paiement izocash sur laquelle on a cliquer 
  sera active avec la couleur jaune */
  const [izocash, setIzocash] = useState(false);
  async function Izocash() {
    setIzocash(true);
    setBonsDachatsZimagic(false);
    /* si dans le localStorage izocash=1, cela veut dire que izocash sera active 
    comme on a fait avec les themes. si izocash=0, alors izocash ne sera pas active */
    const moyenDePaiementIzocash = "1";
    localStorage.setItem("https://alrani.com/izocash", moyenDePaiementIzocash);
    /* ca se sont les autres moyens de paiements, quand on clique on doit les mettre a 0 pour 
    qu'ils ne soient pas active */
    const moyenDePaiementNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/bonsDachatsZimagic",
      moyenDePaiementNonActive
    );
  }
  // Bons d'achats Zimagic
  // Bons d'achats Zimagic
  /* quand on clique sur BonsDachatsZimagic, le moyen de paiement BonsDachatsZimagic sur 
  laquelle on a cliquer sera active avec la couleur jaune */
  const [bonsDachatsZimagic, setBonsDachatsZimagic] = useState(false);
  async function BonsDachatsZimagic() {
    setBonsDachatsZimagic(true);
    setIzocash(false);
    /* si dans le localStorage bonsDachatsZimagic=1, cela veut dire que bonsDachatsZimagic sera 
    active comme on a fait avec les themes. 
    si bonsDachatsZimagic=0, alors bonsDachatsZimagic ne sera pas active */
    const moyenDePaiementBonsDachatsZimagic = "1";
    localStorage.setItem(
      "https://alrani.com/bonsDachatsZimagic",
      moyenDePaiementBonsDachatsZimagic
    );
    /* ca se sont les autres moyens de paiements, quand on clique on doit les mettre a 0 pour 
    qu'ils ne soient pas active */
    const moyenDePaiementNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/izocash",
      moyenDePaiementNonActive
    );
  }

  const moyenDePaiementIzocash = localStorage.getItem(
    "https://alrani.com/izocash"
  );
  const moyenDePaiementBonsDachatsZimagic = localStorage.getItem(
    "https://alrani.com/bonsDachatsZimagic"
  );



  // infos de la personne connecter - IA
  const idPersonConnectedIA = localStorage.getItem("idPersonConnectedIA");


  // dans l'app Izocash, quand on clique sur les 3 points, une PopupToRight va s'afficher
  const [popupToRightIA, setPopupToRightIA] = useState(false);
  async function PopupToRightIA() {
    setPopupToRightIA(!popupToRightIA);
  }

  // settingsIA (parametres de l'application izocash )
  const [settingsIA, setSettingsIA] = useState(false);
  async function SettingsIA() {
    setSettingsIA(true);
  }
  async function CloseSettingsIA() { //fermer
    setSettingsIA(false);
  }

  
  // Les Affaires (page) - IA
  // sur cette page on presente les differentes disponible gratuitement dans l'app izocash
  const [affairsPageIA, setAffairsPageIA] = useState(false);
  async function AffairsPageIA() {
    setAffairsPageIA(true);
  }
  async function CloseAffairsPageIA() { //fermer
    setAffairsPageIA(false);
  }

  // page d'activation de izocash Deals - IA
  const [izocashDealsActivationPageIA, setIzocashDealsActivationPageIA] = useState(false);
  async function IzocashDealsActivationPageIA() {
    setIzocashDealsActivationPageIA(true);
  }
  async function CloseIzocashDealsActivationPageIA() { //fermer
    setIzocashDealsActivationPageIA(false);
  }

  //logique pour activer izocash Deals - IA
  async function IzocashDealsActivationIA() {
    
    //1ere requete
    //1ere requete
    async function premiereReq() {
      setOpacity(true);
      const izocashDealsActive = "1";
      const izocashDealsBalance = "0";
      const izocashDealsCommission = "27";
      const izocashDealsVerificationCode = "1";
      const connection = "1";
      const display = "1";
      const visible = "1";
      const type = "1";

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/toolIA/activate`,
        data: {
          idAccount: idPersonConnectedIA,
          nameAccount: namePersonConnectedIA,
          izocashDealsActive,
          izocashDealsBalance,
          izocashDealsCommission,
          izocashDealsVerificationCode,
          connection,
          display,
          visible,
          type,
        },
      })
      .then((res) => {
        setOpacity(false);
        
        //on enregistre les nouvelles donnees pour debloquer l'access a izocash Deals
        const izocashDealsActive = res.data.izocashDealsActive; 
        if (izocashDealsActive) { localStorage.setItem("izocashDealsActiveIA", izocashDealsActive) }

        const izocashDealsBalance = res.data.izocashDealsBalance; 
        if (izocashDealsBalance) { localStorage.setItem("izocashDealsBalanceIA", izocashDealsBalance) }

      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      })
    }
    premiereReq();
    //1ere requete
  }


  // infos de la personne connecter - IA

  const nomMerePersonneConnecterIA = localStorage.getItem(
    "https://alrani.com/nomMerePersonneConnecterIA"
  );
  const dateNaissancePersonneConnecterIA = localStorage.getItem(
    "https://alrani.com/dateNaissancePersonneConnecterIA"
  );
  const adressePersonneConnecterIA = localStorage.getItem(
    "https://alrani.com/adressePersonneConnecterIA"
  );
  const sexePersonneConnecterIA = localStorage.getItem(
    "https://alrani.com/editMasculinIA"
  );
  const numeroTelephonePersonneConnecterIA = localStorage.getItem(
    "https://alrani.com/numeroTelephonePersonneConnecterIA"
  );
  const photoProfilPersonneConnecterIA = localStorage.getItem(
    "https://alrani.com/photoProfilPersonneConnecterIA"
  );

 

  // recharge error (si la recharge a echouer) - IA
  const [rechargeErrorIA, setRechargeErrorIA] = useState(false);
  async function CloseRechargeErrorIA() {
    setRechargeErrorIA(false);
  }


  // recharge national (Page) - IA
  // recharge national (Page) - IA
  const [rechargeNationalPageIA, setRechargeNationalPageIA] = useState(false);
  async function RechargeNationalPageIA() {
    setRechargeNationalPageIA(true);
  }
  async function CloseRechargeNationalPageIA() { //fermer
    setRechargeNationalPageIA(false);
  }

  // recharge national success - IA
  // ca c'est le recu (on l'affiche une fois que le recharge national a reussi)
  const [rechargeNationalSuccessIA, setRechargeNationalSuccessIA] = useState(false);
  /*async function RechargeNationalSuccessIA() {
    setRechargeNationalSuccessIA(true);
  }*/
  async function CloseRechargeNationalSuccessIA() { //fermer
    setRechargeNationalSuccessIA(false);
  }

  // recharge national success 2 - IA
  const [rechargeNationalSuccess2IA, setRechargeNationalSuccess2IA] = useState(false);
  async function CloseRechargeNationalSuccess2IA() {
    setRechargeNationalSuccess2IA(false);
  }

   // logique pour faire une recharge national (il s'agit de recharger le Stock National du Client) - IA
   async function RechargeNationalIA() {
    setOpacity(true);

    //1ere requete
    //1ere requete
    // obtenir id du compte izocash (Avec cet id on va recharger le Stock National du Client)
    async function premiereReq() {
      const writeAmount = localStorage.getItem("writeAmount");
      const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
      .then((res) => {
        // on filtre en fonction du numero virtuel saisi - IA
        const apiAccount = res.data;
        const filterAccount = apiAccount.filter((api) => api.virtualNumber === writeVirtualNumber);

        const idAccount = filterAccount.map((api) => api._id); // idAccount
        if (idAccount) { localStorage.setItem("idAccount", idAccount); }

        const nameAccount = filterAccount.map((api) => api.nameAccount); // nameAccount
        if (nameAccount) { localStorage.setItem("nameAccount", nameAccount); }

        const oldStockNational = filterAccount.map((api) => api.stockNational); // ancien stock National
        if (oldStockNational) { localStorage.setItem("oldStockNational", oldStockNational); }
        
        // calcul du nouveau stock national
        const increase = parseInt(writeAmount) * 11 / 100; // ajout de l'augmentation (on ajoute une augmentation, ca va lui permettre d'avoir un benefice lorsqu'il va revendre)
        const newStockNational = parseInt(oldStockNational) + parseInt(increase)
        if (newStockNational) { localStorage.setItem("newStockNational", newStockNational); }

        console.log("api/accountIA/create");
        console.log(oldStockNational, "ancien stock National");
        console.log(increase, "augmentation");
        console.log(newStockNational, "nouveau stock national");

        //filtre pour obtenir l'ancien stock du Point Retrait (il s'agit du Point Retrait qui fait la recharge)
        const filterPoint = apiAccount.filter((api) => api._id === idPersonConnectedIA);
        const oldStock = filterPoint.map((api) => api.stockNational); // stock national
        if (oldStock) { localStorage.setItem("oldStock", oldStock); }

        // new stock
        const newStock = parseInt(oldStock) - parseInt(writeAmount);
        if (newStock) { localStorage.setItem("newStock", newStock) }
        console.log(newStock, "new stock");

      if (newStock > -1) {

      //2e requete
      //2e requete
      // debiter le stock (nouveau stock du point retrait)
      async function deuxiemeReq() {
        const newStock = localStorage.getItem("newStock");
        await axios({ 
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
          data: {
            stockNational: newStock,
          },
        })
        .then((res) => {

      //3e requete
      //3e requete
      // on recharge le stock dans le compte du client
      async function troisiemeReq() {
        const idAccount = localStorage.getItem("idAccount");
        const newStockNational = localStorage.getItem("newStockNational");

        await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idAccount}`,
        data: {
          stockNational: newStockNational,
        },
      })
      .then((res) => {
        
      //4e requete
      //4e requete
      // recharge reussie alors on l'envoie la notification pour qu'il sache qu'il a recharger le Stock National du client
      async function quatriemeReq() {
        const notification = "9"; // recharge national reussie
        const idAccount = localStorage.getItem("idAccount");
        const nameAccount = localStorage.getItem("nameAccount");
        const oldStockOwner = localStorage.getItem("oldStock"); //owner
        const newStockOwner = localStorage.getItem("newStock");
        const newStockOther = localStorage.getItem("newStockNational"); //other
        const oldStockOther = localStorage.getItem("oldStockNational");
        const commission = "7000";
        const price = "75000";
        const amount = "75000";
        const visible = "1";
        const connection = "1";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
          data: {
            notification: notification,
            virtualNumber: writeVirtualNumber,
            nameOwnerVirtualNumber: writeNameOwnerIA,
            idOwner: idPersonConnectedIA, //owner
            nameOwner: namePersonConnectedIA,
            oldStockOwner,
            newStockOwner,
            idOther: idAccount, //other
            nameOther: nameAccount,
            oldStockOther,
            newStockOther,
            commission,
            price,
            amount,
            visible,
            connection,
          },
        }).then((res) => {
          // on recupere ces elements ci-dessous car on va afficher ca sur le recu apres qu'il ait delivrer le numero virtuel
          const idNotification = res.data._id; //id
          if (idNotification) { localStorage.setItem("idNotification", idNotification) }

          const date = res.data.createdAt; //date
          if (date) { localStorage.setItem("date", date) }

          const nameOwner = res.data.nameOwner; //nameOwner (nom de celui qui initie la notification, dans ce cas c'est le Point Retrait qui initie la notification)
          if (nameOwner) { localStorage.setItem("nameOwner", nameOwner) }

          const virtualNumber = res.data.virtualNumber; //virtualNumber (numero virtuel)
          if (virtualNumber) { localStorage.setItem("virtualNumber", virtualNumber) }

          const nameOwnerVirtualNumber = res.data.nameOwnerVirtualNumber; //nameOwnerVirtualNumber (nom du proprietaire)
          if (nameOwnerVirtualNumber) { localStorage.setItem("nameOwnerVirtualNumber", nameOwnerVirtualNumber) }

          const price = res.data.price; //price (prix du numero virtuel)
          if (price) { localStorage.setItem("price", price) }

          const amount = res.data.amount; //amount (montant a payer)
          if (amount) { localStorage.setItem("amount", amount) }

       //5e requete
       //5e requete
       // obtenir les nouvelles donnees
       async function cinquiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/notificationIA/`)
        .then((res) => {
          setApiNotificationIA(res.data);

          setRechargeNationalSuccessIA(true); // recharge reussie, on affiche un message de success
          setRechargeNationalSuccess2IA(true);
          setOpacity(false);

        //6e requete
        //6e requete
        // obtenir les nouvelles donnees (on le fait pour pouvoir l'afficher le nouveau stock national)
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
          .then((res) => {
            // on filtre en fonction de l'idPersonConnectedIA
            const api = res.data;
            const filterAccount = api.filter((api) => api._id === idPersonConnectedIA);

            const stockNational = filterAccount.map((api) => api.stockNational); // stockNational
            if (stockNational) { localStorage.setItem("stockNationalIA", stockNational); }
            })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        sixiemeReq();
        //6e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true); 
      });
      }
      cinquiemeReq()
      //5e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); 
    });
    }
    quatriemeReq()
    //4e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true); // erreur, impossible de recharger le stock national
        });
      }
      troisiemeReq();
      //3e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true); 
      });
     }
     deuxiemeReq();
     //2e requete
    } else {
      //dans ce cas: Stock insuffisant (impossible de recharger le stock du client)
      setStockErrorIA(true);
      setOpacity(false);
      console.log("Stock insuffisant, veuillez recharger votre Stock National");
    } //if (newStock > -1) se ferme ici
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); // erreur, impossible d'obtenir l'id du compte. 
    });
  }
  premiereReq();
  // 1ere requete
 }


  // versement national (Page) - IA
  // versement national (Page) - IA
  const [depositNationalPageIA, setDepositNationalPageIA] = useState(false);
  async function DepositNationalPageIA() {
    setDepositNationalPageIA(true);
  }
  async function CloseDepositNationalPageIA() { //fermer
    setDepositNationalPageIA(false);
  }

  // deposit national success - IA
  // ca c'est le recu (on l'affiche une fois que le versement a reussi)
  const [depositNationalSuccessIA, setDepositNationalSuccessIA] = useState(false);
  async function DepositNationalSuccessIA() {
    setDepositNationalSuccessIA(true);

    // recovery - on prend prend tout ce qui est dans recuperation et on le met dans normal 
    // 1er on prend tout ce qui est dans recuperation
    const idNotification = localStorage.getItem("idNotification000");
    const date = localStorage.getItem("date000");
    const amount = localStorage.getItem("amount000");
    const price = localStorage.getItem("price000");
    const total = localStorage.getItem("total000");
    const fees = localStorage.getItem("fees000");
    const nameOwner = localStorage.getItem("nameOwner000");
    const nameOther = localStorage.getItem("nameOther000");
    const virtualNumber = localStorage.getItem("virtualNumber000");
    const phoneNumber = localStorage.getItem("phoneNumber000");
    const nameOwnerVirtualNumber = localStorage.getItem("nameOwnerVirtualNumber000");

    // 2e on le met dans normal
    localStorage.setItem("idNotification", idNotification);
    localStorage.setItem("date", date);
    localStorage.setItem("amount", amount);
    localStorage.setItem("price", price);
    localStorage.setItem("total", total);
    localStorage.setItem("fees", fees);
    localStorage.setItem("nameOwner", nameOwner);
    localStorage.setItem("nameOther", nameOther);
    localStorage.setItem("virtualNumber", virtualNumber);
    localStorage.setItem("phoneNumber", phoneNumber);
    localStorage.setItem("nameOwnerVirtualNumber", nameOwnerVirtualNumber);
  }
  async function CloseDepositNationalSuccessIA() { //fermer
    setDepositNationalSuccessIA(false);
  }

  // deposit national success 2 - IA
  const [depositNationalSuccess2IA, setDepositNationalSuccess2IA] = useState(false);
  async function CloseDepositNationalSuccess2IA() {
    setDepositNationalSuccess2IA(false);
  }
  

  // logique pour faire un versement national - IA
  async function DepositNationalIA() {
    setOpacity(true);

    // 1ere requete
    // 1ere requete
    // obtenir id du compte izocash (Avec cet id on fera le versement au client)
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
       .then((res) => {
        const writeAmount = localStorage.getItem("writeAmount");
        const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");

        // filtre Client
        const apiAccount = res.data;
        const filterClient = apiAccount.filter((api) => api.virtualNumber === writeVirtualNumber);

        const idAccount = filterClient.map((api) => api._id); // idAccount
        if (idAccount) { localStorage.setItem("idAccount", idAccount); }

        const nameAccount = filterClient.map((api) => api.nameAccount); // nameAccount
        if (nameAccount) { localStorage.setItem("nameAccount", nameAccount); }

        const oldBalanceNational = filterClient.map((api) => api.balanceNationalAccount); // ancien solde National
        if (oldBalanceNational) { localStorage.setItem("oldBalanceNational", oldBalanceNational); }
        
        // calcul du nouveau solde national
        const newBalanceNational = parseInt(oldBalanceNational) + parseInt(writeAmount)
        if (newBalanceNational) { localStorage.setItem("newBalanceNational", newBalanceNational); }


        //filtre Point Retrait
        const filterPoint = apiAccount.filter((api) => api._id === idPersonConnectedIA);

        const phoneNumber = filterPoint.map((api) => api.phoneNumber); // phone number
        if (phoneNumber) { localStorage.setItem("phoneNumber", phoneNumber) }

        const depositNationalStock = filterPoint.map((api) => api.depositNationalStock); // depositNationalStock (pourcentage du stock necessaire, c'est le stock necessaire qu'il doit avoir dans son compte pour faire un versement national)
        if (depositNationalStock) { localStorage.setItem("depositNationalStock", depositNationalStock) }

        const depositNationalCommission = filterPoint.map((api) => api.depositNationalCommission); // depositNationalCommission (pourcentage de la commission, c'est ca commission qu'il gagne sur chaque versement national)
        if (depositNationalCommission) { localStorage.setItem("depositNationalCommission", depositNationalCommission) }

        // ancien stock national
        const stock = filterPoint.map((api) => api.stockNational);
        if (stock) { localStorage.setItem("oldStock", stock) }
        
        const oldStock = localStorage.getItem("oldStock");

        // calcul des frais
        const fees = parseInt(writeAmount) * 40 / 100;
        if (fees) { localStorage.setItem("fees", fees) }

        // calcul du montant a payer
        const total = parseInt(writeAmount) + parseInt(fees);
        if (total) { localStorage.setItem("total", total) }
        
        // calcul de la commission
        const calculDepositNationalCommission = parseInt(total) * parseInt(depositNationalCommission) / 100;
        if (calculDepositNationalCommission) { localStorage.setItem("calculDepositNationalCommission", calculDepositNationalCommission) }

        // calcul du stock necessaire
        const calculDepositNationalStock = parseInt(total) * parseInt(depositNationalStock) / 100;
        if (calculDepositNationalStock) { localStorage.setItem("calculDepositNationalStock", calculDepositNationalStock) }
        
        // calcul du nouveau stock
        const newStock = parseInt(oldStock) - parseInt(calculDepositNationalStock);
        if (newStock) { localStorage.setItem("newStock", newStock) }

      if (newStock > -1) {
        //dans ce cas: Stock suffisant (vous pouvez deposer de l'argent dans le compte du client)
      
      //2e requete
      //2e requete
      // debiter le stock (nouveau stock du point retrait)
      async function deuxiemeReq() {
        const newStock = localStorage.getItem("newStock");
        await axios({ 
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
          data: {
            stockNational: newStock,
          },
        })
        .then((res) => {
        
      //3e requete
      //3e requete
      // on depose de l'argent dans le compte national du client
      async function troisiemeReq() {
        const idAccount = localStorage.getItem("idAccount");
        const newBalanceNational = localStorage.getItem("newBalanceNational");
        
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idAccount}`,
          data: {
            balanceNationalAccount: newBalanceNational,
          },
        })
        .then((res) => {

      //4e requete
      //4e requete
      // argent deposer alors on l'envoie la notification pour qu'il sache qu'il a fait un depot dans le compte du client
      async function quatriemeReq() {
        const notification = "6"; // versement national reussie
        const percentageStockRequired = localStorage.getItem("depositNationalStock");
        const percentageCommission = localStorage.getItem("depositNationalCommission");
        const phoneNumberOwner = localStorage.getItem("phoneNumber");
        const fees = localStorage.getItem("fees");
        const amount = localStorage.getItem("writeAmount");
        const total = localStorage.getItem("total");
        const oldStockOwner = localStorage.getItem("oldStock");
        const commission = localStorage.getItem("calculDepositNationalCommission");
        const stockRequired = localStorage.getItem("calculDepositNationalStock");
        const newStockOwner = localStorage.getItem("newStock");
        const idOther = localStorage.getItem("idAccount");
        const nameOther = localStorage.getItem("nameAccount");
        const oldBalanceOther = localStorage.getItem("oldBalanceNational");
        const newBalanceOther = localStorage.getItem("newBalanceNational");
        const display = "1";
        const visible = "1";
        const connection = "1";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
          data: {
            notification: notification,
            idOwner: idPersonConnectedIA,
            nameOwner: namePersonConnectedIA,
            phoneNumberOwner,
            percentageStockRequired, //pourcentage du stock requis
            percentageCommission, //pourcentage des commissions (versement national)
            fees, // frais
            amount, // montant a deposer
            total, // montant a payer
            oldStockOwner, //ancien stock
            commission, //commission
            stockRequired, //stock necessaire
            newStockOwner,
            idOther,
            nameOther,
            oldBalanceOther,
            newBalanceOther,
            display,
            visible,
            connection,
          },
        }).then((res) => {
          // on recupere ces elements ci-dessous car on va afficher ca sur le recu apres qu'il ait effectuer le versement national
          const idNotification = res.data._id; //id
          if (idNotification) { localStorage.setItem("idNotification", idNotification) }

          const phoneNumber = res.data.phoneNumberOwner; //phoneNumber
          if (phoneNumber) { localStorage.setItem("phoneNumber", phoneNumber) }

          const date = res.data.createdAt; //date
          if (date) { localStorage.setItem("date", date) }

          const nameOwner = res.data.nameOwner; //nameOwner (nom de celui qui initie la notification, dans ce cas c'est le Point Retrait qui initie la notification)
          if (nameOwner) { localStorage.setItem("nameOwner", nameOwner) }

          const nameOther = res.data.nameOther; //nameOther (nom du client qui a deposer l'argent)
          if (nameOther) { localStorage.setItem("nameOther", nameOther) }

          const amount = res.data.amount; //amount (montant a deposer)
          if (amount) { localStorage.setItem("amount", amount) }

          const fees = res.data.fees; //fees (frais de versement)
          if (fees) { localStorage.setItem("fees", fees) }

          const total = res.data.total; //total (montant a payer)
          if (total) { localStorage.setItem("total", total) }



        //5e requete
        //5e requete
        // obtenir les nouvelles donnees
        async function cinquiemeReq() {
         await axios
         .get(`${process.env.REACT_APP_BACKEND}/api/notificationIA`)
         .then((res) => {
          setApiNotificationIA(res.data);

          setDepositNationalSuccessIA(true);
          setOpacity(false);

        //6e requete
        //6e requete
        // obtenir les nouvelles donnees (on le fait pour pouvoir lui afficher le nouveau stock national)
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
          .then((res) => {
            // on filtre en fonction de l'idPersonConnectedIA
            const api = res.data;
            const filterAccount = api.filter((api) => api._id === idPersonConnectedIA);

            const stockNational = filterAccount.map((api) => api.stockNational); // stockNational
            if (stockNational) { localStorage.setItem("stockNationalIA", stockNational); }
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        sixiemeReq()
        //6e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true); 
      });
      }
      cinquiemeReq()
      //5e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); 
    });
    }
    quatriemeReq()
    //4e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true); 
        });
        }
        troisiemeReq();
        //3e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true); 
      });
      }
      deuxiemeReq();
      //2e requete
      } else {
        //dans ce cas: Stock insuffisant (impossible de faire le versement au client)
        setStockErrorIA(true);
        setOpacity(false);
      } //if (newStock > -1) se ferme ici
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); // erreur, impossible d'obtenir l'id du compte. 
    });
  }
  premiereReq();
  //1ere requete
  }

  
  // requete pour obtenir toutes les langues - IA
  const [apiLanguageIA, setApiLanguageIA] = useState([]);

  // langue selectionner (666 points retraits)
  const languageIA2 = localStorage.getItem("language");
  const idLanguageIA2 = localStorage.getItem("idLanguage");
  const languageInEnglishIA = localStorage.getItem("languageInEnglish"); //language in english


  // requete pour obtenir tout les pays - IA
  const [apiCountryIA, setApiCountryIA] = useState([]);

  // pays selectionner (666 points retraits)
  const countryIA2 = localStorage.getItem("country");
  const idCountryIA2 = localStorage.getItem("idCountry");
  // afficher les pays en fonction de la langue
  const filterCountryIA = apiCountryIA.filter((api) => api.idLanguage === idLanguageIA2);


  // requete pour afficher toutes les villes - IA
  const [apiCityIA, setApiCityIA] = useState([]);
 

  // ville selectionner (666 points retraits)
  const cityIA2 = localStorage.getItem("city");
  const idCityIA2 = localStorage.getItem("idCity");
  // afficher les villes en fonction du pays
  const filterCityIA = apiCityIA.filter((api) => api.idCountry === idCountryIA2);


  // requete pour afficher tout les quartiers - IA
  const [apiQuarterIA, setApiQuarterIA] = useState([]);

  // quartier selectionner (666 points retraits)
  const quarterIA2 = localStorage.getItem("quarter");
  const idQuarterIA2 = localStorage.getItem("idQuarter");
  // afficher les quartiers en fonction de la ville
  const filterQuarterIA = apiQuarterIA.filter((api) => api.idCity === idCityIA2);


  // requete pour afficher toutes les zones - IA

  // zone selectionner (666 points retraits)
  // afficher les zones en fonction du quartiers
  const filterZoneIA = apiQuarterIA.filter((api) => api.idQuarter === idQuarterIA2);


  // requete pour obtenir toutes les infos à valider - IA
  const [apiInfosValidateIA, setApiInfosValidateIA] = useState([]);

  // on veut afficher les infos de verification de son entreprise qu'il a envoyer
  const infosSendIA = apiInfosValidateIA.filter((api) => api.idAccount === idPersonConnectedIA);
  const nameSendIA = infosSendIA.map((api) => api.name); //name
  const domainSendIA = infosSendIA.map((api) => api.domain); //domain
  const phoneNumberSendIA = infosSendIA.map((api) => api.phoneNumber); //phoneNumber
  const addressSendIA = infosSendIA.map((api) => api.address); //address
  const countrySendIA = infosSendIA.map((api) => api.country); //country
  const citySendIA = infosSendIA.map((api) => api.city); //city
  const quarterSendIA = infosSendIA.map((api) => api.quarter); //quarter
  const zoneSendIA = infosSendIA.map((api) => api.zone); //zone
  const busStopSendIA = infosSendIA.map((api) => api.busStop); //busStop
  const photoSendIA = infosSendIA.map((api) => api.photo); //photo
  if (photoSendIA) { localStorage.setItem("seePhoto", photoSendIA) }

  // 1ere verification (la 1ere verification ont verifie juste s'il a envoyer les infos de verification, s'il a envoyer on passe a la 2e verification)
  const verifyInfosSend1IA = infosSendIA.length > 0;

  // 2e verification (dans la 2e verification on veut juste dire que tu m'affiches le card uniquement s'il y'a les infos, tu m'affiches pas l'icone imageIndisponible mais tu vas juste m'afficher l'image lorsqu'il l'enverra)
  const ifInfosSendIA = infosSendIA.filter((api) => api.name === "0");  // verifier s'il y'a des infos envoyer
  const verifyInfosSendIA = ifInfosSendIA.length > 0;
  
  const ifPhotoSendIA = infosSendIA.filter((api) => api.photo === "0");  // verifier s'il y'a une photo envoyer
  const verifyPhotoSendIA = ifPhotoSendIA.length > 0;


  // requete pour obtenir tout les points retraits- IA
  const [apiWithdrawalPointIA, setApiWithdrawalPointIA] = useState([]);
  if (verifyPhotoSendIA === "3") {
	  console.log("setApiCityIA", setApiCityIA);
	  console.log("setApiQuarterIA", setApiQuarterIA);
	  console.log("setApiWithdrawalPointIA", setApiWithdrawalPointIA);
	  console.log("setApiNavigationAA", setApiNavigationAA);
	  console.log("setApiLanguageIA", setApiLanguageIA);
	  console.log("setApiCountryIA", setApiCountryIA); }

  //on affiche les Points Retraits qui ont visible=1
  const filterWithdrawalPointIA = apiWithdrawalPointIA.filter((api) => api.visible === "1");
  
  
  // on veut afficher les informations du futur Point Retrait
  const idPointIA = localStorage.getItem("id")
  const filterPointIA = apiWithdrawalPointIA.filter((api) => api._id === idPointIA);

  const nameIA = filterPointIA.map((api) => api.name); //name
  const photoIA = filterPointIA.map((api) => api.photo); //photo
  const countryIA = filterPointIA.map((api) => api.country); //country
  const cityIA = filterPointIA.map((api) => api.city); //city
  const quarterIA = filterPointIA.map((api) => api.quarter); //quarter
  const addressIA = filterPointIA.map((api) => api.address); //address
  const virtualNumberIA2 = filterPointIA.map((api) => api.virtualNumber); //virtualNumber
  const phoneNumberIA2 = filterPointIA.map((api) => api.phoneNumber); //phoneNumber

  // points retraits izocash (sur cette page on affiche tout les points retraits) - IA
  const [withdrawalPointIA, setWithdrawalPointIA] = useState(false);
  async function WithdrawalPointIA() {
    setWithdrawalPointIA(true);
  }
  async function CloseWithdrawalPointIA() { //fermer
    setWithdrawalPointIA(false);
  }


  
  // language - on affiche la liste des langues
  const [language666WithdrawalPointIA, setLanguage666WithdrawalPointIA] = useState(false);
  async function Language666WithdrawalPointIA() {
    setLanguage666WithdrawalPointIA(true);
    setCountry666WithdrawalPointIA(false);
    setCity666WithdrawalPointIA(false);
    setQuarter666WithdrawalPointIA(false);
  }

  // country - on affiche la liste des pays
  const [country666WithdrawalPointIA, setCountry666WithdrawalPointIA] = useState(false);
  async function Country666WithdrawalPointIA() {
    setCountry666WithdrawalPointIA(true);
    setLanguage666WithdrawalPointIA(false);
    setCity666WithdrawalPointIA(false);
    setQuarter666WithdrawalPointIA(false);
  }

  // city - on affiche la liste des villes 
  const [city666WithdrawalPointIA, setCity666WithdrawalPointIA] = useState(false);
  async function City666WithdrawalPointIA() {
    setCity666WithdrawalPointIA(true);
    setLanguage666WithdrawalPointIA(false);
    setCountry666WithdrawalPointIA(false);
    setQuarter666WithdrawalPointIA(false);
  }

  // quarter - on affiche la liste des quartiers 
  const [quarter666WithdrawalPointIA, setQuarter666WithdrawalPointIA] = useState(false);
  async function Quarter666WithdrawalPointIA() {
    setQuarter666WithdrawalPointIA(true);
    setLanguage666WithdrawalPointIA(false);
    setCountry666WithdrawalPointIA(false);
    setCity666WithdrawalPointIA(false);
  }
  

  // voir la photo du point retrait - IA
  const [seePhoto666WithdrawalPointIA, setSeePhoto666WithdrawalPointIA] = useState(false);
  async function SeePhoto666WithdrawalPointIA() {
    setSeePhoto666WithdrawalPointIA(true);
  }
  async function CloseSeePhoto666WithdrawalPointIA() { //fermer
    setSeePhoto666WithdrawalPointIA(false);
  }

  // voir les infos du point retrait - IA
  const [seeInfos666WithdrawalPointIA, setSeeInfos666WithdrawalPointIA] = useState(false);
  async function CloseSeeInfos666WithdrawalPointIA() {
    setSeeInfos666WithdrawalPointIA(false);
  }

  // Page Redirection (666 WithdrawalPointIA)
  // Page Redirection (666 WithdrawalPointIA)
  // au niveau de la liste des Points Retraits, la logique ci nous dira quel page ouvrir - IA
  async function PageRedirection666WithdrawalPointIA() {
    // page - voir photo
    const photo = localStorage.getItem("GoToPageSeePhoto666WithdrawalPointIA");
    if (photo === "1") {
      setSeePhoto666WithdrawalPointIA(true);
    }

    // page - voir infos
    const infos = localStorage.getItem("GoToPageSeeInfos666WithdrawalPointIA");
    if (infos === "1") {
      setSeeInfos666WithdrawalPointIA(true);
    }
  }

  // historique - IA
  // ca c'est l'historique
  const [historiqueIA, setHistoriqueIA] = useState(false);
  async function HistoriqueIA() {
    setHistoriqueIA(true);
  }
  async function CloseHistoriqueIA() { //fermer
    setHistoriqueIA(false);
  }

  //reafficher le recu (c'est la popup menu qui va nous permettre de cliquer et de reafficher le recu) - IA
  const [seeReceiptIA, setSeeReceiptIA] = useState(false);
  async function SeeReceiptIA() {
    setSeeReceiptIA(true);
  }
  async function CloseSeeReceiptIA() { //fermer
    setSeeReceiptIA(false);
  }

  //reafficher le recu (versement national) - IA
  const [seeReceiptDepositNationalIA, setSeeReceiptDepositNationalIA] = useState(false);
  async function SeeReceiptDepositNationalIA() {
    setSeeReceiptDepositNationalIA(true);
  }
  async function CloseSeeReceiptDepositNationalIA() { //fermer
    setSeeReceiptDepositNationalIA(false);
  }

  //reafficher le recu (identification reussie) - IA
  const [seeReceiptIdentificationSuccessIA, setSeeReceiptIdentificationSuccessIA] = useState(false);
  async function SeeReceiptIdentificationSuccessIA() {
    setSeeReceiptIdentificationSuccessIA(true);
  }
  async function CloseSeeReceiptIdentificationSuccessIA() { //fermer
    setSeeReceiptIdentificationSuccessIA(false);
  }


  // toast (notification en cours d'actualisation) - IA
  const [waitRefreshIA, setWaitRefreshIA] = useState(false);
  async function CloseWaitRefreshIA() {
    setWaitRefreshIA(false);
  }

  // toast (notification actualisé) - IA
  const [refreshSuccessIA, setRefreshSuccessIA] = useState(false);
  async function CloseRefreshSuccessIA() {
    setRefreshSuccessIA(false);
  }

  // logique pour actualiser les notifications et le solde du compte
  async function RefreshNotificationIA() {
   
  }

  

  // cette requete c'est pour afficher toutes les notifications de l'utilisateur - IA
  const [apiNotificationIA, setApiNotificationIA] = useState([]);


  //creer un id pour chaque notification créer - IA
  const numberNotificationIA = apiNotificationIA.filter((api) => api.notification);
  const totalNotificationIA = numberNotificationIA.length;

  const createIdNotificationIA = totalNotificationIA + 1;
  if (createIdNotificationIA) { localStorage.setItem("createIdNotificationIA", createIdNotificationIA) }


  // Page Redirection (666 HistoryIA)
  // Page Redirection (666 HistoryIA)
  // au niveau de l'historique, la logique ci nous dira quel page ouvrir - IA
  async function PageRedirection666HistoryIA() {
    // page - infos other
    const infosOther = localStorage.getItem("GoToPageInfosOtherIA");
    if (infosOther === "1") {
      setInfosOtherPage666HistoryIA(true);
    }

    // page - infos Notification
    const infosNotification = localStorage.getItem("GoToPageInfosNotificationIA");
    if (infosNotification === "1") {
      setInfosNotificationPage666HistoryIA(true);
    }
  }

  // infos notification - IA
  // ici on affiche plus d'informations sur la Notification
  const [infosNotificationPage666HistoryIA, setInfosNotificationPage666HistoryIA] = useState(false);
  async function CloseInfosNotificationPage666HistoryIA() {
    /* etant donner que plusieurs notification ont les memes constantes alors on retire ca
    pour eviter que les autres s'affiche dans les autres */
    localStorage.removeItem("idNotification");
    localStorage.removeItem("date");
    localStorage.removeItem("amount");
    localStorage.removeItem("price");
    localStorage.removeItem("fees");
    localStorage.removeItem("total");
    localStorage.removeItem("virtualNumber");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("nameOwnerVirtualNumber");
    localStorage.removeItem("commission");
    localStorage.removeItem("stockRequired");
    localStorage.removeItem("idOwner"); //owner
    localStorage.removeItem("nameOwner");
    localStorage.removeItem("oldBalanceOwner");
    localStorage.removeItem("newBalanceOwner"); 
    localStorage.removeItem("oldStockOwner");
    localStorage.removeItem("newStockOwner");
    localStorage.removeItem("idOther"); //other
    localStorage.removeItem("nameOther");
    localStorage.removeItem("oldBalanceOther");
    localStorage.removeItem("newBalanceOther"); 
    localStorage.removeItem("oldStockOther");
    localStorage.removeItem("newStockOther"); 

    setInfosNotificationPage666HistoryIA(false);
  }

  // infos other (page) - IA
  // voir plus d'informations sur l'autre, par exemple sur le Point Retrait ou sur la personne qui nous a envoyer de l'argent
  const [infosOtherPage666HistoryIA, setInfosOtherPage666HistoryIA] = useState(false);
  async function CloseInfosOtherPage666HistoryIA() {
    setInfosOtherPage666HistoryIA(false);
  }

  //type de notification (666 infosTransactionPage 666 HistoryIA)
  //on veut que chaque type de notification soit afficher avec son propre design - IA
  const notificationIA = localStorage.getItem("notification");

  // idOwner ce sont les notifications qui ont ete initier par moi (on affiche ca dans la popup)
  const getIdOwnerIA = localStorage.getItem("idOwner");
  const idOwnerIA = getIdOwnerIA === idPersonConnectedIA;

  // idOther - idOther ce sont les notifications que je recoit (on affiche ca dans la popup)
  const getIdOtherIA = localStorage.getItem("idOther");
  const idOtherIA = getIdOtherIA === idPersonConnectedIA;

  const idNotificationIA = localStorage.getItem("idNotification"); //idNotification
  const dateIA = localStorage.getItem("date"); //date
  const amountIA = localStorage.getItem("amount"); //montant
  const priceIA = localStorage.getItem("price"); //prix
  const feesIA = localStorage.getItem("fees"); //frais
  const totalIA = localStorage.getItem("total"); //total
  const virtualNumberIA = localStorage.getItem("virtualNumber"); //virtualNumber
  const phoneNumberIA = localStorage.getItem("phoneNumber"); //phoneNumber
  const nameOwnerVirtualNumberIA = localStorage.getItem("nameOwnerVirtualNumber"); //nameOwnerVirtualNumber
  const commissionIA = localStorage.getItem("commission");
  const stockRequiredIA = localStorage.getItem("stockRequired");

  // Owner (celui qui envoie la notification)
  const nameOwnerIA = localStorage.getItem("nameOwner"); // nameOwner
  const oldBalanceOwnerIA = localStorage.getItem("oldBalanceOwner"); // old balance sender (ancien solde de l'envoyeur)
  const newBalanceOwnerIA = localStorage.getItem("newBalanceOwner"); // new balance sender (nouveau solde de l'envoyeur)
  const oldStockOwnerIA = localStorage.getItem("oldStockOwner");
  const newStockOwnerIA = localStorage.getItem("newStockOwner");

  // Other (celui qui recoit la notification)
  const nameOtherIA = localStorage.getItem("nameOther"); // nameOther
  const oldBalanceOtherIA = localStorage.getItem("oldBalanceOther"); // old balance receiver (ancien solde du beneficiaire)
  const newBalanceOtherIA = localStorage.getItem("newBalanceOther"); // new balance receiver (nouveau solde du beneficiaire)
  const oldStockOtherIA = localStorage.getItem("oldStockOther");
  const newStockOtherIA = localStorage.getItem("newStockOther");
  
  // documents
  //identiter incomplete (documents d'identiter manquants) - IA
  /* l'utilisateur recoit cette notification s'il n'a pas envoyer les documents d'identiter 
  de son entreprise */
  const identityIncompleteDocumentMissingIA = notificationIA === "143";

  // informations
  //identiter incomplete (Informations de l'entreprise manquantes) - IA
  /* l'utilisateur recoit cette notification s'il n'a pas envoyer les informations 
  d'identiter de son entreprise */
  const identityIncompleteInformationMissingIA = notificationIA === "24";

  // logo
  //identiter incomplete (logo de l'entreprise manquant) - IA
  // l'utilisateur recoit cette notification s'il n'a pas envoyer le logo de son entreprise
  const identityIncompleteLogoMissingIA = notificationIA === "42";

  // photos
  //identiter incomplete (photos de l'entreprise manquantes) - IA
  // l'utilisateur recoit cette notification s'il n'a pas envoyer les photos de son entreprise
  const identityIncompletePhotoMissingIA = notificationIA === "42";

  // Réseaux
  //identiter incomplete - Réseaux sociaux manquants - IA
  /* l'utilisateur recoit cette notification s'il n'a pas ajouter les réseaux sociaux de son 
  entreprise */
  const identityIncompleteSocialNetworkMissingIA = notificationIA === "42";

  //identiter valider - IA
  /*l'utilisateur recoit cette notification si ses informations d'identiter ont été validées 
  par izocash Business*/
  const identityValidateIA = notificationIA === "144";

  // Stock Recharge presque épuisé - IA
  //l'agence recoit cette notification si son stock recharge est presque epuiser
  const stockRefillAlmostExhaustedIA =  notificationIA === "144";

  // Stock Retrait presque épuisé - IA
  //l'agence recoit cette notification si son stock retrait est presque epuiser
  const stockWithdrawalAlmostExhaustedIA = notificationIA === "414";

  //recharge
  //l'utilisateur recoit cette notification apres avoir effectuer une recharge a l'agence
  const rechargeIA = notificationIA === "43";

  //retrait
  //l'utilisateur recoit cette notification apres avoir effectuer un retrait a l'agence
  const retraitIA = notificationIA === "44";


  // seePhoto (page) - IA
  // c'est la page qui permet de voir une photo
  /* dans l'application IA, si la personne a cliquer pour voir une photo, on affiche ca sur 
  cette page */
  const [seePhotoPageIA, setSeePhotoPageIA] = useState(false);
  async function SeePhotoPageIA() {
    setSeePhotoPageIA(true);
  }
  //fermer
  async function CloseSeePhotoPageIA() {
    setSeePhotoPageIA(false);
  }

  //on recupere l'url de la photo - IA
  /* lorsque la personne clique sur une photo, on enregistre l'url de la photo dans 
  le localStorage pour lui permettre de voir la photo sur laquelle il a cliquer. ici on 
  recupere l'url de la photo */
  const seePhotoIA = localStorage.getItem("seePhoto");

  // Verification Didentiter Entreprise - IA
  // Verification Didentiter Entreprise - IA
  /* sur cette page on affiche les infos d'identitées de l'entreprise qui 
  ont ete envoyer dans la bdd */
  const [
    verificationDidentiterEntrepriseIA,
    setVerificationDidentiterEntrepriseIA,
  ] = useState(false);
  async function VerificationDidentiterEntrepriseIA() {
    setVerificationDidentiterEntrepriseIA(true);
  }
  //fermer
  async function CloseVerificationDidentiterEntrepriseIA() {
    setVerificationDidentiterEntrepriseIA(false);
  }

  // liste Des Options (VerificationDidentiterEntrepriseIA)
  // liste Des Options (VerificationDidentiterEntrepriseIA)
  // sur cette page, on affiche la liste Des Options (VerificationDidentiterEntrepriseIA).
  const [
    listesDesOptionsVerificationDidentiterEntrepriseIA,
    setListesDesOptionsVerificationDidentiterEntrepriseIA,
  ] = useState(false);
  async function ListesDesOptionsVerificationDidentiterEntrepriseIA() {
    setListesDesOptionsVerificationDidentiterEntrepriseIA(true);
  }
  //fermer
  async function CloseListesDesOptionsVerificationDidentiterEntrepriseIA() {
    setListesDesOptionsVerificationDidentiterEntrepriseIA(false);
  }

  // importer documents d'identités Entreprise - IA
  // sur cette page, le partenaire va importer les documents d'identités de son entreprise
  const [importerDocumentDidentiterEntrepriseIA, setImporterDocumentDidentiterEntrepriseIA] = useState(false);
  async function ImporterDocumentDidentiterEntrepriseIA() {
    setImporterDocumentDidentiterEntrepriseIA(true);
  }
  async function CloseImporterDocumentDidentiterEntrepriseIA() { //fermer
    setImporterDocumentDidentiterEntrepriseIA(false);
  }

  // send Photo Success (on affiche ce message de succes s'il a envoyer la photo de son entreprise) - IA
  const [sendPhotoSuccessIA, setSendPhotoSuccessIA] = useState(false);
  async function CloseSendPhotoSuccessIA() {
    setSendPhotoSuccessIA(false);
    setImporterDocumentDidentiterEntrepriseIA(false);
  }

  const [sendPhotoSuccess2IA, setSendPhotoSuccess2IA] = useState(false);
  async function CloseSendPhotoSuccess2IA() {
    setSendPhotoSuccess2IA(false);
  }

  //logique pour envoyer la photo de profil à vérifier - IA
  const [filePhotoIA, setFilePhotoIA] = useState();
  async function VerificationPhotoIA() {
    setOpacity(true);
    const data = new FormData();
    data.append("image", filePhotoIA);

    // 1ere requete
    // 1ere requete
    // on upload la photo sur cloudinary puis ils vont nous renvoie l'url de la photo
    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountIA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data", 
        },
      })
      .then((res) => {
        const photo = res.data.urlPhoto;
        if (photo) { localStorage.setItem("photo", photo); }

    // 2e requete
    // 2e requete
    /* on verifie si la personne avait deja envoyer les infos de son entreprise, s'il avait deja envoyer alors on ne fait
    pas un 2e post, on fait directement un put pour modifier les infos qu'il avait envoyer */
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/infosValidateIA`)
      .then((res) => {
        const api = res.data;
        const filterInfos = api.filter((api) => api.idAccount === idPersonConnectedIA);
        const idInfos = filterInfos.map((api) => api._id);

        const verify = filterInfos.length > 0;
        if (verify) {
        // dans ce cas: photo deja envoyer, alors on fait un put pour remplacer la photo envoyer par un autre

        //3e requete
        //3e requete
        // requete pour remplacer la photo envoyer par un autre
        async function troisiemeReq() {
          const photo = localStorage.getItem("photo");
          const infosValidate = "0";
          const visible = "1";
          const connection = "1";
          const type = "1";

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/infosValidateIA/update/${idInfos}`,
            data: {
              photo,
              infosValidate,

              idAccount: idPersonConnectedIA,
              virtualNumber: virtualNumberPersonConnectedIA,
              visible,
              connection,
              type,
            },
          })
          .then((res) => {

        //4e requete
        //4e requete
        // obtenir de nouvelles donnees
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/infosValidateIA/`)
          .then((res) => {
            setApiInfosValidateIA(res.data);

            setSendPhotoSuccessIA(true);
            setOpacity(false);
            setSendPhotoSuccess2IA(true);
          });
        }
        quatriemeReq(); 
        //4e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        troisiemeReq();
        //3e requete
      } else {
      // dans ce cas: photo non envoyer, alors on fait un post pour envoyer la photo
          
        //3e requete
        //3e requete
        //cette 3e requete c'est pour envoyer l'url de la photo dans la bdd
        async function troisiemeReq() {
          const photo = localStorage.getItem("photo");
          const infosValidate = "0";
          const name = "0";
          const visible = "1";
          const connection = "1";
          const type = "1";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/infosValidateIA/save`,
            data: {
              photo,
              infosValidate,
              name,

              idAccount: idPersonConnectedIA,
              virtualNumber: virtualNumberPersonConnectedIA,
              visible,
              connection,
              type,
            },
          })
            .then((res) => {

              //4e requete
              //4e requete
              // obtenir de nouvelles donnees
              async function quatriemeReq() {
                await axios
                .get(`${process.env.REACT_APP_BACKEND}/api/infosValidateIA/`)
                .then((res) => {
                  setApiInfosValidateIA(res.data);

                  setSendPhotoSuccessIA(true);
                  setOpacity(false);
                  setSendPhotoSuccess2IA(true);
                });
              }
              quatriemeReq(); 
              //4e requete
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
          }
          troisiemeReq();
          //3e requete
        }
        //if (verify) {
      }).catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    deuxiemeReq();
    //2e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true);
    });
    //1ere requete
  }

  
  // importation Photo Didentiter Entreprise Success - IA
  // on affiche ce message de succes s'il a reussie a envoyer la photo de profil a verifier
  const [importationPhotoDidentiterEntrepriseSuccessIA, setImportationPhotoDidentiterEntrepriseSuccessIA] = useState(false);
  async function CloseImportationPhotoDidentiterEntrepriseSuccessIA() {
    setImportationPhotoDidentiterEntrepriseSuccessIA(false);
  }

  // envoie Information Didentiter Entreprise Success - IA
  // on affiche ce message de succes si le partenaire a pu envoyer ses informations d'identiter
  const [
    envoieInformationDidentiterEntrepriseSuccessIA,
    setEnvoieInformationDidentiterEntrepriseSuccessIA,
  ] = useState(false);
  //fermer
  async function CloseEnvoieInformationDidentiterEntrepriseSuccessIA() {
    setEnvoieInformationDidentiterEntrepriseSuccessIA(false);
  }

  // Compléter information Entreprise (Page) - VerificationDidentiterEntrepriseIA
  // sur cette page le partenaire va compléter les informations d'identitées de son Entreprise
  const [completerInformationEntreprisePageIA, setCompleterInformationEntreprisePageIA] = useState(false);
  async function CompleterInformationEntreprisePageIA() {
    setCompleterInformationEntreprisePageIA(true);
  }
  async function CloseCompleterInformationEntreprisePageIA() { //fermer
    setCompleterInformationEntreprisePageIA(false);
  }

  
  // send Infos Success (on affiche ce message de succes s'il a envoyer les infos de son entreprise) - IA
  const [sendInfosSuccessIA, setSendInfosSuccessIA] = useState(false);
  async function CloseSendInfosSuccessIA() {
    setSendInfosSuccessIA(false);
    setCompleterInformationEntreprisePageIA(false);
  }

  const [sendInfosSuccess2IA, setSendInfosSuccess2IA] = useState(false);
  async function CloseSendInfosSuccess2IA() {
    setSendInfosSuccess2IA(false);
  }

  // saisir nom, adresse, zone,... de l'entreprise - IA
  const [nameCompanyIA, setNameCompanyIA] = useState("");
  const [domainCompanyIA, setDomainCompanyIA] = useState("");
  const [phoneNumberCompanyIA, setPhoneNumberCompanyIA] = useState("");
  const [addressCompanyIA, setAddressCompanyIA] = useState("");
  const [countryCompanyIA, setCountryCompanyIA] = useState("");
  const [cityCompanyIA, setCityCompanyIA] = useState("");
  const [quarterCompanyIA, setQuarterCompanyIA] = useState("");
  const [zoneCompanyIA, setZoneCompanyIA] = useState("");
  const [busStopCompanyIA, setBusStopCompanyIA] = useState("");

  // logique pour envoyer les informations de l'entreprise à vérifier - IA
  async function VerificationInfosIA() {
    setOpacity(true);

    // 1ere requete
    // 1ere requete
    /* on verifie si la personne avait deja envoyer les infos de son entreprise, s'il avait deja envoyer alors on ne fait
    pas un 2e post, on fait directement un put pour modifier les infos qu'il avait envoyer */
    await axios
    .get(`${process.env.REACT_APP_BACKEND}/api/infosValidateIA`)
    .then((res) => {
      const api = res.data;
      const filterInfos = api.filter((api) => api.idAccount === idPersonConnectedIA);
      const idInfos = filterInfos.map((api) => api._id);

      const verify = filterInfos.length > 0;
      if (verify) {
      // dans ce cas: infos deja envoyer, alors on fait un put pour modifier les infos

    // 2e requete 
    // 2e requete 
    // modifier les informations de l'entreprise
    async function deuxiemeReq() {
      const infosValidate = "0";
      const connection = "1";
      const visible = "1";
      const type = "1";

      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/infosValidateIA/update/${idInfos}`,
        data: {
          name: nameCompanyIA,
          domain: domainCompanyIA,
          phoneNumber: phoneNumberCompanyIA,
          address: addressCompanyIA,
          country: countryCompanyIA,
          city: cityCompanyIA,
          quarter: quarterCompanyIA,
          zone: zoneCompanyIA,
          busStop: busStopCompanyIA,

          idAccount: idPersonConnectedIA,
          virtualNumber: virtualNumberPersonConnectedIA,
          infosValidate,
          connection,
          visible,
          type,
        },
      }).then((res) => {
        
        //3e requete
        //3e requete
        // obtenir de nouvelles donnees
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/infosValidateIA/`)
          .then((res) => {
            setApiInfosValidateIA(res.data);

            setSendInfosSuccessIA(true);
            setOpacity(false);
            setSendInfosSuccess2IA(true);
          });
        }
        troisiemeReq(); 
        //3e requete
      }).catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    deuxiemeReq();
    //2e requete
    } else {
    // dans ce cas: infos non envoyer, alors on fait un post pour envoyer les infos

    // 2e requete 
    // 2e requete 
    // envoyer les informations de l'entreprise
    async function deuxiemeReq() {
      const infosValidate = "0";
      const photo = "0";
      const connection = "1";
      const visible = "1";
      const type = "1";

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/infosValidateIA/save`,
        data: {
          name: nameCompanyIA,
          domain: domainCompanyIA,
          phoneNumber: phoneNumberCompanyIA,
          address: addressCompanyIA,
          country: countryCompanyIA,
          city: cityCompanyIA,
          quarter: quarterCompanyIA,
          zone: zoneCompanyIA,
          busStop: busStopCompanyIA,
          photo,

          idAccount: idPersonConnectedIA,
          virtualNumber: virtualNumberPersonConnectedIA,
          infosValidate,
          connection,
          visible,
          type,
        },
      }).then((res) => {

        //3e requete
        //3e requete
        // obtenir de nouvelles donnees
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/infosValidateIA/`)
          .then((res) => {
            setApiInfosValidateIA(res.data);

            setSendInfosSuccessIA(true);
            setOpacity(false);
            setSendInfosSuccess2IA(true);
          });
        }
        troisiemeReq(); 
        //3e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        deuxiemeReq();
        //2e requete
      } 
      //if (verify) {
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true);
    });
    //1ere requete
  }


  //Licence light - IA
  //sur cette page on affiche les details de la licence light - IA
  const [licenceLightIA, setLicenceLightIA] = useState(false);
  async function LicenceLightIA() {
    setLicenceLightIA(true);
  }
  //fermer
  async function CloseLicenceLightIA() {
    setLicenceLightIA(false);
  }

  // activer Licence light - IA
  // cette page permet a l'utilisateur d'activer sa licence light
  const [activateLicenceLightIA, setActivateLicenceLightIA] = useState(false);
  async function ActivateLicenceLightIA() {
    setActivateLicenceLightIA(true);
  }
  //fermer
  async function CloseActivateLicenceLightIA() {
    setActivateLicenceLightIA(false);
  }

  // activate Tool Success - IA
  /* si l'utilisateur a pu activer sa licence ou un outil, alors on va l'afficher ce 
  message de success */
  const [activateToolSuccessIA, setActivateToolSuccessIA] = useState(false);
  async function ActivateToolSuccessIA() {
    setActivateToolSuccessIA(true);
  }
  //fermer
  async function CloseActivateToolSuccessIA() {
    setActivateToolSuccessIA(false);
  }

  //Licence Grand Distributeur - IA
  //sur cette page on affiche les details de la licence du Distributeur
  const [licenceGrandDistributeur, setLicenceGrandDistributeur] =
    useState(false);
  async function LicenceGrandDistributeur() {
    setLicenceGrandDistributeur(!licenceGrandDistributeur);
  }

  //on affiche le profil de la personne connecter - IA
  const [profilIA, setProfilIA] = useState(false);
  async function ProfilIA() {
    setProfilIA(true);
  }
  //fermer
  async function CloseProfilIA() {
    setProfilIA(false);
  }

  // la photo de profil s'affiche dans la popup - IA
  const [popupImageProfilIA, setPopupImageProfilIA] = useState(false);
  async function PopupImageProfilIA() {
    setPopupImageProfilIA(!popupImageProfilIA);
  }
  //mettre photo sur le profil - IA
  const [mettrePhotoProfilIA, setMettrePhotoProfilIA] = useState(false);
  async function MettrePhotoProfilIA() {
    setMettrePhotoProfilIA(!mettrePhotoProfilIA);
  }

  /* ici c'est au niveau de la page de connexion/inscription
  on clique au niveau du logo pour aller au menu des applications - IA */
  async function CloseConnexionPageIA() {
    setConnexionPageIA(false);
    setTelephoneVirtuel(true);
  }

  /* ici c'est au niveau de la page d'accueil d'izocash
  on clique au niveau du logo pour aller au menu des applications - IA */
  async function CloseIzocashPageDaccueilGotoMenuTelephone() {
    setIzocashApp(false);
    setTelephoneVirtuel(true);
  }

  //quand on clique, on affiche la page qui permet a l'utilisateur de se connecter - IA
  const [connexionPageIA, setConnexionPageIA] = useState(false);

  //ici c'est au niveau de la page d'inscription et connexion
  //s'il clique sur Connexion, alors connexion sera active - IA
  const [connexionIA, setConnexionIA] = useState(true);
  async function ConnexionIA() {
    setConnexionIA(true);
    setInscriptionIA(false);
  }
  //s'il clique sur inscription, alors inscription sera active - IA
  const [inscriptionIA, setInscriptionIA] = useState(false);
  async function InscriptionIA() {
    setInscriptionIA(true);
    setConnexionIA(false);
  }

  //quand une action a reussie, on affiche le message de success  "super"
  const [superIA, setSuperIA] = useState(false);
  async function CloseSuperIA() {
    setSuperIA(false);
  }

  //quand la connexion a reussie, on affiche un message de success - IA
  const [connexionReussieIA, setConnexionReussieIA] = useState(false);
  async function ConnexionReussieIA() {
    //ici on ferme la popup du message de success
    setConnexionReussieIA(false);
    //ici on ferme la page de connexion
    setConnexionPageIA(false);
    //ici on redirige l'utilisateur sur la page d'accueil d'izocash
    setIzocashApp(true);
  }

  //quand l'inscription a reussie, on affiche un message de success - IA
  const [inscriptionReussieIA, setInscriptionReussieIA] = useState(false);
  async function CloseInscriptionReussieIA() {
    setInscriptionReussieIA(false);
    setConnexionIA(true);
    setInscriptionIA(false);
    setSuperCodePageIA(false);
  }

  //on cas d'erreur, ca c'est la popup qui va afficher le message d'erreur - IA
  const [errorIA, setErrorIA] = useState(false);
  async function CloseErrorIA() {
    setErrorIA(false);
  }

  //on affiche ce message d'erreur si l'utilisateur a saisi un numero virtuel qui n'existe pas - IA
  const [erreurNumeroVirtuelIncorrectIA, setErreurNumeroVirtuelIncorrectIA] =
    useState(false);
  async function CloseErreurNumeroVirtuelIncorrectIA() {
    setErreurNumeroVirtuelIncorrectIA(false);
  }

  // code pin incorrect (message d'erreur) - IA
  /* si par exemple l'agent veut demarrer le processus pour valider un compte et que 
  par erreur il entre un mauvais code, alors on va l'afficher ce message d'erreur */
  const [codePinIncorrectIA, setCodePinIncorrectIA] = useState(false);
  async function CloseCodePinIncorrectIA() {
    setCodePinIncorrectIA(false);
  }

  
  const idUserConnectedIA = localStorage.getItem("idUserConnectedIA");
   // requete pour obtenir tout les utilisateurs d'izocash - IA
   const [apiUserIA, setApiUserIA] = useState([]);

    const userConnectedIA = apiUserIA.filter((api) => api._id === idUserConnectedIA);

  const getblockIA = userConnectedIA.map((api) => api.block); // block 
  if (getblockIA) { localStorage.setItem("blockIA", getblockIA); }


  //infos profilIA (infos de la personne connecter)
  const namePersonConnectedIA = localStorage.getItem("namePersonConnectedIA");
  const photoPersonConnectedIA = localStorage.getItem("photoPersonConnectedIA"); 
  const virtualNumberPersonConnectedIA = localStorage.getItem("virtualNumberPersonConnectedIA");
  const balanceNationalAccountIA = localStorage.getItem("balanceNationalAccountIA");
  const balanceInternationalAccountIA = localStorage.getItem("balanceInternationalAccountIA");
  const stockNationalIA = localStorage.getItem("stockNationalIA");
  const stockInternationalIA = localStorage.getItem("stockInternationalIA");
  const verificationIA = localStorage.getItem("verificationIA");
  const identificationIA = localStorage.getItem("identificationIA");
  const typeAccountIA = localStorage.getItem("typeAccountIA");

   // requete pour obtenir tout les comptes izocash - IA
   const [apiAccountIA, setApiAccountIA] = useState([]);

  // filtre dans l'apiAccountIA (on affiche les infos de la personne connecter)
  const accountConnectedIA = apiAccountIA.filter((api) => api._id === idPersonConnectedIA);

  const getIdUserConnectedIA = accountConnectedIA.map((api) => api.idUser); // idUser
  if (getIdUserConnectedIA) { localStorage.setItem("idUserConnectedIA", getIdUserConnectedIA); }

  const getNamePersonConnectedIA = accountConnectedIA.map((api) => api.nameAccount); // name
  if (getNamePersonConnectedIA) { localStorage.setItem("namePersonConnectedIA", getNamePersonConnectedIA); }

  const getPhotoPersonConnectedIA = accountConnectedIA.map((api) => api.photoProfile); // photo
  if (getPhotoPersonConnectedIA) { localStorage.setItem("photoPersonConnectedIA", getPhotoPersonConnectedIA); }

  const getVirtualNumberPersonConnectedIA = accountConnectedIA.map((api) => api.virtualNumber); // virtual number
  if (getVirtualNumberPersonConnectedIA) { localStorage.setItem("virtualNumberPersonConnectedIA", getVirtualNumberPersonConnectedIA); }

  const getBalanceNationalAccountIA = accountConnectedIA.map((api) => api.balanceNationalAccount); // compte national (solde)
  if (getBalanceNationalAccountIA) { localStorage.setItem("balanceNationalAccountIA", getBalanceNationalAccountIA); }

  const getBalanceInternationalAccountIA = accountConnectedIA.map((api) => api.balanceInternationalAccount); // compte international (solde)
  if (getBalanceInternationalAccountIA) { localStorage.setItem("balanceInternationalAccountIA", getBalanceInternationalAccountIA); }

  const getStockNationalIA = accountConnectedIA.map((api) => api.stockNational); // stock national
  if (getStockNationalIA) { localStorage.setItem("stockNationalIA", getStockNationalIA); }

  const getStockInternationalIA = accountConnectedIA.map((api) => api.stockInternational); // stock international
  if (getStockInternationalIA) { localStorage.setItem("stockInternationalIA", getStockInternationalIA); }

  const getVerificationIA = accountConnectedIA.map((api) => api.verification); // verification
  if (getVerificationIA) { localStorage.setItem("verificationIA", getVerificationIA); }

  const getIdentificationIA = accountConnectedIA.map((api) => api.identification); // identification
  if (getIdentificationIA) { localStorage.setItem("identificationIA", getIdentificationIA); }

  const getTypeAccountIA = accountConnectedIA.map((api) => api.type); // typeAccount
  if (getTypeAccountIA) { localStorage.setItem("typeAccountIA", getTypeAccountIA); }

  
  // super code (inscription) - IA
  // le card ci va permettre a la personne d'entrer le super code
  const [superCodePageIA, setSuperCodePageIA] = useState(false);
  async function CloseSuperCodePageIA() {
    setSuperCodePageIA(false);
  }
  // saisir super code (inscription) - IA
  const [superCodeSignupIA, setSuperCodeSignupIA] = useState("");
  if (superCodeSignupIA) {
    localStorage.setItem("writeSuperCode", superCodeSignupIA);
  }

  // on ajoute une photo de profil lors de l'inscription sur izocash
  const [addPhotoProfile66connexionPageIA, setAddPhotoProfile66connexionPageIA] = useState(false);
  async function CloseAddPhotoProfile66connexionPageIA() {
    setAddPhotoProfile66connexionPageIA(false);
  }

  
  // signup - IA
  // signup - IA
  // saisir nom, numero virtuel, mot de passe - IA
  const [nameSignupIA, setNameSignupIA] = useState("");
  const [numberSignupIA, setNumberSignupIA] = useState("");
  const [passwordSignupIA, setPasswordSignupIA] = useState("");

  if (nameSignupIA) { localStorage.setItem("writeName", nameSignupIA); }
  if (numberSignupIA) { localStorage.setItem("writeVirtualNumber", numberSignupIA); }
  if (passwordSignupIA) { localStorage.setItem("writePassword", passwordSignupIA); }

  const [filePhoto66addPhotoProfile66connexionPageIA, setFilePhoto66addPhotoProfile66connexionPageIA] = useState();

  async function SignupIAtest() {
    setErreurNumeroVirtuelIncorrectIA(true);
  }


  // Before Signup - IA
  // Before Signup - IA
  // avant l'inscription
  async function BeforeSignupIA() {
    setOpacity(true);
    
        // 1ere requete - api1
        // on verifie si le numero virtuel existe
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const writeVirtualNumber = localStorage.getItem("writeVirtualNumber"); // on filtre en fonction du numero virtuel saisi

            const api = res.data;
            const filtre = api.filter((api) => api.virtualNumber === writeVirtualNumber && api.type === "1" && api.izocashApp === "1");
            const verifiedNumberExist = filtre.length > 0; // verifiedNumberExist > 0, numero virtuel existe .. verifiedNumberExist < 0, numero virtuel n'existe pas

            if (verifiedNumberExist) {
              // dans ce cas: numero virtuel existe.

              // on verifie si la personne est deja inscrite sur izocash
              const filter = api.filter((api) => api.virtualNumber === writeVirtualNumber && api.type === "9" && api.izocashApp === "1"); // on verifie en fonction du numero virtuel saisi
              const verifiedAlreadySignup = filter.length > 0;

              if (verifiedAlreadySignup) {
                //dans ce cas: numero deja inscrit
                setOpacity(false);
                setErrorIA(true);
              } else {
                //dans ce cas: numero non inscrit
                setOpacity(false);
                setAddPhotoProfile66connexionPageIA(true); //on affiche la page qui va lui permettre de choisir la photo de profil
              }
              //verifiedAlreadySignup
            } else {
              //dans ce cas: numero virtuel n'existe pas 
              setOpacity(false);
              setErreurNumeroVirtuelIncorrectIA(true); //on affiche un message d'erreur
            }
            //verifiedNumberExist
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true);
        });
        }
        premiereReq();
        //1ere requete - api1
  }
  // Before Signup - IA



  // logique pour s'inscrire sur izocash - IA
  async function SignupIA() {
    setOpacity(true);

          //1ere requete - api1
          // on envoie sa photo de profil sur imagekit
          async function premiereReq() {
            const data = new FormData();
            data.append("image", filePhoto66addPhotoProfile66connexionPageIA);

            await axios
            .post(`${process.env.REACT_APP_Api1}/api/messageFA/sendPhoto`, data, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              const urlPhoto = res.data.urlPhoto;
              if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }
              console.log("photo envoyer sur i...", res);


          //2e requete - api1
          // on cree un id ( on va l'utiliser chaque fois qu'on aura besoin d'un id)
          async function deuxiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              const api = res.data;

              //creer un id 
              const numberMessageFA = api.filter((api) => api._id);
              const totalMessageFA = numberMessageFA.length;

              const createId = totalMessageFA + 1;
              if (createId) { localStorage.setItem("createId", createId); }
              console.log("createId :", createId);
              console.log(res);


          //3e requete - api1
          // inscrire l'utilisateur
          async function troisiemeReq() {
            const id = localStorage.getItem("createId");
            const writeName = localStorage.getItem("writeName");
            const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
            const writePassword = localStorage.getItem("writePassword");
            const block = "0";
            const type = "9";

            await axios({
              method: "post",
              url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
              data: {
                id,
                nameUser: writeName,
                virtualNumber: writeVirtualNumber,
                password: writePassword,
                block,
                type,
              },
            })
            .then((res) => {
            // utilisateur enregistré! on prend l'idUser, on va l'ajouter au niveau de son compte IA
            const id = res.data._id;
            if (id) { localStorage.setItem("idUser", id); }

            const online = res.data.createdAt; // on prend la date de derniere connexion
            if (online) { localStorage.setItem("online", online); }

            const block = res.data.block; // block
            if (block) { localStorage.setItem("blockFA", block); }
            console.log(res);
            
          //4e requete - api1
          // on cree son compte izocash
          async function quatriemeReq() {
            const id = localStorage.getItem("createId");
            const idUser = localStorage.getItem("idUser"); 
            const writeName = localStorage.getItem("writeName");
            const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
            const photoProfile = localStorage.getItem("urlPhotoreq");
            const online = localStorage.getItem("online");
            const visible = "1";
            const type = "10";
            const izocashApp = "1";

            await axios({
              method: "post",
              url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
              data: {
                id,
                idUser,
                nameAccount: writeName,
                virtualNumber: writeVirtualNumber,
                photoProfile,
                online,
                visible,
                type,
                izocashApp,
              },
            })
            .then((res) => {
              // on prend l'idAccount, on va l'utiliser pour mettre l'idPhotoProfile sur son compte
              const id = res.data._id;
              if (id) { localStorage.setItem("idAccount", id); }
              console.log(id, "idAccount");

        //5e requete - api1
        // on met l'idAccount au niveau du user (car c'est le compte principal)
        async function cinquiemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const idUser = localStorage.getItem("idUser");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idUser}`,
            data: {
              idAccount,
            },
            })
            .then((res) => {
            console.log("l'idAccount a ete mis au niveau du user");
            console.log(res);

          //6e requete - api1
          // on met la photo de profil dans les favoris
          async function sixiemeReq() {
            const id = localStorage.getItem("createId");
            const idUser = localStorage.getItem("idUser");
            const urlPhoto = localStorage.getItem("urlPhotoreq");
            const urlVideo = "0";
            const visible = "1";
            const type = "20";
                  
            await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
            data: {
              id,
              idUser,
              urlPhoto,
              urlVideo,
              visible,
              type,
            },
          })
          .then((res) => {
            console.log("photo ajouter aux favoris", res);

            //inscription reussie , alors on le connecte directement sur son compte izocash
            //on enregistre l'idAccount pour le maintenir connecté !
            const idAccount = localStorage.getItem("idAccount");
            if (idAccount) { localStorage.setItem("idPersonConnectedIA", idAccount); }

            const idUser = localStorage.getItem("idUser");
            if (idUser) { localStorage.setItem("idUserConnectedIA", idUser); }

            console.log("inscription reussie, idPersonConnectedIA", idAccount);
            console.log("idUserConnectedIA", idUser);

          //7e requete - api1
          // obtenir de nouvelles données
          async function septiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              console.log(res);
    
              //connexion reussie, on affiche la page d'accueil de la messagerie
              setAddPhotoProfile66connexionPageIA(false);
              setConnexionPageIA(false);
              setTelephoneVirtuel(true);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("7e requete - api1", err);
            });
            }
            septiemeReq();
            //7e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("6e requete - api1", err);
            });
            }
            sixiemeReq();
            //6e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("5e requete - api1", err);
            });
            }
            cinquiemeReq();
            //5e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("4e requete - api1", err);
            });
            }
            quatriemeReq();
            //4e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("3e requete - api1", err);
            });
            }
            troisiemeReq();
            //3e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("2e requete - api1", err);
            });
            }
            deuxiemeReq();
            //2e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreurConnexionAA(true);
              console.log("1ere requete - api1", err);
            });
            }
            premiereReq();
            //1ere requete - api1
  }
  // SignupIA


  // login - IA
  // login - IA
  //se connecter sur izocash - IA
  //saisir numero virtuel, mot de passe - IA
  const [numberLoginIA, setNumberLoginIA] = useState("");
  const [passwordLoginIA, setPasswordLoginIA] = useState("");

  if (numberLoginIA) { localStorage.setItem("writeVirtualNumber", numberLoginIA); }

  if (passwordLoginIA) { localStorage.setItem("writePassword", passwordLoginIA); }

  // logique pour se connecter sur izocash - IA
  async function LoginIA() {
    setOpacity(true);
    // 1ere requete
    // 1ere requete
    // numero virtuel inscrit
    //On verifie si la personne est deja inscrite avec ce numero virtuel
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userIA/`)
      .then((res) => {
        const virtualNumber = localStorage.getItem("writeVirtualNumber");

        // on filtre en fonction du numero virtuel saisi - IA
        const api = res.data;
        const filter = api.filter((api) => api.virtualNumber === virtualNumber);
        // verifyAlreadySignup > 0, numero virtuel inscrit
        // verifyAlreadySignup < 0, numero virtuel non inscrit
        const verifyAlreadySignup = filter.length > 0;

        if (verifyAlreadySignup) {
          // dans ce cas: numero virtuel inscrit

          //2e requete
          //2e requete
          //numero virtuel inscrit. on lui laisse se connecter
          async function deuxiemeReq() {
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_BACKEND}/api/userIA/login`,
              data: {
                virtualNumber: numberLoginIA,
                password: passwordLoginIA,
              },
            })
              .then((res) => {
                //on prend l'idUser pour pouvoir filtrer
                const idUser = res.data.idUser;
                if (idUser) { 
                  localStorage.setItem("idUser", idUser); 
                  localStorage.setItem("idUserIAreq", idUser); 
                }

                //3e requete
                //3e requete
                //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
                async function troisiemeReq() {
                  await axios
                    .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
                    .then((res) => {
                      //on recupere l'idUser
                      const idUser = localStorage.getItem("idUser");
                      
                      // filtre pour obtenir uniquement les infos de la personne connecter
                      const api = res.data;
                      const filterUser = api.filter((api) => api.idUser === idUser);

                      const id = filterUser.map((api) => api._id); // id
                      if (id) { localStorage.setItem("idPersonConnectedIA", id); }

                      const name = filterUser.map((api) => api.nameAccount); // name
                      if (name) { localStorage.setItem("namePersonConnectedIA", name); }

                      const photo = filterUser.map((api) => api.photoProfile); // photo
                      if (photo) { localStorage.setItem("photoPersonConnectedIA", photo); }

                      const virtualNumber = filterUser.map((api) => api.virtualNumber); // virtualNumber
                      if (virtualNumber) { localStorage.setItem("virtualNumberPersonConnectedIA", virtualNumber); }

                      const balanceNationalAccount = filterUser.map((api) => api.balanceNationalAccount); // solde National
                      if (balanceNationalAccount) { localStorage.setItem("balanceNationalAccountIA", balanceNationalAccount); }

                      const balanceInternationalAccount = filterUser.map((api) => api.balanceInternationalAccount); // solde International
                      if (balanceInternationalAccount) { localStorage.setItem("balanceInternationalAccountIA", balanceInternationalAccount); }

                      const stockNational = filterUser.map((api) => api.stockNational); // stockNational
                      if (stockNational) { localStorage.setItem("stockNationalIA", stockNational); }

                      const stockInternational = filterUser.map((api) => api.stockInternational); // stockInternational
                      if (stockInternational) { localStorage.setItem("stockInternationalIA", stockInternational); }

                      const myBalanceNationalAccount = filterUser.map((api) => api.myBalanceNationalAccount); // mon solde National
                      if (myBalanceNationalAccount) { localStorage.setItem("myBalanceNationalAccountIA", myBalanceNationalAccount); }

                      const myBalanceInternationalAccount = filterUser.map((api) => api.myBalanceInternationalAccount); // mon solde International
                      if (myBalanceInternationalAccount) { localStorage.setItem("myBalanceInternationalAccountIA", myBalanceInternationalAccount); }

                      const paymentMethod = filterUser.map((api) => api.paymentMethod); // paymentMethod
                      if (paymentMethod) { localStorage.setItem("paymentMethodIA", paymentMethod); }

                      const countryCode = filterUser.map((api) => api.countryCode); // countryCode
                      if (countryCode) { localStorage.setItem("countryCodePersonConnectedIA", countryCode); }

                      const indicativeOne = filterUser.map((api) => api.indicativeOne); // indicativeOne
                      if (indicativeOne) { localStorage.setItem("indicativeOneIA", indicativeOne); }

                      const indicativeTwo = filterUser.map((api) => api.indicativeTwo); // indicativeTwo
                      if (indicativeTwo) { localStorage.setItem("indicativeTwoIA", indicativeTwo); }

                      const indicativeThree = filterUser.map((api) => api.indicativeThree); // indicativeThree
                      if (indicativeThree) { localStorage.setItem("indicativeThreeIA", indicativeThree); }

                      const license = filterUser.map((api) => api.license); // license
                      if (license) { localStorage.setItem("licenseIA", license); }

                      const identification = filterUser.map((api) => api.identification); // identification
                      if (identification) { localStorage.setItem("identificationIA", identification); }

                      const verification = filterUser.map((api) => api.verification); // verification
                      if (verification) { localStorage.setItem("verificationIA", verification); }

                      const typeAccount = filterUser.map((api) => api.type); // typeAccount
                      if (typeAccount) { localStorage.setItem("typeAccountIA", typeAccount); }
                      
                      const head3 = true; //ca c'est pour les onglets, on lui dit les onglets qui doivent etre active lorsqu'on se connecte
                      localStorage.setItem("head1666izocashApp", head3);
                      localStorage.setItem("head3666izocashApp", head3);

                      //si c'est un collaborateur IAC, alors on enregistre ces infos dans le localStorage
                      // idCollaborator
                      const idCollaborator = filterUser.map((api) => api._id);
                      if (idCollaborator) {
                        localStorage.setItem("idCollaboratorIAC", idCollaborator);
                      }

                      // nameCollaborator
                      const nameCollaborator = filterUser.map((api) => api.nameUser);
                      if (nameCollaborator) {
                        localStorage.setItem("nameCollaboratorIAC", nameCollaborator);
                      }

                  //4e requete
                  //4e requete
                  // on fait un appel a l'api pour obtenir les outils activées
                  async function quatriemeReq() {
                    await axios
                    .get(`${process.env.REACT_APP_BACKEND}/api/toolIA`)
                    .then((res) => {
                      // on filtre en fonction de l'idPersonConnectedIA
                      const idPersonConnected = localStorage.getItem("idPersonConnectedIA");
                      const api = res.data;
                      
                      // izocash deals
                      const filterTool = api.filter((api) => api.idAccount === idPersonConnected && api.type === "1");

                      const izocashDealsBalance = filterTool.map((api) => api.izocashDealsBalance); // solde
                      if (izocashDealsBalance) { localStorage.setItem("izocashDealsBalanceIA", izocashDealsBalance); }

                      const izocashDealsCode = filterTool.map((api) => api.izocashDealsCode); // super code
                      if (izocashDealsCode) { localStorage.setItem("izocashDealsCodeIA", izocashDealsCode); }

                      const izocashDealsActive = filterTool.map((api) => api.izocashDealsActive); // active
                      if (izocashDealsActive) { localStorage.setItem("izocashDealsActiveIA", izocashDealsActive); }

                      const izocashDealsDoubleProfit = filterTool.map((api) => api.izocashDealsDoubleProfit); // double benefice
                      if (izocashDealsDoubleProfit) { localStorage.setItem("izocashDealsDoubleProfitIA", izocashDealsDoubleProfit); }

              //5e requete
              //5e requete
              // on enregistre block (ca va etre utile pour l'empecher d'effectuer toute action s'il a ete bloqué)
              async function cinquiemeReq() {
                await axios
                .get(`${process.env.REACT_APP_LoginAA}/api/userAA`)
                .then((res) => {
                  const idUser = localStorage.getItem("idUserIAreq");
                  const api = res.data;
                  const filterUser = api.filter((api) => api._id === idUser);
  
                  const block = filterUser.map((api) => api.block); // block
                  if (block) { localStorage.setItem("blockIA", block); }
                  setApiUserIA(res.data);
  
                  //connexion reussie, on affiche le message de success
                  setOpacity(false);
                  setConnexionReussieIA(true);
                })
                }
                cinquiemeReq();
                //5e requete
                    })
                    .catch((err) => {
                      setOpacity(false);
                      setErrorIA(true);
                    });
                  }
                  quatriemeReq();
                  //4e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorIA(true);
                  });
                }
                troisiemeReq();
                //3e requete
              })
              .catch((err) => {
                //connexion echouer, on declenche cette popup qui va afficher le message d'echec
                setOpacity(false);
                setErrorIA(true);
              });
          }
          deuxiemeReq();
          //2e requete
        } else {
          // dans ce cas: numero virtuel non inscrit
          /* on l'affiche un message d'erreur. il ne peut pas se connecter car il ne 
          s'est pas encore inscrit */
          setOpacity(false);
          setErrorIA(true);
        }
        // le if de verifyAlreadySignup se ferme ici
      });
    //1ere requete
  }
  // login - IA



  // erreur2
  const [erreur2, setErreur2] = useState(false);
  async function CloseErreur2() {
    setErreur2(false);
  } 


  // délivrer un numéro virtuel
  const [delivrerNumeroVirtuel, setDelivrerNumeroVirtuel] = useState(false);
  async function DelivrerNumeroVirtuel() {
    setDelivrerNumeroVirtuel(true);
  }
  async function CloseDelivrerNumeroVirtuel() {
    setDelivrerNumeroVirtuel(false);
  } 

  // numero Offert Success (ça c'est la page de success, lorsque le numero a ete offert, on va afficher cette page)
  const [numeroOffertSuccess, setNumeroOffertSuccess] = useState(false);
  function CloseNumeroOffertSuccess() {
    setNumeroOffertSuccess(false);
  }

  // saisir :
  const [writeVirtualNumberAF, setWriteVirtualNumberAF] = useState(""); //Numero virtuel
  const [writeNameAF, setWriteNameAF] = useState(""); //nom
  const [writeCountryAF, setWriteCountryAF] = useState(""); //Pays
  const [writeSexAF, setWriteSexAF] = useState(""); //Sexe
  const [isLoading66delivrerNumeroVirtuel, setIsLoading66delivrerNumeroVirtuel] = useState(false);

  if (writeVirtualNumberAF) { 
    localStorage.setItem("writeVirtualNumberAF", writeVirtualNumberAF); 
    localStorage.setItem("writeNameAF", writeNameAF); 
    localStorage.setItem("writeCountryAF", writeCountryAF); 
    localStorage.setItem("writeSexAF", writeSexAF); 
  }

  // logique pour délivrer un numéro virtuel (admin florinato)
  async function Delivrer() {
        setIsLoading66delivrerNumeroVirtuel(true);

        // 1ere requete - api1
        //on enregistre le numero virtuel dans la bdd
        async function premiereReq() {
          const virtualNumber = localStorage.getItem("writeVirtualNumberAF");
          const name = localStorage.getItem("writeNameAF");
          const country = localStorage.getItem("writeCountryAF");
          const sex = localStorage.getItem("writeSexAF");
          const izocashApp = "1";
          const visible = "1";
          const type = "1";
          
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
            data: {
              virtualNumber,
              name,
              country,
              sex,
              izocashApp,
              visible,
              type,
            },
          })
          .then((res) => {
            
          //2e requete - api1
          // obtenir de nouvelles données
          async function deuxiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              console.log(res);
    
              setIsLoading66delivrerNumeroVirtuel(false);
              setNumeroOffertSuccess(true);
            })
            .catch((err) => {
              setIsLoading66delivrerNumeroVirtuel(false);
              setErreur2(true); 
            });
            }
            deuxiemeReq();
            //2e requete - api1
            })
            .catch((err) => {
              setIsLoading66delivrerNumeroVirtuel(false);
              setErreur2(true); 
            });
            } 
            premiereReq();
            //1ere requete - api1
  } 
  // Delivrer
  

  // deconnexion - page
  // deconnexion - page
  //on affiche la popup qui permet a l'utilisateur de se connecter - IA
  const [deconnexionPageIA, setDeconnexionPageIA] = useState(false);
  async function DeconnexionPageIA() {
    setDeconnexionPageIA(!deconnexionPageIA);
  }
  
  // logique pour se deconnecter - IA
  async function LogoutIA() {
    localStorage.removeItem("idPersonConnectedIA");
    localStorage.removeItem("namePersonConnectedIA");
    localStorage.removeItem("virtualNumberPersonConnectedIA");
    localStorage.removeItem("photoProfilePersonConnectedIA");
    localStorage.removeItem("countryCodePersonConnectedIA");
    localStorage.removeItem("writeVirtualNumber");
    localStorage.removeItem("photoPersonConnectedIA");
    localStorage.removeItem("idUserIA");
    localStorage.removeItem("GoToPageSeePhoto666WithdrawalPointIA");
    localStorage.removeItem("GoToPageSeeInfos666WithdrawalPointIA");
    localStorage.removeItem("ButtonNewWithdrawalPoint");
    localStorage.removeItem("idLanguage");
    localStorage.removeItem("nameLanguage");
    localStorage.removeItem("identificationCodeIA");
    localStorage.removeItem("nameAtIdentificationIA");
    localStorage.removeItem("id");
    localStorage.removeItem("GoToPageListCountries");
    localStorage.removeItem("GoToPageUpdateLanguage");
    localStorage.removeItem("GoToPageInfosNotificationIA");
    localStorage.removeItem("GoToPageInfosOtherIA");
    localStorage.removeItem("depositNationalStock");
    localStorage.removeItem("depositNationalCommission");
    localStorage.removeItem("newBalanceNational");
    localStorage.removeItem("izocashDealsBalanceIA");
    localStorage.removeItem("izocashDealsCodeIA");
    localStorage.removeItem("sexIA");
    localStorage.removeItem("nameClientIA");
    localStorage.removeItem("jobClientIA");
    localStorage.removeItem("businessClientIA");
    localStorage.removeItem("otherBusinessClientIA");
    localStorage.removeItem("phoneNumberClientIA");
    localStorage.removeItem("addressClientIA");
    localStorage.removeItem("idCountrySelected");
    localStorage.removeItem("countrySelected");
    localStorage.removeItem("createIdNotificationIA");
    localStorage.removeItem("idLanguageIAC");
    localStorage.removeItem("nameLanguageIAC");
    localStorage.removeItem("inEnglish");
    localStorage.removeItem("writeLanguage");
    localStorage.removeItem("GoToPageUpdateCountry");
    localStorage.removeItem("GoToPageUpdateZoneIAC");
    localStorage.removeItem("GoToPageRecapitulatifLocalisationIAC");

    setConnexionPageIA(true);
    setIzocashApp(false);
  }

  //quand on clique, le card qui permet de modifier le Nom de naissance va s'afficher
  const [nomNaissanceIA, setNomNaissanceIA] = useState(false);
  async function NomNaissanceIA() {
    setNomNaissanceIA(true);
  }
  //ca c'est pour fermer le card qui permet de modifier le nom de Naissance
  async function CloseNomNaissanceIA() {
    setNomNaissanceIA(false);
  }
  //quand on clique, le card qui permet de modifier le Nom de la mère va s'afficher
  const [nomMereIA, setNomMereIA] = useState(false);
  async function NomMereIA() {
    setNomMereIA(true);
  }
  //ca c'est pour fermer le card qui permet de modifier le nom de la mere
  async function CloseNomMereIA() {
    setNomMereIA(false);
  }

  // on affiche les informations importantes( tel que date et lieu de naissance, ... ) - IA
  const [informationImportanteIA, setInformationImportanteIA] = useState(false);
  async function InformationImportanteIA() {
    setInformationImportanteIA(!informationImportanteIA);
  } 

  //on affiche le card qui permet de modifier le sexe de la personne - IA
  const [editSexeIA, setEditSexeIA] = useState(false);
  async function EditSexeIA() {
    setEditSexeIA(true);
  }
  // fermer le card qui permet de modifier le sexe - IA
  async function CloseEditSexeIA() {
    setEditSexeIA(false);
  }

  // male (quand on clique, on selectionne le sexe masculin) - IA
  const getMaleIA = localStorage.getItem("maleIA");
  const [maleIA, setMaleIA] = useState(getMaleIA); 
  async function MaleIA() { 
    const male = true;
    localStorage.setItem("maleIA", male);
    setMaleIA(true);

    const sex = "1";
    localStorage.setItem("sexIA", sex);

    localStorage.removeItem("femaleIA"); 
    setFemaleIA(false);
  }


  // female (quand on clique, on selectionne le sexe feminin) - IA
  const getFemaleIA = localStorage.getItem("femaleIA");
  const [femaleIA, setFemaleIA] = useState(getFemaleIA); 
  async function FemaleIA() {
    const female = true;
    localStorage.setItem("femaleIA", female);
    setFemaleIA(true);

    const sex = "2";
    localStorage.setItem("sexIA", sex);

    localStorage.removeItem("maleIA"); 
    setMaleIA(false);
  }
  

  //mettre photo profil - IA
  //mettre photo profil - IA
  //logique pour mettre la photo sur le profil - IA
  const [filePhotoProfilIA, setFilePhotoProfilIA] = useState();
  //1ere requete
  /* cette 1ere requete c'est pour envoyer la photo sur cloudinary, ensuite cloudinary nous
  renvoie l'url de la photo */
  async function EnregistrerPhotoProfilIA() {
    setOpacity(true);

    const data = new FormData();
    data.append("image", filePhotoProfilIA);

    await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountIA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data", 
        },
      })
      .then((res) => {
        const photo = res.data.urlPhoto;
        if (photo) {
          localStorage.setItem("photo", photo);
        }
        //2e requete
        //2e requete
        //cette 2e requete c'est pour envoyer l'url de la photo dans la bdd
        async function deuxiemeReq() {
          const photo = localStorage.getItem("photo");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
            data: {
              photoProfile: photo,
            },
          })
            .then((res) => {
              //3e requete
              //3e requete
              //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
              async function troisiemeReq() {
                await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
                  .then((res) => {
                    const api = res.data;
                    // filtre pour obtenir uniquement les infos de la personne connecter
                    const filtreApiUser = api.filter((api) => api._id === idPersonConnectedIA);
                    const photoProfilIA = filtreApiUser.map((api) => api.photoProfile);
                    localStorage.setItem("photoPersonConnectedIA", photoProfilIA);

                    setOpacity(false);
                    setMettrePhotoProfilIA(false);
                    setSuperIA(true);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorIA(true);
                  });
              }
              troisiemeReq();
              //3e requete
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //mettre photo profil - IA


  // modifier l'adresse (page) - IA
  const [addressPageIA, setAddressPageIA] = useState(false);
  async function AddressPageIA() {
    setAddressPageIA(true);
  }
  async function CloseAddressPageIA() { //fermer
    setAddressPageIA(false);
  }

  // saisir l'adresse du Point Retrait - IA
  const [writeAddress, setWriteAddress] = useState("");
  if (writeAddress) { localStorage.setItem("writeAddress", writeAddress) }

  async function SaveAddressIA() { // enregistrer l'adresse
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
      data: {
        address: writeAddress,
      },
    })
      .then((res) => {

        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
            .then((res) => {
              const api = res.data;
              const filterUser = api.filter((api) => api._id === idPersonConnectedIA);

              const address = filterUser.map((api) => api.address); // new address
              if (address) { localStorage.setItem("addressIA", address); }

              setOpacity(false);
              setAddressPageIA(false);
              setInformationImportanteIA(true);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }


  // modifier l'arret de bus (page) - IA
  const [busStopPageIA, setBusStopPageIA] = useState(false);
  async function BusStopPageIA() {
    setBusStopPageIA(true);
  }
  async function CloseBusStopPageIA() { //fermer
    setBusStopPageIA(false);
  }

  // saisir l'arret de bus le plus proche - IA
  const [writeBusStop, setWriteBusStop] = useState("");
  if (writeBusStop) { localStorage.setItem("writeBusStop", writeBusStop) }

  async function SaveBusStopIA() { // enregistrer l'arret de bus
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
      data: {
        busStop: writeBusStop,
      },
    })
      .then((res) => {

        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
            .then((res) => {
              const api = res.data;
              const filterUser = api.filter((api) => api._id === idPersonConnectedIA);

              const busStop = filterUser.map((api) => api.busStop); // new bus Stop
              if (busStop) { localStorage.setItem("busStopIA", busStop); }

              setOpacity(false);
              setBusStopPageIA(false);
              setInformationImportanteIA(true);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }


  // modifier le numero de telephone (page) - IA
  const [phoneNumberPageIA, setPhoneNumberPageIA] = useState(false);
  async function PhoneNumberPageIA() {
    setPhoneNumberPageIA(true);
  }
  async function ClosePhoneNumberPageIA() { //fermer
    setPhoneNumberPageIA(false);
  }

  // numero de telephone auquel on peut joindre le Point Retrait - IA
  const [writePhoneNumber, setWritePhoneNumber] = useState("");
  if (writePhoneNumber) { localStorage.setItem("writePhoneNumber", writePhoneNumber) }

  async function SavePhoneNumberIA() { //enregistrer le numero de telephone
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
      data: {
        phoneNumber: writePhoneNumber,
      },
    })
      .then((res) => {

        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
            .then((res) => {
              const api = res.data;
              const filterUser = api.filter((api) => api._id === idPersonConnectedIA);

              const phoneNumber = filterUser.map((api) => api.phoneNumber); // new phone Number
              if (phoneNumber) { localStorage.setItem("phoneNumberIA", phoneNumber); }

              setOpacity(false);
              setPhoneNumberPageIA(false);
              setInformationImportanteIA(true);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }

  // nom de la mere - IA
  // nom de la mere - IA
  //quand on clique, on enregistre le nom de la mere dans la bdd
  const [textareaNomMereIA, setTextareaNomMereIA] = useState("");
  async function EnregistrerNomMereIA() {
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
      data: {
        nomMere: textareaNomMereIA,
      },
    })
      .then((res) => {
        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/user`)
            .then((res) => {
              const api = res.data;
              // filtre pour obtenir uniquement les infos de la personne connecter
              const filtreApiUser = api.filter(
                (api) => api._id === idPersonConnectedIA
              );
              const nomMereIA = filtreApiUser.map((api) => api.nomMere);
              localStorage.setItem(
                "https://alrani.com/nomMerePersonneConnecterIA",
                nomMereIA
              );

              setOpacity(false);
              setNomMereIA(false);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //nom de la mere - IA

  //on affiche la page A Propos - IA
  const [aProposIA, setAproposIA] = useState(false);
  async function AproposIA() {
    setAproposIA(!aProposIA);
    //on simile la connexion au niveau du localStorage
    const id = "0217772525";
    localStorage.setItem("https://alrani.com/idPersonneConnecterIA", id);
    const name = "Kilendo D. VB";
    localStorage.setItem("https://alrani.com/nomPersonneConnecterIA", name);
    const nomMere = "Diane Clau";
    localStorage.setItem(
      "https://alrani.com/nomMerePersonneConnecterIA",
      nomMere
    );
    const adresse = "NGanda-Tsimba, Dolisie, Niari";
    localStorage.setItem(
      "https://alrani.com/adressePersonneConnecterIA",
      adresse
    );
    const numeroTelephone = "+5514991550021";
    localStorage.setItem(
      "https://alrani.com/numeroTelephonePersonneConnecterIA",
      numeroTelephone
    );
    const dateNaissance = "10/02/2000";
    localStorage.setItem(
      "https://alrani.com/dateNaissancePersonneConnecterIA",
      dateNaissance
    );
  }

  //module acheter - IA
  /*
  const getTransfert = localStorage.getItem(
    "https://alrani.com/ModuleTransfertIA"
  );
  const moduleTransfert = getTransfert === "1";
*/
  //footer mini Menu - IA
  //on affiche le mini menu en bottom
  const [footerMiniMenuIA, setFooterMiniMenuIA] = useState(false);
  async function FooterMiniMenuIA() {
    setFooterMiniMenuIA(true);
  }
  //fermer le mini menu
  async function CloseFooterMiniMenuIA() {
    setFooterMiniMenuIA(false);
  } 

  // Tools - IA
  // Tools - IA
  // on affiche mes outils
  const [toolsIA, setToolsIA] = useState(false);
  async function ToolsIA() {
    setToolsIA(true);
  }
  //fermer
  async function CloseToolsIA() {
    setToolsIA(false);
  }
  
  // Plus - IA
  // sur cette page on affiche les outils a activer
  const [plusIA, setPlusIA] = useState(false);
  async function PlusIA() {
    setPlusIA(true);
  }
  //fermer
  async function ClosePlusIA() {
    setPlusIA(false);
  }

  // activate Identification Page - IA
  // sur cette page on active izocash Identification
  const [activateIdentificationPageIA, setActivateIdentificationPageIA] = useState(false);
  async function ActivateIdentificationPageIA() {
    setActivateIdentificationPageIA(true);
  }
  //fermer
  async function CloseActivateIdentificationPageIA() {
    setActivateIdentificationPageIA(false);
  }

  // activate Identification Deals (Page) - IA
  // sur cette page on active la Identification Deals - IA
  const [activateIdentificationDealsPageIA, setActivateIdentificationDealsPageIA] = useState(false);
  async function ActivateIdentificationDealsPageIA() {
    setActivateIdentificationDealsPageIA(true);
  }
  //fermer
  async function CloseActivateIdentificationDealsPageIA() {
    setActivateIdentificationDealsPageIA(false);
  }

  // activate Identification Formation (Page) - IA
  // sur cette page on active Identification Formation - IA
  const [activateIdentificationFormationPageIA, setActivateIdentificationFormationPageIA] = useState(false);
  async function ActivateIdentificationFormationPageIA() {
    setActivateIdentificationFormationPageIA(true);
  }
  //fermer
  async function CloseActivateIdentificationFormationPageIA() {
    setActivateIdentificationFormationPageIA(false);
  }

  // Identification (Page) - IA
  // sur cette page on affiche le solde, la base de donnees,...
  const [identificationPageIA, setIdentificationPageIA] = useState(false);
  /*async function IdentificationPageIA() {
    setIdentificationPageIA(true);
  }*/
  //fermer
  async function CloseIdentificationPageIA() {
    setIdentificationPageIA(false);
  }

  // Identification Deals - IA
  // sur cette page on affiche le solde, la base de donnees,...
  const [identificationDealsIA, setIdentificationDealsIA] = useState(false);
  async function IdentificationDealsIA() {
    setIdentificationDealsIA(true);
  }
  //fermer
  async function CloseIdentificationDealsIA() {
    setIdentificationDealsIA(false);
  }

  // Identification Formation - IA
  // sur cette page on affiche le solde, la base de donnees,...
  const [identificationFormationIA, setIdentificationFormationIA] = useState(false);
  async function IdentificationFormationIA() {
    setIdentificationFormationIA(true);
  }
  //fermer
  async function CloseIdentificationFormationIA() {
    setIdentificationFormationIA(false);
  }

  // saisir montant - IA
  const [writeAmount, setWriteAmount] = useState("");
  const [writeVirtualNumber, setWriteVirtualNumber] = useState("");

  if (writeAmount) {
    localStorage.setItem("writeAmount", writeAmount);
  }

  if (writeVirtualNumber) {
    localStorage.setItem("writeVirtualNumber", writeVirtualNumber);
  }

  // international Plus - IA
  // c'est le menu pour international Plus
  const [internationalPlusIA, setInternationalPlusIA] = useState(false);
  async function InternationalPlusIA() {
    setInternationalPlusIA(true);
  }
  //fermer
  async function CloseInternationalPlusIA() {
    setInternationalPlusIA(false);
  }

  // my recharge National Page - IA
  // page pour recharger mon compte national - IA
  const [myRechargeNationalPageIA, setMyRechargeNationalPageIA] = useState(false);
  async function MyRechargeNationalPageIA() {
    setMyRechargeNationalPageIA(true);
  }
  //fermer
  async function CloseMyRechargeNationalPageIA() {
    setMyRechargeNationalPageIA(false);
  }

  // my Recharge National Confirmation - IA
  // Confirmer my recharge National 
  const [myRechargeNationalConfirmationIA, setMyRechargeNationalConfirmationIA] = useState(false);
  async function MyRechargeNationalConfirmationIA() {
    setMyRechargeNationalConfirmationIA(true);
  }
  //fermer
  async function CloseMyRechargeNationalConfirmationIA() {
    setMyRechargeNationalConfirmationIA(false);
  }

  // my recharge National Success - IA
  const [myRechargeNationalSuccessPageIA, setMyRechargeNationalSuccessPageIA] = useState(false);
  async function CloseMyRechargeNationalSuccessPageIA() {
    setMyRechargeNationalSuccessPageIA(false);
  }

  // logique pour recharger mon compte national depuis mon compte international - IA
  // on met my devant juste pour differencier avec la recharge national de l'agence
  async function MyRechargeNationalIA() {
    setOpacity(true);

    // montant saisi
    const writeAmountIA = localStorage.getItem("writeAmount");
    
    //1ere requete
    //1ere requete
    // recharger mon compte national
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
      data: {
        balanceNationalAccount: writeAmountIA,
      },
    }).then((res) => {
      
        //2e requete
        //2e requete
        // recharge national éffectuer alors on cree une notification
        async function deuxiemeReq() {
          const notification = "10"; // my recharge national success
          //const idOther = localStorage.getItem("https://alrani.com/idOther");
          //const nameOther = localStorage.getItem("https://alrani.com/nameOther");

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
            data: {
              idOwner: idPersonConnectedIA,
              //nameOwner: namePersonConnectedIA,
              //idOther: idOther,
              //nameOther: nameOther,
              notification: notification,
            },
          }).then((res) => {
            // notification creer, on affiche le message de success: recharge reussie
            setMyRechargeNationalSuccessPageIA(true);
            setOpacity(false);
          })
          .catch((err) => {
            // erreur, impossible de creer la notification. mais on affiche quand meme le message de success
            setMyRechargeNationalSuccessPageIA(true);
            setOpacity(false);
          });
        }
        deuxiemeReq();
        //2e requete
    })
    .catch((err) => {
      // erreur, impossible de recharger mon compte national
      setOpacity(false);
      setErrorIA(true);
    });
    //1ere requete
  }
  // logique pour recharger mon compte national depuis mon compte international - IA
  

  // national Plus - IA
  // c'est le menu pour national Plus
  const [nationalPlusIA, setNationalPlusIA] = useState(false);
  async function NationalPlusIA() {
    setNationalPlusIA(true);
  }
  //fermer
  async function CloseNationalPlusIA() {
    setNationalPlusIA(false);
  }

  // Recharge Alrani Pay (Page) - IA 
  // page pour recharger mon compte Alrani Pay
  const [rechargeAlraniPayPageIA, setRechargeAlraniPayPageIA] = useState(false);
  async function RechargeAlraniPayPageIA() {
    setRechargeAlraniPayPageIA(true);
  }
  //fermer
  async function CloseRechargeAlraniPayPageIA() {
    setRechargeAlraniPayPageIA(false);
  }

  // Recharge Alrani Pay Confirmation - IA
  // confirmer si tu veux vraiment recharger ton compte Alrani Pay
  const [rechargeAlraniPayConfirmationIA, setRechargeAlraniPayConfirmationIA] = useState(false);
  async function RechargeAlraniPayConfirmationIA() {
    setRechargeAlraniPayConfirmationIA(true);
  }
  async function CloseRechargeAlraniPayConfirmationIA() { //fermer
    setRechargeAlraniPayConfirmationIA(false);
  }

  //recharge Alrani Pay réussie (message de success) - IA
  const [rechargeAlraniPaySuccessIA, setRechargeAlraniPaySuccessIA] = useState(false);
  async function CloseRechargeAlraniPaySuccessIA() {
    setRechargeAlraniPaySuccessIA(false);
  }

  //error Recharge Alrani Pay (message d'erreur) - IA
  const [errorRechargeAlraniPayIA, setErrorRechargeAlraniPayIA] = useState(false);
  async function CloseErrorRechargeAlraniPayIA() {
    setErrorRechargeAlraniPayIA(false);
  }

  //saisir montant a recharger dans le solde Alrani Pay
  const [writeAmountIA, setWriteAmountIA] = useState("");
  if (writeAmountIA) { localStorage.setItem("writeAmountIA", writeAmountIA); }

  // logique pour recharger mon compte Alrani Pay depuis mon compte izocash
   async function RechargeAlraniPay() {
     
    // 1ere requete
    // 1ere requete
    // obtenir l'id du compte Alrani Pay (Avec cet id on va recharger son compte Alrani Pay)
    async function premiereReq() {
      setOpacity(true);
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
       .then((res) => {
        const writeAmount = localStorage.getItem("writeAmountIA");
        const virtualNumberPersonConnected = localStorage.getItem("virtualNumberPersonConnectedIA");

        // filtre compte Alrani Pay
        const apiUser = res.data;
        const filterUser = apiUser.filter((api) => api.virtualNumber === virtualNumberPersonConnected);

        const idUser = filterUser.map((api) => api._id); // idUser
        if (idUser) { localStorage.setItem("idUser", idUser); }

        const nameUser = filterUser.map((api) => api.nameUser); // nameUser
        if (nameUser) { localStorage.setItem("nameUser", nameUser); }

        const oldBalanceAlraniPay = filterUser.map((api) => api.balanceAlraniPay); // ancien solde Alrani Pay
        if (oldBalanceAlraniPay) { localStorage.setItem("oldBalanceAlraniPay", oldBalanceAlraniPay); }
        
        // calcul du nouveau solde alrani pay
        const newBalanceAlraniPay = parseInt(oldBalanceAlraniPay) + parseInt(writeAmount)
        if (newBalanceAlraniPay) { localStorage.setItem("newBalanceAlraniPay", newBalanceAlraniPay); }

        console.log("idUser", idUser);
        console.log("nameUser", nameUser);
        console.log("virtualNumberPersonConnected", virtualNumberPersonConnected);
        console.log("ancien solde alrani pay", oldBalanceAlraniPay);
        console.log("nouveau solde alrani pay", newBalanceAlraniPay);

    // 2e requete
    // 2e requete
    // obtenir les infos du compte izocash (compte national)
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
      .then((res) => {
       const writeAmount = localStorage.getItem("writeAmountIA");

        //filtre compte national
        const apiAccount = res.data;
        const filterAccount = apiAccount.filter((api) => api._id === idPersonConnectedIA);

        const oldBalanceNational = filterAccount.map((api) => api.balanceNationalAccount); // ancien solde national
        if (oldBalanceNational) { localStorage.setItem("oldBalanceNational", oldBalanceNational) }
        
        // calcul des frais
        const fees = parseInt(writeAmount) * 3 / 100;
        if (fees) { localStorage.setItem("fees", fees) }

        // calcul du montant a payer
        const total = parseInt(writeAmount) + parseInt(fees);
        if (total) { localStorage.setItem("total", total) }
        
        // calcul du nouveau solde national
        const newBalanceNational = parseInt(oldBalanceNational) - parseInt(total);
        if (newBalanceNational) { localStorage.setItem("newBalanceNational", newBalanceNational) }

        console.log("montant a recharger", writeAmount);
        console.log("frais de recharge", fees);
        console.log("montant a payer", total);
        console.log("ancien solde national", oldBalanceNational);
        console.log("nouveau solde national", newBalanceNational);

        if (newBalanceNational > -1) {
        //dans ce cas: solde national suffisant (vous pouvez recharger le compte alrani pay)
        console.log("solde national suffisant");
      
      //3e requete
      //3e requete
      // on debite le solde national (nouveau solde national)
      async function troisiemeReq() {
        const newBalanceNational = localStorage.getItem("newBalanceNational");
        await axios({ 
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
          data: {
            balanceNationalAccount: newBalanceNational,
          },
        })
        .then((res) => {
        
      //4e requete
      //4e requete
      // on recharge le compte alrani pay
      async function quatriemeReq() {
        const idUser = localStorage.getItem("idUser");
        const newBalanceAlraniPay = localStorage.getItem("newBalanceAlraniPay");
        
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idUser}`,
          data: {
            balanceAlraniPay: newBalanceAlraniPay,
          },
        })
        .then((res) => {

      //5e requete
      //5e requete
      // recharge éffectuer alors on l'envoie la notification pour qu'il sache qu'il a fait un depot dans le compte du client
      async function cinquiemeReq() {
        const id = localStorage.getItem("createIdNotificationIA");
        const notification = "17"; // recharge alrani pay success
        const fees = localStorage.getItem("fees");
        const amount = localStorage.getItem("writeAmount");
        const total = localStorage.getItem("total");
        const idOther = localStorage.getItem("idUser"); //id 
        const nameOther = localStorage.getItem("nameUser");
        const oldBalanceOther = localStorage.getItem("oldBalanceAlraniPay"); //ancien solde alrani pay
        const newBalanceOther = localStorage.getItem("newBalanceAlraniPay"); //nouveau solde alrani pay
        const oldBalanceOwner = localStorage.getItem("oldBalanceNational"); //ancien solde national
        const newBalanceOwner = localStorage.getItem("newBalanceNational"); //nouveau solde national
        const display = "1";
        const visible = "1";
        const connection = "1";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
          data: {
            id,
            notification: notification,
            idOwner: idPersonConnectedIA,
            nameOwner: namePersonConnectedIA,
            oldBalanceOwner, //ancien solde national
            newBalanceOwner, //nouveau solde national
            fees, // frais
            amount, // montant a recharger
            total, // montant a payer
            idOther,
            nameOther,
            oldBalanceOther, //ancien solde alrani pay
            newBalanceOther, //nouveau solde alrani pay
            display,
            visible,
            connection,
          },
        }).then((res) => {


        //6e requete
        //6e requete
        // obtenir les nouvelles donnees
        async function sixiemeReq() {
         console.log("debut de la 6e requete (recharge alrani Pay)");
         await axios
         .get(`${process.env.REACT_APP_BACKEND}/api/notificationIA`)
         .then((res) => {
          setApiNotificationIA(res.data);
          setRechargeAlraniPaySuccessIA(true);
          setOpacity(false);
          console.log("6e requete reussie (recharge alrani Pay)");

        //7e requete
        //7e requete
        // obtenir les nouvelles donnees (on le fait pour pouvoir lui afficher le nouveau solde national)
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
          .then((res) => {
            setApiAccountIA(res.data);
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        septiemeReq()
        //7e requete
      })
      .catch((err) => {
        console.log("6e requete echouer (recharge alrani Pay)");
        setOpacity(false);
        setErrorIA(true); 
      });
      }
      sixiemeReq()
      //6e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); 
    });
    }
    cinquiemeReq()
    //5e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true); 
        });
        }
        quatriemeReq();
        //4e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
      }
      troisiemeReq();
      //3e requete
      } else {
        //dans ce cas: solde national insuffisant (impossible de recharger son compte alrani pay)
        console.log("dans ce cas: solde national insuffisant (impossible de faire la recharge Alrani pay)");
        setErrorRechargeAlraniPayIA(true);
        setOpacity(false);
      } 
      //if (newBalanceNational > -1) {
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); 
    });
    }
    deuxiemeReq();
    //2e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true); 
    });
  }
  premiereReq();
  //1ere requete
  }
  

  //01
  //01. passer a l'etape suivante (ProcessusValidationCompte) - IA
  const [
    etapeUnProcessusValidationCompteIA,
    setEtapeUnProcessusValidationCompteIA,
  ] = useState(false);
  //fermer la page
  async function CloseEtapeUnProcessusValidationCompteIA() {
    setEtapeUnProcessusValidationCompteIA(false);
  }
  //02
  //02. passer a l'etape suivante (ProcessusValidationCompte) - IA
  const [
    etapeDeuxProcessusValidationCompteIA,
    setEtapeDeuxProcessusValidationCompteIA,
  ] = useState(false);
  async function EtapeDeuxProcessusValidationCompteIA() {
    setEtapeDeuxProcessusValidationCompteIA(true);
    //c'est une entreprise (valeur par defaut) - IA
    /*
    on a mis ca ici parce qu'on veut que la valeur par defaut soit ce n'est pas une entreprise,
    cela veut dire que si l'agent n'a pas cocher sur la case C'est une entreprise alors c'est
    cette valeur 0 qui sera considéré; c'est la valeur par defaut qu'on a mis ici qui sera 
    pris en compte */
    const valeurParDefaut = "0";
    localStorage.setItem(
      "https://alrani.com/cestUneEntrepriseIA",
      valeurParDefaut
    );
  }
  //fermer la page
  async function CloseEtapeDeuxProcessusValidationCompteIA() {
    setEtapeDeuxProcessusValidationCompteIA(false);
  }
  //03
  //03. passer a l'etape suivante (ProcessusValidationCompte) - IA
  const [
    etapeTroisProcessusValidationCompteIA,
    setEtapeTroisProcessusValidationCompteIA,
  ] = useState(false);
  async function EtapeTroisProcessusValidationCompteIA() {
    setEtapeTroisProcessusValidationCompteIA(true);
  }
  //fermer la page
  async function CloseEtapeTroisProcessusValidationCompteIA() {
    setEtapeTroisProcessusValidationCompteIA(false);
  }

  /* lors de la validation d'un compte izocash, s'il s'agit d'une entreprise, l'agent va 
  cocher la case c'est une entreprise */
  const [entrepriseActiveIA, setEntrepriseActiveIA] = useState(false);

  // dans ce cas, la case c'est une entreprise est cocher,
  async function EntrepriseActiveIA() {
    setEntrepriseActiveIA(true);
    /*si c'est une entreprise, on mets la valeur 1, cette valeur sera coller a la racine de 
    son compte izocash */
    const cestUneEntreprise = "1";
    localStorage.setItem(
      "https://alrani.com/cestUneEntrepriseIA",
      cestUneEntreprise
    );
  }

  // dans ce cas, la case c'est une entreprise est décocher
  async function EntrepriseNonActiveIA() {
    setEntrepriseActiveIA(false);
    /*si ce n'est pas une entreprise, on mets la valeur 0, cette valeur sera coller a la racine 
    de son compte izocash */
    const cestUneEntreprise = "0";
    localStorage.setItem(
      "https://alrani.com/cestUneEntrepriseIA",
      cestUneEntreprise
    );
  }

  // listes des langues - IA
  //on affiche la liste des langues
  const [langueLocalisationIA, setLangueLocalisationIA] = useState(false);
  async function LangueLocalisationIA() {
    setLangueLocalisationIA(true);
  }
  //fermer
  async function CloseLangueLocalisationIA() {
    setLangueLocalisationIA(false);
  }

  // listes des Pays - IA
  //on affiche la liste des Pays
  const [paysLocalisationIA, setPaysLocalisationIA] = useState(false);
  async function PaysLocalisationIA() {
    setPaysLocalisationIA(true);
  }
  //fermer
  async function ClosePaysLocalisationIA() {
    setPaysLocalisationIA(false);
  }

  // listes des villes - IA
  //on affiche la liste des villes
  const [villeLocalisationIA, setVilleLocalisationIA] = useState(false);
  /*async function VilleLocalisationIA() {
    setVilleLocalisationIA(true);
  }*/
  //fermer
  async function CloseVilleLocalisationIA() {
    setVilleLocalisationIA(false);
  }

  const [masquerVilleIA, setMasquerVilleIA] = useState(false);
  async function MasquerVilleIA() {
    const listeVille = localStorage.getItem(
      "https://alrani.com/clicListeVilles"
    );
    if (listeVille === "1") {
      setVilleLocalisationIA(true);
    }

    const masquerVille = localStorage.getItem(
      "https://alrani.com/clicMasquerVille"
    );
    if (masquerVille === "1") {
      setMasquerVilleIA(true);
    }
  }

  async function CloseMasquerVilleIA() {
    setMasquerVilleIA(false);
  }

  // listes des quartiers - IA
  //on affiche la liste des quartiers
  const [quartierLocalisationIA, setQuartierLocalisationIA] = useState(false);
  async function QuartierLocalisationIA() {
    setQuartierLocalisationIA(true);
  }
  //fermer
  async function CloseQuartierLocalisationIA() {
    setQuartierLocalisationIA(false);
  }

  // listes des zones - IA
  //on affiche la liste des zones
  const [zoneLocalisationIA, setZoneLocalisationIA] = useState(false);
  async function ZoneLocalisationIA() {
    setZoneLocalisationIA(true);
  }
  //fermer
  async function CloseZoneLocalisationIA() {
    setZoneLocalisationIA(false);
  }

  // recapitulatif Localisation - IA
  //on affiche le recapitulatif de la Localisation
  const [recapitulatifLocalisationIA, setRecapitulatifLocalisationIA] =
    useState(false);
  async function RecapitulatifLocalisationIA() {
    setRecapitulatifLocalisationIA(true);
  }
  //fermer
  async function CloseRecapitulatifLocalisationIA() {
    setRecapitulatifLocalisationIA(false);
  }

  //on enregistre la Localisation (zone d'habitation) - IA
  /*quand on clique sur une donnees, ca ne s'enregistre pas directement sur les variables
  enregistrées, on les mets d'abord dans des variables selectionnées. Maintenant quand 
  l'utilisateur va cliquer sur Enregistrer, c'est a ce moment qu'on va les prendres dans les 
  variables selectionnées pour les mettres dans les variables enregistrées */
  async function EnregistrerLocalisationIA() {
    //ici on prend les donnees dans les variables selectionnées
    //Pays Selectionner
    const idPaysSelectionner = localStorage.getItem(
      "https://alrani.com/idcountrySelected"
    );
    const nomPaysSelectionner = localStorage.getItem(
      "https://alrani.com/nomPaysSelectionnerIA"
    );
    //Ville Selectionner
    const idVilleSelectionner = localStorage.getItem(
      "https://alrani.com/idVilleSelectionnerIA"
    );
    const nomVilleSelectionner = localStorage.getItem(
      "https://alrani.com/nomVilleSelectionnerIA"
    );
    //Quartier Selectionner
    const idQuartierSelectionner = localStorage.getItem(
      "https://alrani.com/idQuartierSelectionnerIA"
    );
    const nomQuartierSelectionner = localStorage.getItem(
      "https://alrani.com/nomQuartierSelectionnerIA"
    );
    //Zone Selectionner
    const idZoneSelectionner = localStorage.getItem(
      "https://alrani.com/idZoneSelectionnerIA"
    );
    const nomZoneSelectionner = localStorage.getItem(
      "https://alrani.com/nomZoneSelectionnerIA"
    );
    /* ici on actualise les donnees, on prend les donnees qui etait dans les variables 
    selectionnées, on les mets dans les variables enregistrées */
    //pays
    localStorage.setItem("https://alrani.com/idPaysIA", idPaysSelectionner);
    localStorage.setItem("https://alrani.com/nomPaysIA", nomPaysSelectionner);
    //ville
    localStorage.setItem("https://alrani.com/idVilleIA", idVilleSelectionner);
    localStorage.setItem("https://alrani.com/nomVilleIA", nomVilleSelectionner);
    //Quartier
    localStorage.setItem(
      "https://alrani.com/idQuartierIA",
      idQuartierSelectionner
    );
    localStorage.setItem(
      "https://alrani.com/nomQuartierIA",
      nomQuartierSelectionner
    );
    //zone
    localStorage.setItem("https://alrani.com/idZoneIA", idZoneSelectionner);
    localStorage.setItem("https://alrani.com/nomZoneIA", nomZoneSelectionner);
    //apres avoir enregistrer, ici on ferme les pages
    setLangueLocalisationIA(false);
    setPaysLocalisationIA(false);
    setVilleLocalisationIA(false);
    setQuartierLocalisationIA(false);
    setZoneLocalisationIA(false);
    setRecapitulatifLocalisationIA(false);
  }

  // ajouter un quartier - IA
  // la page ci permet a l'agent d'ajouter un quartier
  const [ajouterQuartierIA, setAjouterQuartierIA] = useState(false);
  async function AjouterQuartierIA() {
    setAjouterQuartierIA(true);
  }
  //fermer
  async function CloseAjouterQuartierIA() {
    setAjouterQuartierIA(false);
  }

  // ajouter une zone - IA
  // la page ci permet a l'agent d'ajouter une zone
  const [ajouterZoneIA, setAjouterZoneIA] = useState(false);
  async function AjouterZoneIA() {
    setAjouterZoneIA(true);
  }
  //fermer
  async function CloseAjouterZoneIA() {
    setAjouterZoneIA(false);
  }

  // ajout Localisation Success - IA
  /* si le collaborateuur a pu ajouter un quartier, une ville,... on va l'afficher
  ce message de succeSs */
  const [ajoutLocalisationSuccessIA, setAjoutLocalisationSuccessIA] =
    useState(false);
  async function AjoutLocalisationSuccessIA() {
    setAjoutLocalisationSuccessIA(true);
  }
  //fermer
  async function CloseAjoutLocalisationSuccessIA() {
    setAjoutLocalisationSuccessIA(false);
  }

  // erreur - IA
  /* on affiche ce message d'erreur si une erreur est rencontrer par exemple lorsque 
  l'agent ajoute un pays, une langue,... et que ca ne fonctionne pas pour telle ou 
  telle raison alors ce message d'erreur s'affichera */
  const [erreurRencontrerIA, setErreurRencontrerIA] = useState(false);
  async function ErreurRencontrerIA() {
    setErreurRencontrerIA(true);
  }
  //fermer
  async function CloseErreurRencontrerIA() {
    setErreurRencontrerIA(false);
  }


  //Izocash International - IA
  /*on affiche la page qui va permettre a la personne de demarrer le processus pour 
  transferer de largent */
  const [izocashInternational, setIzocashInternational] = useState(false);
  async function IzocashInternational() {
    setIzocashInternational(true);
  }
  //fermer
  async function CloseIzocashInternational() {
    setIzocashInternational(false);
  }

  // logique pour envoyer de l'argent - IA
  // logique pour envoyer de l'argent - IA
  // saisir numero du beneficiaire, montant a envoyer
  const [writeVirtualNumberBeneficiaryIA, setWriteVirtualNumberBeneficiaryIA] = useState("");
  const [writeAmountToSendIA, setWriteAmountToSendIA] = useState("");

  if (writeVirtualNumberBeneficiaryIA) { localStorage.setItem("writeVirtualNumber", writeVirtualNumberBeneficiaryIA); } //numero virtuel
  if (writeAmountToSendIA) { localStorage.setItem("writeAmount", writeAmountToSendIA); } //montant a envoyer

  // logique pour envoyer de l'argent (dans le compte National IA)
  async function TransfertNationalIA() {
    
    // 1ere requete
    // 1ere requete
    // obtenir le solde de l'envoyeur et du beneficiaire
    async function premiereReq() {
      setOpacity(true);
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
      .then((res) => {
        //on filtre en fonction de l'idPersonConnectedIA
        const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
        const amountToSend = localStorage.getItem("writeAmount");
        const api = res.data;

        // filtre Beneficiaire
        const filterReceiver = api.filter((api) => api.virtualNumber === writeVirtualNumber);
        const idReceiver = filterReceiver.map((api) => api._id); // id receiver
        if (idReceiver) { localStorage.setItem("idReceiver", idReceiver); }

        const nameReceiver = filterReceiver.map((api) => api.nameAccount); // name receiver
        if (nameReceiver) { localStorage.setItem("nameReceiver", nameReceiver); }

        const oldBalanceReceiver = filterReceiver.map((api) => api.balanceNationalAccount); // solde receiver
        if (oldBalanceReceiver) { localStorage.setItem("oldBalanceNationalReceiver", oldBalanceReceiver); }
        
        // verification numero virtuel
        const filterVirtualNumber = api.filter((api) => api.virtualNumber === writeVirtualNumber && api.identification === "1"); //on verifie si le numero virtuel existe et qu'il est deja identifié
        const verificationVirtualNumber = filterVirtualNumber.length > 0;


        // filtre Envoyeur
        const filterSender = api.filter((api) => api._id === idPersonConnectedIA);
        const oldBalanceSender = filterSender.map((api) => api.balanceNationalAccount); // solde sender
        if (oldBalanceSender) { localStorage.setItem("oldBalanceNationalSender", oldBalanceSender); }

        // on fait le calcul
        const fees = parseInt(amountToSend) * 1 / 100; //fees (calcul des frais de transfert)
        if (fees) { localStorage.setItem("fees", fees); }

        const total = parseInt(amountToSend) + parseInt(fees) //total
        if (total) { localStorage.setItem("total", total); }

       

        // calcul des nouveaux soldes
        const newBalanceSender = parseInt(oldBalanceSender) - parseInt(amountToSend) - parseInt(fees); //nouveau solde de l'envoyeur
        if (newBalanceSender) { localStorage.setItem("newBalanceNationalSender", newBalanceSender); }

        const newBalanceReceiver = parseInt(oldBalanceReceiver) + parseInt(amountToSend) //nouveau solde du beneficiaire
        if (newBalanceReceiver) { localStorage.setItem("newBalanceNationalReceiver", newBalanceReceiver); }

        const verifiedBalanceNationalSender = newBalanceSender > 0; //verifiedBalanceNationalSender > 0 alors on transfere l'argent, verifiedBalanceNationalSender < 0 alors on ne transfere pas l'argent
     
        if (verificationVirtualNumber) { //on verifie si le numero virtuel est deja identifier
          // dans ce cas: numero virtuel deja identifier

        if (verifiedBalanceNationalSender) {
          // dans ce cas: solde national suffisant (on debite le solde de l'envoyeur puis on effectue le transfert d'argent)
          
          //2e requete
          //2e requete
          // debiter le solde de l'envoyeur (on debite le solde de l'envoyeur puis on envoie cet argent au beneficiaire)
          async function deuxiemeReq() {
            const newBalanceSender = localStorage.getItem("newBalanceNationalSender");

            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
              data: {
                balanceNationalAccount: newBalanceSender,
              },
            })
            .then((res) => {
                      
          //3e requete
          //3e requete
          // deposer l'argent dans le compte du beneficiaire
          async function troisiemeReq() {
            const idReceiver = localStorage.getItem("idReceiver");
            const newBalanceReceiver = localStorage.getItem("newBalanceNationalReceiver");
                
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idReceiver}`,
              data: {
                balanceNationalAccount: newBalanceReceiver,
              },
            })
            .then((res) => {

          //4e requete
          //4e requete
          // obtenir de nouvelles donnees (on actualise le nouveau solde national de l'envoyeur et on le lui affiche)
          async function quatriemeReq() {
            await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
              .then((res) => {
                const api = res.data;
                const filterAccount = api.filter((api) => api._id === idPersonConnectedIA);

                const balance = filterAccount.map((api) => api.balanceNationalAccount); //solde national
                if (balance) { localStorage.setItem("balanceNationalAccountIA", balance); }

            //5e requete
            //5e requete
            // on cree une notification (transfert d'argent reussie)
            async function cinquiemeReq() {
              const notification = "4"; // transfert national reussie
              const idOther = localStorage.getItem("idReceiver");
              const nameOther = localStorage.getItem("nameReceiver");
              const amount = localStorage.getItem("writeAmount");
              const fees = localStorage.getItem("fees");
              const total = localStorage.getItem("total");
              const oldBalanceOwner = localStorage.getItem("oldBalanceNationalSender");
              const newBalanceOwner = localStorage.getItem("newBalanceNationalSender");
              const oldBalanceOther = localStorage.getItem("oldBalanceNationalReceiver");
              const newBalanceOther = localStorage.getItem("newBalanceNationalReceiver");

              await axios({
              method: "post",
              url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
              data: {
                notification,
                amount, // montant envoyé
                fees, // frais de transfert
                total, // total
                idOwner: idPersonConnectedIA,
                nameOwner: namePersonConnectedIA, // nom de l'envoyeur
                oldBalanceOwner, // ancien solde de l'envoyeur
                newBalanceOwner, // nouveau solde de l'envoyeur
                idOther,
                nameOther, // nom du beneficiaire
                oldBalanceOther, // ancien solde du beneficiaire
                newBalanceOther, // nouveau solde du beneficiaire
              },
            }).then((res) => {
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
          }
          cinquiemeReq();
          //5e requete
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
          }
          quatriemeReq();
          //4e requete
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
          }
          troisiemeReq();
          //3e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true);
        });
      }
      deuxiemeReq();
      // 2e requete
        } else {
          //dans ce cas: solde de l'envoyeur insuffisant
          setOpacity(false);
          setErrorIA(true);
        }
        // le if de verifiedBalanceNationalSender se ferme ici
      } else {
        //dans ce cas: numero virtuel non identifier
        setOpacity(false);
        setErrorIA(true);
        console.log("numero virtuel non identifier ou n'existe pas");
      }
      // le if de verificationVirtualNumber se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    premiereReq();
    // 1ere requete
  }


  //double benefice (page) - IA
  const [doubleProfit666izocashDeals, setDoubleProfit666izocashDeals] = useState(false);
  async function DoubleProfit666izocashDeals() {
    setDoubleProfit666izocashDeals(true);
  }
  async function CloseDoubleProfit666izocashDeals() { //fermer
    setDoubleProfit666izocashDeals(false);
  }

  // double bénéfice activé (message de success) - IA
  const [doubleProfitSuccessIA, setDoubleProfitSuccessIA] = useState(false);
  async function CloseDoubleProfitSuccessIA() {
    setDoubleProfitSuccessIA(false);
  }

  // logique pour activer le double benefice
  async function ActivateDoubleProfitIA() {
    
    // 1ere requete
    // 1ere requete
    // on prend l'id de l'outil pour pouvoir modifier le super code 
    async function premiereReq() {
      setOpacity(true);

      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/toolIA`)
      .then((res) => {
        const apiTool = res.data;

        const filterTool = apiTool.filter((api) => api.idAccount === idPersonConnectedIA && api.type === "1"); //type=1, izocash deals
        const idTool = filterTool.map((api) => api._id); //idTool
        if (idTool) { localStorage.setItem("idTool", idTool) }

    //2e requete
    //2e requete
    // on active le double benefice
    async function deuxiemeReq() {
      const idTool = localStorage.getItem("idTool");
      const izocashDealsDoubleProfit = "1";

      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/toolIA/update/${idTool}`,
        data: {
          izocashDealsDoubleProfit,
        },
      }).then((res) => {

        // 3e requete
        // 3e requete
        // obtenir de nouvelles donnees
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/toolIA`)
          .then((res) => {
            setApiToolIA(res.data);
            setOpacity(false);
            setDoubleProfitSuccessIA(true);
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        troisiemeReq()
        // 3e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true);
        });
      }
      deuxiemeReq()
      // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    premiereReq()
    // 1ere requete
  }


  //menu (666 izocash Deals) - IA
  const [menu666izocashDealsIA, setMenu666izocashDealsIA] = useState(false);
  async function Menu666izocashDealsIA() {
    setMenu666izocashDealsIA(true);
  }
  async function CloseMenu666izocashDealsIA() { //fermer
    setMenu666izocashDealsIA(false);
  }

  //infos (666 izocash Deals) - IA
  const [infos666izocashDealsIA, setInfos666izocashDealsIA] = useState(false);
  async function Infos666izocashDealsIA() {
    setInfos666izocashDealsIA(true);
  }
  async function CloseInfos666izocashDealsIA() { //fermer
    setInfos666izocashDealsIA(false);
  }

  // super code enregistré (message de success)
  const [superCodeSuccessIA, setSuperCodeSuccessIA] = useState(false);
  async function CloseSuperCodeSuccessIA() {
    setSuperCodeSuccessIA(false);
  }


  // izocash Deals - IA
  /* sur cette page on va afficher la liste des personnes qui ont acheter leur numero 
  virtuel avec mon super code, on va aussi afficher mon solde izocash Deals */
  const [izocashDealsIA, setIzocashDealsIA] = useState(false);
  async function IzocashDealsIA() {
    setIzocashDealsIA(true);
  }
  async function CloseIzocashDealsIA() { //fermer
    setIzocashDealsIA(false);
  }

  // saisir super code izocash deals (page) . ici c'est pour masquer/afficher la partie qui permet de saisir le super code izocash deals
const [writeSuperCodeIzocashDealsPageIA, setWriteSuperCodeIzocashDealsPageIA] = useState(false);
  async function WriteSuperCodeIzocashDealsPageIA() {
    setWriteSuperCodeIzocashDealsPageIA(!writeSuperCodeIzocashDealsPageIA);
  }

  //saisir super code
  const [writeSuperCode, setWriteSuperCode] = useState(""); 
  if (writeSuperCode) { localStorage.setItem("writeSuperCode", writeSuperCode) }

  // logique pour ajouter/remplacer mon Super code izocash Deals 
  async function SaveIzocashDealsCodeIA() {
    setOpacity(true);
    console.log("a1")

    // 1ere requete
    // 1ere requete
    // on prend l'id de l'outil pour pouvoir modifier le super code 
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/toolIA`)
      .then((res) => {
        const apiTool = res.data;

        const filterTool = apiTool.filter((api) => api.idAccount === idPersonConnectedIA && api.type === "1" && api.visible === "1"); //type=1, izocash deals
        const idTool = filterTool.map((api) => api._id); //idTool
        if (idTool) { localStorage.setItem("idTool", idTool) }
        console.log("a2", apiTool);
        console.log("a3", filterTool);
        console.log("a4", idTool);
  
    //2e requete
    //2e requete
    // on modifie le super code
    async function deuxiemeReq() {
      const idTool = localStorage.getItem("idTool");
      const izocashDealsCode = localStorage.getItem("writeSuperCode");

      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/toolIA/update/${idTool}`,
        data: {
          izocashDealsCode,
        },
      }).then((res) => {
        
        // 3e requete
        // 3e requete
        // obtenir de nouvelles donnees
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/toolIA`)
          .then((res) => {
            setApiToolIA(res.data);

            setOpacity(false);
            setSuperCodeSuccessIA(true);
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        troisiemeReq();
        // 3e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true);
        });
      }
      deuxiemeReq()
      // 2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    premiereReq()
    // 1ere requete
  }


  //izocashBuy 2 - IA
  const [izocashBuy2IA, setIzocashBuy2IA] = useState(false);
  async function IzocashBuy2IA() {
    setIzocashBuy2IA(true);
  }
  //fermer
  async function CloseIzocashBuy2IA() {
    setIzocashBuy2IA(false);
  }

  // head 1 (Commissions) - IA
  //s'il clique on affiche les commissions
  const [head1666izocashBuyIA, setHead1666izocashBuyIA] = useState(true);
  async function Head1666izocashBuyIA() {
    setHead1666izocashBuyIA(true);
    setHead2666izocashBuyIA(false);
    setHead3666izocashBuyIA(false);
  }

  // head 2 (Base de données) - IA
  //s'il clique on affiche la base de donnees
  const [head2666izocashBuyIA, setHead2666izocashBuyIA] = useState(false);
  async function Head2666izocashBuyIA() {
    setHead2666izocashBuyIA(true);
    setHead1666izocashBuyIA(false);
    setHead3666izocashBuyIA(false);
  }

  // head 3 (Super code) - IA
  //s'il clique on affiche le super code
  const [head3666izocashBuyIA, setHead3666izocashBuyIA] = useState(false);
  async function Head3666izocashBuyIA() {
    setHead3666izocashBuyIA(true);
    setHead1666izocashBuyIA(false);
    setHead2666izocashBuyIA(false);
  }

  // envoyer de l'argent: izocash buy => izocash international - IA
  // page pour saisir le montant a envoyer
  const [sendMoneyPage666izocashBuyIA, setSendMoneyPage666izocashBuyIA] = useState(false);
  async function SendMoneyPage666izocashBuyIA() {
    setSendMoneyPage666izocashBuyIA(true);
  }
  //fermer
  async function CloseSendMoneyPage666izocashBuyIA() {
    setSendMoneyPage666izocashBuyIA(true);
  }

  // logique pour envoyer de l'argent: izocash buy => izocash international - IA
  async function SendMoney666izocashBuyIA() {
    setOpacity(true);
    const writeAmountIA = localStorage.getItem("https://alrani.com/writeAmountIA");
    
      //1ere requete
      //1ere requete
      // envoyer de l'argent: izocash buy => izocash international
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
        data: {
          balanceInternationalAccount: writeAmountIA,
        },
      }).then((res) => {
        
          //2e requete
          //2e requete
          // transfert reussie alors on cree une notification
          async function deuxiemeReq() {
            const notification = "12"; //transfert success: izocash buy => izocash international
  
            //const idOther = localStorage.getItem("https://alrani.com/idOther");
            //const nameOther = localStorage.getItem("https://alrani.com/nameOther");
  
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
              data: {
                idOwner: idPersonConnectedIA,
                //nameOwner: namePersonConnectedIA,
                //idOther: idOther,
                //nameOther: nameOther,
                notification: notification,
              },
            }).then((res) => {
              // notification creer, on affiche le message de success
              setEnvoieInformationDidentiterEntrepriseSuccessIA(true);
              setOpacity(false);
            })
            .catch((err) => {
              // erreur, impossible de creer la notification. mais on affiche quand meme le message de success
              setEnvoieInformationDidentiterEntrepriseSuccessIA(true);
              setOpacity(false);
            });
          }
          deuxiemeReq();
          //2e requete
      })
      .catch((err) => {
        // erreur, impossible d'effectuer le transfert
        setOpacity(false);
        setErrorIA(true);
      });
      //1ere requete
    }
    // logique pour envoyer de l'argent: izocash buy => izocash international - IA

  
  // saisir: nom du proprietaire du numero virtuel - IA
  const [writeNameOwnerIA, setWriteNameOwnerIA] = useState("");
  if (writeNameOwnerIA) {
    localStorage.setItem("writeNameOwner", writeNameOwnerIA);
  }

  // on recupere l'indicatif sur lequel on a cliquer puis on le met sur l'indicatif en cours 
  const indicativeIA = localStorage.getItem("indicativeIA");
  const indicativeOneIA = localStorage.getItem("indicativeOneIA");
  const indicativeTwoIA = localStorage.getItem("indicativeTwoIA");

  async function IndicativeOneIA() {
    localStorage.setItem("indicativeIA", indicativeOneIA);
  }

  async function IndicativeTwoIA() {
    localStorage.setItem("indicativeIA", indicativeTwoIA);
  }


  // choisir l'indicatif du numero virtuel (numero terminant: par 0, par 5) - IA
  const [chooseIndicativeIA, setChooseIndicativeIA] = useState(false);
  async function ChooseIndicativeIA() {
    setChooseIndicativeIA(true);
  }
  async function CloseChooseIndicativeIA() { //fermer
    setChooseIndicativeIA(false);
  }

  // stock error (Stock insuffisant, on affiche ce message d'erreur)
  const [stockErrorIA, setStockErrorIA] = useState(false);
  async function CloseStockErrorIA() {
    setStockErrorIA(false);
  }


  // delivrer un numero virtuel - IA
  const [deliverVirtualNumberPageIA, setDeliverVirtualNumberPageIA] = useState(false);
  async function DeliverVirtualNumberPageIA() {
    setDeliverVirtualNumberPageIA(true);
  }
  async function CloseDeliverVirtualNumberPageIA() { //fermer
    setDeliverVirtualNumberPageIA(false);
  } 

  // confirmer le numero virtuel a delivrer
  const [confirmDeliverVirtualNumberPageIA, setConfirmDeliverVirtualNumberPageIA] = useState(false);
  async function ConfirmDeliverVirtualNumberPageIA() {
    setConfirmDeliverVirtualNumberPageIA(true);
  }
  async function CloseConfirmDeliverVirtualNumberPageIA() { //fermer
    setConfirmDeliverVirtualNumberPageIA(false);
  } 

  // numero virtuel delivrer avec Success - IA
  const [deliverNumberSuccessIA, setDeliverNumberSuccessIA] = useState(false);
  async function DeliverNumberSuccessIA() {
    setDeliverNumberSuccessIA(true);

    // recovery - on prend prend tout ce qui est dans recuperation et on le met dans normal 
    // 1er on prend tout ce qui est dans recuperation
    const idNotification = localStorage.getItem("idNotification000");
    const date = localStorage.getItem("date000");
    const amount = localStorage.getItem("amount000");
    const price = localStorage.getItem("price000");
    const total = localStorage.getItem("total000");
    const fees = localStorage.getItem("fees000");
    const nameOwner = localStorage.getItem("nameOwner000");
    const nameOther = localStorage.getItem("nameOther000");
    const virtualNumber = localStorage.getItem("virtualNumber000");
    const phoneNumber = localStorage.getItem("phoneNumber000");
    const nameOwnerVirtualNumber = localStorage.getItem("nameOwnerVirtualNumber000");

    // 2e on le met dans normal
    localStorage.setItem("idNotification", idNotification);
    localStorage.setItem("date", date);
    localStorage.setItem("amount", amount);
    localStorage.setItem("price", price);
    localStorage.setItem("total", total);
    localStorage.setItem("fees", fees);
    localStorage.setItem("nameOwner", nameOwner);
    localStorage.setItem("nameOther", nameOther);
    localStorage.setItem("virtualNumber", virtualNumber);
    localStorage.setItem("phoneNumber", phoneNumber);
    localStorage.setItem("nameOwnerVirtualNumber", nameOwnerVirtualNumber);
  }
  async function CloseDeliverNumberSuccessIA() { //fermer
    setConfirmDeliverVirtualNumberPageIA(false);
    setDeliverNumberSuccessIA(false);
  }

  // le 2e message de success s'affiche en haut du 1er message de success
  const [deliverNumberSuccess2IA, setDeliverNumberSuccess2IA] = useState(false);
  async function CloseDeliverNumberSuccess2IA() {
    setDeliverNumberSuccess2IA(false);
  }
  

  // logique pour delivrer un numero virtuel - IA
  async function DeliverVirtualNumberIA() {
    setOpacity(true);
    
    //on recupere l'ancien stock pour faire le calcul
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
      .then((res) => {
        const price = "75000"; //prix du numero virtuel

        // on filtre en fonction de l'idPersonConnected - IA
        const api = res.data;
        const filterPoint = api.filter((api) => api._id === idPersonConnectedIA);

        const deliverVirtualNumberStock = filterPoint.map((api) => api.deliverVirtualNumberStock); // deliverVirtualNumberStock (pourcentage du stock necessaire, c'est le stock necessaire qu'il doit avoir dans son compte pour delivrer un numero virtuel)
        if (deliverVirtualNumberStock) { localStorage.setItem("deliverVirtualNumberStock", deliverVirtualNumberStock) }

        const deliverVirtualNumberCommission = filterPoint.map((api) => api.deliverVirtualNumberCommission); // deliverVirtualNumberCommission (pourcentage de la commission, c'est ca commission qu'il gagne sur chaque numero virtuel delivrer)
        if (deliverVirtualNumberCommission) { localStorage.setItem("deliverVirtualNumberCommission", deliverVirtualNumberCommission) }
        
        // ancien stock national
        const stock = filterPoint.map((api) => api.stockNational);
        if (stock) { localStorage.setItem("oldStock", stock) }
        
        const oldStock = localStorage.getItem("oldStock");
        
        // calcul de la commission
        const calculDeliverVirtualNumberCommission = parseInt(price) * parseInt(deliverVirtualNumberCommission) / 100;
        if (calculDeliverVirtualNumberCommission) { localStorage.setItem("calculDeliverVirtualNumberCommission", calculDeliverVirtualNumberCommission) }

        // calcul du stock necessaire
        const calculDeliverVirtualNumberStock = parseInt(price) * parseInt(deliverVirtualNumberStock) / 100;
        if (calculDeliverVirtualNumberStock) { localStorage.setItem("calculDeliverVirtualNumberStock", calculDeliverVirtualNumberStock) }
        
        // calcul du nouveau stock
        const newStock = parseInt(oldStock) - parseInt(calculDeliverVirtualNumberStock);
        if (newStock) { localStorage.setItem("newStock", newStock) }

      if (newStock > -1) {
      //dans ce cas: Stock suffisant (si le stock est suffisant on peut delivrer le numero virtuel)
        
      //2e requete
      //2e requete
      // debiter le stock (nouveau stock du point retrait)
      async function deuxiemeReq() {
        const newStock = localStorage.getItem("newStock");
        await axios({ 
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
        data: {
          stockNational: newStock,
        },
      })
      .then((res) => {

    //3e requete
    //3e requete
    // on enregistre le numero virtuel dans la bdd
    async function troisiemeReq() {
      const identification = "0";
      const paymentMethod = "1";
      const countryCode = localStorage.getItem("countryCodePersonConnectedIA");
      const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
      const display = "1";
      const visible = "1";

      await axios({ 
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/virtualNumberIA/new`,
        data: {
          virtualNumber: writeVirtualNumber,
          nameOwner: writeNameOwnerIA,
          identification,
          indicative: indicativeIA,
          idPoint: idPersonConnectedIA,
          namePoint: namePersonConnectedIA,
          paymentMethod,
          countryCode,
          display,
          visible,
        },
      })
      .then((res) => {
      
      //4e requete
      //4e requete
      // numero virtuel delivrer, on l'envoie la notification pour qu'il sache qu'il a delivrer un numero virtuel
      async function quatriemeReq() {
        const id = localStorage.getItem("createIdNotificationIA");
        const notification = "13"; //Numero virtuel delivrer avec success
        const percentageStockRequired = localStorage.getItem("deliverVirtualNumberStock");
        const percentageCommission = localStorage.getItem("deliverVirtualNumberCommission");
        const price = "75000";
        const oldStockOwner = localStorage.getItem("oldStock");
        const commission = localStorage.getItem("calculDeliverVirtualNumberCommission");
        const stockRequired = localStorage.getItem("calculDeliverVirtualNumberStock");
        const newStockOwner = localStorage.getItem("newStock");
        const amount = "75000";
        const display = "1";
        const visible = "1";
        const connection = "1";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
          data: {
            id,
            notification: notification,
            idOwner: idPersonConnectedIA,
            nameOwner: namePersonConnectedIA, // c'est le nom du Point Retrait qui initie la notification
            virtualNumber: writeVirtualNumber,
            nameOwnerVirtualNumber: writeNameOwnerIA,
            percentageStockRequired, //pourcentage du stock necessaire
            percentageCommission, //pourcentage de la commission
            price, //prix du numero virtuel
            oldStockOwner, //ancien stock
            commission, //calcul de la commission
            stockRequired, //calcul du stock necessaire
            newStockOwner, //calcul du nouveau stock
            amount, //montant a payer
            display,
            visible,
            connection,
          },
        }).then((res) => {
          // on recupere ces elements ci-dessous car on va afficher ca sur le recu apres qu'il ait delivrer le numero virtuel
          const idNotification = res.data._id; //id
          if (idNotification) { localStorage.setItem("idNotification", idNotification) }

          const date = res.data.createdAt; //date
          if (date) { localStorage.setItem("date", date) }

          const nameOwner = res.data.nameOwner; //nameOwner (nom de celui qui initie la notification, dans ce cas c'est le Point Retrait qui initie la notification)
          if (nameOwner) { localStorage.setItem("nameOwner", nameOwner) }

          const virtualNumber = res.data.virtualNumber; //virtualNumber (numero virtuel)
          if (virtualNumber) { localStorage.setItem("virtualNumber", virtualNumber) }

          const nameOwnerVirtualNumber = res.data.nameOwnerVirtualNumber; //nameOwnerVirtualNumber (nom du proprietaire)
          if (nameOwnerVirtualNumber) { localStorage.setItem("nameOwnerVirtualNumber", nameOwnerVirtualNumber) }

          const price = res.data.price; //price (prix du numero virtuel)
          if (price) { localStorage.setItem("price", price) }

          const oldStockOwner = res.data.oldStockOwner; //oldStockOwner (ancien stock)
          if (oldStockOwner) { localStorage.setItem("oldStockOwner", oldStockOwner) }

          const commission = res.data.commission; //commission
          if (commission) { localStorage.setItem("commission", commission) }

          const stockRequired = res.data.stockRequired; //calcul du stock necessaire (il s'agit du stock qu'il doit avoir dans son compte pour delivrer un numero virtuel)
          if (stockRequired) { localStorage.setItem("stockRequired", stockRequired) }

          const newStockOwner = res.data.newStockOwner; //newStockOwner (calcul du nouveau stock)
          if (newStockOwner) { localStorage.setItem("newStockOwner", newStockOwner) }

          const amount = res.data.amount; //amount (montant a payer)
          if (amount) { localStorage.setItem("amount", amount) }

        //5e requete
        //5e requete
        // obtenir les nouvelles donnees
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationIA/`)
          .then((res) => {
            setApiNotificationIA(res.data);

            setDeliverNumberSuccessIA(true); 
            setDeliverNumberSuccess2IA(true); 
            setOpacity(false);

        //6e requete
        //6e requete
        // obtenir les nouvelles donnees (on le fait pour pouvoir l'afficher le nouveau stock national)
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
          .then((res) => {
            // on filtre en fonction de l'idPersonConnectedIA
            const api = res.data;
            const filterAccount = api.filter((api) => api._id === idPersonConnectedIA);

            const stockNational = filterAccount.map((api) => api.stockNational); // stockNational
            if (stockNational) { localStorage.setItem("stockNationalIA", stockNational); }
            })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        sixiemeReq()
        //6e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        cinquiemeReq()
        //5e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true);
        });
      }
      quatriemeReq()
      //4e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true);
    })
  }
  troisiemeReq();
  //3e requete
      })
      .catch((err) => {
        setOpacity(false); // une erreur s'est produite, le numero virtuel n'a pas pu etre delivrer 
        setErrorIA(true);
      });
    }
    deuxiemeReq();
    //2e requete
      } else {
        //dans ce cas: Stock insuffisant (le stock est insuffisant, il doit recharger son stock)
        setStockErrorIA(true);
        setOpacity(false);
      } //if (newStock > -1) se ferme ici
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true);
    })
    }
    premiereReq();
    //1ere requete
  }


  const dateParserNumeric = (date) => {
    let newDate = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return newDate;
  };

  
  // delivrer un numero virtuel - IA
  // on affiche la page pour delivrer un numero virtuel - IA
  const [delivrerNumeroVirtuelPageIA, setDelivrerNumeroVirtuelPageIA] = useState(false);
  async function DelivrerNumeroVirtuelPageIA() {
    setDelivrerNumeroVirtuelPageIA(true);
  }
  async function CloseDelivrerNumeroVirtuelPageIA() { //fermer
    setDelivrerNumeroVirtuelPageIA(false);
    setFooterMiniMenuIA(true);
  } 

  // confirmer le numero virtuel a delivrer - IA
  // confirmer le numero virtuel a delivrer - IA
  // on affiche la page qui va permettre a l'agent de confirmer le numero virtuel a delivrer
  const [confirmerNumeroAdelivrerIA, setConfirmerNumeroAdelivrerIA] = useState(false);
  async function ConfirmerNumeroAdelivrerIA() {
    setConfirmerNumeroAdelivrerIA(true);
  }
  //fermer
  async function CloseConfirmerNumeroAdelivrerIA() {
    setConfirmerNumeroAdelivrerIA(false);
  }

  // entrer le nom du propriétaire (Page) - IA
  // entrer le nom du propriétaire (Page) - IA
  /* on affiche la page qui va permettre a l'agent d'entrer le nom du propriétaire du 
  numero virtuel - IA */
  const [entrerNomProprietaireIA, setEntrerNomProprietaireIA] = useState(false);
  async function EntrerNomProprietaireIA() {
    setEntrerNomProprietaireIA(true);
  }
  //fermer
  async function CloseEntrerNomProprietaireIA() {
    setEntrerNomProprietaireIA(false);
  }

  //compte valider, on affiche un message de success
  const [compteValiderIA, setCompteValiderIA] = useState(false);
  async function CloseCompteValiderIA() {
    setBeginIdentificationPageIA(false);
    setEtapeUnProcessusValidationCompteIA(false);
    setEtapeDeuxProcessusValidationCompteIA(false);
    setEtapeTroisProcessusValidationCompteIA(false);
    setCompteValiderIA(false);
    setFooterMiniMenuIA(true);
  }

  
  //on recupere les informations liées a la localisation et d'autres infos saisies
  const countrySelectedIA = localStorage.getItem("countrySelected");
  const citySelectedIA = localStorage.getItem("citySelected");
  const quarterSelectedIA = localStorage.getItem("quarterSelected");
  const zoneSelectedIA = localStorage.getItem("zoneSelected");
  const zoneIA = localStorage.getItem("zone");

  const nameClientIA = localStorage.getItem("nameClientIA");
  const addressClientIA = localStorage.getItem("addressClientIA");
  const jobClientIA = localStorage.getItem("jobClientIA");
  const businessClientIA = localStorage.getItem("businessClientIA");
  const otherBusinessClientIA = localStorage.getItem("otherBusinessClientIA");
  const phoneNumberClientIA = localStorage.getItem("phoneNumberClientIA");
  const sexIA = localStorage.getItem("sexIA");

 // saisir le nom du client - IA
 const [writeNameClientPageIA, setWriteNameClientPageIA] = useState(false);
 /*async function WriteNameClientPageIA() {
   setWriteNameClientPageIA(true);
   setWriteAddressClientPageIA(false);
 }*/
 async function CloseWriteNameClientPageIA() { //fermer
   setWriteNameClientPageIA(false);
 }

 //enregistrer le nom dans le localStorage (on est obliger d'enregistrer le nom a partir de lorsqu'on clique sur le bouton Enregistrer (SaveNameClient) )
 async function SaveNameClientIA() {
  localStorage.setItem("nameClient", writeNameClientIA);
  setWriteNameClientPageIA(false);
 }

  // saisir l'adresse du client - IA
  const [writeAddressClientPageIA, setWriteAddressClientPageIA] = useState(false);
  /*async function WriteAddressClientPageIA() {
    setWriteAddressClientPageIA(true);
    setWriteNameClientPageIA(false);
  }*/
  async function CloseWriteAddressClientPageIA() {  //fermer
    setWriteAddressClientPageIA(false);
  }

  //enregistrer l'adresse dans le localStorage (on est obliger d'enregistrer l'adresse a partir de lorsqu'on clique sur le bouton Enregistrer (SaveAddressClient) )
  async function SaveAddressClientIA() {
    localStorage.setItem("addressClient", writeAddressClientIA);
    setWriteAddressClientPageIA(false);
  }
  
  
  // identification Success - IA
  // ca c'est le recu (on l'affiche une fois que le numero virtuel a ete identifier)
  const [identificationSuccessIA, setIdentificationSuccessIA] = useState(false);
  async function IdentificationSuccessIA() {
    setIdentificationSuccessIA(true);

    // recovery - on prend prend tout ce qui est dans recuperation et on le met dans normal 
    // 1er on prend tout ce qui est dans recuperation
    const idNotification = localStorage.getItem("idNotification000");
    const date = localStorage.getItem("date000");
    const amount = localStorage.getItem("amount000");
    const price = localStorage.getItem("price000");
    const total = localStorage.getItem("total000");
    const fees = localStorage.getItem("fees000");
    const nameOwner = localStorage.getItem("nameOwner000");
    const nameOther = localStorage.getItem("nameOther000");
    const virtualNumber = localStorage.getItem("virtualNumber000");
    const phoneNumber = localStorage.getItem("phoneNumber000");
    const nameOwnerVirtualNumber = localStorage.getItem("nameOwnerVirtualNumber000");

    // 2e on le met dans normal
    localStorage.setItem("idNotification", idNotification);
    localStorage.setItem("date", date);
    localStorage.setItem("amount", amount);
    localStorage.setItem("price", price);
    localStorage.setItem("total", total);
    localStorage.setItem("fees", fees);
    localStorage.setItem("nameOwner", nameOwner);
    localStorage.setItem("nameOther", nameOther);
    localStorage.setItem("virtualNumber", virtualNumber);
    localStorage.setItem("phoneNumber", phoneNumber);
    localStorage.setItem("nameOwnerVirtualNumber", nameOwnerVirtualNumber);
  }
  async function CloseIdentificationSuccessIA() { //fermer
    setIdentificationSuccessIA(false);
  }

  // identification Success 2 - IA
  const [identificationSuccess2IA, setIdentificationSuccess2IA] = useState(false);
  async function CloseIdentificationSuccess2IA() {
    setIdentificationSuccess2IA(false);
  }

  // saisir infos client page (666 identification Étape 3) - IA 
  const [writeInfosClientPageIA, setWriteInfosClientPageIA] = useState(false);
  async function WriteInfosClientPageIA() {
    setWriteInfosClientPageIA(true);
  }
  async function CloseWriteInfosClientPageIA() { //fermer
    setWriteInfosClientPageIA(false);
  }


  // saisir 
  const [writeNameClientIA, setWriteNameClientIA] = useState(""); //Nom du client
  const [writeJobClientIA, setWriteJobClientIA] = useState(""); //Profession
  const [writeBusinessClientIA, setWriteBusinessClientIA] = useState(""); //Business
  const [writeOtherBusinessClientIA, setWriteOtherBusinessClientIA] = useState(""); //Autres Business
  const [writePhoneNumberClientIA, setWritePhoneNumberClientIA] = useState(""); //Numéro de téléphone
  const [writeAddressClientIA, setWriteAddressClientIA] = useState(""); //Adresse

  // logique pour enregistrer les informations du client dans le localStorage - IA
  async function SaveInfosClientIA() {
    localStorage.setItem("nameClientIA", writeNameClientIA);
    localStorage.setItem("jobClientIA", writeJobClientIA);
    localStorage.setItem("businessClientIA", writeBusinessClientIA);
    localStorage.setItem("otherBusinessClientIA", writeOtherBusinessClientIA);
    localStorage.setItem("phoneNumberClientIA", writePhoneNumberClientIA);
    localStorage.setItem("addressClientIA", writeAddressClientIA);
    setWriteInfosClientPageIA(false);
  }


  // logique pour identifier un numero virtuel - IA
  async function IdentificationVirtualNumberIA() {
    setOpacity(true);
    
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
      .then((res) => {
        const price = "90000"; //frais d'identification d'un numero virtuel
        
        // filtre Point Retrait
        const apiAccount = res.data;
        const filterPoint = apiAccount.filter((api) => api._id === idPersonConnectedIA);

        const identificationStock = filterPoint.map((api) => api.identificationStock); // identificationStock (pourcentage du stock necessaire, c'est le stock necessaire qu'il doit avoir dans son compte pour identifier un numero virtuel)
        if (identificationStock) { localStorage.setItem("identificationStock", identificationStock) }

        const identificationCommission = filterPoint.map((api) => api.identificationCommission); // identificationCommission (pourcentage de la commission, c'est ca commission qu'il gagne sur chaque numero virtuel identifier)
        if (identificationCommission) { localStorage.setItem("identificationCommission", identificationCommission) }
        
        // ancien stock national
        const stock = filterPoint.map((api) => api.stockNational);
        if (stock) { localStorage.setItem("oldStock", stock) }
        
        const oldStock = localStorage.getItem("oldStock");

        // calcul de la commission
        const calculIdentificationCommission = parseInt(price) * parseInt(identificationCommission) / 100;
        if (calculIdentificationCommission) { localStorage.setItem("calculIdentificationCommission", calculIdentificationCommission) }

        // calcul du stock necessaire
        const calculIdentificationStock = parseInt(price) * parseInt(identificationStock) / 100;
        if (calculIdentificationStock) { localStorage.setItem("calculIdentificationStock", calculIdentificationStock) }
        
        // calcul du nouveau stock
        const newStock = parseInt(oldStock) - parseInt(calculIdentificationStock);
        if (newStock) { localStorage.setItem("newStock", newStock) }
    
      if (newStock > -1) {
      //dans ce cas: Stock suffisant (vous pouvez identifier le numero virtuel)
      
      //2e requete
      //2e requete
      // debiter le stock (nouveau stock du point retrait)
      async function deuxiemeReq() {
        const newStock = localStorage.getItem("newStock");
        await axios({ 
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
          data: {
            stockNational: newStock,
          },
        })
        .then((res) => {
         
      //3e requete
      //3e requete
      // on identifie le compte du client
      async function troisiemeReq() {
      const identification = "1";
      const idAccount = localStorage.getItem("idAccount");

      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idAccount}`,
        data: {
          identification,
        },
      })
      .then((res) => {

        //4e requete
        //4e requete
        // on enregistre les infos personnelles
        async function quatriemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const nameClientIA = localStorage.getItem("nameClientIA");
          const job = localStorage.getItem("jobClientIA");
          const business = localStorage.getItem("businessClientIA");
          const otherBusiness = localStorage.getItem("otherBusinessClientIA");
          const addressClientIA = localStorage.getItem("addressClientIA");
          const phoneNumber = localStorage.getItem("phoneNumberClientIA");
          const sex = localStorage.getItem("sexIA");
          const connection = "1";
          const display = "1";
          const visible = "1";
          const type = "1";

          await axios({ 
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/identificationIA/save`,
            data: {
              idAccount,
              name: nameClientIA,
              job,
              business,
              otherBusiness,
              address: addressClientIA,
              phoneNumber,
              sex,
              idPoint: idPersonConnectedIA,
              namePoint: namePersonConnectedIA,
              connection,
              display,
              visible,
              type,
            },
          })
          .then((res) => {

      //5e requete
      //5e requete
      // numero virtuel identifié, on l'envoie la notification pour qu'il sache qu'il a identifier un numero virtuel
      async function cinquiemeReq() {
        const id = localStorage.getItem("createIdNotificationIA");
        const notification = "16"; // numero identifier avec success
        const idOther = localStorage.getItem("idAccount"); // id de celui qui veut faire identifier son numero virtuel
        const nameOther = localStorage.getItem("nameClientIA"); //nom public de celui qui veut faire identifier son numero virtuel
        const virtualNumber = localStorage.getItem("virtualNumber");
        const percentageStockRequired = localStorage.getItem("identificationStock");
        const percentageCommission = localStorage.getItem("identificationCommission");
        const price = "90000";
        const oldStockOwner = localStorage.getItem("oldStock");
        const commission = localStorage.getItem("calculIdentificationCommission");
        const stockRequired = localStorage.getItem("calculIdentificationStock");
        const newStockOwner = localStorage.getItem("newStock");
        const amount = "90000";
        const display = "1";
        const visible = "1";
        const connection = "1";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
          data: {
            id,
            notification,
            idOwner: idPersonConnectedIA,
            nameOwner: namePersonConnectedIA, // c'est le nom du Point Retrait qui initie la notification
            virtualNumber,
            percentageStockRequired, //pourcentage du stock necessaire
            percentageCommission, //pourcentage de la commission
            price, //prix du numero virtuel
            oldStockOwner, //ancien stock
            commission, //calcul de la commission
            stockRequired, //calcul du stock necessaire
            newStockOwner, //calcul du nouveau stock
            amount, //montant a payer
            idOther,
            nameOther,
            display,
            visible,
            connection,
          },
        }).then((res) => {
          // on recupere ces elements ci-dessous car on va afficher ca sur le recu apres qu'il ait identifier le numero virtuel
          const idNotification = res.data._id; //id
          if (idNotification) { localStorage.setItem("idNotification", idNotification) }

          const date = res.data.createdAt; //date
          if (date) { localStorage.setItem("date", date) }

          const nameOwner = res.data.nameOwner; //nameOwner (nom de celui qui initie la notification, dans ce cas c'est le Point Retrait qui initie la notification)
          if (nameOwner) { localStorage.setItem("nameOwner", nameOwner) }

          const virtualNumber = res.data.virtualNumber; //virtualNumber (numero virtuel)
          if (virtualNumber) { localStorage.setItem("virtualNumber", virtualNumber) }

          const nameOther = res.data.nameOther; //nameOther (nom du proprietaire)
          if (nameOther) { localStorage.setItem("nameOther", nameOther) }

          const price = res.data.price; //price (prix du numero virtuel)
          if (price) { localStorage.setItem("price", price) }

          const oldStockOwner = res.data.oldStockOwner; //oldStockOwner (ancien stock)
          if (oldStockOwner) { localStorage.setItem("oldStockOwner", oldStockOwner) }

          const commission = res.data.commission; //commission
          if (commission) { localStorage.setItem("commission", commission) }

          const stockRequired = res.data.stockRequired; //calcul du stock necessaire (il s'agit du stock qu'il doit avoir dans son compte pour delivrer un numero virtuel)
          if (stockRequired) { localStorage.setItem("stockRequired", stockRequired) }

          const newStockOwner = res.data.newStockOwner; //newStockOwner (calcul du nouveau stock)
          if (newStockOwner) { localStorage.setItem("newStockOwner", newStockOwner) }

          const amount = res.data.amount; //amount (montant a payer)
          if (amount) { localStorage.setItem("amount", amount) }

        //6e requete
        //6e requete
        // obtenir les nouvelles donnees
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationIA/`)
          .then((res) => {
            setApiNotificationIA(res.data);

            setIdentificationSuccessIA(true); 
            setIdentificationSuccess2IA(true); 
            setOpacity(false);

        //7e requete
        //7e requete
        // obtenir les nouvelles donnees (on le fait pour pouvoir lui afficher le nouveau stock national)
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
          .then((res) => {
            // on filtre en fonction de l'idPersonConnectedIA
            const api = res.data;
            const filterAccount = api.filter((api) => api._id === idPersonConnectedIA);

            const stockNational = filterAccount.map((api) => api.stockNational); // stockNational
            if (stockNational) { localStorage.setItem("stockNationalIA", stockNational); }
          })
          .catch((err) => {
            setOpacity(false);
            setErrorIA(true);
          });
        }
        septiemeReq()
        //7e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(false);
      });
    }
    sixiemeReq()
    //6e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(false);
    });
  }
  cinquiemeReq()
  //5e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(false);
    });
  }
  quatriemeReq()
  //4e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(false);
      });
    }
    troisiemeReq()
    //3e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorIA(true);
    })
  }
  deuxiemeReq();
  //2e requete
   } else {
      //dans ce cas: Stock insuffisant (impossible d'identifier le numero virtuel)
      setStockErrorIA(true);
      setOpacity(false);
     } //if (newStock > -1) se ferme ici
   })
   .catch((err) => {
     setOpacity(false);
     setErrorIA(true);
   })
  }
  premiereReq();
  // 1ere requete
}
// logique pour identifier un numero virtuel - IA


  // numéro virtuel déjà identifié ! - IA
  // on affiche ce message de success lorsque le numéro virtuel à déjà été identifié 
  const [identificationAlreadyIA, setIdentificationAlreadyIA] = useState(false);
  async function CloseIdentificationAlreadyIA() {
    setIdentificationAlreadyIA(false);
  }

  // demarrer la procedure d'identification (page)
  // on affiche le card qui permet de saisir le code d'identification pour demarrer la procedure d'identification d'un numero virtuel
  const [beginIdentificationPageIA, setBeginIdentificationPageIA] = useState(false);
  async function BeginIdentificationPageIA() {
    setBeginIdentificationPageIA(true);
  }
  async function CloseBeginIdentificationPageIA() { //fermer
    setBeginIdentificationPageIA(false);
  }

  //saisir
  const [writeCode, setWriteCode] = useState("");
  if (writeCode) { localStorage.setItem("writeCode", writeCode); }

  /* la logique ci va nous permettre de verifier si le code entrer dans l'input existe dans 
  la bdd, si le code existe alors on va demarrer la procedure d'identification du numero virtuel, 
  ensuite on va enregistrer l'id de la personne dans le localStorage, car 
  avec l'id de la personne on va enregistrer l'url de chaque photo d'identiter dans la bdd */

  // logique pour debuter l'identification d'un numero virtuel - IA
  async function BeginIdentificationIA() {
    setOpacity(true);

    async function premiereReq() {
      /*on retire le nom du client ainsi que son adresse. on le retire du localStorage pour
      eviter que le nom ou l'adresse d'un ancien client qui etait enregistrer dans le localStorage
      puisse s'afficher chez le nouveau client 
      (ca s'affichait au niveau de la 3e etape - processusValidationCompteIA).
      en le retirant du localStorage, le problème sera résolu */
      localStorage.removeItem("idAccount");
      localStorage.removeItem("nameClientIA");
      localStorage.removeItem("jobClientIA");
      localStorage.removeItem("businessClientIA");
      localStorage.removeItem("otherBusinessClientIA");
      localStorage.removeItem("addressClientIA");
      localStorage.removeItem("phoneNumberClientIA");
      localStorage.removeItem("sexIA");

      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
      .then((res) => {
        const api = res.data;
        const code = api.filter((api) => api.identificationCode === writeCode);
        const writeCode = localStorage.getItem("writeCode");
        
        const idAccount = code.map((api) => api._id); //idAccount
        if (idAccount) { localStorage.setItem("idAccount", idAccount); }   

        const virtualNumber = code.map((api) => api.virtualNumber); //virtualNumber
        if (virtualNumber) { localStorage.setItem("virtualNumber", virtualNumber); } 
        
        //on verifie si le code saisi existe
        const verifyCode = code.length > 0;

        // on verifie si le numero virtuel a deja ete identifier
        const identification = api.filter((api) => api.identificationCode === writeCode && api.identification === "1");
        const verifyIdentification = identification.length > 0;

        if (verifyIdentification) {
          //dans ce cas: le numero a deja ete identifier

          setOpacity(false);
          setIdentificationAlreadyIA(true);
        } else {
          //dans ce cas: le numero n'a pas encore ete identifier

          // verification - on verifie si le code saisi par l'agent existe
          if (verifyCode) {
            //dans ce cas: le code saisi existe

            setOpacity(false);
            setEtapeUnProcessusValidationCompteIA(true);
          } else {
            //dans ce cas: le code saisi n'existe pas
            setOpacity(false);
            setErrorIA(true);
          }
          //if (verifyCode) {
        } 
        //le if de verifyIdentification se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    premiereReq();
  }

  // sur cette page on afffiche le code d'identification - IA
  const [beforeIdentificationCodePageIA, setBeforeIdentificationCodePageIA] = useState(false);
  async function BeforeIdentificationCodePageIA() {
    setBeforeIdentificationCodePageIA(true);
  }
  async function CloseBeforeIdentificationCodePageIA() {
    setBeforeIdentificationCodePageIA(false);
  }

  //logique pour verifier le super code identification Deals - IA
  async function BeforeIdentificationCodeIA() {
    setOpacity(true);

    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/toolIA`)
      .then((res) => {
        const writeCode = localStorage.getItem("writeCode");
        //on filtre en fonction du super code saisi
        const apiTool = res.data;
        const filterCode = apiTool.filter((api) => api.identificationDealsCode === writeCode);
        
        const verifyCode = filterCode.length > 0;
        

        if (verifyCode) {
          //dans ce cas: le super code existe
           /* donc comment ca se passe, lorsque la personne clique sur Code d'identification,
          un code aleatoire lui ait attribuer mais dans le cas ou le code qui lui a ete attibuer
          de maniere aleatoire, si ce meme code a deja ete attribuer a l'instant t sur 
          un autre appareil, alors on va l'afficher un message d'erreur et il doit juste reesayer car
          s'il reessaye, un autre code va lui etre generer de maniere aleatoire */

            //ca c'est pour obtenir le code d'identification, cette logique nous donne le code de maniere aleatoire
            /* on generes le code d'identification ici car il y'avais un retard de donnees, au lieu de recuperer 
            le nouveau code generer et l'envoyer dans la bdd, ca envenyait dans la base de donnees 
            un ancien code */
            async function deuxiemeReq() {
              let min = 1000001;
              let max = 9999999;
              let code = Math.floor(Math.random() * (max - min) + min);
              if (code) { localStorage.setItem("identificationCodeIA", code); }
        
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
              .then((res) => {
                //on recupere le code pin qui a été initié - IA
                const identificationCode = localStorage.getItem("identificationCodeIA");
        
                //ici on cherche le code dans la bdd
                const apiAccount = res.data;
                const codeTrouver = apiAccount.filter((api) => api.identificationCode === identificationCode);
                /* on mets un petit blocus pour dire que si y'a pas de code trouver, alors 
                ca veut dire que le code n'est pas utiliser quelque part,
                si y'a 1 seul code trouver, alors ca veut dire que a l'instant t, le meme code est
                entrain d'etre utiliser quelque part */
                const secureCode = codeTrouver.length;
                if (secureCode === 0) {
                  //premierCas
                  /* le code n'est pas utiliser quelque part, alors on peut utiliser ce code qui
                  nous a ete generer de maniere aleatoire */
                  async function premierCas() {
                    const identificationCode = localStorage.getItem("identificationCodeIA");
                    await axios({
                      method: "put",
                      url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
                      data: {
                        identificationCode,
                      },
                    })
                    .then((res) => {
                      //on met ca a true pour afficher la page qui contient le code d'identification
                      setOpacity(false);
                      setIdentificationCodePageIA(true);
                    })
                    .catch((err) => {
                      setOpacity(false);
                      setCodePinIncorrectIA(true);
                    });
                  }
                  premierCas();
                  //premierCas
                } else {
                  // deuxiemeCas
                  // deuxiemeCas
                  /* etant donner que le code est deja utiliser quelque part, alors 
                  on va faire une 2e tentative.
                  Tout simplement, on va generer un nouveau code de maniere aleatoire */
                  async function deuxiemeTentative() {
                    let min = 1000001;
                    let max = 9999999;
                    let code2 = Math.floor(Math.random() * (max - min) + min);
                    localStorage.setItem("identificationCodeIA", code2);
                    
                    const getcode2 = localStorage.getItem("identificationCodeIA");
                    await axios({
                      method: "put",
                      url: `${process.env.REACT_APP_BACKEND}/api/accountIA/update/${idPersonConnectedIA}`,
                      data: {
                        identificationCode: getcode2,
                      },
                    })
                    .then((res) => {
                      //on met ca a true pour afficher la page qui contient le code d'identification
                      setOpacity(false);
                      setIdentificationCodePageIA(true);
                    })
                    .catch((err) => {
                      /* si meme dans le deuxieme Cas, le code est deja utiliser quelque part, alors 
                    on va lui afficher un message d'erreur pour lui dire de reessayer plus tard ou 
                    de reessayer avec un autre code d'identification */
                      setOpacity(false);
                      setCodePinIncorrectIA(true);
                    });
                  }
                  deuxiemeTentative();
                  //deuxiemeTentative
                }
                //le code du else se ferme ici
              })
              .catch((err) => {
                setOpacity(false);
                setCodePinIncorrectIA(true);
              });
            }
            deuxiemeReq();
            //2e requete
        } else {
          //dans ce cas: le super code n'existe pas
          console.log("le super code n'existe pas /api/toolIA");
          setOpacity(false);
          setErrorIA(true);
        }
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    premiereReq();
    //1ere requete
  }


  //obtenir le code d'identification - IA
  //obtenir le code d'identification - IA
  //on recupere le code d'identification qui a été initié pour l'afficher au niveau du card - IA
  const identificationCodeIA = localStorage.getItem("identificationCodeIA");

  // sur cette page on afffiche le code d'identification - IA
  const [identificationCodePageIA, setIdentificationCodePageIA] = useState(false);
  async function CloseIdentificationCodePageIA() {
    setIdentificationCodePageIA(false);
  }
 

  //obtenir le code de l'operation - IA
  //obtenir le code de l'operation - IA
  //on recupere le code de l'opération qui a été initié pour l'afficher au niveau du card - IA
  const initierOperationCodeIA = localStorage.getItem("initierOperationCodeIA");

  //quand on clique, on affiche le card qui contient le code de l'operation
  const [initierOperationIA, setInitierOperationIA] = useState(false);
  async function CloseInitierOperationIA() {
    setInitierOperationIA(false);
  }
  /* donc comment ca se passe, lorsque la personne clique sur initier une operation,
  un code aleatoire lui ait attribuer mais dans le cas ou le code qui lui a ete attibuer
  de maniere aleatoire, si ce meme code a deja ete attribuer a l'instant t sur 
  un autre appareil, alors on l'attribue le code par defaut 000 et là l'agent va 
  recharger en passant par le numero de telephone.
  on a mis la partie du codeOperation=000 parce que il y'aura un moment ou il y'aura 
  plusieurs transactions, et le meme code pourra etre generer de maniere aleatoire dans 
  2 appareils differents. donc on a mis ca pour prevenir */
  async function InitierOperationIA() {
    setOpacity(true);
    /*ca c'est pour obtenir le code de l'operation, cette logique nous donne le code de 
     l'operation de maniere aleatoire */
    /* on generes le code de l'operation ici car il y'avais un retard de donnees, 
    au lieu de recuperer le nouveau code generer et l'envoyer dans la bdd, ca envenyait 
    dans la bdd un ancien code */
    let min = 1001;
    let max = 9999;
    let code = Math.floor(Math.random() * (max - min) + min);
    if (code) {
      localStorage.setItem("initierOperationCodeIA", code);
    }
    //on recupere le code de l'opération qui a été initié - IA
    const initierOperationCode = localStorage.getItem("initierOperationCodeIA");
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA`)
      .then((res) => {
        const api = res.data;
        //ici on cherche le code dans la bdd
        const codeTrouver = api.filter(
          (api) => api.codeOperation === initierOperationCode
        );
        /* on mets un petit blocus pour dire que si y'a pas de code trouver, alors 
        ca veut dire que le code n'est pas utiliser quelque part,
        si y'a 1 seul code trouver, alors ca veut dire que a l'instant t, le meme code est
        entrain d'etre utiliser quelque part */
        const secureCode = codeTrouver.length;
        if (secureCode === 0) {
          //premierCas
          /* le code n'est pas utiliser quelque part, alors on peut utiliser ce code qui
          nous a ete generer de maniere aleatoire */
          async function premierCas() {
            setOpacity(true);
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
              data: {
                codeOperation: initierOperationCode,
              },
            })
              .then((res) => {
                //on met ca a true pour afficher le card qui contient le code de l'operation
                setOpacity(false);
                setInitierOperationIA(true);
              })
              .catch((err) => {
                setOpacity(false);
                setErrorIA(true);
              });
          }
          premierCas();
          //premierCas
        } else {
          // deuxiemeCas
          /* etant donner que le code est deja utiliser quelque part, alors 
          on va faire une 2e tentative.
          Tout simplement, on va generer un nouveau code de maniere aleatoire */
          async function deuxiemeTentative() {
            let min = 1001;
            let max = 9999;
            let code2 = Math.floor(Math.random() * (max - min) + min);
            localStorage.setItem(
              "https://alrani.com/initierOperationCodeIA",
              code2
            );
            //
            const getcode2 = localStorage.getItem(
              "https://alrani.com/initierOperationCodeIA"
            );
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
              data: {
                codeOperation: getcode2,
              },
            })
              .then((res) => {
                //on met ca a true pour afficher le card qui contient le code de l'operation
                setOpacity(false);
                setInitierOperationIA(true);
              })
              .catch((err) => {
                //si aussi la 2e tentative echoue alors on va lui afficher un message d'erreur
                setOpacity(false);
                setErrorIA(true);
              });
          }
          deuxiemeTentative();
          //deuxiemeTentative
        }
        //le code du else se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }

  //ici on recupere les infos du client et de l'agence qui se trouve dans le localStorage
  const idClientIA = localStorage.getItem("idAccount");
 
  //envoyer photo sur cloudinary - IA
  const [filePhotoIdentiterClientIA, setFilePhotoIdentiterClientIA] = useState();
  //l'api pour recuperer les photos d'identiter du client
  //const [apiIdentificationIA, setApiIdentificationIA] = useState([]);

  //la logique pour envoyer la photo sur cloudinary
  async function EnvoyerPhotoIdentiterClientIA(e) {
    e.preventDefault(); 
    setOpacity(true);

    async function premiereReq() {
      const data = new FormData();
      data.append("image", filePhotoIdentiterClientIA);

      await axios
      .post(
        `${process.env.REACT_APP_BACKEND}/api/accountIA/sendPhoto`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data", },
        }
      )
      .then((res) => {
        const urlPhoto = res.data.urlPhoto;
        if (urlPhoto) { localStorage.setItem("urlPhoto", urlPhoto); }

        //2e requete
        //2e requete
        /*cette 2e requete nous permet d'enregistrer l'url de chaque photo d'identiter 
        dans la bdd */
        async function deuxiemeReq() {
          //ici on recupere l'url de la photo d'identiter qui se trouve dans le localStorage
          const idAccount = localStorage.getItem("idAccount");
          const urlPhoto = localStorage.getItem("urlPhoto");
          const visible = "1";
          const connection = "1";
          const type = "2";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/identificationIA/save`,
            data: {
              idAccount,
              photo: urlPhoto,
              connection,
              visible,
              type,
            },
          })
          .then((res) => {

              //3e requete
              //3e requete
              // on fait un appel a l'api
              /*dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles 
              donnees. Avec les nouvelles donnees on va pouvoir filtrer et 
              afficher l'image de la nouvelle photo d'identiter qui a ete ajouter a la bdd*/
              async function troisiemeReq() {
                await axios
                .get(`${process.env.REACT_APP_BACKEND}/api/identificationIA`)
                .then((res) => {
                  setApiIdentificationIA(res.data);
                  /* une fois que l'url de la photo a ete envoyer dans la bdd on supprime l'url de la photo du localStorage */
                  localStorage.removeItem("urlPhoto");
                  setOpacity(false);
                })
                .catch((err) => {
                  setOpacity(false);
                  setErrorIA(true);
                });
              }
              troisiemeReq();
              //3e requete
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
    }
    premiereReq();
    //1ere requete
  }


  // requete pour obtenir toutes les informations enregistrées lors de l'identification
  const [apiIdentificationIA, setApiIdentificationIA] = useState([]);


    const filterInfosIdentificationIA = apiIdentificationIA.filter((api) => api.idAccount === idPersonConnectedIA && api.type === "1");

    const getNameAtIdentificationIA = filterInfosIdentificationIA.map((api) => api.name); // nom a l'identification
    if (getNameAtIdentificationIA) { localStorage.setItem("nameAtIdentificationIA", getNameAtIdentificationIA) }
    const nameAtIdentificationIA = localStorage.getItem("nameAtIdentificationIA"); // nom a l'identification
   
  /*on affiche les photos d'identitées du client */
  //on filtre les photos d'identiter afin qu'il soit afficher a l'operateur du Point Retrait
  const idAccountIA = localStorage.getItem("idAccount");
  const filterPhotoIA = apiIdentificationIA.filter((api) => api.idAccount === idAccountIA);


  // Verification d'identité - etape 1
  // Verification d'identité - etape 1
  //on affiche le card qui permet de choisir si le client est le propriétaire du compte ou non
  const [
    selectionnerOptionRechargeCompteIA,
    setSelectionnerOptionRechargeCompteIA,
  ] = useState(false);
  //fermer le card
  async function CloseSelectionnerOptionRechargeCompteIA() {
    setSelectionnerOptionRechargeCompteIA(false);
    setEntrerCodeOperationRechargeCompteIzocash(true);
  }

  // Verification d'identité - etape 2
  // Verification d'identité - etape 2
  //on affiche la page qui permet a l'agent de verifier l'identité du client
  const [clientEstProprietaireIA, setClientEstProprietaireIA] = useState(false);
  async function ClientEstProprietaireIA() {
    setClientEstProprietaireIA(true);
  }
  //fermer le card, (btn: Annuler la transaction, sur la page clientEstProprietaire)
  async function CloseClientEstProprietaireIA() {
    setTransactionEnCoursVerificationIdentiterEtapeDeuxIA(false);
    setClientEstProprietaireIA(false);
    setEntrerCodeOperationRechargeCompteIzocash(false);
    setChoisirCompteARechargerIA(false);
    setRechargerUnComptePageIA(false);
    setSelectionnerOptionRechargeCompteIA(false);
    setEntrerCodeOperationRechargeCompteIzocash(true);
  }
  //quand on clique sur retourner en arriere, ca va retourner en Arriere - IA
  //ici nous sommes sur la page clientEstProprietaire
  async function RetournerEnArriereClientEstProprietaireIA() {
    setEntrerCodeOperationRechargeCompteIzocash(false);
    setClientEstProprietaireIA(false);
    setSelectionnerOptionRechargeCompteIA(true);
  }

  //Transaction En Cours - VerificationIdentiterEtapeDeux - IA
  /*on affiche le card qui va lui demander s'il veut annuler la transaction qui est en
  cours de traitement */
  const [
    transactionEnCoursVerificationIdentiterEtapeDeuxIA,
    setTransactionEnCoursVerificationIdentiterEtapeDeuxIA,
  ] = useState(false);
  async function TransactionEnCoursVerificationIdentiterEtapeDeuxIA() {
    setTransactionEnCoursVerificationIdentiterEtapeDeuxIA(
      !transactionEnCoursVerificationIdentiterEtapeDeuxIA
    );
  }

  //miniMenu - VerificationIdentiterEtapeDeux - IA
  /*ici on affiche le miniMenu, avec ce miniMenu, la personne pourra
  par exemple: signaler quelque chose sur ce compte (sur le compte du client 
  qu'il fait la recharge) */
  const [
    miniMenuVerificationIdentiterEtapeDeuxIA,
    setMiniMenuVerificationIdentiterEtapeDeuxIA,
  ] = useState(false);
  async function MiniMenuVerificationIdentiterEtapeDeuxIA() {
    setMiniMenuVerificationIdentiterEtapeDeuxIA(
      !miniMenuVerificationIdentiterEtapeDeuxIA
    );
  }

  // recharger un compte (Page) -  IA
  //on affiche la page qui va permettre a l'agent d'entrer le montant a recharger
  const [rechargerUnComptePageIA, setRechargerUnComptePageIA] = useState(false);
  async function RechargerUnComptePageIA(e) {
    setRechargerUnComptePageIA(true);
    //on met la logique ci pour obtenir le solde du compte du Distributeur (solde  de l'agence)
    e.preventDefault();
    setOpacity(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/user`)
      .then((res) => {
        const api = res.data;
        const filtreApiUser = api.filter((x) => x._id === idPersonConnectedIA);
        const soldeCompteDistributeurIA = filtreApiUser.map(
          (api) => api.soldeCompteDistributeur
        );
        localStorage.setItem(
          "https://alrani.com/soldeCompteDistributeurIA",
          soldeCompteDistributeurIA
        );
        setOpacity(false);
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //fermer le card
  async function CloseRechargerUnComptePageIA() {
    setRechargerUnComptePageIA(false);
  }

  //montant a recharger - IA
  const [inputMontantArechargerIA, setInputMontantArechargerIA] = useState("");
  //ici on enregistre le montant a recharger dans le localStorage
  if (inputMontantArechargerIA) {
    localStorage.setItem(
      "https://alrani.com/montantArechargerIA",
      inputMontantArechargerIA
    );
  }

  //Confirmer la recharge - IA
  //on affiche le card qui va permettre a l'agent de Confirmer la recharge
  const [confirmerRechargeIA, setConfirmerRechargeIA] = useState(false);
  async function ConfirmerRechargeIA() {
    setConfirmerRechargeIA(true);
  }
  //fermer le card
  async function CloseConfirmerRechargeIA() {
    setConfirmerRechargeIA(false);
  }

  /*on a mis rechargeActiveIA pour que lorsque l'agent va cliquer sur Recharger, 
  le bouton Recharger va rester vert */
  const [rechargeActiveIA, setRechargeActiveIA] = useState(false);

  // logique pour effectuer un retrait - IA
  async function WithdrawalIA() {
    setRechargeActiveIA(true);
    setOpacity(true);

    // on fait le calcul
    const debiterSoldeDeLagence = parseInt(soldeCompteDistributeurIA) - parseInt(montantArechargerIA);
    
    localStorage.setItem("https://alrani.com/debiterSoldeCompteDistributeurIA", debiterSoldeDeLagence);

    /*si apres avoir effectuer le calcul pour debiter le solde de l'agence, le solde du compte
    du distributeur est superieur a -1, alors la recharge va etre effectuer */
    if (debiterSoldeDeLagence > -1) {
      // dans ce cas: Recharge reussi !

      //1ere requete
      //1ere requete
      /*dans cette 1ere requete, on recupere le solde du compte du client pour pouvoir 
      faire le calcul. ce qu'on fait c'est que on ajoute le montant a recharger au solde existant */
      await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/user`)
        .then((res) => {
          const api = res.data;
          const filterUser = api.filter((api) => api._id === idClientIA);
          const ancienSoldeIA = filterUser.map((api) => api.soldeCompteIzocash);

          if (ancienSoldeIA) {
            localStorage.setItem("https://alrani.com/ancienSoldeCompteClientIA", ancienSoldeIA);
          }

          //on fait le calcul pour obtenir le nouveau solde du compte du client
          const lancienSoldeIA = localStorage.getItem("https://alrani.com/ancienSoldeCompteClientIA");
          const nouveauSoldeIA = parseInt(lancienSoldeIA) + parseInt(montantArechargerIA);
          localStorage.setItem("https://alrani.com/nouveauSoldeCompteClientIA", nouveauSoldeIA);

          //2e requete
          //2e requete
          //dans la 2e requete on debite le compte de l'agence
          async function deuxiemeReq() {

            const debiterSoldeCompteDistributeurIA = localStorage.getItem(
              "https://alrani.com/debiterSoldeCompteDistributeurIA"
            );

            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
              data: {
                soldeCompteDistributeur: debiterSoldeCompteDistributeurIA,
              },
            })
              .then((res) => {

                //3e requete
                //3e requete
                //dans la 3e requete on recharge le compte du client
                async function troisiemeReq() {

                  const leNouveauSoldeIA = localStorage.getItem(
                    "https://alrani.com/nouveauSoldeCompteClientIA"
                  );

                  await axios({
                    method: "put",
                    url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idClientIA}`,
                    data: {
                      soldeCompteIzocash: leNouveauSoldeIA,
                    },
                  })
                    .then((res) => {
                      
                      // 4e requete
                      // 4e requete
                      /* cette 4e requete c'est pour actualiser le stock de l'agence */
                      async function quatriemeReq() {
                        await axios
                          .get(`${process.env.REACT_APP_BACKEND}/api/user`)
                          .then((res) => {
                            const api = res.data;
                            const filtreApiUser = api.filter((api) => api._id === idPersonConnectedIA);
                            const soldeIA = filtreApiUser.map((api) => api.soldeCompteDistributeur);

                            localStorage.setItem("https://alrani.com/soldeCompteDistributeurIA", soldeIA);
                       
        // 5e requete
        // 5e requete
        // retrait reussie alors on cree une notification
        async function cinquiemeReq() {
          const notification = "5"; // retrait reussie

          //const idOther = localStorage.getItem("https://alrani.com/idOther");
          //const nameOther = localStorage.getItem("https://alrani.com/nameOther");

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/notificationIA/create`,
            data: {
              idOwner: idPersonConnectedIA,
              nameOwner: namePersonConnectedIA,
              idOther: idClientIA,
              nameOther: nomClientIA,
              notification: notification,
            },
          }).then((res) => {
            // notification creer, on affiche le message de success: retrait reussie
            setOpacity(false);
            setWithdrawalSuccessPageIA(true);
          })
          .catch((err) => {
            // erreur, impossible de creer la notification. mais on affiche quand meme le message de success
            setOpacity(false);
            setWithdrawalSuccessPageIA(true);
          });
        }
        cinquiemeReq();
        //5e requete
                          })
                          .catch((err) => {
                            setOpacity(false);
                            setErrorIA(true);
                          });
                      }
                      quatriemeReq();
                      //4e requete
                    })
                    .catch((err) => {
                      setOpacity(false);
                      setErrorIA(true);
                    });
                }
                troisiemeReq();
                //3e requete
              })
              .catch((err) => {
                setOpacity(false);
                setErrorIA(true);
              });
          }
          deuxiemeReq();
          //2e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorIA(true);
        });
      //1ere requete
    } else {
      // dans ce cas: Solde insuffisant, impossible d'effectuer le retrait
      setOpacity(false);
      setWithdrawalErrorPageIA(true);
    }
    //le if de debiterSoldeDeLagence se ferme ici
  }
  // logique pour effectuer un retrait - IA

  // retrait success - IA
  const [withdrawalSuccessPageIA, setWithdrawalSuccessPageIA] = useState(false);
  async function CloseWithdrawalSuccessPageIA() {
    setSelectionnerOptionRechargeCompteIA(false);
    setClientEstProprietaireIA(false);
    setRechargerUnComptePageIA(false);
    setRechargeActiveIA(false);
    setConfirmerRechargeIA(false);
    setWithdrawalSuccessPageIA(false);
  }
  
  // retrait error - IA
  const [withdrawalErrorPageIA, setWithdrawalErrorPageIA] = useState(false);
  async function CloseWithdrawalErrorPageIA() {
    setSelectionnerOptionRechargeCompteIA(false);
    setClientEstProprietaireIA(false);
    setRechargerUnComptePageIA(false);
    setRechargeActiveIA(false);
    setConfirmerRechargeIA(false);
    setWithdrawalErrorPageIA(false);
  }

  //on recupere les informations du client pour l'afficher a l'agent qui fait la recharge
  const montantArechargerIA = localStorage.getItem(
    "https://alrani.com/montantArechargerIA"
  );
  const nomClientIA = localStorage.getItem("https://alrani.com/nomClientIA");
  const adresseClientIA = localStorage.getItem(
    "https://alrani.com/adresseClientIA"
  );
  const telephoneClientIA = localStorage.getItem(
    "https://alrani.com/telephoneClientIA"
  );

  //ici on recupere les informations de l'agent
  const soldeCompteDistributeurIA = localStorage.getItem(
    "https://alrani.com/soldeCompteDistributeurIA"
  );

  //choisir compte a recharger - IA
  //quand on clique, on affiche la popup qui permet de choisir le compte a recharger
  const [choisirCompteARechargerIA, setChoisirCompteARechargerIA] = useState(false);
  async function ChoisirCompteARechargerIA() {
    setChoisirCompteARechargerIA(true);
  }
  //fermer le card
  async function CloseChoisirCompteARechargerIA() {
    setChoisirCompteARechargerIA(false);
    setFooterMiniMenuIA(true);
  }
  //on affiche la popup qui permet d'entrer le code de l'operation - rechargeCompteIzocash
  const [
    entrerCodeOperationRechargeCompteIzocash,
    setEntrerCodeOperationRechargeCompteIzocash,
  ] = useState(false);
  async function EntrerCodeOperationRechargeCompteIzocash() {
    setEntrerCodeOperationRechargeCompteIzocash(true);
  }
  //fermer le card
  async function CloseEntrerCodeOperationRechargeCompteIzocash() {
    setEntrerCodeOperationRechargeCompteIzocash(false);
    setChoisirCompteARechargerIA(false);
    setFooterMiniMenuIA(true);
  }

  // saisir code de l'operation
  // client communique le code - l'agent saisi le code de l'operation
  const [codeOperationIA, setCodeOperationIA] = useState("");
  if (codeOperationIA) {
    localStorage.setItem("https://alrani.com/codeOperationIA", codeOperationIA);
  }

  const getCodeOperationIA = localStorage.getItem("https://alrani.com/codeOperationIA");

  // logique pour verifier le code de l'operation - IA
  
  /* la logique ci va nous permettre de verifier si le code entrer dans l'input
  existe dans la bdd, si le code existe, alors on enregistre l'id de la personne dans le
  localStorage, car l'id de la personne va nous permettre de faire la recharge */
  async function CodeOperationIA() {
    setOpacity(true);

    // 1ere requete
    // 1ere requete
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/user`)
      .then((res) => {
        const api = res.data;
        //ici on cherche le code dans la bdd
        const codeTrouver = api.filter((api) => api.codeOperation === getCodeOperationIA);

        /* on met un petit blocus pour dire que si y'a pas de code, tu vas enregistrer rien
        dans la bdd. 
        si y'a 2 ou plusieurs code, alors tu vas enregistrer rien dans le localStorage
        si y'a 1 seul code trouver, alors tu vas enregistrer dans le localStorage l'id 
        de la personne qui detient ce code */
        const secureCode = codeTrouver.length;

        if (secureCode === 1) {
          //ici on cherche l'idClient qui est lier au code entrer
          const idClientIA = codeTrouver.map((x) => x._id);
          //ici on enregistre l'idPersonne ou idClient dans la bdd
          localStorage.setItem("https://alrani.com/idClientIA", idClientIA);
          //
          //
          //nom du client, adresse, numero de telephone
          const nomClientIA = codeTrouver.map((x) => x.nomValider);
          const adresseClientIA = codeTrouver.map((x) => x.adresseValider);
          const telephoneClientIA = codeTrouver.map((x) => x.telephoneValider);
          //ici on enregistre les informations du client dans le localStorage
          localStorage.setItem("https://alrani.com/nomClientIA", nomClientIA);
          localStorage.setItem("https://alrani.com/adresseClientIA", adresseClientIA);
          localStorage.setItem("https://alrani.com/telephoneClientIA", telephoneClientIA);

          setOpacity(false);
          setSelectionnerOptionRechargeCompteIA(true);
        } else {
          setOpacity(false);
          setErrorIA(true);
        }
        //le if de secureCode se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
      // 1ere requete
  }


  

  //numero Incorrect - IA
  /*Dans ce cas on veut recharger le client en passant par le numero de telephone, si le numero 
  entrer par l'agent est incorrect alors on va afficher ce message d'erreur */
  const [numeroIncorrectIA, setNumeroIncorrectIA] = useState(false);
  async function CloseNumeroIncorrectIA() {
    setNumeroIncorrectIA(false);
  }

  //quand on clique, une popup s'affiche puis on choisit son occupation - IA
  const [listOccupationIA, setListOccupationIA] = useState(false);
  async function ListOccupationIA() {
    setListOccupationIA(!listOccupationIA);
  }

  /* ici on recupere les valeurs des occupations, ca nous permettra d'afficher celles
  qui sont actives */
  const valeurOccupationEntrepreneur = localStorage.getItem(
    "https://alrani.com/entrepreneurIA"
  );
  const valeurOccupationTravailleur = localStorage.getItem(
    "https://alrani.com/travailleurIA"
  );
  const valeurOccupationEtudiant = localStorage.getItem(
    "https://alrani.com/etudiantIA"
  );
  const valeurOccupationChomeur = localStorage.getItem(
    "https://alrani.com/chomeurIA"
  );
  const occupationEntrepreneur = localStorage.getItem(
    "https://alrani.com/occupationEntrepreneurIA"
  );
  const occupationTravailleur = localStorage.getItem(
    "https://alrani.com/occupationTravailleurIA"
  );
  const occupationEtudiant = localStorage.getItem(
    "https://alrani.com/occupationEtudiantIA"
  );

  //numero Telephone Compte A recharger - IA
  //on affiche le card qui va nous permettre d'entrer le numero du compte a recharger
  const [
    numeroTelephoneCompteArechargerIA,
    setNumeroTelephoneCompteArechargerIA,
  ] = useState(false);
  async function NumeroTelephoneCompteArechargerIA() {
    setNumeroTelephoneCompteArechargerIA(true);
  }
  // bon! ici il s'agit du numero de telephone qui est entrer dans l'input
  const [
    inputNumeroTelephoneCompteArechargerIA,
    setInputNumeroTelephoneCompteArechargerIA,
  ] = useState("");
  if (inputNumeroTelephoneCompteArechargerIA) {
    localStorage.setItem(
      "https://alrani.com/numeroTelephoneCompteArechargerIA",
      inputNumeroTelephoneCompteArechargerIA
    );
  }
  const getNumeroTelephoneCompteArechargerIA = localStorage.getItem(
    "https://alrani.com/numeroTelephoneCompteArechargerIA"
  );
  /* la logique ci va nous permettre de verifier si le numero entrer dans l'input existe dans 
  la bdd. si le numero existe, alors on va enregistrer l'id de la personne qui detient le 
  numero dans le localStorage, car l'id de la personne va nous permettre de faire la recharge */
  async function ContinuerNumeroTelephoneCompteArechargerIA() {
    setOpacity(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/user`)
      .then((res) => {
        const api = res.data;
        //ici on cherche le numero dans la bdd
        const numeroTrouver = api.filter(
          (api) => api.telephone === getNumeroTelephoneCompteArechargerIA
        );

        /* on met un petit blocus pour dire que si l'agent a mal taper le numero, alors on
        affiche un message d'erreur disant "Numero incorrect".
        si le numero est trouvé, alors on va enregistrer dans le localStorage l'id 
        de la personne qui detient le numero trouver */
        const nbreDeNumeroTrouver = numeroTrouver.length;
        /*l'agent pourra recharger un compte en passant par le numero de telephone
        seulemnt si le codeOperation=000. */
        //on picke la valeur du codeOperation
        const codePickerIA = numeroTrouver.map((x) => x.codeOperation);
        /*je suis obliger d'enregistrer le codePickerIA dans le localStorage car lorsque 
        j'essaie sans enregistrer le code ca ne fonctionne pas */
        localStorage.setItem("https://alrani.com/codePickerIA", codePickerIA);
        const getCodePickerIA = localStorage.getItem(
          "https://alrani.com/codePickerIA"
        );
        if (getCodePickerIA === "000") {
          //ici le codePicker est egale a 000
          if (nbreDeNumeroTrouver === 1) {
            //ici on cherche l'idClient qui est lier au numero trouver
            const idClientIA = numeroTrouver.map((x) => x._id);
            //ici on enregistre l'idPersonne ou idClient dans la bdd
            localStorage.setItem("https://alrani.com/idClientIA", idClientIA);
            localStorage.removeItem(
              "https://alrani.com/numeroTelephoneCompteArechargerIA"
            );
            setOpacity(false);
          }
          //le if de nbreDeNumeroTrouver se ferme ici
        } else {
          //ici le codePicker n'est pas egale a 000
          setOpacity(false);
          setNumeroIncorrectIA(true);
        }
        //le if de codePickerIA se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }

  //fermer le card
  async function CloseNumeroTelephoneCompteArechargerIA() {
    setNumeroTelephoneCompteArechargerIA(false);
  }

  /* dans le cas ou c'est un entrepreneur, on affiche le card qui permet de modifier le
  nom de l'entreprise - IA */
  const [editOccupationEntrepreneurIA, setEditOccupationEntrepreneurIA] =
    useState(false);
  async function EditOccupationEntrepreneurIA() {
    setEditOccupationEntrepreneurIA(true);
  }
  // fermer le card qui permet de modifier le nom de l'entreprise - IA
  async function CloseEditOccupationEntrepreneurIA() {
    setEditOccupationEntrepreneurIA(false);
  }

  /* dans le cas ou c'est un travailleur, on affiche le card qui permet de modifier le
  nom de l'entreprise pour laquelle elle travaille - IA */
  const [editOccupationTravailleurIA, setEditOccupationTravailleurIA] =
    useState(false);
  async function EditOccupationTravailleurIA() {
    setEditOccupationTravailleurIA(true);
  }
  /* fermer le card 
  qui permet de modifier le nom de l'entreprise pour laquelle elle travaille - IA */
  async function CloseEditOccupationTravailleurIA() {
    setEditOccupationTravailleurIA(false);
  }

  /* dans le cas ou c'est un etudiant, on affiche le card qui permet de modifier le
   nom de l'ecole ou il fait ses etudes - IA */
  const [editOccupationEtudiantIA, setEditOccupationEtudiantIA] =
    useState(false);
  async function EditOccupationEtudiantIA() {
    setEditOccupationEtudiantIA(true);
  }
  // fermer le card qui permet de modifier le nom de l'ecole - IA
  async function CloseEditOccupationEtudiantIA() {
    setEditOccupationEtudiantIA(false);
  }

  //Enregistrer Occupation Entrepreneur - IA
  //Enregistrer Occupation Entrepreneur - IA
  //quand on clique, on enregistre le nom de son entreprise dans la bdd
  const [
    enregistrerOccupationEntrepreneurIA,
    setEnregistrerOccupationEntrepreneurIA,
  ] = useState("");
  //valeurOccupationEntrepreneur on le met a 1 pour que Entrepreneur soit active
  //valeurOccupationTravailleur on le met a 0 pour que Travailleur ne soit pas active
  //valeurOccupationEtudiant on le met a 0 pour que Etudiant ne soit pas active
  //valeurOccupationChomeur on le met a 0 pour que Chomeur ne soit pas active
  const aavaleurOccupationEntrepreneur = "1";
  const aavaleurOccupationTravailleur = "0";
  const aavaleurOccupationEtudiant = "0";
  const aavaleurOccupationChomeur = "0";
  async function EnregistrerOccupationEntrepreneurIA() {
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
      data: {
        //dans occupationEntrepreneur il y'a le nom de son entreprise
        occupationEntrepreneur: enregistrerOccupationEntrepreneurIA,
        valeurOccupationEntrepreneur: aavaleurOccupationEntrepreneur,
        valeurOccupationTravailleur: aavaleurOccupationTravailleur,
        valeurOccupationEtudiant: aavaleurOccupationEtudiant,
        valeurOccupationChomeur: aavaleurOccupationChomeur,
      },
    })
      .then((res) => {
        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/user`)
            .then((res) => {
              const api = res.data;
              // filtre pour obtenir uniquement les infos de la personne connecter
              const filtreApiUser = api.filter(
                (api) => api._id === idPersonConnectedIA
              );
              //occupation entrepreneur
              const occupationEntrepreneurIA = filtreApiUser.map(
                (api) => api.occupationEntrepreneur
              );
              localStorage.setItem(
                "https://alrani.com/occupationEntrepreneurIA",
                occupationEntrepreneurIA
              );

              //valeur entrepreneur
              const valeurOccupationEntrepreneurIA = filtreApiUser.map(
                (api) => api.valeurOccupationEntrepreneur
              );
              localStorage.setItem(
                "https://alrani.com/entrepreneurIA",
                valeurOccupationEntrepreneurIA
              );

              //valeur travailleur
              const valeurOccupationTravailleurIA = filtreApiUser.map(
                (api) => api.valeurOccupationTravailleur
              );
              localStorage.setItem(
                "https://alrani.com/travailleurIA",
                valeurOccupationTravailleurIA
              );

              //valeur etudiant
              const valeurOccupationEtudiantIA = filtreApiUser.map(
                (api) => api.valeurOccupationEtudiant
              );
              localStorage.setItem(
                "https://alrani.com/etudiantIA",
                valeurOccupationEtudiantIA
              );

              //valeur chomeur
              const valeurOccupationChomeurIA = filtreApiUser.map(
                (api) => api.valeurOccupationChomeur
              );
              localStorage.setItem(
                "https://alrani.com/chomeurIA",
                valeurOccupationChomeurIA
              );

              setOpacity(false);
              setEditOccupationEntrepreneurIA(false);
              setListOccupationIA(false);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //Enregistrer Occupation Entrepreneur - IA

  //Enregistrer Occupation Travailleur - IA
  //Enregistrer Occupation Travailleur - IA
  //quand on clique, on enregistre le nom de l'entreprise ou il a travailler dans la bdd
  const [
    enregistrerOccupationTravailleurIA,
    setEnregistrerOccupationTravailleurIA,
  ] = useState("");
  //valeurOccupationTravailleur on le met a 1 pour que Travailleur soit active
  //valeurOccupationEntrepreneur on le met a 0 pour que Entrepreneur ne soit pas active
  //valeurOccupationEtudiant on le met a 0 pour que Etudiant ne soit pas active
  //valeurOccupationChomeur on le met a 0 pour que Chomeur ne soit pas active
  const bbvaleurOccupationTravailleur = "1";
  const bbvaleurOccupationEntrepreneur = "0";
  const bbvaleurOccupationEtudiant = "0";
  const bbvaleurOccupationChomeur = "0";
  async function EnregistrerOccupationTravailleurIA() {
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
      data: {
        //dans occupationTravailleur il y'a le nom de l'entreprise ou il a travailler
        occupationTravailleur: enregistrerOccupationTravailleurIA,
        valeurOccupationEntrepreneur: bbvaleurOccupationEntrepreneur,
        valeurOccupationTravailleur: bbvaleurOccupationTravailleur,
        valeurOccupationEtudiant: bbvaleurOccupationEtudiant,
        valeurOccupationChomeur: bbvaleurOccupationChomeur,
      },
    })
      .then((res) => {
        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/user`)
            .then((res) => {
              const api = res.data;
              // filtre pour obtenir uniquement les infos de la personne connecter
              const filtreApiUser = api.filter(
                (api) => api._id === idPersonConnectedIA
              );
              //occupation Travailleur
              const occupationTravailleurIA = filtreApiUser.map(
                (api) => api.occupationTravailleur
              );
              localStorage.setItem(
                "https://alrani.com/occupationTravailleurIA",
                occupationTravailleurIA
              );

              //valeur entrepreneur
              const valeurOccupationEntrepreneurIA = filtreApiUser.map(
                (api) => api.valeurOccupationEntrepreneur
              );
              localStorage.setItem(
                "https://alrani.com/entrepreneurIA",
                valeurOccupationEntrepreneurIA
              );

              //valeur travailleur
              const valeurOccupationTravailleurIA = filtreApiUser.map(
                (api) => api.valeurOccupationTravailleur
              );
              localStorage.setItem(
                "https://alrani.com/travailleurIA",
                valeurOccupationTravailleurIA
              );

              //valeur etudiant
              const valeurOccupationEtudiantIA = filtreApiUser.map(
                (api) => api.valeurOccupationEtudiant
              );
              localStorage.setItem(
                "https://alrani.com/etudiantIA",
                valeurOccupationEtudiantIA
              );

              //valeur chomeur
              const valeurOccupationChomeurIA = filtreApiUser.map(
                (api) => api.valeurOccupationChomeur
              );
              localStorage.setItem(
                "https://alrani.com/chomeurIA",
                valeurOccupationChomeurIA
              );

              setOpacity(false);
              setEditOccupationTravailleurIA(false);
              setListOccupationIA(false);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //Enregistrer Occupation Travailleur - IA

  //Enregistrer Occupation Etudiant - IA
  //Enregistrer Occupation Etudiant - IA
  //quand on clique, on enregistre le nom de l'ecole ou il etudie dans la bdd
  const [enregistrerOccupationEtudiantIA, setEnregistrerOccupationEtudiantIA] =
    useState("");
  //valeurOccupationEtudiant on le met a 1 pour que Etudiant soit active
  //valeurOccupationEntrepreneur on le met a 0 pour que Entrepreneur ne soit pas active
  //valeurOccupationTravailleur on le met a 0 pour que Travailleur ne soit pas active
  //valeurOccupationChomeur on le met a 0 pour que Chomeur ne soit pas active
  const ccvaleurOccupationEtudiant = "1";
  const ccvaleurOccupationEntrepreneur = "0";
  const ccvaleurOccupationTravailleur = "0";
  const ccvaleurOccupationChomeur = "0";
  async function EnregistrerOccupationEtudiantIA() {
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
      data: {
        //dans occupationEtudiant il y'a le nom de l'ecole ou il etudie
        /* valeurOccupationEtudiant, c'est le chiffre 1, ca va permettre de mettre 
        Etudiant active */
        occupationEtudiant: enregistrerOccupationEtudiantIA,
        valeurOccupationEntrepreneur: ccvaleurOccupationEntrepreneur,
        valeurOccupationTravailleur: ccvaleurOccupationTravailleur,
        valeurOccupationEtudiant: ccvaleurOccupationEtudiant,
        valeurOccupationChomeur: ccvaleurOccupationChomeur,
      },
    })
      .then((res) => {
        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/user`)
            .then((res) => {
              const api = res.data;
              // filtre pour obtenir uniquement les infos de la personne connecter
              const filtreApiUser = api.filter(
                (api) => api._id === idPersonConnectedIA
              );
              //occupation etudiant
              const occupationEtudiantIA = filtreApiUser.map(
                (api) => api.occupationEtudiant
              );
              localStorage.setItem(
                "https://alrani.com/occupationEtudiantIA",
                occupationEtudiantIA
              );

              //valeur entrepreneur
              const valeurOccupationEntrepreneurIA = filtreApiUser.map(
                (api) => api.valeurOccupationEntrepreneur
              );
              localStorage.setItem(
                "https://alrani.com/entrepreneurIA",
                valeurOccupationEntrepreneurIA
              );

              //valeur travailleur
              const valeurOccupationTravailleurIA = filtreApiUser.map(
                (api) => api.valeurOccupationTravailleur
              );
              localStorage.setItem(
                "https://alrani.com/travailleurIA",
                valeurOccupationTravailleurIA
              );

              //valeur etudiant
              const valeurOccupationEtudiantIA = filtreApiUser.map(
                (api) => api.valeurOccupationEtudiant
              );
              localStorage.setItem(
                "https://alrani.com/etudiantIA",
                valeurOccupationEtudiantIA
              );

              //valeur chomeur
              const valeurOccupationChomeurIA = filtreApiUser.map(
                (api) => api.valeurOccupationChomeur
              );
              localStorage.setItem(
                "https://alrani.com/chomeurIA",
                valeurOccupationChomeurIA
              );

              setOpacity(false);
              setEditOccupationEtudiantIA(false);
              setListOccupationIA(false);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //Enregistrer Occupation Etudiant - IA

  //Enregistrer Occupation Chomeur - IA
  //Enregistrer Occupation Chomeur - IA
  //vu que c'est un chomeur, alors il n'y a pas d'occupation a enregistrer dans la bdd
  ///
  //valeurOccupationEntrepreneur on le met a 0 pour que Entrepreneur ne soit pas active
  //valeurOccupationTravailleur on le met a 0 pour que Travailleur ne soit pas active
  //valeurOccupationEtudiant on le met a 0 pour que Etudiant ne soit pas active
  //valeurOccupationChomeur on le met a 1 pour que Chomeur soit active
  //j'ai mis dd devant juste pour differencier avec les autres const qui ont les memes noms
  const ddvaleurOccupationEntrepreneur = "0";
  const ddvaleurOccupationTravailleur = "0";
  const ddvaleurOccupationEtudiant = "0";
  const ddvaleurOccupationChomeur = "1";
  async function EnregistrerOccupationChomeurIA() {
    setOpacity(true);
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedIA}`,
      data: {
        //le Chomeur n'a pas d'occupation
        valeurOccupationEntrepreneur: ddvaleurOccupationEntrepreneur,
        valeurOccupationTravailleur: ddvaleurOccupationTravailleur,
        valeurOccupationEtudiant: ddvaleurOccupationEtudiant,
        valeurOccupationChomeur: ddvaleurOccupationChomeur,
      },
    })
      .then((res) => {
        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/user`)
            .then((res) => {
              const api = res.data;
              // filtre pour obtenir uniquement les infos de la personne connecter
              const filtreApiUser = api.filter(
                (api) => api._id === idPersonConnectedIA
              );
              //occupation chomeur
              const occupationChomeurIA = filtreApiUser.map(
                (api) => api.occupationChomeur
              );
              localStorage.setItem(
                "https://alrani.com/occupationChomeurIA",
                occupationChomeurIA
              );

              //valeur entrepreneur
              const valeurOccupationEntrepreneurIA = filtreApiUser.map(
                (api) => api.valeurOccupationEntrepreneur
              );
              localStorage.setItem(
                "https://alrani.com/entrepreneurIA",
                valeurOccupationEntrepreneurIA
              );

              //valeur travailleur
              const valeurOccupationTravailleurIA = filtreApiUser.map(
                (api) => api.valeurOccupationTravailleur
              );
              localStorage.setItem(
                "https://alrani.com/travailleurIA",
                valeurOccupationTravailleurIA
              );

              //valeur etudiant
              const valeurOccupationEtudiantIA = filtreApiUser.map(
                (api) => api.valeurOccupationEtudiant
              );
              localStorage.setItem(
                "https://alrani.com/etudiantIA",
                valeurOccupationEtudiantIA
              );

              //valeur chomeur
              const valeurOccupationChomeurIA = filtreApiUser.map(
                (api) => api.valeurOccupationChomeur
              );
              localStorage.setItem(
                "https://alrani.com/chomeurIA",
                valeurOccupationChomeurIA
              );

              setOpacity(false);
              setSuperIA(true);
            })
            .catch((err) => {
              setOpacity(false);
              setErrorIA(true);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        setErrorIA(true);
      });
  }
  //Enregistrer Occupation Chomeur - IA

  // Swazi Lilangeni
  // Swazi Lilangeni
  /* quand on clique sur Swazi Lilangeni, la monnaie Swazi Lilangeni sur laquelle on a cliquer 
  sera active avec la couleur jaune */
  const [swaziLilangeni, setSwaziLilangeni] = useState(false);
  async function SwaziLilangeni() {
    setSwaziLilangeni(true);
    /* si dans le localStorage le swazi Lilangeni=1, cela veut dire que le swazi Lilangeni sera 
    active comme on a fait avec les themes. 
    si le swazi Lilangeni=0, alors elle ne sera pas active */
    const leSwaziLilangeni = "1";
    localStorage.setItem("https://alrani.com/SwaziLilangeni", leSwaziLilangeni);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setEuro(false);
    setRealBresilien(false);
    setDollarAmericain(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFranc(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
  }

  // Euro
  // Euro
  /* quand on clique sur Euro, la monnaie Euro sur laquelle on a cliquer sera active avec 
  la couleur jaune */
  const [euro, setEuro] = useState(false);
  async function Euro() {
    setEuro(true);
    /* si dans le localStorage l'Euro=1, cela veut dire que Euro sera active comme on a fait 
    avec les themes. si Euro=0, alors elle ne sera pas active */
    const LEuro = "1";
    localStorage.setItem("https://alrani.com/Euro", LEuro);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setRealBresilien(false);
    setDollarAmericain(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFranc(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
  }

  // Dollar Américain
  // Dollar Américain
  /* quand on clique sur Dollar Américain, la monnaie Dollar Américain sur laquelle on a cliquer 
  sera active avec la couleur jaune */
  const [dollarAmericain, setDollarAmericain] = useState(false);
  async function DollarAmericain() {
    setDollarAmericain(true);
    /* si dans le localStorage dollarAmericain=1, cela veut dire que dollarAmericain sera active 
    comme on a fait avec les themes. si Euro=0, alors elle ne sera pas active */
    const leDollarAmericain = "1";
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      leDollarAmericain
    );
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setEuro(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFranc(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
  }

  // Real Brésilien
  // Real Brésilien
  /* quand on clique sur Real Brésilien, la monnaie Real Brésilien sur laquelle on a cliquer 
  sera active avec la couleur jaune */
  const [realBresilien, setRealBresilien] = useState(false);
  async function RealBresilien() {
    setRealBresilien(true);
    /* si dans le localStorage le Real Bresilien=1, cela veut dire que realBresilien sera active 
    comme on a fait avec les themes. si le Real Bresilien=0, alors elle ne sera pas active */
    const leRealBresilien = "1";
    localStorage.setItem("https://alrani.com/RealBresilien", leRealBresilien);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setEuro(false);
    setDollarAmericain(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFranc(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
  }

  // Franc CFA
  // Franc CFA
  /* quand on clique sur Franc CFA, la monnaie Franc CFA sur laquelle on a cliquer sera 
  active avec la couleur jaune */
  const [franc, setFranc] = useState(false);
  async function Franc() {
    setFranc(true);
    /* si dans le localStorage le Franc CFA=1, cela veut dire que le Franc CFA sera active 
    comme on a fait avec les themes. si le Franc CFA=0, alors elle ne sera pas active */
    const leFrancCFA = "1";
    localStorage.setItem("https://alrani.com/FrancCFA", leFrancCFA);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setEuro(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
  }

  // Franc Congolais
  // Franc Congolais
  /* quand on clique sur Franc Congolais, la monnaie Franc Congolais sur laquelle on a 
   cliquer sera active avec la couleur jaune */
  const [francCongolais, setFrancCongolais] = useState(false);
  async function FrancCongolais() {
    setFrancCongolais(true);
    /* si dans le localStorage FrancCongolais=1, cela veut dire que le FrancCongolais sera 
    active comme on a fait avec les themes. si FrancCongolais=0, alors elle ne sera pas active */
    const leFrancCongolais = "1";
    localStorage.setItem("https://alrani.com/FrancCongolais", leFrancCongolais);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setEuro(false);
    setFranc(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
  }

  // Franc Suisse
  // Franc Suisse
  /* quand on clique sur Franc Suisse, la monnaie Franc Suisse sur laquelle on a cliquer 
   sera active avec la couleur jaune */
  const [francSuisse, setFrancSuisse] = useState(false);
  async function FrancSuisse() {
    setFrancSuisse(true);
    /* si dans le localStorage FrancSuisse=1, cela veut dire que le FrancSuisse sera 
    active comme on a fait avec les themes. si FrancSuisse=0, alors elle ne sera pas active */
    const leFrancSuisse = "1";
    localStorage.setItem("https://alrani.com/FrancSuisse", leFrancSuisse);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFrancGuineen(false);
    setFrancCongolais(false);
    setEuro(false);
    setFranc(false);
  }

  // Franc Guineen
  // Franc Guineen
  /* quand on clique sur Franc Guineen, la monnaie Franc Guineen sur laquelle on a cliquer 
   sera active avec la couleur jaune */
  const [francGuineen, setFrancGuineen] = useState(false);
  async function FrancGuineen() {
    setFrancGuineen(true);
    /* si dans le localStorage FrancGuineen=1, cela veut dire que le FrancGuineen sera 
    active comme on a fait avec les themes. si FrancGuineen=0, alors elle ne sera pas active */
    const leFrancGuineen = "1";
    localStorage.setItem("https://alrani.com/FrancGuineen", leFrancGuineen);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
    setEuro(false); 
    setFranc(false);
  }

  // Franc Burundais
  // Franc Burundais
  /* quand on clique sur Franc Burundais, la monnaie Franc Burundais sur laquelle on a cliquer 
  sera active avec la couleur jaune */
  const [francBurundais, setFrancBurundais] = useState(false);
  async function FrancBurundais() {
    setFrancBurundais(true);
    /* si dans le localStorage FrancBurundais=1, cela veut dire que leFrancBurundais sera 
    active comme on a fait avec les themes. si FrancBurundais=0, alors elle ne sera pas active */
    const leFrancBurundais = "1";
    localStorage.setItem("https://alrani.com/FrancBurundais", leFrancBurundais);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
    setEuro(false);
    setFranc(false);
  }

  // dinar Algerien
  // dinar Algerien
  /* quand on clique sur dinar Algerien, la monnaie dinar Algerien sur laquelle on a cliquer 
  sera active avec la couleur jaune */
  const [dinarAlgerien, setDinarAlgerien] = useState(false);
  async function DinarAlgerien() {
    setDinarAlgerien(true);
    /* si dans le localStorage DinarAlgerien=1, cela veut dire que le DinarAlgerien sera 
    active comme on a fait avec les themes. si DinarAlgerien=0, alors elle ne sera pas active */
    const leDinarAlgerien = "1";
    localStorage.setItem("https://alrani.com/DinarAlgerien", leDinarAlgerien);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarTunisien(false);
    setFrancBurundais(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
    setEuro(false);
    setFranc(false);
  }

  // dirham Marocain
  // dirham Marocain
  /* quand on clique sur dirham Marocain, la monnaie dirham Marocain sur laquelle on a cliquer
   sera active avec la couleur jaune */
  const [dirhamMarocain, setDirhamMarocain] = useState(false);
  async function DirhamMarocain() {
    setDirhamMarocain(true);
    /*si dans le localStorage DirhamMarocain=1, cela veut dire que le DirhamMarocain sera 
    active comme on a fait avec les themes. si DirhamMarocain=0, alors elle ne sera pas active */
    const leDirhamMarocain = "1";
    localStorage.setItem("https://alrani.com/DirhamMarocain", leDirhamMarocain);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/DinarTunisien", monnaiesNonActive);
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDinarTunisien(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
    setEuro(false);
    setFranc(false);
  }

  // Dinar Tunisien
  // Dinar Tunisien
  /* quand on clique sur Dinar Tunisien, la monnaie Dinar Tunisien sur laquelle on a cliquer
   sera active avec la couleur jaune */
  const [dinarTunisien, setDinarTunisien] = useState(false);
  async function DinarTunisien() {
    setDinarTunisien(true);
    /* si dans le localStorage DinarTunisien=1, cela veut dire que le DinarTunisien sera 
    active comme on a fait avec les themes. si DinarTunisien=0, alors elle ne sera pas active */
    const leDinarTunisien = "1";
    localStorage.setItem("https://alrani.com/DinarTunisien", leDinarTunisien);
    /* ca se sont les autres monnaies, quand on clique on doit les mettre a 0 pour qu'ils ne
    soient pas active */
    const monnaiesNonActive = "0";
    localStorage.setItem(
      "https://alrani.com/SwaziLilangeni",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/Euro", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DollarAmericain",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/FrancCFA", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancCongolais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/RealBresilien", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancSuisse", monnaiesNonActive);
    localStorage.setItem("https://alrani.com/FrancGuineen", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/FrancBurundais",
      monnaiesNonActive
    );
    localStorage.setItem("https://alrani.com/DinarAlgerien", monnaiesNonActive);
    localStorage.setItem(
      "https://alrani.com/DirhamMarocain",
      monnaiesNonActive
    );
    //
    setSwaziLilangeni(false);
    setDollarAmericain(false);
    setRealBresilien(false);
    setDirhamMarocain(false);
    setDinarAlgerien(false);
    setFrancBurundais(false);
    setFrancGuineen(false);
    setFrancSuisse(false);
    setFrancCongolais(false);
    setEuro(false);
    setFranc(false);
  }

  // on affiche PublicationEnAttente/rejeté - page
  const [publicationEnAttente, setPublicationEnAttente] = useState(false);
  async function PublicationEnAttente() {
    setPublicationEnAttente(!publicationEnAttente);
  }
  // ici on switch/toggle entre les onglets
  // Quand on clique sur en attente/ onglet en attente active
  const [enAttente, setEnAttente] = useState(true);
  async function EnAttenteTrue() {
    setEnAttente(true);
    setRejeter(false);
  }
  // Quand on clique sur rejeter/ onglet rejeter active
  const [rejeter, setRejeter] = useState(false);
  async function RejeterTrue() {
    setEnAttente(false);
    setRejeter(true);
  }
  /* au niveau de publications en attente/rejeté on a fait que, 
  quand on clique sur le BackBtn, on a l'option Retour et l'option Actualiser la page */
  const [backBtn, setBackBtn] = useState(false);
  async function BackBtn() {
    setBackBtn(!backBtn);
  }
  // actualiser post
  /* ici on actualise les post par exemple apres avoir cliquer sur
  Rejeter la publication, Approuver la publication,.. */
  async function ActualiserPost() {
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA/`)
      .then((res) => {
        setApiPosts(res.data);
      });
  }
  const filtreApiPosts = apiPosts.filter((item) => item.idAuteur === idPage);
  // c'est pour le pluriel au niveau de publicationEnAttente
  /* lorsqu'on affiche par exemple Aucune publication en attente de validation ou bien
  Ces publications sont en attente de validation,... */
  const postEnAttente = filtreApiPosts.filter(
    (item) => item.postApprouver === "3"
  );
  const plusieursPublicationEnAttente = postEnAttente.length > 0;
  const nbrePublicationEnAttente = postEnAttente.length;
  const unePublicationEnAttente = postEnAttente.length > 1;

  // c'est pour le pluriel au niveau de publicationRejeter
  /* lorsqu'on affiche par exemple Aucune publication rejetée ou 3 publications rejetées, ... */
  const postRejeter = filtreApiPosts.filter(
    (item) => item.postApprouver === "0"
  );
  const plusieursPublicationRejeter = postRejeter.length > 0;
  const nbrePublicationRejeter = postRejeter.length;
  const unePublicationRejeter = postRejeter.length > 1;

  // ajouter un administrateur
  const [ajouterAdmin, setAjouterAdmin] = useState(false);
  async function AjouterAdmin() {
    setAjouterAdmin(!ajouterAdmin);
  }
  // apres avoir retirer un admin, on actualise la page pour avoir les nouvelles données
  // ca c'est la popup qui va permettre de cliquer sur le btn Actualiser Page
  const [actualiserPage, setActualiserPage] = useState(false);
  async function ActualiserPage() {
    setActualiserPage(!actualiserPage);
  }
  // ici on actualise la page
  async function RetirerAdminActualiserPage() {
    setOpacity(true);
    setErreur(true);
  }

  // cette requete c'est pour afficher la liste des administrateurs qui ont été ajouté à la page

  // on affiche les auteurs en fonction de la page
  //const filtreApiAdmin = apiAdmin.filter((api) => api.idPage === idPage);
  //const filtreApiAdmin = localStorage.getItem("alrani");
  const idPage = localStorage.getItem("alrani");
  
  
  // on affiche la liste des pages ou je suis administrateur
  //const obtenirListeDesPages = apiAdmin.filter((api) => api.idAdmin === idPersonConnectedAA);
  //const obtenirListeDesPages = localStorage.getItem("alrani");

  // un administrateur
  // page pour ajouter un administrateur supreme ou lombda
  // si c'est true la page est declencher
  const [pageAjouterAdmin, setPageAjouterAdmin] = useState(false);
  async function ClosePageAjouterAdmin() {
    setPageAjouterAdmin(false);
    // on supprime la variable search qui est enregistrer dans le localStorage
    localStorage.removeItem("https://alrani.com/search");
    // Actualiser Admin
    // Actualiser Admin
    // Actualiser Admin
    // requete pour afficher une nouvelle liste des administrateurs
    /* par exemple apres avoir ajouter un administrateur supreme ou lombda, on fait cette 
    nouvelle requete pour afficher une nouvelle liste qui comportera le nouveau 
    administrateur qui a ete ajouter
    */
    async function ActualiserAdmin() {
          setErreur(true);
      /*await axios
        .get(`${process.env.REACT_APP_BACKEND}/api//`)
        .then((res) => {
        })
        .catch((err) => {
        });*/
    }
    ActualiserAdmin();
    // Actualiser Admin
  }
  // supreme
  // supreme
  // on declenche la page de recherche qui permet d'ajouter un administrateur supreme
  async function AjouterAdminSupreme() {
    // ici on enregistre le role de l'administrateur supreme dans le localStorage
    // ce role sera utile lorsqu'on va enregistrer l'administrateur dans la bdd
    const supreme = "2";
    localStorage.setItem("https://alrani.com/enAttenteRoleAdmin", supreme);
    // bon! ca c'est le postApprouver pour l'admin suppreme
    /* le postApprouver est utile car si c'est l'admin suppreme ca va publier directement 
    sans besoin d'approbation */
    const postApprouver = "1";
    localStorage.setItem(
      "https://alrani.com/postApprouverAdmin",
      postApprouver
    );
    // ici on declenche la page de recherche qui permet d'ajouter un administrateur supreme
    setPageAjouterAdmin(true);
  }
  // lombda
  // lombda
  // on declenche la page de recherche qui permet d'ajouter un administrateur lombda
  async function AjouterAdminLombda() {
    // ici on enregistre le role de l'administrateur lombda dans le localStorage
    // ce role sera utile lorsqu'on va enregistrer l'administrateur dans la bdd
    const lombda = "3";
    localStorage.setItem("https://alrani.com/enAttenteRoleAdmin", lombda);
    // bon! ca c'est le postApprouver pour l'admin lombda
    /* le postApprouver est utile car si c'est l'admin suppreme ca va publier directement 
    sans besoin d'approbation mais si c'est l'admin lombda qui a publier, sa publication aura
    besoin d'approbation(ca va etre dans la partie des publications en attente d'approbation) */
    const postApprouver = "3";
    localStorage.setItem(
      "https://alrani.com/postApprouverAdmin",
      postApprouver
    );
    // ici on declenche la page de recherche qui permet d'ajouter un administrateur lombda
    setPageAjouterAdmin(true);
  }

  // cette requete c'est lorsqu'on decide d'ajouter un nouvel administrateur
  // ca c'est pour la variable lorsqu'on reherche un administrateur
  // lorsque l'utilisateur tape dans la barre de recherche
  const [search, setSearch] = useState("");
  if (search) {
    localStorage.setItem("https://alrani.com/search", search);
  }
  const getSearch = localStorage.getItem("https://alrani.com/search");

  const compteTrouver = apiAccountAA.filter((api) =>
    api.nameAccount.includes(getSearch)
  );

  // quand on clique, la notification - page va s'afficher
  const [notification, setNotification] = useState(false);
  async function Notification() {
    setNotification(!notification);
  }
  // cette requete c'est pour afficher toutes les notifications de l'utilisateur
  const [apiNotification, setApiNotification] = useState([]);

  // on veut afficher les notifications par compte, on va filtrer par id
  const filtreApiNotification = apiNotification.filter(
    (api) => api.idDestinataire === idPersonConnectedAA
  );

  /* quand on clique sur ce backBtn, il va declencher la popup qui va permettre d'actualiser
  les notifications */
  const [backBtnNotificationPage, setBackBtnNotificationPage] = useState(false);
  async function BackBtnNotificationPage() {
    setBackBtnNotificationPage(!backBtnNotificationPage);
  }
  // logique pour actualiser les notifications
  // on actualise les notifications par exemple apres avoir supprimer une notification
  async function ActualiserNotification() {
    setOpacity(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA/`)
      .then((res) => {
        setApiNotification(res.data);
        setOpacity(false);
      })
      .catch((err) => {
        setOpacity(false);
        setErreur(true);
      });
  }

  /* quand on clique sur la notification, on va envoyer une variable qui va marquer 
    la notification comme lue */
  const idNotification = localStorage.getItem(
    "https://alrani.com/idNotification"
  );
  // notificationLu=1 veut dire que la notification a ete lu
  const notificationLu = "1";
  //1ere requete
  //1ere requete
  // ici on envoie une variable qui va marquer la notification comme lue
  async function MarquerNotificationLue() {
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/notificationAA/update/${idNotification}`,
      data: {
        lu: notificationLu,
      },
    }).then((res) => {
      // 2e requete
      // 2e requete
      /* maintenant que l'update a la bdd a ete fait, on fait une 2e requete pour
        que la notification puisse s'afficher comme lue */
      async function deuxiemeReq() {
        await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA/`)
          .then((res) => {
            setApiNotification(res.data);
          });
      }
      deuxiemeReq();
      // 2e requete
    });
    //1ere requete
  }

  // on recupere la valeur pour savoir si l'utilisateur a un compte professionnel ou non
  const utilisateur = localStorage.getItem("https://alrani.com/utilisateur");

  // roleAdmin ici nous permet de masquer certains choses a l'admin supreme/lombda
  /* par exemple on va masquer le btn ajouter un administrateur a l'admin lombda */
  //const roleAdmin = localStorage.getItem("https://alrani.com/roleAdmin");

  // sans etre connecter
  // ce code empeche l'utilisateur d'utiliser certaines fonctionnaliter sans etre connecter
  const [sansEtreConnecter, setSansEtreConnecter] = useState(false);
  async function SansEtreConnecter() {
    setSansEtreConnecter(!sansEtreConnecter);
  }
  
  
  const [newApp, setNewApp] = useState(false);
  async function NewApp() {
    setNewApp(true);
  }
  async function CloseNewApp() {
    setNewApp(false);
  }
  
  
  // missionApp
  const [missionApp, setMissionApp] = useState(false);
  async function MissionApp() {
    setMissionApp(true);
  }
  
  
  const [index, setIndex] = useState(0); // mission actuelle
  const [message1, setMessage1] = useState("");
  const [ecrireMA, setEcrireMA] = useState("");
  const missionActuelle = missions[index];
  
  const [nomMembre, setNomMembre] = useState("");

  //Charger le nom du membre dès le démarrage
  useEffect(() => {
    const nomEnregistre = localStorage.getItem("NomDeMembreFlorinato");
	const missionSauvegarder = localStorage.getItem("missionSauvegarder");
	
	if (nomEnregistre) setNomMembre(nomEnregistre);
    if (missionSauvegarder) setIndex(parseInt(missionSauvegarder, 10));
  }, []);
  

  const EnvoyerMission = () => {
	const reponse = ecrireMA.trim().toLowerCase();

	  // Cas spécial : mission 10 (nom libre)
	  if (missionActuelle.mot === "NOM_LIBRE") {
		if (reponse.length === 0) {
		  setMessage1("Entrez votre nom de Membre Florinato !");
		  return;
		}
		setMessage1("✅ Nom enregistré avec succès !");
		
		localStorage.setItem("NomDeMembreFlorinato", ecrireMA.trim());
        setNomMembre(ecrireMA.trim());
	  }  
	  
	  // Cas normal
	  else if (reponse === missionActuelle.mot.toLowerCase()) {
		setMessage1("✅ Bonne réponse !");
	  } else {
		setMessage1("Mauvaise réponse, réessayez !");
		return;
	  }
	  
	  // Si bonne réponse → passe à la suivante
      setTimeout(() => {
        setMessage1("");
        setEcrireMA("");
		
		//Sauvegarde la progression dans le localStorage
        setIndex((prev) => {
          const nextIndex = prev + 1 < missions.length ? prev + 1 : prev; //pour passer à la mission suivante
          localStorage.setItem("missionSauvegarder", nextIndex);
          return nextIndex;
        });
      }, 2000);
  };


  // Telephone Virtuel
  // Telephone Virtuel
  // quand on clique, ca va ouvrir le menu des applications dans le telephone virtuel
  const [telephoneVirtuel, setTelephoneVirtuel] = useState(false);

  //ouvrir menu applications - telephone Virtuel
  async function CloseAlraniAppGotoMenuTelephone() { setTelephoneVirtuel(true); }

  // infos Language
  // infos Language
  // on affiche cette petite infos au niveau de la page ou il ya toutes les langues
  const [infosLanguage, setInfosLanguage] = useState(false);
  async function InfosLanguage() {
    setInfosLanguage(true);
  }
  //fermer
  async function CloseInfosLanguage() {
    setInfosLanguage(false);
  }

  // translation
  // translation
  const [translation, setTranslation] = useState(false);
  async function Translation() {
    setTranslation(true);
  }
  //fermer
  async function CloseTranslation() {
    setTranslation(false);
  }

  // logique pour changer une langue
  const { t } = useTranslation();
  async function ChangeLanguage(lng) {
    i18n.changeLanguage(lng);
  }

  // rtl - ca c'est pour les rtl (clavier de la droite vers la gauche)
  const getRtl = localStorage.getItem("rtl");
  const [rtl, setRtl] = useState(getRtl === "1");

  // afrikaans
  // afrikaans.
  const getAfrikaans = localStorage.getItem("afrikaans");
  const [afrikaans, setAfrikaans] = useState(getAfrikaans);
  async function Afrikaans() {
    const afrikaans = true;
    localStorage.setItem("afrikaans", afrikaans);
    setAfrikaans(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // albanian
  // albanian
  const getAlbanian = localStorage.getItem("albanian");
  const [albanian, setAlbanian] = useState(getAlbanian);
  async function Albanian() {
    const albanian = true;
    localStorage.setItem("albanian", albanian);
    setAlbanian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // amharic
  // amharic
  const getAmharic = localStorage.getItem("amharic");
  const [amharic, setAmharic] = useState(getAmharic);
  async function Amharic() {
    const amharic = true;
    localStorage.setItem("amharic", amharic);
    setAmharic(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // arabic
  // arabic
  const getArabic = localStorage.getItem("arabic");
  const [arabic, setArabic] = useState(getArabic);
  async function Arabic() {
    const arabic = true;
    localStorage.setItem("arabic", arabic);
    setArabic(true);
    // rtl
    const rtl = "1"; 
    localStorage.setItem("rtl", rtl);
    setRtl(true);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // armenian
  // armenian
  const getArmenian = localStorage.getItem("armenian");
  const [armenian, setArmenian] = useState(getArmenian);
  async function Armenian() {
    const armenian = true;
    localStorage.setItem("armenian", armenian);
    setArmenian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic(false); setArabic(false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // assamese
  // assamese
  const getAssamese = localStorage.getItem("assamese");
  const [assamese, setAssamese] = useState(getAssamese);
  async function Assamese() {
    const assamese = true;
    localStorage.setItem("assamese", assamese);
    setAssamese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // aymara
  // aymara
  const getAymara = localStorage.getItem("aymara");
  const [aymara, setAymara] = useState(getAymara);
  async function Aymara() {
    const aymara = true;
    localStorage.setItem("aymara", aymara);
    setAymara(true);
    // rtl
    const rtl = "0";
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // azerbaijani
  // azerbaijani
  const getAzerbaijani = localStorage.getItem("azerbaijani");
  const [azerbaijani, setAzerbaijani] = useState(getAzerbaijani);
  async function Azerbaijani() {
    const azerbaijani = true;
    localStorage.setItem("azerbaijani", azerbaijani);
    setAzerbaijani(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // bambara
  // bambara
  const getBambara = localStorage.getItem("bambara");
  const [bambara, setBambara] = useState(getBambara);
  async function Bambara() {
    const bambara = true;
    localStorage.setItem("bambara", bambara);
    setBambara(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // basque
  // basque
  const getBasque = localStorage.getItem("basque");
  const [basque, setBasque] = useState(getBasque);
  async function Basque() {
    const basque = true;
    localStorage.setItem("basque", basque);
    setBasque(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // belarusian
  // belarusian
  const getBelarusian = localStorage.getItem("belarusian");
  const [belarusian, setBelarusian] = useState(getBelarusian);
  async function Belarusian() {
    const belarusian = true;
    localStorage.setItem("belarusian", belarusian);
    setBelarusian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // bengali
  // bengali
  const getBengali = localStorage.getItem("bengali");
  const [bengali, setBengali] = useState(getBengali);
  async function Bengali() {
    const bengali = true;
    localStorage.setItem("bengali", bengali);
    setBengali(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // bhojpuri
  // bhojpuri
  const getBhojpuri = localStorage.getItem("bhojpuri");
  const [bhojpuri, setBhojpuri] = useState(getBhojpuri);
  async function Bhojpuri() {
    const bhojpuri = true;
    localStorage.setItem("bhojpuri", bhojpuri);
    setBhojpuri(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // bosnian
  // bosnian
  const getBosnian = localStorage.getItem("bosnian");
  const [bosnian, setBosnian] = useState(getBosnian);
  async function Bosnian() {
    const bosnian = true;
    localStorage.setItem("bosnian", bosnian);
    setBosnian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // bulgarian
  // bulgarian
  const getBulgarian = localStorage.getItem("bulgarian");
  const [bulgarian, setBulgarian] = useState(getBulgarian);
  async function Bulgarian() {
    const bulgarian = true;
    localStorage.setItem("bulgarian", bulgarian);
    setBulgarian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // catalan
  // catalan
  const getCatalan = localStorage.getItem("catalan");
  const [catalan, setCatalan] = useState(getCatalan);
  async function Catalan() {
    const catalan = true;
    localStorage.setItem("catalan", catalan);
    setCatalan(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // cebuano
  // cebuano
  const getCebuano = localStorage.getItem("cebuano");
  const [cebuano, setCebuano] = useState(getCebuano);
  async function Cebuano() {
    const cebuano = true;
    localStorage.setItem("cebuano", cebuano);
    setCebuano(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // chichewa
  // chichewa
  const getChichewa = localStorage.getItem("chichewa");
  const [chichewa, setChichewa] = useState(getChichewa);
  async function Chichewa() {
    const chichewa = true;
    localStorage.setItem("chichewa", chichewa);
    setChichewa(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // chinese Simplified
  // chinese Simplified
  const getChineseSimplified = localStorage.getItem("chineseSimplified");
  const [chineseSimplified, setChineseSimplified] = useState(getChineseSimplified);
  async function ChineseSimplified() {
    const chinese = true;
    localStorage.setItem("chineseSimplified", chinese);
    setChineseSimplified(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // chinese Traditional
  // chinese Traditional
  const getChineseTraditional = localStorage.getItem("chineseTraditional");
  const [chineseTraditional, setChineseTraditional] = useState(getChineseTraditional);
  async function ChineseTraditional() {
    const chinese = true;
    localStorage.setItem("chineseTraditional", chinese);
    setChineseTraditional(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // corsican
  // corsican
  const getCorsican = localStorage.getItem("corsican");
  const [corsican, setCorsican] = useState(getCorsican);
  async function Corsican() {
    const corsican = true;
    localStorage.setItem("corsican", corsican);
    setCorsican(true);
    // rtl
    const rtl = "0";
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // croatian
  // croatian
  const getCroatian = localStorage.getItem("croatian");
  const [croatian, setCroatian] = useState(getCroatian);
  async function Croatian() {
    const croatian = true;
    localStorage.setItem("croatian", croatian);
    setCroatian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // czech
  // czech
  const getCzech = localStorage.getItem("czech");
  const [czech, setCzech] = useState(getCzech);
  async function Czech() {
    const czech = true;
    localStorage.setItem("czech", czech);
    setCzech(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // danish
  // danish
  const getDanish = localStorage.getItem("danish");
  const [danish, setDanish] = useState(getDanish);
  async function Danish() {
    const danish = true;
    localStorage.setItem("danish", danish);
    setDanish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // dhivehi
  // dhivehi
  const getDhivehi = localStorage.getItem("dhivehi");
  const [dhivehi, setDhivehi] = useState(getDhivehi);
  async function Dhivehi() {
    const dhivehi = true;
    localStorage.setItem("dhivehi", dhivehi);
    setDhivehi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // dogri
  // dogri
  const getDogri = localStorage.getItem("dogri");
  const [dogri, setDogri] = useState(getDogri);
  async function Dogri() {
    const dogri = true;
    localStorage.setItem("dogri", dogri);
    setDogri(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // dutch
  // dutch
  const getDutch = localStorage.getItem("dutch");
  const [dutch, setDutch] = useState(getDutch);
  async function Dutch() {
    const dutch = true;
    localStorage.setItem("dutch", dutch);
    setDutch(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // english
  // english
  const getEnglish = localStorage.getItem("english");
  const [english, setEnglish] = useState(getEnglish);
  async function English() {
    const english = true;
    localStorage.setItem("english", english);
    setEnglish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // esperanto
  // esperanto
  const getEsperanto = localStorage.getItem("esperanto");
  const [esperanto, setEsperanto] = useState(getEsperanto);
  async function Esperanto() {
    const esperanto = true;
    localStorage.setItem("esperanto", esperanto);
    setEsperanto(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // estonian
  // estonian
  const getEstonian = localStorage.getItem("estonian");
  const [estonian, setEstonian] = useState(getEstonian);
  async function Estonian() {
    const estonian = true;
    localStorage.setItem("estonian", estonian);
    setEstonian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // ewe
  // ewe
  const getEwe = localStorage.getItem("ewe");
  const [ewe, setEwe] = useState(getEwe);
  async function Ewe() {
    const ewe = true;
    localStorage.setItem("ewe", ewe);
    setEwe(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // filipino
  // filipino
  const getFilipino = localStorage.getItem("filipino");
  const [filipino, setFilipino] = useState(getFilipino);
  async function Filipino() {
    const filipino = true;
    localStorage.setItem("filipino", filipino);
    setFilipino(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // finnish
  // finnish
  const getFinnish = localStorage.getItem("finnish");
  const [finnish, setFinnish] = useState(getFinnish);
  async function Finnish() {
    const finnish = true;
    localStorage.setItem("finnish", finnish);
    setFinnish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // french
  // french
  const getFrench = localStorage.getItem("french");
  const [french, setFrench] = useState(getFrench);
  async function French() {
    const french = true;
    localStorage.setItem("french", french);
    setFrench(true);

    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);
    
    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // frisian
  // frisian
  const getFrisian = localStorage.getItem("frisian");
  const [frisian, setFrisian] = useState(getFrisian);
  async function Frisian() {
    const frisian = true;
    localStorage.setItem("frisian", frisian);
    setFrisian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false);//f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // galician
  // galician
  const getGalician = localStorage.getItem("galician");
  const [galician, setGalician] = useState(getGalician);
  async function Galician() {
    const galician = true;
    localStorage.setItem("galician", galician);
    setGalician(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // georgian
  // georgian
  const getGeorgian = localStorage.getItem("georgian");
  const [georgian, setGeorgian] = useState(getGeorgian);
  async function Georgian() {
    const georgian = true;
    localStorage.setItem("georgian", georgian);
    setGeorgian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // german
  // german
  const getGerman = localStorage.getItem("german");
  const [german, setGerman] = useState(getGerman);
  async function German() {
    const german = true;
    localStorage.setItem("german", german);
    setGerman(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // greek
  // greek
  const getGreek = localStorage.getItem("greek");
  const [greek, setGreek] = useState(getGreek);
  async function Greek() {
    const greek = true;
    localStorage.setItem("greek", greek);
    setGreek(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // guarani
  // guarani
  const getGuarani = localStorage.getItem("guarani");
  const [guarani, setGuarani] = useState(getGuarani);
  async function Guarani() {
    const guarani = true;
    localStorage.setItem("guarani", guarani);
    setGuarani(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // gujarati
  // gujarati
  const getGujarati = localStorage.getItem("gujarati");
  const [gujarati, setGujarati] = useState(getGujarati);
  async function Gujarati() {
    const gujarati = true;
    localStorage.setItem("gujarati", gujarati);
    setGujarati(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // haitian Creole
  // haitian Creole
  const getHaitianCreole = localStorage.getItem("haitianCreole");
  const [haitianCreole, setHaitianCreole] = useState(getHaitianCreole);
  async function HaitianCreole() {
    const haitianCreole = true;
    localStorage.setItem("haitianCreole", haitianCreole);
    setHaitianCreole(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // hausa
  // hausa
  const getHausa = localStorage.getItem("hausa");
  const [hausa, setHausa] = useState(getHausa);
  async function Hausa() {
    const hausa = true;
    localStorage.setItem("hausa", hausa);
    setHausa(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // hawaiian
  // hawaiian
  const getHawaiian = localStorage.getItem("hawaiian");
  const [hawaiian, setHawaiian] = useState(getHawaiian);
  async function Hawaiian() {
    const hawaiian = true;
    localStorage.setItem("hawaiian", hawaiian);
    setHawaiian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // hebrew
  // hebrew
  const getHebrew = localStorage.getItem("hebrew");
  const [hebrew, setHebrew] = useState(getHebrew);
  async function Hebrew() {
    const hebrew = true;
    localStorage.setItem("hebrew", hebrew);
    setHebrew(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // hindi
  // hindi
  const getHindi = localStorage.getItem("hindi");
  const [hindi, setHindi] = useState(getHindi);
  async function Hindi() {
    const hindi = true;
    localStorage.setItem("hindi", hindi);
    setHindi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // hmong
  // hmong
  const getHmong = localStorage.getItem("hmong");
  const [hmong, setHmong] = useState(getHmong);
  async function Hmong() {
    const hmong = true;
    localStorage.setItem("hmong", hmong);
    setHmong(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // hungarian
  // hungarian
  const getHungarian = localStorage.getItem("hungarian");
  const [hungarian, setHungarian] = useState(getHungarian);
  async function Hungarian() {
    const hungarian = true;
    localStorage.setItem("hungarian", hungarian);
    setHungarian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // icelandic
  // icelandic
  const getIcelandic = localStorage.getItem("icelandic");
  const [icelandic, setIcelandic] = useState(getIcelandic);
  async function Icelandic() {
    const icelandic = true;
    localStorage.setItem("icelandic", icelandic);
    setIcelandic(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // igbo
  // igbo
  const getIgbo = localStorage.getItem("igbo");
  const [igbo, setIgbo] = useState(getIgbo);
  async function Igbo() {
    const igbo = true;
    localStorage.setItem("igbo", igbo);
    setIgbo(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // ilocano
  // ilocano
  const getIlocano = localStorage.getItem("ilocano");
  const [ilocano, setIlocano] = useState(getIlocano);
  async function Ilocano() {
    const ilocano = true;
    localStorage.setItem("ilocano", ilocano);
    setIlocano(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // indonesian
  // indonesian
  const getIndonesian = localStorage.getItem("indonesian");
  const [indonesian, setIndonesian] = useState(getIndonesian);
  async function Indonesian() {
    const indonesian = true;
    localStorage.setItem("indonesian", indonesian);
    setIndonesian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // irish
  // irish
  const getIrish = localStorage.getItem("irish");
  const [irish, setIrish] = useState(getIrish);
  async function Irish() {
    const irish = true;
    localStorage.setItem("irish", irish);
    setIrish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // italian
  // italian
  const getItalian = localStorage.getItem("italian");
  const [italian, setItalian] = useState(getItalian);
  async function Italian() {
    const italian = true;
    localStorage.setItem("italian", italian);
    setItalian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // japanese
  // japanese
  const getJapanese = localStorage.getItem("https://alrani.com/japanese");
  const [japanese, setJapanese] = useState(getJapanese);
  async function Japanese() {
    const japanese = true;
    localStorage.setItem("japanese", japanese);
    setJapanese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // javanese
  // javanese
  const getJavanese = localStorage.getItem("javanese");
  const [javanese, setJavanese] = useState(getJavanese);
  async function Javanese() {
    const javanese = true;
    localStorage.setItem("javanese", javanese);
    setJavanese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // kannada
  // kannada
  const getKannada = localStorage.getItem("kannada");
  const [kannada, setKannada] = useState(getKannada);
  async function Kannada() {
    const kannada = true;
    localStorage.setItem("kannada", kannada);
    setKannada(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // kazakh
  // kazakh
  const getKazakh = localStorage.getItem("kazakh");
  const [kazakh, setKazakh] = useState(getKazakh);
  async function Kazakh() {
    const kazakh = true;
    localStorage.setItem("kazakh", kazakh);
    setKazakh(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // khmer
  // khmer
  const getKhmer = localStorage.getItem("khmer");
  const [khmer, setKhmer] = useState(getKhmer);
  async function Khmer() {
    const khmer = true;
    localStorage.setItem("khmer", khmer);
    setKhmer(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // kinyarwanda
  // kinyarwanda
  const getKinyarwanda = localStorage.getItem("kinyarwanda");
  const [kinyarwanda, setKinyarwanda] = useState(getKinyarwanda);
  async function Kinyarwanda() {
    const kinyarwanda = true;
    localStorage.setItem("kinyarwanda", kinyarwanda);
    setKinyarwanda(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // konkani
  // konkani
  const getKonkani = localStorage.getItem("konkani");
  const [konkani, setKonkani] = useState(getKonkani);
  async function Konkani() {
    const konkani = true;
    localStorage.setItem("konkani", konkani);
    setKonkani(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // korean
  // korean
  const getKorean = localStorage.getItem("korean");
  const [korean, setKorean] = useState(getKorean);
  async function Korean() {
    const korean = true;
    localStorage.setItem("korean", korean);
    setKorean(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // krio
  // krio
  const getKrio = localStorage.getItem("krio");
  const [krio, setKrio] = useState(getKrio);
  async function Krio() {
    const krio = true;
    localStorage.setItem("krio", krio);
    setKrio(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // kurdish (Kurmanji)
  // kurdish (Kurmanji)
  const getKurdishKurmanji = localStorage.getItem("kurdishKurmanji");
  const [kurdishKurmanji, setKurdishKurmanji] = useState(getKurdishKurmanji);
  async function KurdishKurmanji() {
    const kurdish = true;
    localStorage.setItem("kurdishKurmanji", kurdish);
    setKurdishKurmanji(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // Kurdish (Sorani)
  // Kurdish (Sorani)
  const getKurdishSorani = localStorage.getItem("kurdishSorani");
  const [kurdishSorani, setKurdishSorani] = useState(getKurdishSorani);
  async function KurdishSorani() {
    const kurdish = true;
    localStorage.setItem("kurdishSorani", kurdish);
    setKurdishSorani(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }
        
  // kyrgyz
  // kyrgyz
  const getKyrgyz = localStorage.getItem("kyrgyz");
  const [kyrgyz, setKyrgyz] = useState(getKyrgyz);
  async function Kyrgyz() {
    const kyrgyz = true;
    localStorage.setItem("kyrgyz", kyrgyz);
    setKyrgyz(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // lao
  // lao
  const getLao = localStorage.getItem("lao");
  const [lao, setLao] = useState(getLao);
  async function Lao() {
    const lao = true;
    localStorage.setItem("lao", lao);
    setLao(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }  

  // latin
  // latin
  const getLatin = localStorage.getItem("latin");
  const [latin, setLatin] = useState(getLatin);
  async function Latin() {
    const latin = true;
    localStorage.setItem("latin", latin);
    setLatin(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // latvian
  // latvian
  const getLatvian = localStorage.getItem("latvian");
  const [latvian, setLatvian] = useState(getLatvian);
  async function Latvian() {
    const latvian = true;
    localStorage.setItem("latvian", latvian);
    setLatvian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // lingala
  // lingala
  const getLingala = localStorage.getItem("lingala");
  const [lingala, setLingala] = useState(getLingala);
  async function Lingala() {
    const lingala = true;
    localStorage.setItem("lingala", lingala);
    setLingala(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }
  
  // lithuanian
  // lithuanian
  const getLithuanian = localStorage.getItem("lithuanian");
  const [lithuanian, setLithuanian] = useState(getLithuanian);
  async function Lithuanian() {
    const lithuanian = true;
    localStorage.setItem("lithuanian", lithuanian);
    setLithuanian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // luganda
  // luganda
  const getLuganda = localStorage.getItem("luganda");
  const [luganda, setLuganda] = useState(getLuganda);
  async function Luganda() {
    const luganda = true;
    localStorage.setItem("luganda", luganda);
    setLuganda(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // luxembourgish
  // luxembourgish
  const getLuxembourgish = localStorage.getItem("luxembourgish");
  const [luxembourgish, setLuxembourgish] = useState(getLuxembourgish);
  async function Luxembourgish() {
    const luxembourgish = true;
    localStorage.setItem("luxembourgish", luxembourgish);
    setLuxembourgish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // macedonian
  // macedonian
  const getMacedonian = localStorage.getItem("macedonian");
  const [macedonian, setMacedonian] = useState(getMacedonian);
  async function Macedonian() {
    const macedonian = true;
    localStorage.setItem("macedonian", macedonian);
    setMacedonian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }
  
  // maithili
  // maithili
  const getMaithili = localStorage.getItem("maithili");
  const [maithili, setMaithili] = useState(getMaithili);
  async function Maithili() {
    const maithili = true;
    localStorage.setItem("maithili", maithili);
    setMaithili(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // malagasy
  // malagasy
  const getMalagasy = localStorage.getItem("malagasy");
  const [malagasy, setMalagasy] = useState(getMalagasy);
  async function Malagasy() {
    const malagasy = true;
    localStorage.setItem("malagasy", malagasy);
    setMalagasy(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false);  setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // malay
  // malay
  const getMalay = localStorage.getItem("malay");
  const [malay, setMalay] = useState(getMalay);
  async function Malay() {
    const malay = true;
    localStorage.setItem("malay", malay);
    setMalay(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // malayalam
  // malayalam
  const getMalayalam = localStorage.getItem("malayalam");
  const [malayalam, setMalayalam] = useState(getMalayalam);
  async function Malayalam() {
    const malayalam = true;
    localStorage.setItem("malayalam", malayalam);
    setMalayalam(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // maltese
  // maltese
  const getMaltese = localStorage.getItem("maltese");
  const [maltese, setMaltese] = useState(getMaltese);
  async function Maltese() {
    const maltese = true;
    localStorage.setItem("maltese", maltese);
    setMaltese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // maori
  // maori
  const getMaori = localStorage.getItem("maori");
  const [maori, setMaori] = useState(getMaori);
  async function Maori() {
    const maori = true;
    localStorage.setItem("maori", maori);
    setMaori(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // marathi
  // marathi
  const getMarathi = localStorage.getItem("marathi");
  const [marathi, setMarathi] = useState(getMarathi);
  async function Marathi() {
    const marathi = true;
    localStorage.setItem("marathi", marathi);
    setMarathi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // Meiteilon (Manipuri)
  const getMeiteilonManipuri = localStorage.getItem("meiteilonManipuri");
  const [meiteilonManipuri, setMeiteilonManipuri] = useState(getMeiteilonManipuri);
  async function MeiteilonManipuri() {
    const meiteilon = true;
    localStorage.setItem("meiteilonManipuri", meiteilon);
    setMeiteilonManipuri(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // mizo
  // mizo
  const getMizo = localStorage.getItem("mizo");
  const [mizo, setMizo] = useState(getMizo);
  async function Mizo() {
    const mizo = true;
    localStorage.setItem("mizo", mizo);
    setMizo(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // mongolian
  // mongolian
  const getMongolian = localStorage.getItem("mongolian");
  const [mongolian, setMongolian] = useState(getMongolian);
  async function Mongolian() {
    const mongolian = true;
    localStorage.setItem("mongolian", mongolian);
    setMongolian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // Myanmar (Burmese)
  // Myanmar (Burmese)
  const getMyanmarBurmese = localStorage.getItem("myanmarBurmese");
  const [myanmarBurmese, setMyanmarBurmese] = useState(getMyanmarBurmese);
  async function MyanmarBurmese() {
    const myanmar = true;
    localStorage.setItem("myanmarBurmese", myanmar);
    setMyanmarBurmese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // nepali
  const getNepali = localStorage.getItem("nepali");
  const [nepali, setNepali] = useState(getNepali);
  async function Nepali() {
    const nepali = true;
    localStorage.setItem("nepali", nepali);
    setNepali(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // norwegian
  // norwegian
  const getNorwegian = localStorage.getItem("norwegian");
  const [norwegian, setNorwegian] = useState(getNorwegian);
  async function Norwegian() {
    const norwegian = true;
    localStorage.setItem("norwegian", norwegian);
    setNorwegian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // Odia (Oriya)
  // Odia (Oriya)
  const getOdiaOriya = localStorage.getItem("odiaOriya");
  const [odiaOriya, setOdiaOriya] = useState(getOdiaOriya);
  async function OdiaOriya() {
    const odia = true;
    localStorage.setItem("odiaOriya", odia);
    setOdiaOriya(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // oromo
  // oromo
  const getOromo = localStorage.getItem("oromo");
  const [oromo, setOromo] = useState(getOromo);
  async function Oromo() {
    const oromo = true;
    localStorage.setItem("oromo", oromo);
    setOromo(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }
  
  // pashto
  // pashto
  const getPashto = localStorage.getItem("pashto");
  const [pashto, setPashto] = useState(getPashto);
  async function Pashto() {
    const pashto = true;
    localStorage.setItem("pashto", pashto);
    setPashto(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // persian
  // persian
  const getPersian = localStorage.getItem("persian");
  const [persian, setPersian] = useState(getPersian);
  async function Persian() {
    const persian = true;
    localStorage.setItem("persian", persian);
    setPersian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // polish
  // polish
  const getPolish = localStorage.getItem("polish");
  const [polish, setPolish] = useState(getPolish);
  async function Polish() {
    const polish = true;
    localStorage.setItem("polish", polish);
    setPolish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // portuguese
  // portuguese
  const getPortuguese = localStorage.getItem("portuguese");
  const [portuguese, setPortuguese] = useState(getPortuguese);
  async function Portuguese() {
    const portuguese = true;
    localStorage.setItem("portuguese", portuguese);
    setPortuguese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // punjabi
  // punjabi
  const getPunjabi = localStorage.getItem("punjabi");
  const [punjabi, setPunjabi] = useState(getPunjabi);
  async function Punjabi() {
    const punjabi = true;
    localStorage.setItem("punjabi", punjabi);
    setPunjabi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // quechua
  // quechua
  const getQuechua = localStorage.getItem("quechua");
  const [quechua, setQuechua] = useState(getQuechua);
  async function Quechua() {
    const quechua = true;
    localStorage.setItem("quechua", quechua);
    setQuechua(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // romanian
  // romanian
  const getRomanian = localStorage.getItem("romanian");
  const [romanian, setRomanian] = useState(getRomanian);
  async function Romanian() {
    const romanian = true;
    localStorage.setItem("romanian", romanian);
    setRomanian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // russian
  // russian
  const getRussian = localStorage.getItem("russian");
  const [russian, setRussian] = useState(getRussian);
  async function Russian() {
    const russian = true;
    localStorage.setItem("russian", russian);
    setRussian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // samoan
  // samoan
  const getSamoan = localStorage.getItem("samoan");
  const [samoan, setSamoan] = useState(getSamoan);
  async function Samoan() {
    const samoan = true;
    localStorage.setItem("samoan", samoan);
    setSamoan(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // sanskrit
  // sanskrit
  const getSanskrit = localStorage.getItem("sanskrit");
  const [sanskrit, setSanskrit] = useState(getSanskrit);
  async function Sanskrit() {
    const sanskrit = true;
    localStorage.setItem("sanskrit", sanskrit);
    setSanskrit(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // Scots Gaelic
  // Scots Gaelic
  const getScotsGaelic = localStorage.getItem("scotsGaelic");
  const [scotsGaelic, setScotsGaelic] = useState(getScotsGaelic);
  async function ScotsGaelic() {
    const scotsGaelic = true;
    localStorage.setItem("scotsGaelic", scotsGaelic);
    setScotsGaelic(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // sepedi
  // sepedi
  const getSepedi = localStorage.getItem("sepedi");
  const [sepedi, setSepedi] = useState(getSepedi);
  async function Sepedi() {
    const sepedi = true;
    localStorage.setItem("sepedi", sepedi);
    setSepedi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // serbian
  // serbian
  const getSerbian = localStorage.getItem("serbian");
  const [serbian, setSerbian] = useState(getSerbian);
  async function Serbian() {
    const serbian = true;
    localStorage.setItem("serbian", serbian);
    setSerbian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // sesotho
  // sesotho
  const getSesotho = localStorage.getItem("sesotho");
  const [sesotho, setSesotho] = useState(getSesotho);
  async function Sesotho() {
    const sesotho = true;
    localStorage.setItem("sesotho", sesotho);
    setSesotho(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // shona
  // shona
  const getShona = localStorage.getItem("shona");
  const [shona, setShona] = useState(getShona);
  async function Shona() {
    const shona = true;
    localStorage.setItem("shona", shona);
    setShona(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // sindhi
  // sindhi
  const getSindhi = localStorage.getItem("sindhi");
  const [sindhi, setSindhi] = useState(getSindhi);
  async function Sindhi() {
    const sindhi = true;
    localStorage.setItem("sindhi", sindhi);
    setSindhi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // sinhala
  // sinhala
  const getSinhala = localStorage.getItem("sinhala");
  const [sinhala, setSinhala] = useState(getSinhala);
  async function Sinhala() {
    const sinhala = true;
    localStorage.setItem("sinhala", sinhala);
    setSinhala(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // slovak
  // slovak
  const getSlovak = localStorage.getItem("slovak");
  const [slovak, setSlovak] = useState(getSlovak);
  async function Slovak() {
    const slovak = true;
    localStorage.setItem("slovak", slovak);
    setSlovak(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // slovenian
  // slovenian
  const getSlovenian = localStorage.getItem("slovenian");
  const [slovenian, setSlovenian] = useState(getSlovenian);
  async function Slovenian() {
    const slovenian = true;
    localStorage.setItem("slovenian", slovenian);
    setSlovenian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // somali
  // somali
  const getSomali = localStorage.getItem("somali");
  const [somali, setSomali] = useState(getSomali);
  async function Somali() {
    const somali = true;
    localStorage.setItem("somali", somali);
    setSomali(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // spanish
  // spanish
  const getSpanish = localStorage.getItem("spanish");
  const [spanish, setSpanish] = useState(getSpanish);
  async function Spanish() {
    const spanish = true;
    localStorage.setItem("spanish", spanish);
    setSpanish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // sundanese
  // sundanese
  const getSundanese = localStorage.getItem("sundanese");
  const [sundanese, setSundanese] = useState(getSundanese);
  async function Sundanese() {
    const sundanese = true;
    localStorage.setItem("sundanese", sundanese);
    setSundanese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // swahili
  // swahili
  const getSwahili = localStorage.getItem("swahili");
  const [swahili, setSwahili] = useState(getSwahili);
  async function Swahili() {
    const swahili = true;
    localStorage.setItem("swahili", swahili);
    setSwahili(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // swedish
  // swedish
  const getSwedish = localStorage.getItem("swedish");
  const [swedish, setSwedish] = useState(getSwedish);
  async function Swedish() {
    const swedish = true;
    localStorage.setItem("swedish", swedish);
    setSwedish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // tajik
  // tajik
  const getTajik = localStorage.getItem("tajik");
  const [tajik, setTajik] = useState(getTajik);
  async function Tajik() {
    const tajik = true;
    localStorage.setItem("tajik", tajik);
    setTajik(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // tamil
  // tamil
  const getTamil = localStorage.getItem("tamil");
  const [tamil, setTamil] = useState(getTamil);
  async function Tamil() {
    const tamil = true;
    localStorage.setItem("tamil", tamil);
    setTamil(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // tatar
  // tatar
  const getTatar = localStorage.getItem("tatar");
  const [tatar, setTatar] = useState(getTatar);
  async function Tatar() {
    const tatar = true;
    localStorage.setItem("tatar", tatar);
    setTatar(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // telugu
  // telugu
  const getTelugu = localStorage.getItem("telugu");
  const [telugu, setTelugu] = useState(getTelugu);
  async function Telugu() {
    const telugu = true;
    localStorage.setItem("telugu", telugu);
    setTelugu(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // thai
  // thai
  const getThai = localStorage.getItem("thai");
  const [thai, setThai] = useState(getThai);
  async function Thai() {
    const thai = true;
    localStorage.setItem("thai", thai);
    setThai(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // tigrinya
  // tigrinya
  const getTigrinya = localStorage.getItem("tigrinya");
  const [tigrinya, setTigrinya] = useState(getTigrinya);
  async function Tigrinya() {
    const tigrinya = true;
    localStorage.setItem("tigrinya", tigrinya);
    setTigrinya(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // tsonga
  // tsonga
  const getTsonga = localStorage.getItem("tsonga");
  const [tsonga, setTsonga] = useState(getTsonga);
  async function Tsonga() {
    const tsonga = true;
    localStorage.setItem("tsonga", tsonga);
    setTsonga(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // turkish
  // turkish
  const getTurkish = localStorage.getItem("turkish");
  const [turkish, setTurkish] = useState(getTurkish);
  async function Turkish() {
    const turkish = true;
    localStorage.setItem("turkish", turkish);
    setTurkish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // turkmen
  // turkmen
  const getTurkmen = localStorage.getItem("turkmen");
  const [turkmen, setTurkmen] = useState(getTurkmen);
  async function Turkmen() {
    const turkmen = true;
    localStorage.setItem("turkmen", turkmen);
    setTurkmen(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }
  
  // twi
  // twi
  const getTwi = localStorage.getItem("twi");
  const [twi, setTwi] = useState(getTwi);
  async function Twi() {
    const twi = true;
    localStorage.setItem("twi", twi);
    setTwi(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // ukrainian
  // ukrainian
  const getUkrainian = localStorage.getItem("ukrainian");
  const [ukrainian, setUkrainian] = useState(getUkrainian);
  async function Ukrainian() {
    const ukrainian = true;
    localStorage.setItem("ukrainian", ukrainian);
    setUkrainian(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // urdu
  // urdu
  const getUrdu = localStorage.getItem("urdu");
  const [urdu, setUrdu] = useState(getUrdu);
  async function Urdu() {
    const urdu = true;
    localStorage.setItem("urdu", urdu);
    setUrdu(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // uyghur
  // uyghur
  const getUyghur = localStorage.getItem("uyghur");
  const [uyghur, setUyghur] = useState(getUyghur);
  async function Uyghur() {
    const uyghur = true;
    localStorage.setItem("uyghur", uyghur);
    setUyghur(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // uzbek
  // uzbek
  const getUzbek = localStorage.getItem("uzbek");
  const [uzbek, setUzbek] = useState(getUzbek);
  async function Uzbek() {
    const uzbek = true;
    localStorage.setItem("uzbek", uzbek);
    setUzbek(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // vietnamese
  // vietnamese
  const getVietnamese = localStorage.getItem("vietnamese");
  const [vietnamese, setVietnamese] = useState(getVietnamese);
  async function Vietnamese() {
    const vietnamese = true;
    localStorage.setItem("vietnamese", vietnamese);
    setVietnamese(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // welsh
  // welsh
  const getWelsh = localStorage.getItem("welsh");
  const [welsh, setWelsh] = useState(getWelsh);
  async function Welsh() {
    const welsh = true;
    localStorage.setItem("welsh", welsh);
    setWelsh(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // xhosa
  // xhosa
  const getXhosa = localStorage.getItem("xhosa");
  const [xhosa, setXhosa] = useState(getXhosa);
  async function Xhosa() {
    const xhosa = true;
    localStorage.setItem("xhosa", xhosa);
    setXhosa(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setYiddish(false); setYoruba(false); //y
    setZulu(false); //z
  }

  // yiddish
  // yiddish
  const getYiddish = localStorage.getItem("yiddish");
  const [yiddish, setYiddish] = useState(getYiddish);
  async function Yiddish() {
    const yiddish = true;
    localStorage.setItem("yiddish", yiddish);
    setYiddish(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yoruba"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYoruba(false); //y
    setZulu(false); //z
  }

  // yoruba
  // yoruba
  const getYoruba = localStorage.getItem("yoruba");
  const [yoruba, setYoruba] = useState(getYoruba);
  async function Yoruba() {
    const yoruba = true;
    localStorage.setItem("yoruba", yoruba);
    setYoruba(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); //y
    localStorage.removeItem("zulu"); //z
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); //y
    setZulu(false); //z
  }

  // zulu
  // zulu
  const getZulu = localStorage.getItem("zulu");
  const [zulu, setZulu] = useState(getZulu);
  async function Zulu() {
    const zulu = true;
    localStorage.setItem("zulu", zulu);
    setZulu(true);
    // rtl
    const rtl = "0"; 
    localStorage.setItem("rtl", rtl);
    setRtl(false);

    localStorage.removeItem("afrikaans"); localStorage.removeItem("albanian"); localStorage.removeItem("amharic"); localStorage.removeItem("arabic"); localStorage.removeItem("armenian"); localStorage.removeItem("assamese"); localStorage.removeItem("aymara"); localStorage.removeItem("azerbaijani"); //a
    localStorage.removeItem("bambara"); localStorage.removeItem("basque"); localStorage.removeItem("belarusian"); localStorage.removeItem("bengali"); localStorage.removeItem("bhojpuri"); localStorage.removeItem("bosnian"); localStorage.removeItem("bulgarian"); //b
    localStorage.removeItem("catalan"); localStorage.removeItem("cebuano"); localStorage.removeItem("chichewa"); localStorage.removeItem("chineseSimplified"); localStorage.removeItem("chineseTraditional"); localStorage.removeItem("corsican"); localStorage.removeItem("croatian"); localStorage.removeItem("czech"); //c
    localStorage.removeItem("danish"); localStorage.removeItem("dhivehi"); localStorage.removeItem("dogri"); localStorage.removeItem("dutch"); //d
    localStorage.removeItem("english"); localStorage.removeItem("esperanto"); localStorage.removeItem("estonian"); localStorage.removeItem("ewe"); //e
    localStorage.removeItem("filipino"); localStorage.removeItem("finnish"); localStorage.removeItem("french"); localStorage.removeItem("frisian"); //f
    localStorage.removeItem("galician"); localStorage.removeItem("georgian"); localStorage.removeItem("german"); localStorage.removeItem("greek"); localStorage.removeItem("guarani"); localStorage.removeItem("gujarati"); //g
    localStorage.removeItem("haitianCreole"); localStorage.removeItem("hausa"); localStorage.removeItem("hawaiian"); localStorage.removeItem("hebrew"); localStorage.removeItem("hindi"); localStorage.removeItem("hmong"); localStorage.removeItem("hungarian"); //h
    localStorage.removeItem("icelandic"); localStorage.removeItem("igbo"); localStorage.removeItem("ilocano"); localStorage.removeItem("indonesian"); localStorage.removeItem("irish"); localStorage.removeItem("italian"); //i
    localStorage.removeItem("japanese"); localStorage.removeItem("javanese"); //j
    localStorage.removeItem("kannada"); localStorage.removeItem("kazakh"); localStorage.removeItem("khmer"); localStorage.removeItem("kinyarwanda"); localStorage.removeItem("konkani"); localStorage.removeItem("korean"); localStorage.removeItem("krio"); localStorage.removeItem("kurdishKurmanji"); localStorage.removeItem("kurdishSorani"); localStorage.removeItem("kyrgyz"); //k
    localStorage.removeItem("lao"); localStorage.removeItem("latin"); localStorage.removeItem("latvian"); localStorage.removeItem("lingala"); localStorage.removeItem("lithuanian"); localStorage.removeItem("luganda"); localStorage.removeItem("luxembourgish"); //l
    localStorage.removeItem("macedonian"); localStorage.removeItem("maithili"); localStorage.removeItem("malagasy"); localStorage.removeItem("malay"); localStorage.removeItem("malayalam"); localStorage.removeItem("maltese"); localStorage.removeItem("maori"); localStorage.removeItem("marathi"); localStorage.removeItem("meiteilonManipuri"); localStorage.removeItem("mizo"); localStorage.removeItem("mongolian"); localStorage.removeItem("myanmarBurmese"); //m
    localStorage.removeItem("nepali"); localStorage.removeItem("norwegian"); //n
    localStorage.removeItem("odiaOriya"); localStorage.removeItem("oromo"); //o
    localStorage.removeItem("pashto"); localStorage.removeItem("persian"); localStorage.removeItem("polish"); localStorage.removeItem("portuguese"); localStorage.removeItem("punjabi"); //p
    localStorage.removeItem("quechua"); //q
    localStorage.removeItem("romanian"); localStorage.removeItem("russian"); //r
    localStorage.removeItem("samoan"); localStorage.removeItem("sanskrit"); localStorage.removeItem("scotsGaelic"); localStorage.removeItem("sepedi"); localStorage.removeItem("serbian"); localStorage.removeItem("sesotho"); localStorage.removeItem("shona"); localStorage.removeItem("sindhi"); localStorage.removeItem("sinhala"); localStorage.removeItem("slovak"); localStorage.removeItem("slovenian"); localStorage.removeItem("somali"); localStorage.removeItem("spanish"); localStorage.removeItem("sundanese"); localStorage.removeItem("swahili"); localStorage.removeItem("swedish"); //s
    localStorage.removeItem("tajik"); localStorage.removeItem("tamil"); localStorage.removeItem("tatar"); localStorage.removeItem("telugu"); localStorage.removeItem("thai"); localStorage.removeItem("tigrinya"); localStorage.removeItem("tsonga"); localStorage.removeItem("turkish"); localStorage.removeItem("turkmen"); localStorage.removeItem("twi"); //t
    localStorage.removeItem("ukrainian"); localStorage.removeItem("urdu"); localStorage.removeItem("uyghur"); localStorage.removeItem("uzbek"); //u
    localStorage.removeItem("vietnamese"); //v
    localStorage.removeItem("welsh"); //w
    localStorage.removeItem("xhosa"); //x
    localStorage.removeItem("yiddish"); localStorage.removeItem("yoruba"); //y
    setAfrikaans(false); setAlbanian(false); setAmharic (false); setArabic (false); setArmenian (false); setAssamese(false); setAymara(false); setAzerbaijani(false); //a
    setBambara(false); setBasque(false); setBelarusian(false); setBengali(false); setBhojpuri(false); setBosnian(false); setBulgarian(false); //b
    setCatalan(false); setCebuano(false); setChichewa(false); setChineseSimplified(false); setChineseTraditional(false); setCorsican(false); setCroatian(false); setCzech(false); //c
    setDanish(false); setDhivehi(false); setDogri(false); setDutch(false); //d
    setEnglish(false); setEsperanto(false); setEstonian(false); setEwe(false); //e
    setFilipino(false); setFinnish(false); setFrench(false); setFrisian(false); //f
    setGalician(false); setGeorgian(false); setGerman(false); setGreek(false); setGuarani(false); setGujarati(false); //g
    setHaitianCreole(false); setHausa(false); setHawaiian(false); setHebrew(false); setHindi(false); setHmong(false); setHungarian(false); //h
    setIcelandic(false); setIgbo(false); setIlocano(false); setIndonesian(false); setIrish(false); setItalian(false); //i
    setJapanese(false); setJavanese(false); //j
    setKannada(false); setKazakh(false); setKhmer(false); setKinyarwanda(false); setKonkani(false); setKorean(false); setKrio(false); setKurdishKurmanji(false); setKurdishSorani(false); setKyrgyz(false); //k
    setLao(false); setLatin(false); setLatvian(false); setLingala(false); setLithuanian(false); setLuganda(false); setLuxembourgish(false); //l
    setMacedonian(false); setMaithili(false); setMalagasy(false); setMalay(false); setMalayalam(false); setMaltese(false); setMaori(false); setMarathi(false); setMeiteilonManipuri(false); setMizo(false); setMongolian(false); setMyanmarBurmese(false); //m
    setNepali(false); setNorwegian(false); //n
    setOdiaOriya(false); setOromo(false); //o
    setPashto(false); setPersian(false); setPolish(false); setPortuguese(false); setPunjabi(false); //p
    setQuechua(false); //q
    setRomanian(false);  setRussian(false); //r
    setSamoan(false); setSanskrit(false); setScotsGaelic(false); setSepedi(false); setSerbian(false); setSesotho(false); setShona(false); setSindhi(false); setSinhala(false); setSlovak(false); setSlovenian(false); setSomali(false); setSpanish(false); setSundanese(false); setSwahili(false); setSwedish(false); //s
    setTajik(false); setTamil(false); setTatar(false); setTelugu(false); setThai(false); setTigrinya(false); setTsonga(false); setTurkish(false); setTurkmen(false); setTwi(false); //t
    setUkrainian(false); setUrdu(false); setUyghur(false); setUzbek(false); //u
    setVietnamese(false); //v
    setWelsh(false); //w
    setXhosa(false); //x
    setYiddish(false); setYoruba(false); //y
  }



  // alraniApp
  // alraniApp
  // alraniApp 
  // quand on clique sur l'icone de l'App, l'ecran de demarrage s'affiche - AA
  const [ecranDemarrageAA, setEcranDemarrageAA] = useState(false);
  async function EcranDemarrageAA() {
    setEcranDemarrageAA(true);
    //ce code permet de maintenir l'ecran de demarrage ouvert pendant quelques secondes
    async function CloseEcranDemarrageAA() {
      const connected = localStorage.getItem("idPersonConnectedAA");

      console.log("idPersonConnectedAA", connected);

      if (connected) {
        //si la personne est connecter, il est rediriger sur la page d'accueil
        setEcranDemarrageAA(false);
        setTelephoneVirtuel(false);
        setConversationAA(true);

    //verificationLogin 
    // on verifie si le mot de passe est toujours le meme pour le garder connecter ou pour le deconnecter
    async function verificationLogin() {
      const writeVirtualNumber = localStorage.getItem("writeVirtualNumberAAforVerificationLoginAA");
      const writePassword = localStorage.getItem("writePasswordAAforVerificationLoginAA");
      
      console.log("//verificationLogin");

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_VerificationLoginAA}/api/userAA/login`,
        data: {
          virtualNumber: writeVirtualNumber,
          password: writePassword,
        },
      })
      .then((res) => {
       //si le mot de passe enregistré dans le localStorage est different du mot de passe qui se trouve dans la bdd, alors on le deconnecte, cela veut dire que le mot de passe a ete changé
       const incorrectPassword = res.data.incorrectPassword;
       if (incorrectPassword === "1") { localStorage.removeItem("idPersonConnectedAA"); } 

       console.log(res);
       console.log("incorrectPassword", incorrectPassword);
      })
    }
    verificationLogin();
    //verificationLogin
    
    // on continue avec les requetes suivantes (on verifiait d'abord si le mot de passe etait toujours le meme pour le garder connecter)
      //1ere requete
      //1ere requete
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
        .then((res) => {
        setApiPostAA(res.data);
        console.log("/api/postAA");
        console.log(res);


      //2e requete
      //2e requete
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
        .then((res) => {
        setApiUserAA(res.data);
        console.log("/api/userAA");
        console.log(res);

      //3e requete
      //3e requete
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
        .then((res) => {
        setApiAccountAA(res.data);
        console.log("/api/accountAA");
        console.log(res);

      //4e requete
      //4e requete
      async function quatriemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
        .then((res) => {
        setApiConversationAA(res.data);
        console.log("/api/conversationAA");
        console.log(res);

      //5e requete
      //5e requete
      async function cinquiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
        .then((res) => {
        setApiMessageAA(res.data);
        console.log("/api/messageAA");
        console.log(res);

      //6e requete
      //6e requete
      async function sixiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
        .then((res) => {
        console.log("/api/favoriteAA");
        console.log(res);

      //7e requete
      //7e requete
      async function septiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/followerAA`)
        .then((res) => {
        setApiFollowerAA(res.data);
        console.log("/api/followerAA");
        console.log(res);

      //8e requete
      //8e requete
      async function huitiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
        .then((res) => {
          setApiNotificationAA(res.data);
          console.log("/api/notificationAA");
          console.log(res);

        //9e requete
        //9e requete
        // on obtiens la localisation de l'utilisateur
        async function neuviemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

            console.log(res, "localisation");
            console.log("country Ip", getcountryip);
            console.log("city Ip", getcityip);
            console.log("adresse Ip", getuserip);

        //10e requete
        //10e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function dixiemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Téléphone virtuel (il est au niveau du menu des applications. il a cliqué sur l'application Alrani) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

          console.log("navigationAA/new");
          console.log(res);
          console.log(online, "date de derniere connexion");

        //11e requete
        //11e requete
        // on enregistre la date de derniere connexion
        async function onziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          .then((res) => {
            console.log("on enregistre la date de derniere connexion, method PUT, api/accountAA/update");
            console.log(res);

        //12e requete
        //12e requete
        async function douziemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/navigationAA`)
          .then((res) => {
            console.log("/api/navigationAA");
            console.log(res);
          })
          }
          douziemeReq();
          //12e requete
          });
          }
          onziemeReq();
          //11e requete
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
          });
        }
        premiereReq();
        //1ere requete
      } else {
        //si la personne n'est pas connecter, il est rediriger sur la page d'inscription
        setEcranDemarrageAA(false);
        setInscriptionPageAA(true);
        setConnexionPageAA(false); 

        //1ere requete
        //1ere requete
        // on obtiens la localisation de l'utilisateur non connecter
        async function premiereReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

            console.log(res, "localisation");
            console.log(getcountryip);
            console.log(getcityip);
            console.log(getuserip);

        //2e requete
        //2e requete
        // on enregistre la localisation et la navigation de l'utilisateur non connecter
        async function deuxiemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Téléphone virtuel (Un utilisateur non connecter est au niveau du menu des applications. il a cliqué sur l'application Alrani) - AA";
          
          console.log("on enregistre la localisation et la navigation de l'utilisateur non connecter");
          
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          console.log("navigationAA/new");
          console.log(res);

        //3e requete
        //3e requete
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/navigationAA`)
          .then((res) => {
            console.log("/api/navigationAA");
            console.log(res);
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
          });
        }
        premiereReq();
        //1ere requete
      }
    }
    setTimeout(CloseEcranDemarrageAA, 2000);
  }


  //logique pour actualiser son solde Alrani pay (ainsi que d'autres elements...)
  async function RefreshBalanceAA() {
      //1ere requete
      //1ere requete
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
        .then((res) => {
        setApiPostAA(res.data);

      //2e requete
      //2e requete
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
        .then((res) => {
        setApiUserAA(res.data);

      //3e requete
      //3e requete
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
        .then((res) => {
        setApiAccountAA(res.data);

      //4e requete
      //4e requete
      async function quatriemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
        .then((res) => {
        setApiConversationAA(res.data);

      //5e requete
      //5e requete
      async function cinquiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
        .then((res) => {
        setApiMessageAA(res.data);

      //6e requete
      //6e requete
      async function sixiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
        .then((res) => {
        setApiNotificationAA(res.data);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Solde Alrani Pay (il a actualisé son solde Alrani Pay en 1 clic) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
      });
      }
      sixiemeReq();
      //6e requete
        });
        }
        cinquiemeReq();
        //5e requete
        });
        }
        quatriemeReq();
        //4e requete
        });
        }
        troisiemeReq();
        //3e requete
        });
        }
        deuxiemeReq();
        //2e requete
        });
      }
      premiereReq();
      //1ere requete
  }


  // solde insuffisant (Alrani Pay) - AA
  // on affiche cette page s'il clique et qu'il n'a plus d'argent dans son compte Alrani Pay - AA
  const [errorAlraniPayAA, setErrorAlraniPayAA] = useState(false);
  async function CloseErrorAlraniPayAA() {
    setErrorAlraniPayAA(false);
  }
  

  // error - AA
  // on affiche cette page s'il y'a une erreur qui s'est produite 
  const [errorAA, setErrorAA] = useState(false);
  async function CloseErrorAA() {
    setErrorAA(false);
  }


  // page - partager un post
  const [sharePostPageAA, setSharePostPageAA] = useState(false);
  async function CloseSharePostPageAA() {
    setSharePostPageAA(false);
  }

  // page - ajouter une reaction
  const [addReactionPageAA, setAddReactionPageAA] = useState(false);
  async function CloseAddReactionPageAA() {
    setAddReactionPageAA(false);
    //on met like, love,... a false (pour eviter que le like de l'autre qui est a true, puisse s'afficher dans les autres posts)
    setLikeAA(false);
    setLoveAA(false);
    setSadAA(false);
  }


  // afficher la reaction, si la personne a reagit au post (par exemple: afficher le like si la personne a liker le post,... )
  const filterLikePostAA = apiReactionAA.filter((api) => api.reaction === "1" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); 
  const likePostAA = filterLikePostAA.length > 0; // like

  const filterLovePostAA = apiReactionAA.filter((api) => api.reaction === "2" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); 
  const lovePostAA = filterLovePostAA.length > 0; // love

  const filterSadPostAA = apiReactionAA.filter((api) => api.reaction === "3" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); 
  const sadPostAA = filterSadPostAA.length > 0; // sad


  //logique pour mettre un like sur un post - AA
  const [likeAA, setLikeAA] = useState(false);
  async function LikeAA() {
    setLikeAA(true);
    setLoveAA(false);
    setSadAA(false);

    //1ere requete
    //1ere requete
    // on verifie d'abord si le post a deja ete liker
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        const apiReaction = res.data;
        const filterLike = apiReaction.filter((api) => api.reaction === "1" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // like
        
        const verifyLike = filterLike.length > 0;
        if (verifyLike) {
          //dans ce cas: le post a deja ete liker
          console.log("le post a deja ete liker");

        //2e requete
        //2e requete
        // obtenir de nouvelles donnees (etant donné que le post a deja ete liker, alors on affiche le bouton dislike)
        async function deuxiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
          .then((res) => {
            setApiReactionAA(res.data);
  
          })
        }
        deuxiemeReq();
        //2e requete
    } else {
    //dans ce cas: le post n'a pas un like, (alors on va mettre un like le post)

        // on verifie s'il y'a les donnees de la reaction
        const reaction = apiReaction.filter((api) => api._id && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // like
        const dataReaction = reaction.length > 0;

        const id = reaction.map((api) => api._id);  //id de la reaction
        if (id) { localStorage.setItem("idReactionAA", id)}

        if (dataReaction) { 
          //dans ce cas: il y'a deja les donnees de la reaction
        
          //2e requete
          //2e requete
          // on met un like en faisant un put
          async function deuxiemeReq() {
            const idReactionAA = localStorage.getItem("idReactionAA");
            const reaction = "1";
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/update/${idReactionAA}`,
              data: {
                reaction,
              },
            })
            .then((res) => {

          //3e requete
          //3e requete
          // obtenir de nouvelles donnees (on a mis un like ! , alors on affiche le bouton dislike)
          async function troisiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
            .then((res) => {
              setApiReactionAA(res.data);
    
            })
          }
          troisiemeReq();
          //3e requete
          })
        }
        deuxiemeReq()
        //2e requete
      } else {
        //dans ce cas: il n y'a pas encore les donnees de la reaction
         
        //2e requete
        //2e requete
        // on met un like en faisant un post
        async function deuxiemeReq() {
          const reaction = "1";
          const id = localStorage.getItem("createIdReactionAA");
          const idPost = localStorage.getItem("idPostAA");
          const idOwnerAA = localStorage.getItem("idOwnerAA");
          const nameOwnerAA = localStorage.getItem("nameOwnerAA");
          const photoOwnerAA = localStorage.getItem("photoOwnerAA");
          const badgeOwnerAA = localStorage.getItem("badgeOwnerAA");
          const countryOwnerAA = localStorage.getItem("countryOwnerAA");
          const connection = "1";
          const visible = "1";
          const type = "1";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/add`,
            data: {
              reaction,
              id,
              idPost,
              idSender: idPersonConnectedAA, // Sender - celui qui envoie la reaction
              nameSender: namePersonConnectedAA,
              photoSender: photoPersonConnectedAA,
              badgeSender: badgePersonConnectedAA,
              countrySender: countryPersonConnectedAA,
              idReceiver: idOwnerAA, // Receiver - celui qui recoit la reaction, idOwnerAA ici c'est l'id du proprietaire du post
              nameReceiver: nameOwnerAA,
              photoReceiver: photoOwnerAA,
              badgeReceiver: badgeOwnerAA,
              countryReceiver: countryOwnerAA,
              connection,
              visible,
              type,
            },
          })
          .then((res) => {


              //3e requete
              //3e requete
              // obtenir de nouvelles donnees (on a mis un like ! , alors on affiche le bouton dislike)
              async function troisiemeReq() {
                await axios
                .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
                .then((res) => {
                  setApiReactionAA(res.data);
        
                })
              }
              troisiemeReq();
              //3e requete
            })
          }
          deuxiemeReq();
          //2e requete
        }
        //if (dataReaction) {
      }
      //if (verifyLike) {
    })
    }
    premiereReq();
    //1ere requete
  }

  
//logique pour dislike 1 post - AA
async function DislikeAA() {
    setLikeAA(false);
    setLoveAA(false);
    setSadAA(false);

    //1ere requete
    //1ere requete
    // on prend l'id de la reaction (pour changer le like en dislike)
    async function premiereReq() {
      await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
        .then((res) => {
          const apiReaction = res.data;
          const filterLike = apiReaction.filter((api) => api.reaction === "1" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // like
          
          const idReaction = filterLike.map((api) => api._id); 
          if (idReaction) { localStorage.setItem("idReactionAA", idReaction)}

          const verifyLike = filterLike.length > 0; // cette petite verification c'est vraiment pour verifier si le post avait deja ete liker (comme ca on va mettre le dislike)
          if (verifyLike) {
            //dans ce cas: le post a deja un like

            //2e requete
            //2e requete
            // on met le dislike
            async function deuxiemeReq() {
              const reaction = "0";
              const idReactionAA = localStorage.getItem("idReactionAA");
              await axios({
                method: "put",
                url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/update/${idReactionAA}`,
                data: {
                  reaction,
                },
              })
              .then((res) => {

            //3e requete
            //3e requete
            // obtenir de nouvelles donnees (etant donné qu'on a dislike, alors on affiche le bouton like)
            async function troisiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
              .then((res) => {
                setApiReactionAA(res.data);
      
              })
            }
            troisiemeReq();
            //3e requete
              })
            }
            deuxiemeReq()
            //2e requete
          } else {
            //dans ce cas: le post n'a pas un like
            console.log("le post n'a pas un like");

            //2e requete
            //2e requete
            // obtenir de nouvelles donnees (etant donné que le post n'a pas un like, alors on affiche le bouton like)
            async function deuxiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
              .then((res) => {
                setApiReactionAA(res.data);
      
              })
            }
            deuxiemeReq();
            //2e requete
          }
          //if (verifyLike) {
        })
      }
    premiereReq();
    //1ere requete
  }


  //logique pour mettre un love sur un post - AA
  const [loveAA, setLoveAA] = useState(false);
  async function LoveAA() {
    setLoveAA(true);
    setLikeAA(false);
    setSadAA(false);

    //1ere requete
    //1ere requete
    // on verifie d'abord si le post a deja un love
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        const apiReaction = res.data;
        const filterLove = apiReaction.filter((api) => api.reaction === "2" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // love
        
        const verifyLove = filterLove.length > 0;
        if (verifyLove) {
          //dans ce cas: le post a deja un love
          console.log("le post a deja un love");

        //2e requete
        //2e requete
        // obtenir de nouvelles donnees (etant donné que le post a deja un love, alors on affiche le bouton dislove)
        async function deuxiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
          .then((res) => {
            setApiReactionAA(res.data);
  
          })
        }
        deuxiemeReq();
        //2e requete
    } else {
    //dans ce cas: le post n'a pas un love, (alors on va mettre un love)
    console.log("le post n'a pas un love");

        // on verifie s'il y'a les donnees de la reaction
        const reaction = apiReaction.filter((api) => api._id && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // like
        const dataReaction = reaction.length > 0;

        const id = reaction.map((api) => api._id);  //id de la reaction
        if (id) { localStorage.setItem("idReactionAA", id)}

        if (dataReaction) { 
          //dans ce cas: il y'a deja les donnees de la reaction
          console.log("il y'a deja les donnees de la reaction, on va mettre un love en faisant un put");
        
          //2e requete
          //2e requete
          // on va mettre un love en faisant un put
          async function deuxiemeReq() {
            const reaction = "2";
            const idReactionAA = localStorage.getItem("idReactionAA");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/update/${idReactionAA}`,
              data: {
                reaction,
              },
            })
            .then((res) => {

          //3e requete
          //3e requete
          // obtenir de nouvelles donnees (on a mis un love ! , alors on affiche le bouton dislove)
          async function troisiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
            .then((res) => {
              setApiReactionAA(res.data);
    
            })
          }
          troisiemeReq();
          //3e requete
          })
        }
        deuxiemeReq()
        //2e requete
      } else {
        //dans ce cas: il n y'a pas encore les donnees de la reaction
        console.log("il n y'a pas encore les donnees de la reaction, on met un love en faisant un post");
         
        //2e requete
        //2e requete
        // on met un love en faisant un post
        async function deuxiemeReq() {
          const reaction = "2";
          const id = localStorage.getItem("createIdReactionAA");
          const idPost = localStorage.getItem("idPostAA");
          const idOwnerAA = localStorage.getItem("idOwnerAA");
          const nameOwnerAA = localStorage.getItem("nameOwnerAA");
          const photoOwnerAA = localStorage.getItem("photoOwnerAA");
          const badgeOwnerAA = localStorage.getItem("badgeOwnerAA");
          const countryOwnerAA = localStorage.getItem("countryOwnerAA");
          const connection = "1";
          const visible = "1";
          const type = "1";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/add`,
            data: {
              reaction,
              id,
              idPost,
              idSender: idPersonConnectedAA, // Sender - celui qui envoie la reaction
              nameSender: namePersonConnectedAA,
              photoSender: photoPersonConnectedAA,
              badgeSender: badgePersonConnectedAA,
              countrySender: countryPersonConnectedAA,
              idReceiver: idOwnerAA, // Receiver - celui qui recoit la reaction, idOwnerAA ici c'est l'id du proprietaire du post
              nameReceiver: nameOwnerAA,
              photoReceiver: photoOwnerAA,
              badgeReceiver: badgeOwnerAA,
              countryReceiver: countryOwnerAA,
              connection,
              visible,
              type,
            },
          })
          .then((res) => {


              //3e requete
              //3e requete
              // obtenir de nouvelles donnees (on a mis un love ! , alors on affiche le bouton dislove)
              async function troisiemeReq() {
                await axios
                .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
                .then((res) => {
                  setApiReactionAA(res.data);
        
                })
              }
              troisiemeReq();
              //3e requete
            })
          }
          deuxiemeReq();
          //2e requete
        }
        //if (dataReaction) {
      }
      //if (verifyLove) {
    })
    }
    premiereReq();
    //1ere requete
  }

  
//logique pour dislove 1 post - AA
async function DisloveAA() {
    setLoveAA(false);
    setLikeAA(false);
    setSadAA(false);

    //1ere requete
    //1ere requete
    // on prend l'id de la reaction (pour changer love en dislove)
    async function premiereReq() {
      await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
        .then((res) => {
          const apiReaction = res.data;
          const filterLove = apiReaction.filter((api) => api.reaction === "2" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // love
          
          const idReaction = filterLove.map((api) => api._id); 
          if (idReaction) { localStorage.setItem("idReactionAA", idReaction)}

          const verifyLove = filterLove.length > 0; // cette petite verification c'est vraiment pour verifier si le post a deja un love (comme ca on va mettre un dislove)
          if (verifyLove) {
            //dans ce cas: le post a deja un love
            console.log(verifyLove);
            console.log("le post a deja un love");

            //2e requete
            //2e requete
            // on met un dislove
            async function deuxiemeReq() {
              const idReactionAA = localStorage.getItem("idReactionAA");
              const reaction = "0";
              await axios({
                method: "put",
                url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/update/${idReactionAA}`,
                data: {
                  reaction,
                },
              })
              .then((res) => {

            //3e requete
            //3e requete
            // obtenir de nouvelles donnees (etant donné qu'on a mis un dislove, alors on affiche le bouton love)
            async function troisiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
              .then((res) => {
                setApiReactionAA(res.data);
      
              })
            }
            troisiemeReq();
            //3e requete
              })
            }
            deuxiemeReq()
            //2e requete
          } else {
            //dans ce cas: le post n'a pas un love
            console.log("le post n'a pas un love");

            //2e requete
            //2e requete
            // obtenir de nouvelles donnees (etant donné que le post n'a pas un love, alors on affiche le bouton love)
            async function deuxiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
              .then((res) => {
                setApiReactionAA(res.data);
      
              })
            }
            deuxiemeReq();
            //2e requete
          }
          //if (verifyLove) {
        })
      }
    premiereReq();
    //1ere requete
  }


  //logique pour mettre un sad sur un post - AA
  const [sadAA, setSadAA] = useState(false);
  async function SadAA() {
    setSadAA(true);
    setLoveAA(false);
    setLikeAA(false);

    //1ere requete
    //1ere requete
    // on verifie d'abord si le post a deja un sad
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        const apiReaction = res.data;
        const filterSad = apiReaction.filter((api) => api.reaction === "3" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // sad
        
        const verifySad = filterSad.length > 0;
        if (verifySad) {
          //dans ce cas: le post a deja un sad
          console.log("le post a deja un sad");

        //2e requete
        //2e requete
        // obtenir de nouvelles donnees (etant donné que le post a deja un sad, alors on affiche le bouton dissad)
        async function deuxiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
          .then((res) => {
            setApiReactionAA(res.data);
  
          })
        }
        deuxiemeReq();
        //2e requete
    } else {
    //dans ce cas: le post n'a pas un sad, (alors on va mettre un sad)
    console.log("le post n'a pas un sad");

        // on verifie s'il y'a les donnees de la reaction
        const reaction = apiReaction.filter((api) => api._id && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // like
        const dataReaction = reaction.length > 0;

        const id = reaction.map((api) => api._id);  //id de la reaction
        if (id) { localStorage.setItem("idReactionAA", id)}

        if (dataReaction) { 
          //dans ce cas: il y'a deja les donnees de la reaction
          console.log("il y'a deja les donnees de la reaction, on va mettre un sad en faisant un put");
        
          //2e requete
          //2e requete
          // on va mettre un sad en faisant un put
          async function deuxiemeReq() {
            const reaction = "3";
            const idReactionAA = localStorage.getItem("idReactionAA");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/update/${idReactionAA}`,
              data: {
                reaction,
              },
            })
            .then((res) => {

          //3e requete
          //3e requete
          // obtenir de nouvelles donnees (on a mis un sad ! , alors on affiche le bouton dissad)
          async function troisiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
            .then((res) => {
              setApiReactionAA(res.data);
    
            })
          }
          troisiemeReq();
          //3e requete
          })
        }
        deuxiemeReq()
        //2e requete
      } else {
        //dans ce cas: il n y'a pas encore les donnees de la reaction
        console.log("il n y'a pas encore les donnees de la reaction, on met un sad en faisant un post");
         
        //2e requete
        //2e requete
        // on met un sad en faisant un post
        async function deuxiemeReq() {
          const reaction = "3";
          const id = localStorage.getItem("createIdReactionAA");
          const idPost = localStorage.getItem("idPostAA");
          const idOwnerAA = localStorage.getItem("idOwnerAA");
          const nameOwnerAA = localStorage.getItem("nameOwnerAA");
          const photoOwnerAA = localStorage.getItem("photoOwnerAA");
          const badgeOwnerAA = localStorage.getItem("badgeOwnerAA");
          const countryOwnerAA = localStorage.getItem("countryOwnerAA");
          const connection = "1";
          const visible = "1";
          const type = "1";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/add`,
            data: {
              reaction,
              id,
              idPost,
              idSender: idPersonConnectedAA, // Sender - celui qui envoie la reaction
              nameSender: namePersonConnectedAA,
              photoSender: photoPersonConnectedAA,
              badgeSender: badgePersonConnectedAA,
              countrySender: countryPersonConnectedAA,
              idReceiver: idOwnerAA, // Receiver - celui qui recoit la reaction, idOwnerAA ici c'est l'id du proprietaire du post
              nameReceiver: nameOwnerAA,
              photoReceiver: photoOwnerAA,
              badgeReceiver: badgeOwnerAA,
              countryReceiver: countryOwnerAA,
              connection,
              visible,
              type,
            },
          })
          .then((res) => {


              //3e requete
              //3e requete
              // obtenir de nouvelles donnees (on a mis un sad ! , alors on affiche le bouton dissad)
              async function troisiemeReq() {
                await axios
                .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
                .then((res) => {
                  setApiReactionAA(res.data);
        
                })
              }
              troisiemeReq();
              //3e requete
            })
          }
          deuxiemeReq();
          //2e requete
        }
        //if (dataReaction) {
      }
      //if (verifySad) {
    })
    }
    premiereReq();
    //1ere requete
  }

  
//logique pour dissad 1 post - AA
async function DissadAA() {
    setSadAA(false);
    setLoveAA(false);
    setLikeAA(false);
  
    //1ere requete
    //1ere requete
    // on prend l'id de la reaction (pour changer sad en dissad)
    async function premiereReq() {
      await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
        .then((res) => {
          const apiReaction = res.data;
          const filterSad = apiReaction.filter((api) => api.reaction === "3" && api.idPost === idPostAA && api.idSender === idPersonConnectedAA); // sad
          
          const idReaction = filterSad.map((api) => api._id); 
          if (idReaction) { localStorage.setItem("idReactionAA", idReaction)}

          const verifySad = filterSad.length > 0; // cette petite verification c'est vraiment pour verifier si le post a deja un sad (comme ca on va mettre un dissad)
          if (verifySad) {
            //dans ce cas: le post a deja un sad
            console.log(verifySad);
            console.log("le post a deja un sad");

            //2e requete
            //2e requete
            // on met un dissad
            async function deuxiemeReq() {
              const idReactionAA = localStorage.getItem("idReactionAA");
              const reaction = "0";
              await axios({
                method: "put",
                url: `${process.env.REACT_APP_BACKEND}/api/reactionAA/update/${idReactionAA}`,
                data: {
                  reaction,
                },
              })
              .then((res) => {

            //3e requete
            //3e requete
            // obtenir de nouvelles donnees (etant donné qu'on a mis un dissad, alors on affiche le bouton sad)
            async function troisiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
              .then((res) => {
                setApiReactionAA(res.data);
      
              })
            }
            troisiemeReq();
            //3e requete
              })
            }
            deuxiemeReq()
            //2e requete
          } else {
            //dans ce cas: le post n'a pas un sad
            console.log("le post n'a pas un sad");

            //2e requete
            //2e requete
            // obtenir de nouvelles donnees (etant donné que le post n'a pas un sad, alors on affiche le bouton sad)
            async function deuxiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
              .then((res) => {
                setApiReactionAA(res.data);
      
              })
            }
            deuxiemeReq();
            //2e requete
          }
          //if (verifySad) {
        })
      }
    premiereReq();
    //1ere requete
  }


  // page - voir les reactions
  const [seeReactionPageAA, setSeeReactionPageAA] = useState(false);
  async function CloseSeeReactionPageAA() {
    setSeeReactionPageAA(false);
  }


  // page pour voir la video sur laquelle j'ai cliqué (au niveau de la page video, il clique sur une video)
  const [seeVideoAA, setSeeVideoAA] = useState(false);
  async function CloseSeeVideoAA() {
    setSeeVideoAA(false);
  }

  // Page Redirection (666 videoAA)
  // au niveau de la page video, la logique ci nous dira quel page ouvrir - AA
  async function PageRedirection666videoAA() {

    // page - voir le profil Other (sur la page d'accueil, il clique pour accéder à la page de l'autre)
    /*const GoToPageProfilOther = localStorage.getItem("GoToProfilOtherAA");
    if (GoToPageProfilOther === "1") {
      //logique pour debiter le solde d'une personne qui a cliquer pour accéder à notre page - AA
      async function Monetization666HomeAAforGoToProfilOtherAA() { 

        if (idPersonConnectedAA) {
          //1ere requete
          //1ere requete
          // obtenir les anciens solde (solde alrani pay, solde alrani monetization. avec ces anciens solde, on va pouvoir faire les calculs des nouveaux soldes)
          async function premiereReq() {
            const idOwner = localStorage.getItem("idOwnerAA");
            const idPost = localStorage.getItem("idPostAA");
            const price = "25"; //prix par clic 25FCFA
            
            // on verifie si celui qui a cliquer est le proprietaire de la page (comme ca on va eviter de le facturer)
            const owner = apiPostAA.filter((api) => api._id === idPost && api.idOwner === idPersonConnectedAA);
            const ownerPost = owner.length > 0;
            if (ownerPost) {
              //dans ce cas: celui qui a cliquer est le proprietaire de la page
              console.log("celui qui a cliquer est le proprietaire de la page");

              // vu qu'il est le proprietaire de la page alors on lui affiche sa page
              setProfilOtherAA(true); 
            } else {
              //dans ce cas: celui qui a cliquer n'est pas le proprietaire de la page
              console.log("celui qui a cliquer n'est pas le proprietaire de la page");
            
            // filtre Client
            const filterClient = apiUserAA.filter((api) => api._id === idUserConnectedAA);
    
            const oldBalanceAlraniPay = filterClient.map((api) => api.balanceAlraniPay); // ancien solde alrani pay
            if (oldBalanceAlraniPay) { localStorage.setItem("oldBalanceAlraniPay", oldBalanceAlraniPay); }
            
            // calcul du nouveau solde alrani pay
            const newBalanceAlraniPay = parseInt(oldBalanceAlraniPay) - parseInt(price)
            if (newBalanceAlraniPay) { localStorage.setItem("newBalanceAlraniPay", newBalanceAlraniPay); }
    
            //filtre Owner 
            const filterOwner = apiAccountAA.filter((api) => api._id === idOwner);
    
            const monetizationCommission = filterOwner.map((api) => api.monetizationCommission); // monetization Commission (pourcentage de la commission, c'est ca commission qu'il gagne sur chaque clic sur sa publication)
            if (monetizationCommission) { localStorage.setItem("monetizationCommission", monetizationCommission) }
    
            const oldMonetization = filterOwner.map((api) => api.monetizationBalance); // ancien solde monetization 
            if (oldMonetization) { localStorage.setItem("oldBalanceMonetization", oldMonetization) }
            
            // calcul de la commission
            const calculMonetizationCommission = parseInt(price) * parseInt(monetizationCommission) / 100;
            if (calculMonetizationCommission) { localStorage.setItem("calculMonetizationCommission", calculMonetizationCommission) }
    
            // calcul du nouveau solde monetization
            const newMonetization = parseInt(oldMonetization) + parseInt(calculMonetizationCommission);
            if (newMonetization) { localStorage.setItem("newBalanceMonetization", newMonetization) }
            
            //on verifie si c'est myAccount, si c'est myAccount il y'aura des codes spécifiques pour myAccount
            const filterAccount = apiAccountAA.filter((api) => api._id === idOwner && api.myAccount === "1");
            const myAccount = filterAccount.length > 0;
            console.log(filterAccount, "filterAccount");
            console.log(myAccount, "myAccount");
    
            // calculs des vues et clics
            if (myAccount) {
              //dans ce cas: c'est myAccount
              console.log("c'est myAccount");
    
              let minClic = 101;
              let maxClic = 399;
              let newClic000 = Math.floor(Math.random() * (maxClic - minClic) + minClic);
              const oldClic000 = localStorage.getItem("oldClicAA");
              const calculClic000 = parseInt(oldClic000) + parseInt(newClic000);
              if (calculClic000) { localStorage.setItem("newClicAA", calculClic000); }
                
              let minView = 399;
              let maxView = 2999;
              let newView000 = Math.floor(Math.random() * (maxView - minView) + minView);
              const oldView000 = localStorage.getItem("oldViewAA");
              const calculView000 = parseInt(oldView000) + parseInt(newView000);
              if (calculView000) { localStorage.setItem("newViewAA", calculView000); }
    
              //vu que c'est myAccount, alors on calcule le nouveau solde monetization
              const calculMonetization = parseInt(calculMonetizationCommission) * parseInt(newClic000);
              const newMonetization000 = parseInt(oldMonetization) + parseInt(calculMonetization);
              if (newMonetization000) { localStorage.setItem("newBalanceMonetization", newMonetization000) }
    
            } else {
              //dans ce cas: ce n'est pas myAccount
              console.log("ce n'est pas myAccount");
    
              const newClic = "1";
              const oldClic = localStorage.getItem("oldClicAA");
              const calculClic = parseInt(oldClic) + parseInt(newClic);
              if (calculClic) { localStorage.setItem("newClicAA", calculClic); }
                
              let min = 399;
              let max = 2999;
              let newView = Math.floor(Math.random() * (max - min) + min);
              const oldView = localStorage.getItem("oldViewAA");
              const calculView = parseInt(oldView) + parseInt(newView);
              if (calculView) { localStorage.setItem("newViewAA", calculView); }
            }
    
            console.log(price, "prix pour chaque clic");
            console.log(idPersonConnectedAA, "id de la personne qui a cliquer");
            console.log(filterClient, "filterClient");
            console.log(oldBalanceAlraniPay, "ancien solde alrani pay");
            console.log(newBalanceAlraniPay, "nouveau solde alrani pay");
    
            console.log(idOwner, "id du proprietaire du post");
            console.log(filterOwner, "filterOwner");
            console.log(monetizationCommission, "pourcentage de la commission monetization");
            console.log(calculMonetizationCommission, "calcul de la commission monetization");
            console.log(oldMonetization, "ancien solde monetization");
            console.log(newMonetization, "nouveau solde monetization");
            
          if (newBalanceAlraniPay > 99) {
            //dans ce cas: Solde suffisant 
            setProfilOtherAA(true); // page affiché! (solde alrani pay suffisant alors on affiche la page)

          //2e requete
          //2e requete
          // on debite le solde de l'utilisateur (nouveau solde alrani pay)
          async function deuxiemeReq() {
            const balanceAlraniPay = localStorage.getItem("newBalanceAlraniPay");
            await axios({ 
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idUserConnectedAA}`,
              data: {
                balanceAlraniPay,
              },
            })
            .then((res) => {
            
        //3e requete
        //3e requete
        // on obtiens de nouvelles donnees - apiUserAA
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
          .then((res) => {
            setApiUserAA(res.data);
  
   
    
        //4e requete
        //4e requete
        // on depose l'argent dans le solde du proprietaire de la page (nouveau solde monetization)
        async function quatriemeReq() {
          const idOwner = localStorage.getItem("idOwnerAA");
          const monetizationBalance = localStorage.getItem("newBalanceMonetization");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idOwner}`,
            data: {
              monetizationBalance,
            },
          })
          .then((res) => {
            console.log("le proprietaire de la page a deja recu son argent");
    
        //5e requete
        //5e requete
        // on obtiens de nouvelles - apiAccountAA
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
          .then((res) => {
            setApiAccountAA(res.data);
  
   
    
          //6e requete
          //6e requete
          // argent deposer alors on envoie la notification au proprietaire pour qu'il sache qu'il a recu de l'argent (lorsqu'on a cliquer sur sa publication)
          async function sixiemeReq() {
            const id = localStorage.getItem("createIdNotificationAA");
            const notification = "1"; // clic pour voir un post
            const percentageStockRequired = localStorage.getItem("depositNationalStock");
            const percentageCommission = localStorage.getItem("depositNationalCommission");
            const phoneNumberOwner = localStorage.getItem("phoneNumber");
            const fees = localStorage.getItem("fees");
            const amount = localStorage.getItem("writeAmount");
            const total = localStorage.getItem("total");
            const oldStockOwner = localStorage.getItem("oldStock");
            const commission = localStorage.getItem("calculDepositNationalCommission");
            const stockRequired = localStorage.getItem("calculDepositNationalStock");
            const newStockOwner = localStorage.getItem("newStock");
            const idOther = localStorage.getItem("idOwnerAA");
            const nameOther = localStorage.getItem("nameOwnerAA");
            const oldBalanceOther = localStorage.getItem("oldBalanceNational");
            const newBalanceOther = localStorage.getItem("newBalanceNational");
            const display = "1";
            const visible = "1";
            const connection = "1";
    
            console.log(price, "prix pour chaque clic");
            
            console.log(idPersonConnectedAA, "id de la personne qui a cliquer");
            console.log(filterClient, "filterClient");
            console.log(oldBalanceAlraniPay, "ancien solde alrani pay");
            console.log(newBalanceAlraniPay, "nouveau solde alrani pay");
    
            console.log(idOwner, "id du proprietaire du post");
            console.log(filterOwner, "filterOwner");
            console.log(monetizationCommission, "pourcentage de la commission monetization");
            console.log(calculMonetizationCommission, "calcul de la commission monetization");
            console.log(oldMonetization, "ancien solde monetization");
            console.log(newMonetization, "nouveau solde monetization");
    
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_BACKEND}/api/notificationAA/create`,
              data: {
                id,
                notification,
                idOwner: idPersonConnectedAA,
                nameOwner: namePersonConnectedAA,
                phoneNumberOwner,
                percentageStockRequired, //pourcentage du stock requis
                percentageCommission, //pourcentage des commissions (versement national)
                fees, // frais
                amount, // montant a deposer
                total, // montant a payer
                oldStockOwner, //ancien stock
                commission, //commission
                stockRequired, //stock necessaire
                newStockOwner,
                idOther,
                nameOther,
                oldBalanceOther,
                newBalanceOther,
                display,
                visible,
                connection,
              },
            })
            .then((res) => {
  
            
            //7e requete
            //7e requete
            // on met les vues et les clics
            async function septiemeReq() {
              const idPost = localStorage.getItem("idPostAA");
              const view = localStorage.getItem("newViewAA");
              const clic = localStorage.getItem("newClicAA");
    
              await axios({
                method: "put",
                url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPost}`,
                data: {
                  view,
                  clic,
                },
              })
              .then((res) => {
                console.log("les vues et les clics ont ete mis");

            //8e requete
            //8e requete
            // obtenir les nouvelles donnees
            async function huitiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
              .then((res) => {
               setApiPostAA(res.data);
      
      
              
            //9e requete
            //9e requete
            // obtenir les nouvelles donnees
            async function neuviemeReq() {
             await axios
             .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
             .then((res) => {
              setApiNotificationAA(res.data);

    
    
            //10e requete
            //10e requete
            // obtenir les nouvelles donnees 
            async function dixiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
              .then((res) => {
               setApiConversationAA(res.data);
      
      
    
            //11e requete
            //11e requete
            // obtenir les nouvelles donnees - apiMessageAA
            async function onziemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
              .then((res) => {
               setApiMessageAA(res.data);
      
      

        //12e requete
        //12e requete
        // on obtiens la localisation de l'utilisateur
        async function douziemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //13e requete
        //13e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function treiziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Profil Other (au niveau de la page d'accueil d'Alrani, il a cliquer pour acceder au profil de l'autre) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //14e requete
        //14e requete
        // on enregistre la date de derniere connexion
        async function quatorziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          quatorziemeReq();
          //14e requete
          });
          }
          treiziemeReq();
          //13e requete
          });
          }
          douziemeReq();
          //12e requete
              })
              }
              onziemeReq();
              //11e requete
              })
              }
              dixiemeReq();
              //10e requete
              })
              }
              neuviemeReq();
              //9e requete
              })
              }
              huitiemeReq();
              //8e requete
              })
              }
              septiemeReq();
              //7e requete
              })
              }
              sixiemeReq();
              //6e requete
              })
              }
              cinquiemeReq();
              //5e requete
              })
              }
              quatriemeReq();
              //4e requete
              })
              }
              troisiemeReq();
              //3e requete
              })
              }
              deuxiemeReq();
              //2e requete
              } else {
                //dans ce cas: Solde insuffisant (impossible d'afficher le page)
                setErrorAlraniPayAA(true); 
                console.log("veuillez recharger votre solde alrani pay");
              } 
              //if (newBalanceAlraniPay > -1)
            }
            //if (ownerPost)
            }
            premiereReq();
            //1ere requete
           }// if(idPersonConnectedAA)
          }
      Monetization666HomeAAforGoToProfilOtherAA();
    }*/
    

    // page - voir une video
    //(sur la page video, il a cliquer pour voir la video)
    const GoToPageSeeVideo = localStorage.getItem("GoToPageSeeVideo666videoAA");
    if (GoToPageSeeVideo === "1") {

      //logique pour debiter le solde d'une personne qui a cliquer pour voir ma video (il a cliquer sur la page video) - AA
      async function Monetization666HomeAAforGoToPageSeeVideoAA() { //monetisation 666 homeAA dans le cas ou on veut aller sur la page pour voir le post (seePostAA)
        
        if (idPersonConnectedAA) {
      //1ere requete
      //1ere requete
      // obtenir les anciens solde (solde alrani pay, solde alrani monetization. avec ces anciens solde, on va pouvoir faire les calculs des nouveaux soldes)
      async function premiereReq() {
        const idOwner = localStorage.getItem("idOwnerAA");
        const idPost = localStorage.getItem("idPostAA");
        const price = "25"; //prix par clic 25FCFA
        
      // on verifie si celui qui a cliquer est le proprietaire de la video (comme ca on va eviter de le facturer)
      const owner = apiPostAA.filter((api) => api._id === idPost && api.idOwner === idPersonConnectedAA);
      const ownerPost = owner.length > 0;
      if (ownerPost) {
        //dans ce cas: celui qui a cliquer est le proprietaire de la video

        // vu qu'il est le proprietaire de la video alors on lui affiche sa video
        setSeeVideoAA(true);
      } else {
        //dans ce cas: celui qui a cliquer n'est pas le proprietaire de la video
        
        // filtre Client
        const filterClient = apiUserAA.filter((api) => api._id === idUserConnectedAA);

        const oldBalanceAlraniPay = filterClient.map((api) => api.balanceAlraniPay); // ancien solde alrani pay
        if (oldBalanceAlraniPay) { localStorage.setItem("oldBalanceAlraniPay", oldBalanceAlraniPay); }
        
        // calcul du nouveau solde alrani pay
        const newBalanceAlraniPay = parseInt(oldBalanceAlraniPay) - parseInt(price)
        if (newBalanceAlraniPay) { localStorage.setItem("newBalanceAlraniPay", newBalanceAlraniPay); }

        //filtre Owner 
        const filterOwner = apiAccountAA.filter((api) => api._id === idOwner);

        const monetizationCommission = filterOwner.map((api) => api.monetizationCommission); // monetization Commission (pourcentage de la commission, c'est ca commission qu'il gagne sur chaque clic sur sa publication)
        if (monetizationCommission) { localStorage.setItem("monetizationCommission", monetizationCommission) }

        const oldMonetization = filterOwner.map((api) => api.monetizationBalance); // ancien solde monetization 
        if (oldMonetization) { localStorage.setItem("oldBalanceMonetization", oldMonetization) }
        
        // calcul de la commission
        const calculMonetizationCommission = parseInt(price) * parseInt(monetizationCommission) / 100;
        if (calculMonetizationCommission) { localStorage.setItem("calculMonetizationCommission", calculMonetizationCommission) }

        // calcul du nouveau solde monetization
        const newMonetization = parseInt(oldMonetization) + parseInt(calculMonetizationCommission);
        if (newMonetization) { localStorage.setItem("newBalanceMonetization", newMonetization) }
        
        //on verifie si c'est myAccount, si c'est myAccount il y'aura des codes spécifiques pour myAccount
        const filterAccount = apiAccountAA.filter((api) => api._id === idOwner && api.myAccount === "1");
        const myAccount = filterAccount.length > 0;

        // calculs des vues et clics
        if (myAccount) {
          //dans ce cas: c'est myAccount

          let minClic = 101;
          let maxClic = 399;
          let newClic = Math.floor(Math.random() * (maxClic - minClic) + minClic);
          const oldClic = localStorage.getItem("oldClicAA");
          const calculClic = parseInt(oldClic) + parseInt(newClic);
          if (calculClic) { localStorage.setItem("newClicAA", calculClic); }
            
          let minView = 399;
          let maxView = 2999;
          let newView = Math.floor(Math.random() * (maxView - minView) + minView);
          const oldView = localStorage.getItem("oldViewAA");
          const calculView = parseInt(oldView) + parseInt(newView);
          if (calculView) { localStorage.setItem("newViewAA", calculView); }

          //vu que c'est myAccount, alors on calcule le nouveau solde monetization
          const calculMonetization = parseInt(calculMonetizationCommission) * parseInt(newClic);
          const newMonetization = parseInt(oldMonetization) + parseInt(calculMonetization);
          if (newMonetization) { localStorage.setItem("newBalanceMonetization", newMonetization) }

        } else {
          //dans ce cas: ce n'est pas myAccount

          const newClic = "1";
          const oldClic = localStorage.getItem("oldClicAA");
          const calculClic = parseInt(oldClic) + parseInt(newClic);
          if (calculClic) { localStorage.setItem("newClicAA", calculClic); }
            
          let min = 399;
          let max = 2999;
          let newView = Math.floor(Math.random() * (max - min) + min);
          const oldView = localStorage.getItem("oldViewAA");
          const calculView = parseInt(oldView) + parseInt(newView);
          if (calculView) { localStorage.setItem("newViewAA", calculView); }
        }
        
      if (newBalanceAlraniPay > 99) {
        //dans ce cas: Solde suffisant 
        setSeeVideoAA(true);// video affiché! (solde alrani pay suffisant alors on affiche la video)
      
      //2e requete
      //2e requete
      // on debite le solde de l'utilisateur (nouveau solde alrani pay)
      async function deuxiemeReq() {
        const balanceAlraniPay = localStorage.getItem("newBalanceAlraniPay");
        await axios({ 
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idUserConnectedAA}`,
          data: {
            balanceAlraniPay,
          },
        })
        .then((res) => {
        
    //3e requete
    //3e requete
    // on obtiens de nouvelles donnees - apiUserAA
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data); 

    //4e requete
    //4e requete
    // on depose l'argent dans le solde du proprietaire du post (nouveau solde monetization)
    async function quatriemeReq() {
      const idOwner = localStorage.getItem("idOwnerAA");
      const monetizationBalance = localStorage.getItem("newBalanceMonetization");
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idOwner}`,
        data: {
          monetizationBalance,
        },
      })
      .then((res) => {

    //5e requete
    //5e requete
    // on obtiens de nouvelles
    async function cinquiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
      .then((res) => {
        setApiAccountAA(res.data); 

      //6e requete
      //6e requete
      // argent deposer alors on envoie la notification au proprietaire pour qu'il sache qu'il a recu de l'argent (lorsqu'on a cliquer sur sa publication)
      async function sixiemeReq() {
        const id = localStorage.getItem("createIdNotificationAA");
        const notification = "1"; // clic pour voir un post
        const percentageStockRequired = localStorage.getItem("depositNationalStock");
        const percentageCommission = localStorage.getItem("depositNationalCommission");
        const phoneNumberOwner = localStorage.getItem("phoneNumber");
        const fees = localStorage.getItem("fees");
        const amount = localStorage.getItem("writeAmount");
        const total = localStorage.getItem("total");
        const oldStockOwner = localStorage.getItem("oldStock");
        const commission = localStorage.getItem("calculDepositNationalCommission");
        const stockRequired = localStorage.getItem("calculDepositNationalStock");
        const newStockOwner = localStorage.getItem("newStock");
        const idOther = localStorage.getItem("idOwnerAA");
        const nameOther = localStorage.getItem("nameOwnerAA");
        const oldBalanceOther = localStorage.getItem("oldBalanceNational");
        const newBalanceOther = localStorage.getItem("newBalanceNational");
        const display = "1";
        const visible = "1";
        const connection = "1";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND}/api/notificationAA/create`,
          data: {
            id,
            notification,
            idOwner: idPersonConnectedAA,
            nameOwner: namePersonConnectedAA,
            phoneNumberOwner,
            percentageStockRequired, //pourcentage du stock requis
            percentageCommission, //pourcentage des commissions (versement national)
            fees, // frais
            amount, // montant a deposer
            total, // montant a payer
            oldStockOwner, //ancien stock
            commission, //commission
            stockRequired, //stock necessaire
            newStockOwner,
            idOther,
            nameOther,
            oldBalanceOther,
            newBalanceOther,
            display,
            visible,
            connection,
          },
        })
        .then((res) => {
        
        //7e requete
        //7e requete
        // on met les vues et les clics
        async function septiemeReq() {
          const idPost = localStorage.getItem("idPostAA");
          const view = localStorage.getItem("newViewAA");
          const clic = localStorage.getItem("newClicAA");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPost}`,
            data: {
              view,
              clic,
            },
          })
          .then((res) => {

        //8e requete
        //8e requete
        // obtenir les nouvelles donnees
        async function huitiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
          .then((res) => {
           setApiPostAA(res.data);
  
  
          
        //9e requete
        //9e requete
        // obtenir les nouvelles donnees - apiNotificationAA
        async function neuviemeReq() {
         await axios
         .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
         .then((res) => {
          setApiNotificationAA(res.data)


        //10e requete
        //10e requete
        // obtenir les nouvelles donnees
        async function dixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
           setApiConversationAA(res.data);
  
  

        //11e requete
        //11e requete
        // obtenir les nouvelles donnees 
        async function onziemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
           setApiMessageAA(res.data);
  
  

        //12e requete
        //12e requete
        // on obtiens la localisation de l'utilisateur
        async function douziemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //13e requete
        //13e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function treiziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "seeVideo (au niveau de la page d'accueil d'Alrani, il a cliquer pour voir la video de l'autre) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //14e requete
        //14e requete
        // on enregistre la date de derniere connexion
        async function quatorziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          quatorziemeReq();
          //14e requete
          });
          }
          treiziemeReq();
          //13e requete
          });
          }
          douziemeReq();
          //12e requete
          })
          }
          onziemeReq();
          //11e requete
          })
          }
          dixiemeReq();
          //10e requete
          })
          }
          neuviemeReq();
          //9e requete
          })
          }
          huitiemeReq();
          //8e requete
          })
          }
          septiemeReq();
          //7e requete
          })
          }
          sixiemeReq();
          //6e requete
          })
          }
          cinquiemeReq()
          //5e requete
          })
          }
          quatriemeReq()
          //4e requete
          })
          }
          troisiemeReq();
          //3e requete
          })
          }
          deuxiemeReq();
          //2e requete
        } else {
          //dans ce cas: Solde insuffisant (impossible d'afficher le post)
          setErrorAlraniPayAA(true); 
        } 
        //if (newBalanceAlraniPay > -1)
      }
      //if (ownerPost)
      }
      premiereReq();
      //1ere requete
      }// if(idPersonConnectedAA)
    }
    Monetization666HomeAAforGoToPageSeeVideoAA();
  }
    
    // page - partager un post
    /*const GoToPageSharePost = localStorage.getItem("GoToPageSharePostAA");
    if (GoToPageSharePost === "1") { setSharePostPageAA(true); }

    // page - ajouter une reaction
    const GoToPageAddReaction = localStorage.getItem("GoToPageAddReactionAA");
    if (GoToPageAddReaction === "1") { 
      setAddReactionPageAA(true); 
    }

    // page - voir une reaction
    const GoToPageSeeReaction = localStorage.getItem("GoToPageSeeReactionAA");
    if (GoToPageSeeReaction === "1") { setSeeReactionPageAA(true); }*/
}
  


  // Page Redirection (666 HomeAA)
  // au niveau de la page d'accueil, la logique ci nous dira quel page ouvrir - AA
  async function PageRedirection666HomeAA() {

    // page - voir le profil Other (sur la page d'accueil, il clique pour accéder à la page)
    const GoToPageProfilOther = localStorage.getItem("GoToProfilOtherAA");
    if (GoToPageProfilOther === "1") { setProfilOtherAA(true); }
    
    // page - voir un post (sur la page d'accueil, il a cliquer pour voir le post)
    const GoToPageSeePost = localStorage.getItem("GoToPageSeePost666homeAA");
    if (GoToPageSeePost === "1") { setSeePostAA(true); }

    // page - partager un post
    const GoToPageSharePost = localStorage.getItem("GoToPageSharePostAA");
    if (GoToPageSharePost === "1") { setSharePostPageAA(true); }

    // page - ajouter une reaction
    const GoToPageAddReaction = localStorage.getItem("GoToPageAddReactionAA");
    if (GoToPageAddReaction === "1") { 
      setAddReactionPageAA(true); 
    }

    // page - voir une reaction
    const GoToPageSeeReaction = localStorage.getItem("GoToPageSeeReactionAA");
    if (GoToPageSeeReaction === "1") { setSeeReactionPageAA(true); }
}

  // newAA
  // newAA
  const [newAA, setNewAA] = useState(false);
  async function NewAA() {
    setNewAA(true);
  }
  //fermer
  async function CloseNewAA() {
    setNewAA(false);
  }

  // seePost (666 ProfilAA)
  // on affiche le post sur laquelle on a cliquer
  const [seePost666ProfilAA, setSeePost666ProfilAA] = useState(false);
  async function CloseSeePost666ProfilAA() {
    setSeePost666ProfilAA(false);
  }

  //PageRedirection 666seePost666ProfilAA
  async function PageRedirection666seePost666ProfilAA() {
    // page pour voir une photo
    const seePhoto = localStorage.getItem("GotoSeePhotoAA")
    if (seePhoto === "1") { setSeePhotoAA(true); }
  }


  // voir photo profil (666 ProfilAA)
  // on affiche la photo de profil
  const [seePhotoProfil666ProfilAA, setSeePhotoProfil666ProfilAA] = useState(false);
  async function SeePhotoProfil666ProfilAA() {
    setSeePhotoProfil666ProfilAA(true);
  }
  //fermer
  async function CloseSeePhotoProfil666ProfilAA() {
    setSeePhotoProfil666ProfilAA(false);
  }

  // profilOther - AA
  // on affiche le profil de l'autre
  const [profilOtherAA, setProfilOtherAA] = useState(false);
  async function ProfilOtherAA() {
    setProfilOtherAA(true);
  }
  //fermer
  async function CloseProfilOtherAA() {
    setProfilOtherAA(false);
  }


  // page pour afficher tout mes abonnés AA
  const [follower666profilOtherAA, setFollower666profilOtherAA] = useState(false);
  async function Follower666profilOtherAA() {
    setFollower666profilOtherAA(true);
  }
  async function CloseFollower666profilOtherAA() { //fermer
    setFollower666profilOtherAA(false);
  }

  // page pour afficher tout mes abonnements AA
  const [following666profilOtherAA, setFollowing666profilOtherAA] = useState(false);
  async function Following666profilOtherAA() {
    setFollowing666profilOtherAA(true);
  }
  async function CloseFollowing666profilOtherAA() { //fermer
    setFollowing666profilOtherAA(false);
  }


  //PageRedirection 666profilOtherAA
  async function PageRedirection666profilOtherAA() {
    // page pour voir un post
    const seePost = localStorage.getItem("GoToSeePostAA")
    if (seePost === "1") { setSeePostAA(true); }
  }

  // voir le post - AA
  // voir le post - AA
  const [seePostAA, setSeePostAA] = useState(false);
  async function CloseSeePostAA() { //fermer
    setSeePostAA(false);
  }

  //PageRedirection 666seePostAA
  async function PageRedirection666seePostAA() {
    // page pour voir une photo
    const seePhoto = localStorage.getItem("GotoSeePhotoAA")
    if (seePhoto === "1") { setSeePhotoAA(true); }
  }


  // voir le post (666 homeAA, au niveau de la page d'accueil, il a cliquer sur un post, et sur cette page on affiche le post)
  const [seePost666homeAA, setSeePost666homeAA] = useState(false);
  async function CloseSeePost666homeAA() { //fermer
    setSeePost666homeAA(false);
  }

  //PageRedirection666 seePost666homeAA
  /*async function PageRedirection666seePost666homeAA() {
    // page pour voir une photo
    const seePhoto = localStorage.getItem("GotoSeePhotoAA")
    if (seePhoto === "1") { setSeePhotoAA(true); }
  }*/


  // voir la photo - AA
  // on affiche une photo
  const [seePhotoAA, setSeePhotoAA] = useState(false);
  async function SeePhotoAA() {
    setSeePhotoAA(true);
  }
  async function CloseSeePhotoAA() { //fermer
    setSeePhotoAA(false);
  }


  // voir photo profil - AA
  // on affiche la photo de profil
  const [seePhotoProfilAA, setSeePhotoProfilAA] = useState(false);
  async function SeePhotoProfilAA() {
    setSeePhotoProfilAA(true);
  }
  //fermer
  async function CloseSeePhotoProfilAA() {
    setSeePhotoProfilAA(false);
  }

  // on recupere les infos du post - AA
  const urlPhotoAA = localStorage.getItem("urlPhotoAA");
  const urlVideoAA = localStorage.getItem("urlVideoAA");
  const shareAA = localStorage.getItem("shareAA");
  const commentAA2 = localStorage.getItem("commentAA2");
  const reactionAA = localStorage.getItem("reactionAA");
  const viewAA = localStorage.getItem("viewAA");
  const adAA = localStorage.getItem("adAA");
  const descriptionAA = localStorage.getItem("descriptionAA");
  const createdAtAA = localStorage.getItem("createdAtAA");
  const postStyle1AA = localStorage.getItem("postStyle1AA");
  const postStyle6AA = localStorage.getItem("postStyle6AA");
  const postStyle30AA = localStorage.getItem("postStyle30AA");

  // sur un post, on clique sur la description pour Voir plus, ou on reclique pour Voir moins - AA
  const [seeMoreAA, setSeeMoreAA] = useState(false);
  async function SeeMoreAA() {
    setSeeMoreAA(!seeMoreAA);
  }


  // afficher tout les commentaires - AA
  // afficher tout les commentaires - AA
  const [apiCommentAA, setApiCommentAA] = useState([]);


  //creer un id pour chaque commentaire publié - AA
  const numbersCommentAA = apiCommentAA.filter((api) => api._id);
  const totalCommentAA = numbersCommentAA.length;

  const createIdCommentAA = totalCommentAA + 1;
  if (createIdCommentAA) { localStorage.setItem("createIdCommentAA", createIdCommentAA) }


  // filtre pour afficher les commentaires qui sont liés au post
  const filterCommentAA = apiCommentAA.filter((api) => api.idPost === idPostAA);

  // logique pour enregistrer le commentaire - AA
  const [writeCommentAA, setWriteCommentAA] = useState("");

  async function SaveCommentAA() {
    if (idPersonConnectedAA) {

      const block = localStorage.getItem("blockAA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      // 1ere requete
      // 1ere requete
      // on commente
      async function premiereReq() {
        const id = localStorage.getItem("createIdCommentAA");
        const idPost = localStorage.getItem("idPostAA");
        const idOwnerPost = localStorage.getItem("idOwnerAA");
        const idUserOwnerPost = localStorage.getItem("idUserOwnerAA");
        const connection = "1";
        const displayOwnerPost = "1";
        const display = "1";
        const visible = "1";
        const type = "1";

        await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/commentAA/new`,
        data: {
          id,
          idOwner: idPersonConnectedAA,
          idUserOwner: idUserConnectedAA,
          nameOwner: namePersonConnectedAA,
          photoOwner: photoPersonConnectedAA,
          badgeOwner: badgePersonConnectedAA,
          countryOwner: countryPersonConnectedAA,
          comment: writeCommentAA,
          //replyComment,
          idPost,
          idOwnerPost,
          idUserOwnerPost,
          connection,
          displayOwnerPost,
          display,
          visible,
          type,
        },
      })
      .then((res) => {

      // 2e requete
      // 2e requete
      // on obtiens les nouvelles donnees
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/commentAA`)
        .then((res) => {
          setApiCommentAA(res.data);
        })
        .catch((err) => { 
          setErrorAA(true);
        });
        }
        deuxiemeReq();
        // 2e requete
        })
        .catch((err) => { 
          setErrorAA(true);
        });
      }
      premiereReq()
      // 1ere requete
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }


  // afficher toute les réponses du commentaire - AA
  // afficher toute les réponses du commentaire - AA
  const [apiReplyAA, setApiReplyAA] = useState([]);

  //creer un id pour chaque réponse (commentaire) publié - AA
  const numbersReplyAA = apiReplyAA.filter((api) => api._id);
  const totalReplyAA = numbersReplyAA.length;

  const createIdReplyAA = totalReplyAA + 1;
  if (createIdReplyAA) { localStorage.setItem("createIdReplyAA", createIdReplyAA) }

  
  // obtenir les réponses liés au commentaire - AA
  const idCommentAA = localStorage.getItem("idCommentAA");
  const filterReplyAA = apiReplyAA.filter((api) => api.idComment === idCommentAA);
  
  // obtenir le nom du proprietaire du commentaire et le commentaire - AA
  const oneCommentAA = apiCommentAA.filter((api) => api._id === idCommentAA);

  // infos owner CommentAA (infos du commentaire)
  const commentAA = oneCommentAA.map((api) => api.comment); // commentaire
  const nameOwnerCommentAA = oneCommentAA.map((api) => api.nameOwner); // nom proprietaire commentaire
  const photoOwnerCommentAA = oneCommentAA.map((api) => api.photoOwner); // photo proprietaire commentaire
  //const badgeOwnerCommentAA = oneCommentAA.map((api) => api.badgeOwner); // badge proprietaire commentaire


  // reponse commentaire - AA
  // reponse commentaire - AA
  const [replyAA, setReplyAA] = useState(false);
  async function ReplyAA() {
    setReplyAA(true);
  }
  //fermer
  async function CloseReplyAA() {
    setReplyAA(false);
  }

  // logique pour enregistrer la reponse - AA
  const [writeReplyAA, setWriteReplyAA] = useState("");

  // logique pour enregistrer la reponse - AA
  async function SaveReplyAA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      // 1ere requete
      // 1ere requete
      // on commente
      async function premiereReq() {
        const id = localStorage.getItem("createIdReplyAA");
        const idPost = localStorage.getItem("idPostAA");
        const idOwnerPost = localStorage.getItem("idOwnerAA");
        const idUserOwnerPost = localStorage.getItem("idUserOwnerAA");
        const idComment = localStorage.getItem("idCommentAA");
        const idOwnerComment = localStorage.getItem("idOwnerCommentAA");
        const idUserOwnerComment = localStorage.getItem("idUserOwnerCommentAA");
        const connection = "1";
        const displayOwnerPost = "1";
        const displayOwnerComment = "1";
        const display = "1";
        const visible = "1";
        const type = "1";

        await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/replyAA/new`,
        data: {
          id,
          idOwner: idPersonConnectedAA,
          idUserOwner: idUserConnectedAA,
          nameOwner: namePersonConnectedAA,
          photoOwner: photoPersonConnectedAA,
          badgeOwner: badgePersonConnectedAA,
          countryOwner: countryPersonConnectedAA,
          reply: writeReplyAA,
          //replyComment,
          idPost,
          idOwnerPost,
          idUserOwnerPost,
          idComment,
          idOwnerComment,
          idUserOwnerComment,
          connection,
          displayOwnerPost,
          displayOwnerComment,
          display,
          visible,
          type,
        },
      })
      .then((res) => {

      // 2e requete
      // 2e requete
      // on obtiens les nouvelles donnees
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/replyAA`)
        .then((res) => {
          setApiReplyAA(res.data);
        })
        .catch((err) => { 
          setErrorAA(true);
        });
        }
        deuxiemeReq();
        // 2e requete
      })
      .catch((err) => { 
        setErrorAA(true);
      });
      }
      premiereReq()
      // 1ere requete
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }

 
  // search (on fait des recherches sur cette page) - AA
  // search (on fait des recherches sur cette page) - AA
  const [searchAA, setSearchAA] = useState(false);
  async function SearchAA() {
    setSearchAA(true);
  }
  async function CloseSearchAA() { //fermer
    setSearchAA(false);
  }

  // plus d'options sur le compte (666 searchAA)
  const [moreOptionsAccount666searchAA, setMoreOptionsAccount666searchAA] = useState(false);
  async function CloseMoreOptionsAccount666searchAA() {
    setMoreOptionsAccount666searchAA(false);
  }
  
  // PageRedirection666SearchAccountAA (la logique ci nous dira quel page ouvrir) - AA
  async function PageRedirection666SearchAccountAA() {
    // page - profil de l'autre
    const ProfilOther = localStorage.getItem("GoToProfilOtherAA");
    if (ProfilOther === "1") { setProfilOtherAA(true); }

    // page - Plus d'options du compte
    const MoreOptions = localStorage.getItem("GoToMoreOptionsAccountAA");
    if (MoreOptions === "1") { setMoreOptionsAccount666searchAA(true); }
  }


  // PageRedirection666SearchPostAA (au niveau de la page de recherche, la logique ci nous dira quel page ouvrir) - AA
  async function PageRedirection666SearchPostAA() {
    // page - profil de l'autre
    const ProfilOther = localStorage.getItem("GoToProfilOtherAA");
    if (ProfilOther === "1") { setProfilOtherAA(true); } 

    // page - voir un post
    const SeePost = localStorage.getItem("GoToPageSeePost666homeAA");
    if (SeePost === "1") { setSeePost666homeAA(true); }
  }

  // logique pour obtenir, afficher les resultats de la recherche - AA
  const [mySearchAA, setMySearchAA] = useState("");
  if (mySearchAA) { localStorage.setItem("searchAA", mySearchAA); }
  const getMySearchAA = localStorage.getItem("searchAA");

  
  // rechercher parmi les comptes 
  const accountFindAA = apiAccountAA.filter((api) => api.nameAccount.includes(getMySearchAA) && api.visible === "1");
  const verifyAccountAA  = accountFindAA.length > 0; // ici les comptes ont ete trouver


  // rechercher parmi les posts 
  const postFindAA = apiPostAA.filter((api) => api.description?.includes(getMySearchAA) && api.visible === "1" && api.displayOther === "1" && api.approved === "1");

  const verifyPostAA  = postFindAA.length > 0; // ici les posts ont ete trouver
  const numberPostAA = postFindAA.length; // ca c'est pour le pluriel


  // rechercher parmi les commentaires 
  const commentFindAA = apiCommentAA.filter((api) => api.comment.includes(getMySearchAA) && api.visible === "1" && api.display === "1");

  const verifyCommentAA = commentFindAA.length > 0; // ici les commentaires ont ete trouver
  const numberCommentAA = commentFindAA.length; // ca c'est pour le pluriel

  // compter le nombre de commentaire qui comporte le mot Nestelia
  //const data = commentaireTrouver.length;


  // tout - onglet
  const [allAA, setAllAA] = useState(true);
  async function AllAA() {
    setAllAA(true);
    setAccountAA(false);
    setPublicationAA(false);
    setVideoSearchAA(false);
    setCommentSearchAA(false);
  }

  // compte - onglet
  const [accountAA, setAccountAA] = useState(false);
  async function AccountAA() {
    setAllAA(false);
    setAccountAA(true);
    setPublicationAA(false);
    setVideoSearchAA(false);
    setCommentSearchAA(false);
  }

  // publication - onglet
  const [publicationAA, setPublicationAA] = useState(false);
  async function PublicationAA() {
    setAllAA(false);
    setAccountAA(false);
    setPublicationAA(true);
    setVideoSearchAA(false);
    setCommentSearchAA(false);
  }

  // videos - onglet
  const [videoSearchAA, setVideoSearchAA] = useState(false);
  async function VideoSearchAA() {
    setAllAA(false);
    setAccountAA(false);
    setPublicationAA(false);
    setVideoSearchAA(true);
    setCommentSearchAA(false);
  }

  // commentaire - onglet
  const [commentSearchAA, setCommentSearchAA] = useState(false);
  async function CommentSearchAA() {
    setAllAA(false);
    setAccountAA(false);
    setPublicationAA(false);
    setVideoSearchAA(false);
    setCommentSearchAA(true);
  }


   // refreshHomeAA (pour actualiser les donnees sur la page d'accueil d'Alrani)
   async function RefreshHomeAA() {
    //on fait ces requetes pour que quand il va cliquer il puisse avoir de nouvelles donnees
    
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

        //2e requete
        //2e requete
        async function deuxiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
          .then((res) => {
            setApiReactionAA(res.data);
  
        //3e requete
        //3e requete
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
          .then((res) => {
            setApiUserAA(res.data);
  
        //4e requete
        //4e requete
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
          .then((res) => {
            setApiAccountAA(res.data);
  
        //5e requete
        //5e requete
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);
  
        //6e requete
        //6e requete
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
            setApiMessageAA(res.data);
  
        //7e requete
        //7e requete
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "RefreshHome (sur la Page Home, il a cliquer sur l'icone Home) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
        });
      }
      premiereReq();
      //1ere requete
    }


  // refreshVideoAA (pour actualiser les donnees sur la page des videos)
  async function RefreshVideoAA() {
    //on fait ces requetes pour que quand il va cliquer il puisse avoir de nouvelles donnees
    
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

        //2e requete
        //2e requete
        async function deuxiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
          .then((res) => {
            setApiReactionAA(res.data);
  
        //3e requete
        //3e requete
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
          .then((res) => {
            setApiUserAA(res.data);
  
        //4e requete
        //4e requete
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
          .then((res) => {
            setApiAccountAA(res.data);

        //5e requete
        //5e requete
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);
  
        //6e requete
        //6e requete
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
            setApiMessageAA(res.data);
  
        //7e requete
        //7e requete
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);
  
        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "RefreshHome (sur la Page Home, il a cliquer sur l'icone Home) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
        });
      }
      premiereReq();
      //1ere requete
    }


  // RefreshConversationAA (pour avoir de nouveaux messages, nouvelles conversations,...)
  async function RefreshConversationAA() {
    setFavoriteAA(true);
    //on fait ces requetes pour que quand il va cliquer il puisse avoir de nouvelles donnees
    
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
      .then((res) => {
        setApiConversationAA(res.data);

      //2e requete
      //2e requete
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
        .then((res) => {
          setApiMessageAA(res.data);

      //3e requete
      //3e requete
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
        .then((res) => {
          setApiUserAA(res.data);

    //4e requete
    //4e requete
    async function quatriemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
      .then((res) => {
        setApiAccountAA(res.data);

    //5e requete
    //5e requete
    async function cinquiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

    //6e requete
    //6e requete
    async function sixiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        setApiReactionAA(res.data);

        //7e requete
        //7e requete
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "RefreshMessage (sur la Page Message, il a cliquer sur l'icone Message) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
        });
      }
      premiereReq();
      //1ere requete
    }

  
  // videos- AA
  const [videoAA, setVideoAA] = useState(false);
  async function VideoAA() {
    setProfilAA(false);
    setConversationAA(false);
    setVideoAA(true);

    //on fait ces requetes pour que qu'on il va cliquer il puisse avoir de nouvelles donnees
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

    //2e requete
    //2e requete
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        setApiReactionAA(res.data);

    //3e requete
    //3e requete
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);

        //4e requete
        //4e requete
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
          .then((res) => {
            setApiAccountAA(res.data);

        //5e requete
        //5e requete
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/followerAA`)
          .then((res) => {
            setApiFollowerAA(res.data);

        //6e requete
        //6e requete
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
          .then((res) => {
  
        //7e requete
        //7e requete
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);
  
        //8e requete
        //8e requete
        async function huitiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
            setApiMessageAA(res.data);
  
        //9e requete
        //9e requete
        async function neuviemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //10e requete
        //10e requete
        // on obtiens la localisation de l'utilisateur
        async function dixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //11e requete
        //11e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function onziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Page Vidéos (il est sur la Page Vidéos) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //12e requete
        //12e requete
        // on enregistre la date de derniere connexion
        async function douziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          }
          douziemeReq();
          //12e requete
          })
          }
          onziemeReq();
          //11e requete
          })
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
      });
    }
    premiereReq();
    //1ere requete
  }
  async function CloseVideoAA() { //fermer
    setVideoAA(false);
  }

  // page d'accueil - AA
  // page d'accueil - AA
  const [homeAA, setHomeAA] = useState(false);
  async function HomeAA() {
    setHomeAA(true);

    //on fait ces requetes pour que qu'on il va cliquer il puisse avoir de nouvelles donnees
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

    //2e requete
    //2e requete
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        setApiReactionAA(res.data);

    //3e requete
    //3e requete
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);

    //4e requete
    //4e requete
    async function quatriemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
      .then((res) => {
        setApiAccountAA(res.data);

        //5e requete
        //5e requete
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/followerAA`)
          .then((res) => {
            setApiFollowerAA(res.data);

        //6e requete
        //6e requete
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
          .then((res) => {
  
        //7e requete
        //7e requete
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);

        //8e requete
        //8e requete
        async function huitiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
            setApiMessageAA(res.data);

        //9e requete
        //9e requete
        async function neuviemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //10e requete
        //10e requete
        // on obtiens la localisation de l'utilisateur
        async function dixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //11e requete
        //11e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function onziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Page d'Accueil d'Alrani (il etait sur un onglet: message, profil,... il a cliquer sur l'icone Home pour aller sur la Page d'Accueil d'Alrani) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //12e requete
        //12e requete
        // on enregistre la date de derniere connexion
        async function douziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          }
          douziemeReq();
          //12e requete
          })
          }
          onziemeReq();
          //11e requete
          })
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
      });
    }
    premiereReq();
    //1ere requete
  }
  async function CloseHomeAA() { //fermer
    setHomeAA(false);
    setTelephoneVirtuel(true);
  }


  // code qui ouvre la page de connexion - AA
  async function OuvrirPageConnexionAA() {
    setHomeAA(false);
    setConnexionPageAA(true);
  }


  //PageRedirection666conversationAA
  async function PageRedirection666conversationAA() {
    // on affiche la page du message
    const pageMessage = localStorage.getItem("GoToPageMessageAA");
    if (pageMessage === "1") { 
      setMessageAA(true);
      localStorage.removeItem("GoToSeePhoto666ChildApiMessageAA");

      //logique pour desactiver le signe du nouveau message - AA
      async function DesactivateNewMessageAA() {
          const filterUser = apiUserAA.filter((api) => api._id === idPersonConnectedAA);
          const newMessage = filterUser.map((api) => api.newMessage);
        if (newMessage === "1") { //etant donné que la personne a cliquer sur la conversation alors on desactive le signe du nouveau message

          //1ere requete
          //1ere requete
          // on desactive le signe du nouveau message
          async function premiereReq() {
            const newMessage = "0";
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
              data: {
                newMessage,
              },
            })
            .then((res) => {
              
            //2e requete
            //2e requete
            // on obtiens de nouvelles donnees
            async function deuxiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
              .then((res) => {
                setApiConversationAA(res.data);
              })
            }
            deuxiemeReq();
            //2e requete
            })
          }
          premiereReq();
          //1ere requete
        } //if (newMessage === "1")
      } //async function DesactivateNewMessageAA()
      DesactivateNewMessageAA();
    } //if (pageMessage === "1")

  }


  // conversations - AA
  // on affiche les conversations
  const [conversationAA, setConversationAA] = useState(false);
  async function ConversationAA() {
    setVideoAA(false);
    setProfilAA(false);
    setRencontreAA(false);
    setConversationAA(true);

    //avoir de nouvelles donnees lorsqu'on clique sur l'onglet Message
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
      .then((res) => {
        setApiConversationAA(res.data);

    //2e requete
    //2e requete
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
      .then((res) => {
        setApiMessageAA(res.data);

    //3e requete
    //3e requete
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);

    //4e requete
    //4e requete
    async function quatriemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
      .then((res) => {
        setApiAccountAA(res.data);

    //5e requete
    //5e requete
    async function cinquiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

    //6e requete
    //6e requete
    async function sixiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        setApiReactionAA(res.data);

    //7e requete
    //7e requete
    async function septiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
      .then((res) => {

    //8e requete
    //8e requete
    async function huitiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/followerAA`)
      .then((res) => {
        setApiFollowerAA(res.data);

        //9e requete
        //9e requete
        async function neuviemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //10e requete
        //10e requete
        // on obtiens la localisation de l'utilisateur
        async function dixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //11e requete
        //11e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function onziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Page Conversation (il etait sur un onglet: accueil, profil,... il a cliquer sur l'icone Message pour aller sur la Page Conversation)";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //12e requete
        //12e requete
        // on enregistre la date de derniere connexion
        async function douziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          douziemeReq();
          //12e requete
          });
          }
          onziemeReq();
          //11e requete
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
        });
      }
      premiereReq();
      //1ere requete
  }
  async function CloseConversationAA() {  //fermer
    setHomeAA(true);
    setConversationAA(false);
  }


  async function CloseConversationGoToVirtualPhoneAA() {
    setConversationAA(false);
    setHomeAA(false);
    setTelephoneVirtuel(true);
  }


 /* la page ci va permettre de choisir le moyen de paiement pour payer la publiciter 
  au niveau de personnaliser Publiciter.
  la page en question c'est une bottom, quand on clique sur acheter la publiciter, ca
  s'affiche en bas, ainsi on pourra choisir le moyen de paiement qui nous convient pour 
  acheter la publiciter */
  const [moyenDePaiementPP, setMoyenDePaiementPP] = useState(false);
  async function MoyenDePaiementPP() {
    setMoyenDePaiementPP(!moyenDePaiementPP);
  }

  //on affiche publiciter (c'est la page qui va permettre aux entreprises de gerer leur publiciter)
  /* const [publiciterPage, setPubliciterPage] = useState(false);
  async function PubliciterPage() {
    setPubliciterPage(!publiciterPage);
  } */

  //on affiche booster la page (sur cette page, on va afficher les modeles que la personne va choisir ensuite il pourra booster sa page)
  const [boosterPage, setBoosterPage] = useState(false);
  /* async function BoosterPage() {
    setBoosterPage(true);
  } */
  async function CloseBoosterPage() { //fermer
    setBoosterPage(false);
  }
 
  // on affiche la page qui va permettre de personnaliser la publiciter pour bien cibler les clients 
  const [personnaliserPubliciter, setPersonnaliserPubliciter] = useState(false);
  async function PersonnaliserPubliciter() {
    setPersonnaliserPubliciter(!personnaliserPubliciter);
  }

  // publicité débuté (message de success)
  const [adSuccessAA, setAdSuccessAA] = useState(false);
  async function CloseAdSuccessAA() {
    setPersonnaliserPubliciter(false);
    setMoyenDePaiementPP(false);
    setBoosterPage(false);
    //setPubliciterPage(false);
    setAdSuccessAA(false);
  }

  const [adSuccess2AA, setAdSuccess2AA] = useState(false);
  async function CloseAdSuccess2AA() {
    setAdSuccess2AA(false);
  }
  

  // logique pour booster une publication
  async function BoostPostAA() {
    
    //1ere requete
    //1ere requete
    // on verifie si le solde alrani pay est suffisant
    async function premiereReq() {
      setOpacity(true);
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);
        const api = res.data;
        const price = "35000";

        const filterClient = api.filter((api) => api._id === idUserConnectedAA);
    
        const oldBalanceAlraniPay = filterClient.map((api) => api.balanceAlraniPay); // ancien solde alrani pay
        if (oldBalanceAlraniPay) { localStorage.setItem("oldBalanceAlraniPay", oldBalanceAlraniPay); }
            
        // calcul du nouveau solde alrani pay
        const newBalanceAlraniPay = parseInt(oldBalanceAlraniPay) - parseInt(price)
        if (newBalanceAlraniPay) { localStorage.setItem("newBalanceAlraniPay", newBalanceAlraniPay); }

      if (newBalanceAlraniPay > -1) {
        //dans  ce cas: solde alrani pay suffisant (on peut continuer pour débuté la publicité)
        console.log("solde alrani pay suffisant (on peut continuer pour débuté la publicité)");
    
        //2e requete
        //2e requete
        // on debite le solde de l'utilisateur (nouveau solde alrani pay)
        async function deuxiemeReq() {
          const balanceAlraniPay = localStorage.getItem("newBalanceAlraniPay");
          const idUserConnectedAA = localStorage.getItem("idUserConnectedAA");
          await axios({ 
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idUserConnectedAA}`,
            data: {
              balanceAlraniPay,
            },
          })
          .then((res) => {
          // solde de l'utilisateur débité (on débute la publicité)
          //console.log("solde de l'utilisateur débité (on débute la publicité)");

        //3e requete
        //3e requete
        // on débute la publicité
        async function troisiemeReq() {
          const idPost = localStorage.getItem("idPostAA");
          const home = "1";
          const ad = "1";
          await axios({ 
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idPost}`,
            data: {
              home,
              ad,
            },
          })
          .then((res) => {
          // publicité débuté !
          //console.log("publicité débuté !");

        //4e requete
        //4e requete
        // on met le dernier post a 0 (c'est pour eviter que lorsqu'il va publier, la publicité se retire de la page d'accueil)
        async function quatriemeReq() {
          const lastPost = "0";
          await axios({ 
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              lastPost,
            },
          })
          .then((res) => {

        //5e requete
        //5e requete
        // on obtiens de nouvelles donnees - apiUserAA
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
          .then((res) => {
            setApiUserAA(res.data);

        //6e requete
        //6e requete
        // on obtiens de nouvelles donnees - apiPostAA
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
          .then((res) => {
            setApiPostAA(res.data);

        //7e requete
        //7e requete
        // on obtiens de nouvelles donnees - apiAccountAA
        async function septiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
          .then((res) => {
            setApiAccountAA(res.data);

            setAdSuccessAA(true);
            setOpacity(false);

            //message de succes
            setAdSuccess2AA(true);

            //on le fait disparaitre
            async function CloseAdSuccess() {
              setAdSuccess2AA(false);
            }
            setTimeout(CloseAdSuccess, 1400);
          })
          .catch((err) => {
            setOpacity(false);
            setErrorAA(true);
          })
        }
        septiemeReq()
        //7e requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorAA(true);
        })
        }
        sixiemeReq()
        //6e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorAA(true);
          })
          }
          cinquiemeReq()
          //5e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorAA(true);
          })
          }
          quatriemeReq()
          //4e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorAA(true);
          })
          }
          troisiemeReq()
          //3e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErrorAA(true);
          })
          }
          deuxiemeReq()
          //2e requete
          } else {
            //dans  ce cas: solde alrani pay insuffisant (impossible de débuter la publicité)
            //console.log("solde alrani pay insuffisant (impossible de débuter la publicité)");
            setOpacity(false);
            setErrorAlraniPayAA(true);
          }
          //if (newBalanceAlraniPay > -1) {
        })
        .catch((err) => {
          setOpacity(false);
          setErrorAA(true);
        })
      }
      premiereReq()
      //1ere requete
  }



  const nameFA = localStorage.getItem("nameFA");
  const photoFA = localStorage.getItem("photoFA");
  const badgeFA = localStorage.getItem("badgeFA");
  const phoneNumberFA = localStorage.getItem("phoneNumberFA");
  const nameGroupFA = localStorage.getItem("nameGroupFA");
  const photoGroupFA = localStorage.getItem("photoGroupFA");
  //const popularityFA = localStorage.getItem("popularityFA");
  //const idConversationFA = localStorage.getItem("idConversation");
  const message = localStorage.getItem("message"); 
  const type = localStorage.getItem("type"); 
  const urlPhoto = localStorage.getItem("urlPhoto"); 
  //const urlVideo = localStorage.getItem("urlVideo"); 
  const urlPhotoreq = localStorage.getItem("urlPhotoreq");
  const urlVideoreq = localStorage.getItem("urlVideoreq");
	
	const [onlineUsers, setOnlineUsers] = useState([]); // pour Écouter (ou Surveiller) les utilisateurs en ligne
	const [idreq, setId] = useState(null);
	const [idPersonConnectedFA, setIdPersonConnectedFA] = useState(localStorage.getItem("idPersonConnectedFA"));
	const [idCompteConnecter, setIdCompteConnecter] = useState(idPersonConnectedFA);
	const [idExpediteur, setIdExpediteur] = useState(idPersonConnectedFA);
	const [idCommentaire, setIdCommentaire] = useState(null);
	const [idConversation, setIdConversation] = useState(null);
	const [idDestinataire, setIdDestinataire] = useState(null);	
	const [idProprietaireCommentaire, setIdProprietaireCommentaire] = useState(null);
	const [idPost, setIdPost] = useState(null);
	const [idProprietairePost, setIdProprietairePost] = useState(null);
	const [idCompte, setIdCompte] = useState(null);
	const [idContact, setIdContact] = useState(null);
	const [idAnnonce, setIdAnnonce] = useState(null);
	const [urlVideo, setUrlVideo] = useState(null);
	
	console.log("idDestinataire", idDestinataire); 
	console.log("idConversation", idConversation); 
	
	/* console.log("idCompte", idCompte);
	console.log("idPersonConnectedFA", idPersonConnectedFA);
	console.log("idExpediteur", idExpediteur);
	console.log("idContact", idContact); 
	console.log("idConversation", idConversation); 
	console.log("idAnnonce", idAnnonce); */


// jai mis le useEffect pour quil utilise dabord idPersonConnectedFA qui est dans sessionStorage, et lavantage de mettre sessionStorage comme prioritaire, cest que si idPersonConnectedFA change, ca reste dans cet onglet, ca ne change pas dans les autres onglets

/*useEffect(() => {
  // Au chargement de la page
  const idSession = sessionStorage.getItem("idPersonConnectedFA");
  const idLocal = localStorage.getItem("idPersonConnectedFA");

  if (idSession) {
    setIdPersonConnectedFA(idSession);
    setIdExpediteur(idSession);
  } else if (idLocal) {
    // Si sessionStorage est vide, on récupère idPersonConnectedFA dans localStorage et on le met dans sessionStorage
    sessionStorage.setItem("idPersonConnectedFA", idLocal);
    setIdPersonConnectedFA(idLocal);
    setIdExpediteur(idLocal);
  }
}, []); */




  //requete pour obtenir tout les donnees (messages, videos, comptes, ..)
  const [apiMessageFA, setApiMessageFA] = useState([]);
  
  /* // useEffect(() => {
	async function fetchData() {
		await ObtenirLesDonneesFA();
	}
	fetchData();
  }, []); */
  

  const idUserConnectedFA = localStorage.getItem("idUserConnectedFA");
  //const idPersonConnectedFA = localStorage.getItem("idPersonConnectedFA");
  const idGroupFA = localStorage.getItem("idGroupFA");

  const idAccount = localStorage.getItem("idPersonConnectedFA");
  const idOther = localStorage.getItem("idAccountChef");
  const idAccountChefFA = localStorage.getItem("idAccountChef");


  // filtre pour obtenir quelques infos de l'utilisateur connecter
  const userConnectedFA = apiMessageFA.filter((api) => api._id === idUserConnectedFA);
  const getblockFA = userConnectedFA.map((api) => api.block); // block
  const verifyData = userConnectedFA.length > 0; // verifier si les données sont disponibles

  if (verifyData) { //j'ai ajouté le if car cette requette etait faite avant que l'idUserConnectedFA ne soit présent dans le localStorage et supprimait la valeur qui était enregistré dans le localstorage
    localStorage.setItem("blockFA", getblockFA);
  }

    // filtre pour obtenir les infos de la personne connecté
    const accountConnectedFA = apiMessageFA.filter((api) => api._id === idPersonConnectedFA);

    const getName = accountConnectedFA.map((api) => api.nameAccount); // name
    const getPhoto = accountConnectedFA.map((api) => api.photoProfile); // photoProfile
    const getBadge = accountConnectedFA.map((api) => api.badge); // badge
    const getPhoneNumber = accountConnectedFA.map((api) => api.phoneNumber); // phoneNumber
    const getidGroup = accountConnectedFA.map((api) => api.idGroup); // idGroup
    const getNameGroup = accountConnectedFA.map((api) => api.nameGroup); // nameGroup
    const getPhotoGroup = accountConnectedFA.map((api) => api.photoGroup); // photoGroup
    const getPopularity = accountConnectedFA.map((api) => api.popularity); // popularité

    if (verifyData) {
      localStorage.setItem("nameFA", getName);
      localStorage.setItem("photoFA", getPhoto);
      localStorage.setItem("badgeFA", getBadge);
      localStorage.setItem("phoneNumberFA", getPhoneNumber);
      localStorage.setItem("idGroupFA", getidGroup);
	  //localStorage.setItem("idGroupChef", getidGroup); 
	  //localStorage.setItem("idAccountChef", idPersonConnectedFA); 
      localStorage.setItem("nameGroupFA", getNameGroup);
      localStorage.setItem("photoGroupFA", getPhotoGroup);
      localStorage.setItem("popularityFA", getPopularity);
    } //if (idPersonConnectedFA)

    
    // filtre pour afficher les infos de l'autre - FA
    const accountOther = apiMessageFA.filter((api) => api._id === idAccountChefFA);
    const nameOther = accountOther.map((api) => api.nameAccount); // name
    if (nameOther) { localStorage.setItem("nameOther", nameOther); }

    const photoOther = accountOther.map((api) => api.photoProfile); // photo
    if (photoOther) { localStorage.setItem("photoOther", photoOther); }

    const badgeOther = accountOther.map((api) => api.badge); // badge
    if (badgeOther) { localStorage.setItem("badgeOther", badgeOther); }

    const onlineOther = accountOther.map((api) => api.online); // online
    if (onlineOther) { localStorage.setItem("onlineOther", onlineOther); }

    const getIdGroupOther = accountOther.map((api) => api.idGroup); // idGroupOther
    if (getIdGroupOther) { localStorage.setItem("idGroupOther", getIdGroupOther); }

    const getNameGroupOther = accountOther.map((api) => api.nameGroup); // nameGroupOther
    if (getNameGroupOther) { localStorage.setItem("nameGroupOther", getNameGroupOther); }

    const getPhotoGroupOther = accountOther.map((api) => api.photoGroup); // photoGroupOther
    if (getPhotoGroupOther) { localStorage.setItem("photoGroupOther", getPhotoGroupOther); }

    const popularityOther = accountOther.map((api) => api.popularity); // popularité

    const getfollow = apiMessageFA.filter((api) => api.follow === "1" && api.idOther === idAccount && api.idAccount === idPersonConnectedFA && api.type === "50"); 
    const follow = getfollow.length > 0; //verifier s'il est déjà abonné

    const idGroupOther = localStorage.getItem("idGroupChef");
    const idMessageEpingler = localStorage.getItem("idMessageEpingler");

    const getInfosGroupOther = apiMessageFA.filter((api) => api._id === idGroupOther); 
    const nameGroupOther = getInfosGroupOther.map((api) => api.nameGroup);
    const photoGroupOther = getInfosGroupOther.map((api) => api.photoGroup);
    const visitOther = getInfosGroupOther.map((api) => api.visit);
    const clicOther = getInfosGroupOther.map((api) => api.clic);

    const getidMessageEpingler = getInfosGroupOther.map((api) => api.idMessageEpingler); // idMessageEpingler
    if (getidMessageEpingler) { localStorage.setItem("idMessageEpingler", getidMessageEpingler); }
 
  //filtre pour affiher les infos de l'autre
  const filter66profilOtherFA = apiMessageFA.sort((a, b) => b.id - a.id);

  // filtre pour afficher le message epingler
  const filterMessageEpinglerFA = apiMessageFA.filter((api) => api.epingler === "1" && api._id === idMessageEpingler);
  const messageEpinglerFA = filterMessageEpinglerFA.map((api) => api.message); // messageEpingler
  


  //filtre pour afficher les comptes les plus populaires sur Florinato
  const filterPopularityAccountsFA = apiMessageFA.filter((api) => api.top ==="1");

  const filterTopFA = apiMessageFA.filter((api) => api.top ==="1" && api.idUser === idUserConnectedFA);
  const filterAdminFA = apiMessageFA.filter((api) => api.admin ==="1" && api.idUser === idUserConnectedFA);
  const filterAdminFlorinatoFA = apiMessageFA.filter((api) => api.adminFlorinato ==="1" && api.idUser === idUserConnectedFA);
    
	
  //filtre pour afficher les commentaires d'un post (video, photo, ...)
  const filterCommentaireFA = apiMessageFA.filter((api) => api.type ==="25" && api.idPost === idPost);

  // effectuer une recherche - FA  
  const [rechercherUnCompteFA, setRechercherUnCompteFA] = useState("");
  const [rechercherMonCompteFA, setRechercherMonCompteFA] = useState("");
  
  const [rechercherUneVideoFA, setRechercherUneVideoFA] = useState("");
  const [rechercherMaVideoFA, setRechercherMaVideoFA] = useState("");


			
const annoncesSource = useMemo(() => apiMessageFA.filter(api => api.type === "60"), [apiMessageFA] ); // toutes les annonces
const {
	donneesAffichees_byClic: dataAnnoncesFA, 
	infosAnnonce_by_id: dataAnnoncesById, 
	//setToutesDonnees: setToutesDonneesAnnonces,
	gererScroll: gererScrollAnnonces 
} = useScrollIndexedDB({
	nomStockage: "annonces", 
	donnees:annoncesSource, 
	idAnnonce,
});


// filtre pour obtenir les infos de l'annonce - FA
const dataAnnonce = dataAnnoncesById?.[0] ?? {};
const texteAnnonceFA = dataAnnonce.texte || "";



const videosSource = useMemo(() => apiMessageFA.filter(api => api.type === "3"), [apiMessageFA] ); // toutes les vidéos
const { 
	donneesAffichees_byClic: dataVideoFAbyClic, 
	donneesAffichees_byClic_idAccount: dataVideoByIdCompte, 
	donneesAffichees_byClic_idAccountConnecter: dataVideoByIdCompteConnecter, 
	donneesAffichees_recent_idAccount: dataVideoRecenteByIdCompte, 
	donneesAffichees_recent_idAccountConnecter: dataVideoRecenteByIdCompteConnecter, 
	
	//toutesDonnees_idAccount: videoByIdAccount, // obtenir toutes les videos qui contient cet idAccount (ici , ideale pour la recherche)
	toutesDonnees_all: toutesVideos, 	
	infosPost_by_id: infosPostById,
	
	toutesVideoPar_idAccount: toutesVideoParIdAccount,
	toutesVideoCompteConnecterPar_idAccount : toutesVideoCompteConnecterParIdAccount,
	
	setToutesDonnees:setToutesDonneesVideos, chargerPlus,
	gererScroll 
} = useScrollIndexedDB({ 
	nomStockage: "videos", 
	donnees:videosSource, 
	idCompte,
	idCompteConnecter,
	idProprietairePost,
	idPost,
	rechercherMaVideo: rechercherMaVideoFA,
	rechercherUneVideo: rechercherUneVideoFA,
});


// scroller
const scrollX = useScrollInfini(chargerPlus, 'x'); // scrollHorizontal , overflow-x 
const scrollY = useScrollInfini(chargerPlus, 'y'); // scroll Vertical


//console.log("dataVideoFAbyClic", dataVideoFAbyClic);
//console.log("toutesVideos", toutesVideos);

const listVideoFA = useMemo(() => rechercherAvecFuse({ data:toutesVideos, search:rechercherUneVideoFA, keys:["message"] }), [toutesVideos, rechercherUneVideoFA] );
//const videosRecherchees = useMemo(() => rechercherAvecFuse({ data:videosR, search:maRechercheVideoFA, keys:["message"] }), [videosR, maRechercheVideoFA] );
//const listVideoFA = maRechercheVideoFA ? videosRecherchees.slice(0, dataVideoFA.length) : [];


const listMesVideosFA = useMemo(() => rechercherAvecFuse({ data:toutesVideoCompteConnecterParIdAccount, search:rechercherMaVideoFA, keys: ["message"] }), 
[toutesVideoCompteConnecterParIdAccount, rechercherMaVideoFA]);
//const mesVideosRecherchees = useMemo(() => rechercherAvecFuse({ data:mesVideosR, search:maRechercheVideoFA, keys: ["message"] }), [mesVideosR, maRechercheVideoFA] );
//const listMesVideosFA = maRechercheVideoFA ? mesVideosRecherchees.slice(0, dataMesVideosFA.length) : [];


const listTesVideosFA = useMemo(() => rechercherAvecFuse({ data:toutesVideoParIdAccount, search:rechercherMaVideoFA, keys: ["message"] }), 
[toutesVideoParIdAccount, rechercherMaVideoFA]);


// filtre pour obtenir les infos du post (video, photo, ..) - FA
const clicFA = infosPostById.map((api) => api.clic); // clic
const titreFA = infosPostById.map((api) => api.message); // message
const photoCouvertureVideo = infosPostById.map((api) => api.urlPhoto);


// visites
const visitesSource = useMemo(() => apiMessageFA.filter(api => api.type === "200"), [apiMessageFA] ); // toutes mes visites
const { donneesAffichees_idCompteConnecter:dataMesVisitesFA, gererScroll:gererScrollVisites } = useScrollIndexedDB({ nomStockage: "visites", donnees:visitesSource });



// comptes
const comptesSource = useMemo(() => apiMessageFA.filter(api => api.type === "10"), [apiMessageFA] ); // toutes mes comptes
const { 
	donneesAffichees:dataComptesFA, 
	donneesAffichees_idUser:dataMesComptesFA, 
	donneesAffichees_CompteEnLigne: comptesOnline,
	
	toutesDonnees_idUser: toutMesComptes, 
	toutesDonnees: toutComptes, 
	infosCompte_by_id: infosCompteById, 
	infosCompte_by_id_2: infosCompteById2,
	infosCompteConnecter_by_id: infosCompteConnecterById, 
	
	setToutesDonnees: setToutesDonneesComptes,
	gererScroll: gererScrollComptes 
} = useScrollIndexedDB({
	nomStockage: "comptes", 
	donnees:comptesSource, 
	onlineUsers,
	idCompte,
	idCompte2: idContact,
	idCompteConnecter,
	rechercherUnCompte: rechercherUnCompteFA,
	rechercherMonCompte: rechercherMonCompteFA,
});



// filtre pour obtenir les infos du compte - FA 
const infosCompte = infosCompteById?.[0] ?? {};
const photoTonCompteFA = infosCompte.photoProfile || photoBlanche;
const taDerniereConnexion = infosCompte.derniereConnexion;


// infos du compte connecté
const infosCompteConnecter = infosCompteConnecterById?.[0] ?? {};
const photoCompteConnecter = infosCompteConnecter.photoProfile || photoBlanche;
const nomCompteConnecter = infosCompteConnecter.nameAccount || "";
const populariteCompteConnecter = infosCompteConnecter.popularity || "";



const filtrerUnCompteRechercher = useMemo(() => toutComptes.filter(api => api.nameAccount), [toutComptes] );
const listAccountFA = useMemo(() => rechercherAvecFuse({ data:filtrerUnCompteRechercher, search:rechercherUnCompteFA, keys: ["nameAccount"] }), [filtrerUnCompteRechercher, rechercherUnCompteFA] );

const filtrerMonCompteRechercher = useMemo(() => toutMesComptes.filter(api => api.nameAccount), [toutMesComptes] );
const listMesComptesFA = useMemo(() => rechercherAvecFuse({ data:filtrerMonCompteRechercher, search:rechercherMonCompteFA, keys: ["nameAccount"] }), [filtrerMonCompteRechercher, rechercherMonCompteFA] );


// follower
const followersSource = useMemo(() => apiMessageFA.filter(api => api.type === "50"), [apiMessageFA] ); 
const { donneesAffichees_account_other:dataFollowers, gererScroll: gererScrollFollowers } = useScrollIndexedDB({ nomStockage: "followers", donnees:followersSource });


// conversations
const conversationsSource = useMemo(() => apiMessageFA.filter(api => api.type === "30"), [apiMessageFA] ); 

const {
	donneesAffichees_account_other: dataConversations, 
	toutesDonnees: toutConversations,
	setToutesDonnees: setToutesDonneesConversation,
	gererScroll: gererScrollConversations 
} = useScrollIndexedDB({ 
	nomStockage: "conversations", 
	donnees:conversationsSource,
	idCompteConnecter
}); 


// messages
const messagesSource = useMemo(() => apiMessageFA.filter(api => api.type === "1"), [apiMessageFA] ); // toutes mes messages
const { donneesAffichees_messages:dataMessagesFA, toutesDonnees:toutMessages, 
	setToutesDonnees: setToutesDonneesMessage, 
	//setIdConversationtrans: idConversation, 
	gererScroll:gererScrollMessages 
} = useScrollIndexedDB({
	nomStockage: "messages", 
	donnees:messagesSource, 
	idConversation
});

console.log("dataMessagesFA", dataMessagesFA);


  
const socketRef = useRef(null); // Socket
//const [onlineUsers, setOnlineUsers] = useState([]); // Écouter les utilisateurs en ligne

useEffect(() => {
	// S'il ya une socket existante, déconnecte-la proprement
    if (socketRef.current) {
      socketRef.current.disconnect();
    }
  
	// Crée une nouvelle socket
    socketRef.current = io("https://api2florinato.onrender.com", {
      transports: ["websocket"],
      reconnection: true,
    });

  const socket = socketRef.current;
  
	// Lors de la connexion . À CHAQUE connexion / reconnexion
	// Écoute la connexion et renvoie le bon idPersonConnectedFA
  socket.on("connect", () => {
    console.log("Socket connecté :", socket.id);
    if (idCompteConnecter) {
      socket.emit("user:online", idCompteConnecter);
    }
  });

  // Envoie l'ID si changé
  if (idCompteConnecter) {
    socket.emit("user:online", idCompteConnecter); // Quand l’utilisateur est connecté , on envoie ca pour signaler quil est en ligne
  } 

	// Écoute les utilisateurs en ligne . Réception de la liste des utilisateurs en ligne 
  socket.on("users:online", (users) => {
    setOnlineUsers(users);
  }); 
  
	// Reçoit les message
 /* socket.on("receiveMessage", (msg) => {
    setApiMessageFA(prev => [msg, ...prev]);
  });*/
  
  socket.on("message:misAJour", async (element) => {
    console.log("🔥 SOCKET RECU - put:", element);
    if (element.type === "3") { setToutesDonneesVideos(prev => prev.map(m => m._id === element._id ? element : m)); } // videos
    if (element.type === "10") { setToutesDonneesComptes(prev => prev.map(m => m._id === element._id ? element : m)); } // comptes
    if (element.type === "60") { setApiMessageFA(prev => prev.map(m => m._id === element._id ? element : m)); } // annonces
  });
  
  
  socket.on("receiveMessage", async (data) => {
    console.log("🔥 SOCKET RECU - post:", data);
    if (data.type === "3") { setToutesDonneesVideos(prev => [data, ...prev]); } // videos
    if (data.type === "10") { setToutesDonneesComptes(prev => [data, ...prev]); } // comptes
    if (data.type === "60") { setApiMessageFA(prev => [data, ...prev]); } // annonces
	if (data.type === "1") { console.log("nouveau message", data); setToutesDonneesMessage(prev => [data, ...prev]); } // message
    if (data.type === "30") { console.log("nouveau conversation", data); setToutesDonneesConversation(prev => [data, ...prev]); } // conversation
 });
    
  
  // Nettoyage
  return () => {
    socket.off("connect");
    socket.off("users:online");
    socket.off("message:misAJour");
    socket.off("receiveMessage");
	socket.disconnect();
  };
}, [idCompteConnecter]); // 🔹 Dépendance ici pour réémettre à chaque changement


// Array.isArray(onlineUsers) , vérifie qpue onlineUsers est un tableau. Si ce n’est pas un tableau, destinataireOnline sera false au lieu de planter le site. Si c’est bien un tableau, .includes(idDestinataire) s’exécute normalement. C’est tout ce qu’il faut pour réparer le problème de includes sans toucher à la logique des utilisateurs en ligne.
const destinataireOnline = (onlineUsers && Array.isArray(onlineUsers)) ? onlineUsers.includes(idDestinataire) : false;


  // Créer une map pour accéder rapidement aux profils par id
  const { filterFA, profilMap } = useMemo(() => {
	  //const sorted = [...toutComptes].sort((a, b) => b.id - a.id);
	  const sorted = [...toutComptes];
	  const map = {};

	  sorted.forEach(item => {
		if (item.type === "10") {
		  map[item._id] = item;
		}
	  });

	  return { filterFA: sorted, profilMap: map };
}, [toutComptes]); 



// On crée un map de messages récents par conversation
const messageMap = useMemo(() => {
  const map = {};

  toutMessages.forEach(msg => {
    if (msg.type !== "1") return; // on ne prend que les messages ( type=1 )

    const idConv = msg.idConversation;
    const exist = map[idConv];

    // si pas encore défini ou si message plus récent, on met à jour
    if (!exist || new Date(msg.createdAt) > new Date(exist.createdAt)) {
      map[idConv] = msg;
    }
  });

  return map;
}, [toutMessages]);

/*
	useMemo permet de recalculer messageMap uniquement quand toutMessages change, pas à chaque render → performant.
	map[idConv] = msg → on garde toujours le message le plus récent pour chaque conversation.
	À la fin, messageMap ressemble à ça

	{
	  "idConv1": { _id: "...", message: "Salut", createdAt: "2026-01-30" },
	  "idConv2": { _id: "...", message: "Hello", createdAt: "2026-01-29" },
	  ...
	}
	
*/


const conversationsTrierParDate = useMemo(() => {
  return [...dataConversations]
  .sort((a, b) => {
    const msgA = messageMap[a._id];
    const msgB = messageMap[b._id];

    if (!msgA && !msgB) return 0; // Les deux conversations n’ont aucun message . on ne change pas leur ordre
    if (!msgA) return 1; // msgA n’a pas de message . msgB en a peut-être . msgA descend en bas
    if (!msgB) return -1; // msgB n’a pas de message ; msgA en a un ; msgA monte en haut

    return new Date(msgB.createdAt) - new Date(msgA.createdAt); // la plus récente en haut
	/* Compare les dates
	la plus récente doit être au-dessus
	Si :
	msgB est plus récent → B passe avant A
	msgA est plus récent → A passe avant B */
  })
}, [dataConversations, messageMap]);

	/* RÉSUMÉ SIMPLE
	a/b → conversations
	msgA → dernier message de la conversation A
	msgB → dernier message de la conversation B
	on compare leurs dates
	la conversation avec le message le plus récent monte en haut */

const dataConversationFA = useMemo(() => { return [...conversationsTrierParDate, ...dataFollowers] }, [conversationsTrierParDate, dataFollowers]);


   // filtre pour obtenir tout les favoris
  const allMessageFA = apiMessageFA.filter((api) => api.idUser === idUserConnectedFA);
  const allFavoriteAA = apiMessageFA.filter((api) => api.idUser === idUserConnectedFA && api.type === "20");
  

  //on affiche la liste des numeros virtuels délivrés
  const filter66delivrerNumeroVirtuelAf = apiMessageFA.filter((api) => api.izocashApp === "1" && api.visible === "1" && api.type === "1").sort((a, b) => b.id - a.id);

  //on affiche la liste des contacts 
  //const filter66envoyerContactFA = apiMessageFA.filter((api) => api.florinatoApp === "1" && api.visible === "1" && api.type === "10").sort((a, b) => b.id - a.id);


  // verifier s'il existe une conversation avec l'autre utilisateur
  // on verifie en fonction de l'idAccount
  // le truc, le code ci-dessous je navais pas commenter ca, donc je ne pas dabord si je peux lui donner les commentaires ci-dessus


// on verifie si ya deja une conversation entre les 2 utilisateurs
const conversationExistante = useMemo(() => {	
  if (!idCompteConnecter || !idDestinataire) return null;

  return toutConversations.find(api =>
    api.type === "30" &&
    (
      (api.idAccount === idCompteConnecter && api.idOther === idDestinataire) ||
      (api.idAccount === idDestinataire && api.idOther === idCompteConnecter)
    )
  );

}, [toutConversations, idCompteConnecter, idDestinataire]);

const verifyConversation = !!conversationExistante;
console.log("conversationExistante", conversationExistante); 


useEffect(() => {
  if (conversationExistante?._id) {
    setIdConversation(conversationExistante._id); 
  } else {
    setIdConversation(null);
  }
}, [conversationExistante]); 



async function OuvrirMessagePage66ComptesEnLigne(idDestinataireget) { 
  setIdDestinataire(idDestinataireget); // 🔥 utilise directement la valeur passée
  
  const conversation = toutConversations.find(api => // en fonction de idDestinataire, idCompteConnecter (idPersonConnectedFA), obtenir la ou les conversations d'un compte connecté avec son destinataire
    api.type === "30" && (
      (api.idAccount === idCompteConnecter && api.idOther === idDestinataireget) ||
      (api.idAccount === idDestinataireget && api.idOther === idCompteConnecter)
    ));

  setIdConversation(conversation ? conversation._id : null);
  setMessageFA(true);
}



  const [partagerContactPageFA, setPartagerContactPageFA] = useState(false); // partager un contact par message - FA
  async function PartagerContactPageFA() { setPartagerContactPageFA(true); }
  async function ClosePartagerContactPageFA() { setPartagerContactPageFA(false); }
  
  const [messageFA, setMessageFA] = useState(false); // page pour envoyer un message personnel - FA 
  async function MessageFA() { setMessageFA(true); setFlorinatoApp(false); }
  async function CloseMessageFA() { setFlorinatoApp(true); setMessageFA(false); setBlocPartagerContactFA(false); setIdConversation(null); }
  
  const [blocPartagerContactFA, setBlocPartagerContactFA] = useState(false); // blocPartagerContactFA c'est le petit bloc de contact (photo + nom) , qui va s'afficher au niveau du textarea ou on ecrit le message
  async function OuvrirMessagePage66PartagerContactPageFA() { setBlocPartagerContactFA(true); setPartagerContactPageFA(false); }



  const [messageFA2e, setMessageFA2e] = useState(false); // 2e page pour envoyer un message personnel - FA 
  async function MessageFA2e() { setMessageFA2e(true); }
  async function CloseMessageFA2e() { setMessageFA2e(false); setBlocPartagerContactFA(false); setIdConversation(null); }
  
  
// logique pour envoyer un message privé sur florinato
const [writeMessage66messageFA, setWriteMessage66messageFA] = useState(""); // saisir le message


async function SendMessageFAA(customConversationId = null) {
	const messageText = writeMessage66messageFA; 
	if (!messageText.trim()) return; 
	setWriteMessage66messageFA(""); // vider immédiatement
  
	if (!socketRef.current) { console.warn("Socket non initialisé"); return; }
	let expediteur = idExpediteur; 
	let destinataire = idDestinataire;
	let idConversationreq = customConversationId ?? idConversation;
	

  // ✅ CREER INVITE SI EXISTE PAS
  if (!expediteur) {
	  console.log("Pas d'idExpediteur, création identifiant...");
    try {
		// on veut generer un identifiant unique pour permettre aux personnes qui n'ont pas de compte d'envoyer des messages
		const nomsHumains = ["jennifer", "anna", "ciel", "alex", "sam", "lina", "marc", "nina", "leo", "sarah"]; // noms Humains
		const nom = nomsHumains[Math.floor(Math.random() * nomsHumains.length)];
	  
	  const res = await axios.post(`${process.env.REACT_APP_Api2}/api/messageFA/new`, { nomIdentifiant: nom } );
	  const identifiantId = res.data._id;
      const identifiant = `${nom}_${identifiantId}`;
	  
	  await axios.put(`${process.env.REACT_APP_Api2}/api/messageFA/update/${identifiantId}`, { identifiant } );

      localStorage.setItem("identifiantFA", identifiantId);	  
      setIdExpediteur(identifiantId); // ✅ mettre à jour le state React
	  
      expediteur = identifiantId;
    } catch (error) { console.error("Erreur création invité", error); return; }
  }
  
  const messageData = { // ✅BASE COMMUNE
    idConversation: idConversationreq, // ENVOI du message
    idAccount: expediteur,
    idOther: destinataire,
    message: messageText,
	type: blocPartagerContactFA ? "74" : "1",
  };
  
  if (blocPartagerContactFA) messageData.idContact = idreq; // AJOUT CONDITIONNEL
    
  socketRef.current.emit("sendMessage", messageData); //FRONT : message envoyé au serveur    
  setWriteMessage66messageFA("");
  if (blocPartagerContactFA) setBlocPartagerContactFA(false);
  
  //await ObtenirLesDonneesFA();
}

  
  
//logique pour debuter une conversation
const [isLoading66messageFA, setIsLoading66messageFA] = useState(false);

async function BeginConversationFA() {
  if (!writeMessage66messageFA.trim()) return;
  setIsLoading66messageFA(true);

  try {
    const res = await axios.post(`${process.env.REACT_APP_Api2}/api/messageFA/new`,
      {
        idAccount: idExpediteur,
		idOther: idDestinataire,
        type: "30",
      }
    );
		
    const idConversation = res.data._id;
	//setIdConversation(idConversation);	
    console.log("Conversation créée :", idConversation);
	
    // ✅ envoyer message via socket
    SendMessageFAA(idConversation);
  } 
  catch (err) { console.error(err); }
  finally { setIsLoading66messageFA(false); }
}
// BeginConversationFA



// Écouter l'écriture (côté RECEVEUR) 
const [utilisateursQuiEcrivent, setUtilisateursQuiEcrivent] = useState({}); // État qui stocke qui écrit

useEffect(() => {
  const socket = socketRef.current;
  if (!socket) return;
  
  
  socket.on("ecrire:debut", ({ idConversation, idExpediteur }) => { // 👂 il ecoute Quand quelqu’un commence à écrire , puis sest afficher ‘en train d’écrire’”
    setUtilisateursQuiEcrivent(prev => ({ // Quand un autre utilisateur commence à écrire (ecrire:debut), on met à jour l'état utilisateursQuiEcrivent pour indiquer qui écrit dans quelle conversation.
      ...prev,
      [idConversation]: idExpediteur,
    }));
  });

  socket.on("ecrire:fin", ({ idConversation }) => { // Quand il arrête . On enlève l’indicateur pour cette conversation
    setUtilisateursQuiEcrivent(prev => { // Quand il arrête (ecrire:fin), on supprime cette information
      const copie = { ...prev };
      delete copie[idConversation];
      return copie;
    });
  });

  return () => {
    socket.off("ecrire:debut");
    socket.off("ecrire:fin");
  };
}, []);




// Ce code gère la fonctionnalité d'indicateur d'écriture dans une messagerie en temps réel, en utilisant React et Socket.IO.

/* PRINCIPE (1 phrase)

Quand l’utilisateur commence à écrire, le client prévient le serveur.
Le serveur prévient l’autre personne uniquement.
Quand il arrête, on enlève l’indicateur. */


/* Le typing indicator, c’est juste ça :

✍️ quand je commence à taper → je préviens
⏸️ quand j’arrête de taper → je préviens aussi
et chez l’autre personne, on affiche ou enlève “en train d’écrire…” */

const [estEnTrainDecrire, setEstEnTrainDecrire] = useState(false); // il n’écrivait pas -> false , il est déjà en train d’écrire -> true
const timerEcriture = useRef(null); //Ça sert à savoir quand l’utilisateur s’est arrêté d’écrire.

//Quand l’utilisateur écrit . Quand l’utilisateur écrit dans le textarea
const gererChangementMessage = (e) => { // Quand l’utilisateur tape dans le textarea . Cette fonction est appelée à CHAQUE lettre
	const texte = e.target.value;
	setWriteMessage66messageFA(texte); // On met à jour le texte (normal) . Juste pour afficher ce que l’utilisateur tape
    if (!socketRef.current) return;
  
  if (!estEnTrainDecrire) { // S’il commence JUSTE à écrire . Ah, il n’écrivait pas avant → là il commence → j’envoie UNE fois . Le if évite le spam socket
    setEstEnTrainDecrire(true);

    socketRef.current.emit("ecrire:debut", { // l'utilisateur commence à écrire . Quand un utilisateur commence à taper dans le message, le client envoie un signal au serveur (ecrire:debut) pour prévenir l'autre personne
	  idConversation, idAccount:idExpediteur, idOther:idDestinataire,
    });
  }
 
  clearTimeout(timerEcriture.current); // On reset le timer à chaque frappe . À chaque lettre, on dit: non, il ne s’est pas encore arrêté”

	// Si l'utilisateur ne tape plus pendant 1,5 seconde, le timer se déclenche automatiquement : On met estEnTrainDecrire à false . On envoie ecrire:fin via le socket pour prévenir l'autre utilisateur.
  timerEcriture.current = setTimeout(() => { // S’il ne tape plus pendant 1.5s . on enlève l’indicateur chez l’autre personne
    setEstEnTrainDecrire(false);

    socketRef.current.emit("ecrire:fin", { // Quand il arrête d'écrire pendant 1,5 seconde, le client envoie un signal (ecrire:fin) pour indiquer qu'il a arrêté
      idConversation, idAccount:idExpediteur, idOther:idDestinataire,
    });
  }, 1500); // 1.5s sans écrire
};
// Sur le côté réception, chaque utilisateur voit qui est en train d'écrire grâce à ces signaux ci-dessus


/* CE QUI SE PASSE CONCRÈTEMENT

Tu tapes une lettre
onChange se déclenche
gererChangementMessage(e) est appelée
Le socket envoie écriture:debut
Si tu t’arrêtes 1,5 s → écriture:fin */




async function AvantMessagePage(idDestinataireget) {
  setIdDestinataire(idDestinataireget); setIdCompte(idDestinataireget);
  
  const conversation = toutConversations.find(api => // en fonction de idDestinataire, idCompteConnecter (idPersonConnectedFA), obtenir la ou les conversations d'un compte connecté avec son destinataire
    api.type === "30" && (
      (api.idAccount === idCompteConnecter && api.idOther === idDestinataireget) ||
      (api.idAccount === idDestinataireget && api.idOther === idCompteConnecter)
    ));

  setIdConversation(conversation ? conversation._id : null);
} 



async function OuvrirMessageFA2e(idDestinataireget) {
  setIdDestinataire(idDestinataireget); setIdCompte(idDestinataireget);
  
  const conversation = toutConversations.find(api =>
    api.type === "30" && (
      (api.idAccount === idCompteConnecter && api.idOther === idDestinataireget) ||
      (api.idAccount === idDestinataireget && api.idOther === idCompteConnecter)
    ));

  setIdConversation(conversation ? conversation._id : null);
  setMessageFA2e(true);
}




const SeeVideoTemplatePropsCommun = {
  voirProfil: ProfilFA2e, voirPhoto: SeePhotoCouvertureVideo, OuvrirMessagePage: OuvrirMessageFA2e, 
  dataVideoFAbyClic, dataVideoByIdCompte, data: infosCompte, idCompte, idCompteConnecter, listVideoFA,
  rechercherUneVideoFA, setRechercherUneVideoFA, publierVideoPage:AddVideoPageFA, profilMap, clicFA, titreFA, photoCouvertureVideo, urlVideo, scrollY, scrollX,
  CommenterPageFA, ModifierUrlPage, ReparerUrlPage, ModifierTitrePageFA, ChangerMiniaturePage, clicVideo: ClicVideoFAA,
  setIdPost, setUrlVideo, setIdProprietairePost, setIdCompte,
};


const profilPropsCommun = {
	MenuFA, AddVideoPageFA, AccountsFA, ClicVideoFAA, rechercherMaVideoFA, setRechercherMaVideoFA, idCompte, idCompteConnecter, 
	gererScroll, gererScrollVisites, scrollX, setIdPost, setUrlVideo, setIdProprietairePost, OuvrirMessagePage: MessageFA2e, OuvrirInscriptionPage,
	data: infosCompte, dataMesVisitesFA, dataVideos: dataVideoByIdCompte, dataOverflow: dataVideoRecenteByIdCompte, listVideo: listTesVideosFA, messagebtn: true
};

const ComptesRecentsPropsCommun = {
  listAccount: listAccountFA, setIdCompte, setIdDestinataire, valeur: rechercherUnCompteFA, setValeur: setRechercherUnCompteFA, onlineUsers, 
  gererScroll: gererScrollComptes, OuvrirMessagePage: OuvrirMessagePage66ComptesEnLigne, 
};

const AnnoncesPropsCommun = { OuvrirMessagePage: OuvrirMessageFA2e, };


const MessagePropsCommun = {
  profilMap, gererScrollMessages, voirProfil: ProfilFA2e, gererChangementMessage, SendMessageFAA,
  data: infosCompteById[0], data2: infosCompteById2[0], dataMessagesFA,
  idCompte, idCompteConnecter, destinataireOnline, Favorite66messageFA, PartagerContactPageFA, blocPartagerContact: blocPartagerContactFA,
  onlineOther, badgeOther, nameOther, photoOther, isLoading66messageFA, BeginConversationFA, verifyConversation, writeMessage66messageFA, setWriteMessage66messageFA,
};



const [inscriptionPageAA, setInscriptionPageAA] = useState(false); // inscription Page AA - on affiche la page qui permet a l'utilisateur de s'inscrire - AA
async function InscriptionPageAA() {
    setInscriptionPageAA(true);
    setConnexionPageAA(false);
}
  
async function CloseInscriptionPageAA() { 
	setTelephoneVirtuel(true); 
	setInscriptionPageAA(false); 
}



async function OuvrirInscriptionPage() { setInscriptionPageAA(true); setProfilFA(false); }




  // on affiche son compte - FA
  const [profilFA, setProfilFA] = useState(false); 
  async function ProfilFA() { setProfilFA(true); setFlorinatoApp(false); }
  async function CloseProfilFA() { setFlorinatoApp(true); setProfilFA(false); }
  
  
  const [tonProfilPourNonConnecter, setTonProfilPourNonConnecter] = useState(false); 
  //async function ProfilFA0e() { setTonProfilPourNonConnecter(true); }
  async function CloseTonProfilPourNonConnecter() { setVideosPageFA(true); setTonProfilPourNonConnecter(false); }
  
  
  const [profilFA2e, setProfilFA2e] = useState(false); 
  async function ProfilFA2e() { setProfilFA2e(true); }
  async function CloseProfilFA2e() { setProfilFA2e(false); }
  
  
  const [profilFA3e, setProfilFA3e] = useState(false); 
  async function ProfilFA3e() { setProfilFA3e(true); }
  async function CloseProfilFA3e() { setProfilFA3e(false); }
  
  
  const [seePhotoFA, setSeePhotoFA] = useState(false); //voir la photo 
  async function SeePhotoFA() { setSeePhotoFA(true); }
  async function CloseSeePhotoFA() { setSeePhotoFA(false); }
  
  
  const [seeVideoFA, setSeeVideoFA] = useState(false); //voir la video
  async function SeeVideoFA() { setSeeVideoFA(true); setVideosPageFA(false); }
  async function CloseSeeVideoFA() { setVideosPageFA(true); setSeeVideoFA(false); }
  

  const [seeVideoFAPourNonConnecter, setSeeVideoFAPourNonConnecter] = useState(false); 
  async function SeeVideoFAPourNonConnecter() { setSeeVideoFAPourNonConnecter(true); }
  async function CloseSeeVideoFAPourNonConnecter() { setSeeVideoFAPourNonConnecter(false); }
  
  
  const [seeVideoFA2e, setSeeVideoFA2e] = useState(false); 
  async function SeeVideoFA2e() { setSeeVideoFA2e(true); }
  async function CloseSeeVideoFA2e() { setSeeVideoFA2e(false); }
  
  
  const [seeVideoFA3e, setSeeVideoFA3e] = useState(false); 
  async function SeeVideoFA3e() { setSeeVideoFA3e(true); }
  async function CloseSeeVideoFA3e() { setSeeVideoFA3e(false); }
  

  const [seePhotoFAreq, setSeePhotoFAreq] = useState(false); 
  async function SeePhotoFAreq() { setSeePhotoFAreq(true); } //voir la photo (lors de la requete) 
  async function CloseSeePhotoFAreq() { setSeePhotoFAreq(false); }
  

  const [seeVideoFAreq, setSeeVideoFAreq] = useState(false); 
  async function SeeVideoFAreq() { setSeeVideoFAreq(true); } //voir la video (lors de la requete)
  async function CloseSeeVideoFAreq() { setSeeVideoFAreq(false); }

  
  const [seePhotoOther, setSeePhotoOther] = useState(false); 
  async function SeePhotoOther() { setSeePhotoOther(true); } //afficher la photo de l'autre 
  async function CloseSeePhotoOther() { setSeePhotoOther(false); }


  //selected2FA (selectionner photo, video, texte,.. )
  const [selected2FA, setSelected2FA] = useState(false);
  async function CloseSelected2FA() { setSelected2FA(false); }
  async function Annuler66selected2FA() { setSelected2FA(false); } 




  // menuFA
  const [menuFA, setMenuFA] = useState(false); 
  async function MenuFA() { setMenuFA(true); }
  async function CloseMenuFA() { setMenuFA(false); }


  // gestionnaireFA - listes des comptes ou vous avez été ajoutés
  const [gestionnaireFA, setGestionnaireFA] = useState(false); 
  async function GestionnaireFA() { setGestionnaireFA(true); }
  async function CloseGestionnaireFA() { setGestionnaireFA(false); }

  
  // gestionDuCompteFA - listes des comptes qui pourront publier sur votre compte
  const [gestionDuCompteFA, setGestionDuCompteFA] = useState(false); 
  async function GestionDuCompteFA() { setGestionDuCompteFA(true); }
  async function CloseGestionDuCompteFA() { setGestionDuCompteFA(false); }
  
  // PopupDuBas - Ajouter un compte qui pourra publier sur votre compte
  const [publierSurVotreCompteFApb, setPublierSurVotreCompteFApb] = useState(false); 
  async function OuvrirPublierSurVotreCompteFApb() { setPublierSurVotreCompteFApb(true); }
  async function ClosePublierSurVotreCompteFApb() { setPublierSurVotreCompteFApb(false); }
  
  // confirmation popup - confirmer l'ajout du compte qui pourra publier sur votre compte
  const [publierSurVotreCompteFAconfp, setPublierSurVotreCompteFAconfp] = useState(false); 
  async function PublierSurVotreCompteFAconfp() { setPublierSurVotreCompteFAconfp(true); }
  async function ClosePublierSurVotreCompteFAconfp() { setPublierSurVotreCompteFAconfp(false); }
  
  
  // MettreEnAvantCompteFA
  const [mettreEnAvantCompteFA, setMettreEnAvantCompteFA] = useState(false); 
  async function MettreEnAvantCompteFA() { setMettreEnAvantCompteFA(true); }
  async function CloseMettreEnAvantCompteFA() { setMettreEnAvantCompteFA(false); }
  
  // PopupDuBas - Selectionner, Ajouter un compte qui sera mis en avant
  const [mettreEnAvantFApb, setMettreEnAvantFApb] = useState(false); 
  async function OuvrirMettreEnAvantFApb() { setMettreEnAvantFApb(true); }
  async function CloseMettreEnAvantFApb() { setMettreEnAvantFApb(false); }
  
  // confirmation popup - confirmer l'ajout du compte qui sera mis en avant sur Florinato
  const [mettreEnAvantFAconfp, setMettreEnAvantFAconfp] = useState(false); 
  async function MettreEnAvantFAconfp() { setMettreEnAvantFAconfp(true); }
  async function CloseMettreEnAvantFAconfp() { setMettreEnAvantFAconfp(false); }
  
  
    // page - listes des admins florinato
  const [adminFlorinato, setAdminFlorinato] = useState(false); 
  async function AdminFlorinato() { setAdminFlorinato(true); }
  async function CloseAdminFlorinato() { setAdminFlorinato(false); }
  
  // PopupDuBas - Selectionner, Ajouter un compte qui sera admin Florinato
  const [adminFlorinatopb, setAdminFlorinatopb] = useState(false); 
  async function OuvrirAdminFlorinatopb() { setAdminFlorinatopb(true); }
  async function CloseAdminFlorinatopb() { setAdminFlorinatopb(false); }
  
  // confirmation popup - confirmer l'ajout du compte qui sera admin Florinato
  const [adminFlorinatoconfp, setAdminFlorinatoconfp] = useState(false); 
  async function OuvrirAdminFlorinatoconfp() { setAdminFlorinatoconfp(true); }
  async function CloseAdminFlorinatoconfp() { setAdminFlorinatoconfp(false); }
  
  


// url pour tomber directement sur la page
// url pour tomber directement sur la page

	const location = useLocation();

	// État pour gérer l’ouverture du popup
	useEffect(() => {
	  // const match = location.pathname.match(/^\/profile\/(.+)$/);
	  const profilePage = location.pathname.startsWith('/profile'); // Vérifier si l'URL correspond à la page profil
	  const messagePage = location.pathname.startsWith('/m'); // Vérifier si l'URL correspond à la page des messages
	  const videoPage = location.pathname.startsWith('/video'); // Vérifier si l'URL correspond à la page pour voir la video
	  // const userId = isProfilePage ? location.pathname.split('/profile/')[1] : null; // Extraire l'ID si besoin
	  
	  // petite logique pour recuperer l'id qui est dans l'url
	    let id = null;

		// URL du style /profile/12345
		//const match = location.pathname.match(/^\/profile\/([^\/]+)$/);
		const match = location.pathname.match(/^\/profile\/([^/]+)$/);
		if (match) {
		  id = match[1]; // Récupère l'ID dans la partie après /profile/
		  //console.log("id trouver dans l'url ", id);
		  setIdCompte(id);
		  
		  // localStorage.setItem("idAccountChef", id);
		  // console.log("idAccountChef deja enregistrer : ", id);
		}
	  
	  if (profilePage) {
		// const id = isProfilePage[1];
		// ouvre la popup avec cet ID
		setTonProfilPourNonConnecter(true);
		
		setFlorinatoApp(false);
        setTelephoneVirtuel(false);
        setInscriptionPageAA(false);
	  }
	  
	  if (messagePage) {
		setMessageFA(true);
		setFlorinatoApp(true);
        setTelephoneVirtuel(false);
        setInscriptionPageAA(false);
	  }
	  
	  if (videoPage) {
		setVideosPageFA(true);
		
		setFlorinatoApp(false);
        setTelephoneVirtuel(false);
        setInscriptionPageAA(false);
	  }
	  
	  
	  async function fetchData() {
		await ObtenirLesDonneesFA();
	  }
	  fetchData();
	  
	}, [location]);

/*
const closePopup = () => {
    navigate.push('/'); // revenir à la page d'accueil
	// navigate.goBack(); 
  }; */




// lier une video a une photo - FA
const [addVideoPageFA, setAddVideoPageFA] = useState(false);
async function AddVideoPageFA() { setAddVideoPageFA(true); }
async function CloseAddVideoPageFA() { setAddVideoPageFA(false); } 


//logique pour GenererMiniatureVideo
const [miniatureFA, setMiniatureFA] = useState();
const [fileVideoFAA, setFileVideoFAA] = useState();
const [second, setSecond] = useState(10);

// useEffect affiche la miniature immédiatement après sa génération sans délai
  useEffect(() => {
	async function GenererMiniature() {
		if (fileVideoFAA) {
			// Supposons que vous avez votre fichier vidéo dans `file`
			await GenererMiniatureVideo({ file: fileVideoFAA, setMiniature: setMiniatureFA, second: second });
		}
	}
	GenererMiniature();
}, [fileVideoFAA, second]);



/* voir la miniature- FA  */
const [voirMiniature, setVoirMiniature] = useState(false);
const [photoUrl, setPhotoUrl] = useState();

async function CloseVoirMiniature() { //fermer
  setVoirMiniature(false);
} 


async function transVoirMiniatureFA(url) { //transmettre VoirMiniature (on transmet la miniature a l'autre composant (au modal))
  setPhotoUrl(url);
  setVoirMiniature(true);
} 
  
  
//logique pour ajouter les liens de la video (lien de chaque service ou la video est heberger)
const [lienDropbox, setLienDropbox] = useState("");
const [lienGitHub, setLienGitHub] = useState("");
const [lienGitLab, setLienGitLab] = useState("");
const [ecrireTitre, setecrireTitre] = useState(""); //titre de la video
const [isLoading666PublierVideoFAA, setisLoading666PublierVideoFAA] = useState(false);


//logique pour publier une video - FA
async function PublierVideoFAA() {
  await ExecuterActionFA({ file:miniatureFA, urlVideo:lienDropbox, loader: setisLoading666PublierVideoFAA, actions: ["post"],
    dataPOST: {
      message: ecrireTitre,
      idAccount: idPersonConnectedFA,
      idAccountChef: idPersonConnectedFA,
      clic:0, account:1, type:3
    }, });
}


//logique pour publier une annonce - FA
const [ecrireAnnonce, setEcrireAnnonce] = useState("");
const [isLoading666PublierAnnonceFA, setisLoading666PublierAnnonceFA] = useState(false);

async function PublierAnnonceFA() {
  await ExecuterActionFA({ loader: setisLoading666PublierAnnonceFA, actions: ["post"],
    dataPOST: {
      texte: ecrireAnnonce,
      idProprietaireAnnonce: idPersonConnectedFA,
      clic:0, type:60
    }, });
}



const [isLoading666AjouterAdminFA, setIsLoading666AjouterAdminFA] = useState(false);
const [isLoading666AjouterAdminFlorinato, setIsLoading666AjouterAdminFlorinato] = useState(false);
const [isLoading666MettreEnAvantFA, setIsLoading666MettreEnAvantFA] = useState(false);


// toutes les donnees FA
async function ObtenirLesDonneesFA() {
  const data = await getAllData();
  if (data === null) { return; }
  setApiMessageFA(data);
}


async function ExecuterActionFA({ actions = ["post"], loader, id, file, nouveauUrl, urlVideo, dataPUT={}, dataPOST={} }) {
	try { if (loader) loader(true);
		
	    for (const action of actions) {
		  if (action === "post") { await envoyerPOST({ file, urlVideo, dataPOST }); }
		  if (action === "put") { await envoyerPUT({ id, file, nouveauUrl, dataPUT }) }
		}
	} finally { if (loader) loader(false); }
}



// il verifie s'il faut faire un post ou un put
async function verificationAvantExecuterActionFA({ loader, type, dataPUT, dataPOST2 }) { 
  const filterInfos = apiMessageFA.filter((api) => api.idAccount === idAccount && api.idOther === idreq && api.type === type);
  const idInfos = filterInfos.map((api) => api._id);
  const existe = filterInfos.length > 0;

  if (existe) { await ExecuterActionFA({ dataPUT, id:idInfos, loader, actions: ["put"] }); } // donnees existe deja , alors on fait un put
  else { await ExecuterActionFA({ dataPOST: {...dataPOST2, idAccount, idOther:idreq, visible:1, type }, loader }); } // donnees n'existe pas , alors on fait un post
}



//logique pour ajouter un admin qui pourra publier sur un compte florinato
async function AjouterAdminFA() {
	await verificationAvantExecuterActionFA({ dataPUT:{admin:1}, dataPOST2:{admin:1}, loader:setIsLoading666AjouterAdminFA, type:81 });
}

//logique pour ajouter un admin florinato
async function AjouterAdminFlorinato() {
	await verificationAvantExecuterActionFA({ dataPUT:{adminFlorinato:1}, dataPOST2:{adminFlorinato:1}, loader:setIsLoading666AjouterAdminFlorinato, type:80 });
}

//logique pour mettre en avant un compte - FA
async function MettreEnAvantFA() {
	await verificationAvantExecuterActionFA({ dataPUT:{top:1}, dataPOST2:{top:1}, loader:setIsLoading666MettreEnAvantFA, type:82 });
}


// clic de la video
async function ClicVideoFAA({ id, idOther, nombreClic }) {	
	const clic = (Number(nombreClic) || 0) + 1; //type:204 il a cliqué sur la video 
	await ExecuterActionFA({ dataPUT:{clic}, dataPOST: {idAccount, idOther, visible:1, id, type:204}, id, actions: ["post", "put"] });
}
		

//page pour changer la miniature de la video - FA
const [changerMiniaturePage, setChangerMiniaturePage] = useState(false);
async function ChangerMiniaturePage() { setChangerMiniaturePage(true); }
async function CloseChangerMiniaturePage() { setChangerMiniaturePage(false); }

//logique pour changer la miniature de la video - FA
const [isLoading666ChangerMiniatureFA, setIsLoading666ChangerMiniatureFA] = useState(false);
async function ChangerMiniatureFA() { await ExecuterActionFA({ id:idPost, file: miniatureFA, loader:setIsLoading666ChangerMiniatureFA, actions: ["put"] }); }
	
	
	
//page pour changer le titre de la video - FA
const [modifierTitrePageFA , setmodifierTitrePageFA] = useState(false);
async function ModifierTitrePageFA() { setmodifierTitrePageFA(true); }
async function CloseModifierTitrePageFA() { setmodifierTitrePageFA(false); }

//logique pour changer le titre de la video - FA
const [isLoading666ModifierTitreFA, setIsLoading666ModifierTitreFA] = useState(false);
const [nouveauTitre, setNouveauTitre] = useState("");
async function ModifierTitreFA() { await ExecuterActionFA({ dataPUT:{message: nouveauTitre}, id:idPost, loader:setIsLoading666ModifierTitreFA, actions: ["put"] }); }


//page pour modifier l'annonce - FA
const [modifierAnnoncePageFA , setModifierAnnoncePageFA] = useState(false);
async function ModifierAnnoncePageFA() { setModifierAnnoncePageFA(true); }
async function CloseModifierAnnoncePageFA() { setModifierAnnoncePageFA(false); }

//logique pour modifier l'annonce - FA
const [isLoading666ModifierAnnonceFA, setIsLoading666ModifierAnnonceFA] = useState(false);
const [nouvelleAnnonce, setNouvelleAnnonce] = useState("");
async function ModifierAnnonceFA() { await ExecuterActionFA({ dataPUT:{texte: nouvelleAnnonce}, id:idAnnonce, loader:setIsLoading666ModifierAnnonceFA, actions: ["put"] }); }



//page pour commenter la vidéo- FA
const [commenterPageFA, setcommenterPageFA] = useState(false);
async function CommenterPageFA() { setcommenterPageFA(true); }
async function CloseCommenterPageFA() { setcommenterPageFA(false); }

//logique pour commenter un post (commenter une video ou une photo ou n'importe qu'elle post) - FA
const [isLoading666CommenterFA, setIsLoading666CommenterFA] = useState(false);
const [ecrireCommentaireFA, setEcrireCommentaireFA] = useState("");
async function CommenterFA() { await ExecuterActionFA({
	actions: ["post"],
	loader:setIsLoading666CommenterFA,
	dataPOST:{
		idPost,
		idProprietairePost,
		
		commentaire: ecrireCommentaireFA,
		idProprietaireCommentaire: idPersonConnectedFA,
        type:25,
	}, 
}); }
	  
	  

//page pour ecrire sa reponse
const [repondrePageFA, setrepondrePageFA] = useState(false); 
async function RepondrePageFA() { setrepondrePageFA(true); }
async function CloseRepondrePageFA() { setrepondrePageFA(false); }

//logique pour repondre a un commentaire - FA
const [isLoading666RepondreFA, setIsLoading666RepondreFA] = useState(false);
const [ecrireReponseFA, setEcrireReponseFA] = useState("");
async function RepondreFA() { await ExecuterActionFA({
	actions: ["post"],
	loader:setIsLoading666RepondreFA,
	dataPOST:{
		idPost,
		idProprietairePost,

		idCommentaire,
		idProprietaireCommentaire,
		
		reponse: ecrireReponseFA,		
		idProprietaireReponse: idPersonConnectedFA,
        type:26,
	}, 
}); } 


//page pour enregistrer l'url modifier
const [modifierUrlPage, setmodifierUrlPage] = useState(false);
async function ModifierUrlPage() { setmodifierUrlPage(true); }
async function CloseModifierUrlPage() { setmodifierUrlPage(false); }

const [isLoading666ValiderUrl, setisLoading666ValideUrl] = useState(false); //logique pour enregistrer l'url modifier 
const [ecrire666modifierUrl, setecrire666modifierUrl] = useState("");

// modifier l'url de la video
async function ValiderUrl() { await ExecuterActionFA({ id: idPost, nouveauUrl: ecrire666modifierUrl, loader:setisLoading666ValideUrl, actions: ["put"] }); }



//page pour reparer l'url de la video
const [reparerUrlPage, setReparerUrlPage] = useState(false);
async function ReparerUrlPage() { setReparerUrlPage(true); }
async function CloseReparerUrlPage() { setReparerUrlPage(false); }
const [isLoading666ReparerUrl, setisLoading666ReparerUrl] = useState(false); 

// logique pour reparer l'url de la video

//async function ReparerUrl() { await ExecuterActionFA({ id: idPost, nouveauUrl: urlVideo, loader:setisLoading666ReparerUrl, actions: ["put"] }); }
async function ReparerUrl() {
    if (!urlVideo) return;
	
    const newUrl = await AdapterLien(urlVideo);
	await ExecuterActionFA({ id: idPost, nouveauUrl: newUrl, loader:setisLoading666ReparerUrl, actions: ["put"] });
    setUrlVideo(newUrl); // recharge video locale instantanément
	console.log("newUrl", newUrl);
}
	
	
	

  // application florinato
  const [florinatoApp, setFlorinatoApp] = useState(false);
  async function CloseFlorinatoApp() { setTelephoneVirtuel(true); setFlorinatoApp(false); }

  const [dataFA, setDataFA] = useState(false);
  async function DataFA() { setDataFA(!dataFA); }

  
  // PageRedirection 66ChildApi66florinatoApp
  async function PageRedirection66ChildApi66florinatoApp() {
    //page pour afficher le groupe que j'ai cliqué
    const groupOther = localStorage.getItem("GoTogroupOtherFA");
    if (groupOther === "1") { setGroupOtherFA(true); }//if (groupOther === "1")

    //aller vers la page du message
    const GoTomessageFA = localStorage.getItem("GoTomessageFA"); 
    if (GoTomessageFA === "1") { setMessageFA(true); } //if (GoTomessageFA === "1")
  }


  // rencontre - FA
  const [rencontreFA, setRencontreFA] = useState(false);
  async function RencontreFA() {
    setRencontreFA(true);
  }
  async function CloseRencontreFA() {
    setRencontreFA(false);
  }
  

  // on affiche les favoris 66accountsFA
  const [favorite66accountsFA, setFavorite66accountsFA] = useState(false);
  async function Favorite66accountsFA() {
    setFavorite66accountsFA(true);
  }
  async function CloseFavorite66accountsFA() {
    setFavorite66accountsFA(false);
  }


  // mes comptes Florinato
  const [accountsFA, setAccountsFA] = useState(false);
  async function AccountsFA() {
    setAccountsFA(true);
  }
  async function CloseAccountsFA() {
    setAccountsFA(false);
  }


  //page pour créer un nouveau compte Florinato
  const [newAccountPageFA, setNewAccountPageFA] = useState(false);
  async function NewAccountPageFA() {
    setNewAccountPageFA(true);
  }
  async function CloseNewAccountPageFA() {
    setNewAccountPageFA(false);
  }


  const [nameNewAccountFA, setNameNewAccountFA] = useState(""); //saisir le nom du nouveau compte
  //if (nameNewAccountFA) { localStorage.setItem("nameNewAccountFA", nameNewAccountFA); } 

  //logique pour creer un nouveau compte Florinato
  async function NewAccountFA() {
    setOpacity(true);
    
          // 1ere requete - api1
          // on cree un id , on va l'utiliser chaque fois qu'on aura besoin d'un id
            async function premiereReq() {
              await axios
              .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
              .then((res) => {
                setApiMessageFA(res.data);
                const api = res.data;

              //creer un id 
              const numberMessageFA = api.filter((api) => api._id);
              const totalMessageFA = numberMessageFA.length;

              const createId = totalMessageFA + 1;
              if (createId) { localStorage.setItem("createId", createId); }
              console.log("createId :", createId);
              console.log(res);

                //2e requete - api1
                // on cree son nouveau compte 
                async function deuxiemeReq() {
                  const id = localStorage.getItem("createId");
                  const badge = "0";
                  const photoProfile = localStorage.getItem("urlPhotoreq");
                  const popularity = "0";
                  const newAccount = "1"; // newAccount c'est juste pour mentionner que c'est un nouveau compte Florinato
                  const visible = "1";
                  const type = "10";
                  const florinatoApp = "1";

                  await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
                    data: {
                      id,
                      idUser: idUserConnectedFA,
                      nameAccount: nameNewAccountFA,
                      phoneNumber: phoneNumberFA,
                      badge,
                      photoProfile,
                      popularity,
                      newAccount,
                      visible,
                      type,
                      florinatoApp,
                    },
                  })
                  .then((res) => {
                    // on prend l'idAccount, on va l'utiliser pour mettre l'idPhotoProfile sur son compte
                    const id = res.data._id;
                    if (id) { localStorage.setItem("idAccount", id); }
                    console.log(id, "idAccount");
                    
                    const online = res.data.createdAt; // on prend la date de derniere connexion
                    if (online) { localStorage.setItem("online", online); }
                    console.log("online", online);
                    
            //3e requete - api1
            // on cree son groupe
            async function troisiemeReq() {
              const id = localStorage.getItem("createId");
              const idAccount = localStorage.getItem("idAccount");
              const photoGroup = localStorage.getItem("urlPhotoreq");
              const photo2Group = localStorage.getItem("urlPhotoreq");
              const badgeGroup = "0";
              const visit = "0";
              const clic = "0";
              const visible = "1";
              const type = "11";

              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
                data: {
                  id,
                  idAccount, 
                  nameGroup: nameNewAccountFA,
                  photoGroup,
                  photo2Group,
                  badgeGroup,
                  visit,
                  clic,
                  visible,
                  type,
                },
              })
              .then((res) => {
                const id = res.data._id; //on prend l'id du groupe pour l'ajouter au niveau du compte
                if (id) { localStorage.setItem("idGroup", id); }
                console.log(id, "idGroup");
                console.log(res);

            //4e requete - api1
            // on met la photo de profil dans l'album photo de profil
            async function quatriemeReq() {
              const id = localStorage.getItem("createId");
              const photoProfile = localStorage.getItem("urlPhotoreq");
              const idAccount = localStorage.getItem("idAccount");
              const popularity = "0";
              const visible = "1";
              const type = "12"; //album photo de profil

            await axios({
              method: "post",
              url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
              data: {
                id,
                photoProfile,
                idAccount,
                popularity,
                visible, 
                type,
              },
            })
            .then((res) => {
              const id = res.data._id; //on prend l'id de la Photo de Profil
              if (id) { localStorage.setItem("idPhotoProfile", id); }
              console.log(id, "idPhoto");
              console.log(res);

        //5e requete - api1
        // on met l'idPhotoProfile sur son compte
        async function cinquiemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const idPhotoProfile = localStorage.getItem("idPhotoProfile");
          const idGroup = localStorage.getItem("idGroup");
          const online = localStorage.getItem("online");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idAccount}`, 
            data: {
              idPhotoProfile,
              idGroup,
              online,
            },
            })
            .then((res) => {
            console.log("l'id de la photo de profil a ete mis sur le compte");
            console.log(res);

          //6e requete - api1
          // obtenir de nouvelles données
          async function sixiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              //Compte créer avec success , alors on le connecte directement sur le nouveau compte florinato
              //on enregistre l'idAccount pour le maintenir connecté !
              const idAccount = localStorage.getItem("idAccount");
              const idGroup = localStorage.getItem("idGroup");
              if (idAccount) { 
				localStorage.setItem("idPersonConnectedFA", idAccount);
                localStorage.setItem("idAccountChef", idAccount); 
                localStorage.setItem("idGroupChef", idGroup); 
			  }

              console.log("Compte créer avec success, idPersonConnectedFA", idAccount);
              console.log(res);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            sixiemeReq();
            //6e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            cinquiemeReq();
            //5e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            quatriemeReq();
            //4e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            troisiemeReq();
            //3e requete - api1
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            deuxiemeReq();
            //2e requete - api1
            })
            .catch((err) => {
              
            //1ere requete - api2
            //creer un id
            async function premiereReq() {
              await axios
              .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
              .then((res) => {
                setApiMessageFA(res.data);
                const api = res.data;

              //creer un id 
              const numberMessageFA = api.filter((api) => api._id);
              const totalMessageFA = numberMessageFA.length;

              const createId = totalMessageFA + 1;
              if (createId) { localStorage.setItem("createId", createId); }
              console.log("createId :", createId);
              console.log(res);

            //2e requete - api2
            // on cree son nouveau compte 
            async function deuxiemeReq() {
              const id = localStorage.getItem("createId");
              const badge = "0";
              const photoProfile = localStorage.getItem("urlPhotoreq");
              const popularity = "0";
              const newAccount = "1"; // newAccount c'est juste pour mentionner que c'est un nouveau compte Florinato
              const visible = "1";
              const type = "10";
              const florinatoApp = "1";

              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
                data: {
                  id,
                  idUser: idUserConnectedFA,
                  nameAccount: nameNewAccountFA,
                  phoneNumber: phoneNumberFA,
                  badge,
                  photoProfile,
                  popularity,
                  newAccount,
                  visible,
                  type,
                  florinatoApp,
                },
              })
              .then((res) => {
                // on prend l'idAccount, on va l'utiliser pour mettre l'idPhotoProfile sur son compte
                const id = res.data._id;
                if (id) { localStorage.setItem("idAccount", id); }
                console.log(id, "idAccount");
                
                const online = res.data.createdAt; // on prend la date de derniere connexion
                if (online) { localStorage.setItem("online", online); }
                console.log("online", online);

            //3e requete - api2
            // on cree son groupe
            async function troisiemeReq() {
              const id = localStorage.getItem("createId");
              const idAccount = localStorage.getItem("idAccount");
              const photoGroup = localStorage.getItem("urlPhotoreq");
              const photo2Group = localStorage.getItem("urlPhotoreq");
              const badgeGroup = "0";
              const visit = "0";
              const clic = "0";
              const visible = "1";
              const type = "11";

              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
                data: {
                  id,
                  idAccount, 
                  nameGroup: nameNewAccountFA,
                  photoGroup,
                  photo2Group,
                  badgeGroup,
                  visit,
                  clic,
                  visible,
                  type,
                },
              })
              .then((res) => {
                const id = res.data._id; //on prend l'id du groupe pour l'ajouter au niveau du compte
                if (id) { localStorage.setItem("idGroup", id); }
                console.log(id, "idGroup");
                console.log(res);

            //4e requete - api2
            // on met la photo de profil dans l'album photo de profil
            async function quatriemeReq() {
              const id = localStorage.getItem("createId");
              const photoProfile = localStorage.getItem("urlPhotoreq");
              const idAccount = localStorage.getItem("idAccount");
              const popularity = "0";
              const visible = "1";
              const type = "12"; //album photo de profil

            await axios({
              method: "post",
              url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
              data: {
                id,
                photoProfile,
                idAccount,
                popularity,
                visible, 
                type,
              },
            })
            .then((res) => {
              const id = res.data._id; //on prend l'id de la Photo de Profil
              if (id) { localStorage.setItem("idPhotoProfile", id); }
              console.log(id, "idPhoto");
              console.log(res);

          //5e requete - api2
          // on met l'idPhotoProfile sur son compte
          async function cinquiemeReq() {
            const idAccount = localStorage.getItem("idAccount");
            const idPhotoProfile = localStorage.getItem("idPhotoProfile");
            const idGroup = localStorage.getItem("idGroup");
            const online = localStorage.getItem("online");

            await axios({
              method: "put",
              url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idAccount}`, 
              data: {
                idPhotoProfile,
                idGroup,
                online,
              },
              })
              .then((res) => {
              console.log("l'id de la photo de profil a ete mis sur le compte");
              console.log(res);

          //6e requete - api2
          // obtenir de nouvelles données
          async function sixiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              //Compte créer avec success , alors on le connecte directement sur le nouveau compte florinato
              //on enregistre l'idAccount pour le maintenir connecté !
			  const idAccount = localStorage.getItem("idAccount");
              const idGroup = localStorage.getItem("idGroup");
              if (idAccount) { 
				localStorage.setItem("idPersonConnectedFA", idAccount);
                localStorage.setItem("idAccountChef", idAccount); 
                localStorage.setItem("idGroupChef", idGroup); 
			  }

              console.log("Compte créer avec success, idPersonConnectedFA", idAccount);
              console.log(res);
              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            sixiemeReq();
            //6e requete - api2
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            cinquiemeReq();
            //5e requete - api2
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            quatriemeReq();
            //4e requete - api2
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            troisiemeReq();
            //3e requete - api2
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            deuxiemeReq();
            //2e requete - api2
            })
            .catch((err) => {
              setOpacity(false);
              setErreur(true);
            });
            }
            premiereReq();
            //1ere requete - api2

            });
            }
            premiereReq();
            //1ere requete - api1
  } 
  // NewAccountFA


  //logique pour s'abonner à un compte et un groupe FA
  const [isLoading66FollowFA, setIsLoading66FollowFA] = useState(false);

  async function FollowFA() {
    setIsLoading66FollowFA(true);

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete - api1
      // creer un id
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          const api = res.data;
        
        //creer un id pour chaque message envoyé sur florinato
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
      
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete - api1
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idAccountChef");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idGroupOther = localStorage.getItem("idGroupOther");
      const nameGroupOther = localStorage.getItem("nameGroupOther");
      const photoGroupOther = localStorage.getItem("photoGroupOther");
      const account = "1";
      const group = "1";
      const follow = "1";
      const visible = "1";
      const type = "50"; // il s'est abonné

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idGroup: idGroupFA,
          nameGroup: nameGroupFA,
          photoGroup: photoGroupFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idGroupOther,
          nameGroupOther,
          photoGroupOther,
          account,
          group,
          follow,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete - api1
        // on obtiens les nouvelles données
        async function troisiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              setIsLoading66FollowFA(false);
              console.log("il s'est abonné");
              console.log(res);
            })
            }
            troisiemeReq();
            //3e requete - api1
            })
            }
            deuxiemeReq();
            //2e requete - api1
            })
            .catch((err) => {

      //1ere requete - api2
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
        
        //creer un id pour chaque message envoyé sur florinato
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
            
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

        //2e requete - api2
        // on envoie le message
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const idOther = localStorage.getItem("idAccountChef");
          const nameOther = localStorage.getItem("nameOther");
          const photoOther = localStorage.getItem("photoOther");
          const badgeOther = localStorage.getItem("badgeOther");
          const idGroupOther = localStorage.getItem("idGroupOther");
          const nameGroupOther = localStorage.getItem("nameGroupOther");
          const photoGroupOther = localStorage.getItem("photoGroupOther");
          const account = "1";
          const group = "1";
          const follow = "1";
          const visible = "1";
          const type = "50"; // il s'est abonné

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
            data: {
              id,
              idAccount: idPersonConnectedFA,
              nameAccount: nameFA,
              photoAccount: photoFA,
              badgeAccount: badgeFA,
              idGroup: idGroupFA,
              nameGroup: nameGroupFA,
              photoGroup: photoGroupFA,
              idOther,
              nameOther,
              photoOther,
              badgeOther,
              idGroupOther,
              nameGroupOther,
              photoGroupOther,
              account,
              group,
              follow,
              visible,
              type,
            },
          })
          .then((res) => {
            console.log(res);

        //3e requete - api2
        // on obtiens les nouvelles données
        async function troisiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              setIsLoading66FollowFA(false);
              console.log("il s'est abonné");
              console.log(res);
            })
            }
            troisiemeReq();
            //3e requete - api2
            })
            }
            deuxiemeReq();
            //2e requete - api2
            })
            .catch((err) => {
              setErreurConnexionAA(true);
              setIsLoading66FollowFA(false);
            });
            }
            premiereReq();
            //1ere requete - api2

            });
            }
            premiereReq();
            //1ere requete - api1
            } 
            // if (block === "0")
          } // if(idPersonConnectedFA)
  }
  //FollowFA
			

  // favoris (page) - AA
  const [favoriteAA, setFavoriteAA] = useState(false);
  async function FavoriteAA() {
    setFavoriteAA(true);
  }
  async function CloseFavoriteAA() { //fermer
    setFavoriteAA(false);
  }


  // infos666favoriteAA (on passe une petite infos)
  const [infos666favoriteAA, setInfos666favoriteAA] = useState(false);
  async function Infos666favoriteAA() {
    setInfos666favoriteAA(true);
  }
  async function CloseInfos666favoriteAA() { //fermer
    setInfos666favoriteAA(false);
  }


  // popupToRightAA (mini menu) - AA
  const [popupToRightAA, setPopupToRightAA] = useState(false);
  async function PopupToRightAA() {
    setPopupToRightAA(true);
  }
  async function ClosePopupToRightAA() { //fermer
    setPopupToRightAA(false);
  }

  // photoProfile666favoriteAA (Au niveau des Favoris, on selectionne une photo a mettre sur le profil) - AA */}
  const [photoProfile666favoriteAA, setPhotoProfile666favoriteAA] = useState(false);
  async function PhotoProfile666favoriteAA() {
    setPhotoProfile666favoriteAA(true);
  }
  async function ClosePhotoProfile666favoriteAA() { //fermer
    setPhotoProfile666favoriteAA(false);
  }


  // voir photo + nom de la personne connecté - AA
  const [seePhotoWithNamePersonConnectedAA, setSeePhotoWithNamePersonConnectedAA] = useState(false);
  async function SeePhotoWithNamePersonConnectedAA() { //fermer
    setSeePhotoWithNamePersonConnectedAA(true);
  }
  async function CloseSeePhotoWithNamePersonConnectedAA() { //fermer
    setSeePhotoWithNamePersonConnectedAA(false);
  }


  // seePhoto 666favoriteAA (on affiche la photo )
  const [seePhoto666favoriteAA, setSeePhoto666favoriteAA] = useState(false);
  async function CloseSeePhoto666favoriteAA() { //fermer
    setSeePhoto666favoriteAA(false);
  }

  // seeVideo 666favoriteAA (au niveau des favoris on affiche la video)
  const [seeVideo666favoriteAA, setSeeVideo666favoriteAA] = useState(false);
  async function CloseSeeVideo666favoriteAA() { //fermer
    setSeeVideo666favoriteAA(false);
  }


  // PageRedirection (666 ChildApiVideo666favoriteAA)
  async function PageRedirection666ChildApiVideo666favoriteAA() {
    //page - voir une photo
    const seePhoto = localStorage.getItem("GoToSeePhoto666favoriteAA");
    if (seePhoto === "1") { setSeePhoto666favoriteAA(true) }

    //page - voir une video
    const seeVideo = localStorage.getItem("GoToSeeVideo666favoriteAA");
    if (seeVideo === "1") { 
      setSeeVideo666favoriteAA(true) 
      //ca va permettre de marquer les minutes de la video au moment de la lecture
      setConfigurationVideo(false);
      setIsPlaying(true);
      setSon(false);
    }
  }


  // Rencontre - AA
  // on affiche les personnes qui veulent trouver l'amour
  const [rencontreAA, setRencontreAA] = useState(false);
  async function RencontreAA() {
    setVideoAA(false);
    setConversationAA(false);
    setRencontreAA(true);
    setProfilAA(false);
    
    //verificationLogin 
    // on verifie si le mot de passe est toujours le meme pour le garder connecter ou pour l'ejecter
    async function verificationLogin() {
      console.log("aaaa2");
      const writeVirtualNumber = localStorage.getItem("writeVirtualNumberAAforVerificationLoginAA");
      const writePassword = localStorage.getItem("writePasswordAAforVerificationLoginAA");
      
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_VerificationLoginAA}/api/userAA/login`,
        data: {
          virtualNumber: writeVirtualNumber,
          password: writePassword,
        },
      })
      .then((res) => {
       //si le mot de passe enregistré dans le localStorage est different du mot de passe qui se trouve dans la bdd, alors on le deconnecte, cela veut dire que le mot de passe a ete changé
       const incorrectPassword = res.data.incorrectPassword;
       if (incorrectPassword === "1") { localStorage.removeItem("idPersonConnectedAA"); }  
      })
    }
    verificationLogin();
    //verificationLogin

    //avoir de nouvelles donnees sur sa page Alrani
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
      .then((res) => {
        setApiAccountAA(res.data);

    //2e requete
    //2e requete
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

    //3e requete
    //3e requete
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        setApiReactionAA(res.data);

    //4e requete
    //4e requete
    async function quatriemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
      .then((res) => {

    //5e requete
    //5e requete
    async function cinquiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/followerAA`)
      .then((res) => {
        setApiFollowerAA(res.data);

    //6e requete
    //6e requete
    async function sixiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);

    //7e requete
    //7e requete
    async function septiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
      .then((res) => {
        setApiConversationAA(res.data);

    //8e requete
    //8e requete
    async function huitiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
      .then((res) => {
        setApiMessageAA(res.data);

        //9e requete
        //9e requete
        async function neuviemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //10e requete
        //10e requete
        //on obtiens la localisation de l'utilisateur
        async function dixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //11e requete
        //11e requete
        //on enregistre la localisation et la navigation de l'utilisateur
        async function onziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Profil (il etait sur un onglet: home, message,... il a cliquer sur l'icone Profil pour aller sur sa Page Alrani) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //12e requete
        //12e requete
        // on enregistre la date de derniere connexion
        async function douziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          douziemeReq();
          //12e requete
          });
          }
          onziemeReq();
          //11e requete
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
        });
      }
      premiereReq();
      //1ere requete
  }
  async function CloseRencontreAA() { //fermer
    setRencontreAA(false);
  }


  // page pour afficher tout mes abonnés AA
  const [followerAA, setFollowerAA] = useState(false);
  async function FollowerAA() {
    setFollowerAA(true);
  }
  async function CloseFollowerAA() { //fermer
    setFollowerAA(false);
  }

  // page pour afficher tout mes abonnements AA
  const [followingAA, setFollowingAA] = useState(false);
  async function CloseFollowingAA() { //fermer
    setFollowingAA(false);
  }


  // profil - AA
  // on affiche le profil de la personne connecter
  const [profilAA, setProfilAA] = useState(false);
  async function ProfilAA() {
    setConversationAA(false);
    setVideoAA(false);
    setRencontreAA(false);
    setProfilAA(true);

    console.log("aaaa1");
    
    //verificationLogin 
    // on verifie si le mot de passe est toujours le meme pour le garder connecter ou pour l'ejecter
    async function verificationLogin() {
      console.log("aaaa2");
      const writeVirtualNumber = localStorage.getItem("writeVirtualNumberAAforVerificationLoginAA");
      const writePassword = localStorage.getItem("writePasswordAAforVerificationLoginAA");
      
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_VerificationLoginAA}/api/userAA/login`,
        data: {
          virtualNumber: writeVirtualNumber,
          password: writePassword,
        },
      })
      .then((res) => {
       //si le mot de passe enregistré dans le localStorage est different du mot de passe qui se trouve dans la bdd, alors on le deconnecte, cela veut dire que le mot de passe a ete changé
       const incorrectPassword = res.data.incorrectPassword;
       if (incorrectPassword === "1") { localStorage.removeItem("idPersonConnectedAA"); }  
      })
    }
    verificationLogin();
    //verificationLogin

    //avoir de nouvelles donnees sur sa page Alrani
    //1ere requete
    //1ere requete
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
      .then((res) => {
        setApiAccountAA(res.data);

    //2e requete
    //2e requete
    async function deuxiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/postAA`)
      .then((res) => {
        setApiPostAA(res.data);

    //3e requete
    //3e requete
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/reactionAA`)
      .then((res) => {
        setApiReactionAA(res.data);

    //4e requete
    //4e requete
    async function quatriemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
      .then((res) => {

    //5e requete
    //5e requete
    async function cinquiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/followerAA`)
      .then((res) => {
        setApiFollowerAA(res.data);

    //6e requete
    //6e requete
    async function sixiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA`)
      .then((res) => {
        setApiUserAA(res.data);

    //7e requete
    //7e requete
    async function septiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
      .then((res) => {
        setApiConversationAA(res.data);

    //8e requete
    //8e requete
    async function huitiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
      .then((res) => {
        setApiMessageAA(res.data);

        //9e requete
        //9e requete
        async function neuviemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/notificationAA`)
          .then((res) => {
            setApiNotificationAA(res.data);

        //10e requete
        //10e requete
        //on obtiens la localisation de l'utilisateur
        async function dixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //11e requete
        //11e requete
        //on enregistre la localisation et la navigation de l'utilisateur
        async function onziemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Profil (il etait sur un onglet: home, message,... il a cliquer sur l'icone Profil pour aller sur sa Page Alrani) - AA";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //12e requete
        //12e requete
        // on enregistre la date de derniere connexion
        async function douziemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          });
          }
          douziemeReq();
          //12e requete
          });
          }
          onziemeReq();
          //11e requete
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
          });
          }
          septiemeReq();
          //7e requete
          });
          }
          sixiemeReq();
          //6e requete
          });
          }
          cinquiemeReq();
          //5e requete
          });
          }
          quatriemeReq();
          //4e requete
          });
          }
          troisiemeReq();
          //3e requete
          });
          }
          deuxiemeReq();
          //2e requete
        });
      }
      premiereReq();
      //1ere requete
  }
  async function CloseProfilAA() { //fermer
    setProfilAA(false);
  }

  
  //PageRedirection (666profilAA)
  async function PageRedirection666profilAA() {
    localStorage.removeItem("GotoSeePhotoAA"); //on retire ces variables du localStorage car on ne veut pas que ca affiche la page photo lorsqu'on clique sur la video qui est en cours de lecture

    //page - seePost
    const seePost = localStorage.getItem("GoToPageSeePostAA");
    if (seePost === "1") { setSeePost666ProfilAA(true); }

    //page - booster page
    const boosterPage = localStorage.getItem("GoToPageBoosterPageAA");
    if (boosterPage === "1") { setBoosterPage(true); }
  }


  //Monétisation Activé (message de success) - AA
  const [monetizationSuccessAA, setMonetizationSuccessAA] = useState(false);
  async function CloseMonetizationSuccessAA() {
    setMonetizationSuccessAA(false);
  }

    // logique pour activer la Monetization sur sa page Alrani Business - AA
    async function ActivateMonetizationAA() {
    
      // 1ere requete
      // 1ere requete
      // on active la monetization
      async function premiereReq() {
        setOpacity(true);
        const monetization = "1";
        const monetizationBalance = "0";
        const monetizationCommission = "40";

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
          data: {
            monetization,
            monetizationBalance,
            monetizationCommission,
          },
        })
          .then((res) => {
            
          // 2e requete
          // 2e requete
          // on obtiens les nouvelles donnees
          async function deuxiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
          .then((res) => {
            setApiAccountAA(res.data);
            setMonetizationSuccessAA(true);
            setOpacity(false);
          })
          .catch((err) => {
            setOpacity(false);
            setErrorAA(true);
          });
      }
      deuxiemeReq();
      //2e requete
    })
    .catch((err) => {
      setOpacity(false);
      setErrorAA(true);
    });
}
premiereReq();
//1ere requete
}


// alrani Business - AA
const [alraniBusinessAA, setAlraniBusinessAA] = useState(false);
async function AlraniBusinessAA() {
  setAlraniBusinessAA(true);
}
async function CloseAlraniBusinessAA() { //fermer
  setAlraniBusinessAA(false);
}

// infos solde Alrani Business - AA
const [infosBalanceAlraniBusinessAA, setInfosBalanceAlraniBusinessAA] = useState(false);
async function InfosBalanceAlraniBusinessAA() {
  setInfosBalanceAlraniBusinessAA(true);
}
async function CloseInfosBalanceAlraniBusinessAA() { //fermer
  setInfosBalanceAlraniBusinessAA(false);
}



  // conversation - AA
  // conversation - AA
  // logique pour afficher toutes les conversations
  const [apiConversationAA, setApiConversationAA] = useState([]);

   //creer un id pour chaque conversation - AA
  const numberConversationAA = apiConversationAA.filter((api) => api._id);
  const totalConversationAA = numberConversationAA.length;

  const createIdConversationAA = totalConversationAA + 1;
  if (createIdConversationAA) { localStorage.setItem("createIdConversationAA", createIdConversationAA) }


  //on verifie si idOwner egale idPersonConnectedAA (Pour masquer certains boutons a la personne connecter; Pour ne point afficher le bouton Envoyer un message a la personne connecter. Pour eviter qu'il essaie d'envoyer un message a lui meme)
  const personConnectedAA = idOwnerAA === idPersonConnectedAA;  

  // obtenir les conversations non masqué, non supprimé, non disparu
  const filterConversationAA = apiConversationAA.filter((api) => api.hide === "0" && api.deleted === "0" && api.visible === "1");


  // on veut savoir s'il y'a un nouveau message
  //const filterNewMessageAA = apiConversationAA.filter((api) => api.idOwnerLastMessage === !idPersonConnectedAA && api.readLastMessage === "0");
  //const newMessageAA = filterNewMessageAA.length > 0;


  //logique pour debuter une conversation
  async function BeginConversationAA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setOpacity(true);
      
      //1ere requete
      //1ere requete
      // on verifie s'il existe deja une conversation entre les deux utilisateurs
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
        .then((res) => {
          const api = res.data;

          // possibiliterUn
          const possibiliterUn = api.filter((api) => api.idOwner === idPersonConnectedAA && api.idOther === idOwnerAA && api.deleted === "0" && api.hide === "0" && api.visible === "1");
          const verified1 = possibiliterUn.length > 0;
          if (verified1) {
            //console.log("possibilité 1, idOwner est la personne connecté");
            const idConversation1 = possibiliterUn.map((api) => api._id);
            localStorage.setItem("idConversationAA", idConversation1);
            setMessageAA(true);
            setOpacity(false);
          }

          // possibiliterDeux
          const possibiliterDeux = api.filter((api) => api.idOwner === idOwnerAA && api.idOther === idPersonConnectedAA && api.deleted === "0" && api.hide === "0" && api.visible === "1");
          const verified2 = possibiliterDeux.length > 0;
          if (verified2) {
            //console.log("possibilité 2, idOther est la personne connecté");
            const idConversation2 = possibiliterDeux.map((api) => api._id);
            localStorage.setItem("idConversationAA", idConversation2);
            setMessageAA(true);
            setOpacity(false);
          }
          
          // possibiliterTrois
          if (!verified1 && !verified2) {
            //console.log("possibilité 3, il n'existe pas de conversation entre les deux utilisateurs");

            //2e requete
            //2e requete
            // on informe d'abord le destinataire qu'il a recu un nouveau message
            async function deuxiemeReq() {
              const id = localStorage.getItem("idUserOwnerAA");
              const newMessage = "1";

              await axios({
                method: "put",
                url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${id}`,
                data: {
                  newMessage,
                },
              })
              .then((res) => {

            // 3e requete
            // 3e requete
            // on initie la conversation
            async function troisiemeReq() {
              const id = localStorage.getItem("createIdConversationAA");
              //const id = "1";
              const idOther = localStorage.getItem("idOwnerAA");
              const idUserOther = localStorage.getItem("idUserOwnerAA");
              const nameOther = localStorage.getItem("nameOwnerAA");
              const photoOther = localStorage.getItem("photoOwnerAA");
              const badgeOther = localStorage.getItem("badgeOwnerAA");
              const lastMessage = "Click to start the conversation..";
              //const lastMessage = localStorage.getItem("writeMessageAA");
              const connection = "1";
              const display = "1";
              const hide = "0";
              const deleted = "0";
              const visible = "1";
              const type = "1";
              
              await axios({
                method: "post",
                url: `${process.env.REACT_APP_BACKEND}/api/conversationAA/new`,
                data: {
                  id,
                  idOther, // l'autre personne
                  idUserOther,
                  nameOther,
                  photoOther,
                  badgeOther,
                  lastMessage,
                  idOwner: idPersonConnectedAA, // personne connecter
                  idUserOwner: idUserConnectedAA,
                  nameOwner: namePersonConnectedAA,
                  photoOwner: photoPersonConnectedAA,
                  badgeOwner: badgePersonConnectedAA,
                  connection,
                  display,
                  hide,
                  deleted,
                  visible,
                  type,
                },
              })
              .then((res) => {
                const idConversation = res.data._id;
                if (idConversation) { localStorage.setItem("idConversationAA", idConversation); }

                // 4e requete
                // 4e requete
                // on obtiens de nouvelles donnees - apiConversation
                async function quatriemeReq() {
                  await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
                  .then((res) => {
                    setApiConversationAA(res.data);

                //5e requete
                //5e requete
                // on obtiens de nouvelles donnees - apiMessage
                async function cinquiemeReq() {
                  await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
                  .then((res) => {
                    setApiMessageAA(res.data);
                    setMessageAA(true); //on lui affiche la page messageAA (pour lui permettre de causer avec l'autre)
                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                  }
                  cinquiemeReq();
                  //5e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                  }
                  quatriemeReq(); 
                  //4e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                  }
                  troisiemeReq();
                  //3e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                }
                deuxiemeReq();
                //2e requete
              }
              //possibiliterTrois
            })
            .catch((err) => {
              setOpacity(false);
              setErrorAA(true);
            });
          }
          premiereReq();
          //1ere requete
          }// if (block === "0")
        }// if(idPersonConnectedAA)
      }


   // seePhoto2 (page pour voir la photo de la personne connecté)
   const [seePhoto2personConnectedAA, setSeePhoto2personConnectedAA] = useState(false);
   async function SeePhoto2personConnectedAA() {
    setSeePhoto2personConnectedAA(true);
   }
   async function CloseSeePhoto2personConnectedAA() { 
    setSeePhoto2personConnectedAA(false);
   }


   // page pour voir la photo que j'ai recu ou envoyé par message
   const [seePhoto2AA, setSeePhoto2AA] = useState(false);
   async function CloseSeePhoto2AA() { 
    setSeePhoto2AA(false);
    localStorage.removeItem("GoToSeePhoto666ChildApiMessageAA");
   }

 
  // PageRedirection 666ChildApiMessageAA
  async function PageRedirection666ChildApiMessageAA() {

    // GoToSeePhotoAA (page pour voir la photo que j'ai recu ou envoyé par message)
    const seePhoto = localStorage.getItem("GoToSeePhoto666ChildApiMessageAA");
    if (seePhoto === "1") { setSeePhoto2AA(true) }
  }

  
  // message - AA
  // on affiche les messages
  const [messageAA, setMessageAA] = useState(false);
  async function CloseMessageAA() {
    setMessageAA(false);
  }


  
  const idConversationAA = localStorage.getItem("idConversationAA");

  // filtre pour obtenir tout les messages de la discussion - AA
  const filterMessageAA = apiMessageAA.filter((api) => api.idConversation === idConversationAA);

 
  const [myMessageAA, setMyMessageAA] = useState(""); // saisir le message

  // logique pour envoyer un message - AA
  async function SendMessageAA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //on enregistre le message saisi dans le localStorage pour ensuite vider le textarea
      localStorage.setItem("myMessageXA", myMessageAA)
      //ici on vide le textarea
      setMyMessageAA("");

      // AllMessageReq
      async function AllMessageReq() {
        await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
            setApiMessageAA(res.data);
            const api = res.data;
        
    //creer un id pour chaque message envoyé sur X
    const numberMessageXA = api.filter((api) => api._id);
    const totalMessageXA = numberMessageXA.length;
  
    const createIdMessageXA = totalMessageXA + 1;
    if (createIdMessageXA) { localStorage.setItem("createIdMessageXA", createIdMessageXA) }

    //1ere requete
    //1ere requete
    // on envoie le message
    async function premiereReq() {
      const id = localStorage.getItem("createIdMessageXA");
      const idConversation = "";
      const message = localStorage.getItem("myMessageXA");
      const xApp = "3";
      const xDecouverte = "1";
      const display = "1";
      const visible = "1";
      const hide = "0";
      const deleted = "0";
      const type = "1";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_SendMessageAA}/api/messageAA/new`,
      data: {
        id,
        idConversation,
        message,
        idOwner: idPersonConnectedAA,
        nameOwner: namePersonConnectedAA,
        badgeOwner: badgePersonConnectedAA,
        photoOwner: photoPersonConnectedAA,
        xApp,
        xDecouverte,
        display,
        hide,
        deleted,
        visible,
        type,
      },
    })
    .then((res) => {
      const id = res.data._id; //id (cet id va etre utile lorsqu'on voudra mettre si le message a ete lu ou non)
      if (id) { localStorage.getItem("idLastMessage", id); }

      const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
      localStorage.setItem("onlineAA", online);
      console.log(online);
      console.log(res);

      // 2e requete
      // 2e requete
      // cette requete c'est pour recuperer tout les messages de la bdd
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_SendMessageAA}/api/messageAA`)
        .then((res) => {
          setApiMessageAA(res.data);

        // 3e requete
        // 3e requete
        // cette requete c'est pour modifier le dernier message au niveau de la conversation
        async function troisiemeReq() {
          const readLastMessage = "0";
          const idLastMessage = localStorage.getItem("idLastMessage");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SendMessageAA}/api/conversationAA/update/${idConversationAA}`,
            data: {
              lastMessage: myMessageAA,
              readLastMessage,
              idLastMessage,
            },
          })
          .then((res) => {

        // 4e requete
        // 4e requete
        // cette requete c'est pour recuperer toutes les conversations de la bdd
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_SendMessageAA}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);

        //5e requete
        //5e requete
        // on enregistre la date de derniere connexion
        async function cinquiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SendMessageAA}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          .then((res) => {
       
          // 6e requete
          // on recupere les nouvelles données de  la bdd
          async function sixiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_SendMessageAA}/api/accountAA`)
            .then((res) => {
              setApiAccountAA(res.data);

                          // 6e requete
                          // 6e requete
                          /* cette requete c'est pour update le nom, photo, badge des 
                          personnes qui echange dans la conversation */
                          // a chaque message, on update, on remplace l'ancien par le nouveau
                          /* cela va permettre par exemple si la personne a changer de photo de profil
                    ou de nom, au niveau des conversations la nouvelle photo va etre afficher */

                          /*
                          if (idReceiverMessageAA === idPersonConnectedAA) {
                            // si l'idInitieur=idPersonneConnecter,alors on update les infos de l'initieur
                            //l'initieur c'est la personne qui avait initier la conversation pour la toute premiere fois
                            //ici on va update ces infos, son nom, sa photo et son badge
                            async function sixiemeReq() {
                              await axios({
                                method: "put",
                                url: `${process.env.REACT_APP_BACKEND}/api/conversation/update/${idConversationAA}`,
                                data: {
                                  nomDestinataire: nameReceiverMessageAA,
                                  photoProfilDestinataire: verifiedPhotoReceiverAA,
                                  badgeVerifiedDestinataire: verifiedBadgeReceiverAA,
                                },
                              })
                            }
                            sixiemeReq();
                            //6e requete
                          } else {
                            // ici c'est dans le cas ou c'est pas egale
                            // alors on update les infos du destinataire
                            async function sixiemeReq() {
                              await axios({
                                method: "put",
                                url: `${process.env.REACT_APP_BACKEND}/api/conversation/update/${idConversationAA}`,
                                data: {
                                  nomInitieur: nameReceiverMessageAA,
                                  photoProfilInitieur: verifiedPhotoReceiverAA,
                                  badgeVerifiedInitieur: verifiedBadgeReceiverAA,
                                },
                              })
                            }
                            sixiemeReq();
                            //6e requete
                          }
                          // le code du if s'arrete ici
                          */
                    })
                    }
                    sixiemeReq();
                    //6e requete
                    })
                    }
                    cinquiemeReq();
                    //5e requete
                    })
                    }
                    quatriemeReq();
                    //4e requete
                    })
                    }
                    troisiemeReq();
                    //3e requete
                    })
                    }
                    deuxiemeReq();
                    //2e requete
                    })
                  }
                  premiereReq();
                  //1ere requete
                })
                .catch((err) => {
                  setErreur(true);
                })
                }
                AllMessageReq();
                //AllMessageReq
                } 
                // if (block === "0")
              } 
              // if(idPersonConnectedAA)
            }


  // page pour ajouter une photo aux favoris - AA
  const [addPhotoToFavoritePageAA, setAddPhotoToFavoritePageAA] = useState(false);
  async function AddPhotoToFavoritePageAA() {
    setAddPhotoToFavoritePageAA(true);
  }
  async function CloseAddPhotoToFavoritePageAA() { //fermer
    setAddPhotoToFavoritePageAA(false);
  }

  // message de success (photo aux favoris) - AA
  const [successAddPhotoToFavoriteAA, setSuccessAddPhotoToFavoriteAA] = useState(false);
  async function CloseSuccessAddPhotoToFavoriteAA() {
    setSuccessAddPhotoToFavoriteAA(false);
  }

  //logique pour ajouter une photo aux favoris - AA
  async function AddPhotoToFavoriteAA() {
    console.log("a1");
    if (idPersonConnectedAA) {
      console.log("a2");

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
    setIsLoading(true);
    console.log("a3");

    // AllFavoriteReq
    async function AllFavoriteReq() {
      await axios
      .get(`${process.env.REACT_APP_PostAA}/api/favoriteAA`)
      .then((res) => {
        console.log("a4");
        const api = res.data;

    //creer un id pour chaque elements ajouté aux favoris - AA
    const numberFavoriteAA = api.filter((api) => api._id);
    const totalFavoriteAA = numberFavoriteAA.length;

    const createIdFavoriteAA = totalFavoriteAA + 1;
    if (createIdFavoriteAA) { localStorage.setItem("createIdFavoriteAA", createIdFavoriteAA) }
    console.log("a5");

    //1ere requete 
    //1ere requete
    // on envoie la photo sur imagekit
    async function premiereReq() {
      const data = new FormData();
      data.append("image", filePhotoAA);

      await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("a6");
      const urlPhoto = res.data.urlPhoto;
      if (urlPhoto) { localStorage.setItem("urlPhotoAAreq", urlPhoto) }

      //2e requete
      //2e requete
      // on ajoute la photo au favoris
      async function deuxiemeReq() {
        const id = localStorage.getItem("createIdFavoriteAA");
        const urlPhoto = localStorage.getItem("urlPhotoAAreq");
        const urlVideo = "0";
        const display = "1";
        const hide = "0";
        const deleted = "0";
        const visible = "1";
        const approved = "1";
        const connection = "1";
        const type = "1";
      
        await axios({
        method: "post",
        url: `${process.env.REACT_APP_PostPhotoAA}/api/favoriteAA/new`,
        data: {
          id,
          idOwner: idUserConnectedAA,
          urlPhoto,
          urlVideo,
          display,
          hide,
          deleted,
          visible,
          approved,
          connection,
          type,
        },
      })
      .then((res) => {
        console.log("a7");

        //3e requete
        //3e requete
        // on obtiens de nouvelles donnees
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_PostPhotoAA}/api/favoriteAA`)
          .then((res) => {
            console.log("a8");
            setIsLoading(false);
            setSuccessAddPhotoToFavoriteAA(true);
          })
          }
          troisiemeReq();
          //3e requete
          })
          .catch((err) => {
            console.log("a9");
            setIsLoading(false);
            setSuccessAddPhotoToFavoriteAA(true);
          });
          }
          deuxiemeReq();
          //2e requete
        })
        .catch((err) => {
          console.log("a10");
          setIsLoading(false);
          setErrorAA(true);
        });
      }
      premiereReq();
      //1ere requete
      })
      .catch((err) => {
        console.log("a11");
        setErreur(true);
        setIsLoading(false);
      })
      }
      AllFavoriteReq();
      // AllFavoriteReq
      }
      // if (block === "0")
    }
    // if(idPersonConnectedAA)
  }


  // page pour ajouter la photo de couverture de la vidéo - AA 
  const [addCoverVideoPageAA, setAddCoverVideoPageAA] = useState(false);
  async function AddCoverVideoPageAA() {
    setAddCoverVideoPageAA(true);
    localStorage.removeItem("writeDescriptionAA");
  }
  async function CloseAddCoverVideoPageAA() { //fermer
    setAddCoverVideoPageAA(false);
  }

  // logique pour ajouter la photo de couverture de la vidéo aux favoris - AA
  const [isLoadingCoverVideo666favoriteAA, setIsLoadingCoverVideo666favoriteAA] = useState(false);

  async function AddCoverVideoAA() {
    console.log("a1");
    if (idPersonConnectedAA) {
      console.log("a2");

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoadingCoverVideo666favoriteAA(true);
      console.log("a3");

    // AllFavoriteReq
    async function AllFavoriteReq() {
      await axios
      .get(`${process.env.REACT_APP_PostAA}/api/favoriteAA`)
      .then((res) => {
        console.log("a4");
        const api = res.data;

    //creer un id pour chaque elements ajouté aux favoris - AA
    const numberFavoriteAA = api.filter((api) => api._id);
    const totalFavoriteAA = numberFavoriteAA.length;

    const createIdFavoriteAA = totalFavoriteAA + 1;
    if (createIdFavoriteAA) { localStorage.setItem("createIdFavoriteAA", createIdFavoriteAA) }
    console.log("a5");

    //1ere requete
    //1ere requete
    // on envoie l'image sur cloudinary
    async function premiereReq() {
      const data = new FormData();
      data.append("image", filePhotoAA);

      await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("a6");
        const photo = res.data.urlPhoto;
        if (photo) { localStorage.setItem("urlPhotoAAreq", photo); }

      //2e requete
      //2e requete
      // on enregistre l'image dans les favoris
      async function deuxiemeReq() {
        const id = localStorage.getItem("createIdFavoriteAA");
        const urlPhoto = localStorage.getItem("urlPhotoAAreq");
        const urlVideo = "0"; 
        const hide = "0";
        const deleted = "0";
        const display = "1";
        const approved = "1";
        const visible = "1";
        const type = "1";

        await axios({
        method: "post",
        url: `${process.env.REACT_APP_PostPhotoAA}/api/favoriteAA/new`,
        data: {
          id,
          idOwner: idUserConnectedAA,
          urlPhoto,
          urlVideo,
          hide,
          deleted,
          display,
          approved,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log("a7");
        const id = res.data._id; //photo ajoutée! (on enregistre l'id du favoris, cela va nous permettre de lier une video a la photo de couverture qui a ete ajouté aux favoris)
        if (id) { localStorage.setItem("idFavoriteAAreq", id) } 

        const cover = res.data.urlPhoto; //on enregistre la photo de couverture (cela va nous permettre de l'utiliser si on veut publier la video)
        if (cover) { localStorage.setItem("urlPhotoAAreq", cover) } 

      //3e requete
      //3e requete
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/favoriteAA`)
        .then((res) => {
          console.log("a8");
          // photo de couverture ajouté aux favoris! (on affiche la page qui va lui permettre de selectionner la video à lier)
          setIsLoadingCoverVideo666favoriteAA(false);
          setAddCoverVideoPageAA(false);
          setAddVideoPageAA(true);
        })
        }
        troisiemeReq();
        //3e requete
        })
        .catch((err) => {
          console.log("a9");
          setIsLoadingCoverVideo666favoriteAA(false);
          setErreur(true);
        });
        }
        deuxiemeReq();
        //2e requete
        })
        .catch((err) => {
          console.log("a10");
          setIsLoadingCoverVideo666favoriteAA(false);
          setErreur(true);
        });
      }
      premiereReq();
      //1ere requete
    })
    .catch((err) => {
      console.log("a11");
      setErreur(true);
      setIsLoadingCoverVideo666favoriteAA(false);
    })
    }
    AllFavoriteReq();
    // AllFavoriteReq 
    }// if (block === "0")
    }// if(idPersonConnectedAA)
  }



  // page pour choisir la video a ajouter aux favoris
  const [addVideoPageAA, setAddVideoPageAA] = useState(false);
  async function CloseAddVideoPageAA() { 
    setAddVideoPageAA(false);
  }

  // page pour choisir la video a ajouter a une photo - AA
  const [addVideoToPhotoPageAA, setAddVideoToPhotoPageAA] = useState(false);
  async function AddVideoToPhotoPageAA() { 
    setAddVideoToPhotoPageAA(true);
  }
  async function CloseAddVideoToPhotoPageAA() { // fermer
    setAddVideoToPhotoPageAA(false);
  }


  //logique pour ajouter une video aux favoris
  const [fileVideoAA, setFileVideoAA] = useState();
  const [isLoadingVideo666favoriteAA, setIsLoadingVideo666favoriteAA] = useState(false);

  async function AddVideoAA() {
    console.log("a1");
    if (idPersonConnectedAA) {
      console.log("a2");
      setIsLoadingVideo666favoriteAA(true);
    
      //1ere requete
      //1ere requete
      //on envoie la video sur cloudinary
      async function premiereReq() {
        const data = new FormData();
        data.append("video", fileVideoAA);

        await axios
        .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendVideo`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("a3");
          const urlVideo = res.data.secure_url; //url de la Video
          if (urlVideo) { localStorage.setItem("urlVideoAAreq", urlVideo); }

          //2e requete
          //2e requete
          // on lie la video a la photo de couverture (on le fait, en ajoutant tout simplement l'url de la video a la photo de couverture)
          async function deuxiemeReq() {
            //on recupere l'id du favoris (lié a la photo de couverture qu'on avait ajouté)
            const id = localStorage.getItem("idFavoriteAAreq");
            const urlVideo = localStorage.getItem("urlVideoAAreq");

            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/favoriteAA/update/${id}`,
              data: {
                urlVideo,
              },
            })
            .then((res) => {
              console.log("a4");
              // vidéo lié à la photo de couverture (on affiche la page qui va lui permettre d'écrire la description de la video et de publier la video)
              setPostVideoPageAA(true);
              setIsLoadingVideo666favoriteAA(false);
            })
            .catch((err) => {
              console.log("a5");
              setIsLoadingVideo666favoriteAA(false);
              setErrorAA(true);
            })
            }
            deuxiemeReq();
            //2e requete
          })
          .catch((err) => {
            console.log("a6");
            setIsLoadingVideo666favoriteAA(false);
            setErrorAA(true);
          })
        }
        premiereReq();
        //1ere requete
      } //if (idPersonConnectedAA)
  }



  // page pour publier la video - AA 
  const [postVideoPageAA, setPostVideoPageAA] = useState(false);
  async function PostVideoPageAA() { 
    setPostVideoPageAA(true);
  }
  async function ClosePostVideoPageAA() { //fermer
    setPostVideoPageAA(false);
  }

  // logique pour publier une video sur Alrani
  const [isLoading666postVideoPageAA, setIsLoading666postVideoPageAA] = useState(false);

  async function PostVideoAA() {
    if (idPersonConnectedAA) {
      setIsLoading666postVideoPageAA(true);

      // AllPostReq
      async function AllPostReq() { //on a refait la requete car il y'avait des posts ou le createIdPostAA ratait
        await axios
        .get(`${process.env.REACT_APP_PostAA}/api/postAA`)
        .then((res) => {
          setApiPostAA(res.data);
		      const api = res.data;

      //creer un id pour chaque post publié - AA
      const numberPostsAA = api.filter((api) => api._id); //on a mis au pluriel car numberPostAA est deja pris
      const totalPostAA = numberPostsAA.length;

      const createIdPostAA = totalPostAA + 1;
      if (createIdPostAA) { localStorage.setItem("createIdPostAA", createIdPostAA)
    
    //1ere requete
    //1ere requete
    // on publie la video sur Alrani
    async function premiereReq() {
      const id = localStorage.getItem("createIdPostAA");
      const reaction = "0";
      const comment = "0";
      const share = "0";
      const view = "0";
      const clic = "0";
      const clicMyAccount = "0";
      const urlVideo = localStorage.getItem("urlVideoAAreq");
      const coverVideo = localStorage.getItem("urlPhotoAAreq");
      const description = localStorage.getItem("writeDescriptionAA");
      const buttonActivated = "0";
      const monetization = "1";
      const monetizationBalance = "0";
      const filter = localStorage.getItem("countryPersonConnectedAA");
      const display = "1";
      const displayOther = localStorage.getItem("displayOtherAA");
      const home = localStorage.getItem("homeAA");
      const homeVideo = localStorage.getItem("homeVideoAA");
      const visible = "1";
      const hide = "0";
      const deleted = "0";
      const best = "0";
      const approved = "1";
      const connection = "1"; 
      const type = "30";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_PostPhotoAA}/api/postAA/new`,
      data: {
        id,
        idOwner: idPersonConnectedAA,
        idUserOwner: idUserConnectedAA,
        nameOwner: namePersonConnectedAA,
        photoOwner: photoPersonConnectedAA,
        badgeOwner: badgePersonConnectedAA,
        reaction,
        comment,
        share,
        view,
        clic,
        clicMyAccount,
        description,
        buttonActivated,
        monetization,
        monetizationBalance,
        connection,
        filter,
        approved,
        home,
        homeVideo,
        display,
        hide,
        deleted,
        best,
        displayOther,
        visible,
        urlVideo,
        coverVideo,
        type,
      },
    })
    .then((res) => {
      //on prend l'id du nouveau Post, on va l'ajouter au niveau du compte comme etant le dernier post
      const idNewPost = res.data._id;
      if (idNewPost) { localStorage.setItem("idNewPost", idNewPost); }

      //2e requete
      //2e requete
      // obtenir de nouvelles donnees
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
        .then((res) => {
        setApiPostAA(res.data);
        setAddVideoPageAA(false);
        setAddCoverVideoPageAA(false);
        setPostVideoPageAA(false);
        setIsLoading666postVideoPageAA(false);

        //ici on affiche le message de succes
        setPostSuccessAA(true);
        //ici on le fait disparaitre
        async function ClosePostSuccess() {
          setPostSuccessAA(false);
        }
        setTimeout(ClosePostSuccess, 1400);

      //3e requete
      //3e requete
      // on prend l'id du dernier post (pour retirer le dernier post du fil d'actualité)
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostPhotoAA}/api/accountAA`)
        .then((res) => {
          console.log("a7");
        const api = res.data;
        const filtreApiUser = api.filter((api) => api._id === idPersonConnectedAA);
        
        const lastPost = filtreApiUser.map((api) => api.lastPost); //id du dernier post
        if (lastPost) { localStorage.setItem("lastPost", lastPost); }

        const post = api.filter((api) => api._id === idPersonConnectedAA && api.lastPost === "0"); //on vérifie si sur le fil d'actualité 1 post a déjà été publié
        const verifyLastPost = post.length > 0;

        if (verifyLastPost) {
          //dans ce cas: dernier post non present sur le fil d'actualité
          console.log("a8");

          //4e requete
          //4e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function quatriemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {

          //5e requete
          //5e requete
          // obtenir de nouvelles donnees
          async function cinquiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
            .then((res) => {
              setApiPostAA(res.data);

          //6e requete
          //6e requete
          // on obtiens la localisation de l'utilisateur
          async function sixiemeReq() {
            await axios
            .get("https://ip.nf/me.json")
            .then((res) => {
              const getcountryip = res.data.ip.country; //country
              if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

              const getcityip = res.data.ip.city; //city
              if (getcityip) { localStorage.setItem("cityIp", getcityip) }

              const getuserip = res.data.ip.ip; //ip
              if (getuserip) { localStorage.setItem("addressIp", getuserip) }

          //7e requete
          //7e requete
          // on enregistre la localisation et la navigation de l'utilisateur
          async function septiemeReq() {
            const id = localStorage.getItem("createIdNavigationAA");
            const addressIp = localStorage.getItem("addressIp");
            const countryIp = localStorage.getItem("countryIp");
            const cityIp = localStorage.getItem("cityIp");
            const page = "Video publiée! (il a réussi à publier une video) - AA";
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/navigationAA/new`,
              data: {
                id,
                idAccount: idPersonConnectedAA,
                nameAccount: namePersonConnectedAA,
                addressIp,
                countryIp,
                cityIp,
                page,
              },
            })
            .then((res) => {
              console.log("a12");
            const online = res.data.createdAt; //on recupere la date de derniere connexion
            if (online) { localStorage.setItem("onlineAA", online) }

          //8e requete
          //8e requete
          // on enregistre la date de derniere connexion
          async function huitiemeReq() {
            const online = localStorage.getItem("onlineAA");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                online,
              },
            })
            .then((res) => {
              console.log("a13");
            })
            }
            huitiemeReq();
            //8e requete
            });
            }
            septiemeReq();
            //7e requete
            });
            }
            sixiemeReq();
            //6e requete
            })
            }
            cinquiemeReq();
            //5e requete
            })
          }
          quatriemeReq();
          //4e requete
        } else {
          //dans ce cas: dernier post present sur le fil d'actualité
          console.log("a14");

          //4e requete
          //4e requete
          // on retire le dernier post du fil d'actualité
          async function quatriemeReq() {
            const id = localStorage.getItem("lastPost");
            const home = "0";
            const homeVideo = "0";
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/postAA/update/${id}`,
              data: {
                home,
                homeVideo,
              },
            })
            .then((res) => {
              console.log("a15");

          //5e requete
          //5e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function cinquiemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoAA}/api/accountAA/update/${idPersonConnectedAA}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {

            //6e requete
            //6e requete
            // obtenir de nouvelles donnees
            async function sixiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
              .then((res) => {
                setApiPostAA(res.data);
              })
              }
              sixiemeReq();
              //6e requete
              })
              }
              cinquiemeReq();
              //5e requete
              })
              }
              quatriemeReq();
              //4e requete
            }
            //if (verifyLastPost) 
            })
          }
          troisiemeReq();
          //3e requete
      })
      .catch((err) => {

        // ici nous sommes au niveau du .catch de la deuxiemeReq()
        //la 2e requete c'est pour obtenir de nouvelles donnees, si ca rate, alors on va encore insister, on va refaire la requete pour obtenir de nouvelles donnees, ensuite on va l'afficher le message que la video avait deja ete publié
        // get
        async function get() {
          await axios
          .get(`${process.env.REACT_APP_PostPhotoAA}/api/postAA`)
          .then((res) => {
          setApiPostAA(res.data);

          setAddVideoPageAA(false);
          setAddCoverVideoPageAA(false);
          setIsLoading666postVideoPageAA(false);
          //ici on affiche le message de succes
          setPostSuccessAA(true);
          //ici on le fait disparaitre
          async function Close() {
            setPostSuccessAA(false);
          }
          setTimeout(Close, 1400);
        })
        .catch((err) => {
          //si on arrive pas a obtenir tout les posts, alors on lui affiche juste le message que sa video avait deja ete publié
          setAddVideoPageAA(false);
          setAddCoverVideoPageAA(false);
          setIsLoading666postVideoPageAA(false);

          //ici on affiche le message de succes
          setPostSuccessAA(true);
          //ici on le fait disparaitre
          async function Close() {
            setPostSuccessAA(false);
          }
          setTimeout(Close, 1400);
        })
        }
        get();
        //get
      });
      }
      deuxiemeReq();
      //2e requete
      })
      .catch((err) => {
        console.log("a21");
        setErrorAA(true);
        setIsLoading666postVideoPageAA(false);
      });
      }
      premiereReq();
      //1ere requete
    } //if (createIdPostAA)
  })
  .catch((err) => {
    console.log("a22");
    setErreur(true);
    setIsLoading666postVideoPageAA(false);
  })
  }
  AllPostReq();
  // AllPostReq 
  }// if(idPersonConnectedAA)
}


  // moreOptions666messageAA (page pour choisir une option, par exemple: Envoyer une image, Envoyer une vidéo,.. )
  const [moreOptions666messageAA, setMoreOptions666messageAA] = useState(false);
  async function MoreOptions666messageAA() {
    setMoreOptions666messageAA(true);
  }
  async function CloseMoreOptions666messageAA() { //fermer
    setMoreOptions666messageAA(false);
  }


  // envoyer une photo (page pour envoyer une photo par message)
  const [sendPhotoPageAA, setSendPhotoPageAA] = useState(false);
  async function SendPhotoPageAA() {
    setSendPhotoPageAA(true);
  }
  async function CloseSendPhotoPageAA() { //fermer
    setSendPhotoPageAA(false);
  }

  
  // logique pour envoyer une photo par message
  async function SendPhotoAA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
    //setSendPhotoPageAA(false);

    //1ere requete
    //1ere requete
    // on envoie la photo sur imagekit
   /* async function premiereReq() {

      const data = new FormData();
      data.append("image", filePhotoAA);

      await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
      const urlPhoto = res.data.urlPhoto;
      if (urlPhoto) { localStorage.setItem("urlPhotoAAreq", urlPhoto) }*/

      //2e requete
      //2e requete
      // on envoie le message
      async function deuxiemeReq() {
        const id = localStorage.getItem("createIdMessageAA");
        const urlPhoto = localStorage.getItem("urlPhotoAAreq");
        const message = localStorage.getItem("writeDescriptionAA");
        const connection = "1";
        const display = "1";
        const hide = "0";
        const deleted = "0";
        const visible = "1";
        const type = "1";

        await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/messageAA/new`,
        data: {
          id,
          idConversation: idPersonConnectedAA,
          urlPhoto,
          message,
          idOwner: idPersonConnectedAA,
          connection,
          display,
          hide,
          deleted,
          visible,
          type,
        },
      })
      .then((res) => {
        const id = res.data._id; //id (cet id va etre utile lorsqu'on voudra mettre si le message a ete lu ou non)
        if (id) { localStorage.getItem("idLastMessage", id); }
        console.log(res);

      //3e requete
      //3e requete
      // cette requete c'est pour recuperer tout les messages de la bdd
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/messageAA/`)
        .then((res) => {
          setApiMessageAA(res.data);
          console.log(res);

        //4e requete
        //4e requete
        // cette requete c'est pour modifier le dernier message
        async function quatriemeReq() {
          const lastMessage = "1 photo..";
          const readLastMessage = "0";
          const idLastMessage = localStorage.getItem("idLastMessage");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/conversationAA/update/${idConversationAA}`,
            data: {
              lastMessage,
              readLastMessage,
              idLastMessage,
            },
          })
          .then((res) => {

        //5e requete
        //5e requete
        // cette requete c'est pour recuperer toutes les conversations de la bdd
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);

        //6e requete
        //6e requete
        // on obtiens la localisation de l'utilisateur
        async function sixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //7e requete
        //7e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function septiemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Photo envoyé (il a envoyé une photo (par message))";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //8e requete
        //8e requete
        // on enregistre la date de derniere connexion
        async function huitiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          }
          huitiemeReq();
          //8e requete
          })
          }
          septiemeReq();
          //7e requete
          })
          }
          sixiemeReq();
          //6e requete
          })
          }
          cinquiemeReq();
          //5e requete
          })
          }
          quatriemeReq();
          //4e requete
          })
          }
          troisiemeReq();
          // 3e requete
          })
          }
          deuxiemeReq();
          // 2e requete
        /*})
      }
      premiereReq();*/
      //1ere requete
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }


  // envoyer une video (page pour envoyer une video par message) */}
  const [sendVideoPageAA, setSendVideoPageAA] = useState(false);
  async function SendVideoPageAA() {
    setSendVideoPageAA(true);
  }
  async function CloseSendVideoPageAA() { //fermer
    setSendVideoPageAA(false);
  }

  // logique pour envoyer une video par message
  const [isLoading666sendVideoPageAA, setIsLoading666sendVideoPageAA] = useState(false);
  async function SendVideoAA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoading666sendVideoPageAA(true);
    
    //1ere requete
    //1ere requete
    // on envoie la video sur cloudinary
    async function premiereReq() {
      const data = new FormData();
      data.append("video", fileVideoAA);

      await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountAA/sendVideo`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
      const urlVideo = res.data.secure_url; //urlVideo
      if (urlVideo) { localStorage.setItem("urlVideo", urlVideo); }

      // 2e requete
      // 2e requete
      // on envoie le message
      async function deuxiemeReq() {
        const id = localStorage.getItem("createIdMessageAA");
        const urlVideo = localStorage.getItem("urlVideo");
        const read = "0";
        const connection = "1";
        const display = "1";
        const hide = "0";
        const deleted = "0";
        const visible = "1";
        const type = "1";

        await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND}/api/messageAA/new`,
        data: {
          id,
          idConversation: idConversationAA,
          urlVideo,
          idOwner: idPersonConnectedAA,
          read,
          connection,
          display,
          hide,
          deleted,
          visible,
          type,
        },
      })
      .then((res) => {
        const id = res.data._id; //id (cet id va etre utile lorsqu'on voudra mettre si le message a ete lu ou non)
        if (id) { localStorage.getItem("idLastMessage", id); }

        setIsLoading666sendVideoPageAA(false); //vu que la video a deja ete envoyé, alors on peut deja fermer la page qui permet d'envoyer une video 
        setSendVideoPageAA(false);

      // 3e requete
      // 3e requete
      // cette requete c'est pour recuperer tout les messages de la bdd
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
        .then((res) => {
          setApiMessageAA(res.data);

        //4e requete
        //4e requete
        // cette requete c'est pour modifier le dernier message
        async function quatriemeReq() {
          const lastMessage = "1 video..";
          const readLastMessage = "0";
          const idLastMessage = localStorage.getItem("idLastMessage");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/conversationAA/update/${idConversationAA}`,
            data: {
              lastMessage,
              readLastMessage,
              idLastMessage,
            },
          })
          .then((res) => {

        //5e requete
        //5e requete
        // cette requete c'est pour recuperer toutes les conversations de la bdd
        async function cinquiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
          .then((res) => {
            setApiConversationAA(res.data);

        //6e requete
        //6e requete
        // on obtiens la localisation de l'utilisateur
        async function sixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //7e requete
        //7e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function septiemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Vidéo envoyé (il a envoyé une vidéo (par message))";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //8e requete
        //8e requete
        // on enregistre la date de derniere connexion
        async function huitiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          }
          huitiemeReq();
          //8e requete
          })
          }
          septiemeReq();
          //7e requete
          })
          }
          sixiemeReq();
          //6e requete
          })
          }
          cinquiemeReq();
          //5e requete
          })
          }
          quatriemeReq();
          //4e requete
          })
          }
          troisiemeReq();
          //3e requete
          })
          .catch((err) => {
            setIsLoading666sendVideoPageAA(false);
          })
          }
          deuxiemeReq();
          //2e requete
        })
        .catch((err) => {
          setIsLoading666sendVideoPageAA(false);
        })
      }
      premiereReq();
      //1ere requete
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }


  // alrani Pay - AA
  // alrani Pay - AA
  const [alraniPayAA, setAlraniPayAA] = useState(false);
  async function AlraniPayAA() {
    setAlraniPayAA(true);
  }
  async function CloseAlraniPayAA() { //fermer
    setAlraniPayAA(false);
  }

  // infos solde Alrani Pay - AA
  const [infosBalanceAlraniPayAA, setInfosBalanceAlraniPayAA] = useState(false);
  async function InfosBalanceAlraniPayAA() {
    setInfosBalanceAlraniPayAA(true);
  }
  async function CloseInfosBalanceAlraniPayAA() { //fermer
    setInfosBalanceAlraniPayAA(false);
  }


  // Security Alrani Pay - AA
  // Security Alrani Pay - AA
  // mot de passe avant d'entrer dans Alrani Pay
  const [securityAlraniPayAA, setSecurityAlraniPayAA] = useState(false);
  async function SecurityAlraniPayAA() {
    setSecurityAlraniPayAA(true);
  }
  //fermer
  async function CloseSecurityAlraniPayAA() {
    setSecurityAlraniPayAA(false);
  }

  
  // favoris (page) - AA
  // favoris (page) - AA
  // on affiche les favoris
  const [favoritePageAA, setFavoritePageAA] = useState(false);
  async function FavoritePageAA() {
    setFavoritePageAA(true);
  }
  //fermer
  async function CloseFavoritePageAA() {
    setFavoritePageAA(false);
  }

  // videos - AA
  // videos - AA
  const [videosAA, setVideosAA] = useState(false);
  async function VideosAA() {
    setVideosAA(true);
  }
  //fermer
  async function CloseVideosAA() {
    setVideosAA(false);
  }


  // notification - AA
  // notification - AA
  const [notificationAA, setNotificationAA] = useState(false);
  async function NotificationAA() {
    setNotificationAA(true);
  }
  async function CloseNotificationAA() { //fermer
    setNotificationAA(false);
  }

  // on ajoute une photo de profil lors de l'inscription sur florinato
  const [addPhoto666inscriptionPageAA, setAddPhoto666inscriptionPageAA] = useState(false);
  async function AddPhoto666inscriptionPageAA() {
    setAddPhoto666inscriptionPageAA(true);
  }
  async function CloseAddPhoto666inscriptionPageAA() {
    setAddPhoto666inscriptionPageAA(false);
  }


  
  // connexion Page - AA
  // connexion Page - AA
  // on affiche la page qui permet a l'utilisateur de se connecter - AA
  const [connexionPageAA, setConnexionPageAA] = useState(false);
  async function ConnexionPageAA() {
    setConnexionPageAA(true);
    setInscriptionPageAA(false);
  }
  
async function CloseConnexionPageAA() { 
	setTelephoneVirtuel(true); 
	setConnexionPageAA(false); 
}

  // signup - AA
  // signup - AA
  //ici l'utilisateur saisi son nom, numero virtuel, mot de passe - AA
  const [nameSignupAA, setNameSignupAA] = useState("");
  const [numberSignupAA, setNumberSignupAA] = useState("");
  const [passwordSignupAA, setPasswordSignupAA] = useState("");

  if (nameSignupAA) { localStorage.setItem("writeName", nameSignupAA); } //nom
  if (numberSignupAA) { localStorage.setItem("writePhoneNumber", numberSignupAA); } //numero virtuel
  if (passwordSignupAA) { localStorage.setItem("writePassword", passwordSignupAA); } //mot de passe

  const [filePhoto66addPhoto666inscriptionPageAA, setFilePhoto66addPhoto666inscriptionPageAA] = useState();

  //logique pour s'inscrire sur Florinato - FA
  async function SignupFA() {
    setOpacity(true);
    
          // 1ere requete - api1
          // on verifie si la personne est deja inscrite sur Florinato avec ce numero 
          async function premiereReq() {
            await axios
            .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
            .then((res) => {
              // on filtre en fonction du numero saisi - AA
              const writePhoneNumber = localStorage.getItem("writePhoneNumber");

              const api = res.data;
              const filter = api.filter((api) => api.phoneNumber === writePhoneNumber && api.type === "9");

              const verifiedAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
              if (verifiedAlreadySignup) {
                // dans ce cas: numero  deja inscrit (on affiche un message d'erreur, car il y'a deja une personne inscrite avec ce numero virtuel)
                setErreurConnexionAA(true);
                setOpacity(false);
                console.log("numero deja inscrit");
              } else {
                // dans ce cas: numero non inscrit
                // avant d'inscrire l'utilisateur sur Florinato , on envoi d'abord sa photo de profil sur imagekit
                console.log("numero non inscrit");

                //2e requete - api1
                // on envoie la photo sur imagekit
                async function deuxiemeReq() {
                  const data = new FormData();
                  data.append("image", filePhoto66addPhoto666inscriptionPageAA);

                  await axios
                  .post(`${process.env.REACT_APP_Api1}/api/messageFA/sendPhoto`, data, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then((res) => {
                    const urlPhoto = res.data.urlPhoto;
                    if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }
                    console.log("photo envoyer sur i...", res);

            //3e requete - api1
            // on cree un id , on va l'utiliser chaque fois qu'on aura besoin d'un id
            async function troisiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
              .then((res) => {
                setApiMessageFA(res.data);
                const api = res.data;

              //creer un id 
              const numberMessageFA = api.filter((api) => api._id);
              const totalMessageFA = numberMessageFA.length;

              const createId = totalMessageFA + 1;
              if (createId) { localStorage.setItem("createId", createId); }
              console.log("createId :", createId);
              console.log(res);

            //4e requete - api1
            // inscrire l'utilisateur (numero  non inscrit, alors on lui laisse s'inscrire)
            async function quatriemeReq() {
              const id = localStorage.getItem("createId");
              const writeName = localStorage.getItem("writeName");
              const writePhoneNumber = localStorage.getItem("writePhoneNumber");
              const writePassword = localStorage.getItem("writePassword");
              const block = "0";
              const type = "9";
              
              console.log("writeName", writeName);
              console.log("writePhoneNumber", writePhoneNumber);
              console.log("writePassword", writePassword);
              
              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
                data: {
                  id,
                  nameUser: writeName,
                  phoneNumber: writePhoneNumber,
                  password: writePassword,
                  block,
                  type,
                },
              })
              .then((res) => {
              // utilisateur enregistré! on prend l'idUser, on va l'ajouter au niveau de son compte AA
              const id = res.data._id;
              if (id) { localStorage.setItem("idUser", id); }

              const online = res.data.createdAt; // on prend la date de derniere connexion
              if (online) { localStorage.setItem("online", online); }

              const block = res.data.block; // block
              if (block) { localStorage.setItem("blockFA", block); }

              console.log("idUser", id);
              console.log("online", online);
              console.log("blockFA", block);
              console.log(res);

                //5e requete - api1
                // on cree son compte 
                async function cinquiemeReq() {
                  const id = localStorage.getItem("createId");
                  const idUser = localStorage.getItem("idUser"); 
                  const writeName = localStorage.getItem("writeName");
                  const badge = "0";
                  const photoProfile = localStorage.getItem("urlPhotoreq");
                  const online = localStorage.getItem("online");
                  const popularity = "0";
                  const visible = "1";
                  const type = "10";
                  const florinatoApp = "1";

                  await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
                    data: {
                      id,
                      idUser,
                      nameAccount: writeName,
                      phoneNumber: writePhoneNumber,
                      badge,
                      photoProfile,
                      online,
                      popularity,
                      visible,
                      type,
                      florinatoApp,
                    },
                  })
                  .then((res) => {
                    // on prend l'idAccount, on va l'utiliser pour mettre l'idPhotoProfile sur son compte
                    const id = res.data._id;
                    if (id) { localStorage.setItem("idAccount", id); }
                    console.log(id, "idAccount");
                    
            //6e requete - api1
            // on cree son groupe
            async function sixiemeReq() {
              const id = localStorage.getItem("createId");
              const idAccount = localStorage.getItem("idAccount");
              const photoGroup = localStorage.getItem("urlPhotoreq");
              const photo2Group = localStorage.getItem("urlPhotoreq");
              const badgeGroup = "0";
              const visit = "0";
              const clic = "0";
              const visible = "1";
              const type = "11";

              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
                data: {
                  id,
                  idAccount, 
                  nameGroup: writeName,
                  photoGroup,
                  photo2Group,
                  badgeGroup,
                  visit,
                  clic,
                  visible,
                  type,
                },
              })
              .then((res) => {
                const id = res.data._id; //on prend l'id du groupe pour l'ajouter au niveau du compte
                if (id) { localStorage.setItem("idGroup", id); }
                console.log(id, "idGroup");
                console.log(res);

            //7e requete - api1
            // on met la photo de profil dans l'album photo de profil
            async function septiemeReq() {
              const id = localStorage.getItem("createId");
              const photoProfile = localStorage.getItem("urlPhotoreq");
              const idAccount = localStorage.getItem("idAccount");
              const popularity = "0";
              const visible = "1";
              const type = "12"; //album photo de profil

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
            data: {
              id,
              photoProfile,
              idAccount,
              popularity,
              visible, 
              type,
            },
          })
          .then((res) => {
            const id = res.data._id; //on prend l'id de la Photo de Profil
            if (id) { localStorage.setItem("idPhotoProfile", id); }
            console.log(id, "idPhoto");
            console.log(res);

        //8e requete - api1
        // on met l'idPhotoProfile sur son compte
        async function huitiemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const idPhotoProfile = localStorage.getItem("idPhotoProfile");
          const idGroup = localStorage.getItem("idGroup");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idAccount}`, 
            data: {
              idPhotoProfile,
              idGroup,
            },
            })
            .then((res) => {
            console.log("l'id de la photo de profil a ete mis sur le compte");
            console.log(res);

        //9e requete - api1
        // on met l'idAccount au niveau du user (car c'est le compte principal)
        async function neuviemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const idUser = localStorage.getItem("idUser");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idUser}`,
            data: {
              idAccount,
            },
            })
            .then((res) => {
            console.log("l'idAccount a ete mis au niveau du user");
            console.log(res);

                  //10e requete - api1
                  // on met la photo de profil dans les favoris
                  async function dixiemeReq() {
                    const id = localStorage.getItem("createId");
                    const idUser = localStorage.getItem("idUser");
                    const urlPhoto = localStorage.getItem("urlPhotoreq");
                    const urlVideo = "0";
                    const visible = "1";
                    const type = "20";
                  
                    await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
                    data: {
                      id,
                      idUser,
                      urlPhoto,
                      urlVideo,
                      visible,
                      type,
                    },
                  })
                  .then((res) => {
                    console.log("photo ajouter aux favoris", res);

                    //inscription reussie , alors on le connecte directement sur florinato
                    //on enregistre l'idAccount pour le maintenir connecté !
					const idAccount = localStorage.getItem("idAccount");
                    const idGroup = localStorage.getItem("idGroup");
                    if (idAccount) {
						localStorage.setItem("idPersonConnectedFA", idAccount);
						localStorage.setItem("idAccountChef", idAccount); 
						localStorage.setItem("idGroupChef", idGroup); 
						setIdPersonConnectedFA(idAccount);
						
						console.log("idPersonConnectedFA", idPersonConnectedFA);
						console.log("idAccount", idAccount);
					}
					
                    const idUser = localStorage.getItem("idUser");
                    if (idUser) { localStorage.setItem("idUserConnectedFA", idUser); }

                    console.log("inscription reussie, idPersonConnectedFA", idAccount);
                    console.log("idUserConnectedFA", idUser);

              //11e requete - api1
              // obtenir de nouvelles données
              async function onziemeReq() {
                await axios
                  .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
                  .then((res) => {
                    setApiMessageFA(res.data);
                    console.log(res);
    
                    //connexion reussie, on affiche la page d'accueil de la messagerie
                    setAddPhoto666inscriptionPageAA(false);
                    setInscriptionPageAA(false);
                    setTelephoneVirtuel(true);
                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  onziemeReq();
                  //11e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  dixiemeReq();
                  //10e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  neuviemeReq();
                  //9e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  huitiemeReq();
                  //8e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  septiemeReq();
                  //7e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  sixiemeReq();
                  //6e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  cinquiemeReq();
                  //5e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  quatriemeReq();
                  //4e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  troisiemeReq();
                  //3e requete - api1
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  deuxiemeReq();
                  // 2e requete - api1
              }
              // le if de verifiedAlreadySignup se ferme ici
        })
        .catch((err) => {
          
          // 1ere requete - api2
          // on verifie si la personne est deja inscrite sur Florinato avec ce numero 
          async function premiereReq() {
            await axios
            .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
            .then((res) => {
              // on filtre en fonction du numero saisi - AA
              const writePhoneNumber = localStorage.getItem("writePhoneNumber");

              const api = res.data;
              const filter = api.filter((api) => api.phoneNumber === writePhoneNumber && api.type === "9");

              const verifiedAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
              if (verifiedAlreadySignup) {
                // dans ce cas: numero  deja inscrit (on affiche un message d'erreur, car il y'a deja une personne inscrite avec ce numero virtuel)
                setErreurConnexionAA(true);
                setOpacity(false);
                console.log("numero deja inscrit");
              } else {
                // dans ce cas: numero non inscrit
                // avant d'inscrire l'utilisateur sur Florinato , on envoi d'abord sa photo de profil sur imagekit
                console.log("numero non inscrit");

                //2e requete - api2
                // on envoie la photo sur imagekit
                async function deuxiemeReq() {
                  const data = new FormData();
                  data.append("image", filePhoto66addPhoto666inscriptionPageAA);

                  await axios
                  .post(`${process.env.REACT_APP_Api2}/api/messageFA/sendPhoto`, data, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then((res) => {
                    const urlPhoto = res.data.urlPhoto;
                    if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }
                    console.log("photo envoyer sur i...", res);

            //3e requete - api2
            // on cree un id , on va l'utiliser chaque fois qu'on aura besoin d'un id
            async function troisiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
              .then((res) => {
                setApiMessageFA(res.data);
                const api = res.data;

              //creer un id 
              const numberMessageFA = api.filter((api) => api._id);
              const totalMessageFA = numberMessageFA.length;

              const createId = totalMessageFA + 1;
              if (createId) { localStorage.setItem("createId", createId); }
              console.log("createId :", createId);
              console.log(res);

            //4e requete - api2
            // inscrire l'utilisateur (numero  non inscrit, alors on lui laisse s'inscrire)
            async function quatriemeReq() {
              const id = localStorage.getItem("createId");
              const writeName = localStorage.getItem("writeName");
              const writePhoneNumber = localStorage.getItem("writePhoneNumber");
              const writePassword = localStorage.getItem("writePassword");
              const block = "0";
              const type = "9";
              
              console.log("writeName", writeName);
              console.log("writePhoneNumber", writePhoneNumber);
              console.log("writePassword", writePassword);
              
              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
                data: {
                  id,
                  nameUser: writeName,
                  phoneNumber: writePhoneNumber,
                  password: writePassword,
                  block,
                  type,
                },
              })
              .then((res) => {
              // utilisateur enregistré! on prend l'idUser, on va l'ajouter au niveau de son compte AA
              const id = res.data._id;
              if (id) { localStorage.setItem("idUser", id); }

              const online = res.data.createdAt; // on prend la date de derniere connexion
              if (online) { localStorage.setItem("online", online); }

              const block = res.data.block; // block
              if (block) { localStorage.setItem("blockFA", block); }

              console.log("idUser", id);
              console.log("online", online);
              console.log("blockFA", block);
              console.log(res);

              //5e requete - api2
              // on cree son compte 
                async function cinquiemeReq() {
                  const id = localStorage.getItem("createId");
                  const idUser = localStorage.getItem("idUser"); 
                  const writeName = localStorage.getItem("writeName");
                  const badge = "0";
                  const photoProfile = localStorage.getItem("urlPhotoreq");
                  const online = localStorage.getItem("online");
                  const popularity = "0";
                  const visible = "1";
                  const type = "10";
                  const florinatoApp = "1";

                  await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
                    data: {
                      id,
                      idUser,
                      nameAccount: writeName,
                      phoneNumber: writePhoneNumber,
                      badge,
                      photoProfile,
                      online,
                      popularity,
                      visible,
                      type,
                      florinatoApp,
                    },
                  })
                  .then((res) => {
                    // on prend l'idAccount, on va l'utiliser pour mettre l'idPhotoProfile sur son compte
                    const id = res.data._id;
                    if (id) { localStorage.setItem("idAccount", id); }
                    console.log(id, "idAccount");

            //6e requete - api2
            // on cree son groupe
            async function sixiemeReq() {
              const id = localStorage.getItem("createId");
              const idAccount = localStorage.getItem("idAccount");
              const photoGroup = localStorage.getItem("urlPhotoreq");
              const photo2Group = localStorage.getItem("urlPhotoreq");
              const badgeGroup = "0";
              const visit = "0";
              const clic = "0";
              const visible = "1";
              const type = "11";

              await axios({
                method: "post",
                url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
                data: {
                  id,
                  idAccount, 
                  nameGroup: writeName,
                  photoGroup,
                  photo2Group,
                  badgeGroup,
                  visit,
                  clic,
                  visible,
                  type,
                },
              })
              .then((res) => {
                const id = res.data._id; //on prend l'id du groupe pour l'ajouter au niveau du compte
                if (id) { localStorage.setItem("idGroup", id); }
                console.log(id, "idGroup");
                console.log(res);

            //7e requete - api2
            // on met la photo de profil dans l'album photo de profil
            async function septiemeReq() {
              const id = localStorage.getItem("createId");
              const photoProfile = localStorage.getItem("urlPhotoreq");
              const idAccount = localStorage.getItem("idAccount");
              const popularity = "0";
              const visible = "1";
              const type = "12"; //album photo de profil

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
            data: {
              id,
              photoProfile,
              idAccount,
              popularity,
              visible, 
              type,
            },
          })
          .then((res) => {
            const id = res.data._id; //on prend l'id de la Photo de Profil
            if (id) { localStorage.setItem("idPhotoProfile", id); }
            console.log(id, "idPhoto");
            console.log(res);

        //8e requete - api2
        // on met l'idPhotoProfile sur son compte
        async function huitiemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const idPhotoProfile = localStorage.getItem("idPhotoProfile");
          const idGroup = localStorage.getItem("idGroup");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idAccount}`, 
            data: {
              idPhotoProfile,
              idGroup,
            },
            })
            .then((res) => {
            console.log("l'id de la photo de profil a ete mis sur le compte");
            console.log(res);

        //9e requete - api2
        // on met l'idAccount au niveau du user (car c'est le compte principal)
        async function neuviemeReq() {
          const idAccount = localStorage.getItem("idAccount");
          const idUser = localStorage.getItem("idUser");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idUser}`,
            data: {
              idAccount,
            },
            })
            .then((res) => {
            console.log("l'idAccount a ete mis au niveau du user");
            console.log(res);

            //10e requete - api2
            // on met la photo de profil dans les favoris
                  async function dixiemeReq() {
                    const id = localStorage.getItem("createId");
                    const idUser = localStorage.getItem("idUser");
                    const urlPhoto = localStorage.getItem("urlPhotoreq");
                    const urlVideo = "0";
                    const visible = "1";
                    const type = "20";
                  
                    await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
                    data: {
                      id,
                      idUser,
                      urlPhoto,
                      urlVideo,
                      visible,
                      type,
                    },
                  })
                  .then((res) => {

                    //inscription reussie , alors on le connecte directement sur florinato
                    //on enregistre l'idAccount pour le maintenir connecté !
                    const idAccount = localStorage.getItem("idAccount");
                    const idGroup = localStorage.getItem("idGroup");
                    if (idAccount) { 
						localStorage.setItem("idPersonConnectedFA", idAccount);
						localStorage.setItem("idAccountChef", idAccount); 
						localStorage.setItem("idGroupChef", idGroup); 
						setIdPersonConnectedFA(idAccount);
						
						console.log("idPersonConnectedFA", idPersonConnectedFA);
						console.log("idAccount", idAccount);
					}

                    const idUser = localStorage.getItem("idUser");
                    if (idUser) { localStorage.setItem("idUserConnectedFA", idUser); }

              //11e requete - api2
              // obtenir de nouvelles données
              async function onziemeReq() {
                await axios
                  .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
                  .then((res) => {
                    setApiMessageFA(res.data);
    
                    //connexion reussie, on affiche la page d'accueil de la messagerie
                    setAddPhoto666inscriptionPageAA(false);
                    setInscriptionPageAA(false);
                    setTelephoneVirtuel(true);
                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurConnexionAA(true);
                  });
                  }
                  onziemeReq();
                  //11e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                dixiemeReq();
                //10e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                neuviemeReq();
                //9e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                huitiemeReq();
                //8e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                septiemeReq();
                //7e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                sixiemeReq();
                //6e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                cinquiemeReq();
                //5e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                quatriemeReq();
                //4e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                troisiemeReq();
                //3e requete - api2
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                deuxiemeReq();
                //2e requete - api2
                } //le if de verifiedAlreadySignup se ferme ici
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurConnexionAA(true);
                });
                }
                premiereReq();
                //1ere requete - api2
          });
          }
          premiereReq();
          // 1ere requete - api1
  }

  

  // login - AA
  // login - AA
  // saisir :
  const [numberLoginAA, setNumberLoginAA] = useState(""); //numero virtuel
  const [passwordLoginAA, setPasswordLoginAA] = useState(""); //mot de passe

  if (numberLoginAA) {
    localStorage.setItem("writePhoneNumberFA", numberLoginAA); 
    localStorage.setItem("writeVirtualNumberAAforVerificationLoginAA", numberLoginAA); 
  }

  if (passwordLoginAA) {
    localStorage.setItem("writePasswordFA", passwordLoginAA); 
    localStorage.setItem("writePasswordAAforVerificationLoginAA", passwordLoginAA); 
  } 

  //logique pour se connecter sur Florinato - FA
  async function LoginFA() {
    setOpacity(true);

    //1ere requete - api1
    // on verifie si la personne est deja inscrite sur Florinato avec ce numero 
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        // on filtre en fonction du numero  saisi
        const writePhoneNumber = localStorage.getItem("writePhoneNumberFA");
        const writePassword = localStorage.getItem("writePasswordFA");
        setApiMessageFA(res.data);

        const api = res.data;
        const filterUser = api.filter((api) => api.phoneNumber === writePhoneNumber && api.password === writePassword && api.type === "9");
        console.log("filterUser", filterUser);
        console.log(res);

        const verifyAlreadySignup = filterUser.length > 0; // verifyAlreadySignup > 0 numero deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
        if (verifyAlreadySignup) {
            // dans ce cas: numero  deja inscrit
            console.log("numero deja inscrit");

            const idAccount = filterUser.map((api) => api.idAccount); //on enregistre l'idAccount pour le maintenir connecté !
            
			if (idAccount) { 
				localStorage.setItem("idPersonConnectedFA", idAccount); 
				setIdPersonConnectedFA(idAccount);
				
				console.log("idPersonConnectedFA", idPersonConnectedFA);
				console.log("idAccount", idAccount);
			}

            const idUser = filterUser.map((api) => api._id); 
            if (idUser) { localStorage.setItem("idUserConnectedFA", idUser); }

            const block = filterUser.map((api) => api.block); //on enregistre block , ça va etre utile si on veut bloquer le compte
            if (block) { localStorage.setItem("blockFA", block); }
            
            console.log("connexion reussie, idPersonConnectedFA", idAccount);
            console.log("idUserConnectedFA", idUser);
            console.log("block", block);

            //connexion reussie, on affiche le message de success
            setOpacity(false);
            setConnexionSuccessAA(true); 
          } else {
            // numero virtuel non inscrit, impossible de se connecter
            setOpacity(false);
            setErreurConnexionAA(true);
            console.log("numero non inscrit");
          }
          //le if de verifyAlreadySignup se ferme ici
        })
        .catch((err) => {
          
    //1ere requete - api2
    // on verifie si la personne est deja inscrite sur Florinato avec ce numero 
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        // on filtre en fonction du numero  saisi
        const writePhoneNumber = localStorage.getItem("writePhoneNumberFA");
        const writePassword = localStorage.getItem("writePasswordFA");
        setApiMessageFA(res.data);

        const api = res.data;
        const filterUser = api.filter((api) => api.phoneNumber === writePhoneNumber && api.password === writePassword && api.type === "9");
        console.log("filterUser", filterUser);
        console.log(res);

        const verifyAlreadySignup = filterUser.length > 0; // verifyAlreadySignup > 0 numero deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
        if (verifyAlreadySignup) {
            // dans ce cas: numero  deja inscrit
            console.log("numero deja inscrit");

            const idAccount = filterUser.map((api) => api.idAccount); //on enregistre l'idAccount pour le maintenir connecté !
			if (idAccount) { 
				localStorage.setItem("idPersonConnectedFA", idAccount); 
				setIdPersonConnectedFA(idAccount);
				
				console.log("idPersonConnectedFA", idPersonConnectedFA);
				console.log("idAccount", idAccount);
			}

            const idUser = filterUser.map((api) => api._id); 
            if (idUser) { localStorage.setItem("idUserConnectedFA", idUser); }

            const block = filterUser.map((api) => api.block); //on enregistre block , ça va etre utile si on veut bloquer le compte
            if (block) { localStorage.setItem("blockFA", block); }
            
            console.log("connexion reussie, idPersonConnectedFA", idAccount);
            console.log("idUserConnectedFA", idUser);
            console.log("block", block);

            //connexion reussie, on affiche le message de success
            setOpacity(false);
            setConnexionSuccessAA(true); 
          } else {
            // numero virtuel non inscrit, impossible de se connecter
            setOpacity(false);
            setErreurConnexionAA(true);
            console.log("numero non inscrit");
          }
          //le if de verifyAlreadySignup se ferme ici
        })
        .catch((err) => {
          setOpacity(false);
          setErreurConnexionAA(true);
        });
        }
        premiereReq();
        //1ere requete - api2

        });
        }
        premiereReq();
        //1ere requete - api1
  }


  //Moyen de Paiement (page) - AA
  //Moyen de Paiement (page) - AA
  /*le card ci va permettre a la personne d'entrer le code pin pour lier un moyen de
  paiement lors de l'inscription sur Alrani */
  const [moyenPaiementPageAA, setMoyenPaiementPageAA] = useState(false);
  async function CloseMoyenPaiementPageAA() {
    setMoyenPaiementPageAA(false);
  }

  // super code (inscription) - AA
  // super code (inscription) - AA
  // le card ci va permettre a la personne d'entrer le super code
  const [superCodePageAA, setSuperCodePageAA] = useState(false);
  async function SuperCodePageAA() {
    setSuperCodePageAA(true);
  }
  //fermer
  async function CloseSuperCodePageAA() {
    setSuperCodePageAA(false);
  }

  // super code - AA
  // super code - AA
  // on affiche la liste des super code qui ont ete ajouter au compte
  const [superCodeAA, setSuperCodeAA] = useState(false);
  async function SuperCodeAA() {
    setSuperCodeAA(true);
  }
  //fermer
  async function CloseSuperCodeAA() {
    setSuperCodeAA(false);
  }

  // partenariat - AA
  // partenariat - AA
  const [partnershipAA, setPartnershipAA] = useState(false);
  async function PartnershipAA() {
    setPartnershipAA(true);
  }
  //fermer
  async function ClosePartnershipAA() {
    setPartnershipAA(false);
  }

  // partenariat Deals - AA
  // partenariat Deals - AA
  const [partnershipDealsAA, setPartnershipDealsAA] = useState(false);
  async function PartnershipDealsAA() {
    setPartnershipDealsAA(true);
  }
  //fermer
  async function ClosePartnershipDealsAA() {
    setPartnershipDealsAA(false);
  }

  // partenariat Formation - AA
  // partenariat Formation - AA
  const [partnershipFormationAA, setPartnershipFormationAA] = useState(false);
  async function PartnershipFormationAA() {
    setPartnershipFormationAA(true);
  }
  //fermer
  async function ClosePartnershipFormationAA() {
    setPartnershipFormationAA(false);
  }

  // statistique - AA
  // statistique - AA
  // on affiche les statistiques detaillées
  const [statisticAA, setStatisticAA] = useState(false);
  async function StatisticAA() {
    setStatisticAA(true);
  }
  //fermer
  async function CloseStatisticAA() {
    setStatisticAA(false);
  }

  // statistique deals - AA
  // statistique deals - AA
  const [statisticDealsAA, setStatisticDealsAA] = useState(false);
  async function StatisticDealsAA() {
    setStatisticDealsAA(true);
  }
  //fermer
  async function CloseStatisticDealsAA() {
    setStatisticDealsAA(false);
  }

  // statistique Formation - AA
  // statistique Formation - AA
  const [statisticFormationAA, setStatisticFormationAA] = useState(false);
  async function StatisticFormationAA() {
    setStatisticFormationAA(true);
  }
  //fermer
  async function CloseStatisticFormationAA() {
    setStatisticFormationAA(false);
  }

  // music - AA
  // music - AA
  const [musicAA, setMusicAA] = useState(false);
  async function MusicAA() {
    setMusicAA(true);
  }
  //fermer
  async function CloseMusicAA() {
    setMusicAA(false);
  }

  // music Deals - AA
  // music Deals - AA
  const [musicDealsAA, setMusicDealsAA] = useState(false);
  async function MusicDealsAA() {
    setMusicDealsAA(true);
  }
  //fermer
  async function CloseMusicDealsAA() {
    setMusicDealsAA(false);
  }

  // music Formation - AA
  // music Formation - AA
  const [musicFormationAA, setMusicFormationAA] = useState(false);
  async function MusicFormationAA() {
    setMusicFormationAA(true);
  }
  //fermer
  async function CloseMusicFormationAA() {
    setMusicFormationAA(false);
  }

  // statut - AA
  // statut - AA
  const [statutAA, setStatutAA] = useState(false);
  async function StatutAA() {
    setStatutAA(true);
  }
  //fermer
  async function CloseStatutAA() {
    setStatutAA(false);
  }

  // statut Deals - AA
  // statut Deals - AA
  const [statutDealsAA, setStatutDealsAA] = useState(false);
  async function StatutDealsAA() {
    setStatutDealsAA(true);
  }
  //fermer
  async function CloseStatutDealsAA() {
    setStatutDealsAA(false);
  }

  // statut Formation - AA
  // statut Formation - AA
  const [statutFormationAA, setStatutFormationAA] = useState(false);
  async function StatutFormationAA() {
    setStatutFormationAA(true);
  }
  //fermer
  async function CloseStatutFormationAA() {
    setStatutFormationAA(false);
  }

  // migration - AA
  // migration - AA
  const [migrationAA, setMigrationAA] = useState(false);
  async function MigrationAA() {
    setMigrationAA(true);
  }
  //fermer
  async function CloseMigrationAA() {
    setMigrationAA(false);
  }

  // migration Deals - AA
  // migration Deals - AA
  const [migrationDealsAA, setMigrationDealsAA] = useState(false);
  async function MigrationDealsAA() {
    setMigrationDealsAA(true);
  }
  //fermer
  async function CloseMigrationDealsAA() {
    setMigrationDealsAA(false);
  }

  // migration formation - AA
  // migration formation - AA
  const [migrationFormationAA, setMigrationFormationAA] = useState(false);
  async function MigrationFormationAA() {
    setMigrationFormationAA(true);
  }
  //fermer
  async function CloseMigrationFormationAA() {
    setMigrationFormationAA(false);
  }

  // group - AA
  // group - AA
  const [groupAA, setGroupAA] = useState(false);
  async function GroupAA() {
    setGroupAA(true);
  }
  //fermer
  async function CloseGroupAA() {
    setGroupAA(false);
  }

  // group Deals - AA
  // group Deals - AA
  const [groupDealsAA, setGroupDealsAA] = useState(false);
  async function GroupDealsAA() {
    setGroupDealsAA(true);
  }
  //fermer
  async function CloseGroupDealsAA() {
    setGroupDealsAA(false);
  }

  // group Formation - AA
  // group Formation - AA
  const [groupFormationAA, setGroupFormationAA] = useState(false);
  async function GroupFormationAA() {
    setGroupFormationAA(true);
  }
  //fermer
  async function CloseGroupFormationAA() {
    setGroupFormationAA(false);
  }

  // Tools - AA
  // ici il ya mes outils
  const [toolsAA, setToolsAA] = useState(false);
  async function ToolsAA() {
    setToolsAA(true);
  }
  //fermer
  async function CloseToolsAA() {
    setToolsAA(false);
  }

  // Plus - AA
  // sur cette page on affiche les outils a activer
  const [plusAA, setPlusAA] = useState(false);
  async function PlusAA() {
    setPlusAA(true);
  }
  //fermer
  async function ClosePlusAA() {
    setPlusAA(false);
  }

  // activation Alrani monetization - AA
  // sur cette page l'utilisateur va activer Alrani monetization
  const [activateMonetizationPageAA, setActivateMonetizationPageAA] = useState(false);
  async function ActivateMonetizationPageAA() {
    setActivateMonetizationPageAA(true);
  }
  //fermer
  async function CloseActivateMonetizationPageAA() {
    setActivateMonetizationPageAA(false);
  }

  // page pour saisir le super code - (666 activateMonetizationPageAA)
  const [writeSuperCode666ActivateMonetizationPageAA, setWriteSuperCode666ActivateMonetizationPageAA] = useState(false);
  async function WriteSuperCode666ActivateMonetizationPageAA() {
    setWriteSuperCode666ActivateMonetizationPageAA(true);
  }
  //fermer
  async function CloseWriteSuperCode666ActivateMonetizationPageAA() {
    setWriteSuperCode666ActivateMonetizationPageAA(false);
  }

  // saisir le super code pour l'activation de Alrani monetization
  const [superCodeWrittenAA, setSuperCodeWrittenAA] = useState("");

  if (superCodeWrittenAA) {
    localStorage.setItem("https://alrani.com/superCodeWrittenAA", superCodeWrittenAA);
  }



  // activate Monetization Deals (Page) - AA
  // sur cette page on active la Monetization Deals - AA
  const [activateMonetizationDealsPageAA, setActivateMonetizationDealsPageAA] = useState(false);
  async function ActivateMonetizationDealsPageAA() {
    setActivateMonetizationDealsPageAA(true);
  }
  //fermer
  async function CloseActivateMonetizationDealsPageAA() {
    setActivateMonetizationDealsPageAA(false);
  }

  // activate Monetization Formation (Page) - AA
  // sur cette page on active la Monetization Formation - AA
  const [activateMonetizationFormationPageAA, setActivateMonetizationFormationPageAA] = useState(false);
  async function ActivateMonetizationFormationPageAA() {
    setActivateMonetizationFormationPageAA(true);
  }
  //fermer
  async function CloseActivateMonetizationFormationPageAA() {
    setActivateMonetizationFormationPageAA(false);
  }

  // Alrani Monetization
  // Alrani Monetization
  // Alrani Monetization


  
  // logique pour recevoir son argent (=> Alrani Monetization vers izocash)
  const [
    writeAmountReceive666MonetizationPageAA,
    setWriteAmountReceive666MonetizationPageAA,
  ] = useState("");
  /*on enregitre le montant saisi dans le localStorage avant de faire le calcul car ca ne
  marche pas sans avoir enregistrer d'abord le montant saisi dans le localStorage */
  if (writeAmountReceive666MonetizationPageAA) {
    localStorage.setItem(
      "https://alrani.com/writeAmountReceive",
      writeAmountReceive666MonetizationPageAA
    );
  }
  async function Receive666MonetizationPageAA() {
    setOpacity(true);

    // 1ere requete
    // 1ere requete
    // verifier son solde alrani monetization
    /* on verifie son solde alrani monetization, cela va nous permettre de debiter son solde 
    puis envoyer cet argent dans son compte izocash */
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userAA/`)
      .then((res) => {
        const api = res.data;

        // pour avoir son solde Alrani Monetisation on filtre en fonction de l'idPersonConnectedAA
        const filterUser = api.filter((api) => api._id === idPersonConnectedAA);

        // solde Alrani Monetisation
        const balance = filterUser.map((api) => api.balanceMonetization);
        if (balance) {
          localStorage.setItem(
            "https://alrani.com/balanceMonetization",
            balance
          );
        }

        // on recupere les infos pour faire le calcul
        const amountWritten = localStorage.getItem(
          "https://alrani.com/writeAmountReceive"
        );
        const balanceMonetization = localStorage.getItem(
          "https://alrani.com/balanceMonetization"
        );

        // on fait le calcul
        const newBalanceMonetizationAA =
          parseInt(balanceMonetization) - parseInt(amountWritten);
        //verifiedBalance > 0, alors le solde est superieure a 0
        //verifiedBalance < 0, alors le solde est insuffisant
        const verifiedBalance = newBalanceMonetizationAA > 0;
        if (verifiedBalance) {
          // dans ce cas le solde est > 0, alors on transfere l'argent dans son compte izocash
          //2e requete
          //2e requete
          // debiter son solde alrani monetization
          /* vu qu'il a l'argent, alors on debite son solde alrani monetization, puis on envoie
          cet argent dans son compte izocash.
          Faut d'abord commencez par debiter le compte pour eviter que cela ne soit une faille,
          internet peut couper mais c'est pas grave car on a deja debiter son solde, or s'il avait 
          deja recu son argent et que internet a couper là c'est nous qui devrait perdre. or si c'est 
          lui qui a perdu, s'il nous contacte on pourra toujours lui rembourser. */
          /*pour debiter le solde c'est simple, le calcul avait deja ete effectuer plus haut alors
          on prend juste le nouveau solde monetization puis on envoie d ans la bdd */
          async function deuxiemeReq() {
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedAA}`,
              data: {
                balanceMonetization: newBalanceMonetizationAA,
              },
            })
              .then((res) => {
                setOpacity(false);
                // 3e requete
                // 3e requete
                /* dans la 3e requete, on a d'abord besoin de savoir l'ancien solde izocash de 
          l'utilisateur car on va utiliser l'ancien solde pour faire le calcul du nouveau solde */
                async function troisiemeReq() {
                  await axios
                    .get(`${process.env.REACT_APP_BACKEND}/api/userAA/`)
                    .then((res) => {
                      const api = res.data;

                      // pour avoir le solde IA, on filtre premierement en fonction du numero virtuel qui est sur Alrani
                      const filterUserByVirtualNumber = api.filter(
                        (api) =>
                          api.telephone === virtualNumberPersonConnectedAA
                      );

                      //solde de l'utilisateur
                      const balanceIzocashUser = filterUserByVirtualNumber.map(
                        (api) => api.balanceInternationalAccount
                      );
                      if (balanceIzocashUser) {
                        localStorage.setItem(
                          "https://alrani.com/balanceIzocashUser",
                          balanceIzocashUser
                        );
                      }

                      // on obtient son idIzocash
                      // l'id Izocash servira a l'envoyer de l'argent à travers Alrani Monetization
                      const idIzocashUser = filterUserByVirtualNumber.map(
                        (api) => api._id
                      );
                      //4e requete
                      //4e requete
                      //la requete pour transferer l'argent dans son compte IA
                      async function quatriemeReq() {
                        // ici on fait le calcul
                        const amountWritten = localStorage.getItem(
                          "https://alrani.com/writeAmountReceive"
                        );
                        const balanceIzocashUserAA = localStorage.getItem(
                          "https://alrani.com/balanceIzocashUser"
                        );
                        const newBalance =
                          parseInt(balanceIzocashUserAA) +
                          parseInt(amountWritten);

                        await axios({
                          method: "put",
                          url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idIzocashUser}`,
                          data: {
                            balanceInternationalAccount: newBalance,
                          },
                        })
                          .then((res) => {
                            setOpacity(false);
                            console.log("Transfert réussi");
                            //5e requete
                            //5e requete
                            //requete pour obtenir de nouvelles donnees
                            /* une fois que l'utilisateur a transferer son argent dans son compte IA,
                      on veut afficher son nouveau solde Alrani Monetisation. donc ca c'est 
                      la requete pour actualiser son solde Alrani Monetisation */
                            async function cinquiemeReq() {
                              await axios
                                .get(
                                  `${process.env.REACT_APP_BACKEND}/api/userAA/`
                                )
                                .then((res) => {
                                  const api = res.data;
                                  // pour avoir son solde Alrani Monetisation on filtre en fonction de l'idPersonConnectedAA
                                  const filterUser = api.filter(
                                    (api) => api._id === idPersonConnectedAA
                                  );

                                  // solde Alrani Monetisation
                                  const balance = filterUser.map(
                                    (api) => api.balanceMonetization
                                  );
                                  if (balance) {
                                    localStorage.setItem(
                                      "https://alrani.com/balanceMonetizationAA",
                                      balance
                                    );
                                  }
                                })
                                .catch((err) => {
                                  setOpacity(false);
                                });
                            }
                            cinquiemeReq();
                            //5e requete
                          })
                          .catch((err) => {
                            setOpacity(false);
                            console.log("Transfert echouer");
                          });
                      }
                      quatriemeReq();
                      //4e requete
                    })
                    .catch((err) => {
                      setOpacity(false);
                    });
                }
                troisiemeReq();
                //3e requete
              })
              .catch((err) => {
                setOpacity(false);
                console.log("une erreur s'est produite");
              });
          }
          deuxiemeReq();
          // 2e requete */
        } else {
          // dans ce cas le solde est insuffisant: alors on envoie un message d'erreur
          console.log("insuffisant - solde alrani monetisation insuffisant");
          console.log(newBalanceMonetizationAA, "nouveau solde monetisation");
        }
        // le if de newBalanceMonetizationAA se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        console.log("une erreur s'est produiteee");
      });
    // 1ere requete
  }
  // Alrani Monetization

  // Monetization Deals - AA
  // sur cette page on affiche le solde, la base de donnees,...
  const [monetizationDealsAA, setMonetizationDealsAA] = useState(false);
  async function MonetizationDealsAA() {
    setMonetizationDealsAA(true);
  }
  //fermer
  async function CloseMonetizationDealsAA() {
    setMonetizationDealsAA(false);
  }

  // Monetization Formation - AA
  // sur cette page on affiche le solde, la base de donnees,...
  const [monetizationFormationAA, setMonetizationFormationAA] = useState(false);
  async function MonetizationFormationAA() {
    setMonetizationFormationAA(true);
  }
  //fermer
  async function CloseMonetizationFormationAA() {
    setMonetizationFormationAA(false);
  }

  // certification - AA
  // certification - AA
  const [certificationAA, setCertificationAA] = useState(false);
  async function CertificationAA() {
    setCertificationAA(true);
  }
  //fermer
  async function CloseCertificationAA() {
    setCertificationAA(false);
  }

  // certification Deals - AA
  // certification Deals - AA
  const [certificationDealsAA, setCertificationDealsAA] = useState(false);
  async function CertificationDealsAA() {
    setCertificationDealsAA(true);
  }
  //fermer
  async function CloseCertificationDealsAA() {
    setCertificationDealsAA(false);
  }

  // certification Formation - AA
  // certification Formation - AA
  const [certificationFormationAA, setCertificationFormationAA] =
    useState(false);
  async function CertificationFormationAA() {
    setCertificationFormationAA(true);
  }
  //fermer
  async function CloseCertificationFormationAA() {
    setCertificationFormationAA(false);
  }

  // plus Deals - AA
  // plus Deals - AA
  const [plusDealsAA, setPlusDealsAA] = useState(false);
  async function PlusDealsAA() {
    setPlusDealsAA(true);
  }
  //fermer
  async function ClosePlusDealsAA() {
    setPlusDealsAA(false);
  }

  // plus Formation - AA
  // plus Formation - AA
  const [plusFormationAA, setPlusFormationAA] = useState(false);
  async function PlusFormationAA() {
    setPlusFormationAA(true);
  }
  //fermer
  async function ClosePlusFormationAA() {
    setPlusFormationAA(false);
  }

  // collaborator - AA
  // collaborator - AA
  const [collaboratorAA, setCollaboratorAA] = useState(false);
  async function CollaboratorAA() {
    setCollaboratorAA(true);
  }
  //fermer
  async function CloseCollaboratorAA() {
    setCollaboratorAA(false);
  }

  // collaborator deals - AA
  // collaborator deals - AA
  const [collaboratorDealsAA, setCollaboratorDealsAA] = useState(false);
  async function CollaboratorDealsAA() {
    setCollaboratorDealsAA(true);
  }
  //fermer
  async function CloseCollaboratorDealsAA() {
    setCollaboratorDealsAA(false);
  }

  // collaborator formation - AA
  // collaborator formation - AA
  const [collaboratorFormationAA, setCollaboratorFormationAA] = useState(false);
  async function CollaboratorFormationAA() {
    setCollaboratorFormationAA(true);
  }
  //fermer
  async function CloseCollaboratorFormationAA() {
    setCollaboratorFormationAA(false);
  }

  // monetization Deals - AA
  // monetization Deals - AA
  /*
  const [monetizationDealsAA, setMonetizationDealsAA] = useState(false);
  async function MonetizationDealsAA() {
    setMonetizationDealsAA(true);
  }
  //fermer
  async function CloseMonetizationDealsAA() {
    setMonetizationDealsAA(false);
  }

  // monetization Formation - AA
  // monetization Formation - AA
  const [monetizationFormationAA, setMonetizationFormationAA] = useState(false);
  async function MonetizationFormationAA() {
    setMonetizationFormationAA(true);
  }
  //fermer
  async function CloseMonetizationFormationAA() {
    setMonetizationFormationAA(false);
  }*/

  // inscription Success - AA
  // inscription Success - AA
  // on affiche cette page si la personne a pu s'inscrire
  const [inscriptionSuccessAA, setInscriptionSuccessAA] = useState(false);
  async function CloseInscriptionSuccessAA() {
    setInscriptionSuccessAA(false);
  }

  // connexion Success - AA
  // connexion Success - AA
  // on affiche cette page si la personne a pu se connecter
  const [connexionSuccessAA, setConnexionSuccessAA] = useState(false);
  async function CloseConnexionSuccessAA() {
    setConnexionPageAA(false);
    setConnexionSuccessAA(false);
    setTelephoneVirtuel(true);
  }
  
  // erreur (connexion) - AA
  /* on affiche cette page si l'inscription a echouer ou si la personne a 
  rencontrer une erreur lors de la connexion a son compte Alrani */
  const [erreurConnexionAA, setErreurConnexionAA] = useState(false);
  async function CloseErreurConnexionAA() {
    setErreurConnexionAA(false);
  }


  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app
  // florinato app

  // Fonctionnalités Supplémentaires (cette page signale que au niveau de son compte Florinato, l'application Donazia a ete activé) - FA */}
  const [fonctionnalitesSupplementaireFA, setFonctionnalitesSupplementaireFA] = useState(false);
  async function FonctionnalitesSupplementaireFA() {
    setFonctionnalitesSupplementaireFA(true);
  }
  async function CloseFonctionnalitesSupplementaireFA() { 
    setFonctionnalitesSupplementaireFA(false);
  }



  // x app
  // x app
  // x app
  // x app
  // ça c'est l'application X (page d'accueil)
  //const [xApp, setXApp] = useState(false); 
  async function XApp() {
	  
    if (idPersonConnectedFA) { // si la personne est connecté , on affiche pas la page d'inscription
      setFlorinatoApp(true);
      setTelephoneVirtuel(false);
      setInscriptionPageAA(false);
    } else {
		setInscriptionPageAA(true);
        setTelephoneVirtuel(false);
    }
  }

  /*async function CloseXApp() {
    setTelephoneVirtuel(true);
  }*/

  // toast (notification en cours d'actualisation) - XA
  const [waitRefreshXA, setWaitRefreshXA] = useState(false);
  async function CloseWaitRefreshXA() {
    setWaitRefreshXA(false);
  }

  // toast (notification actualisé) - XA
  const [refreshSuccessXA, setRefreshSuccessXA] = useState(false);
  async function CloseRefreshSuccessXA() {
    setRefreshSuccessXA(false);
  }

  // logique pour obtenir de nouvelles données - XA
  async function RefreshXA() {
    setWaitRefreshXA(true);

    //1ere requete
    //1ere requete
    // obtenir les nouveaux messages
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
      .then((res) => {
        setApiMessageAA(res.data);
          
          // données actualiser: message de succes qui s'affiche et disparait apres quelques secondes
          //ici on affiche le message de succes
          setWaitRefreshXA(false);
          setRefreshSuccessXA(true);

          //ici on le fait disparaitre
          async function CloseRefreshSuccess() {
            setRefreshSuccessXA(false);
          }
          setTimeout(CloseRefreshSuccess, 1400);
          console.log("message actualiser");
        })
        .catch((err) => {
          setErreur(true);
        })
    }
    premiereReq();
    //1ere requete
  }


  // on affiche les messages de groupe dans l'application x 
  const [messagePublicXA, setMessagePublicXA] = useState(false); 
  async function CloseMessagePublicXA() {
    setTelephoneVirtuel(true);
  }
  
  
  // PageRedirection 66ChildApi66profilFA
  /* async function PageRedirection66ChildApi66profilFA() {
	  
	const gotoVideo = localStorage.getItem("gotoVideo");
    if (gotoVideo === "1") { setSeeVideoFA(true); }
	
	const gotoPhoto = localStorage.getItem("gotoPhoto");
    if (gotoPhoto === "1") { setSeePhotoFA(true); }
  } */
  

  // on affiche le compte de l'autre - FA 
  const [profilOtherFA, setProfilOtherFA] = useState(false); 
  async function CloseProfilOtherFA() {
    setProfilOtherFA(false);
  }

  // PageRedirection 66ChildApi66profilOtherFA
  async function PageRedirection66ChildApi66profilOtherFA() {
	  
	const gotoVideo = localStorage.getItem("gotoVideo");
    if (gotoVideo === "1") { setSeeVideoFA(true); }
	
	const gotoPhoto = localStorage.getItem("gotoPhoto");
    if (gotoPhoto === "1") { setSeePhotoFA(true); }
	   
    //page pour afficher ce que j'ai cliqué
	/*
    const selected = localStorage.getItem("GoToselectedFA");
    if (selected === "1") { setSelected2FA(true); } */
  }


  // jeuxFA
  const [jeuxFA, setJeuxFA] = useState(false); 
  async function JeuxFA() {
    setJeuxFA(true);
  }
  async function CloseJeuxFA() {
    setJeuxFA(false);
  } 


  async function Chiffre1FA() {
    const filter = apiMessageFA.filter((api) => api.idOther === idAccountChefFA && api.type === "100" && api.visible === "0");
    const getchiffre = filter.map((api) => api.typeOther); 
    localStorage.setItem("chiffre", getchiffre);
    const chiffre = localStorage.getItem("chiffre");
    console.log("Chiffre 1", chiffre);

    if(chiffre === "1") {
      setGagnerFA(true);
      setPerduFA(false);
      console.log("gagné");
    } else {
      setPerduFA(true);
      setGagnerFA(false);
      console.log("perdu");
    }
  }
  // Chiffre1FA

  async function Chiffre2FA() { 
    const filter = apiMessageFA.filter((api) => api.idOther === idAccountChefFA && api.type === "100" && api.visible === "0");
    const getchiffre = filter.map((api) => api.typeOther); 
    localStorage.setItem("chiffre", getchiffre);
    const chiffre = localStorage.getItem("chiffre");
    console.log("Chiffre 2", chiffre);

    if(chiffre === "2") {
      setGagnerFA(true);
      setPerduFA(false);
      console.log("gagné");
    } else {
      setPerduFA(true);
      setGagnerFA(false);
      console.log("perdu");
    }
  }
  // Chiffre2FA

  async function Chiffre3FA() {
    const filter = apiMessageFA.filter((api) => api.idOther === idAccountChefFA && api.type === "100" && api.visible === "0");
    const getchiffre = filter.map((api) => api.typeOther); 
    localStorage.setItem("chiffre", getchiffre);
    const chiffre = localStorage.getItem("chiffre");
    console.log("Chiffre 3", chiffre);

    if(chiffre === "3") {
      setGagnerFA(true);
      setPerduFA(false);
      console.log("gagné");
    } else {
      setPerduFA(true);
      setGagnerFA(false);
      console.log("perdu");
    }
  }
  // Chiffre3FA

  async function Chiffre4FA() {
    const filter = apiMessageFA.filter((api) => api.idOther === idAccountChefFA && api.type === "100" && api.visible === "0");
    const getchiffre = filter.map((api) => api.typeOther); 
    localStorage.setItem("chiffre", getchiffre);
    const chiffre = localStorage.getItem("chiffre");
    console.log("Chiffre 4", chiffre);

    if(chiffre === "4") {
      setGagnerFA(true);
      setPerduFA(false);
      console.log("gagné");

      // logique pour envoyer le gain à celui qui à gagner
      async function EnvoyerGain() { 
        //1ere requete
        //calcul du gain
        async function premiereReq() {
          const jackpot = "2000";

          const ancienGain = localStorage.getItem("ancienGain");
          const nouveauGain = parseInt(ancienGain) + parseInt(jackpot);
          localStorage.setItem("nouveauGain", nouveauGain);

        //2e requete
        // on envoi son gain
        async function deuxiemeReq() {
          const gain = localStorage.getItem("nouveauGain");
          const idAccountGainFA = localStorage.getItem("idAccountGainFA");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idAccountGainFA}`, 
            data: {
              gain,
            },
            })
            .then((res) => {
            console.log(res);

        //3e requete - api1
        // on obtiens les nouvelles données
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
          })
          }
          troisiemeReq();
          //3e requete - api1
          })
          }
          deuxiemeReq();
          //2e requete - api1
          }
          premiereReq();
          //1ere requete - api1
      }
      EnvoyerGain();
      //EnvoyerGain

    } else {
      setPerduFA(true);
      setGagnerFA(false);
      console.log("perdu");
    } //if(chiffre === "4")
  }
  // Chiffre4FA

  const [perduFA, setPerduFA] = useState(false); 
  const [gagnerFA, setGagnerFA] = useState(false); 

  
       
  // logique pour débuter le jeux 
  async function DebuterJeuxFA() {
  /*
    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      
        //1ere requete - api1
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          const api = res.data;

          //creer un id pour chaque message envoyé sur X
          const numberMessageXA = api.filter((api) => api._id);
          const totalMessageXA = numberMessageXA.length;
        
          const createIdMessageXA = totalMessageXA + 1;
          if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }
*/

          let min = 1;
          let max = 5;
          let chiffre = Math.floor(Math.random() * (max - min) + min);

          console.log(chiffre);

          /*const oldView = localStorage.getItem("oldViewAA");
          const calculView = parseInt(oldView) + parseInt(newView);
          if (calculView) { localStorage.setItem("newViewAA", calculView); }

          const hazard = "1";
          if (jeux === "1") { localStorage.setItem("hazard", hazard) }
          
          if (jeux === "2") { localStorage.setItem("hazard", hazard) }
          */

        //2e requete - api1
        // on débute le jeu
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          //const urlPhoto = localStorage.getItem("photoFA");
          const idOther = localStorage.getItem("idAccountChef");
          const visible = "0";
          const type = "100"; //débuter le jeu

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
            data: {
              id,
              idAccount: idPersonConnectedFA,
              nameAccount: nameFA,
              photoAccount: photoFA,
              badgeAccount: badgeFA,
              typeOther: chiffre,
              urlPhoto: photoFA,
              idOther,
              visible,
              type,
            },
          })
          .then((res) => {
            console.log(res);

        //3e requete - api1
        // on obtiens les nouvelles données
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
          })
          }
          troisiemeReq();
          //3e requete - api1
          })
          }
          deuxiemeReq();
          //2e requete - api1
  }
  //DebuterJeuxFA




//logique pour ajouter une photo à nos favoris FA
  const [isLoading66favorite66messageFA, setIsLoading66favorite66messageFA] = useState(false);
  const [filePhoto66favorite66messageFA, setFilePhoto66favorite66messageFA] = useState();

  async function AddPhoto66favorite66messageFA() {
    setIsLoading66favorite66messageFA(true);

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      
    //1ere requete - api1
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;

        //creer un id pour chaque elements ajouté aux favoris
        const numberFavoriteAA = api.filter((api) => api._id);
        const totalFavoriteAA = numberFavoriteAA.length;

        const createIdFavoriteAA = totalFavoriteAA + 1;
        if (createIdFavoriteAA) { localStorage.setItem("createId", createIdFavoriteAA) }

    //2e requete - api1
    // on envoie la photo sur imagekit
    async function deuxiemeReq() {
      const data = new FormData();
      data.append("image", filePhoto66favorite66messageFA);

      await axios
      .post(`${process.env.REACT_APP_Api1}/api/messageFA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("photo ajouter aux favoris", res);
        const urlPhoto = res.data.urlPhoto;
        if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }

      //3e requete - api1
      // on enregistre la photo dans notre bdd
      async function troisiemeReq() {
        const id = localStorage.getItem("createId");
        const urlPhoto = localStorage.getItem("urlPhotoreq");
        const urlVideo = "0";
        const visible = "1";
        const type = "20";
      
        await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
        data: {
          id,
          idUser: idUserConnectedFA,
          urlPhoto,
          urlVideo,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log("photo enregistrer dans la bdd", res);

        //4e requete - api1
        // on obtiens de nouvelles donnees
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            console.log(res);
            setApiMessageFA(res.data);
            setIsLoading66favorite66messageFA(false);
            //setWriteMessagePageFA(true)
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            //setWriteMessagePageFA(true)
          });
          }
          quatriemeReq();
          //4e requete - api1
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            //setWriteMessagePageFA(true)
            setErreur(true);
          });
          }
          troisiemeReq();
          //3e requete - api1
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            setErreur(true);
          });
          }
          deuxiemeReq();
          //2e requete - api1
          })
          .catch((err) => {
            
        //1ere requete - api2
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;

            //creer un id pour chaque elements ajouté aux favoris
            const numberFavoriteAA = api.filter((api) => api._id);
            const totalFavoriteAA = numberFavoriteAA.length;

            const createIdFavoriteAA = totalFavoriteAA + 1;
            if (createIdFavoriteAA) { localStorage.setItem("createId", createIdFavoriteAA) }

        //2e requete - api2
        // on envoie la photo sur imagekit
        async function deuxiemeReq() {
          const data = new FormData();
          data.append("image", filePhoto66favorite66messageFA); 

          await axios
          .post(`${process.env.REACT_APP_Api2}/api/messageFA/sendPhoto`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            console.log("photo ajouter aux favoris", res);
            const urlPhoto = res.data.urlPhoto;
            if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }

        //3e requete - api2
        // on enregistre la photo dans notre bdd
        async function troisiemeReq() {
          const id = localStorage.getItem("createId");
          const urlPhoto = localStorage.getItem("urlPhotoreq");
          const urlVideo = "0";
          const visible = "1";
          const type = "20";
        
          await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
          data: {
            id,
            idUser: idUserConnectedFA,
            urlPhoto,
            urlVideo,
            visible,
            type,
          },
        })
        .then((res) => {
          console.log("photo enregistrer dans la bdd", res);

        //4e requete - api2
        // on obtiens de nouvelles donnees
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            console.log(res);
            setApiMessageFA(res.data);
            setIsLoading66favorite66messageFA(false);
            //setWriteMessagePageFA(true)
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            //setWriteMessagePageFA(true)
          });
          }
          quatriemeReq();
          //4e requete - api2
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            //setWriteMessagePageFA(true)
            setErreur(true);
          });
          }
          troisiemeReq();
          //3e requete - api2
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            setErreur(true);
          });
          }
          deuxiemeReq();
          //2e requete - api2
          })
          .catch((err) => {
            setIsLoading66favorite66messageFA(false);
            setErreur(true);
          });
          }
          premiereReq();
          //1ere requete - api2

          })
          }
          premiereReq();
          //1ere requete - api1
    }//if (block === "0")
    }//if(idPersonConnectedFA)
}
//AddPhoto66favorite66messageFA




  // on affiche les favoris au niveau des messages 
  const [favorite66messageFA, setFavorite66messageFA] = useState(false); 
  async function Favorite66messageFA() { setFavorite66messageFA(true); }
  async function CloseFavorite66messageFA() { setFavorite66messageFA(false); }


  //PageRedirection 66favorite66messageFA
  async function PageRedirection66favorite66messageFA() {

    // logique pour envoyer une photo par message privé - FA
    async function SendMessagePhotoFA() {
      setFavorite66messageFA(false);

      if (idPersonConnectedFA) {
        const block = localStorage.getItem("blockFA");
        if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

        //on enregistre le message saisi dans le localStorage pour ensuite vider le textarea
        localStorage.setItem("writeMessage66messageFA", writeMessage66messageFA);
        setWriteMessage66messageFA(""); //ici on vide le textarea

        //1ere requete - api1
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;

          //creer un id pour chaque message envoyé sur X
          const numberMessageXA = api.filter((api) => api._id);
          const totalMessageXA = numberMessageXA.length;

          const createIdMessageXA = totalMessageXA + 1;
          if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

      //2e requete - api1
      // on envoie le message
      async function deuxiemeReq() {
        const id = localStorage.getItem("createId");
        const idConversation = localStorage.getItem("idConversation");
        const idOther = localStorage.getItem("idOther");
        const message = localStorage.getItem("writeMessage66messageFA");
        const urlPhoto = localStorage.getItem("urlPhotoreq");
        const visible = "1";
        const type = "2";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
          data: {
            id,
            idConversation,
            message,
            urlPhoto,
            idAccount: idPersonConnectedFA,
            nameAccount: nameFA,
            photoAccount: photoFA,
            badgeAccount: badgeFA,
            idOther,
            visible,
            type,
          },
        })
        .then((res) => {
          const id = res.data._id; //id (cet id va etre utile lorsqu'on voudra mettre si le message a ete lu ou non)
          if (id) { localStorage.getItem("idLastMessage", id); }

          const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
          localStorage.setItem("online", online);
          console.log(online);
          console.log(res);

      //3e requete - api1
      // cette requete c'est pour modifier le dernier message au niveau de la conversation
      async function troisiemeReq() {
        const id = localStorage.getItem("createId");
        const idConversation = localStorage.getItem("idConversation");
        const lastMessage = localStorage.getItem("writeMessage66messageFA");
        const typeLastMessage = "2";

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idConversation}`,
          data: {
            id,
            lastMessage,
            typeLastMessage,
          },
        })
        .then((res) => {

      //4e requete - api1
      // on enregistre la date de derniere connexion
      async function quatriemeReq() {
        const online = localStorage.getItem("online");
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idPersonConnectedFA}`,
          data: {
            online,
          },
        })
        .then((res) => {

      //5e requete - api1
      // on obtiens les nouvelles données
      async function cinquiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        cinquiemeReq();
        //5e requete - api1
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        quatriemeReq();
        //4e requete - api1
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        troisiemeReq();
        //3e requete - api1
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        deuxiemeReq();
        //2e requete - api1
        })
        .catch((err) => {
          
      //1ere requete - api2
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          const api = res.data;

          //creer un id pour chaque message envoyé sur X
          const numberMessageXA = api.filter((api) => api._id);
          const totalMessageXA = numberMessageXA.length;
        
          const createIdMessageXA = totalMessageXA + 1;
          if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

      //2e requete - api2
      // on envoie le message
      async function deuxiemeReq() {
        const id = localStorage.getItem("createId");
        const idConversation = localStorage.getItem("idConversation");
        const idOther = localStorage.getItem("idOther");
        const message = localStorage.getItem("writeMessage66messageFA");
        const urlPhoto = localStorage.getItem("urlPhotoreq");
        const visible = "1";
        const type = "2";

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
          data: {
            id,
            idConversation,
            message,
            urlPhoto,
            idAccount: idPersonConnectedFA,
            nameAccount: nameFA,
            photoAccount: photoFA,
            badgeAccount: badgeFA,
            idOther,
            visible,
            type,
          },
        })
        .then((res) => {
          const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
          localStorage.setItem("online", online);
          console.log(online);
          console.log(res);

      //3e requete - api2
      // cette requete c'est pour modifier le dernier message au niveau de la conversation
      async function troisiemeReq() {
        const id = localStorage.getItem("createId");
        const idConversation = localStorage.getItem("idConversation");
        const lastMessage = localStorage.getItem("writeMessage66messageFA");
        const typeLastMessage = "2";

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idConversation}`,
          data: {
            id,
            lastMessage,
            typeLastMessage,
          },
        })
        .then((res) => {

      //4e requete - api2
      // on enregistre la date de derniere connexion
      async function quatriemeReq() {
        const online = localStorage.getItem("online");
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idPersonConnectedFA}`,
          data: {
            online,
          },
        })
        .then((res) => {

      //5e requete - api2
      // on obtiens les nouvelles données
      async function cinquiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        cinquiemeReq();
        //5e requete - api2
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        quatriemeReq();
        //4e requete - api2
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        troisiemeReq();
        //3e requete - api2
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        deuxiemeReq();
        //2e requete - api2
        })
        .catch((err) => {
          setErreur(true);
        })
        }
        premiereReq();
        //1ere requete - api2

        })
        }
        premiereReq();
        //1ere requete - api1
      } //if (block === "0")
      } //if(idPersonConnectedFA)
    }
    SendMessagePhotoFA();
    //SendMessagePhotoFA
}
//PageRedirection 66favorite66messageFA


//logique pour debuter une conversation 
// const [isLoading66messageFA, setIsLoading66messageFA] = useState(false);

/*
async function BeginConversationFA() {

    localStorage.setItem("writeMessage66messageFA", writeMessage66messageFA);
    setWriteMessage66messageFA("");

    setIsLoading66messageFA(true);
  
    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
        
      //1ere requete - api1
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          const api = res.data;

          //creer un id 
          const numberMessageFA = api.filter((api) => api._id);
          const totalMessageFA = numberMessageFA.length;

          const createId = totalMessageFA + 1;
          localStorage.setItem("createId", createId);

        // 2e requete
        //on initie la conversation car il n'existe pas de conversation entre les deux utilisateurs
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const idOther = localStorage.getItem("idOther");
          const idUserOther = localStorage.getItem("idUserOther");
          const nameOther = localStorage.getItem("nameOther");
          const photoOther = localStorage.getItem("photoOther");
          const badgeOther = localStorage.getItem("badgeOther");
          const lastMessage = localStorage.getItem("writeMessage66messageFA");
          const visible = "1";
          const type = "30";
          
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
            data: {
              id,
              idOther, // l'autre personne
              idUserOther,
              nameOther,
              photoOther,
              badgeOther,
              lastMessage,
              idAccount: idPersonConnectedFA, // personne connecter
              idUser: idUserConnectedFA,
              nameAccount: nameFA,
              photoAccount: photoFA,
              badgeAccount: badgeFA,
              visible,
              type,
            },
          })
          .then((res) => {
            const id = res.data._id;
            if(id) { localStorage.setItem("idConversation", id); }
            console.log(res);

        //3e requete - api1
        // on envoie le message
        async function troisiemeReq() {
          const id = localStorage.getItem("createId");
          const idConversation = localStorage.getItem("idConversation");
          const idOther = localStorage.getItem("idOther");
          const message = localStorage.getItem("writeMessage66messageFA");
          const visible = "1";
          const type = "1";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
            data: {
              id,
              idConversation,
              message,
              idAccount: idPersonConnectedFA,
              nameAccount: nameFA,
              photoAccount: photoFA,
              badgeAccount: badgeFA,
              idOther,
              visible,
              type,
            },
          })
          .then((res) => {
            const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
            localStorage.setItem("online", online);
            console.log(online);
            console.log(res);

        //4e requete - api1
        // cette requete c'est pour modifier le dernier message au niveau de la conversation
        async function quatriemeReq() {
          const id = localStorage.getItem("idConversation");
          const lastMessage = localStorage.getItem("writeMessage66messageFA");
          //const idReceiver = localStorage.getItem("idOther");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${id}`,
            data: {
              lastMessage,
              //idReceiver,
            },
          })
          .then((res) => {

        //5e requete - api1
        // on enregistre la date de derniere connexion
        async function cinquiemeReq() {
          const online = localStorage.getItem("online");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idPersonConnectedFA}`,
            data: {
              online,
            },
          })
          .then((res) => {

        //6e requete - api1
        // on obtiens de  nouvelles données
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
            setIsLoading66messageFA(false);
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          sixiemeReq();
          //6e requete - api1
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          cinquiemeReq();
          //5e requete - api1
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          quatriemeReq();
          //4e requete - api1
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          troisiemeReq();
          //3e requete - api1
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          deuxiemeReq();
          //2e requete - api1
          })
          .catch((err) => {

        //1ere requete - api2
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;

            //creer un id 
            const numberMessageFA = api.filter((api) => api._id);
            const totalMessageFA = numberMessageFA.length;

            const createId = totalMessageFA + 1;
            localStorage.setItem("createId", createId);

        // 2e requete - api2
        //on initie la conversation car il n'existe pas de conversation entre les deux utilisateurs
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const idOther = localStorage.getItem("idOther");
          const idUserOther = localStorage.getItem("idUserOther");
          const nameOther = localStorage.getItem("nameOther");
          const photoOther = localStorage.getItem("photoOther");
          const badgeOther = localStorage.getItem("badgeOther");
          const lastMessage = localStorage.getItem("writeMessage66messageFA");
          const visible = "1";
          const type = "30";
  
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
            data: {
              id,
              idOther, // l'autre personne
              idUserOther,
              nameOther,
              photoOther,
              badgeOther,
              lastMessage,
              idAccount: idPersonConnectedFA, // personne connecter
              idUser: idUserConnectedFA,
              nameAccount: nameFA,
              photoAccount: photoFA,
              badgeAccount: badgeFA,
              visible,
              type,
            },
          })
          .then((res) => {
            const id = res.data._id;
            if(id) { localStorage.setItem("idConversation", id); }
            console.log(res);

        //3e requete - api2
        // on envoie le message
        async function troisiemeReq() {
          const id = localStorage.getItem("createId");
          const idConversation = localStorage.getItem("idConversation");
          const idOther = localStorage.getItem("idOther");
          const message = localStorage.getItem("writeMessage66messageFA");
          const visible = "1";
          const type = "1";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
            data: {
              id,
              idConversation,
              message,
              idAccount: idPersonConnectedFA,
              nameAccount: nameFA,
              photoAccount: photoFA,
              badgeAccount: badgeFA,
              idOther,
              visible,
              type,
            },
          })
          .then((res) => {
            const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
            localStorage.setItem("online", online);
            console.log(online);
            console.log(res);

        //4e requete - api2
        // cette requete c'est pour modifier le dernier message au niveau de la conversation
        async function quatriemeReq() {
          const id = localStorage.getItem("idConversation");
          const lastMessage = localStorage.getItem("writeMessage66messageFA");
          //const idReceiver = localStorage.getItem("idOther");

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${id}`,
            data: {
              lastMessage,
              //idReceiver,
            },
          })
          .then((res) => {

        //5e requete - api2
        // on enregistre la date de derniere connexion
        async function cinquiemeReq() {
          const online = localStorage.getItem("online");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idPersonConnectedFA}`,
            data: {
              online,
            },
          })
          .then((res) => {

        //6e requete - api2
        // on obtiens de  nouvelles données
        async function sixiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            setIsLoading66messageFA(false);
            console.log(res);
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          sixiemeReq();
          //6e requete - api2
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          cinquiemeReq();
          //5e requete - api2
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          quatriemeReq();
          //4e requete - api2
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          troisiemeReq();
          //3e requete - api2
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          deuxiemeReq();
          //2e requete - api2
          })
          .catch((err) => {
            setErreur(true);
            setIsLoading66messageFA(false);
          });
          }
          premiereReq();
          //1ere requete - api2

          });
          }
          premiereReq();
          //1ere requete - api1
     } //if (block === "0")
     } //if(idPersonConnectedFA)
  } */
  //BeginConversationFA

    
  // on affiche le groupe de l'autre - FA 
  const [groupOtherFA, setGroupOtherFA] = useState(false); 
  async function GroupOtherFA() {
    setGroupOtherFA(true);

  // logique pour envoyer le clic lorsqu'on clique sur un groupe
  async function ClicGroup() {
    if (idPersonConnectedFA) {

    const block = localStorage.getItem("blockFA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete
      //1ere requete
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
        
    //creer un id pour chaque message envoyé sur florinato
    const numberMessageXA = api.filter((api) => api._id);
    const totalMessageXA = numberMessageXA.length;
  
    const createIdMessageXA = totalMessageXA + 1;
    if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete
    //2e requete
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idGroup = localStorage.getItem("idGroupOther");
      const nameGroup = localStorage.getItem("nameGroupOther");
      const photoGroup = localStorage.getItem("photoGroupOther");
      const idOther = localStorage.getItem("idAccount");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const visible = "1";
      const type = "201"; // il a visité le groupe,

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_SendMessageAA}/api/messageAA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idGroup,
          nameGroup,
          photoGroup,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete
        //3e requete
        // on augmente la popularité
        async function troisiemeReq() {
          //on compte la popularité 
          const numberPopularityGroup = apiMessageAA.filter((api) => api.idGroup === idGroupOther && api.type === "201");
          const popularityGroup = numberPopularityGroup.length;
          //console.log("numberPopularityGroup", numberPopularityGroup);

          const one = "1";
          const popularity = parseInt(popularityGroup) + parseInt(one);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SendMessageAA}/api/messageAA/update/${idGroupOther}`,
            data: {
              popularity,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete
      //4e requete
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA/`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete
        })
        }
        troisiemeReq();
        //3e requete

                })
                }
                deuxiemeReq();
                //2e requete
                })
                }
                premiereReq();
                //1ere requete
                } 
                // if (block === "0")
              } // if(idPersonConnectedFA)
          }
          ClicGroup();
  }
  async function CloseGroupOtherFA() {
    setGroupOtherFA(false);
  }



// PageRedirection 66groupOtherFA
async function PageRedirection66groupOtherFA() {
  //page pour afficher la video sur laquelle on a cliquer
  const selected = localStorage.getItem("GoToselectedFA");
  if (selected === "1") { setSelectedFA(true); }

  
  // logique pour epingler un message - FA
  async function EpinglerMessageFA() {
    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete - api1
      // on epingle le message 
      async function premiereReq() {
        const id = localStorage.getItem("idreq");
        const epingler = "1";

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${id}`,
          data: {
            epingler,
          },
        })
        .then((res) => {
          console.log(res);

      //2e requete - api1
      // on met l'id du message épingler au niveau du groupe
      async function deuxiemeReq() {
        const idMessageEpingler = localStorage.getItem("idreq");
        const idGroup = localStorage.getItem("idGroupFA");

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idGroup}`,
          data: {
            idMessageEpingler,
          },
        })
        .then((res) => {
          console.log(res);

      //3e requete - api1
      // on obtiens les nouvelles données
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        troisiemeReq();
        //3e requete - api1
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        deuxiemeReq();
        //2e requete - api1
        })
        .catch((err) => {
          
      //1ere requete - api2
      // on epingle le message 
      async function premiereReq() {
        const id = localStorage.getItem("idreq");
        const epingler = "1";

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${id}`,
          data: {
            epingler,
          },
        })
        .then((res) => {
          console.log(res);

      //2e requete - api2
      // on met l'id du message épingler au niveau du groupe
      async function deuxiemeReq() {
        const idMessageEpingler = localStorage.getItem("idreq");
        const idGroup = localStorage.getItem("idGroupFA");

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idGroup}`,
          data: {
            idMessageEpingler,
          },
        })
        .then((res) => {
          console.log(res);

      //3e requete - api2
      // on obtiens les nouvelles données
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        troisiemeReq();
        //3e requete - api2
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        deuxiemeReq();
        //2e requete - api2
        })
        .catch((err) => {
          setErreur(true);
        });
        }
        premiereReq();
        //1ere requete - api2

        });
        }
        premiereReq();
        //1ere requete - api1
      } // if (block === "0")
    } // if(idPersonConnectedFA)
  }
  EpinglerMessageFA();
  //EpinglerMessageFA
}
//PageRedirection66groupOtherFA


  // speedMessagesPagesFA (optimiser , juste 20 messages)
  const [speedMessagesPagesFA, setSpeedMessagesPagesFA] = useState(false); 
  async function SpeedMessagesPagesFA() { setSpeedMessagesPagesFA(true); setFlorinatoApp(false); }
  async function CloseSpeedMessagesPagesFA() { setSpeedMessagesPagesFA(false); setFlorinatoApp(true); }
  
  
  const [menuPopup, setMenuPopup] = useState(false); 
  async function MenuPopup() { setMenuPopup(true); }
  async function CloseMenuPopup() { setMenuPopup(false); }
 
  const [pagesGerer, setPagesGerer] = useState(false); 
  async function PagesGerer() { setPagesGerer(true); }
  async function ClosePagesGerer() { setPagesGerer(false); }
  
  const [menuAvecIcone, setMenuAvecIcone] = useState(false); 
  async function MenuAvecIcone() { setMenuAvecIcone(true); }
  async function CloseMenuAvecIcone() { setMenuAvecIcone(false); }
  
  const [menuBas, setMenuBas] = useState(false); 
  async function MenuBas() { setMenuBas(true); }
  async function CloseMenuBas() { setMenuBas(false); }
  
  const [gestionPage, setGestionPage] = useState(false); 
  async function GestionPage() { setGestionPage(true); }
  async function CloseGestionPage() { setGestionPage(false); }
  
  const [popupBasTextarea, setPopupBasTextarea] = useState(false); 
  async function PopupBasTextarea() { setPopupBasTextarea(true); }
  async function ClosePopupBasTextarea() { setPopupBasTextarea(false); }
  

  // Listes de tout les comptes (par ordre de comptes recents) - FA 
  const [comptesRecentsPageFA, setComptesRecentsPageFA] = useState(false); // listes des comptes recents
  async function ComptesRecentsPageFA() { setComptesRecentsPageFA(true); }
  async function CloseComptesRecentsPageFA() { setComptesRecentsPageFA(false);  }
  
  
  const [comptesEnLigneFA, setComptesEnLigneFA] = useState(false); // listes des comptes en lignes
  async function ComptesEnLigneFA() { setComptesEnLigneFA(true); setFlorinatoApp(false); }
  async function CloseComptesEnLigneFA() { setFlorinatoApp(true); setComptesEnLigneFA(false);  }
  
  
  // ajouter un autre compte a la gestion du compte florinato - FA 
  //const [ajouterGestionCompteConfirmation, setAjouterGestionCompteConfirmation] = useState(false); 
  //async function AjouterGestionCompteConfirmation() { setAjouterGestionCompteConfirmation(true); }
  //async function CloseAjouterGestionCompteConfirmation() { setAjouterGestionCompteConfirmation(false); }


  
  const [annoncesPageFA, setAnnoncesPageFA] = useState(false); // page pour afficher les annonces
  async function AnnoncesPageFA() { setAnnoncesPageFA(true); setVideosPageFA(false); }
  async function CloseAnnoncesPageFA() { setVideosPageFA(true); setAnnoncesPageFA(false); }
  
  
  const [afficherAnnoncePageFA, setAfficherAnnoncePageFA] = useState(false); // page pour afficher une annonce
  async function AfficherAnnoncePageFA() { setAfficherAnnoncePageFA(true); setAnnoncesPageFA(false); }
  async function CloseAfficherAnnoncePageFA() { setAnnoncesPageFA(true); setAfficherAnnoncePageFA(false); }
  
  
  const [publierAnnoncePageFA, setPublierAnnoncePageFA] = useState(false); // page pour publier une annonce
  async function PublierAnnoncePageFA() { setPublierAnnoncePageFA(true); }
  async function ClosePublierAnnoncePageFA() { setPublierAnnoncePageFA(false); }
  
  
  // page ou on affiche toutes les videos - FA 
  const [videosPageFA, setVideosPageFA] = useState(true); 
  async function VideosPageFA() { setVideosPageFA(true); setFlorinatoApp(false); }
  async function CloseVideosPageFA() { setFlorinatoApp(true); setVideosPageFA(false); }
  
  
  // Les comptes les plus populaires sur florinato - FA 
  const [popularityAccountsPageFA, setPopularityAccountsPageFA] = useState(false); 
  async function PopularityAccountsPageFA() {
    setPopularityAccountsPageFA(true);
	setFlorinatoApp(false);

    async function get() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
      })
      .catch((err) => {

      async function get2() {
        await axios
        .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
        })
        }
        get2();
    });
    }
    get();
  }

  async function ClosePopularityAccountsPageFA() { //fermer
	setFlorinatoApp(true);
    setPopularityAccountsPageFA(false);
  }

    
  // PageRedirection 666ChildApi66popularityAccountsPageFA
  async function PageRedirection666ChildApi66popularityAccountsPageFA() {

    // GoToProfilOther (page pour afficher le compte sur laquelle j'ai cliqué)
    const profilOther = localStorage.getItem("GoToProfilOther");
    if (profilOther === "1") { 
      setProfilOtherFA(true); //on affiche le profile de l'autre

  // logique pour envoyer la visite lorsqu'on clique sur un compte
  async function ClicAccount() {
    if (idPersonConnectedFA) {
		
		const popularity = popularityOther + 1;  //type:200 il a visité le compte
		await ExecuterActionFA({ dataPUT:{popularity}, dataPOST: {idAccount, idOther, visible:1, type:200}, id:idAccount, actions: ["post", "put"] });
		
		/*
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete -api1
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
        
    //creer un id pour chaque message envoyé sur florinato
    const numberMessageXA = api.filter((api) => api._id);
    const totalMessageXA = numberMessageXA.length;
  
    const createIdMessageXA = totalMessageXA + 1;
    if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete -api1
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idAccountChef");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idAccountChef = localStorage.getItem("idAccountChef");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const visible = "1";
      const type = "200"; // il a visité le compte,

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idAccountChef,
          idGroupChef,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete - api1
        // on augmente la popularité
        async function troisiemeReq() {
          const idAccount = localStorage.getItem("idAccountChef");
          //on compte la popularité
          const numberPopularityOther = apiMessageFA.filter((api) => api.idOther === idAccount && api.type === "200");
          const popularityOther = numberPopularityOther.length;

          const one = "1";
          const popularity = parseInt(popularityOther) + parseInt(one);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idAccount}`,
            data: {
              popularity,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete - api1
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete - api1
        })
        }
        troisiemeReq();
        //3e requete - api1
        })
        }
        deuxiemeReq();
        //2e requete - api1
        })
        .catch((err) => {

      //1ere requete - api2
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
        
    //creer un id pour chaque message envoyé sur florinato
    const numberMessageXA = api.filter((api) => api._id);
    const totalMessageXA = numberMessageXA.length;
  
    const createIdMessageXA = totalMessageXA + 1;
    if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete -api2
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idAccountChef");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idAccountChef = localStorage.getItem("idAccountChef");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const visible = "1";
      const type = "200"; // il a visité le compte,

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idAccountChef,
          idGroupChef,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete - api2
        // on augmente la popularité
        async function troisiemeReq() {
          const idAccount = localStorage.getItem("idAccountChef");
          //on compte la popularité
          const numberPopularityOther = apiMessageFA.filter((api) => api.idOther === idAccount && api.type === "200");
          const popularityOther = numberPopularityOther.length;

          const one = "1";
          const popularity = parseInt(popularityOther) + parseInt(one);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${idAccount}`,
            data: {
              popularity,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete -api2
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete -api2
        })
        }
        troisiemeReq();
        //3e requete -api2
        })
        }
        deuxiemeReq();
        //2e requete -api2
        })
        }
        premiereReq();
        //1ere requete -api2

        });
        }
        premiereReq();
        //1ere requete -api1
      } // if (block === "0")
	  */
  
      } // if(idPersonConnectedFA)
    }
    ClicAccount();
    }//if (profilOther === "1")
  }




  // logique lorsqu'il clique sur une photo
  async function ClicPhotoFA() {
    setSeePhotoFA(true);

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete - api1
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
            
        //creer un id pour chaque message envoyé sur florinato
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
      
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete - api1
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idOther");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idAccountChef = localStorage.getItem("idAccountChef");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const visible = "1";
      const type = "203"; // xxx a cliquer sur cette photo

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idAccountChef,
          idGroupChef,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete -api1
        // on augmente le nombre de clic
        async function troisiemeReq() {
          const id = localStorage.getItem("idreq");
          //on compte les clic
          const numberclic = apiMessageFA.filter((api) => api.idOther === idAccount && api.type === "203");
          const totalclic = numberclic.length;

          const one = "1";
          const clic = parseInt(totalclic) + parseInt(one);
          console.log("totalclic", totalclic);
          console.log("clic augmenter", clic);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${id}`,
            data: {
              clic,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete -api1
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete -api1
        })
        }
        troisiemeReq();
        //3e requete -api1
        })
        }
        deuxiemeReq();
        //2e requete -api1
        })
        .catch((err) => {

      //1ere requete -api2
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
        
    //creer un id pour chaque message envoyé sur florinato
    const numberMessageXA = api.filter((api) => api._id);
    const totalMessageXA = numberMessageXA.length;
  
    const createIdMessageXA = totalMessageXA + 1;
    if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete -api2
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idOther");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idAccountChef = localStorage.getItem("idAccountChef");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const visible = "1";
      const type = "203"; // xxx a cliquer sur cette photo

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idAccountChef,
          idGroupChef,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete -api2
        // on augmente le nombre de clic
        async function troisiemeReq() {
          const id = localStorage.getItem("idreq");
          //on compte les clic
          const numberclic = apiMessageFA.filter((api) => api.idOther === idAccount && api.type === "203");
          const totalclic = numberclic.length;
          
          const one = "1";
          const clic = parseInt(totalclic) + parseInt(one);
          console.log("totalclic", totalclic);
          console.log("clic augmenter", clic);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${id}`,
            data: {
              clic,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete -api2
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete -api2
        })
        }
        troisiemeReq();
        //3e requete -api2
        })
        }
        deuxiemeReq();
        //2e requete -api2
        })
        }
        premiereReq();
        //1ere requete -api2

        });
        }
        premiereReq();
        //1ere requete -api1
      } // if (block === "0")
      } // if(idPersonConnectedFA)
    }
    //ClicPhotoFA



  // logique lorsqu'il clique sur une video 
  async function ClicVideoFA() {
    setSeeVideoFA(true);

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete -api1
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
            
        //creer un id pour chaque message envoyé sur florinato
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
      
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete -api1
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idOther");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idAccountChef = localStorage.getItem("idAccountChef");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const visible = "1";
      const type = "204"; // xxx a cliquer sur cette video

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idAccountChef,
          idGroupChef,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete -api1
        // on augmente le nombre de clic
        async function troisiemeReq() {
          const id = localStorage.getItem("idreq");
          //on compte les clic
          const numberclic = apiMessageFA.filter((api) => api.idOther === idAccount && api.type === "204");
          const totalclic = numberclic.length;

          const one = "1";
          const clic = parseInt(totalclic) + parseInt(one);
          console.log("totalclic", totalclic);
          console.log("clic augmenter", clic);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${id}`,
            data: {
              clic,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete -api1
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete -api1
        })
        }
        troisiemeReq();
        //3e requete -api1
        })
        }
        deuxiemeReq();
        //2e requete -api1
        })
        .catch((err) => {

      //1ere requete -api2
      // creer un id
      async function premiereReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
            
        //creer un id pour chaque message envoyé sur florinato
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
      
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //2e requete -api2
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idOther");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const idAccountChef = localStorage.getItem("idAccountChef");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const visible = "1";
      const type = "204"; // xxx a cliquer sur cette video

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: nameFA,
          photoAccount: photoFA,
          badgeAccount: badgeFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          idAccountChef,
          idGroupChef,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete -api2
        // on augmente le nombre de clic
        async function troisiemeReq() {
          const id = localStorage.getItem("idreq");
          //on compte les clic
          const numberclic = apiMessageFA.filter((api) => api.idOther === idAccount && api.type === "204");
          const totalclic = numberclic.length;

          const one = "1";
          const clic = parseInt(totalclic) + parseInt(one);
          console.log("totalclic", totalclic);
          console.log("clic augmenter", clic);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${id}`,
            data: {
              clic,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete -api2
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete -api2
        })
        }
        troisiemeReq();
        //3e requete -api2
        })
        }
        deuxiemeReq();
        //2e requete -api2
        })
        }
        premiereReq();
        //1ere requete -api2

        });
        }
        premiereReq();
        //1ere requete -api1
      } // if (block === "0")
      } // if(idPersonConnectedFA)
    }
    //ClicVideoFA


  // on affiche les messages privés dans l'application x 
  const [messageXA, setMessageXA] = useState(false); 
  async function MessageXA() {
    setMessageXA(true);
  }
  async function CloseMessageXA() {
    setMessagePublicXA(false);
  }

  // displayPhotoXA (au niveau de decouverte, on affiche la photo sur laquelle on a cliquer)
  /*const [displayPhotoXA, setDisplayPhotoXA] = useState(false); 
  async function CloseDisplayPhotoXA() {
    setDisplayPhotoXA(false);
  }*/

  
  // PageRedirection 666ChildApiDecouverteXA
  async function PageRedirection666ChildApiDecouverteXA() {

    // GoToDisplayPhotoXA (page pour afficher la photo sur laquelle on a cliquer)
    const displayPhoto = localStorage.getItem("GoToDisplayPhotoXA");
    if (displayPhoto === "1") { 
      //setDisplayPhotoXA(true);

      setProfilOtherFA(true); //on affiche le profile de l'autre

  // logique pour envoyer le clic d'une photo
  async function ClicPhotoXA() {
    if (idPersonConnectedFA) {

    const block = localStorage.getItem("blockFA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      // AllMessageReq
      async function AllMessageReq() {
        await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA/`)
          .then((res) => {
            setApiMessageAA(res.data);
            const api = res.data;
        
    //creer un id pour chaque message envoyé sur X
    const numberMessageXA = api.filter((api) => api._id);
    const totalMessageXA = numberMessageXA.length;
  
    const createIdMessageXA = totalMessageXA + 1;
    if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

    //1ere requete
    //1ere requete
    // on envoie le message
    async function premiereReq() {
      const id = localStorage.getItem("createId");
      const photo1 = localStorage.getItem("photo1req");
      const idPhoto1 = localStorage.getItem("idPhoto1req");
      const idOther = localStorage.getItem("idAccount");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const display = "1";
      const visible = "1";
      const hide = "0";
      const deleted = "0";
      const type = "101"; //il a cliqué sur cette photo

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_SendMessageAA}/api/messageAA/new`,
      data: {
        id,
        idAccount: idPersonConnectedFA,
        nameAccount: namePersonConnectedFA,
        badgeAccount: badgePersonConnectedFA,
        photoAccount: photoPersonConnectedFA,
        idOther,
        nameOther,
        photoOther,
        badgeOther,
        photo1,
        idPhoto1,
        display,
        hide,
        deleted,
        visible,
        type,
      },
    })
    .then((res) => {
      console.log(res);

    //2e requete
    //2e requete
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const idOther = localStorage.getItem("idAccount");
      const nameOther = localStorage.getItem("nameOther");
      const photoOther = localStorage.getItem("photoOther");
      const badgeOther = localStorage.getItem("badgeOther");
      const display = "1";
      const visible = "1";
      const hide = "0";
      const deleted = "0";
      const type = "200"; // il a visité le compte,

      await axios({
        method: "post",
        url: `${process.env.REACT_APP_SendMessageAA}/api/messageAA/new`,
        data: {
          id,
          idAccount: idPersonConnectedFA,
          nameAccount: namePersonConnectedFA,
          photoAccount: photoPersonConnectedFA,
          badgeAccount: badgePersonConnectedFA,
          idOther,
          nameOther,
          photoOther,
          badgeOther,
          display,
          hide,
          deleted,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log(res);

        //3e requete
        //3e requete
        // on augmente la popularité
        async function troisiemeReq() {
          //on compte la popularité
          const numberPopularityOther = apiMessageAA.filter((api) => api.idOther === idOther && api.type === "200");
          const popularityOther = numberPopularityOther.length;
          console.log("numberPopularityOther", numberPopularityOther);

          const one = "1";
          const popularity = parseInt(popularityOther) + parseInt(one);
          console.log("popularityOther", popularityOther);
          console.log("popularité augmenter", popularity);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SendMessageAA}/api/messageAA/update/${idOther}`,
            data: {
              popularity,
            },
          })
          .then((res) => {
            console.log(res);

      //4e requete
      //4e requete
      // on obtiens les nouvelles données
      async function quatriemeReq() {
        await axios
          .get(`${process.env.REACT_APP_BACKEND}/api/messageAA/`)
          .then((res) => {
            setApiMessageAA(res.data);
            console.log(res);
          })
        }
        quatriemeReq();
        //4e requete
        })
        }
        troisiemeReq();
        //3e requete

                })
                }
                deuxiemeReq();
                //2e requete
                })
                }
                premiereReq();
                //1ere requete
                })
                }
                AllMessageReq();
                //AllMessageReq
                } 
                // if (block === "0")
              } // if(idPersonConnectedFA)
            }
            ClicPhotoXA();
      }//if (displayPhoto === "1")
  }


  // afficher la photo de la personne connecté - FA
  const [seePhoto66profilFA, setSeePhoto66profilFA] = useState(false); 
  async function SeePhoto66profilFA() { setSeePhoto66profilFA(true); }
  async function CloseSeePhoto66profilFA() { setSeePhoto66profilFA(false); }


  const [seePhoto2e, setSeePhoto2e] = useState(false); 
  async function SeePhoto2e() { setSeePhoto2e(true); }
  async function CloseSeePhoto2e() { setSeePhoto2e(false); }
  
  
  const [seePhotoCouvertureVideo, setSeePhotoCouvertureVideo] = useState(false); 
  async function SeePhotoCouvertureVideo() { setSeePhotoCouvertureVideo(true); }
  async function CloseSeePhotoCouvertureVideo() { setSeePhotoCouvertureVideo(false); }



  // favoris - page
  const [favoriteFA, setFavoriteFA] = useState(false); 
  async function FavoriteFA() {
    setFavoriteFA(true);
  }
  async function CloseFavoriteFA() {
    setFavoriteFA(false);
  }


  //logique pour ajouter une photo à nos favoris FA
  const [isLoading66favoriteFA, setIsLoading66favoriteFA] = useState(false);
  const [filePhoto66favoriteFA, setFile66favoriteFA] = useState();

  async function AddPhoto66favoriteFA() {
    setIsLoading66favoriteFA(true);

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      
    //1ere requete - api1
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;

        //creer un id pour chaque elements ajouté aux favoris
        const numberFavoriteAA = api.filter((api) => api._id);
        const totalFavoriteAA = numberFavoriteAA.length;

        const createIdFavoriteAA = totalFavoriteAA + 1;
        if (createIdFavoriteAA) { localStorage.setItem("createId", createIdFavoriteAA) }

    //2e requete - api1
    // on envoie la photo sur imagekit
    async function deuxiemeReq() {
      const data = new FormData();
      data.append("image", filePhoto66favoriteFA);

      await axios
      .post(`${process.env.REACT_APP_Api1}/api/messageFA/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("photo ajouter aux favoris", res);
        const urlPhoto = res.data.urlPhoto;
        if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }

      //3e requete - api1
      // on enregistre la photo dans notre bdd
      async function troisiemeReq() {
        const id = localStorage.getItem("createId");
        const urlPhoto = localStorage.getItem("urlPhotoreq");
        const urlVideo = "0";
        const visible = "1";
        const type = "20";
      
        await axios({
        method: "post",
        url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
        data: {
          id,
          idUser: idUserConnectedFA,
          urlPhoto,
          urlVideo,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log("photo enregistrer dans la bdd", res);

        //4e requete - api1
        // on obtiens de nouvelles donnees
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            console.log(res);
            setApiMessageFA(res.data);
            setIsLoading66favoriteFA(false);
            setWriteMessagePageFA(true)
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setWriteMessagePageFA(true)
          });
          }
          quatriemeReq();
          //4e requete - api1
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setWriteMessagePageFA(true)
            setErreur(true);
          });
          }
          troisiemeReq();
          //3e requete - api1
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setErreur(true);
          });
          }
          deuxiemeReq();
          //2e requete - api1
          })
          .catch((err) => {
            
        //1ere requete - api2
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;

            //creer un id pour chaque elements ajouté aux favoris
            const numberFavoriteAA = api.filter((api) => api._id);
            const totalFavoriteAA = numberFavoriteAA.length;

            const createIdFavoriteAA = totalFavoriteAA + 1;
            if (createIdFavoriteAA) { localStorage.setItem("createId", createIdFavoriteAA) }

        //2e requete - api2
        // on envoie la photo sur imagekit
        async function deuxiemeReq() {
          const data = new FormData();
          data.append("image", filePhoto66favoriteFA);

          await axios
          .post(`${process.env.REACT_APP_Api2}/api/messageFA/sendPhoto`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            console.log("photo ajouter aux favoris", res);
            const urlPhoto = res.data.urlPhoto;
            if (urlPhoto) { localStorage.setItem("urlPhotoreq", urlPhoto); }

        //3e requete - api2
        // on enregistre la photo dans notre bdd
        async function troisiemeReq() {
          const id = localStorage.getItem("createId");
          const urlPhoto = localStorage.getItem("urlPhotoreq");
          const urlVideo = "0";
          const visible = "1";
          const type = "20";
        
          await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
          data: {
            id,
            idUser: idUserConnectedFA,
            urlPhoto,
            urlVideo,
            visible,
            type,
          },
        })
        .then((res) => {
          console.log("photo enregistrer dans la bdd", res);

        //4e requete - api2
        // on obtiens de nouvelles donnees
        async function quatriemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            console.log(res);
            setApiMessageFA(res.data);
            setIsLoading66favoriteFA(false);
            setWriteMessagePageFA(true)
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setWriteMessagePageFA(true)
          });
          }
          quatriemeReq();
          //4e requete - api2
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setWriteMessagePageFA(true)
            setErreur(true);
          });
          }
          troisiemeReq();
          //3e requete - api2
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setErreur(true);
          });
          }
          deuxiemeReq();
          //2e requete - api2
          })
          .catch((err) => {
            setIsLoading66favoriteFA(false);
            setErreur(true);
          });
          }
          premiereReq();
          //1ere requete - api2

          })
          }
          premiereReq();
          //1ere requete - api1
    }//if (block === "0")
    }//if(idPersonConnectedFA)
}
//AddPhoto66favoriteFA
  


  //page - pour ecrire le message et envoyer la photo
  const [writeMessagePageFA, setWriteMessagePageFA] = useState(false);
  async function CloseWriteMessagePageFA() { 
    setWriteMessagePageFA(false);
  }

  // Tout Annuler FA - (au niveau de la page pour ecrire un message et envoyer la photo, on clique sur Annuler.
  async function Annuler66writeMessagePageFA() {
    setFavoriteFA(false);
    setWriteMessagePageFA(false);
  } 
 
  // PageRedirection 66ChildApi66favoriteFA
  async function PageRedirection66ChildApi66favoriteFA() {
    //page - pour ecrire message + envoyer photo
    const writeMessagePage = localStorage.getItem("GoToWriteMessagePageFA");
    if (writeMessagePage === "1") { setWriteMessagePageFA(true); }
  }
  

  // PageRedirection 66ChildApi66favorite66selectedFA
  async function PageRedirection66ChildApi66favorite66selectedFA() {
    //page - pour ecrire message + envoyer photo
    const writeMessagePage = localStorage.getItem("GoToWriteMessagePage66selectedFA");
    if (writeMessagePage === "1") { setWriteMessagePage66selectedFA(true); }
  }

  // filtre pour obtenir tout les messages de la discussion - XA
  const getAllMessageXA = apiMessageAA.filter((api) => api.Decouverte);
  const filterMessageXA = getAllMessageXA.sort((a, b) => b.id - a.id); 


  // selectedFA (selectionner)
  const [selectedFA, setSelectedFA] = useState(false);
  async function CloseSelectedFA() { 
    setSelectedFA(false);
  }


  //writeMessagePage66selectedFA - page pour ecrire le message et envoyer la photo
  const [writeMessagePage66selectedFA, setWriteMessagePage66selectedFA] = useState(false);
  async function CloseWriteMessagePage66selectedFA() { 
    setWriteMessagePage66selectedFA(false);
  }

  // favoris - page
  const [favorite66selectedFA, setFavorite66selectedFA] = useState(false); 
  async function Favorite66selectedFA() {
    setFavorite66selectedFA(true);
  }
  async function CloseFavorite66selectedFA() {
    setFavorite66selectedFA(false);
  }



  // logique pour publier une photo sur son compte et groupe florinato
  const [writeMessage66writeMessagePageFA, setWriteMessage66writeMessagePageFA] = useState(""); 
  
  async function SendPhoto66writeMessagePageFA() {
      localStorage.setItem("writeMessage", writeMessage66writeMessagePageFA); //enregistrer le message saisi
      setWriteMessage66writeMessagePageFA("");//ici, une fois que on a cliquer sur le bouton envoyer la photo, on vide le textarea, et ensuite on ferme ces deux pages
      setFavoriteFA(false); 
      setWriteMessagePageFA(false);

      if (idPersonConnectedFA) {
        const block = localStorage.getItem("blockFA");
        if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

        //1ere requete - api1
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
          
          //creer un id 
          const numberMessageXA = api.filter((api) => api._id);
          const totalMessageXA = numberMessageXA.length;
        
          const createIdMessageXA = totalMessageXA + 1;
          if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

        //2e requete - api1
        // on publie la photo
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const message = localStorage.getItem("writeMessage");
          const urlPhoto = localStorage.getItem("urlPhotoreq");
          const idAccountChef = localStorage.getItem("idAccountChef");
          const idGroupChef = localStorage.getItem("idGroupChef");
          const clic = "0";
          const comment = "0";
          const account = "1";
          const group = "1";
          const visible = "1";
          const type = "2"; //envoyer un message + photo

          await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
          data: {
            id,
            message,
            urlPhoto,
            idAccount: idPersonConnectedFA,
            nameAccount: nameFA,
            photoAccount: photoFA,
            badgeAccount: badgeFA,
            idAccountChef,
            idGroupChef,
            clic,
            comment,
            account,
            group,
            visible,
            type,
          },
        })
        .then((res) => {
          console.log(res);

        //3e requete - api1
        // cette requete c'est pour recuperer tout les messages de la bdd
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
          })
          }
          troisiemeReq();
          //3e requete - api1
          })
          .catch((err) => {
            setErreur(true);
          });
          }
          deuxiemeReq();
          //2e requete - api1
          })
          .catch((err) => {
            
        //1ere requete - api2
        async function premiereReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            const api = res.data;
          
          //creer un id 
          const numberMessageXA = api.filter((api) => api._id);
          const totalMessageXA = numberMessageXA.length;
        
          const createIdMessageXA = totalMessageXA + 1;
          if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

        //2e requete - api2
        // on publie la photo
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const message = localStorage.getItem("writeMessage");
          const urlPhoto = localStorage.getItem("urlPhotoreq");
          const idAccountChef = localStorage.getItem("idAccountChef");
          const idGroupChef = localStorage.getItem("idGroupChef");
          const clic = "0";
          const comment = "0";
          const account = "1";
          const group = "1";
          const visible = "1";
          const type = "2"; //envoyer un message + photo

          await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
          data: {
            id,
            message,
            urlPhoto,
            idAccount: idPersonConnectedFA,
            nameAccount: nameFA,
            photoAccount: photoFA,
            badgeAccount: badgeFA,
            idAccountChef,
            idGroupChef,
            clic,
            comment,
            account,
            group,
            visible,
            type,
          },
        })
        .then((res) => {
          console.log(res);

        //3e requete - api2
        // cette requete c'est pour recuperer tout les messages de la bdd
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
          })
          }
          troisiemeReq();
          //3e requete - api2
          })
          .catch((err) => {
            setErreur(true);
          });
          }
          deuxiemeReq();
          //2e requete - api2
          })
          .catch((err) => {
            setErreur(true);
          });
          }
          premiereReq();
          //1ere requete - api2

          });
          }
          premiereReq()
          //1ere requete - api1
      } // if (block === "0")
      } // if(idPersonConnectedFA)
}
//SendPhoto66writeMessagePageFA
//SendPhoto66groupFA



  //logique pour envoyer un message dans un groupe
  const [writeMessage66groupOtherFA, setWriteMessage66groupOtherFA] = useState(""); 

  async function SendMessage66groupOtherFA() {
    localStorage.setItem("writeMessage66groupOtherFA", writeMessage66groupOtherFA);  //on enregistre le message saisi dans le localStorage
    setWriteMessage66groupOtherFA(""); //vider le textarea
    console.log("envoi du message..");

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //1ere requete -api1
      // creer un id
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          const api = res.data;
        
        //creer un id pour chaque message envoyé
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
      
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }
        console.log("success 1ere requete - api1");

    //2e requete -api1
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const message = localStorage.getItem("writeMessage66groupOtherFA");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const idGroup = localStorage.getItem("idGroup");
      const group = "1";
      const visible = "1";
      const type = "1"; //envoyer un message 
      console.log("idGroup :", idGroup);
      console.log("idGroupChef :", idGroupChef);

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
      data: {
        id,
        message,
        idAccount: idPersonConnectedFA,
        nameAccount: nameFA,
        photoAccount: photoFA,
        badgeAccount: badgeFA,
        idGroupChef,
        group,
        visible,
        type,
      },
    })
    .then((res) => {
      const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
      localStorage.setItem("online", online);
      console.log(online);
      console.log(res);
      console.log("success 2e requete - api1");

      //3e requete - api1
      // cette requete c'est pour modifier le dernier message au niveau de la conversation
      async function troisiemeReq() {
        const id = localStorage.getItem("createId");
        const idGroupChef = localStorage.getItem("idGroupChef");
        const lastMessage = localStorage.getItem("writeMessage66groupOtherFA");

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idGroupChef}`,
          data: {
            id,
            lastMessage,
          },
        })
        .then((res) => {
          console.log("success 3e requete - api1");

      //4e requete -api1
      // obtenir de nouvelles données
      async function quatriemeReq() {
        await axios
        .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          console.log("success 4e requete - api1");
        })
        .catch((err) => {
          setErreur(true);
          console.log("4e requete - api1");
        })
        }
        quatriemeReq();
        //4e requete -api1
        })
        .catch((err) => {
          setErreur(true);
          console.log("3e requete - api1");
        })
        }
        troisiemeReq();
        //3e requete -api1
        })
        .catch((err) => {
          setErreur(true);
          console.log("2e requete - api1");
        })
        }
        deuxiemeReq();
        //2e requete -api1
        })
        .catch((err) => {
        console.log("1ere requete - api1"); 
        console.log("utilisation de l'api2"); 
          
      //1ere requete -api2
      // creer un id
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          const api = res.data;
        
        //creer un id pour chaque message
        const numberMessageXA = api.filter((api) => api._id);
        const totalMessageXA = numberMessageXA.length;
      
        const createIdMessageXA = totalMessageXA + 1;
        if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }
        console.log("success 1ere requete - api2");

    //2e requete -api2
    // on envoie le message
    async function deuxiemeReq() {
      const id = localStorage.getItem("createId");
      const message = localStorage.getItem("writeMessage66groupOtherFA");
      const idGroupChef = localStorage.getItem("idGroupChef");
      const group = "1";
      const visible = "1";
      const type = "1"; //envoyer un message 

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
      data: {
        id,
        message,
        idAccount: idPersonConnectedFA,
        nameAccount: nameFA,
        photoAccount: photoFA,
        badgeAccount: badgeFA,
        idGroupChef,
        group,
        visible,
        type,
      },
    })
    .then((res) => {
      const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
      localStorage.setItem("online", online);
      console.log(online);
      console.log(res);
      console.log("success 2e requete - api2");

      //3e requete - api2
      // cette requete c'est pour modifier le dernier message au niveau de la conversation
      async function troisiemeReq() {
        const id = localStorage.getItem("createId");
        const idGroupChef = localStorage.getItem("idGroupChef");
        const lastMessage = localStorage.getItem("writeMessage66groupOtherFA");

        await axios({
          method: "put",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${idGroupChef}`,
          data: {
            id,
            lastMessage,
          },
        })
        .then((res) => {
          console.log("success 3e requete - api2");

      //4e requete - api2
      // obtenir de nouvelles données
      async function quatriemeReq() {
        await axios
        .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
        .then((res) => {
          setApiMessageFA(res.data);
          console.log("success 4e requete - api2");
        })
        .catch((err) => {
          setErreur(true);
          console.log("4e requete - api2");
        })
        }
        quatriemeReq();
        //4e requete -api2
        })
        .catch((err) => {
          setErreur(true);
          console.log("3e requete - api2");
        })
        }
        troisiemeReq();
        //3e requete -api2
        })
        .catch((err) => {
          setErreur(true);
          console.log("2e requete - api2");
        })
        }
        deuxiemeReq();
        //2e requete -api2
        })
        .catch((err) => {
          setErreur(true);
          console.log("1ere requete - api2");
        })
        }
        premiereReq();
        //1ere requete -api2

        })
        }
        premiereReq();
        //1ere requete - api1
      } 
      // if (block === "0")
    } 
    // if(idPersonConnectedFA)
}
// SendMessage66groupOtherFA




// saisir la réponse 
const [writeReponseFA, setWriteReponseFA] = useState(""); 

//logique pour envoyer une réponse
async function SendReponseFA() {
  if (idPersonConnectedFA) {
    const block = localStorage.getItem("blockFA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

    //on enregistre le message saisi dans le localStorage pour ensuite vider le textarea
    localStorage.setItem("writeReponseFA", writeReponseFA)
    //ici, une fois que on a cliquer sur le bouton envoyer la photo, on vide le textarea, et ensuite on ferme ces deux pages
    setWriteReponseFA("");

    setSelectedFA(false);
    setFavorite66selectedFA(false);
    setWriteMessagePage66selectedFA(false);

    // 1ere requete -api1
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;
      
  //creer un id pour chaque message envoyé sur X
  const numberMessageXA = api.filter((api) => api._id);
  const totalMessageXA = numberMessageXA.length;

  const createIdMessageXA = totalMessageXA + 1;
  if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

  //2e requete -api1
  // on envoie le message
  async function deuxiemeReq() {
    const id = localStorage.getItem("createId");
    const message = localStorage.getItem("writeReponseFA");
    const urlPhoto = localStorage.getItem("urlPhotoreq");
    const urlVideo = localStorage.getItem("urlVideoreq");

    const idMessageOther = localStorage.getItem("idMessageOther");
    const messageOther = localStorage.getItem("messageOther");
    const idOther = localStorage.getItem("idOther");
    const nameOther = localStorage.getItem("nameOther");
    const photoOther = localStorage.getItem("photoOther");
    const badgeOther = localStorage.getItem("badgeOther");
    const urlPhotoOther = localStorage.getItem("urlPhotoOther");
    const urlVideoOther = localStorage.getItem("urlVideoOther");
    const typeOther = localStorage.getItem("typeOtherreq");

    const idAccountChef = localStorage.getItem("idAccountChef");
    const idGroupChef = localStorage.getItem("idGroupChef");
    const account = "1";
    const group = "1";
    const clic = "0";
    const comment = "0";
    const visible = "1";
    const type = localStorage.getItem("typereq"); // envoyer une réponse, (apres avoir cliquer sur un message text, un message photo ou un message video)

    await axios({
    method: "post",
    url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
    data: {
      id,
      message,
      idAccount: idPersonConnectedFA,
      nameAccount: nameFA,
      photoAccount: photoFA,
      badgeAccount: badgeFA,
      urlPhoto,
      urlVideo,
      
      idMessageOther,
      messageOther,
      idOther,
      nameOther,
      photoOther,
      badgeOther,
      urlPhotoOther,
      urlVideoOther,
      typeOther,
      
      idAccountChef,
      idGroupChef,
      account,
      group,
      clic,
      comment,
      visible,
      type,
    },
  })
  .then((res) => {
    //const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
    //localStorage.setItem("online", online);
    //console.log(online);
    console.log(res);

    // 3e requete -api1
    // cette requete c'est pour recuperer tout les messages de la bdd
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        console.log(res);
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      troisiemeReq();
      //3e requete -api1
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      deuxiemeReq();
      //2e requete -api1
      })
      .catch((err) => {
        
    // 1ere requete -api2
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;
          
      //creer un id pour chaque message envoyé sur X
      const numberMessageXA = api.filter((api) => api._id);
      const totalMessageXA = numberMessageXA.length;

      const createIdMessageXA = totalMessageXA + 1;
      if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

  //2e requete -api2
  // on envoie la réponse
  async function deuxiemeReq() {
    const id = localStorage.getItem("createId");
    const message = localStorage.getItem("writeReponseFA");
    const urlPhoto = localStorage.getItem("urlPhotoreq");
    const urlVideo = localStorage.getItem("urlVideoreq");

    const idMessageOther = localStorage.getItem("idMessageOther");
    const messageOther = localStorage.getItem("messageOther");
    const idOther = localStorage.getItem("idOther");
    const nameOther = localStorage.getItem("nameOther");
    const photoOther = localStorage.getItem("photoOther");
    const badgeOther = localStorage.getItem("badgeOther");
    const urlPhotoOther = localStorage.getItem("urlPhotoOther");
    const urlVideoOther = localStorage.getItem("urlVideoOther");
    const typeOther = localStorage.getItem("typeOtherreq");

    const idAccountChef = localStorage.getItem("idAccountChef");
    const idGroupChef = localStorage.getItem("idGroupChef");
    const account = "1";
    const group = "1";
    const clic = "0";
    const comment = "0";
    const visible = "1";
    const type = localStorage.getItem("typereq"); // envoyer une réponse, (apres avoir cliquer sur un message text, un message photo ou un message video)

    await axios({
    method: "post",
    url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
    data: {
      id,
      message,
      idAccount: idPersonConnectedFA,
      nameAccount: nameFA,
      photoAccount: photoFA,
      badgeAccount: badgeFA,
      urlPhoto,
      urlVideo,
      
      idMessageOther,
      messageOther,
      idOther,
      nameOther,
      photoOther,
      badgeOther,
      urlPhotoOther,
      urlVideoOther,
      typeOther,
      
      idAccountChef,
      idGroupChef,
      account,
      group,
      clic,
      comment,
      visible,
      type,
    },
  })
  .then((res) => {
    //const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
    //localStorage.setItem("online", online);
    //console.log(online);
    console.log(res);

    // 3e requete -api2
    // cette requete c'est pour recuperer tout les messages de la bdd
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        console.log(res);
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      troisiemeReq();
      //3e requete -api2
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      deuxiemeReq();
      //2e requete -api2
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      premiereReq();
      //1ere requete -api2

      })
      }
      premiereReq();
      //1ere requete -api1
    } 
    // if (block === "0")
  } 
  // if(idPersonConnectedFA)
}
// SendReponseFA



// saisir le message 
/*const [writeMessage66groupOtherFA, setWriteMessage66groupOtherFA] = useState(""); 

//logique pour envoyer une réponse, (message photo)
async function SendMessagetype41() {
  if (idPersonConnectedFA) {

  const block = localStorage.getItem("blockFA");
  if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

    //on enregistre le message saisi dans le localStorage pour ensuite vider le textarea
    localStorage.setItem("writeMessage66groupOtherFA", writeMessage66groupOtherFA)
    //ici, une fois que on a cliquer sur le bouton envoyer la photo, on vide le textarea, et ensuite on ferme ces deux pages
    setWriteMessage66groupOtherFA("");

    // 1ere requete -api1
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;
      
  //creer un id pour chaque message envoyé sur X
  const numberMessageXA = api.filter((api) => api._id);
  const totalMessageXA = numberMessageXA.length;

  const createIdMessageXA = totalMessageXA + 1;
  if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

  //2e requete -api1
  // on envoie le message
  async function deuxiemeReq() {
    const id = localStorage.getItem("createId");
    const message = localStorage.getItem("writeMessage66groupOtherFA");
    const urlPhoto = localStorage.getItem("urlPhotoreq");
    const urlVideo = localStorage.getItem("urlVideoreq");
    const photo = localStorage.getItem("photoreq");
    const video = localStorage.getItem("videoreq");
    const idGroup = localStorage.getItem("idGroup");
    const group = "1";
    const visible = "1";
    const type = "41"; //envoyer un message 

    await axios({
    method: "post",
    url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
    data: {
      id,
      message,
      idAccount: idPersonConnectedFA,
      nameAccount: nameFA,
      photoAccount: photoFA,
      badgeAccount: badgeFA,
      urlPhoto,
      urlVideo,
      photo,
      video,
      idGroup,
      group,
      visible,
      type,
    },
  })
  .then((res) => {
    const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
    localStorage.setItem("online", online);
    console.log(online);
    console.log(res);

    // 3e requete -api1
    // cette requete c'est pour recuperer tout les messages de la bdd
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      troisiemeReq();
      //3e requete -api1
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      deuxiemeReq();
      //2e requete -api1
      })
      .catch((err) => {
        
    // 1ere requete -api2
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;
      
  //creer un id pour chaque message envoyé sur X
  const numberMessageXA = api.filter((api) => api._id);
  const totalMessageXA = numberMessageXA.length;

  const createIdMessageXA = totalMessageXA + 1;
  if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

  //2e requete -api2
  // on envoie le message
  async function deuxiemeReq() {
    const id = localStorage.getItem("createId");
    const message = localStorage.getItem("writeMessage66groupOtherFA");
    const idGroup = localStorage.getItem("idGroup");
    const urlPhoto = localStorage.getItem("urlPhotoreq");
    const urlVideo = localStorage.getItem("urlVideoreq");
    const photo = localStorage.getItem("photoreq");
    const video = localStorage.getItem("videoreq");
    urlPhoto,
      urlVideo,
      photo,
      video,
    const group = "1";
    const visible = "1";
    const type = "41"; //envoyer une réponse (message photo)

    await axios({
    method: "post",
    url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
    data: {
      id,
      message,
      idAccount: idPersonConnectedFA,
      nameAccount: nameFA,
      photoAccount: photoFA,
      badgeAccount: badgeFA,
      idGroup,
      group,
      visible,
      type,
    },
  })
  .then((res) => {
    const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
    localStorage.setItem("online", online);
    console.log(online);
    console.log(res);

    // 3e requete -api2
    // cette requete c'est pour recuperer tout les messages de la bdd
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      troisiemeReq();
      //3e requete -api2
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      deuxiemeReq();
      //2e requete -api2
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      premiereReq();
      //1ere requete -api2

      })
      }
      premiereReq();
      //1ere requete -api1
    } 
    // if (block === "0")
  } 
  // if(idPersonConnectedFA)
} */
// SendMessagetype41



// saisir le message 
/*const [writeMessage66groupOtherFA, setWriteMessage66groupOtherFA] = useState(""); 

//logique pour envoyer une réponse, (message video)
async function SendMessagetype42() {
  if (idPersonConnectedFA) {

  const block = localStorage.getItem("blockFA");
  if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

    //on enregistre le message saisi dans le localStorage pour ensuite vider le textarea
    localStorage.setItem("writeMessage66groupOtherFA", writeMessage66groupOtherFA)
    //ici, une fois que on a cliquer sur le bouton envoyer la photo, on vide le textarea, et ensuite on ferme ces deux pages
    setWriteMessage66groupOtherFA("");

    // 1ere requete -api1
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;
      
  //creer un id pour chaque message envoyé sur X
  const numberMessageXA = api.filter((api) => api._id);
  const totalMessageXA = numberMessageXA.length;

  const createIdMessageXA = totalMessageXA + 1;
  if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

  //2e requete -api1
  // on envoie le message
  async function deuxiemeReq() {
    const id = localStorage.getItem("createId");
    const message = localStorage.getItem("writeMessage66groupOtherFA");
    const urlPhoto = localStorage.getItem("urlPhotoreq");
    const urlVideo = localStorage.getItem("urlVideoreq");
    const photo = localStorage.getItem("photoreq");
    const video = localStorage.getItem("videoreq");
    const idGroup = localStorage.getItem("idGroup");
    const group = "1";
    const visible = "1";
    const type = "42"; //envoyer une réponse (message video) 

    await axios({
    method: "post",
    url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
    data: {
      id,
      message,
      idAccount: idPersonConnectedFA,
      nameAccount: nameFA,
      photoAccount: photoFA,
      badgeAccount: badgeFA,
      urlPhoto,
      urlVideo,
      photo,
      video,
      idGroup,
      group,
      visible,
      type,
    },
  })
  .then((res) => {
    const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
    localStorage.setItem("online", online);
    console.log(online);
    console.log(res);

    // 3e requete -api1
    // cette requete c'est pour recuperer tout les messages de la bdd
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      troisiemeReq();
      //3e requete -api1
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      deuxiemeReq();
      //2e requete -api1
      })
      .catch((err) => {
        
    // 1ere requete -api2
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
        const api = res.data;
      
  //creer un id pour chaque message envoyé sur X
  const numberMessageXA = api.filter((api) => api._id);
  const totalMessageXA = numberMessageXA.length;

  const createIdMessageXA = totalMessageXA + 1;
  if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

  //2e requete -api2
  // on envoie le message
  async function deuxiemeReq() {
    const id = localStorage.getItem("createId");
    const message = localStorage.getItem("writeMessage66groupOtherFA");
    const urlPhoto = localStorage.getItem("urlPhotoreq");
    const urlVideo = localStorage.getItem("urlVideoreq");
    const video = localStorage.getItem("videoreq");
    const photo = localStorage.getItem("photoreq");
    const idGroup = localStorage.getItem("idGroup");
    const group = "1";
    const visible = "1";
    const type = "42"; //envoyer une réponse, (message vidéo) 

    await axios({
    method: "post",
    url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
    data: {
      id,
      message,
      idAccount: idPersonConnectedFA,
      nameAccount: nameFA,
      photoAccount: photoFA,
      badgeAccount: badgeFA,
      urlPhoto,
      urlVideo,
      video,
      photo,
      idGroup,
      group,
      visible,
      type,
    },
  })
  .then((res) => {
    const online = res.data.createdAt; //createdAt, c'est pour prendre la date de derniere connexion
    localStorage.setItem("online", online);
    console.log(online);
    console.log(res);

    // 3e requete -api2
    // cette requete c'est pour recuperer tout les messages de la bdd
    async function troisiemeReq() {
      await axios
      .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
      .then((res) => {
        setApiMessageFA(res.data);
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      troisiemeReq();
      //3e requete -api2
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      deuxiemeReq();
      //2e requete -api2
      })
      .catch((err) => {
        setErreur(true);
      })
      }
      premiereReq();
      //1ere requete -api2

      })
      }
      premiereReq();
      //1ere requete -api1
    } 
    // if (block === "0")
  } 
  // if(idPersonConnectedFA)
}*/
// SendMessagetype42


	
//logique pour ajouter une photo de couverture a la video
const [isLoading66addVideoPageFA, setIsLoading66addVideoPageFA] = useState(false);

async function AddVideoFA() {
  if (idPersonConnectedFA) {
    setIsLoading66addVideoPageFA(true);
  
    //1ere requete - api1
    //on envoie la video sur cloudinary
    async function premiereReq() {
      const data = new FormData();
      //data.append("video", fileVideo66addVideoPageFA);

      await axios
      .post(`${process.env.REACT_APP_Api1}/api/messageFA/sendVideo`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("video envoyer sur clou..");
        const urlVideo = res.data.secure_url; //url de la Video
        if (urlVideo) { 
          localStorage.setItem("urlVideo", urlVideo); 
          localStorage.setItem("urlVideoreq", urlVideo); 
        }

        //2e requete - api1
        // on lie la video a la photo de couverture 
        async function deuxiemeReq() {
          //on recupere l'id du favoris (lié a la photo de couverture qu'on avait ajouté)
          const id = localStorage.getItem("idFavoritereq");
          const urlVideo = localStorage.getItem("urlVideoreq");
          const type = "21"; // pour les vidéos dans les favoris

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api1}/api/messageFA/update/${id}`,
            data: {
              urlVideo,
              type,
            },
          })
          .then((res) => {
            console.log("vidéo lié à la photo", res);

            const type = "21";
            if(type) { localStorage.setItem("type", type); }

      //3e requete - api1
      // on obtiens de nouvelles données
      async function troisiemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
            console.log(res);
            // vidéo lié à la photo de couverture , on affiche la page qui va lui permettre d'écrire le message et publier la video
            setIsLoading66addVideoPageFA(false);
          })
          .catch((err) => {
            setIsLoading66addVideoPageFA(false);
            setErrorAA(true);
          })
          }
          troisiemeReq();
          //3e requete - api1
          })
          .catch((err) => {
            setIsLoading66addVideoPageFA(false);
            setErrorAA(true);
          })
          }
          deuxiemeReq();
          //2e requete - api1
          })
          .catch((err) => {
            
      //1ere requete - api2
      //on envoie la video sur cloudinary
      async function premiereReq() {
        const data = new FormData();
        //data.append("video", fileVideo66addVideoPageFA);

        await axios
        .post(`${process.env.REACT_APP_Api2}/api/messageFA/sendVideo`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("video envoyer sur clou..");
          const urlVideo = res.data.secure_url; //url de la Video
          if (urlVideo) { 
            localStorage.setItem("urlVideo", urlVideo); 
            localStorage.setItem("urlVideoreq", urlVideo); 
          }

        //2e requete - api2
        // on lie la video a la photo de couverture 
        async function deuxiemeReq() {
          //on recupere l'id du favoris (lié a la photo de couverture qu'on avait ajouté)
          const id = localStorage.getItem("idFavoritereq");
          const urlVideo = localStorage.getItem("urlVideoreq");
          const type = "21"; // pour les vidéos dans les favoris

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_Api2}/api/messageFA/update/${id}`,
            data: {
              urlVideo,
              type,
            },
          })
          .then((res) => {
            console.log("vidéo lié à la photo", res);

            const type = "21";
            if(type) { localStorage.setItem("type", type); }

        //3e requete - api2
        // on obtiens de nouvelles données
        async function troisiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              console.log(res);
              // vidéo lié à la photo de couverture , on affiche la page qui va lui permettre d'écrire le message et publier la video
              setIsLoading66addVideoPageFA(false);
            })
            }
            troisiemeReq();
            //3e requete - api2
            })
            .catch((err) => {
              setIsLoading66addVideoPageFA(false);
              setErrorAA(true);
            })
            }
            deuxiemeReq();
            //2e requete - api2
            })
            .catch((err) => {
              setIsLoading66addVideoPageFA(false);
              setErrorAA(true);
            })
            }
            premiereReq();
            //1ere requete - api2

            })
            }
            premiereReq();
            //1ere requete - api1
        }//if (idPersonConnectedFA)
}
//AddVideoFA


// logique pour publier une video sur son compte et groupe Florinato
async function PostVideoFA() {
    localStorage.setItem("writeMessage", writeMessage66writeMessagePageFA); //on enregistrer le message saisi
    setWriteMessage66writeMessagePageFA(""); //ici, une fois que on a cliquer sur le bouton envoyer la photo, on vide le textarea, et ensuite on ferme ces deux pages
    setFavoriteFA(false); 
    setWriteMessagePageFA(false);

    if (idPersonConnectedFA) {
      const block = localStorage.getItem("blockFA");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

          //1ere requete - api1
          //creer un id
          async function premiereReq() {
            await axios
            .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              const api = res.data;
                
            //creer un id pour chaque message envoyé sur X
            const numberMessageXA = api.filter((api) => api._id);
            const totalMessageXA = numberMessageXA.length;

            const createIdMessageXA = totalMessageXA + 1;
            if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

        //2e requete - api1
        // on publie la video
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const message = localStorage.getItem("writeMessage");
          const urlPhoto = localStorage.getItem("urlPhotoreq");
          const urlVideo = localStorage.getItem("urlVideoreq");
          const idAccountChef = localStorage.getItem("idAccountChef");
          const idGroupChef = localStorage.getItem("idGroupChef");
          const clic = "0";
          const comment = "0";
          const account = "1";
          const group = "1";
          const visible = "1";
          const type = "3"; //envoyer un message + video

          await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api1}/api/messageFA/new`,
          data: {
            id,
            message,
            urlPhoto,
            urlVideo,
            idAccount: idPersonConnectedFA,
            nameAccount: nameFA,
            photoAccount: photoFA,
            badgeAccount: badgeFA,
            idAccountChef,
            idGroupChef,
            clic,
            comment,
            account,
            group,
            visible,
            type,
          },
        })
        .then((res) => {
          console.log(res);

        //3e requete - api1
        //cette requete c'est pour recuperer tout les messages de la bdd
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
          })
          }
          troisiemeReq();
          //3e requete - api1
          })
          .catch((err) => {
            setErreur(true);
          })
          }
          deuxiemeReq();
          //2e requete - api1
          })
          .catch((err) => {
            
          //1ere requete - api2
          //creer un id
          async function premiereReq() {
            await axios
            .get(`${process.env.REACT_APP_Api2}/api/messageFA`)
            .then((res) => {
              setApiMessageFA(res.data);
              const api = res.data;
                
            //creer un id pour chaque message envoyé sur X
            const numberMessageXA = api.filter((api) => api._id);
            const totalMessageXA = numberMessageXA.length;

            const createIdMessageXA = totalMessageXA + 1;
            if (createIdMessageXA) { localStorage.setItem("createId", createIdMessageXA) }

        //2e requete - api2
        // on publie la video
        async function deuxiemeReq() {
          const id = localStorage.getItem("createId");
          const message = localStorage.getItem("writeMessage");
          const urlPhoto = localStorage.getItem("urlPhotoreq");
          const urlVideo = localStorage.getItem("urlVideoreq");
          const idAccountChef = localStorage.getItem("idAccountChef");
          const idGroupChef = localStorage.getItem("idGroupChef");
          const clic = "0";
          const comment = "0";
          const account = "1";
          const group = "1";
          const visible = "1";
          const type = "3"; //envoyer un message + video

          await axios({
          method: "post",
          url: `${process.env.REACT_APP_Api2}/api/messageFA/new`,
          data: {
            id,
            message,
            urlPhoto,
            urlVideo,
            idAccount: idPersonConnectedFA,
            nameAccount: nameFA,
            photoAccount: photoFA,
            badgeAccount: badgeFA,
            idAccountChef,
            idGroupChef,
            clic,
            comment,
            account,
            group,
            visible,
            type,
          },
        })
        .then((res) => {
          console.log(res);

          //3e requete - api1
        //cette requete c'est pour recuperer tout les messages de la bdd
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_Api1}/api/messageFA`)
          .then((res) => {
            setApiMessageFA(res.data);
          })
          }
          troisiemeReq();
          //3e requete - api2
          })
          .catch((err) => {
            setErreur(true);
          })
          }
          deuxiemeReq();
          //2e requete - api2
          })
          .catch((err) => {
            setErreur(true);
          })
          }
          premiereReq();
          //1ere requete - api2

          })
          }
          premiereReq()
          //1ere requete - api1
    }//if (block === "0")
    }//if(idPersonConnectedFA)
}
//PostVideoFA




  // zimagic app
  // zimagic app
  // zimagic app
  // zimagic app
  // zimagic app
  // zimagic app

  // ça c'est l'application zimagic (page d'accueil)
  const [zimagicApp, setZimagicApp] = useState(false); 
  async function ZimagicApp() {
    setZimagicApp(true);
    setTelephoneVirtuel(false);
  }

  async function CloseZimagicApp() {
    setTelephoneVirtuel(true);
  }


   // les plus populaires sur Zimagic
  const [zimagicPopularity, setZimagicPopularity] = useState(false); 
  async function ZimagicPopularity() {
    setZimagicPopularity(true);
  }
  async function CloseZimagicPopularity() {
    setZimagicPopularity(false);
  }


  // message - ZA
  // message - ZA
  // obtenir tout les messages envoyer sur Zimagic
  const [apiMessageZA, setApiMessageZA] = useState([]);

  //creer un id pour chaque message envoyé - ZA
  const numberMessageZA = apiMessageZA.filter((api) => api._id);
  const totalMessageZA = numberMessageZA.length;

  const createIdMessageZA = totalMessageZA + 1;
  if (createIdMessageZA) { localStorage.setItem("createIdMessageZA", createIdMessageZA) }


  const [myMessageZA, setMyMessageZA] = useState(""); // saisir le message

  // logique pour envoyer un message sur Zimagic
  async function SendMessageZA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      //on enregistre le message saisi dans le localStorage pour ensuite vider le textarea
      localStorage.setItem("myMessageZA", myMessageZA)
      //ici on vide le textarea
      setMyMessageZA("");

    //1ere requete
    //1ere requete
    // on envoie le message
    async function premiereReq() {
      const id = localStorage.getItem("createIdMessageZA");
      const message = localStorage.getItem("myMessageZA");
      const displayOther = "1";
      const display = "1";
      const visible = "1";
      const hide = "0";
      const type = "1";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_SendMessageZA}/api/messageZA/new`,
      data: {
        id,
        message,
        idOwner: idPersonConnectedAA,
        displayOther,
        display,
        hide,
        visible,
        type,
      },
    })
    .then((res) => {

      // 2e requete
      // 2e requete
      // cette requete c'est pour recuperer tout les messages de la bdd
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_SendMessageZA}/api/messageZA`)
        .then((res) => {
          setApiMessageZA(res.data);

        //3e requete
        //3e requete
        // on obtiens la localisation de l'utilisateur
        async function troisiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //4e requete
        //4e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function quatriemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Message envoyé (il a envoyé un message)";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SendMessageAA}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //5e requete
        //5e requete
        // on enregistre la date de derniere connexion
        async function cinquiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SendMessageAA}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
          })
          }
          cinquiemeReq();
          //5e requete

                        // 5e requete
                        // 5e requete
                        //cette requete c'est pour creer une notification,
                        //cela va permettre a l'autre d'etre informer
                        // la notification va dire par exemple: David vous a envoyer un message
                        /*async function cinquiemeReq() {
                          await axios({
                            method: "post",
                            url: `${process.env.REACT_APP_BACKEND}/api/notificationAA/create`,
                            data: {*/
                          /* la notification est destiner au destinataire du message voila 
                          pourquoi on prend les infos du destinataire du message */
                          //idDestinataire: idDestinataireMessage,
                          //nomDestinataire: nomDestinataireMessage,

                          /* ici on prend les infos de la personneConnecter parce que c'est lui qui 
                          informe */
                          /*idDeLaPersonneQuiInforme: idPersonneConnecter,
                          nomDeLaPersonneQuiInforme: nomPersonneConnecter,
                          photoProfilDeLaPersonneQuiInforme: photoProfilPersonneConnecter,
                          badgeVerifiedDeLaPersonneQuiInforme: badgeVerifiedPersonneConnecter,
                          notification: notification,
                          lu: lu,
                          parle: parle,*/
                          /* l'idConversation va permettre d'entrer dans message et d'afficher 
                          la conversation lorsqu'on va cliquer sur Voir le message au niveau 
                          des notifications */
                          //idConversation: idConversation,
                          //idInitieur: idInitieur,
                        /*},
                      })
                        .then((res) => {*/

                          // 6e requete
                          // 6e requete
                          /* cette requete c'est pour update le nom, photo, badge des 
                          personnes qui echange dans la conversation */
                          // a chaque message, on update, on remplace l'ancien par le nouveau
                          /* cela va permettre par exemple si la personne a changer de photo de profil
                    ou de nom, au niveau des conversations la nouvelle photo va etre afficher */

                          /*
                          if (idReceiverMessageAA === idPersonConnectedAA) {
                            // si l'idInitieur=idPersonneConnecter,alors on update les infos de l'initieur
                            //l'initieur c'est la personne qui avait initier la conversation pour la toute premiere fois
                            //ici on va update ces infos, son nom, sa photo et son badge
                            async function sixiemeReq() {
                              await axios({
                                method: "put",
                                url: `${process.env.REACT_APP_BACKEND}/api/conversation/update/${idConversationAA}`,
                                data: {
                                  nomDestinataire: nameReceiverMessageAA,
                                  photoProfilDestinataire: verifiedPhotoReceiverAA,
                                  badgeVerifiedDestinataire: verifiedBadgeReceiverAA,
                                },
                              })
                            }
                            sixiemeReq();
                            //6e requete
                          } else {
                            // ici c'est dans le cas ou c'est pas egale
                            // alors on update les infos du destinataire
                            async function sixiemeReq() {
                              await axios({
                                method: "put",
                                url: `${process.env.REACT_APP_BACKEND}/api/conversation/update/${idConversationAA}`,
                                data: {
                                  nomInitieur: nameReceiverMessageAA,
                                  photoProfilInitieur: verifiedPhotoReceiverAA,
                                  badgeVerifiedInitieur: verifiedBadgeReceiverAA,
                                },
                              })
                            }
                            sixiemeReq();
                            //6e requete
                          }
                          // le code du if s'arrete ici
                          */

                        /*})
                        .catch((err) => {
                          setErreur(true);
                        });
                      }
                      cinquiemeReq();*/
                      //5e requete
                    })
                    }
                    quatriemeReq();
                    //4e requete
                    })
                    }
                    troisiemeReq();
                    //3e requete
                    })
                    }
                    deuxiemeReq();
                    //2e requete
                    })
                  }
                  premiereReq()
                  //1ere requete
                } 
                // if (block === "0")
              } 
              // if(idPersonConnectedAA)
            }
  


  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // donazia app
  // quand on clique sur l'icone de l'App, l'ecran de demarrage s'affiche - DA
  /*const [ecranDemarrageDA, setEcranDemarrageDA] = useState(false);
  async function EcranDemarrageDA() {
    setEcranDemarrageDA(true);

    //ce code permet de maintenir l'ecran de demarrage ouvert pendant quelques secondes
    async function CloseEcranDemarrageDA() {
      setEcranDemarrageDA(false);
      setDonaziaApp(true);
    }
    setTimeout(CloseEcranDemarrageDA, 2000);
  }*/

  // ça c'est l'application Donazia (page d'accueil)
  const [donaziaApp, setDonaziaApp] = useState(false); 
  async function DonaziaApp() {
    setDonaziaApp(true);
  }
  async function CloseDonaziaApp() {
    setDonaziaApp(false);
  }


  // on recupere les infos de l'album dans le localStorage
  const photoAlbumDA = localStorage.getItem("photoAlbumDA"); 
  const nameAlbumDA = localStorage.getItem("nameAlbumDA");
  const urlAlbumDA = localStorage.getItem("urlAlbumDA"); 
  const infosAlbumDA = localStorage.getItem("infosAlbumDA"); 

  // photo de l'album (on affiche la photo de l'album)
  const [seePhotoAlbumPageDA, setSeePhotoAlbumPageDA] = useState(false);
  async function SeePhotoAlbumPageDA() {
    setSeePhotoAlbumPageDA(true);
  }
  async function CloseSeePhotoAlbumPageDA() { 
    setSeePhotoAlbumPageDA(false);
  }

  // infos de l'album (on affiche les infos de l'album)
  const [infosAlbumPageDA, setInfosAlbumPageDA] = useState(false);
  async function InfosAlbumPageDA() {
    setInfosAlbumPageDA(true);
  }
  async function CloseInfosAlbumPageDA() { 
    setInfosAlbumPageDA(false);
  }

  //download AlbumPageDA - on affiche la page qui conduit au telechargement de l'album
  const [downloadAlbumPageDA, setDownloadAlbumPageDA] = useState(false); 
  async function DownloadAlbumPageDA() {
    setDownloadAlbumPageDA(true);
  }
  async function CloseDownloadAlbumPageDA() {
    setDownloadAlbumPageDA(false);
  }


  // profil - DA
  // profil - DA
  const [profilDA, setProfilDA] = useState(false);
  async function ProfilDA() {
    setProfilDA(true);
  }
  async function CloseProfilDA() { 
    setProfilDA(false);
  }

  // seePhoto (sur donazia, page pour voir la photo de la personne connecté)
  const [seePhotoPersonConnectedDA, setSeePhotoPersonConnectedDA] = useState(false);
  async function SeePhotoPersonConnectedDA() {
    setSeePhotoPersonConnectedDA(true);
  }
  async function CloseSeePhotoPersonConnectedDA() { 
    setSeePhotoPersonConnectedDA(false);
  }


  // ca c'est la page qui rappel a l'utilisateur d'acheter un abonnement annuel - DA
  const [buySubscriptionMessageDA, setBuySubscriptionMessageDA] = useState(false);
  async function BuySubscriptionMessageDA() {
    setBuySubscriptionMessageDA(true);
  }
  async function CloseBuySubscriptionMessageDA() { 
    setBuySubscriptionMessageDA(false);
  }

  // confirmation (confirmer s'il veut envoyer un message à Donazia)
  const [confirmationSendMessageDonaziaDA, setConfirmationSendMessageDonaziaDA] = useState(false);
  async function ConfirmationSendMessageDonaziaDA() {
    setConfirmationSendMessageDonaziaDA(true);
  }
  async function CloseConfirmationSendMessageDonaziaDA() { 
    setConfirmationSendMessageDonaziaDA(false);
  }


  //logique pour envoyer un message à donazia 
  async function BeginConversationDonaziaDA() {
    if (idPersonConnectedAA) {

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setOpacity(true);

      //verification - requete pour recuperer les informations de donazia
      //verification - requete pour recuperer les informations de donazia
      async function verificationReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountAA`)
        .then((res) => {

          // on filtre en fonction du numero virtuel de donazia
          const virtualNumberDonazia = "001_donazia";

          const apiAccount = res.data;
          const filterAccount = apiAccount.filter((api) => api.virtualNumber === virtualNumberDonazia);

          const idAccount = filterAccount.map((api) => api._id); // idAccount
          if (idAccount) { localStorage.setItem("idOwnerAA", idAccount); }

          const idUser = filterAccount.map((api) => api.idUser); // idUser
          if (idUser) { localStorage.setItem("idUserOwnerAA", idUser); }

          const nameAccount = filterAccount.map((api) => api.nameAccount); // name
          if (nameAccount) { localStorage.setItem("nameOwnerAA", nameAccount); }

          const photoProfile = filterAccount.map((api) => api.photoProfile); // photo
          if (photoProfile) { localStorage.setItem("photoOwnerAA", photoProfile); }

          const badge = filterAccount.map((api) => api.badge); // badge
          if (badge) { localStorage.setItem("badgeOwnerAA", badge); }
      
      //1ere requete
      //1ere requete
      // on verifie s'il existe deja une conversation entre les deux utilisateurs
      async function premiereReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
        .then((res) => {
          const api = res.data;

          // possibiliterUn
          const possibiliterUn = api.filter((api) => api.idOwner === idPersonConnectedAA && api.idOther === idOwnerAA && api.deleted === "0" && api.hide === "0" && api.visible === "1");
          const verified1 = possibiliterUn.length > 0;
          if (verified1) {
            //console.log("possibilité 1, idOwner est la personne connecté");
            const idConversation1 = possibiliterUn.map((api) => api._id);
            localStorage.setItem("idConversationAA", idConversation1);
            setMessageAA(true);
            setOpacity(false);
          }

          // possibiliterDeux
          const possibiliterDeux = api.filter((api) => api.idOwner === idOwnerAA && api.idOther === idPersonConnectedAA && api.deleted === "0" && api.hide === "0" && api.visible === "1");
          const verified2 = possibiliterDeux.length > 0;
          if (verified2) {
            //console.log("possibilité 2, idOther est la personne connecté");
            const idConversation2 = possibiliterDeux.map((api) => api._id);
            localStorage.setItem("idConversationAA", idConversation2);
            setMessageAA(true);
            setOpacity(false);
          }
          
          // possibiliterTrois
          if (!verified1 && !verified2) {
            //console.log("possibilité 3, il n'existe pas de conversation entre les deux utilisateurs");

            //2e requete
            //2e requete
            // on informe d'abord le destinataire qu'il a recu un nouveau message
            async function deuxiemeReq() {
              const id = localStorage.getItem("idUserOwnerAA");
              const newMessage = "1";

              await axios({
                method: "put",
                url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${id}`,
                data: {
                  newMessage,
                },
              })
              .then((res) => {

            // 3e requete
            // 3e requete
            // on initie la conversation
            async function troisiemeReq() {
              const id = localStorage.getItem("createIdConversationAA");
              //const id = "1";
              const idOther = localStorage.getItem("idOwnerAA");
              const idUserOther = localStorage.getItem("idUserOwnerAA");
              const nameOther = localStorage.getItem("nameOwnerAA");
              const photoOther = localStorage.getItem("photoOwnerAA");
              const badgeOther = localStorage.getItem("badgeOwnerAA");
              const lastMessage = "Click to start the conversation..";
              //const lastMessage = localStorage.getItem("writeMessageAA");
              const connection = "1";
              const display = "1";
              const hide = "0";
              const deleted = "0";
              const visible = "1";
              const type = "1";
              
              await axios({
                method: "post",
                url: `${process.env.REACT_APP_BACKEND}/api/conversationAA/new`,
                data: {
                  id,
                  idOther, // l'autre personne
                  idUserOther,
                  nameOther,
                  photoOther,
                  badgeOther,
                  lastMessage,
                  idOwner: idPersonConnectedAA, // personne connecter
                  idUserOwner: idUserConnectedAA,
                  nameOwner: namePersonConnectedAA,
                  photoOwner: photoPersonConnectedAA,
                  badgeOwner: badgePersonConnectedAA,
                  connection,
                  display,
                  hide,
                  deleted,
                  visible,
                  type,
                },
              })
              .then((res) => {
                const idConversation = res.data._id;
                if (idConversation) { localStorage.setItem("idConversationAA", idConversation); }

                // 4e requete
                // 4e requete
                // on obtiens de nouvelles donnees - apiConversation
                async function quatriemeReq() {
                  await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/conversationAA`)
                  .then((res) => {
                    setApiConversationAA(res.data);

                //5e requete
                //5e requete
                // on obtiens de nouvelles donnees - apiMessage
                async function cinquiemeReq() {
                  await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/messageAA`)
                  .then((res) => {
                    setApiMessageAA(res.data);
                    setMessageAA(true); //on lui affiche la page messageAA (pour lui permettre de causer avec l'autre)
                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                  }
                  cinquiemeReq();
                  //5e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                  }
                  quatriemeReq(); 
                  //4e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                  }
                  troisiemeReq();
                  //3e requete
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErrorAA(true);
                  });
                }
                deuxiemeReq();
                //2e requete
              }
              //possibiliterTrois
            })
            .catch((err) => {
              setOpacity(false);
              setErrorAA(true);
            });
          }
          premiereReq();
          //1ere requete
        })
        .catch((err) => {
          setOpacity(false);
          setErrorAA(true);
        });
        }
        verificationReq(); //verification - requete pour recuperer les informations de donazia
      }// if (block === "0")
    }// if(idPersonConnectedAA)
  }



  // requete pour obtenir tout les comptes Donazia - DA



   // requete pour obtenir tout les comptes Donazia - DA

   
  const idPersonConnectedDA = localStorage.getItem("idPersonConnectedDA");

   // filtre dans l'apiAccountDA (on affiche les infos de la personne connecter) 
   // on obtiens les infos de son compte donazia pour le lui afficher
   //const accountConnectedDA = apiAccountDA.filter((api) => api._id === idPersonConnectedDA);

   /*const getNamePersonConnectedDA = accountConnectedDA.map((api) => api.nameAccount); // name
   if (getNamePersonConnectedDA) { localStorage.setItem("namePersonConnectedDA", getNamePersonConnectedDA); }
 
   const getPhotoPersonConnectedDA = accountConnectedDA.map((api) => api.photoProfile); // photo
   if (getPhotoPersonConnectedDA) { localStorage.setItem("photoPersonConnectedDA", getPhotoPersonConnectedDA); }
 
   const getBadgePersonConnectedDA = accountConnectedDA.map((api) => api.badge); // badge
   if (getBadgePersonConnectedDA) { localStorage.setItem("badgePersonConnectedDA", getBadgePersonConnectedDA); }*/

   // on recupere les informations qu'on a stocker dans le localstorage
   const namePersonConnectedDA = localStorage.getItem("namePersonConnectedDA");
   const photoPersonConnectedDA = localStorage.getItem("photoPersonConnectedDA");
   const badgePersonConnectedDA = localStorage.getItem("badgePersonConnectedDA");
 

  //const idPostAA = localStorage.getItem("idPostAA");  
  // requete pour obtenir tout les posts sur Donazia - DA


  // page d'accueil de donazia (on affiche tout les posts sur la page d'accueil de donazia)
  //const getAllPostDA = apiPostDA.filter((api) => api.home === "1" && api.display === "1" && api.displayOther === "1" && api.approved === "1" && api.visible === "1");
  //const filterPost666homeDA = getAllPostDA.sort((a, b) => b.id - a.id); 

  // page pour activer l'application donazia 
  const [activateDonaziaPage, setActivateDonaziaPage] = useState(false);
  async function ActivateDonaziaPage() {
    setActivateDonaziaPage(true);
  }
  async function CloseActivateDonaziaPage() {
    setActivateDonaziaPage(false);
  }

  // on affiche la page ci, si la personne a pu creer son compte Donazia 
  const [inscriptionSuccessDA, setInscriptionSuccessDA] = useState(false);
  async function CloseInscriptionSuccessDA() {
    setInscriptionSuccessDA(false);
  }

  // erreur - DA
  /* on affiche cette page si la creation de son compte donazia a echouer ou si 
  la personne a rencontrer une erreur quelconque sur Donazia */
  const [erreurDA, setErreurDA] = useState(false);
  async function CloseErreurDA() {
    setErreurDA(false);
  }



  ///
  ///
  ///

  // logique pour creer son compte donazia (activate donazia)
  async function ActivateDonazia() {
    
    setOpacity(true);
    console.log("aa1, signup");
    
          // 1ere requete
          // 1ere requete
          // on verifie si la personne est deja inscrite sur Donazia avec ce numero virtuel
          async function premiereReq() {
            await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/accountDA`)
            .then((res) => {
              console.log(res);
              // on prend le numero virtuel - FA
              const getVirtualNumber = localStorage.getItem("virtualNumberPersonConnectedAA");
              console.log(getVirtualNumber);

              const myapi = res.data; // ici on cree un id pour chaque compte creer (ca permettra de faire la recense, en mettant les comptes les plus recents devant)
              //creer un id pour chaque compte creer 
              const numberAccountDA = myapi.filter((api) => api._id); 
              const totalAccountDA = numberAccountDA.length;

              const createIdAccountDA = totalAccountDA + 1;
              if (createIdAccountDA) { localStorage.setItem("createIdAccountDA", createIdAccountDA) }


              const api = res.data; // ici on verifie s'il ya deja un compte inscrit avec ce numero
              const filter = api.filter((api) => api.virtualNumber === getVirtualNumber);

              const verifiedAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
              if (verifiedAlreadySignup) {
                // dans ce cas: numero virtuel deja inscrit (on affiche un message d'erreur, car il y'a deja une personne inscrite avec ce numero virtuel)
                setOpacity(false);
                console.log("numero virtuel deja inscrit");
              } else {
              // dans ce cas: numero virtuel non inscrit
              console.log("numero virtuel non inscrit");

                //2e requete
                //2e requete
                // on cree son compte donazia
                async function deuxiemeReq() {
                  const id = localStorage.getItem("createIdAccountDA");
                  const popularity = "0";
                  const activatePopularity = "1";
                  const privateAccount = "0";
                  const newPost = "0";
                  const connection = "1";
                  const display = "1";
                  const visible = "1";
                  const type = "1";

                  await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_BACKEND}/api/accountDA/create`,
                    data: {
                      id,
                      idAccountFlorinato: idPersonConnectedAA,
                      nameAccount: namePersonConnectedAA,
                      photoProfile: photoPersonConnectedAA,
                      badge: badgePersonConnectedAA,
                      popularity,
                      activatePopularity,
                      privateAccount,
                      newPost,
                      connection,
                      display,
                      visible,
                      type,
                    },
                  })
                  .then((res) => {
                    console.log(res, "inscription reussie, compte donazia creer");

                    //on prend l'idAccountDonazia pour pouvoir afficher ces informations personnelles, mais il va etre maintenu connecter avec l'idAccount de son compte Florinato (idPersonConnectedAA)
                  const idAccountDonazia = res.data._id;
                  if (idAccountDonazia) { localStorage.setItem("idPersonConnectedDA", idAccountDonazia); }

        //3e requete
        //3e requete
        // on obtiens les nouvelles donnees pour pouvoir afficher son compte parmi les comptes les plus recents! 
        // (on enregistre les infos de connexion)
        async function troisiemeReq() {
        await axios
          .get(`${process.env.REACT_APP_Donazia}/api/accountDA`)
          .then((res) => {
           // setApiAccountDA(res.data);
           console.log(res);

            //inscription et connexion reussie sur Donazia, on affiche le message de success
            setInscriptionSuccessDA(true); 
            setOpacity(false);
          })
          .catch((err) => {
            setInscriptionSuccessDA(true); 
            setErreurDA(true);
          });
        }
        troisiemeReq();
        //3e requete
          })
          .catch((err) => {
            setOpacity(false);
            setInscriptionSuccessDA(true); 
          });
        }
        deuxiemeReq();
        //2e requete
          }// le if de verifiedAlreadySignup se ferme ici
          })
          .catch((err) => {
            setOpacity(false);
            setErreurDA(true); 
          });
        }
        premiereReq();
        //1ere requete
    }

  
  // post publié (message de success) - DA 
  const [postSuccessDA, setPostSuccessDA] = useState(false);
  async function ClosePostSuccessDA() {
    setPostSuccessDA(false);
  }

  // LierMusicPageAA (page pour lier une musique et la publier)
  const [lierMusicPageAA, setLierMusicPageAA] = useState(false);
  async function LierMusicPageAA() {
    setLierMusicPageAA(true);
  }
  async function CloseLierMusicPageAA() {
    setLierMusicPageAA(false);
  }
  

  const [writeTitleDA, setWriteTitleDA] = useState(""); //saisir le titre du film
  if (writeTitleDA) { localStorage.setItem("writeTitleDA", writeTitleDA); }

  const [writeDetailsDA, setWriteDetailsDA] = useState(""); //saisir d'autres detsils
  if (writeDetailsDA) { localStorage.setItem("writeDetailsDA", writeDetailsDA); }

  const [writeUrlDownloadDA, setWriteUrlDownloadDA] = useState(""); //saisir le lien de telechargement
  if (writeUrlDownloadDA) { localStorage.setItem("urlDownloadDAreq", writeUrlDownloadDA); }


  // logique pour publier sur Donazia
  const [isLoading666publierPageDA, setIsLoading666publierPageDA] = useState(false);

  async function PublierDA() {
    if (idPersonConnectedAA) { 

    const block = localStorage.getItem("blockAA");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business

      setIsLoading666publierPageDA(true);

      // AllPostReq
      async function AllPostReq() { //on a refait la requete car il y'avait des posts ou le createIdPostAA ratait
        await axios
        .get(`${process.env.REACT_APP_PostDA}/api/postDA`)
        .then((res) => {
          console.log(res);
          //setApiPostDA(res.data);
		      const api = res.data;

      //creer un id pour chaque post publié - DA
      const numberPostDA = api.filter((api) => api._id); 
      const totalPostDA = numberPostDA.length;

      const createIdPostDA = totalPostDA + 1;

    if (createIdPostDA) { localStorage.setItem("createIdPostDA", createIdPostDA)

    //1ere requete
    //1ere requete 
    // on publie sur mon compte (homeDA) , pour que ça puisse s'afficher sur mon compte, là ou il ya toutes mes publications)
    async function premiereReq() {
      const id = localStorage.getItem("createIdPostDA");
      const ad = "0";
      const messageButton = "0";
      const downloadButton = "1";
      const urlPhoto = localStorage.getItem("urlPhotoDAreq");
      const title = localStorage.getItem("writeTitleDA");
      const details = localStorage.getItem("writeDetailsDA");
      const home = localStorage.getItem("homeDA");
      const urlDownload = localStorage.getItem("urlDownloadDAreq");
      const like = "0";
      const popularity = "0";
      const comment = "0";
      const deleted = "0";
      const approved = "1";
      const display = "1";
      const displayOther = localStorage.getItem("displayOtherAA");
      const visible = "1";
      const best = "0";
      const type = "1";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_PostPhotoDA}/api/postDA/new`,
      data: {
        id,
        idOwner: idPersonConnectedDA,
        nameOwner: namePersonConnectedDA,
        photoOwner: photoPersonConnectedDA,
        badgeOwner: badgePersonConnectedDA,
        ad,
        downloadButton,
        messageButton,
        title,
        details,
        home,
        urlPhoto,
        urlDownload,
        like,
        popularity,
        comment,
        deleted,
        approved,
        display,
        displayOther,
        visible,
        best,
        type,
      },
    })
    .then((res) => {
      console.log("a4");
      //on prend l'id du nouveau Post, on va l'ajouter au niveau de mon accountDA
      const idNewPost = res.data._id;
      if (idNewPost) { localStorage.setItem("idNewPost", idNewPost); }

          //2e requete
          //2e requete
          // on publie sur la page d'accueil (accountDA) , pour que ça puisse s'afficher aux personnes qui sont abonnés à mon compte
          async function deuxiemeReq() {
            const idPost1 = localStorage.getItem("idNewPost");
            const id1 = localStorage.getItem("createIdPostDA");
            const ad1 = "0";
            const messageButton1 = "0";
            const downloadButton1 = "1";
            const urlPhoto1 = localStorage.getItem("urlPhotoDAreq");
            const title1 = localStorage.getItem("writeTitleDA");
            const details1 = localStorage.getItem("writeDetailsDA");
            const home1 = localStorage.getItem("homeDA");
            const urlDownload1 = localStorage.getItem("urlDownloadDAreq");
            const like1 = "0";
            const popularity1 = "0";
            const comment1 = "0";
            const deleted1 = "0";
            const approved1 = "1";
            const display1 = "1";
            const displayOther1 = localStorage.getItem("displayOtherAA");
            const visible1 = "1";
            const best1 = "0";
            const type1 = "1";

            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoDA}/api/accountDA/update/${idPersonConnectedDA}`,
              data: {
                idPost1,
                id1,
                idOwner: idPersonConnectedDA,
                nameOwner: namePersonConnectedDA,
                photoOwner: photoPersonConnectedDA,
                badgeOwner: badgePersonConnectedDA,
                ad1,
                downloadButton1,
                messageButton1,
                title1,
                details1,
                home1,
                urlPhoto1,
                urlDownload1,
                like1,
                popularity1,
                comment1,
                deleted1,
                approved1,
                display1,
                displayOther1,
                visible1,
                best1,
                type1,
              },
            })
            .then((res) => {

    //3e requete
    //3e requete
    // on publie dans la communauté,  on publie le message (ou film) dans la communauté Donazia, pour que les membres qui sont dans la communauté puissent voir ma publication
    async function troisiemeReq() {
      const id = localStorage.getItem("createIdMessageDA");
      const idPost = localStorage.getItem("idNewPost");
      const messageButton = "0";
      const downloadButton = "1";
      const message = localStorage.getItem("writeTitleDA");
      const details = localStorage.getItem("writeDetailsDA");
      const urlDownload = localStorage.getItem("urlDownloadDAreq");
      const urlPhoto = localStorage.getItem("urlPhotoDAreq");
      const like = "0";
      const popularity = "0";
      const comment = "0";
      const deleted = "0";
      const approved = "1";
      const display = "1";
      const displayOther = localStorage.getItem("displayOtherAA");
      const visible = "1";
      const best = "0";
      const type = "1";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_SendMessageDA}/api/messageDA/new`,
      data: {
        idPost,
        id,
        idOwner: idPersonConnectedDA,
        nameOwner: namePersonConnectedDA,
        photoOwner: photoPersonConnectedDA,
        badgeOwner: badgePersonConnectedDA,
        downloadButton,
        messageButton,
        message,
        details,
        urlPhoto,
        urlDownload,
        like,
        popularity,
        comment,
        deleted,
        approved,
        display,
        displayOther,
        visible,
        best,
        type,
      },
    })
    .then((res) => {

      // 4e requete
      // 4e requete
      // cette requete c'est pour recuperer tout les messages de la bdd
      async function quatriemeReq() {
        await axios
        .get(`${process.env.REACT_APP_SendMessageDA}/api/accountDA`)
        .then((res) => {
          //setApiAccountDA(res.data);
          console.log(res);

      //5e requete
      //5e requete
      // obtenir tout les posts de la bdd
      async function cinquiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostDA}/api/postDA`)
        .then((res) => {
          //setApiPostDA(res.data);
          console.log(res);
          //setBeforePostPhotoPageAA(false);
          //setPostPhotoPageAA(false);
          setIsLoading666publierPageDA(false);

          //ici on affiche le message de succes
          setPostSuccessDA(true);
          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessDA(false);
          }
          setTimeout(ClosePostSuccess, 1400);

        //6e requete
        //6e requete
        // on obtiens la localisation de l'utilisateur
        async function sixiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //7e requete
        //7e requete
        // on enregistre la localisation et la navigation de l'utilisateur au niveau de son compte florinato
        async function septiemeReq() {
          const id = localStorage.getItem("createIdNavigationAA");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Message envoyé, Publication publié sur Donazia";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SendMessageAA}/api/navigationAA/new`,
            data: {
              id,
              idAccount: idPersonConnectedAA,
              nameAccount: namePersonConnectedAA,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineAA", online) }

        //8e requete
        //8e requete
        // on enregistre la date de derniere connexion au niveau de son compte florinato
        async function huitiemeReq() {
          const online = localStorage.getItem("onlineAA");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SendMessageAA}/api/accountAA/update/${idPersonConnectedAA}`,
            data: {
              online,
            },
            })
            }
            huitiemeReq();
            //8e requete
            });
            }
            septiemeReq();
            //7e requete
            });
            }
            sixiemeReq();
            //6e requete
            })
            }
            cinquiemeReq();
            //5e requete
        })
        .catch((err) => {

        // ici nous sommes au niveau du .catch de la quatriemeReq()
        //la 4e requete c'est pour obtenir de nouvelles donnees, si ca rate, alors on va encore insister, on va refaire la requete pour obtenir de nouvelles donnees, ensuite on va l'afficher le message que le post avait deja ete publié
        // get
        async function get() {
          await axios
          .get(`${process.env.REACT_APP_PostDA}/api/postDA`)
          .then((res) => {
          //setApiPostDA(res.data);
          console.log(res);
          
          //setBeforePostPhotoPageAA(false);
          //setPostPhotoPageAA(false);
          setIsLoading666publierPageDA(false);
          //ici on affiche le message de succes
          setPostSuccessDA(true);
          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessDA(false);
          }
          setTimeout(ClosePostSuccess, 1400);
        })
        .catch((err) => {
          //si on arrive pas a obtenir tout les posts, alors on lui affiche juste le message que sa photo avait deja ete publié
          //setBeforePostPhotoPageAA(false);
          //setPostPhotoPageAA(false);
          setIsLoading666publierPageDA(false);
          //ici on affiche le message de succes
          setPostSuccessDA(true);
          //ici on le fait disparaitre
          async function ClosePostSuccess() {
            setPostSuccessDA(false);
          }
          setTimeout(ClosePostSuccess, 1400);
          })
          }
          get();
          //get
      });
      }
      quatriemeReq();
      //4e requete
      })
      }
      troisiemeReq();
      //3e requete
      })
      }
      deuxiemeReq();
      //2e requete
      })
      .catch((err) => {
        setErreur(true);
        setIsLoading666publierPageDA(false);
      });
    }
    premiereReq();
    //1ere requete
    } //if (createIdPostDA)
    })
    .catch((err) => {
      setErreur(true);
      setIsLoading666publierPageDA(false);
    })
    }
    AllPostReq();
    // AllPostReq

    } // if (block === "0")
  }//if(idPersonConnectedAA)
}


  // Page Redirection (666 HomeAA)
  // au niveau de la page d'accueil, la logique ci nous dira quel page ouvrir - DA
  async function PageRedirection666HomeDA() {

    // page - voir le profil Other (sur la page d'accueil, il clique pour accéder à la page)
    /*const GoToPageProfilOther = localStorage.getItem("GoToProfilOtherAA");
    if (GoToPageProfilOther === "1") { setProfilOtherAA(true); }
    
    // page - voir un post (sur la page d'accueil, il a cliquer pour voir le post)
    const GoToPageSeePost = localStorage.getItem("GoToPageSeePost666homeAA");
    if (GoToPageSeePost === "1") { setSeePostAA(true); }

    // page - partager un post
    const GoToPageSharePost = localStorage.getItem("GoToPageSharePostAA");
    if (GoToPageSharePost === "1") { setSharePostPageAA(true); }

    // page - ajouter une reaction
    const GoToPageAddReaction = localStorage.getItem("GoToPageAddReactionAA");
    if (GoToPageAddReaction === "1") { 
      setAddReactionPageAA(true); 
    }

    // page - voir une reaction
    const GoToPageSeeReaction = localStorage.getItem("GoToPageSeeReactionAA");
    if (GoToPageSeeReaction === "1") { setSeeReactionPageAA(true); }*/
}



  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App
  // Izocash App

  // on recupere les infos - IA
  // izocash deals
  const izocashDealsBalanceIA = localStorage.getItem("izocashDealsBalanceIA"); //solde
  const izocashDealsCodeIA = localStorage.getItem("izocashDealsCodeIA"); //super code
  const izocashDealsActiveIA = localStorage.getItem("izocashDealsActiveIA"); //active
  const izocashDealsDoubleProfitIA = localStorage.getItem("izocashDealsDoubleProfitIA"); //double benefice
  

  // requete pour obtenir tout les outils activer
  const [apiToolIA, setApiToolIA] = useState([]);

    const filterAccountIA = apiToolIA.filter((api) => api.idAccount === idPersonConnectedIA && api.type === "1" && api.visible === "1");

    const getIzocashDealsBalance = filterAccountIA.map((api) => api.izocashDealsBalance); //solde izocash deals
    if (getIzocashDealsBalance) { localStorage.setItem("izocashDealsBalanceIA", getIzocashDealsBalance) }

    const getIzocashDealsCode = filterAccountIA.map((api) => api.izocashDealsCode); //super code izocash deals
    if (getIzocashDealsCode) { localStorage.setItem("izocashDealsCodeIA", getIzocashDealsCode) }

    const getIzocashDealsDoubleProfit = filterAccountIA.map((api) => api.izocashDealsDoubleProfit); //double benefice izocash deals
    if (getIzocashDealsDoubleProfit) { localStorage.setItem("izocashDealsDoubleProfitIA", getIzocashDealsDoubleProfit) }




  // quand on clique sur l'icone de l'App, l'ecran de demarrage s'affiche - IA
  const [ecranDemarrageIA, setEcranDemarrageIA] = useState(false);
  async function EcranDemarrageIA() {
    setEcranDemarrageIA(true);

    // si la personne est connecter alors on fait des requetes pour obtenir de nouvelles données (dès que l'utilisateur connecter clique sur l'application izocash, on fait une requete pour obtenir de nouvelles donnees)
    const connected = localStorage.getItem("idPersonConnectedIA");
    if (connected) {
      //1ere requete

      
    }

    //ce code permet de maintenir l'ecran de demarrage ouvert pendant quelques secondes
    async function CloseEcranDemarrageIA() {
      if (connected) {
        //si la personne est connecter, il est rediriger sur la page d'accueil
        setEcranDemarrageIA(false);
        setIzocashApp(true);
      } else {
        //si la personne n'est pas connecter, il est rediriger sur la page de connexion
        setEcranDemarrageIA(false);
        setConnexionPageIA(true);
      }
    }
    setTimeout(CloseEcranDemarrageIA, 2000);
  }


  //logique pour actualiser son solde izocash (et d'autres elements...)
  async function RefreshBalanceIA() {

    }


  // quand on clique, l'application Izocash va s'ouvrir
  const [izocashApp, setIzocashApp] = useState(false); 

  // IA veut dire Izocash App
  // au niveau de la navbar de l'appli Izocash, quand on clique sur un onglet ca sera active
  
  // head 1 (stock national)
  const getHead1666izocashApp = localStorage.getItem("head1666izocashApp");
  const [head1666izocashApp, setHead1666izocashApp] = useState(getHead1666izocashApp);
  async function Head1666izocashApp() {
    const head1 = true;
    localStorage.setItem("head1666izocashApp", head1);
    localStorage.removeItem("head2666izocashApp");
    localStorage.removeItem("head3666izocashApp");
    localStorage.removeItem("head4666");
    setHead1666izocashApp(true);
    setHead2666izocashApp(false);
    setHead3666izocashApp(false);
    setHead4666izocashApp(false);
  }

  // head 2 (stock international)
  const getHead2666izocashApp = localStorage.getItem("head2666izocashApp");
  const [head2666izocashApp, setHead2666izocashApp] = useState(getHead2666izocashApp);
  async function Head2666izocashApp() {
    const head2 = true;
    localStorage.setItem("head2666izocashApp", head2);
    localStorage.removeItem("head1666izocashApp");
    localStorage.removeItem("head3666izocashApp");
    localStorage.removeItem("head4666izocashApp");
    setHead2666izocashApp(true);
    setHead1666izocashApp(false);
    setHead3666izocashApp(false);
    setHead4666izocashApp(false);
  }

  // head 3 (solde national)
  const getHead3666izocashApp = localStorage.getItem("head3666izocashApp");
  const [head3666izocashApp, setHead3666izocashApp] = useState(getHead3666izocashApp);
  async function Head3666izocashApp() {
    const head3 = true;
    localStorage.setItem("head3666izocashApp", head3);
    localStorage.removeItem("head1666izocashApp");
    localStorage.removeItem("head2666izocashApp");
    localStorage.removeItem("head4666izocashApp");
    setHead3666izocashApp(true);
    setHead1666izocashApp(false);
    setHead2666izocashApp(false);
    setHead4666izocashApp(false);
  }

  // head 4 (solde international)
  const getHead4666izocashApp = localStorage.getItem("head4666izocashApp");
  const [head4666izocashApp, setHead4666izocashApp] = useState(getHead4666izocashApp);
  async function Head4666izocashApp() {
    const head4 = true;
    localStorage.setItem("head4666izocashApp", head4);
    localStorage.removeItem("head1666izocashApp");
    localStorage.removeItem("head2666izocashApp");
    localStorage.removeItem("head3666izocashApp");
    setHead4666izocashApp(true);
    setHead1666izocashApp(false);
    setHead2666izocashApp(false);
    setHead3666izocashApp(false);
  }

  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // Veil Brillant App
  // quand on clique sur l'icone de l'App, l'ecran de demarrage s'affiche - VB
  const [ecranDemarrageVB, setEcranDemarrageVB] = useState(false);
  async function FermerEcranDemarrageVB() {
    setEcranDemarrageVB(false);
  }

  async function EcranDemarrageVB() {
    setEcranDemarrageVB(true);

    //Ca c'est la fonction qui va mettre les lettres a true
    //VEIL
    async function LettreV() {
      setLettreV(true);
    }
    async function LettreE() {
      setLettreE(true);
    }
    async function PremierI() {
      setPremierI(true);
    }
    async function PremierL() {
      setPremierL(true);
    }
    //BRILLANT
    async function LettreB() {
      setLettreB(true);
    }
    async function LettreR() {
      setLettreR(true);
    }
    async function DeuxiemeI() {
      setDeuxiemeI(true);
    }
    async function DeuxiemeL() {
      setDeuxiemeL(true);
    }
    async function TroisiemeL() {
      setTroisiemeL(true);
    }
    async function LettreA() {
      setLettreA(true);
    }
    async function LettreN() {
      setLettreN(true);
    }
    async function LettreT() {
      setLettreT(true);
    }
    //ce code permet de maintenir l'ecran de demarrage ouvert pendant quelques secondes
    async function CloseEcranDemarrageVB() {
      setEcranDemarrageVB(false);
      //VEIL
      setLettreV(false);
      setLettreE(false);
      setPremierI(false);
      setPremierL(false);
      //BRILLANT
      setLettreB(false);
      setLettreR(false);
      setDeuxiemeI(false);
      setDeuxiemeL(false);
      setTroisiemeL(false);
      setLettreA(false);
      setLettreN(false);
      setLettreT(false);
      setVeilBrillantApp(true);
    }
    //ici c'est pour lui dire que tu vas m'afficher les lettres du logo apres 0,1 secondes
    //VEIL
    setTimeout(LettreV, 60);
    setTimeout(LettreE, 120);
    setTimeout(PremierI, 180);
    setTimeout(PremierL, 240);
    //BRILLANT
    setTimeout(LettreB, 300);
    setTimeout(LettreR, 360);
    setTimeout(DeuxiemeI, 420);
    setTimeout(DeuxiemeL, 480);
    setTimeout(TroisiemeL, 540);
    setTimeout(LettreA, 600);
    setTimeout(LettreN, 660);
    setTimeout(LettreT, 720);
    setTimeout(CloseEcranDemarrageVB, 2000);

    // requete pour obtenir toutes les videos publier par les utilisateurs de veil brillant

  }
  //ca ce sont les lettres du logo de Veil Brillant
  //VEIL
  const [lettreV, setLettreV] = useState(false);
  const [lettreE, setLettreE] = useState(false);
  const [premierI, setPremierI] = useState(false);
  const [premierL, setPremierL] = useState(false);
  //BRILLANT
  const [lettreB, setLettreB] = useState(false);
  const [lettreR, setLettreR] = useState(false);
  const [deuxiemeI, setDeuxiemeI] = useState(false);
  const [deuxiemeL, setDeuxiemeL] = useState(false);
  const [troisiemeL, setTroisiemeL] = useState(false);
  const [lettreA, setLettreA] = useState(false);
  const [lettreN, setLettreN] = useState(false);
  const [lettreT, setLettreT] = useState(false);

  //veil Brillant app
  //ca c'est l'application veil Brillant
  //cette logique affiche la page d'accueil de l'application veil Brillant
  const [veilBrillantApp, setVeilBrillantApp] = useState(false);
  async function VeilBrillantApp() {
    setVeilBrillantApp(false);
  }


  //on recupere les infos de la personne connecter - VB
  const idPersonConnectedVB = localStorage.getItem("idPersonConnectedVB");
  const namePersonConnectedVB = localStorage.getItem("namePersonConnectedVB");
  const photoPersonConnectedVB = localStorage.getItem("photoPersonConnectedVB");
  const badgePersonConnectedVB = localStorage.getItem("badgePersonConnectedVB");


  // infos userVB
  const idUserConnectedVB = localStorage.getItem("idUserConnectedVB");
  //const balanceVeilB = localStorage.getItem("balanceVeilB");

  // requete pour obtenir tout les utilisateurs Veil Brillant - VB
  const [apiUserVB, setApiUserVB] = useState([]);


  // filtre dans l'apiUserVB (on affiche les infos de l'utilisateur connecter)
 const userConnectedVB = apiUserVB.filter((api) => api._id === idUserConnectedVB);

 const getBalanceVeilB = userConnectedVB.map((api) => api.balanceVeilB); // solde Veil B
 if (getBalanceVeilB) { localStorage.setItem("balanceVeilB", getBalanceVeilB); }

 const getDisplayOtherVB = userConnectedVB.map((api) => api.displayOther); // displayOther 
 if (getDisplayOtherVB) { localStorage.setItem("displayOtherVB", getDisplayOtherVB); }

 const gethomeVB = userConnectedVB.map((api) => api.home); // home 
 if (gethomeVB) { localStorage.setItem("homeVB", gethomeVB); }

 const gethomeVideoVB = userConnectedVB.map((api) => api.homeVideo); // homeVideo 
 if (gethomeVideoVB) { localStorage.setItem("homeVideoVB", gethomeVideoVB); }

 const getblockVB = userConnectedVB.map((api) => api.block); // block 
 if (getblockVB) { localStorage.setItem("blockVB", getblockVB); }

 const getNewMessageVB = userConnectedVB.map((api) => api.newMessage); // newMessage 
 if (getNewMessageVB) { localStorage.setItem("newMessageVB", getNewMessageVB); }

 const getNewNotificationVB = userConnectedVB.map((api) => api.newNotification); // newNotification 
 if (getNewNotificationVB) { localStorage.setItem("newNotificationVB", getNewNotificationVB); }


  //const idOwnerVB = localStorage.getItem("idOwnerVB");
  // requete pour obtenir tout les comptes Veil Brillant - VB
  const [apiAccountVB, setApiAccountVB] = useState([]);


  // requete pour obtenir toutes les videos publier par les utilisateurs de veil brillant


  // on affiche les videos presentes sur la page d'accueil de veil brillant du plus recent au plus ancien
  const allVideoVB = apiAccountVB.filter((api) => api.visible === "1" && api.display === "1");
  const filterVideoVB = allVideoVB.sort((a, b) => b.id - a.id);


  
  // obtenir les infos du proprietaire de la video
  const idOwnerVideoVB = localStorage.getItem("idOwnerVideo");
  const filterOwnerVideoVB = apiAccountVB.filter((api) => api._id === idOwnerVideoVB);
  const nameOtherVB = filterOwnerVideoVB.map((api) => api.nameAccount);  // nom
  const photoOtherVB = filterOwnerVideoVB.map((api) => api.photoProfile);  // photo (on affiche la photo de profil)

  
  // obtenir les infos du proprietaire de la video suggerer
  const idOwnerSuggestedVideoVB = localStorage.getItem("idOwnerSuggestedVideo");
  const filterOwnerSuggestedVideoVB = apiAccountVB.filter((api) => api._id === idOwnerSuggestedVideoVB);
  const nameOwnerSuggestedVideoVB = filterOwnerSuggestedVideoVB.map((api) => api.nameAccount);  // nom
  const photoOwnerSuggestedVideoVB = filterOwnerSuggestedVideoVB.map((api) => api.photoProfile);  // photo (on affiche la photo de profil)

  // obtenir toutes les videos par personne
  const filterVideoOwnerVB = apiAccountVB.filter((api) => api.idOwner === idOwnerVideoVB);
 
  
  // filtre dans l'apiAccountVB (on affiche les infos de la personne connecter) 
  const accountConnectedVB = apiAccountVB.filter((api) => api._id === idPersonConnectedVB);

  const getIdUserConnectedVB = accountConnectedVB.map((api) => api.idUser); // idUser
  if (getIdUserConnectedVB) { localStorage.setItem("idUserConnectedVB", getIdUserConnectedVB); }

  const getNamePersonConnectedVB = accountConnectedVB.map((api) => api.nameAccount); // name
  if (getNamePersonConnectedVB) { localStorage.setItem("namePersonConnectedVB", getNamePersonConnectedVB); }

  const getPhotoPersonConnectedVB = accountConnectedVB.map((api) => api.photoProfile); // photo
  if (getPhotoPersonConnectedVB) { localStorage.setItem("photoPersonConnectedVB", getPhotoPersonConnectedVB); }

  const getBadgePersonConnectedVB = accountConnectedVB.map((api) => api.badge); // badge
  if (getBadgePersonConnectedVB) { localStorage.setItem("badgePersonConnectedVB", getBadgePersonConnectedVB); }

  const getVirtualNumberPersonConnectedVB = accountConnectedVB.map((api) => api.virtualNumber); // virtual number
  if (getVirtualNumberPersonConnectedVB) { localStorage.setItem("virtualNumberPersonConnectedVB", getVirtualNumberPersonConnectedVB); }

  const getCountryPersonConnectedVB = accountConnectedVB.map((api) => api.country); // country (pays)
  if (getCountryPersonConnectedVB) { localStorage.setItem("countryPersonConnectedVB", getCountryPersonConnectedVB); }

  const getMonetizationVB = accountConnectedVB.map((api) => api.monetization); // monetisation 
  if (getMonetizationVB) { localStorage.setItem("monetizationVB", getMonetizationVB); }

  const getMonetizationBalanceVB = accountConnectedVB.map((api) => api.monetizationBalance); // solde 
  if (getMonetizationBalanceVB) { localStorage.setItem("monetizationBalanceVB", getMonetizationBalanceVB); }
  

  //ca se sont les onglets de l'application Veil Brillant
  //video onglet
  const [videoOngletVB, setVideoOngletVB] = useState(true);
  async function VideoOngletVB() {
    setVideoOngletVB(true);
    setCompteOngletVB(false);
    setSearchOngletVB(false);
  }
  //compte onglet
  const [compteOngletVB, setCompteOngletVB] = useState(false);
  async function CompteOngletVB() {
    setVideoOngletVB(false);
    setCompteOngletVB(true);
    setSearchOngletVB(false);
  }
  //search onglet
  const [searchOngletVB, setSearchOngletVB] = useState(false);
  async function SearchOngletVB() {
    setSearchOngletVB(true);
    setVideoOngletVB(false);
    setCompteOngletVB(false);
  }


  // seePhoto2 (page pour voir la photo de la personne connecté) - VB
  const [seePhoto2personConnectedVB, setSeePhoto2personConnectedVB] = useState(false);
  /*async function SeePhoto2personConnectedVB() {
   setSeePhoto2personConnectedVB(true);
  }*/
  async function CloseSeePhoto2personConnectedVB() { 
   setSeePhoto2personConnectedVB(false);
  }


  // voir photo profil (666 ProfilVB)
  // on affiche la photo de profil
  const [seePhotoProfil666ProfilVB, setSeePhotoProfil666ProfilVB] = useState(false);
  async function SeePhotoProfil666ProfilVB() {
    setSeePhotoProfil666ProfilVB(true);
  }
  async function CloseSeePhotoProfil666ProfilVB() {
    setSeePhotoProfil666ProfilVB(false);
  }


  // logique pour obtenir, afficher les resultats de la recherche - VB
  const [mySearchVB, setMySearchVB] = useState("");
  if (mySearchVB) { localStorage.setItem("search", mySearchVB); }

  const getMySearchVB = localStorage.getItem("search");

  // rechercher parmi les comptes 
  const accountFindVB = apiAccountVB.filter((api) => api.nameAccount.includes(getMySearchVB));
  const verifyAccountVB  = accountFindVB.length > 0; // ici les comptes ont ete trouver

  // rechercher parmi les videos 
  const videoFindVB = apiAccountVB.filter((api) => api.title?.includes(getMySearchVB));
  const verifyVideoVB  = videoFindVB.length > 0; // ici les videos ont ete trouver


  //videoPage - VB
  //ici on affiche la page qui va permettre a l'utilisateur de commenter ou de voir la video
  const [videoPageVB, setVideoPageVB] = useState(false);
  async function VideoPageVB() {
    setVideoPageVB(true);
    setConfigurationVideo(false);
    setIsPlaying(true);
    setSon(false);
  }
  //fermer
  async function CloseVideoPageVB() {
    setVideoPageVB(false);
  }

  //lecteur video personnaliser - VB
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  
  
  // relire la video - FA
  useEffect(() => {
	  if (videoRef.current) {
		videoRef.current.load();   // recharge la vidéo
		videoRef.current.play();   // lance la lecture
	  }
	}, [urlVideo]);


//logique pour mettre la video en mode plein ecran - VB
async function FullScreen() { videoRef.current.requestFullscreen(); }


  //ca c'est le bouton play - VB
  //quand on clique sur play, on peut jouer la video ou mettre en pause la video
  async function Play() {
    setIsPlaying(true);

    if (isPlaying) {
      //mettre en pause la video
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      //lire la video
      videoRef.current.play();
      setIsPlaying(true);

      //ce code permet de masquer les boutons de la video apres quelques secondes
      async function CloseConfigurationVideo() {
        setConfigurationVideo(false);
      }
      setTimeout(CloseConfigurationVideo, 300);
    }
  }
  //ca c'est pour masquer/afficher les boutons de la video - VB
  const [configurationVideo, setConfigurationVideo] = useState(false);
  async function ConfigurationVideo() {
    setConfigurationVideo(!configurationVideo);
  }

  //logique pour afficher les minutes/secondes lors de la lecture de la video - VB
  const [currentTime, setCurrentTime] = useState([0, 0]);
  const [currentTimeSec, setCurrentTimeSec] = useState();
  const [duration, setDuration] = useState([0, 0]);
  const [durationSec, setDurationSec] = useState();

  //ici on converti les secondes en minutes
  async function sec2Min(sec) {
    const min = Math.floor(sec / 60);
    const secRemain = Math.floor(sec % 60);
    return {
      min: min,
      sec: secRemain,
    };
  }

useEffect(() => {
  if (!isPlaying) return;

  const afficherDuree = setInterval(() => {
    const { min, sec } = sec2Min(videoRef.current.duration);
    setDurationSec(videoRef.current.duration);
    setDuration([min, sec]);
  }, 500); // ✅ 500ms pour durée totale

  const interval = setInterval(() => {
    const { min, sec } = sec2Min(videoRef.current.currentTime);
    setCurrentTimeSec(videoRef.current.currentTime);
    setCurrentTime([min, sec]);
  }, 200); // ✅ 200ms pour timer en cours

  return () => {
    clearInterval(afficherDuree);
    clearInterval(interval);
  };
}, [isPlaying]);

  // videoPage (page) - VB
  // on recupere l'url de la video sur laquelle on a cliquer, pour voir la video.
  const urlVideoVB = localStorage.getItem("urlVideoVB");

  //logique pour jouer/couper le son de la video - VB
  const [son, setSon] = useState(false);
  //jouer le son. (ici le son est jouer) - VB
  async function VolumeOn() {
    videoRef.current.muted = false;
    setSon(true);
  }
  //couper le son. (ici le son est couper) - VB.
  async function VolumeOff() {
    videoRef.current.muted = true;
    setSon(false);
  }

  
  /* quand la video est terminer, cette logique va changer le bouton pause en play, cela va
 permettre a l'utilisateur de cliquer et de regarder la video a nouveau s'il veut - VB */
  async function LectureVideoTerminer() {
    setIsPlaying(false);
  }

  //voirToutesLesVideos - VB
  //on affiche toutes Les Videos de la personne
  const [voirToutesLesVideos, setVoirToutesLesVideos] = useState(false);
  async function VoirToutesLesVideos() {
    setVoirToutesLesVideos(true);
  }
  //fermer
  async function CloseVoirToutesLesVideos() {
    setVoirToutesLesVideos(false);
  }

  // seeVideo (SeeVideo2 666AllVideosUser1 666homeVB)
  /* ici on affiche la page qui va permettre a l'utilisateur de voir la video sur laquelle
  il a cliquer au niveau de SeeVideo2 666homeVB */
  const [seeVideo2666AllVideosUser1666homeVB, setSeeVideo2666AllVideosUser1666homeVB] = useState(false);
  async function SeeVideo2666AllVideosUser1666homeVB() {
    setSeeVideo2666AllVideosUser1666homeVB(true);
    setConfigurationVideo3(false);
    setIsPlaying3(true);
    setSon3(false);
  }
  async function CloseSeeVideo2666AllVideosUser1666homeVB() { //fermer
    setSeeVideo2666AllVideosUser1666homeVB(false);
  }

  // SeeSuggestedVideo2 - clique pour voir la video suggerer - VB
  async function SeeSuggestedVideo2666SeeVideo2666homeVB() {
    setSeeVideo2666AllVideosUser1666homeVB(true);
    setConfigurationVideo3(false);
    setIsPlaying3(true);
  }

  // on recupere l'url de la video sur laquelle on a cliquer, pour voir la video.
  const urlVideo3VB = localStorage.getItem("urlVideo3");
  
  //lecteur video personnaliser - VB
  const videoRef3 = useRef(null);
  const [isPlaying3, setIsPlaying3] = useState(false);

  //ca c'est le bouton play - VB
  //quand on clique sur play, on peut jouer la video ou mettre en pause la video
  async function Play3() {
    setIsPlaying3(true);

    if (isPlaying3) {
      //mettre en pause la video
      videoRef3.current.pause();
      setIsPlaying3(false);
    } else {
      //lire la video
      videoRef3.current.play();
      setIsPlaying3(true);

      //ce code permet de masquer les boutons de la video apres quelques secondes
      async function CloseConfigurationVideo3() {
        setConfigurationVideo3(false);
      }
      setTimeout(CloseConfigurationVideo3, 300);
    }
  }
  //ca c'est pour masquer/afficher les boutons de la video - VB
  const [configurationVideo3, setConfigurationVideo3] = useState(false);
  async function ConfigurationVideo3() {
    setConfigurationVideo3(!configurationVideo3);
  }

  //logique pour afficher les minutes/secondes lors de la lecture de la video - VB
  const [currentTime3, setCurrentTime3] = useState([0, 0]);
  const [currentTimeSec3, setCurrentTimeSec3] = useState();
  const [duration3, setDuration3] = useState([0, 0]);
  const [durationSec3, setDurationSec3] = useState();

  //ici on converti les secondes en minutes
  async function secToMin3(sec) {
    const min = Math.floor(sec / 60);
    const secRemain = Math.floor(sec % 60);
    return {
      min: min,
      sec: secRemain,
    };
  }

useEffect(() => {
  if (!isPlaying3) return;

  const afficherDuree3 = setInterval(() => {
    const { min, sec } = secToMin3(videoRef3.current.duration);
    setDurationSec3(videoRef3.current.duration);
    setDuration3([min, sec]);
  }, 500); // ✅ 500ms suffit pour durée totale

  const interval3 = setInterval(() => {
    const { min, sec } = secToMin3(videoRef3.current.currentTime);
    setCurrentTimeSec3(videoRef3.current.currentTime);
    setCurrentTime3([min, sec]);
  }, 200); // ✅ 200ms pour mise à jour timer en cours

  return () => {
    clearInterval(afficherDuree3);
    clearInterval(interval3);
  };
}, [isPlaying3]);

  //logique pour jouer/couper le son de la video - VB
  const [son3, setSon3] = useState(false);
  //jouer le son. (ici le son est jouer) - VB
  async function VolumeOn3() {
    videoRef3.current.muted = false;
    setSon3(true);
  }
  //couper le son. (ici le son est couper) - VB.
  async function VolumeOff3() {
    videoRef3.current.muted = true;
    setSon3(false);
  }

  //logique pour mettre la video en mode plein ecran - VB
  async function FullScreen3() {
    videoRef3.current.requestFullscreen();
  }

  /* quand la video est terminer, cette logique va changer le bouton pause en play, cela va
 permettre a l'utilisateur de cliquer et de regarder la video a nouveau s'il veut - VB */
  async function LectureVideoTerminer3() {
    setIsPlaying3(false);
  }

  // lastVideo1 (666Profil1 666homeVB)
  // lastVideo1 (666Profil1 666homeVB)
  // l'utilisateur clique pour voir la derrniere video publier
  const [lastVideo1666Profil1666homeVB, setLastVideo1666Profil1666homeVB] = useState(false);
  async function LastVideo1666Profil1666homeVB() {
    setLastVideo1666Profil1666homeVB(true);
    setConfigurationVideo4(false);
    setIsPlaying4(true);
    setSon4(false);
  }
  //fermer
  async function CloseLastVideo1666Profil1666homeVB() {
    setLastVideo1666Profil1666homeVB(false);
  }

  // derniere video que l'autre a publier. on recupere l'url de la video - VB
  const urlLastVideoVB = localStorage.getItem("urlLastVideo");

  //lecteur video personnaliser - VB
  const videoRef4 = useRef(null);
  const [isPlaying4, setIsPlaying4] = useState(false);

  //ca c'est le bouton play - VB
  //quand on clique sur play, on peut jouer la video ou mettre en pause la video
  async function Play4() {
    setIsPlaying4(true);

    if (isPlaying4) {
      //mettre en pause la video
      videoRef4.current.pause();
      setIsPlaying4(false);
    } else {
      //lire la video
      videoRef4.current.play();
      setIsPlaying4(true);

      //ce code permet de masquer les boutons de la video apres quelques secondes
      async function CloseConfigurationVideo4() {
        setConfigurationVideo4(false);
      }
      setTimeout(CloseConfigurationVideo4, 300);
    }
  }
  //ca c'est pour masquer/afficher les boutons de la video - VB
  const [configurationVideo4, setConfigurationVideo4] = useState(false);
  async function ConfigurationVideo4() {
    setConfigurationVideo4(!configurationVideo4);
  }

  //logique pour afficher les minutes/secondes lors de la lecture de la video - VB
  const [currentTime4, setCurrentTime4] = useState([0, 0]);
  const [currentTimeSec4, setCurrentTimeSec4] = useState();
  const [duration4, setDuration4] = useState([0, 0]);
  const [durationSec4, setDurationSec4] = useState();

  //ici on converti les secondes en minutes
  async function secToMin4(sec) {
    const min = Math.floor(sec / 60);
    const secRemain = Math.floor(sec % 60);
    return {
      min: min,
      sec: secRemain,
    };
  }


useEffect(() => {
  if (!isPlaying4) return;

  const afficherDuree4 = setInterval(() => {
    const { min, sec } = secToMin4(videoRef4.current.duration);
    setDurationSec4(videoRef4.current.duration);
    setDuration4([min, sec]);
  }, 500); // ✅ 500ms suffisent pour afficher la durée totale

  const interval4 = setInterval(() => {
    const { min, sec } = secToMin4(videoRef4.current.currentTime);
    setCurrentTimeSec4(videoRef4.current.currentTime);
    setCurrentTime4([min, sec]);
  }, 200); // ✅ 200ms est suffisant pour le timer en cours

  return () => {
    clearInterval(afficherDuree4);
    clearInterval(interval4);
  };
}, [isPlaying4]);


  //logique pour jouer/couper le son de la video - VB
  const [son4, setSon4] = useState(false);
  //jouer le son. (ici le son est jouer) - VB
  async function VolumeOn4() {
    videoRef4.current.muted = false;
    setSon4(true);
  }
  //couper le son. (ici le son est couper) - VB.
  async function VolumeOff4() {
    videoRef4.current.muted = true;
    setSon4(false);
  }

  //logique pour mettre la video en mode plein ecran - VB
  async function FullScreen4() {
    videoRef4.current.requestFullscreen();
  }

  /* quand la video est terminer, cette logique va changer le bouton pause en play, cela va
 permettre a l'utilisateur de cliquer et de regarder la video a nouveau s'il veut - VB */
  async function LectureVideoTerminer4() {
    setIsPlaying4(false);
  }
  

  // seeSuggestedVideoPage (2e lecteur) - VB
  // seeSuggestedVideoPage (2e lecteur) - VB
  /* note: je mets 2 a chaque fois parce que c'est la 2e page qui a son propre lecteur video 
  personnaliser. le 1er lecteur video personnaliser est sur la page principale pratiquement au 
  niveau de la page d'accueil, mais labas je n'est pas mis de numero. donc 2 veut tout
  simplement dire 2e lecteur video personnaliser, ou 2 represente le 2e lecteur video 
  personnaliser.
  2VB signifie : lecteur numero 2 dans l'application veil brillant */
  // quand l'utilisateur clique, il va voir la video suggerer sur cette page
  const [seeSuggestedVideoPageVB, setSeeSuggestedVideoPageVB] = useState(false);
  async function SeeSuggestedVideoPageVB() {
    //mettre en pause la video
    videoRef.current.pause();
    setIsPlaying(false);

    setSeeSuggestedVideoPageVB(true);
    setConfigurationVideo2VB(false);
    setIsPlaying2VB(true);
    setSon2VB(false);
  }
  //fermer
  async function CloseSeeSuggestedVideoPageVB() {
    //lire la video
    videoRef.current.play();
    setIsPlaying(true);

    setSeeSuggestedVideoPageVB(false);
  }

  // logique pour lire une video qui est dans les suggestions - 666SeeSuggestedVideoPageVB
  /* sur cette page (SeeSuggestedVideoPageVB), quand on clique sur une video qui est dans 
  les suggestions,  */
  async function SeeSuggestedVideoVB() {
    //mettre en pause la video
    videoRef.current.pause();
    setIsPlaying(false);

    setSeeSuggestedVideoPageVB(true);
    setConfigurationVideo2VB(false);
    setIsPlaying2VB(true);
  }

  //lecteur video personnaliser (2e lecteur) - VB
  const videoRef2VB = useRef(null);
  const [isPlaying2VB, setIsPlaying2VB] = useState(false);

  //ca c'est le bouton play - VB
  //quand on clique sur play, on peut jouer la video ou mettre en pause la video
  async function Play2VB() {
    setIsPlaying2VB(true);

    if (isPlaying2VB) {
      //mettre en pause la video
      videoRef2VB.current.pause();
      setIsPlaying2VB(false);
    } else {
      //lire la video
      videoRef2VB.current.play();
      setIsPlaying2VB(true);

      //ce code permet de masquer les boutons de la video apres quelques secondes
      async function CloseConfigurationVideo2VB() {
        setConfigurationVideo2VB(false);
      }
      setTimeout(CloseConfigurationVideo2VB, 300);
    }
  }
  //ca c'est pour masquer/afficher les boutons de la video - VB
  const [configurationVideo2VB, setConfigurationVideo2VB] = useState(false);
  async function ConfigurationVideo2VB() {
    setConfigurationVideo2VB(!configurationVideo2VB);
  }

  //logique pour afficher les minutes/secondes lors de la lecture de la video - VB
  const [currentTime2VB, setCurrentTime2VB] = useState([0, 0]);
  const [currentTimeSec2VB, setCurrentTimeSec2VB] = useState();
  const [duration2VB, setDuration2VB] = useState([0, 0]);
  const [durationSec2VB, setDurationSec2VB] = useState();

  //ici on converti les secondes en minutes
  async function secToMin2VB(sec) {
    const min = Math.floor(sec / 60);
    const secRemain = Math.floor(sec % 60);
    return {
      min: min,
      sec: secRemain,
    };
  }


useEffect(() => {
  if (!isPlaying2VB) return;

  const afficherDuree2VB = setInterval(() => {
    const { min, sec } = secToMin2VB(videoRef2VB.current.duration);
    setDurationSec2VB(videoRef2VB.current.duration);
    setDuration2VB([min, sec]);
  }, 500); // ✅ 500ms suffisent

  const interval2VB = setInterval(() => {
    const { min, sec } = secToMin2VB(videoRef2VB.current.currentTime);
    setCurrentTimeSec2VB(videoRef2VB.current.currentTime);
    setCurrentTime2VB([min, sec]);
  }, 200); // ✅ 200ms est suffisant

  return () => {
    clearInterval(afficherDuree2VB);
    clearInterval(interval2VB);
  };
}, [isPlaying2VB]);


  // SuggestedVideo (page) - VB
  // on recupere l'url de la video sur laquelle on a cliquer, pour voir la video.
  const urlSuggestedVideoVB = localStorage.getItem("urlSuggestedVideo");

  //logique pour jouer/couper le son de la video - VB
  const [son2VB, setSon2VB] = useState(false);

  //jouer le son. (ici le son est jouer) - VB
  async function VolumeOn2VB() {
    videoRef2VB.current.muted = false;
    setSon2VB(true);
  }
  //couper le son. (ici le son est couper) - VB.
  async function VolumeOff2VB() {
    videoRef2VB.current.muted = true;
    setSon2VB(false);
  }

  //logique pour mettre la video en mode plein ecran - VB
  async function FullScreen2VB() {
    videoRef2VB.current.requestFullscreen();
  }

  /* quand la video est terminer, cette logique va changer le bouton pause en play, cela va
 permettre a l'utilisateur de cliquer et de regarder la video a nouveau s'il veut - VB */
  async function LectureVideoTerminer2VB() {
    setIsPlaying2VB(false);
  }


  //connexion veil Brillant app
  /*ici on affiche la popup card qui va permettre a la personne de se connecter 
  a son compte veil Brillant */
  const [connexionPageVB, setConnexionPageVB] = useState(false);
  async function ConnexionPageVB() {
    setConnexionPageVB(true);
    setInscriptionPageVB(false);
  }
  //fermer
  async function CloseConnexionPageVB() {
    setConnexionPageVB(false);
  }

  //inscription veil Brillant app
  //on affiche la popup card qui va permettre a la personne de s'inscrire sur veil Brillant
  const [inscriptionPageVB, setInscriptionPageVB] = useState(false);
  async function InscriptionPageVB() {
    setInscriptionPageVB(true);
    setConnexionPageVB(false);
  }
  //fermer
  async function CloseInscriptionPageVB() {
    setInscriptionPageVB(false);
  }

  //inscription success - VB
  //inscription success - VB
  //on affiche ce message de success lorsque la personne a pu s'inscrire
  const [inscriptionSuccessVB, setInscriptionSuccessVB] = useState(false);
  async function CloseInscriptionSuccessVB() {
    setInscriptionSuccessVB(false);
    setConnectezVousVB(true);
  }
  //connectezVous(message) - VB
  //message pour inviter l'utilisateur a se connecter
  const [connectezVousVB, setConnectezVousVB] = useState(false);
  async function CloseConnectezVousVB() {
    setConnectezVousVB(false);
    setInscriptionPageVB(false);
    setConnexionPageVB(true);
  }

  //connexion success - VB
  //connexion success - VB
  //on affiche ce message de success lorsque la personne a pu se connecter
  const [connexionSuccessVB, setConnexionSuccessVB] = useState(false);
  async function CloseConnexionSuccessVB() {
    setConnexionSuccessVB(false);
    setConnexionPageVB(false);
  }

  //erreur - VB
  //on affiche ce message d'erreur s'il y'a une erreur
  const [erreurVB, setErreurVB] = useState(false);
  async function CloseErreurVB() {
    setErreurVB(false);
  }

  //si la personne non connecter clique pour voir une video on va l'afficher ce message 
  const [disconnectedPersonWantSeeVideoVB, setDisconnectedPersonWantSeeVideoVB] = useState(false);
  async function DisconnectedPersonWantSeeVideoVB() {
    setDisconnectedPersonWantSeeVideoVB(true);
  }
  async function CloseDisconnectedPersonWantSeeVideoVB() { //fermer
    setDisconnectedPersonWantSeeVideoVB(false);
  }


  // signup - VB
  // signup - VB
  //ici l'utilisateur saisi son nom, numero virtuel, mot de passe - VB
  const [nameSignupVB, setNameSignupVB] = useState("");
  const [numberSignupVB, setNumberSignupVB] = useState("");
  const [passwordSignupVB, setPasswordSignupVB] = useState("");

  if (nameSignupVB) { localStorage.setItem("writeNameVB", nameSignupVB); } //nom
  if (numberSignupVB) { localStorage.setItem("writeVirtualNumberVB", numberSignupVB); } //numero virtuel
  if (passwordSignupVB) { localStorage.setItem("writePasswordVB", passwordSignupVB); } //mot de passe

  //logique pour s'inscrire sur Veil Brillant - VB
  async function SignupVB() {
    setOpacity(true);
    
    // 1ere requete
    // 1ere requete
    // on verifie si le numero virtuel existe et si c'est deja identifier
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_SignupVB}/api/accountIA`)
      .then((res) => {
        const writeVirtualNumber = localStorage.getItem("writeVirtualNumberVB");

        const api = res.data;
        const filterVirtualNumber = api.filter((api) => api.virtualNumber === writeVirtualNumber && api.identification === "1" && api.type === "1");

        const paymentMethod = filterVirtualNumber.map((api) => api.paymentMethod); //paymentMethod
        if (paymentMethod) { localStorage.setItem("paymentMethod", paymentMethod); }

        const countryCode = filterVirtualNumber.map((api) => api.countryCode); //countryCode
        if (countryCode) { localStorage.setItem("countryCode", countryCode); }

        // verifiedNumberExist > 0, numero virtuel existe
        // verifiedNumberExist < 0, numero virtuel existe pas
        const verifiedNumberExist = filterVirtualNumber.length > 0;
        
        if (verifiedNumberExist) {
          //dans ce cas: numero virtuel existe

          // 2e requete
          // 2e requete
          // on verifie si la personne est deja inscrite sur Veil Brillant avec ce numero virtuel
          async function deuxiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_SignupVB}/api/userVB`)
            .then((res) => {
              // on filtre en fonction du numero virtuel saisi - VB
              const writeVirtualNumber = localStorage.getItem("writeVirtualNumberVB");

              const api = res.data;
              const filter = api.filter((api) => api.virtualNumber === writeVirtualNumber);

              const verifiedAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
              if (verifiedAlreadySignup) {
                // dans ce cas: numero virtuel deja inscrit (on affiche un message d'erreur, car il y'a deja une personne inscrite avec ce numero virtuel)
                setErreurVB(true);
                setOpacity(false);
              } else {
              // dans ce cas: numero virtuel non inscrit

            //3e requete
            //3e requete
            // inscrire l'utilisateur (numero virtuel non inscrit, alors on lui laisse s'inscrire)
            async function troisiemeReq() {
              const writeName = localStorage.getItem("writeNameVB");
              const writeVirtualNumber = localStorage.getItem("writeVirtualNumberVB");
              const writePassword = localStorage.getItem("writePasswordVB");
              const photoProfile = "0";
              const balanceVeilB= "0";
              const displayOther = "0";
              const home = "0";
              const homeVideo = "0";
              const block = "0";
              const connection = "1";
              
              await axios({
                method: "post",
                url: `${process.env.REACT_APP_SignupVB}/api/userVB/signup`,
                data: {
                  nameUser: writeName,
                  virtualNumber: writeVirtualNumber,
                  password: writePassword,
                  photoProfile,
                  balanceVeilB,
                  displayOther,
                  home,
                  homeVideo,
                  block,
                  connection,
                },
              })
              .then((res) => {
              // utilisateur enregistré! on prend l'idUser, on va l'ajouter au niveau de son compte VB
              const id = res.data.idUser;
              if (id) { localStorage.setItem("idUser", id); }

                //4e requete
                //4e requete
                // on cree son compte 
                async function quatriemeReq() {
                  const idUser = localStorage.getItem("idUser");
                  const writeName = localStorage.getItem("writeNameVB");
                  const writeVirtualNumber = localStorage.getItem("writeVirtualNumberVB");
                  const lastVideo = "0";
                  const badge = "0";
                  const photoProfile = "0";
                  const paymentMethod = localStorage.getItem("paymentMethod");
                  const countryCode = localStorage.getItem("countryCode");
                  const myAccount = "0";
                  const monetization = "0";
                  const connection = "1";
                  const display = "1";
                  const visible = "1";
                  const type = "1";

                  await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_SignupVB}/api/accountVB/create`,
                    data: {
                      idUser,
                      nameAccount: writeName,
                      virtualNumber: writeVirtualNumber,
                      lastVideo,
                      badge,
                      photoProfile,
                      paymentMethod,
                      countryCode,
                      monetization,
                      myAccount,
                      connection,
                      display,
                      visible,
                      type,
                    },
                  })
                  .then((res) => {
                    setInscriptionSuccessVB(true); //inscription reussie (message de success)
                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurVB(true);
                  });
                }
                quatriemeReq();
                //4e requete
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurVB(true);
                });
              }
              troisiemeReq();
              //3e requete
              }
              // le if de verifiedAlreadySignup se ferme ici
            })
            .catch((err) => {
              setOpacity(false);
              setErreurVB(true);
            });
          }
          deuxiemeReq();
          // 2e requete
        } else {
          //dans ce cas: numero virtuel n'existe pas (on affiche a l'utilisateur un message d'erreur)
          setOpacity(false);
          setErreurVB(true);
        }
        //le if de verifiedNumberExist se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErreurVB(true);
      });
    }
    premiereReq();
    // 1ere requete
  }

  
  // login - VB
  // login - VB
  // saisir :
  const [numberLoginVB, setNumberLoginVB] = useState(""); //numero virtuel
  const [passwordLoginVB, setPasswordLoginVB] = useState(""); //mot de passe

  if (numberLoginVB) { 
    localStorage.setItem("writeVirtualNumberVB", numberLoginVB); 
    localStorage.setItem("writeVirtualNumberVBforVerificationLoginVB", numberLoginVB); 
  }

  if (passwordLoginVB) { 
    localStorage.setItem("writePasswordVB", passwordLoginVB); 
    localStorage.setItem("writePasswordVBforVerificationLoginVB", passwordLoginVB); 
  } 

  //logique pour se connecter sur Veil Brillant - VB
  async function LoginVB() {
    setOpacity(true);

    //1ere requete
    //1ere requete
    // on verifie si la personne est deja inscrite sur Veil Brillant avec ce numero virtuel
    async function premiereReq() {
      await axios
      .get(`${process.env.REACT_APP_LoginVB}/api/userVB`)
      .then((res) => {
        // on filtre en fonction du numero virtuel saisi
        const writeVirtualNumber = localStorage.getItem("writeVirtualNumberVB");

        const api = res.data;
        const filter = api.filter((api) => api.virtualNumber === writeVirtualNumber);
        
        const verifyAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
        if (verifyAlreadySignup) {
        // dans ce cas: numero virtuel deja inscrit
      
        //2e requete
        //2e requete
        // connecter l'utilisateur (numero virtuel deja inscrit sur VB alors on lui laisse se connecter)
        async function deuxiemeReq() {
          const writeVirtualNumber = localStorage.getItem("writeVirtualNumberVB");
          const writePassword = localStorage.getItem("writePasswordVB");
          
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_LoginVB}/api/userVB/login`,
            data: {
              virtualNumber: writeVirtualNumber,
              password: writePassword,
            },
          })
          .then((res) => {
            //on prend l'idUser pour pouvoir filtrer
            const idUser = res.data.idUser;
            if (idUser) { localStorage.setItem("idUser", idUser); }
  
          //3e requete
          //3e requete
          // maintenir l'utilisateur connecté ! (on enregistre les infos de connexion)
          async function troisiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_LoginVB}/api/accountVB`)
            .then((res) => {
              //on recupere l'idUser
              const idUser = localStorage.getItem("idUser");
              
              // filtre pour obtenir uniquement les infos de la personne connecter
              const api = res.data;
              const filterUser = api.filter((api) => api.idUser === idUser);
  
              const id = filterUser.map((api) => api._id); // id
              if (id) { localStorage.setItem("idPersonConnectedVB", id); }
              setApiAccountVB(res.data);

            //4e requete
            //4e requete
            // on enregistre displayOther (ca va etre utile lorsqu'il voudra publier)
            async function quatriemeReq() {
            await axios
              .get(`${process.env.REACT_APP_LoginVB}/api/userVB`)
              .then((res) => {
                const idUser = localStorage.getItem("idUser");
                const api = res.data;
                const filterUser = api.filter((api) => api._id === idUser);
    
                const displayOther = filterUser.map((api) => api.displayOther); // displayOther
                if (displayOther) { localStorage.setItem("displayOtherVB", displayOther); }

                const home = filterUser.map((api) => api.home); // home
                if (home) { localStorage.setItem("homeVB", home); }

                const homeVideo = filterUser.map((api) => api.homeVideo); // homeVideo
                if (homeVideo) { localStorage.setItem("homeVideoVB", homeVideo); }

                const block = filterUser.map((api) => api.block); // block
                if (block) { localStorage.setItem("blockVB", block); }
                setApiUserVB(res.data);

                //connexion reussie, on affiche le message de success
                setOpacity(false);
                setConnexionSuccessVB(true);
              })
              }
              quatriemeReq();
              //4e requete
              })
              .catch((err) => {
                setOpacity(false);
                setErreurVB(true);
              });
            }
            troisiemeReq();
            //3e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErreurVB(true);
          });
        }
        deuxiemeReq();
        //2e requete
        } else {
          // numero virtuel non inscrit, impossible de se connecter
          setOpacity(false);
          setErreurVB(true);
        }
        //le if de verifyAlreadySignup se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErreurVB(true);
      });
    }
    premiereReq();
    //1ere requete
  }


  //on affiche le card qui va permettre a l'utilisateur de se deconnecter - VB
  const [deconnexionPageVB, setDeconnexionPageVB] = useState(false);
  async function DeconnexionPageVB() {
    setDeconnexionPageVB(!deconnexionPageVB);
  }
  //deconnexion reussie(message) - VB
  const [deconnexionSuccessVB, setDeconnexionSuccessVB] = useState(false);
  async function CloseDeconnexionSuccessVB() {
    setDeconnexionPageVB(false);
    setDeconnexionSuccessVB(false);
    setConnexionPageVB(true);
  }

  //logique pour se deconnecter du compte Veil Brillant
  async function LogoutVB() {
    localStorage.removeItem("idPersonConnectedVB");
    localStorage.removeItem("namePersonConnectedVB");
    localStorage.removeItem("photoPersonConnectedVB");
    localStorage.removeItem("idVideo");
    localStorage.removeItem("idOwnerVideo");
    localStorage.removeItem("idOwnerSuggestedVideo");
    localStorage.removeItem("urlVideo");
    localStorage.removeItem("urlVideo3");
    localStorage.removeItem("urlLastVideo");
    localStorage.removeItem("idSuggestedVideo");
    localStorage.removeItem("urlSuggestedVideo");
    localStorage.removeItem("writeName");
    localStorage.removeItem("writeVirtualNumber");
    localStorage.removeItem("writePassword");
    localStorage.removeItem("search");
    localStorage.removeItem("videoSended");
    localStorage.removeItem("createIdInfosValidate");
    localStorage.removeItem("createIdVideo");
    localStorage.removeItem("GoToPageMiniMenuVB");
    //une fois que la personne est deconnecter, on affiche un message de success
    setDeconnexionSuccessVB(true);
  }

  //nonConnecterVB
  /*si la personne n'est pas connecter, on va l'afficher un message pour lui dire quelle 
  doit se connecter a son compte veil Brillant pour avoir acces a cette fonctionaliter */
  const [nonConnecterVB, setNonConnecterVB] = useState(false);
  async function NonConnecterVB() {
    setNonConnecterVB(!nonConnecterVB);
  }



  //ProfilOther (666VideoPageVB)
  //ici on affiche le profil d"une autre personne
  const [profilOther666VideoPageVB, setProfilOther666VideoPageVB] = useState(false);
  async function ProfilOther666VideoPageVB() {
    setProfilOther666VideoPageVB(true);
  }
  //fermer
  async function CloseProfilOther666VideoPageVB() {
    setProfilOther666VideoPageVB(false);
  }

  //ProfilOther (666SuggestedVideoPageVB)
  //ici on affiche le profil d"une autre personne
  const [
    profilOther666SuggestedVideoPageVB,
    setProfilOther666SuggestedVideoPageVB,
  ] = useState(false);
  async function ProfilOther666SuggestedVideoPageVB() {
    setProfilOther666SuggestedVideoPageVB(true);
  }
  //fermer
  async function CloseProfilOther666SuggestedVideoPageVB() {
    setProfilOther666SuggestedVideoPageVB(false);
  }

  //SeePhoto (666ProfilOther 666VideoPageVB)
  //l'utilisateur clique pour voir la photo de profil
  const [seePhoto666ProfilOther666VideoPageVB, setSeePhoto666ProfilOther666VideoPageVB] = useState(false);
  async function SeePhoto666ProfilOther666VideoPageVB() {
    setSeePhoto666ProfilOther666VideoPageVB(true);
  }
  async function CloseSeePhoto666ProfilOther666VideoPageVB() {
    setSeePhoto666ProfilOther666VideoPageVB(false);
  }

  const photoOwnerVideoVB = localStorage.getItem("urlPhotoVB");

  //SeePhoto (666ProfilOther 666SuggestedVideoPageVB)
  //l'utilisateur clique pour voir la photo de profil
  const [
    seePhoto666ProfilOther666SuggestedVideoPageVB,
    setSeePhoto666ProfilOther666SuggestedVideoPageVB,
  ] = useState(false);
  async function SeePhoto666ProfilOther666SuggestedVideoPageVB() {
    setSeePhoto666ProfilOther666SuggestedVideoPageVB(true);
  }
  //fermer
  async function CloseSeePhoto666ProfilOther666SuggestedVideoPageVB() {
    setSeePhoto666ProfilOther666SuggestedVideoPageVB(false);
  }


  // choisir la photo a mettre sur le profil (page) - VB
  const [choosePhotoProfilePageVB, setChoosePhotoProfilePageVB] = useState(false);
  async function CloseChoosePhotoProfilePageVB() { //fermer
    setChoosePhotoProfilePageVB(false);
  }


    //requete pour obtenir tout les favoris
    const [apiFavoriteVB, setApiFavoriteVB] = useState([]);

    // Tout les favoris
    //const allFavoriteVB = apiFavoriteVB.filter((api) => api.idOwner === idUserConnectedVB && api.visible === "1"); 


  // favoris (page) - VB
  // favoris (page) - VB
  const [favoriteVB, setFavoriteVB] = useState(false);
  async function FavoriteVB() {
    setFavoriteVB(true);
  }
  async function CloseFavoriteVB() { //fermer
    setFavoriteVB(false);
  }

  // infos - mettre Photo Profil
  const [infosMettrePhotoProfilVB, setInfosMettrePhotoProfilVB] = useState(false);
  async function InfosMettrePhotoProfilVB() {
    setInfosMettrePhotoProfilVB(true);
  }
  async function CloseInfosMettrePhotoProfilVB() {
    setInfosMettrePhotoProfilVB(false);
  }

  // photo de profil ajoutée (message de success) - VB
  const [photoProfileSuccessVB, setPhotoProfileSuccessVB] = useState(false);
  async function ClosePhotoProfileSuccessVB() {
    setPhotoProfileSuccessVB(false);
  }


    // infos666favoriteVB (on passe une petite infos)
    const [infos666favoriteVB, setInfos666favoriteVB] = useState(false);
    async function Infos666favoriteVB() {
      setInfos666favoriteVB(true);
    }
    async function CloseInfos666favoriteVB() { //fermer
      setInfos666favoriteVB(false);
    }
  
  
    // popupToRightVB (mini menu) - VB
    const [popupToRightVB, setPopupToRightVB] = useState(false);
    async function PopupToRightVB() {
      setPopupToRightVB(true);
    }
    async function ClosePopupToRightVB() { //fermer
      setPopupToRightVB(false);
    }


    // photoProfile666favoriteVB (Au niveau des Favoris, on selectionne une photo a mettre sur le profil) - VB */}
    const [photoProfile666favoriteVB, setPhotoProfile666favoriteVB] = useState(false);
    async function PhotoProfile666favoriteVB() {
      setPhotoProfile666favoriteVB(true);
    }
    async function ClosePhotoProfile666favoriteVB() { //fermer
      setPhotoProfile666favoriteVB(false);
    }
  
  
    // voir photo + nom de la personne connecté - VB
    const [seePhotoWithNamePersonConnectedVB, setSeePhotoWithNamePersonConnectedVB] = useState(false);
    async function SeePhotoWithNamePersonConnectedVB() { //fermer
      setSeePhotoWithNamePersonConnectedVB(true);
    }
    async function CloseSeePhotoWithNamePersonConnectedVB() { //fermer
      setSeePhotoWithNamePersonConnectedVB(false);
    }


    // voir la photo - VB
    // on affiche une photo
    const [seePhotoVB, setSeePhotoVB] = useState(false);
    async function SeePhotoVB() {
      setSeePhotoVB(true);
    }
    async function CloseSeePhotoVB() { //fermer
      setSeePhotoVB(false);
    }

    const urlPhotoVB = localStorage.getItem("urlPhotoVB");
    //const urlVideoVB = localStorage.getItem("urlVideoVB");



    // seePhoto 666favoriteVB (on affiche la photo )
    const [seePhoto666favoriteVB, setSeePhoto666favoriteVB] = useState(false);
    async function CloseSeePhoto666favoriteVB() { //fermer
      setSeePhoto666favoriteVB(false);
    }
  
    // seeVideo 666favoriteVB (au niveau des favoris on affiche la video)
    const [seeVideo666favoriteVB, setSeeVideo666favoriteVB] = useState(false);
    async function CloseSeeVideo666favoriteVB() { //fermer
      setSeeVideo666favoriteVB(false);
    }


  // PageRedirection (666 ChildApiVideo666favoriteVB)
  async function PageRedirection666ChildApiVideo666favoriteVB() {
    //page - voir une photo
    const seePhoto = localStorage.getItem("GoToSeePhoto666favoriteVB");
    if (seePhoto === "1") { setSeePhoto666favoriteVB(true) }

    //page - voir une video
    const seeVideo = localStorage.getItem("GoToSeeVideo666favoriteVB");
    if (seeVideo === "1") { 
      setSeeVideo666favoriteVB(true) 
      //ca va permettre de marquer les minutes de la video au moment de la lecture
      setConfigurationVideo(false);
      setIsPlaying(true);
      setSon(false);
    }
  }


  // error - VB
  // on affiche cette page s'il y'a une erreur qui s'est produite 
  const [errorVB, setErrorVB] = useState(false);
  async function CloseErrorVB() {
    setErrorVB(false);
  }

  
  // page pour ajouter une photo aux favoris - VB
  const [addPhotoToFavoritePageVB, setAddPhotoToFavoritePageVB] = useState(false);
  async function AddPhotoToFavoritePageVB() {
    setAddPhotoToFavoritePageVB(true);
  }
  async function CloseAddPhotoToFavoritePageVB() { //fermer
    setAddPhotoToFavoritePageVB(false);
  }

  // message de success (photo aux favoris) - VB
  const [successAddPhotoToFavoriteVB, setSuccessAddPhotoToFavoriteVB] = useState(false);
  async function CloseSuccessAddPhotoToFavoriteVB() {
    setSuccessAddPhotoToFavoriteVB(false);
  }

  
  //logique pour ajouter une photo a vos favoris - VB
  const [filePhotoVB, setFilePhotoVB] = useState();

  async function AddPhotoToFavoriteVB() {
    console.log("a1");
    if (idPersonConnectedVB) {
      console.log("a2");

    const block = localStorage.getItem("blockVB");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
    setIsLoading(true);
    console.log("a3");

    // AllFavoriteReq
    async function AllFavoriteReq() {
      await axios
      .get(`${process.env.REACT_APP_FavoriteVB}/api/favoriteVB`)
      .then((res) => {
        console.log("a4");
        setApiFavoriteVB(res.data);
        const api = res.data;

    //creer un id pour chaque elements ajouté aux favoris - VB
    const numberFavoriteVB = api.filter((api) => api._id);
    const totalFavoriteVB = numberFavoriteVB.length;

    const createIdFavoriteVB = totalFavoriteVB + 1;
    if (createIdFavoriteVB) { localStorage.setItem("createIdFavoriteVB", createIdFavoriteVB) 
    console.log("a5");

    //1ere requete 
    //1ere requete
    // on envoie la photo sur cloudinary
    async function premiereReq() {
      const data = new FormData();
      data.append("image", filePhotoVB);

      await axios
      .post(`${process.env.REACT_APP_FavoriteVB}/api/accountVB/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("a6");
      const urlPhoto = res.data.urlPhoto;
      if (urlPhoto) { localStorage.setItem("urlPhotoVBreq", urlPhoto) }

      //2e requete
      //2e requete
      // on ajoute la photo au favoris
      async function deuxiemeReq() {
        const id = localStorage.getItem("createIdFavoriteVB");
        const urlPhoto = localStorage.getItem("urlPhotoVBreq");
        const urlVideo = "0";
        const display = "1";
        const hide = "0";
        const deleted = "0";
        const visible = "1";
        const approved = "1";
        const connection = "1";
        const type = "1";
      
        await axios({
        method: "post",
        url: `${process.env.REACT_APP_FavoriteVB}/api/favoriteVB/new`,
        data: {
          id,
          idOwner: idUserConnectedVB,
          urlPhoto,
          urlVideo,
          display,
          hide,
          deleted,
          visible,
          approved,
          connection,
          type,
        },
      })
      .then((res) => {
        console.log("a7");

        //3e requete
        //3e requete
        // on obtiens de nouvelles donnees
        async function troisiemeReq() {
          await axios
          .get(`${process.env.REACT_APP_FavoriteVB}/api/favoriteVB`)
          .then((res) => {
            console.log("a8");
            setApiFavoriteVB(res.data);
            setIsLoading(false);
            setSuccessAddPhotoToFavoriteVB(true);
          })
          }
          troisiemeReq();
          //3e requete
          })
          .catch((err) => {
            console.log("a9");
            setIsLoading(false);
            setSuccessAddPhotoToFavoriteVB(true);
          });
          }
          deuxiemeReq();
          //2e requete
        })
        .catch((err) => {
          console.log("a10");
          setIsLoading(false);
          setErrorVB(true);
        });
      }
      premiereReq();
      //1ere requete
      } 
      //if (createIdFavoriteVB)
      })
      .catch((err) => {
        console.log("a11");
        setErreur(true);
        setIsLoading(false);
      })
      }
      AllFavoriteReq();
      // AllFavoriteReq
      }
      // if (block === "0")
    }
    // if(idPersonConnectedVB)
  }


  // page pour ajouter la photo de couverture de la vidéo - VB 
  const [addCoverVideoPageVB, setAddCoverVideoPageVB] = useState(false);
  async function AddCoverVideoPageVB() {
    setAddCoverVideoPageVB(true);
    localStorage.removeItem("writeDescriptionVB");
  }
  async function CloseAddCoverVideoPageVB() { //fermer
    setAddCoverVideoPageVB(false);
  }

  // logique pour ajouter la photo de couverture de la vidéo aux favoris - VB
  const [isLoadingCoverVideo666favoriteVB, setIsLoadingCoverVideo666favoriteVB] = useState(false);

  async function AddCoverVideoVB() {
    console.log("a1");
    if (idPersonConnectedVB) {
      console.log("a2");

    const block = localStorage.getItem("blockVB");
    if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoadingCoverVideo666favoriteVB(true);
      console.log("a3");

    // AllFavoriteReq
    async function AllFavoriteReq() {
      await axios
      .get(`${process.env.REACT_APP_FavoriteVB}/api/favoriteVB`)
      .then((res) => {
        console.log("a4");
        setApiFavoriteVB(res.data);
        const api = res.data;

    //creer un id pour chaque elements ajouté aux favoris - VB
    const numberFavoriteVB = api.filter((api) => api._id);
    const totalFavoriteVB = numberFavoriteVB.length;

    const createIdFavoriteVB = totalFavoriteVB + 1;
    if (createIdFavoriteVB) { localStorage.setItem("createIdFavoriteVB", createIdFavoriteVB)
    console.log("a5");

    //1ere requete
    //1ere requete
    // on envoie l'image sur cloudinary
    async function premiereReq() {
      const data = new FormData();
      data.append("image", filePhotoVB);

      await axios
      .post(`${process.env.REACT_APP_BACKEND}/api/accountVB/sendPhoto`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("a6");
        const photo = res.data.urlPhoto;
        if (photo) { localStorage.setItem("urlPhotoVBreq", photo); }

      //2e requete
      //2e requete
      // on enregistre l'image dans les favoris
      async function deuxiemeReq() {
        const id = localStorage.getItem("createIdFavoriteVB");
        const urlPhoto = localStorage.getItem("urlPhotoVBreq");
        const urlVideo = "0"; 
        const hide = "0";
        const deleted = "0";
        const display = "1";
        const approved = "1";
        const visible = "1";
        const type = "1";

        await axios({
        method: "post",
        url: `${process.env.REACT_APP_PostPhotoVB}/api/favoriteVB/new`,
        data: {
          id,
          idOwner: idUserConnectedVB,
          urlPhoto,
          urlVideo,
          hide,
          deleted,
          display,
          approved,
          visible,
          type,
        },
      })
      .then((res) => {
        console.log("a7");
        const id = res.data._id; //photo ajoutée! (on enregistre l'id du favoris, cela va nous permettre de lier une video a la photo de couverture qui a ete ajouté aux favoris)
        if (id) { localStorage.setItem("idFavoriteVBreq", id) } 

        const cover = res.data.urlPhoto; //on enregistre la photo de couverture (cela va nous permettre de l'utiliser si on veut publier la video)
        if (cover) { localStorage.setItem("urlPhotoVBreq", cover) } 

      //3e requete
      //3e requete
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/favoriteVB`)
        .then((res) => {
          console.log("a8");
          setApiFavoriteVB(res.data);
          // photo de couverture ajouté aux favoris! (on affiche la page qui va lui permettre de selectionner la video à lier)
          setIsLoadingCoverVideo666favoriteVB(false);
          setAddCoverVideoPageVB(false);
          setAddVideoPageVB(true);
        })
        }
        troisiemeReq();
        //3e requete
        })
        .catch((err) => {
          console.log("a9");
          setIsLoadingCoverVideo666favoriteVB(false);
          setErreur(true);
        });
        }
        deuxiemeReq();
        //2e requete
        })
        .catch((err) => {
          console.log("a10");
          setIsLoadingCoverVideo666favoriteVB(false);
          setErreur(true);
        });
      }
      premiereReq();
      //1ere requete
    } 
    //if (createIdFavoriteVB)
    })
    .catch((err) => {
      console.log("a11");
      setErreur(true);
      setIsLoadingCoverVideo666favoriteVB(false);
    })
    }
    AllFavoriteReq();
    // AllFavoriteReq 
    }// if (block === "0")
    }// if(idPersonConnectedVB)
  }



  // page pour choisir la video a ajouter aux favoris
  const [addVideoPageVB, setAddVideoPageVB] = useState(false);
  async function CloseAddVideoPageVB() { 
    setAddVideoPageVB(false);
  }
  // page pour choisir la video a ajouter a une photo - VB
  const [addVideoToPhotoPageVB, setAddVideoToPhotoPageVB] = useState(false);
  async function AddVideoToPhotoPageVB() { 
    setAddVideoToPhotoPageVB(true);
  }
  async function CloseAddVideoToPhotoPageVB() { // fermer
    setAddVideoToPhotoPageVB(false);
  }


  //logique pour ajouter une video aux favoris
  const [fileVideoVB, setFileVideoVB] = useState();
  const [isLoadingVideo666favoriteVB, setIsLoadingVideo666favoriteVB] = useState(false);

  async function AddVideoVB() {
    console.log("a1");
    if (idPersonConnectedVB) {
      console.log("a2");
      setIsLoadingVideo666favoriteVB(true);
    
      //1ere requete
      //1ere requete
      //on envoie la video sur cloudinary
      async function premiereReq() {
        const data = new FormData();
        data.append("video", fileVideoVB);

        await axios
        .post(`${process.env.REACT_APP_BACKEND}/api/accountVB/sendVideo`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("a3");
          const urlVideo = res.data.secure_url; //url de la Video
          if (urlVideo) { localStorage.setItem("urlVideoVBreq", urlVideo); }

          //2e requete
          //2e requete
          // on lie la video a la photo de couverture (on le fait, en ajoutant tout simplement l'url de la video a la photo de couverture)
          async function deuxiemeReq() {
            //on recupere l'id du favoris (lié a la photo de couverture qu'on avait ajouté)
            const id = localStorage.getItem("idFavoriteVBreq");
            const urlVideo = localStorage.getItem("urlVideoVBreq");

            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoVB}/api/favoriteVB/update/${id}`,
              data: {
                urlVideo,
              },
            })
            .then((res) => {
              console.log("a4");
              // vidéo lié à la photo de couverture (on affiche la page qui va lui permettre d'écrire la description de la video et de publier la video)
              setPostVideoPageVB(true);
              setIsLoadingVideo666favoriteVB(false);
            })
            .catch((err) => {
              console.log("a5");
              setIsLoadingVideo666favoriteVB(false);
              setErrorVB(true);
            })
            }
            deuxiemeReq();
            //2e requete
          })
          .catch((err) => {
            console.log("a6");
            setIsLoadingVideo666favoriteVB(false);
            setErrorVB(true);
          })
        }
        premiereReq();
        //1ere requete
      } //if (idPersonConnectedVB)
  }


  // page pour publier la video - VB 
  const [postVideoPageVB, setPostVideoPageVB] = useState(false);
  async function PostVideoPageVB() { 
    setPostVideoPageVB(true);
  }
  async function ClosePostVideoPageVB() { //fermer
    setPostVideoPageVB(false);
  }

  // post publié (message de success) - VB
  const [postSuccessVB, setPostSuccessVB] = useState(false);
  async function ClosePostSuccessVB() {
    setPostSuccessVB(false);
  }

  
  // logique pour publier une video sur Veil Brillant
  const [isLoading666postVideoPageVB, setIsLoading666postVideoPageVB] = useState(false);
  const [descriptionVB, setDescriptionVB] = useState(""); //saisir la description de la publication
  if (descriptionVB) { localStorage.setItem("writeDescriptionVB", descriptionVB); }

  async function PostVideoVB() {
    console.log("a1");
    if (idPersonConnectedVB) {
      setIsLoading666postVideoPageVB(true);
      console.log("a2");

      // AllPostReq
      async function AllPostReq() { //on a refait la requete car il y'avait des posts ou le createIdPostVB ratait
        await axios
        .get(`${process.env.REACT_APP_FavoriteVB}/api/postVB`)
        .then((res) => {
          console.log("a3");
		      const api = res.data;

      //creer un id pour chaque post publié - VB
      const numberPost = api.filter((api) => api._id); 
      const totalPostVB = numberPost.length;

      const createIdPostVB = totalPostVB + 1;
      if (createIdPostVB) { localStorage.setItem("createIdPostVB", createIdPostVB)
      console.log("a4");
    
    //1ere requete
    //1ere requete
    // on publie la video sur Veil Brillant
    async function premiereReq() {
      const id = localStorage.getItem("createIdPostVB");
      const reaction = "0";
      const comment = "0";
      const share = "0";
      const view = "0";
      const clic = "0";
      const clicMyAccount = "0";
      const urlVideo = localStorage.getItem("urlVideoVBreq");
      const coverVideo = localStorage.getItem("urlPhotoVBreq");
      const description = localStorage.getItem("writeDescriptionVB");
      const buttonActivated = "0";
      const monetization = "1";
      const monetizationBalance = "0";
      const filter = localStorage.getItem("countryPersonConnectedVB");
      const display = "1";
      const displayOther = localStorage.getItem("displayOtherVB");
      const home = localStorage.getItem("homeVB");
      const homeVideo = localStorage.getItem("homeVideoVB");
      const visible = "1";
      const hide = "0";
      const deleted = "0";
      const best = "0";
      const approved = "1";
      const connection = "1"; 
      const type = "30";

      await axios({
      method: "post",
      url: `${process.env.REACT_APP_PostPhotoVB}/api/postVB/new`,
      data: {
        id,
        idOwner: idPersonConnectedVB,
        idUserOwner: idUserConnectedVB,
        nameOwner: namePersonConnectedVB,
        photoOwner: photoPersonConnectedVB,
        badgeOwner: badgePersonConnectedVB,
        reaction,
        comment,
        share,
        view,
        clic,
        clicMyAccount,
        description,
        buttonActivated,
        monetization,
        monetizationBalance,
        connection,
        filter,
        approved,
        home,
        homeVideo,
        display,
        hide,
        deleted,
        best,
        displayOther,
        visible,
        urlVideo,
        coverVideo,
        type,
      },
    })
    .then((res) => {
      //on prend l'id du nouveau Post, on va l'ajouter au niveau du compte comme etant le dernier post
      const idNewPost = res.data._id;
      if (idNewPost) { localStorage.setItem("idNewPost", idNewPost); }
      console.log("a5");

      //2e requete
      //2e requete
      // obtenir de nouvelles donnees
      async function deuxiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostPhotoVB}/api/postVB`)
        .then((res) => {
          console.log("a6");
        setAddVideoPageVB(false);
        setAddCoverVideoPageVB(false);
        setPostVideoPageVB(false);
        setIsLoading666postVideoPageVB(false);

        //ici on affiche le message de succes
        setPostSuccessVB(true);
        //ici on le fait disparaitre
        async function ClosePostSuccess() {
          setPostSuccessVB(false);
        }
        setTimeout(ClosePostSuccess, 1400);

      //3e requete
      //3e requete
      // on prend l'id du dernier post (pour retirer le dernier post du fil d'actualité)
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_PostPhotoVB}/api/accountVB`)
        .then((res) => {
          console.log("a7");
        const api = res.data;
        const filtreApiUser = api.filter((api) => api._id === idPersonConnectedVB);
        
        const lastPost = filtreApiUser.map((api) => api.lastPost); //id du dernier post
        if (lastPost) { localStorage.setItem("lastPost", lastPost); }

        const post = api.filter((api) => api._id === idPersonConnectedVB && api.lastPost === "0"); //on vérifie si sur le fil d'actualité 1 post a déjà été publié
        const verifyLastPost = post.length > 0;

        if (verifyLastPost) {
          //dans ce cas: dernier post non present sur le fil d'actualité
          console.log("a8");

          //4e requete
          //4e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function quatriemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoVB}/api/accountVB/update/${idPersonConnectedVB}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {
              console.log("a9");

          //5e requete
          //5e requete
          // obtenir de nouvelles donnees
          async function cinquiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_PostPhotoVB}/api/postVB`)
            .then((res) => {
              console.log("a10");

          //6e requete
          //6e requete
          // on obtiens la localisation de l'utilisateur
          async function sixiemeReq() {
            await axios
            .get("https://ip.nf/me.json")
            .then((res) => {
              console.log("a11");
              const getcountryip = res.data.ip.country; //country
              if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

              const getcityip = res.data.ip.city; //city
              if (getcityip) { localStorage.setItem("cityIp", getcityip) }

              const getuserip = res.data.ip.ip; //ip
              if (getuserip) { localStorage.setItem("addressIp", getuserip) }

          //7e requete
          //7e requete
          // on enregistre la localisation et la navigation de l'utilisateur
          async function septiemeReq() {
            const id = localStorage.getItem("createIdNavigationVB");
            const addressIp = localStorage.getItem("addressIp");
            const countryIp = localStorage.getItem("countryIp");
            const cityIp = localStorage.getItem("cityIp");
            const page = "Video publiée! (il a réussi à publier une video) - VB";
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_PostPhotoVB}/api/navigationVB/new`,
              data: {
                id,
                idAccount: idPersonConnectedVB,
                nameAccount: namePersonConnectedVB,
                addressIp,
                countryIp,
                cityIp,
                page,
              },
            })
            .then((res) => {
              console.log("a12");
            const online = res.data.createdAt; //on recupere la date de derniere connexion
            if (online) { localStorage.setItem("onlineVB", online) }

          //8e requete
          //8e requete
          // on enregistre la date de derniere connexion
          async function huitiemeReq() {
            const online = localStorage.getItem("onlineVB");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoVB}/api/accountVB/update/${idPersonConnectedVB}`,
              data: {
                online,
              },
            })
            .then((res) => {
              console.log("a13");
            })
            }
            huitiemeReq();
            //8e requete
            });
            }
            septiemeReq();
            //7e requete
            });
            }
            sixiemeReq();
            //6e requete
            })
            }
            cinquiemeReq();
            //5e requete
            })
          }
          quatriemeReq();
          //4e requete
        } else {
          //dans ce cas: dernier post present sur le fil d'actualité
          console.log("a14");

          //4e requete
          //4e requete
          // on retire le dernier post du fil d'actualité
          async function quatriemeReq() {
            const id = localStorage.getItem("lastPost");
            const home = "0";
            const homeVideo = "0";
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoVB}/api/postVB/update/${id}`,
              data: {
                home,
                homeVideo,
              },
            })
            .then((res) => {
              console.log("a15");

          //5e requete
          //5e requete
          // on met que le nouveau post est devenu le dernier post publié (on le fait au niveau du compte)
          async function cinquiemeReq() {
            const idNewPost = localStorage.getItem("idNewPost");
            await axios({
              method: "put",
              url: `${process.env.REACT_APP_PostPhotoVB}/api/accountVB/update/${idPersonConnectedVB}`,
              data: {
                lastPost: idNewPost,
              },
            })
            .then((res) => {
              console.log("a16");

            //6e requete
            //6e requete
            // obtenir de nouvelles donnees
            async function sixiemeReq() {
              await axios
              .get(`${process.env.REACT_APP_PostPhotoVB}/api/postVB`)
              .then((res) => {
                console.log("a17");
              })
              }
              sixiemeReq();
              //6e requete
              })
              }
              cinquiemeReq();
              //5e requete
              })
              }
              quatriemeReq();
              //4e requete
            }
            //if (verifyLastPost) 
            })
          }
          troisiemeReq();
          //3e requete
      })
      .catch((err) => {
        console.log("a18");

        // ici nous sommes au niveau du .catch de la deuxiemeReq()
        //la 2e requete c'est pour obtenir de nouvelles donnees, si ca rate, alors on va encore insister, on va refaire la requete pour obtenir de nouvelles donnees, ensuite on va l'afficher le message que la video avait deja ete publié
        // get
        async function get() {
          await axios
          .get(`${process.env.REACT_APP_PostPhotoVB}/api/postVB`)
          .then((res) => {
            console.log("a19");

          setAddVideoPageVB(false);
          setAddCoverVideoPageVB(false);
          setIsLoading666postVideoPageVB(false);
          //ici on affiche le message de succes
          setPostSuccessVB(true);
          //ici on le fait disparaitre
          async function Close() {
            setPostSuccessVB(false);
          }
          setTimeout(Close, 1400);
        })
        .catch((err) => {
          console.log("a20");
          //si on arrive pas a obtenir tout les posts, alors on lui affiche juste le message que sa video avait deja ete publié
          setAddVideoPageVB(false);
          setAddCoverVideoPageVB(false);
          setIsLoading666postVideoPageVB(false);

          //ici on affiche le message de succes
          setPostSuccessVB(true);
          //ici on le fait disparaitre
          async function Close() {
            setPostSuccessVB(false);
          }
          setTimeout(Close, 1400);
        })
        }
        get();
        //get
      });
      }
      deuxiemeReq();
      //2e requete
      })
      .catch((err) => {
        console.log("a21");
        setErrorVB(true);
        setIsLoading666postVideoPageVB(false);
      });
      }
      premiereReq();
      //1ere requete
    } //if (createIdPostVB)
  })
  .catch((err) => {
    console.log("a22");
    setErreur(true);
    setIsLoading666postVideoPageVB(false);
  })
  }
  AllPostReq();
  // AllPostReq 
  }// if(idPersonConnectedVB)
}


  // Actualiser infos Video - VB
  /* actualiser infos prend l'ancienne photo de profil, l'ancien nom et remplace par la
   nouvelle photo de profil, le nouveau nom.
   par exemple lorsque la personne a publier sa video sur VB, et qu'il change sa photo de 
   profil, par defaut la photo ne change pas au niveau du post, donc s'il veut que la photo
   puisse aussi changer au niveau du post, il doit venir au niveau de la video puis cliquer sur
   Actualiser infos */
   async function UpdateInfosVideoVB() {
    setOpacity(true);

    //1ere requete
    //dans cette 1ere requete, on fait un appel a l'api pour obtenir les nouvelles donnees
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/user`)
      .then((res) => {
        console.log("nouvelles donnees obtenues, on peut filtrer.");
        const api = res.data;
        // obtenir les infos de la personne connecter
        // on filtre en fonction de l'idPersonConnectedVB
        const idPersonConnectedVB = localStorage.getItem(
          "https://alrani.com/idPersonneConnecterVB"
        );
        const filterUser = api.filter((api) => api._id === idPersonConnectedVB);
        // photo
        const photo = filterUser.map((api) => api.photoProfil);
        if (photo) {
          localStorage.setItem(
            "https://alrani.com/photoPersonConnected",
            photo
          );
        }

        // name
        const name = filterUser.map((api) => api.nomAuteur);
        if (name) {
          localStorage.setItem("https://alrani.com/namePersonConnected", name);
        }

        // badge
        /*
        const badge = filterUser.map((api) => api.badge);
        if (badge) {
          localStorage.setItem("https://alrani.com/badgePersonConnected", badge);
        }*/
        //2e requete
        //2e requete
        //dans cette 2e requete on actualise les infos au niveau de la video
        async function deuxiemeReq() {
          const nameOwner = localStorage.getItem(
            "https://alrani.com/namePersonConnected"
          );
          const photoOwner = localStorage.getItem(
            "https://alrani.com/photoPersonConnected"
          );
          const idVideo = localStorage.getItem("https://alrani.com/idVideo");

          //
          const number = "30";
          const idAuteur = localStorage.getItem(
            "https://alrani.com/idPersonneConnecterVB"
          );

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/postAA/update/${idVideo}`,
            data: {
              nameOwnerVideo: nameOwner,
              photoOwnerVideo: photoOwner,
              nbreVentes: number,
              idOwnerVideo: idAuteur,
              //badgeOwnerVideo: badgeOwner,
            },
          })
            .then((res) => {
              console.log("les infos du proprietaire de la video ont ete actualiser");
              setOpacity(false);
              //3e requete
              //3e requete
              //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
              /*
              async function troisiemeReq() {
                await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/user`)
                  .then((res) => {
                    const api = res.data;
                    // filtre pour obtenir uniquement les infos de la personne connecter
                    const filtreApiUser = api.filter(
                      (api) => api._id === idPersonConnectedIA
                    );
                    const photoProfilIA = filtreApiUser.map(
                      (api) => api.photoProfil
                    );
                    localStorage.setItem(
                      "https://alrani.com/photoProfilPersonneConnecterIA",
                      photoProfilIA
                    );

                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    //setErreurVB(true);
                  });
              }
              troisiemeReq();
              */
              //3e requete
            })
            .catch((err) => {
              setOpacity(false);
              //setErreurVB(true);
              console.log(
                "les infos du proprietaire de la video n'ont pas ete actualiser"
              );
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        console.log("nouvelles donnees non obtenues, impossible de filtrer.");
        //setErreurVB(true);
      });
    //1ere requete
  }
 

  //vidéo visible au public - VB
  const [videoVisible, setVideoVisible] = useState(false);
  async function VideoVisible() {
    setVideoVisible(true);
  }
  async function CloseVideoVisible() { //fermer
    setVideoVisible(false);
    setMiniMenu(true);
  }

  //vidéo non visible au public - VB
  const [videoNonVisible, setVideoNonVisible] = useState(false);
  async function VideoNonVisible() {
    setVideoNonVisible(true);
  }
  async function CloseVideoNonVisible() { //fermer
    setVideoNonVisible(false);
    setMiniMenu(true);
  }

  // mini menu (ici cest pour choisir parmi les options du miniMenu) - VB
  const [miniMenu, setMiniMenu] = useState(false);
  async function CloseMiniMenu() {
    setMiniMenu(false);
  }

  // titre (ici cest pour mettre le titre de la video) - VB
  const [titre, setTitre] = useState(false);
  async function Titre() {
    setTitre(true);
  }
  async function CloseTitre() { //fermer
    setTitre(false);
    setMiniMenu(true);
  }

  //saisir
  const [titleVideoVB, setTitleVideoVB] = useState("");
  if (titleVideoVB) { localStorage.setItem("writeTitle", titleVideoVB) } //titre de la video
  
  const [durationVideoVB, setDurationVideoVB] = useState("");
  if (durationVideoVB) { localStorage.setItem("writeDuration", durationVideoVB) } //duree 

  //logique pour ajouter/modifier le titre de la video ainsi que la duree de la video
  async function SaveTitleVideoVB() {
        
      //1ere requete
      //1ere requete
      // on met a jour le nouveau titre et la nouvelle duree
      async function premiereReq() {
        const id = localStorage.getItem("idInfosValidate");
        const title = localStorage.setItem("writeTitle") //titre de la video
        const duration = localStorage.setItem("writeDuration") //duree 
        const infosValidate = "0";
        
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_BACKEND}/api/infosValidateVB/update/${id}`,
          data: {
            title,
            duration,
            infosValidate,
          },
        })
        .then((res) => {
          setOpacity(false);
          console.log("le titre et la duree de la video ont ete modifier");
        })
        .catch((err) => {
          setOpacity(false);
          setErreurVB(false);
        });
      }
      premiereReq();
      //1ere requete
  }

  //ici cest pour mettre la Photo de couverture de la video - VB
  async function Photo() {
  }
  async function ClosePhoto() {  //fermer
    setMiniMenu(true);
  }


  //menu - VB
  //on affiche le card qui contient le menu
  const [menuVB, setMenuVB] = useState(false);
  async function CloseMenuVB() {
    setMenuVB(false);
  }

  // Tools - VB
  // on affiche mes outils
  const [toolsVB, setToolsVB] = useState(false);
  async function ToolsVB() {
    setToolsVB(true);
  }
  //fermer
  async function CloseToolsVB() {
    setToolsVB(false);
  }

  // Plus - VB
  // sur cette page on affiche les outils a activer
  const [plusVB, setPlusVB] = useState(false);
  async function PlusVB() {
    setPlusVB(true);
  }
  //fermer
  async function ClosePlusVB() {
    setPlusVB(false);
  }

  // activate Monetization Page - VB
  // sur cette page active la monetisation
  const [activateMonetizationPageVB, setActivateMonetizationPageVB] = useState(false);
  async function ActivateMonetizationPageVB() {
    setActivateMonetizationPageVB(true);
  }
  //fermer
  async function CloseActivateMonetizationPageVB() {
    setActivateMonetizationPageVB(false);
  }

  // activate Monetization Deals (Page) - VB
  // sur cette page on active la Monetization Deals - VB
  const [activateMonetizationDealsPageVB, setActivateMonetizationDealsPageVB] = useState(false);
  async function ActivateMonetizationDealsPageVB() {
    setActivateMonetizationDealsPageVB(true);
  }
  //fermer
  async function CloseActivateMonetizationDealsPageVB() {
    setActivateMonetizationDealsPageVB(false);
  }

  // activate Monetization Formation (Page) - VB
  // sur cette page on active la Monetization Formation - VB
  const [activateMonetizationFormationPageVB, setActivateMonetizationFormationPageVB] = useState(false);
  async function ActivateMonetizationFormationPageVB() {
    setActivateMonetizationFormationPageVB(true);
  }
  //fermer
  async function CloseActivateMonetizationFormationPageVB() {
    setActivateMonetizationFormationPageVB(false);
  }

  // Monetization - VB
  // sur cette page on affiche le solde, la base de donnees,...
  const [monetizationVB, setMonetizationVB] = useState(false);
  async function MonetizationVB() {
    setMonetizationVB(true);
  }
  //fermer
  async function CloseMonetizationVB() {
    setMonetizationVB(false);
  }

  // Monetization Deals - VB
  // sur cette page on affiche le solde, la base de donnees,...
  const [monetizationDealsVB, setMonetizationDealsVB] = useState(false);
  async function MonetizationDealsVB() {
    setMonetizationDealsVB(true);
  }
  //fermer
  async function CloseMonetizationDealsVB() {
    setMonetizationDealsVB(false);
  }

  // Monetization Formation - VB
  // sur cette page on affiche le solde, la base de donnees,...
  const [monetizationFormationVB, setMonetizationFormationVB] = useState(false);
  async function MonetizationFormationVB() {
    setMonetizationFormationVB(true);
  }
  //fermer
  async function CloseMonetizationFormationVB() {
    setMonetizationFormationVB(false);
  }


  //menu Modifications - VB
  //menu Modifications - VB
  //on affiche le card qui contient le menu des modifications
  const [menuModificationsVB, setMenuModificationsVB] = useState(false);
  async function MenuModificationsVB() {
    setMenuModificationsVB(true);
  }
  //fermer
  async function CloseMenuModificationsVB() {
    setMenuModificationsVB(false);
  }

  //modifier photo de profil - VB
  //modifier photo de profil - VB
  //on affiche le card qui permet a la personne de mettre ou de remplacer sa photo de profil
  const [mettrePhotoProfilPageVB, setMettrePhotoProfilPageVB] = useState(false);
  async function MettrePhotoProfilPageVB() {
    setMenuModificationsVB(false);
    setMettrePhotoProfilPageVB(true);
  }
  //fermer
  async function CloseMettrePhotoProfilPageVB() {
    setMettrePhotoProfilPageVB(false);
    setMenuModificationsVB(true);
  }

  
  // seePhotoVBreq (lors des requetes, page pour afficher la photo sur laquelle on a cliquer)
  const [seePhotoVBreq, setSeePhotoVBreq] = useState(false);
  async function SeePhotoVBreq() {
    setSeePhotoVBreq(true);
  }
  async function CloseSeePhotoVBreq() {
    setSeePhotoVBreq(false);
  }
  // on affiche la photo qu'on veut publier
  const urlPhotoVBreq = localStorage.getItem("urlPhotoVBreq");


  //enregistrer photo de profil - VB
  //logique pour mettre la photo sur le profil - VB
  const [filePhotoProfilVB, setFilePhotoProfilVB] = useState();
  const [fileVB, setFileVB] = useState();
  const [isLoadingPhotoProfileVB, setIsLoadingPhotoProfileVB] = useState(false);

  async function SavePhotoProfileVB() {
    setOpacity(true);
    //1ere requete
    /* cette 1ere requete c'est pour envoyer la photo sur cloudinary, ensuite cloudinary nous
  renvoie l'url de la photo */
    const data = new FormData();
    data.append("image", filePhotoProfilVB);

    await axios
      .post(
        `${process.env.REACT_APP_BACKEND}/api/accountVB/sendPhoto`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        const url = res.data.urlPhoto;
        if (url) { localStorage.setItem("urlPhoto", url); }

        //2e requete
        //2e requete
        //cette 2e requete c'est pour envoyer l'url de la photo dans la bdd
        async function deuxiemeReq() {
          const urlPhoto = localStorage.getItem("urlPhoto");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountVB/update/${idPersonConnectedVB}`,
            data: {
              photoProfile: urlPhoto,
            },
          })
            .then((res) => {
              console.log("l'url de la photo a ete enregistrer dans la bdd");
              //3e requete
              //3e requete
              //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
              async function troisiemeReq() {
                await axios
                  .get(`${process.env.REACT_APP_BACKEND}/api/accountVB`)
                  .then((res) => {
                    console.log("nouvelles donnees obtenues");
                    const api = res.data;
                    // filtre pour obtenir uniquement les infos de la personne connecter
                    const filtreApiUser = api.filter(
                      (api) => api._id === idPersonConnectedVB
                    );
                    const photo = filtreApiUser.map((api) => api.photoProfile);
                    if (photo) { localStorage.setItem("photoPersonConnectedVB", photo); }

                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                  });
              }
              troisiemeReq();
              //3e requete
            })
            .catch((err) => {
              setOpacity(false);
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
      });
    //1ere requete
  }
  //enregistrer photo de profil - VB


  // ce qui est en haut , je verifierai, si je peux retirer cette logique
  // logique pour mettre une photo sur son profil - VB
  async function PhotoProfileVB() { 
    if (idPersonConnectedVB) {

      const block = localStorage.getItem("blockVB");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoadingPhotoProfileVB(true);

      //1ere requete
      //1ere requete
      // on envoie la photo sur cloudinary
      async function premiereReq() {
        const data = new FormData();
        data.append("image", fileVB);
        await axios
        .post(`${process.env.REACT_APP_BACKEND}/api/accountVB/sendPhoto`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          const urlPhoto = res.data.urlPhoto;
          if (urlPhoto) { localStorage.setItem("urlPhotoVBreq", urlPhoto); }

      //2e requete
      //2e requete
      // on enregistre l'url de la photo dans la bdd
      async function deuxiemeReq() {
        const urlPhoto = localStorage.getItem("urlPhotoVBreq");
        await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountVB/update/${idPersonConnectedVB}`,
        data: {
          photoProfile: urlPhoto,
        },
        })
        .then((res) => {
              
      //3e requete
      //3e requete
      //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountVB`)
        .then((res) => {
          setApiAccountVB(res.data);
          setPhotoProfileSuccessVB(true);
          setChoosePhotoProfilePageVB(false);
          setIsLoadingPhotoProfileVB(false);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationVB");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Photo de profil remplacée! (il a réussi à mettre sa nouvelle photo de profil) - VB";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationVB/new`,
            data: {
              id,
              idAccount: idPersonConnectedVB,
              nameAccount: namePersonConnectedVB,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineVB", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineVB");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountVB/update/${idPersonConnectedVB}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileVB(false);
          setErrorVB(true);
        });
        }
        troisiemeReq();
        //3e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileVB(false);
          setErrorVB(true);
        });
        }
        deuxiemeReq();
        //2e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileVB(false);
          setErrorVB(true);
        });
      }
      premiereReq();
      //1ere requete
      }// if (block === "0")
    }// if(idPersonConnectedVB)
  }


  //logique pour mettre une photo sur son profil en passant par les favoris - VB
  async function PhotoProfileVB666favoriteVB() {
    if (idPersonConnectedVB) {

      const block = localStorage.getItem("blockVB");
      if (block === "0") { //block on applique ça uniquement aux personnes indesirables qui veulent detruire notre business
      setIsLoadingPhotoProfileVB(true);

      //2e requete
      //2e requete
      // on enregistre l'url de la photo dans la bdd
      async function deuxiemeReq() {
        const urlPhoto = localStorage.getItem("urlPhotoVBreq");
        await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND}/api/accountVB/update/${idPersonConnectedVB}`,
        data: {
          photoProfile: urlPhoto,
        },
        })
        .then((res) => {
              
      //3e requete
      //3e requete
      //dans cette 3e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
      async function troisiemeReq() {
        await axios
        .get(`${process.env.REACT_APP_BACKEND}/api/accountVB`)
        .then((res) => {
          setApiAccountVB(res.data);
          setPhotoProfileSuccessVB(true);
          setPhotoProfile666favoriteVB(false);
          setIsLoadingPhotoProfileVB(false);

        //8e requete
        //8e requete
        // on obtiens la localisation de l'utilisateur
        async function huitiemeReq() {
          await axios
          .get("https://ip.nf/me.json")
          .then((res) => {
            const getcountryip = res.data.ip.country; //country
            if (getcountryip) { localStorage.setItem("countryIp", getcountryip) }

            const getcityip = res.data.ip.city; //city
            if (getcityip) { localStorage.setItem("cityIp", getcityip) }

            const getuserip = res.data.ip.ip; //ip
            if (getuserip) { localStorage.setItem("addressIp", getuserip) }

        //9e requete
        //9e requete
        // on enregistre la localisation et la navigation de l'utilisateur
        async function neuviemeReq() {
          const id = localStorage.getItem("createIdNavigationVB");
          const addressIp = localStorage.getItem("addressIp");
          const countryIp = localStorage.getItem("countryIp");
          const cityIp = localStorage.getItem("cityIp");
          const page = "Photo de profil remplacée! (666favoriteVB) (il a mis une photo sur son profil en passant par les favoris)";

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/navigationVB/new`,
            data: {
              id,
              idAccount: idPersonConnectedVB,
              nameAccount: namePersonConnectedVB,
              addressIp,
              countryIp,
              cityIp,
              page,
            },
          })
          .then((res) => {
          const online = res.data.createdAt; //on recupere la date de derniere connexion
          if (online) { localStorage.setItem("onlineVB", online) }

        //10e requete
        //10e requete
        // on enregistre la date de derniere connexion
        async function dixiemeReq() {
          const online = localStorage.getItem("onlineVB");
          await axios({
            method: "put",
            url: `${process.env.REACT_APP_BACKEND}/api/accountVB/update/${idPersonConnectedVB}`,
            data: {
              online,
            },
          });
          }
          dixiemeReq();
          //10e requete
          });
          }
          neuviemeReq();
          //9e requete
          });
          }
          huitiemeReq();
          //8e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileVB(false);
          setErrorVB(true);
        });
        }
        troisiemeReq();
        //3e requete
        })
        .catch((err) => {
          setIsLoadingPhotoProfileVB(false);
          setErrorVB(true);
        });
      }
      deuxiemeReq();
      //2e requete
      }// if (block === "0")
    }// if(idPersonConnectedVB)
  }


  //modifier nom - VB
  //modifier nom - VB
  //on affiche le card qui permet a la personne connecter de modifier son propre nom
  const [modifierNomPageVB, setModifierNomPageVB] = useState(false);
  async function ModifierNomPageVB() {
    setMenuModificationsVB(false);
    setModifierNomPageVB(true);
  }
  //fermer
  async function CloseModifierNomPageVB() {
    setModifierNomPageVB(false);
    setMenuModificationsVB(true);
  }

  // enregistrer le nom modifié - VB
  // logique pour enregistrer le nom dans la bdd - VB
  const [changeNameVB, setChangeNameVB] = useState("");
  async function SaveNameVB() {
    setOpacity(true);
    //1ere requete
    //1ere requete
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND}/api/userAA/update/${idPersonConnectedVB}`,
      data: {
        nomAuteur: changeNameVB,
      },
    })
      .then((res) => {
        console.log("le nom modifié a été enregistré");
        //2e requete
        //2e requete
        //dans cette 2e requete, on fait un appel a l'api pour obtenir les nouvelles donnees
        async function deuxiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/user`)
            .then((res) => {
              console.log("nouvelles donnees obtenues");
              const api = res.data;
              // filtre pour obtenir uniquement les infos de la personne connecter
              const filtreApiUser = api.filter(
                (api) => api._id === idPersonConnectedVB
              );
              const name = filtreApiUser.map((api) => api.nomAuteur);
              if (name) {
                localStorage.setItem(
                  "https://alrani.com/nomPersonneConnecterVB",
                  name
                );
              }

              setOpacity(false);
            })
            .catch((err) => {
              setOpacity(false);
              console.log("nouvelles donnees non obtenues");
            });
        }
        deuxiemeReq();
        //2e requete
      })
      .catch((err) => {
        setOpacity(false);
        console.log("le nom modifié n'a pas été enregistré");
      });
    //1ere requete
  }
  // enregistrer le nom modifié - VB

  //modifier telephone - VB
  //modifier telephone - VB
  /*on affiche le card qui permet a la personne connecter de modifier son numero de 
telephone (le numero qui lui permet a se connecter a son compte Veil Brillant) */
  const [modifierTelephonePageVB, setModifierTelephonePageVB] = useState(false);
  async function ModifierTelephonePageVB() {
    setMenuModificationsVB(false);
    setModifierTelephonePageVB(true);
  }
  //fermer
  async function CloseModifierTelephonePageVB() {
    setModifierTelephonePageVB(false);
    setMenuModificationsVB(true);
  }

  //modifier description - VB
  //modifier description - VB
  //on affiche le card qui permet a la personne connecter d"entrer sa description
  const [modifierDescriptionPageVB, setModifierDescriptionPageVB] =
    useState(false);
  async function ModifierDescriptionPageVB() {
    setMenuModificationsVB(false);
    setModifierDescriptionPageVB(true);
  }
  //fermer
  async function CloseModifierDescriptionPageVB() {
    setModifierDescriptionPageVB(false);
    setMenuModificationsVB(true);
  }

  //business Page VB
  //business Page VB
  //on affiche la page VB Business
  const [businessPageVB, setBusinessPageVB] = useState(false);
  async function BusinessPageVB() {
    setBusinessPageVB(true);
  }
  //fermer
  async function CloseBusinessPageVB() {
    setBusinessPageVB(false);
  }

  //optionsBusinessPage - VBB
  //sur la page VBB, ici on affiche les differents options - VBB
  const [optionsBusinessPage, setOptionsBusinessPage] = useState(false);

  //optionsVideo - VBB
  //apres le clique sur Vidéo, on tombe ici, et ici on affiche les options - VBB
  const [optionsVideoVBB, setOptionsVideoVBB] = useState(false);
  async function OptionsVideoVBB() {
    setOptionsVideoVBB(true);
    setOptionsBusinessPage(true);
  }
  //fermer
  async function CloseOptionsVideoVBB() {
    setOptionsVideoVBB(false);
    setOptionsBusinessPage(false);
  }

  //publierVideoPage - VBB
  //ici la personne va pouvoir choisir la video et la publier - VBB
  const [publierVideoPageVBB, setPublierVideoPageVBB] = useState(false);
  async function PublierVideoPageVBB() {
    setPublierVideoPageVBB(true);
    setOptionsVideoVBB(false);
    setOptionsBusinessPage(true);
  }
  //fermer
  async function ClosePublierVideoPageVBB() {
    setPublierVideoPageVBB(false);
    setOptionsBusinessPage(false);
  }



  
  // Wei-D App
  // Wei-D App
  // Wei-D App
  // Wei-D App
  // Wei-D App
  // Wei-D App
  //ca c'est l'application Wei-D
  //cette logique affiche la page d'accueil de l'application Wei-D
  const [weidApp, setWeidApp] = useState(false);
  async function WeidApp() {
    setWeidApp(true);
  }

  //ca se sont les onglets de l'application Wei-D
  //personnel onglet
  const [personnelOngletWA, setPersonnelOngletWA] = useState(true);
  async function PersonnelOngletWA() {
    setPersonnelOngletWA(true);
    setProfessionnelOngletWA(false);
  }
  //professionnel onglet
  const [professionnelOngletWA, setProfessionnelOngletWA] = useState(false);
  async function ProfessionnelOngletWA() {
    setProfessionnelOngletWA(true);
    setPersonnelOngletWA(false);
  }

  // Vixinol Store App
  // Vixinol Store App
  // Vixinol Store App
  // Vixinol Store App
  // quand on clique sur l'icone de l'App, l'ecran de demarrage s'affiche - VS
  const [ecranDemarrageVS, setEcranDemarrageVS] = useState(false);
  async function EcranDemarrageVS() {
    setEcranDemarrageVS(true);
    //ce code permet de maintenir l'ecran de demarrage ouvert pendant quelques secondes
    async function CloseEcranDemarrageVS() {
      const connecter = localStorage.getItem(
        "https://alrani.com/idPersonneConnecterVS"
      );
      if (connecter) {
        //si la personne est connecter, il est rediriger sur la page d'accueil
        setEcranDemarrageVS(false);
        setVixinolStoreApp(true);
      } else {
        //si la personne n'est pas connecter, il est rediriger sur la page de connexion
        setEcranDemarrageVS(false);
        setConnexionPageVS(true);
      }
    }
    setTimeout(CloseEcranDemarrageVS, 2000);
  }

  //ca c'est l'application vixinol Store
  //cette logique affiche la page d'accueil de l'application vixinol Store
  const [vixinolStoreApp, setVixinolStoreApp] = useState(false);
  async function VixinolStoreApp() {
    setVixinolStoreApp(false);
  }

  //Moyen de Paiement (page) - VS
  //Moyen de Paiement (page) - VS
  /*le card ci va permettre a la personne d'entrer le code pin pour lier un moyen de
  paiement lors de l'inscription sur vixinol store */
  const [moyenPaiementPageVS, setMoyenPaiementPageVS] = useState(false);
  async function CloseMoyenPaiementPageVS() {
    setMoyenPaiementPageVS(false);
  }

  // inscription (page) - VS
  // inscription (page) - VS
  /* on affiche la page qui va permettre a la personne de s'inscrire sur 
  vixinol store */
  const [inscriptionPageVS, setInscriptionPageVS] = useState(false);
  async function InscriptionPageVS() {
    setInscriptionPageVS(true);
    setConnexionPageVS(false);
  }
  //fermer
  async function CloseInscriptionPageVS() {
    setInscriptionPageVS(false);
  }

  // connexion (page) - VS
  // connexion (page) - VS
  /* on affiche la page qui va permettre a la personne de se connecter sur 
  vixinol store */
  const [connexionPageVS, setConnexionPageVS] = useState(false);
  async function ConnexionPageVS() {
    setConnexionPageVS(true);
    setInscriptionPageVS(false);
  }
  //fermer
  async function CloseConnexionPageVS() {
    setConnexionPageVS(false);
  }

  //message d'erreur - (codePinIncorrectVS)
  /* lors de l'inscription sur vixinol, si l'utilisateur a entrer un code pin incorrect 
  ou si le code pin est deja utiliser par un autre utilisateur au meme moment, alors 
  on va afficher ce message d'erreur */
  const [codePinIncorrectVS, setCodePinIncorrectVS] = useState(false);
  async function CloseCodePinIncorrectVS() {
    setCodePinIncorrectVS(false);
    setMoyenPaiementPageVS(true);
  }

  //Moyen de Paiement - VS
  //Moyen de Paiement - VS
  const [codePinVS, setCodePinVS] = useState("");
  //on enregistre le code pin qu'il a entrer dans le localStorage
  if (codePinVS) {
    localStorage.setItem("https://alrani.com/codePinVS", codePinVS);
  }
  const getCodePinVS = localStorage.getItem("https://alrani.com/codePinVS");
  /*lors de l'inscription sur vixinol, cette logique va permettre a l'utilisateur d'entrer 
  le code pin dans le but d'ajouter un moyen de paiement a son compte vixinol.
  pour ajouter le moyen de paiement on fait d'abord des verifications pour voir 
  si le code pin entrer est correct. si c'est correct, alors on prend l'id du compte de 
  son moyen de paiement puis on enregistre ca dans le localStorage. ensuite on inscrit 
  l'utilisateur en liant l'idMoyenPaiement a son compte vixinol */
  async function AjouterMoyenPaiementVS() {
    setOpacity(true);
    //en premier, le code qu'il a entrer, on verifie si ca existe dans la bdd
    await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/user`)
      .then((res) => {
        const api = res.data;
        //ici on cherche le code dans la bdd
        const codeTrouver = api.filter((api) => api.codePin === getCodePinVS);
        //
        /*on met un petit blocus pour dire que :
         si y'a 0 code trouver, alors tu vas rien enregistrer dans le localStorage. 
         si y'a 2 ou plusieurs code trouver, alors tu vas rien enregistrer dans le localStorage
         si y'a 1 seul code trouver, alors tu vas enregistrer dans le localStorage l'id 
         de la personne qui detient ce code */
        const secureCode = codeTrouver.length;
        if (secureCode === 1) {
          //ici on cherche l'id de son compte du moyen de paiement qui est lier au code trouver
          //Dans ce cas le moyen de paiement c'est izocash
          const idCompte = codeTrouver.map((x) => x._id);
          //id du Compte
          //ici on enregistre l'id du Compte dans le localStorage
          localStorage.setItem(
            "https://alrani.com/idCompteMoyenPaiementVS",
            idCompte
          );
          //nom du Compte
          //ici on enregistre le nom du Compte
          const nomCompte = codeTrouver.map((x) => x.nomValider);
          localStorage.setItem(
            "https://alrani.com/nomCompteMoyenPaiementVS",
            nomCompte
          );
          //nom du moyen de paiement
          //ici on enregistre le nom du Compte
          //si nomMoyenPaiement=1, cela veut dire que le moyen de paiement s'appelle izocash
          const nomMoyenPaiement = codeTrouver.map((x) => x.nomMoyenPaiement);
          if (nomMoyenPaiement) {
            localStorage.setItem(
              "https://alrani.com/nomMoyenPaiementVS",
              nomMoyenPaiement
            );
          }

          /*on recupere les infos stockées dans le localStorage 
          ensuite on inscrit la personne sur vixinol store */
          const nomAuteurSignupVS = localStorage.getItem(
            "https://alrani.com/nomAuteurSignupVS"
          );
          const telephoneSignupVS = localStorage.getItem(
            "https://alrani.com/telephoneSignupVS"
          );
          const passwordSignupVS = localStorage.getItem(
            "https://alrani.com/passwordSignupVS"
          );
          const idCompteMoyenPaiementVS = localStorage.getItem(
            "https://alrani.com/idCompteMoyenPaiementVS"
          );
          const nomCompteMoyenPaiementVS = localStorage.getItem(
            "https://alrani.com/nomCompteMoyenPaiementVS"
          );
          const nomMoyenPaiementVS = localStorage.getItem(
            "https://alrani.com/nomMoyenPaiementVS"
          );
          //2e requette
          //2e requette
          /* dans cette requette on va inscrire l'utilisateur sur vixinol 
          et lier le moyen de paiement a son compte vixinol */
          async function deuxiemeReq() {
            await axios({
              method: "post",
              url: `${process.env.REACT_APP_VIXINOL_API}/api/userAA/signup`,
              data: {
                nomAuteur: nomAuteurSignupVS,
                telephone: telephoneSignupVS,
                password: passwordSignupVS,
                idCompteMoyenPaiement: idCompteMoyenPaiementVS,
                nomCompteMoyenPaiement: nomCompteMoyenPaiementVS,
                nomMoyenPaiement: nomMoyenPaiementVS,
              },
            })
              .then((res) => {
                //on enregistre ca dans le localstorage pour maintenir l'utilisateur connecter - VS
                const idAuteur = res.data._id;
                if (idAuteur) {
                  localStorage.setItem(
                    "https://alrani.com/idPersonneConnecterVS",
                    idAuteur
                  );
                }

                const nomAuteur = res.data.nomAuteur;
                if (nomAuteur) {
                  localStorage.setItem(
                    "https://alrani.com/nomPersonneConnecterVS",
                    nomAuteur
                  );
                }
                setOpacity(false);
                setInscriptionSuccessVS(true);
              })
              .catch((err) => {
                setOpacity(false);
                setErreurVS(true);
              });
          }
          deuxiemeReq();
          //2e requette
        } else {
          setOpacity(false);
          setCodePinIncorrectVS(true);
        }
        //le if de secureCode se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setCodePinIncorrectVS(true);
      });
  }

  // signup - VS
  // signup - VS
  //ici l'utilisateur saisi: nom, numero virtuel, mot de passe
  const [nameSignupVS, setNameSignupVS] = useState("");
  const [numberSignupVS, setNumberSignupVS] = useState("");
  const [passwordSignupVS, setPasswordSignupVS] = useState("");

  if (nameSignupVS) { localStorage.setItem("writeName", nameSignupVS); } //nom
  if (numberSignupVS) { localStorage.setItem("writeVirtualNumber", numberSignupVS); } //numero virtuel
  if (passwordSignupVS) { localStorage.setItem("writePassword", passwordSignupVS); } //mot de passe

  //logique pour s'inscrire sur Vixinol Store - VS
  async function SignupVS() {
    
    // 1ere requete
    // 1ere requete
    // on verifie si le numero virtuel existe et si c'est deja identifier
    async function premiereReq() {
      setOpacity(true);
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/accountIA/`)
      .then((res) => {
        const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");

        const api = res.data;
        const filterVirtualNumber = api.filter((api) => api.virtualNumber === writeVirtualNumber && api.identification === "1" && api.type === "1");

        const paymentMethod = filterVirtualNumber.map((api) => api.paymentMethod); //paymentMethod
        if (paymentMethod) { localStorage.setItem("paymentMethod", paymentMethod); }

        const countryCode = filterVirtualNumber.map((api) => api.countryCode); //countryCode
        if (countryCode) { localStorage.setItem("countryCode", countryCode); }

        // verifiedNumberExist > 0, numero virtuel existe
        // verifiedNumberExist < 0, numero virtuel existe pas
        const verifiedNumberExist = filterVirtualNumber.length > 0;
        
        if (verifiedNumberExist) {
          //dans ce cas: numero virtuel existe

          // 2e requete
          // 2e requete
          // on verifie si la personne est deja inscrite sur Vixinol avec ce numero virtuel
          async function deuxiemeReq() {
            await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/userVS/`)
            .then((res) => {
              // on filtre en fonction du numero virtuel saisi - AA
              const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");

              const api = res.data;
              const filter = api.filter((api) => api.virtualNumber === writeVirtualNumber);

              const verifiedAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
              if (verifiedAlreadySignup) {
                // dans ce cas: numero virtuel deja inscrit (on affiche un message d'erreur, car il y'a deja une personne inscrite avec ce numero virtuel)
                setErreurConnexionAA(true);
                setOpacity(false);
              } else {
              // dans ce cas: numero virtuel non inscrit

            //3e requete
            //3e requete
            // inscrire l'utilisateur (numero virtuel non inscrit, alors on lui laisse s'inscrire)
            async function troisiemeReq() {
              const writeName = localStorage.getItem("writeName");
              const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
              const writePassword = localStorage.getItem("writePassword");
              const connection = "1";

              await axios({
                method: "post",
                url: `${process.env.REACT_APP_BACKEND}/api/userVS/signup`,
                data: {
                  nameUser: writeName,
                  virtualNumber: writeVirtualNumber,
                  password: writePassword,
                  connection,
                },
              })
              .then((res) => {
              // utilisateur enregistré! on prend l'idUser, on va l'ajouter au niveau de son compte VS
              const id = res.data.idUser;
              if (id) { localStorage.setItem("idUser", id); }

                //4e requete
                //4e requete
                // on cree son compte 
                async function quatriemeReq() {
                  const idUser = localStorage.getItem("idUser");
                  const writeName = localStorage.getItem("writeName");
                  const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
                  const photoProfile = "0";
                  const paymentMethod = localStorage.getItem("paymentMethod");
                  const countryCode = localStorage.getItem("countryCode");
                  const myAccount = "0";
                  const connection = "1";
                  const display = "1";
                  const visible = "1";
                  const type = "1";

                  await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_BACKEND}/api/accountVS/create`,
                    data: {
                      idUser,
                      nameAccount: writeName,
                      virtualNumber: writeVirtualNumber,
                      photoProfile,
                      paymentMethod,
                      countryCode,
                      myAccount,
                      connection,
                      display,
                      visible,
                      type,
                    },
                  })
                  .then((res) => {
                    setInscriptionSuccessVS(true); //inscription reussie (message de success)
                    setOpacity(false);
                  })
                  .catch((err) => {
                    setOpacity(false);
                    setErreurVS(true);
                  });
                }
                quatriemeReq();
                //4e requete
                })
                .catch((err) => {
                  setOpacity(false);
                  setErreurVS(true);
                });
              }
              troisiemeReq();
              //3e requete
              }
              // le if de verifiedAlreadySignup se ferme ici
            })
            .catch((err) => {
              setOpacity(false);
              setErreurVS(true);
            });
          }
          deuxiemeReq();
          // 2e requete
        } else {
          //dans ce cas: numero virtuel n'existe pas (on affiche a l'utilisateur un message d'erreur)
          setOpacity(false);
          setErreurVS(true);
        }
        //le if de verifiedNumberExist se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErreurVS(true);
      });
    }
    premiereReq();
    // 1ere requete
  }


  // login - VS
  // login - VS
  //ici l'utilisateur saisi: numero virtuel, mot de passe
  const [numberLoginVS, setNumberLoginVS] = useState("");
  const [passwordLoginVS, setPasswordLoginVS] = useState("");

  if (numberLoginVS) { localStorage.setItem("writeVirtualNumber", numberLoginVS); } //numero virtuel
  if (passwordLoginVS) { localStorage.setItem("writePassword", passwordLoginVS); } //mot de passe

  //logique pour se connecter sur Vixinol - VS
  async function LoginVS() {

    //1ere requete
    //1ere requete
    // on verifie si la personne est deja inscrite sur Vixinol avec ce numero virtuel
    async function premiereReq() {
      setOpacity(true);
      await axios
      .get(`${process.env.REACT_APP_BACKEND}/api/userVS`)
      .then((res) => {
        // on filtre en fonction du numero virtuel saisi
        const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");

        const api = res.data;
        const filter = api.filter((api) => api.virtualNumber === writeVirtualNumber);
        
        const verifyAlreadySignup = filter.length > 0; // verifyAlreadySignup > 0 numero virtuel deja inscrit, verifyAlreadySignup < 0 numero virtuel non inscrit
        if (verifyAlreadySignup) {
        // dans ce cas: numero virtuel deja inscrit
      
        //2e requete
        //2e requete
        // connecter l'utilisateur (numero virtuel deja inscrit sur AA alors on lui laisse se connecter)
        async function deuxiemeReq() {
          const writeVirtualNumber = localStorage.getItem("writeVirtualNumber");
          const writePassword = localStorage.getItem("writePassword");
          
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_BACKEND}/api/userVS/login`,
            data: {
              virtualNumber: writeVirtualNumber,
              password: writePassword,
            },
          })
          .then((res) => {
            //on prend l'idUser pour pouvoir filtrer
            const idUser = res.data.idUser;
            if (idUser) { localStorage.setItem("idUser", idUser); }
  
          //3e requete
          //3e requete
          // maintenir l'utilisateur connecté ! (on enregistre les infos de connexion)
          async function troisiemeReq() {
          await axios
            .get(`${process.env.REACT_APP_BACKEND}/api/accountVS`)
            .then((res) => {
              //on recupere l'idUser
              const idUser = localStorage.getItem("idUser");
              
              // filtre pour obtenir uniquement les infos de la personne connecter
              const api = res.data;
              const filterUser = api.filter((api) => api.idUser === idUser);
  
              const id = filterUser.map((api) => api._id); // id
              if (id) { localStorage.setItem("idPersonConnectedVS", id); }
  
              const name = filterUser.map((api) => api.nameAccount); // name
              if (name) { localStorage.setItem("namePersonConnectedVS", name); }
  
              const virtualNumber = filterUser.map((api) => api.virtualNumber); // virtualNumber
              if (virtualNumber) { localStorage.setItem("virtualNumberPersonConnectedVS", virtualNumber); }

              const phoneNumber = filterUser.map((api) => api.phoneNumber); // phoneNumber
              if (phoneNumber) { localStorage.setItem("phoneNumberPersonConnectedVS", phoneNumber); }

              const photo = filterUser.map((api) => api.photoProfile); // photo
              if (photo) { localStorage.setItem("photoPersonConnectedVS", photo); }
                  
              const paymentMethod = filterUser.map((api) => api.paymentMethod); // paymentMethod
              if (paymentMethod) { localStorage.setItem("paymentMethodVS", paymentMethod); }
  
              const countryCode = filterUser.map((api) => api.countryCode); // countryCode
              if (countryCode) { localStorage.setItem("countryCodeVS", countryCode); }
  
              const typeAccount = filterUser.map((api) => api.type); // typeAccount
              if (typeAccount) { localStorage.setItem("typeAccountVS", typeAccount); }
              
                //connexion reussie: message de succes qui s'affiche et disparait apres quelques secondes
                //ici on affiche le message de succes
                setOpacity(false);
                setConnexionSuccessVS(true);

                //ici on le fait disparaitre
                async function CloseConnexionSuccessVS() {
                  setConnexionSuccessVS(false);
                  setInscriptionPageVS(false);
                  setConnexionPageVS(false);
                  setVixinolStoreApp(true);
                }
                setTimeout(CloseConnexionSuccessVS, 1400);
                console.log("connexion reussie - VS");
              })
              .catch((err) => {
                setOpacity(false);
                setErreurVS(true);
              });
            }
            troisiemeReq();
            //3e requete
          })
          .catch((err) => {
            setOpacity(false);
            setErreurVS(true);
          });
        }
        deuxiemeReq();
        //2e requete
        } else {
          // numero virtuel non inscrit, impossible de se connecter
          setOpacity(false);
          setErreurVS(true);
        }
        //le if de verifyAlreadySignup se ferme ici
      })
      .catch((err) => {
        setOpacity(false);
        setErreurVS(true);
      });
    }
    premiereReq();
    //1ere requete
  }


  // inscriptionSuccess - VS
  // inscriptionSuccess - VS
  // on va afficher cette page si l'utilisateur a pu s'inscrire sur Vixinol Store
  const [inscriptionSuccessVS, setInscriptionSuccessVS] = useState(false);
  async function CloseInscriptionSuccessVS() {
    setInscriptionSuccessVS(false);
    setInscriptionPageVS(false);
    setMoyenPaiementPageVS(false);
    setConnexionPageVS(true);
  }

  // connexionSuccess - VS
  // connexionSuccess - VS
  /* on va afficher cette page si l'utilisateur a pu se connecter a son compte vixinol. 
  on affiche ca juste pour lui signaler qu'il a pu se connecter a son compte ensuite 
  ca va disparaitre apres quelques secondes pour ouvrir la page d'accueil de vixinol store */
  const [connexionSuccessVS, setConnexionSuccessVS] = useState(false);

  // erreur - VS
  // erreur - VS
  /* si jamais il ya une erreur qui sest produite quelque part dans l'app vixinol,
  on pourra afficher cette page en fonction du type d'erreur */
  const [erreurVS, setErreurVS] = useState(false);
  async function CloseErreurVS() {
    setErreurVS(false);
  }

  //super module - VS
  /*dans vixinol store, si l'utilisateur a cliquer sur une app, on va afficher 
  cette page superModule */
  //donc clic sur une app, on affiche super module
  const [superModule, setSuperModule] = useState(false);
  async function SuperModule() {
    setSuperModule(true);
  }
  //fermer
  async function CloseSuperModule() {
    setSuperModule(false);
  }

  //module - VS
  /*dans vixinol store, si l'utilisateur a cliquer sur un super module, on va afficher
  cette page module */
  //donc clic sur un super module, on affiche module
  const [module, setModule] = useState(false);
  async function Module() {
    /*on a mis le filtre ici parce que a l'exterieur il y'avait un retard, il fallait cliquer
    02 fois */
    /*filtre pour afficher directement la page module lorsqu'on clique sur 
    un Super module */
    /*apres avoir filtrer, si l'api nous renvoie un bloc de données, cela veut dire que 
    la personne a deja acheter le super module. Si ca renvoie rien, cela veut dire que 
    la personne n'a pas encore acheter le super module */
    const idSuperModule = localStorage.getItem(
      "https://alrani.com/idSuperModule"
    );
    const filtreApiModuleAcheter = apiModuleAcheter.filter(
      (api) => api.id === idSuperModule
    );
    const verifyModuleAcheter = filtreApiModuleAcheter.length > 0;
    if (verifyModuleAcheter) {
      setModule(true);
    } else {
      setDetailModule(true);
    }
  }
  //fermer
  async function CloseModule() {
    setModule(false);
  }

  //ici on affiche les details du module - VS
  const [detailModule, setDetailModule] = useState(false);
  async function DetailModule() {
    /*on a mis le filtre ici parce que a l'exterieur il y'avait un retard, il fallait cliquer
    02 fois */
    //filtre pour afficher directement la page module acheter lorsqu'on clique sur un module - VS
    /*apres avoir filtrer, si l'api nous renvoie un bloc de données, cela veut dire que 
  la personne a deja acheter le module. Si ca renvoie rien, cela veut dire que la personne 
  n'a pas encore acheter le module */
    const idModule = localStorage.getItem("https://alrani.com/idModule");
    const filtreApiModuleAcheter = apiModuleAcheter.filter(
      (api) => api.id === idModule
    );
    const verifyModuleAcheter = filtreApiModuleAcheter.length > 0;
    //
    if (verifyModuleAcheter) {
      setModuleAcheter(true);
    } else {
      setModuleAcheter(false);
      setDetailModule(true);
    }
  }
  //fermer
  async function CloseDetailModule() {
    setDetailModule(false);
  }

  //abonnementAnnuel - VS
  /*ici on affiche le card qui va permetre a la personne d'acheter 
  son abonnement annuel */
  const [abonnementAnnuel, setAbonnementAnnuel] = useState(false);
  async function AbonnementAnnuel() {
    setDetailModule(false);
    setAbonnementAnnuel(true);
  }
  //fermer
  async function CloseAbonnementAnnuel() {
    setAbonnementAnnuel(false);
    setDetailModule(true);
  }

  //moduleAcheter - VS
  //on affiche tout les modules que la personne connecter a acheter
  const [moduleAcheter, setModuleAcheter] = useState(false);
  async function ModuleAcheter() {
    /*on a fais ceci car on rencontrait un probleme de donnees corrompues voila pourquoi
    on a enregistrer les idSuperModule, nomSuperModule dans la reserve */
    const id = localStorage.getItem("https://alrani.com/idSuperModuleReserve");
    const nom = localStorage.getItem(
      "https://alrani.com/nomSuperModuleReserve"
    );
    localStorage.setItem("https://alrani.com/idModuleGeneral", id);
    localStorage.setItem("https://alrani.com/nomModuleGeneral", nom);
    //
    setModuleAcheter(true);
  }
  //fermer
  async function CloseModuleAcheter() {
    setModuleAcheter(false);
  }

  //ici on simile la connexion - VS
  //async function Connecter() {

    /*
    //Vixinol
    //Vixinol
    //Vixinol
    //const idVS = "VS000111";
    //const nomVS = "Kilendo Dingha Veil Brillant";
    //const idVS = "VS000222";
    //const nomVS = "Laura Labelle";
    //localStorage.setItem("https://alrani.com/idPersonneConnecterVS", idVS);
    //localStorage.setItem("https://alrani.com/namePersonConnectedVS", nomVS);
    */

    //Alrani
    //Alrani
    //Alrani
    //const idAA = "AA000111";
    //const nomAA = "Kilendo Dingha Veil Brillant";
    /*const idAA = "AA000222";
    const nomAA = "Laura Labelle";
    localStorage.setItem("https://alrani.com/idPersonneConnecterAA", idAA);
    localStorage.setItem("https://alrani.com/nomPersonneConnecterAA", nomAA);
    */

    /*

    //Veil Brillant
    //Veil Brillant
    //const idVB = "VB000111";
    //const nomVB = "Kilendo Dingha Veil Brillant";
    const idVB = "VB000222";
    const nomVB = "Laura Labelle";
    localStorage.setItem("https://alrani.com/idPersonneConnecterVB", idVB);
    localStorage.setItem("https://alrani.com/nomPersonneConnecterVB", nomVB);

    //izocash
    //izocash
    //const idIA = "IA000111";
    //const nomIA = "Kilendo Dingha Veil Brillant";
    const idIA = "IA000222";
    const nomIA = "Laura Labelle";
    localStorage.setItem("https://alrani.com/idPersonneConnecterIA", idIA);
    localStorage.setItem("https://alrani.com/nomPersonneConnecterIA", nomIA);

    */
  //}

  //on filtre pour afficher chaque application avec son superModule
  const idApp = localStorage.getItem("https://alrani.com/idApp");
  const filtreApiSuperModule = apiSuperModule.filter(
    (api) => api.idApp === idApp
  );

  //on filtre pour afficher chaque module avec son superModule - VS
  const idSuperModule = localStorage.getItem(
    "https://alrani.com/idSuperModule"
  );
  const filtreApiModule = apiModule.filter(
    (api) => api.idSuperModule === idSuperModule
  );

  //filtre pour afficher directement la page module acheter lorsqu'on clique sur un module - VS
  /*apres avoir filtrer, si l'api nous renvoie un bloc de données, cela veut dire que 
  la personne a deja acheter le module. Si ca renvoie rien, cela veut dire que la personne 
  n'a pas encore acheter le module */
  const idModuleGeneral = localStorage.getItem(
    "https://alrani.com/idModuleGeneral"
  );
  const filtreApiModuleAcheter = apiModuleAcheter.filter(
    (api) => api.id === idModuleGeneral
  );
  //const verifyModuleAcheter = filtreApiModuleAcheter.length > 0;
  //console.log(verifyModuleAcheter);

  //on filtre pour savoir si l'application est deja installer ou pas
  //si l'application est deja installer on va qfficher installée
  /*const idPersonneConnecterVS = localStorage.getItem(
    "https://alrani.com/idPersonneConnecterVS"
  );
  const filtreApiAppInstaller = apiAppInstaller.filter(
    (api) => api.idApp === idApp && api.idAuteur === idPersonneConnecterVS
  );*/

  //const installer = filtreApiAppInstaller.map((api) => api.installer === "1");
  //console.log(filtreApiAppInstaller);
  //console.log(installer);

  //on filtre pour que ca affiche chaque recu avec son module
  //const idModuleCliquer = localStorage.getItem("https://alrani.com/idModuleCliquer");
  //const filtreApiRecu = apiRecu.filter((api) => api.idModule === idModuleCliquer);

  //Profil - VS
  //on affiche le profil de la personne connecter sur vixinol Store - VS
  const [profilVS, setProfilVS] = useState(false);
  async function ProfilVS() {
    setProfilVS(true);
  }
  //fermer
  async function CloseProfilVS() {
    setProfilVS(false);
  }

  //deconnexion - VS
  /* on affiche la page qui va permettre a l'utilisateur de se deconnecter de
son compte Vixinol store */
  const [deconnexionVS, setDeconnexionVS] = useState(false);
  async function DeconnexionVS() {
    setDeconnexionVS(true);
  }
  //fermer
  async function CloseDeconnexionVS() {
    setDeconnexionVS(false);
  }

  //on recupere les infos de la personne connecter - VS
  const namePersonConnectedVS = localStorage.getItem("namePersonConnectedVS");

  // App. on recupere les infos de l'app - VS
  const nomApp = localStorage.getItem("https://alrani.com/nomApp");
  const descApp = localStorage.getItem("https://alrani.com/descApp");

  // Super module. on recupere les infos du super module - VS
  const nomSuperModule = localStorage.getItem(
    "https://alrani.com/nomSuperModule"
  );
  const gratuit = localStorage.getItem("https://alrani.com/gratuitSuperModule");
  const gratuitSuperModule = gratuit === "1";

  // Module. on recupere les infos du module - VS
  const nomModule = localStorage.getItem("https://alrani.com/nomModule");
  const prixModule = localStorage.getItem("https://alrani.com/prixModule");
  const descModule = localStorage.getItem("https://alrani.com/descModule");
  //annuel
  const descAnnuelModule = localStorage.getItem(
    "https://alrani.com/descAnnuelModule"
  );
  const prixAnnuelModule = localStorage.getItem(
    "https://alrani.com/prixAnnuelModule"
  );
  const typeDabonnement = localStorage.getItem(
    "https://alrani.com/typeDabonnement"
  );

  // General. on recupere les infos du General - VS
  const nomModuleGeneral = localStorage.getItem(
    "https://alrani.com/nomModuleGeneral"
  );

  //logique pour acheter un module - VS
  /*
  async function AcheterModule() {
    setOpacity(true);
    const url = localStorage.getItem("https://alrani.com/urlModule");

    //super module Alrani Business - AA
    //super module Alrani Business - AA
    const moduleAlraniBusinessAA = "https://alrani.com/ModuleAlraniBusinessAA";
    const verifyAlraniBusinessAA = url === moduleAlraniBusinessAA;
    if (verifyAlraniBusinessAA) {
      const alraniBusinessAA = "1";
      localStorage.setItem(
        "https://alrani.com/ModuleAlraniBusinessAA",
        alraniBusinessAA
      );
      */

  /*une fois que le super module Alrani Business a ete acheter alors on enleve l'opacity
        puis on filtre pour afficher la page module */
  /*filtre pour afficher directement la page module lorsqu'on a terminer d'acheter 
        le Super module */
  /*
      const idSuperModule = localStorage.getItem(
        "https://alrani.com/idSuperModule"
      );
      const filtreApiModuleAcheter = apiModuleAcheter.filter(
        (api) => api.id === idSuperModule
      );
      const verifyModuleAcheter = filtreApiModuleAcheter.length > 0;
      if (verifyModuleAcheter) {
        setOpacity(false);
        setModule(true);
      }
      //
      setOpacity(false);
    }
    //module Alrani Business - AA

    //module Recherche - AA
    //module Recherche - AA
    const moduleRechercheAA = "https://alrani.com/ModuleRechercheAA";
    const verifyRechercheAA = url === moduleRechercheAA;
    if (verifyRechercheAA) {
      const rechercheAA = "1";
      localStorage.setItem("https://alrani.com/ModuleRechercheAA", rechercheAA);
      console.log("module acheter : Recherche");
      console.log("le module Recherche a ete acheter");
      setOpacity(false);
    }
    //module Recherche - AA

    //transfert
    const moduleTransfert = "https://alrani.com/ModuleTransfertIA";
    const verifyTransfert = url === moduleTransfert;
    if (verifyTransfert) {
      const transfert = "1";
      localStorage.setItem("https://alrani.com/ModuleTransfertIA", transfert);
      console.log("module acheter : transfert dargent");
      console.log("le module transfert dargent a ete acheter");
    }

    //si le module n'a pas ete acheter peut-etre en cas d'erreur, on enleve juste l'opacity
    setOpacity(false);
  }
  */

  // official App
  // official App
  // ca c'est l'application official
  const [officialApp, setOfficialApp] = useState(false);
  async function OfficialApp() {
    setOfficialApp(true);
  }
  //fermer
  async function CloseOfficialApp() {
    setOfficialApp(false);
  }

  // recommandations
  // recommandations
  const getRecommendation = localStorage.getItem("recommendation");
  const [recommendation, setRecommendation] = useState(getRecommendation);
  async function Recommendation() {
    const recommendation = true;
    localStorage.setItem("recommendation", recommendation);

    localStorage.removeItem("address");
    localStorage.removeItem("rule");
    localStorage.removeItem("advice");
    setRecommendation(true);
    setAddress(false);
    setRule(false);
    setAdvice(false);
  }

  // address
  // address
  const getAddress = localStorage.getItem("address");
  const [address, setAddress] = useState(getAddress);
  async function Address() {
    const address = true;
    localStorage.setItem("address", address);

    localStorage.removeItem("recommendation");
    localStorage.removeItem("rule");
    localStorage.removeItem("advice");
    setAddress(true);
    setRecommendation(false);
    setRule(false);
    setAdvice(false);
  }

  // regles
  // regles
  const getRule = localStorage.getItem("rule");
  const [rule, setRule] = useState(getRule);
  async function Rule() {
    const rule = true;
    localStorage.setItem("rule", rule);

    localStorage.removeItem("recommendation");
    localStorage.removeItem("address");
    localStorage.removeItem("advice");
    setRule(true);
    setRecommendation(false);
    setAddress(false);
    setAdvice(false);
  }

  // conseils
  // conseils
  const getAdvice = localStorage.getItem("advice");
  const [advice, setAdvice] = useState(getAdvice);
  async function Advice() {
    const advice = true;
    localStorage.setItem("advice", advice);

    localStorage.removeItem("recommendation");
    localStorage.removeItem("address");
    localStorage.removeItem("rule");
    setAdvice(true);
    setRecommendation(false);
    setAddress(false);
    setRule(false);
  }

  
  // Paramètres du Téléphone virtuel 
  const [settings, setSettings] = useState(false);
  async function Settings() {
    setSettings(true);
  }
  //fermer
  async function CloseSettings() {
    setSettings(false);
  }

  // toast au niveau des paramètres du Téléphone virtuel
  const [toastSettings, setToastSettings] = useState(false);
  async function ToastSettings() {
    setToastSettings(true);
    //mettre fin au toast
    async function CloseToastSettings() {
      setToastSettings(false);
    }
    setTimeout(CloseToastSettings, 800);
  }


  // configuration de l'application Alrani - AA
  // configuration de l'application Alrani - AA
  const [configurationAA, setConfigurationAA] = useState(false);
  async function ConfigurationAA() {
    setConfigurationAA(true);
  }
  //fermer
  async function CloseConfigurationAA() {
    setConfigurationAA(false);
  }

  // Vitesse 1 - AA
  const getSpeed1AA = localStorage.getItem("speed1AA");
  const [speed1AA, setSpeed1AA] = useState(getSpeed1AA);
  async function Speed1AA() {
    const speed = true;
    localStorage.setItem("speed1AA", speed);

    localStorage.removeItem("speed2AA");
    localStorage.removeItem("speed3AA");
    setSpeed1AA(true);
    setSpeed2AA(false);
    setSpeed3AA(false);
  }

  // Vitesse 2 - AA
  const getSpeed2AA = localStorage.getItem("speed2AA");
  const [speed2AA, setSpeed2AA] = useState(getSpeed2AA);
  async function Speed2AA() {
    const speed = true;
    localStorage.setItem("speed2AA", speed);

    localStorage.removeItem("speed1AA");
    localStorage.removeItem("speed3AA");
    setSpeed2AA(true);
    setSpeed1AA(false);
    setSpeed3AA(false);
  }

  // Vitesse 3 - AA
  const getSpeed3AA = localStorage.getItem("speed3AA");
  const [speed3AA, setSpeed3AA] = useState(getSpeed3AA);
  async function Speed3AA() {
    const speed = true;
    localStorage.setItem("speed3AA", speed);

    localStorage.removeItem("speed1AA");
    localStorage.removeItem("speed2AA");
    setSpeed3AA(true);
    setSpeed1AA(false);
    setSpeed2AA(false);
  }

    
  // Datacenter 1 - AA
  const getDatacenter1AA = localStorage.getItem("datacenter1AA");
  const [datacenter1AA, setDatacenter1AA] = useState(getDatacenter1AA);
  async function Datacenter1AA() {
    const datacenter = true;
    localStorage.setItem("datacenter1AA", datacenter);

    localStorage.removeItem("datacenter2AA");
    localStorage.removeItem("datacenter3AA");
    setDatacenter1AA(true);
    setDatacenter2AA(false);
    setDatacenter3AA(false);
  }
 
  // Datacenter 2 - AA
  const getDatacenter2AA = localStorage.getItem("datacenter2AA");
  const [datacenter2AA, setDatacenter2AA] = useState(getDatacenter2AA);
  async function Datacenter2AA() {
    const datacenter = true;
    localStorage.setItem("datacenter2AA", datacenter);

    localStorage.removeItem("datacenter1AA");
    localStorage.removeItem("datacenter3AA");
    setDatacenter2AA(true);
    setDatacenter1AA(false);
    setDatacenter3AA(false);
  }

  // Datacenter 3 - AA
  const getDatacenter3AA = localStorage.getItem("datacenter3AA");
  const [datacenter3AA, setDatacenter3AA] = useState(getDatacenter3AA);
  async function Datacenter3AA() {
    const datacenter = true;
    localStorage.setItem("datacenter3AA", datacenter);

    localStorage.removeItem("datacenter1AA");
    localStorage.removeItem("datacenter2AA");
    setDatacenter3AA(true);
    setDatacenter1AA(false);
    setDatacenter2AA(false);
  }


  // configuration de l'application izocash - IA
  // configuration de l'application izocash - IA
  const [configurationIA, setConfigurationIA] = useState(false);
  async function ConfigurationIA() {
    setConfigurationIA(true);
  }
  //fermer
  async function CloseConfigurationIA() {
    setConfigurationIA(false);
  }

  // les vitesses correspondent au choix  de l'api, soit speed1 = Render 1 + mongodb1 + cloudinary1, 
  // Vitesse 1 - IA
  const getSpeed1IA = localStorage.getItem("speed1IA");
  const [speed1IA, setSpeed1IA] = useState(getSpeed1IA);
  async function Speed1IA() {
    const speed = true;
    localStorage.setItem("speed1IA", speed);

    localStorage.removeItem("speed2IA");
    localStorage.removeItem("speed3IA");
    setSpeed1IA(true);
    setSpeed2IA(false);
    setSpeed3IA(false);
  }

  // Vitesse 2 - IA
  const getSpeed2IA = localStorage.getItem("speed2IA");
  const [speed2IA, setSpeed2IA] = useState(getSpeed2IA);
  async function Speed2IA() {
    const speed = true;
    localStorage.setItem("speed2IA", speed);

    localStorage.removeItem("speed1IA");
    localStorage.removeItem("speed3IA");
    setSpeed2IA(true);
    setSpeed1IA(false);
    setSpeed3IA(false);
  }

  // Vitesse 3 - IA
  const getSpeed3IA = localStorage.getItem("speed3IA");
  const [speed3IA, setSpeed3IA] = useState(getSpeed3IA);
  async function Speed3IA() {
    const speed = true;
    localStorage.setItem("speed3IA", speed);

    localStorage.removeItem("speed1IA");
    localStorage.removeItem("speed2IA");
    setSpeed3IA(true);
    setSpeed1IA(false);
    setSpeed2IA(false);
  }

  // Datacenter 1 - IA
  const getDatacenter1IA = localStorage.getItem("datacenter1IA");
  const [datacenter1IA, setDatacenter1IA] = useState(getDatacenter1IA);
  async function Datacenter1IA() {
    const datacenter = true;
    localStorage.setItem("datacenter1IA", datacenter);

    localStorage.removeItem("datacenter2IA");
    localStorage.removeItem("datacenter3IA");
    setDatacenter1IA(true);
    setDatacenter2IA(false);
    setDatacenter3IA(false);
  }
 
  // Datacenter 2 - IA
  const getDatacenter2IA = localStorage.getItem("datacenter2IA");
  const [datacenter2IA, setDatacenter2IA] = useState(getDatacenter2IA);
  async function Datacenter2IA() {
    const datacenter = true;
    localStorage.setItem("datacenter2IA", datacenter);

    localStorage.removeItem("datacenter1IA");
    localStorage.removeItem("datacenter3IA");
    setDatacenter2IA(true);
    setDatacenter1IA(false);
    setDatacenter3IA(false);
  }

  // Datacenter 3 - IA
  const getDatacenter3IA = localStorage.getItem("datacenter3IA");
  const [datacenter3IA, setDatacenter3IA] = useState(getDatacenter3IA);
  async function Datacenter3IA() {
    const datacenter = true;
    localStorage.setItem("datacenter3IA", datacenter);

    localStorage.removeItem("datacenter1IA");
    localStorage.removeItem("datacenter2IA");
    setDatacenter3IA(true);
    setDatacenter1IA(false);
    setDatacenter2IA(false);
  }


  // configuration de l'application Vixinol Store - VS
  // configuration de l'application Vixinol Store - VS
  const [configurationVS, setConfigurationVS] = useState(false);
  async function ConfigurationVS() {
    setConfigurationVS(true);
  }
  //fermer
  async function CloseConfigurationVS() {
    setConfigurationVS(false);
  }

  // les vitesses correspondent au choix  de l'api, soit speed1 = Render 1 + mongodb1 + cloudinary1, 
  // Vitesse 1 - VS
  const getSpeed1VS = localStorage.getItem("speed1VS");
  const [speed1VS, setSpeed1VS] = useState(getSpeed1VS);
  async function Speed1VS() {
    const speed = true;
    localStorage.setItem("speed1VS", speed);

    localStorage.removeItem("speed2VS");
    localStorage.removeItem("speed3VS");
    setSpeed1VS(true);
    setSpeed2VS(false);
    setSpeed3VS(false);
  }

  // Vitesse 2 - VS
  const getSpeed2VS = localStorage.getItem("speed2VS");
  const [speed2VS, setSpeed2VS] = useState(getSpeed2VS);
  async function Speed2VS() {
    const speed = true;
    localStorage.setItem("speed2VS", speed);

    localStorage.removeItem("speed1VS");
    localStorage.removeItem("speed3VS");
    setSpeed2VS(true);
    setSpeed1VS(false);
    setSpeed3VS(false);
  }

  // Vitesse 3 - VS
  const getSpeed3VS = localStorage.getItem("speed3VS");
  const [speed3VS, setSpeed3VS] = useState(getSpeed3VS);
  async function Speed3VS() {
    const speed = true;
    localStorage.setItem("speed3VS", speed);

    localStorage.removeItem("speed1VS");
    localStorage.removeItem("speed2VS");
    setSpeed3VS(true);
    setSpeed1VS(false);
    setSpeed2VS(false);
  }

  // Datacenter 1 - VS
  const getDatacenter1VS = localStorage.getItem("datacenter1VS");
  const [datacenter1VS, setDatacenter1VS] = useState(getDatacenter1VS);
  async function Datacenter1VS() {
    const datacenter = true;
    localStorage.setItem("datacenter1VS", datacenter);

    localStorage.removeItem("datacenter2VS");
    localStorage.removeItem("datacenter3VS");
    setDatacenter1VS(true);
    setDatacenter2VS(false);
    setDatacenter3VS(false);
  }
 
  // Datacenter 2 - VS
  const getDatacenter2VS = localStorage.getItem("datacenter2VS");
  const [datacenter2VS, setDatacenter2VS] = useState(getDatacenter2VS);
  async function Datacenter2VS() {
    const datacenter = true;
    localStorage.setItem("datacenter2VS", datacenter);

    localStorage.removeItem("datacenter1VS");
    localStorage.removeItem("datacenter3VS");
    setDatacenter2VS(true);
    setDatacenter1VS(false);
    setDatacenter3VS(false);
  }

  // Datacenter 3 - VS
  const getDatacenter3VS = localStorage.getItem("datacenter3VS");
  const [datacenter3VS, setDatacenter3VS] = useState(getDatacenter3VS);
  async function Datacenter3VS() {
    const datacenter = true;
    localStorage.setItem("datacenter3VS", datacenter);

    localStorage.removeItem("datacenter1VS");
    localStorage.removeItem("datacenter2VS");
    setDatacenter3VS(true);
    setDatacenter1VS(false);
    setDatacenter2VS(false);
  }


  // configuration de l'application Veil Brillant - VB
  // configuration de l'application Veil Brillant - VB
  const [configurationVB, setConfigurationVB] = useState(false);
  async function ConfigurationVB() {
    setConfigurationVB(true);
  }
  //fermer
  async function CloseConfigurationVB() {
    setConfigurationVB(false);
  }

  // les vitesses correspondent au choix  de l'api, soit speed1 = Render 1 + mongodb1 + cloudinary1, 
  // Vitesse 1 - VB
  const getSpeed1VB = localStorage.getItem("speed1VB");
  const [speed1VB, setSpeed1VB] = useState(getSpeed1VB);
  async function Speed1VB() {
    const speed = true;
    localStorage.setItem("speed1VB", speed);

    localStorage.removeItem("speed2VB");
    localStorage.removeItem("speed3VB");
    setSpeed1VB(true);
    setSpeed2VB(false);
    setSpeed3VB(false);
  }

  // Vitesse 2 - VB
  const getSpeed2VB = localStorage.getItem("speed2VB");
  const [speed2VB, setSpeed2VB] = useState(getSpeed2VB);
  async function Speed2VB() {
    const speed = true;
    localStorage.setItem("speed2VB", speed);

    localStorage.removeItem("speed1VB");
    localStorage.removeItem("speed3VB");
    setSpeed2VB(true);
    setSpeed1VB(false);
    setSpeed3VB(false);
  }

  // Vitesse 3 - VB
  const getSpeed3VB = localStorage.getItem("speed3VB");
  const [speed3VB, setSpeed3VB] = useState(getSpeed3VB);
  async function Speed3VB() {
    const speed = true;
    localStorage.setItem("speed3VB", speed);

    localStorage.removeItem("speed1VB");
    localStorage.removeItem("speed2VB");
    setSpeed3VB(true);
    setSpeed1VB(false);
    setSpeed2VB(false);
  }

  // Datacenter 1 - VB
  const getDatacenter1VB = localStorage.getItem("datacenter1VB");
  const [datacenter1VB, setDatacenter1VB] = useState(getDatacenter1VB);
  async function Datacenter1VB() {
    const datacenter = true;
    localStorage.setItem("datacenter1VB", datacenter);

    localStorage.removeItem("datacenter2VB");
    localStorage.removeItem("datacenter3VB");
    setDatacenter1VB(true);
    setDatacenter2VB(false);
    setDatacenter3VB(false);
  }
 
  // Datacenter 2 - VB
  const getDatacenter2VB = localStorage.getItem("datacenter2VB");
  const [datacenter2VB, setDatacenter2VB] = useState(getDatacenter2VB);
  async function Datacenter2VB() {
    const datacenter = true;
    localStorage.setItem("datacenter2VB", datacenter);

    localStorage.removeItem("datacenter1VB");
    localStorage.removeItem("datacenter3VB");
    setDatacenter2VB(true);
    setDatacenter1VB(false);
    setDatacenter3VB(false);
  }

  // Datacenter 3 - VB
  const getDatacenter3VB = localStorage.getItem("datacenter3VB");
  const [datacenter3VB, setDatacenter3VB] = useState(getDatacenter3VB);
  async function Datacenter3VB() {
    const datacenter = true;
    localStorage.setItem("datacenter3VB", datacenter);

    localStorage.removeItem("datacenter1VB");
    localStorage.removeItem("datacenter2VB");
    setDatacenter3VB(true);
    setDatacenter1VB(false);
    setDatacenter2VB(false);
  }
  
  
function rechargerPage() {
	if (window.location.pathname === "/") {
		window.location.reload();
	}
}


  // translation
  // translation
  if (!afrikaans && !albanian && !amharic && !arabic && !armenian && !assamese && !aymara && !azerbaijani //a
    && !bambara && !basque && !belarusian && !bengali && !bhojpuri && !bosnian && !bulgarian //b
    && !catalan && !cebuano && !chichewa && !chineseSimplified && !chineseTraditional && !corsican && !croatian && !czech //c
    && !danish && !dhivehi && !dogri && !dutch //d
    && !english && !esperanto && !estonian && !ewe //e
    && !filipino && !finnish && !french && !frisian //f
    && !galician && !georgian && !german && !greek && !guarani && !gujarati //g
    && !haitianCreole && !hausa && !hawaiian && !hebrew && !hindi && !hmong && !hungarian //h 
    && !icelandic && !igbo && !ilocano && !indonesian && !irish && !italian //i
    && !japanese && !javanese //j
    && !kannada && !kazakh && !khmer && !kinyarwanda && !konkani && !korean && !krio && !kurdishKurmanji && !kurdishSorani && !kyrgyz //k
    && !lao && !latin && !latvian && !lingala && !lithuanian && !luganda && !luxembourgish //l
    && !macedonian && !maithili && !malagasy && !malay && !malayalam && !maltese && !maori && !marathi && !meiteilonManipuri && !mizo && !mongolian && !myanmarBurmese //m
    && !nepali && !norwegian //n
    && !odiaOriya && !oromo //o
    && !pashto && !persian && !polish && !portuguese && !punjabi //p
    && !quechua //q
    && !romanian && !russian //r
    && !samoan && !sanskrit && !scotsGaelic && !sepedi && !serbian && !sesotho && !shona && !sindhi && !sinhala && !slovak && !slovenian && !somali && !spanish && !sundanese && !swahili && !swedish //s
    && !tajik && !tamil && !tatar && !telugu && !thai && !tigrinya && !tsonga && !turkish && !turkmen && !twi //t
    && !ukrainian && !urdu && !uyghur && !uzbek //u
    && !vietnamese //v
    && !welsh //w
    && !xhosa //x
    && !yiddish && !yoruba //y
    && !zulu //z
  ) {
    // par defaut on injecte la langue anglaise dans le localStorage
    const english = true;
    localStorage.setItem("english", english);
  
    //rtl (s'il n'ya pas encore de langue selectionner, on injecte la langue anglaise sans rtl)
    const rtl = "0";
    localStorage.setItem("rtl", rtl);
	rechargerPage();
  }

  // Datacenter et vitesse (configuration de l'application Alrani) - AA 
  if (!speed1AA && !datacenter1AA && !speed2AA && !datacenter2AA && !speed3AA && !datacenter3AA) {
    // par defaut on injecte speed1 et datacenter1
    const defaultConfig = true;
    localStorage.setItem("speed1AA", defaultConfig);
    localStorage.setItem("datacenter1AA", defaultConfig);
	rechargerPage();
  }

  // Datacenter et vitesse (configuration de l'application izocash) - IA
  if (!speed1IA && !datacenter1IA && !speed2IA && !datacenter2IA && !speed3IA && !datacenter3IA) {
    // par defaut on injecte speed1 et datacenter1
    const defaultConfig = true;
    localStorage.setItem("speed1IA", defaultConfig);
    localStorage.setItem("datacenter1IA", defaultConfig);
	rechargerPage();
  }

  // Datacenter et vitesse (configuration de l'application Vixinol Store) - VS
  if (!speed1VS && !datacenter1VS && !speed2VS && !datacenter2VS && !speed3VS && !datacenter3VS) {
    // par defaut on injecte speed1 et datacenter1
    const defaultConfig = true;
    localStorage.setItem("speed1VS", defaultConfig);
    localStorage.setItem("datacenter1VS", defaultConfig);
	rechargerPage();
  }

  // Datacenter et vitesse (configuration de l'application Veil Brillant) - VB 
  if (!speed1VB && !datacenter1VB && !speed2VB && !datacenter2VB && !speed3VB && !datacenter3VB) {
    // par defaut on injecte speed1 et datacenter1
    const defaultConfig = true;
    localStorage.setItem("speed1VB", defaultConfig);
    localStorage.setItem("datacenter1VB", defaultConfig);
	rechargerPage();
  }

  // onglet pour l'application official
  if (!recommendation && !address && !rule && !advice) {
    // par defaut on injecte recommendation dans le localStorage
    const recommendation = true;
    localStorage.setItem("recommendation", recommendation);
	rechargerPage();
  }

  // navbar (666izocashApp) - IA
  // navbar (666izocashApp) - IA
  if (!head1666izocashApp && !head2666izocashApp && !head3666izocashApp && !head4666izocashApp) {
    // par defaut on injecte head3 
    // quand on clique sur Head3666izocashApp ca va mettre active l'onglet compte national
    const head3 = true;
    localStorage.setItem("head1666izocashApp", head3);
    localStorage.setItem("head3666izocashApp", head3);
	rechargerPage();
  }

  // theme - AA
  // theme - AA
  if (!gettheme1 && !gettheme2 && !gettheme3) {
    // par defaut on injecte theme1 dans le localStorage
    const theme3 = true;
    localStorage.setItem("theme3", theme3);
	rechargerPage();
  }



  //other app
  //other app
  const [otherApp, setOtherApp] = useState(false);
  async function OtherApp() {
    setOtherApp(true);
  }
  //fermer
  async function CloseOtherApp() {
    setOtherApp(false);
  }


  /* l'id developpeur va nous permettre d'afficher certaines fonctionnaliter seulement 
  a celui qui a un compte developpeur */
  const developer = localStorage.getItem("dev");
  const dev = developer === "1";
  
  return (
    <>

      {/* zimagic app */}
      {/* zimagic app */}
      {/* ça c'est l'application zimagic (page d'accueil) */}
      {zimagicApp && (<>
      <div className="zimagicApp">
        <div className="block-onee">
          <div className="a"> 
            <div className="cc"> <SvgMark1 /> </div>
            <div className="cc"> <SvgMark2 /> </div>
            <div onClick={CloseZimagicApp} className="aa"> <img src={zimagicLogo} alt=""/> </div>
            <div onClick={ZimagicPopularity} className="dd"> <SvgFire /> </div>
            <div onClick={CloseZimagicApp} className="bb"> <p>Zimagic</p> </div>
          </div>
          {/* a */}

          <div onClick={LierMusicPageAA} className="b"> <SvgAdd5 /> </div>
          {/* b */}
        </div>
        {/* block-one */}

        <div className="block-two">
          <div className="a">
            <div className="a"> <p>Zimagic est la messagerie des utilisateurs de Florinato, pour discuter ensemble, en communauté, en famille</p> </div>
            
            <div className="b"> <p>Vous pouvez même envoyer un message sans inscrire.</p> </div>

            <div className="b"> <p>Zimagic c'est magique !</p> </div>
          </div>
          {/* a */}
        </div>
        {/* block-two */}
            
        <div className="child">
          <div className="one">
            {apiMessageZA.map((api) => (<>
              <ChildApiMessageZA api={api} />
            </>))}
          </div>
          {/* one */}
        </div>
        {/* child */}
            
        {/* ecrire message (ca c'est l'input pour ecrire un message) */}
        <div className="block-three">
          <div className="write">
            <div className="a"> <textarea type="text" placeholder="Message" value={myMessageZA} onChange={(e) => setMyMessageZA(e.target.value)}></textarea> </div>
            <div onClick={SendMessageZA} className="b"> <SvgSend /> </div>
          </div>
          {/* write */}
        </div>
        {/* block-three */}
      </div>
      {/* zimagicApp */}
      </>)}
      {/* zimagic app */}
      {/* ça c'est l'application Zimagic (page d'accueil) */}


      {/* les plus populaires sur Zimagic */}
      {/* les plus populaires sur Zimagic */}
      {zimagicPopularity && (<>
      <div className="zimagicPopularity">
        <div className="block-one">
          <div className="a">
            <div onClick={CloseZimagicPopularity} className="aa"> <p>Le Cercle fermé des comptes Les plus populaires sur Zimagic</p> </div>
          </div>

          <div className="b"></div>
          {/* b */}
        </div>
        {/* block-one */}
            
        <div className="child">
          <div className="one">
            {filterMessageAA.map((api) => (<>
              <ChildApiMessageAA api={api} />
            </>))}
          </div>
          {/* one */}
        </div>
        {/* child */}
      </div>
      {/* zimagicPopularity */}
      </>)}
      {/* les plus populaires sur Zimagic application zimagic */}
	  

      {/* application florinato */}
      {/* application florinato */}
      {florinatoApp && (<>
        <div className="florinatoApp" onScroll={(e) => { gererScrollConversations(e); gererScrollFollowers(e); }}>
          <div className="head">
            <div className="close">
              <div className="block-un" onClick={ProfilFA}>
                <div className="a"> <img src={photoCompteConnecter} alt=""/> </div>

                <div className="b">
                  <div className="aa"> <p>{nomCompteConnecter}</p> </div>
                  <div className="bb"> <SvgPopularity/> <p>Popularité</p> </div>
                  <div className="cc"> <p>{populariteCompteConnecter} visites</p> </div>
                </div>
              </div>
              {/* block-un */}
      
              <div className="block-deux">
                {dev && (<><div className="a" onClick={RencontreFA}> <SvgLove2/> </div></>)}

                <div className="b" onClick={VideosPageFA}> <SvgVideo6/> </div>
                {dev && (<><div className="b" onClick={SpeedMessagesPagesFA}> <SvgLove2/> </div></>)}
                <div className="b" onClick={ComptesEnLigneFA}> <SvgSearch5/> </div>
                {dev && (<><div className="b" onClick={PopularityAccountsPageFA}> <SvgExplore/> </div></>)}
                <div className="c" onClick={CloseFlorinatoApp}> <SvgExit/> </div>
              </div>
              {/* block-deux */}
            </div>
            {/* close */}
          </div>
          {/* head */}

          <div className="body"> 
            <div className="api">
                {dataConversationFA.map((api) => (
			    <div onClick={() => {
					if (api.type === "30") {
						setIdConversation(api._id);
						
						if (api.idAccount === idCompteConnecter) { setIdDestinataire(api.idOther); setIdCompte(api.idOther); }
						else { setIdDestinataire(api.idAccount); setIdCompte(api.idAccount); }
					}
					PageRedirection66ChildApi66florinatoApp(); }} >
					
					<ChildApi66florinatoApp api={api} idCompteConnecter={idCompteConnecter} profilMap={profilMap} messageMap={messageMap} onlineUsers={onlineUsers} utilisateursQuiEcrivent={utilisateursQuiEcrivent} /> 
				</div> 
				))}
            </div> 
          </div>
          {/* body */}
        </div>
        {/* florinatoApp */}
      </>)}
      {/* application florinato */}
	  
	  
		
		<VideosPageTemplate
			visible={videosPageFA} fermer={CloseVideosPageFA} 
			voirVideo={SeeVideoFA} OuvrirAnnoncesPage={AnnoncesPageFA} voirProfil={ProfilFA2e} AvantMessagePage={AvantMessagePage} video
			setIdPost={setIdPost} setUrlVideo={setUrlVideo} setIdProprietairePost={setIdProprietairePost} setIdCompte={setIdCompte} setIdDestinataire={setIdDestinataire}
			data={dataVideoFAbyClic} profilMap={profilMap} photo={photoFA} gererScroll={scrollY} clicVideo={ClicVideoFAA} photo={photoFA}
			photocss="photo-200px-carre" listVideo={listVideoFA} valeur={rechercherUneVideoFA} setValeur={setRechercherUneVideoFA} />
  
  
		<AnnoncesTemplate 
			{...AnnoncesPropsCommun} 
			visible={annoncesPageFA} fermer={CloseAnnoncesPageFA} profilMap={profilMap} setIdAnnonce={setIdAnnonce} 
			data={dataAnnoncesFA} AfficherAnnoncePage={AfficherAnnoncePageFA} gererScroll={gererScrollAnnonces} />
		
		<AfficherAnnonceTemplate 
			{...AnnoncesPropsCommun} 
			visible={afficherAnnoncePageFA} fermer={CloseAfficherAnnoncePageFA} profilMap={profilMap} idCompteConnecter={idCompteConnecter}
			data={dataAnnonce} ModifierAnnoncePageFA={ModifierAnnoncePageFA} gererScroll={gererScrollAnnonces} />
			
		
	
		<ComptesRecentsTemplate {...ComptesRecentsPropsCommun} visible={comptesEnLigneFA} fermer={CloseComptesEnLigneFA} data={comptesOnline} online />


		<SpeedMessages 
			visible={speedMessagesPagesFA} data={dataComptesFA} fermer={CloseSpeedMessagesPagesFA} 
			MenuPopup={MenuPopup} PagesGerer={PagesGerer} MenuAvecIcone={MenuAvecIcone} MenuBas={MenuBas} 
			GestionPage={GestionPage} PopupBasTextarea={PopupBasTextarea} gererScroll={gererScrollComptes} />
		
		
		<MenuPopupTemplate visible={menuPopup} fermer={CloseMenuPopup} />
		<PagesGererTemplate visible={pagesGerer} fermer={ClosePagesGerer} />
		<MenuAvecIconeTemplate visible={menuAvecIcone} fermer={CloseMenuAvecIcone} />
		<GestionPageTemplate visible={gestionPage} fermer={CloseGestionPage} />
		<PopupBasTextareaTemplate visible={popupBasTextarea} fermer={ClosePopupBasTextarea} />
		
	
		{/* compte connecté - FA */}
		<ProfilTemplate  
			{...profilPropsCommun}
			visible={profilFA} fermer={CloseProfilFA} video connecter={idPersonConnectedFA} idCompte={idPersonConnectedFA} messagebtn={false}
			dataVideos={dataVideoByIdCompteConnecter} dataOverflow={dataVideoRecenteByIdCompteConnecter} data={infosCompteConnecter} listVideo={listMesVideosFA} 
			SeePhoto66profilFA={SeePhoto66profilFA} voirVideo={SeeVideoFA} MenuBas={MenuBas} />

		{/* SeeVideoFA */}
		<SeeVideoTemplate 
			{...SeeVideoTemplatePropsCommun}
			visible={seeVideoFA} fermer={CloseSeeVideoFA} voirProfil={ProfilFA2e} />


		<MenuBasTemplate visible={menuBas} fermer={CloseMenuBas} PublierAnnoncePageFA={PublierAnnoncePageFA} titre="Publier une annonce" />
		
		<ModifierTemplate 
			visible={publierAnnoncePageFA} fermer={ClosePublierAnnoncePageFA} titre="Publier une annonce" texte = "Écrivez l'annonce ..." textbtn="Publier" 
			valeur={ecrireAnnonce} setValeur={setEcrireAnnonce} Valider={PublierAnnonceFA} isLoading={isLoading666PublierAnnonceFA} changerUrl textarea />

		<ModifierTemplate 
			visible={modifierAnnoncePageFA} fermer={CloseModifierAnnoncePageFA} titre="Modifier l'annonce" texte = "Écrivez..." infos={texteAnnonceFA} 
			valeur={nouvelleAnnonce} setValeur={setNouvelleAnnonce} Valider={ModifierAnnonceFA} isLoading={isLoading666ModifierAnnonceFA} changerUrl textarea />


		<MonetizationEntrer visible={alraniBusinessAA} fermer={CloseAlraniBusinessAA} />
		
		<PortefeuilleSortie visible={alraniPayAA} fermer={CloseAlraniPayAA} />
		
		{/* infos solde Alrani Business - AA */}
		<InfosTemplate 
			visible={infosBalanceAlraniBusinessAA} fermer={CloseInfosBalanceAlraniBusinessAA} 
			texte="Votre Solde Florinato Business est de {monetizationBalanceAA} FCFA" />

		{/* infos solde Alrani Pay - AA */}
		<InfosTemplate 
			visible={infosBalanceAlraniPayAA} fermer={CloseInfosBalanceAlraniPayAA} 
			texte="Votre Solde Florinato Pay est de {balanceAlraniPayAA} FCFA" />


		  
		<PopupDuBasTemplate 
			visible={menuFA} fermer={CloseMenuFA} photo={photoFA} titre="Menu" GestionDuCompte={GestionDuCompteFA} Gestionnaire={GestionnaireFA}
			MettreEnAvantCompte={MettreEnAvantCompteFA} AdminFlorinato={AdminFlorinato} ComptesRecentsPageFA={ComptesRecentsPageFA} list/>
		  
		<ComptesRecentsTemplate {...ComptesRecentsPropsCommun} visible={comptesRecentsPageFA} fermer={CloseComptesRecentsPageFA} data={dataComptesFA} dev />
	

		<MessageTemplate 
			{...MessagePropsCommun} 
			visible={messageFA} fermer={CloseMessageFA} />
			
			
	    <PageTemplate 
		  visible={gestionDuCompteFA} fermer={CloseGestionDuCompteFA} data={filterAdminFA} profilMap={profilMap} gestionnaireCompte
		  clicSvg={OuvrirPublierSurVotreCompteFApb} titre="Mon compte - Listes des comptes qui peuvent publier sur votre compte" photo={photoFA} proprietaireCompte={false} />
		  
		<PageTemplate 
			visible={gestionnaireFA} fermer={CloseGestionnaireFA} data={filterAdminFA} profilMap={profilMap} proprietaireCompte
			titre="Gestionnaire - Listes des comptes ou vous avez été ajoutés" photo={photoFA} gestionnaireCompte={false} />
		  
	    <PageTemplate 
		  visible={mettreEnAvantCompteFA} fermer={CloseMettreEnAvantCompteFA} data={filterTopFA} profilMap={profilMap}
		  clicSvg={OuvrirMettreEnAvantFApb} titre="Listes des comptes mis en avant" photo={photoFA} />
		  
		<PageTemplate 
		  visible={adminFlorinato} fermer={CloseAdminFlorinato} data={filterAdminFlorinatoFA} profilMap={profilMap}
		  clicSvg={OuvrirAdminFlorinatopb} titre="Listes des comptes ajoutés comme Admin Florinato" photo={photoFA} />
		
		
	    <PopupDuBasTemplate 
		  visible={publierSurVotreCompteFApb} fermer={ClosePublierSurVotreCompteFApb} photo={photoFA} titre="Ajouter un compte qui pourra publier sur votre compte" 
		  listAccount={listAccountFA} valeur={rechercherUnCompteFA} setValeur={setRechercherUnCompteFA} cliquer={PublierSurVotreCompteFAconfp} setId={setId} search/>
	  
	    <PopupDuBasTemplate 
		  visible={mettreEnAvantFApb} fermer={CloseMettreEnAvantFApb} photo={photoFA} titre="Choisir le compte à mettre en avant" 
		  listAccount={listAccountFA} valeur={rechercherUnCompteFA} setValeur={setRechercherUnCompteFA} cliquer={MettreEnAvantFAconfp} setId={setId} search/>
	  
	    <PopupDuBasTemplate 
		  visible={adminFlorinatopb} fermer={CloseAdminFlorinatopb} photo={photoFA} titre="Ajouter un compte qui sera admin Florinato" 
		  listAccount={listAccountFA} valeur={rechercherUnCompteFA} setValeur={setRechercherUnCompteFA} cliquer={OuvrirAdminFlorinatoconfp} setId={setId} search/>
		  
		  
	  
	  <ConfirmationTemplate 
		  visible={publierSurVotreCompteFAconfp} fermer={ClosePublierSurVotreCompteFAconfp} 
		  isLoading={isLoading666AjouterAdminFA} Validerbtn={AjouterAdminFA} />
	  
	  <ConfirmationTemplate 
		  visible={mettreEnAvantFAconfp} fermer={CloseMettreEnAvantFAconfp} 
		  isLoading={isLoading666MettreEnAvantFA} Validerbtn={MettreEnAvantFA} />
	  
	  <ConfirmationTemplate 
		  visible={adminFlorinatoconfp} fermer={CloseAdminFlorinatoconfp} 
		  isLoading={isLoading666AjouterAdminFlorinato} Validerbtn={AjouterAdminFlorinato} />
		  
		  
		  
    {/* page pour modifier l'url  */}
	<ModifierTemplate 
		visible={modifierUrlPage} fermer={CloseModifierUrlPage} titre="Modifier l'url de la vidéo" infos={urlVideo}
		valeur={ecrire666modifierUrl} setValeur={setecrire666modifierUrl} Valider={ValiderUrl} isLoading={isLoading666ValiderUrl} changerUrl textarea />
	
	{/* reparer l'url  */} 
 	<ModifierTemplate 
		visible={reparerUrlPage} fermer={CloseReparerUrlPage} titre="Réparer l'url de la vidéo automatiquement (url Dropbox)" textbtn="Réparer" infos={urlVideo}
		Valider={ReparerUrl} isLoading={isLoading666ReparerUrl} changerUrl />
		
		
	<ModifierTemplate 
		visible={commenterPageFA} fermer={CloseCommenterPageFA} titre="Commenter la vidéo" texte = "Écrivez votre commentaire ..." infos={titreFA} 
		valeur={ecrireCommentaireFA} setValeur={setEcrireCommentaireFA} Valider={CommenterFA} isLoading={isLoading666CommenterFA} profilMap={profilMap} 
		data={filterCommentaireFA} setIdCommentaire={setIdCommentaire} setIdProprietaireCommentaire={setIdProprietaireCommentaire} changerUrl textarea lesCommentaires 
		RepondrePage={RepondrePageFA} />
		
		
	<ModifierTemplate 
		visible={modifierTitrePageFA} fermer={CloseModifierTitrePageFA} titre="Modifier le titre de la vidéo" texte = "Écrivez le titre ..." infos={titreFA} 
		valeur={nouveauTitre} setValeur={setNouveauTitre} Valider={ModifierTitreFA} isLoading={isLoading666ModifierTitreFA} changerUrl textarea />
		
	
	<ModifierTemplate 
		visible={changerMiniaturePage} fermer={CloseChangerMiniaturePage} Valider={ChangerMiniatureFA} isLoading={isLoading666ChangerMiniatureFA} 
		transVoirMiniature={transVoirMiniatureFA} miniature={miniatureFA} setFileVideo={setFileVideoFAA} second={second} setSecond={setSecond} 
		titre="Changer la miniature de la vidéo" changerMiniature />

	
	
	<PopupBasTextareaTemplate 
		visible={repondrePageFA} fermer={CloseRepondrePageFA} titre="Écrivez votre réponse" isLoading={isLoading666RepondreFA}
		valeur={ecrireReponseFA} setValeur={setEcrireReponseFA} titrebtn="Répondre" valider={RepondreFA} />
	  	

		
		{/* compte non connecté - FA */}
		<ProfilTemplate
			{...profilPropsCommun}
			visible={tonProfilPourNonConnecter} fermer={CloseTonProfilPourNonConnecter} video
			SeePhoto66profilFA={SeePhoto2e} voirVideo={SeeVideoFAPourNonConnecter} />
			
		<SeeVideoTemplate 
			{...SeeVideoTemplatePropsCommun}
			visible={seeVideoFAPourNonConnecter} fermer={CloseSeeVideoFAPourNonConnecter} voirProfil={ProfilFA2e} />
		
		
  
		{/* 2e profil	- (on affiche ton compte) - FA */}
		<ProfilTemplate 
			{...profilPropsCommun}
			visible={profilFA2e} fermer={CloseProfilFA2e} voirVideo={SeeVideoFA2e} video SeePhoto66profilFA={SeePhoto2e} />
				
		<SeeVideoTemplate 
			{...SeeVideoTemplatePropsCommun}
			visible={seeVideoFA2e} fermer={CloseSeeVideoFA2e} voirProfil={ProfilFA3e} />
		
			
	
		{/* 3e profil	- FA */}
		<ProfilTemplate 
			{...profilPropsCommun}
			visible={profilFA3e} fermer={CloseProfilFA3e} voirVideo={SeeVideoFA3e} video SeePhoto66profilFA={SeePhoto66profilFA} />

		<SeeVideoTemplate 
			{...SeeVideoTemplatePropsCommun}
			visible={seeVideoFA3e} fermer={CloseSeeVideoFA3e} voirProfil={CloseSeeVideoFA3e} />
		

		
		<MessageTemplate 
			{...MessagePropsCommun} 
			visible={messageFA2e} fermer={CloseMessageFA2e} />
		
		<PopupDuBasTemplate 
			visible={partagerContactPageFA} fermer={ClosePartagerContactPageFA} photo={photoFA} titre="Partager un contact" setIdContact={setIdContact}
			listAccount={listAccountFA} valeur={rechercherUnCompteFA} setValeur={setRechercherUnCompteFA} OuvrirMessagePage={OuvrirMessagePage66PartagerContactPageFA} search/>




		{/* choisir la video a ajouter à la photo - FA  */}
		{/* choisir la video a ajouter à la photo - FA  */}
		{addVideoPageFA && (<>
          <div className="publier-video-opacity">
            <div className="align">
              <div className="card">
				<div className="photo-25px" onClick={SeePhoto66profilFA}> <img src={getPhoto} alt=""/> </div>
				
                <div onClick={CloseAddVideoPageFA} className="block">
                  <div className="a"> <SvgVideo9 /> </div>
                  <div className="b"> <p>Publier votre vidéo</p> </div>
                </div>
                {/* block */}
				
				<div className="p-14px-center-espace-gris"> <p>Mettez votre vidéo dans Dropbox et mettez le lien de la vidéo ici</p> </div> 
				
				<div className="pre-14px-center-gris"> <pre>{lienDropbox}</pre> </div> 
				<Input texte="Lien de la vidéo.." valeur={lienDropbox} setValeur={setLienDropbox} />
				  
				  {dev && (<>
				  <Input texte="Lien github" valeur={lienGitHub} setValeur={setLienGitHub} /> 
				  <Input texte="Lien gitlab" valeur={lienGitLab} setValeur={setLienGitLab} /> </>)}
				  
				<div className="pre-14px-center-gris"> <pre>{ecrireTitre}</pre> </div> 
				<Input texte="Titre de la vidéo (facultatif)" valeur={ecrireTitre} setValeur={setecrireTitre} />
				  
				  
				<VideoMiniatureTemplate transVoirMiniature={transVoirMiniatureFA} miniature={miniatureFA} setFileVideo={setFileVideoFAA} second={second} setSecond={setSecond} />
				
				{isLoading666PublierVideoFAA ? (<div className="loader-display-flex"> <Loader/> </div>
				):(<div className="block-trois"> <button onClick={PublierVideoFAA}>Publier</button> </div> )}
					
				<div className="fermer"> <button onClick={CloseAddVideoPageFA}>Fermer</button> </div>

                <div className="block-quatre"> <p>Mettez votre vidéo dans Dropbox , Gitlab , ou Github</p></div> 	
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* publier-video-opacity */}
        </>)}
      {/* choisir la video a ajouter à la photo */}
			
			

		<SeePhotoTemplate visible={seePhoto66profilFA} fermer={CloseSeePhoto66profilFA} urlPhoto={photoCompteConnecter} />		
		
		<SeePhotoTemplate visible={seePhoto2e} fermer={CloseSeePhoto2e} urlPhoto={photoTonCompteFA} />
		
		<SeePhotoTemplate visible={seePhotoCouvertureVideo} fermer={CloseSeePhotoCouvertureVideo} urlPhoto={photoCouvertureVideo} />
		
		
		{/* voir la miniature - FA  */}
		<SeePhotoTemplate visible={voirMiniature} fermer={CloseVoirMiniature} urlPhoto={photoUrl} />
		
	

      {/* mes comptes Florinato */}
      {/* mes comptes Florinato */}
      {accountsFA && (<>
        <div className="accountsFA" onScroll={gererScrollComptes}>
          <div className="align">
            <div className="head">
              <div className="close">
                <div className="block-un" onClick={CloseAccountsFA}> <p>Fermer</p> </div>
                <div className="block-deux" onClick={Favorite66accountsFA}> <p>Créer un nouveau compte</p> </div>
              </div>
              {/* close */}
            </div>
            {/* head */}
			
						
            <div className="body">
				<MesComptesTemplate
					data={dataMesComptesFA} dataCompteConnecté={infosCompteConnecterById} listMesComptes={listMesComptesFA}
					setIdExpediteur={setIdExpediteur} idCompteConnecter={idCompteConnecter} setIdCompteConnecter={setIdCompteConnecter} 
					valeur={rechercherMonCompteFA} setValeur={setRechercherMonCompteFA} cliquerSurMonCompte={DataFA} />
	
            </div>
            {/* body */} 
          </div>
          {/* align */}
        </div>
        {/* accountsFA */}
      </>)}
      {/* mes comptes Florinato */}


      {/* on affiche les favoris 66accountsFA */}
      {/* on affiche les favoris 66accountsFA */}
      {favorite66accountsFA && (<>
        <div className="favoriteFA">
        <div className="align">
          <div className="head" onClick={CloseFavorite66accountsFA}> 
            <div className="block-one"> <p>Choisissez une photo de profil</p> </div>

            <div className="block-two"> 
              <div className="a"> <img src={photoFA} alt=""/> </div>
              <div className="b"> <SvgBottom5/> </div>
            </div>
            {/* block-two */}
          </div>
          {/* head */}

          <div className="body">
            <div className="card">
              <div className="block-one">                
                <div className="a"><input onChange={(e) => setFile66favoriteFA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png"/> </div>
           
                {isLoading66favoriteFA ? (<><div className="b"> <Loader/> </div></>
                ):(<><div className="b"> <button onClick={AddPhoto66favoriteFA}>Valider</button> </div></>)}
              </div>
              {/* block-one */}

              <div className="child">
                {allMessageFA.map((api) => (
                <div onClick={NewAccountPageFA}>
                  <ChildApi66favoriteFA api={api} />
                </div>
                ))}
              </div>
              {/* child */}

              <p style={{ paddingTop: "100px" }}></p>
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* favoriteFA */}
      </>)}
      {/* on affiche les favoris 66accountsFA */}


      {/* page pour créer un nouveau compte Florinato */}
      {/* page pour créer un nouveau compte Florinato */}
      {newAccountPageFA && (<>
        <div className="newAccountPageFA">
          <div className="align">
            <div className="head"></div>
            {/* head */} 

            <div className="body">
              <div className="a" onClick={CloseNewAccountPageFA}> <p>Créer un nouveau compte Florinato</p> </div>
              <div className="b"> <img onClick={SeePhotoFA} src={urlPhoto} alt=""/> </div>
              <div className="c"> <pre>{nameNewAccountFA}</pre> </div>

              <div className="a"> <input type="text" placeholder="Nom du compte.." value={nameNewAccountFA} onChange={(e) => setNameNewAccountFA(e.target.value)}/> </div>
              <div className="a"> <button onClick={NewAccountFA}>Créer</button> </div>
              <div className="b"> <p onClick={CloseNewAccountPageFA}>Annuler</p> </div>
            </div>
            {/* body */}
          </div>
          {/* align */}
        </div>
        {/* newAccountPageFA */}
      </>)}
      {/* page pour créer un nouveau compte Florinato */}



      {/* rencontre - FA */}
      {rencontreFA && (<>
        <div className="rencontreFA">
          <div className="head">
            <div className="block-un" onClick={CloseRencontreFA}> <SvgLove2/> <p>Rencontre</p> </div>
            <div className="block-deux"> <SvgAdd/> </div>
          </div>
          {/* head */}

          <div className="body">
          </div>
          {/* body */}
        </div>
        {/* rencontreFA */}
      </>)} 
      {/* rencontre - FA */}


      {/* on affiche les messages de groupe dans l'application x */}
      {/* on affiche les messages de groupe dans l'application x */}
      {messagePublicXA && (<>
          <div className="messageXA">
              <div className="close">
                <div onClick={CloseMessagePublicXA} className="block-un">
                  <div className="a"> <img src={xLogo} alt="" /> </div>
                  <div className="b"> <p>Découverte</p> </div>
                  {/* a */}
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <div onClick={PopularityAccountsPageFA} className="a"> <SvgAdd5 /> </div>
                  <div onClick={RefreshXA} className="a"> <SvgRefresh /> </div>
                  <div onClick={ProfilFA} className="b"> <p>{namePersonConnectedFA}</p> </div>
                  {dev && (<>
                  <div onClick={MoreOptions666messageAA} className="a"> <SvgFile /> </div>
                  
                  <div className="b"> <SvgPointsVertical /> </div></>)}
                </div>
                {/* block-deux */} 
              </div>
              {/* close */}

              {/* ici c'est pour mettre l'espacement entre le navbar top et les donnees de l'api */}
              <div className="espacement-navbar-top-et-donnees-api"></div>

              <div onClick={PageRedirection666ChildApiDecouverteXA}>
              {filterMessageXA.map((api) => (<>
                <ChildApiMessageXA api={api} />
              </>))}
              </div>

              <p style={{ paddingTop: "100px" }}></p>

            {/* ecrire message (ca c'est l'input pour ecrire un message) */}
            <div className="write">
              <div className="c"> <SvgFile /> </div>
              <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={myMessageAA} onChange={(e) => setMyMessageAA(e.target.value)}></textarea> </div>
              <div onClick={SendMessageAA} className="b"> <SvgSend /> </div>
            </div>
            {/* write */}
          </div>
          {/* messageXA */}
        </>
      )}
      {/* on affiche les messages de groupe dans l'application x */}


      {/* Les comptes les plus populaires sur florinato */}
      {/* Les comptes les plus populaires sur florinato */}
      {popularityAccountsPageFA && (<>
        <div className="popularityAccountsPageFA">
          <div className="close">
            <div className="block-un" onClick={ClosePopularityAccountsPageFA}>
              <div className="a">
                <div className="aa"> <SvgLeft/> </div>
                <div className="bb"> <img src={florinatoLogo} alt=""/> </div>
                <div className="p-17px"> <p>Populaires sur Florinato</p> </div>
              </div>
              {/* a */}
            </div>
            {/* block-un */}
          </div>
          {/* close */}

          <div className="body">
            <div className="api" onClick={PageRedirection666ChildApi66popularityAccountsPageFA}>
              {filterPopularityAccountsFA.map((api) => (<>
                <ChildApi66popularityAccountsPageFA api={api} />
              </>))}
            </div>
            {/* api */} 
          </div>
          {/* body */}
        </div>
        {/* popularityAccountsPageFA */}
      </>)}
      {/* Les comptes les plus populaires sur florinato */}
	

	  
      {/* délivrer un numéro virtuel (admin florinato) */}
      {/* délivrer un numéro virtuel (admin florinato) */}
      {delivrerNumeroVirtuel && (<>
        <div className="saisirNomBeneficiaireNumeroVirtuelGratuitIAC">
          <div className="align">
            <div className="card">
              <div className="block-un"> <p onClick={CloseDelivrerNumeroVirtuel}>Offrir un Numéro virtuel</p> </div>
              <div className="block-deux"> <input type="text" value={writeVirtualNumberAF} onChange={(e) => setWriteVirtualNumberAF(e.target.value)} placeholder="Numéro virtuel" /> </div>
              <div className="block-deux"> <input type="text" value={writeNameAF} onChange={(e) => setWriteNameAF(e.target.value)} placeholder="Nom du propriétaire" /> </div>
              <div className="block-deux"> <input type="text" value={writeCountryAF} onChange={(e) => setWriteCountryAF(e.target.value)} placeholder="Pays" /> </div>
              <div className="block-deux"> <input type="text" value={writeSexAF} onChange={(e) => setWriteSexAF(e.target.value)} placeholder="Sexe" /> </div>

              {isLoading66delivrerNumeroVirtuel ? (<><div className="loader-display-flex" onClick={DelivrerNumeroVirtuel}> <Loader /> </div></>):(<>
              <div className="block-trois">
                <button onClick={Delivrer}>
                  <p>Délivrer</p>
                  <hr />
                </button>
              </div></>)}
              {/* block-trois */}

              {/* on affiche la liste des numeros virtuels délivrés */}
              <div className="api"> 
              {filter66delivrerNumeroVirtuelAf.map((api) => (<>
                <ChildApi66delivrerNumeroVirtuelAf api={api} />
              </>))}
              </div>
              {/* api */}
            </div>
            {/* card */}
          </div>
          {/* align */}
        </div>
        {/* saisirNomBeneficiaireNumeroVirtuelGratuitIAC */}
      </>)}
      {/* délivrer un numéro virtuel (admin florinato) */}


      {/* Numero Offert Success (ça c'est la page de success, lorsque le numero virtuel a ete offert, on va afficher cette page) */}
      {/* Numero Offert Success (ça c'est la page de success, lorsque le numero virtuel a ete offert, on va afficher cette page) */}
      {numeroOffertSuccess && (<>
        <div onClick={CloseNumeroOffertSuccess} className="numeroOffertSuccessIAC">
          <div className="align">
            <div className="card">
              <div className="display"> <p>Numéro virtuel offert</p> <SvgValidate3/> </div>
            </div>
            {/* card */}
          </div>
          {/* align */}
        </div>
        {/* numeroOffertSuccessIAC */}
      </>)}
      {/* Numero Offert Success (ça c'est la page de success, lorsque le numero virtuel a ete offert, on va afficher cette page) */}



      {/* on affiche le compte de l'autre - FA */}
      {/* on affiche le compte de l'autre - FA */}
      {profilOtherFA && (<>
        <div className="profilOtherFA">
          <div className="close">
            <div className="block">
              <div className="block-un">
                <div className="a" onClick={CloseProfilOtherFA}> <SvgLeft/> </div>
                <div className="b"> <pre>{nameOther}</pre> </div>
                <div className="c"> <img onClick={GroupOtherFA} src={photoOther} alt=""/> </div>
              </div>
              {/* block-un */}

              <div className="block-deux">
                <div className="a" onClick={MessageFA}> <SvgMessage/> <p>Message</p> </div>
              </div>
              {/* block-deux */}
            </div>
            {/* block */}
          </div>
          {/* close */}

          <div className="body">
            <div className="block-un"> <img onClick={SeePhotoOther} src={photoOther} alt=""/> </div>

            <div className="block-deux">
              <div className="a">
                <div className="aa"> <SvgFavoris/> <p>Popularité</p> </div>
                <div className="bb"> <p>{popularityOther} visites</p> </div>
              </div>
              {/* a */} 

              {follow && (<><div className="b"> <p>Abonné</p> <SvgValidate4/> </div></>)}

              {!follow && (<>
              {isLoading66FollowFA && (<><div className="b"> <p>Abonné..</p> </div></>)}
              {!isLoading66FollowFA && (<><div className="b"> <button onClick={FollowFA}>S'abonner</button> </div></>)} </>)}
            </div> 
            {/* block-deux */}

            {dev && (<><div className="block-trois" onClick={JeuxFA}> <p>Jouer</p> </div></>)}

            <div className="api" onClick={PageRedirection66ChildApi66profilOtherFA}>
            {filter66profilOtherFA.map((api) => (<>
              <ChildApi66profilOtherFA api={api} />
            </>))}
            </div> 

            <div className="api2">
              {filter66profilOtherFA.map((api2) => (<>
                <ChildApi266profilOtherFA api2={api2} />
              </>))}
            </div> 
          </div>
          {/* body */}
        </div>
        {/* profilOtherFA */} 
      </>)}
      {/* on affiche le compte de l'autre - FA */}


      {/* jeuxFA */}
      {/* jeuxFA */}
      {jeuxFA && (<>
        <div className="jeuxFA">
          <div className="align">
            <div className="head">
              <div className="close">
                <div className="block-un" onClick={CloseJeuxFA}> <p>Jouez et Gagnez</p> </div>
                <div className="block-deux"> <p></p> </div>
              </div>
              {/* close */}
            </div>
            {/* head */}

            <div className="body">
              <div className="block-un"> <p>Jouez uniquement un montant que vous pouvez perdre</p> </div>
              <div className="block-un" onClick={DebuterJeuxFA}> <p>Debuter le jeux</p> </div>

              <div className="api">
                {apiMessageFA.map((api) => (<>
                  <ChildApi66jeuxFA api={api} />
                </>))}
              </div> 

              <div className="block-deux">
                <div className="a" onClick={Chiffre1FA}> <p>1</p> </div>
                <div className="a" onClick={Chiffre2FA}> <p>2</p> </div>
                <div className="a" onClick={Chiffre3FA}> <p>3</p> </div>
                <div className="a" onClick={Chiffre4FA}> <p>4</p> </div>
              </div> 
              {/* block-deux */}

              {perduFA && (<><div className="block-trois"> <p>Perdu !</p> </div></>)}
              {gagnerFA && (<><div className="block-quatre"> <p>Gagné !</p> </div></>)}
            </div> 
            {/* body */}
          </div>
          {/* align */}
        </div>
        {/* jeuxFA */}
      </>)}
      {/* jeuxFA */}


      {/* on affiche le groupe de l'autre - FA */}
      {/* on affiche le groupe de l'autre - FA */}
      {groupOtherFA && (<>
        <div className="groupOtherFA">
          <div className="head">
            <div className="close">
              <div className="block-un">
                <div className="a" onClick={CloseGroupOtherFA}>
                  <div className="aa"> <SvgLeft/> </div>
                  <div className="bb"> <img src={photoGroupOther} alt=""/> </div>
                </div>

                <div className="b">
                  <div className="aa"> <p>{nameGroupOther}</p> </div>
                  <div className="bb"> <p>Groupe</p> </div>
                </div> 
                {/* b */}
              </div>
              {/* block-un */}

              <div className="block-deux">
                <div className="aa"> <SvgPopularity/></div>

                <div className="bb"> 
                  <p>{visitOther} visites</p>
                  <p>{clicOther} clic</p> 
                </div>
                {/* bb */}
              </div>
              {/* block-deux */}
            </div>
            {/* close */}

          <div className="epingler"> 
            <div className="a"> <img src={photoGroupOther} alt=""/> </div>
            <div className="b"> <pre>{messageEpinglerFA}</pre> </div>
          </div>
          {/* epingler */}
        </div>
        {/* head */}

          <div className="body">
            <div className="api" onClick={PageRedirection66groupOtherFA}>
            {filterFA.map((api) => (<>
              <ChildApi66groupOtherFA api={api} />
            </>))}
            </div>
          </div>
          {/* body */}

          <div className="footer">
            <div className="block-un">
              <div className="c" onClick={FavoriteFA}> <SvgFile/> </div>
              <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={writeMessage66groupOtherFA} onChange={(e) => setWriteMessage66groupOtherFA(e.target.value)}></textarea> </div>
              <div className="b" onClick={SendMessage66groupOtherFA}> <SvgSend/> </div>
            </div>
            {/* block-un */}
          </div>
          {/* footer */}
        </div>
        {/* groupOtherFA */}
      </>)}
      {/* on affiche le groupe de l'autre - FA */}


      

      {/* on affiche les favoris au niveau des messages */}
      {/* on affiche les favoris au niveau des messages */}
      {favorite66messageFA && (<>
        <div className="favoriteFA">
          <div className="align">
            <div onClick={CloseFavorite66messageFA} className="head"> 
              <div className="block-one"> <p>Vos photos et vidéos</p> </div>

              <div className="block-two"> 
                <div className="a"> <img src={photoFA} alt=""/> </div>
                <div className="b"> <SvgBottom5/> </div>
              </div>
              {/* block-two */}
            </div>
            {/* head */}

          <div className="body">
            <div className="card">
              <div className="block-one">                
                <div className="a"><input onChange={(e) => setFilePhoto66favorite66messageFA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png"/> </div>
                
                {isLoading66favorite66messageFA ? (<>
                <div className="b"> <Loader/> </div></>):(<>
                <div className="b"> <button onClick={AddPhoto66favorite66messageFA}>Valider</button> </div></>)}
              </div>
              {/* block-one */}

              <div className="child">
                {allMessageFA.map((api) => (
                <div onClick={PageRedirection66favorite66messageFA}>
                  <ChildApi66favoriteFA api={api} />
                </div>))}
              </div>
              {/* child */}

              <p style={{ paddingTop: "100px" }}></p>
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* favoriteFA */}
      </>)}
      {/* on affiche les favoris au niveau des messages */}


      {/* selected2FA (selectionner photo, vidéo, texte,.. ) */}
      {/* selected2FA (selectionner photo, vidéo, texte,.. ) */}
      {selected2FA && (<>
        <div className="selectedFA">
          <div className="align">
            <div className="head"> 
              <div className="block-one" onClick={CloseSelected2FA}> <SvgLeft/> </div>

              <div className="block-two"> 
                {type === "3" && (<>
                <div className="a" onClick={SeePhotoFA}> <Svg1Photo3/> </div>
                <div className="a" onClick={AddVideoPageFA}> <SvgHorizontal3/> </div></>)} {/* type=3 */}

                <div className="b" onClick={Annuler66selected2FA}> 
                  <div className="aa"> <p>Annuler</p> </div>
                  <div className="bb"> <img src={photoFA} alt=""/> </div>
                </div>
                {/* b */}
              </div>
              {/* block-two */}
            </div>
            {/* head */}

            <div className="body">
            {type === "1" && (<> {/* type=1, text */}
            <div className="block-one"> 
              <div className="b"> <pre>{message}</pre> </div>
              <div className="b"> <pre>{writeReponseFA}</pre> </div>
            </div> </>)}
            
            {type === "41" && (<>
            <div className="block-one"> 
              <div className="b"> <pre>{message}</pre> </div>
              <div className="b"> <pre>{writeReponseFA}</pre> </div>
            </div> </>)}

          {type === "2" && (<> {/* type=2, photo */}
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="b"> <img onClick={ClicPhotoFA} src={urlPhoto} alt=""/> </div>
            <div className="c"> <pre>{writeReponseFA}</pre> </div>
          </div> </>)}
          
          {type === "42" && (<>
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="b"> <img onClick={ClicPhotoFA} src={urlPhoto} alt=""/> </div>
            <div className="c"> <pre>{writeReponseFA}</pre> </div>
          </div></>)}

          {type === "3" && (<> {/* type=3, video */}
          <div className="block-one"> 
            <div className="b"> <pre>{message}</pre> </div>
              
            <div className="a">
              <div className="aa"> <img onClick={ClicVideoFA} src={urlPhoto} alt=""/> </div>
              <div className="bb"> <button onClick={ClicVideoFA}><SvgPlay2/></button> </div>
            </div>
            
            <div className="b"> <pre>{writeReponseFA}</pre> </div>
          </div></>)}
          {/* type=3, video */}

          {type === "43" && (<> 
          <div className="block-one"> 
            <div className="b"> <pre>{message}</pre> </div>
              
            <div className="a">
              <div className="aa"> <img onClick={ClicVideoFA} src={urlPhoto} alt=""/> </div>
              <div className="bb"> <button onClick={ClicVideoFA}><SvgPlay2/></button> </div>
            </div>
            
            <div className="b"> <pre>{writeReponseFA}</pre> </div>
          </div></>)}
          {/* type=43, video */}

            <div className="footer">
              <div className="block-un">
                <div className="c" onClick={Favorite66selectedFA}> <SvgFile/> </div>
                <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={writeReponseFA} onChange={(e) => setWriteReponseFA(e.target.value)}></textarea> </div>
                <div className="b" onClick={SendReponseFA}> <SvgSend/> </div>
              </div>
              {/* block-un */}
            </div>
            {/* footer */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* selectedFA */}
      </>)}
      {/* selected2FA (selectionner photo, vidéo, texte,.. ) */}

      
      {/* selectedFA (selectionner une vidéo) */}
      {/* selectedFA (selectionner une vidéo) */}
      {selectedFA && (<>
        <div className="selectedFA">
          <div className="align">
            <div className="head"> 
              <div className="block-one" onClick={CloseSelectedFA}> <SvgLeft/> </div>

              <div className="block-two"> 
                {type === "3" && (<>
                <div className="a" onClick={SeePhotoFA}> <Svg1Photo3/> </div>
                <div className="a" onClick={AddVideoPageFA}> <SvgHorizontal3/> </div></>)} {/* type=3 */}

                <div className="b" onClick={Annuler66writeMessagePageFA}> 
                  <div className="aa"> <p>Annuler</p> </div>
                  <div className="bb"> <img src={photoFA} alt=""/> </div>
                </div>
                {/* b */}
              </div>
              {/* block-two */}
            </div>
            {/* head */}

          <div className="body">
            {type === "1" && (<> {/* type=1, text */}
            <div className="block-one"> 
              <div className="b"> <pre>{message}</pre> </div>
              <div className="b"> <pre>{writeReponseFA}</pre> </div>
            </div> </>)}
            
            {type === "41" && (<>
            <div className="block-one"> 
              <div className="b"> <pre>{message}</pre> </div>
              <div className="b"> <pre>{writeReponseFA}</pre> </div>
            </div> </>)}

          {type === "2" && (<> {/* type=2, photo */}
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="b"> <img onClick={ClicPhotoFA} src={urlPhoto} alt=""/> </div>
            <div className="c"> <pre>{writeReponseFA}</pre> </div>
          </div> </>)}
          
          {type === "42" && (<>
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="b"> <img onClick={ClicPhotoFA} src={urlPhoto} alt=""/> </div>
            <div className="c"> <pre>{writeReponseFA}</pre> </div>
          </div></>)}


          {type === "3" && (<> {/* type=3, video */}
          <div className="block-one"> 
            <div className="b"> <pre>{message}</pre> </div>
              
            <div className="a">
              <div className="aa"> <img onClick={ClicVideoFA} src={urlPhoto} alt=""/> </div>
              <div className="bb"> <button onClick={ClicVideoFA}><SvgPlay2/></button> </div>
            </div>
            
            <div className="b"> <pre>{writeReponseFA}</pre> </div>
          </div></>)}
          {/* type=3, video */}

          {type === "43" && (<> 
          <div className="block-one"> 
            <div className="b"> <pre>{message}</pre> </div>
              
            <div className="a">
              <div className="aa"> <img onClick={ClicVideoFA} src={urlPhoto} alt=""/> </div>
              <div className="bb"> <button onClick={ClicVideoFA}><SvgPlay2/></button> </div>
            </div>
            
            <div className="b"> <pre>{writeReponseFA}</pre> </div>
          </div></>)}
          {/* type=43, video */}
          
            <div className="footer">
              <div className="block-un">
                <div className="c" onClick={Favorite66selectedFA}> <SvgFile/> </div>
                <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={writeReponseFA} onChange={(e) => setWriteReponseFA(e.target.value)}></textarea> </div>
                <div className="b" onClick={SendReponseFA}> <SvgSend/> </div>
              </div>
              {/* block-un */}
            </div>
            {/* footer */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* selectedFA */}
      </>)}
      {/* selectedFA */}


      {/* toast (notification en cours d'actualisation) - XA */}
      {/* toast (notification en cours d'actualisation) - XA */}
      {waitRefreshXA && (<>
        <div onClick={CloseWaitRefreshXA} className="toastSettings">
          <div className="bottom">
            <div className="center">
              <button>. . .</button>
            </div>
            {/* center */}
          </div>
          {/* bottom */}
        </div>
        {/* toastSettings */}
      </>)}
      {/* toast (notification en cours d'actualisation) - XA */}


      {/* toast (notification actualisé) - XA */}
      {/* toast (notification actualisé) - XA */}
      {refreshSuccessXA && (<>
        <div onClick={CloseRefreshSuccessXA} className="toastRefreshIA">
          <div className="bottom">
            <div className="card">
              <button> <p>Actualiser</p><SvgValidate4 /> </button>
            </div>
            {/* card */}
          </div>
          {/* bottom */}
        </div>
        {/* toastRefreshIA */}
      </>)}
      {/* toast (notification actualisé) - XA */}


      {/* on affiche les favoris 66selectedFA */}
      {/* on affiche les favoris 66selectedFA */}
      {favorite66selectedFA && (<>
        <div className="favoriteFA">
          <div className="align">
            <div onClick={CloseFavorite66selectedFA} className="head"> 
              <div className="block-one"> <p>Vos photos et vidéos</p> </div>

              <div className="block-two"> 
                <div className="a"> <img src={photoFA} alt=""/> </div>
                <div className="b"> <SvgBottom5/> </div>
              </div>
              {/* block-two */}
            </div>
            {/* head */}

            <div className="body">
            <div className="card">
              <div className="block-one">                
                <div className="a"><input onChange={(e) => setFile66favoriteFA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png"/> </div>
           
                {isLoading66favoriteFA ? (<><div className="b"> <Loader/> </div></>
                ):(<><div className="b"> <button onClick={AddPhoto66favoriteFA}>Valider</button> </div></>)}
              </div>
              {/* block-one */}

              <div className="child">
                {allMessageFA.map((api) => (
                <div onClick={PageRedirection66ChildApi66favorite66selectedFA}>
                  <ChildApi66favorite66selectedFA api={api} />
                </div>))}
              </div>
              {/* child */}

              <p style={{ paddingTop: "100px" }}></p>
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* favoriteFA */}
      </>)}
      {/* on affiche les favoris 66selectedFA */}


      {/* writeMessagePage66selectedFA - page pour ecrire un message et envoyer la photo - FA */}
      {/* writeMessagePage66selectedFA - page pour ecrire un message et envoyer la photo - FA */}
      {writeMessagePage66selectedFA && (<>
        <div className="writeMessagePageFA">
          <div className="align">
            <div className="head"> 
              <div className="block-one" onClick={CloseWriteMessagePage66selectedFA}> 
                {isLoading66addVideoPageFA ? (<div> <SvgLeft/><p>Vidéo en cours d'importation..</p> </div>
                ):(<><div> <SvgLeft/> </div></>)}
              </div>

              <div className="block-two"> 
                <div className="a" onClick={SeePhotoFAreq}> <Svg1Photo3/> </div>
                <div className="a" onClick={AddVideoPageFA}> <SvgHorizontal3/> </div>

                <div className="b" onClick={Annuler66writeMessagePageFA}> 
                  <div className="aa"> <p>Annuler</p> </div>
                  <div className="bb"> <img src={photoFA} alt=""/> </div>
                </div>
                {/* b */}
              </div>
              {/* block-two */}
            </div>
            {/* head */}

      <div className="body">
        <div className="card">
          {type === "1" && (<> {/* type=1, text */}
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="c"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
          </div></>)}
          
          {type === "41" && (<>
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="c"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
          </div></>)}

          {type === "2" && (<> {/* type=2, photo */}
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="b"> <img onClick={SeePhotoFAreq} src={urlPhotoreq} alt=""/> </div>
            <div className="c"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
          </div></>)}

          {type === "42" && (<> 
          <div className="block-two"> 
            <div className="a"> <pre>{message}</pre> </div>
            <div className="b"> <img onClick={SeePhotoFAreq} src={urlPhotoreq} alt=""/> </div>
            <div className="c"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
          </div></>)}

          {type === "3" && (<> {/* type=3, video */}
          <div className="block-one"> 
            <div className="b"> <pre>{message}</pre> </div>
              
            <div className="a">
              <div className="aa"> <img onClick={SeeVideoFAreq} src={urlPhotoreq} alt=""/> </div>
              <div className="bb"> <button onClick={SeeVideoFAreq}><SvgPlay2/></button> </div>
            </div>
            
            <div className="b"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
          </div></>)}

          {type === "43" && (<>
          <div className="block-one"> 
            <div className="b"> <pre>{message}</pre> </div>
              
            <div className="a">
              <div className="aa"> <img onClick={SeeVideoFAreq} src={urlPhotoreq} alt=""/> </div>
              <div className="bb"> <button onClick={SeeVideoFAreq}><SvgPlay2/></button> </div>
            </div>
            
            <div className="b"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
          </div></>)}
          {/* type=3, video */}


            <p style={{ paddingTop: "100px" }}></p>

            <div className="block-two">
              <div className="write">
                <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={writeReponseFA} onChange={(e) => setWriteReponseFA(e.target.value)}></textarea> </div>
                <div className="b" onClick={SendReponseFA}> <SvgSend/> </div>
              </div>
              {/* write */}
            </div>
            {/* block-two */}
           </div>
           {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* writeMessagePageFA */}
      </>)}
      {/* writeMessagePage66selectedFA - page pour ecrire un message et envoyer la photo - FA */}


      {/* on affiche les favoris FA */}
      {/* on affiche les favoris FA */}
      {favoriteFA && (<>
        <div className="favoriteFA">
          <div className="align">
            <div onClick={CloseFavoriteFA} className="head"> 
              <div className="block-one"> <p>Vos photos et vidéos</p> </div>

              <div className="block-two"> 
                <div className="a"> <img src={photoFA} alt=""/> </div>
                <div className="b"> <SvgBottom5/> </div>
              </div>
              {/* block-two */}
            </div>
            {/* head */}

          <div className="body">
            <div className="card">
              <div className="block-one">                
                <div className="a"><input onChange={(e) => setFile66favoriteFA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png"/> </div>
           
                {isLoading66favoriteFA ? (<><div className="b"> <Loader /> </div></>
                ):(<><div className="b"> <button onClick={AddPhoto66favoriteFA}>Valider</button> </div></>)}
              </div>
              {/* block-one */}

              <div className="child">
                {allMessageFA.map((api) => (
                <div onClick={PageRedirection66ChildApi66favoriteFA}>
                  <ChildApi66favoriteFA api={api} />
                </div>))}
              </div>
              {/* child */}

              <p style={{ paddingTop: "100px" }}></p>
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* favoriteFA */}
      </>)}
      {/* on affiche les favoris FA */}


      {/* page pour ecrire un message et envoyer la photo - FA */}
      {/* page pour ecrire un message et envoyer la photo - FA */}
      {writeMessagePageFA && (<>
        <div className="writeMessagePageFA">
          <div className="align">
            <div className="head"> 
              <div className="block-one" onClick={CloseWriteMessagePageFA}> 
                {isLoading66addVideoPageFA ? (<div> <SvgLeft/><p>Vidéo en cours d'importation..</p> </div>
                ):(<><div> <SvgLeft/> </div></>)}
              </div>

              <div className="block-two"> 
                <div className="a" onClick={SeePhotoFA}> <Svg1Photo3/> </div>
                <div className="a" onClick={AddVideoPageFA}> <SvgHorizontal3/> </div>

                <div className="b" onClick={Annuler66writeMessagePageFA}> 
                  <div className="aa"> <p>Annuler</p> </div>
                  <div className="bb"> <img src={photoFA} alt=""/> </div>
                </div>
                {/* b */}
              </div>
              {/* block-two */}
            </div>
            {/* head */}

          <div className="body">
            <div className="card">
              <div className="block-one">
                {type === "20" && (<><div className="a"> <img onClick={SeePhotoFAreq} src={urlPhotoreq} alt=""/> </div></>)}
                {type === "21" && (<><div className="a"> <img onClick={SeeVideoFAreq} src={urlPhotoreq} alt=""/> </div></>)}
                <div className="b"> <pre>{writeMessage66writeMessagePageFA}</pre> </div>
              </div>
              {/* "block-one */}

            <p style={{ paddingTop: "100px" }}></p>

            <div className="block-two">
              <div className="write">
                <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={writeMessage66writeMessagePageFA} onChange={(e) => setWriteMessage66writeMessagePageFA(e.target.value)}></textarea> </div>
                {type === "20" && (<><div className="b" onClick={SendPhoto66writeMessagePageFA}> <SvgSend/> </div></>)}
                {type === "21" && (<><div className="b" onClick={PostVideoFA}> <SvgSend/> </div></>)}
              </div>
              {/* write */}
            </div>
            {/* block-two */}
           </div>
           {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* writeMessagePageFA */}
      </>)}
      {/* page pour ecrire un message et envoyer la photo - FA */}


      

      {/* page pour voir la photo - FA */}
      {/* page pour voir la photo - FA */}
      {seePhotoFA && (<>
      <div className="seePhotoFA">
        <div className="close">
          <div className="a" onClick={FullScreen}>Plein écran <SvgFullScreen2/></div>
          <div className="b" onClick={CloseSeePhotoFA}> <SvgClose2 /> </div>
        </div>
        {/* close */}

        <div className="body"> 
			<img src={urlPhoto} alt="" /> 
		</div>
        {/* body*/}
      </div>
      {/* seePhotoFA */}
      </>)}
      {/* page pour voir la photo - FA */}
	  
	  

      {/* voir la photo (lors de la requete) - FA */}
      {/* voir la photo (lors de la requete) - FA */}
      {seePhotoFAreq && (<>
        <div className="seePhotoFA">
          <div className="close">
            <div className="a" onClick={FullScreen}>Plein écran <SvgFullScreen2/></div>
            <div className="b" onClick={CloseSeePhotoFAreq}> <SvgClose2 /> </div>
          </div>
          {/* close */}

          <div className="body"> <img src={urlPhotoreq} ref={videoRef} alt="" /> </div>
          {/* body*/}
        </div>
        {/* seePhotoFA */}
      </>)}
      {/* voir la photo (lors de la requete) - FA */}

      
      {/* voir la video (lors de la requete) - FA */}
      {/* voir la video (lors de la requete) - FA */}
      {seeVideoFAreq && (<>
        <div className="seeVideoFA"> 
          <div className="close">
            <div className="a" onClick={FullScreen}>Plein écran <SvgFullScreen2/></div>
            <div className="b" onClick={CloseSeeVideoFAreq}> <SvgClose2 /> </div>
          </div>
          {/* close */}

          <div className="body">
            {/* on affiche la video */}
            <div className="block-video">
              <video ref={videoRef} autoPlay={"autoplay"} muted loop controls> <source src={urlVideoreq} type="video/mp4"/> </video>
            </div>
          </div>
          {/* body */}
        </div>
        {/* seeVideoFA */}
      </>)}
      {/* voir la video (lors de la requete) - FA */}


      {/* afficher la photo de l'autre - FA */}
      {/* afficher la photo de l'autre - FA */}
      {seePhotoOther && (<>
      <div className="seePhotoFA">
        <div className="close">
          <div className="a" onClick={FullScreen}>Plein écran <SvgFullScreen2/></div>
          <div className="b" onClick={CloseSeePhotoOther}> <SvgClose2/> </div>
        </div>
        {/* close */}

        <div className="body"> <img src={photoOther} ref={videoRef} alt=""/> </div>
        {/* body*/}
      </div>
      {/* seePhotoFA */}
      </>)}
      {/* afficher la photo de l'autre - FA */}


     

      {/* on affiche les messages privés dans l'application x */}
      {/* on affiche les messages privés dans l'application x */}
      {messageXA && (<>
          <div className="messageAA">
              <div className="close">
                <div className="block-un" onClick={AddVideoFA}>
                  <div onClick={CloseMessageXA} className="a"> <SvgLeft /> </div>
                  {/* a */}

                  <div onClick={CloseMessageXA} className="b">
                    {photoOtherAA === "0" ? (<><SvgProfil /></>
                    ):(<><img src={photoOtherAA} alt="" /></>)}
                  </div>
                  {/* b */}

                  <div onClick={ProfilOtherAA} className="c">
                    <div className="aa">
                      <p>{nameOtherAA}</p>
                      {badgeOtherAA === "1" && (<><SvgBadge /></>)}
                    </div>
                    {/* aa */}

                    <div className="bb"> <p>{dateParser(onlineOtherAA)} (Dernière connexion)</p> </div>
                    {/* bb */}
                  </div>
                  {/* c */}
                </div>
                {/* block-un */}

                <div className="block-deux">
                  {dev && (<>
                  <div onClick={MoreOptions666messageAA} className="a"> <SvgFile /> </div>
                  <div className="b"> </div>
                  <div className="b"> <SvgPointsVertical /> </div></>)}
                </div>
                {/* block-deux */}
              </div>
              {/* close */}

              {/* ici c'est pour mettre l'espacement entre le navbar top et les donnees de l'api */}
              <div className="espacement-navbar-top-et-donnees-api"></div>

              <div onClick={PageRedirection666ChildApiMessageAA}>
              {filterMessageXA.map((api) => (<>
                <ChildApiMessageXA api={api} />
              </>))}
              </div>

              <p style={{ paddingTop: "100px" }}></p>

            {/* ecrire message (ca c'est l'input pour ecrire un message) */}
            <div className="write">
              <div className="a"> <textarea type="text" placeholder="Écrivez un message..." value={myMessageAA} onChange={(e) => setMyMessageAA(e.target.value)}></textarea> </div>
              <div onClick={SendMessageAA} className="b"> <SvgSend /> </div>
            </div>
            {/* write */}
          </div>
          {/* messageAA */}
        </>
      )}
      {/* on affiche les messages privés dans l'application x */}


		{/* inscription Page - AA */}
		{/* inscription Page - AA */}
		{inscriptionPageAA && (<>
        <div className="connexionPageAA">
            <div className="display">
              <div className="card-un">
                <div className=""> <p>{t("--welcome to")}</p> </div>
                <div className="a"> <p onClick={CloseInscriptionPageAA}>Florinato.</p> </div>
                <div className=""> <p>{t("--if you have not registered")}</p> </div>
              </div>
              {/* card-un */}

              <div className="card-deux">
                <div className="block-un"> <p onClick={CloseInscriptionPageAA}>{t("--registration")}</p> </div>
                {/* block-un */}

                {rtl && (<>
                <div className="block-deux-rtl">
                  <input type="text" placeholder={t("--username")} value={nameSignupAA} onChange={(e) => setNameSignupAA(e.target.value)} />
                  <input type="text" placeholder={t("--phone number")} value={numberSignupAA} onChange={(e) => setNumberSignupAA(e.target.value)} />
                  <input type="text" placeholder={t("--password")} value={passwordSignupAA} onChange={(e) => setPasswordSignupAA(e.target.value)} />
                </div> </>)}

                {!rtl && (<>
                <div className="block-deux">
                  <input type="text" placeholder={t("--username")} value={nameSignupAA} onChange={(e) => setNameSignupAA(e.target.value)} />
                  <input type="text" placeholder={t("--phone number")} value={numberSignupAA} onChange={(e) => setNumberSignupAA(e.target.value)} />
                  <input type="text" placeholder={t("--password")} value={passwordSignupAA} onChange={(e) => setPasswordSignupAA(e.target.value)} />
                </div> </>)}
                {/* block-deux */}

                <div className="block-trois"> <button onClick={AddPhoto666inscriptionPageAA}>{t("--signup for free")}</button> </div>
                {/* block-trois */}

                <div className="block-quatre">
                  <div className=""> <p>{t("--i have account")}.</p> </div>
                  <div className="b"> <p onClick={ConnexionPageAA}>{t("--login")}</p> </div>
                </div>
                {/* block-quatre */}

              </div>
              {/* card-deux */}
            </div>
            {/* display */}
          </div>
          {/* connexionPageAA */}
        </>
      )}
      {/* inscription Page - AA */}


      {/* on ajoute une photo de profil lors de l'inscription sur florinato */}
      {/* on ajoute une photo de profil lors de l'inscription sur florinato */}
      {addPhoto666inscriptionPageAA && (<>
      <div className="favoriteFA">
        <div className="align">
          <div onClick={CloseAddPhoto666inscriptionPageAA} className="head"> 
            <div className="block-one"> <p>Choisissez une photo de profil</p> </div>

            <div className="block-two"> 
              <div className="b"> <SvgBottom5/> </div>
            </div>
            {/* block-two */}
          </div>
          {/* head */}

          <div className="body">
            <div className="card">
              <div className="block-one">
                <div className="a"><input onChange={(e) => setFilePhoto66addPhoto666inscriptionPageAA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
                <div className="b"> <button onClick={SignupFA}>Valider</button> </div>
              </div>
              {/* block-one */}
              
              <p style={{ paddingTop: "100px" }}></p>
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* favoriteFA */}
      </>)}
      {/* on ajoute une photo de profil lors de l'inscription sur florinato */}



		{/* connexion Page - AA */}
		{/* connexion Page - AA */}
		{connexionPageAA && (<>
        <div className="connexionPageAA">
            <div className="display">
              <div className="card-un">
                <div className="a"> <p onClick={CloseConnexionPageAA}>Florinato</p> </div>
                <div className=""> <p>{t("--it is your house")}.</p> </div>
                <div className=""> <p>{t("--log in")}</p> </div>
              </div>
              {/* card-un */}

              <div className="card-deux">
                <div className="block-un"> <p onClick={CloseConnexionPageAA}>{t("--connection")}</p> </div>
                {/* block-un */}

                {rtl && (<>
                <div className="block-deux-rtl">
                  <input type="text" placeholder={t("--phone number")} value={numberLoginAA} onChange={(e) => setNumberLoginAA(e.target.value)} />
                  <input type="text" placeholder={t("--password")} value={passwordLoginAA} onChange={(e) => setPasswordLoginAA(e.target.value)} />
                </div> </>)}

                {!rtl && (<>
                <div className="block-deux">
                  <input type="text" placeholder={t("--phone number")} value={numberLoginAA} onChange={(e) => setNumberLoginAA(e.target.value)} />
                  <input type="text" placeholder={t("--password")} value={passwordLoginAA} onChange={(e) => setPasswordLoginAA(e.target.value)} />
                </div> </>)}
                {/* block-deux */}

                <div className="block-trois"> <button onClick={LoginFA}>{t("--login")}</button> </div>
                {/* block-trois */}

                <div className="block-quatre"> 
                  <div className="a"> <p>{t("--i don't have account")}.</p> </div>
                  <div className="b"> <p onClick={InscriptionPageAA}>{t("--signup")}</p> </div>
                </div>
                {/* block-quatre */}

              </div>
              {/* card-deux */}
            </div>
            {/* display */}
          </div>
          {/* connexionPageAA */}
        </>
      )}
      {/* connexion Page - AA */}



      {/* telephone virtuel - page */}
      {/* telephone virtuel - page */}
      {/* telephone virtuel - page */}
      {/* telephone virtuel - page */}
      {/* telephone virtuel - page */}
      {/* telephone virtuel - page */}
      {/* telephone virtuel - page */}
      {/* ca c'est le menu des applications dans le telephone virtuel */}
      {telephoneVirtuel && (<>
        <div className="telephoneVirtuel-opacity">
          <div className="title">
            <div className="a">
              <div className="aa"> 
                <p>La messagerie 2026</p>
                <p></p> 
              </div> 
              <div onClick={Translation} className="bb"> <SvgTranslation /> </div>
            </div>
            {/* a */}

            <div className="b"> <hr /> </div>
            {/* b */}
          </div>
          {/* title */}

          <div className="menuDesApplications">
            {/* Alrani App */}
            {dev && (<>
            <div className="application">
              <img onClick={EcranDemarrageAA} src={xLogo} alt="" />
              <p onClick={EcranDemarrageAA}>X</p>
            </div> </>)}

            {/* Zimagic */}
            {dev && (<>
            <div onClick={MessageXA} className="application"> {/* page pour ouvrir un message privé, mais on va enlever ce bouton là */}
              <img onClick={ZimagicApp} src={zimagicLogo} alt="" />
              <p onClick={ZimagicApp}>Zimagic</p>
            </div> </>)}

            {/* florinato */}
            <div className="application">
              <img onClick={XApp} src={florinatoLogo} alt=""/>
              <p onClick={XApp}>Florinato</p>
            </div>

            {/* izocash */}
            <div className="application">
              <img onClick={EcranDemarrageIA} src={izocashLogo} alt=""/>
              <p onClick={EcranDemarrageIA}>izocash</p>
            </div>
			
			{dev && (<>
			{/* newApp1 */}
			<div className="application">
              <img onClick={NewApp} src={donaziaLogo} alt=""/>
              <p onClick={NewApp}>newApp1</p>
            </div>
			
			{/* Mission App */}
            <div className="application">
              <img onClick={MissionApp} src={officialLogo} alt="" />
              <p onClick={MissionApp}>Missions</p>
            </div> </>)}

             {/* donazia */}
             {dev && (<>
             <div className="application">
              <img onClick={DonaziaApp} src={donaziaLogo} alt="" />
              <p onClick={DonaziaApp}>Donazia</p>
            </div> </>)}

            {/* Send Me */}
            {dev && (<>
            <div className="application">
              <img onClick={EcranDemarrageIA} src={bavardageLogo} alt="" />
              <p onClick={EcranDemarrageIA}>Send Me</p>
            </div> </>)}

            {/* ertiden */}
            {dev && (<>
            <div className="application">
              <img onClick={EcranDemarrageIA} src={ertidenLogo} alt="" />
              <p onClick={EcranDemarrageIA}>ertiden</p>
            </div> </>)}

            {/* Veil Brillant */}
            {dev && (<>
            <div className="application">
              <img onClick={EcranDemarrageVB} src={vbLogo} alt="" />
              <p onClick={EcranDemarrageVB}>VB</p>
            </div> </>)}

            {/* Vixinol Store */}
            {dev && (<>
            <div className="application">
              <img onClick={EcranDemarrageVS} src={vixinolLogo} alt="" />
              <p onClick={EcranDemarrageVS}>Vixinol</p>
            </div> </>)}

            {/* other app */}
            {dev && (<>
            <div className="application">
              <img onClick={OtherApp} src={zimagicLogo} alt="" />
              <p onClick={OtherApp}>Other App</p>
            </div> </>)}

            {/* paramètres */}
            {dev && (<>
            <div className="application">
              <img onClick={Settings} src={settingsLogo} alt="" />
              <p onClick={Settings}>{t("--settings")}</p>
            </div> </>)}

            {/* official app */}
            {dev && (<>
            <div className="application">
              <img onClick={OfficialApp} src={officialLogo} alt="" />
              <p onClick={OfficialApp}>www</p>
            </div> </>)}

            {/* Wei-D */}
            {dev && (<>
            <div className="application">
              <img onClick={WeidApp} src={weidLogo} alt="" />
              <p onClick={WeidApp}>Wei-D</p>
            </div> </>)}
            {/* application */}
          </div>
          {/* menuDesApplications */}
        </div>
        {/* telephoneVirtuel-opacity */}
      </>
    )}
    {/* telephone virtuel - page */}
	
	
      {/* messagerie */}
	  <Page visible={newApp} fermer={CloseNewApp}>
		<Close visible={newApp} fermer={CloseNewApp} />
      </Page>
	  

	  {/* missions */}
	  <MissionTemplate 
	  titre={`${missionActuelle.id}/${missions.length}`}
	  visible={missionApp} 
	  valeur={ecrireMA} setValeur={setEcrireMA} 
	  envoyer={EnvoyerMission} 
	  message={message1}
	  nomMembre={nomMembre}
	  titre2="À la fin de vos missions, en tant que Membre"
	  titre3="Florinato"
	  titre4=", vous allez recevoir une maison et des voitures"
	  titre5={
	  missionActuelle.mot === "NOM_LIBRE"
		? "Écrivez votre nom de Membre Florinato"
		: `Écrivez le mot "${missionActuelle.mot}"`
	  }

	  titre7=" est le meilleur cercle"
	  titre8="Bienvenue sur"
	  titre9="Rejoignez Florinato"
	  />
	  
	  
	  {/*
	  <Page>
		<MilieuMA 
		nom="Florinato" 
		titre="À la fin de vos missions, en tant que Membre Florinato, vous allez recevoir une maison et des voitures" />
		
		<MilieuMA 
		nom="Réalisez ces missions" 
		titre="1/100"
		titre2="Quel est votre nom de Membre Florinato ?" />
		
		<Input texte=". . ." valeur={ecrireMA} setValeur={setEcrireMA} />
		  
		<Button texte="Envoyer" envoyer={NewApp} />
	</Page>*/}

		  
      {/* ecran de demarrage - donazia app */}
      {/* ecran de demarrage - donazia app */}
      {/* sur cette page on a mis l'ecran de demarrage de notre application donazia
      {ecranDemarrageDA && (<>
          <div className="ecranDemarrageDA">
            <div className="align">
              <div className="logo">
                <img src={donaziaEcranDemarrage} alt="" />
              </div>
              {/* logo 
            </div>
            {/* align 
          </div>
          {/* ecranDemarrageDA 
        </>
      )}
      {/* ecran de demarrage - donazia app */}


      {/* donazia app */}
      {/* donazia app */}
      {/* donazia app */}
      {/* ça c'est l'application Donazia (page d'accueil) */}
      {donaziaApp && (<>
          <div className="donaziaApp">
            {/* head (la tete) - donazia app */}
            {/* head (la tete) - donazia app */}
            <div className="head">
              <div className="a"> <img onClick={CloseDonaziaApp} src={donaziaLogoAccueil} alt=""/> </div>
              <div className="b" onClick={ProfilDA}> <SvgProfil5 /> </div>
              <div className="b"> <p onClick={ActivateDonaziaPage}>Activer</p> </div>
              {/* b */}
            </div>
            {/* head */}

            {/* on affiche les posts (page d'accueil) - DA */}
            {filterPost666homeAA.map((api) => (<>
            <div onClick={PageRedirection666HomeDA} className="posts">
              <ChildApi666homeAA api={api} />
            </div>
            {/* posts */}
            </>))}

            <div className="body">
              <div className="title">
                <div className="a"> <p>Télécharger vos</p> </div>
                <div className="b"> <p>Films et séries préférées</p> </div>
                <div className="c"> <p>sur Donazia</p> </div>
                {/* c */}
              </div>
              {/* title */}

              <div className="films">
                <div className="one"> <p>Séries</p> </div> 
                  {/* Nikita _ S4 E1 */}
                  <div className="two">
                    <div onClick={SeePhotoAlbumPageDA} className="a"> <img src={photoAlbumDA} alt=""/> </div>

                    <div onClick={SeePhotoAlbumPageDA} className="b">
                      <div className="aa"> <p>{nameAlbumDA}</p> </div>
                      <div className="bb"> 
                        <div className="aaa"> <p>42:20</p> </div>
                        <div className="bbb"> <p>.avi</p> </div>
                        <div className="ccc"> <p>361MB</p> </div>
                      </div>
                    </div>
                    {/* b */}

                    {freeDonaziaFA ==="1" || subscriptionDonaziaFA > 0 ? (<>
                    <div className="c"> <button onClick={DownloadAlbumPageDA}>Télécharger</button> </div>
                      </>) : (<>
                    <div className="c"> <button onClick={BuySubscriptionMessageDA}>Télécharger</button> </div></>)}
                  </div>
                  {/* two */}

              </div>
              {/* films */}
            </div>
            {/* body */}
          </div>
          {/* donaziaApp */}
      </>)}
      {/* donazia app */}
      {/* ça c'est l'application Donazia (page d'accueil) */}


      {/* seePhotoAlbumPageDA - on affiche la photo de l'album */}
      {/* seePhotoAlbumPageDA - on affiche la photo de l'album */}
      {seePhotoAlbumPageDA && (<>
      <div className="seePhotoWithNameDA">
        <div className="close">
          <div onClick={CloseSeePhotoAlbumPageDA} className="a"> <SvgLeft2 /> </div>
          <div onClick={InfosAlbumPageDA} className="b"> <SvgInfos4 /> </div>
        </div>
        {/* close */}

        <div className="card">
          <div className="a">
            <div className="aa"> <img src={photoAlbumDA} alt="" /> </div>
            <div className="bb"> <p>{nameAlbumDA}</p> </div>
          </div>

          <div className="b"></div>
        </div>
        {/* card */}
      </div>
      {/* seePhotoWithNameDA */}
      </>)}

      {/* infosAlbumPageDA - on affiche les infos de l'album */}
      {/* infosAlbumPageDA - on affiche les infos de l'album */}
      {infosAlbumPageDA && (<>
      <div onClick={CloseInfosAlbumPageDA} className="moreInfosDA">
        <div className="align">
          <div className="card">
            <div className="a"> <p>{infosAlbumDA}</p> </div>
            <div className="b"></div>
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* moreInfosDA */}
      </>)}

      {/* download AlbumPageDA - on affiche la page qui conduit au telechargement de l'album */}
      {/* download AlbumPageDA - on affiche la page qui conduit au telechargement de l'album */}
      {downloadAlbumPageDA && (<>
      <div className="otherAppDA">
        <div onClick={CloseDownloadAlbumPageDA} className="head"> 
          <div className="close"> 
            <div className="a"> <SvgLeft /><p>Donazia</p> </div>
            <div className="b"></div>
          </div>
          {/* close */}
        </div>
        {/* head */}

        <div className="application">
          <iframe src={urlAlbumDA} title="donazia iframe"></iframe>
        </div>
        {/* application */}
      </div>
      {/* otherAppDA */}
      </>)}


      {/* profil - DA */}
      {/* profil - DA */}
      {profilDA && (<>
          <div className="profilDA">
            <div className="close">
              <div className="a"> <p> <b></b></p> </div>
              <div className="b"> <button onClick={CloseProfilDA}>Fermer</button> </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="photo">
              {!photoPersonConnectedAA < 1 ? (<><img onClick={SeePhotoPersonConnectedDA} src={photoPersonConnectedAA} alt="" />
              </>):(<><SvgProfil5/></>)}

              {badgePersonConnectedAA > 0 ? (<><h3>{namePersonConnectedAA}</h3> <SvgBadge/>
              </>):(<><h3>{namePersonConnectedAA}</h3></>)}
            </div>
            {/* photo */}

            {freeDonaziaFA === "1" && (<>
            <div style={{ paddingTop: "30px", paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px", display: "flex"  }}>
              <p style={{ fontSize: "15px", paddingRight: "5px" }}>Abonnement journalier gratuit activé</p>
              <SvgValidate3 />
            </div> </>)}


            {subscriptionDonaziaFA > 0 ? (<>
            <div style={{ paddingTop: "30px", paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px", display: "flex"  }}>
              <p style={{ fontSize: "15px", paddingRight: "5px" }}>Abonnement annuel activé</p>
              <SvgValidate3 />
            </div>

            </>) : (<>
            <div className="solde">
              <div className="a">
                <button onClick={BuySubscriptionMessageDA}>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b"> <p>Abonnement annuel non activer</p> </div>
            </div> </>)} {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* profil - DA */}


      {/* seePhoto (sur donazia, page pour voir la photo de la personne connecté) */}
      {/* seePhoto (sur donazia, page pour voir la photo de la personne connecté) */}
      {seePhotoPersonConnectedDA && (<>
          <div className="seePhoto2AA">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseSeePhotoPersonConnectedDA} className="b"> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={photoPersonConnectedAA} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhoto2AA */}
        </>)}
        {/* seePhoto (sur donazia, page pour voir la photo de la personne connecté) */}


      {/* ca c'est la page qui rappel a l'utilisateur d'acheter un abonnement annuel - DA */}
      {/* ca c'est la page qui rappel a l'utilisateur d'acheter un abonnement annuel - DA */}
      {buySubscriptionMessageDA && (<>
          <div onClick={CloseBuySubscriptionMessageDA} className="deconnexionPageIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>Avec un abonnement annuel à 8900FCFA (15$), vous pourrez télécharger pendant toute l'année toutes les séries, films,... qui sont sur Donazia et toutes les nouveautés qu'on va ajouter.</p> </div>
                {/* block-un */}

                <div className="block-deux"> <button onClick={ConfirmationSendMessageDonaziaDA}>Envoyer un message à Donazia</button> </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* deconnexionPageIA-opacity */}
        </>)}
        {/* ca c'est la page qui rappel a l'utilisateur d'acheter un abonnement annuel - DA */}


      {/* confirmation (confirmer s'il veut envoyer un message à Donazia) */}
      {/* confirmation (confirmer s'il veut envoyer un message à Donazia) */}
      {confirmationSendMessageDonaziaDA && (<>
          <div className="offrirNumeroConfirmationIAC">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <h6>Confirmation</h6>
                  <p>Êtes-vous sûr d'envoyer un message à Donazia ? (Vous pourrez continuer la discussion dans l'application Florinato)</p>
                </div>
                {/* block-un */}

                <hr />
                <div className="block-trois"> <p onClick={BeginConversationDonaziaDA}>Oui</p> </div>
                {/* block-trois */}

                <hr />
                <div className="block-quatre"> <p onClick={CloseConfirmationSendMessageDonaziaDA}>Annuler</p> </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* offrirNumeroConfirmationIAC */}
        </>)}
        {/* confirmation (confirmer s'il veut envoyer un message à Donazia) */}


      {/* LierMusicPageAA (page pour lier une musique et la publier) */}
      {/* LierMusicPageAA (page pour lier une musique et la publier) */}
      {lierMusicPageAA && (<>
          <div className="deliverVirtualNumberPageIA">
            <div className="close">
              <div onClick={CloseLierMusicPageAA} className="a"> <SvgLeft /> </div>
              <div className="b"> <p>Publier sur Donazia</p> </div>
              <div className="a"> <img src={photoPersonConnectedAA} alt="" /> </div>
            </div>
            {/* close */}
       
            {/* Titre */}
            <div className="block-trois">
              <div className="a"> <p>Titre</p> </div>

              <div className="b">
                <input type="text" value={writeTitleDA} onChange={(e) => setWriteTitleDA(e.target.value)} />
              </div>
            </div>

            {/* Url */}
            <div className="block-trois">
              <div className="a"> <p>Lien de Téléchargement</p> </div>

              <div className="b">
                <input type="text" value={writeUrlDownloadDA} onChange={(e) => setWriteUrlDownloadDA(e.target.value)} />
              </div>
            </div>

            {/* Autres détails */}
            <div className="block-trois">
              <div className="b">
                <p>Autres détails (Pas obligatoire)</p>
                <input type="text" value={writeDetailsDA} onChange={(e) => setWriteDetailsDA(e.target.value)} />
              </div>
            </div>

          {/*<div className="block-two">
          <pre>{writeDescriptionAA}</pre>
          <img onClick={SeePhotoAAreq} src={urlPhotoAAreq} alt="" />
        </div>
        */}

      {isLoading666publierPageDA ? (<><div className="loader-display-flex"> <Loader /> </div></>
            ):(<><div onClick={PublierDA} className="block-quatre"> <SvgRight /><p>Publier</p> </div></>)}
            {/* block-quatre */}
          </div>
          {/* deliverVirtualNumberPageIA */}
        </>
      )}
      {/* LierMusicPageAA (page pour lier une musique et la publier) */}


      {/* post publié (message de success) - DA */}
      {/* post publié (message de success) - DA */}
      {postSuccessDA && (<>
          <div onClick={ClosePostSuccessDA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Publié</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* post publié (message de success) - DA */}


      {/* activer l'application donazia */}
      {/* activer l'application donazia */}
      {activateDonaziaPage && (<>
      <div className="activateDonaziaPage">
        <div className="align">
          <div className="head"></div>
          {/* head */}

          <div className="body">
            <div className="card">
              <p>Créer votre compte Donazia en un clic</p>
              <button onClick={ActivateDonazia}>Créer</button>
              <div className="block-onee"> <p onClick={CloseActivateDonaziaPage}>Annuler</p> </div>
            </div>
            {/* card */}
            </div>
            {/* body */}
          </div>
          {/* align */}
      </div>
      {/* activateDonaziaPage */}
      </>)}
      {/* activer l'application donazia */}


      {/* inscriptionSuccess - DA */}
      {/* inscriptionSuccess - DA */}
      {/* on affiche la page ci, si la personne a pu creer son compte Donazia */}
      {inscriptionSuccessDA && (<>
          <div onClick={CloseInscriptionSuccessDA} className="inscriptionSuccessAA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <div className="a"> <p>Donazia</p> </div>
                  <div className="b"> <p>Compte créer !</p> </div>
                </div>
                {/* block-un */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* inscriptionSuccessAA */}
      </>)}
      {/* inscriptionSuccess - DA */}


      {/* erreur - DA */}
      {/* erreur - DA */}
      {/* on affiche cette page si la creation de son compte donazia a echouer ou si 
      la personne a rencontrer une erreur quelconque sur Donazia */}
      {erreurDA && (<>
          <div onClick={CloseErreurDA} className="erreurConnexionAA">
            <div className="block-deux">
              <div className="a">
                <p>Une erreur s'est produite</p>
              </div>

              <div className="b">
                <p>Reessayer maintenant ou réessayer plus tard !</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}
          </div>
          {/* erreurConnexionAA */}
        </>
      )}
      {/* erreur (connexion) - DA */}



      {/* home - AA */}
      {/* home - AA */}
      {/* page d'accueil de l'application Alrani */}
      {homeAA && (<>
      <div className="homeAA">

        {theme3 && (<>
        <div className="theme-quatre-en-haut"> {/* partie haute theme 3 */}
          <div className="space">
            <div className="a"><p onClick={CloseHomeAA} style={{ color: "#00cc00", fontSize: "19px", cursor: "pointer" }}>Florinato</p> </div>
            
            <div className="b">  
              {dev && (<>          
              {newNotificationAA === "1" ? (<><div onClick={NotificationAA} className="aa"> <SvgNotification /> </div></>) : (<>
              <div onClick={NotificationAA} className="aa"> <SvgNotification /> </div></>)} 
              </>)}

              <div onClick={SearchAA} className="aa"> <SvgSearch2 /> </div>
              <div onClick={Menu} className="bb"> <SvgMenu /> </div>
            </div>
          </div>
        </div>

        <div className="theme-quatre-navbar-bottom-alr"> {/* partie basse theme 3 */}
          <div className="display">
            {newMessageAA === "1" ? (<><div onClick={ConversationAA} className="a"> <SvgMessage11 /> </div></>) : (<>
            <div onClick={ConversationAA} className="a"> <SvgMessage10 /> </div></>)} {/* conversation */}

            <div onClick={RencontreAA} className="a"> <SvgLove /> </div> {/* rencontre */}

            <div onClick={RefreshHomeAA} className="a"> <SvgHome /> </div> {/* home */}

            {dev && (<><div onClick={VideoAA} className="a"> <SvgVideo6 /> </div> </>)} {/* videos */}

            <div onClick={ProfilAA} className="a"> <SvgProfil2 /> </div> {/* profil */}
          </div>
        </div>
        </>)}
        {theme3 && (<> <div style={{ paddingTop: "50px" }}></div> </>)} {/* theme 3 true, on met un espace en haut pour eviter que les choses soit barrer */}

        {theme2 && (<>
          <div className="partie-haute-theme-trois"> {/* partie haute theme 2 */}
            <p onClick={CloseAlraniAppGotoMenuTelephone} style={{ color: "#00cc00", fontSize: "18px", paddingLeft: "15px", paddingTop: "10px", paddingBottom: "10px", cursor: "pointer", }}>Alrani</p> 
          </div>
          <div className="navbar-bottom-omisify"> {/* partie basse theme 2 */}
            <div className="display">
              <div className="a"> {/* home */}
                {!menu && (<><div> <SvgHome3 /> </div></>)}
                {menu && (<><div> <SvgHome4 /> </div></>)}
              </div>
              <div className="a"> <SvgProfil4 /> </div> {/* profil */}
              <div className="a"> <SvgMessage4 /> </div> {/* message */}
              <div className="a"> {/* menu */}
                {!menu && (<><div onClick={Menu}> <SvgMenu3 /> </div></>)}
                {menu && (<><div onClick={Menu}> <SvgMenu2 /> </div></>)}
              </div>
            </div>
          </div>
          </>)}

          {theme1 && (<>
          <div className="themeUn-pc"> {/* theme 1 - pc (c'est le theme 1 - pc. sur mobile ca ne sera pas visible) */}
            <div className="display">
              <div className="block-un"> <p onClick={CloseAlraniAppGotoMenuTelephone}>Alrani</p> </div>
              <div className="block-deux">
                {!menu && (<> <li className="active-class-al">Accueil</li> </>)}
                {menu && (<> <li className="no-active-class-al">Accueil</li> </>)}
                <li className="no-active-class-al">Profil</li>
                <li className="no-active-class-al">Messages</li>
                <div className="navlink">
                  {!menu && (<> onClick={Menu} <li style={{ cursor: "pointer" }} className="no-active-class-al">Menu</li> </>)}
                  {menu && (<> <li className="active-class-al">Menu</li> </>)}
                </div>
              </div>
            </div>
          </div> {/* themeUn-pc (ici c'est la fin du code de theme 1 - pc ) */}

          {!openMobileMenu && (<> {/* theme 1 - mobile (ca c'est le theme 1 - mobile, ca ne sera pas visible sur pc. quand on clique sur le btn menu, la version bloquer et sa popup va s'afficher) */}
              <div className="themeUn-mobile">
                <div className="display">
                  <div className="logo"> <p onClick={CloseAlraniAppGotoMenuTelephone}>Alrani</p> </div>
                  <div onClick={OpenMobileMenu} className="menu"> <SvgMenu2 /> </div>
                </div>
              </div>
              {/* themeUn-mobile */}
            </>)}

          {openMobileMenu && (<> {/* theme 1 - mobile (version bloquer). on a mis la version bloquer, parce que quand la personne scrolle, on ne veut pas que la navbar puisse partir, on veut que la navbar soit bloquer */}
              <div className="themeUnMobile-versionBloquer">
                <div className="block-un">
                  <div className="display">
                    <div className="logo"> <p onClick={CloseAlraniAppGotoMenuTelephone}>Alrani</p> </div>
                    <div onClick={OpenMobileMenu} className="menu"> <SvgMenu2 /> </div>
                  </div>
                </div>
              </div>
              {/* themeUnMobile-versionBloquer */}
            </>)} {/* fin du code de theme 1 - mobile (version bloquer) */}
        </>)} {/* fin du code de theme 1 */}

      {openMobileMenu && (<> {/* theme 1 - mobile (popup version bloquer) */}
          <div onClick={OpenMobileMenu} className="themeUnMobile-versionBloquerPopup">
            <div className="block-deux">
                <div className="icon">
                  {!menu && (<> <p style={{ color: "#00cc00" }}>Accueil</p> </>)}
                  {menu && (<> <p style={{ color: "black" }}>Accueil</p> </>)}
                </div>
                <div className="icon"> <p style={{ color: "black" }}>Profil</p> </div>
                <div className="icon"> <p style={{ color: "black" }}> Messages</p> </div>
              <div className="icon">
                {!menu && (<>
                <div> <p onClick={Menu} style={{ cursor: "pointer" }}>Menu</p> </div>
                <div onClick={Menu}> <SvgMenu4 /> </div> </>)}
                {menu && (<>
                <p onClick={Menu} style={{ cursor: "pointer", color: "#00cc00" }}>Menu</p>
                <div onClick={Menu}> <SvgMenu5 /> </div>  </>)}
              </div>
            </div>
          </div>
          {/* themeUnMobile-versionBloquerPopup */}
        </>)} {/* theme 1 - mobile (popup version bloquer) */}
        
            {/* on affiche les posts (page d'accueil) - AA */}
            {filterPost666homeAA.map((api) => (<>
            <div onClick={PageRedirection666HomeAA} className="posts">
              <ChildApi666homeAA api={api} />
            </div>
            {/* posts */}
            </>))}
            
            {theme3 && (<> <div style={{ paddingBottom: "50px" }}></div> </>)} {/* theme 3 true, on met un espace en bas pour eviter que les choses soit barrer */}
          </div>
          {/* homeAA */}
      </>)}
      {/* home - AA */}


      {/* seePostAA */}
      {/* seePostAA */}
      {/* on affiche le post sur laquelle on a cliquer (post sur la page d'accueil) - AA */}
      {seePost666homeAA && (<>
          <div className="seePostAA">
            <div className="close">
              <div className="block-un">
                <div className="a" onClick={CloseSeePost666homeAA}> <SvgLeft /> </div>
                <div className="b"> <p>Publication de {nameOtherAA}</p> </div>
                {dev && (<>
                <div className="c"> <button>S'abonner</button> </div></>)} {/* dev se ferme ici */}
              </div>
              {/* block-un */}

              <div className="block-deux"> <p></p> </div>
              {/* block-deux */}
            </div>
            {/* close */}

            {/* on affiche le post - AA */}
                <div className="posts">
                  {/* ici on affiche: photo + nom, en haut de chaque posts */}
                  {badgeOtherAA > 0 ? (<><div onClick={ProfilOtherAA} className="infos"> <img src={photoOtherAA} alt="" /> <p>{nameOtherAA}</p> <SvgBadge /> </div>
                  </>):(<><div onClick={ProfilOtherAA} className="infos"> <img src={photoOtherAA} alt="" /> <p>{nameOtherAA}</p> </div></>)}
                  {/* infos */} 

                  <div className="post">
                  {adAA === "1" ? (<>
                  <div className="block-one"> <p>Sponsorisée</p> <p>•</p> <SvgGlobeAfricaAA /> </div></>
                  ):(<><div className="block-one"> <p>{dateParser(createdAtAA)}</p> <p>•</p> <SvgGlobeAfricaAA /> </div></>)}
                  {/* block-one */}

                  {/* postStyle1 */}
                  {postStyle1AA === "1" && (<>
                  {seeMoreAA ? (<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA}</pre> </div> </>):(<>
                  {descriptionAA?.length > 140 ? (<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA.slice(0, 140)}..</pre> </div></>
                  ):(<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA}</pre> </div></>)} {/* descriptionAA.length */}
                  </>)} {/* seeMoreAA  */} 

                  <div className="block-three"> <img onClick={SeePhotoAA} src={urlPhotoAA} alt="" /> </div>
                  {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div> </>)}
                  <div className="block-five"> <p>{viewAA} personnes ont vues cette publication</p> </div>
                  </>)}


                  {/* postStyle6 */}
                  {postStyle6AA === "6" && (<>
                  {seeMoreAA ? (<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA}</pre> </div> </>):(<>
                  {descriptionAA?.length > 140 ? (<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA.slice(0, 140)}..</pre> </div></>
                  ):(<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA}</pre> </div></>)} {/* api.description.length */}
                  </>)} {/* seeMore  */} 

                  {dev && (<><div className="block-four"> <p>Envoyer un message</p> </div></>)}
                  <div className="block-five"> <p>{viewAA} personnes ont vues cette publication</p> </div>
                  </>)}


                  {/* postStyle30 (video) */}
                  {postStyle30AA === "30" && (<>
                    {seeMoreAA ? (<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA}</pre> </div> </>):(<>
                    {descriptionAA?.length > 140 ? (<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA.slice(0, 140)}..</pre> </div></>
                    ):(<><div onClick={SeeMoreAA} className="block-two"> <pre>{descriptionAA}</pre> </div></>)} {/* api.description.length */}
                    </>)} {/* seeMore  */}

                    <div className="videoo">
                        {/* on affiche la video */}
                        <video onEnded={LectureVideoTerminer} autoPlay={"autoplay"} muted onClick={ConfigurationVideo} ref={videoRef} src={urlVideoAA} />

                        {/* configurationVideo (bouton de configuration de la video) - VB */}
                        {/* on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
                        {configurationVideo && (<>
                            <div className="align-configuration">
                              <div className="configuration">
                                {isPlaying && (<><div onClick={Play} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                                {!isPlaying && (<><div onClick={Play} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                                <div className="b"> <input type="range" value={currentTimeSec} min="0" max={durationSec} default="0" onChange={(e) => { videoRef.current.currentTime = e.target.value }} /> </div>

                                {/* duree de la video */}
                                <div className="c"> <p>{currentTime[0]}:{currentTime[1]} / {duration[0]}:{duration[1]}</p> </div>
                                
                                <div onClick={FullScreen} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}
                                
                                {son && (<><div onClick={VolumeOff} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                                {!son && (<><div onClick={VolumeOn} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                              </div>
                              {/* configuration */}
                            </div>
                            {/* align-configuration */}
                          </>)} {/* le code de configurationVideo se ferme ici */}
                          </div> </>)} {/* postStyle30 */}
                          {/* videoo */}
                  
                  {dev && (<>
                  <div className="block-six">
                    <div className="a">
                      <div className="aa"> <SvgLike /> </div> {/* svg like (like) */}
                      <div className="aa"> <SvgLove /> </div> {/* svg love (adore) */}
                      <div className="aa"> <SvgSad /> </div> {/* svg sad (triste) */}
                      <div className="aa"> <SvgSurprisedAA /> </div> {/* svg surprised (surpris) */}
                      <div className="aa"> <SvgLaughAA /> </div> {/* svg laugh (rire) */}
                      <div className="aa"> <SvgAngryAA /> </div> {/* svg angry (faché) */}
                    </div>
                    {/* a */}

                    <div className="b">
                      <div className="aa"> <p>Voir</p> </div>
                      <div className="bb"> <SvgRight3 /> </div>
                    </div>
                    {/* b */}
                  </div>
                  {/* block-six */}

                  <div className="block-seven">
                    <div className="a"> <SvgDislike /> <p>{reactionAA}</p> </div> {/* svg like */}
                    <div className="b"> <SvgCommentAA /><p>{commentAA2}</p> </div> {/* svg comment (commentaire) */} 
                    <div className="c"> <SvgShare /><p>{shareAA}</p> </div> {/* svg share (partage) */}
                  </div></>)} {/* dev se ferme ici */}
                  {/* block-seven */}
                </div>
                {/* post */}
                </div>
                {/* posts */}

            {/* on affiche les commentaires - AA */}
            {filterCommentAA.map((api) => (<>
              <div onClick={ReplyAA}>
                <ChildApiCommentAA api={api} />
              </div>
            </>))}

            <p style={{ paddingTop: "100px" }}></p>
            <div className="write">
              <div className="a"> <textarea type="text" placeholder="Commentez..." value={writeCommentAA} onChange={(e) => setWriteCommentAA(e.target.value)}></textarea> </div>
              <div onClick={SaveCommentAA} className="b"> <SvgSend /> </div>
            </div> 
            {/* write */}
          </div>
          {/* seePostAA */}
        </>)}
      {/* seePostAA */}


      {/* video - AA */}
      {/* video - AA */}
      {videoAA && (<>
      <div className="videoAA">
      {theme3 && (<>
        <div className="theme-quatre-navbar-bottom-alr"> {/* partie basse theme 3 */}
          <div className="display">
            <div onClick={CloseVideoAA} className="a"> <SvgHome2 /> </div> {/* home */}
            <div onClick={RefreshVideoAA} className="a"> <SvgVideo5 /> </div> {/* videos */}

            {newMessageAA === "1" ? (<><div onClick={ConversationAA} className="a"> <SvgMessage11 /> </div></>) : (<>
            <div onClick={ConversationAA} className="a"> <SvgMessage10 /> </div></>)} {/* conversation */}

            <div onClick={ProfilAA} className="a"> <SvgProfil2 /> </div> {/* profil */}
          </div>
        </div>
        </>)}
        {theme3 && (<> <div style={{ paddingBottom: "50px" }}></div> </>)} {/* theme 3 true, on met un espace en bas pour eviter que les choses soit barrer */}
        
        <div className="title">
          <div className="a"> <SvgVideo7 /> <p>Vidéos</p> </div>
          {dev && (<>
          <div className="b">
            <div className="aa"> <SvgPay /> </div>
            <div className="aa"> <SvgFavoris /> </div>
          </div></>)}
        </div>
        {/* title */} 

        {/* on affiche les posts (page d'accueil) - AA */}
        {allVideo666videoAA.map((api) => (<>
        <div onClick={PageRedirection666videoAA} className="posts">
          <ChildApi666videoAA api={api} />
        </div>
        </>))}

        </div>
        {/* videoAA */}
        </>
      )}
      {/* video - AA */}


      {/* seeVideoAA */}
      {/* seeVideoAA */}
      {/* page pour voir la video sur laquelle j'ai cliqué (au niveau de la page video, il clique sur une video) */}
      {seeVideoAA && (<>
          <div className="videoPageVB">
            <div className="close">
              <div onClick={CloseSeeVideoAA} className="aa"> <SvgLeft /> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video */}
              <video onEnded={LectureVideoTerminer} autoPlay={"autoplay"} muted onClick={ConfigurationVideo} ref={videoRef} src={urlVideoAA} />

              {/* configurationVideo (bouton de configuration de la video). on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying && (<><div onClick={Play} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying && (<><div onClick={Play} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec} min="0" max={durationSec} default="0" onChange={(e) => { videoRef.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime[0]}:{currentTime[1]} / {duration[0]}:{duration[1]}</p> </div>
                      
                      <div onClick={FullScreen} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}
                      
                      {son && (<><div onClick={VolumeOff} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son && (<><div onClick={VolumeOn} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>)} {/* le code de configurationVideo se ferme ici */}
              
            </div>
            {/* videoo */}

            {/* on affiche les videos suggérées - VB */}
            {filterVideoVB.map((api) => (<>
              <div onClick={SeeSuggestedVideoPageVB}>
                <ChildApiSuggestedVideoVB api={api} />
              </div> 
            </>))}

          </div>
          {/* videoPageVB */}
        </>)}
      {/* seeVideoAA */}


      {/* partager un post (page) - AA */}
      {/* partager un post (page) - AA */}
      {sharePostPageAA && (<>
          <div onClick={CloseSharePostPageAA} className="writeInfosClientPageIA">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div className="aa"> <p></p> </div>
                  <div className="bb"> <SvgDash3 /> </div>
                </div>
                {/* close */}
              </div>
              {/* head */}

            <div className="body">
              <div className="card">
                <div className="hr"> <hr /> </div>
                <div className="block-one"> <SvgShare /><p>Partager sur ma Page</p> </div>
                <div className="block-one"> <SvgShare /><p>Envoyer uniquement la photo par message</p> </div>
                <div className="block-one"> <SvgShare /><p>Envoyer la photo et le post par message</p> </div>
              </div>
              {/* card */}
            </div>
            {/* body */}
          </div>
          {/* align */}
        </div>
        {/* writeInfosClientPageIA */}
        </>)}
      {/* partager un post (page) - AA */}


      {/* ajouter une reaction (page) - AA */}
      {/* ajouter une reaction (page) - AA */}
      {addReactionPageAA && (<>
          <div className="writeInfosClientPageIA">
            <div className="align">
              <div onClick={CloseAddReactionPageAA} className="head">
                <div className="close">
                  <div className="aa"> <p></p> </div>
                  <div className="bb"> <SvgDash3 /> </div>
                </div>
                {/* close */}
              </div>
              {/* head */}

            <div className="body">
              <div className="card">
                <div className="hr"> <hr /> </div>
                <div className="block-one">
                  {likeAA || likePostAA ? (<><div onClick={DislikeAA} className="aa"> <SvgLike /> </div></>
                  ):(<><div onClick={LikeAA} className="aa"> <SvgDislike /> </div></>)}

                  {loveAA || lovePostAA ? (<><div onClick={DisloveAA} className="aa"> <SvgLove /> </div></>
                  ):(<><div onClick={LoveAA} className="aa"> <SvgDislove /> </div></>)}

                  {sadAA || sadPostAA ? (<><div onClick={DissadAA} className="aa"> <SvgSad /> </div></>
                  ):(<><div onClick={SadAA} className="aa"> <SvgDissad /> </div></>)}
                  
                  {dev && (<>
                  <div className="aa"> <SvgSurprisedAA /> </div> {/* surpris */}
                  <div className="aa"> <SvgLaughAA /> </div> {/* rire */}
                  <div className="aa"> <SvgAngryAA /> </div> {/* faché */}
                  </>)} {/* le code de dev se ferme ici */} 
                </div>
                {/* block-one */}

                
                {likeAA || likePostAA ? (<> {/* like */}
                <div className="block-two">
                  <div className="a"> <SvgLike /> </div>
                  <div className="b"> <p>{namePersonConnectedAA}</p> {dev && (<><img src={photoPersonConnectedAA} alt="" /></>)} </div>
                </div> </>):(<></>)}

                
                {loveAA || lovePostAA ? (<> {/* love */}
                <div className="block-two">
                  <div className="a"> <SvgLove /> </div>
                  <div className="b"> <p>{namePersonConnectedAA}</p> {dev && (<><img src={photoPersonConnectedAA} alt="" /></>)} </div>
                </div> </>):(<></>)}

                
                {sadAA || sadPostAA ? (<> {/* triste */}
                <div className="block-two">
                  <div className="a"> <SvgSad /> </div>
                  <div className="b"> <p>{namePersonConnectedAA}</p> {dev && (<><img src={photoPersonConnectedAA} alt="" /></>)} </div>
                </div> </>):(<></>)}

              </div>
              {/* card */}
            </div>
            {/* body */}
          </div>
          {/* align */}
        </div>
        {/* writeInfosClientPageIA */}
        </>)}
      {/* ajouter une reaction (page) - AA */}


      {/* voir les reactions (page) - AA */}
      {/* voir les reactions (page) - AA */}
      {seeReactionPageAA && (<>
          <div onClick={CloseSeeReactionPageAA} className="writeInfosClientPageIA">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div className="aa"> <p></p> </div>
                  <div className="bb"> <SvgDash3 /> </div>
                </div>
                {/* close */}
              </div>
              {/* head */}

            <div className="body">
              <div className="card">
                <div className="hr"> <hr /> </div>

                {likeAA || likePostAA ? (<> {/* like */}
                <div className="block-two">
                  <div className="a"> <SvgLike /> </div>
                  <div className="b"> <p>{namePersonConnectedAA}</p> {dev && (<><img src={photoPersonConnectedAA} alt="" /></>)} </div>
                </div> </>):(<></>)}

                
                {loveAA || lovePostAA ? (<> {/* love */}
                <div className="block-two">
                  <div className="a"> <SvgLove /> </div>
                  <div className="b"> <p>{namePersonConnectedAA}</p> {dev && (<><img src={photoPersonConnectedAA} alt="" /></>)} </div>
                </div> </>):(<></>)}

                
                {sadAA || sadPostAA ? (<> {/* triste */}
                <div className="block-two">
                  <div className="a"> <SvgSad /> </div>
                  <div className="b"> <p>{namePersonConnectedAA}</p> {dev && (<><img src={photoPersonConnectedAA} alt="" /></>)} </div>
                </div> </>):(<></>)}

                <div className="block-two"></div>
                {/* block-two */}
              </div>
              {/* card */}
            </div>
            {/* body */}
          </div>
          {/* align */}
        </div>
        {/* writeInfosClientPageIA */}
        </>)}
      {/* voir les reactions (page) - AA */}


      {/* conversation - AA */}
      {/* conversation - AA */}
      {/* on affiche les conversations */}
      {conversationAA && (<>
      <div className="conversationAA">
        {theme3 && (<>
        <div className="part1"> {/* partie basse theme 3 */}
          <div className="card">
            <div className="one11"> <SvgLove2 /> </div>
            {/* one11 */} 

            <div className="one22">
              <div className="one1">
                <div className="a">
                  <div className="aa">
                    <div className="aaa"> <SvgLove2 /> </div> 
                    <div className="bbb"> <p>Popularité</p> </div> 
                  </div>

                  <div className="bb"> <p>0 visite</p> </div>
                </div>
                {/* a */} 

                <div className="b"> 
                  <div className="aa"> <img src={photoPersonConnectedAA} alt="" /> </div>
                  <div className="bb"> <SvgProfil /> </div>
                </div>
                {/* b */} 
              </div>
              {/* one1 */} 

              <div className="one2">
                <div className="a">
                  <div className="aa"> <p>Publier sur Florinato et soyez Populaire</p> </div> 
                  <div className="bb"> <p>Activer la Popularité</p> </div>
                </div>
                {/* a */}

                <div className="b"> 
                  <div className="aa"> <img src={photoPersonConnectedAA} alt="" /> </div>
                  <div className="aa"> <img src={florinatoLogo} alt="" /> </div>
                </div>
                {/* b */}
              </div> 
              {/* one2 */}
            </div> 
            {/* one22 */}

          </div>
          {/* card */} 
        </div></>)}
        {/* part1 */}

            <div className="title">
              <div onClick={CloseConversationGoToVirtualPhoneAA} className="a"> <SvgMessage3 /> <p>Messages</p> </div>
              {/* a */}

              <div className="b">
                <div onClick={RefreshConversationAA} className="aa"> <SvgFavoris /> </div>
                <div onClick={RencontreAA} className="aa"> <SvgLove2 /> </div>
                {dev && (<><div onClick={AlraniPayAA} className="aa"> <SvgPay /> </div></>)}
              </div>
              {/* b */}
            </div>
            {/* title */} 

              <div onClick={PageRedirection666conversationAA}> {/* conversations */}
                {filterConversationAA.map((api) => (<>
                  <ChildApiConversationAA api={api} />
                </>))}
              </div>

            {theme3 && (<> <div style={{ paddingBottom: "50px" }}></div> </>)} {/* theme 3 true, on met un espace en bas pour eviter que les choses soit barrer */}
          </div>
          {/* conversationAA */}
        </>)}
      {/* conversation - AA */}


      {/* rencontre - AA */}
      {/* rencontre - AA */}
      {/* on affiche les personnes qui veulent trouver l'amour */}
      {rencontreAA && (<>
      <div className="profilAA">
              {theme3 && (<>
              <div className="theme-quatre-navbar-bottom-alr"> {/* partie basse theme 3 */}
                <div className="display">
                  {newMessageAA === "1" ? (<><div onClick={ConversationAA} className="a"> <SvgMessage11 /> </div></>) : (<>
                  <div onClick={ConversationAA} className="a"> <SvgMessage10 /> </div></>)} {/* conversation */}

                  <div onClick={RencontreAA} className="a"> <SvgLove /> </div> {/* rencontre */}

                  <div onClick={CloseRencontreAA} className="a"> <SvgHome2 /> </div> {/* home */}
                  {dev && (<> <div onClick={VideoAA} className="a"> <SvgVideo6 /> </div> </>)} {/* videos */}

                  <div onClick={ProfilAA} className="a"> <SvgProfil3 /> </div> {/* profil */}
                </div> 
              </div>
              </>)}

            <div className="block-one">
              <div className="a">
                <div className="aa">
                  <img src={photoPersonConnectedAA} alt="" />
                </div>

                <div className="bb"> <button>Envoyer un message</button> </div>
              </div>
              {/* a */}

              <div onClick={CloseConversationAA} className="b"> <SvgHome2 /> </div> {/* home */}
              {/* b */}
            </div>
            {/* block-one */}
          </div>
          {/* profilAA */}
        </>)}
      {/* Rencontre - AA */}
   

      {/* profil - AA */}
      {/* profil - AA */}
      {/* profil de la personne connecter */}
      {profilAA && (<>
      <div className="profilAA">
              {theme3 && (<>
              <div className="theme-quatre-navbar-bottom-alr"> {/* partie basse theme 3 */}
                <div className="display">
                  {newMessageAA === "1" ? (<><div onClick={ConversationAA} className="a"> <SvgMessage11 /> </div></>) : (<>
                  <div onClick={ConversationAA} className="a"> <SvgMessage10 /> </div></>)} {/* conversation */}

                  <div onClick={RencontreAA} className="a"> <SvgLove /> </div> {/* rencontre */}

                  <div onClick={CloseProfilAA} className="a"> <SvgHome2 /> </div> {/* home */}
                  {dev && (<> <div onClick={VideoAA} className="a"> <SvgVideo6 /> </div> </>)} {/* videos */}

                  <div onClick={ProfilAA} className="a"> <SvgProfil3 /> </div> {/* profil */}
                </div> 
              </div>
              </>)}

            <div className="block-one">
              <div className="a">
                <img onClick={SeePhotoProfil666ProfilAA} src={photoPersonConnectedAA} alt="" />
                {badgePersonConnectedAA > 0 ? (<><h3>{namePersonConnectedAA}</h3> <SvgBadge/> </>
                ):(<><h3>{namePersonConnectedAA}</h3></>)}
              </div>
              {/* a */}

              <div className="b">
                {countFollowerAA > 1 ? (<>
                <div onClick={FollowerAA} className="aa">
                  <b>{countFollowerAA} visites</b>
                </div>
                </>):(<>
                <div onClick={FollowerAA} className="aa">
                  <b>{countFollowerAA} visite</b>
                </div></>)}     
              </div>
              {/* b */}
            </div>
            {/* block-one */}

            <div className="close">
              <div className="a"> <p></p> </div> 
              <div className="b">
                <div onClick={BeforePostPhotoPageAA} className="aa"> <SvgAdd3 /> </div>
                <div onClick={ChoosePhotoProfilePageAA} className="bb"> <SvgCamera /> </div>
                <div onClick={PostTextPageAA} className="bb"> <SvgText /> </div>
                <div onClick={FavoriteAA} className="bb"> <SvgFavoris /> </div>
              </div>
            </div>
            {/* close */}
            
            {dev && (<>
            <div className="photoProfil">
              <div className="block-un">
                <img onClick={SeePhotoProfil666ProfilAA} src={photoPersonConnectedAA} alt="" />
                {badgePersonConnectedAA > 0 ? (<><h3>{namePersonConnectedAA}</h3> <SvgBadge /></>
                ):(<><h3>{namePersonConnectedAA}</h3></>)}

                {dev && (<><p>Compte Business</p></>)}
                <p style={{ paddingTop: "20px" }}></p>
              </div>
              {/* block-un */}

              <div className="block-deux"> <SvgPointsHorizontal2 /> </div>
              {/* block-deux */}
            </div>
            {/* photoProfil */}
            </>)}

            {monetizationAA && (<> {/* on a mis {monetizationAA && pour regler un probleme d'affichage, pour dire que tu m'affiches ce card uniquement si les donnees sont deja disponible */}
            {monetizationAA === "1" ? (<>
            <div onClick={AlraniBusinessAA} style={{ paddingTop: "20px", paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px", display: "flex", justifyContent: "center"  }}>
              <p style={{ color: "blue", fontSize: "17px", paddingRight: "5px" }}>Florinato Business</p>
              <SvgRight4 />
            </div>
            </>) : (<>
            <div style={{ paddingTop: "20px", paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px", textAlign: "center"  }}>
              <p style={{ paddingTop: "10px" }}>Gagner de l'argent en discutant avec les autres dans l'application de la famille, Zimagic.</p>
              <p style={{ paddingTop: "10px" }}>1FCFA par message</p>
              <p style={{ paddingTop: "12px" }}>Activer la Monétisation et générer des revenus avec les messages Zimagic</p>
              <p onClick={ActivateMonetizationAA} style={{ color: "blue", fontSize: "17px", paddingTop: "20px" }}>Activer</p>
            </div> </>)} </>)} 

            {/* on affiche tout les posts de la personne connecter */}
            {filterPost666profilAA.map((api) => (<>
                <div className="posts">
                  {/* ici on affiche: photo + nom, en haut de chaque posts */}
                  {badgePersonConnectedAA > 0 ? (<><div className="infos"> <img src={photoPersonConnectedAA} alt="" /> <p>{namePersonConnectedAA}</p> <SvgBadge /> </div></>
                  ):(<><div className="infos"> <img src={photoPersonConnectedAA} alt="" /> <p>{namePersonConnectedAA}</p> </div></>)}

                  <div onClick={PageRedirection666profilAA}>
                    <ChildApiProfilAA api={api} />
                  </div>
                  {/*  */}
                </div>
                {/* posts */}
              </>))}

              {theme3 && (<> <div style={{ paddingBottom: "50px" }}></div> </>)} {/* theme 3 true, on met un espace en bas pour eviter que les choses soit barrer */}
          </div>
          {/* profilAA */}
        </>)}
      {/* profil - AA */}


      {/* page pour afficher les abonnés de la personne connecter - AA */}
      {/* page pour afficher les abonnés de la personne connecter - AA */}
      {followerAA && (<>
          <div onClick={CloseFollowerAA} className="popup-list-des-abonnes">
            <div className="center">
              <div className="card">
                {countFollowerAA < 2 && (<><p>Voici la seule personne qui s'est abonné à votre page Alrani</p></>)}
                {countFollowerAA > 1 && (<><p>Voici les personnes qui se sont abonnés à votre page Alrani</p></>)}

                {apiFollowerAA.map((api) => (<> 
                  <ChildApiFollowerAA api={api} />
                </>))}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-list-des-abonnes */}
        </>)}
        {/* page pour afficher les abonnés de la personne connecter - AA */}


      {/* page pour afficher les abonnements de la personne connecter - AA */}
      {/* page pour afficher les abonnements de la personne connecter - AA */}
      {followingAA && (<>
          <div onClick={CloseFollowingAA} className="popup-list-des-abonnes">
            <div className="center">
              <div className="card">
                {countFollowingAA < 2 && (<><p>Vous êtes abonné à cette page Alrani</p></>)}
                {countFollowingAA > 1 && (<><p>Vous vous êtes abonnés à ces pages Alrani</p></>)}

                {apiFollowerAA.map((api) => (<> 
                  <ChildApiFollowingAA api={api} />
                </>))}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-list-des-abonnements */}
        </>
      )}
      {/* page pour afficher les abonnements de la personne connecter - AA */}


      {/* favoris (page) - AA */}
      {/* favoris (page) - AA */}
      {favoriteAA && (<>
          <div className="favoriteAA">
            <div className="close"> 
              <div className="a"> 
                <div onClick={CloseFavoriteAA} className="aa"> <SvgLeft /> </div>
                <div className="bb"> <p>Favoris</p> </div>
              </div>
              {/* a */}

              <div className="b">
                <div onClick={AddPhotoToFavoritePageAA} className="aa"> <SvgAdd5 /> </div>
                <div onClick={AddCoverVideoPageAA} className="aa"> <SvgVideo8 /> </div>
                <div onClick={Infos666favoriteAA} className="aa"> <SvgInfos /> </div>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <div className="infos"> <p>Vidéos</p> </div>
              {/* infos */}

              <div className="display-videos">
                {allFavoriteAA.map((api) => (
                <div onClick={PageRedirection666ChildApiVideo666favoriteAA}>
                  <ChildApiVideo666favoriteAA api={api} />
                </div>
                ))}
              </div>
              {/* display-videos */} 
            </div>
            {/* align */}
          </div>
          {/* favoriteAA */}
        </>)}
      {/* favoris (page) - AA */}

      {/* infos666favoriteAA (on passe une petite infos) */}
      {/* infos666favoriteAA (on passe une petite infos) */}
      {infos666favoriteAA && (<>
      <div onClick={CloseInfos666favoriteAA} className="infosLanguage">
        <div className="align">
          <div className="card"> <p>Ajouter vos photos à vos favoris pour les pubiées à n'importe quelle moment</p> </div>
        </div>
        {/* align */}
      </div>
      {/* infosLanguage */}
      </>)}
      {/* infos666favoriteAA (on passe une petite infos) */}


      {/* seeVideo (666 favoriteAA) */}
      {/* seeVideo (666 favoriteAA) */}
      {/* page pour voir la video sur laquelle j'ai cliqué (au niveau des favoris il clique sur une video) */}
      {seeVideo666favoriteAA && (<>
          <div className="videoPageVB">
            <div className="close">
              <div onClick={CloseSeeVideo666favoriteAA} className="aa"> <SvgLeft /> </div>
              <div onClick={PopupToRightAA} className="bb"> <SvgVertical /> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video */}
              <video onEnded={LectureVideoTerminer} autoPlay={"autoplay"} muted onClick={ConfigurationVideo} ref={videoRef} src={urlVideoAA} />

              {/* configurationVideo (bouton de configuration de la video) - VB */}
              {/* on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying && (<><div onClick={Play} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying && (<><div onClick={Play} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec} min="0" max={durationSec} default="0" onChange={(e) => { videoRef.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime[0]}:{currentTime[1]} / {duration[0]}:{duration[1]}</p> </div>
                      
                      <div onClick={FullScreen} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}
                      
                      {son && (<><div onClick={VolumeOff} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son && (<><div onClick={VolumeOn} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>)} {/* le code de configurationVideo se ferme ici */}
            </div>
            {/* videoo */}
          </div>
          {/* videoPageVB */}
        </>)}
      {/* seeVideo666favoriteAA */} 

      {/* Popup To Right - AA */}
      {/* apres avoir cliquer sur une photo 666 favoris, dans la page qui va s'afficher il y'aura une PopupToRight */}
      {popupToRightAA && (<>
          <div onClick={ClosePopupToRightAA} className="popupToRightIA-opacity">
            <div className="block-un">
              <div onClick={PostVideoPageAA} className="icon"> <p>Publier cette vidéo</p> </div>
              <div onClick={PostPhotoPageAA} className="icon"> <p>Publier cette photo</p> </div>
              <div onClick={PhotoProfile666favoriteAA} className="icon-b"> <p>Mettre cette photo comme photo de profil</p> </div>
              {/* icon-b */}
            </div>
            {/* block-un */}
          </div>
          {/* popupToRightIA-opacity */}
        </>
      )}
      {/* Popup To Right - AA */}


      {/* seePhoto (666 favoriteAA) */}
      {/* seePhoto (666 favoriteAA) */}
      {/* page pour voir la photo sur laquelle j'ai cliqué au niveau des favoris */}
      {seePhoto666favoriteAA && (<>
          <div className="seePhoto666favoriteAA">
            <div className="close">
              <div onClick={CloseSeePhoto666favoriteAA} className="aa"> <SvgLeft /> </div>
              <div className="bb"></div>
            </div>
            {/* close */}

            <div className="block-one"> <img onClick={SeePhotoAA} src={urlPhotoAA} alt="" /> </div>
            {/* block-one */}

            <div className="block-two">
              <button onClick={LierMusicPageAA}>Lier une musique</button>
              <button onClick={PostPhotoPageAA}>Publier cette photo</button>
              <button onClick={PhotoProfile666favoriteAA}>Mettre cette photo comme photo de profil</button>
              <button onClick={AddVideoToPhotoPageAA}>Ajouter une vidéo à cette photo</button>
            </div>
            {/* block-two */} 
          </div>
          {/* videoPageVB */}
        </>)}
      {/* seePhoto (666 favoriteAA) */} 


      {/* page pour choisir la video a ajouter a une photo - AA  */}
      {/* page pour choisir la video a ajouter a une photo - AA  */}
      {addVideoToPhotoPageAA && (<>
          <div className="publier-video-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseAddVideoToPhotoPageAA} className="block">
                  <div className="a"> <SvgVideo9 /> </div>
                  <div className="b"> <p>Choisir la vidéo à Ajouter à cette photo</p> </div>
                </div>
                {/* block */}

                <div className="block-deux"> <input onChange={(e) => setFileVideoAA(e.target.files[0])} id="file" type="file" name="video" accept=".mp4" /> </div>
                {/* block-deux */}

                {isLoadingVideo666favoriteAA ? (<div style={{ align: "center", padding: "3px" }}> <p>Votre vidéo sera ajoutée à cette photo... Vous pouvez continuer à naviguer sur Alrani ou dans d'autres applications de votre Téléphone virtuel mais! Ne Recharger pas la page. Vous verez votre vidéo lorsqu'elle sera ajoutée à cette photo</p> </div>
                ):(<><div className="block-trois"> <button onClick={AddVideoAA}>Continuer</button> </div></>)}

                <div className="block-quatre"> <p>Max: 100MB</p> </div> 
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* publier-video-opacity */}
        </>)}
        {/* page pour choisir la video a ajouter a une photo - AA  */}


      {/* PhotoProfileAA (au niveau des favoris, selectionner une photo a mettre sur le profil) - AA */}
      {/* PhotoProfileAA (au niveau des favoris, selectionner une photo a mettre sur le profil) - AA */}
      {photoProfile666favoriteAA && (<>
      <div className="photoProfileAA">
        <div className="close">
          <div className="a"> <div onClick={ClosePhotoProfile666favoriteAA} className="aa"><SvgLeft /></div> </div>
          <div className="b"> <img onClick={SeePhotoWithNamePersonConnectedAA} src={photoPersonConnectedAA} alt="" /> </div>
        </div>
        {/* close */}

        <div className="block-one">
          <img onClick={SeePhotoAAreq} src={urlPhotoAAreq} alt="" />

          {isLoadingPhotoProfileAA ? (<> <Loader /> </>
          ):(<> <button onClick={PhotoProfileAA666favoriteAA}>Mettre sur le profil</button> </>)}
        </div>
        {/* block-one */}
      </div>
      {/* PhotoProfileAA */}
      </>
      )}
      {/* PhotoProfileAA (au niveau des favoris, selectionner une photo a mettre sur le profil) - AA */}


      {/* voir photo + nom de la personne connecté - AA */}
      {/* voir photo + nom de la personne connecté - AA */}
      {seePhotoWithNamePersonConnectedAA && (<>
          <div onClick={CloseSeePhotoWithNamePersonConnectedAA} className="seePhotoWithNameAA">
            <div className="block-two">
              <div className="a">
                <div className="aa"> <img src={photoPersonConnectedAA} alt="" /> </div>
                <div className="bb"> <p>{namePersonConnectedAA }</p> </div>
              </div>
              {/* a */}

              <div className="b"> </div>
              {/* b */}
            </div>
            {/* block-two */}
          </div>
          {/* seePhotoWithNameAA */}
        </>
      )}
      {/* voir photo + nom de la personne connecté - AA */}


      {/* Monétisation Activé (message de success) - AA */}
      {/* Monétisation Activé (message de success) - AA */}
      {monetizationSuccessAA && (<>
          <div onClick={CloseMonetizationSuccessAA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Monétisation Activé</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* Monétisation Activé (message de success) - AA */}

      

      {/* seePhoto2 (page pour voir la photo de la personne connecté) */}
      {/* seePhoto2 (page pour voir la photo de la personne connecté) */}
      {seePhoto2personConnectedAA && (<>
          <div className="seePhoto2AA">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseSeePhoto2personConnectedAA} className="b"> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={photoPersonConnectedAA} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhoto2AA */}
        </>)}
        {/* seePhoto2 (page pour voir la photo de la personne connecté) */}

      {/* ajouter une photo aux favoris - AA */}
      {/* ajouter une photo aux favoris - AA */}
      {addPhotoToFavoritePageAA && (<> 
      <div className="page-general-opacity"> 
        <div className="align"> 
          <div className="card"> 
            <div onClick={CloseAddPhotoToFavoritePageAA} className="center"> <Svg3Photo3 /> </div>
            <div onClick={CloseAddPhotoToFavoritePageAA} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px", textAlign: "center" }}>Ajouter une photo à vos Favoris</p> </div>

            <div className="capture-decran-du-contact">
              <div className="display"> <input onChange={(e) => setFilePhotoAA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            </div>

            <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

            {isLoading ? (<><div className="loader-display-flex"> <Loader /> </div></>
            ):(<><div className="orange-btn"> <button onClick={AddPhotoToFavoriteAA}>Continuer</button> </div></>)}
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* page-general-opacity */}
    </>)}
    {/* ajouter une photo aux favoris - AA */}


      {/* success AddPhotoToFavorite - AA */}
      {/* success AddPhotoToFavorite - AA */}
      {/* message de succes (on affiche ce message de succes s'il a reussi a ajouter une photo aux favoris) */}
      {successAddPhotoToFavoriteAA && (<>
          <div onClick={CloseSuccessAddPhotoToFavoriteAA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Photo ajoutée</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* success AddPhotoToFavorite - AA */}


      {/* page pour ajouter la photo de couverture de la video - AA */}
      {/* page pour ajouter la photo de couverture de la video - AA */}
      {addCoverVideoPageAA && (<>
      <div className="page-general-opacity"> 
        <div className="align">
          <div className="card">
            <div onClick={CloseAddCoverVideoPageAA} className="center"> <SvgOneImage3 /> </div>
            <div onClick={CloseAddCoverVideoPageAA} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px", textAlign: "center" }}>Photo de couverture de la Vidéo</p> </div>

            <div className="capture-decran-du-contact">
              <div className="display"> <input onChange={(e) => setFilePhotoAA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            </div>

            <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

            {isLoadingCoverVideo666favoriteAA ? (<><div className="loader-display-flex"> <Loader /> </div>
            </>):(<><div className="vert-btn"> <button onClick={AddCoverVideoAA}>Continuer</button> </div></>)}
          </div>
          {/* card */} 
        </div>
        {/* align */} 
      </div>
      {/* page-general-opacity */}
    </>)}
    {/* page pour ajouter la photo de couverture de la video - AA  */}

 
      {/* page pour choisir la video a publier - AA  */}
      {/* page pour choisir la video a publier - AA  */}
      {addVideoPageAA && (<>
          <div className="publier-video-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseAddVideoPageAA} className="block">
                  <div className="a"> <SvgVideo9 /> </div>
                  <div className="b"> <p>Choisir la vidéo à Publier</p> </div>
                </div>
                {/* block */}

                <div className="block-deux"> <input onChange={(e) => setFileVideoAA(e.target.files[0])} id="file" type="file" name="video" accept=".mp4" /> </div>
                {/* block-deux */}

                {isLoadingVideo666favoriteAA ? (<div style={{ align: "center", padding: "3px" }}> <p>Votre vidéo sera ajoutée aux favoris... Vous pouvez continuer à naviguer sur Alrani ou dans d'autres applications de votre Téléphone virtuel mais! Ne Recharger pas la page. Vous verez votre vidéo lorsqu'elle sera ajoutée à vos favoris</p> </div>
                ):(<><div className="block-trois"> <button onClick={AddVideoAA}>Continuer</button> </div></>)}

                <div className="block-quatre"> <p>Max: 100MB</p> </div> 
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* publier-video-opacity */}
        </>)}
      {/* page pour choisir la video a publier - AA  */}


      {/* page pour publié la video - AA */}
      {/* page pour publié la video - AA */}
      {postVideoPageAA && (<>
      <div className="postVideoPageAA">
      <p style={{ paddingTop: "40px" }}></p>

      <div onClick={ClosePostVideoPageAA} className="publier-publication">
        <div className="center"> <Svg3Photo3 /> </div>
        <div> <p style={{fontSize: "17px", paddingTop: "5px", textAlign: "center" }}>Publier une Vidéo..</p> </div>
        <div className="hr"> <hr /> </div>
      </div>
      {/* publier-publication */}

      <div className="post">
        <div className="block-one">
          <img onClick={SeePhotoProfil666ProfilAA} src={photoPersonConnectedAA} alt="" />
          <p>{namePersonConnectedAA}</p>
        </div>

        <div className="block-two"> <pre>{writeDescriptionAA}</pre> </div>
      </div>
      {/* post */}

      <div className="block-one"> <video autoPlay={"autoplay"} muted loop controls><source src={urlVideoAA} type="video/mp4" /></video> </div>
      {/* block-one */}

      <div className="block-two">
        <div className="a"> <p>Photo de couverture de la vidéo</p> </div>
        <div className="b"> <img onClick={SeePhotoAAreq} src={urlPhotoAAreq} alt="" /> </div>
      </div>
      {/* block-two */}

      {isLoading666postVideoPageAA ? (<div className="loader-display-flex"> <Loader /> </div>
      ):(<><div className="vert-btn"> <button onClick={PostVideoAA}>Publier maintenant</button> </div></>)}

      <p style={{ paddingBottom: "100px" }}></p>

      {!isLoading666postVideoPageAA && (<>
        <div className="write">
          <div className="a"> <textarea type="text" placeholder="Description de la vidéo.." value={writeDescriptionAA} onChange={(e) => setWriteDescriptionAA(e.target.value)}></textarea> </div>
        </div>
        {/* write */}
      </>)}
    </div>
    {/* postVideoPageAA */}
  </>)}
  {/* page pour publié la video - AA */}


      {/* choisir la photo a mettre sur le profil (page) - AA */}
      {/* choisir la photo a mettre sur le profil (page) - AA */}
      {choosePhotoProfilePageAA && (<>
          <div className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseChoosePhotoProfilePageAA} className="center"> <SvgCamera3 /> </div>
                <div onClick={CloseChoosePhotoProfilePageAA} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px" }}>Photo de Profil</p> </div>

                <div className="capture-decran-du-contact">
                  <div className="display">
                    <div style={{ paddingRight: "5px" }} className="aa"> <SvgImage /> </div>
                    <div className="bb"> <input onChange={(e) => setFile(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
                    <div onClick={InfosMettrePhotoProfil} style={{ paddingLeft: "10px" }} className="cc"> <SvgInfos4 /> </div>
                  </div>
                  {/* display */}
                </div>
                {/* capture-decran-du-contact */}
                <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

                {isLoadingPhotoProfileAA ? (<div className="loader-display-flex"> <Loader /> </div>
                ):(<><div className="vert-btn"> <button onClick={PhotoProfileAA}>Continuer</button> </div></>)}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* add-your-contact-opacity */}
        </>)}
        {/* choisir la photo a mettre sur le profil (page) - AA */}


      {/* infos - mettre photo profil */}
      {/* infos - mettre photo profil */}
      {infosMettrePhotoProfil && (<>
          <div onClick={InfosMettrePhotoProfil} className="popup-infos-capture-decran-opacity">
            <div className="align">
              <div className="card"> <p>Choisir la photo à mettre sur le profil</p> </div>
            </div>
            {/* align */}
          </div>
          {/* popup-infos-capture-decran-opacity */}
        </>)}
      {/* infos - mettre photo profil */}

      
      {/* photo de profil ajoutée (message de success) - AA */}
      {/* photo de profil ajoutée (message de success) - AA */}
      {photoProfileSuccessAA && (<>
          <div onClick={ClosePhotoProfileSuccessAA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Photo mis sur le profil</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* photo de profil ajoutée (message de success) - AA */}
     

      {/* ajouter une image au favoris (page) - AA */}
      {/* ajouter une image au favoris (page) - AA */}
      {beforePostPhotoPageAA && (<>
      <div className="page-general-opacity"> 
        <div className="align">
          <div className="card">
            <div onClick={CloseBeforePostPhotoPageAA} className="center"> <SvgOneImage3 /> </div>
            <div onClick={CloseBeforePostPhotoPageAA} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px", textAlign: "center" }}>Publier quelque chose..</p> </div>

            <div className="capture-decran-du-contact">
              <div className="display"> <input onChange={(e) => setFilePhotoAA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            </div>

            <div onClick={PostPhotoAA} style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

            {isLoading ? (<><div className="loader-display-flex"> <Loader /> </div>
            </>):(<><div className="vert-btn"> <button onClick={SendPhotoToCloudinaryAA}>Continuer</button> </div></>)}
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* page-general-opacity */}
    </>)}
    {/* ajouter une image au favoris (page) - AA */}


      {/* postPhotoPageAA (page pour ecrire la description et publier la photo) */}
      {/* postPhotoPageAA (page pour ecrire la description et publier la photo) */}
      {postPhotoPageAA && (<>
      <div className="beforePostImageAA">
      <p style={{ paddingTop: "40px" }}></p>

      <div onClick={ClosePostPhotoPageAA} className="publier-publication">
        <div className="center"> <Svg1Photo3 /> </div>
        <div> <p style={{fontSize: "17px", paddingTop: "5px", textAlign: "center" }}>Publier quelque chose..</p> </div>
        <div className="hr"> <hr /> </div>
      </div>
      {/* publier-publication */}

      <div className="post">
        <div className="block-one">
          <img onClick={SeePhotoProfil666ProfilAA} src={photoPersonConnectedAA} alt="" />
          <p>{namePersonConnectedAA}</p>
        </div>

        <div className="block-two">
          <pre>{writeDescriptionAA}</pre>
          <img onClick={SeePhotoAAreq} src={urlPhotoAAreq} alt="" />
        </div>
        {/* block-two */}
      </div>

      {isLoading666postPhotoPageAA ? (<><div className="loader-display-flex"> <Loader /> </div></>
      ):(<><div className="vert-btn"> <button onClick={SendPhotoAA}>Publier maintenant</button> </div></>)}

      <p style={{ paddingBottom: "100px" }}></p>

      {!isLoading666postPhotoPageAA && (<>
        <div className="write">
          <div className="a"> <textarea type="text" placeholder="Dites quelque chose.." value={writeDescriptionAA} onChange={(e) => setWriteDescriptionAA(e.target.value)}></textarea> </div>
        </div></>)}
        {/* write */}
    </div>
    {/* beforePostImageAA */}
  </>)}
  {/* postPhotoPageAA (page pour ecrire la description et publier la photo) */}

      {/* seePhotoAAreq (lors des requetes, on affiche la photo sur laquelle on a cliquer) */}
      {/* seePhotoAAreq (lors des requetes, on affiche la photo sur laquelle on a cliquer) */}
      {seePhotoAAreq && (<>
      <div className="seePhoto2AA">
          <div className="close">
            <div className="a"> </div>
            <div onClick={CloseSeePhotoAAreq} className="b"> <SvgClose2 /> </div>
          </div>
            {/* close */}

          <div className="card"> <img src={urlPhotoAAreq} alt="" /> </div>
          {/* card */}
        </div>
        {/* seePhoto2AA */}
      </>)}
      {/* seePhotoAAreq (lors des requetes, on affiche la photo sur laquelle on a cliquer) */}


      {/* postTextPageAA (page pour faire une publication text) */}
      {/* postTextPageAA (page pour faire une publication text) */}
      {postTextPageAA && (<>
      <div className="beforePostImageAA">
      <p style={{ paddingTop: "40px" }}></p>

      <div onClick={ClosePostTextPageAA} className="publier-publication">
        <div className="center"> <SvgText3 /> </div>
        <div> <p style={{fontSize: "17px", paddingTop: "5px", textAlign: "center" }}>Faire une Publication Texte</p> </div>
        <div className="hr"> <hr /> </div>
      </div>
      {/* publier-publication */}

      <div className="post">
        <div className="block-one">
          <img onClick={SeePhotoProfil666ProfilAA} src={photoPersonConnectedAA} alt="" />
          <p>{namePersonConnectedAA}</p>
        </div>

        <div className="block-two"> <pre>{writeDescriptionAA}</pre> </div>
        {/* block-two */}
      </div>

      {isLoading ? (<><div className="loader-display-flex"> <Loader /> </div>
      </>):(<><div className="vert-btn"> <button onClick={PostTextAA}>Publier maintenant</button> </div></>)}

      <p style={{ paddingBottom: "100px" }}></p>
      {/* publier une photo (ca c'est le textarea pour publier une photo) */}
      {!isLoading && (<>
        <div className="write">
          <div className="a"> <textarea type="text" placeholder="Écriver la publication.." value={writeDescriptionAA} onChange={(e) => setWriteDescriptionAA(e.target.value)}></textarea> </div>
        </div></>)}
        {/* write */}
    </div>
    {/* beforePostImageAA */}
  </>)}
  {/* postTextPageAA (page pour faire une publication text) */}

      {/* post publié (message de success) - AA */}
      {/* post publié (message de success) - AA */}
      {postSuccessAA && (<>
          <div onClick={ClosePostSuccessAA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Publié</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* post publié (message de success) - AA */}

  
      {/* seePost (666 ProfilAA) */}
      {/* seePost (666 ProfilAA) */}
      {/* on affiche le post sur laquelle on a cliquer */}
      {seePost666ProfilAA && (<>  
          <div className="seePostAA">
            <div className="close">
              <div className="block-un">
                <div className="a" onClick={CloseSeePost666ProfilAA}> <SvgLeft /> </div>
                <div className="b"> <p>Publication de {namePersonConnectedAA}</p> </div>
                {dev && (<>
                <div className="c"> <button>S'abonner</button> </div></>)}
              </div>
              {/* block-un */}

              <div className="block-deux"> <p></p> </div>
              {/* block-deux */}
            </div>
            {/* close */}

            {/* on affiche les posts */}
            {filterPostAA.map((api) => (<>
                <div className="posts">
                  {/* ici on affiche: photo + nom, en haut de chaque posts */}
                  <div className="infos">
                    <img src={photoPersonConnectedAA} alt="" />
                    <p>{namePersonConnectedAA}</p>
                  </div>
                  {/* infos */}

                  <div onClick={PageRedirection666seePost666ProfilAA}>
                    <ChildApiSeePostAA api={api} />
                  </div>
                </div>
                {/* posts */}
              </>))}

            {/* on affiche les commentaires - AA */}
            {filterCommentAA.map((api) => (<>
              <div onClick={ReplyAA}>
                <ChildApiCommentAA api={api} />
              </div>
            </>))}

            <p style={{ paddingTop: "100px" }}></p>

            <div className="write">
              <div className="a"> <textarea type="text" placeholder="Commentez..." value={writeCommentAA} onChange={(e) => setWriteCommentAA(e.target.value)}></textarea> </div>
              <div onClick={SaveCommentAA} className="b"> <SvgSend /> </div>
            </div> 
            {/* write */}
          </div>
          {/* seePostAA */}
        </>
      )}
      {/* seePost (666 ProfilAA) */}


      {/* voir photo profil (666 ProfilAA) */}
      {/* voir photo profil (666 ProfilAA) */}
      {/* on affiche la photo de profil */}
      {seePhotoProfil666ProfilAA && (<>
          <div onClick={CloseSeePhotoProfil666ProfilAA} className="popup-image-opacity">
            <div className="align">
              <div className="image"> <img src={photoPersonConnectedAA} alt="" /> </div>
            </div>
            {/* align */}
          </div>
          {/* popup-image-opacity */}
        </>)}
      {/* voir photo profil (666 ProfilAA) */}


      {/* menu */}
      {/* menu */}
      {/* menu */}
      {/* menu */}
      {menu && (
        <>
          <div onClick={Menu} className="popup-menu-opacity">
            <div className="align">
              <div className="card">
                <div style={{ paddingTop: "20px" }} className="a">
                  <svg
                    onClick={Theme}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    enableBackground="new 0 0 478.703 478.703"
                    version="1.1"
                    viewBox="0 0 478.703 478.703"
                    xmlSpace="preserve"
                  >
                    <path d="M454.2 189.101l-33.6-5.7c-3.5-11.3-8-22.2-13.5-32.6l19.8-27.7c8.4-11.8 7.1-27.9-3.2-38.1l-29.8-29.8c-5.6-5.6-13-8.7-20.9-8.7-6.2 0-12.1 1.9-17.1 5.5l-27.8 19.8c-10.8-5.7-22.1-10.4-33.8-13.9l-5.6-33.2a29.54 29.54 0 00-29.2-24.7h-42.1c-14.5 0-26.8 10.4-29.2 24.7l-5.8 34c-11.2 3.5-22.1 8.1-32.5 13.7l-27.5-19.8c-5-3.6-11-5.5-17.2-5.5-7.9 0-15.4 3.1-20.9 8.7l-29.9 29.8c-10.2 10.2-11.6 26.3-3.2 38.1l20 28.1c-5.5 10.5-9.9 21.4-13.3 32.7l-33.2 5.6a29.54 29.54 0 00-24.7 29.2v42.1c0 14.5 10.4 26.8 24.7 29.2l34 5.8c3.5 11.2 8.1 22.1 13.7 32.5l-19.7 27.4c-8.4 11.8-7.1 27.9 3.2 38.1l29.8 29.8c5.6 5.6 13 8.7 20.9 8.7 6.2 0 12.1-1.9 17.1-5.5l28.1-20c10.1 5.3 20.7 9.6 31.6 13l5.6 33.6a29.54 29.54 0 0029.2 24.7h42.2c14.5 0 26.8-10.4 29.2-24.7l5.7-33.6c11.3-3.5 22.2-8 32.6-13.5l27.7 19.8c5 3.6 11 5.5 17.2 5.5 7.9 0 15.3-3.1 20.9-8.7l29.8-29.8c10.2-10.2 11.6-26.3 3.2-38.1l-19.8-27.8c5.5-10.5 10.1-21.4 13.5-32.6l33.6-5.6a29.54 29.54 0 0024.7-29.2v-42.1c.2-14.5-10.2-26.8-24.5-29.2zm-2.3 71.3c0 1.3-.9 2.4-2.2 2.6l-42 7c-5.3.9-9.5 4.8-10.8 9.9-3.8 14.7-9.6 28.8-17.4 41.9-2.7 4.6-2.5 10.3.6 14.7l24.7 34.8c.7 1 .6 2.5-.3 3.4l-29.8 29.8c-.7.7-1.4.8-1.9.8-.6 0-1.1-.2-1.5-.5l-34.7-24.7c-4.3-3.1-10.1-3.3-14.7-.6-13.1 7.8-27.2 13.6-41.9 17.4-5.2 1.3-9.1 5.6-9.9 10.8l-7.1 42c-.2 1.3-1.3 2.2-2.6 2.2h-42.1c-1.3 0-2.4-.9-2.6-2.2l-7-42c-.9-5.3-4.8-9.5-9.9-10.8-14.3-3.7-28.1-9.4-41-16.8-2.1-1.2-4.5-1.8-6.8-1.8-2.7 0-5.5.8-7.8 2.5l-35 24.9c-.5.3-1 .5-1.5.5-.4 0-1.2-.1-1.9-.8l-29.8-29.8c-.9-.9-1-2.3-.3-3.4l24.6-34.5c3.1-4.4 3.3-10.2.6-14.8-7.8-13-13.8-27.1-17.6-41.8-1.4-5.1-5.6-9-10.8-9.9l-42.3-7.2c-1.3-.2-2.2-1.3-2.2-2.6v-42.1c0-1.3.9-2.4 2.2-2.6l41.7-7c5.3-.9 9.6-4.8 10.9-10 3.7-14.7 9.4-28.9 17.1-42 2.7-4.6 2.4-10.3-.7-14.6l-24.9-35c-.7-1-.6-2.5.3-3.4l29.8-29.8c.7-.7 1.4-.8 1.9-.8.6 0 1.1.2 1.5.5l34.5 24.6c4.4 3.1 10.2 3.3 14.8.6 13-7.8 27.1-13.8 41.8-17.6 5.1-1.4 9-5.6 9.9-10.8l7.2-42.3c.2-1.3 1.3-2.2 2.6-2.2h42.1c1.3 0 2.4.9 2.6 2.2l7 41.7c.9 5.3 4.8 9.6 10 10.9 15.1 3.8 29.5 9.7 42.9 17.6 4.6 2.7 10.3 2.5 14.7-.6l34.5-24.8c.5-.3 1-.5 1.5-.5.4 0 1.2.1 1.9.8l29.8 29.8c.9.9 1 2.3.3 3.4l-24.7 34.7c-3.1 4.3-3.3 10.1-.6 14.7 7.8 13.1 13.6 27.2 17.4 41.9 1.3 5.2 5.6 9.1 10.8 9.9l42 7.1c1.3.2 2.2 1.3 2.2 2.6v42.1h-.1z"></path>
                    <path d="M239.4 136.001c-57 0-103.3 46.3-103.3 103.3s46.3 103.3 103.3 103.3 103.3-46.3 103.3-103.3-46.3-103.3-103.3-103.3zm0 179.6c-42.1 0-76.3-34.2-76.3-76.3s34.2-76.3 76.3-76.3 76.3 34.2 76.3 76.3-34.2 76.3-76.3 76.3z"></path>
                  </svg>
                  <p onClick={Theme}>Paramètres</p>
                </div>

                {donaziaFA === "1" && (<>
                <div className="a">
                  <svg
                    onClick={FonctionnalitesSupplementaireFA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="#000"
                    viewBox="0 0 32 32"
                  >
                    <path d="M27.783 7.936a6.377 6.377 0 01-1.379 6.955c-2.071 2.071-5.201 2.395-7.634 1.022l-1.759 1.921 1.255 1.26.75-.75a.98.98 0 011.388 0l6.082 6.144a.98.98 0 010 1.388l-2.776 2.776a.98.98 0 01-1.388 0l-6.082-6.144a.98.98 0 010-1.388l.685-.685-1.196-1.199-8.411 9.189a1.962 1.962 0 01-2.776 0l-.694-.694a1.962 1.962 0 010-2.776l9.582-8.025-6.364-6.381-2.01-.001-2.326-3.74 1.872-1.875 3.825 2.341.025 1.968 6.438 6.463 1.873-1.568c-1.831-2.496-1.64-6.012.616-8.268a6.382 6.382 0 016.925-1.396L20.18 8.54l3.471 3.471 4.132-4.075zM6.15 25.934a.982.982 0 10-1.388 1.39.982.982 0 001.388-1.39z"></path>
                  </svg>
                  <p onClick={FonctionnalitesSupplementaireFA} style={{ color: "black" }}>Fonctionalités supplémentaires</p>
                </div> </>)}

                {dev && (<>
                <div className="a">
                  <svg
                    onClick={Notification}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="black"
                    viewBox="0 0 24 24"
                  >
                    <path d="M10 21h4a2 2 0 01-4 0zm-6.924-2.617a1 1 0 01.217-1.09L5 15.586V10a7.006 7.006 0 016-6.92V2a1 1 0 012 0v1.08A7.006 7.006 0 0119 10v5.586l1.707 1.707A1 1 0 0120 19H4a1 1 0 01-.924-.617zM6.414 17h11.172l-.293-.293A1 1 0 0117 16v-6a5 5 0 00-10 0v6a1 1 0 01-.293.707z"></path>
                  </svg>

                  <p onClick={Notification} style={{ color: "black" }}>Notifications</p>
                </div>

                <div className="a">
                  <svg
                    onClick={ToolsAA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="#000"
                    viewBox="0 0 32 32"
                  >
                    <path d="M27.783 7.936a6.377 6.377 0 01-1.379 6.955c-2.071 2.071-5.201 2.395-7.634 1.022l-1.759 1.921 1.255 1.26.75-.75a.98.98 0 011.388 0l6.082 6.144a.98.98 0 010 1.388l-2.776 2.776a.98.98 0 01-1.388 0l-6.082-6.144a.98.98 0 010-1.388l.685-.685-1.196-1.199-8.411 9.189a1.962 1.962 0 01-2.776 0l-.694-.694a1.962 1.962 0 010-2.776l9.582-8.025-6.364-6.381-2.01-.001-2.326-3.74 1.872-1.875 3.825 2.341.025 1.968 6.438 6.463 1.873-1.568c-1.831-2.496-1.64-6.012.616-8.268a6.382 6.382 0 016.925-1.396L20.18 8.54l3.471 3.471 4.132-4.075zM6.15 25.934a.982.982 0 10-1.388 1.39.982.982 0 001.388-1.39z"></path>
                  </svg>
                  <p onClick={ToolsAA} style={{ color: "black" }}>Outils</p>
                </div>

                <NavLink style={{ textDecoration: "none" }} to="/actu">
                  <div className="a">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      fill="#000"
                      viewBox="0 0 17 17"
                    >
                      <path d="M17 16v1H0v-1h17zM5.203 7.976l4.204 3.026L15 4.751v2.284h1V3h-4.036v1h2.366L9.26 9.665 5.131 6.691.759 10.647l.671.741 3.773-3.412z"></path>
                    </svg>
                    <p style={{ color: "black" }}>Fil d'actualité</p>
                  </div>
                </NavLink>

                <div className="a">
                  <svg
                    onClick={HomeAA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    viewBox="0 0 17 17"
                  >
                    <path d="M17 16v1H0v-1h17zM5.203 7.976l4.204 3.026L15 4.751v2.284h1V3h-4.036v1h2.366L9.26 9.665 5.131 6.691.759 10.647l.671.741 3.773-3.412z"></path>
                  </svg>
                  <p onClick={HomeAA} style={{ color: "black" }}>
                    new
                  </p>
                </div>

                <div className="a">
                  <svg
                    onClick={NewAA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    viewBox="0 0 17 17"
                  >
                    <path d="M17 16v1H0v-1h17zM5.203 7.976l4.204 3.026L15 4.751v2.284h1V3h-4.036v1h2.366L9.26 9.665 5.131 6.691.759 10.647l.671.741 3.773-3.412z"></path>
                  </svg>
                  <p onClick={NewAA} style={{ color: "black" }}>new 2</p>
                </div>
                {/* a */}
                </>)} {/* dev se ferme ici */}

              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-menu-opacity */}
        </>
      )}


      {/* Fonctionnalités Supplémentaires (cette page signale que au niveau de son compte Florinato, l'application Donazia a ete activé) - FA */}
      {/* Fonctionnalités Supplémentaires (cette page signale que au niveau de son compte Florinato, l'application Donazia a ete activé) - FA */}
      {fonctionnalitesSupplementaireFA && (<>
        <div className="alraniBusinessAA">
            <div className="close">
              <div onClick={CloseFonctionnalitesSupplementaireFA} className="a">
                <p>Fonctionnalités <b>Supplémentaires</b></p>
              </div>

              <div className="b"></div>
            </div>
            {/* close */}

            <div style={{ paddingTop: "30px", paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px", display: "flex"  }}>
              <p style={{ fontSize: "15px", paddingRight: "5px" }}>Fonctionnalités supplémentaires activé</p>
              <SvgValidate3 />
            </div>
          </div>
          {/* alraniBusinessAA */}
        </>)}
      {/* Fonctionnalités Supplémentaires (cette page signale que au niveau de son compte Florinato, l'application Donazia a ete activé) - FA */}


     

      {/* security alrani Pay - AA */}
      {/* security alrani Pay - AA */}
      {/* mot de passe avant d'entrer dans Alrani Pay */}
      {securityAlraniPayAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseSecurityAlraniPayAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>security alrani Pay</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* security alrani Pay - AA */}

      {/* favoris (page) - AA */}
      {/* favoris (page) - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {favoritePageAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseFavoritePageAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>favoris</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* favoris (page) - AA */}

      {/* Tools -  AA */}
      {/* Tools -  AA */}
      {/* on affiche mes outils */}
      {toolsAA && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={CloseToolsAA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Mes outils</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>Outils</p>
            </div>
            {/* block-un */}

            <div className="block-deux">
              <p>Monetization</p>
              <hr />
            </div>

            <div onClick={MonetizationDealsAA} className="block-deux">
              <p>Monetization Deals</p>
              <hr />
            </div>

            <div onClick={MonetizationFormationAA} className="block-deux">
              <p>Monetization Formation</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* Tools - AA */}

      {/* Plus -  AA */}
      {/* Plus -  AA */}
      {/* sur cette page on affiche les outils a activer */}
      {plusAA && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={ClosePlusAA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Alrani</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>Plus</p>
            </div>
            {/* block-un */}

            <div onClick={ActivateMonetizationPageAA} className="block-deux">
              <p>Monetization</p>
              <p>Avec Alrani Monetization, vous gagnez de l'argent lorsqu'une personne clique sur votre publication</p>
              <hr />
            </div>

            <div onClick={ActivateMonetizationDealsPageAA} className="block-deux">
              <p>Monetization Deals</p>
              <hr />
            </div>

            <div onClick={ActivateMonetizationFormationPageAA} className="block-deux">
              <p>Monetization Formation</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* Plus - AA */}

      {/* activate Monetization (Page) - AA */}
      {/* activate Monetization (Page) - AA */}
      {/* activation Alrani monetization */}
      {/* sur cette page on paye et active la monetisation */}
      {activateMonetizationPageAA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Alrani <b>Monetization</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateMonetizationPageAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button onClick={WriteSuperCode666ActivateMonetizationPageAA}>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Soyez rémunérer sur chaque clic sur votre vidéo, chaque fois qu'une personne cliquera pour accéder à votre chaine, elle payera 1 FCFA à chaque clic</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Monetization (Page) - AA */}

      {/* activate Monetization Deals (Page) - AA */}
      {/* activate Monetization Deals (Page) - AA */}
      {/* sur cette page on paye et active Monetization Deals - AA */}
      {activateMonetizationDealsPageAA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Monetization <b>Deals</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateMonetizationDealsPageAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Celui qui veut activer la monétisation sur sa chaine utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lorsqu'il réactivera</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Monetization Deals (Page) - AA */}

      {/* activate Monetization Formation (Page) - AA */}
      {/* activate Monetization Formation (Page) - AA */}
      {/* sur cette page on paye et active Monetization Formation - AA */}
      {activateMonetizationFormationPageAA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Monetization <b>Formation</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateMonetizationFormationPageAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Celui qui veut activer Monetization Deals utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lors de la réactivation</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Monetization Formation (Page) - AA */}

      {/* saisir le super code pour l'activation de Alrani monetization */}
      {writeSuperCode666ActivateMonetizationPageAA && (
        <>
          <div className="saisirNomBeneficiaireNumeroVirtuelGratuitIAC">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p onClick={CloseWriteSuperCode666ActivateMonetizationPageAA}>Saisir le Super code pour l'activation de Alrani monetization</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <input
                    type="text"
                    value={superCodeWrittenAA}
                    onChange={(e) =>setSuperCodeWrittenAA(e.target.value)}
                    placeholder="Saisissez..."
                  />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <button onClick={ActivateMonetizationAA}>
                    <p>Enregistrer</p>
                    <hr />
                  </button>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* saisirNomBeneficiaireNumeroVirtuelGratuitIAC */}
        </>
      )}
      {/* activate monetization - AA */}


      {/* monetization Deals - AA */}
      {/* monetization Deals - AA */}
      {monetizationDealsAA && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>Monetization <b>Deals</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseMonetizationDealsAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}

            <button onClick={WriteAmountReceivePage666MonetizationPageAA}>
                  Recevoir
                </button>
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* monetization Deals - AA */}

      {/* monetization formation - AA */}
      {/* monetization formation - AA */}
      {monetizationFormationAA && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>Monetization <b>Formation</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseMonetizationFormationAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>550 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* monetization formation - AA */}

      {/* saisir montant a recevoir (666 MonetizationPageAA) */}
      {/* saisir montant a recevoir (666 MonetizationPageAA) */}
      {/* sur cette page l'utilisateur va saisir le montant a recevoir dans son moyen de 
      paiement virtuel */}
      {writeAmountReceivePage666MonetizationPageAA && (
        <>
          <div className="writeAmountReceivePageAA">
            <div className="close">
              <div className="a">
                <p onClick={CloseWriteAmountReceivePage666MonetizationPageAA}>
                  Saisissez le montant à recevoir
                </p>
                <input
                  type="text"
                  value={writeAmountReceive666MonetizationPageAA}
                  onChange={(e) =>
                    setWriteAmountReceive666MonetizationPageAA(e.target.value)
                  }
                />
              </div>
              {/* a */}

              <div className="b">
                <button onClick={ChoosePaymentMethod666MonetizationPageAA}>
                  Valider
                </button>

                <button onClick={Receive666MonetizationPageAA}>
                  Recevoir mon argent
                </button>
              </div>
              {/* b */}
            </div>
            {/* close */}
          </div>
          {/* writeAmountReceivePageAA */}
        </>
      )}
      {/* saisir montant a recevoir (666 MonetizationPageAA) */}

      {/* choisir moyen de paiement (666 MonetizationPageAA) */}
      {/* choisir moyen de paiement (666 MonetizationPageAA) */}
      {/* il choisit le moyen de paiement ou il veut verser son argent */}
      {choosePaymentMethod666MonetizationPageAA && (
        <>
          <div
            onClick={CloseChoosePaymentMethod666MonetizationPageAA}
            className="choosePaymentMethodAA"
          >
            <div className="block-un">
              <h6>Verser mon argent</h6>
            </div>
            {/* block-un */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-deux">
              <p onClick={ConfirmDeposit666MonetizationPageAA}>dans</p>
              <h6 onClick={ConfirmDeposit666MonetizationPageAA}>izocash</h6>
            </div>
            {/* block-deux */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}
          </div>
          {/* choosePaymentMethodPageAA */}
        </>
      )}
      {/* choisir moyen de paiement (666 MonetizationPageAA) */}

      {/* confirmer versement (666 MonetizationPageAA) */}
      {/* confirmer versement (666 MonetizationPageAA) */}
      {/* sur cette page il va confirmer s'il veut vraiment verser son argent dans son moyen de
      paiement */}
      {confirmDeposit666MonetizationPageAA && (
        <>
          <div
            onClick={CloseConfirmDeposit666MonetizationPageAA}
            className="confirmDepositAA"
          >
            <div className="balance">
              <div className="a">
                <p>
                  Etes-vous sur de vouloir verser 10000 FCFA dans votre compte
                  izocash ?
                </p>
                <p>Oui</p>
                <p>Annuler</p>
              </div>
              {/* a */}
            </div>
            {/* balance */}

            <hr />

            <div className="balance">
              <div className="b">
                <p>Compte izocash</p>
                <p>Mixton</p>
              </div>
              {/* b */}

              <div className="b">
                <p>Numéro virtuel</p>
                <p>242_mixton</p>
              </div>
              {/* b */}
            </div>
            {/* balance */}

            <hr />
          </div>
          {/* confirmDepositAA */}
        </>
      )}
      {/* confirmer versement (666 MonetizationPageAA)  */}

      {/* Plus Deals - AA */}
      {/* Plus Deals - AA */}
      {plusDealsAA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Plus <b>Deals</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={ClosePlusDealsAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Avec Plus Deals, vous gagnez de l'argent lorsqu'une personne clique sur votre publication</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* Plus Deals - AA */}

      {/* Plus Formation - AA */}
      {/* Plus Formation - AA */}
      {plusFormationAA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Plus <b>Formation</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={ClosePlusFormationAA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Avec Plus Formation, vous gagnez de l'argent lorsqu'une personne clique sur votre publication</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* Plus Formation - AA */}


      {/* search - AA */}
      {/* search - AA */}
      {/* on fait des recherches sur cette page */}
      {searchAA && (<>
          <div className="searchAA">
              <div className="search-app">
                <div className="back" onClick={CloseSearchAA}><SvgLeft /></div>
                <div className="input"> <input value={mySearchAA} onChange={(e) => setMySearchAA(e.target.value)} name="search" type="text" /><SvgSearch /> </div>
                {/* input */}
              </div>
              {/* search-app */}

              {/* ca c'est la barre de filtre qui est en dessous de la barre de recherche */}
              <div className="search-section">
                <div className="overflow">
                  {allAA ? (<><div className="active"> <button onClick={AllAA}>Tout</button> </div></>
                  ) : (<><div className="no-active"> <button onClick={AllAA}>Tout</button> </div></>)}

                  {accountAA ? (<><div className="active"> <button onClick={AccountAA}>Comptes</button> </div></>
                  ) : (<><div className="no-active"> <button onClick={AccountAA}>Comptes</button> </div></>)}

                  {publicationAA ? (<><div className="active"> <button onClick={PublicationAA}>Publications</button></div></>
                  ) : (<><div className="no-active"> <button onClick={PublicationAA}>Publications</button> </div></>)}

                  {videoSearchAA ? (<><div className="active"> <button onClick={VideoSearchAA}>Vidéos</button></div></>
                  ) : (<><div className="no-active"> <button onClick={VideoSearchAA}>Vidéos</button> </div></>)}

                  {commentSearchAA ? (<><div className="active"> <button onClick={CommentSearchAA}>Commentaires</button></div></>
                  ) : (<><div className="no-active"> <button onClick={CommentSearchAA}>Commentaires</button> </div></>)}
                </div>
                {/* overflow */}
              </div>
              {/* search-section */}

              {/* mySearchAA c'est juste pour dire que on affiche rien si l'utilisateur 
              n'a rien entrer dans la barre de recherche */}
              {mySearchAA && (
              <>

              {/* allAA - body */}
              {/* allAA - body */}
              {/* allAA c'est juste pour dire que les resultat de la recherche doivent 
              s'afficher uniquement dans l'onglet allAA */}
              {allAA && (<>
                  {/* comptes - resultat de la recherche */}
                  {/* comptes - resultat de la recherche */}
                  {/* verifyAccountAA c'est pour dire que tu m'affiches ceci 
                   seulement s'il y'a des comptes lié à la recherche */}
                  {verifyAccountAA && (<>
                      {/* on affiche les comptes trouver */}
                      {accountFindAA.map((api) => (<>
                          <div onClick={PageRedirection666SearchAccountAA} className="posts">
                            <ChildApiSearchAccountAA api={api} />
                          </div>
                          {/* posts */}
                        </>))}
                      {/* accountFindAA.map */}
                    </>)}
                  {/* verifyAccountAA */}
                  {/* comptes - resultat de la recherche */}

                  {/* posts - resultat de la recherche */}
                  {/* posts - resultat de la recherche */}
                  {/* verifyPostAA c'est pour dire que tu m'affiches ceci 
                  seulement s'il y'a des posts liés à la recherche */}
                  {verifyPostAA && (<>
                      {/* pluriel si numberPostAA > 1,
                      singulier si numberPostAA < 1 */}
                      {numberPostAA > 1 ? (
                        <>
                          <div className="nbre-de-commentaire-avec-mention">
                            <p>{mySearchAA} a été mentionné dans ces publications</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="nbre-de-commentaire-avec-mention">
                            <p>{mySearchAA} a été mentionné dans cette publication</p>
                          </div>
                        </>
                      )}
                      {/* numberPostAA */}

                      {/* on affiche les posts trouver */}
                      {postFindAA.map((api) => (<>
                          <div onClick={PageRedirection666SearchPostAA} className="posts">
                            <ChildApiSearchAA api={api} />
                          </div>
                          {/* posts */}
                        </>))}
                      {/* postFindAA.map */}
                    </>)}
                  {/* verifyPostAA */}
                  {/* posts - resultat de la recherche */}

                  {/* comments - resultat de la recherche */}
                  {/* comments - resultat de la recherche */}
                  {/* verifyCommentAA c'est pour dire que tu m'affiches ceci 
                  seulement s'il y'a des commentaires liés à la recherche */}
                  {verifyCommentAA && (<>
                      {/* pluriel si numberCommentAA > 1, singulier si numberCommentAA < 1 */}
                      {numberCommentAA > 1 ? (<><div className="nbre-de-commentaire-avec-mention"> <p>{mySearchAA} a été mentionné dans ces commentaires</p> </div></>
                      ) : (<><div className="nbre-de-commentaire-avec-mention"> <p>{mySearchAA} a été mentionné dans cette commentaires</p> </div></>)}

                      {/* on affiche les commentaires trouver */}
                      {commentFindAA.map((api) => (<>
                          <div onClick={PageRedirection666SearchPostAA} className="posts">
                            <ChildApiSearchAA api={api} />
                          </div>
                          {/* posts */}
                        </>
                      ))}
                      {/* commentFindAA.map */}
                    </>
                  )}
                  {/* verifyCommentAA */}
                  {/* comments - resultat de la recherche */}
                </>
              )}
              {/* allAA - body */}

              {/* accountAA - body */}
              {/* accountAA - body */}
              {/* accountAA c'est pour dire que les resultats de la recherche doivent s'afficher uniquement dans l'onglet accountAA */}
              {accountAA && (<>
                  {/* verifyAccountAA c'est pour dire que tu m'affiches ceci seulement s'il y'a des comptes liés à la recherche */}
                  {verifyAccountAA && (<>
                      {/* on affiche les comptes trouver */}
                      {accountFindAA.map((api) => (<>
                          <div onClick={PageRedirection666SearchAccountAA}>
                            <ChildApiSearchAccountAA api={api} />
                          </div>
                        </>))}
                      {/* accountFindAA.map */}
                    </>)}
                  {/* verifyAccountAA */}
                </>)}
              {/* accountAA */}
              
              {/* publicationAA - body */}
              {/* publicationAA - body */}
              {/* publicationAA c'est pour dire que les 
              resultats de la recherche doivent s'afficher uniquement dans l'onglet publicationAA */}
              {publicationAA && (
                <>
                  {/* verifyPostAA c'est pour dire que tu m'affiches ceci 
                  seulement s'il y'a des posts liés à la recherche */}
                  {verifyPostAA && (
                  <>
                    {/* pluriel si numberPostAA > 1,
                      singulier si numberPostAA < 1 */}
                      {numberPostAA > 1 ? (
                        <>
                          <div className="nbre-de-commentaire-avec-mention">
                            <p>{mySearchAA} a été mentionné dans ces publications</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="nbre-de-commentaire-avec-mention">
                            <p>{mySearchAA} a été mentionné dans cette publication</p>
                          </div>
                        </>
                      )}
                      {/* numberPostAA */}

                      {/* on affiche les posts trouver */}
                      {postFindAA.map((api) => (
                        <>
                          <div onClick={PageRedirection666SearchPostAA} className="posts">
                            <ChildApiSearchAA api={api} />
                          </div>
                          {/* posts */}
                        </>
                      ))}
                      {/* postFindAA.map */}
                    </>
                  )}
                  {/* verifyPostAA */}
                </>
              )}
              {/* publicationAA */}

              {/* commentSearchAA - body */}
              {/* commentSearchAA - body */}
              {/* commentSearchAA c'est pour dire que
              les resultats de la recherche doivent s'afficher uniquement dans l'onglet commentSearchAA */}
              {commentSearchAA && (
                <>
                  {/* verifyCommentAA c'est pour dire que tu m'affiches ceci 
                   seulement s'il y'a des commentaires liés à la recherche */}
                  {verifyCommentAA && (
                    <>
                      {/* pluriel si numberCommentAA > 1,
                      singulier si numberCommentAA < 1 */}
                      {numberCommentAA > 1 ? (
                        <>
                          <div className="nbre-de-commentaire-avec-mention">
                            <p>{mySearchAA} a été mentionné dans ces commentaires</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="nbre-de-commentaire-avec-mention">
                            <p>{mySearchAA} a été mentionné dans ce commentaire</p>
                          </div>
                        </>
                      )}
                      {/* numberCommentAA */}

                      {/* on affiche les commentaires trouver */}
                      {commentFindAA.map((api) => (
                        <>
                          <div onClick={PageRedirection666SearchPostAA} className="posts">
                            <ChildApiSearchAA api={api} />
                          </div>
                          {/* posts */} 
                        </>
                      ))}
                      {/* commentFindAA.map */}
                    </>
                  )}
                  {/* verifyCommentAA */}
                </>
              )}
              {/* commentSearchAA */}

                </>
              )}
              {/* mySearchAA */}

              <div style={{ paddingBottom: "40px" }}></div>

              {/* mySearchAA c'est juste pour dire que on affiche rien si l'utilisateur 
              n'a rien entrer dans la barre de recherche */}
              {mySearchAA && (
                <>
                  {/* allAA - fin des resultats */}
                  {/* allAA - fin des resultats */}
                  {/* allAA c'est juste pour dire que ca doit s'afficher uniquement dans 
                  l'onglet tout */}
                  {allAA && (
                  <>
                    {/* comptes */}
                    {/* comptes */}
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyAccountAA ? (
                      <>
                        <div className="fin-des-resultats">
                          <p>Fin des résultats</p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats">
                          <p>Aucun résultat trouvé</p>
                        </div>
                      </>
                    )}

                    {/* posts */}
                    {/* posts */}
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyPostAA ? (
                      <>
                        <div className="fin-des-resultats">
                          <p>Fin des résultats</p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats">
                          <p>Aucun résultat trouvé</p>
                        </div>
                      </>
                    )}

                    {/* comments */}
                    {/* comments */}
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyCommentAA ? (
                      <>
                        <div className="fin-des-resultats">
                          <p>Fin des résultats</p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats">
                          <p>Aucun résultat trouvé</p>
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* allAA - fin des resultats */}

                {/* accountAA - fin des resultats */}
                {/* accountAA - fin des resultats */}
                {/* accountAA c'est pour dire que ca doit uniquement s'afficher 
                dans l'onglet accountAA */}
                {accountAA && (
                  <>
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyAccountAA ? (
                      <>
                        <div className="fin-des-resultats">
                          <p>Fin des résultats</p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats">
                          <p>Aucun résultat trouvé</p>
                        </div>
                      </>
                    )}
                    {/* verifyAccountAA */}
                  </>
                )}
                {/* accountAA - fin des resultats */}

                {/* publicationAA - fin des resultats */}
                {/* publicationAA - fin des resultats */}
                {/* publicationAA c'est pour dire que ca doit uniquement s'afficher 
                dans l'onglet publicationAA */}
                {publicationAA && (
                  <>
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyPostAA ? (
                      <>
                        <div className="fin-des-resultats">
                          <p>Fin des résultats</p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats">
                          <p>Aucun résultat trouvé</p>
                        </div>
                      </>
                    )}
                    {/* verifyPostAA */}
                  </>
                )}
                {/* publicationAA - fin des resultats */}

                {/* commentSearchAA - fin des resultats */}
                {/* commentSearchAA - fin des resultats */}
                {/* commentSearchAA c'est pour dire que ca doit uniquement s'afficher 
                dans l'onglet commentSearchAA */}
                {commentSearchAA && (
                  <>
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyCommentAA ? (
                      <>
                        <div className="fin-des-resultats">
                          <p>Fin des résultats</p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats">
                          <p>Aucun résultat trouvé</p>
                        </div>
                      </>
                    )}
                    {/* verifyCommentAA */}
                  </>
                )}
                {/* commentSearchAA - fin des resultats */}
              </>
            )}
            {/* mySearchAA */}

            <div style={{ paddingBottom: "400px" }}></div>
          </div>
          {/* searchAA */}
        </>
      )}
      {/* search - AA */}


      {/* plus d'options sur le compte (666 searchAA) */}
      {/* plus d'options sur le compte (666 searchAA) */}
      {moreOptionsAccount666searchAA && (<>
          <div onClick={CloseMoreOptionsAccount666searchAA} className="moreOptionsAccount666searchAA">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div onClick={ProfilOtherAA} className="block-one">
                    <img src={photoOtherAA} alt="" />
                    <p>{nameOtherAA}</p>
                  </div>
                  {/* block-one */}

                  <div className="block-two"></div>
                  {/* block-two */}
                </div>
                {/* close */}

                <div className="hr"> <hr/> </div>
                {/* hr */}
              </div>
              {/* head */}

              <div className="body">
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p></p> </div>
                    <div className="b"> <p></p> </div>
                  </div>
                  {/* block-one */}
                  
                  {!personConnectedAA && (<>
                  <div className="block-two">
                    <div onClick={BeginConversationAA} className="a"> <SvgMessage /> </div>
                    <div className="b"> <p onClick={BeginConversationAA}>Envoyer un message</p> </div>
                  </div></>)}
                  {/* block-two */}
                  <hr />
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* moreOptionsAccount666searchAA */}
        </>)}
        {/* plus d'options sur le compte (666 searchAA) */}


      {/* message - AA */}
      {/* message - AA */}
      {/* on affiche les messages */}
      {messageAA && (<>
          <div className="messageAA">
              <div className="close">
                <div className="block-un">
                  <div onClick={CloseMessageAA} className="a"> <SvgLeft /> </div>
                  {/* a */}

                  <div onClick={CloseMessageAA} className="b">
                    {photoOtherAA === "0" ? (<><SvgProfil /></>
                    ):(<><img src={photoOtherAA} alt="" /></>)}
                  </div>
                  {/* b */}

                  <div onClick={ProfilOtherAA} className="c">
                    <div className="aa">
                      <p>{nameOtherAA}</p>
                      {badgeOtherAA === "1" && (<><SvgBadge /></>)}
                    </div>
                    {/* aa */}

                    <div className="bb"> <p>{dateParser(onlineOtherAA)} (Dernière connexion)</p> </div>
                    {/* bb */}
                  </div>
                  {/* c */}
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <div onClick={MoreOptions666messageAA} className="a"> <SvgFile /> </div>
                  <div className="b"> </div>
                  {dev && (<><div className="b"> <SvgPointsVertical /> </div></>)}
                </div>
                {/* block-deux */}
              </div>
              {/* close */}

              {/* ici c'est pour mettre l'espacement entre le navbar top et les donnees de l'api */}
              <div className="espacement-navbar-top-et-donnees-api"></div>

              <div onClick={PageRedirection666ChildApiMessageAA}>
              {filterMessageAA.map((api) => (<>
                <ChildApiMessageAA api={api} />
              </>))}
              </div>

              <p style={{ paddingTop: "100px" }}></p>

            {/* ecrire message (ca c'est l'input pour ecrire un message) */}
            <div className="write">
              <div className="a"> <textarea type="text" placeholder="Écrire un message..." value={myMessageAA} onChange={(e) => setMyMessageAA(e.target.value)}></textarea> </div>
              <div onClick={SendMessageAA} className="b"> <SvgSend /> </div>
            </div>
            {/* write */}
          </div>
          {/* messageAA */}
        </>
      )}
      {/* message - AA */}


      {/* page pour voir la photo que j'ai recu ou envoyé par message */}
      {/* page pour voir la photo que j'ai recu ou envoyé par message */}
      {seePhoto2AA && (<>
          <div className="seePhoto2AA">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseSeePhoto2AA} className="b"> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={urlPhotoAA} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhoto2AA */}
        </>)}
      {/* page pour voir la photo que j'ai recu ou envoyé par message */}
      
      
      {/* moreOptions666messageAA */}
      {/* moreOptions666message (choisir une option, par exemple: Envoyer une image, Envoyer une vidéo,.. ) */}
      {moreOptions666messageAA && (<>
          <div onClick={CloseMoreOptions666messageAA} className="actualiser-page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a"> <p onClick={SendPhotoPageAA}>Envoyer une image</p></div>
                  <div className="b"> <p onClick={SendVideoPageAA}>Envoyer une vidéo</p></div>
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* actualiser-page-opacity */}
        </>)}
      {/* moreOptions666messageAA */}


      {/* envoyer une photo - AA */}
      {/* envoyer une photo (page pour envoyer une photo par message) */}
      {sendPhotoPageAA && (<>
          <div className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseSendPhotoPageAA} className="center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#00cc00"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4 10V6a2 2 0 012-2h6M4.027 18.329A2 2 0 006 20h12a2 2 0 002-2v-3.81M4.027 18.33A2.014 2.014 0 014 18v-3m.027 3.329l3.82-3.82a2 2 0 012.427-.16l.51.34a2 2 0 002.358-.103l2.648-2.118a2 2 0 012.333-.12c.08.052.15.115.217.182L20 14.19m0 0V6a2 2 0 00-2-2h-1m-6 5a2 2 0 11-4 0 2 2 0 014 0z"
                    ></path>
                  </svg>
                </div>

                <div onClick={CloseSendPhotoPageAA} className="center">
                  <p
                    style={{
                      fontSize: "17px",
                      paddingBottom: "16px",
                      paddingTop: "5px",
                      textAlign: "center",
                    }}
                  >
                    Envoyer une photo
                  </p>
                </div>

                <div className="capture-decran-du-contact">
                  <div className="display"> <input onChange={(e) => setFilePhotoAA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png"/> </div>
                </div>
                {/* capture-decran-du-contact */}

                <div style={{ paddingTop: "10px" }} className="hr"><hr /></div>

                <div className="btn-envoyer-image">
                  <p onClick={SendPhotoAA}>Envoyer</p>
                  <svg
                    onClick={SendPhotoAA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    viewBox="0 0 28 28"
                  >
                    <g
                      fill="none"
                      fillRule="evenodd"
                      stroke="none"
                      strokeWidth="1"
                    >
                      <g fill="#00cc00" fillRule="nonzero">
                        <path d="M3.79 2.772L24.86 12.85a1.25 1.25 0 010 2.255L3.79 25.183a1.25 1.25 0 01-1.746-1.457l2.108-7.728a.5.5 0 01.415-.364l10.21-1.387a.25.25 0 00.195-.149l.018-.063a.25.25 0 00-.157-.268l-.055-.014-10.2-1.387a.5.5 0 01-.414-.364l-2.12-7.773A1.25 1.25 0 013.79 2.772z"></path>
                      </g>
                    </g>
                  </svg>
                </div> 
                {/* btn-envoyer-image */}
              </div>
            </div>
          </div>
        </>)}
      {/* envoyer une photo - AA */}


      {/* envoyer une video - AA */}
      {/* envoyer une video (page pour envoyer une video par message) */}
      {sendVideoPageAA && (<>
          <div className="publier-video-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseSendVideoPageAA} className="block">
                  <div className="a"> <SvgVideo3 /> </div>
                  <div className="b"> <p>Envoyer une vidéo</p> </div>
                </div>
                {/* block */}

                <div className="block-deux"> <input onChange={(e) => setFileVideoAA(e.target.files[0])} id="file" type="file" name="video" accept=".mp4, .3gp"/> </div>
                {/* block-deux */}

                {isLoading666sendVideoPageAA ? (<><div className="loader-display-flex"> <p>Envoi en cours..</p> </div></>
                ):(<><div className="block-trois-vert"> <button onClick={SendVideoAA}>Envoyer</button> </div></>)}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* publier-video-opacity */}
        </>)}
        {/* envoyer une video - AA */}
     

      {/* profil Other - AA */}
      {/* profil Other - AA */}
      {/* on affiche le profil de l'autre */}
      {profilOtherAA && (<>
          <div className="profilOtherAA">
            <div className="close">
              <div className="a" onClick={CloseProfilOtherAA}> <SvgLeft /> </div>
              <div className="b"> </div>
            </div>
            {/* close */}

            <div className="block-one">
              <div className="a">
                <img onClick={SeePhotoProfilAA} src={photoOtherAA} alt="" />
                {badgeOtherAA > 0 ? (<><h3>{nameOtherAA}</h3> <SvgBadge />
                </>) : (<><h3>{nameOtherAA}</h3></>)}
              </div>
              {/* a */}

              <div className="b">
                <div className="aa">
                  <b>0</b>
                  <p>post</p>
                </div>

                {countFollowerOtherAA > 1 ? (<>
                <div onClick={Follower666profilOtherAA} className="aa">
                  <b>{countFollowerOtherAA}</b>
                  <p>personnes</p>
                </div>
                </>):(<>
                <div onClick={Follower666profilOtherAA} className="aa">
                  <b>{countFollowerOtherAA}</b>
                  <p>personne</p>
                </div></>)}

                {countFollowingOtherAA > 1 ? (<>
                <div onClick={Following666profilOtherAA} className="aa">
                  <b>{countFollowingOtherAA}</b>
                  <p>abonnements</p>
                </div>
                </>):(<>
                <div onClick={Following666profilOtherAA} className="aa">
                  <b>{countFollowingOtherAA}</b>
                  <p>abonnement</p>
                </div></>)}
              </div>
              {/* b */}
            </div>
            {/* block-one */}

            {/* on affiche les posts (page d'accueil) - AA */}
            {filterPost666profilOtherAA.map((api) => (<>
                <div className="posts">
                  {/* ici on affiche: photo + nom, en haut de chaque posts */}
                  {badgeOtherAA > 0 ? (<><div className="infos"> <img src={photoOtherAA} alt="" /> <p>{nameOtherAA}</p> <SvgBadge /> </div>
                  </>) : (<><div className="infos"> <img src={photoOtherAA} alt="" /> <p>{nameOtherAA}</p> </div></>)}

                  <div onClick={PageRedirection666profilOtherAA}>
                    <ChildApiProfilOtherAA api={api} />
                  </div>
                  {/*  */}
                </div>
                {/* posts */}
              </>))}
          </div>
          {/* profilOtherAA */}
        </>)}
      {/* profil Other - AA */}


      {/* page pour afficher tout les abonnés de l'autre - AA */}
      {/* page pour afficher tout les abonnés de l'autre - AA */}
      {follower666profilOtherAA && (<>
          <div onClick={CloseFollower666profilOtherAA} className="popup-list-des-abonnes">
            <div className="center">
              <div className="card">
                {countFollowerOtherAA < 2 && (<><p>Voici la seule personne qui s'est abonné à la page Alrani de {nameOtherAA}</p></>)}
                {countFollowerOtherAA > 1 && (<><p>Voici les personnes qui se sont abonnés à la page Alrani de {nameOtherAA}</p></>)}

                {apiFollowerAA.map((api) => (<> 
                  <ChildApiFollowerAA api={api} />
                </>))}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-list-des-abonnes */}
        </>)}
        {/* page pour afficher tout les abonnés de l'autre - AA */}


      {/* page pour afficher les abonnements de l'autre - AA */}
      {/* page pour afficher les abonnements de l'autre - AA */}
      {following666profilOtherAA && (<>
          <div onClick={CloseFollowing666profilOtherAA} className="popup-list-des-abonnes">
            <div className="center">
              <div className="card">
                {countFollowingOtherAA < 2 && (<><p>{nameOtherAA} est abonné à cette page Alrani</p></>)}
                {countFollowingOtherAA > 1 && (<><p>{nameOtherAA} s'est abonné à ces pages Alrani</p></>)}

                {apiFollowerAA.map((api) => (<>
                  <ChildApiFollowingAA api={api} />
                </>))}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-list-des-abonnements */}
        </>
      )}
      {/* page pour afficher les abonnements de l'autre - AA */}


      {/* seePostAA */}
      {/* seePostAA */}
      {/* on affiche le post sur laquelle on a cliquer */}
      {seePostAA && (<>
          <div className="seePostAA">
            <div className="close">
              <div className="block-un">
                <div className="a" onClick={CloseSeePostAA}> <SvgLeft /> </div>
                <div className="b"> <p>Publication de {nameOtherAA}</p> </div>
                {dev && (<>
                <div className="c"> <button>S'abonner</button> </div></>)} {/* dev se ferme ici */}
              </div>
              {/* block-un */}

              <div className="block-deux"> <p></p> </div>
              {/* block-deux */}
            </div>
            {/* close */}

            {/* on affiche le post - AA */}
            {filterPostAA.map((api) => (<>
                <div className="posts">
                  {/* ici on affiche: photo + nom, en haut de chaque posts */}
                  {badgeOtherAA > 0 ? (<><div className="infos"> <img src={photoOtherAA} alt="" /> <p>{nameOtherAA}</p> <SvgBadge /> </div>
                  </>):(<><div className="infos"> <img src={photoOtherAA} alt="" /> <p>{nameOtherAA}</p> </div></>)}
                  {/* infos */}
                  
                  <div onClick={PageRedirection666seePostAA}>
                    <ChildApiSeePostAA api={api} />
                  </div>
                </div>
                {/* posts */}
              </>))}

            {/* on affiche les commentaires - AA */}
            {filterCommentAA.map((api) => (<>
              <div onClick={ReplyAA}>
                <ChildApiCommentAA api={api} />
              </div>
            </>))}

            <p style={{ paddingTop: "100px" }}></p>

            <div className="write">
              <div className="a"> <textarea type="text" placeholder="Commentez..." value={writeCommentAA} onChange={(e) => setWriteCommentAA(e.target.value)}></textarea> </div>
              <div onClick={SaveCommentAA} className="b"> <SvgSend /> </div>
            </div> 
            {/* write */}
          </div>
          {/* seePostAA */}
        </>)}
      {/* seePostAA */}


      {/* seePhoto (page) - AA */}
      {/* seePhoto (page) - AA */}
      {/* on affiche une photo */}
      {seePhotoAA && (<>
          <div className="seePhotoPageAA">
            <div className="close">
              <div onClick={CloseSeePhotoAA} className="a"> <SvgLeft2 /> </div>
              <div className="b"> <p></p> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={urlPhotoAA} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhotoPageAA */}
        </>)}
      {/* seePhoto (page) - AA */}


      {/* voir photo profil - AA */}
      {/* voir photo profil - AA */}
      {/* on affiche la photo de profil */}
      {seePhotoProfilAA && (<>
          <div onClick={CloseSeePhotoProfilAA} className="popup-image-opacity">
            <div className="align">
              <div className="image"> <img src={photoOtherAA} alt="" /> </div>
            </div>
            {/* align */}
          </div>
          {/* popup-image-opacity */}
        </>)}
      {/* voir photo profil - AA */}


      {/* reponse commentaire - AA */}
      {/* reponse commentaire - AA */}
      {replyAA && (<>
          <div className="replyAA">
            <div className="close">
              <div className="a" onClick={CloseReplyAA}> <SvgLeft /> </div>
              <div className="b"> <p></p> </div>
            </div>
            {/* close */}

            <div className="comment">
              <div className="block-one"> <img src={photoOwnerCommentAA} alt="" /> </div>
              {/* block-one */}

              <div className="block-two">
                <div className="a"> <p>{nameOwnerCommentAA}</p> </div>
                <div className="b"> <p>{commentAA}</p> </div>
              </div>
              {/* block-two */}
            </div>
            {/* comment */}

            {/* on affiche les réponses du commentaires - AA */}
            {filterReplyAA.map((api) => (<>
              <div>
                <ChildApiReplyAA api={api} />
              </div>
            </>))}

            <p style={{ paddingTop: "100px" }}></p>

            <div className="write">
              <div className="a"> <textarea type="text" placeholder="Répondez..." value={writeReplyAA} onChange={(e) => setWriteReplyAA(e.target.value)}></textarea> </div>
              <div onClick={SaveReplyAA} className="b"> <SvgSend /> </div>
            </div> 
            {/* write */}
          </div>
          {/* replyAA */}
        </>
      )}
      {/* reponse commentaire - AA */}

      

      {/* super code (page) - AA */}
      {/* on affiche la liste des super code qui ont ete ajouter au compte */}
      {superCodeAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseSuperCodeAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>liste des supers code qui ont ete ajouter au compte </p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* ProfilOthers - VB */}

      {/* new - AA */}
      {/* new - AA */}
      {newAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseNewAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p onClick={SuperCodeAA}>Super Code</p>
              <p onClick={FavoritePageAA}>Favoris</p>
              <p onClick={VideosAA}>Videos</p>
              <p onClick={Translation}>Langue</p>
              <p onClick={NotificationAA}>Notification</p>

              <p onClick={PlusAA}>Plus</p>
              <p onClick={PlusDealsAA}>Plus Deals</p>
              <p onClick={PlusFormationAA}>Plus Formation</p>

              <p onClick={AlraniPayAA}>Alrani Pay</p>
              <p onClick={SecurityAlraniPayAA}>Mot de passe - Alrani Pay</p>

              <p onClick={PartnershipAA}>Partenariat</p>
              <p onClick={PartnershipDealsAA}>Partenariat Deals</p>
              <p onClick={PartnershipFormationAA}>Partenariat Formation</p>

              <p onClick={StatisticAA}>Statistique</p>
              <p onClick={StatisticDealsAA}>Statistique Deals</p>
              <p onClick={StatisticFormationAA}>Statistique Formation</p>

              <p onClick={MusicAA}>Music</p>
              <p onClick={MusicDealsAA}>Music Deals</p>
              <p onClick={MusicFormationAA}>Music Formation</p>

              <p onClick={StatutAA}>Statut</p>
              <p onClick={StatutDealsAA}>Statut Deals</p>
              <p onClick={StatutFormationAA}>Statut Formation</p>

              <p onClick={MigrationAA}>Migration</p>
              <p onClick={MigrationDealsAA}>Migration Deals</p>
              <p onClick={MigrationFormationAA}>Migration Formation</p>

              <p onClick={GroupAA}>Groupes</p>
              <p onClick={GroupDealsAA}>Groupes Deals</p>
              <p onClick={GroupFormationAA}>Groupes Formation</p>

              <p onClick={CertificationAA}>Certification</p>
              <p onClick={CertificationDealsAA}>Certification Deals</p>
              <p onClick={CertificationFormationAA}>Certification Formation</p>

              <p onClick={CollaboratorAA}>Collaborator</p>
              <p onClick={CollaboratorDealsAA}>Collaborator Deals</p>
              <p onClick={CollaboratorFormationAA}>Collaborator Formation</p>

            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* new - AA */}

      {/* videos - AA */}
      {/* videos - AA */}
      {/* on affiche les videos */}
      {videosAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseVideosAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>Videos</p>
              <div style={{ paddingBottom: "400px" }}></div>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* videos - AA */}

      {/* notification - AA */}
      {/* notification - AA */}
      {/* on affiche les notifications */}
      {notificationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseNotificationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>Notifications Business</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* notification - AA */}

      
      {/* partenariat - AA */}
      {/* partenariat - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {partnershipAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={ClosePartnershipAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>partenariat</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* partenariat - AA */}

      {/* partenariat Deals - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {partnershipDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={ClosePartnershipDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>partenariat Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* partenariat Deals - AA */}

      {/* partenariat Formation - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {partnershipFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={ClosePartnershipFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>partenariat Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* partenariat Formation - AA */}

      {/* Statistics tools */}
      {/* Statistics tools Deals */}
      {/* Statistics tools Formation */}

      {/* Statistics affiliation */}
      {/* Statistics affiliation Deals */}
      {/* Statistics affiliation Formation */}

      {/* statistique - AA */}
      {/* statistique - AA */}
      {/* on affiche les statistiques detaillées */}
      {statisticAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseStatisticAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>statistiques detaillées</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* statistique - AA */}

      {/* statistique deals - AA */}
      {/* statistique deals - AA */}
      {statisticDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseStatisticDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>statistiques detaillées deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* statistique deals - AA */}

      {/* statistique Formation - AA */}
      {/* statistique Formation - AA */}
      {statisticFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseStatisticFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>statistique detaillées Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* statistiques Formation - AA */}

      {/* music Profil - AA */}
      {/* music Profil - AA */}
      {/* mettre la musique sur la photo de profil */}
      {musicAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseMusicAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>music Profil</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* music - AA */}

      {/* music Deals - AA */}
      {/* music Deals - AA */}
      {musicDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseMusicDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>music Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* music Deals - AA */}

      {/* music Formation - AA */}
      {/* music Formation - AA */}
      {musicFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseMusicFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>music Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/*  music Formation - AA */}

      {/* statut - AA */}
      {/* statut - AA */}
      {statutAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseStatutAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>statut</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* statut - AA */}

      {/* statut Deals - AA */}
      {/* statut Deals - AA */}
      {statutDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseStatutDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>statut Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* statut Deals - AA */}

      {/* statut Formation - AA */}
      {/* statut Formation - AA */}
      {statutFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseStatutFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>statut Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* statut Formation - AA */}

      {/* migration - AA */}
      {/* migration - AA */}
      {migrationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseMigrationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>migration</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* migration - AA */}

      {/* migration Deals - AA */}
      {/* migration Deals - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {migrationDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseMigrationDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>migration Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* migration Deals - AA */}

      {/* migration Formation - AA */}
      {/* migration Formation - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {migrationFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseMigrationFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>migration Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* migration Formation - AA */}

      {/* group - AA */}
      {/* group - AA */}
      {groupAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseGroupAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>groupe</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* group - AA */}

      {/* group Deals - AA */}
      {/* group Deals - AA */}
      {groupDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseGroupDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>groupe Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* group Deals - AA */}

      {/* group Formation - AA */}
      {/* group Formation - AA */}
      {groupFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseGroupFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>groupe Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* group Formation - AA */}
      
      {/* certification - AA */}
      {/* certification - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {certificationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseCertificationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>Certification</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* certification - AA */}

      {/* certification Deals - AA */}
      {/* certification Deals - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {certificationDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseCertificationDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>certification Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* certification Deals - AA */}

      {/* certification Formation - AA */}
      {/* certification Formation - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {certificationFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseCertificationFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>certification Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* certification Formation - AA */}

      {/* collaborator - AA */}
      {/* collaborator - AA */}
      {collaboratorAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseCollaboratorAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>Alrani collaborator</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* collaborator - AA */}

      {/* collaborator Deals - AA */}
      {/* collaborator Deals - AA */}
      {collaboratorDealsAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseCollaboratorDealsAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>collaborator Deals</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* collaborator Deals - AA */}

      {/* collaborator Formation - AA */}
      {/* collaborator Formation - AA */}
      {/* ici on affiche le profil d"une autre personne */}
      {collaboratorFormationAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseCollaboratorFormationAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>collaborator Formation</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* collaborator Formation - AA */}

      {/* group - AA */}
      {/* group - AA */}
      {/* on affiche les groupes */}
      {groupAA && (
        <>
          <div className="generalAA">
            <div className="close">
              <div className="a" onClick={CloseGroupAA}>
                <SvgLeft />
              </div>
              {/* a */}

              <div className="b">
                <p></p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <p>groupe</p>
            </div>
            {/* align */}
          </div>
          {/* generalAA */}
        </>
      )}
      {/* group - AA */}

      {/* notification */}
      {/* notification - page */}
      {notification && (
        <>
          <div className="notificationIA">
            <div className="historic">
              <div className="title">
                <svg
                  onClick={BackBtnNotificationPage}
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  width="20px"
                  cursor="pointer"
                  enableBackground="new 0 0 486.975 486.975"
                  version="1.1"
                  viewBox="0 0 486.975 486.975"
                  xmlSpace="preserve"
                >
                  <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                </svg>

                <svg
                  style={{ paddingRight: "7px", fill: "black" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  viewBox="0 0 24 24"
                >
                  <path d="M10 21h4a2 2 0 01-4 0zm-6.924-2.617a1 1 0 01.217-1.09L5 15.586V10a7.006 7.006 0 016-6.92V2a1 1 0 012 0v1.08A7.006 7.006 0 0119 10v5.586l1.707 1.707A1 1 0 0120 19H4a1 1 0 01-.924-.617zM6.414 17h11.172l-.293-.293A1 1 0 0117 16v-6a5 5 0 00-10 0v6a1 1 0 01-.293.707z"></path>
                </svg>
                <p>Notifications</p>
              </div>
              {/* title */}

              <div className="hr">
                <hr />
              </div>
              {/* hr */}

              {/* on affiche les notifications dans l'api enfant */}
              {/* quand on clique sur une notification, MarquerNotificationLue va agir pour
              marquer la notification comme lue */}
              {filtreApiNotification.map((api) => (
                <div onClick={MarquerNotificationLue}>
                  <EnfantApiNotification api={api} />
                </div>
              ))}

              {/* notification aux abonnes plumes 
              {filtreNotificationPlume.map((api) => (
                <EnfantApiNotificationAuxAbonnesPlume api={api} />
              ))}
              */}
            </div>
            {/* historic */}
          </div>
          {/* notificationIA */}
        </>
      )}
      {/* notification - page */}

      {/* backBtn */}
      {/* backBtn - notification - page */}
      {/* au niveau de notification-page on a fait que, 
      quand on clique sur le backBtn, 
      on a l'option Retour et l'option Actualiser(pour actualiser les notifications) */}
      {backBtnNotificationPage && (
        <>
          <div
            onClick={BackBtnNotificationPage}
            className="actualiser-page-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p
                      style={{ textDecoration: "underline", color: "#444" }}
                      onClick={Notification}
                    >
                      Retour
                    </p>
                  </div>

                  <div className="b">
                    <p onClick={ActualiserNotification}>Actualiser</p>
                  </div>
                  {/* b */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* actualiser-page-opacity */}
        </>
      )}
      {/* backBtn - notification - page */}

      {/* theme */}
      {/* theme */}
      {/* theme */}
      {/* theme */}
      {theme && (
        <>
          <div onClick={Theme} className="popup-menu-opacity">
            <div className="align">
              <div className="card">
                <div style={{ paddingTop: "20px", paddingBottom: "10px" }} className="title">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    fill="#00cc00"
                    enableBackground="new 0 0 478.703 478.703"
                    version="1.1"
                    viewBox="0 0 478.703 478.703"
                    xmlSpace="preserve"
                  >
                    <path d="M454.2 189.101l-33.6-5.7c-3.5-11.3-8-22.2-13.5-32.6l19.8-27.7c8.4-11.8 7.1-27.9-3.2-38.1l-29.8-29.8c-5.6-5.6-13-8.7-20.9-8.7-6.2 0-12.1 1.9-17.1 5.5l-27.8 19.8c-10.8-5.7-22.1-10.4-33.8-13.9l-5.6-33.2a29.54 29.54 0 00-29.2-24.7h-42.1c-14.5 0-26.8 10.4-29.2 24.7l-5.8 34c-11.2 3.5-22.1 8.1-32.5 13.7l-27.5-19.8c-5-3.6-11-5.5-17.2-5.5-7.9 0-15.4 3.1-20.9 8.7l-29.9 29.8c-10.2 10.2-11.6 26.3-3.2 38.1l20 28.1c-5.5 10.5-9.9 21.4-13.3 32.7l-33.2 5.6a29.54 29.54 0 00-24.7 29.2v42.1c0 14.5 10.4 26.8 24.7 29.2l34 5.8c3.5 11.2 8.1 22.1 13.7 32.5l-19.7 27.4c-8.4 11.8-7.1 27.9 3.2 38.1l29.8 29.8c5.6 5.6 13 8.7 20.9 8.7 6.2 0 12.1-1.9 17.1-5.5l28.1-20c10.1 5.3 20.7 9.6 31.6 13l5.6 33.6a29.54 29.54 0 0029.2 24.7h42.2c14.5 0 26.8-10.4 29.2-24.7l5.7-33.6c11.3-3.5 22.2-8 32.6-13.5l27.7 19.8c5 3.6 11 5.5 17.2 5.5 7.9 0 15.3-3.1 20.9-8.7l29.8-29.8c10.2-10.2 11.6-26.3 3.2-38.1l-19.8-27.8c5.5-10.5 10.1-21.4 13.5-32.6l33.6-5.6a29.54 29.54 0 0024.7-29.2v-42.1c.2-14.5-10.2-26.8-24.5-29.2zm-2.3 71.3c0 1.3-.9 2.4-2.2 2.6l-42 7c-5.3.9-9.5 4.8-10.8 9.9-3.8 14.7-9.6 28.8-17.4 41.9-2.7 4.6-2.5 10.3.6 14.7l24.7 34.8c.7 1 .6 2.5-.3 3.4l-29.8 29.8c-.7.7-1.4.8-1.9.8-.6 0-1.1-.2-1.5-.5l-34.7-24.7c-4.3-3.1-10.1-3.3-14.7-.6-13.1 7.8-27.2 13.6-41.9 17.4-5.2 1.3-9.1 5.6-9.9 10.8l-7.1 42c-.2 1.3-1.3 2.2-2.6 2.2h-42.1c-1.3 0-2.4-.9-2.6-2.2l-7-42c-.9-5.3-4.8-9.5-9.9-10.8-14.3-3.7-28.1-9.4-41-16.8-2.1-1.2-4.5-1.8-6.8-1.8-2.7 0-5.5.8-7.8 2.5l-35 24.9c-.5.3-1 .5-1.5.5-.4 0-1.2-.1-1.9-.8l-29.8-29.8c-.9-.9-1-2.3-.3-3.4l24.6-34.5c3.1-4.4 3.3-10.2.6-14.8-7.8-13-13.8-27.1-17.6-41.8-1.4-5.1-5.6-9-10.8-9.9l-42.3-7.2c-1.3-.2-2.2-1.3-2.2-2.6v-42.1c0-1.3.9-2.4 2.2-2.6l41.7-7c5.3-.9 9.6-4.8 10.9-10 3.7-14.7 9.4-28.9 17.1-42 2.7-4.6 2.4-10.3-.7-14.6l-24.9-35c-.7-1-.6-2.5.3-3.4l29.8-29.8c.7-.7 1.4-.8 1.9-.8.6 0 1.1.2 1.5.5l34.5 24.6c4.4 3.1 10.2 3.3 14.8.6 13-7.8 27.1-13.8 41.8-17.6 5.1-1.4 9-5.6 9.9-10.8l7.2-42.3c.2-1.3 1.3-2.2 2.6-2.2h42.1c1.3 0 2.4.9 2.6 2.2l7 41.7c.9 5.3 4.8 9.6 10 10.9 15.1 3.8 29.5 9.7 42.9 17.6 4.6 2.7 10.3 2.5 14.7-.6l34.5-24.8c.5-.3 1-.5 1.5-.5.4 0 1.2.1 1.9.8l29.8 29.8c.9.9 1 2.3.3 3.4l-24.7 34.7c-3.1 4.3-3.3 10.1-.6 14.7 7.8 13.1 13.6 27.2 17.4 41.9 1.3 5.2 5.6 9.1 10.8 9.9l42 7.1c1.3.2 2.2 1.3 2.2 2.6v42.1h-.1z"></path>
                    <path d="M239.4 136.001c-57 0-103.3 46.3-103.3 103.3s46.3 103.3 103.3 103.3 103.3-46.3 103.3-103.3-46.3-103.3-103.3-103.3zm0 179.6c-42.1 0-76.3-34.2-76.3-76.3s34.2-76.3 76.3-76.3 76.3 34.2 76.3 76.3-34.2 76.3-76.3 76.3z"></path>
                  </svg>
                  <p>Paramètres</p>
                </div>
                {/* title */}

                <div className="hr"> <hr /> </div>
                {/* hr */}

                {/* theme */}
                {/* theme */}
                {dev && (<>
                <div style={{ paddingTop: "20px" }} className="a">
                  <div className="display">
                    <div className="f">
                      <svg
                        onClick={ThemePage}
                        xmlns="http://www.w3.org/2000/svg"
                        width="28px"
                        cursor="pointer"
                        viewBox="0 0 24 24"
                      >
                        <g fillRule="evenodd" stroke="none" strokeWidth="1">
                          <g fill="blue" fillRule="nonzero">
                            <path d="M17.404 4.722l2.717 10.142a2.75 2.75 0 01-1.944 3.368l-6.279 1.683A2.75 2.75 0 018.53 17.97L5.813 7.828A2.75 2.75 0 017.757 4.46l6.279-1.683a2.75 2.75 0 013.368 1.945zm-6.438 3.02a1 1 0 10-1.932.517 1 1 0 001.932-.518zm-5.163 3.916l1.761 6.57a3.733 3.733 0 001.003 1.714l-.443-.024a2.75 2.75 0 01-2.603-2.89l.282-5.37zm-.925-1.478l-.355 6.796c-.037.698.12 1.362.424 1.94l-.414-.161a2.75 2.75 0 01-1.582-3.553l1.927-5.022z"></path>
                          </g>
                        </g>
                      </svg>
                    </div>

                    <div className="bc">
                      <div className="b">
                        <p onClick={ThemePage}>Thème</p>
                      </div>

                      <div className="c">
                        <p onClick={ThemePage}>
                          Choisir parmi plusieurs thèmes
                        </p>
                      </div>
                    </div>

                    <div className="d">
                      <svg
                        onClick={ThemePage}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        width="10px"
                        cursor="pointer"
                        fill="#a6a6a6"
                        enableBackground="new 0 0 477.175 477.175"
                        version="1.1"
                        viewBox="0 0 477.175 477.175"
                        xmlSpace="preserve"
                      >
                        <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                      </svg>
                    </div>
                  </div>
                  {/* display */}
                </div>
                {/* a */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                {/* informations personnelles */}
                {/* informations personnelles */}
                <div style={{ paddingTop: "20px" }} className="a">
                  <div className="display">
                    {idPersonConnectedAA ? (
                      <>
                        {/* ici c'est lorsque la personne est connecter */}
                        <div className="f">
                          <svg
                            onClick={InformationPersonnelle}
                            xmlns="http://www.w3.org/2000/svg"
                            x="0"
                            y="0"
                            width="28px"
                            cursor="pointer"
                            enableBackground="new 0 0 496.158 496.158"
                            version="1.1"
                            viewBox="0 0 496.158 496.158"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#fd7e14"
                              d="M496.158 248.085C496.158 111.063 385.089.003 248.083.003 111.07.003 0 111.063 0 248.085c0 137.001 111.07 248.07 248.083 248.07 137.006 0 248.075-111.069 248.075-248.07z"
                            ></path>
                            <g fill="#FFF">
                              <path d="M315.249 359.555a5.002 5.002 0 00-6.27-1.702c-24.582 11.637-52.482 23.94-57.958 25.015a4.83 4.83 0 01-.644-.737c-.742-1.005-1.103-2.318-1.103-4.015 0-13.905 10.495-56.205 31.192-125.719 17.451-58.406 19.469-70.499 19.469-74.514 0-6.198-2.373-11.435-6.865-15.146-4.267-3.519-10.229-5.302-17.719-5.302-12.459 0-26.899 4.73-44.146 14.461-16.713 9.433-35.352 25.41-55.396 47.487a5.002 5.002 0 005.591 7.992c7.037-2.872 42.402-17.359 47.557-20.597 4.221-2.646 7.875-3.989 10.861-3.989.107 0 .199.004.276.01.036.198.07.5.07.933 0 3.047-.627 6.654-1.856 10.703-30.136 97.641-44.785 157.498-44.785 182.994 0 8.998 2.501 16.242 7.432 21.528 5.025 5.393 11.803 8.127 20.146 8.127 8.891 0 19.712-3.714 33.08-11.354 12.936-7.392 32.68-23.653 60.363-49.717a4.998 4.998 0 00.705-6.458zM314.282 76.672c-4.925-5.041-11.227-7.597-18.729-7.597-9.34 0-17.475 3.691-24.176 10.971-6.594 7.16-9.938 15.946-9.938 26.113 0 8.033 2.463 14.69 7.32 19.785 4.922 5.172 11.139 7.794 18.476 7.794 8.958 0 17.049-3.898 24.047-11.586 6.876-7.553 10.363-16.433 10.363-26.393.001-7.654-2.476-14.075-7.363-19.087z"></path>
                            </g>
                          </svg>
                        </div>

                        <div className="bc">
                          <div className="b">
                            <p onClick={InformationPersonnelle}>
                              Informations Personnelles
                            </p>
                          </div>

                          <div className="c">
                            <p onClick={InformationPersonnelle}>
                              Noms, Genre, Age
                            </p>
                          </div>
                        </div>

                        <div className="d">
                          <svg
                            onClick={InformationPersonnelle}
                            xmlns="http://www.w3.org/2000/svg"
                            x="0"
                            y="0"
                            width="10px"
                            cursor="pointer"
                            fill="#a6a6a6"
                            enableBackground="new 0 0 477.175 477.175"
                            version="1.1"
                            viewBox="0 0 477.175 477.175"
                            xmlSpace="preserve"
                          >
                            <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                          </svg>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* ca c'est le cas ou la personne n'est pas connecter */}
                        <div className="f">
                          <svg
                            onClick={SansEtreConnecter}
                            xmlns="http://www.w3.org/2000/svg"
                            x="0"
                            y="0"
                            width="28px"
                            cursor="pointer"
                            enableBackground="new 0 0 496.158 496.158"
                            version="1.1"
                            viewBox="0 0 496.158 496.158"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#fd7e14"
                              d="M496.158 248.085C496.158 111.063 385.089.003 248.083.003 111.07.003 0 111.063 0 248.085c0 137.001 111.07 248.07 248.083 248.07 137.006 0 248.075-111.069 248.075-248.07z"
                            ></path>
                            <g fill="#FFF">
                              <path d="M315.249 359.555a5.002 5.002 0 00-6.27-1.702c-24.582 11.637-52.482 23.94-57.958 25.015a4.83 4.83 0 01-.644-.737c-.742-1.005-1.103-2.318-1.103-4.015 0-13.905 10.495-56.205 31.192-125.719 17.451-58.406 19.469-70.499 19.469-74.514 0-6.198-2.373-11.435-6.865-15.146-4.267-3.519-10.229-5.302-17.719-5.302-12.459 0-26.899 4.73-44.146 14.461-16.713 9.433-35.352 25.41-55.396 47.487a5.002 5.002 0 005.591 7.992c7.037-2.872 42.402-17.359 47.557-20.597 4.221-2.646 7.875-3.989 10.861-3.989.107 0 .199.004.276.01.036.198.07.5.07.933 0 3.047-.627 6.654-1.856 10.703-30.136 97.641-44.785 157.498-44.785 182.994 0 8.998 2.501 16.242 7.432 21.528 5.025 5.393 11.803 8.127 20.146 8.127 8.891 0 19.712-3.714 33.08-11.354 12.936-7.392 32.68-23.653 60.363-49.717a4.998 4.998 0 00.705-6.458zM314.282 76.672c-4.925-5.041-11.227-7.597-18.729-7.597-9.34 0-17.475 3.691-24.176 10.971-6.594 7.16-9.938 15.946-9.938 26.113 0 8.033 2.463 14.69 7.32 19.785 4.922 5.172 11.139 7.794 18.476 7.794 8.958 0 17.049-3.898 24.047-11.586 6.876-7.553 10.363-16.433 10.363-26.393.001-7.654-2.476-14.075-7.363-19.087z"></path>
                            </g>
                          </svg>
                        </div>

                        <div className="bc">
                          <div className="b">
                            <p onClick={SansEtreConnecter}>
                              Informations Personnelles
                            </p>
                          </div>

                          <div className="c">
                            <p onClick={SansEtreConnecter}>Noms, Genre, Age</p>
                          </div>
                        </div>

                        <div className="d">
                          <svg
                            onClick={SansEtreConnecter}
                            xmlns="http://www.w3.org/2000/svg"
                            x="0"
                            y="0"
                            width="10px"
                            cursor="pointer"
                            fill="#a6a6a6"
                            enableBackground="new 0 0 477.175 477.175"
                            version="1.1"
                            viewBox="0 0 477.175 477.175"
                            xmlSpace="preserve"
                          >
                            <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                          </svg>
                        </div>
                      </>
                    )}
                  </div>
                  {/* display */}
                </div>
                {/* a */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                {/* Business - (666 parametresAA) */}
                {/* Business - (666 parametresAA) */}
                <div style={{ paddingTop: "20px" }} className="a">
                  <div className="display">
                    <div className="f">
                      <svg
                        onClick={Business}
                        xmlns="http://www.w3.org/2000/svg"
                        width="28px"
                        fill="none"
                        cursor="pointer"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#6f42c1"
                          d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2zM8.18 16.77h-.07c-.97-.09-1.88-.54-2.56-1.26-1.6-1.68-1.6-4.41 0-6.09l2.19-2.3a4.05 4.05 0 012.95-1.28c1.12 0 2.17.45 2.95 1.28 1.6 1.68 1.6 4.41 0 6.09l-1.09 1.15c-.29.3-.76.31-1.06.03a.755.755 0 01-.03-1.06l1.09-1.15c1.06-1.11 1.06-2.92 0-4.02-.99-1.04-2.73-1.04-3.73 0l-2.19 2.3c-1.06 1.11-1.06 2.92 0 4.02.43.46 1.01.74 1.62.8.41.04.71.41.67.82a.74.74 0 01-.74.67zm10.27-2.18l-2.19 2.3a4.05 4.05 0 01-2.95 1.28c-1.12 0-2.17-.45-2.95-1.28-1.6-1.68-1.6-4.41 0-6.09l1.09-1.15c.29-.3.76-.31 1.06-.03.3.29.31.76.03 1.06l-1.09 1.15c-1.06 1.11-1.06 2.92 0 4.02.99 1.04 2.73 1.05 3.73 0l2.19-2.3c1.06-1.11 1.06-2.92 0-4.02-.43-.46-1.01-.74-1.62-.8a.75.75 0 01-.67-.82c.04-.41.4-.72.82-.67.97.1 1.88.54 2.56 1.26 1.59 1.67 1.59 4.41-.01 6.09z"
                        ></path>
                      </svg>
                    </div>

                    <div className="bc">
                      <div className="b">
                        <p onClick={Business}>Business</p>
                      </div>

                      <div className="c">
                        <p onClick={Business}>
                          Compte professionnel, Statistiques détaillés
                        </p>
                      </div>
                    </div>

                    <div className="d">
                      <svg
                        onClick={Business}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        width="10px"
                        cursor="pointer"
                        fill="#a6a6a6"
                        enableBackground="new 0 0 477.175 477.175"
                        version="1.1"
                        viewBox="0 0 477.175 477.175"
                        xmlSpace="preserve"
                      >
                        <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                      </svg>
                    </div>
                  </div>
                  {/* display */}
                </div>
                {/* a */}
                <div className="hr"> <hr /> </div>
                

                {/* Plus d'options - (666 parametresAA) */}
                {/* Plus d'options - (666 parametresAA) */}
                <div style={{ paddingTop: "20px" }} className="a">
                  <div className="display">
                    <div onClick={PlusOptions} className="f"> <SvgAdd3 /> </div>

                    <div onClick={PlusOptions} className="bc">
                      <div className="b"> <p>Plus d'Options</p> </div>
                      <div className="c"> <p>Photo de Profil, Publication</p> </div>
                    </div>

                    <div onClick={PlusOptions} className="d"> <SvgRight4 /> </div>
                  </div>
                  {/* display */}
                </div>
                {/* a */}
                <div className="hr"> <hr /> </div></>)} {/* dev se ferme ici */}


                {idPersonConnectedAA ? (<>
                {/* déconnexion - (666 parametresAA) */}
                {/* déconnexion - (666 parametresAA) , ici il est connecter , alors on affiche le bouton Déconnexion */}
                <div style={{ paddingTop: "20px" }} className="a">
                  <div className="display">
                    <div onClick={LogoutPageAA} className="f"> <SvgLogout3 /> </div>

                    <div onClick={LogoutPageAA} className="bc">
                      <div className="b"> <p>Déconnexion</p> </div>
                      <div className="c"> <p>Option de déconnexion</p> </div>
                    </div>

                    <div onClick={LogoutPageAA} className="d"> <SvgRight4 /> </div>
                  </div>
                  {/* display */}
                </div>
                {/* a */}

            
                </>):(<>
                {/* s'inscire - (666 parametresAA) */}
                {/* s'inscire - (666 parametresAA) , ici il n'est pas connecter , alors on affiche le bouton Créer un compte */}
                <div style={{ paddingTop: "20px" }} className="a">
                  <div className="display">
                    <div onClick={OuvrirPageConnexionAA} className="f"> <SvgLogin /> </div>

                    <div onClick={OuvrirPageConnexionAA} className="bc">
                      <div className="b"> <p>Créer un compte</p> </div>
                      <div className="c"> <p>S'inscrire sur Florinato</p> </div>
                    </div>

                    <div onClick={OuvrirPageConnexionAA} className="d"> <SvgRight4 /> </div>
                  </div>
                  {/* display */}
                </div>
                {/* a */}
                </>)}

              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-menu-opacity */}
        </>
      )}
      {/* theme */}



      

      {/* page theme */}
      {/* page theme */}
      {/* page theme */}
      {/* page theme */}
      {themePage && (<>
          <div onClick={ThemePage} className="popup-menu-opacity">
            <div className="align">
              <div className="card">
                <div style={{ paddingTop: "20px" }} className="a">
                  {!theme1 && (<><p onClick={Theme1} style={{ padding: "0px 10px" }}>Thème 1</p></>)}
                  {theme1 && (<><p onClick={Theme1} style={{ color: "black", backgroundColor: "yellow", padding: "5px 10px"}}>Thème 1</p></>)}
                </div>

                <div className="a">
                  {!theme2 && (<><p onClick={Theme2} style={{ padding: "0px 10px" }}>Thème 2</p></>)}
                  {theme2 && (<><p onClick={Theme2} style={{ color: "black", backgroundColor: "yellow", padding: "5px 10px" }}>Thème 2</p></>)}
                </div>

                <div className="a">
                  {!theme3 && (<><p onClick={Theme3} style={{ padding: "0px 10px" }}>Thème 3</p></>)}
                  {theme3 && (<><p onClick={Theme3} style={{ color: "black", backgroundColor: "yellow", padding: "5px 10px" }}>Thème 3</p></>)}
                </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-menu-opacity */}
        </>)}
      {/* page theme */}
      

      {/* Plus d'Options */}
      {/* Plus d'Options */}
      {plusOptions && (
        <>
          <div onClick={PlusOptions} className="popup-logout-opacity">
            <div className="align">
              <div className="card">
                <div style={{ marginBottom: "10px" }} className="title-logout">
                  <div className="display">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30px"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="green"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 11v3m0 0v3m0-3h3m-3 0H9M6 7h12M8 5h8M6 9h12a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2z"
                      ></path>
                    </svg>

                    <p>Plus d'Options</p>
                  </div>
                  {/* display */}
                </div>
                {/* title logout */}

                <div className="display-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 9a2 2 0 012-2h1.5a2 2 0 001.6-.8l1.05-1.4a2 2 0 011.6-.8h2.5a2 2 0 011.6.8l1.05 1.4a2 2 0 001.6.8H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                    ></path>
                    <circle
                      cx="12"
                      cy="13"
                      r="4"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    ></circle>
                  </svg>
                  <p style={{ cursor: "pointer" }}>
                    Photo de Profil
                  </p>
                </div>
                {/* display-icon */}

                {/* publication */}
                <div className="display-icon">
                  <svg
                    onClick={PublierPublication}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="#000"
                    cursor="pointer"
                    version="1.1"
                    viewBox="0 0 198.439 198.439"
                    xmlSpace="preserve"
                  >
                    <path d="M197.762 169.999L177.324 5.262a5.995 5.995 0 00-6.693-5.215L5.893 20.484a6 6 0 00-5.261 5.955v166a6 6 0 006 6h166a6 6 0 006-6v-14.021l13.915-1.727a6 6 0 005.215-6.692zm-177.326 16.44h-7.805V123.53l7.805 62.909zM13.882 40.181a6.04 6.04 0 00-.546.096l-1.183-9.536 154.915-19.22 1.18 9.509L13.882 40.181zm152.75 146.258h-52.65l52.65-6.532v6.532zm-135.26-.783L14.805 52.124c.184-.006.368-.011.554-.034l154.365-19.151 16.563 133.497-154.915 19.22z"></path>
                  </svg>
                  <p style={{ cursor: "pointer" }} onClick={PublierPublication}>
                    Publication
                  </p>
                </div>
                {/* display-icon */}

                {/* Publier une vidéo */}
                {dev && (<>
                <div className="display-icon">
                  <svg
                    onClick={Video}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    version="1.1"
                    viewBox="0 0 511.984 511.984"
                    xmlSpace="preserve"
                  >
                    <path d="M256.144 101.928c-26.048 0-47.232 21.344-47.232 47.6 0 26.24 21.184 47.584 47.232 47.584s47.232-21.344 47.232-47.584c0-26.256-21.184-47.6-47.232-47.6zm0 79.2c-17.216 0-31.232-14.176-31.232-31.584 0-17.44 14.016-31.6 31.232-31.6s31.232 14.176 31.232 31.6c0 17.408-14.016 31.584-31.232 31.584zM299.504 216.408l-43.36 32.976-43.36-32.976c-53.376 16.16-52.704 70.672-52.704 70.672h192.128s.672-54.512-52.704-70.672z"></path>
                    <path d="M466.976 43.976H45.152c-22.864 0-41.456 18.896-41.456 42.096v224.912c0 23.2 18.592 42.096 41.456 42.096h421.824v-.016c22.848 0 41.424-18.896 41.424-42.096V86.072c0-23.2-18.576-42.096-41.424-42.096zm25.408 267.008c0 14.384-11.408 26.096-25.424 26.096H45.152c-14.032-.016-25.456-11.712-25.456-26.112V86.072c0-14.384 11.424-26.096 25.456-26.096H466.96c14.016 0 25.424 11.696 25.424 26.096v224.912zM451.12 420.808c-3.664-17.808-19.296-31.184-38.032-31.184S378.72 403 375.056 420.808H0v16h375.056c3.664 17.808 19.296 31.2 38.032 31.2s34.368-13.392 38.032-31.2h60.864v-16H451.12zm-38.032 31.2c-12.608 0-22.848-10.4-22.848-23.2 0-12.784 10.256-23.2 22.848-23.2s22.848 10.4 22.848 23.2c.016 12.8-10.24 23.2-22.848 23.2z"></path>
                  </svg>
                  <p style={{ cursor: "pointer" }} onClick={Video}>
                    Publier une vidéo
                  </p>
                </div>
                {/* display-icon */}

                {/* Bouton Principal */}
                <div className="display-icon">
                  <svg
                    onClick={BoutonPrincipal}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#000" d="M7 15a3 3 0 110-6 3 3 0 010 6z"></path>
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M24 12a7 7 0 00-7-7H7a7 7 0 000 14h10a7 7 0 007-7zm-7-5H7a5 5 0 000 10h10a5 5 0 000-10z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <p style={{ cursor: "pointer" }} onClick={BoutonPrincipal}>
                    Bouton Principal
                  </p>
                </div> 
                {/* display-icon */}
                </>)}{/* dev se ferme ici */}

              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-logout-opacity */}
        </>
      )}
      {/* Plus d'options */}

      {/* Bouton Principal - page */}
      {/* Bouton Principal - page */}
      {boutonPrincipal && (
        <>
          <div
            onClick={CloseBoutonPrincipal}
            className="bouton-principal-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="block-title">
                  <div className="title">
                    <p>Bouton Principal</p>
                  </div>
                  {/* title */}

                  <div className="hr">
                    <hr />
                  </div>
                  {/* hr */}
                </div>
                {/* block-title */}

                <div className="block">
                  <div className="space">
                    <p>Message</p>

                    {buttonActiverSurLeProfil === "1" ? (
                      <>
                        <svg
                          onClick={BoutonEnvoyerUnMessageDesactiver}
                          xmlns="http://www.w3.org/2000/svg"
                          width="35px"
                          cursor="pointer"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="blue"
                            fillRule="evenodd"
                            d="M7 6h10a6 6 0 010 12H7A6 6 0 017 6zm13 6a3 3 0 11-6 0 3 3 0 016 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </>
                    ) : (
                      <>
                        <svg
                          onClick={BoutonEnvoyerUnMessageActiver}
                          xmlns="http://www.w3.org/2000/svg"
                          width="35px"
                          cursor="pointer"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#000"
                            d="M7 15a3 3 0 110-6 3 3 0 010 6z"
                          ></path>
                          <path
                            fill="#000"
                            fillRule="evenodd"
                            d="M24 12a7 7 0 00-7-7H7a7 7 0 000 14h10a7 7 0 007-7zm-7-5H7a5 5 0 000 10h10a5 5 0 000-10z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </>
                    )}
                  </div>
                  {/* space */}

                  <div className="detail">
                    <p>Envoyer un message</p>
                  </div>
                  {/* detail */}

                  <div className="hr">
                    <hr />
                  </div>
                  {/* hr */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* bouton-principal-opacity */}
        </>
      )}
      {/* Bouton Principal - page */}

      {/* presentation */}
      {/* presentation */}
      {/* ici c'est pour la presentation de Page Alrani Business */}
      {presentation && (
        <>
          <div onClick={ClosePresentation} className="presentation-opacity">
            <div className="align">
              <div className="card">
                <div className="block-title">
                  <div className="title">
                    <button>Compte Alrani Business</button>
                  </div>
                  {/* title */}
                </div>
                {/* block-title */}

                {utilisateur === "1" ? (
                  <>
                    <div className="block">
                      <div className="a">
                        <p>C'est quoi un Compte Alrani Business ?</p>
                      </div>
                      {/* a */}

                      <div className="b">
                        <p>
                          Un Compte Alrani Business est un compte qui gagne de
                          l'argent avec Alrani ou encore c'est un compte qui est
                          prêt à gagner de l'argent avec Alrani.
                        </p>
                        <p>
                          Les Comptes Alrani Business sont bien différents des
                          Comptes Alrani Personnels, car les Comptes Alrani
                          Personnels ne gagnent pas de l'argent avec Alrani
                        </p>
                      </div>
                      {/* b */}

                      <div className="c">
                        <p onClick={Avertissement}>Compris !</p>
                      </div>
                      {/* c */}
                    </div>
                    {/* block */}
                  </>
                ) : (
                  <>
                    <div className="block-deux">
                      <div className="detail">
                        <p>
                          Les utilisateurs présents sur Alrani sont des
                          personnes avec un très grand pouvoir d'achat c'est à
                          dire ce sont des personnes qui ont la capacité
                          d'acheter un album de musique, un produit cosmétique
                          ou tout autre types de produits
                        </p>
                      </div>
                      {/* detail */}

                      <div className="a">
                        <p>Fonctionnalités professionnelles activées !</p>
                      </div>

                      <div className="b">
                        <p>Désormais vous pouvez :</p>
                      </div>

                      <div className="c">
                        <p>
                          - Ajouter des collaborateurs qui pourront vous aider à
                          gérer votre compte
                        </p>
                        <p>- Gagner de l'argent en activant la monétisation</p>
                        <p>
                          - Associer des outils professionnels à votre compte
                          pour gagner en temps et en productivité
                        </p>
                      </div>

                      <div className="d">
                        <p onClick={PageAlrani}>Voir plus</p>
                      </div>
                    </div>
                    {/* block-deux */}
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* presentation-opacity */}
        </>
      )}
      {/* presentation */}

      {/* avertissement */}
      {/* avertissement */}
      {/* ca c'est apres la presentation de la Page Alrani Business */}
      {avertissement && (
        <>
          <div onClick={CloseAvertissement} className="avertissement-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>Attention !</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p>
                      Transformer votre Compte Alrani Personnel en Compte Alrani
                      Business est irréversible.
                    </p>
                    <p>
                      Si vous transformer votre Compte Alrani Personnel en
                      Compte Alrani Business vous ne pourrez plus faire marche
                      arrière, c'est-à-dire vous ne pourrez plus transformer
                      votre Compte Alrani Business en Compte Alrani Personnel
                    </p>
                  </div>
                  {/* b */}

                  <div className="c">
                    {/* quand on clique ca va enregistrer une valeur qui permet a
                          l'utilisateur de passer a un compte professionnel */}
                    {/* utilisateur = 1, compte standard */}
                    {/* utilisateur = 0, compte professionnel */}
                    <p onClick={Transformer}>J'accepte</p>
                  </div>
                  {/* c */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* avertissement-opacity */}
        </>
      )}
      {/* avertissement */}

      {/* page Alrani Business */}
      {/* page Alrani Business */}
      {/* ici c'est pour afficher toute les publications de la page Alrani Business */}
      {pageAlrani && (
        <>
          <div className="page-alrani-opacity">
            <div className="align">
              <div className="card">
                <div className="block-title">
                  <div className="a">
                    {/* si photoProfilPage=0, ca va rien afficher
                     sinon cava afficher la photo de profil */}
                    {photoProfilPage === "0" ? (
                      <>
                        <p></p>
                      </>
                    ) : (
                      <>
                        <div className="photo">
                          <img src={photoProfilPage} alt="" />
                        </div>
                      </>
                    )}

                    <div className="space">
                      <div className="nom-et-service">
                        <div className="nom">
                          <p>{nomPage}</p>
                          {/* si badgeVerifiedPage est egale a 0, le badge va s'afficher */}
                          {badgeVerifiedPage === "1" && (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="blue"
                                  fillRule="evenodd"
                                  d="M15.418 5.643a1.25 1.25 0 00-1.34-.555l-1.798.413a1.25 1.25 0
01-.56 0l-1.798-.413a1.25 1.25 0 00-1.34.555l-.98
1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 00-.555 1.338l.413
1.8a1.25 1.25 0 010 .559l-.413 1.799a1.25 1.25 0 00.555
1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674
1.339.555l1.798-.413a1.25 1.25 0 01.56 0l1.799.413a1.25 1.25 0
001.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0
00.554-1.34L18.5 12.28a1.25 1.25 0 010-.56l.413-1.799a1.25 1.25 0
00-.554-1.339l-1.565-.98a1.25 1.25 0 01-.395-.395l-.98-1.564zm-.503
4.127a.5.5 0 00-.86-.509l-2.615 4.426-1.579-1.512a.5.5 0 10-.691.722l2.034
1.949a.5.5 0 00.776-.107l2.935-4.97z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </>
                          )}
                        </div>

                        <div className="service">
                          {serviceOuOccupationPage === "undefined" ? (
                            <>
                              <p></p>
                            </>
                          ) : (
                            <>
                              <p>{serviceOuOccupationPage}</p>
                            </>
                          )}
                        </div>
                      </div>
                      {/* nom-et-service */}

                      <div className="mini-menu">
                        <svg
                          onClick={MiniMenuPageAlrani}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="#000"
                          fillRule="evenodd"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          clipRule="evenodd"
                          viewBox="0 0 64 64"
                        >
                          <path fill="none" d="M-256 -64H1024V736H-256z"></path>
                          <g>
                            <g>
                              <circle cx="32.026" cy="12.028" r="4"></circle>
                              <circle cx="32.026" cy="52.028" r="4"></circle>
                              <circle cx="32.026" cy="32.028" r="4"></circle>
                            </g>
                          </g>
                        </svg>
                      </div>
                      {/* mini-menu */}
                    </div>
                    {/* space */}
                  </div>
                  {/* a */}
                </div>
                {/* block-title */}

                <div className="block">
                  {filtreApiPosts.map((api) => (
                    <>
                      <EnfantApiPost api={api} />
                    </>
                  ))}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-alrani-opacity */}
        </>
      )}
      {/* page Alrani Business */}

      

      {/* Statistiques de la page - AA */}
      {/* Statistiques de la page - AA */}
      {/* ici on affiche les Statistiques de la page - page Alrani Business */}
      {statistiquePageAA && (
        <>
          <div onClick={CloseStatistiquePageAA} className="statistiquePageAA">
            <div className="block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                cursor="pointer"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M22 16.74V4.67c0-1.2-.98-2.09-2.17-1.99h-.06c-2.1.18-5.29 1.25-7.07 2.37l-.17.11c-.29.18-.77.18-1.06 0l-.25-.15C9.44 3.9 6.26 2.84 4.16 2.67 2.97 2.57 2 3.47 2 4.66v12.08c0 .96.78 1.86 1.74 1.98l.29.04c2.17.29 5.52 1.39 7.44 2.44l.04.02c.27.15.7.15.96 0 1.92-1.06 5.28-2.17 7.46-2.46l.33-.04c.96-.12 1.74-1.02 1.74-1.98zM12 5.49v15M7.75 8.49H5.5M8.5 11.49h-3"
                ></path>
              </svg>
              <div className="b">
                <p>Statistiques de la Page</p>
              </div>

              <div className="b">
                <p>Black M</p>
              </div>
            </div>
            {/* block */}

            <div className="block">
              <div className="a">
                <p>Monétisation :</p>
              </div>

              <div className="b">
                <p>Activer</p>
              </div>
            </div>
            {/* block */}

            <div className="block">
              <p>Publications</p>
              <p>Lorsqu'une personne Clique pour voir votre publication</p>
              <p>Nombre total des clics :</p>
              <p>1540</p>
            </div>
            {/* block */}
          </div>
          {/* statistiquePageAA */}
        </>
      )}
      {/* Statistiques de la page - AA */}


      {/* Information Importante - page */}
      {/* Information Importante - page */}
      {informationImportante && (
        <>
          <div className="information-importante-opacity">
            <div className="align" onClick={PublierVideo}>
              <div className="card" onClick={Video}>
                <div className="block">
                  <button onClick={InformationImportante}>
                    Information importante pour nos chères utilisateurs
                  </button>
                </div>
                {/* block */}

                <div className="block-deux">
                  <p>
                    A partir du 06/04/2024 vous pouvez seulement publier des
                    vidéos qui ont une taille de 10MB.
                  </p>
                  <p>
                    Pour les utilisateurs qui veulent publier des vidéos qui
                    dépassent 10MB, entrer en contact avec nous et nous allons
                    vous montrer une méthode pour publier en attendant la
                    méthode officielle.
                  </p>
                </div>
                {/* block-deux */}

                {/* la c'est pour entrer en contact avec Alrani */}
                <div className="block-trois">
                  <button onClick={ContacterAlrani}>Entrer en contact</button>
                </div>
                {/* block-trois */}

                <div className="block-quatre">
                  <p onClick={LienVideo}>J'ai un lien</p>
                </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* information-importante-opacity */}
        </>
      )}
      {/* Information Importante - page */}

      {/* j'ai un lien - page */}
      {/* j'ai un lien - page */}
      {lienVideo && (
        <>
          <div className="page-general-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={LienVideo}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35px"
                    fill="blue"
                    viewBox="0 0 32 32"
                  >
                    <path d="M15 3c-1.258 0-2.152.89-2.594 2H5v23h8v2h14V14h-2V5h-7.406C17.152 3.89 16.258 3 15 3zm0 2c.555 0 1 .445 1 1v1h3v2h-8V7h3V6c0-.555.445-1 1-1zM7 7h2v4h12V7h2v7H13v12H7zm8 9h10v12H15z"></path>
                  </svg>
                </div>

                <div className="center">
                  <p
                    style={{
                      fontSize: "17px",
                      paddingBottom: "16px",
                      paddingTop: "5px",
                    }}
                  >
                    Coller le lien
                  </p>
                </div>

                <div className="capture-decran-du-contact">
                  <div className="display">
                    <input
                      type="text"
                      placeholder="coller le lien de la vidéo ici.."
                      value={urlVideo}
                    />
                  </div>
                  {/* display */}
                </div>
                {/* capture-decran-du-contact */}

                <div style={{ paddingTop: "10px" }} className="hr">
                  <hr />
                </div>

                <div className="vert-btn">
                  {/* quand on clique, ca va envoyer le lien de la video dans la page /video */}
                  <button onClick={CollerLienContinuer}>Continuer</button>
                </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* add-your-contact-opacity */}
        </>
      )}
      {/* j'ai un lien - page */}

      

      {/* booster la page - page */}
      {/* ici on va afficher les modeles que la personne va choisir ensuite il pourra
      booster sa page */}
      {boosterPage && (<>
          <div className="booster-page-opacity">
            <div className="align">
              <div onClick={CloseBoosterPage} className="block-un">
                <div className="a"> <p>Booster la Publication</p> </div>
                <div className="b"> <p>Choisissez un modèle qui vous convient</p> </div>
              </div>
              {/* block-un */}

              <div className="block-deux">
                {/* modele 1 */}
                {/* modele 1 */}
                {/* modele 1 . card-vert */}
                <div className="modele-un">
                  <div onClick={PersonnaliserPubliciter} className="card-vert">
                    <div className="title">
                      <p>Modèle 1</p>
                    </div>
                    {/* title */}

                    <div className="details">
                      <div className="phrase-daccroche"> <p>Booster la publication pour avoir Plus de clics et gagner Plus de Millions. Si votre objectif c'est Plus de ventes, vous allez aussi obtenir Plus de ventes</p> </div>
                      <div className="infos"> <p>Booster la publication avec le Modèle 1</p> </div>

                      {/* Swazi Lilangeni - modele 1 */}
                      {/* Swazi Lilangeni - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Swazi Lilangeni, alors ici
                    on affiche le prix en Swazi Lilangeni */}
                      {monnaieSwaziLilangeni === "1" || swaziLilangeni ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 617.60 SZL
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Swazi Lilangeni
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Swazi Lilangeni - modele 1 */}

                      {/* Euro - modele 1 */}
                      {/* Euro - modele 1 */}
                      {/* si dans la liste des pays, il a choisit l'euro, alors ici
                    on affiche le prix en euro */}
                      {monnaieEuro === "1" || euro ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 80 Euros</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Euro</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Euro - modele 1 */}

                      {/* Dollar Américain - modele 1 */}
                      {/* Dollar Américain - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Dollar Américain, alors ici
                    on affiche le prix en Dollar Américain */}
                      {monnaieDollarAmericain === "1" || dollarAmericain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 85.50 $</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dollar Américain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dollar Américain - modele 1 */}

                      {/* Real Brésilien - modele 1 */}
                      {/* Real Brésilien - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Real Brésilien, alors ici
                    on affiche le prix en Real Brésilien */}
                      {monnaieRealBresilien === "1" || realBresilien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 350 R$</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Real Brésilien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Real Brésilien - modele 1 */}

                      {/* Franc CFA - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Franc CFA, alors 
                    on affiche le prix en FCFA */}
                      {monnaieFrancCFA === "1" || franc ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 35 000 FCFA
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc CFA d'Afrique Centrale
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc CFA - modele 1 */}

                      {/* Franc Congolais - modele 1 */}
                      {/* Franc Congolais - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Franc Congolais, alors ici
                    on affiche le prix en Franc Congolais */}
                      {monnaieFrancCongolais === "1" || francCongolais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 120 000 CDF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Congolais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Congolais - modele 1 */}

                      {/* Franc burundais - modele 1 */}
                      {/* Franc burundais - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Franc burundais, alors ici
                    on affiche le prix en Franc burundais */}
                      {monnaieFrancBurundais === "1" || francBurundais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 75.000 BIF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Burundais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Burundais - modele 1 */}

                      {/* Franc Suisse - modele 1 */}
                      {/* Franc Suisse - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Franc Suisse, alors ici
                    on affiche le prix en Franc Suisse*/}
                      {monnaieFrancSuisse === "1" || francSuisse ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 1000 SWZ</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Suisse</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Suisse - modele 1 */}

                      {/* Franc Guineen - modele 1 */}
                      {/* Franc Guineen - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Franc Guineen, alors ici
                    on affiche le prix en Franc Guineen */}
                      {monnaieFrancGuineen === "1" || francGuineen ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 800 000 FG
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Guinéen</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Guineen - modele 1 */}

                      {/* Dinar Algérien - modele 1 */}
                      {/* Dinar Algérien - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Algérien, alors ici
                    on affiche le prix en Dinar Algérien */}
                      {monnaieDinarAlgerien === "1" || dinarAlgerien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 4300 DZD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Algérien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* dinar algerien - modele 1 */}

                      {/* Dirham Marocain - modele 1 */}
                      {/* Dirham Marocain - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Dirham Marocain, alors ici
                    on affiche le prix en Dirham Marocain */}
                      {monnaieDirhamMarocain === "1" || dirhamMarocain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 450 MAD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dirham Marocain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dirham Marocain - modele 1 */}

                      {/* Dinar Tunisien - modele 1 */}
                      {/* Dinar Tunisien - modele 1 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Tunisien, alors ici
                    on affiche le prix en Dinar Tunisien */}
                      {monnaieDinarTunisien === "1" || dinarTunisien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 120.000 TND
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Tunisien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dinar Tunisien - modele 1 */}
                    </div>
                    {/* details */}
                  </div>
                  {/* card-vert */}
                </div>
                {/* modele-un */}
                {/* modele 1 . card-vert */}

                {/* modele 2 */}
                {/* modele 2 */}
                {/* modele 2 . card-jaune */}
                <div className="modele-un">
                  <div onClick={PersonnaliserPubliciter} className="card-jaune">
                    <div className="title">
                      <p>Modèle 2</p>
                    </div>
                    {/* title */}

                    <div className="details">
                      <div className="phrase-daccroche"> <p>Booster la publication pour avoir Plus de clics et gagner Plus de Millions. Si votre objectif c'est Plus de ventes, vous allez aussi obtenir Plus de ventes</p> </div>
                      <div className="infos"> <p>Booster la publication avec le Modèle 1</p> </div>


                      {/* Swazi Lilangeni - modele 2 */}
                      {/* Swazi Lilangeni - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Swazi Lilangeni, alors ici
                    on affiche le prix en Swazi Lilangeni */}
                      {monnaieSwaziLilangeni === "1" || swaziLilangeni ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 617.60 SZL
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Swazi Lilangeni
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Swazi Lilangeni - modele 2 */}

                      {/* Euro - modele 2 */}
                      {/* Euro - modele 2 */}
                      {/* si dans la liste des pays, il a choisit l'euro, alors ici
                    on affiche le prix en euro */}
                      {monnaieEuro === "1" || euro ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 40 Euros</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Euro</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Euro - modele 2 */}

                      {/* Dollar Américain - modele 2 */}
                      {/* Dollar Américain - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Dollar Américain, alors ici
                    on affiche le prix en Dollar Américain */}
                      {monnaieDollarAmericain === "1" || dollarAmericain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 40.50 $</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dollar Américain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dollar Américain - modele 2 */}

                      {/* Real Brésilien - modele 2 */}
                      {/* Real Brésilien - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Real Brésilien, alors ici
                    on affiche le prix en Real Brésilien */}
                      {monnaieRealBresilien === "1" || realBresilien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 169.14 R$</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Real Brésilien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Real Brésilien - modele 2 */}

                      {/* Franc CFA - modele 2 */}
                      {/* Franc CFA - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Franc CFA, alors 
                    on affiche le prix en FCFA */}
                      {monnaieFrancCFA === "1" || franc ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 35 000 FCFA
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc CFA d'Afrique Centrale
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc CFA - modele 2 */}

                      {/* Franc Congolais - modele 2 */}
                      {/* Franc Congolais - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Franc Congolais, alors ici
                    on affiche le prix en Franc Congolais */}
                      {monnaieFrancCongolais === "1" || francCongolais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 30 000 CDF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Congolais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Congolais - modele 2 */}

                      {/* Franc burundais - modele 2 */}
                      {/* Franc burundais - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Franc burundais, alors ici
                    on affiche le prix en Franc burundais */}
                      {monnaieFrancBurundais === "1" || francBurundais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 75.000 BIF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Burundais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Burundais - modele 2 */}

                      {/* Franc Suisse - modele 2 */}
                      {/* Franc Suisse - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Franc Suisse, alors ici
                    on affiche le prix en Franc Suisse*/}
                      {monnaieFrancSuisse === "1" || francSuisse ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 1000 SWZ</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Suisse</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Suisse - modele 2 */}

                      {/* Franc Guineen - modele 2 */}
                      {/* Franc Guineen - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Franc Guineen, alors ici
                    on affiche le prix en Franc Guineen */}
                      {monnaieFrancGuineen === "1" || francGuineen ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 800 000 FG
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Guinéen</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Guineen - modele 2 */}

                      {/* Dinar Algérien - modele 2 */}
                      {/* Dinar Algérien - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Algérien, alors ici
                    on affiche le prix en Dinar Algérien */}
                      {monnaieDinarAlgerien === "1" || dinarAlgerien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 4300 DZD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Algérien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* dinar algerien - modele 2 */}

                      {/* Dirham Marocain - modele 2 */}
                      {/* Dirham Marocain - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Dirham Marocain, alors ici
                    on affiche le prix en Dirham Marocain */}
                      {monnaieDirhamMarocain === "1" || dirhamMarocain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 450 MAD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dirham Marocain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dirham Marocain - modele 2 */}

                      {/* Dinar Tunisien - modele 2 */}
                      {/* Dinar Tunisien - modele 2 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Tunisien, alors ici
                    on affiche le prix en Dinar Tunisien */}
                      {monnaieDinarTunisien === "1" || dinarTunisien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 120.000 TND
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Tunisien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dinar Tunisien - modele 2 */}
                    </div>
                    {/* details */}
                  </div>
                  {/* card-jaune */}
                </div>
                {/* modele-un */}
                {/* modele 2 . card-jaune */}

                {/* modele 3 */}
                {/* modele 3 */}
                {/* modele 3 . card-bleu */}
                <div className="modele-un">
                  <div onClick={PersonnaliserPubliciter} className="card-bleu">
                    <div className="title">
                      <p>Modèle 3</p>
                    </div>
                    {/* title */}

                    <div className="details">
                      <div className="phrase-daccroche"> <p>Booster la publication pour avoir Plus de clics et gagner Plus de Millions. Si votre objectif c'est Plus de ventes, vous allez aussi obtenir Plus de ventes</p> </div>
                      <div className="infos"> <p>Booster la publication avec le Modèle 1</p> </div>

                         

                      {/* Swazi Lilangeni - modele 3 */}
                      {/* Swazi Lilangeni - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Swazi Lilangeni, alors ici
                    on affiche le prix en Swazi Lilangeni */}
                      {monnaieSwaziLilangeni === "1" || swaziLilangeni ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 617.60 SZL
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Swazi Lilangeni
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Swazi Lilangeni - modele 3 */}

                      {/* Euro - modele 3 */}
                      {/* Euro - modele 3 */}
                      {/* si dans la liste des pays, il a choisit l'euro, alors ici
                    on affiche le prix en euro */}
                      {monnaieEuro === "1" || euro ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 40 Euros</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Euro</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Euro - modele 3 */}

                      {/* Dollar Américain - modele 3 */}
                      {/* Dollar Américain - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Dollar Américain, alors ici
                    on affiche le prix en Dollar Américain */}
                      {monnaieDollarAmericain === "1" || dollarAmericain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 40.50 $</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dollar Américain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dollar Américain - modele 3 */}

                      {/* Real Brésilien - modele 3 */}
                      {/* Real Brésilien - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Real Brésilien, alors ici
                    on affiche le prix en Real Brésilien */}
                      {monnaieRealBresilien === "1" || realBresilien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 169.14 R$</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Real Brésilien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Real Brésilien - modele 3 */}

                      {/* Franc CFA - modele 3 */}
                      {/* Franc CFA - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Franc CFA, alors 
                    on affiche le prix en FCFA */}
                      {monnaieFrancCFA === "1" || franc ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 35 000 FCFA
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc CFA d'Afrique Centrale
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc CFA - modele 3 */}

                      {/* Franc Congolais - modele 3 */}
                      {/* Franc Congolais - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Franc Congolais, alors ici
                    on affiche le prix en Franc Congolais */}
                      {monnaieFrancCongolais === "1" || francCongolais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 30 000 CDF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Congolais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Congolais - modele 3 */}

                      {/* Franc burundais - modele 3 */}
                      {/* Franc burundais - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Franc burundais, alors ici
                    on affiche le prix en Franc burundais */}
                      {monnaieFrancBurundais === "1" || francBurundais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 75.000 BIF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Burundais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Burundais - modele 3 */}

                      {/* Franc Suisse - modele 3 */}
                      {/* Franc Suisse - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Franc Suisse, alors ici
                    on affiche le prix en Franc Suisse*/}
                      {monnaieFrancSuisse === "1" || francSuisse ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 1000 SWZ</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Suisse</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Suisse - modele 3 */}

                      {/* Franc Guineen - modele 3 */}
                      {/* Franc Guineen - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Franc Guineen, alors ici
                    on affiche le prix en Franc Guineen */}
                      {monnaieFrancGuineen === "1" || francGuineen ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 800 000 FG
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Guinéen</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Guineen - modele 3 */}

                      {/* Dinar Algérien - modele 3 */}
                      {/* Dinar Algérien - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Algérien, alors ici
                    on affiche le prix en Dinar Algérien */}
                      {monnaieDinarAlgerien === "1" || dinarAlgerien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 4300 DZD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Algérien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* dinar algerien - modele 3 */}

                      {/* Dirham Marocain - modele 3 */}
                      {/* Dirham Marocain - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Dirham Marocain, alors ici
                    on affiche le prix en Dirham Marocain */}
                      {monnaieDirhamMarocain === "1" || dirhamMarocain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 450 MAD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dirham Marocain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dirham Marocain - modele 3 */}

                      {/* Dinar Tunisien - modele 3 */}
                      {/* Dinar Tunisien - modele 3 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Tunisien, alors ici
                    on affiche le prix en Dinar Tunisien */}
                      {monnaieDinarTunisien === "1" || dinarTunisien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 120.000 TND
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Tunisien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dinar Tunisien - modele 3 */}
                    </div>
                    {/* details */}
                  </div>
                  {/* card-jaune */}
                </div>
                {/* modele-un */}
                {/* modele 3 . card-bleu */}

                {/* modele 4 */}
                {/* modele 4 */}
                {/* modele 4 . card-rouge */}
                <div className="modele-un">
                  <div onClick={PersonnaliserPubliciter} className="card-rouge">
                    <div className="title">
                      <p>Modèle 4</p>
                    </div>
                    {/* title */}

                    <div className="details">
                      <div className="phrase-daccroche"> <p>Booster la publication pour avoir Plus de clics et gagner Plus de Millions. Si votre objectif c'est Plus de ventes, vous allez aussi obtenir Plus de ventes</p> </div>
                      <div className="infos"> <p>Booster la publication avec le Modèle 1</p> </div>

                      {/* Swazi Lilangeni - modele 4 */}
                      {/* Swazi Lilangeni - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Swazi Lilangeni, alors ici
                    on affiche le prix en Swazi Lilangeni */}
                      {monnaieSwaziLilangeni === "1" || swaziLilangeni ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 617.60 SZL
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Swazi Lilangeni
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Swazi Lilangeni - modele 4 */}

                      {/* Euro - modele 4 */}
                      {/* Euro - modele 4 */}
                      {/* si dans la liste des pays, il a choisit l'euro, alors ici
                    on affiche le prix en euro */}
                      {monnaieEuro === "1" || euro ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 40 Euros</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Euro</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Euro - modele 4 */}

                      {/* Dollar Américain - modele 4 */}
                      {/* Dollar Américain - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Dollar Américain, alors ici
                    on affiche le prix en Dollar Américain */}
                      {monnaieDollarAmericain === "1" || dollarAmericain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 40.50 $</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dollar Américain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dollar Américain - modele 4 */}

                      {/* Real Brésilien - modele 4 */}
                      {/* Real Brésilien - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Real Brésilien, alors ici
                    on affiche le prix en Real Brésilien */}
                      {monnaieRealBresilien === "1" || realBresilien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 169.14 R$</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Real Brésilien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Real Brésilien - modele 4 */}

                      {/* Franc CFA - modele 4 */}
                      {/* Franc CFA - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Franc CFA, alors 
                    on affiche le prix en FCFA */}
                      {monnaieFrancCFA === "1" || franc ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 20 000 FCFA
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc CFA d'Afrique Centrale
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc CFA - modele 4 */}

                      {/* Franc Congolais - modele 4 */}
                      {/* Franc Congolais - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Franc Congolais, alors ici
                    on affiche le prix en Franc Congolais */}
                      {monnaieFrancCongolais === "1" || francCongolais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 30 000 CDF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Congolais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Congolais - modele 4 */}

                      {/* Franc burundais - modele 4 */}
                      {/* Franc burundais - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Franc burundais, alors ici
                    on affiche le prix en Franc burundais */}
                      {monnaieFrancBurundais === "1" || francBurundais ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 75.000 BIF
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Franc Burundais
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Burundais - modele 4 */}

                      {/* Franc Suisse - modele 4 */}
                      {/* Franc Suisse - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Franc Suisse, alors ici
                    on affiche le prix en Franc Suisse*/}
                      {monnaieFrancSuisse === "1" || francSuisse ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 1000 SWZ</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Suisse</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Suisse - modele 4 */}

                      {/* Franc Guineen - modele 4 */}
                      {/* Franc Guineen - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Franc Guineen, alors ici
                    on affiche le prix en Franc Guineen */}
                      {monnaieFrancGuineen === "1" || francGuineen ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 800 000 FG
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Franc Guinéen</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Franc Guineen - modele 4 */}

                      {/* Dinar Algérien - modele 4 */}
                      {/* Dinar Algérien - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Algérien, alors ici
                    on affiche le prix en Dinar Algérien */}
                      {monnaieDinarAlgerien === "1" || dinarAlgerien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 4300 DZD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Algérien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* dinar algerien - modele 4 */}

                      {/* Dirham Marocain - modele 4 */}
                      {/* Dirham Marocain - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Dirham Marocain, alors ici
                    on affiche le prix en Dirham Marocain */}
                      {monnaieDirhamMarocain === "1" || dirhamMarocain ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>Prix : 450 MAD</p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>
                                  • Dirham Marocain
                                </p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dirham Marocain - modele 4 */}

                      {/* Dinar Tunisien - modele 4 */}
                      {/* Dinar Tunisien - modele 4 */}
                      {/* si dans la liste des pays, il a choisit le Dinar Tunisien, alors ici
                    on affiche le prix en Dinar Tunisien */}
                      {monnaieDinarTunisien === "1" || dinarTunisien ? (
                        <>
                          <div className="display">
                            <div className="a">
                              <div className="prix">
                                <p onClick={AutresMonnaies}>
                                  Prix : 120.000 TND
                                </p>
                              </div>
                              {/* prix */}

                              <div className="monnaie">
                                <p onClick={AutresMonnaies}>• Dinar Tunisien</p>
                              </div>
                              {/* monnaie */}
                            </div>
                            {/* a */}

                            <div className="b">
                              <svg
                                onClick={AutresMonnaies}
                                xmlns="http://www.w3.org/2000/svg"
                                cursor="pointer"
                                width="10px"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fff"
                                  fillRule="evenodd"
                                  d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            {/* b */}
                          </div>
                          {/* display */}
                        </>
                      ) : (
                        <>
                          <p></p>
                        </>
                      )}
                      {/* Dinar Tunisien - modele 4 */}
                    </div>
                    {/* details */}
                  </div>
                  {/* card-rouge */}
                </div>
                {/* modele-un */}
                {/* modele 4 . card-rouge*/}
              </div>
              {/* block-deux */}
            </div>
            {/* align */}
          </div>
          {/* booster-page-opacity */}
        </>
      )}
      {/* booster la page - page */}

      {/* afficher le prix dans d'autres monnaies */}
      {/* bon! quand on clique sur la fleche qui est a coter du prix, une popup va s'ouvrir 
     pour nous permettre de choisir une monnaie et d'afficher le prix de la publicité
      dans une autre monnaie */}
      {autresMonnaies && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={AutresMonnaies}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Choisir une monnaie</li>
                </div>
                {/* title */}

                {/* Swazi Lilangeni */}
                {/* il clique pour choisir le Swazi Lilangeni, dans la liste des monnaies */}
                {swaziLilangeni && (
                  <>
                    <div onClick={SwaziLilangeni} className="active">
                      <p>Swazi Lilangeni</p>
                    </div>
                  </>
                )}

                {!swaziLilangeni && (
                  <>
                    <div onClick={SwaziLilangeni} className="no-active">
                      <p>Swazi Lilangeni</p>
                    </div>
                  </>
                )}

                {/* Euro */}
                {/* il clique pour choisir l'Euro, dans la liste des monnaies */}
                {euro && (
                  <>
                    <div onClick={Euro} className="active">
                      <p>Euro</p>
                    </div>
                  </>
                )}

                {!euro && (
                  <>
                    <div onClick={Euro} className="no-active">
                      <p>Euro</p>
                    </div>
                  </>
                )}

                {/* Dollar Américain */}
                {/* il clique pour choisir le Dollar Américain, dans la liste des monnaies */}
                {dollarAmericain && (
                  <>
                    <div onClick={DollarAmericain} className="active">
                      <p>Dollar Américain</p>
                    </div>
                  </>
                )}

                {!dollarAmericain && (
                  <>
                    <div onClick={DollarAmericain} className="no-active">
                      <p>Dollar Américain</p>
                    </div>
                  </>
                )}

                {/* Real Brésilien */}
                {/* il clique pour choisir le Real Brésilien, dans la liste des monnaies */}
                {realBresilien && (
                  <>
                    <div onClick={RealBresilien} className="active">
                      <p>Real Brésilien</p>
                    </div>
                  </>
                )}

                {!realBresilien && (
                  <>
                    <div onClick={RealBresilien} className="no-active">
                      <p>Real Brésilien</p>
                    </div>
                  </>
                )}

                {/* Franc CFA */}
                {/* Franc CFA */}
                {/* il clique pour choisir le Franc CFA, dans la listes des monnaies */}
                {franc && (
                  <>
                    <div onClick={Franc} className="active">
                      <p>Franc CFA d'Afrique Centrale</p>
                    </div>
                  </>
                )}

                {!franc && (
                  <>
                    <div onClick={Franc} className="no-active">
                      <p>Franc CFA d'Afrique Centrale</p>
                    </div>
                  </>
                )}

                {/* Franc Guineen */}
                {/* il clique pour choisir le Franc Guineen, dans la listes des monnaies */}
                {francGuineen && (
                  <>
                    <div onClick={FrancGuineen} className="active">
                      <p>Franc Guinéen</p>
                    </div>
                  </>
                )}

                {!francGuineen && (
                  <>
                    <div onClick={FrancGuineen} className="no-active">
                      <p>Franc Guinéen</p>
                    </div>
                  </>
                )}

                {/* Franc Congolais */}
                {/* il clique pour choisir le Franc Congolais, dans la listes des monnaies */}
                {francCongolais && (
                  <>
                    <div onClick={FrancCongolais} className="active">
                      <p>Franc Congolais</p>
                    </div>
                  </>
                )}

                {!francCongolais && (
                  <>
                    <div onClick={FrancCongolais} className="no-active">
                      <p>Franc Congolais</p>
                    </div>
                  </>
                )}

                {/* Franc Suisse */}
                {/* il clique pour choisir le Franc Suisse, dans la listes des monnaies */}
                {francSuisse && (
                  <>
                    <div onClick={FrancSuisse} className="active">
                      <p>Franc Suisse</p>
                    </div>
                  </>
                )}

                {!francSuisse && (
                  <>
                    <div onClick={FrancSuisse} className="no-active">
                      <p>Franc Suisse</p>
                    </div>
                  </>
                )}

                {/* Franc Burundais */}
                {/* il clique pour choisir le Franc Burundais, dans la listes des monnaies */}
                {francBurundais && (
                  <>
                    <div onClick={FrancBurundais} className="active">
                      <p>Franc Burundais</p>
                    </div>
                  </>
                )}

                {!francBurundais && (
                  <>
                    <div onClick={FrancBurundais} className="no-active">
                      <p>Franc Burundais</p>
                    </div>
                  </>
                )}

                {/* Dinar Algérien */}
                {/* il clique pour choisir le Franc Guineen, dans la listes des monnaies */}
                {dinarAlgerien && (
                  <>
                    <div onClick={DinarAlgerien} className="active">
                      <p>Dinar Algérien</p>
                    </div>
                  </>
                )}

                {!dinarAlgerien && (
                  <>
                    <div onClick={DinarAlgerien} className="no-active">
                      <p>Dinar Algérien</p>
                    </div>
                  </>
                )}

                {/* Dirham Marocain */}
                {/* il clique pour choisir le Dirham Marocain, dans la listes des monnaies */}
                {dirhamMarocain && (
                  <>
                    <div onClick={DirhamMarocain} className="active">
                      <p>Dirham Marocain</p>
                    </div>
                  </>
                )}

                {!dirhamMarocain && (
                  <>
                    <div onClick={DirhamMarocain} className="no-active">
                      <p>Dirham Marocain</p>
                    </div>
                  </>
                )}

                {/* Dinar Tunisien */}
                {/* il clique pour choisir le Dinar Tunisien, dans la listes des monnaies */}
                {dinarTunisien && (
                  <>
                    <div onClick={DinarTunisien} className="active">
                      <p>Dinar Tunisien</p>
                    </div>
                  </>
                )}

                {!dinarTunisien && (
                  <>
                    <div onClick={DinarTunisien} className="no-active">
                      <p>Dinar Tunisien</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* afficher le prix dans d'autres monnaies */}

      {/* personnaliser publiciter - page */}
      {/* personnaliser publiciter - page */}
      {/* sur cette page, on va par exemple dire qu'on veut que la publicité s'affiche aux 
      personnes qui vivent au Congo, on va par exemple selectionner uniquement les hommes
      , l'age on va selectionner par exemple, 30-40 ans */}
      {personnaliserPubliciter && (
        <>
          <div className="personnaliserPubliciter-opacity">
            <div className="align">
              <div className="title">
                <div className="a">
                  <svg
                    onClick={PersonnaliserPubliciter}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>

                  <p>Booster la Publication</p>
                </div>
                {/* a */}

                <div className="b">
                  <button>Personnaliser la Publicité</button>
                </div>
                {/* b */}

                <div className="c">
                  <p>
                    Effectuer un ciblage personnalisé pour toucher uniquement
                    les personnes qui vous conviennes
                  </p>
                </div>
                {/* c */}

                <div className="d">
                  <p>
                    Plus le ciblage est personnalisé, plus vous toucher les
                    bonnes personnes
                  </p>
                </div>
                {/* d */}

                <div className="e">
                  <p>
                    (Dans les Préférences, vous pouvez par exemple cibler des
                    personnes qui préfèrent des vêtements Made in Africa)
                  </p>
                </div>
                {/* e */}
              </div>
              {/* title */}

              {/* partie - preference */}
              {/* partie - preference */}
              {/* partie - preference */}
              <div className="block-un">
                <div className="preference">
                  <div className="a">
                    <p>Préférences</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <hr />
                  </div>
                  {/* b */}
                </div>
                {/* preference */}

                <div className="mes-choix">
                  <p onClick={SelectionnerPreference}>
                    Préférences des personnes
                  </p>

                  <svg
                    onClick={SelectionnerPreference}
                    xmlns="http://www.w3.org/2000/svg"
                    cursor="pointer"
                    width="10px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                {/* mes-choix */}

                <div className="display">
                  {/* Football */}
                  {football && (
                    <>
                      <button onClick={Football}>Vêtements et Chaussures</button>
                    </>
                  )}

                  {/* Produits Cosmétiques */}
                  {produitsCosmetiques && (
                    <>
                      <button onClick={ProduitsCosmetiques}>
                        Produits Cosmétiques
                      </button>
                    </>
                  )}

                  {/* Soins de visage */}
                  {soinsDeVisage && (
                    <>
                      <button onClick={SoinsDeVisage}>Soins de visage</button>
                    </>
                  )}

                  {/* Made In Africa */}
                  {madeInAfrica && (
                    <>
                      <button onClick={MadeInAfrica}>Made in Africa</button>
                    </>
                  )}
                </div>
                {/* display */}
              </div>
              {/* block-un */}
              {/* partie - preference */}

              {/* partie - pays */}
              {/* partie - pays */}
              {/* partie - pays */}
              <div className="block-un">
                <div className="preference">
                  <div className="a">
                    <p>Zone géographique</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <hr />
                  </div>
                  {/* b */}
                </div>
                {/* preference */}

                <div className="mes-choix">
                  <p onClick={SelectionnerPays}>Zone/Pays</p>

                  <svg
                    onClick={SelectionnerPays}
                    xmlns="http://www.w3.org/2000/svg"
                    cursor="pointer"
                    width="10px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                {/* mes-choix */}

                <div className="display">
                  {/* Afrique Centrale */}
                  {afriqueCentralePP && (
                    <>
                      <button onClick={AfriqueCentralePP}>
                        Afrique Centrale
                      </button>
                    </>
                  )}

                  {/* Congo */}
                  {congoPP && (
                    <>
                      <button onClick={CongoPP}>Congo</button>
                    </>
                  )}

                  {/* Gabon */}
                  {gabonPP && (
                    <>
                      <button onClick={GabonPP}>Gabon</button>
                    </>
                  )}

                  {/* Afrique Australe */}
                  {afriqueAustralePP && (
                    <>
                      <button onClick={AfriqueAustralePP}>
                        Afrique Australe
                      </button>
                    </>
                  )}

                  {/* Afrique du Sud */}
                  {afriqueDuSudPP && (
                    <>
                      <button onClick={AfriqueDuSudPP}>Afrique du Sud</button>
                    </>
                  )}

                  {/* eswatini */}
                  {eswatiniPP && (
                    <>
                      <button onClick={EswatiniPP}>Eswatini</button>
                    </>
                  )}
                </div>
                {/* display */}
              </div>
              {/* block-un */}
              {/* partie - pays */}

              {/* partie - age */}
              {/* partie - age */}
              {/* partie - age */}
              <div className="block-un">
                <div className="preference">
                  <div className="a">
                    <p>Age</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <hr />
                  </div>
                  {/* b */}
                </div>
                {/* preference */}

                <div className="mes-choix">
                  <p onClick={SelectionnerAge}>Age des personnes</p>

                  <svg
                    onClick={SelectionnerAge}
                    xmlns="http://www.w3.org/2000/svg"
                    cursor="pointer"
                    width="10px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                {/* mes-choix */}

                <div className="display">
                  {/* Moins de 10 ans */}
                  {dixMoins && (
                    <>
                      <button onClick={DixMoins}>Moins de 10 ans</button>
                    </>
                  )}

                  {/* 10 - 20 ans */}
                  {dixVingt && (
                    <>
                      <button onClick={DixVingt}>10 - 20 ans</button>
                    </>
                  )}

                  {/* 20 - 30 ans */}
                  {vingtTrente && (
                    <>
                      <button onClick={VingtTrente}>20 - 30 ans</button>
                    </>
                  )}

                  {/* 30 - 40 ans */}
                  {trenteQuarante && (
                    <>
                      <button onClick={TrenteQuarante}>30 - 40 ans</button>
                    </>
                  )}

                  {/* 40 - 50 ans */}
                  {quaranteCinquante && (
                    <>
                      <button onClick={QuaranteCinquante}>40 - 50 ans</button>
                    </>
                  )}

                  {/* 50 - 60 ans */}
                  {cinquanteSoixante && (
                    <>
                      <button onClick={CinquanteSoixante}>50 - 60 ans</button>
                    </>
                  )}

                  {/* Plus de 60 ans */}
                  {soixantePlus && (
                    <>
                      <button onClick={SoixantePlus}>Plus de 60 ans</button>
                    </>
                  )}
                </div>
                {/* display */}
              </div>
              {/* block-un */}
              {/* partie - age */}

              {/* partie - sexe */}
              {/* partie - sexe */}
              {/* partie - sexe */}
              <div className="block-un">
                <div className="preference">
                  <div className="a">
                    <p>Sexe</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <hr />
                  </div>
                  {/* b */}
                </div>
                {/* preference */}

                <div className="mes-choix">
                  <p onClick={SelectionnerSexe}>Sexe des personnes</p>

                  <svg
                    onClick={SelectionnerSexe}
                    xmlns="http://www.w3.org/2000/svg"
                    cursor="pointer"
                    width="10px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                {/* mes-choix */}

                <div className="display">
                  {/* Masculin */}
                  {masculinPP && (
                    <>
                      <button onClick={MasculinPP}>Masculin</button>
                    </>
                  )}

                  {/* feminin */}
                  {femininPP && (
                    <>
                      <button onClick={FemininPP}>Féminin</button>
                    </>
                  )}

                  {/* Trans */}
                  {/* PP veut dire PersonnaliserPubliciter, ca me permet de differencier
                  les trans que j'avais mis au niveau du compte, lorsque la personne veut 
                  changer de genre.
                  TransPP veut tout simplement dire Trans dans PersonnaliserPubliciter */}
                  {transPP && (
                    <>
                      <button onClick={TransPP}>Trans</button>
                    </>
                  )}
                </div>
                {/* display */}
              </div>
              {/* block-un */}
              {/* partie - genre */}

              <div className="acheter">
                <button onClick={MoyenDePaiementPP}>Booster</button>
              </div>
              {/* acheter */}
            </div>
            {/* align */}
          </div>
          {/* personnaliserPubliciter-opacity */}
        </>
      )}
      {/* personnaliser publiciter - page */}

      {/* moyen de paiement - page */}
      {/* moyen de paiement - page */}
      {/* ca c'est la page qui va permettre de choisir le moyen de paiement avec lequel 
      on va acheter la publiciter et c'est aussi un petit recapitulatif avant l'achat de la pub */}
      {moyenDePaiementPP && (
        <>
          <div className="moyenDePaiementPP-bottom">
            <div className="bottom">
              <div className="card">
                <div className="center">
                  <div className="a">
                    <button onClick={MoyenDePaiementPP}>Booster la publication</button>
                  </div>
                  {/* a */}

                  <div className="b">
                    <div className="display">
                      <li onClick={SelectionnerMoyenDePaiement}>
                        Moyen de Paiement
                      </li>
                      <svg
                        onClick={SelectionnerMoyenDePaiement}
                        xmlns="http://www.w3.org/2000/svg"
                        cursor="pointer"
                        width="10px"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#000"
                          fillRule="evenodd"
                          d="M4.293 8.293a1 1 0 011.414 0L12 14.586l6.293-6.293a1 1 0 111.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    {/* display */}

                    {/* si le moyen de paiement Izocash a ete selectionner, ca va s'afficher */}
                    {moyenDePaiementIzocash === "1" || izocash ? (
                      <>
                        <button onClick={Izocash}>Florinato Pay</button>
                      </>
                    ) : (
                      <>
                        <p></p>
                      </>
                    )}

                    {dev && (<>
                    {/* si le moyen de paiement Bons d'achats Zimagic a ete 
                    selectionner, ca va s'afficher */}
                    {moyenDePaiementBonsDachatsZimagic === "1" ||
                    bonsDachatsZimagic ? (
                      <>
                        <button onClick={BonsDachatsZimagic}>
                          Bons d'achats Zimagic
                        </button>
                      </>
                    ) : (
                      <>
                        <p></p>
                      </>)}
                    </>)} {/* le code de dev se ferme ici */}
                  </div>
                  {/* b */}

                  <div className="c">
                    <div className="card-c">
                      <p>Votre publication aura 12000 clics de plus</p>
                      <p>Montant à payer : 35 000 FCFA</p>
                      <p>Peu importe le nombre de personnes qui ont vues la publicité, votre publicité ne sera point stopper tant que le nombre de clics n'est pas atteint</p>
                      <p>Booster votre publication maintenant pour obtenir Plus de clics et gagner Plus de Millions. Si votre objectif c'est avoir Plus de ventes, vous allez aussi avoir Plus de ventes</p>
                    </div>
                    {/* .card-c */}
                  </div>
                  {/* c */}

                  <div className="d"> <button onClick={BoostPostAA}>Booster Maintenant</button> </div>
                  {/* d */}
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* bottom */}
          </div>
          {/* moyenDePaiementPP-bottom */}
        </>
      )}
      {/* moyen de paiement - page */}

      
      {/* publicité débuté (message de success) */}
      {/* publicité débuté (message de success) */}
      {adSuccessAA && (<>
          <div onClick={CloseAdSuccessAA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>La Publicité à déjà débuter</p> </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>)}
      {/* publicité débuté (message de success) */}

      
      {/* publicité débuté (message de success 2 ) */}
      {/* publicité débuté (message de success 2 ) */}
      {adSuccess2AA && (<>
          <div onClick={CloseAdSuccess2AA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Sponsorisée</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* publicité débuté (message de success 2 ) */}


       {/* solde insuffisant (Alrani Pay) - AA */}
      {/* on affiche cette page s'il clique et qu'il n'a plus d'argent dans son compte Alrani Pay - AA */}
      {errorAlraniPayAA && (<>
          <div onClick={CloseErrorAlraniPayAA} className="errorAlraniPayAA">
            <div className="align">
              <div className="card">
                <div className="block-one"> <SvgPay /> <p>Alrani <b>Pay</b></p> </div>

                <div className="block-two"> <p>Veuillez recharger votre Solde Alrani Pay</p> </div>
                {/* block-two */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* errorAlraniPayAA */}
        </>)}
      {/* solde insuffisant (Alrani Pay) - AA */}


      {/* error - AA */}
      {/* error - AA */}
      {/* on affiche cette page s'il y'a une erreur qui s'est produite */}
      {errorAA && (<>
          <div onClick={CloseErrorAA} className="errorAA">
            <div className="align">
              <div className="card">
                <div className="block-one"> <p>Une erreur s'est produite. Réessayer plus tard!</p> </div>
                <div className="block-two"> <p></p> <p>OK</p> </div>
                {/* block-two */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* errorAA */}
        </>)}
      {/* error - AA */}


      {/* selectionner un moyen de Paiement */}
      {/* selectionner un moyen de Paiement */}
      {/* quand on clique, une popup va s'ouvrir pour nous permettre de selectionner un
      moyen de Paiement afin de pouvoir payer la publiciter pour booster la page */}
      {selectionnerMoyenDePaiement && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={SelectionnerMoyenDePaiement}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>
                    Pour booster votre publication, sélectionner un moyen de paiement
                  </li>
                </div>
                {/* title */}

                {/* Izocash */}
                {/* il clique pour choisir Izocash, dans la liste des moyens de paiement */}
                {/* si dans le localStorage, le moyenDePaiementIzocash=1, alors Izocash
                sera active avec la couleur jaune */}
                {moyenDePaiementIzocash === "1" || izocash ? (
                  <>
                    <div onClick={Izocash} className="active">
                      <p>Florinato Pay</p>
                    </div>
                  </>
                ) : (
                  <>
                    <p></p>
                  </>
                )}

                {!izocash && (
                  <>
                    <div onClick={Izocash} className="no-active">
                      <p>Florinato Pay</p>
                    </div>
                  </>
                )}

                {/* Bons d'achats Zimagic */}
                {/* il clique pour choisir Bons d'achats Zimagic, dans la liste des 
                moyens de paiements */}
                {/* si dans le localStorage, le moyenDePaiementBonsDachatsZimagic=1, alors
               bonsDachatsZimagic sera active avec la couleur jaune */}
               {dev && (<>
                {moyenDePaiementBonsDachatsZimagic === "1" ||
                bonsDachatsZimagic ? (
                  <>
                    <div onClick={BonsDachatsZimagic} className="active">
                      <p>Bons d'achats Zimagic</p>
                    </div>
                  </>
                ) : (
                  <>
                    <p></p>
                  </>
                )}

                {!bonsDachatsZimagic && (
                  <>
                    <div onClick={BonsDachatsZimagic} className="no-active">
                      <p>Bons d'achats Zimagic</p>
                    </div>
                  </>
                )}
                </>)}

              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-genre-opacity*/}
        </>
      )}
      {/* selectionner un moyen de Paiement pour Booster la page */}
      {/* selectionner un moyen de Paiement */}

      {/* selectionner les preferences */}
      {/* selectionner les preferences */}
      {/* quand on clique, une popup va s'ouvrir pour nous permettre de selectionner les 
      preferences de notre choix */}
      {selectionnerPreference && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={SelectionnerPreference}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Sélectionner les bons critères</li>
                </div>
                {/* title */}

                {/* football */}
                {/* il clique pour choisir football, dans la liste des preferences */}
                {football && (
                  <>
                    <div onClick={Football} className="active">
                      <p>Vêtements et Chaussures</p>
                    </div>
                  </>
                )}

                {!football && (
                  <>
                    <div onClick={Football} className="no-active">
                      <p>Vêtements et Chaussures</p>
                    </div>
                  </>
                )}

                {/* Produits Cosmétiques */}
                {/* il clique pour choisir Produits Cosmétiques, dans la liste des preferences */}
                {produitsCosmetiques && (
                  <>
                    <div onClick={ProduitsCosmetiques} className="active">
                      <p>Produits Cosmétiques</p>
                    </div>
                  </>
                )}

                {!produitsCosmetiques && (
                  <>
                    <div onClick={ProduitsCosmetiques} className="no-active">
                      <p>Produits Cosmétiques</p>
                    </div>
                  </>
                )}

                {/* Soins de visage */}
                {/* il clique pour choisir Soins de visage, dans la liste des preferences */}
                {soinsDeVisage && (
                  <>
                    <div onClick={SoinsDeVisage} className="active">
                      <p>Soins de visage</p>
                    </div>
                  </>
                )}

                {!soinsDeVisage && (
                  <>
                    <div onClick={SoinsDeVisage} className="no-active">
                      <p>Soins de visage</p>
                    </div>
                  </>
                )}

                {/* Made In Africa */}
                {/* il clique pour choisir Made In Africa, dans la liste des preferences */}
                {madeInAfrica && (
                  <>
                    <div onClick={MadeInAfrica} className="active">
                      <p>Made In Africa</p>
                    </div>
                  </>
                )}

                {!madeInAfrica && (
                  <>
                    <div onClick={MadeInAfrica} className="no-active">
                      <p>Made In Africa</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* selectionner les preferences */}

      {/* selectionner le pays ou la zone */}
      {/* selectionner le pays ou la zone */}
      {/* quand on clique, une popup va s'ouvrir pour nous permettre de selectionner
      le pays ou la zone */}
      {selectionnerPays && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={SelectionnerPays}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Sélectionner le pays ou la zone</li>
                </div>
                {/* title */}

                {/* Afrique Centrale */}
                {/* il clique pour choisir Afrique Centrale, dans la liste des pays/zone */}
                {afriqueCentralePP && (
                  <>
                    <div onClick={AfriqueCentralePP} className="active">
                      <p>Afrique Centrale</p>
                    </div>
                  </>
                )}

                {!afriqueCentralePP && (
                  <>
                    <div onClick={AfriqueCentralePP} className="no-active">
                      <p>Afrique Centrale</p>
                    </div>
                  </>
                )}

                {/* Congo */}
                {/* il clique pour choisir Congo, dans la liste des pays/zone */}
                {congoPP && (
                  <>
                    <div onClick={CongoPP} className="active">
                      <p>Congo</p>
                    </div>
                  </>
                )}

                {!congoPP && (
                  <>
                    <div onClick={CongoPP} className="no-active">
                      <p>Congo</p>
                    </div>
                  </>
                )}

                {/* Gabon */}
                {/* il clique pour choisir Gabon, dans la liste des pays/zone */}
                {gabonPP && (
                  <>
                    <div onClick={GabonPP} className="active">
                      <p>Gabon</p>
                    </div>
                  </>
                )}

                {!gabonPP && (
                  <>
                    <div onClick={GabonPP} className="no-active">
                      <p>Gabon</p>
                    </div>
                  </>
                )}

                {/* Afrique Australe */}
                {/* il clique pour choisir Afrique Australe, dans la liste des pays/zone */}
                {afriqueAustralePP && (
                  <>
                    <div onClick={AfriqueAustralePP} className="active">
                      <p>Afrique Australe</p>
                    </div>
                  </>
                )}

                {!afriqueAustralePP && (
                  <>
                    <div onClick={AfriqueAustralePP} className="no-active">
                      <p>Afrique Australe</p>
                    </div>
                  </>
                )}

                {/* afrique Du Sud */}
                {/* il clique pour choisir Afrique du Sud, dans la liste des pays/zone */}
                {afriqueDuSudPP && (
                  <>
                    <div onClick={AfriqueDuSudPP} className="active">
                      <p>Afrique du Sud</p>
                    </div>
                  </>
                )}

                {!afriqueDuSudPP && (
                  <>
                    <div onClick={AfriqueDuSudPP} className="no-active">
                      <p>Afrique du Sud</p>
                    </div>
                  </>
                )}

                {/* eswatini */}
                {/* il clique pour choisir eswatini, dans la liste des pays/zone */}
                {eswatiniPP && (
                  <>
                    <div onClick={EswatiniPP} className="active">
                      <p>Eswatini</p>
                    </div>
                  </>
                )}

                {!eswatiniPP && (
                  <>
                    <div onClick={EswatiniPP} className="no-active">
                      <p>Eswatini</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* selectionner le pays ou la zone */}

      {/* selectionner la tranche d'age */}
      {/* selectionner la tranche d'age */}
      {/* quand on clique, une popup va s'ouvrir pour nous permettre de selectionner la
      tranche d'age */}
      {selectionnerAge && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={SelectionnerAge}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Sélectionner la tranche d'age</li>
                </div>
                {/* title */}

                {/* Moins de 10 ans */}
                {/* il clique pour choisir Moins de 10 ans, dans la liste des tranches d'age */}
                {dixMoins && (
                  <>
                    <div onClick={DixMoins} className="active">
                      <p>Moins de 10 ans</p>
                    </div>
                  </>
                )}

                {!dixMoins && (
                  <>
                    <div onClick={DixMoins} className="no-active">
                      <p>Moins de 10 ans</p>
                    </div>
                  </>
                )}

                {/* 10 - 20 ans */}
                {/* il clique pour choisir 10 - 20 ans, dans la liste des tranches d'age */}
                {dixVingt && (
                  <>
                    <div onClick={DixVingt} className="active">
                      <p>10 - 20 ans</p>
                    </div>
                  </>
                )}

                {!dixVingt && (
                  <>
                    <div onClick={DixVingt} className="no-active">
                      <p>10 - 20 ans</p>
                    </div>
                  </>
                )}

                {/* 20 - 30 ans */}
                {/* il clique pour choisir 20 - 30 ans, dans la liste des tranches d'age */}
                {vingtTrente && (
                  <>
                    <div onClick={VingtTrente} className="active">
                      <p>20 - 30 ans</p>
                    </div>
                  </>
                )}

                {!vingtTrente && (
                  <>
                    <div onClick={VingtTrente} className="no-active">
                      <p>20 - 30 ans</p>
                    </div>
                  </>
                )}

                {/* 30 - 40 ans */}
                {/* il clique pour choisir 30 - 40 ans, dans la liste des tranches d'age */}
                {trenteQuarante && (
                  <>
                    <div onClick={TrenteQuarante} className="active">
                      <p>30 - 40 ans</p>
                    </div>
                  </>
                )}

                {!trenteQuarante && (
                  <>
                    <div onClick={TrenteQuarante} className="no-active">
                      <p>30 - 40 ans</p>
                    </div>
                  </>
                )}

                {/* 40 - 50 ans */}
                {/* il clique pour choisir 40 - 50 ans, dans la liste des tranches d'age */}
                {quaranteCinquante && (
                  <>
                    <div onClick={QuaranteCinquante} className="active">
                      <p>40 - 50 ans</p>
                    </div>
                  </>
                )}

                {!quaranteCinquante && (
                  <>
                    <div onClick={QuaranteCinquante} className="no-active">
                      <p>40 - 50 ans</p>
                    </div>
                  </>
                )}

                {/* 50 - 60 ans */}
                {/* il clique pour choisir 50 - 60 ans, dans la liste des tranches d'age */}
                {cinquanteSoixante && (
                  <>
                    <div onClick={CinquanteSoixante} className="active">
                      <p>50 - 60 ans</p>
                    </div>
                  </>
                )}

                {!cinquanteSoixante && (
                  <>
                    <div onClick={CinquanteSoixante} className="no-active">
                      <p>50 - 60 ans</p>
                    </div>
                  </>
                )}

                {/* Plus de 60 ans */}
                {/* il clique pour choisir Plus de 60 ans, dans la liste des tranches d'age */}
                {soixantePlus && (
                  <>
                    <div onClick={SoixantePlus} className="active">
                      <p>Plus de 60 ans</p>
                    </div>
                  </>
                )}

                {!soixantePlus && (
                  <>
                    <div onClick={SoixantePlus} className="no-active">
                      <p>Plus de 60 ans</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* selectionner la tranche d'age */}

      {/* selectionner le sexe */}
      {/* selectionner le sexe */}
      {/* quand on clique, une popup va s'ouvrir pour nous permettre de selectionner le sexe */}
      {selectionnerSexe && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={SelectionnerSexe}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Vous cibler les personnes de sexe ?</li>
                </div>
                {/* title */}

                {/* Masculin */}
                {/* il clique pour choisir Masculin, dans la liste des sexes */}
                {masculinPP && (
                  <>
                    <div onClick={MasculinPP} className="active">
                      <p>Masculin</p>
                    </div>
                  </>
                )}

                {!masculinPP && (
                  <>
                    <div onClick={MasculinPP} className="no-active">
                      <p>Masculin</p>
                    </div>
                  </>
                )}

                {/* Féminin */}
                {/* il clique pour choisir Féminin, dans la liste des sexes */}
                {femininPP && (
                  <>
                    <div onClick={FemininPP} className="active">
                      <p>Féminin</p>
                    </div>
                  </>
                )}

                {!femininPP && (
                  <>
                    <div onClick={FemininPP} className="no-active">
                      <p>Féminin</p>
                    </div>
                  </>
                )}

                {/* Trans */}
                {/* il clique pour choisir Trans, dans la liste des sexes */}
                {transPP && (
                  <>
                    <div onClick={TransPP} className="active">
                      <p>Trans</p>
                    </div>
                  </>
                )}

                {!transPP && (
                  <>
                    <div onClick={TransPP} className="no-active">
                      <p>Trans</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* center */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* selectionner le sexe */}


      {/* actualiser page */}
      {/* apres avoir retirer un administrateur, on vient ici pour actualiser la page
     c'est a dire, on fait un appel a l'api pour avoir de nouvelle donnees */}
      {actualiserPage && (
        <>
          <div onClick={ActualiserPage} className="actualiser-page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p onClick={RetirerAdminActualiserPage}>
                      Actualiser la Page
                    </p>
                  </div>

                  <div className="b">
                    <p onClick={PublicationEnAttente}>
                      Publication en attente / rejetée
                    </p>
                  </div>
                  {/* b */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* actualiser-page-opacity */}
        </>
      )}
      {/* actualiser page */}

      {/* publications en attente/rejeté - page */}
      {/* publications en attente/rejeté - page */}
      {/* s'il y'a des publications en attente/rejeté, ca va s'afficher sur cette page */}
      {publicationEnAttente && (
        <>
          <div className="en-attente-opacity">
            {/* dans le cas ou il clique sur publication en attente, par defaut c'est publication en attente */}
            {enAttente && (
              <>
                <div className="block">
                  <div className="display">
                    <div className="back">
                      <svg
                        onClick={BackBtn}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        width="20px"
                        height="10px"
                        cursor="pointer"
                        enableBackground="new 0 0 477.175 477.175"
                        version="1.1"
                        viewBox="0 0 477.175 477.175"
                        xmlSpace="preserve"
                      >
                        <path d="M145.188 238.575l215.5-215.5c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-225.1 225.1c-5.3 5.3-5.3 13.8 0 19.1l225.1 225c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-215.4-215.5z"></path>
                      </svg>
                    </div>
                    {/* back */}

                    <div className="btn">
                      <div className="a">
                        <button onClick={EnAttenteTrue}>En attente</button>
                      </div>

                      <div className="b">
                        <button onClick={RejeterTrue}>Rejetée(s)</button>
                      </div>
                    </div>
                    {/* btn */}
                  </div>
                  {/* display */}
                </div>
                {/* block */}
              </>
            )}

            {/* dans le cas ou il clique sur publication rejeté */}
            {rejeter && (
              <>
                <div className="block">
                  <div className="display">
                    <div className="back">
                      <svg
                        onClick={BackBtn}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        width="20px"
                        height="10px"
                        cursor="pointer"
                        enableBackground="new 0 0 477.175 477.175"
                        version="1.1"
                        viewBox="0 0 477.175 477.175"
                        xmlSpace="preserve"
                      >
                        <path d="M145.188 238.575l215.5-215.5c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-225.1 225.1c-5.3 5.3-5.3 13.8 0 19.1l225.1 225c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-215.4-215.5z"></path>
                      </svg>
                    </div>
                    {/* back */}

                    <div className="btn">
                      <div className="b">
                        <button onClick={EnAttenteTrue}>En attente</button>
                      </div>

                      <div className="a">
                        <button onClick={RejeterTrue}>Rejetée(s)</button>
                      </div>
                    </div>
                    {/* btn */}
                  </div>
                  {/* display */}
                </div>
                {/* block */}
              </>
            )}

            <div className="block-deux">
              {enAttente && (
                <>
                  {/* ici c'est pour le pluriel */}
                  {plusieursPublicationEnAttente && (
                    <>
                      {/* ici c'est dans le cas ou il y'a plusieurs publications en attente de 
                   validation */}
                      {unePublicationEnAttente ? (
                        <>
                          <div className="title">
                            <p>
                              {nbrePublicationEnAttente} publications en attente
                              de validation
                            </p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="title">
                            <p>
                              Il y'a une publication en attente de validation
                            </p>
                          </div>
                        </>
                      )}
                      {/* ce qui est en haut c'est dans le cas ou il y'a 1 publication
                  en attente de validation */}
                    </>
                  )}

                  {/* ici c'est dans le cas ou il n'ya aucune publication en attente de 
                    validation */}
                  {!plusieursPublicationEnAttente && (
                    <>
                      <div className="title">
                        <p>Aucune publication en attente de validation</p>
                      </div>
                    </>
                  )}
                  {/* Aucune publication en attente */}

                  {/* ici on affiche toutes les publications en attente */}
                  {filtreApiPosts.map((api) => (
                    <>
                      <EnfantPublicationEnAttente api={api} />
                    </>
                  ))}
                </>
              )}

              {rejeter && (
                <>
                  {/* ici c'est pour le pluriel */}
                  {plusieursPublicationRejeter && (
                    <>
                      {/* ici c'est dans le cas ou il y'a plusieurs publications rejetées */}
                      {unePublicationRejeter ? (
                        <>
                          <div className="title">
                            <p>
                              {nbrePublicationRejeter} publications rejetées
                            </p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="title">
                            <p>Il y'a une publication rejetée</p>
                          </div>
                        </>
                      )}
                      {/* ce qui est en haut c'est dans le cas ou il y'a 1 publication rejetée */}
                    </>
                  )}

                  {/* ici c'est dans le cas ou il n'ya aucune publication rejetée */}
                  {!plusieursPublicationRejeter && (
                    <>
                      <div className="title">
                        <p>Aucune publication rejetée</p>
                      </div>
                    </>
                  )}
                  {/* Aucune publication rejetée */}

                  {/* ici on affiche toutes les publications rejeter */}
                  {filtreApiPosts.map((api) => (
                    <>
                      <EnfantPublicationRejeter api={api} />
                    </>
                  ))}
                </>
              )}
            </div>
            {/* block-deux */}
          </div>
          {/* en-attente-opacity */}
        </>
      )}
      {/* publications en attente/rejetée - page */}

      {/* backBtn */}
      {/* backBtn - publications en attente/rejetée - page */}
      {/* au niveau de publications en attente/rejeté on a fait que, 
      quand on clique sur le backBtn, on a l'option Retour et l'option Actualiser la page */}
      {backBtn && (
        <>
          <div onClick={BackBtn} className="actualiser-page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p
                      style={{ textDecoration: "underline", color: "#444" }}
                      onClick={PublicationEnAttente}
                    >
                      Retour
                    </p>
                  </div>

                  <div className="b">
                    <p onClick={ActualiserPost}>Actualiser la Page</p>
                  </div>
                  {/* b */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* actualiser-page-opacity */}
        </>
      )}
      {/* backBtn - publications en attente/rejetée - page */}

      {/* ajouter admin */}
      {/* ajouter admin */}
      {/* ajouter un administrateur */}
      {ajouterAdmin && (
        <>
          <div onClick={AjouterAdmin} className="ajouter-admin-opacity">
            <div className="align">
              <div className="card">
                <div className="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="#444"
                    cursor="pointer"
                    viewBox="0 0 1920 1920"
                  >
                    <path
                      fillRule="evenodd"
                      d="M276.941 440.584v565.722c0 422.4 374.174 625.468 674.71 788.668l8.02 4.292 8.131-4.292c300.537-163.2 674.71-366.268 674.71-788.668V440.584l-682.84-321.657L276.94 440.584zm682.73 1479.529c-9.262 0-18.523-2.372-26.993-6.89l-34.9-18.974C588.095 1726.08 164 1495.906 164 1006.306V404.78c0-21.91 12.65-41.788 32.414-51.162L935.727 5.42c15.134-7.228 32.866-7.228 48 0l739.313 348.2c19.765 9.374 32.414 29.252 32.414 51.162v601.525c0 489.6-424.207 719.774-733.779 887.943l-34.899 18.975c-8.47 4.517-17.731 6.889-27.105 6.889zm467.158-547.652h-313.412l-91.595-91.482v-83.803H905.041v-116.78h-83.69l-58.503-58.504c-1.92.113-3.84.113-5.76.113-176.075 0-319.285-143.21-319.285-319.285 0-176.075 143.21-319.398 319.285-319.398 176.075 0 319.285 143.323 319.285 319.398 0 1.92 0 3.84-.113 5.647l350.57 350.682v313.412zm-266.654-112.941h153.713v-153.713L958.462 750.155l3.953-37.27c1.017-123.897-91.595-216.621-205.327-216.621S550.744 588.988 550.744 702.72c0 113.845 92.612 206.344 206.344 206.344l47.21-5.309 63.811 63.7h149.873v116.78h116.781v149.986l25.412 25.299zm-313.4-553.57c0 46.758-37.949 84.706-84.706 84.706-46.758 0-84.706-37.948-84.706-84.706s37.948-84.706 84.706-84.706c46.757 0 84.706 37.948 84.706 84.706"
                    ></path>
                  </svg>
                  <p>Administrateur :</p>
                </div>

                <div className="b">
                  <p onClick={AjouterAdminSupreme}>Suprême</p>
                  <p onClick={AjouterAdminLombda}>Lombda</p>
                </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* ajouter-admin-opacity */}
        </>
      )}
      {/* ajouter un administrateur */}

      {/* page ajouter admin */}
      {/* page ajouter admin */}
      {/* page qui permet d'ajouter un administrateur */}
      {/* on recherche, puis on clique pour ajouter l'administrateur */}
      {pageAjouterAdmin && (
        <>
          <div className="rechercher-admin-opacity">
            <div className="search-app">
              <div className="back">
                <svg
                  onClick={ClosePageAjouterAdmin}
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  width="20px"
                  cursor="pointer"
                  enableBackground="new 0 0 486.975 486.975"
                  version="1.1"
                  viewBox="0 0 486.975 486.975"
                  xmlSpace="preserve"
                >
                  <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                </svg>
              </div>
              {/* back */}

              <div className="input">
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  name="search"
                  type="text"
                />

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  width="20px"
                  cursor="pointer"
                  enableBackground="new 0 0 487.95 487.95"
                  version="1.1"
                  viewBox="0 0 487.95 487.95"
                  xmlSpace="preserve"
                >
                  <path d="M481.8 453l-140-140.1c27.6-33.1 44.2-75.4 44.2-121.6C386 85.9 299.5.2 193.1.2S0 86 0 191.4s86.5 191.1 192.9 191.1c45.2 0 86.8-15.5 119.8-41.4l140.5 140.5c8.2 8.2 20.4 8.2 28.6 0 8.2-8.2 8.2-20.4 0-28.6zM41 191.4c0-82.8 68.2-150.1 151.9-150.1s151.9 67.3 151.9 150.1-68.2 150.1-151.9 150.1S41 274.1 41 191.4z"></path>
                </svg>
              </div>
              {/* input */}
            </div>
            {/* search-app */}

            {/* lorsqu'on lance la recherche et apres on clique sur l'administrateur a ajouter */}
            <div className="margin-top-search-administrateur">
              {compteTrouver.map((api) => (
                <>
                  <EnfantSearchAdministrateur api={api} />
                </>
              ))}
            </div>
            {/* margin-top-search-administrateur */}
          </div>
          {/* rechercher-admin-opacity */}
        </>
      )}
      {/* page ajouter admin */}

      {/* publier Publication - page */}
      {/* publier Publication - page */}
      {publierPublication && (
        <>
          <div className="page-general-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                {deuxPhotosImage2 || troisPhotosImage2 || troisPhotosImage3 ? (
                  <>
                    <div></div>
                  </>
                ) : (
                  <>
                    <svg
                      onClick={PublierPublication}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      version="1.1"
                      viewBox="0 0 40 40"
                      xmlSpace="preserve"
                    >
                      <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                    </svg>
                  </>
                )}
              </div>
              {/* close */}

              <div className="card">
                {/* choisir entre text, image */}
                {/* choisir entre text, image */}
                {/* choisir entre text, image */}
                <div className="display-block-un">
                  {/* ca cava s'afficher si la personne n'a pas cliquer sur text */}
                  {!text && (
                    <>
                      {deuxPhotosImage2 ||
                      troisPhotosImage2 ||
                      troisPhotosImage3 ? (
                        <>
                          <div></div>
                        </>
                      ) : (
                        <>
                          <svg
                            onClick={TextPublierQuelqueChose}
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            cursor="pointer"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke="#ccc"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C13.76 16 14.04 16 14.6 16z"
                            ></path>
                          </svg>
                        </>
                      )}
                    </>
                  )}
                  {/* ceci s'affichera si la personne a cliquer sur text */}
                  {text && (
                    <>
                      {deuxPhotosImage2 ||
                      troisPhotosImage2 ||
                      troisPhotosImage3 ? (
                        <>
                          <div></div>
                        </>
                      ) : (
                        <>
                          <svg
                            style={{ border: "1px solid #a6a6a6" }}
                            onClick={TextPublierQuelqueChose}
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            cursor="pointer"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke="#000"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C13.76 16 14.04 16 14.6 16z"
                            ></path>
                          </svg>
                        </>
                      )}
                    </>
                  )}

                  {/* ca cava s'afficher si la personne n'a pas cliquer sur image */}
                  {!image && (
                    <>
                      {deuxPhotosImage2 ||
                      troisPhotosImage2 ||
                      troisPhotosImage3 ? (
                        <>
                          <div></div>
                        </>
                      ) : (
                        <>
                          <svg
                            onClick={ImagePublierQuelqueChose}
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            cursor="pointer"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="#ccc"
                              fillRule="evenodd"
                              d="M6.205 3h11.59c1.114 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926v7.51l-4.391-4.053a1.5 1.5 0 00-2.265.27l-3.13 4.695-2.303-1.48a1.5 1.5 0 00-1.96.298L3.005 18.15A12.98 12.98 0 013 17.795V6.205c0-1.115.116-1.519.334-1.926.218-.407.538-.727.945-.945C4.686 3.116 5.09 3 6.205 3zm9.477 8.53L21 16.437v1.357c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 01-.945.945c-.407.218-.811.334-1.926.334H6.205c-1.115 0-1.519-.116-1.926-.334a2.305 2.305 0 01-.485-.345L8.2 15.067l2.346 1.508a1.5 1.5 0 002.059-.43l3.077-4.616zM7.988 6C6.878 6 6 6.832 6 7.988 6 9.145 6.879 10 7.988 10 9.121 10 10 9.145 10 7.988 10 6.832 9.121 6 7.988 6z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </>
                      )}
                    </>
                  )}
                  {/* ceci s'affichera si la personne a cliquer sur image */}
                  {image && (
                    <>
                      {deuxPhotosImage2 ||
                      troisPhotosImage2 ||
                      troisPhotosImage3 ? (
                        <>
                          <div></div>
                        </>
                      ) : (
                        <>
                          <svg
                            style={{ border: "1px solid #a6a6a6" }}
                            onClick={ImagePublierQuelqueChose}
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            cursor="pointer"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="#000"
                              fillRule="evenodd"
                              d="M6.205 3h11.59c1.114 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926v7.51l-4.391-4.053a1.5 1.5 0 00-2.265.27l-3.13 4.695-2.303-1.48a1.5 1.5 0 00-1.96.298L3.005 18.15A12.98 12.98 0 013 17.795V6.205c0-1.115.116-1.519.334-1.926.218-.407.538-.727.945-.945C4.686 3.116 5.09 3 6.205 3zm9.477 8.53L21 16.437v1.357c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 01-.945.945c-.407.218-.811.334-1.926.334H6.205c-1.115 0-1.519-.116-1.926-.334a2.305 2.305 0 01-.485-.345L8.2 15.067l2.346 1.508a1.5 1.5 0 002.059-.43l3.077-4.616zM7.988 6C6.878 6 6 6.832 6 7.988 6 9.145 6.879 10 7.988 10 9.121 10 10 9.145 10 7.988 10 6.832 9.121 6 7.988 6z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </>
                      )}
                    </>
                  )}
                </div>
                {/* display-block-un */}
                {/* choisir entre text, image */}

                {/* text */}
                {/* text */}
                {text && (
                  <>
                    <div className="display-block-deux">
                      {/* le block-deux commence ici */}
                      {/* la personne n'a pas encore cliquer sur publication Text, alors on affiche ceci */}
                      {!publicationText && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationText}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16px"
                                cursor="pointer"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke="#00cc00"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C13.76 16 14.04 16 14.6 16z"
                                ></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la pesonne a cliquer sur publication Text, on affiche ceci */}
                      {publicationText && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationText}
                                xmlns="http://www.w3.org/2000/svg"
                                width="27px"
                                cursor="pointer"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke="#00cc00"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C13.76 16 14.04 16 14.6 16z"
                                ></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne n'a pas cliquer sur publication box shadow, on affiche ceci */}
                      {!publicationTextBoxShadow && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationTextBoxShadow}
                                xmlns="http://www.w3.org/2000/svg"
                                width="15px"
                                cursor="pointer"
                                fill="#fcff07"
                                version="1.1"
                                viewBox="0 0 198.439 198.439"
                                xmlSpace="preserve"
                              >
                                <path d="M197.762 169.999L177.324 5.262a5.995 5.995 0 00-6.693-5.215L5.893 20.484a6 6 0 00-5.261 5.955v166a6 6 0 006 6h166a6 6 0 006-6v-14.021l13.915-1.727a6 6 0 005.215-6.692zm-177.326 16.44h-7.805V123.53l7.805 62.909zM13.882 40.181a6.04 6.04 0 00-.546.096l-1.183-9.536 154.915-19.22 1.18 9.509L13.882 40.181zm152.75 146.258h-52.65l52.65-6.532v6.532zm-135.26-.783L14.805 52.124c.184-.006.368-.011.554-.034l154.365-19.151 16.563 133.497-154.915 19.22z"></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne a cliquer sur publication box shadow, on affiche ceci */}
                      {publicationTextBoxShadow && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationTextBoxShadow}
                                xmlns="http://www.w3.org/2000/svg"
                                width="25px"
                                cursor="pointer"
                                fill="#fcff07"
                                version="1.1"
                                viewBox="0 0 198.439 198.439"
                                xmlSpace="preserve"
                              >
                                <path d="M197.762 169.999L177.324 5.262a5.995 5.995 0 00-6.693-5.215L5.893 20.484a6 6 0 00-5.261 5.955v166a6 6 0 006 6h166a6 6 0 006-6v-14.021l13.915-1.727a6 6 0 005.215-6.692zm-177.326 16.44h-7.805V123.53l7.805 62.909zM13.882 40.181a6.04 6.04 0 00-.546.096l-1.183-9.536 154.915-19.22 1.18 9.509L13.882 40.181zm152.75 146.258h-52.65l52.65-6.532v6.532zm-135.26-.783L14.805 52.124c.184-.006.368-.011.554-.034l154.365-19.151 16.563 133.497-154.915 19.22z"></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
                {/* text - publier quelque chose  */}

                {/* image */}
                {/* image */}
                {/* image */}
                {image && (
                  <>
                    <div className="display-block-deux">
                      {/* la personne n'a pas cliquer sur imageUnPhoto, on affiche ceci */}
                      {!publicationImageUnPhoto && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationImageUnPhoto}
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                cursor="pointer"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fd7e14"
                                  fillRule="evenodd"
                                  d="M6.205 3h11.59c1.114 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926v7.51l-4.391-4.053a1.5 1.5 0 00-2.265.27l-3.13 4.695-2.303-1.48a1.5 1.5 0 00-1.96.298L3.005 18.15A12.98 12.98 0 013 17.795V6.205c0-1.115.116-1.519.334-1.926.218-.407.538-.727.945-.945C4.686 3.116 5.09 3 6.205 3zm9.477 8.53L21 16.437v1.357c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 01-.945.945c-.407.218-.811.334-1.926.334H6.205c-1.115 0-1.519-.116-1.926-.334a2.305 2.305 0 01-.485-.345L8.2 15.067l2.346 1.508a1.5 1.5 0 002.059-.43l3.077-4.616zM7.988 6C6.878 6 6 6.832 6 7.988 6 9.145 6.879 10 7.988 10 9.121 10 10 9.145 10 7.988 10 6.832 9.121 6 7.988 6z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne a cliquer sur imageUnPhoto, on affiche ceci */}
                      {publicationImageUnPhoto && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationImageUnPhoto}
                                xmlns="http://www.w3.org/2000/svg"
                                width="35px"
                                cursor="pointer"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="#fd7e14"
                                  fillRule="evenodd"
                                  d="M6.205 3h11.59c1.114 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926v7.51l-4.391-4.053a1.5 1.5 0 00-2.265.27l-3.13 4.695-2.303-1.48a1.5 1.5 0 00-1.96.298L3.005 18.15A12.98 12.98 0 013 17.795V6.205c0-1.115.116-1.519.334-1.926.218-.407.538-.727.945-.945C4.686 3.116 5.09 3 6.205 3zm9.477 8.53L21 16.437v1.357c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 01-.945.945c-.407.218-.811.334-1.926.334H6.205c-1.115 0-1.519-.116-1.926-.334a2.305 2.305 0 01-.485-.345L8.2 15.067l2.346 1.508a1.5 1.5 0 002.059-.43l3.077-4.616zM7.988 6C6.878 6 6 6.832 6 7.988 6 9.145 6.879 10 7.988 10 9.121 10 10 9.145 10 7.988 10 6.832 9.121 6 7.988 6z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne n'a pas cliquer sur imageDeuxPhotos, on affiche ceci */}
                      {!publicationImageDeuxPhotos && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationImageDeuxPhotos}
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                cursor="pointer"
                                fill="#6f42c1"
                                viewBox="0 0 30 30"
                              >
                                <path d="M10.5 5a.495.495 0 00-.207.045L.83 9.35c-.737.335-1.033 1.227-.687 1.945L6.355 24.18c.347.718 1.24 1.07 1.967.664l3.422-1.907c.588-.298.044-1.18-.486-.873L7.834 23.97c-.196.11-.467.01-.58-.224l-.414-.857 1.885-.943c.605-.304.078-1.16-.45-.894l-1.87.935L1.044 10.86a.438.438 0 01.2-.6l9.464-4.305c.485-.222.287-.955-.207-.955zm4.777-1c-.19 0-.377.035-.552.104-.35.137-.648.407-.81.775L8.122 18.15c-.32.737.02 1.61.757 1.93l13.277 5.797c.737.32 1.61-.02 1.93-.757l5.795-13.277a1.475 1.475 0 00-.76-1.93L15.847 4.12a1.43 1.43 0 00-.57-.12zm-.015.994c.06.002.122.016.183.043l13.278 5.795c.244.107.345.37.238.613l-4.82 11.047-14.13-6.166 4.822-11.05a.456.456 0 01.43-.282zM9.61 17.242l14.13 6.168-.572 1.313a.454.454 0 01-.613.24L9.277 19.168a.456.456 0 01-.24-.615zM7.5 16a.487.487 0 00-.475.342l-1 3c-.194.583.733.967.95.316l1-3A.5.5 0 007.5 16zm9-3a.522.522 0 00-.223.053l-4 2c-.596.267-.093 1.19.446.894l3.605-1.802 1.756 2.632a.5.5 0 00.64.17l3.604-1.802 1.756 2.632c.352.547 1.19-.033.832-.554l-2-3a.5.5 0 00-.64-.17l-3.604 1.802-1.756-2.632A.484.484 0 0016.5 13zm.5-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1zM6 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1z"></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne a cliquer sur imageDeuxPhotos, on affiche ceci */}
                      {publicationImageDeuxPhotos && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationImageDeuxPhotos}
                                xmlns="http://www.w3.org/2000/svg"
                                width="35px"
                                cursor="pointer"
                                fill="#6f42c1"
                                viewBox="0 0 30 30"
                              >
                                <path d="M10.5 5a.495.495 0 00-.207.045L.83 9.35c-.737.335-1.033 1.227-.687 1.945L6.355 24.18c.347.718 1.24 1.07 1.967.664l3.422-1.907c.588-.298.044-1.18-.486-.873L7.834 23.97c-.196.11-.467.01-.58-.224l-.414-.857 1.885-.943c.605-.304.078-1.16-.45-.894l-1.87.935L1.044 10.86a.438.438 0 01.2-.6l9.464-4.305c.485-.222.287-.955-.207-.955zm4.777-1c-.19 0-.377.035-.552.104-.35.137-.648.407-.81.775L8.122 18.15c-.32.737.02 1.61.757 1.93l13.277 5.797c.737.32 1.61-.02 1.93-.757l5.795-13.277a1.475 1.475 0 00-.76-1.93L15.847 4.12a1.43 1.43 0 00-.57-.12zm-.015.994c.06.002.122.016.183.043l13.278 5.795c.244.107.345.37.238.613l-4.82 11.047-14.13-6.166 4.822-11.05a.456.456 0 01.43-.282zM9.61 17.242l14.13 6.168-.572 1.313a.454.454 0 01-.613.24L9.277 19.168a.456.456 0 01-.24-.615zM7.5 16a.487.487 0 00-.475.342l-1 3c-.194.583.733.967.95.316l1-3A.5.5 0 007.5 16zm9-3a.522.522 0 00-.223.053l-4 2c-.596.267-.093 1.19.446.894l3.605-1.802 1.756 2.632a.5.5 0 00.64.17l3.604-1.802 1.756 2.632c.352.547 1.19-.033.832-.554l-2-3a.5.5 0 00-.64-.17l-3.604 1.802-1.756-2.632A.484.484 0 0016.5 13zm.5-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1zM6 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1z"></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne n'a pas cliquer sur imageTroisPhotos, on affiche ceci */}
                      {!publicationImageTroisPhotos && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationImageTroisPhotos}
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                cursor="pointer"
                                fill="blue"
                                viewBox="0 0 30 30"
                              >
                                <path d="M19.5 9c-.492-.004-.916.242-1.092.47l-2.737 3.457c-.17.208-.55.073-.727-.03l-2.455-1.547c-.29-.19-.62-.35-.988-.35-.38 0-.786.114-1.072.434l-3.293 3.724c-.445.498.3 1.166.746.668l3.294-3.724c.218-.234.535-.05.765.084l2.46 1.552.012.006c.306.19.65.252.988.256.34.004.71-.027.985-.36l2.767-3.5c.217-.263.534-.14.744.04l2.254 1.688c.527.477 1.205-.375.62-.78l-2.252-1.69C20.252 9.188 19.913 9 19.5 9zm-12 8h15a.499.499 0 110 1h-15a.499.499 0 110-1zM11 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.558 0 1 .442 1 1s-.442 1-1 1-1-.442-1-1 .442-1 1-1zm14 19.5a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zm-19 0a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zm9-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1zM26.5 3c-.665 0-.648 1 0 1h2c.286 0 .5.214.5.5v14c0 .286-.214.5-.5.5h-2c-.654 0-.66 1 0 1h2c.822 0 1.5-.678 1.5-1.5v-14c0-.822-.678-1.5-1.5-1.5zm-25 0C.678 3 0 3.678 0 4.5v14c0 .822.678 1.5 1.5 1.5h2c.66 0 .665-1 0-1h-2a.488.488 0 01-.5-.5v-14c0-.286.214-.5.5-.5h2c.66 0 .66-1 0-1zm5-1C5.678 2 5 2.678 5 3.5v16c0 .822.678 1.5 1.5 1.5h17c.822 0 1.5-.678 1.5-1.5v-16c0-.822-.678-1.5-1.5-1.5zm0 1h17c.286 0 .5.214.5.5v16c0 .286-.214.5-.5.5h-17a.488.488 0 01-.5-.5v-16c0-.286.214-.5.5-.5z"></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                      {/* la personne a cliquer sur imageTroisPhotos, on affiche ceci */}
                      {publicationImageTroisPhotos && (
                        <>
                          {deuxPhotosImage2 ||
                          troisPhotosImage2 ||
                          troisPhotosImage3 ? (
                            <>
                              <div></div>
                            </>
                          ) : (
                            <>
                              <svg
                                onClick={PublicationImageTroisPhotos}
                                xmlns="http://www.w3.org/2000/svg"
                                width="35px"
                                cursor="pointer"
                                fill="blue"
                                viewBox="0 0 30 30"
                              >
                                <path d="M19.5 9c-.492-.004-.916.242-1.092.47l-2.737 3.457c-.17.208-.55.073-.727-.03l-2.455-1.547c-.29-.19-.62-.35-.988-.35-.38 0-.786.114-1.072.434l-3.293 3.724c-.445.498.3 1.166.746.668l3.294-3.724c.218-.234.535-.05.765.084l2.46 1.552.012.006c.306.19.65.252.988.256.34.004.71-.027.985-.36l2.767-3.5c.217-.263.534-.14.744.04l2.254 1.688c.527.477 1.205-.375.62-.78l-2.252-1.69C20.252 9.188 19.913 9 19.5 9zm-12 8h15a.499.499 0 110 1h-15a.499.499 0 110-1zM11 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.558 0 1 .442 1 1s-.442 1-1 1-1-.442-1-1 .442-1 1-1zm14 19.5a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zm-19 0a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zm9-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1zM26.5 3c-.665 0-.648 1 0 1h2c.286 0 .5.214.5.5v14c0 .286-.214.5-.5.5h-2c-.654 0-.66 1 0 1h2c.822 0 1.5-.678 1.5-1.5v-14c0-.822-.678-1.5-1.5-1.5zm-25 0C.678 3 0 3.678 0 4.5v14c0 .822.678 1.5 1.5 1.5h2c.66 0 .665-1 0-1h-2a.488.488 0 01-.5-.5v-14c0-.286.214-.5.5-.5h2c.66 0 .66-1 0-1zm5-1C5.678 2 5 2.678 5 3.5v16c0 .822.678 1.5 1.5 1.5h17c.822 0 1.5-.678 1.5-1.5v-16c0-.822-.678-1.5-1.5-1.5zm0 1h17c.286 0 .5.214.5.5v16c0 .286-.214.5-.5.5h-17a.488.488 0 01-.5-.5v-16c0-.286.214-.5.5-.5z"></path>
                              </svg>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    {/* display-block-deux */}
                  </>
                )}
                {/* le block-deux ca s'arrete ici, */}

                {/* maintenant on affiche le contenu de chaque chose */}
                {/* ca c'est le contenu pour publication Text */}
                {/* publication Text */}
                {/* publication Text */}
                {/* publication Text */}
                {publicationText && (
                  <>
                    <div className="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C13.76 16 14.04 16 14.6 16z"
                        ></path>
                      </svg>
                    </div>

                    <div className="center">
                      <p
                        style={{
                          fontSize: "17px",
                          paddingBottom: "16px",
                          paddingTop: "5px",
                          textAlign: "center",
                        }}
                      >
                        Publier quelque chose..
                      </p>
                    </div>

                    <div className="capture-decran-du-contact">
                      <div className="display">
                        <textarea
                          name="description"
                          placeholder="Dites quelque chose.."
                          value={descriptionTextBtn}
                          onChange={(e) =>
                            setDescriptionTextBtn(e.target.value)
                          }
                        ></textarea>
                      </div>
                      {/* display */}
                    </div>
                    {/* capture-decran-du-contact */}

                    <div style={{ paddingTop: "10px" }} className="hr">
                      <hr />
                    </div>

                    {isLoading ? (
                      <div className="loader-display-flex">
                        <Loader />
                      </div>
                    ) : (
                      <>
                      {dev && (<>
                        <div className="vert-btn">
                          <button onClick={PublierTextBtn}>Continuer</button>
                        </div></>)}
                        {/* center */}
                      </>
                    )}
                  </>
                )}
                {/* publication Text */}

                {/* ca c'est le contenu pour publication Text Box Shadow */}
                {/* publication Text Box Shadow */}
                {/* publication Text Box Shadow */}
                {/* publication Text Box Shadow */}
                {publicationTextBoxShadow && (
                  <>
                    <div className="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="35px"
                        fill="#000"
                        version="1.1"
                        viewBox="0 0 198.439 198.439"
                        xmlSpace="preserve"
                      >
                        <path d="M197.762 169.999L177.324 5.262a5.995 5.995 0 00-6.693-5.215L5.893 20.484a6 6 0 00-5.261 5.955v166a6 6 0 006 6h166a6 6 0 006-6v-14.021l13.915-1.727a6 6 0 005.215-6.692zm-177.326 16.44h-7.805V123.53l7.805 62.909zM13.882 40.181a6.04 6.04 0 00-.546.096l-1.183-9.536 154.915-19.22 1.18 9.509L13.882 40.181zm152.75 146.258h-52.65l52.65-6.532v6.532zm-135.26-.783L14.805 52.124c.184-.006.368-.011.554-.034l154.365-19.151 16.563 133.497-154.915 19.22z"></path>
                      </svg>
                    </div>

                    <div className="center">
                      <p
                        style={{
                          fontSize: "17px",
                          paddingBottom: "16px",
                          paddingTop: "5px",
                          textAlign: "center",
                        }}
                      >
                        Publier quelque chose..
                      </p>
                    </div>

                    <div className="capture-decran-du-contact">
                      <div className="display">
                        <textarea
                          name="description"
                          placeholder="Dites quelque chose.."
                          value={descriptionBoxShadow}
                          onChange={(e) =>
                            setDescriptionBoxShadow(e.target.value)
                          }
                        ></textarea>
                      </div>
                      {/* display */}
                    </div>
                    {/* capture-decran-du-contact */}

                    <div style={{ paddingTop: "10px" }} className="hr">
                      <hr />
                    </div>

                    {isLoading ? (
                      <div className="loader-display-flex">
                        <Loader />
                      </div>
                    ) : (
                      <>
                      {dev && (<>
                        <div className="yellow-btn">
                          <button onClick={PublierBoxShadow}>Continuer</button>
                        </div></>)}
                        {/* center */}
                      </>
                    )}
                  </>
                )}
                {/* publication Text Box Shadow */}


                {/* ajouter une image au favoris - AA */}
                {publicationImageUnPhoto && (<>
                    <div className="center"> <SvgOneImage3 /> </div>
                    <div className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px", textAlign: "center" }}>Publier quelque chose..</p> </div>

                    <div className="capture-decran-du-contact">
                      <div className="display"> <input onChange={(e) => setFilePhotoAA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
                    </div>

                    <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

                    {isLoading ? (
                      <div className="loader-display-flex"> <Loader /> </div>
                    ) : (
                      <><div className="orange-btn"> <button>Continuer</button> </div></>)}

                </>)}
                

                {/* ca c'est le contenu pour Image Deux Photos */}
                {/* publication Image Deux Photos */}
                {/* publication Image Deux Photos */}
                {/* publication Image Deux Photos */}
                {publicationImageDeuxPhotos && (
                  <>
                    <div className="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45px"
                        viewBox="0 0 30 30"
                      >
                        <path d="M10.5 5a.495.495 0 00-.207.045L.83 9.35c-.737.335-1.033 1.227-.687 1.945L6.355 24.18c.347.718 1.24 1.07 1.967.664l3.422-1.907c.588-.298.044-1.18-.486-.873L7.834 23.97c-.196.11-.467.01-.58-.224l-.414-.857 1.885-.943c.605-.304.078-1.16-.45-.894l-1.87.935L1.044 10.86a.438.438 0 01.2-.6l9.464-4.305c.485-.222.287-.955-.207-.955zm4.777-1c-.19 0-.377.035-.552.104-.35.137-.648.407-.81.775L8.122 18.15c-.32.737.02 1.61.757 1.93l13.277 5.797c.737.32 1.61-.02 1.93-.757l5.795-13.277a1.475 1.475 0 00-.76-1.93L15.847 4.12a1.43 1.43 0 00-.57-.12zm-.015.994c.06.002.122.016.183.043l13.278 5.795c.244.107.345.37.238.613l-4.82 11.047-14.13-6.166 4.822-11.05a.456.456 0 01.43-.282zM9.61 17.242l14.13 6.168-.572 1.313a.454.454 0 01-.613.24L9.277 19.168a.456.456 0 01-.24-.615zM7.5 16a.487.487 0 00-.475.342l-1 3c-.194.583.733.967.95.316l1-3A.5.5 0 007.5 16zm9-3a.522.522 0 00-.223.053l-4 2c-.596.267-.093 1.19.446.894l3.605-1.802 1.756 2.632a.5.5 0 00.64.17l3.604-1.802 1.756 2.632c.352.547 1.19-.033.832-.554l-2-3a.5.5 0 00-.64-.17l-3.604 1.802-1.756-2.632A.484.484 0 0016.5 13zm.5-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1zM6 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1z"></path>
                      </svg>
                    </div>

                    <div className="center">
                      <p
                        style={{
                          fontSize: "17px",
                          paddingBottom: "16px",
                          paddingTop: "5px",
                          textAlign: "center",
                        }}
                      >
                        Publier quelque chose..
                      </p>
                    </div>

                    {/* enregistrer-image1 */}
                    {/* enregistrer-image1 */}
                    {deuxPhotosImage1 && (
                      <>
                        <div className="deux-photos-enregistrer-image1">
                          <p>image 1</p>
                        </div>
                      </>
                    )}
                    {/* enregistrer-image1 */}

                    {/* enregistrer-image2 */}
                    {/* enregistrer-image2 */}
                    {deuxPhotosImage2 && (
                      <>
                        <div className="deux-photos-enregistrer-image2">
                          <p>image 2</p>
                        </div>
                      </>
                    )}
                    {/* enregistrer-image2 */}

                    {deuxPhotosImage1 && (
                      <>
                        <div className="capture-decran-du-contact">
                          <div className="display">
                            <input
                              onChange={(e) =>
                                setFileDeuxPhotosImage1(e.target.files[0])
                              }
                              id="file"
                              type="file"
                              name="image"
                              accept=".jpg, .jpeg, .png"
                            />
                          </div>
                          {/* display */}
                        </div>
                        {/* capture-decran-du-contact */}
                      </>
                    )}

                    {deuxPhotosImage2 && (
                      <>
                        <div className="capture-decran-du-contact">
                          <div className="display">
                            <input
                              onChange={(e) =>
                                setFileDeuxPhotosImage2(e.target.files[0])
                              }
                              id="file"
                              type="file"
                              name="image"
                              accept=".jpg, .jpeg, .png"
                            />
                          </div>
                          {/* display */}
                        </div>
                        {/* capture-decran-du-contact */}
                      </>
                    )}

                    <div style={{ paddingTop: "10px" }} className="hr">
                      <hr />
                    </div>

                    {isLoading ? (
                      <div className="loader-display-flex">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <div className="violet-btn">
                          {deuxPhotosImage1 && (
                            <>
                            {dev && (<>
                              <button onClick={DeuxPhotosImage1}>
                                Continuer
                              </button></>)}
                            </>
                          )}

                          {deuxPhotosImage2 && (
                            <>
                              <button onClick={DeuxPhotosImage2}>
                                Continuer
                              </button>
                            </>
                          )}
                        </div>
                        {/* violet */}
                      </>
                    )}
                  </>
                )}
                {/* publication Image Deux Photos */}

                {/* ca c'est le contenu pour Image Trois Photos */}
                {/* publication Image Trois Photos */}
                {/* publication Image Trois Photos */}
                {/* publication Image Trois Photos */}
                {publicationImageTroisPhotos && (
                  <>
                    <div className="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45px"
                        viewBox="0 0 30 30"
                      >
                        <path d="M19.5 9c-.492-.004-.916.242-1.092.47l-2.737 3.457c-.17.208-.55.073-.727-.03l-2.455-1.547c-.29-.19-.62-.35-.988-.35-.38 0-.786.114-1.072.434l-3.293 3.724c-.445.498.3 1.166.746.668l3.294-3.724c.218-.234.535-.05.765.084l2.46 1.552.012.006c.306.19.65.252.988.256.34.004.71-.027.985-.36l2.767-3.5c.217-.263.534-.14.744.04l2.254 1.688c.527.477 1.205-.375.62-.78l-2.252-1.69C20.252 9.188 19.913 9 19.5 9zm-12 8h15a.499.499 0 110 1h-15a.499.499 0 110-1zM11 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.558 0 1 .442 1 1s-.442 1-1 1-1-.442-1-1 .442-1 1-1zm14 19.5a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zm-19 0a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zm9-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.563 0 1 .437 1 1s-.437 1-1 1-1-.437-1-1 .437-1 1-1zM26.5 3c-.665 0-.648 1 0 1h2c.286 0 .5.214.5.5v14c0 .286-.214.5-.5.5h-2c-.654 0-.66 1 0 1h2c.822 0 1.5-.678 1.5-1.5v-14c0-.822-.678-1.5-1.5-1.5zm-25 0C.678 3 0 3.678 0 4.5v14c0 .822.678 1.5 1.5 1.5h2c.66 0 .665-1 0-1h-2a.488.488 0 01-.5-.5v-14c0-.286.214-.5.5-.5h2c.66 0 .66-1 0-1zm5-1C5.678 2 5 2.678 5 3.5v16c0 .822.678 1.5 1.5 1.5h17c.822 0 1.5-.678 1.5-1.5v-16c0-.822-.678-1.5-1.5-1.5zm0 1h17c.286 0 .5.214.5.5v16c0 .286-.214.5-.5.5h-17a.488.488 0 01-.5-.5v-16c0-.286.214-.5.5-.5z"></path>
                      </svg>
                    </div>

                    <div className="center">
                      <p
                        style={{
                          fontSize: "17px",
                          paddingBottom: "16px",
                          paddingTop: "5px",
                          textAlign: "center",
                        }}
                      >
                        Publier quelque chose..
                      </p>
                    </div>

                    {/* enregistrer-image1 */}
                    {/* enregistrer-image1 */}
                    {/* enregistrer-image1 */}
                    {troisPhotosImage1 && (
                      <>
                        <div className="trois-photos-enregistrer-image1">
                          <p>image 1</p>
                        </div>
                      </>
                    )}
                    {/* enregistrer-image1 */}

                    {/* enregistrer-image2 */}
                    {/* enregistrer-image2 */}
                    {/* enregistrer-image2 */}
                    {troisPhotosImage2 && (
                      <>
                        <div className="trois-photos-enregistrer-image2">
                          <p>image 2</p>
                        </div>
                      </>
                    )}
                    {/* enregistrer-image2 */}

                    {/* enregistrer-image3 */}
                    {/* enregistrer-image3 */}
                    {/* enregistrer-image3 */}
                    {troisPhotosImage3 && (
                      <>
                        <div className="trois-photos-enregistrer-image3">
                          <p>image 3</p>
                        </div>
                      </>
                    )}
                    {/* enregistrer-image3 */}

                    {troisPhotosImage1 && (
                      <>
                        <div className="capture-decran-du-contact">
                          <div className="display">
                            <input
                              onChange={(e) =>
                                setFileTroisPhotosImage1(e.target.files[0])
                              }
                              id="file"
                              type="file"
                              name="image"
                              accept=".jpg, .jpeg, .png"
                            />
                          </div>
                          {/* display */}
                        </div>
                        {/* capture-decran-du-contact */}
                      </>
                    )}

                    {troisPhotosImage2 && (
                      <>
                        <div className="capture-decran-du-contact">
                          <div className="display">
                            <input
                              onChange={(e) =>
                                setFileTroisPhotosImage2(e.target.files[0])
                              }
                              id="file"
                              type="file"
                              name="image"
                              accept=".jpg, .jpeg, .png"
                            />
                          </div>
                          {/* display */}
                        </div>
                        {/* capture-decran-du-contact */}
                      </>
                    )}

                    {troisPhotosImage3 && (
                      <>
                        <div className="capture-decran-du-contact">
                          <div className="display">
                            <input
                              onChange={(e) =>
                                setFileTroisPhotosImage3(e.target.files[0])
                              }
                              id="file"
                              type="file"
                              name="image"
                              accept=".jpg, .jpeg, .png"
                            />
                          </div>
                          {/* display */}
                        </div>
                        {/* capture-decran-du-contact */}
                      </>
                    )}

                    <div style={{ paddingTop: "10px" }} className="hr">
                      <hr />
                    </div>

                    {isLoading ? (
                      <div className="loader-display-flex">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <div className="blue-btn">
                          {troisPhotosImage1 && (
                            <>
                              {dev && (<>
                              <button onClick={TroisPhotosImage1}>
                                Continuer
                              </button> </>)}
                            </>
                          )}

                          {troisPhotosImage2 && (
                            <>
                              <button onClick={TroisPhotosImage2}>
                                Continuer
                              </button>
                            </>
                          )}

                          {troisPhotosImage3 && (
                            <>
                              <button onClick={TroisPhotosImage3}>
                                Continuer
                              </button>
                            </>
                          )}
                        </div>
                        {/* center */}
                      </>
                    )}
                  </>
                )}
                {/* Trois Photos */}
                {/* bon!, le contenu de Image Trois Photos s'arretent ici */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* add-your-contact-opacity */}
        </>
      )}
      {/* page - publier Publication */}


     


      {/* compte lier */}
      {/* compte lier */}
      {/* compte lier */}
      {/* compte lier */}
      {/* compte lier */}
      {compteLier && (
        <>
          <div onClick={CompteLier} className="popup-logout-opacity">
            <div className="align">
              <div className="card">
                <div style={{ marginBottom: "30px" }} className="title-logout">
                  <div className="display">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30px"
                      fill="none"
                      cursor="pointer"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#6f42c1"
                        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2zM8.18 16.77h-.07c-.97-.09-1.88-.54-2.56-1.26-1.6-1.68-1.6-4.41 0-6.09l2.19-2.3a4.05 4.05 0 012.95-1.28c1.12 0 2.17.45 2.95 1.28 1.6 1.68 1.6 4.41 0 6.09l-1.09 1.15c-.29.3-.76.31-1.06.03a.755.755 0 01-.03-1.06l1.09-1.15c1.06-1.11 1.06-2.92 0-4.02-.99-1.04-2.73-1.04-3.73 0l-2.19 2.3c-1.06 1.11-1.06 2.92 0 4.02.43.46 1.01.74 1.62.8.41.04.71.41.67.82a.74.74 0 01-.74.67zm10.27-2.18l-2.19 2.3a4.05 4.05 0 01-2.95 1.28c-1.12 0-2.17-.45-2.95-1.28-1.6-1.68-1.6-4.41 0-6.09l1.09-1.15c.29-.3.76-.31 1.06-.03.3.29.31.76.03 1.06l-1.09 1.15c-1.06 1.11-1.06 2.92 0 4.02.99 1.04 2.73 1.05 3.73 0l2.19-2.3c1.06-1.11 1.06-2.92 0-4.02-.43-.46-1.01-.74-1.62-.8a.75.75 0 01-.67-.82c.04-.41.4-.72.82-.67.97.1 1.88.54 2.56 1.26 1.59 1.67 1.59 4.41-.01 6.09z"
                      ></path>
                    </svg>

                    <p>Compte Lier</p>
                  </div>
                  {/* display */}
                </div>
                {/* title logout */}

                {verifyCompteLier > 0 ? (
                  <>
                    <div className="a">
                      <img
                        onClick={DelierCompteOmisify}
                        src={izocashLogo}
                        alt=""
                      />

                      <p
                        onClick={DelierCompteOmisify}
                        style={{ cursor: "pointer", color: "#551a8b" }}
                      >
                        Atakidja Ines Magalie
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="a">
                      <img
                        onClick={CompteLierOmisifyPopupHelp}
                        src={izocashLogo}
                        alt=""
                      />

                      <p
                        onClick={CompteLierOmisifyPopupHelp}
                        style={{ paddingRight: "3px", cursor: "pointer" }}
                      >
                        Omisify
                      </p>

                      <svg
                        onClick={CompteLierOmisifyPopupHelp}
                        style={{ paddingTop: "3px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        width="10px"
                        cursor="pointer"
                        fill="#a6a6a6"
                        enableBackground="new 0 0 477.175 477.175"
                        version="1.1"
                        viewBox="0 0 477.175 477.175"
                        xmlSpace="preserve"
                      >
                        <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                      </svg>
                    </div>
                    {/* a */}
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
        </>
      )}
      {/* compte lier */}

      {/* delier Compte Omisify */}
      {/* delier Compte Omisify */}
      {/* delier Compte Omisify */}
      {/* delier Compte Omisify */}
      {delierCompteOmisify && (
        <>
          <div onClick={DelierCompteOmisify} className="popup-logout-opacity">
            <div className="align">
              <div className="card">
                <div className="logout">
                  <p>
                    Souhaitez-vous délier votre compte Omisify de votre compte
                    Alrani?
                  </p>

                  <div className="button">
                    <div className="yes">
                      <button onClick={Delier}>Oui</button>
                    </div>

                    <div className="no">
                      <NavLink to="/">
                        <button>Non</button>
                      </NavLink>
                    </div>
                  </div>
                  {/* button */}
                </div>
                {/* logout */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
        </>
      )}

      {/* compte lier omisify popup help */}
      {/* compte lier omisify popup help */}
      {/* compte lier omisify popup help */}
      {/* compte lier omisify popup help */}
      {compteLierOmisifyPopupHelp && (
        <>
          <div
            onClick={CompteLierOmisifyPopupHelp}
            className="popup-logout-opacity"
          >
            <div className="align">
              <div className="card">
                <p>
                  Pour lier votre compte Omisify à votre compte Alrani, allez
                  sur{" "}
                  <a
                    style={{ color: "blue", paddingRight: "3px" }}
                    href="https://omisify.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Omisify.com
                  </a>
                  , au niveau des paramètres de votre compte Omisify, suivez les
                  instructions qui vous permettrons de lier votre compte Omisify
                  à votre compte Alrani
                </p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
        </>
      )}
      {/* compte lier omisify popup help */}

      {informationPersonnelle && (
        <>
          <div
            onClick={InformationPersonnelle}
            className="popup-logout-opacity"
          >
            <div className="align">
              <div className="card">
                <div style={{ marginBottom: "13px" }} className="title-logout">
                  <div className="display">
                    <svg
                      style={{ paddingRight: "3px" }}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      width="30px"
                      enableBackground="new 0 0 496.158 496.158"
                      version="1.1"
                      viewBox="0 0 496.158 496.158"
                      xmlSpace="preserve"
                    >
                      <path
                        fill="#fd7e14"
                        d="M496.158 248.085C496.158 111.063 385.089.003 248.083.003 111.07.003 0 111.063 0 248.085c0 137.001 111.07 248.07 248.083 248.07 137.006 0 248.075-111.069 248.075-248.07z"
                      ></path>
                      <g fill="#FFF">
                        <path d="M315.249 359.555a5.002 5.002 0 00-6.27-1.702c-24.582 11.637-52.482 23.94-57.958 25.015a4.83 4.83 0 01-.644-.737c-.742-1.005-1.103-2.318-1.103-4.015 0-13.905 10.495-56.205 31.192-125.719 17.451-58.406 19.469-70.499 19.469-74.514 0-6.198-2.373-11.435-6.865-15.146-4.267-3.519-10.229-5.302-17.719-5.302-12.459 0-26.899 4.73-44.146 14.461-16.713 9.433-35.352 25.41-55.396 47.487a5.002 5.002 0 005.591 7.992c7.037-2.872 42.402-17.359 47.557-20.597 4.221-2.646 7.875-3.989 10.861-3.989.107 0 .199.004.276.01.036.198.07.5.07.933 0 3.047-.627 6.654-1.856 10.703-30.136 97.641-44.785 157.498-44.785 182.994 0 8.998 2.501 16.242 7.432 21.528 5.025 5.393 11.803 8.127 20.146 8.127 8.891 0 19.712-3.714 33.08-11.354 12.936-7.392 32.68-23.653 60.363-49.717a4.998 4.998 0 00.705-6.458zM314.282 76.672c-4.925-5.041-11.227-7.597-18.729-7.597-9.34 0-17.475 3.691-24.176 10.971-6.594 7.16-9.938 15.946-9.938 26.113 0 8.033 2.463 14.69 7.32 19.785 4.922 5.172 11.139 7.794 18.476 7.794 8.958 0 17.049-3.898 24.047-11.586 6.876-7.553 10.363-16.433 10.363-26.393.001-7.654-2.476-14.075-7.363-19.087z"></path>
                      </g>
                    </svg>
                    <p>Informations Personnelles</p>
                  </div>
                  {/* display */}
                </div>
                {/* title logout */}

                <div className="couvrir-block">
                  <div className="block">
                    <div className="a">
                      <p onClick={Nom}>Noms :</p>
                    </div>
                    {/* a */}

                    <div className="b">
                      <p onClick={Nom}>{namePersonConnectedAA}</p>
                    </div>
                    {/* b */}
                  </div>
                  {/* block */}

                  {genrePersonneConnecter ? (
                    <>
                      {/* ca c'est dans le cas ou la personne a mis son genre */}
                      {/* homme */}
                      {/* homme */}
                      {genrePersonneConnecter === "1" && (
                        <>
                          <div className="block">
                            <div className="a">
                              <p onClick={Genre}>Genre :</p>
                            </div>
                            {/* a */}

                            <div className="b">
                              <p onClick={Genre}>Homme</p>
                            </div>
                            {/* b */}
                          </div>
                          {/* block */}
                        </>
                      )}

                      {/* femme */}
                      {/* femme */}
                      {genrePersonneConnecter === "2" && (
                        <>
                          <div className="block">
                            <div className="a">
                              <p onClick={Genre}>Genre :</p>
                            </div>
                            {/* a */}

                            <div className="b">
                              <p onClick={Genre}>Femme</p>
                            </div>
                            {/* b */}
                          </div>
                          {/* block */}
                        </>
                      )}

                      {/* trans */}
                      {/* trans */}
                      {genrePersonneConnecter === "3" && (
                        <>
                          <div className="block">
                            <div className="a">
                              <p onClick={Genre}>Genre :</p>
                            </div>
                            {/* a */}

                            <div className="b">
                              <p onClick={Genre}>Trans</p>
                            </div>
                            {/* b */}
                          </div>
                          {/* block */}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {/* ca c'est dans le cas ou la personne n'a pas mis son genre */}

                      <div className="block">
                        <div className="a">
                          <p onClick={Genre}>Genre :</p>
                        </div>
                        {/* a */}

                        <div className="b">
                          <p onClick={Genre}>...</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block */}
                    </>
                  )}

                  {agePersonneConnecter ? (
                    <>
                      {/* si la personne a mis son age, on affiche ca */}
                      <div style={{ marginBottom: "10px" }} className="block">
                        <div className="a">
                          <p onClick={Age}>Age :</p>
                        </div>
                        {/* a */}

                        <div className="b">
                          <p onClick={Age}>{agePersonneConnecter} ans</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block */}
                    </>
                  ) : (
                    <>
                      {/* si la personne n'a pas mis son age, on affiche ca */}
                      <div style={{ marginBottom: "10px" }} className="block">
                        <div className="a">
                          <p onClick={Age}>Age :</p>
                        </div>
                        {/* a */}

                        <div className="b">
                          <p onClick={Age}>...</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block */}
                    </>
                  )}

                  {/* Afghanistan */}
                  {/* Afghanistan */}
                  {paysPersonneConnecter === "1" && (
                    <>
                      <p>Pays de connexion : Afghanistan</p>
                    </>
                  )}

                  {/* Afrique du Sud */}
                  {/* Afrique du Sud */}
                  {paysPersonneConnecter === "2" && (
                    <>
                      <p>Pays de connexion : Afrique du Sud</p>
                    </>
                  )}

                  {/* Albanie */}
                  {/* Albanie */}
                  {paysPersonneConnecter === "3" && (
                    <>
                      <p>Pays de connexion : Albanie</p>
                    </>
                  )}

                  {/* Algérie */}
                  {/* Algérie */}
                  {paysPersonneConnecter === "4" && (
                    <>
                      <p>Pays de connexion : Algérie</p>
                    </>
                  )}

                  {/* Allemagne */}
                  {/* Allemagne */}
                  {paysPersonneConnecter === "5" && (
                    <>
                      <p>Pays de connexion : Allemagne</p>
                    </>
                  )}

                  {/* Andorre */}
                  {/* Andorre */}
                  {paysPersonneConnecter === "6" && (
                    <>
                      <p>Pays de connexion : Andorre</p>
                    </>
                  )}

                  {/* Angola */}
                  {/* Angola */}
                  {paysPersonneConnecter === "7" && (
                    <>
                      <p>Pays de connexion : Angola</p>
                    </>
                  )}

                  {/* Antigua-et-Barbuda */}
                  {/* Antigua-et-Barbuda */}
                  {paysPersonneConnecter === "8" && (
                    <>
                      <p>Pays de connexion : Antigua-et-Barbuda</p>
                    </>
                  )}

                  {/* Arabie Saoudite */}
                  {/* Arabie Saoudite */}
                  {paysPersonneConnecter === "9" && (
                    <>
                      <p>Pays de connexion : Arabie Saoudite</p>
                    </>
                  )}

                  {/* Argentine */}
                  {/* Argentine */}
                  {paysPersonneConnecter === "10" && (
                    <>
                      <p>Pays de connexion : Argentine</p>
                    </>
                  )}

                  {/* Arménie */}
                  {/* Arménie */}
                  {paysPersonneConnecter === "11" && (
                    <>
                      <p>Pays de connexion : Arménie</p>
                    </>
                  )}

                  {/* Australie */}
                  {/* Australie */}
                  {paysPersonneConnecter === "12" && (
                    <>
                      <p>Pays de connexion : Australie</p>
                    </>
                  )}

                  {/* Autriche */}
                  {/* Autriche */}
                  {paysPersonneConnecter === "13" && (
                    <>
                      <p>Pays de connexion : Autriche</p>
                    </>
                  )}

                  {/* Azerbaïdjan */}
                  {/* Azerbaïdjan */}
                  {paysPersonneConnecter === "14" && (
                    <>
                      <p>Pays de connexion : Azerbaïdjan</p>
                    </>
                  )}

                  {/* Bahamas */}
                  {/* Bahamas */}
                  {paysPersonneConnecter === "15" && (
                    <>
                      <p>Pays de connexion : Bahamas</p>
                    </>
                  )}

                  {/* Bahreïn */}
                  {/* Bahreïn */}
                  {paysPersonneConnecter === "16" && (
                    <>
                      <p>Pays de connexion : Bahreïn</p>
                    </>
                  )}

                  {/* Bangladesh */}
                  {/* Bangladesh */}
                  {paysPersonneConnecter === "17" && (
                    <>
                      <p>Pays de connexion : Bangladesh</p>
                    </>
                  )}

                  {/* Barbade */}
                  {/* Barbade */}
                  {paysPersonneConnecter === "18" && (
                    <>
                      <p>Pays de connexion : Barbade</p>
                    </>
                  )}

                  {/* Belgique */}
                  {/* Belgique */}
                  {paysPersonneConnecter === "19" && (
                    <>
                      <p>Pays de connexion : Belgique</p>
                    </>
                  )}

                  {/* Belize */}
                  {/* Belize */}
                  {paysPersonneConnecter === "20" && (
                    <>
                      <p>Pays de connexion : Belize</p>
                    </>
                  )}

                  {/* Congo */}
                  {/* Congo */}
                  {paysPersonneConnecter === "50" && (
                    <>
                      <p>Pays de connexion : Congo</p>
                    </>
                  )}

                  {/* Guinee equatoriale */}
                  {/* Guinee equatoriale */}
                  {paysPersonneConnecter === "100" && (
                    <>
                      <p>Pays de connexion : Guinée Équatoriale</p>
                    </>
                  )}

                  {paysPersonneConnecter > 0 ? (
                    <>
                      <i
                        onClick={Country}
                        style={{
                          color: "blue",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        Changer le Pays de connexion
                      </i>
                    </>
                  ) : (
                    <>
                      <i
                        onClick={Country}
                        style={{
                          color: "blue",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        Choisir le Pays de connexion
                      </i>
                    </>
                  )}
                </div>
                {/* couvrir block */}
              </div>
            </div>
          </div>
        </>
      )}

      {/* country */}
      {/* country */}
      {/* country */}
      {/* country */}
      {/* country */}
      {/* country */}
      {/* country */}
      {country && (
        <>
          <div className="page-general-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={Country}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="center">
                  <p>Choix du Pays</p>
                </div>
                {/* center */}

                {afghanistan && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Afghanistan</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {afriqueDuSud && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Afrique du Sud</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {albanie && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Albanie</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {algerie && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Algérie</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {allemagne && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Allemagne</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {andorre && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Andorre</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {angola && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Angola</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {antigua && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Antigua-et-Barbuda</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {arabie && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Arabie Saoudite</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {argentine && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Argentine</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {armenie && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Arménie</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {australie && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Australie</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {autriche && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Autriche</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {azerbaidjan && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Azerbaïdjan</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {bahamas && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Bahamas</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {bahrein && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Bahreïn</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {bangladesh && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Bangladesh</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {barbade && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Barbade</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {belgique && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Belgique</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {belize && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Belize</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {congo && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Congo</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {guineeE && (
                  <>
                    <div className="genre">
                      <p onClick={PopupCountry}>Guinée Equatoriale</p>
                      <svg
                        onClick={PopupCountry}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}
                <div style={{ paddingTop: "10px" }} className="hr">
                  <hr />
                </div>

                <div className="center">
                  <button onClick={ModifierPays}>Enregistrer</button>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* add-your-contact-opacity */}
        </>
      )}
      {/* country */}

      {/* popup country */}
      {/* popup country */}
      {popupCountry && (
        <>
          <div className="popup-genre-opacity">
            <div className="center">
              <div className="close">
                <p></p>
                <svg
                  onClick={PopupCountry}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Liste des Pays</li>
                </div>
                {/* title */}

                {/* Afghanistan */}
                {/* Afghanistan */}
                {afghanistan && (
                  <>
                    <div onClick={Afghanistan} className="active">
                      <p>Afghanistan</p>
                    </div>
                  </>
                )}

                {!afghanistan && (
                  <>
                    <div onClick={Afghanistan} className="no-active">
                      <p>Afghanistan</p>
                    </div>
                  </>
                )}

                {/* Afrique Du Sud */}
                {/* Afrique Du Sud */}
                {afriqueDuSud && (
                  <>
                    <div onClick={AfriqueDuSud} className="active">
                      <p>Afrique du Sud</p>
                    </div>
                  </>
                )}

                {!afriqueDuSud && (
                  <>
                    <div onClick={AfriqueDuSud} className="no-active">
                      <p>Afrique du Sud</p>
                    </div>
                  </>
                )}

                {/* Albanie */}
                {/* Albanie */}
                {albanie && (
                  <>
                    <div onClick={Albanie} className="active">
                      <p>Albanie</p>
                    </div>
                  </>
                )}

                {!albanie && (
                  <>
                    <div onClick={Albanie} className="no-active">
                      <p>Albanie</p>
                    </div>
                  </>
                )}

                {/* Algerie */}
                {/* Algerie */}
                {algerie && (
                  <>
                    <div onClick={Algerie} className="active">
                      <p>Algérie</p>
                    </div>
                  </>
                )}

                {!algerie && (
                  <>
                    <div onClick={Algerie} className="no-active">
                      <p>Algérie</p>
                    </div>
                  </>
                )}

                {/* Allemagne */}
                {/* Allemagne */}
                {allemagne && (
                  <>
                    <div onClick={Allemagne} className="active">
                      <p>Allemagne</p>
                    </div>
                  </>
                )}

                {!allemagne && (
                  <>
                    <div onClick={Allemagne} className="no-active">
                      <p>Allemagne</p>
                    </div>
                  </>
                )}

                {/* andorre */}
                {andorre && (
                  <>
                    <div onClick={Andorre} className="active">
                      <p>Andorre</p>
                    </div>
                  </>
                )}

                {!andorre && (
                  <>
                    <div onClick={Andorre} className="no-active">
                      <p>Andorre</p>
                    </div>
                  </>
                )}

                {/* angola */}
                {angola && (
                  <>
                    <div onClick={Angola} className="active">
                      <p>Angola</p>
                    </div>
                  </>
                )}

                {!angola && (
                  <>
                    <div onClick={Angola} className="no-active">
                      <p>Angola</p>
                    </div>
                  </>
                )}

                {/* antigua */}
                {antigua && (
                  <>
                    <div onClick={Antigua} className="active">
                      <p>Antigua-et-Barbuda</p>
                    </div>
                  </>
                )}

                {!antigua && (
                  <>
                    <div onClick={Antigua} className="no-active">
                      <p>Antigua-et-Barbuda</p>
                    </div>
                  </>
                )}

                {/* arabie saoudite */}
                {arabie && (
                  <>
                    <div onClick={Arabie} className="active">
                      <p>Arabie Saoudite</p>
                    </div>
                  </>
                )}

                {!arabie && (
                  <>
                    <div onClick={Arabie} className="no-active">
                      <p>Arabie Saoudite</p>
                    </div>
                  </>
                )}

                {/* argentine */}
                {argentine && (
                  <>
                    <div onClick={Argentine} className="active">
                      <p>Argentine</p>
                    </div>
                  </>
                )}

                {!argentine && (
                  <>
                    <div onClick={Argentine} className="no-active">
                      <p>Argentine</p>
                    </div>
                  </>
                )}

                {/* armenie */}
                {armenie && (
                  <>
                    <div onClick={Armenie} className="active">
                      <p>Arménie</p>
                    </div>
                  </>
                )}

                {!armenie && (
                  <>
                    <div onClick={Armenie} className="no-active">
                      <p>Arménie</p>
                    </div>
                  </>
                )}

                {/* australie */}
                {australie && (
                  <>
                    <div onClick={Australie} className="active">
                      <p>Australie</p>
                    </div>
                  </>
                )}

                {!australie && (
                  <>
                    <div onClick={Australie} className="no-active">
                      <p>Australie</p>
                    </div>
                  </>
                )}

                {/* autriche */}
                {autriche && (
                  <>
                    <div onClick={Autriche} className="active">
                      <p>Autriche</p>
                    </div>
                  </>
                )}

                {!autriche && (
                  <>
                    <div onClick={Autriche} className="no-active">
                      <p>Autriche</p>
                    </div>
                  </>
                )}

                {/* azerbaidjan */}
                {azerbaidjan && (
                  <>
                    <div onClick={Azerbaidjan} className="active">
                      <p>Azerbaïdjan</p>
                    </div>
                  </>
                )}

                {!azerbaidjan && (
                  <>
                    <div onClick={Azerbaidjan} className="no-active">
                      <p>Azerbaïdjan</p>
                    </div>
                  </>
                )}

                {/* bahamas */}
                {bahamas && (
                  <>
                    <div onClick={Bahamas} className="active">
                      <p>Bahamas</p>
                    </div>
                  </>
                )}

                {!bahamas && (
                  <>
                    <div onClick={Bahamas} className="no-active">
                      <p>Bahamas</p>
                    </div>
                  </>
                )}

                {/* Bahreïn */}
                {bahrein && (
                  <>
                    <div onClick={Bahrein} className="active">
                      <p>Bahreïn</p>
                    </div>
                  </>
                )}

                {!bahrein && (
                  <>
                    <div onClick={Bahrein} className="no-active">
                      <p>Bahreïn</p>
                    </div>
                  </>
                )}

                {/* bangladesh */}
                {bangladesh && (
                  <>
                    <div onClick={Bangladesh} className="active">
                      <p>Bangladesh</p>
                    </div>
                  </>
                )}

                {!bangladesh && (
                  <>
                    <div onClick={Bangladesh} className="no-active">
                      <p>Bangladesh</p>
                    </div>
                  </>
                )}

                {/* barbade */}
                {barbade && (
                  <>
                    <div onClick={Barbade} className="active">
                      <p>Barbade</p>
                    </div>
                  </>
                )}

                {!barbade && (
                  <>
                    <div onClick={Barbade} className="no-active">
                      <p>Barbade</p>
                    </div>
                  </>
                )}

                {/* belgique */}
                {belgique && (
                  <>
                    <div onClick={Belgique} className="active">
                      <p>Belgique</p>
                    </div>
                  </>
                )}

                {!belgique && (
                  <>
                    <div onClick={Belgique} className="no-active">
                      <p>Belgique</p>
                    </div>
                  </>
                )}

                {/* belize */}
                {belize && (
                  <>
                    <div onClick={Belize} className="active">
                      <p>Belize</p>
                    </div>
                  </>
                )}

                {!belize && (
                  <>
                    <div onClick={Belize} className="no-active">
                      <p>Belize</p>
                    </div>
                  </>
                )}

                {/* Congo */}
                {/* Congo */}
                {congo && (
                  <>
                    <div onClick={Congo} className="active">
                      <p>Congo</p>
                    </div>
                  </>
                )}

                {!congo && (
                  <>
                    <div onClick={Congo} className="no-active">
                      <p>Congo</p>
                    </div>
                  </>
                )}

                {/* Guinée Equatoriale */}
                {/* Guinée Equatoriale */}
                {guineeE && (
                  <>
                    <div onClick={GuineeE} className="active">
                      <p>Guinée Equatoriale</p>
                    </div>
                  </>
                )}

                {!guineeE && (
                  <>
                    <div onClick={GuineeE} className="no-active">
                      <p>Guinée Equatoriale</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}

      {/* nom */}
      {/* nom */}
      {/* nom */}
      {/* nom */}
      {/* nom */}
      {/* nom */}
      {/* nom */}
      {nom && (
        <>
          <div className="page-general-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={Nom}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="center">
                  <p>Modifier le Nom(s)</p>
                </div>
                {/* center */}

                <div className="center">
                  <input
                    value={modifierNom}
                    onChange={(e) => setModifierNom(e.target.value)}
                    type="text"
                    placeholder="Nom(s)"
                  />
                </div>
                {/* center */}

                <div className="center">
                  <button onClick={ModifierNom}>Enregistrer</button>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
        </>
      )}
      {/* nom */}

      {/* age */}
      {/* age */}
      {/* age */}
      {/* age */}
      {/* age */}
      {age && (
        <>
          <div className="page-general-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={Age}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="center">
                  <p>Modifier l'age</p>
                </div>
                {/* center */}

                {/* 17 ans */}
                {/* 17 ans */}
                {dixseptans && (
                  <>
                    <div className="genre">
                      <p onClick={PopupAge}>17 ans</p>
                      <svg
                        onClick={PopupAge}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {/* 18 ans */}
                {/* 18 ans */}
                {dixhuitans && (
                  <>
                    <div className="genre">
                      <p onClick={PopupAge}>18 ans</p>
                      <svg
                        onClick={PopupAge}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}
                <div style={{ paddingTop: "10px" }} className="hr">
                  <hr />
                </div>

                <div className="center">
                  <button onClick={ModifierAge}>Enregistrer</button>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
        </>
      )}
      {/* age */}

      {/* popup age */}
      {/* popup age */}
      {popupAge && (
        <>
          <div className="popup-genre-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={PopupAge}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Choisir l'age</li>
                </div>
                {/* title */}

                {/* 17 ans */}
                {/* 17 ans */}
                {dixseptans && (
                  <>
                    <div onClick={Dixseptans} className="active">
                      <p>17 ans</p>
                    </div>
                  </>
                )}

                {!dixseptans && (
                  <>
                    <div onClick={Dixseptans} className="no-active">
                      <p>17 ans</p>
                    </div>
                  </>
                )}

                {/* 18 ans */}
                {/* 18 ans */}
                {dixhuitans && (
                  <>
                    <div onClick={Dixhuitans} className="active">
                      <p>18 ans</p>
                    </div>
                  </>
                )}

                {!dixhuitans && (
                  <>
                    <div onClick={Dixhuitans} className="no-active">
                      <p>18 ans</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* popup age */}

      {/* genre */}
      {/* genre */}
      {/* genre */}
      {/* genre */}
      {/* genre */}
      {/* genre */}
      {/* genre */}
      {genre && (
        <>
          <div className="page-general-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={Genre}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="center">
                  <p>Modifier le Genre</p>
                </div>
                {/* center */}

                {/* homme */}
                {/* homme */}
                {homme && (
                  <>
                    <div className="genre">
                      <p onClick={PopupGenre}>Homme</p>
                      <svg
                        onClick={PopupGenre}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {/* femme */}
                {/* femme */}
                {femme && (
                  <>
                    <div className="genre">
                      <p onClick={PopupGenre}>Femme</p>
                      <svg
                        onClick={PopupGenre}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                {/* trans */}
                {/* trans */}
                {trans && (
                  <>
                    <div className="genre">
                      <p onClick={PopupGenre}>Trans</p>
                      <svg
                        onClick={PopupGenre}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="9px"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                  </>
                )}

                <div style={{ paddingTop: "10px" }} className="hr">
                  <hr />
                </div>

                <div className="center">
                  <button onClick={ModifierGenre}>Enregistrer</button>
                </div>
                {/* center */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
        </>
      )}
      {/* genre */}

      {/* popup genre */}
      {/* popup genre */}
      {/* popup genre */}
      {/* popup genre */}
      {/* popup genre */}
      {popupGenre && (
        <>
          <div className="popup-genre-opacity">
            <div className="align">
              <div className="close">
                <p></p>
                <svg
                  onClick={PopupGenre}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* close */}

              <div className="card">
                <div className="title">
                  <li>Choisir le Genre</li>
                </div>
                {/* title */}

                {/* homme */}
                {/* homme */}
                {homme && (
                  <>
                    <div onClick={Homme} className="active">
                      <p>Homme</p>
                    </div>
                  </>
                )}

                {!homme && (
                  <>
                    <div onClick={Homme} className="no-active">
                      <p>Homme</p>
                    </div>
                  </>
                )}

                {/* femme */}
                {/* femme */}
                {femme && (
                  <>
                    <div onClick={Femme} className="active">
                      <p>Femme</p>
                    </div>
                  </>
                )}

                {!femme && (
                  <>
                    <div onClick={Femme} className="no-active">
                      <p>Femme</p>
                    </div>
                  </>
                )}

                {/* Trans */}
                {/* Trans */}
                {trans && (
                  <>
                    <div onClick={Trans} className="active">
                      <p>Trans</p>
                    </div>
                  </>
                )}

                {!trans && (
                  <>
                    <div onClick={Trans} className="no-active">
                      <p>Trans</p>
                    </div>
                  </>
                )}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* popup-genre-opacity */}
        </>
      )}
      {/* popup genre */}


      {/* Logout Page */}
      {/* Logout Page */}
      {logoutPageAA && (<>
        <div className="popup-logout-opacity">
          <div className="align">
            <div className="card">
              <div className="title-logout">
                <div className="display"> <SvgLogout4 /><p>{t("--log out")}</p> </div>
              </div>
              {/* title logout */}

              <div className="logout">
                <p>{t("--would you like to log out of your florinato account")}</p>

                <div className="button">
                  <div className="yes"> <button onClick={LogoutAA}>{t("--yes")}</button> </div>
                  <div className="no"> <button onClick={CloseLogoutPageAA}>{t("--no")}</button> </div>
                </div>
                {/* button */}
              </div>
              {/* logout */}
            </div>
          </div>
        </div>
      </>)}


      {/* btn activer */}
      {/* btn activer */}
      {/* ce message de succes s'affiche lorsque le btn envoyerUnMessage
         a ete activer */}
      {envoyerUnMessageSuccess && (
        <>
          <div onClick={CloseEnvoyerUnMessageSuccess} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>
                      Le bouton Envoyer un message a été ajouté sur votre profil
                      !
                    </p>
                  </div>

                  <div className="b">
                    <p>
                      Désormais, Des personnes et des entreprises pourront vous
                      contacter
                    </p>
                  </div>
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}
      {/* btn activer */}

      {/* btn desactiver */}
      {/* btn desactiver */}
      {/* ce message de succes s'affiche lorsque le btn envoyerUnMessage
         a ete desactiver */}
      {envoyerUnMessageError && (
        <>
          <div onClick={CloseEnvoyerUnMessageError} className="page-opacity">
            <div className="align">
              <div className="card">
                <div className="block">
                  <div className="a">
                    <p>
                      Le bouton Envoyer un message a été retiré de votre profil
                      !
                    </p>
                  </div>

                  <div className="b">
                    <p>Aucune personne ne pourra vous envoyer un message</p>
                  </div>
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* page-opacity */}
        </>
      )}
      {/* btn desactiver */}

      {/* nomSuccess */}
      {/* nomSuccess */}
      {/* nomSuccess */}
      {/* ca va s'afficher lorsque le nom sera enregistré avec succès, c'est un message de succès */}
      {nomSuccess && (
        <>
          <div className="nom-success-opacity">
            <div className="center">
              <div className="change-photo-cover-success">
                <div className="column">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100px"
                    fill="blue"
                    data-name="Layer 1"
                    viewBox="0 0 16 16"
                  >
                    <circle
                      cx="12.5"
                      cy="11.5"
                      r="1.5"
                      className="cls-1"
                    ></circle>
                    <path
                      d="M14 4.693l-8.182 8.182L2 9.057 3.636 7.42l2.25 2.25 6.546-6.545z"
                      className="cls-2"
                    ></path>
                  </svg>
                </div>
                {/* column */}

                <div className="align">
                  <p>Votre nom a été modifié avec succès !</p>

                  <button onClick={nomSuccessBtnTerminer}>Terminer</button>
                </div>
                {/* align */}
              </div>
              {/* change-photo-cover-success */}
            </div>
            {/* center */}
          </div>
          {/* nom-success-opacity */}
        </>
      )}
      {/* nomSuccess */}

      {/* ageSuccess */}
      {/* ageSuccess */}
      {/* ageSuccess */}
      {/* ca va s'afficher lorsque l'age sera enregistré avec succès, c'est un message de succès */}
      {ageSuccess && (
        <>
          <div className="nom-success-opacity">
            <div className="center">
              <div className="change-photo-cover-success">
                <div className="column">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100px"
                    fill="blue"
                    data-name="Layer 1"
                    viewBox="0 0 16 16"
                  >
                    <circle
                      cx="12.5"
                      cy="11.5"
                      r="1.5"
                      className="cls-1"
                    ></circle>
                    <path
                      d="M14 4.693l-8.182 8.182L2 9.057 3.636 7.42l2.25 2.25 6.546-6.545z"
                      className="cls-2"
                    ></path>
                  </svg>
                </div>
                {/* column */}

                <div className="align">
                  <p>Votre age a été modifié avec succès !</p>

                  <button onClick={ageSuccessBtnTerminer}>Terminer</button>
                </div>
                {/* align */}
              </div>
              {/* change-photo-cover-success */}
            </div>
            {/* center */}
          </div>
          {/* nom-success-opacity */}
        </>
      )}
      {/* ageSuccess */}

      {/* genreSuccess */}
      {/* genreSuccess */}
      {/* genreSuccess */}
      {/* ca va s'afficher lorsque le genre sera enregistré avec succès, c'est un message de succès */}
      {genreSuccess && (
        <>
          <div className="nom-success-opacity">
            <div className="center">
              <div className="change-photo-cover-success">
                <div className="column">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100px"
                    fill="blue"
                    data-name="Layer 1"
                    viewBox="0 0 16 16"
                  >
                    <circle
                      cx="12.5"
                      cy="11.5"
                      r="1.5"
                      className="cls-1"
                    ></circle>
                    <path
                      d="M14 4.693l-8.182 8.182L2 9.057 3.636 7.42l2.25 2.25 6.546-6.545z"
                      className="cls-2"
                    ></path>
                  </svg>
                </div>
                {/* column */}

                <div className="align">
                  <p>Votre genre a été modifié avec succès !</p>

                  <button onClick={genreSuccessBtnTerminer}>Terminer</button>
                </div>
                {/* align */}
              </div>
              {/* change-photo-cover-success */}
            </div>
            {/* center */}
          </div>
          {/* nom-success-opacity */}
        </>
      )}
      {/* genreSuccess */}

      {/* countrySuccess */}
      {/* countrySuccess */}
      {/* countrySuccess */}
      {/* ca va s'afficher lorsque le pays sera enregistré avec succès, c'est un message de succès */}
      {countrySuccess && (
        <>
          <div className="nom-success-opacity">
            <div className="center">
              <div className="change-photo-cover-success">
                <div className="column">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100px"
                    fill="blue"
                    data-name="Layer 1"
                    viewBox="0 0 16 16"
                  >
                    <circle
                      cx="12.5"
                      cy="11.5"
                      r="1.5"
                      className="cls-1"
                    ></circle>
                    <path
                      d="M14 4.693l-8.182 8.182L2 9.057 3.636 7.42l2.25 2.25 6.546-6.545z"
                      className="cls-2"
                    ></path>
                  </svg>
                </div>
                {/* column */}

                <div className="align">
                  <p>Votre pays a été modifié avec succès !</p>

                  <button onClick={countrySuccessBtnTerminer}>Terminer</button>
                </div>
                {/* align */}
              </div>
              {/* change-photo-cover-success */}
            </div>
            {/* center */}
          </div>
          {/* nom-success-opacity */}
        </>
      )}
      {/* countrySuccess */}

      {/* sans etre connecter */}
      {/* ce code empeche la personne d'accéder à certaines
      fonctionnalités sans être connecter */}
      {sansEtreConnecter && (
        <>
          <div
            onClick={SansEtreConnecter}
            className="sans-etre-connecter-opacity"
          >
            <div className="align">
              <div className="card">
                <p>Connectez-vous à votre compte Alrani</p>
                <NavLink to="/login">
                  <button>Se connecter</button>
                </NavLink>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* sans-etre-connecter-opacity */}
        </>
      )}
      {/* sans etre connecter */}


      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* home */}
      {/* 
      <div className="home-al">
        {openMobileMenu && (
          <>
            <p style={{ paddingBottom: "60px" }}></p>
          </>
        )}
        
        <div className="overflow">
          {api.map((api) => (
            <div className="book">
              <NavLink className="navlink" to="/book">
                <img src={api.imagebook} alt="" />

                <div className="title">
                  <p>{api.titlebook}</p>
                </div>

                <div className="author">
                  <p>{api.authorbook}</p>
                </div>

                <div className="b">
                  <p>Saison 4</p>
                  <p>Episode 1</p>
                </div>
              </NavLink>

              <div className="buttona">
                <button>Télécharger</button>
              </div>

              {/* 
            <div className="buttonb">
              <button>Télécharger</button>
            </div>
            
            </div>
          ))}
        </div>
      </div>
         */}

      {openMobileMenu && (<> <p style={{ paddingBottom: "49px" }}></p> </>)}

      {theme2 && (<> <p style={{ paddingBottom: "50px" }}></p> </>)}
      {theme3 && (<><p style={{ paddingBottom: "50px" }}></p> </>)}

      {/* ca va s'afficher uniquement chez celui qui a un compte developpeur */}
      {dev && (
        <>
          {/* on affiche les pages booster */}
          {/* on affiche les pages booster */}
          {apiPageBooster.map((api) => (
            <EnfantApiPageBooster api={api} />
          ))}
          {/* on affiche les pages booster */}

          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          {/* Afrique Francophone */}
          <div className="book-by-categorie">
            <div className="a">
              <p>Afrique Francophone</p>
              <div className="infos">
                <p>
                  Livres en Français écris par des Auteurs africains francophone
                </p>
              </div>
            </div>
            {/* a */}

            <div className="overflow">
              {apiAfriqueFrancophone.map((api) => {
                return (
                  <>
                    <NavLink style={{ textDecoration: "none" }} to="/book">
                      <EnfantApiAfriqueFrancophone
                        apiAfriqueFrancophone={api}
                      />
                    </NavLink>
                  </>
                );
              })}

              <div className="next">
                <NavLink to="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </NavLink>
              </div>
              {/* next */}
            </div>
            {/* overflow */}
          </div>
          {/* Afrique Francophone */}

          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          {/* Investir en Afrique */}
          <div className="book-by-categorie">
            <div className="a">
              <p>Investir en Afrique</p>

              <div className="infos">
                <p>
                  Avant de commencer à investir il faut apprendre à investir
                </p>
              </div>
            </div>
            {/* a */}

            <div className="overflow">
              {apiInvestirEnAfrique.map((api) => {
                return (
                  <>
                    <NavLink style={{ textDecoration: "none" }} to="/book">
                      <EnfantApiInvestirEnAfrique apiInvestirEnAfrique={api} />
                    </NavLink>
                  </>
                );
              })}

              <div className="next">
                <NavLink to="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </NavLink>
              </div>
              {/* next */}
            </div>
            {/* overflow */}
          </div>
          {/* Investir en Afrique */}

          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          {/* Livre en Français */}
          <div className="book-by-categorie">
            <div className="a">
              <p>Livre en Français</p>

              <div className="infos">
                <p>
                  Augmentez vos connaissances en lisant des Livres en langue
                  Française
                </p>
              </div>
            </div>
            {/* a */}

            <div className="overflow">
              {apiLivreEnFrancais.map((api) => {
                return (
                  <>
                    <NavLink style={{ textDecoration: "none" }} to="/book">
                      <EnfantApiLivreEnFrancais apiLivreEnFrancais={api} />
                    </NavLink>
                  </>
                );
              })}

              <div className="next">
                <NavLink to="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </NavLink>
              </div>
              {/* next */}
            </div>
            {/* overflow */}
          </div>
          {/* Livre en Français */}

          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          {/* Cameroun */}
          <div className="book-by-categorie">
            <div className="a">
              <div className="style-jaune">
                <p>Cameroun</p>
              </div>

              <div className="infos">
                <p>Livres écris par des Auteurs de nationalité camerounaise</p>
              </div>
            </div>
            {/* a */}

            <div className="overflow">
              {apiAuteurCameroun.map((api) => {
                return (
                  <>
                    <NavLink style={{ textDecoration: "none" }} to="/book">
                      <EnfantApiAuteurCameroun apiAuteurCameroun={api} />
                    </NavLink>
                  </>
                );
              })}

              <div className="next">
                <NavLink to="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </NavLink>
              </div>
              {/* next */}
            </div>
            {/* overflow */}
          </div>
          {/* Cameroun */}
        </>
      )}
      {/* le code de dev se ferme ici */}

      {theme2 && (<> <p style={{ paddingTop: "40px" }}></p> </>)}
      {theme3 && (<> <p style={{ paddingTop: "40px" }}></p> </>)}

      


      {/* official app */}
      {/* official app */}
      {/* ca c'est l'application Official */}
      {officialApp && (
        <>
          <div className="officiaApp">
            <div className="logo">
              <div onClick={CloseOfficialApp} className="block-one"> <p>www.</p> </div>
              <div className="block-two"> <p></p> </div>
            </div>
            {/* logo */}

            <div className="head">  
              {/* Recommandations */}
              {recommendation && (<><div className="active"> <p>{t("--recommendation")}</p> </div></>)}
              {!recommendation && (<><div onClick={Recommendation} className="noActive"> <p>{t("--recommendation")}</p> </div></>)}
              
              {/* address */}
              {address && (<><div className="active"> <p>{t("--address")}</p> </div></>)}
              {!address && (<><div onClick={Address} className="noActive"> <p>{t("--address")}</p> </div></>)}

              {/* Règles */}
              {rule && (<><div className="active"> <p>{t("--rule")}</p> </div></>)}
              {!rule && (<><div onClick={Rule} className="noActive"> <p>{t("--rule")}</p> </div></>)}
              
              {/* Conseils */}
              {advice && (<><div className="active"> <p>{t("--advice")}</p> </div></>)}
              {!advice && (<><div onClick={Advice} className="noActive"> <p>{t("--advice")}</p> </div></>)}
            </div>
            {/* head */}

            <div className="hr"> <hr /> </div>
            {/* hr */}

            <div className="body">
              {/* Recommandations (body) */}
              {/* Recommandations (body) */}
              {recommendation && (
              <>
                <div className="block-one"> 
                  <div className="active"> <p>{t("--for all virtual phone users")}</p> </div>
                  <div className="active"> <p>{t("--the vpn allows you to access")}</p> </div>
                  <div className="active"> <p>{t("--preferably, use a vpn")}</p> </div>
                </div>
                {/* block-one */}
              </>)}
              {/* Recommandations (body) */}

              {/* address (body) */}
              {/* address (body) */}
              {address && (
              <>
                <div className="block-three"> 
                  <div className="a"> <p>{t("--official addresses to access your virtual phone")}</p> </div>
                  {/* a */}

                  <div className="b"> <a href="https://alrani.onrender.com" target="_blank" rel="noopener noreferrer"><p>https://alrani.onrender.com</p> <SvgNewOnglet /></a> </div>
                  <div className="b"> <a href="https://alrani.vercel.app" target="_blank" rel="noopener noreferrer"><p>https://alrani.vercel.app</p> <SvgNewOnglet /></a> </div>

                  <div className="b"> <a href="https://izocash.onrender.com" target="_blank" rel="noopener noreferrer"><p>https://izocash.onrender.com</p> <SvgNewOnglet /></a> </div>

                  <div className="b"> <a href="https://vixinol.netlify.app" target="_blank" rel="noopener noreferrer"><p>https://vixinol.netlify.app</p> <SvgNewOnglet /></a> </div>
                  <div className="b"> <a href="https://vixinol.vercel.app" target="_blank" rel="noopener noreferrer"><p>https://vixinol.vercel.app</p> <SvgNewOnglet /></a> </div>
                  {/* b */}
                </div>
                {/* block-three */}
              </>)}
              {/* address (body) */}

              {/* Règles (body) */}
              {/* Règles (body) */}
              {rule && (
              <>
                <div className="block-one"> 
                  <div className="active"> <p>{t("--don't prevent competition")}</p> </div>
                  <div className="active"> <p>{t("--no ban on stifling competition")}</p> </div>
                  <div className="active"> <p>{t("--identity update every year")}</p> </div>
                  <div className="active"> <p>{t("--no jealousy, no hatred")}</p> </div>
                  <div className="active"> <p>{t("--collaborate, live in harmony")}</p> </div>
                </div>
                {/* block-one */}
              </>)}
              {/* Règles (body) */}
              
              {/* Conseils (body) */}
              {/* Conseils (body) */}
              {advice && (
              <>
                <div className="block-one"> 
                  <div className="active"> <p>{t("--where people's attention goes")}</p> </div>
                  <div className="active"> <p>{t("--the largest tree was above")}</p> </div>
                  <div className="active"> <p>{t("--winners persevere")}</p> </div>
                  <div className="active"> <p>{t("--persistence always pays off")}</p> </div>
                </div>
                {/* block-one */}
              </>)}
              {/* Conseils (body) */}
            </div>
            {/* body */}
          </div>
          {/* officiaApp */}
        </>
      )}
      {/* official app */}

      {/* Paramètres du Téléphone virtuel */}
      {/* Paramètres du Téléphone virtuel */}
      {settings && (
        <>
          <div className="settings">
            <div className="close">
              <div onClick={CloseSettings} className="block-one">
                <div className="a"> <SvgSettings /> </div>
                <div className="b"> <p>{t("--settings")}</p> </div>
              </div>
              {/* block-one */}

              <div onClick={ToastSettings} className="block-two"> <SvgInfos2 /> </div>
              {/* block-two */}
            </div>
            {/* close */}

            <div className="hr"> <hr /> </div>
            {/* hr */}

            {/* Alrani */}
            <div onClick={ConfigurationAA} className="app">
              <div className="block-one">
                <div className="a">
                  <img src={alraniLogo} alt="" />
                  <p>Alrani</p>
                </div>
                {/* a */}

                <div className="b">
                  <SvgBottom4 />
                </div>
                {/* b */}
              </div>
              {/* block-one */}

              <div className="block-two"> <hr /> </div>
              {/* block-two */}
            </div>
            
            {/* izocash */}
            <div onClick={ConfigurationIA} className="app">
              <div className="block-one">
                <div className="a">
                  <img src={izocashLogo} alt="" />
                  <p>izocash</p>
                </div>
                {/* a */}

                <div className="b">
                  <SvgBottom4 />
                </div>
                {/* b */}
              </div>
              {/* block-one */}

              <div className="block-two"> <hr /> </div>
              {/* block-two */}
            </div>
           
            {/* Vixinol Store */}
            <div onClick={ConfigurationVS} className="app">
              <div className="block-one">
                <div className="a">
                  <img src={vixinolLogo} alt="" />
                  <p>Vixinol</p>
                </div>
                {/* a */}

                <div className="b">
                  <SvgBottom4 />
                </div>
                {/* b */}
              </div>
              {/* block-one */}

              <div className="block-two"> <hr /> </div>
              {/* block-two */}
            </div>

            {/* Veil Brillant */}
            <div onClick={ConfigurationVB} className="app">
              <div className="block-one">
                <div className="a">
                  <img src={vbLogo} alt="" />
                  <p>Veil Brillant</p>
                </div>
                {/* a */}

                <div className="b">
                  <SvgBottom4 />
                </div>
                {/* b */}
              </div>
              {/* block-one */}

              <div className="block-two"> <hr /> </div>
              {/* block-two */}
            </div>
            {/* app */}

          </div>
          {/* settings */}
        </>
      )}
      {/* Paramètres du Téléphone virtuel */}


      {/* toast au niveau des paramètres du Téléphone virtuel */}
      {/* toast au niveau des paramètres du Téléphone virtuel */}
      {toastSettings && (
        <>
          <div className="toastSettings">
            <div className="bottom">
              <div className="center">
                <button>{t("--virtual phone settings")}</button>
              </div>
              {/* center */}
            </div>
            {/* bottom */}
          </div>
          {/* toastSettings */}
        </>
      )}
      {/* toast au niveau des paramètres du Téléphone virtuel */}


      {/* configuration de l'application Alrani - AA */}
      {/* configuration de l'application Alrani - AA */}
      {configurationAA && (
        <>
          <div className="configuration">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div onClick={CloseConfigurationAA} className="block-one">
                    <img src={alraniLogo} alt="" />
                    <p>{t("--setting up the alrani app")}</p>
                  </div>
                  {/* block-one */}

                  <div className="block-two"></div>
                  {/* block-two */}
                </div>
                {/* close */}

                <div className="hr"> <hr/> </div>
                {/* hr */}
              </div>
              {/* head */}

              <div className="body">

                {/* les vitesses correspond juste au choix  de l'api, soit Render 1, Render 2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--speed")}</p> </div>
                    <div className="b"> <p>{t("--speed of reception")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Vitesse 1 */}
                    {speed1AA && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed1AA && (<>
                    <div onClick={Speed1AA} className="noActive">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 2 */}
                    {speed2AA && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed2AA && (<> 
                    <div onClick={Speed2AA} className="noActive">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 3 */}
                    {speed3AA && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed3AA && (<> 
                    <div onClick={Speed3AA} className="noActive">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}

                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--image / video +")}</p> </div>
                    <div className="b"> <p>{t("--storage of images, videos")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Datacenter 1 */}
                    {datacenter1AA && (<>
                    <div className="active">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter1AA && (<> 
                    <div onClick={Datacenter1AA} className="noActive">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Datacenter 2 */}
                    {datacenter2AA && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter2AA && (<> 
                    <div onClick={Datacenter2AA} className="noActive">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Datacenter 3 */}
                    {datacenter3AA && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter3AA && (<> 
                    <div onClick={Datacenter3AA} className="noActive">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* configuration */}
        </>
      )}
      {/* configuration de l'application Alrani - AA */}

      {/* configuration de l'application izocash - IA */}
      {/* configuration de l'application izocash - IA */}
      {configurationIA && (
        <>
          <div className="configuration">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div onClick={CloseConfigurationIA} className="block-one">
                    <img src={izocashLogo} alt="" />
                    <p>{t("--setting up the izocash app")}</p>
                  </div>
                  {/* block-one */}

                  <div className="block-two"></div>
                  {/* block-two */}
                </div>
                {/* close */}

                <div className="hr"> <hr/> </div>
                {/* hr */}
              </div>
              {/* head */}

              <div className="body">

                {/* les vitesses correspond juste au choix  de l'api, soit Render 1, Render 2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--speed")}</p> </div>
                    <div className="b"> <p>{t("--speed of reception")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Vitesse 1 */}
                    {speed1IA && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed1IA && (<>
                    <div onClick={Speed1IA} className="noActive">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 2 */}
                    {speed2IA && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed2IA && (<> 
                    <div onClick={Speed2IA} className="noActive">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 3 */}
                    {speed3IA && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed3IA && (<> 
                    <div onClick={Speed3IA} className="noActive">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}

                {/* Datacenter correspond juste au choix de la ou on stocke les donnees. Datacenter 1 = mongodb1 + cloudinary1, Datacenter 2 = mongodb2 + cloudinary2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--image / video +")}</p> </div>
                    <div className="b"> <p>{t("--storage of images, videos")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Datacenter 1 */}
                    {datacenter1IA && (<>
                    <div className="active">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter1IA && (<> 
                    <div onClick={Datacenter1IA} className="noActive">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Datacenter 2 */}
                    {datacenter2IA && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter2IA && (<> 
                    <div onClick={Datacenter2IA} className="noActive">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                <div className="block-two">
                  {/* Datacenter 3 */}
                  {datacenter3IA && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter3IA && (<> 
                    <div onClick={Datacenter3IA} className="noActive">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* configuration */}
        </>
      )}
      {/* configuration de l'application izocash - IA */}

      {/* configuration de l'application Vixinol Store - VS */}
      {/* configuration de l'application Vixinol Store - VS */}
      {configurationVS && (
        <>
          <div className="configuration">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div onClick={CloseConfigurationVS} className="block-one">
                    <img src={vixinolLogo} alt="" />
                    <p>{t("--setting up the vixinol app")}</p>
                  </div>
                  {/* block-one */}

                  <div className="block-two"></div>
                  {/* block-two */}
                </div>
                {/* close */}

                <div className="hr"> <hr/> </div>
                {/* hr */}
              </div>
              {/* head */}

              <div className="body">

                {/* les vitesses correspond juste au choix  de l'api, soit Render 1, Render 2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--speed")}</p> </div>
                    <div className="b"> <p>{t("--speed of reception")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Vitesse 1 */}
                    {speed1VS && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed1VS && (<>
                    <div onClick={Speed1VS} className="noActive">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 2 */}
                    {speed2VS && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed2VS && (<> 
                    <div onClick={Speed2VS} className="noActive">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 3 */}
                    {speed3VS && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed3VS && (<> 
                    <div onClick={Speed3VS} className="noActive">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}

                {/* Datacenter correspond juste au choix de la ou on stocke les donnees. Datacenter 1 = mongodb1 + cloudinary1, Datacenter 2 = mongodb2 + cloudinary2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--image / video +")}</p> </div>
                    <div className="b"> <p>{t("--storage of images, videos")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Datacenter 1 */}
                    {datacenter1VS && (<>
                    <div className="active">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter1VS && (<> 
                    <div onClick={Datacenter1VS} className="noActive">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Datacenter 2 */}
                    {datacenter2VS && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter2VS && (<> 
                    <div onClick={Datacenter2VS} className="noActive">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                <div className="block-two">
                  {/* Datacenter 3 */}
                  {datacenter3VS && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter3VS && (<> 
                    <div onClick={Datacenter3VS} className="noActive">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* configuration */}
        </>
      )}
      {/* configuration de l'application Vixinol Store - VS */}

      {/* configuration de l'application Veil Brillant - VB */}
      {/* configuration de l'application Veil Brillant - VB */}
      {configurationVB && (
        <>
          <div className="configuration">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div onClick={CloseConfigurationVB} className="block-one">
                    <img src={vbLogo} alt="" />
                    <p>{t("--setting up the veil brillant app")}</p>
                  </div>
                  {/* block-one */}

                  <div className="block-two"></div>
                  {/* block-two */}
                </div>
                {/* close */}

                <div className="hr"> <hr/> </div>
                {/* hr */}
              </div>
              {/* head */}

              <div className="body">

                {/* les vitesses correspond juste au choix  de l'url de l'api, soit Render 1, Render 2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--speed")}</p> </div>
                    <div className="b"> <p>{t("--speed of reception")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Vitesse 1 */}
                    {speed1VB && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed1VB && (<>
                    <div onClick={Speed1VB} className="noActive">
                      <div className="a"> <p>{t("--speed")} 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 2 */}
                    {speed2VB && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed2VB && (<> 
                    <div onClick={Speed2VB} className="noActive">
                      <div className="a"> <p>{t("--speed")} 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Vitesse 3 */}
                    {speed3VB && (<> 
                    <div className="active">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!speed3VB && (<> 
                    <div onClick={Speed3VB} className="noActive">
                      <div className="a"> <p>{t("--speed")} 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  {/* block-two */}
                </div>
                {/* card */}

                {/* Datacenter correspond juste au choix de la ou on stocke les donnees. Datacenter 1 = mongodb1 + cloudinary1, Datacenter 2 = mongodb2 + cloudinary2 */}
                <div className="card">
                  <div className="block-one">
                    <div className="a"> <p>{t("--image / video +")}</p> </div>
                    <div className="b"> <p>{t("--storage of images, videos")}</p> </div>
                  </div>
                  {/* block-one */}

                  <div className="block-two">
                    {/* Datacenter 1 */}
                    {datacenter1VB && (<>
                    <div className="active">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter1VB && (<> 
                    <div onClick={Datacenter1VB} className="noActive">
                      <div className="a"> <p>Datacenter 1</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Datacenter 2 */}
                    {datacenter2VB && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter2VB && (<> 
                    <div onClick={Datacenter2VB} className="noActive">
                      <div className="a"> <p>Datacenter 2</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />

                  <div className="block-two">
                    {/* Datacenter 3 */}
                    {datacenter3VB && (<> 
                    <div className="active">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckbox /> </div>
                    </div> </>)}

                    {!datacenter3VB && (<> 
                    <div onClick={Datacenter3VB} className="noActive">
                      <div className="a"> <p>Datacenter 3</p> </div>
                      <div className="b"> <SvgCheckboxNoActive /> </div>
                    </div> </>)}
                  </div>
                  <hr />
                  {/* block-two */}
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* configuration */}
        </>
      )}
      {/* configuration de l'application Veil Brillant - VB */}

      {/* translation */}
      {/* translation */}
      {/* choisir la langue du telephone virtuel */}
      {translation && (
        <>
          <div className="translation">
            <div className="close">
              <div className="a">
                <div onClick={CloseTranslation} className="aa"> <SvgLeft /> </div>
                <div className="bb"> <p>{t("--virtual phone language")}</p> </div>
              </div>
              {/* a */}

              <div onClick={InfosLanguage} className="b"> <SvgInfos /> </div>
              {/* b */}
            </div>
            {/* close */}

             {/* arabic */}
             <div onClick={() => ChangeLanguage("arabic")} className="language">
              <div onClick={Arabic} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--arabic")}</p> </div>
                  <div className="bb"> <p>Arabic</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {arabic && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!arabic && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* albanian */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("albanian")} className="language">
              <div onClick={Albanian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--albanian")}</p> </div>
                  <div className="bb"> <p>Albanian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {albanian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!albanian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}

            {/* amharic */}
            <div onClick={() => ChangeLanguage("amharic")} className="language">
              <div onClick={Amharic} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--amharic")}</p> </div>
                  <div className="bb"> <p>Amharic</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {amharic && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!amharic && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* afrikaans */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("afrikaans")} className="language">
              <div onClick={Afrikaans} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--afrikaans")}</p> </div>
                  <div className="bb"> <p>Afrikaans</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {afrikaans && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!afrikaans && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* armenian */}
            <div onClick={() => ChangeLanguage("armenian")} className="language">
              <div onClick={Armenian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--armenian")}</p> </div>
                  <div className="bb"> <p>Armenian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {armenian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!armenian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* assamese */}
            <div onClick={() => ChangeLanguage("assamese")} className="language">
              <div onClick={Assamese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--assamese")}</p> </div>
                  <div className="bb"> <p>Assamese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {assamese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!assamese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* aymara */}
            <div onClick={() => ChangeLanguage("aymara")} className="language">
              <div onClick={Aymara} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--aymara")}</p> </div>
                  <div className="bb"> <p>Aymara</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {aymara && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!aymara && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* azerbaijani */}
            <div onClick={() => ChangeLanguage("azerbaijani")} className="language">
              <div onClick={Azerbaijani} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--azerbaijani")}</p> </div>
                  <div className="bb"> <p>Azerbaijani</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {azerbaijani && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!azerbaijani && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* bambara */}
            <div onClick={() => ChangeLanguage("bambara")} className="language">
              <div onClick={Bambara} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--bambara")}</p> </div>
                  <div className="bb"> <p>Bambara</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {bambara && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!bambara && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* basque */}
            <div onClick={() => ChangeLanguage("basque")} className="language">
              <div onClick={Basque} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--basque")}</p> </div>
                  <div className="bb"> <p>Basque</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {basque && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!basque && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* belarusian */}
            <div onClick={() => ChangeLanguage("belarusian")} className="language">
              <div onClick={Belarusian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--belarusian")}</p> </div>
                  <div className="bb"> <p>Belarusian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {belarusian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!belarusian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* bengali */}
            <div onClick={() => ChangeLanguage("bengali")} className="language">
              <div onClick={Bengali} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--bengali")}</p> </div>
                  <div className="bb"> <p>Bengali</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {bengali && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!bengali && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* bhojpuri */}
            <div onClick={() => ChangeLanguage("bhojpuri")} className="language">
              <div onClick={Bhojpuri} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--bhojpuri")}</p> </div>
                  <div className="bb"> <p>Bhojpuri</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {bhojpuri && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!bhojpuri && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* bosnian */}
            <div onClick={() => ChangeLanguage("bosnian")} className="language">
              <div onClick={Bosnian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--bosnian")}</p> </div>
                  <div className="bb"> <p>Bosnian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {bosnian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!bosnian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* bulgarian */}
            <div onClick={() => ChangeLanguage("bulgarian")} className="language">
              <div onClick={Bulgarian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--bulgarian")}</p> </div>
                  <div className="bb"> <p>Bulgarian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {bulgarian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!bulgarian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* catalan */}
            <div onClick={() => ChangeLanguage("catalan")} className="language">
              <div onClick={Catalan} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--catalan")}</p> </div>
                  <div className="bb"> <p>Catalan</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {catalan && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!catalan && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* cebuano */}
            <div onClick={() => ChangeLanguage("cebuano")} className="language">
              <div onClick={Cebuano} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--cebuano")}</p> </div>
                  <div className="bb"> <p>Cebuano</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {cebuano && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!cebuano && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* chichewa */}
            <div onClick={() => ChangeLanguage("chichewa")} className="language">
              <div onClick={Chichewa} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--chichewa")}</p> </div>
                  <div className="bb"> <p>Chichewa</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {chichewa && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!chichewa && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            </>)}

             {/* chinese (Simplified) */}
             <div onClick={() => ChangeLanguage("chineseSimplified")} className="language">
              <div onClick={ChineseSimplified} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--chineseSimplified")}</p> </div>
                  <div className="bb"> <p>Chinese (Simplified)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {chineseSimplified && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!chineseSimplified && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* chinese (Traditional) */}
            {dev && (<>
             <div onClick={() => ChangeLanguage("chineseTraditional")} className="language">
              <div onClick={ChineseTraditional} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--chineseTraditional")}</p> </div>
                  <div className="bb"> <p>Chinese (Traditional)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {chineseTraditional && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!chineseTraditional && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* corsican */}
            <div onClick={() => ChangeLanguage("corsican")} className="language">
              <div onClick={Corsican} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--corsican")}</p> </div>
                  <div className="bb"> <p>Corsican</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {corsican && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!corsican && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* croatian */}
            <div onClick={() => ChangeLanguage("croatian")} className="language">
              <div onClick={Croatian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--croatian")}</p> </div>
                  <div className="bb"> <p>Croatian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {croatian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!croatian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* czech */}
            <div onClick={() => ChangeLanguage("czech")} className="language">
              <div onClick={Czech} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--czech")}</p> </div>
                  <div className="bb"> <p>Czech</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {czech && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!czech && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* danish */}
            <div onClick={() => ChangeLanguage("danish")} className="language">
              <div onClick={Danish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--danish")}</p> </div>
                  <div className="bb"> <p>Danish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {danish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!danish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* dhivehi */}
            <div onClick={() => ChangeLanguage("dhivehi")} className="language">
              <div onClick={Dhivehi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--dhivehi")}</p> </div>
                  <div className="bb"> <p>Dhivehi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {dhivehi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!dhivehi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* dogri */}
            <div onClick={() => ChangeLanguage("dogri")} className="language">
              <div onClick={Dogri} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--dogri")}</p> </div>
                  <div className="bb"> <p>Dogri</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {dogri && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!dogri && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* dutch */}
            <div onClick={() => ChangeLanguage("dutch")} className="language">
              <div onClick={Dutch} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--dutch")}</p> </div>
                  <div className="bb"> <p>Dutch</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {dutch && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!dutch && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            </>)}
           
            {/* english */}
            <div onClick={() => ChangeLanguage("english")} className="language">
              <div onClick={English} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--english")}</p> </div>
                  <div className="bb"> <p>English</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {english && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!english && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* esperanto */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("esperanto")} className="language">
              <div onClick={Esperanto} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--esperanto")}</p> </div>
                  <div className="bb"> <p>Esperanto</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {esperanto && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!esperanto && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* estonian */}
            <div onClick={() => ChangeLanguage("estonian")} className="language">
              <div onClick={Estonian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--estonian")}</p> </div>
                  <div className="bb"> <p>Estonian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {estonian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!estonian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* ewe */}
            <div onClick={() => ChangeLanguage("ewe")} className="language">
              <div onClick={Ewe} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--ewe")}</p> </div>
                  <div className="bb"> <p>Ewe</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {ewe && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!ewe && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* filipino */}
            <div onClick={() => ChangeLanguage("filipino")} className="language">
              <div onClick={Filipino} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--filipino")}</p> </div>
                  <div className="bb"> <p>Filipino</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {filipino && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!filipino && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* finnish */}
            <div onClick={() => ChangeLanguage("finnish")} className="language">
              <div onClick={Finnish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--finnish")}</p> </div>
                  <div className="bb"> <p>Finnish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {finnish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!finnish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
             </>)}

            {/* french */}
            <div onClick={() => ChangeLanguage("french")} className="language">
              <div onClick={French} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--french")}</p> </div>
                  <div className="bb"> <p>French</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {french && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!french && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            
            {/* frisian */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("frisian")} className="language">
              <div onClick={Frisian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--frisian")}</p> </div>
                  <div className="bb"> <p>Frisian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {frisian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!frisian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* galician */}
            <div onClick={() => ChangeLanguage("galician")} className="language">
              <div onClick={Galician} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--galician")}</p> </div>
                  <div className="bb"> <p>Galician</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {galician && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!galician && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Georgian */}
            <div onClick={() => ChangeLanguage("georgian")} className="language">
              <div onClick={Georgian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--georgian")}</p> </div>
                  <div className="bb"> <p>Georgian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {georgian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!georgian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}

            
            {/* german */}
            <div onClick={() => ChangeLanguage("german")} className="language">
              <div onClick={German} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--german")}</p> </div>
                  <div className="bb"> <p>German</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {german && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!german && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* greek */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("greek")} className="language">
              <div onClick={Greek} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--greek")}</p> </div>
                  <div className="bb"> <p>Greek</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {greek && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!greek && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* guarani */}
            <div onClick={() => ChangeLanguage("guarani")} className="language">
              <div onClick={Guarani} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--guarani")}</p> </div>
                  <div className="bb"> <p>Guarani</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {guarani && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!guarani && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* gujarati */}
            <div onClick={() => ChangeLanguage("gujarati")} className="language">
              <div onClick={Gujarati} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--gujarati")}</p> </div>
                  <div className="bb"> <p>Gujarati</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {gujarati && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!gujarati && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* haitianCreole */}
            <div onClick={() => ChangeLanguage("haitianCreole")} className="language">
              <div onClick={HaitianCreole} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--haitianCreole")}</p> </div>
                  <div className="bb"> <p>Haitian Creole</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {haitianCreole && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!haitianCreole && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* hausa */}
            <div onClick={() => ChangeLanguage("hausa")} className="language">
              <div onClick={Hausa} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--hausa")}</p> </div>
                  <div className="bb"> <p>Hausa</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {hausa && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!hausa && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* hawaiian */}
            <div onClick={() => ChangeLanguage("hawaiian")} className="language">
              <div onClick={Hawaiian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--hawaiian")}</p> </div>
                  <div className="bb"> <p>Hawaiian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {hawaiian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!hawaiian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* hebrew */}
            <div onClick={() => ChangeLanguage("hebrew")} className="language">
              <div onClick={Hebrew} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--hebrew")}</p> </div>
                  <div className="bb"> <p>Hebrew</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {hebrew && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!hebrew && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}
            

            {/* hindi */}
            <div onClick={() => ChangeLanguage("hindi")} className="language">
              <div onClick={Hindi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--hindi")}</p> </div>
                  <div className="bb"> <p>Hindi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {hindi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!hindi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* hmong */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("hmong")} className="language">
              <div onClick={Hmong} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--hmong")}</p> </div>
                  <div className="bb"> <p>Hmong</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {hmong && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!hmong && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* hungarian */}
            <div onClick={() => ChangeLanguage("hungarian")} className="language">
              <div onClick={Hungarian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--hungarian")}</p> </div>
                  <div className="bb"> <p>Hungarian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {hungarian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!hungarian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* icelandic */}
            <div onClick={() => ChangeLanguage("icelandic")} className="language">
              <div onClick={Icelandic} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--icelandic")}</p> </div>
                  <div className="bb"> <p>Icelandic</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {icelandic && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!icelandic && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* igbo */}
            <div onClick={() => ChangeLanguage("igbo")} className="language">
              <div onClick={Igbo} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--igbo")}</p> </div>
                  <div className="bb"> <p>Igbo</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {igbo && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!igbo && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* ilocano */}
            <div onClick={() => ChangeLanguage("ilocano")} className="language">
              <div onClick={Ilocano} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--ilocano")}</p> </div>
                  <div className="bb"> <p>Ilocano</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {ilocano && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!ilocano && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}
            
            {/* indonesian */}
            <div onClick={() => ChangeLanguage("indonesian")} className="language">
              <div onClick={Indonesian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--indonesian")}</p> </div>
                  <div className="bb"> <p>Indonesian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {indonesian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!indonesian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* irish */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("irish")} className="language">
              <div onClick={Irish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--irish")}</p> </div>
                  <div className="bb"> <p>Irish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {irish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!irish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}


            {/* italian */}
            <div onClick={() => ChangeLanguage("italian")} className="language">
              <div onClick={Italian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--italian")}</p> </div>
                  <div className="bb"> <p>Italian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {italian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!italian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>


            {/* japanese */}
            <div onClick={() => ChangeLanguage("japanese")} className="language">
              <div onClick={Japanese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--japanese")}</p> </div>
                  <div className="bb"> <p>Japanese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {japanese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!japanese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* javanese */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("javanese")} className="language">
              <div onClick={Javanese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--javanese")}</p> </div>
                  <div className="bb"> <p>Javanese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {javanese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!javanese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* kannada */}
            <div onClick={() => ChangeLanguage("kannada")} className="language">
              <div onClick={Kannada} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--kannada")}</p> </div>
                  <div className="bb"> <p>Kannada</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {kannada && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!kannada && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* kazakh */}
            <div onClick={() => ChangeLanguage("kazakh")} className="language">
              <div onClick={Kazakh} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--kazakh")}</p> </div>
                  <div className="bb"> <p>Kazakh</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {kazakh && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!kazakh && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* khmer */}
            <div onClick={() => ChangeLanguage("khmer")} className="language">
              <div onClick={Khmer} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--khmer")}</p> </div>
                  <div className="bb"> <p>Khmer</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {khmer && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!khmer && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* kinyarwanda */}
            <div onClick={() => ChangeLanguage("kinyarwanda")} className="language">
              <div onClick={Kinyarwanda} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--kinyarwanda")}</p> </div>
                  <div className="bb"> <p>Kinyarwanda</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {kinyarwanda && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!kinyarwanda && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* konkani */}
            <div onClick={() => ChangeLanguage("konkani")} className="language">
              <div onClick={Konkani} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--konkani")}</p> </div>
                  <div className="bb"> <p>Konkani</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {konkani && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!konkani && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* korean */}
            <div onClick={() => ChangeLanguage("korean")} className="language">
              <div onClick={Korean} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--korean")}</p> </div>
                  <div className="bb"> <p>Korean</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {korean && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!korean && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* krio */}
            <div onClick={() => ChangeLanguage("krio")} className="language">
              <div onClick={Krio} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--krio")}</p> </div>
                  <div className="bb"> <p>Krio</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {krio && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!krio && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Kurdish (Kurmanji) */}
            <div onClick={() => ChangeLanguage("kurdishKurmanji")} className="language">
              <div onClick={KurdishKurmanji} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--kurdishKurmanji")}</p> </div>
                  <div className="bb"> <p>Kurdish (Kurmanji)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {kurdishKurmanji && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!kurdishKurmanji && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Kurdish (Sorani) */}
            <div onClick={() => ChangeLanguage("kurdishSorani")} className="language">
              <div onClick={KurdishSorani} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--kurdishSorani")}</p> </div>
                  <div className="bb"> <p>Kurdish (Sorani)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {kurdishSorani && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!kurdishSorani && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* kyrgyz */}
            <div onClick={() => ChangeLanguage("kyrgyz")} className="language">
              <div onClick={Kyrgyz} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--kyrgyz")}</p> </div>
                  <div className="bb"> <p>Kyrgyz</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {kyrgyz && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!kyrgyz && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* lao */}
            <div onClick={() => ChangeLanguage("lao")} className="language">
              <div onClick={Lao} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--lao")}</p> </div>
                  <div className="bb"> <p>Lao</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {lao && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!lao && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* latin */}
            <div onClick={() => ChangeLanguage("latin")} className="language">
              <div onClick={Latin} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--latin")}</p> </div>
                  <div className="bb"> <p>Latin</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {latin && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!latin && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* latvian */}
            <div onClick={() => ChangeLanguage("latvian")} className="language">
              <div onClick={Latvian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--latvian")}</p> </div>
                  <div className="bb"> <p>Latvian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {latvian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!latvian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* lingala */}
            <div onClick={() => ChangeLanguage("lingala")} className="language">
              <div onClick={Lingala} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--lingala")}</p> </div>
                  <div className="bb"> <p>Lingala</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {lingala && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!lingala && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* lithuanian */}
            <div onClick={() => ChangeLanguage("lithuanian")} className="language">
              <div onClick={Lithuanian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--lithuanian")}</p> </div>
                  <div className="bb"> <p>Lithuanian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {lithuanian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!lithuanian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* luganda */}
            <div onClick={() => ChangeLanguage("luganda")} className="language">
              <div onClick={Luganda} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--luganda")}</p> </div>
                  <div className="bb"> <p>Luganda</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {luganda && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!luganda && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* luxembourgish */}
            <div onClick={() => ChangeLanguage("luxembourgish")} className="language">
              <div onClick={Luxembourgish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--luxembourgish")}</p> </div>
                  <div className="bb"> <p>Luxembourgish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {luxembourgish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!luxembourgish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* macedonian */}
            <div onClick={() => ChangeLanguage("macedonian")} className="language">
              <div onClick={Macedonian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--macedonian")}</p> </div>
                  <div className="bb"> <p>Macedonian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {macedonian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!macedonian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* maithili */}
            <div onClick={() => ChangeLanguage("maithili")} className="language">
              <div onClick={Maithili} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--maithili")}</p> </div>
                  <div className="bb"> <p>Maithili</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {maithili && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!maithili && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* malagasy */}
            <div onClick={() => ChangeLanguage("malagasy")} className="language">
              <div onClick={Malagasy} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--malagasy")}</p> </div>
                  <div className="bb"> <p>Malagasy</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {malagasy && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!malagasy && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* malay */}
            <div onClick={() => ChangeLanguage("malay")} className="language">
              <div onClick={Malay} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--malay")}</p> </div>
                  <div className="bb"> <p>Malay</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {malay && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!malay && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* malayalam */}
            <div onClick={() => ChangeLanguage("malayalam")} className="language">
              <div onClick={Malayalam} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--malayalam")}</p> </div>
                  <div className="bb"> <p>Malayalam</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {malayalam && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!malayalam && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* maltese */}
            <div onClick={() => ChangeLanguage("maltese")} className="language">
              <div onClick={Maltese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--maltese")}</p> </div>
                  <div className="bb"> <p>Maltese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {maltese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!maltese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
          
            {/* maori */}
            <div onClick={() => ChangeLanguage("maori")} className="language">
              <div onClick={Maori} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--maori")}</p> </div>
                  <div className="bb"> <p>Maori</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {maori && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!maori && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* marathi */}
            <div onClick={() => ChangeLanguage("marathi")} className="language">
              <div onClick={Marathi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--marathi")}</p> </div>
                  <div className="bb"> <p>Marathi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {marathi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!marathi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Meiteilon (Manipuri) */}
            <div onClick={() => ChangeLanguage("meiteilonManipuri")} className="language">
              <div onClick={MeiteilonManipuri} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--meiteilonManipuri")}</p> </div>
                  <div className="bb"> <p>Meiteilon (Manipuri)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {meiteilonManipuri && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!meiteilonManipuri && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* mizo */}
            <div onClick={() => ChangeLanguage("mizo")} className="language">
              <div onClick={Mizo} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--mizo")}</p> </div>
                  <div className="bb"> <p>Mizo</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {mizo && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!mizo && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* mongolian */}
            <div onClick={() => ChangeLanguage("mongolian")} className="language">
              <div onClick={Mongolian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--mongolian")}</p> </div>
                  <div className="bb"> <p>Mongolian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {mongolian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!mongolian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Myanmar (Burmese) */}
            <div onClick={() => ChangeLanguage("myanmarBurmese")} className="language">
              <div onClick={MyanmarBurmese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--myanmarBurmese")}</p> </div>
                  <div className="bb"> <p>Myanmar (Burmese)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {myanmarBurmese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!myanmarBurmese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* nepali */}
            <div onClick={() => ChangeLanguage("nepali")} className="language">
              <div onClick={Nepali} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--nepali")}</p> </div>
                  <div className="bb"> <p>Nepali</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {nepali && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!nepali && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* norwegian */}
            <div onClick={() => ChangeLanguage("norwegian")} className="language">
              <div onClick={Norwegian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--norwegian")}</p> </div>
                  <div className="bb"> <p>Norwegian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {norwegian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!norwegian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Odia (Oriya) */}
            <div onClick={() => ChangeLanguage("odiaOriya")} className="language">
              <div onClick={OdiaOriya} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--odiaOriya")}</p> </div>
                  <div className="bb"> <p>Odia (Oriya)</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {odiaOriya && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!odiaOriya && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* oromo */}
            <div onClick={() => ChangeLanguage("oromo")} className="language">
              <div onClick={Oromo} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--oromo")}</p> </div>
                  <div className="bb"> <p>Oromo</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {oromo && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!oromo && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* pashto */}
            <div onClick={() => ChangeLanguage("pashto")} className="language">
              <div onClick={Pashto} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--pashto")}</p> </div>
                  <div className="bb"> <p>Pashto</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {pashto && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!pashto && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* persian */}
            <div onClick={() => ChangeLanguage("persian")} className="language">
              <div onClick={Persian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--persian")}</p> </div>
                  <div className="bb"> <p>Persian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {persian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!persian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* polish */}
            <div onClick={() => ChangeLanguage("polish")} className="language">
              <div onClick={Polish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--polish")}</p> </div>
                  <div className="bb"> <p>Polish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {polish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!polish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            </>)}

            {/* portuguese */}
            <div onClick={() => ChangeLanguage("portuguese")} className="language">
              <div onClick={Portuguese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--portuguese")}</p> </div>
                  <div className="bb"> <p>Portuguese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {portuguese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!portuguese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* punjabi */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("punjabi")} className="language">
              <div onClick={Punjabi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--punjabi")}</p> </div>
                  <div className="bb"> <p>Punjabi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {punjabi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!punjabi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
          
            {/* quechua */}
            <div onClick={() => ChangeLanguage("quechua")} className="language">
              <div onClick={Quechua} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--quechua")}</p> </div>
                  <div className="bb"> <p>Quechua</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {quechua && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!quechua && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* romanian */}
            <div onClick={() => ChangeLanguage("romanian")} className="language">
              <div onClick={Romanian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--romanian")}</p> </div>
                  <div className="bb"> <p>Romanian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {romanian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!romanian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}

            {/* russian */}
            <div onClick={() => ChangeLanguage("russian")} className="language">
              <div onClick={Russian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--russian")}</p> </div>
                  <div className="bb"> <p>Russian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {russian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!russian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* samoan */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("samoan")} className="language">
              <div onClick={Samoan} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--samoan")}</p> </div>
                  <div className="bb"> <p>Samoan</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {samoan && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!samoan && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* sanskrit */}
            <div onClick={() => ChangeLanguage("sanskrit")} className="language">
              <div onClick={Sanskrit} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--sanskrit")}</p> </div>
                  <div className="bb"> <p>Sanskrit</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {sanskrit && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!sanskrit && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* Scots Gaelic */}
            <div onClick={() => ChangeLanguage("scotsGaelic")} className="language">
              <div onClick={ScotsGaelic} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--scotsGaelic")}</p> </div>
                  <div className="bb"> <p>Scots Gaelic</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {scotsGaelic && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!scotsGaelic && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* sepedi */}
            <div onClick={() => ChangeLanguage("sepedi")} className="language">
              <div onClick={Sepedi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--sepedi")}</p> </div>
                  <div className="bb"> <p>Sepedi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {sepedi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!sepedi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* serbian */}
            <div onClick={() => ChangeLanguage("serbian")} className="language">
              <div onClick={Serbian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--serbian")}</p> </div>
                  <div className="bb"> <p>Serbian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {serbian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!serbian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            
            {/* sesotho */}
            <div onClick={() => ChangeLanguage("sesotho")} className="language">
              <div onClick={Sesotho} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--sesotho")}</p> </div>
                  <div className="bb"> <p>Sesotho</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {sesotho && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!sesotho && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* shona */}
            <div onClick={() => ChangeLanguage("shona")} className="language">
              <div onClick={Shona} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--shona")}</p> </div>
                  <div className="bb"> <p>Shona</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {shona && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!shona && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* sindhi */}
            <div onClick={() => ChangeLanguage("sindhi")} className="language">
              <div onClick={Sindhi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--sindhi")}</p> </div>
                  <div className="bb"> <p>Sindhi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {sindhi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!sindhi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* sinhala */}
            <div onClick={() => ChangeLanguage("sinhala")} className="language">
              <div onClick={Sinhala} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--sinhala")}</p> </div>
                  <div className="bb"> <p>Sinhala</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {sinhala && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!sinhala && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* slovak */}
            <div onClick={() => ChangeLanguage("slovak")} className="language">
              <div onClick={Slovak} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--slovak")}</p> </div>
                  <div className="bb"> <p>Slovak</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {slovak && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!slovak && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* slovenian */}
            <div onClick={() => ChangeLanguage("slovenian")} className="language">
              <div onClick={Slovenian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--slovenian")}</p> </div>
                  <div className="bb"> <p>Slovenian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {slovenian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!slovenian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* somali */}
            <div onClick={() => ChangeLanguage("somali")} className="language">
              <div onClick={Somali} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--somali")}</p> </div>
                  <div className="bb"> <p>Somali</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {somali && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!somali && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}

            {/* spanish */}
            <div onClick={() => ChangeLanguage("spanish")} className="language">
              <div onClick={Spanish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--spanish")}</p> </div>
                  <div className="bb"> <p>Spanish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {spanish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!spanish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* sundanese */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("sundanese")} className="language">
              <div onClick={Sundanese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--sundanese")}</p> </div>
                  <div className="bb"> <p>Sundanese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {sundanese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!sundanese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* swahili */}
            <div onClick={() => ChangeLanguage("swahili")} className="language">
              <div onClick={Swahili} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--swahili")}</p> </div>
                  <div className="bb"> <p>Swahili</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {swahili && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!swahili && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* swedish */}
            <div onClick={() => ChangeLanguage("swedish")} className="language">
              <div onClick={Swedish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--swedish")}</p> </div>
                  <div className="bb"> <p>Swedish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {swedish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!swedish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* tajik */}
            <div onClick={() => ChangeLanguage("tajik")} className="language">
              <div onClick={Tajik} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--tajik")}</p> </div>
                  <div className="bb"> <p>Tajik</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {tajik && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!tajik && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* tamil */}
            <div onClick={() => ChangeLanguage("tamil")} className="language">
              <div onClick={Tamil} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--tamil")}</p> </div>
                  <div className="bb"> <p>Tamil</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {tamil && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!tamil && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* tatar */}
            <div onClick={() => ChangeLanguage("tatar")} className="language">
              <div onClick={Tatar} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--tatar")}</p> </div>
                  <div className="bb"> <p>Tatar</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {tatar && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!tatar && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* telugu */}
            <div onClick={() => ChangeLanguage("telugu")} className="language">
              <div onClick={Telugu} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--telugu")}</p> </div>
                  <div className="bb"> <p>Telugu</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {telugu && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!telugu && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* thai */}
            <div onClick={() => ChangeLanguage("thai")} className="language">
              <div onClick={Thai} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--thai")}</p> </div>
                  <div className="bb"> <p>Thai</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {thai && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!thai && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* tigrinya */}
            <div onClick={() => ChangeLanguage("tigrinya")} className="language">
              <div onClick={Tigrinya} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--tigrinya")}</p> </div>
                  <div className="bb"> <p>Tigrinya</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {tigrinya && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!tigrinya && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* tsonga */}
            <div onClick={() => ChangeLanguage("tsonga")} className="language">
              <div onClick={Tsonga} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--tsonga")}</p> </div>
                  <div className="bb"> <p>Tsonga</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {tsonga && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!tsonga && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* turkish */}
            <div onClick={() => ChangeLanguage("turkish")} className="language">
              <div onClick={Turkish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--turkish")}</p> </div>
                  <div className="bb"> <p>Turkish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {turkish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!turkish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* turkmen */}
            <div onClick={() => ChangeLanguage("turkmen")} className="language">
              <div onClick={Turkmen} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--turkmen")}</p> </div>
                  <div className="bb"> <p>Turkmen</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {turkmen && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!turkmen && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* twi */}
            <div onClick={() => ChangeLanguage("twi")} className="language">
              <div onClick={Twi} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--twi")}</p> </div>
                  <div className="bb"> <p>Twi</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {twi && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!twi && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div></>)}

            
            {/* ukrainian */}
            <div onClick={() => ChangeLanguage("ukrainian")} className="language">
              <div onClick={Ukrainian} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--ukrainian")}</p> </div>
                  <div className="bb"> <p>Ukrainian</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {ukrainian && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!ukrainian && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* urdu */}
            {dev && (<>
            <div onClick={() => ChangeLanguage("urdu")} className="language">
              <div onClick={Urdu} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--urdu")}</p> </div>
                  <div className="bb"> <p>Urdu</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {urdu && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!urdu && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* uyghur */}
            <div onClick={() => ChangeLanguage("uyghur")} className="language">
              <div onClick={Uyghur} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--uyghur")}</p> </div>
                  <div className="bb"> <p>Uyghur</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {uyghur && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!uyghur && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* uzbek */}
            <div onClick={() => ChangeLanguage("uzbek")} className="language">
              <div onClick={Uzbek} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--uzbek")}</p> </div>
                  <div className="bb"> <p>Uzbek</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {uzbek && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!uzbek && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* vietnamese */}
            <div onClick={() => ChangeLanguage("vietnamese")} className="language">
              <div onClick={Vietnamese} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--vietnamese")}</p> </div>
                  <div className="bb"> <p>Vietnamese</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {vietnamese && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!vietnamese && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* welsh */}
            <div onClick={() => ChangeLanguage("welsh")} className="language">
              <div onClick={Welsh} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--welsh")}</p> </div>
                  <div className="bb"> <p>Welsh</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {welsh && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!welsh && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* xhosa */}
            <div onClick={() => ChangeLanguage("xhosa")} className="language">
              <div onClick={Xhosa} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--xhosa")}</p> </div>
                  <div className="bb"> <p>Xhosa</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {xhosa && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!xhosa && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* yiddish */}
            <div onClick={() => ChangeLanguage("yiddish")} className="language">
              <div onClick={Yiddish} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--yiddish")}</p> </div>
                  <div className="bb"> <p>Yiddish</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {yiddish && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!yiddish && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* yoruba */}
            <div onClick={() => ChangeLanguage("yoruba")} className="language">
              <div onClick={Yoruba} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--yoruba")}</p> </div>
                  <div className="bb"> <p>Yoruba</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {yoruba && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!yoruba && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>

            {/* zulu */}
            <div onClick={() => ChangeLanguage("zulu")} className="language">
              <div onClick={Zulu} className="block-deux">
                <div className="a">
                  <div className="aa"> <p>{t("--zulu")}</p> </div>
                  <div className="bb"> <p>Zulu</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <div className="aa"> {zulu && (<> <SvgCheckbox /> </>)} </div>
                  <div className="bb"> {!zulu && (<> <SvgCheckboxNoActive /> </>)} </div>
                </div>
                {/* b */}
              </div>
              {/* block-deux */}
            </div>
            </>)}

            {/* language */}
          </div>
          {/* translation */}
        </>
      )}
      {/* translation */}

      {/* infos Language */}
      {/* infos Language */}
      {/* on affiche cette petite infos au niveau de la page ou il ya toutes les langues */}
      {infosLanguage && (
      <>
      <div onClick={CloseInfosLanguage} className="infosLanguage">
        <div className="align">
          <div className="card">
            <p>{t("--virtual phone language is applied")}</p>
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* infosLanguage */}
      </>
      )}
      {/* infos Language */}
  
      {/* ecran de demarrage - Alrani app */}
      {/* ecran de demarrage - Alrani app */}
      {/* sur cette page on a mis l'ecran de demarrage de notre application Alrani */}
      {ecranDemarrageAA && (
        <>
          <div className="ecranDemarrageIA-opacity">
            <div className="align">
              <div className="logo">
                <img src={florinatoEcranDemarrage} alt="" />
              </div>
              {/* logo */}
            </div>
            {/* align */}
          </div>
          {/* ecranDemarrageIA-opacity */}
        </>
      )}
      {/* ecran de demarrage - Alrani app */}

     
      {/* Moyen de Paiement (page) - AA */}
      {/* Moyen de Paiement (page) - AA */}
      {/* le card ci va permettre a la personne d'entrer le code pin pour lier un moyen de
      paiement lors de l'inscription sur Alrani */}
      {moyenPaiementPageAA && (
        <>
          <div className="moyenPaiementVS">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p onClick={CloseMoyenPaiementPageAA}>
                      Moyen de paiement virtuel
                    </p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p onClick={CloseMoyenPaiementPageAA}>
                      Ajouter un moyen de paiement virtuel compatible à votre
                      téléphone virtuel
                    </p>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="codePin">
                  <div className="block-un">
                    <p style={{ color: "#00cc00" }}>Code PIN</p>
                  </div>
                  {/* block-un */}

                  <div className="block-deux">
                    <input type="number" placeholder="_ _ _ _ _ _" />
                  </div>
                  {/* block-deux */}

                  <div className="block-trois">
                    <button
                      style={{
                        border: "1px solid #00cc00",
                        backgroundColor: "#00cc00",
                      }}
                      onClick={SuperCodePageAA}
                    >
                      Ajouter
                    </button>
                  </div>
                  {/* block-trois */}
                </div>
                {/* codePin */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* moyenPaiementVS */}
        </>
      )}
      {/* Moyen de Paiement (page) - AA */}

      {/* super code (inscription) - AA */}
      {/* super code (inscription) - AA */}
      {/* le card ci va permettre a la personne d'entrer le super code */}
      {superCodePageAA && (
        <>
          <div className="superCodeAA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p onClick={CloseSuperCodePageAA}>Super Code</p>
                  <svg
                    onClick={CloseSuperCodePageAA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    enableBackground="new 0 0 25.93 25.93"
                    version="1.1"
                    viewBox="0 0 25.93 25.93"
                    xmlSpace="preserve"
                  >
                    <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-un">
                  <p>* Entrer un Super code</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <div className="a">
                    <input type="text" />
                  </div>
                  {/* a */}

                  <div className="b">
                    <button>
                      <p>Valider</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15px"
                        viewBox="0 0 48 48"
                        fill="#fff"
                      >
                        <g data-name="Layer 2">
                          <path fill="none" d="M0 0H48V48H0z"></path>
                          <path d="M44.9 23.2l-38-18L6 5a2 2 0 00-2 2l5.3 16H24a2.1 2.1 0 012 2 2 2 0 01-2 2H9.3L4 43a2 2 0 002 2l.9-.2 38-18a2 2 0 000-3.6z"></path>
                        </g>
                      </svg>
                    </button>
                  </div>
                  {/* b */}
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* superCodeAA */}
        </>
      )}
      {/* super code (inscription) - AA */}

      {/* inscriptionSuccess - AA */}
      {/* inscriptionSuccess - AA */}
      {/* on affiche cette page si la personne a pu s'inscrire */}
      {inscriptionSuccessAA && (
        <>
          <div className="inscriptionSuccessAA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <div className="a"> <p>{t("--signup success")}</p> </div>
                  <div className="b"> <p>{t("--now log in")}</p> </div>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <button onClick={CloseInscriptionSuccessAA}>
                    <p>{t("--go to login page")}</p>
                    <hr />
                  </button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* inscriptionSuccessAA */}
        </>
      )}
      {/* inscriptionSuccess - AA */}

      {/* connexionSuccess - AA */}
      {/* connexionSuccess - AA */}
      {/* on affiche cette page si la personne a pu se connecter */}
      {connexionSuccessAA && (
        <>
          <div className="connexionSuccessAA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Connexion réussie</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <button onClick={CloseConnexionSuccessAA}>{t("--continue")}</button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionSuccessAA */}
        </>
      )}
      {/* connexionSuccess - AA */}

      {/* erreur (connexion) - AA */}
      {/* erreur (connexion) - AA */}
      {/* on affiche cette page si l'inscription a echouer ou si la personne a 
            rencontrer une erreur lors de la connexion a son compte Alrani */}
      {erreurConnexionAA && (
        <>
          <div className="erreurConnexionAA">
            <div className="block-un">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                ariaHidden="true"
                viewBox="0 0 128 128"
              >
                <path
                  fill="#888071"
                  d="M19.7 45.67c-.04 0-.08 0-.12-.01-.06-.01-1.56-.18-4.11-.64-2.78-.51-4.61-.72-4.63-.72-.6-.07-1.04-.61-.97-1.22.07-.6.62-1.04 1.22-.97.08.01 1.92.22 4.78.74 2.47.45 3.95.62 3.96.62.6.07 1.04.61.97 1.22-.07.56-.55.98-1.1.98zM10.78 50.08c-.55 0-1.03-.41-1.09-.97a1.1 1.1 0 01.97-1.22c.03 0 2.81-.33 4.22-.56 1.46-.23 4.74-.75 4.74-.75l.34 2.17-4.73.75c-1.46.24-4.2.56-4.32.57-.05 0-.09.01-.13.01zM12.51 54.68c-.48 0-.92-.31-1.06-.8-.17-.58.17-1.19.76-1.36l7.88-2.25a1.102 1.102 0 01.6 2.12l-7.88 2.25c-.09.02-.2.04-.3.04z"
                ></path>
                <path
                  fill="#b85c3e"
                  d="M53.29 84.41l-10.84 8.31s.42 17.32.14 18.02c-.28.7-4.08 5.07-3.66 7.6.33 1.97 1.83 2.67 5.91 2.82s12.39-1.69 12.39-1.69l-3.94-35.06zM85.11 91.02l-8.02 4.5s1.13 3.38 1.13 8.17-.42 7.79-.7 8.78c-.28.99-2.63 2.86-2.39 5.58.11 1.26 1.69 2.25 4.5 2.11s6.9-.42 6.9-.42l4.08-26.61-5.5-2.11z"
                ></path>
                <path
                  fill="#fb8b02"
                  d="M33.26 27.81s-1.31-4.6-.19-11.92c1.13-7.32 3-11.17 4.79-11.36 1.78-.19 5.16 3.19 7.79 7.23 2.63 4.04 4.79 11.17 4.79 11.17l-17.18 4.88zM63.85 97.26s.09 8.45.28 12.2c.19 3.75.01 12.08-.75 13-1.17 1.41-2.35 1.45-4.88 1.55-1.51.06.47-9.29.47-9.67s.09-22.81.09-22.81l4.79 5.73z"
                ></path>
                <path
                  fill="#ffb800"
                  d="M38.79 68.08s-2.25 7.13-1.69 12.48c.56 5.35 3.66 12.11 6.76 14.83s5.91 4.13 6.19 4.79c.28.66 1.41 9.95 1.03 11.92s-3.1 7.04-2.63 9.01c.47 1.97 2.33 3.21 7.13 3.1 6.24-.14 5.91-1.08 6.38-4.97.32-2.62-.09-20.74-.09-20.74s3.85.38 9.29 0c5.44-.38 12.2-2.82 12.2-2.82s3.85 12.01 2.53 15.67c-1.31 3.66-3.47 5.73-3.1 8.26.38 2.53 3.66 3.66 7.7 3.28 4.04-.38 7.13-3 7.32-6.48.19-3.47.09-22.71.66-24.21.56-1.5 2.63-6.66 2.44-11.83s-.56-7.23-.56-7.23 4.85-1.85 9.34-5.25c3.42-2.59 5.99-6 7.36-11.08 2.25-8.35-.84-16.61-7.04-19.43-5.96-2.71-11.83-1.69-12.01 2.63s3.66 3.38 6.57 4.5c2.91 1.13 6.19 6.29 2.72 11.36-3.47 5.07-9.57 6.66-11.45 6.85-1.88.19-5.35-2.72-12.58-2.91-7.23-.19-17.64 5.07-17.93 4.41-.28-.66 10.32-7.51 11.07-16.42.7-8.26-1.03-12.11-1.03-12.11s-1.31-13.98-3.19-20.55S67.7 3.69 66.01 3.79c-1.69.09-7.13 6.01-9.1 8.92s-4.13 7.6-4.13 7.6-8.4-.31-12.11 1.03c-3.38 1.22-7.23 3.28-9.67 7.13s-3.19 6.1-4.32 6.66c-1.13.56-6.48 1.69-6.95 2.35-.47.66-1.69 9.39-1.41 10.7s.5 4.37 2.06 6.1c1.78 1.97 6.71 5.3 10.61 7.79 3.77 2.4 7.43 4.32 7.8 6.01z"
                ></path>
                <path
                  fill="#ff9b31"
                  d="M73.38 77.27c3.47-.05 3.38-4.22 3.43-9.39.04-4.52-.14-7.18-.14-7.18s-1.99.27-3.75.94c-1.74.66-3.24 1.27-3.24 1.27v7.27c-.01 2.49.27 7.14 3.7 7.09zM79.48 60.05s0 4.36.05 8.07c.05 3.99-.33 8.31 3.66 8.26 3.43-.04 3.43-4.41 3.47-9.34.02-2.58.09-6.99.09-6.99s-1.69-.33-3.71-.28c-1.59.04-3.56.28-3.56.28z"
                ></path>
                <path
                  fill="#2c312c"
                  d="M44.81 41.02c-.73 1.77-2.3 4.3-4.89 3.64-1.66-.42-1.78-3.99-.81-6.11 1.15-2.5 2.68-3.63 4.47-3.42 1.97.24 2.16 3.62 1.23 5.89zM27.67 40.48c-.05-1.13-2.96-1.92-5.21-2.77-1.91-.71-2.96-.75-3.47-.28s-1.13 1.69-1.41 3.57-.18 5.06.28 7.04c.47 2.02 1.22 4.55 4.55 5.87 2.86 1.13 4.55-.42 5.77-1.27 1.55-1.07.88-3.61-1.31-2.3-1.64.99-2.77 1.27-4.04.33-1.74-1.29-2.16-5.11-2.02-5.44.61-1.43 3.05-1.78 4.04-2.16.99-.38 2.87-1.6 2.82-2.59z"
                ></path>
                <path
                  fill="#888071"
                  d="M47.34 50.45h-.08c-.03 0-3.19-.23-5.16-.28l-5.63-.14s-1.18.1-1.18-1.06c0-1.23 1.23-1.04 1.23-1.04l5.63.14c2.02.05 5.13.27 5.26.28.58.04 1.01.55.97 1.12-.04.56-.5.98-1.04.98zM45.55 57.3c-.15 0-.31-.03-.45-.1-.02-.01-2.51-1.2-4.76-1.97-2.34-.79-4.96-1.64-4.96-1.64-.55-.18-.86-.77-.68-1.32.18-.55.77-.86 1.32-.68 0 0 2.64.85 4.99 1.65 2.38.81 4.89 2.01 5 2.07.52.25.74.88.49 1.4-.18.37-.56.59-.95.59zM40.44 61.2c-.2 0-.41-.06-.59-.18-.02-.01-1.78-1.21-2.96-1.94-1.23-.75-3.44-2.17-3.44-2.17s-.99-.58-.35-1.5 1.48-.28 1.48-.28 2.2 1.4 3.41 2.15c1.23.75 2.97 1.95 3.05 2 .48.33.6.98.27 1.46-.21.3-.54.46-.87.46z"
                ></path>
                <path
                  fill="#fed0ab"
                  d="M64.35 12.33c-.48-.17-3.59 3.45-5.14 7.04-1.55 3.59-2.11 5.56-1.97 6.19.06.28 1.85 1.83 4.5 3.94 2.75 2.18 4.5 3.52 5.28 3.45.77-.07.99-6.05.35-11.47s-2.25-8.87-3.02-9.15z"
                ></path>
              </svg>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                ariaHidden="true"
                viewBox="0 0 128 128"
              >
                <path
                  fill="#ffd2b1"
                  d="M28.94 63.15s-2.39 6.9-.99 14.22c1.41 7.32 3.38 14.08 3.38 14.08s.42 14.36 0 15.91c-.42 1.55-3.66 3.52-3.66 6.34s1.03 6.38 6.24 7.23 9.43-.89 11.17-3c2.51-3.05 2.02-5.21 2.02-7.46s.14-15.2.7-17.18c.56-1.97 1.41-3.1 2.96-2.96 1.55.14 3.24 2.53 3.38 7.04.14 4.5.28 12.39.14 13.94-.14 1.55-1.55 6.76-.42 8.87 1.13 2.11 6.24 4.16 10.18 3.94 5.16-.28 8.26-3.52 8.54-6.05.28-2.53-1.41-8.31-1.41-10 0-1.69 1.97-13.23 2.53-13.94.56-.7 2.28-.55 6.05-2.25 3.43-1.55 5.26-3.1 5.26-3.1s.09 10-.05 11.12c-.14 1.13-3.52 4.65-2.96 7.32s3.86 4.23 6.8 4.5c4.97.47 9.81-3.38 11.07-6.76 1.27-3.38.7-7.6.42-9.85-.28-2.25-.28-10.14 0-12.25.28-2.11.74-3.39.92-4.5.28-1.83.21-3.87.21-3.87s4.86 0 7.74-1.9 5.91-5.21 7.25-9.29c1.31-3.99.99-5.21-.14-5.35-1.13-.14-6.19 6.96-10.49 7.18-6.83.35-6.15-6.97-11.36-11.4-5.87-5-15.02-5.63-15.02-5.63s1.58-5.91 1.6-10.28c.07-19.08-9.22-25.55-9.22-25.55S60.61 3.95 47.94 4.51 25.98 15.14 25.98 15.14L19.01 45.9s1.76 5.91 4.58 10.21c2.96 4.5 5.35 7.04 5.35 7.04z"
                ></path>
                <path
                  fill="#865b52"
                  d="M20.14 8.32C9.79 8.53 4.32 17.35 4.16 22.75c-.09 3.17-1.34 26.21 11.4 26.68 5.11.19 8.91-5.74 10.84-12.46 2.43-8.47 2.32-16.96 2.6-19.22.45-3.61 1.2-6.26 1.2-6.26s-1.26-3.35-10.06-3.17zM75.54 4.8c11.26.42 15.1 5.41 16.19 8.31 1.2 3.17 2.25 14.48.49 22.03-1.43 6.16-3.59 9.29-8.66 9.08-4.64-.19-6.99-6.88-10.49-15.98-3.38-8.8-5.97-16.68-6.41-17.81-.56-1.48-1.76-2.11-1.76-2.11s2.25-3.84 10.64-3.52z"
                ></path>
                <path
                  fill="#d27856"
                  d="M62.66 27.67c-5.56.35-8.22 6.53-7.04 12.74 1.27 6.69 5.66 9.86 11.19 9.15 6.05-.77 7.88-7.67 7.11-12.88-.71-4.74-3.39-9.51-11.26-9.01z"
                ></path>
                <path
                  fill="#060401"
                  d="M69.2 39c0 2.92-1.62 5.36-4.19 5.29-3.49-.1-4.4-3.19-4.33-5.79.08-3.04 1.9-4.48 4.5-4.41 2.32.05 4.02 1.99 4.02 4.91zM39.85 40.61c0 3.04-1.62 5.58-4.19 5.5-3.49-.1-4.4-3.32-4.33-6.03.08-3.17 2.25-4.52 4.29-4.37 2.31.17 4.23 1.86 4.23 4.9zM53.22 57.59s6.12-.63 5.84-5.07c-.28-4.43-4.43-4.72-7.67-4.65-3.24.07-7.88 1.76-7.39 5.49.49 3.73 5.77 4.22 5.77 4.22s-.01 2.76-1.83 2.96c-1.97.21-4.79-2.82-5.56-3.59-.77-.77-1.97-.49-2.39.14s-.14 2.04 1.06 3.24 4.01 4.22 6.83 3.94c2.82-.28 2.89-1.76 4.01-1.83 1.13-.07 1.06 1.62 3.87 1.55 1.98-.05 5.97-3.53 6.69-4.15 1.62-1.41 2.04-2.82 1.34-3.73s-2.67.42-3.73 1.2c-1.06.77-2.77 2.59-4.43 2.89-2.76.49-2.41-2.61-2.41-2.61z"
                ></path>
                <path
                  fill="#d27856"
                  d="M78.21 50.99s-1.33 2.92-2.44 5.26c-1.34 2.82-3.26 5.28-3.26 5.28s2.17 14.84 15.08 13.56c4.62-.46 8.12-4.08 8.45-7.92.56-6.48-1.9-9.51-5.72-12.47-6.19-4.78-12.11-3.71-12.11-3.71zM69.27 74.2c-2.29 2.1-1.06 6.05 1.97 6.48 3.03.42 4.66-2.1 4.43-4.01-.34-2.96-3.79-4.86-6.4-2.47zM39.36 70.3s-2.02 5.54 2.25 12.48c1.82 2.95 5.87 4.61 8.73 4.5 3.02-.11 5.75-1.16 8.09-4.08 3.73-4.65 2.67-12.39 2.67-12.39s-5.91 2.43-11.33 2.25C44 72.88 39.36 70.3 39.36 70.3zM31.99 112.7c-1.47-.45-2.06 1.83-2.16 3.28s-.09 3.33 1.22 3.8c1.31.47 1.05-2.32 1.17-3.24.24-1.77 1.32-3.37-.23-3.84zM37.76 113.55c-.88-.04-1.81.85-1.92 3.43-.09 2.16 0 3.94 1.22 4.04 1.64.13 1.18-1.97 1.27-3.71.04-.99 1.26-3.67-.57-3.76zM60.15 116.36c-1.41 0-1.45 1.6-1.45 3.33 0 1.74-.36 3.89 1.22 4.08 1.92.23 1.55-2.35 1.55-3.8-.01-1.26.22-3.61-1.32-3.61zM66.53 116.04c-1.13.23-1.03 1.78-.99 3.66.05 1.88-.23 3.87 1.36 3.71 1.36-.14 1.27-2.35 1.22-4.04-.04-1.46.15-3.7-1.59-3.33zM85.86 103.81c-.97-.19-2.07.63-2.35 2.82-.23 1.88-.14 3.53 1.5 3.89.84.19.99-1.97 1.03-3.52.05-1.34 1.04-2.95-.18-3.19zM91.16 104.95c-.93-.15-1.84.42-2.08 2.75-.14 1.36-.64 3.8 1.05 3.89 1.31.06 1.21-2.09 1.33-3.21.19-1.77 1.23-3.17-.3-3.43z"
                ></path>
              </svg>
            </div>
            {/* block-un */}

            <div className="block-deux">
              <div className="a">
                <p>{t("--an error has occurred")} </p>
              </div>

              <div className="b">
                <p>{t("--check your virtual number or try again later")}</p>
              </div>
              {/* b */}
            </div>
            {/* block-deux */}

            <div className="block-trois">
              <button onClick={CloseErreurConnexionAA}>{t("--terminate")}</button>
            </div>
            {/* block-trois */}
          </div>
          {/* erreurConnexionAA */}
        </>
      )}
      {/* erreur (connexion) - AA */}



      {/* izocash app - page */}
      {/* izocash app - page */}
      {/* quand on clique, on est dans l'application izocash */}
      {/* donc ca c'est l'application izocash */}
      {izocashApp && (
        <>
          <div className="izocashApp-opacity">
            {/* head (la tete) - izocashApp */}
            {/* head (la tete) - izocashApp */}
            {/* head (la tete) - izocashApp */}
            <div className="navbar">
              <div className="logo">
                <div className="a">
                  <img
                    onClick={CloseIzocashPageDaccueilGotoMenuTelephone}
                    src={izocashLogoAccueil}
                    alt=""
                  />
                </div>
                {/* a */}

                <div className="b">
                  <svg
                    onClick={PopupToRightIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                    strokeMiterlimit="2"
                    clipRule="evenodd"
                    viewBox="0 0 64 64"
                  >
                    <path fill="none" d="M-256 -64H1024V736H-256z"></path>
                    <g>
                      <g>
                        <circle cx="32.026" cy="12.028" r="4"></circle>
                        <circle cx="32.026" cy="52.028" r="4"></circle>
                        <circle cx="32.026" cy="32.028" r="4"></circle>
                      </g>
                    </g>
                  </svg>
                </div>
                {/* b */}
              </div>
              {/* logo */}

              <div className="subNavbar">

                {/* Compte Points Retrait */}
                {typeAccountIA === "2" && (<>

                {/* stock national */}
                {head1666izocashApp && (
                  <>
                    <div className="ongletActive">
                      <p>SN</p>
                      <div className="barreActive"> <hr /> </div>
                    </div>
                  </>
                )}

                {!head1666izocashApp && (
                  <>
                    <div onClick={Head1666izocashApp} className="ongletNonActive">
                      <p>SN</p>
                      <div className="barreNonActive"> <hr /> </div>
                    </div>
                  </>
                )}


                {/* stock international */}
                {head2666izocashApp && (
                  <>
                    <div className="ongletActive">
                      <p>SI</p>
                      <div className="barreActive"> <hr /> </div>
                    </div>
                  </>
                )}

                {!head2666izocashApp && (
                  <>
                    <div onClick={Head2666izocashApp} className="ongletNonActive">
                      <p>SI</p>
                      <div className="barreNonActive"> <hr /> </div>
                    </div>
                  </>
                )} 
              </>)} {/* typeAccountIA === "2" se ferme ici */}


                {/* Compte Personnel */}
                {typeAccountIA === "1" && (<>

                {/* solde national */}
                {head3666izocashApp && (
                  <>
                    <div className="ongletActive">
                      <p>National</p>
                      <div className="barreActive"> <hr /> </div>
                    </div>
                  </>
                )}

                {!head3666izocashApp && (
                  <>
                    <div onClick={Head3666izocashApp} className="ongletNonActive">
                      <p>National</p>
                      <div className="barreNonActive"> <hr /> </div>
                    </div>
                  </>
                )}
                

                {/* solde international) */}
                {head4666izocashApp && (
                  <>
                    <div className="ongletActive">
                      <p>International</p>
                      <div className="barreActive"> <hr /> </div>
                    </div>
                  </>
                )}

                {!head4666izocashApp && (
                  <>
                    <div  onClick={Head4666izocashApp} className="ongletNonActive">
                      <p>International</p>
                      <div className="barreNonActive"> <hr /> </div>
                    </div>
                  </>
                )}
                </>)} {/* typeAccountIA === "1" se ferme ici */}

              </div>
              {/* subNavbar */}
            </div>
            {/* navbar */}
            {/* head */}

            {/* body */}
            {/* body */}
            <div className="body">

              {/* Stock national */}
              {head1666izocashApp && typeAccountIA === "2" && (<>
                  <div className="solde">
                    <div onClick={RefreshBalanceIA} className="block-one">
                      <p>{stockNationalIA} FCFA</p>
                      <li>Stock national</li>
                    </div>

                    <div className="block-two"> {dev && (<><button> <p>Stock national</p> </button></>)} </div>
                  </div>
                </>)}

              {/* Stock international */}
              {head2666izocashApp && typeAccountIA === "2" && (<>
                  <div className="solde">
                    <div onClick={RefreshBalanceIA} className="block-one">
                      <p>{stockInternationalIA} FCFA</p>
                      <li>Stock international</li>
                    </div>

                    <div className="block-two"> {dev && (<><button> <p>Stock international</p> </button></>)} </div>
                  </div>
                </>)}

              {/* solde national */}
              {head3666izocashApp && typeAccountIA === "1" && (<>
                  <div className="solde">
                    <div onClick={RefreshBalanceIA} className="block-one">
                      <p>{balanceNationalAccountIA} FCFA</p>
                      <li>Solde du compte</li>
                    </div>

                    <div className="block-two"> <button onClick={NationalPlusIA}> <p>Compte national</p><SvgRight4 /> </button> </div>
                  </div>
                </>)}

              {/* solde international */}
              {head4666izocashApp && typeAccountIA === "1" && (<>
                  <div className="solde">
                    <div onClick={RefreshBalanceIA} className="block-one">
                      <p>{balanceInternationalAccountIA} FCFA</p>
                      <li>Solde du compte</li>
                    </div>

                    <div className="block-two">
                      <button> <p>Compte international</p> </button>
                      {dev && (<> <button onClick={InternationalPlusIA}> <p>Compte international</p><SvgRight4 /> </button> </>)}
                    </div>
                    {/* block-two */}
                  </div>
                  {/* solde */}
                </>)}
            </div>
            {/* body */}

            {/* footer */}
            {/* footer */}
            {/* {typeAccountIA === "2" && (<> */}
            <div className="footer-izocash">
              <hr />
              <div className="center">
                {!dev && (<> <p></p> </>)}
                {dev && (<><div className="a"> <SvgQuestionMark3 /> </div></>)}
                <div onClick={FooterMiniMenuIA} className="a"> <SvgHorizontal /> </div>
              </div>
              {/* center */}
            </div>
            {/* footer-izocash */}
            {/* footer */}
          </div>
          {/* izocashApp-opacity */}
        </>
      )}
      {/* izocash app - page */}

      {/* ecran de demarrage - izocash app */}
      {/* ecran de demarrage - izocash app */}
      {/* sur cette page on a mis l'ecran de demarrage de notre application izocash */}
      {ecranDemarrageIA && (
        <>
          <div className="ecranDemarrageIA-opacity">
            <div className="align">
              <div className="logo">
                <img src={izocashEcranDemmarrage} alt="" />
              </div>
              {/* logo */}
            </div>
            {/* align */}
          </div>
          {/* ecranDemarrageIA-opacity */}
        </>
      )}
      {/* ecran de demarrage - izocash app */}

      {/* footer mini Menu - IA */}
      {/* footer mini Menu - IA */}
      {footerMiniMenuIA && (
        <>
          <div onClick={CloseFooterMiniMenuIA} className="business-opacity">
            <div className="bottom">
              <div className="card">
                <div className="block">
                  {dev && (<>
                    <p onClick={ChoisirCompteARechargerIA}>Recharger... devient Effectuer un retrait</p>
                    <p onClick={DepositNationalPageIA}>Faire un Versement National</p>
                    <p onClick={RechargeNationalPageIA}>Faire une Recharge National</p>
                    <p onClick={EntrerCodeOperationRechargeCompteIzocash}>Éffectuer un Retrait</p>
                    <p onClick={InitierOperationIA}>Initier une opération</p>
                    <p>Bloquer un compte</p>
                    <p onClick={BeginIdentificationPageIA}>Identifier un Numéro virtuel</p>
                    <p onClick={DelivrerNumeroVirtuelPageIA}>Délivrer un Numéro virtuel</p>
                    <p onClick={IzocashInternational}>Transfert d'argent</p>
                  </>)}

                  {typeAccountIA === "2" && (<>
                    <p onClick={DepositNationalPageIA}>Faire un Versement National</p>
                    <p onClick={BeginIdentificationPageIA}>Identifier un Numéro virtuel</p>
                    <p onClick={ChooseIndicativeIA}>Délivrer un Numéro virtuel</p>
                  </>)}
                  
                  {identificationIA === "0" && (<>
                    <p onClick={BeforeIdentificationCodePageIA}>Identifier mon Numéro virtuel</p>
                  </>)}

                  {typeAccountIA === "1" && identificationIA === "1" && izocashDealsActiveIA === "1" && (<>
                    <p onClick={IzocashDealsIA}>izocash Deals</p>
                  </>)}
                 
                  {dev && (<>
                    <p onClick={IzocashDealsIA}>izocash Deals</p>
                    <p onClick={IzocashBuy2IA}>izocash 2 Achats</p>
                    <p onClick={BeforeIdentificationCodePageIA}>Identifier mon Numéro virtuel</p>
                    <p onClick={ToolsIA}>Outils</p>
                    <p onClick={PlusIA}>Plus</p>
                  </>)}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* bottom */}
          </div>
          {/* business-opacity */}
        </>
      )}
      {/* footer mini Menu - IA */}

      {/* Tools -  IA */}
      {/* Tools -  IA */}
      {/* on affiche mes outils */}
      {toolsIA && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={CloseToolsIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Mes outils</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>Outils</p>
            </div>
            {/* block-un */}

            <div className="block-deux">
              <p>Identification</p>
              <hr />
            </div>

            <div onClick={IdentificationDealsIA} className="block-deux">
              <p>Identification Deals</p>
              <hr />
            </div>

            <div onClick={IdentificationFormationIA} className="block-deux">
              <p>Identification Formation</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* Tools - IA */}

      {/* plus - IA */}
      {/* plus - IA */}
      {/* on affiche les outils a activer */}
      {plusIA && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={ClosePlusIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>izocash</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>Plus</p>
            </div>
            {/* block-un */}

            <div onClick={ActivateIdentificationPageIA} className="block-deux">
              <p>Identification</p>
              <hr />
            </div>

            <div onClick={ActivateIdentificationDealsPageIA} className="block-deux">
              <p>Identification Deals</p>
              <hr />
            </div>

            <div onClick={ActivateIdentificationFormationPageIA} className="block-deux">
              <p>Identification Formation</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* Plus - IA */}
      
      {/* activate Identification (Page) - IA */}
      {/* activate Identification (Page) - IA */}
      {/* sur cette page on active Identification */}
      {activateIdentificationPageIA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  izocash <b>Identification</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateIdentificationPageIA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Soyez rémunérer chaque fois qu'une personne utilisera votre Super code pour identifier son numéro virtuel</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Identification (Page) - IA */}

      {/* activate Identification Deals (Page) - IA */}
      {/* activate Identification Deals (Page) - IA */}
      {/* sur cette page on active Identification Deals - IA */}
      {activateIdentificationDealsPageIA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Identification <b>Deals</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateIdentificationDealsPageIA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Celui qui veut activer la izocash Identification utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lorsqu'il réactivera</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Identification Deals (Page) - IA */}

      {/* activate Identification Formation (Page) - IA */}
      {/* activate Identification Formation (Page) - IA */}
      {/* sur cette page on active Identification Formation - IA */}
      {activateIdentificationFormationPageIA && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Identification <b>Formation</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateIdentificationFormationPageIA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Celui qui veut activer Identification Deals utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lors de la réactivation</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Identification Formation (Page) - IA */}

       {/* Identification (Page) - IA */}
       {/* Identification (Page) - IA */}
       {identificationPageIA && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>izocash <b>Identification</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseIdentificationPageIA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* Identification (Page) - IA */}

       {/* Identification Deals - IA */}
       {/* Identification Deals - IA */}
       {identificationDealsIA && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>Identification <b>Deals</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseIdentificationDealsIA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* identification Deals - IA */}

      {/* identification Formation - IA */}
      {/* identification Formation - IA */}
      {identificationFormationIA && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>Identification <b>Formation</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseIdentificationFormationIA}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* Identification Formation - IA */}

      {/* national Plus - IA */}
      {/* national Plus - IA */}
      {/* c'est le menu pour national Plus */}
      {nationalPlusIA && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={CloseNationalPlusIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>izocash</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>National Plus</p>
            </div>
            {/* block-un */}

            <div onClick={RechargeAlraniPayPageIA} className="block-deux">
              <p>Recharge Alrani Pay</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* national Plus - IA */}

      {/* Recharge Alrani Pay (Page) - IA */}
      {/* Recharge Alrani Pay (Page) - IA */}
      {/* page pour recharger mon compte Alrani Pay */}
      {rechargeAlraniPayPageIA && (
        <>
          <div className="offrirNumeroVirtuelPageIAC">
            <div className="close">
              <p onClick={CloseRechargeAlraniPayPageIA}>Recharge Alrani Pay</p>
            </div>
            {/* close */}

            <div className="align">
              <div className="card">
                <div className="block-un">
                  <div className="a"> <p>Recharger mon compte Alrani Pay</p> </div>
                  <div className="b"> <p>Saisir le montant à recharger</p> </div>
                </div>
                {/* block-un */}

                <div className="block-deux"> <input type="text" value={writeAmountIA} onChange={(e) => setWriteAmountIA(e.target.value)} /> </div>
                {/* block-deux */}

                <div onClick={RechargeAlraniPayConfirmationIA} className="block-trois">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p>Recharger</p>
                </div>
                {/* block-trois */}

                <div className="block-quatre">
                  <hr />
                </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* offrirNumeroVirtuelPageIAC */}
        </>
      )}
      {/* Recharge Alrani Pay (Page) - IA */}

      {/* Recharge Alrani Pay Confirmation - IA */}
      {/* Recharge Alrani Pay Confirmation - IA */}
      {/* confirmer si tu veux vraiment recharger ton compte Alrani Pay */}
      {rechargeAlraniPayConfirmationIA && (<>
          <div className="offrirNumeroConfirmationIAC">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <h6>Confirmation</h6>
                  <p>Voulez-vous vraiment éffectuer une Recharge Alrani Pay de {writeAmountIA} FCFA ?</p>
                </div>
                {/* block-un */}

                <hr />
                <div className="block-trois"> <p onClick={RechargeAlraniPay}>Oui</p> </div>
                {/* block-trois */}

                <hr />
                <div className="block-quatre"> <p onClick={CloseRechargeAlraniPayConfirmationIA}>Annuler</p> </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* offrirNumeroConfirmationIAC */}
        </>)}
      {/* Recharge Alrani Pay Confirmation - IA */}

      
      {/* recharge Alrani Pay réussie (message de success) - IA */}
      {/* recharge Alrani Pay réussie (message de success) - IA */}
      {rechargeAlraniPaySuccessIA && (<>
          <div onClick={CloseRechargeAlraniPaySuccessIA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Recharge Alrani Pay réussie</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* recharge Alrani Pay réussie (message de success) - IA  */}


      {/* error Recharge Alrani Pay (message d'erreur) - IA */}
      {/* error Recharge Alrani Pay (message d'erreur) - IA */}
      {errorRechargeAlraniPayIA && (<>
          <div onClick={CloseErrorRechargeAlraniPayIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>COMPTE NATIONAL</p> </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois"> <p>Vous n'avez pas assez d'argent dans votre Compte National</p> </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>)}
      {/* error Recharge Alrani Pay (message d'erreur) - IA */}
	  

      {/* international Plus - IA */}
      {/* international Plus - IA */}
      {/* c'est le menu pour international Plus */}
      {internationalPlusIA && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={CloseInternationalPlusIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>izocash</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>international Plus</p>
            </div>
            {/* block-un */}

            <div onClick={MyRechargeNationalPageIA} className="block-deux">
              <p>Recharger mon compte national</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* international Plus - IA */}

      {/* my recharge National Page - IA */}
      {/* my recharge National Page - IA */}
      {/* page pour recharger mon compte national - IA */}
      {myRechargeNationalPageIA && (
        <>
          <div className="completerInformationEntreprisePageIA">
            <div className="close">
              <svg
                onClick={CloseMyRechargeNationalPageIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Recharge National</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>Recharger mon compte national</p>
            </div>
            {/* block-un */}

            <div className="block-trois">
              <div className="a">
                <p></p>
              </div>

              <div className="b">
                <p>Montant à recharger</p>
                <input 
                type="text"
                value={writeAmount}
                onChange={(e) => setWriteAmount(e.target.value)}
                />
              </div>
              {/* b */}
            </div>
            {/* block-trois */}

            <div onClick={MyRechargeNationalConfirmationIA} className="block-quatre">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                cursor="pointer"
                fill="#000"
                data-name="Layer 2"
                viewBox="0 0 32 32"
              >
                <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
              </svg>
              <p>Recharger</p>
            </div>
            {/* block-quatre */}
          </div>
          {/* completerInformationEntreprisePageIA */}
        </>
      )}
      {/* my recharge National Page - IA */}

      {/* My Recharge National Confirmation - IA */}
      {/* My Recharge National Confirmation - IA */}
      {/* Confirmer my recharge National */}
      {myRechargeNationalConfirmationIA && (
        <>
          <div className="confirmerRechargeIA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Confirmation</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Voulez-vous recharger {writeAmount} FCFA dans votre Compte izocash National !</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="a">
                    <button onClick={CloseMyRechargeNationalConfirmationIA}>Annuler</button>
                  </div>
                  {/* a */}
                
                  <div className="b">
                    <button onClick={MyRechargeNationalIA}>Valider</button>
                  </div>
                  {/* b */}
                
                  <div className="rechargeActive">
                    <button onClick={MyRechargeNationalIA}>Valider</button>
                  </div>
                  {/* rechargeActive */}
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* confirmerRechargeIA */}
        </>
      )}
      {/* my Recharge National Confirmation - IA */}

      {/* my recharge National Success - IA */}
      {/* my recharge National Success - IA */}
      {myRechargeNationalSuccessPageIA && (
        <>
          <div onClick={CloseMyRechargeNationalSuccessPageIA} className="importationPhotoDidentiterEntrepriseSuccessIA">
            <div className="align">
              <div className="card">
                <div className="display">
                  <p>Recharge réussie</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#00cc00"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M20 7L9 18l-5-5"
                    ></path>
                  </svg>
                </div>
                {/* display */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* importationPhotoDidentiterEntrepriseSuccessIA */}
        </>
      )}
      {/* my recharge National Success - IA */}


      {/* versement national (Page) - IA */}
      {/* versement national (Page) - IA */}
      {depositNationalPageIA && (
        <>
          <div className="depositNationalPageIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <div className="aa"> <p onClick={CloseDepositNationalPageIA}>Versement National</p> </div>
                    <div className="bb"> <button onClick={DepositNationalIA}>Déposer</button> </div>
                  </div>
                  {/* a */}

                  <div className="b"> <p>Déposer de l'argent dans le Compte National d'un Client</p> </div>
                  {/* b */}
                </div>
                {/* close */}
                
                {/* Numéro virtuel */}
                <div className="block-un">
                  <p>Numéro virtuel du Client</p>
                  <input type="text" placeholder="numéro.." value={writeVirtualNumber} onChange={(e) => setWriteVirtualNumber(e.target.value)} /> 
                </div>

                {/* Montant à déposer */}
                <div className="block-un">
                  <p>Montant à déposer</p>
                  <input type="text" placeholder="montant.." value={writeAmount} onChange={(e) => setWriteAmount(e.target.value)} />
                </div>
                
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* depositNationalPageIA */}
        </>
      )}
      {/* versement national (Page) - IA */}



      {/* recharge national (Page) - IA */}
      {/* recharge national (Page) - IA */}
      {rechargeNationalPageIA && (
        <>
          <div className="rechargeAccountIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <div className="aa"> <p onClick={CloseRechargeNationalPageIA}>Recharge National</p> </div>
                    <div className="bb"> <button onClick={RechargeNationalIA}>Recharger</button> </div>
                  </div>
                  {/* a */}

                  <div className="b"> <p>Recharger le Stock National d'un Client</p> </div>
                  {/* b */}
                </div>
                {/* close */}


                {/* Numéro virtuel */}
                <div className="block-un">
                  <p>Numéro virtuel du Client</p>
                  <input type="text" placeholder="numéro.." value={writeVirtualNumber} onChange={(e) => setWriteVirtualNumber(e.target.value)} /> 
                </div>

                {/* Montant à recharger */}
                <div className="block-un">
                  <p>Montant à recharger</p>
                  <input type="text" placeholder="montant.." value={writeAmount} onChange={(e) => setWriteAmount(e.target.value)} />
                </div>
                
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeAccountIA */}
        </>
      )}
      {/* recharge national (Page) - IA */}


      {/* recharge national success - IA */}
      {/* recharge national success - IA */}
      {/* ca c'est le recu (on l'affiche une fois que le versement national a reussi) */}
      {rechargeNationalSuccessIA && (
        <>
          <div className="delivrerNumeroVirtuelSuccessIA">
            <div className="align">
              <div className="block-un">
                <p>{dateParserNumeric(dateIA)}</p>
                <p>{nameOwnerIA}</p>
              </div>
              {/* block-un */}

              <div className="hr"> <hr /> </div>

              <div className="block-deux">
                <div className="a"> 
                  <div className="aa"> <p>La Recharge du Stock a réussi.</p> </div>
                  <div className="bb"> <p>Stock National</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <p>Numéro virtuel:</p>
                  <p>{virtualNumberIA}</p>
                </div>
                {/* b */}

                <div className="c">
                  <p>Propriétaire: {nameOwnerVirtualNumberIA}</p>
                  <p>Frais de versement: {feesIA} FCFA</p>
                  <p>Total: {totalIA} FCFA</p>
                </div>
                {/* c */}
              </div>
              {/* block-deux */}

              <div className="hr"> <hr /> </div>

              <div onClick={CloseRechargeNationalSuccessIA} className="block-trois">
                <p>ID: {idNotificationIA}</p>
                <SvgClose3 />
              </div>
              {/* block-trois */}

              <div className="block-four"> <p>Pour toutes réclamations, n'hésiter pas à contacter {nameOwnerIA} au {phoneNumberIA} ou contacter directement izocash sur Alrani</p> </div>
              {/* block-four */}

            </div>
            {/* align */}
          </div>
          {/* delivrerNumeroVirtuelSuccessIA */}
        </>
      )}
      {/* recharge national Success - IA */}


      {/* recharge national Success 2 - IA */}
      {/* recharge national Success 2 - IA */}
      {rechargeNationalSuccess2IA && (
        <>
          <div onClick={CloseRechargeNationalSuccess2IA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Recharge réussi</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>
      )}
      {/* recharge national Success 2 - IA */}


      {/* recharge Error - IA */}
      {/* recharge Error - IA */}
      {/* si la recharge a echouer on affiche ce message d'erreur */}
      {rechargeErrorIA && (
        <>
          <div onClick={CloseRechargeErrorIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>le Stock de l'agence est insuffisant !</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <hr />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <p>Impossible d'éffectuer la recharge</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* recharge Error - IA */}

      {/* izocashBuy 2 - IA */}
      {/* izocashBuy 2 - IA */}
      {/* sur cette page on va afficher la liste des personnes qui ont acheter leur numero 
      virtuel avec mon super code, on va aussi afficher mon solde izocashBuyIA */}
      {izocashBuy2IA && (
        <>
          <div className="izocashBuy2IA">
            <div className="close">
              <div className="a">
                <div onClick={CloseIzocashBuy2IA} className="p">
                  izocash Achats
                </div>
                {/* p */}
              </div>
              {/* a */}

              <div className="b">
                <div className="p">
                  Ces personnes ont acheter leur numero virtuel avec votre super
                  code
                </div>
                {/* p */}
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="p">100 000 FCFA</div>
              {/* p */}
            </div>
            {/* solde */}

            <div className="retrait">
              <div className="p">Retrait</div>
              {/* p */}
            </div>
            {/* retrait */}

            <div className="verser">
              <span>
                verser mon argent dans mon solde izocash international
              </span>
              {/*  */}
            </div>
            {/* verser */}

            <div className="kilendo">
              <div className="p">kilendo a acheter son nv</div>
              {/* p */}
            </div>
            {/* kilendo */}

            <div className="amesia">
              <div className="p">amesia a acheter son nv</div>
              {/* p */}
            </div>
            {/* amesia */}

            <div className="desti">
              <div className="p">desti a acheter son nv</div>
              {/* p */}
            </div>
            {/* desti */}

            <div className="diane">
              <div className="p">diane a acheter son nv</div>
              {/* p */}
            </div>
            {/* diane */}

            <div className="veil">
              <p>veil a acheter son nv</p>
            </div>
            {/* veil */}

            <div className="topzer">
              <p>topzer a acheter son nv</p>
            </div>
            {/* topzer */}

            <div className="lise">
              <div className="p">lise a acheter son nv</div>
              {/* p */}
            </div>
            {/* lise */}

            <div className="rosia">
              <div className="p">rosia a acheter son nv</div>
              {/* p */}
            </div>
            {/* rosia */}

            <div className="david">
              <div className="p">david a acheter son nv</div>
              {/* p */}
            </div>
            {/* david */}
          </div>
          {/* izocashBuy2IA */}
        </>
      )}
      {/* izocashBuy 2 - IA */}


      {/* izocash Deals - IA */}
      {/* izocash Deals - IA */}
      {/* sur cette page on va afficher la liste des personnes qui ont acheter leur numero 
      virtuel avec mon super code, la liste des personnes qui ont activer izocash Deals avec mon 
      super code, on va aussi afficher mon solde izocash Deals */}
      {izocashDealsIA && (<>
          <div className="izocashDealsIA">
            <div className="close">
              <div className="a">
                <p>izocash <b>Deals</b></p>
              </div>

              <div className="b">
                <div onClick={Menu666izocashDealsIA} className="aa"> <SvgVertical /> </div>
                <div onClick={Infos666izocashDealsIA} className="bb"> <SvgInfos3 /> </div>
                <div className="cc"> <button onClick={CloseIzocashDealsIA}>Fermer</button> </div>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div onClick={RefreshBalanceIA} className="solde">
              <div className="a"> <p>{izocashDealsBalanceIA} FCFA</p> </div>
              <div className="b"> <p>Solde disponible</p> </div>
            </div>
            {/* solde */}

              <div className="head">
                {/* Commissions */}
                {head1666izocashBuyIA && (<><div className="active"> <button>Commissions</button> </div></>)}
                {!head1666izocashBuyIA && (<><div className="noActive"> <button onClick={Head1666izocashBuyIA}>Commissions</button> </div></>)}

                {/* Base de données */}
                {dev && (<>
                {head2666izocashBuyIA && (<><div className="active"> <button>Base de données</button> </div></>)}
                {!head2666izocashBuyIA && (<><div className="noActive"> <button onClick={Head2666izocashBuyIA}>Base de données</button> </div></>)}
                </>)}

                {/* Super code */}
                {head3666izocashBuyIA && (<>
                <div className="active"> 
                  <button> 
                    <div className="a"> <p>Super</p> </div> 
                    <div className="b"> <p>code</p> </div> 
                  </button> 
                </div></>)}

                {!head3666izocashBuyIA && (<>
                <div className="noActive"> 
                  <button onClick={Head3666izocashBuyIA}> 
                    <div className="a"> <p>Super</p> </div> 
                    <div className="b"> <p>code</p> </div> 
                  </button> 
                </div></>)}
              </div>
              {/* head */}


              <div className="body">

              {dev && (<>
                {/* -- body 1 (Commissions) -- */}
                {/* -- body 1 (Commissions) -- */}
                {head1666izocashBuyIA && (
                  <>
                    <ChildApiHistoryIzocashBuyIA />

                    <div className="block-un">
                      <button onClick={SendMoneyPage666izocashBuyIA}>Envoyer dans mon Compte international</button>

              {/* sendMoneyPage (666izocashBuyIA) */}
              {/* envoyer de l'argent: izocash buy => izocash international */}
              {sendMoneyPage666izocashBuyIA && (
                <>
                  <div className="editProfil">
                    <div className="card">
                      <div className="close">
                        <p onClick={CloseSendMoneyPage666izocashBuyIA}>{t("--izocash buy to")}</p>
                        <svg
                          onClick={CloseSendMoneyPage666izocashBuyIA}
                          xmlns="http://www.w3.org/2000/svg"
                          x="0"
                          y="0"
                          cursor="pointer"
                          width="10px"
                          fill="#ccc"
                          enableBackground="new 0 0 25.93 25.93"
                          version="1.1"
                          viewBox="0 0 25.93 25.93"
                          xmlSpace="preserve"
                        >
                          <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                        </svg>
                      </div>
                      {/* close */}

                      <div className="block-un">
                        <p>Saisir le montant à envoyer</p>
                      </div>
                      {/* block-un */} 

                      <div className="block-deux"> <textarea value={writeAmount} onChange={(e) => setWriteAmount(e.target.value)}></textarea> </div>
                      {/* block-deux */}

                      <div onClick={SendMoney666izocashBuyIA} className="block-trois">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="#000"
                          data-name="Layer 2"
                          viewBox="0 0 32 32"
                        >
                          <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                        </svg>
                        <p>Envoyer</p>
                      </div>
                      {/* block-trois */}
                    </div>
                    {/* card */}
                  </div>
                  {/* editProfil */}
                </>
              )}
              {/* sendMoneyPage (666izocashBuyIA) */}

                    </div>
                    {/* block-un */}
                  </>
                )}
                {/* -- body 1 (Commissions) -- */}
              </>)} {/* le code de dev se ferme ici */}

                {/* -- body 2 (Base de données) -- */}
                {/* -- body 2 (Base de données) -- */}
                {head2666izocashBuyIA && (
                  <>
                    <div className="database"> <p>Base de données des personnes qui ont achetées leur numéro virtuel avec votre super code</p> </div>
                    {/* database */}
                  </>
                )}
                {/* -- body 2 (Base de données) -- */}

                {/* -- body 3 (Super code) -- */}
                {/* -- body 3 (Super code) -- */}
                {head3666izocashBuyIA && (
                  <>
                    <div className="superCode">
                      <div className="block-one">
                        <div className="a"> <p>Votre Super code izocash Deals</p> </div>
                        <div className="b"> <p>{izocashDealsCodeIA}</p> <SvgValidate3 /> </div>
                      </div>
                      {/* block-one */}

                      {writeSuperCodeIzocashDealsPageIA && (<>
                      <div className="block-two">
                        <div className="a"> <p>Saisir votre Super code izocash Deals</p> </div>
                        {/* a */}

                        <div className="b">
                          <div className="aa"> <input value={writeSuperCode} onChange={(e) => setWriteSuperCode(e.target.value)} type="text" placeholder="Super code.." /> </div>
                          <div onClick={WriteSuperCodeIzocashDealsPageIA} className="bb"> <SvgBottom4 /> </div>
                        </div>
                        {/* b */}

                        <div className="c"> <button onClick={SaveIzocashDealsCodeIA}>Enregistrer</button> </div>
                        {/* c */}
                      </div></>)}
                      {/* block-two */}

                      <div className="block-three">
                        <div className="aa"> </div>
                        <div onClick={WriteSuperCodeIzocashDealsPageIA} className="bb"> <SvgPencil3 /> </div>
                      </div>
                      {/* block-three */}
                    </div>
                    {/* superCode */}
                  </>
                )}
                {/* -- body 3 (Super code) -- */}
              </div>
              {/* body */}
          </div>
          {/* izocashDealsIA */}
        </>)}
        {/* izocash Deals - IA */}


      {/* super code enregistré (message de success) - IA */}
      {/* super code enregistré (message de success) - IA */}
      {superCodeSuccessIA && (<>
        <div onClick={CloseSuperCodeSuccessIA} className="toastRefreshIA">
          <div className="bottom">
            <div className="card">
              <button> <p>Super code enregistré</p><SvgValidate4 /> </button>
            </div>
            {/* card */}
          </div>
          {/* bottom */}
        </div>
        {/* toastRefreshIA */}
      </>)}
      {/* super code enregistré (message de success) - IA */}


      {/* menu (666 izocash Deals) - IA */}
      {/* menu (666 izocash Deals) - IA */}
      {menu666izocashDealsIA && (
        <>
          <div onClick={CloseMenu666izocashDealsIA} className="menuVB">
            <div className="align">
              <div className="card">
                <div onClick={DoubleProfit666izocashDeals} className="a"> <p>Double Bénéfice</p> <SvgRight3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* menuVB */}
        </>
      )}
      {/* menu (666 izocash Deals) - IA */}


      {/* infos (666 izocash Deals) - IA */}
      {/* infos (666 izocash Deals) - IA */}
      {infos666izocashDealsIA && (<>
      <div onClick={CloseInfos666izocashDealsIA} className="infosLanguage">
        <div className="align">
          <div className="card">
            <p>L'avantage du Double Bénéfice, si la Personne qui a achetée son Numéro virtuel avec votre Super code active lui aussi à son tour izocash Deals alors vous allez gagnez Doublement c'est à dire la même commission que vous avez reçu lors de l'achat du Numéro virtuel vous allez recevoir la même commission lorsqu'il activera izocash Deals</p>
            <hr />
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* infosLanguage */}
      </>)}
      {/* infos (666 izocash Deals) - IA */}


      {/* double benefice - page */}
      {/* double benefice - page */}
      {doubleProfit666izocashDeals && (
        <>
          <div className="bouton-principal-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseDoubleProfit666izocashDeals} style={{ cursor: "pointer" }} className="block-title">
                  <div className="title"> <p>Double Bénéfice</p> </div>
                  <div className="hr"> <hr /> </div>
                </div>
                {/* block-title */}

                <div className="block">
                  <div className="space">
                    <p onClick={CloseDoubleProfit666izocashDeals} style={{ cursor: "pointer" }}>Gagnez Doublement avec izocash Deals</p>

                    {izocashDealsDoubleProfitIA === "1" ? (
                    <><div> <SvgToggleActive /> </div></>
                    ) : (
                    <><div onClick={ActivateDoubleProfitIA}> <SvgToggleInactive /> </div></> )}
                  </div>
                  {/* space */}

                  <div onClick={CloseDoubleProfit666izocashDeals} className="detail" style={{ cursor: "pointer" }}> <p>Profitez de l'avantage du Double Bénéfice</p> </div>
                  {/* detail */}

                  <div onClick={CloseDoubleProfit666izocashDeals} className="hr" style={{ cursor: "pointer" }}> <hr /> </div>
                  {/* hr */}
                </div>
                {/* block */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* bouton-principal-opacity */}
        </>
      )}
      {/* double benefice - page */}


      {/* double bénéfice activé (message de success) - IA  */}
      {/* double bénéfice activé (message de success) - IA  */}
      {doubleProfitSuccessIA && (<>
        <div onClick={CloseDoubleProfitSuccessIA} className="toastRefreshIA">
          <div className="bottom">
            <div className="card">
              <button> <p>Double bénéfice activé</p><SvgValidate4 /> </button>
            </div>
            {/* card */}
          </div>
          {/* bottom */}
        </div>
        {/* toastRefreshIA */}
      </>)}
      {/* double bénéfice activé (message de success) - IA  */}

      
      {/* choisir l'indicatif du numero virtuel - IA */}
      {/* choisir l'indicatif du numero virtuel - IA */}
      {chooseIndicativeIA && (
        <>
          <div className="chooseIndicativeIA">
            <div className="close">
              <div onClick={CloseChooseIndicativeIA} className="a"> <SvgLeft /> </div>
              <div className="b"> <p>izocash</p> </div>
            </div>
            {/* close */}

            <div className="hr"> <hr /> </div>
            {/* hr */}

            <div className="block-un">
              <div className="a"> <p>Indicatif</p> </div>
              <div className="b"> <p>Choisir l'indicatif du Numéro virtuel</p> </div>
            </div>
            {/* block-un */}


            <div onClick={IndicativeOneIA}>
              <div onClick={DeliverVirtualNumberPageIA} className="block-deux">
                <div className="a"> <p>{indicativeOneIA}</p> </div>

                <div className="b">
                  <div className="aa"> <p>Prix</p> </div>
                  <div className="bb"> <p>75 000 FCFA</p> </div>
                </div>
              </div>
              {/* block-deux */}
            </div>
            <div className="block-trois"> <hr /> </div>


            <div onClick={IndicativeTwoIA}>
              <div onClick={DeliverVirtualNumberPageIA} className="block-deux">
                <div className="a"> <p>{indicativeTwoIA}</p> </div>

                <div className="b">
                  <div className="aa"> <p>Prix</p> </div>
                  <div className="bb"> <p>75 000 FCFA</p> </div>
                </div>
              </div>  
              {/* block-deux */}
            </div>
            <div className="block-trois"> <hr /> </div>

          </div>
          {/* chooseIndicativeIA */}
        </>
      )}
      {/* choisir l'indicatif du numero virtuel - IA */}

      {/* delivrer un numero virtuel - IA */}
      {/* delivrer un numero virtuel - IA */}
      {/* page pour delivrer un numero virtuel */}
      {deliverVirtualNumberPageIA && (
        <>
          <div className="deliverVirtualNumberPageIA">
            <div className="close">
              <div onClick={CloseDeliverVirtualNumberPageIA} className="a"> <SvgLeft /> </div>
              <div className="b"> <p>Délivrer un Numéro virtuel</p> </div>
            </div>
            {/* close */}

            <div className="hr"> <hr /> </div>
            {/* hr */}

            <div className="block-un"> <p>Indicatif du Numéro virtuel : {indicativeIA}</p> </div>
            {/* block-un */}

            <div className="block-trois">
              <div className="a"> <p>Numéro virtuel</p> </div>

              <div className="b">
                <p>Écrire le Numéro virtuel</p>
                <input type="text" value={writeVirtualNumber} onChange={(e) => setWriteVirtualNumber(e.target.value)} />
              </div>
            </div>
            {/* block-trois */}

            <div className="block-trois">
              <div className="a"> <p>Nom du Propriétaire</p> </div>

              <div className="b">
                <p>Écrire le Nom du Propriétaire du Numéro virtuel</p>
                <input type="text" value={writeNameOwnerIA} onChange={(e) => setWriteNameOwnerIA(e.target.value)} />
              </div>
            </div>
            {/* block-trois */}

            <div onClick={ConfirmDeliverVirtualNumberPageIA} className="block-quatre">
              <SvgRight /><p>Continuer</p>
            </div>
            {/* block-quatre */}
          </div>
          {/* deliverVirtualNumberPageIA */}
        </>
      )}
      {/* delivrer un numero virtuel - IA */}

      {/* confirmer le numero virtuel a delivrer - IA */}
      {/* confirmer le numero virtuel a delivrer - IA */}
      {confirmDeliverVirtualNumberPageIA && (
        <>
          <div className="confirmerNumeroAdelivrerIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a"> <p></p></div>
                  <div onClick={CloseConfirmDeliverVirtualNumberPageIA} className="b"> <SvgBottom2 /> </div>
                </div>
                {/* close */}

                <div className="hr"> <hr /> </div>
                {/* hr */}

                <div className="numeroCard">
                  <div className="card">
                    <div className="block-un">
                      <div className="a">
                        <p>Numéro Virtuel :</p>
                        <p>{writeVirtualNumber}</p>
                      </div>

                      <div className="b"> <p>Propriétaire : {writeNameOwnerIA}</p> </div>
                    </div>
                    {/* block-un */}

                    <div className="block-deux"> <hr /> </div>
                    {/* block-deux */}

                    <div className="block-trois">
                      <div onClick={CloseConfirmDeliverVirtualNumberPageIA} className="a"> <SvgClose4 /> </div>
                      <div className="b"> <p>{namePersonConnectedIA}</p> </div>
                    </div>
                    {/* block-trois */}
                  </div>
                  {/* card */}
                </div>
                {/* numeroCard */}

                <div className="consigne"> <p>En cliquant sur Délivrer, le Numéro virtuel sera délivré</p> </div>
                {/* consigne */}

                <div className="btn"> 
                  <button onClick={DeliverVirtualNumberIA}> <p>Délivrer</p> <SvgValidate4 /> </button> 
                </div>
                {/* btn */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* confirmerNumeroAdelivrerIA */}
        </>
      )}
      {/* confirmer le numero virtuel a delivrer - IA */}



      {/* stock error - IA */}
      {/* stock error - IA */}
      {/* Stock insuffisant, on affiche ce message d'erreur */}
      {stockErrorIA && (
        <>
          <div onClick={CloseStockErrorIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>Stock insuffisant, impossible de délivrer le Numéro virtuel !</p> </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois"> <p>Veuiller recharger votre Stock National</p> </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* stock error - IA */}


      {/* Delivrer un Numero Virtuel (Page) - IA */}
      {/* Delivrer un Numero Virtuel (Page) - IA */}
      {/* on affiche la page pour delivrer un numero virtuel - IA */}
      {delivrerNumeroVirtuelPageIA && (
        <>
          <div className="delivrerNumeroVirtuelPageIA">
            <div className="close">
              <svg
                onClick={CloseDelivrerNumeroVirtuelPageIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#fff"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Délivrer un Numéro Virtuel</p>
            </div>
            {/* close */}

            <div className="alignTitre">
              <div className="titre">
                <div className="a">
                  <p>* Numéro personnel</p>
                </div>

                <div className="b">
                  <p>Pour un usage personnel</p>
                </div>
                {/* b */}
              </div>
              {/* titre */}
            </div>
            {/* alignTitre */}

            {/* numero virtuel 1 - IA */}
            {/* numero virtuel 1 - IA */}
            <div className="alignCard">
              <div className="card">
                <div className="block-un">
                  <p>2425</p>
                  <input
                    type="text"
                    placeholder="..."
                  />
                </div>
                {/* block-un */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-deux">
                  <p>2425</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <button onClick={EntrerNomProprietaireIA}>
                    <p>Valider</p>
                    <hr />
                  </button>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* alignCard */}

            {/* numero virtuel 2 - IA */}
            {/* numero virtuel 2 - IA */}
            <div className="alignCard">
              <div className="card">
                <div className="block-un">
                  <p>2422</p>
                  <input
                    type="text"
                    placeholder="..."
                  />
                </div>
                {/* block-un */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-deux">
                  <p>2425</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <button onClick={EntrerNomProprietaireIA}>
                    <p>Valider</p>
                    <hr />
                  </button>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* alignCard */}

            <div className="alignTitre">
              <div className="titre">
                <div className="a">
                  <p>* Numéro professionnel</p>
                </div>

                <div className="b">
                  <p>Pour un usage professionnel</p>
                </div>
                {/* b */}
              </div>
              {/* titre */}
            </div>
            {/* alignTitre */}

            {/* numero virtuel professionnel - IA */}
            {/* numero virtuel professionnel - IA */}
            <div className="alignCard">
              <div className="card">
                <div className="block-un">
                  <p>242</p>
                  <input type="text" placeholder="..." />
                </div>
                {/* block-un */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-deux">
                  <p>242_monica</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <button onClick={EntrerNomProprietaireIA}>
                    <p>Valider</p>
                    <hr />
                  </button>
                </div>

                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* alignCard */}
            {/* numero virtuel professionnel - IA */}

            <div style={{ paddingBottom: "70px" }}></div>
          </div>
          {/* delivrerNumeroVirtuelPageIA */}
        </>
      )}
      {/* Delivrer un Numero Virtuel (Page) - IA */}

      {/* Expressions utiles (Page) - IA */}
      {/* Expressions utiles (Page) - IA */}
      {/* Expressions utiles (Page) - IA */}
      {/* sur cette page on explique comment delivrer un numero virtuel 
            {explicationIA && (
            <>
            <div className="explicationDelivrerNumeroVirtuelPageIA">
              <div className="align">
                <div className="card">
                  <p>La différence entre un numéro virtuel personnel et un numéro virtuel professionnel est que le numéro virtuel personnel fonctionne dans toutes les applications virtuelles et peut même être utiliser pour de nombreuses taches professionnelles (Par exemple: Monétisation des pages Alrani, Réception des paiements, Vente en ligne,... ) mais dans certaines applications virtuelles ou dans certaines taches professionnelles c'est obligatoire d'avoir un numéro virtuel professionnel (Par exemple : commercialisation des recharges izocash, ouvertures des comptes bancaires virtuels, organisations des jeux concours avec résultas des votes en temps réel, ...)</p>
                  <p>exemple de numéro virtuel personnel.. 2425_sarah, 2425.sarah, 2425-sarah, 2425_Sarah, 2425_SARAH) et exemple de numéro virtuel professionnel.. 242_izocash, 242.izocash, 242-izocash, 242_Izocash, 242_IZOCASH)</p>
                  <p>Expressions utiles</p>
                  <p>Recharge izocash autrement dit mettre de l'argent dans son moyen de paiement virtuel, recharger un moyen de paiement virtuel</p>
                  <p>Exemple.</p>
                  <p>je veux une recharge izocash de 10.000FCFA. Ok, initier l'opération et communiquer moi le code... </p>
                  <p>je veux recharger mon compte izocash, est-ce-que vous faites des recharges izocash </p>
                  <p>Madame s'il vous plait, les recharges izocash sont disponibles. Oui c'est disponible. Merci, Faites moi une recharge izocash de 10.000FCFA</p>
                  <p>Bonjour, c'est possible chez vous de faire des recharges izocash. Oui c'est possible, installez-vous !</p>
                  <p>Bonjour, Est-ce que vous faites des recharges izocash. Oui bien sur, vous voulez une recharge de combien. 10.000FCFA. Ok prenez place. Initier l'opération puis communiquer moi le code de l'opération...</p>
                  <p>Bonjour, est-ce-que les recharges izocash passent. Oui ca passent. Ok, faites moi une recharge à 10.000</p>
                  <p>Bonjour, je veux une recharge izocash</p>
                  <p>Bonjour, faites moi une recharge izocash de 10.000</p>
                  <p>Bonjour, recharge izocash de 10.000</p>
                  <p>Bonjour, recharge izocash. de combien. 10.000</p>
                  <p>Bonjour, je veux une recharge de 10.000, par izocash</p>
                  <p>Salut ma belle, fais moi une recharge izocash de 10.000</p>
                  <p>Ma chérie, fais moi une recharge de 10.000 s'il te plait. izocash. oui izocash</p>
                  <p>Bonjour Madame ou mademoiselle, faite moi une recharge izocash de 50.000FCFA</p>
                  <p>Boss, tu veux une recharge de combien</p>
                  <p>Patron, la recharge a été éffectuée !</p>
                  <p>je veux mettre de l'argent dans mon moyen de paiement virtuel. Lequel . izocash</p>
                  <p>je veux recharger mon moyen de paiement virtuel. lequel. izocash</p>

                  <p>Lorsque vous naviguez dans une application virtuelle, au cas ou vous voulez retourner en arrière s'il n'ya pas la flèche retour, vous pourrez cliquer sur le titre ou sur le Grand titre pour retourner en arrière. S'il n'y a pas le titre, vous pourrez cliquer sur le logo pour retourner en arrière. S'il n'y a pas le logo, alors observez bien vous verrez une icone en forme de croix ou en forme de trait ou en une autre forme et cliquez dessus.</p>
                  <p>Sur la page d'accueil de chaque application virtuelle vous verrez l'icone traduction représenter par cette icone ou soit cette icone. Si vous ne la voyez pas alors verifier s'il y'a cette icone ou cette ou cette icone ou cette icone en forme de menu. Si vous ne la voyer toujours pas alors cela veut simplement dire que la traduction n'est pas disponible ou la traduction n'est pas encore disponible car dans chaque application virtuelle l'icone traduction n'est jamais loin.</p>
                  <p></p>
                </div>
                {/* card 
              </div>
              {/* align 
            </div>
            {/* explicationDelivrerNumeroVirtuelPageIA
            </>
            )}
            {/* Expressions utiles (Page) - IA */}

      {/* entrer le nom du propriétaire (Page) - delivrerNumeroVirtuelPageIA - IA */}
      {/* entrer le nom du propriétaire (Page) - delivrerNumeroVirtuelPageIA - IA */}
      {/* on affiche la page qui va permettre a l'agent d'entrer le nom du propriétaire du 
      numero virtuel - IA */}
      {entrerNomProprietaireIA && (
        <>
          <div className="entrerNomProprietaireIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p onClick={CloseEntrerNomProprietaireIA}>
                      Nom du propriétaire
                    </p>
                  </div>

                  <div className="b">
                    <button onClick={ConfirmerNumeroAdelivrerIA}>
                      Enregistrer
                    </button>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="block-un">
                  <p>Entrer le nom du propriétaire du Numéro Virtuel</p>
                  <input 
                    type="text" 
                    placeholder="Nom.."
                  />
                </div>
                {/* block-un */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* entrerNomProprietaireIA */}
        </>
      )}
      {/* entrer le nom du propriétaire (Page) - delivrerNumeroVirtuelPageIA - IA*/}

      {/* confirmer le numero virtuel a delivrer - IA */}
      {/* confirmer le numero virtuel a delivrer - IA */}
      {/* on affiche la page qui va permettre a l'agent de confirmer le numero
            a delivrer - IA */}
      {confirmerNumeroAdelivrerIA && (
        <>
          <div className="confirmerNumeroAdelivrerIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p></p>
                  <svg
                    onClick={CloseConfirmerNumeroAdelivrerIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    enableBackground="new 0 0 25.93 25.93"
                    version="1.1"
                    viewBox="0 0 25.93 25.93"
                    xmlSpace="preserve"
                  >
                    <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="numeroCard">
                  <div className="card">
                    <div className="block-un">
                      <div className="a">
                        <p>Numéro Virtuel :</p>
                        <p>242_serfin</p>
                      </div>

                      <div className="b">
                        <p>Propriétaire : KILENDO</p>
                      </div>
                      {/* b */}
                    </div>
                    {/* block-un */}

                    <div className="block-deux">
                      <hr />
                    </div>
                    {/* block-deux */}

                    <div className="block-trois">
                      <svg
                        onClick={CloseConfirmerNumeroAdelivrerIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="10px"
                        cursor="pointer"
                        fill="#a6a6a6"
                        version="1.1"
                        viewBox="0 0 40 40"
                        xmlSpace="preserve"
                      >
                        <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                      </svg>
                      <p>Serfin SA</p>
                    </div>
                    {/* block-trois */}
                  </div>
                  {/* card */}
                </div>
                {/* numeroCard */}

                <div className="consigne"> <p>En cliquant sur Délivrer, le numéro virtuel sera délivré</p> </div>
                {/* consigne */}

                <div className="btn">
                  <button onClick={DeliverVirtualNumberIA}>
                    <p>Délivrer</p>
                    <SvgValidate4 />
                  </button>
                </div>
                {/* btn */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* confirmerNumeroAdelivrerIA */}
        </>
      )}
      {/* confirmer le numero virtuel a delivrer - IA */}

     
      {/* Izocash International - IA */}
      {/* Izocash International - IA */}
      {/* on affiche la page qui va permettre a la personne de demarrer le processus pour 
      transferer de largent - IA */}
      {izocashInternational && (
        <>
          <div className="izocashInternational">
            <div className="align">
              <div onClick={CloseIzocashInternational} className="logo">
                <div className="block-un">
                  <div className="a">
                    <p>izocash</p>
                  </div>

                  <div className="b">
                    <p>International</p>
                  </div>
                  {/* b */}
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Aussitot envoyé, aussitot recu !</p>
                </div>
                {/* block-deux */}
              </div>
              {/* logo */}

              <div className="align-transfert">
                <div className="transfert">
                  {/* Numéro virtuel du Bénéficiaire */}
                  {/* Numéro virtuel du Bénéficiaire */}
                  <div className="block-un">
                    <div className="a">
                      <p>Numéro virtuel du Bénéficiaire</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="red"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M14.5 6.5c.737.144 1.469.469 2 1 .531.531.856 1.263 1 2M15 3c1.532.17 2.91.911 4 2 1.09 1.089 1.828 2.469 2 4m0 7.477v2.71c.004 1.035-.928 1.9-1.974 1.806C10 21 3 13.935 3.008 4.969 2.913 3.93 3.774 3.001 4.808 3h2.715c.44-.004.865.151 1.198.437.947.812 1.556 3.57 1.322 4.667-.183.856-1.046 1.455-1.633 2.04a14.467 14.467 0 005.43 5.42c.587-.585 1.187-1.446 2.045-1.629 1.1-.234 3.877.376 4.686 1.329.287.338.44.77.428 1.213z"
                        ></path>
                      </svg>
                    </div>

                    <div className="b">
                      <input
                        type="text"
                        placeholder=". . ."
                        value={writeVirtualNumberBeneficiaryIA}
                        onChange={(e) => setWriteVirtualNumberBeneficiaryIA(e.target.value)}
                      />
                      <button>OK</button>
                    </div>
                    {/* b */}
                  </div>
                  {/* block-un */}
                  {/* Numéro virtuel du Bénéficiaire */}

                  {/* Montant à envoyer */}
                  {/* Montant à envoyer */}
                  <div className="block-un">
                    <div className="a">
                      <p>Montant à envoyer</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          fillRule="evenodd"
                          stroke="none"
                          strokeWidth="1"
                        >
                          <g fillRule="nonzero" transform="translate(-912)">
                            <g transform="translate(912)">
                              <path
                                fillRule="nonzero"
                                d="M24 0v24H0V0h24zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018zm.265-.113l-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022zm-.715.002a.023.023 0 00-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092z"
                              ></path>
                              <path
                                fill="red"
                                d="M20 14a1 1 0 01.117 1.993L20 16H6.414l2.293 2.293a1 1 0 01-1.32 1.497l-.094-.083-3.83-3.83c-.665-.664-.239-1.783.663-1.871L4.241 14H20zm-4.707-9.707a1 1 0 011.32-.083l.094.083 3.83 3.83c.665.664.239 1.783-.663 1.871l-.115.006H4a1 1 0 01-.117-1.993L4 8h13.586l-2.293-2.293a1 1 0 010-1.414z"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>

                    <div className="b">
                      <input
                        type="text"
                        placeholder=". . ."
                        value={writeAmountToSendIA}
                        onChange={(e) => setWriteAmountToSendIA(e.target.value)}
                      />
                      <button>OK</button>
                    </div>
                    {/* b */}
                  </div>
                  {/* block-un */}
                  {/* Montant à envoyer */}

                  <div className="block-cinq">
                    <p>Montant à recevoir :</p>
                    <p>50000 FCFA</p>
                  </div>
                  {/* block-cinq */}

                  <div className="block-quatre">
                    <button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        fill="#000"
                        data-name="Layer 2"
                        viewBox="0 0 32 32"
                      >
                        <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                      </svg>
                      <p onClick={TransfertNationalIA}>Envoyer</p>
                    </button>
                  </div>
                  {/* block-quatre */}

                  <div className="block-six">
                    <hr />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      cursor="pointer"
                      width="10px"
                      enableBackground="new 0 0 25.93 25.93"
                      version="1.1"
                      viewBox="0 0 25.93 25.93"
                      xmlSpace="preserve"
                    >
                      <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                    </svg>
                  </div>
                  {/* block-six */}
                </div>
                {/* transfert */}
              </div>
              {/* align-transfert */}
            </div>
            {/* bottom */}
          </div>
          {/*izocashInternational */}
        </>
      )}
      {/* Izocash International - IA */}


      {/* before IdentificationCodePageIA */}
      {/* before IdentificationCodePageIA */}
      {/* on affiche ca avant d'afficher le card qui contient le code d'identification - IA */}
      {beforeIdentificationCodePageIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a"> <p>Identifier mon Numéro virtuel</p> </div>
                  <div onClick={CloseBeforeIdentificationCodePageIA} className="b"> <SvgClose2 /> </div>
                </div>
                {/* close */}

                <div className="block-un"> <p>Veuillez saisir un Super Code</p> </div>
                {/* block-un */}

                <div className="block-deux"> <input type="text" value={writeCode} onChange={(e) => setWriteCode(e.target.value)} /> </div>
                {/* block-deux */}

                <div onClick={BeforeIdentificationCodeIA} className="block-trois">
                  <div className="a"> <SvgRight2 /> </div>
                  <div className="b"> <p>Valider</p> </div>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* before IdentificationCodePageIA */}


      {/* code d'identification - IA */}
      {/* code d'identification - IA */}
      {/* on affiche le card qui contient le code d'identification - IA */}
      {identificationCodePageIA && (
        <>
          <div onClick={CloseIdentificationCodePageIA} className="identificationCodeIA">
            <div className="align">
              <div className="card">
                <div className="block-one">
                  <div className="a"> <p>L'identification de votre Numéro virtuel vous coûtera 90000 FCFA</p> </div>
                  <div className="b"> <p>Veuillez vous rendre dans un Point Retrait izocash muni de votre pièce d'identitée pour vous faire identifier</p> </div>
                </div>
                {/* block-one */}

                <div className="block-two"> <p>Code d'identification : {identificationCodeIA}</p> </div>
                {/* block-two */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* identificationCodeIA */}
        </>
      )}
      {/* code d'identification - IA */}


      {/* identifier un numéro virtuel - IA */}
      {/* identifier un numéro virtuel - IA */}
      {/* on affiche le card qui permet d'entrer le code d'identification - IA */}
      {beginIdentificationPageIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a"> <p>Identifier un Numéro virtuel</p> </div>
                  <div onClick={CloseBeginIdentificationPageIA} className="b"> <SvgClose2 /> </div>
                </div>
                {/* close */}

                <div className="block-un"> <p>Entrer le Code d'identification pour démarrer la procédure d'identification d'un Numéro virtuel</p> </div>
                {/* block-un */}

                <div className="block-deux"> <input type="text" value={writeCode} onChange={(e) => setWriteCode(e.target.value)} /> </div>
                {/* block-deux */}

                <div onClick={BeginIdentificationIA} className="block-trois">
                  <div className="a"> <SvgRight2 /> </div>
                  <div className="b"> <p>Démarrer</p> </div>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* identifier un numéro virtuel - IA */}


      {/* etape 1 - Procédure d'identification d'un numéro virtuel - IA */}
      {/* etape 1 - Procédure d'identification d'un numéro virtuel - IA */}
      {/* on affiche la page qui va permettre a l'agent d'identifier un numéro virtuel */}
      {etapeUnProcessusValidationCompteIA && (
        <>
          <div className="validerUnComptePageIA">
            <div className="block-un"> <p onClick={CloseEtapeUnProcessusValidationCompteIA}>Procédure d'identification d'un Numéro virtuel (Étape 1)</p> </div>
            {/* block-un */}

            <div style={{ paddingBottom: "70px" }}></div>
            <div className="align-block-deux">
              <div className="aablock-deux">
                <div className="a"> <p>01</p> </div>
                <div className="b"> <p>Prenez la Pièce d'identité du Client en photo puis importer-là</p> </div>
              </div>
              {/* aablock-deux */}
            </div>
            {/* align-block-deux */}

            <div className="block-trois"> <p>Si possible, prenez plusieurs face de la Pièce d'identité en photo</p> </div>
            {/* block-trois */}

            <div className="block-quatre"> <input onChange={(e) => setFilePhotoIdentiterClientIA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            {/* block-quatre */}

            <div className="block-cinq"> <button onClick={EnvoyerPhotoIdentiterClientIA}>Importer</button> </div>
            {/* block-cinq */}

            {/* pieces d'identité et photos du client */}
            {/* on affiche les photos d'identiter du client dans l'EnfantApi car ca va nous
             permettre lors d'un clic sur une photo, d'enregistrer l'url de la photo d'identiter 
             dans le localStorage. cette url sera utile lorsqu'on voudra voir la photo en grand.
            par exemple lorsqu'on clique sur la photo d'identiter pour la voir dans la popup */}

            <div style={{ paddingTop: "50px" }}></div>
            <div className="imageDeuxAdeux">
              <div className="displayPhoto">
                {filterPhotoIA.map((api) => (
                  <>
                    <EnfantApiPhotoIdentiterClientIA api={api} />
                  </>
                ))}
              </div>
              {/* displayPhoto */}
            </div>
            {/* imageDeuxAdeux */}
            <div style={{ paddingBottom: "50px" }}></div>

            <div className="aablock-six"> <p onClick={EtapeDeuxProcessusValidationCompteIA}>Passer à l'étape suivante</p> </div>
            {/* aablock-six */}

            <div className="important">
              <hr />

              <div className="a">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  curseur="pointer"
                  viewBox="0 -0.5 21 21"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  >
                    <g fill="#000" transform="translate(-139 -520)">
                      <g transform="translate(56 160)">
                        <path d="M94.55 365.007v7c0 .552-.47 1-1.05 1-.58 0-1.05-.448-1.05-1v-7c0-.552.47-1 1.05-1 .58 0 1.05.448 1.05 1zm0 10c0 .552-.47 1-1.05 1-.58 0-1.05-.448-1.05-1s.47-1 1.05-1c.58 0 1.05.448 1.05 1zM101.9 377c0 .552-.47 1-1.05 1h-14.7c-.58 0-1.05-.448-1.05-1v-14c0-.552.47-1 1.05-1h14.7c.58 0 1.05.448 1.05 1v14zm0-17H85.1c-1.16 0-2.1.899-2.1 2.003v16.004c0 1.105.94 1.993 2.1 1.993h16.8c1.16 0 2.1-.892 2.1-1.997v-15.996c0-1.105-1.05-2.007-2.1-2.007z"></path>
                      </g>
                    </g>
                  </g>
                </svg>
                <p>important !</p>
              </div>
              {/* a */}

              <div className="b"> <p>S'il s'agit d'une entreprise, importer les documents d'identité de l'entreprise ou importer des éléments qui prouvent qu'il s'agit d'une entreprise. Toutefois, un entrepreneur qui possède une entreprise peut faire identifier le Numéro virtuel de son entreprise avec sa propre pièce d'identitée à la place des documents d'identités de l'entreprise</p> </div>
              {/* b */}
            </div>
            {/* important */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* etape 1 - Procédure d'identification d'un numéro virtuel - IA */}


      {/* etape 2 - Procédure d'identification d'un numéro virtuel - IA */}
      {/* etape 2 - Procédure d'identification d'un numéro virtuel - IA */}
      {/* on affiche la page qui va permettre a l'agent de prendre le client en photo */}
      {etapeDeuxProcessusValidationCompteIA && (
        <>
          <div className="validerUnComptePageIA">
            <div className="block-un"> <p onClick={CloseEtapeDeuxProcessusValidationCompteIA}>Procédure d'identification d'un Numéro virtuel (Étape 2)</p> </div>
            {/* block-un */}

            <div style={{ paddingBottom: "70px" }}></div>

            <div className="align-block-deux">
              <div className="ccblock-deux">
                <div className="a"> <p>02</p> </div>
                <div className="b"> <p>Prenez le Client en photo puis importer la photo du Client</p> </div>
              </div>
              {/* block-deux */}
            </div>
            {/* align-block-deux */}

            <div className="block-trois"> <p>Si possible prenez plusieurs photos</p> </div>
            {/* block-trois */}

            <div className="block-quatre"> <input onChange={(e) => setFilePhotoIdentiterClientIA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            {/* block-quatre */}

            <div className="block-cinq"> <button onClick={EnvoyerPhotoIdentiterClientIA}>Importer</button> </div>
            {/* block-cinq */}

            {/* pieces d'identité et photos du client */}
            {/* on affiche les photos d'identiter du client dans l'EnfantApi car ca va nous
             permettre lors d'un clic sur une photo, d'enregistrer l'url de la photo d'identiter 
             dans le localStorage. cette url sera utile lorsqu'on voudra voir la photo en grand.
            par exemple lorsqu'on clique sur la photo d'identiter pour la voir dans la popup */}

            <div style={{ paddingTop: "50px" }}></div>
            <div className="imageDeuxAdeux">
              <div className="displayPhoto">
                {filterPhotoIA.map((api) => (
                  <>
                    <EnfantApiPhotoIdentiterClientIA api={api} />
                  </>
                ))}
              </div>
              {/* displayPhoto */}
            </div>
            {/* imageDeuxAdeux */}
            <div style={{ paddingBottom: "50px" }}></div>

            <div className="align-siCestUneEntreprise">
              <div className="siCestUneEntreprise">
                {/* dans ce cas, la case c'est une entreprise est cocher */}
                {entrepriseActiveIA && (
                  <>
                    <div className="active">
                      <p onClick={EntrepriseNonActiveIA}>C'est une entreprise</p>
                      <svg
                        onClick={EntrepriseNonActiveIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="#00cc00"
                        viewBox="0 0 512 512"
                      >
                        <path d="M400 48H112a64.07 64.07 0 00-64 64v288a64.07 64.07 0 0064 64h288a64.07 64.07 0 0064-64V112a64.07 64.07 0 00-64-64zm-35.75 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"></path>
                      </svg>
                    </div>
                    {/* active */}
                  </>
                )}

                {/* dans ce cas, la case c'est une entreprise est décocher */}
                {!entrepriseActiveIA && (
                  <>
                    <div className="nonActive">
                      <p onClick={EntrepriseActiveIA}>C'est une entreprise</p>
                      <svg
                        onClick={EntrepriseActiveIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <g>
                          <path
                            stroke="#000"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 7.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.427.218.987.218 2.105.218h9.606c1.118 0 1.677 0 2.104-.218.377-.192.683-.498.875-.874.218-.428.218-.986.218-2.104V7.197c0-1.118 0-1.678-.218-2.105a2.001 2.001 0 00-.875-.874C18.48 4 17.92 4 16.8 4H7.2c-1.12 0-1.68 0-2.108.218a1.999 1.999 0 00-.874.874C4 5.52 4 6.08 4 7.2z"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    {/* nonActive */}
                  </>
                )}
              </div>
              {/* siCestUneEntreprise */}
            </div>
            {/* align-siCestUneEntreprise */}

            <div className="ccblock-six"> <p onClick={EtapeTroisProcessusValidationCompteIA}>Passer à l'étape suivante</p> </div>
            {/* block-six */}

            <div className="important">
              <hr />

              <div className="a">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  curseur="pointer"
                  viewBox="0 -0.5 21 21"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  >
                    <g fill="#000" transform="translate(-139 -520)">
                      <g transform="translate(56 160)">
                        <path d="M94.55 365.007v7c0 .552-.47 1-1.05 1-.58 0-1.05-.448-1.05-1v-7c0-.552.47-1 1.05-1 .58 0 1.05.448 1.05 1zm0 10c0 .552-.47 1-1.05 1-.58 0-1.05-.448-1.05-1s.47-1 1.05-1c.58 0 1.05.448 1.05 1zM101.9 377c0 .552-.47 1-1.05 1h-14.7c-.58 0-1.05-.448-1.05-1v-14c0-.552.47-1 1.05-1h14.7c.58 0 1.05.448 1.05 1v14zm0-17H85.1c-1.16 0-2.1.899-2.1 2.003v16.004c0 1.105.94 1.993 2.1 1.993h16.8c1.16 0 2.1-.892 2.1-1.997v-15.996c0-1.105-1.05-2.007-2.1-2.007z"></path>
                      </g>
                    </g>
                  </g>
                </svg>
                <p>important !</p>
              </div>
              {/* a */}

              <div className="b"> <p>Sauter cette étape s'il s'agit d'une entreprise mais avant de sauter, cocher la case C'est une entreprise</p> </div>
              {/* b */}
            </div>
            {/* important */}
          </div>
          {/* validerUnComptePageIA */}
        </>
      )}
      {/* etape 2 - Procédure d'identification d'un numéro virtuel - IA */}


      {/* etape 3 - Procédure d'identification d'un numéro virtuel - IA */}
      {/* etape 3 - Procédure d'identification d'un numéro virtuel - IA */}
      {/* on affiche la page qui va permettre a l'agent d'entrer la zone dans laquelle réside
      le client */}
      {etapeTroisProcessusValidationCompteIA && (
        <>
          <div className="validerUnComptePageIA">
            <div className="block-un"> <p onClick={CloseEtapeTroisProcessusValidationCompteIA}>Procédure d'identification d'un Numéro virtuel (Étape 3)</p> </div>
            {/* block-un */}

            <div style={{ paddingBottom: "70px" }}></div>
            <div className="align-block-deux">
              <div className="eeblock-deux">
                <div className="a"> <p>03</p> </div>
                <div className="b"> <p>Ajouter les informations du Client</p> </div>
              </div>
              {/* block-deux */}
            </div>
            {/* align-block-deux */}

            <div className="block-trois"> <p>Ajouter le Nom de naissance du Client (ou nom de l'entreprise), sa Zone d'habitation (ou zone du siège social) et si possible son Adresse</p> </div>
            {/* block-trois */}

            <div className="infosClient">
              <div className="card">
                {/* Nom du client */}
                <div className="display">
                  <div className="a"> <p onClick={WriteInfosClientPageIA}>Nom :</p> </div>
                  <div className="b"> <p onClick={WriteInfosClientPageIA}>{nameClientIA}</p> </div>
                </div>

                {/* Profession */}
                <div className="display">
                  <div className="a"> <p onClick={WriteInfosClientPageIA}>Profession :</p> </div>
                  <div className="b"> <p onClick={WriteInfosClientPageIA}>{jobClientIA}</p> </div>
                </div>

                {/* Business */}
                <div className="display">
                  <div className="a"> <p onClick={WriteInfosClientPageIA}>Business :</p> </div>
                  <div className="b"> <p onClick={WriteInfosClientPageIA}>{businessClientIA}</p> </div>
                </div>

                {/* Autres Business */}
                <div className="display">
                  <div className="a"> <p onClick={WriteInfosClientPageIA}>Autres Business :</p> </div>
                  <div className="b"> <p onClick={WriteInfosClientPageIA}>{otherBusinessClientIA}</p> </div>
                </div>

                {/* Numéro de Téléphone */}
                <div className="display">
                  <div className="a"> <p onClick={WriteInfosClientPageIA}>Numéro de Téléphone :</p> </div>
                  <div className="b"> <p onClick={WriteInfosClientPageIA}>{phoneNumberClientIA}</p> </div>
                </div>

                {/* Adresse */}
                {/* Adresse */}
                <div className="display">
                  <div className="a"> <p onClick={WriteInfosClientPageIA}>Adresse (facultatif) : </p> </div>
                  <div className="b"> <p onClick={WriteInfosClientPageIA}>{addressClientIA}</p> </div>
                </div>

                {/* Sexe */}
                {/* Sexe */}
                {sexIA === "1" && (<>
                <div className="display">
                  <div className="a"> <p onClick={EditSexeIA}>Sexe :</p> </div>
                  <div className="b"> <p onClick={EditSexeIA}>Masculin</p> </div>
                </div></>)}

                {sexIA === "2" && (<>
                <div className="display">
                  <div className="a"> <p onClick={EditSexeIA}>Sexe :</p> </div>
                  <div className="b"> <p onClick={EditSexeIA}>Féminin</p> </div>
                </div></>)}

                {/* Zone d'habitation */}
                {/* Zone d'habitation */}
                {dev && (<>
                <div className="display">
                  <div className="a"> <p onClick={LangueLocalisationIA}>Zone d'habitation :</p> </div>
                  <div className="b"> <p onClick={LangueLocalisationIA}>{zoneIA}</p> </div>
                </div></>)}

              </div>
              {/* card */}
            </div>
            {/* infosClient */}

            {/* pieces d'identité et photos du client */}
            {/* on affiche les photos d'identiter du client dans l'EnfantApi car ca va nous
             permettre lors d'un clic sur une photo, d'enregistrer l'url de la photo d'identiter 
             dans le localStorage. cette url sera utile lorsqu'on voudra voir la photo en grand.
            par exemple lorsqu'on clique sur la photo d'identiter pour la voir dans la popup */}

            <div style={{ paddingTop: "50px" }}></div>
            <div className="imageDeuxAdeux">
              <div className="displayPhoto">
                {filterPhotoIA.map((api) => (
                  <>
                    <EnfantApiPhotoIdentiterClientIA api={api} />
                  </>
                ))}
              </div>
              {/* displayPhoto */}
            </div>
            {/* imageDeuxAdeux */}
            <div style={{ paddingBottom: "50px" }}></div>

            <div className="eeblock-six"> <button onClick={IdentificationVirtualNumberIA}>Identifier</button> </div>
            {/* block-six */}

            <div className="important">
              <hr />

              <div className="a">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  curseur="pointer"
                  viewBox="0 -0.5 21 21"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  >
                    <g fill="#000" transform="translate(-139 -520)">
                      <g transform="translate(56 160)">
                        <path d="M94.55 365.007v7c0 .552-.47 1-1.05 1-.58 0-1.05-.448-1.05-1v-7c0-.552.47-1 1.05-1 .58 0 1.05.448 1.05 1zm0 10c0 .552-.47 1-1.05 1-.58 0-1.05-.448-1.05-1s.47-1 1.05-1c.58 0 1.05.448 1.05 1zM101.9 377c0 .552-.47 1-1.05 1h-14.7c-.58 0-1.05-.448-1.05-1v-14c0-.552.47-1 1.05-1h14.7c.58 0 1.05.448 1.05 1v14zm0-17H85.1c-1.16 0-2.1.899-2.1 2.003v16.004c0 1.105.94 1.993 2.1 1.993h16.8c1.16 0 2.1-.892 2.1-1.997v-15.996c0-1.105-1.05-2.007-2.1-2.007z"></path>
                      </g>
                    </g>
                  </g>
                </svg>
                <p>important !</p>
              </div>
              {/* a */}

              <div className="b"> <p>Le Client doit fournir des informations exactes ou encore le Client doit fournir des informations qu'il ne va pas oublier car si jamais il oublie son Numéro virtuel, ces informations pourrait être utiliser pour lui aider à récupérer son Numéro virtuel</p> </div>
              {/* b */}
            </div>
            {/* important */}
          </div>
          {/* validerUnComptePageIA */}
        </>
      )}
      {/* etape 3 - Procédure d'identification d'un numéro virtuel - IA  */}


      {/* saisir infos client page (666 identification Étape 3) - IA */}
      {/* saisir infos client page (666 identification Étape 3) - IA */}
      {writeInfosClientPageIA && (<>
          <div className="writeInfosClientPageIA">
            <div className="align">
              <div className="head">
                <div className="close">
                  <div className="aa"> <p>Informations du Client</p> </div>
                  <div onClick={CloseWriteInfosClientPageIA} className="bb"> <SvgDash3 /> </div>
                </div>
                {/* close */}
              </div>
              {/* head */}

              <div className="body">
                <div className="card">
                  
                <div className="hr"> <hr /> </div>

                <div className="block-un"> <p>Veuillez compléter les informations d'identification ci-dessous</p> </div>
                
                {/* Nom du Client */}
                <div className="block-trois">
                  <div className="a"> <p>Nom du Client</p> </div>

                  <div className="b">
                    <p>Saissisez le Nom de naissance du Client (ou nom de l'entreprise)</p>
                    <input type="text" value={writeNameClientIA} onChange={(e) => setWriteNameClientIA(e.target.value)} />
                  </div>
                </div>

                {/* Profession */}
                <div className="block-trois">
                  <div className="a"> <p>Profession</p> </div>

                  <div className="b">
                    <p>Saisissez la Profession du Client. Saisissez le Travail qu'il fait s'il est employé quelque part (Par exemple: Professeur, Ménagère, Chauffeur, ...)</p>
                    <input type="text" value={writeJobClientIA} onChange={(e) => setWriteJobClientIA(e.target.value)} />
                  </div>
                </div>

                {/* Business */}
                <div className="block-trois">
                  <div className="a"> <p>Business</p> </div>

                  <div className="b">
                    <p>Saisissez le Business du Client s'il a un Business qu'il fait (Par exemple: Vente en ligne des chaussures, Vente d'articles d'habillements, Business du Transport, Import/export des marchandises, ...). Si ce Numéro virtuel appartiendra à une Entreprise, un Produit ou un Service alors écrivez le secteur d'activité de l'Entreprise, du Produit ou du Service</p>
                    <input type="text" value={writeBusinessClientIA} onChange={(e) => setWriteBusinessClientIA(e.target.value)} />
                  </div>
                </div>

              {/* Autres Business */}
              <div className="block-trois">
                <div className="a"> <p>Autres Business</p> </div>

                <div className="b">
                  <p>Saisissez les autres Business du Client s'il a plusieurs autres Business</p>
                  <input type="text" value={writeOtherBusinessClientIA} onChange={(e) => setWriteOtherBusinessClientIA(e.target.value)} />
                </div>
              </div>

              {/* Numéro de téléphone */}
              <div className="block-trois">
                <div className="a"> <p>Numéro de téléphone</p> </div>

                <div className="b">
                  <p>Saisissez le numéro de téléphone auquel on peut joindre le Client</p>
                  <input type="text" value={writePhoneNumberClientIA} onChange={(e) => setWritePhoneNumberClientIA(e.target.value)} />
                </div>
              </div>

              {/* Adresse */}
              <div className="block-trois">
                <div className="a"> <p>Adresse (facultatif)</p> </div>

                <div className="b">
                  <p>Saissisez l'Adresse du Client. Saissisez l'Adresse où le Client habite (ou adresse du siège social pour une entreprise)</p>
                  <input type="text" value={writeAddressClientIA} onChange={(e) => setWriteAddressClientIA(e.target.value)} />
                </div>
              </div>

              <div className="block-quatre"> 
                <div onClick={SaveInfosClientIA} className="a"> <SvgRight /> </div>
                <div onClick={SaveInfosClientIA} className="b"> <p>Enregistrer</p> </div>
              </div>
              {/* block-quatre */}
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
      </div>
      {/* writeInfosClientPageIA */}
      </>)}
      {/* saisir infos client page (666 identification Étape 3) - IA */}

       
      {/* edit sexe - IA */}
      {/* edit sexe - IA */}
      {/* on affiche le card qui permet de modifier le sexe de la personne - IA */}
      {editSexeIA && (<>
          <div className="editSexeIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="aa"> <p>Choix du sexe</p> </div>
                  <div onClick={CloseEditSexeIA} className="bb"> <SvgClose2 /> </div>
                </div>
                {/* close */}

                <div className="block-un"> <hr /> </div>
                {/* block-un */}

                <div className="block-deux">
                  {maleIA ? (
                    <><div className="active"> <button>Masculin</button> </div></>
                  ) : (
                    <><div className="noActive"> <button onClick={MaleIA}>Masculin</button></div> </>)}

                  {femaleIA ? (
                    <><div className="active"> <button>Féminin</button> </div></>
                  ) : (
                    <><div className="noActive"> <button onClick={FemaleIA}>Féminin</button> </div></>)}
                </div>
                {/* block-deux */}

                <div className="block-trois"> <p>Ignorer le sexe s'il s'agit d'une entreprise</p> </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* editSexeIA-opacity */}
        </>)}
      {/* edit sexe - IA */}


      {/* listes des langues - IA */}
      {/* listes des langues - IA */}
      {/* on affiche la liste des langues */}
      {langueLocalisationIA && (
        <>
          <div className="localisationIA">
            <div className="align">
              <div className="close">
                <div className="a">
                  <svg
                    onClick={CloseLangueLocalisationIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>
                  <p>Sélectionner la langue</p>
                </div>
                {/* a */}

                <div className="b"></div>
              </div>
              {/* close */}

              {/* on affiche la liste des langues - IA */}
              <div onClick={PaysLocalisationIA}>
                {apiLanguageIA.map((api) => (
                  <EnfantApiListeDesLanguesIA api={api} />
                ))}
              </div>
            </div>
            {/* align */}
          </div>
          {/* localisationIA */}
        </>
      )}
      {/* listes des langues - IA */}

      {/* listes des Pays - IA */}
      {/* listes des Pays - IA */}
      {/* on affiche la liste des Pays */}
      {paysLocalisationIA && (
        <>
          <div className="localisationIA">
            <div className="align">
              <div className="close">
                <div className="a">
                  <svg
                    onClick={ClosePaysLocalisationIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>
                  <p>Sélectionner le Pays</p>
                </div>
                {/* a */}

                <div className="b"></div>
                {/* b */}
              </div>
              {/* close */}

              {/* on affiche la liste des pays - IA */}
              <div onClick={MasquerVilleIA}>
                {filterCountryIA.map((api) => (
                  <EnfantApiListeDesPaysIA api={api} />
                ))}
              </div>
            </div>
            {/* align */}
          </div>
          {/* localisationIA */}
        </>
      )}
      {/* listes des Pays - IA */}

      {/* confirmation - masquer pays */}
      {masquerVilleIA && (
        <>
          <div className="offrirNumeroConfirmationIAC">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <h6>Confirmation</h6>
                  <p>Voulez-vous vraiment masquer cette ce pays : congo ?</p>
                </div>
                {/* block-un */}

                <hr />
                <div className="block-trois">
                  <p>Oui</p>
                </div>
                {/* block-trois */}

                <hr />
                <div className="block-quatre">
                  <p onClick={CloseMasquerVilleIA}>Annuler</p>
                </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* offrirNumeroConfirmationIAC */}
        </>
      )}
      {/* masquer langue Confirmation - IAC */}

      {/* listes des villes - IA  */}
      {/* listes des villes - IA  */}
      {/* on affiche la liste des villes */}
      {villeLocalisationIA && (
        <>
          <div className="localisationIA">
            <div className="align">
              <div className="close">
                <div className="a">
                  <svg
                    onClick={CloseVilleLocalisationIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>
                  <p>Sélectionner la ville</p>
                </div>
                {/* a */}

                <div className="b"></div>
                {/* b */}
              </div>
              {/* close */}

              <div className="indiceLocalisation">
                <button>{countryIA2}</button>
              </div>
              {/* indiceLocalisation */}

              {/* on affiche la liste des villes - IA */}
              <div onClick={QuartierLocalisationIA}>
                {filterCityIA.map((api) => (
                  <EnfantApiListeDesVillesIA api={api} />
                ))}
              </div>
            </div>
            {/* align */}
          </div>
          {/* localisationIA */}
        </>
      )}
      {/* listes des villes - IA */}

      {/* listes des quartiers - IA  */}
      {/* listes des quartiers - IA  */}
      {/* on affiche la liste des quartiers */}
      {quartierLocalisationIA && (
        <>
          <div className="localisationIA">
            <div className="align">
              <div className="close">
                <div className="a">
                  <svg
                    onClick={CloseQuartierLocalisationIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>
                  <p>Sélectionner le quartier</p>
                </div>
                {/* a */}

                <div className="b">
                  <svg
                    onClick={AjouterQuartierIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="17px"
                    cursor="pointer"
                    viewBox="0 0 24 24"
                  >
                    <g>
                      <g
                        fill="none"
                        stroke="#444"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        data-name="add"
                      >
                        <path d="M12 19L12 5"></path>
                        <path d="M5 12L19 12"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                {/* b */}
              </div>
              {/* close */}

              <div className="indiceLocalisation">
                <button>{cityIA2}</button>
              </div>
              {/* indiceLocalisation */}

              {/* on affiche la liste des quartiers - IA */}
              <div onClick={ZoneLocalisationIA}>
                {filterQuarterIA.map((api) => (
                  <EnfantApiListeDesQuartiersIA api={api} />
                ))}
              </div>
            </div>
            {/* align */}
          </div>
          {/* localisationIA */}
        </>
      )}
      {/* listes des quartiers - IA */}

      {/* listes des zones - IA  */}
      {/* listes des zones - IA  */}
      {/* on affiche la liste des zones */}
      {zoneLocalisationIA && (
        <>
          <div className="localisationIA">
            <div className="align">
              <div className="close">
                <div className="a">
                  <svg
                    onClick={CloseZoneLocalisationIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 486.975 486.975"
                    version="1.1"
                    viewBox="0 0 486.975 486.975"
                    xmlSpace="preserve"
                  >
                    <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                  </svg>
                  <p>Sélectionner la zone</p>
                </div>
                {/* a */}

                <div className="b">
                  <svg
                    onClick={AjouterZoneIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="17px"
                    cursor="pointer"
                    viewBox="0 0 24 24"
                  >
                    <g>
                      <g
                        fill="none"
                        stroke="#444"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        data-name="add"
                      >
                        <path d="M12 19L12 5"></path>
                        <path d="M5 12L19 12"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                {/* b */}
              </div>
              {/* close */}

              <div className="indiceLocalisation"> <button>{quarterIA2}</button> </div>
              {/* indiceLocalisation */}

              {/* on affiche la liste des zones - IA */}
              <div onClick={RecapitulatifLocalisationIA}>
                {filterZoneIA.map((api) => (
                  <EnfantApiListeDesZonesIA api={api} />
                ))}
              </div>
            </div>
            {/* align */}
          </div>
          {/* localisationIA */}
        </>
      )}
      {/* listes des zones - IA  */}

      {/* recapitulatif Localisation - IA */}
      {/* recapitulatif Localisation - IA */}
      {/* on affiche le recapitulatif de la Localisation */}
      {recapitulatifLocalisationIA && (
        <>
          <div className="recapitulatifLocalisationIA">
            <div className="close">
              <div className="a">
                <svg
                  onClick={CloseRecapitulatifLocalisationIA}
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  cursor="pointer"
                  width="10px"
                  enableBackground="new 0 0 25.93 25.93"
                  version="1.1"
                  viewBox="0 0 25.93 25.93"
                  xmlSpace="preserve"
                >
                  <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                </svg>
                <p>Récapitulatif Localisation</p>
              </div>

              <div className="b">
                <hr />
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="indiceLocalisation">
              <button>{zoneSelectedIA}</button>
            </div>
            {/* indiceLocalisation */}

            <div className="card">
              <div className="a">
                <button onClick={EnregistrerLocalisationIA}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#0F0F0F"
                      fillRule="evenodd"
                      d="M18.172 1a2 2 0 011.414.586l2.828 2.828A2 2 0 0123 5.828V20a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h14.172zM4 3a1 1 0 00-1 1v16a1 1 0 001 1h1v-6a3 3 0 013-3h8a3 3 0 013 3v6h1a1 1 0 001-1V6.828a2 2 0 00-.586-1.414l-1.828-1.828A2 2 0 0017.172 3H17v2a3 3 0 01-3 3h-4a3 3 0 01-3-3V3H4zm13 18v-6a1 1 0 00-1-1H8a1 1 0 00-1 1v6h10zM9 3h6v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V3z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <p>Enregistrer</p>
                </button>
              </div>
              {/* a */}

              <div className="b">
                <hr />
              </div>
              {/* b */}

              <div className="c">
                <p>Zone d'habitation : {zoneSelectedIA}</p>
                <p>Quartier : {quarterSelectedIA}</p>
                <p>Ville : {citySelectedIA}</p>
                <p>Pays : {countrySelectedIA}</p>
              </div>
              {/* c */}
            </div>
            {/* card */}
          </div>
          {/* recapitulatifLocalisationIA */}
        </>
      )}
      {/* recapitulatif Localisation - IA */}

      {/* ajouter Quartier - IA */}
      {/* ajouter Quartier - IA */}
      {/* la page ci permet a l'agent d'ajouter un quartier */}
      {ajouterQuartierIA && (
        <>
          <div className="ajouterQuartierIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p onClick={ErreurRencontrerIA}>Ajouter un Quartier</p>
                  </div>

                  <div className="b">
                    <svg
                      onClick={CloseAjouterQuartierIA}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      cursor="pointer"
                      width="10px"
                      enableBackground="new 0 0 25.93 25.93"
                      version="1.1"
                      viewBox="0 0 25.93 25.93"
                      xmlSpace="preserve"
                    >
                      <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                    </svg>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="block-un">
                  <div className="a">
                    <p>Saissisez le nom du Quartier.</p>

                    <p>
                      Si jamais là où le client habite on a pas encore donné de
                      nom à ce quartier alors entrer la manière dont les gens
                      qui y vivent appellent cet endroit
                    </p>
                  </div>

                  <div className="b">
                    <input type="text" placeholder="..." />
                    <button onClick={AjoutLocalisationSuccessIA}>
                      <p>Ajouter</p>
                      <hr />
                    </button>
                  </div>
                  {/* b */}
                </div>
                {/* block-un */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* ajouterQuartierIA */}
        </>
      )}
      {/* ajouter Quartier - IA */}

      {/* ajouter Zone - IA */}
      {/* ajouter Zone - IA */}
      {/* la page ci permet a l'agent d'ajouter une zone */}
      {ajouterZoneIA && (
        <>
          <div className="ajouterQuartierIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p>Ajouter une Zone</p>
                  </div>

                  <div className="b">
                    <svg
                      onClick={CloseAjouterZoneIA}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      cursor="pointer"
                      width="10px"
                      enableBackground="new 0 0 25.93 25.93"
                      version="1.1"
                      viewBox="0 0 25.93 25.93"
                      xmlSpace="preserve"
                    >
                      <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                    </svg>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="block-un">
                  <div className="a">
                    <p>Saissisez le nom de la Zone.</p>

                    <p>
                      Le nom de la Zone peut être le nom d'un lieu public (par
                      exemple un Hôpital, un Arrêt de bus, ...) ou le nom d'un
                      lieu privé (par exemple une École, une Boulangerie, ...).
                    </p>

                    <p>
                      Il faudrait que ça soit un nom ou une appelation connue de
                      tout le monde
                    </p>
                  </div>

                  <div className="b">
                    <input type="text" placeholder="..." />
                    <button>
                      <p>Ajouter</p>
                      <hr />
                    </button>
                  </div>
                  {/* b */}
                </div>
                {/* block-un */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* ajouterQuartierIA */}
        </>
      )}
      {/* ajouter Zone - IA */}

      {/* ajout Localisation Success - IA */}
      {/* ajout Localisation Success - IA */}
      {/* si l'agent a pu ajouter un quartier, une ville,... on va l'afficher
      ce message de succes */}
      {ajoutLocalisationSuccessIA && (
        <>
          <div
            onClick={CloseAjoutLocalisationSuccessIA}
            className="ajoutLocalisationSuccessIAC"
          >
            <div className="align">
              <div className="card">
                <p>Ajout réussi !</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* ajoutLocalisationSuccessIAC */}
        </>
      )}
      {/* ajout Localisation Success - IA */}


      {/* saisir nom client (page) - ProcessusValidationCompteIA */}
      {/* saisir nom client (page) - ProcessusValidationCompteIA */}
      {/* ca c'est la page qui nous permet de saisir le nom du client */}
      {writeNameClientPageIA && (
        <>
          <div className="saisirNomClientIA">
            <div className="align">
              <div className="card">
                <div className="fermer">
                  <p onClick={CloseWriteNameClientPageIA}>Nom du Client</p>
                  <svg
                    onClick={CloseWriteNameClientPageIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    fill="#ccc"
                    enableBackground="new 0 0 25.93 25.93"
                    version="1.1"
                    viewBox="0 0 25.93 25.93"
                    xmlSpace="preserve"
                  >
                    <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                  </svg>
                </div>
                {/* fermer */}

                <div className="block-uno"> <p>Saissisez le Nom de naissance du Client (ou nom de l'entreprise)</p> </div>
                {/* block-uno */}

                <div className="block-dos"> <textarea value={writeNameClientIA} onChange={(e) => setWriteNameClientIA(e.target.value)}></textarea> </div>
                {/* block-dos */}

                <div className="block-tres">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p onClick={SaveNameClientIA}>Enregistrer</p>
                </div>
                {/* block-tres */} 
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* saisirNomClientIA */}
        </>
      )}
      {/* saisir nom client (page) - ProcessusValidationCompteIA */}


      {/* saisir adresse client (page) - ProcessusValidationCompteIA */}
      {/* saisir adresse client (page) - ProcessusValidationCompteIA */}
      {/* ca c'est la page qui nous permet de saisir l'adresse du client */}
      {writeAddressClientPageIA && (
        <>
          <div className="saisirNomClientIA">
            <div className="align">
              <div className="card">
                <div className="fermer">
                  <p onClick={CloseWriteAddressClientPageIA}>Adresse du Client</p>
                  <svg
                    onClick={CloseWriteAddressClientPageIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    fill="#ccc"
                    enableBackground="new 0 0 25.93 25.93"
                    version="1.1"
                    viewBox="0 0 25.93 25.93"
                    xmlSpace="preserve"
                  >
                    <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                  </svg>
                </div>
                {/* fermer */}

                <div className="block-uno"> <p>Saissisez l'Adresse où le Client habite (ou adresse du siège social pour une entreprise)</p> </div>
                {/* block-uno */}

                <div className="block-dos"> <textarea value={writeAddressClientIA} onChange={(e) => setWriteAddressClientIA(e.target.value)} ></textarea> </div>
                {/* block-dos */}

                <div className="block-tres">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#000"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p onClick={SaveAddressClientIA}>Enregistrer</p>
                </div>
                {/* block-tres */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* saisirNomClientIA */}
        </>
      )}
      {/* saisir adresse client (page) - ProcessusValidationCompteIA */}


      {/* code de l'operation - IA */}
      {/* code de l'operation - IA */}
      {/* quand on clique, on affiche le card qui contient le code de l'operation - IA */}
      {initierOperationIA && (
        <>
          <div
            onClick={CloseInitierOperationIA}
            className="initierOperation-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="access-code-success">
                  <div className="code">
                    <p>{initierOperationCodeIA}</p>
                  </div>
                  <p>{initierOperationCodeIA} est le Code de l'opération</p>
                </div>
                {/* business-opacity */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* initierOperation-opacity */}
        </>
      )}
      {/* code de l'operation - IA */}

      {/* Choisir le compte a Recharger - IA */}
      {/* Choisir le compte a Recharger - IA */}
      {/* on affiche le card qui permet de choisir le compte a recharger  */}
      {choisirCompteARechargerIA && (
        <>
          <div className="choisirCompteARechargerIA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p onClick={EntrerCodeOperationRechargeCompteIzocash}>
                    Compte izocash
                  </p>

                  <p>Compte de Générosité</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <hr />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <li>Recharger un compte</li>
                  <svg
                    onClick={CloseChoisirCompteARechargerIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="10px"
                    cursor="pointer"
                    fill="#444"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* choisirCompteARechargerIA */}
        </>
      )}
      {/* Choisir le compte a Recharger - IA */}

      {/* entrer le code de l'operation - IA */}
      {/* entrer le code de l'operation - IA */}
      {/*on affiche la popup qui permet d'entrer le code de l'operation - rechargeCompteIzocash  */}
      {entrerCodeOperationRechargeCompteIzocash && (
        <>
          <div className="entrerCodeOperationIA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Code de l'opération</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Entrer le code à 4 chiffres</p>
                  <input
                    type="number"
                    placeholder="__ __ __ __"
                    value={codeOperationIA}
                    onChange={(e) => setCodeOperationIA(e.target.value)}
                  />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <button onClick={CodeOperationIA}>Continuer</button>
                </div>
                {/* block-trois */}

                <div className="block-quatre">
                  <p onClick={NumeroTelephoneCompteArechargerIA}>
                    Numéro de téléphone
                  </p>
                </div>
                {/* block-quatre */}

                <div className="block-cinq">
                  <p onClick={CloseEntrerCodeOperationRechargeCompteIzocash}>
                    Annuler
                  </p>
                </div>
                {/* block-cinq */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* entrerCodeOperationIA */}
        </>
      )}
      {/* entrer le code de l'operation - IA */}

      {/* Sélectionner une option - rechargeCompteIA */}
      {/*ici on affiche le card qui permet de choisir si le client est le propriétaire 
      du compte ou pas */}
      {selectionnerOptionRechargeCompteIA && (
        <>
          <div className="selectionnerOptionIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Vérification d'identité</p>

                  <svg
                    onClick={CloseSelectionnerOptionRechargeCompteIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="15px"
                    cursor="pointer"
                    fill="#000"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un">
                  <p>Sélectionner l'option qui convient</p>
                </div>
                {/* block-un */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-deux">
                  <p onClick={ClientEstProprietaireIA}>
                    Le client est le propriétaire du compte
                  </p>
                </div>
                {/* block-deux */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div style={{ paddingTop: "35px" }}></div>

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-deux">
                  <p>Le client n'est pas le propriétaire du compte</p>
                </div>
                {/* block-deux */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* selectionnerOptionIA */}
        </>
      )}
      {/* Sélectionner une option - rechargeCompteIA */}

      {/* page - client Est Proprietaire -  IA */}
      {/* page - client Est Proprietaire -  IA */}
      {/*on affiche la page qui permet a l'agent de verifier l'identité du client */}
      {clientEstProprietaireIA && (
        <>
          <div className="clientEstProprietaireIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <svg
                      onClick={
                        TransactionEnCoursVerificationIdentiterEtapeDeuxIA
                      }
                      xmlns="http://www.w3.org/2000/svg"
                      width="12px"
                      cursor="pointer"
                      fill="#000"
                      version="1.1"
                      viewBox="0 0 40 40"
                      xmlSpace="preserve"
                    >
                      <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                    </svg>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p>Vérification d'identité</p>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="card-nom">
                  <div className="block">
                    <p>Noms de naissance : {nomClientIA}</p>
                    <p>Téléphone : {telephoneClientIA}</p>
                    <p>Adresse : {adresseClientIA}</p>
                  </div>
                  {/* block */}
                </div>
                {/* card-nom */}
              </div>
              {/* card */}
            </div>
            {/* align */}

            {/* on affiche les photos d'identiter dans l'EnfantApi car ca va nous permettre
          d'enregistrer l'url de la photo d'identiter dans le localStorage.
          cette url de la photo, sera utile lorsqu'on voudra voir la photo en grand.
          par exemple lorsqu'on clique sur la photo d'identiter pour la voir dans la popup */}
            <div className="imageDeuxAdeux">
              <div className="displayPhoto">
                {filterPhotoIA.map((api) => (
                  <>
                    <EnfantApiPhotoIdentiterClientIA api={api} />
                  </>
                ))}
              </div>
              {/* displayPhoto */}
            </div>
            {/* imageDeuxAdeux */}

            <div className="miniMenu">
              <svg
                onClick={MiniMenuVerificationIdentiterEtapeDeuxIA}
                xmlns="http://www.w3.org/2000/svg"
                width="12px"
                cursor="pointer"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="#a6a6a6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 13a1 1 0 100-2 1 1 0 000 2zM12 13a1 1 0 100-2 1 1 0 000 2zM5 13a1 1 0 100-2 1 1 0 000 2z"
                ></path>
              </svg>
            </div>
            {/* miniMenu */}

            <div className="retourner">
              <p onClick={RetournerEnArriereClientEstProprietaireIA}>
                Retourner en arrière
              </p>
            </div>
            {/* retourner */}

            <div className="continuer">
              <p onClick={RechargerUnComptePageIA}>Continuer</p>
            </div>
            {/* continuer */}
          </div>
          {/* entrerCodeOperationIA */}
        </>
      )}
      {/* page - client Est Proprietaire -  IA */}

      {/* recharger un compte (Page) -  IA */}
      {/* recharger un compte (Page) -  IA */}
      {/*on affiche la page qui va permettre a l'agent d'entrer le montant a recharger */}
      {rechargerUnComptePageIA && (
        <>
          <div className="rechargerUnComptePageIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <svg
                      onClick={
                        TransactionEnCoursVerificationIdentiterEtapeDeuxIA
                      }
                      xmlns="http://www.w3.org/2000/svg"
                      width="12px"
                      cursor="pointer"
                      fill="#000"
                      version="1.1"
                      viewBox="0 0 40 40"
                      xmlSpace="preserve"
                    >
                      <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                    </svg>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p onClick={CloseRechargerUnComptePageIA}>Effectuer un retrait</p>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="solde">
                  <p>Votre solde est de {soldeCompteDistributeurIA} FCFA</p>
                </div>
                {/* solde */}
              </div>
              {/* card */}
            </div>
            {/* align */}

            {/* ca c'est l'input qui va permettre a l'agent d'entrer le montant 
                a recharger - IA */}
            <div className="align-block-deux">
              <div className="block-deux">
                <div className="a">
                  <p>Entrer le montant à recharger</p>
                </div>

                <div className="b">
                  <input
                    type="number"
                    value={inputMontantArechargerIA}
                    onChange={(e) => setInputMontantArechargerIA(e.target.value)}
                  />
                </div>

                <div className="c">
                  <button onClick={ConfirmerRechargeIA}>Valider le retrait</button>
                </div>
              </div>
              {/* block-deux */}
            </div>
            {/* align-block-deux */}
          </div>
          {/* rechargerUnComptePageIA */}
        </>
      )}
      {/* recharger un compte (Page) -  IA */}

      {/* Confirmer la recharge - IA */}
      {/* Confirmer la recharge - IA */}
      {/* on affiche le card qui va permettre a l'agent de Confirmer la recharge */}
      {confirmerRechargeIA && (
        <>
          <div className="confirmerRechargeIA">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Confirmation</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Retrait : {montantArechargerIA} FCFA ... {nomClientIA}</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="a">
                    <button onClick={CloseConfirmerRechargeIA}>Annuler</button>
                  </div>
                  {/* a */}

                  {/*on a mis rechargeActiveIA pour que lorsque l'agent va cliquer sur 
                  Recharger, le bouton Recharger va rester rouge */}
                  {!rechargeActiveIA && (
                    <>
                      <div className="b">
                        {/*quand on clique, on recharge le compte du client*/}
                        <button onClick={WithdrawalIA}>Valider</button>
                      </div>
                      {/* b */}
                    </>
                  )}

                  {rechargeActiveIA && (
                    <>
                      <div className="rechargeActive">
                        <button onClick={WithdrawalIA}>Valider</button>
                      </div>
                      {/* rechargeActive */}
                    </>
                  )}
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* confirmerRechargeIA */}
        </>
      )}
      {/* Confirmer la recharge - IA */}

      {/* retrait Reussie - IA */}
      {/* retrait Reussie - IA */}
      {/* si le retrait a reussie on affiche ce message de success */}
      {withdrawalSuccessPageIA && (
        <>
          <div onClick={CloseWithdrawalSuccessPageIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Retrait réussie !</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <hr />
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* retrait Reussie - IA */}

      {/* retrait error - IA */}
      {/* retrait error - IA */}
      {/* si le retrait a echouer on affiche ce message d'erreur */}
      {withdrawalErrorPageIA && (
        <>
          <div onClick={CloseWithdrawalErrorPageIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>Solde du client insuffisant !</p> </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois"> <p>Impossible d'éffectuer le retrait</p> </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* retrait error - IA */}

      {/* Transation En Cours - VerificationIdentiterEtapeDeux - IA */}
      {/* Transation En Cours - VerificationIdentiterEtapeDeux - IA */}
      {/* on affiche le card qui va lui demander s'il veut annuler la transaction qui est en
      cours de traitement */}
      {transactionEnCoursVerificationIdentiterEtapeDeuxIA && (
        <>
          <div className="transactionEnCours">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Transaction en cours de traitement..</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <button onClick={CloseClientEstProprietaireIA}>
                    Annuler la transaction
                  </button>

                  <button
                    onClick={TransactionEnCoursVerificationIdentiterEtapeDeuxIA}
                  >
                    Ne pas annuler la transaction
                  </button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* transactionEnCours */}
        </>
      )}
      {/* Transaction En Cours - VerificationIdentiterEtapeDeux - IA */}

      {/* miniMenu - VerificationIdentiterEtapeDeux - IA */}
      {/* miniMenu - VerificationIdentiterEtapeDeux - IA */}
      {/* ici on affiche le miniMenu, avec ce miniMenu, la personne pourra
       par exemple: signaler quelque chose sur ce compte (sur le compte du client 
        qu'il fait la recharge) */}
      {miniMenuVerificationIdentiterEtapeDeuxIA && (
        <>
          <div
            onClick={MiniMenuVerificationIdentiterEtapeDeuxIA}
            className="miniMenuVerificationIdentiterEtapeDeuxIA"
          >
            <div className="align">
              <div className="card">
                <li>Signaler quelque chose concernant ce client</li>
                <li>Bloquer le compte de ce client</li>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* miniMenuVerificationIdentiterEtapeDeuxIA */}
        </>
      )}
      {/* miniMenu - VerificationIdentiterEtapeDeux - IA */}

      {/* numero virtuel Compte A recharger - IA */}
      {/* numero virtuel Compte A recharger - IA */}
      {/* on affiche le card qui permet d'entrer le numero virtuel pour ensuite
      effectuer la recharge */}
      {numeroTelephoneCompteArechargerIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Numéro virtuel</p>
                  <svg
                    onClick={CloseNumeroTelephoneCompteArechargerIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un">
                  <p>Entrer le numéro virtuel de la personne</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <input
                    type="text"
                    value={inputNumeroTelephoneCompteArechargerIA}
                    onChange={(e) =>
                      setInputNumeroTelephoneCompteArechargerIA(e.target.value)
                    }
                  />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  {/* j'ai mis ca : ContinuerNumeroTelephoneCompteArechargerIA , juste pour
                  le nom. car si je mets juste Continuer, il y'aura confusion s'il y'a deja
                  une fonction qui porte le nom Continuer */}
                  <p onClick={ContinuerNumeroTelephoneCompteArechargerIA}>
                    Continuer
                  </p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* numero virtuel Compte A recharger - IA */}


      {/* connexion/inscription - page - IA */}
      {/* connexion/inscription - page - IA */}
      {/* ca c'est la page qui permet a l'utilisateur de se connecter et de s'inscrire - IA */}
      {connexionPageIA && (<>
        <div className="connexionPageIA-opacity">
          <div className="align">
            <div className="logo">
              <div className="a"> <img onClick={CloseConnexionPageIA} src={izocashLogoConnexion} alt=""/> </div>
              {dev && (<><div className="b" onClick={PopupToRightIA}> <SvgPointsVertical/> </div></>)}
            </div>
            {/* logo */}

            <div className="btn">
                {/* s'il clique sur connexion, alors connexion sera active */}
                {!connexionIA && (<><div className="nonActive"> <button onClick={ConnexionIA}>{t("--connection")}</button> </div></>)}
                {connexionIA && (<><div className="active"> <button>{t("--connection")}</button> </div></>)}

                {/* s'il clique sur inscription, alors inscription sera active */}
                {!inscriptionIA && (<><div className="nonActive"> <button onClick={InscriptionIA}>{t("--registration")}</button> </div></>)}
                {inscriptionIA && (<><div className="active"> <button>{t("--registration")}</button> </div></>)}
              </div>
              {/* btn */}

              {/* connexion - IA */}
              {/* ca c'est le modal de connexion */}
              {connexionIA && (<>
                  <div className="center-card">
                    <div className="card">
                      <div className="block-un" onClick={CloseConnexionPageIA}> <p>{t("--izocash customer portal")}</p> </div>
                      <div className="block-deux" onClick={CloseConnexionPageIA}> <p>{t("--connection")}</p> </div>
                      {/* block-deux */}

                      {rtl && (<>
                      <div className="block-trois-rtl">
                        <div className="a"> <input type="text" placeholder={t("--virtual number")} value={numberLoginIA} onChange={(e) => setNumberLoginIA(e.target.value)} /> </div>
                        <div className="a"> <input type="text" placeholder={t("--password")} value={passwordLoginIA} onChange={(e) => setPasswordLoginIA(e.target.value)} /> </div>
                      </div> </>)}

                      {!rtl && (<>
                      <div className="block-trois">
                        <div className="a"> <input type="text" placeholder={t("--virtual number")} value={numberLoginIA} onChange={(e) => setNumberLoginIA(e.target.value)} /> </div>
                        <div className="a"> <input type="text" placeholder={t("--password")} value={passwordLoginIA} onChange={(e) => setPasswordLoginIA(e.target.value)} /> </div>
                      </div> </>)}
                      {/* block-trois */}

                      {dev && (<><div className="block-quatre"> <button onClick={LoginIA}>{t("--login")}</button> </div></>)}
                      <div className="block-quatre"> <button onClick={LoginIA}>{t("--login")}</button> </div>
                      {/* block-quatre */}

                      <div className="block-cinq"> <p></p> </div> {/* Mot de passe oublié */}
                    </div>
                    {/* card */}
                  </div>
                  {/* center-card */}
              </>)} {/* connexion - IA */}

              {/* inscription - IA */}
              {/* ca c'est le modal d'inscription */}
              {inscriptionIA && (<>
                  <div className="center-card">
                    <div className="card">
                      <div className="block-un" onClick={CloseConnexionPageIA}> <p>{t("--welcome to the izocash customer portal")}</p> </div>
                      <div className="block-deux" onClick={CloseConnexionPageIA}> <p>{t("--registration")}</p> </div>
                      {/* block-deux */}

                      {rtl && (<>
                      <div className="block-trois-rtl">
                        <div className="a"> <input type="text" placeholder={t("--name")} value={nameSignupIA} onChange={(e) => setNameSignupIA(e.target.value)} /> </div>
                        <div className="a"> <input type="text" placeholder={t("--virtual number")} value={numberSignupIA} onChange={(e) => setNumberSignupIA(e.target.value)} /> </div>
                        <div className="a"> <input type="text" placeholder={t("--password")} value={passwordSignupIA} onChange={(e) => setPasswordSignupIA(e.target.value)} /> </div>
                      </div></>)}

                      {!rtl && (<>
                      <div className="block-trois">
                        <div className="a"> <input type="text" placeholder={t("--name")} value={nameSignupIA} onChange={(e) => setNameSignupIA(e.target.value)} /> </div>
                        <div className="a"> <input type="text" placeholder={t("--virtual number")} value={numberSignupIA} onChange={(e) => setNumberSignupIA(e.target.value)} /> </div>
                        <div className="a"> <input type="text" placeholder={t("--password")} value={passwordSignupIA} onChange={(e) => setPasswordSignupIA(e.target.value)} /> </div>
                      </div> </>)}
                      {/* block-trois */}

                      {dev && (<><div className="block-quatre"> <button onClick={BeforeSignupIA}>{t("--signup")} ...</button> </div></>)}
                      {dev && (<><div className="block-quatre"> <button onClick={SignupIAtest}>{t("--signup")}</button> </div></>)}
                      <div className="block-quatre"> <button onClick={BeforeSignupIA}>{t("--signup")}</button> </div>
                      {/* block-quatre */}

                      <div style={{ paddingTop: "20px" }}></div>
                    </div>
                    {/* card */}
                  </div>
                  {/* center-card */}
                </>)} {/* inscription - IA */}
              
            </div>
            {/* align */}
          </div>
          {/* connexionPage-opacity */}
        </>
      )}
      {/* connexion/inscription - page - IA */}

      {/* connexion reussie - IA */}
      {/* connexion reussie - IA */}
      {/* quand la connexion a reussie, cette page va s'afficher */}
      {connexionReussieIA && (
        <>
          <div
            onClick={ConnexionReussieIA}
            className="connexionReussieIA-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>{t("--touch the screen")}</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>{t("--signup success IA")}</p>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionReussieIA-opacity */}
        </>
      )}
      {/* connexion reussie - IA */}


      {/* on ajoute une photo de profil lors de l'inscription sur izocash */}
      {/* on ajoute une photo de profil lors de l'inscription sur izocash */}
      {addPhotoProfile66connexionPageIA && (<>
      <div className="favoriteFA">
        <div className="align">
          <div onClick={CloseAddPhotoProfile66connexionPageIA} className="head"> 
            <div className="block-one"> <p>Choisissez une photo de profil</p> </div>

            <div className="block-two"> 
              <div className="b"> <SvgBottom5/> </div>
            </div>
            {/* block-two */}
          </div>
          {/* head */}

          <div className="body">
            <div className="card">
              <div className="block-one">
                <div className="a"><input onChange={(e) => setFilePhoto66addPhotoProfile66connexionPageIA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
                <div className="b"> <button onClick={SignupIA}>Valider</button> </div>
              </div>
              {/* block-one */}
              
              <p style={{ paddingTop: "100px" }}></p>
            </div>
            {/* card */}
          </div>
          {/* body */}
        </div>
        {/* align */}
        </div>
        {/* favoriteFA */}
      </>)}
      {/* on ajoute une photo de profil lors de l'inscription sur izocash */}


      {/* super code (inscription) - IA */}
      {/* super code (inscription) - IA */}
      {/* le card ci va permettre a la personne d'entrer le super code */}
      {superCodePageIA && (
        <>
          <div className="superCodeIA">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p onClick={CloseSuperCodePageIA}>Super Code</p>
                  <svg
                    onClick={CloseSuperCodePageIA}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    cursor="pointer"
                    width="10px"
                    enableBackground="new 0 0 25.93 25.93"
                    version="1.1"
                    viewBox="0 0 25.93 25.93"
                    xmlSpace="preserve"
                  >
                    <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-un">
                  <p>* {t("--write a super code")}</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <div className="a">
                    <input
                      type="text"
                      value={superCodeSignupIA}
                      onChange={(e) => setSuperCodeSignupIA(e.target.value)}
                    />
                  </div>
                  {/* a */}

                  <div className="b">
                    <button onClick={SignupIA}>
                      <p>{t("--validate")}</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15px"
                        viewBox="0 0 48 48"
                        fill="#fff"
                      >
                        <g data-name="Layer 2">
                          <path fill="none" d="M0 0H48V48H0z"></path>
                          <path d="M44.9 23.2l-38-18L6 5a2 2 0 00-2 2l5.3 16H24a2.1 2.1 0 012 2 2 2 0 01-2 2H9.3L4 43a2 2 0 002 2l.9-.2 38-18a2 2 0 000-3.6z"></path>
                        </g>
                      </svg>
                    </button>
                  </div>
                  {/* b */}
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* superCodeIA */}
        </>
      )}
      {/* super code (inscription) - IA */}

      {/* inscription reussie - IA */}
      {/* inscription reussie - IA */}
      {/* quand l'inscription a reussie, cette page va s'afficher */}
      {inscriptionReussieIA && (
        <>
          <div
            onClick={CloseInscriptionReussieIA}
            className="inscriptionReussieIA-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>{t("--signup success")}!</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>{t("--login now")}</p>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* inscriptionReussieIA-opacity */}
        </>
      )}
      {/* inscription reussie - IA */}

      {/* Popup To Right - IA */}
      {/* Popup To Right - IA */}
      {/* dans l'application Izocash, quand on clique sur les 3 points, une PopupToRight va
      s'afficher */}
      {popupToRightIA && (
        <>
          <div onClick={PopupToRightIA} className="popupToRightIA-opacity">
            <div className="block-un">

              {idPersonConnectedIA && (<><div className="icon"> <p onClick={ProfilIA}>{namePersonConnectedIA}</p> </div></>)} {/* nomPersonneConnecterIA */}
              {idPersonConnectedIA && (<><div className="icon"> <p onClick={HistoriqueIA}>{t("--historical")}</p> </div></>)} {/* Historique */}
              <div className="icon"> <p onClick={WithdrawalPointIA}>{t("--points withdrawals")}</p> </div> {/* Points Retraits izocash */}
              
              {/* J'avais deja fait ces traductions. mais j'ai changer donc faut aller modifier ces traductions 
              Faut remplacer Vérification d'identité par Vérification, traduction: --identity verification */}
              {verificationIA === "0" && (<><div className="icon"> <p onClick={VerificationDidentiterEntrepriseIA}>Vérification</p> </div></>)}
              
              {dev && (<><div className="icon"> <p onClick={VerificationDidentiterEntrepriseIA}>Vérification</p> </div></>)}
              {dev && (<><div className="icon"> <p>Jolies photos</p> </div></>)} {/* Jolies photos */}
              {dev && (<><div className="icon"> <p>Photos de l'agence</p> </div></>)} {/* Photos de l'agence */}
              {dev && (<><div className="icon"> <p onClick={WithdrawalPointIA}>{t("--points withdrawals")}</p> </div></>)} {/* Points Retraits izocash */}
              {dev && (<><div className="icon"> <p>Historique (agence)</p> </div></>)} {/* Historique (agence) */}
              {dev && (<><div className="icon"> <p>Distributeurs izocash</p> </div></>)} {/* Distributeurs izocash */}
              {dev && (<><div className="icon"> <p>izocash Business</p> </div></>)} {/* izocash Business */}
              {dev && (<><div className="icon"> <p onClick={LicenceGrandDistributeur}>Licence</p> </div></>)} {/* Licence */}
              {dev && (<><div className="icon"> <p onClick={LicenceLightIA}>Licence</p> </div></>)}
              {dev && (<><div className="icon"> <p onClick={AproposIA}>A propos</p> </div></>)} {/* A propos */}
              {dev && (<><div onClick={SettingsIA} className="icon"> <p>Paramètres</p> </div></>)} {/* Paramètres */}
                
              {typeAccountIA === "1" && identificationIA === "1" && (
              <><div onClick={SettingsIA} className="icon"> <p>Paramètres</p> </div> {/* Paramètres */}
              </>)} 

              {idPersonConnectedIA && (<><div className="icon-b"> <p onClick={DeconnexionPageIA}>{t("--log out")}</p> </div></>)} {/* Déconnexion */}
              {/* icon-b */}

            </div>
            {/* block-un */}
          </div>
          {/* popupToRightIA-opacity */}
        </>
      )}
      {/* ight - IA */}


      {/* settings - IA */}
      {/* settings - IA */}
      {/* parametres de l'application izocash */}
      {settingsIA && (
      <>
      <div className="settingsIA">
        <div className="block-one">
          <div className="a"> 
            <div onClick={CloseSettingsIA} className="aa"> <SvgLeft /> </div>
            <div className="bb"> <p>Paramètres</p> </div>
          </div>
          {/* a */}

          <div className="b"></div>
          {/* b */}
        </div>
        {/* block-one */}

        <div onClick={AffairsPageIA} className="block-two"> 
          <div className="a"> <SvgMoneyBag /> </div>
          <div className="b"> <p>Les Affaires</p> </div>
        </div>
        {/* block-two */}
      </div>
      {/* settingsIA */}
      </>
      )}
      {/* settings - IA */}


      {/* Les Affaires (page) - IA */}
      {/* Les Affaires (page) - IA */}
      {/* sur cette page on presente les differentes disponible gratuitement dans l'app izocash */}
      {affairsPageIA && (
      <>
      <div className="affairsPageIA">
        <div className="block-one">
          <div className="a"> 
            <div onClick={CloseAffairsPageIA} className="aa"> <SvgLeft /> </div>
            <div className="bb"> <p>Les Affaires</p> </div>
          </div>
          {/* a */}

          <div className="b"></div>
          {/* b */}
        </div>
        {/* block-one */}

        <div onClick={IzocashDealsActivationPageIA} className="block-two"> 
          <div className="a"> 
            <div className="aa"> <p>izocash Deals</p> </div>
            <div className="bb"> <SvgRight3 /> </div>
          </div>

          <div className="b"> <p>Gagnez une Commission de 40500 FCFA sur chaque Numéro virtuel acheté</p> </div>
          <div className="c"> <hr /> </div>
          {/* c */}
        </div>
        {/* block-two */}

      </div>
      {/* affairsPageIA */}
      </>
      )}
      {/* Les Affaires (page) - IA */}


      {/* page d'activation de izocash Deals - IA */}
      {/* page d'activation de izocash Deals - IA */}
      {izocashDealsActivationPageIA && (
        <>
          <div className="izocashDealsActivationIA">
            <div className="close">
              <div className="a"> <p>izocash <b>Deals</b></p> </div>
              <div className="b"> <button onClick={CloseIzocashDealsActivationPageIA}>Fermer</button> </div>
            </div>
            {/* close */}

            {izocashDealsActiveIA && (<> {/* pour dire que tu m'affiches ceci uniquement si les donnees sont disponibles */}

            {izocashDealsActiveIA === "1" ? (<><div className="block-two"> <p>Activé</p><SvgValidate3 /> </div>
            </>):(<><div className="block-one"> <button onClick={IzocashDealsActivationIA}><p>Activer</p><hr /> </button> </div></>)}
            </>)}

            <div className="block-three"> 
              <p>Faites du Business avec izocash Deals et Gagnez une Commission de 40500 FCFA sur chaque Numéro virtuel acheté avec votre Super code</p> 
              <p>Retirer votre rémunération à n'importe quelle moment au Point Retrait le plus proche de chez vous.</p>
              <p>izocash vous accompagne Partout pour que vous aussi vous Gagnez Plusieurs Millions avec le Téléphone virtuel</p>
            </div>
            {/* block-three */}
        </div>
        {/* izocashDealsActivationIA */}
      </>)}
      {/* page d'activation de izocash Deals - IA */}


      {/* points retraits izocash - IA */}
      {/* points retraits izocash - IA */}
      {/* sur cette page on affiche tout les points retraits */}
      {withdrawalPointIA && (
      <>
      <div className="withdrawalPointIA">
        <div className="block-one">
          <div className="a">
            <div onClick={CloseWithdrawalPointIA} className="aa"><SvgLeft /></div>
            <div className="bb"><p>{t("--points withdrawals izocash")}</p></div>
          </div>

          {dev && (<><div className="b"> <SvgBottom4 /> </div></>)}
        </div>
        {/* block-one */}

        <div className="block-two">
          <SvgMaps2 />
          <p>Pointe-Noire</p>
          {dev && (<><p>{cityIA2}</p></>)}
        </div>
        {/* block-two */}

        <div className="block-four">
          <div className="a"> <img src={flagCongo} alt="" /> </div>
          <div className="b"> <p>{t("--congo")}</p> </div>
        </div>
        {/* block-four */}


        {/* language - on affiche la liste des langues */}
        {/* language - on affiche la liste des langues */}
        {dev && (<>
        {language666WithdrawalPointIA && (
        <>
        <div className="block-three">
          <div className="a">
            <div className="aa"> <SvgTranslate /> </div>
            <div className="bb"> <p>{languageIA2}</p> </div>
          </div>

          <div className="b"> <p>{languageInEnglishIA}</p> </div>
        </div>
        
        <div onClick={Country666WithdrawalPointIA} className="display-language"> 
          {apiLanguageIA.map((api) => (
          <> 
            <ChildApiLanguageIA api={api} /> 
          </>))}
        </div>
        </>)}

        {/* country - on affiche la liste des pays */}
        {/* country - on affiche la liste des pays */}
        {country666WithdrawalPointIA && (
        <>
        <div className="block-three"> 
          <div onClick={Language666WithdrawalPointIA} className="a">
            <div className="aa"> <SvgTranslate /> </div>
            <div className="bb"> <p>{languageIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div className="b"> <p>{languageInEnglishIA}</p> </div>

          <div className="a">
            <div className="bb"> <p>{countryIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>
        </div>
        
        <div onClick={City666WithdrawalPointIA} className="display-language"> 
          {filterCountryIA.map((api) => (
          <> 
            <ChildApiCountryIA api={api} /> 
          </>))} 
        </div> 
        </>)}

        {/* city - on affiche la liste des villes */}
        {/* city - on affiche la liste des villes */}
        {city666WithdrawalPointIA && (
        <>
        <div className="block-three"> 
          <div onClick={Language666WithdrawalPointIA} className="a">
            <div className="aa"> <SvgTranslate /> </div>
            <div className="bb"> <p>{languageIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div onClick={Country666WithdrawalPointIA} className="a">
            <div className="bb"> <p>{countryIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div className="a">
            <div className="bb"> <p>{cityIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div className="b"> <p>{languageInEnglishIA}</p> </div>
        </div>

        <div onClick={Quarter666WithdrawalPointIA} className="display-language"> 
          {filterCityIA.map((api) => (
          <> 
            <ChildApiCityIA api={api} /> 
          </>))} 
        </div> 
        </>)}

        {/* quarter - on affiche la liste des quartiers */}
        {/* quarter - on affiche la liste des quartiers */}
        {quarter666WithdrawalPointIA && (
          <>
        <div className="block-three"> 
          <div onClick={Language666WithdrawalPointIA} className="a">
            <div className="aa"> <SvgTranslate /> </div>
            <div className="bb"> <p>{languageIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div onClick={Country666WithdrawalPointIA} className="a">
            <div className="bb"> <p>{countryIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div onClick={City666WithdrawalPointIA} className="a">
            <div className="bb"> <p>{cityIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>

          <div className="a">
            <div className="bb"> <p>{quarterIA2}</p> </div>
            <div className="cc"> <SvgRight3 /> </div>
          </div>
        </div>

        <div className="display-language"> 
          {filterQuarterIA.map((api) => (
          <> 
            <ChildApiQuarterIA api={api} /> 
          </>))} 
        </div> 
        </>)} {/* overflow666WithdrawalPointIA && (<> */}

        </>)} {/* dev && se ferme ici */}

        {/* on affiche les points retraits */}
        <div onClick={PageRedirection666WithdrawalPointIA} className="display-withdrawalPoint">
          {filterWithdrawalPointIA.map((api) => (
            <>
              <ChildApiWithdrawalPointIA api={api} />
            </>
          ))}
        </div>

      </div>
      {/* withdrawalPointIA */}
      </>
      )}
      {/* points retraits izocash - IA */}

      {/* voir les infos du point retrait - IA */}
      {/* voir les infos du point retrait - IA */}
      {seeInfos666WithdrawalPointIA && (
        <>
          <div className="seeInfos666WithdrawalPointIA">
            <div className="align">
              <div className="head"></div>
              {/* head */}

              <div className="body">
                <div className="card">
                  <div className="infos">
                    <div className="width">
                      <div className="adresseEtLocalisation">
                        <div className="block-one">
                          <div className="a">
                            <div className="aa"> <p>{nameIA}</p> </div>
                            <div onClick={SeePhoto666WithdrawalPointIA} className="bb"> <img src={photoIA} alt="" /> </div>
                          </div>
                          {/* a */}

                          <div onClick={CloseSeeInfos666WithdrawalPointIA} className="b">
                            <hr />
                            <p>{addressIA}</p>
                            <p>{quarterIA}</p>
                            <p>{cityIA}</p>
                            <p>{countryIA}</p>
                          </div>
                          {/* b */}
                        </div>
                        {/* block-one */}

                        <div onClick={CloseSeeInfos666WithdrawalPointIA} className="block-two"> <SvgVirtualNumber /> <p>{virtualNumberIA2}</p> </div> {/* numero virtuel */}
                        <div onClick={CloseSeeInfos666WithdrawalPointIA} className="block-two"> <SvgPhoneNumber /> <p>{phoneNumberIA2}</p> </div> {/* numero de telephone */}
                        {/* block-two */}

                      </div>
                      {/*adresseEtLocalisation */}
                    </div>
                    {/* width */}
                  </div>
                  {/* infos */}
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* seeInfos666WithdrawalPointIA */}
        </>
      )}
      {/* voir les infos du point retrait - IA */}

      {/* voir la photo du point retrait - IA */}
      {/* voir la photo du point retrait - IA */}
      {seePhoto666WithdrawalPointIA && (
        <>
          <div onClick={CloseSeePhoto666WithdrawalPointIA} className="seePhoto666WithdrawalPointIA">
            <div className="block-one">
              <div className="a"> <img src={izocashWhite} alt="" /> </div>
              <div className="b"> </div>
            </div>
            {/* block-one */}

            <div className="block-two">
              <div className="a">
                <div className="aa"> <img src={photoIA} alt="" /> </div>
                <div className="bb"> <p>{nameIA}</p> </div>
              </div>
              {/* a */}

              <div className="b"> </div>
              {/* b */}
            </div>
            {/* block-two */}
          </div>
          {/* seePhoto666WithdrawalPointIA */}
        </>
      )}
      {/* voir la photo du point retrait - IA */}
      

      {/* historique (page) - IA */}
      {/* historique (page) - IA */}
      {/* ca c'est l'historique */}
      {historiqueIA && (
        <>
          <div className="historiquePageIA">
            <div className="close">
              <div className="a">
                <div onClick={CloseHistoriqueIA} className="aa"> <SvgLeft3 /> </div>
                <div className="bb"> <p>{t("--historical")}</p> </div>
              </div>
              {/* a */}

              <div onClick={RefreshNotificationIA} className="b"> <SvgRefresh /> </div>
              {/* b */}
            </div>
            {/* close */}  

            {/* on affiche l'historique - IA */}
            <div onClick={PageRedirection666HistoryIA}>
              {apiNotificationIA.map((api) => (
                <>
                  <EnfantApiHistoryIA api={api} />
                </>
              ))}
            </div>

          </div>
          {/* historiquePageIA */}
        </>
      )}
      {/* historique (page) - IA */}


      {/* toast (notification en cours d'actualisation) - IA */}
      {/* toast (notification en cours d'actualisation) - IA */}
      {waitRefreshIA && (<>
        <div onClick={CloseWaitRefreshIA} className="toastSettings">
          <div className="bottom">
            <div className="center">
              <button>. . .</button>
            </div>
            {/* center */}
          </div>
          {/* bottom */}
        </div>
        {/* toastSettings */}
      </>)}
      {/* toast (notification en cours d'actualisation) - IA */}


      {/* toast (notification actualisé) - IA */}
      {/* toast (notification actualisé) - IA */}
      {refreshSuccessIA && (<>
        <div onClick={CloseRefreshSuccessIA} className="toastRefreshIA">
          <div className="bottom">
            <div className="card">
              <button> <p>Actualiser</p><SvgValidate4 /> </button>
            </div>
            {/* card */}
          </div>
          {/* bottom */}
        </div>
        {/* toastRefreshIA */}
      </>)}
      {/* toast (notification actualisé) - IA */}


      {/* infos notification ( 666 HistoryIA) */}
      {/* infos notification ( 666 HistoryIA) */}
      {/* ici on affiche plus d'informations sur la notification */} 
      {infosNotificationPage666HistoryIA && (
        <>
          <div onClick={CloseInfosNotificationPage666HistoryIA} className="infosNotificationPage666HistoryIA">
            <div className="align">
              <div className="head"></div>
              {/* head */}

              <div className="body">
                <div className="card">

                  {/* notification=2 (identification reussie) */}
                  {/* l'utilisateur recoit cette notification si son numero virtuel a bien ete identifier */}
                  {notificationIA === "2" && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identification réussie !</p>
                        </div>

                        <div className="c">
                          <p>Votre numéro virtuel a bien été identifié</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identification reussie */}

                  {/* notification=4 (transfert national envoyer) */}
                  {/* l'utilisateur recoit cette notification s'il a envoyer de l'argent */}
                  {notificationIA === "4" && idOwnerIA && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                        <p>{nameOtherIA}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>Transfert d'argent</p> </div>
                          <div className="bb"> <p>Dans le Compte National</p> </div>
                        </div>
                        {/* a */}

                        {/* nameOtherIA = nameReceiver */}

                        <div className="b"> <p>Vous avez envoyé {amountIA} FCFA à {nameOtherIA}</p> </div>
                        {/* b */}

                        <div className="c">
                          <p>Transfert: {amountIA} FCFA</p>
                          <p>Frais de transfert: {feesIA} FCFA</p>
                          <p>Total: {totalIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-trois">
                        <p>ID: {idNotificationIA}</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Solde</p> </div>
                        <div className="b"> <p>{oldBalanceOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Solde</p> </div>
                        <div className="b"> <p>{newBalanceOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* transfert national envoyer */}


                  {/* notification=4 (transfert national recu) */}
                  {/* l'utilisateur recoit cette notification s'il a recu un transfert d'argent */}
                  {notificationIA === "4" && idOtherIA && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                        <p>{nameOwnerIA}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>Transfert reçu !</p> </div>
                          <div className="bb"> <p>Dans le Compte National</p> </div>
                        </div>
                        {/* a */}

                        {/* nameOwnerIA = nameSender */}

                        <div className="b"> <p>{nameOwnerIA} vous a envoyé {amountIA} FCFA</p> </div>
                        {/* b */}

                        <div className="c"> 
                          <p>Transfert: {amountIA} FCFA</p>
                          <p>Frais de transfert: {feesIA} FCFA</p>
                          <p>Total: {totalIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-trois">
                        <p>ID: {idNotificationIA}</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Solde</p> </div>
                        <div className="b"> <p>{oldBalanceOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Solde</p> </div>
                        <div className="b"> <p>{newBalanceOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* transfert national recu */}


                  {/* notification=5 (retrait reussie) */}
                  {/* l'utilisateur recoit cette notification apres avoir effectuer un retrait */}
                  {notificationIA === "5" && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Retrait réussie !</p>
                        </div>

                        <div className="c">
                          <p>Vous avez effectuer un retrait de 10 000 FCFA. Merci !</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* retrait reussie */}

                  {/* notification=7 (versement International envoyer) */}
                  {/* l'utilisateur recoit cette notification s'il a envoyer un versement */}
                  {notificationIA === "7" && idOwnerIA && (
                    <>
                    <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                        <p>{nameOtherIA}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa">
                            <p>VERSEMENT EN ESPÈCES</p>
                          </div>
                          {/* aa */}
                          
                          <div className="bb">
                            <p>Dans le Compte international</p>
                          </div>
                          {/* bb */}
                        </div>
                        {/* a */}

                        {/* nameOtherIA = nameReceiver */}

                        <div className="b">
                          <p>Vous avez envoyé {amountIA} FCFA à {nameOtherIA}</p>
                        </div>
                        {/* b */}

                        <div className="c">
                          <p>Transfert: {amountIA} FCFA</p>
                          <p>Frais de versement: {feesIA} FCFA</p>
                          <p>Total: {totalIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-trois">
                        <p>ID: 1230511044</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Ancien Solde</p>
                        </div>

                        <div className="b">
                          <p>{oldBalanceOwnerIA} FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Nouveau Solde</p>
                        </div>

                        <div className="b">
                          <p>{newBalanceOwnerIA} FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* versement International envoyer */}


                  {/* notification=6 (versement national recu) */}
                  {/* notification=6 (versement national recu) */}
                  {notificationIA === "6" && idOtherIA && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                        <p>{nameOwnerIA}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>VERSEMENT EN ESPÈCES</p> </div>
                          <div className="bb"> <p>Dans le Compte National</p> </div>
                        </div>
                        {/* a */}

                        {/* nameOwnerIA = nameSender */}

                        <div className="b"> <p>{nameOwnerIA} a effectué un dépôt d'argent de {amountIA} FCFA dans votre Compte National</p> </div>
                        {/* b */}

                        <div className="c"> 
                          <p>Versement: {amountIA} FCFA</p>
                          <p>Frais de versement: {feesIA} FCFA</p>
                          <p>Montant à payer: {totalIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-trois">
                        <p>ID: {idNotificationIA}</p>
                        <div onClick={SeeReceiptDepositNationalIA}> <SvgHorizontal3 /> </div>
                      </div>
                      {/* block-trois */} 

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Solde</p> </div>
                        <div className="b"> <p>{oldBalanceOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Solde</p> </div>
                        <div className="b"> <p>{newBalanceOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* versement national recu */}


                  {/* notification=6 (versement national recu) */}
                  {/* notification=6 (versement national recu) */}
                  {notificationIA === "6" && idOwnerIA && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                        <p>{nameOtherIA}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">  <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>VERSEMENT EN ESPÈCES</p> </div>
                          <div className="bb"> <p>Dans le Compte National</p> </div>
                        </div>
                        {/* a */}

                        {/* nameOwnerIA = nameSender */}

                        <div className="b"> <p>Vous avez effectué un dépôt d'argent de {amountIA} FCFA dans le Compte National de {nameOtherIA}</p> </div>
                        {/* b */}

                        <div className="c"> 
                          <p>Versement: {amountIA} FCFA</p>
                          <p>Frais de versement: {feesIA} FCFA</p>
                          <p>Total: {totalIA} FCFA</p>
                          <p>Commission: {commissionIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-trois">
                        <p>ID: {idNotificationIA}</p>
                        <div onClick={SeeReceiptDepositNationalIA}> <SvgHorizontal3 /> </div>
                      </div>
                      {/* block-trois */} 

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Stock National</p> </div>
                        <div className="b"> <p>{newStockOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Stock National</p> </div>
                        <div className="b"> <p>{oldStockOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-sept"> <p>Stock nécessaire: {stockRequiredIA} FCFA</p> </div>
                      {/* block-sept */}
                    </>
                  )}
                  {/* versement national recu */}


                  {/* notification=8 (Commission achat Numéro virtuel) */}
                  {/* il va recevoir cette notification si une personne a acheter son numero virtuel avec son super code */}
                  {notificationIA === "8" && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>izocash Buy</p>
                        </div>

                        <div className="c">
                          <p>Une personne a achetée son numéro virtuel avec votre Super code</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* Commission achat Numéro virtuel */}

                  {/* notification=9 (Identités envoyées) */}
                  {/* informations d'identiter de l'entreprise envoyé */}
                  {notificationIA === "9" && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée envoyer !</p>
                        </div>

                        <div className="c">
                          <p>
                            Vos informations d'identitées ont bien été envoyées.
                            Les équipes d'izocash Business analyseront les
                            informations que vous avez envoyer et vous
                            retournera la réponse au niveau de l'historique de
                            votre compte izocash. Merci !
                          </p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* Identités envoyées */}

                  {/* notification=10 (Votre Recharge national a réussie) */}
                  {/* recharger mon compte national depuis mon compte international - IA */}
                  {notificationIA === "10" && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Votre recharge national a reussie !</p>
                        </div>

                        <div className="c">
                          <p>La recharge de 10 000 FCFA vers votre compte national a reussie</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* Votre Recharge national a réussie */}


                  {/* notification=12 (Transfert réussie: izocash Buy vers izocash international) */}
                  {notificationIA === "12" && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>izocash Buy vers izocash international</p>
                        </div>

                        <div className="c">
                          <p>Le transfert de 10 000 FCFA de votre compte izocash Buy vers votre izocash International a réussie</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* Transfert réussie: izocash Buy vers izocash international */}


                  {/* notification=11 (stock national gratuit) */}
                  {notificationIA === "11" && (
                    <>
                      <div className="block-un"> <p>{dateParserLong(dateIA)}</p> </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a"> <p>INFORMATION</p> </div>
                        <div className="c"> <p>Vous avez reçu gratuitement un Stock National de {amountIA} FCFA. Merci de faire confiance à izocash !</p> </div>
                      </div>
                      {/* block-deux */}

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Stock National</p> </div>
                        <div className="b"> <p>{newStockOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Stock National</p> </div>
                        <div className="b"> <p>{oldStockOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* stock national gratuit */}
                  

                  {/* notification=13 (numero virtuel delivrer) */}
                  {/* notification=13 (numero virtuel delivrer) */}
                  {notificationIA === "13" && (
                    <>
                      <div className="block-un">
                        <div className="a"> <p>{dateParserLong(dateIA)}</p> </div>
                        <div className="b"> <p>{nameOwnerIA}</p> </div>
                      </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>Numéro virtuel délivré</p> </div>
                          <div className="bb"> </div>
                        </div>
                        {/* a */}

                        <div className="b"> <p>Numéro virtuel: {virtualNumberIA}</p> </div>
                        {/* b */}

                        <div className="c">
                          <p>Propriétaire: {nameOwnerVirtualNumberIA}</p>
                          <p>Prix du Numéro virtuel: {priceIA} FCFA</p>
                          <p>Montant à payer: {amountIA} FCFA</p>
                          <p>Commission: {commissionIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-trois">
                        <p>ID: {idNotificationIA}</p>
                        <div onClick={SeeReceiptIA}> <SvgHorizontal3 /> </div>
                      </div>
                      {/* block-trois */} 

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Stock National</p> </div>
                        <div className="b"> <p>{newStockOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Stock National</p> </div>
                        <div className="b"> <p>{oldStockOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-sept"> <p>Stock nécessaire: {stockRequiredIA} FCFA</p> </div>
                      {/* block-sept */}
                    </>
                  )}
                  {/* numero virtuel delivrer */}


                   {/* notification=14 (rappel pour aller identifier le numero virtuel) */}
                   {notificationIA === "14" && (
                    <>
                      <div className="block-un"> <p>{dateParserLong(dateIA)}</p> </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a"> <p>INFORMATION</p> </div>
                        <div className="c"> <p>Chèr(e) Client(e), votre Numéro virtuel n'est point identifier. Veuillez vous rendre dans un Point Retrait izocash muni de votre pièce d'identitée pour le faire identifier</p> </div>
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* rappel pour aller identifier le numero virtuel */}


                  {/* notification=15 (stock national payant) */}
                  {notificationIA === "15" && (
                    <>
                      <div className="block-un"> <p>{dateParserLong(dateIA)}</p> </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a"> <p>INFORMATION</p> </div>
                        <div className="c"> <p>Votre Stock National a été rechargé. N'oublier pas de Recharger votre Stock avant qu'il ne s'épuise pour ne pas être en Rupture de Stock !</p> </div>
                        <div className="c"> <p>Montant rechargé: {amountIA} FCFA</p> </div>
                      </div>
                      {/* block-deux */}

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Stock National</p> </div>
                        <div className="b"> <p>{newStockOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Stock National</p> </div>
                        <div className="b"> <p>{oldStockOtherIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* stock national payant */}


                  {/* notification=16 (identification reussie) */}
                  {/* notification=16 (identification reussie) */}
                  {notificationIA === "16" && idOwnerIA && (
                    <>
                      <div className="block-un">
                        <div className="a"> <p>{dateParserLong(dateIA)}</p> </div>
                        <div className="b"> <p>{nameOtherIA}</p> </div>
                      </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>Identification réussie</p> </div>
                          <div className="bb"> </div>
                        </div>
                        {/* a */}

                        <div className="b"> <p>Numéro virtuel identifié: {virtualNumberIA}</p> </div>
                        {/* b */}

                        <div className="c">
                          <p>Identifier au nom de: {nameOwnerIA}</p>
                          <p>Frais d'identification: {priceIA} FCFA</p>
                          <p>Montant à payer: {amountIA} FCFA</p>
                          <p>Commission: {commissionIA} FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>
                      
                      <div className="block-trois">
                        <p>ID: {idNotificationIA}</p>
                        <div onClick={SeeReceiptIdentificationSuccessIA}> <SvgHorizontal3 /> </div>
                      </div>
                      {/* block-trois */} 

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Stock National</p> </div>
                        <div className="b"> <p>{newStockOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Stock National</p> </div>
                        <div className="b"> <p>{oldStockOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-sept"> <p>Stock nécessaire: {stockRequiredIA} FCFA</p> </div>
                      {/* block-sept */}
                    </>
                  )}
                  {/* identification reussie */}


                  {/* notification=16 (identification reussie) */}
                  {/* notification=16 (identification reussie) */}
                  {notificationIA === "16" && idOtherIA && (
                    <>
                      <div className="block-un"> <p>{dateParserLong(dateIA)}</p> </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a"> <p>INFORMATION</p> </div>
                        <div className="c"> <p>Chèr(e) abonné(e), votre Numéro virtuel a été identifié. Bienvenue dans la Famille izocash !</p> </div>
                        <div className="c"> <p>Passez une très belle expérience avec votre Numéro virtuel !</p> </div>
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identification reussie*/}


                  {/* notification=17 (recharge alrani pay reussie) */}
                  {notificationIA === "17" && idOwnerIA && (
                    <>
                      <div className="block-un">
                        <p>{dateParserLong(dateIA)}</p>
                        <p>{nameOtherIA}</p>
                      </div>
                      {/* block-un */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-deux">
                        <div className="a">
                          <div className="aa"> <p>Recharge Alrani Pay</p> </div>
                        </div>
                        {/* a */}

                        {/* nameOwnerIA = nameSender */}

                        <div className="b"> <p>La Recharge Alrani Pay de {amountIA} FCFA a réussie !</p> </div>
                        {/* b */}

                        <div className="c"> 
                          <p>Recharge: {amountIA} FCFA</p>
                          <p>Frais de recharge: {feesIA} FCFA</p>
                          <p>Montant à payer: {totalIA} FCFA</p>
                          <p>Compte Alrani Pay Bénéficiaire: {nameOtherIA}</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr"> <hr /> </div>

                      <div className="block-trois"> <p>ID: {idNotificationIA}</p> </div>
                      {/* block-trois */} 

                      <div className="block-quatre">
                        <div className="a"> <p>Ancien Solde</p> </div>
                        <div className="b"> <p>{oldBalanceOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a"> <p>Nouveau Solde</p> </div>
                        <div className="b"> <p>{newBalanceOwnerIA} FCFA</p> </div>
                      </div>
                      {/* block-quatre */}
                    </>
                  )}
                  {/* recharge alrani pay reussie */}

            
                  {/* recharge (client) - IA */}
                  {/* recharge (client) - IA */}
                  {rechargeIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                        <p>Serfin SA</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Recharge national</p>
                        </div>

                        <div className="c">
                          <p>Recharge: 5000 FCFA</p>
                          <p>Frais de recharge: 1000 FCFA</p>
                          <p>Total: 6000 FCFA</p>
                          <p>Éffectuer par: KILENDO DINGHA VEIL BRILLANT</p>
                          <p>Montant à payer: 6000 FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-trois">
                        <p>ID: 1230511044</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Nouveau solde</p>
                        </div>

                        <div className="b">
                          <p>10.000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Ancien solde</p>
                        </div>

                        <div className="b">
                          <p>5000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-cinq">
                        <div className="a">
                          <p>Taux de change de Serfin SA</p>
                        </div>

                        <div className="b">
                          <p>1 FCFA</p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#000"
                            data-name="Layer 2"
                            viewBox="0 0 32 32"
                          >
                            <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                          </svg>
                          <p>1 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-cinq */}
                    </>
                  )}
                  {/* recharge (client) - IA */}

                  {/* recharge (agence) - IA */}
                  {/* recharge (agence) - IA */}
                  {rechargeIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                        <p>Serfin SA</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Recharge national</p>
                        </div>

                        <div className="c">
                          <p>Recharge: 5000 FCFA</p>
                          <p>Frais de recharge: 1000 FCFA</p>
                          <p>Total: 6000 FCFA</p>
                          <p>Client: KILENDO DINGHA VEIL BRILLANT</p>
                          <p>Montant à payer: 6000 FCFA</p>
                          <p>Commission: 250 FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-trois">
                        <p>ID: 1230511044</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Nouveau Stock Recharge</p>
                        </div>

                        <div className="b">
                          <p>10.000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Ancien Stock Recharge</p>
                        </div>

                        <div className="b">
                          <p>5000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-cinq">
                        <div className="a">
                          <p>Serfin SA - Taux de change</p>
                        </div>

                        <div className="b">
                          <p>1 FCFA</p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#000"
                            data-name="Layer 2"
                            viewBox="0 0 32 32"
                          >
                            <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                          </svg>
                          <p>1 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-cinq */}

                      <div className="block-six">
                        <div className="a">
                          <h6>Faites un éffort et devenez Partenaire+</h6>
                          <p>
                            En étant Partenaire+ vous pourrez gagner entre 40 et
                            60% de commission
                          </p>
                        </div>
                        {/* a */}

                        <div className="b">
                          <p>Partenaire+++ 60%</p>
                          <p>Partenaire++ 50%</p>
                          <p>Partenaire+ 40%</p>
                          <p>Partenaire 30%</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-six */}
                    </>
                  )}
                  {/* recharge (agence) - IA */}

                  {/* retrait - IA */}
                  {/* retrait - IA */}
                  {retraitIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                        <p>Serfin SA</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Retrait réussi</p>
                        </div>

                        <div className="c">
                          <p>Retrait: 5000 FCFA</p>
                          <p>Frais de retrait: 0 FCFA</p>
                          <p>Total: 5000 FCFA</p>
                          <p>Éffectuer par: KILENDO DINGHA VEIL BRILLANT</p>
                          <p>Montant à recevoir: 5000 FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-trois">
                        <p>ID: 1230511044</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Nouveau solde</p>
                        </div>

                        <div className="b">
                          <p>10.000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Ancien solde</p>
                        </div>

                        <div className="b">
                          <p>5000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-cinq">
                        <div className="a">
                          <p>Taux de change de Serfin SA</p>
                        </div>

                        <div className="b">
                          <p>1 FCFA</p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#000"
                            data-name="Layer 2"
                            viewBox="0 0 32 32"
                          >
                            <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                          </svg>
                          <p>1 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-cinq */}
                    </>
                  )}
                  {/* retrait - IA */}

                  {/* retrait (agence) - IA */}
                  {/* retrait (agence) - IA */}
                  {retraitIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                        <p>Serfin SA</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Retrait réussi</p>
                        </div>

                        <div className="c">
                          <p>Retrait: 5000 FCFA</p>
                          <p>Frais de retrait: 0 FCFA</p>
                          <p>Total: 5000 FCFA</p>
                          <p>Éffectuer par: KILENDO DINGHA VEIL BRILLANT</p>
                          <p>Montant à recevoir: 5000 FCFA</p>
                          <p>Commission: 250 FCFA</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-trois">
                        <p>ID: 1230511044</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12px"
                          fill="#000"
                          version="1.1"
                          viewBox="0 0 40 40"
                          xmlSpace="preserve"
                        >
                          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                        </svg>
                      </div>
                      {/* block-trois */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Nouveau Stock Retrait</p>
                        </div>

                        <div className="b">
                          <p>10.000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-quatre">
                        <div className="a">
                          <p>Ancien Stock Retrait</p>
                        </div>

                        <div className="b">
                          <p>5000 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-quatre */}

                      <div className="block-cinq">
                        <div className="a">
                          <p>Serfin SA - Taux de change</p>
                        </div>

                        <div className="b">
                          <p>1 FCFA</p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#000"
                            data-name="Layer 2"
                            viewBox="0 0 32 32"
                          >
                            <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                          </svg>
                          <p>1 FCFA</p>
                        </div>
                        {/* b */}
                      </div>
                      {/* block-cinq */}
                    </>
                  )}
                  {/* retrait (agence) - IA */}

                  {/* identiter incomplete (documents d'identiter manquants) - IA */}
                  {/* identiter incomplete (documents d'identiter manquants) - IA */}
                  {/* l'utilisateur recoit cette notification s'il n'a pas envoyer les 
                  documents d'identiter de son entreprise */}
                  {identityIncompleteDocumentMissingIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée incomplète</p>
                        </div>

                        <div className="c">
                          <p>Document(s) d'identité(s) manquant(s).</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identiter incomplete (documents d'identiter manquants) - IA */}

                  {/* identiter incomplete (Informations de l'entreprise manquantes) - IA */}
                  {/* identiter incomplete (Informations de l'entreprise manquantes) - IA */}
                  {/* l'utilisateur recoit cette notification s'il n'a pas envoyer les 
                  informations d'identiter de son entreprise */}
                  {identityIncompleteInformationMissingIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée incomplète</p>
                        </div>

                        <div className="c">
                          <p>Informations de l'entreprise manquantes.</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identiter incomplete (Informations de l'entreprise manquantes) - IA */}

                  {/* identiter incomplete (logo de l'entreprise manquant) - IA */}
                  {/* identiter incomplete (logo de l'entreprise manquant) - IA */}
                  {/* l'utilisateur recoit cette notification s'il n'a pas envoyer le logo de 
                  son entreprise */}
                  {identityIncompleteLogoMissingIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée incomplète</p>
                        </div>

                        <div className="c">
                          <p>Logo de l'entreprise manquant</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identiter incomplete (logo de l'entreprise manquant) - IA */}

                  {/* identiter incomplete (photos de l'entreprise manquantes) - IA */}
                  {/* identiter incomplete (photos de l'entreprise manquantes) - IA */}
                  {/* l'utilisateur recoit cette notification s'il n'a pas envoyer les photos 
                  de son entreprise */}
                  {identityIncompletePhotoMissingIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée incomplète</p>
                        </div>

                        <div className="c">
                          <p>Photos de l'entreprise manquantes.</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identiter incomplete (photos de l'entreprise manquantes) - IA */}

                  {/* identiter incomplete - Réseaux sociaux manquants - IA */}
                  {/* identiter incomplete - Réseaux sociaux manquants - IA */}
                  {/* l'utilisateur recoit cette notification s'il n'a pas ajouter 
                  les réseaux sociaux de son entreprise */}
                  {identityIncompleteSocialNetworkMissingIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée incomplète</p>
                        </div>

                        <div className="c">
                          <p>Réseaux sociaux manquants.</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identiter incomplete - Réseaux sociaux manquants - IA */}

                  {/* identiter valider - IA */}
                  {/* identiter valider - IA */}
                  {/* l'utilisateur recoit cette notification si ses informations d'identiter 
                  ont été validées par izocash Business */}
                  {identityValidateIA && (
                    <>
                      <div className="block-un">
                        <p>10/09/2024, 10:34</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Identitée valider !</p>
                        </div>

                        <div className="c">
                          <p>
                            Vous pouvez maintenant gagner de l'argent avec
                            izocash Points de retraits
                          </p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* identiter valider - IA */}

                  {/* Stock Recharge presque épuisé - IA */}
                  {/* Stock Recharge presque épuisé - IA */}
                  {/* l'agence recoit cette notification si son stock recharge est presque 
                  epuiser */}
                  {stockRefillAlmostExhaustedIA && (
                    <>
                      <div className="block-un">
                        <p>ss</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Stock Recharge presque épuisé</p>
                        </div>

                        <div className="c">
                          <p>
                            Votre Stock Recharge est presque épuisé. Veuillez le
                            recharger à temps pour ne pas être en rupture de
                            Stock
                          </p>
                          <p>10/09/2024, 10:34</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* Stock Recharge presque épuisé - IA */}

                  {/* Stock Retrait presque épuisé - IA */}
                  {/* Stock Retrait presque épuisé - IA */}
                  {/* l'agence recoit cette notification si son stock retrait est presque 
                  epuiser */}
                  {stockWithdrawalAlmostExhaustedIA && (
                    <>
                      <div className="block-un">
                        <p>ss</p>
                      </div>
                      {/* block-un */}

                      <div className="hr">
                        <hr />
                      </div>

                      <div className="block-deux">
                        <div className="a">
                          <p>Stock Retrait presque épuisé</p>
                        </div>

                        <div className="c">
                          <p>
                            Votre Stock Retrait est presque épuisé. Veuillez le
                            recharger à temps pour ne pas être en rupture de
                            Stock
                          </p>
                          <p>10/09/2024, 10:34</p>
                        </div>
                        {/* c */}
                      </div>
                      {/* block-deux */}
                    </>
                  )}
                  {/* Stock Retrait presque épuisé - IA */}

                  
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* infosTransactionPageIA */}
        </>
      )}
      {/* infos notification page ( 666 HistoryIA) */}

      {/* infos other page ( 666 HistoryIA) */}
      {/* infos other page ( 666 HistoryIA) */}
      {infosOtherPage666HistoryIA && (
        <>
          <div className="infosAgencePageIA">
            <div className="align">
              <div className="head"></div>
              {/* head */}

              <div className="body">
                <div className="card">
                  <div className="infos">
                    <div className="width">
                      <div onClick={CloseInfosOtherPage666HistoryIA} className="adresseEtLocalisation">
                        <p>Serfin SA</p>
                        <hr />
                        <p>
                          107 Avenue de la Frontière, non loin de la pharmacie
                          Médina
                        </p>
                        <p>FLM</p>
                        <p>Tchimbamba</p>
                        <p>Pointe-Noire</p>
                        <p>Congo</p>

                        {/* nv - numero virtuel */}
                        <div className="nv">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke="#000"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.5"
                              d="M14.5 6.5c.737.144 1.469.469 2 1 .531.531.856 1.263 1 2M15 3c1.532.17 2.91.911 4 2 1.09 1.089 1.828 2.469 2 4m0 7.477v2.71c.004 1.035-.928 1.9-1.974 1.806C10 21 3 13.935 3.008 4.969 2.913 3.93 3.774 3.001 4.808 3h2.715c.44-.004.865.151 1.198.437.947.812 1.556 3.57 1.322 4.667-.183.856-1.046 1.455-1.633 2.04a14.467 14.467 0 005.43 5.42c.587-.585 1.187-1.446 2.045-1.629 1.1-.234 3.877.376 4.686 1.329.287.338.44.77.428 1.213z"
                            ></path>
                          </svg>
                          <p>242_serfin</p>
                        </div>
                        {/* nv */}

                        {/* nt - numero telephone */}
                        <div className="nv">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="#1C274C"
                              fillRule="evenodd"
                              d="M5.733 2.043c1.217-1.21 3.221-.995 4.24.367l1.262 1.684c.83 1.108.756 2.656-.229 3.635l-.238.238a.653.653 0 00-.008.306c.063.408.404 1.272 1.832 2.692 1.428 1.42 2.298 1.76 2.712 1.824a.668.668 0 00.315-.009l.408-.406c.876-.87 2.22-1.033 3.304-.444l1.91 1.04c1.637.888 2.05 3.112.71 4.445l-1.421 1.412c-.448.445-1.05.816-1.784.885-1.81.169-6.027-.047-10.46-4.454-4.137-4.114-4.931-7.702-5.032-9.47l.749-.042-.749.042c-.05-.894.372-1.65.91-2.184l1.569-1.561zm3.04 1.266c-.507-.677-1.451-.731-1.983-.202l-1.57 1.56c-.33.328-.488.69-.468 1.036.08 1.405.72 4.642 4.592 8.492 4.062 4.038 7.813 4.159 9.263 4.023.296-.027.59-.181.865-.454l1.42-1.413c.578-.574.451-1.62-.367-2.064l-1.91-1.039c-.528-.286-1.146-.192-1.53.19l-.455.453-.53-.532c.53.532.529.533.528.533l-.001.002-.003.003-.007.006-.015.014a1.11 1.11 0 01-.136.106c-.08.053-.186.112-.319.161-.27.101-.628.155-1.07.087-.867-.133-2.016-.724-3.543-2.242-1.526-1.518-2.122-2.66-2.256-3.526-.069-.442-.014-.8.088-1.07a1.527 1.527 0 01.238-.42l.032-.035.014-.015.006-.006.003-.003.002-.002.53.53-.53-.531.288-.285c.428-.427.488-1.134.085-1.673L8.773 3.309z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                          <p>+242069741128</p>
                        </div>
                        {/* nv */}
                      </div>
                      {/*adresseEtLocalisation */}

                      <div className="otherInformation">
                        <p>
                          Appeler nous directement sur notre whatsapp
                          +55140235511
                        </p>
                      </div>
                      {/* otherInformation */}

                      {/* on affiche plus de photos publiques - ( 666 historyIA 666 InfosAgencePageIA) .
                      Si l'agence a ajouter plus de photos publiques on va afficher ca ici. */}
                      <div
                        onClick={SeePhotoPageIA}
                        className="display-morePhotoPublic"
                      >
                        {apiMorePhotoPublicIA.map((api) => (
                          <>
                            <EnfantApiMorePhotoPublicIA api={api} />
                          </>
                        ))}
                      </div>
                      {/* display-morePhotoPublic */}
                    </div>
                    {/* width */}
                  </div>
                  {/* infos */}
                </div>
                {/* card */}
              </div>
              {/* body */}
            </div>
            {/* align */}
          </div>
          {/* infosAgencePageIA */}
        </>
      )}
      {/* infos other page ( 666 HistoryIA) */}


      {/* reafficher le recu - IA */}
      {/* reafficher le recu - IA */}
      {seeReceiptIA && (
        <>
          <div onClick={CloseSeeReceiptIA} className="miniMenuVerificationIdentiterEtapeDeuxIA">
            <div className="align">
              <div className="card"> <li onClick={DeliverNumberSuccessIA}>Réafficher le reçu</li> </div>
            </div>
            {/* align */}
          </div>
          {/* miniMenuVerificationIdentiterEtapeDeuxIA */}
        </>
      )}
      {/* reafficher le recu - IA */}


      {/* reafficher le recu (versement national) - IA */}
      {/* reafficher le recu (versement national) - IA */}
      {seeReceiptDepositNationalIA && (
        <>
          <div onClick={CloseSeeReceiptDepositNationalIA} className="miniMenuVerificationIdentiterEtapeDeuxIA">
            <div className="align">
              <div className="card"> <li onClick={DepositNationalSuccessIA}>Réafficher le reçu</li> </div>
            </div>
            {/* align */}
          </div>
          {/* miniMenuVerificationIdentiterEtapeDeuxIA */}
        </>
      )}
      {/* reafficher le recu (versement national) - IA */}


      {/* reafficher le recu (identification reussie) - IA */}
      {/* reafficher le recu (identification reussie) - IA */}
      {seeReceiptIdentificationSuccessIA && (
        <>
          <div onClick={CloseSeeReceiptIdentificationSuccessIA} className="miniMenuVerificationIdentiterEtapeDeuxIA">
            <div className="align">
              <div className="card"> <li onClick={IdentificationSuccessIA}>Réafficher le reçu</li> </div>
            </div>
            {/* align */}
          </div>
          {/* miniMenuVerificationIdentiterEtapeDeuxIA */}
        </>
      )}
      {/* reafficher le recu (identification reussie) - IA */}


      {/* deliver Number Success - IA */}
      {/* deliver Number Success - IA */}
      {/* ca c'est le recu (on l'affiche une fois que le numero virtuel a ete delivrer) */}
      {deliverNumberSuccessIA && (
        <>
          <div className="delivrerNumeroVirtuelSuccessIA">
            <div className="align">
              <div className="block-un">
                <p>{dateParserNumeric(dateIA)}</p>
                <p>{nameOwnerIA}</p>
              </div>
              {/* block-un */}

              <div className="hr"> <hr /> </div>

              <div className="block-deux">
                <div className="a"> <p>Numéro virtuel délivré et prêt à être utiliser.</p> </div>

                <div className="b">
                  <p>Numéro virtuel:</p>
                  <p>{virtualNumberIA}</p>
                </div>

                <div className="c">
                  <p>Propriétaire: {nameOwnerVirtualNumberIA}</p>
                  <p>Prix du Numéro virtuel: {priceIA} FCFA</p>
                  <p>Montant à payer: {amountIA} FCFA</p>
                </div>
                {/* c */}
              </div>
              {/* block-deux */}

              <div className="hr"> <hr /> </div>

              <div onClick={CloseDeliverNumberSuccessIA} className="block-trois">
                <p>ID: {idNotificationIA}</p>
                <SvgClose3 />
              </div>
              {/* block-trois */}

              <div className="block-four"> <p>Le Numéro virtuel n'est ni remboursé, ni échangé. Aucun remboursement ne sera accepté</p> </div>
              {/* block-four */}

            </div>
            {/* align */}
          </div>
          {/* delivrerNumeroVirtuelSuccessIA */}
        </>
      )}
      {/* deliver Number Success - IA */}

      
      {/* deliver Number Success 2 - IA */}
      {/* deliver Number Success 2 - IA */}
      {deliverNumberSuccess2IA && (
        <>
          <div onClick={CloseDeliverNumberSuccess2IA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Numéro virtuel délivré</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>
      )}
      {/* deliver Number Success 2 - IA */}


      {/* deposit national success - IA */}
      {/* deposit national success - IA */}
      {/* ca c'est le recu (on l'affiche une fois que le versement national a reussi) */}
      {depositNationalSuccessIA && (
        <>
          <div className="depositNationalSuccessIA">
            <div className="align">
              <div className="block-un">
                <p>{dateParserNumeric(dateIA)}</p>
                <p>{nameOwnerIA}</p>
              </div>
              {/* block-un */}

              <div className="hr"> <hr /> </div>

              <div className="block-deux">
                <div className="a"> 
                  <div className="aa"> <p>VERSEMENT EN ESPÈCES</p> </div>
                  <div className="bb"> <p>Compte National</p> </div>
                </div>
                {/* a */}

                <div className="b">
                  <p>Versement:</p>
                  <p>{amountIA} FCFA</p>
                </div>
                {/* b */}

                <div className="c">
                  <p>Éffectué par: {nameOtherIA}</p>
                  <p>Frais de versement: {feesIA} FCFA</p>
                  <p>Montant à payer: {totalIA} FCFA</p>
                </div>
                {/* c */}
              </div>
              {/* block-deux */}

              <div className="hr"> <hr /> </div>

              <div onClick={CloseDepositNationalSuccessIA} className="block-trois">
                <p>ID: {idNotificationIA}</p>
                <SvgClose3 />
              </div>
              {/* block-trois */}

              <div className="block-four"> <p>Pour toutes réclamations, n'hésiter pas à contacter {nameOwnerIA} au {phoneNumberIA} ou contacter directement izocash sur Alrani</p> </div>
              {/* block-four */}

            </div>
            {/* align */}
          </div>
          {/* depositNationalSuccessIA */}
        </>
      )}
      {/* deposit national success - IA */}


      {/* deposit national Success 2 - IA */}
      {/* deposit national Success 2 - IA */}
      {depositNationalSuccess2IA && (
        <>
          <div onClick={CloseDepositNationalSuccess2IA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Versement réussi</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>
      )}
      {/* deposit national Success 2 - IA */}


      {/* identification Success - IA */}
      {/* identification Success - IA */}
      {/* ca c'est le recu (on l'affiche une fois que le numero virtuel a ete identifier) */}
      {identificationSuccessIA && (
        <>
          <div className="delivrerNumeroVirtuelSuccessIA">
            <div className="align">
              <div className="block-un">
                <p>{dateParserNumeric(dateIA)}</p>
                <p>{nameOwnerIA}</p>
              </div>
              {/* block-un */}

              <div className="hr"> <hr /> </div>

              <div className="block-deux">
                <div className="a"> <p>Identification réussie</p> </div>

                <div className="b">
                  <p>Numéro virtuel identifié:</p>
                  <p>{virtualNumberIA}</p>
                </div>

                <div className="c">
                  <p>Identifier au Nom de: {nameOtherIA}</p>
                  <p>Frais d'identification: {priceIA} FCFA</p>
                  <p>Montant à payer: {amountIA} FCFA</p>
                </div>
                {/* c */}
              </div>
              {/* block-deux */}

              <div className="hr"> <hr /> </div>

              <div onClick={CloseIdentificationSuccessIA} className="block-trois">
                <p>ID: {idNotificationIA}</p>
                <SvgClose3 />
              </div>
              {/* block-trois */}

              <div className="block-four"> <p>Les Frais d'identification du Numéro virtuel ne sont pas remboursables. Aucun remboursement ne sera accepté</p> </div>
              {/* block-four */}

            </div>
            {/* align */}
          </div>
          {/* delivrerNumeroVirtuelSuccessIA */}
        </>
      )}
      {/* identification Success - IA */}

      
      {/* identification Success 2 - IA */}
      {/* identification Success 2 - IA */}
      {identificationSuccess2IA && (
        <>
          <div onClick={CloseIdentificationSuccess2IA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Numéro virtuel identifié</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>
      )}
      {/* identification Success 2 - IA */}


      {/* Verification Didentiter Entreprise - IA */}
      {/* Verification Didentiter Entreprise - IA */}
      {/* sur cette page on affiche les infos d'identitées de l'entreprise qui 
        ont ete envoyer dans la bdd */}
      {verificationDidentiterEntrepriseIA && (
        <>
          <div className="verificationDidentiterEntrepriseIA">
            <div className="close">
              <div onClick={CloseVerificationDidentiterEntrepriseIA} className="a"> <SvgLeft /><p>Vérification de l'Entreprise</p> </div>
              <div onClick={ListesDesOptionsVerificationDidentiterEntrepriseIA} className="b"> <SvgAdd /> </div>
            </div>
            {/* close */} 

            {verifyInfosSend1IA && (
            <>
            
            <div className="infos">
              {verifyInfosSendIA ? (<><p></p></>) : (
              <>
              <div className="adresseEtLocalisation">
                <p>{nameSendIA}</p>
                <hr />
                <p>{domainSendIA}</p>
                <p>{phoneNumberSendIA}</p>
                <p>{addressSendIA}</p>
                <p>{busStopSendIA}</p>
                <p>{zoneSendIA}</p>
                <p>{quarterSendIA}</p>
                <p>{citySendIA}</p>
                <p>{countrySendIA}</p>
              </div></>)}
              {/*adresseEtLocalisation */}

              {verifyPhotoSendIA ? (<><p></p></>) : (
              <>
              <div className="display-photosDidentiter">
                <div className="photosDidentiter">
                  <div>
                    <img onClick={SeePhotoPageIA} src={photoSendIA} alt="" />
                  </div>
                </div>
              </div></>)}
              {/* display-photosDidentiter */}
            </div></>)}
            {/* infos */}
          </div>
          {/* verificationDidentiterEntrepriseIA */}
        </>
      )}
      {/* Verification Didentiter Entreprise - IA */}

      {/* liste Des Options (VerificationDidentiterEntrepriseIA) */}
      {/* liste Des Options (VerificationDidentiterEntrepriseIA) */}
      {/* sur cette page, on affiche la liste Des Options */}
      {listesDesOptionsVerificationDidentiterEntrepriseIA && (
        <>
          <div
            onClick={CloseListesDesOptionsVerificationDidentiterEntrepriseIA}
            className="listesDesOptionsVerificationDidentiterEntrepriseIA"
          >
            <div className="align">
              <div className="card">
                <p onClick={ImporterDocumentDidentiterEntrepriseIA}>Photo de l'entreprise</p>
                <hr />
                <p onClick={CompleterInformationEntreprisePageIA}>Informations de l'entreprise</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* listesDesOptionsVerificationDidentiterEntrepriseIA */}
        </>
      )}
      {/* liste Des Options (VerificationDidentiterEntrepriseIA) */}

      {/* importer documents d'identités Entreprise - IA */}
      {/* importer documents d'identités Entreprise - IA */}
      {/* sur cette page, le partenaire va importer les documents d'identités de son 
            agence ou de son entreprise */}
      {importerDocumentDidentiterEntrepriseIA && (
        <>
          <div className="importerDocumentDidentiterEntrepriseIA">
            <div className="close">
              <svg
                onClick={CloseImporterDocumentDidentiterEntrepriseIA}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Photo de l'entreprise</p>
            </div>
            {/* close */}

            <div className="hr"> <hr /> </div>
            {/* hr */}

            <div className="block-un">
              <div className="a"> <p>Ajouter la photo de la devanture de votre magasin ou de votre entreprise</p> </div>
              <div className="b"> <p>Ajouter une belle photo (Jolie à regarder)</p> </div>
            </div>
            {/* block-un */}

            <div className="block-deux"> <input onChange={(e) => setFilePhotoIA(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            {/* block-deux */}

            <div className="block-trois">
              <div onClick={VerificationPhotoIA} className="a"> <SvgRight /> </div>
              <div onClick={VerificationPhotoIA} className="a"> <p>Ajouter</p> </div>
            </div>
            {/* block-trois */}


            {verifyInfosSend1IA && (
            <>

            {verifyPhotoSendIA ? (<><p></p></>) : (
            <>
            <div className="display-photosDidentiter">
              <div className="photosDidentiter">
                <div>
                  <img onClick={SeePhotoPageIA} src={photoSendIA} alt="" />
                </div>
              </div>
            </div></>)} </>)}
            {/* display-photosDidentiter */}
          </div>
          {/* importerDocumentDidentiterEntrepriseIA */}
        </>
      )}
      {/* importer documents d'identités Entreprise - IA */}

      

      {/* importation Photo Didentiter Entreprise Success - IA */}
      {/* importation Photo Didentiter Entreprise Success - IA */}
      {/* on affiche ce message de succes si le partenaire a pu importer la photo d'identité
      de son entreprise */}
      {importationPhotoDidentiterEntrepriseSuccessIA && (
        <>
          <div
            onClick={CloseImportationPhotoDidentiterEntrepriseSuccessIA}
            className="importationPhotoDidentiterEntrepriseSuccessIA"
          >
            <div className="align">
              <div className="card">
                <div className="display">
                  <p>Ajout réussie</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#00cc00"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M20 7L9 18l-5-5"
                    ></path>
                  </svg>
                </div>
                {/* display */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* importationPhotoDidentiterEntrepriseSuccessIA */}
        </>
      )}
      {/* importation Photo Didentiter Entreprise Success - IA */}

      {/* Compléter information Entreprise (Page) - VerificationDidentiterEntrepriseIA */}
      {/* Compléter information Entreprise (Page) - VerificationDidentiterEntrepriseIA */}
      {/* sur cette page le partenaire va compléter les informations d'identitées de son 
      Entreprise */}
      {completerInformationEntreprisePageIA && (
        <>
          <div className="completerInformationEntreprisePageIA">
            <div className="close">
              <div onClick={CloseCompleterInformationEntreprisePageIA} className="a"> <SvgLeft /> </div>
              <div className="a"> <p>Informations de l'entreprise</p> </div>
            </div>

            <div className="hr"> <hr /> </div>

            <div className="block-un"> <p>Veuillez compléter les informations de votre Entreprise</p> </div>

           
            {/* Nom de l'entreprise */}
            <div className="block-deux">
              <p>Nom de l'entreprise</p>      
              <input type="text" value={nameCompanyIA} onChange={(e) => setNameCompanyIA(e.target.value)} /> 
            </div>


            {/* Domaine d'activité */}
            <div className="block-trois">
              <div className="a"> <p>Domaine d'activité</p> </div>

              <div className="b">
                <p>Saisissez votre Domaine d'activité</p>
                <input type="text" value={domainCompanyIA} onChange={(e) => setDomainCompanyIA(e.target.value)} />
              </div>
            </div>


            {/* Numéro de téléphone */}
            <div className="block-trois">
              <div className="a"> <p>Numéro de téléphone</p> </div>

              <div className="b">
                <p>Saisissez le numéro de téléphone auquel on peut vous joindre</p>
                <input type="text" value={phoneNumberCompanyIA} onChange={(e) => setPhoneNumberCompanyIA(e.target.value)} />
              </div>
            </div>


            {/* Adresse */}
            <div className="block-trois">
              <div className="a"> <p>Adresse</p> </div>

              <div className="b">
                <p>Saisissez l'adresse de l'entreprise</p>
                <input type="text" value={addressCompanyIA} onChange={(e) => setAddressCompanyIA(e.target.value)} />
              </div>
            </div>


            {/* Pays */}
            <div className="block-trois">
              <div className="a"> <p>Pays</p> </div>

              <div className="b">
                <p>Saisissez le nom du pays</p>
                <input type="text" value={countryCompanyIA} onChange={(e) => setCountryCompanyIA(e.target.value)} />
              </div>
            </div>

            {/* Ville */}
            <div className="block-trois">
              <div className="a"> <p>Ville</p> </div>

              <div className="b">
                <p>Saisissez le nom de la ville</p>
                <input type="text" value={cityCompanyIA} onChange={(e) => setCityCompanyIA(e.target.value)} />
              </div>
            </div>


            {/* Quartier */}
            <div className="block-trois">
              <div className="a"> <p>Quartier</p> </div>

              <div className="b">
                <p>Saisissez le nom du quartier</p>
                <input type="text" value={quarterCompanyIA} onChange={(e) => setQuarterCompanyIA(e.target.value)} />
              </div>
            </div>


            {/* Zone */}
            <div className="block-trois">
              <div className="a"> <p>Zone</p> </div>

              <div className="b">
                <p>Saisissez la zone dans laquelle se trouve votre entreprise</p>
                <input type="text" value={zoneCompanyIA} onChange={(e) => setZoneCompanyIA(e.target.value)} />
              </div>
            </div>


            {/* Arrêt de Bus */}
            <div className="block-trois">
              <div className="a"> <p>Arrêt de Bus</p> </div>

              <div className="b">
                <p>Saisissez l'Arrêt de Bus le plus proche de votre entreprise</p>
                <input type="text" value={busStopCompanyIA} onChange={(e) => setBusStopCompanyIA(e.target.value)} />
              </div>
            </div>

            <div className="block-quatre"> 
              <div onClick={VerificationInfosIA} className="a"> <SvgRight /> </div>
              <div onClick={VerificationInfosIA} className="b"> <p>Ajouter</p> </div>
            </div>
            {/* block-quatre */}
          </div>
          {/* completerInformationEntreprisePageIA */}
        </>
      )}
      {/* Compléter information Entreprise (Page) - VerificationDidentiterEntrepriseIA */}


      {/* send Infos Success - IA */}
      {/* send Infos Success - IA */}
      {/* on affiche ce message de succes s'il a envoyer les infos de son entreprise */}
      {sendInfosSuccessIA && (
        <>
          <div onClick={CloseSendInfosSuccessIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> 
                  <p>Les informations de votre entreprise ont bien été ajoutées !</p>
                </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* send Infos Success - IA */}


      {/* send Photo Success - IA */}
      {/* send Photo Success - IA */}
      {/* on affiche ce message de succes s'il a envoyer la photo de son entreprise */}
      {sendPhotoSuccessIA && (
        <>
          <div onClick={CloseSendPhotoSuccessIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> 
                  <p>La photo de votre entreprise a bien été ajoutée !</p>
                </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* send Photo Success - IA */}


      {/* send Infos Success 2 - IA */}
      {/* send Infos Success 2 - IA */}
      {/* on affiche ce message de succes s'il a envoyer les infos de son entreprise */}
      {sendInfosSuccess2IA && (
        <>
          <div onClick={CloseSendInfosSuccess2IA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Informations ajoutées</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>
      )}
      {/* send Infos Success 2 - IA */}

      {/* send Photo Success 2 - IA */}
      {/* send Photo Success 2 - IA */}
      {/* on affiche ce message de succes s'il a envoyer la photo de son entreprise */}
      {sendPhotoSuccess2IA && (
        <>
          <div onClick={CloseSendPhotoSuccess2IA} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Photo ajoutée</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>
      )}
      {/* send Photo Success 2 - IA */}


      {/* seePhoto (page) - IA */}
      {/* seePhoto (page) - IA */}
      {/* c'est la page qui permet de voir une photo */}
      {/* dans l'application IA, si la personne a cliquer pour voir une photo, on affiche 
      la photo sur cette page */}
      {seePhotoPageIA && (<>
          <div className="seePhotoPageIA">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseSeePhotoPageIA} className="b"> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card">
              <img src={seePhotoIA} alt="" />
            </div>
            {/* card */}
          </div>
          {/* seePhotoPageIA */}
        </>)}
      {/* seePhoto (page) - IA */}


      {/* envoie Information Didentiter Entreprise Success - IA */}
      {/* envoie Information Didentiter Entreprise Success - IA */}
      {/* on affiche ce message de succes si le partenaire a pu envoyer ses informations
      d'identiter */}
      {envoieInformationDidentiterEntrepriseSuccessIA && (
        <>
          <div
            onClick={CloseEnvoieInformationDidentiterEntrepriseSuccessIA}
            className="importationPhotoDidentiterEntrepriseSuccessIA"
          >
            <div className="align">
              <div className="card">
                <div className="display">
                  <p>Envoie réussie</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#00cc00"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M20 7L9 18l-5-5"
                    ></path>
                  </svg>
                </div>
                {/* display */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* importationPhotoDidentiterEntrepriseSuccessIA */}
        </>
      )}
      {/* envoie Information Didentiter Entreprise Success - IA  */}

      {/* Licence Grand Distributeur - IA */}
      {/* Licence Grand Distributeur - IA */}
      {/* sur cette page on affiche les details de la licence du Distributeur - IA */}
      {licenceGrandDistributeur && (
        <>
          <div className="licenceDistributeur">
            <div className="align">
              <div className="border">
                <div className="block-deux">
                  <div onClick={LicenceGrandDistributeur} className="card">
                    <p>Licence B</p>
                    <p>Validité : 5 ans</p>
                    <p>Volume : 10.000.000FCFA / mois</p>
                  </div>
                  {/* card */}
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="card">
                    <p>Licence B</p>

                    <p>Type : Licence achetée</p>
                    <p>Date : 10/05/2024</p>

                    <hr />
                    <p>Licence en cours de validitée !</p>
                  </div>
                  {/* card */}
                </div>
                {/* block-trois */}
              </div>
              {/* border */}
            </div>
            {/* align */}
          </div>
          {/* licenceDistributeur */}
        </>
      )}
      {/* Licence Grand Distributeur - IA */}

      {/* Licence light - IA */}
      {/* Licence light - IA */}
      {/* sur cette page on affiche les details de la licence light - IA */}
      {licenceLightIA && (
        <>
          <div className="licenceDistributeur">
            <div className="align">
              <div className="border">
                <div className="block-un">
                  <div className="a">
                    <img src={izocashEcranDemmarrage} alt="" />
                  </div>

                  <div className="b">
                    <button>Mini Licence</button>
                  </div>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <h6>Licence Light</h6>
                  <p>Validité : 1 ans</p>
                  <p>Attribué le : 10/05/2024</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <p>Attribué par : SERFIN SA</p>
                  <p>Attribué le : 10/05/2024</p>
                  <p>Expire le : 10/05/2024</p>
                </div>
                {/* block-trois */}
              </div>
              {/* border */}
            </div>
            {/* align */}

            <div className="close">
              <div className="a">
                <p onClick={CloseLicenceLightIA}>Close</p>
                <p>Licence Light</p>
                <button onClick={ActivateLicenceLightIA}>Activé</button>
              </div>
              {/* a */}

              <div className="b">
                <p>SERFIN SA</p>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="block-deux">
              <h6>Licence Light</h6>
              <p>Validité : 1 ans</p>
              <p>Activation : 10/05/2024</p>
            </div>
            {/* block-deux */}

            <div className="block-un">
              <div className="a">
                <h6>Recharge / Retrait</h6>
                <p>Commission 5%</p>
              </div>
              {/* a */}

              <div className="b">
                <p>Partenaire</p>
                <hr />
              </div>
              {/* b */}
            </div>
            {/* block-un */}

            <div className="block-un">
              <div className="a">
                <h6>Vente Numéro Virtuel</h6>
                <p>Commission 10%</p>
              </div>
              {/* a */}

              <div className="b">
                <p>Partenaire</p>
                <hr />
              </div>
              {/* b */}
            </div>
            {/* block-un */}
          </div>
          {/* licenceLight */}
        </>
      )}
      {/* Licence light - IA */}

      {/* activer Licence light - IA */}
      {/* activer Licence light - IA */}
      {/* cette page permet a l'utilisateur d'activer sa licence light */}
      {activateLicenceLightIA && (
        <>
          <div onClick={CloseActivateLicenceLightIA} className="activateToolIA">
            <div>
              <p>Licence Light</p>
              <p>Cout: 700.000 FCFA</p>
              <button onClick={ActivateToolSuccessIA}>Activer</button>
            </div>
          </div>
          {/* activateToolIA */}
        </>
      )}
      {/* activer Licence light - IA */}

      {/* activate Tool Success - IA */}
      {/* activate Tool Success - IA */}
      {/* si l'utilisateur a pu activer sa licence ou un outil, alors on va l'afficher ce 
      message de success */}
      {activateToolSuccessIA && (
        <>
          <div
            onClick={CloseActivateToolSuccessIA}
            className="activateToolSuccessIA"
          >
            <p>Paiement reussie</p>
          </div>
          {/* activateToolSuccessIA */}
        </>
      )}
      {/* activate Tool Success - IA */}


      {/* Deconnexion - page */}
      {/* Deconnexion - page */}
      {/* ca c'est la page qui permet a l'utilisateur de se deconnecter - IA */}
      {deconnexionPageIA && (<>
          <div onClick={DeconnexionPageIA} className="deconnexionPageIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>{t("--by clicking on disconnect you will be disconnected")}</p> </div>
                {/* block-un */}

                <div className="block-deux"> <button onClick={LogoutIA}>{t("--logout")}</button> </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* deconnexionPageIA-opacity */}
        </>)}
      {/* Deconnexion - page */}


      {/* A propos - IA */}
      {/* A propos - IA */}
      {/* on affiche la page a propos - IA */}
      {aProposIA && (
        <>
          <div className="aPropos-opacity">
            <div className="close">
              <div className="a">
                <p>A Propos</p>
              </div>
              {/* a */}

              <div className="b">
                <svg
                  onClick={AproposIA}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  cursor="pointer"
                  fill="red"
                  version="1.1"
                  viewBox="0 0 40 40"
                  xmlSpace="preserve"
                >
                  <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                </svg>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="block-un">
              <div className="box-shadow">
                <div className="like-i-b">
                  <i>izocash !!!</i>
                </div>

                <div className="like-i-c">
                  <p>
                    Le moyen de paiement le mieux adapté pour votre téléphone
                    virtuel !
                  </p>
                </div>

                <div className="like-i-d">
                  <div
                    style={{ marginTop: "40px" }}
                    className="svg-and-p"
                  ></div>

                  <div className="svg-and-p">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      width="28px"
                      height="28px"
                      fill="red"
                      enableBackground="new 0 0 490.766 490.766"
                      version="1.1"
                      viewBox="0 0 490.766 490.766"
                      xmlSpace="preserve"
                    >
                      <path d="M472.554 319.199c-9.4-.7-28.8 9.8-34.1 12.5-18.9 9.5-45.2 24.4-62.5 36.3-1.2.8-2.8 1.9-4 2.7-7.8 5-16 8.3-25.1 10.3-50.2 10.7-123.3 11.8-123.3 11.8l-4.3.2c-3.2.2-6.1-2.1-6.5-5.2-.5-3.4 2-6.6 5.6-6.9l108.7-10.3c12-1.3 21.5-12.5 20.2-25.1s-12.9-21.8-24.9-20.5l-96.7-1.2c-6.6-.1-17.1-1.7-23.4-3.6-62.3-18.2-97.5-1.2-116.2 6.8-4.2-6.9-12.1-11.4-20.9-10.8l-41.7 2.8c-13.9.9-24.3 12.5-23.4 25.9l6.7 92.6c1 13.4 13 23.5 26.9 22.5l41.7-2.8c8.8-.6 16-6 19.1-13.4l183.2 7.9c20.4 2.2 39.5-.3 57.5-9.7l5.2-2.7 138.5-81c6.8-4 11.6-10.9 11.9-18.5.3-9.3-5-19.6-18.2-20.6zm-423.6 118.9c-7.8 0-14.2-6.1-14.2-13.7s6.4-13.7 14.2-13.7 14.2 6.1 14.2 13.7-6.4 13.7-14.2 13.7zm320.6-87c.2-2.5.2-5.1-.1-7.7-.3-3.3-1.1-6.4-2.1-9.4.1-.2.2-.4.2-.6 14.6-8 43.2-21.8 58.8-27.9 7.8-3.1 15.5-2.9 22.6 1.9-5.6 2-10.8 4.5-15.7 6.9-16.4 8.2-45.3 23.9-59.4 33.8-1.4 1-2.9 2-4.3 3zm41.8-54.9c-11.3 5-33 12.6-43.3 18.3l-7 3.8c-.7.4-1.3.8-1.9 1.3-3.1-3.7-6.8-6.8-10.9-9.3 9.6-5.1 31-12 40.7-15.8 7.8-3.1 15.3-2.9 22.4 1.7zm-155.3-231.6c-29.7 0-53.7 24.1-53.7 53.7s24.1 53.7 53.7 53.7c29.7 0 53.7-24.1 53.7-53.7s-24-53.7-53.7-53.7zm15.4 74.9c-2.3 2.8-5.4 4.8-9 5.7-1.6.4-2.2 1.2-2.2 2.9.1 1.6 0 3.2 0 4.8 0 1.4-.7 2.2-2.1 2.2h-5.1c-1.5 0-2.2-.9-2.2-2.3v-3.5c0-2.6-.1-2.7-2.6-3.1-3.1-.5-6.2-1.2-9.1-2.6-2.3-1.1-2.5-1.7-1.8-4 .5-1.8 1-3.5 1.5-5.3.6-2 1.2-2.3 3-1.3 3.2 1.7 6.6 2.6 10.1 3 2.3.3 4.5.1 6.6-.9 3.9-1.7 4.6-6.3 1.2-9.1-1.1-.9-2.4-1.6-3.8-2.2-3.5-1.5-7.1-2.7-10.3-4.6-5.3-3.2-8.7-7.5-8.3-14 .4-7.3 4.6-11.9 11.3-14.3 2.8-1 2.8-1 2.8-3.9v-2.9c.1-2.2.4-2.5 2.6-2.6h2c4.6 0 4.6 0 4.6 4.6 0 3.3 0 3.3 3.3 3.8 2.5.4 4.9 1.1 7.2 2.1 1.3.6 1.8 1.4 1.4 2.8-.6 2-1.1 4-1.8 6-.6 1.9-1.2 2.1-3 1.3-3.6-1.7-7.4-2.5-11.4-2.3-1 .1-2.1.2-3 .6-3.4 1.5-4 5.3-1.1 7.6 1.5 1.2 3.2 2 4.9 2.8 3 1.3 6.1 2.5 9 4.1 9.4 5.2 11.8 16.7 5.3 24.6zm77.7-21.2c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9zm-156.3 0c0 8.2-6.7 14.9-14.9 14.9s-14.9-6.7-14.9-14.9 6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9zm180.2-87.6h-234c-13.5 0-24.5 11-24.5 24.5v126.2c0 13.5 11 24.5 24.5 24.5h234c13.5 0 24.5-11 24.5-24.5v-126.2c0-13.5-11-24.5-24.5-24.5zm3.6 127.2c-2-.5-4-.8-6.1-.8-13.7 0-24.8 11.1-24.8 24.8 0 1 .1 2.1.2 3.1h-181.7c.3-1.5.4-3 .4-4.6 0-13.7-11.1-24.8-24.8-24.8-1.5 0-2.9.1-4.4.4v-75.4c1.4.3 2.9.4 4.4.4 13.7 0 24.8-11.1 24.8-24.8 0-1.6-.1-3.1-.4-4.6h182.2c-.5 1.9-.8 4-.8 6.1 0 13.7 11.1 24.8 24.8 24.8 2.1 0 4.2-.3 6.1-.8v76.2h.1zm-261.7 75.1c0-5.8 4.7-10.5 10.5-10.5h261.7c5.8 0 10.5 4.7 10.5 10.5s-4.7 10.5-10.5 10.5h-261.8c-5.7 0-10.4-4.7-10.4-10.5zm0 38c0-5.8 4.7-10.5 10.5-10.5h261.7c5.8 0 10.5 4.7 10.5 10.5s-4.7 10.5-10.5 10.5h-261.8c-5.7 0-10.4-4.7-10.4-10.5z"></path>
                    </svg>

                    <p>Achéteur, vendeur, izocash est pour vous</p>
                  </div>

                  <div className="svg-and-p">
                    <svg
                      width="40px"
                      height="40px"
                      fill="red"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M473.6 256.6c0-99.3-67.1-185.9-163.3-210.6-9.2-2.4-18.6 3.2-20.9 12.4-2.4 9.2 3.2 18.6 12.4 20.9C382.7 100 439.2 173 439.2 256.6c0 73.7-43.9 139-109.6 167.7l15.9-37c3.7-8.7-.3-18.8-9-22.6-8.7-3.7-18.8.3-22.6 9l-31 72.2c-3.7 8.7.3 18.8 9 22.6l72.2 31c10.8 3.8 19.8-2.5 22.6-9 3.7-8.7-.3-18.8-9-22.6l-31.4-13.5c76.5-34.6 127.3-111.4 127.3-197.8zM210.4 433.9C129.5 413.1 73 340.2 73 256.6c0-72.7 42.7-137.2 106.9-166.5L165 124.7c-3.7 8.7.1 19.2 9 22.6 10.4 3.9 19.2-.8 22.6-9l31-72.3c3-7 2.9-17.5-9-22.6l-72.2-31c-8.7-3.7-18.8.3-22.6 9-3.7 8.7.3 18.8 9 22.6l33.6 14.4C89.6 93.1 38.6 170 38.6 256.6c0 99.3 67.2 185.8 163.3 210.6 11.6 3 18.9-4.6 20.9-12.4 2.3-9.2-3.2-18.5-12.4-20.9z"></path>
                      <path d="M296.6 321.4c8.8-9.2 13.2-20.8 13.2-34.6 0-6.3-1.1-12.1-3.2-17.5s-5.1-10-9-14c-3.9-3.9-9-7.2-15.2-10-3.3-1.4-9.9-3.4-20-5.9V182c6.5 1.3 11.6 4.1 15.4 8.3 3.7 4.2 6.2 10.2 7.4 18l20.6-3.1c-1.8-12.6-7-22.6-15.7-29.8-6.8-5.7-16-9.1-27.6-10.2v-9.5h-11.8v9.5c-13.2 1.3-23.2 5-29.9 10.9-10.1 8.8-15.1 20.3-15.1 34.5 0 8 1.7 15.1 5.2 21.4 3.4 6.3 8.3 11.2 14.7 14.7 8.6 4.8 17 8 25.2 9.5v63.5c-7.8-.8-14.6-4.8-20.2-11.9-3.9-5-6.7-12.9-8.2-23.6l-20.1 3.8c.7 10.3 3.4 19.1 7.9 26.3 4.5 7.2 9.9 12.4 16.2 15.6 6.2 3.2 14.4 5.4 24.3 6.7v19.9h11.8v-20.2c14-.7 25.4-5.7 34.1-14.9zm-45.8-84.5c-9.1-2.7-15.5-6.4-19.3-11-3.8-4.6-5.7-10.3-5.7-17.1 0-6.9 2.2-12.8 6.7-17.8s10.6-8.1 18.3-9.3v55.2zm30.9 72.6c-5.1 5.8-11.5 9.1-19.2 10.1v-60.7c10.7 3.5 17.9 7.4 21.5 11.8 3.6 4.4 5.4 10.2 5.4 17.5-.1 8.4-2.6 15.6-7.7 21.3z"></path>
                    </svg>
                    <p>
                      Retirer gratuitement de l'argent de votre compte de
                      Générosité dans une agence ou auprès d'un Distributeur
                      izocash
                    </p>
                  </div>
                  {/* svg-and-p */}
                </div>
                {/* like-i-d */}

                <div className="slogan">
                  <p>izocash, Partout dans votre téléphone virtuel</p>
                </div>
                {/* slogan */}
              </div>
              {/* box-shadow */}
            </div>
            {/* block-un */}

            <div className="block-deux">
              <p>RINABEL FINANCE ©2024</p>
            </div>
            {/* block-deux */}
          </div>
          {/* aPropos-opacity */}
        </>
      )}
      {/* A propos - IA */}

      {/* profil - IA */}
      {/* profil - IA */}
      {/* dans l'application izocash, ca c'est le profil de l'utilisateur - IA */}
      {profilIA && (
        <>
          <div className="profilIA">
            <div className="close">
              <div onClick={CloseProfilIA} className="a"> <SvgLeft4 /> </div>
              <div className="b"> <p onClick={InformationImportanteIA}>{virtualNumberPersonConnectedIA}</p> </div>
            </div>
            {/* close */}

            {dev && (<>
            <div className="localisation">
              <div className="block-un">
                <SvgMaps />
                <p>Kilendo Dingha Veil Brillant</p>
              </div>
              {/* block-un */}

              <div className="block-deux">
                <p>107 Avenue de la Frontière, non loin de la pharmacie Médina</p>
                <p>FLM</p>
                <p>Tchimbamba</p>
                <p>Pointe-Noire</p>
                <p>Congo</p>
              </div>
              {/* block-deux */}
            </div> </>)}
            {/* localisation */}

            <div className="photoPublique">
              <div className="block-un"> <SvgInfos /> <p>Photo publique</p> </div>
              {/* block-un */}

              <div className="block-deux">
                <div onClick={MettrePhotoProfilIA} className="a"> <SvgCamera /> </div>
                
                {photoPersonConnectedIA === "0" ? (<><p></p></>
                ) : (<><div className="b"> <img onClick={PopupImageProfilIA} src={photoPersonConnectedIA} alt="" /> </div></>)}
              </div>
              {/* block-deux */}
            </div>
            {/* photoPublique */}

            <div className="hr"> <hr /> </div>
            {/* hr */}

            {dev && (<>
            <hr />
            <div className="block-dix">
              {/* photo de profil - IA */}
              {/* s'il y'a une photo de profil, on affiche la photo de profil - IA */}
              {!photoPersonConnectedIA === "0" && (
                <>
                  <div className="photoProfil">
                    <div className="a">
                      <img
                        onClick={PopupImageProfilIA}
                        src={photoPersonConnectedIA}
                        alt=""
                      />
                    </div>
                    {/* a */}

                    <div className="b">
                      <p></p>
                      <svg
                        onClick={MettrePhotoProfilIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="#e6e6e6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 9a2 2 0 012-2h1.5a2 2 0 001.6-.8l1.05-1.4a2 2 0 011.6-.8h2.5a2 2 0 011.6.8l1.05 1.4a2 2 0 001.6.8H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                        ></path>
                        <circle
                          cx="12"
                          cy="13"
                          r="4"
                          stroke="#e6e6e6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        ></circle>
                      </svg>
                    </div>
                    {/* b */}
                  </div>
                </>
              )}
              {/* photo de profil - IA */}

              {/* si y'a pas de photo de profil, on a affiche ceci - IA */}
              {!photoProfilPersonneConnecterIA && (
                <>
                  <div className="photoProfil">
                    <div className="c">
                      <button onClick={MettrePhotoProfilIA}>
                        Ajouter une photo de profil
                      </button>
                    </div>
                    {/* c */}
                  </div>
                </>
              )}
              {/* photo de profil - IA */}

              {/* on met cet espace en haut pour eviter que ca soit coincer les uns avec les autres */}
              <div style={{ paddingTop: "20px" }}></div>

              {/* Noms de naissance : */}
              {/* Noms de naissance : */}
              {/* Noms de naissance : */}
              <div className="filsDe">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    fill="#000"
                    version="1.1"
                    viewBox="0 0 221 256"
                    xmlSpace="preserve"
                  >
                    <path d="M69.439 33.796c0-7.293 5.96-13.253 13.332-13.253s13.332 5.882 13.332 13.253c0 7.293-5.96 13.253-13.332 13.253s-13.332-5.96-13.332-13.253zm26.899 17.645c-1.49-1.412-3.215-2.353-5.725-2.353H74.693c-2.51 0-4.078.941-5.568 2.353L51.323 69.243c-4.862 4.862 1.725 11.058 6.588 6.274l10.744-10.822v10.117h27.997V64.616l11.136 11.058c4.47 4.705 11.214-1.568 6.588-6.274L96.338 51.441zm.314 28.624L86.143 90.652l7.764 7.764-7.921 7.921c-4.705 4.705 1.804 11.371 6.588 6.509l12.548-13.018c2.745-2.745 3.451-7.842.549-10.744l-9.019-9.019zM71.478 98.338l7.764-7.764-10.509-10.509-9.097 9.019c-2.902 2.902-2.117 7.999.549 10.744l12.548 13.018c4.862 4.862 11.293-1.882 6.666-6.509l-7.921-7.999zm135.688 4.856V128c0 2.559-1.969 4.528-4.528 4.528s-4.528-1.969-4.528-4.528V91.972c0-1.575-.197-2.953-.984-4.331-1.378-3.347-4.528-5.906-8.072-6.694-.591-.197-1.575-.197-2.166-.197v42.722c0 2.559-1.969 4.528-4.528 4.528s-4.528-1.969-4.528-4.528V69.528c0-1.181-.197-1.969-.394-2.953-.197-1.181-.984-2.166-1.575-3.347-.984-1.181-1.772-2.166-3.15-3.15-.984-.591-2.166-1.181-3.347-1.575-.591 0-1.575-.197-2.756-.197-.591 0-1.575 0-2.166.197V2H2.416v189H126.25c4.134 11.419 13.191 20.475 24.806 24.806V254h67.528V114.416c-.196-6.3-5.118-11.222-11.418-11.222zm-56.307 49.612c-2.559 0-4.528-1.969-4.528-4.528v-40.556c0-6.3-4.922-11.222-11.222-11.222-6.984 0-11.222 5.212-11.222 11.294v15.875H33.916v9.056h89.972v13.584H33.916v9.056h89.972v22.444c0 1.575.197 2.953.197 4.528H11.275V11.056h143.916v137.222h.197c0 2.56-1.969 4.528-4.529 4.528z"></path>
                  </svg>
                </div>
                {/* icon */}

                <div className="name">
                  <div className="a">
                    <p>Noms de naissance :</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p>{namePersonConnectedIA}</p>
                  </div>
                  {/* b */}
                </div>
                {/* name */}

                <div className="edit">
                  <svg
                    onClick={NomNaissanceIA}
                    width="20px"
                    cursor="pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 30 30"
                  >
                    <g transform="translate(0 -289.063)">
                      <path
                        fill="#ccc"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="2"
                        d="M22.824 296.239a11.986 11.986 0 00-1.542-1.287l-2.665 2.665 2.828 2.828 2.666-2.665a11.986 11.986 0 00-1.287-1.541zm-5.621 2.792L6.596 309.638l-.707 3.535 3.536-.707L20.03 301.86z"
                        opacity="0.93"
                      ></path>
                    </g>
                  </svg>
                </div>
                {/* edit */}
              </div>
              {/* Noms de naissance : */}

              {/* Modifier le Nom de naissance */}
              {/* Modifier le Nom de naissance */}
              {/* quand on clique, le card qui permet de modifier le Nom de naissance va 
              s'afficher */}
              {nomNaissanceIA && (
                <>
                  <div className="editProfil">
                    <div className="card">
                      <div className="close">
                        <p onClick={CloseNomNaissanceIA}>Nom de naissance</p>
                        <svg
                          onClick={CloseNomNaissanceIA}
                          xmlns="http://www.w3.org/2000/svg"
                          x="0"
                          y="0"
                          cursor="pointer"
                          width="10px"
                          fill="#ccc"
                          enableBackground="new 0 0 25.93 25.93"
                          version="1.1"
                          viewBox="0 0 25.93 25.93"
                          xmlSpace="preserve"
                        >
                          <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                        </svg>
                      </div>
                      {/* close */}

                      <div className="block-un">
                        <p>Entrer votre nom de naissance</p>
                      </div>
                      {/* block-un */}

                      <div className="block-deux">
                        <textarea></textarea>
                      </div>
                      {/* block-deux */}

                      <div className="block-trois">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="#000"
                          data-name="Layer 2"
                          viewBox="0 0 32 32"
                        >
                          <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                        </svg>
                        <p>Valider</p>
                      </div>
                      {/* block-trois */}
                    </div>
                    {/* card */}
                  </div>
                  {/* editProfil */}
                </>
              )}
              {/* Modifier le Nom de naissance */}

              {/* s'il n'a pas mis d'occupation, alors on affiche les 3 points */}
              {!valeurOccupationEntrepreneur && (
                <>
                  <div className="filsDe">
                    <div className="sans-occupation">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        viewBox="0 0 24 24"
                      >
                        <path d="M5 21h14a2.006 2.006 0 002-2V9a2.006 2.006 0 00-2-2h-2V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2H5a2.006 2.006 0 00-2 2v10a2.006 2.006 0 002 2zM9 5.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V7H9zm-4 5.3l6.594 2.93a1 1 0 00.812 0L19 10.8v2.188l-6.594 2.931a1 1 0 01-.812 0L5 12.983z"></path>
                      </svg>
                      <p onClick={ListOccupationIA}>. . .</p>
                    </div>
                    {/* sans-occupation */}
                  </div>
                  {/* filsDe */}
                </>
              )}

              {/* entrepreneur : */}
              {/* entrepreneur : */}
              {valeurOccupationEntrepreneur === "1" ? (
                <>
                  <div className="filsDe">
                    <div className="icon">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        width="30px"
                        fill="#000"
                        enableBackground="new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        xmlSpace="preserve"
                      >
                        <path d="M389.376 0H122.624c-5.632 0-10.199 4.566-10.199 10.199v491.602c0 5.633 4.567 10.199 10.199 10.199h266.752c5.632 0 10.199-4.566 10.199-10.199V10.199C399.575 4.566 395.008 0 389.376 0zm-91.45 491.602h-31.727v-31.193c0-5.633-4.567-10.199-10.199-10.199s-10.199 4.566-10.199 10.199v31.193h-31.726v-85.383h83.851v85.383zm81.252 0h-60.855V396.02c0-5.633-4.567-10.199-10.199-10.199H203.876c-5.632 0-10.199 4.566-10.199 10.199v95.582h-60.854V20.398h246.355v471.204z"></path>
                        <path d="M230.96 43.436h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V53.636c0-5.633-4.567-10.2-10.199-10.2zm-10.199 63.367h-42.968V63.835h42.968v42.968zM344.407 43.436H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V53.636c0-5.633-4.567-10.2-10.199-10.2zm-10.199 63.367H291.24V63.835h42.968v42.968zM230.96 155.861h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V166.06c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367h-42.968V176.26h42.968v42.968zM344.407 155.861H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V166.06c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367H291.24V176.26h42.968v42.968zM230.96 268.286h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199v-63.367c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367h-42.968v-42.968h42.968v42.968zM344.407 268.286H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199v-63.367c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367H291.24v-42.968h42.968v42.968zM256 418.526c-5.632 0-10.199 4.566-10.199 10.199v1.022c0 5.633 4.567 10.199 10.199 10.199s10.199-4.566 10.199-10.199v-1.022c0-5.632-4.567-10.199-10.199-10.199z"></path>
                      </svg>
                    </div>
                    {/* icon */}

                    <div className="name">
                      <div className="b">
                        <p
                          style={{ cursor: "pointer" }}
                          onClick={ListOccupationIA}
                        >
                          Propriétaire de : {occupationEntrepreneur}
                        </p>
                      </div>
                      {/* b */}
                    </div>
                    {/* name */}

                    <div className="edit">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="10px"
                        fill="#ccc"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                    {/* edit */}
                  </div>
                </>
              ) : (
                <>
                  <p></p>
                </>
              )}
              {/* entrepreneur : */}

              {/* etudiant : */}
              {/* etudiant : */}
              {valeurOccupationEtudiant === "1" ? (
                <>
                  <div className="filsDe">
                    <div className="icon">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="30px"
                        fill="#000"
                        version="1.1"
                        viewBox="0 0 300 300"
                        xmlSpace="preserve"
                      >
                        <path d="M128.7 32.2c0-13 10.5-23.5 23.5-23.5s23.5 10.5 23.5 23.5-10.5 23.5-23.5 23.5-23.5-10.5-23.5-23.5zM87.5 135l-12.2-2.5c-4.1 2.8-6.5 4.3-10.6 7l-12.1 60.3 21 4.2 13.9-69zm97.3 156.6c7.6-1.8 12.4-9.4 10.6-17l-13.9-60.2c-.5-2.2-1.5-4.2-2.9-5.9L143.2 166l8.8-41.1-62.3 37.8L79 214.6l-33.7 56c-4 6.7-1.9 15.4 4.8 19.4 6.7 4 15.4 1.9 19.4-4.8l35-58.1c.8-1.4 1.4-2.9 1.7-4.5l9.3-45.5 39.2 47.1 13.1 56.9c1.8 7.6 9.4 12.3 17 10.5zm71.5-193.7l-.2.2-49.9 42.2-22.3-22.3h-41.1l-50.1 30.3 14.5-67.7c3.1-14.3 17.2-23.5 31.5-20.4 14.4 3.1 23.5 17.2 20.4 31.5L158 96h8.3l51.5-43.5 16 18.9L256 57.7v40l.3.2zm-10.7-.9L217 63.2 178.2 96H195c6.1 0 11 4.9 11 11 0 6-4.8 10.9-10.9 11l12 11.5L245.6 97z"></path>
                      </svg>
                    </div>
                    {/* icon */}

                    <div className="name">
                      <div className="b">
                        <p
                          style={{ cursor: "pointer" }}
                          onClick={ListOccupationIA}
                        >
                          Étudie à : {occupationEtudiant}
                        </p>
                      </div>
                      {/* b */}
                    </div>
                    {/* name */}

                    <div className="edit">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="10px"
                        fill="#ccc"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                    {/* edit */}
                  </div>
                </>
              ) : (
                <>
                  <p></p>
                </>
              )}
              {/* etudiant : */}

              {/* chomeur : */}
              {/* chomeur : */}
              {valeurOccupationChomeur === "1" ? (
                <>
                  <div className="filsDe">
                    <div className="icon">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="30px"
                        fill="#000"
                        baseProfile="tiny"
                        version="1.2"
                        viewBox="-335 337 128 128"
                        xmlSpace="preserve"
                      >
                        <path d="M-207 458h-9.1c-5.6-12.2-10.3-25.4-12.6-37.9-.5-2.6-1.1-5.1-1.3-7.7-1.1-10.4-.1-20 4-27.7l.7.3c2.5 2.4 5.9 16.1 6 19.6 4.2-7 3.2-17.3-1.6-23.8.2.1.9.6 3.9 2.3l1.9-2.5-.3 4.3c.8.6 2.8 3 3.2 3.2l1.9-2.3-.1 4.3c.7 1 1.5 1.5 2.3 2.5 2.1-12.7-8-16.7-13.9-17.2 2.5-2.7 8.3-5 14.7.4-.4-11.4-17.5-9.8-18.9-2.2-.4-11.8-18.9-20.9-24.8-11.4.7 0 3.5.8 6.7 2.2l3.2-4.2v5.7c1 .6 2.1 1.1 3.1 1.7l4.3-3v6.2c1.5 1.4 2.5 2.8 2.9 4.3 0 0-26.3-7.8-21.1 17.1 0 0 8-16.5 20.7-11.5l-1.1 1.5c-6.5 11.2-6.4 28.5-3.4 44.9-2.1 3-4.7 5.8-7.8 8.2-1.5 1.2-3 2.2-4.6 3.1l-6.6-7.5c-.9-1-2.4-1.3-3.5-.7l-7.3 4c-3-.7-18.5-4.6-19.7-4.7-1.4 0-1.8 1-2.1 2.8 0 .3-.1.6-.1.8v.5c0 .5.4 2.6.9 5.1-3.8-2.1-7.3-4.9-10.2-8.1-2.3-2.5-4.2-5.2-5.6-8-.8-13.9-3.3-27-9.4-37.4l-1.1-1.5c12.7-5 17.9 15.2 17.9 15.2 5.2-24.9-18.3-20.8-18.3-20.8.4-1.5 1.4-2.9 2.9-4.3v-5.6l4.3 2.3c1-.6 2.1-1.1 3.1-1.7l-3.1-5.7 6.3 4.2c3.2-1.4 6-2.2 6.7-2.2-5.9-9.5-24.9-2.2-25.3 9.5-.5-5.3-11.1-9.8-14.6.7 6.6-2.7 4.9-1.7 8.6 2.4-10.9-.6-11.7 8-9.6 20.7.8-1 2.8-9 5.5-11.6 2.7-2.6 4.4-3.1 4.8-2.4-4.9 6.4-5.3 16-1.1 23 .1-3.5 3.5-17.2 6-19.6l.7-.3c9.8 18.6 7 44.7 5.2 70.3H-335v7.6H-206.6V458h-.4zm-64.8-15.4c2.2.6 4.7.3 6-1.3l8.2-4.8 4.1 4.7c-5.7 2.2-11.8 3.1-17.7 2.6-3.3-.3-6.6-1-9.8-2.2l-.3-1.4c3.5.8 9.5 2.4 9.5 2.4zm15.3 15.3H-302.8c.4-9.5.8-19.4.5-29.1 1 1.4 2 2.7 3.2 3.9 3.8 4.1 8.3 7.4 13.2 9.8.8 3.7 1.6 7.2 1.6 7.2.2 1 .9 1.8 1.9 2 .3.1.7.1 1.1 0 1.4-.2 2.3-1.6 2.1-3l-.9-4.1c2.8.9 5.8 1.5 8.7 1.8 2.4.2 4.9.2 7.4 0 4.3-.4 8.5-1.5 12.6-3.2l3.4 3.9c1 1.2 2.8 1.3 4 .3 1.2-1 1.3-2.8.3-4l-2.5-2.9c1.5-.9 3-1.9 4.4-3 2.6-2 4.9-4.2 6.8-6.6 2.1 10 5.3 19.4 8.7 26.7h-30.2zm-34.3-36.7c2.5.6 3.9 3.1 3.2 5.6-.6 2.4-3.1 3.9-5.6 3.2-2.4-.7-3.9-3.1-3.2-5.6.6-2.4 3.1-3.8 5.6-3.2z"></path>
                      </svg>
                    </div>
                    {/* icon */}

                    <div className="name">
                      <div className="b">
                        <p onClick={ListOccupationIA}>Chômeur</p>
                      </div>
                      {/* b */}
                    </div>
                    {/* name */}

                    <div className="edit">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="10px"
                        fill="#ccc"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                    {/* edit */}
                  </div>
                </>
              ) : (
                <>
                  <p></p>
                </>
              )}
              {/* chomeur : */}

              {/* travailleur : */}
              {/* travailleur : */}
              {valeurOccupationTravailleur === "1" ? (
                <>
                  <div className="filsDe">
                    <div className="icon">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        width="30px"
                        fill="#000"
                        version="1.1"
                        viewBox="0 0 495.604 495.604"
                        xmlSpace="preserve"
                      >
                        <path d="M199.467 470.483c0 13.871 11.252 25.121 25.123 25.121 13.876 0 25.12-11.243 25.12-25.121v-135.29l-50.243 38.538v96.752zM259.612 109.353c30.197 0 54.681-24.474 54.681-54.672C314.293 24.483 289.809 0 259.612 0c-30.198 0-54.68 24.483-54.68 54.681 0 30.198 24.482 54.672 54.68 54.672zM224.555 249.702c-.168 3.631-.639 7.284-1.818 10.908l-14.67 45.087c-5.69 17.483-21.913 28.589-39.348 28.589-4.243 0-8.56-.654-12.811-2.037-15.911-5.177-26.452-19.1-28.235-34.705l-2.303 1.766a13.248 13.248 0 00-5.053 8.746 13.196 13.196 0 002.619 9.757l37.256 48.563a13.165 13.165 0 0010.475 5.165 13.11 13.11 0 008.027-2.732l75.922-58.247a13.237 13.237 0 005.053-8.745 13.2 13.2 0 00-2.619-9.757l-32.495-42.358z"></path>
                        <path d="M374.171 285.214l-42.152-129.602a41.79 41.79 0 00-39.825-28.921h-65.108c-18.186 0-34.19 11.624-39.824 28.929l-17.311 53.21-24.85 76.384c-4.244 13.038 2.885 27.046 15.931 31.289 13.013 4.244 27.045-2.878 31.289-15.931l24.855-76.395.365-1.121c6.032 1.729 11.439 5.223 15.389 10.362l4.692 6.117 10.83-63.182 2.05-11.956a2.2 2.2 0 012.167-1.817h13.886c1.066 0 1.979.767 2.166 1.817l2.049 11.956 13.163 76.788a13.24 13.24 0 01-2.878 10.686l-12.929 15.477 2.04 2.662c4.843 6.288 6.944 14.096 5.909 22.033-.738 5.557-3.029 10.629-6.514 14.861v151.625c0 13.877 11.244 25.121 25.12 25.121 13.88 0 25.123-11.243 25.123-25.121V312.171h-.023v-33.638l7.169 22.039c3.411 10.492 13.143 17.16 23.602 17.16 2.547 0 5.141-.396 7.687-1.228 13.047-4.236 20.176-18.252 15.932-31.29zM268.447 150.843a2.188 2.188 0 01-2.189 2.191h-12.95a2.189 2.189 0 01-2.191-2.191v-15.236c0-1.213.978-2.191 2.191-2.191h12.95c1.211 0 2.189.978 2.189 2.191v15.236z"></path>
                      </svg>
                    </div>
                    {/* icon */}

                    <div className="name">
                      <div className="b">
                        <p
                          style={{ cursor: "pointer" }}
                          onClick={ListOccupationIA}
                        >
                          Travaille chez : {occupationTravailleur}
                        </p>
                      </div>
                      {/* b */}
                    </div>
                    {/* name */}

                    <div className="edit">
                      <svg
                        onClick={ListOccupationIA}
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        cursor="pointer"
                        width="10px"
                        fill="#ccc"
                        enableBackground="new 0 0 25.93 25.93"
                        version="1.1"
                        viewBox="0 0 25.93 25.93"
                        xmlSpace="preserve"
                      >
                        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                      </svg>
                    </div>
                    {/* edit */}
                  </div>
                </>
              ) : (
                <>
                  <p></p>
                </>
              )}
              {/* travailleur : */}

              {/* Nom de la mère : */}
              {/* Nom de la mère : */}
              {/* Nom de la mère : */}
              <div className="filsDe">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    fill="#000"
                    version="1.1"
                    viewBox="0 0 511.988 511.988"
                    xmlSpace="preserve"
                  >
                    <path d="M380.637 132.128c-1.583-10.407-11.306-17.568-21.711-15.979l-6.504.989-9.046 11.417a18.606 18.606 0 01-11.345 6.769c-7.336 1.301-20.087 3.644-36.271 6.947-14.014 3.427-28.135-4.151-33.286-17.205l-52.252-16.575 29.819 1.455c-4.905-5.715-12.159-9.262-20.115-9.262h-45.871c-12.688 0-23.55 8.952-26.013 21.398l-40.546 204.853c-1.384 6.995 4.003 13.477 11.06 13.477h24.468v147.22c0 13.451 10.904 24.355 24.355 24.355s24.355-10.904 24.355-24.355v-147.22h10.516v147.22c0 13.451 10.904 24.355 24.355 24.355s24.355-10.904 24.355-24.355v-147.22h24.468c7.097 0 12.442-6.493 11.06-13.477l-28.61-144.539-59.182-37.567 68.739 21.805a19.063 19.063 0 008.629.675l88.592-13.472c10.409-1.581 17.563-11.301 15.981-21.709z"></path>
                    <path d="M403.853 157.536l-4.34-16.989c-2.372 16.148-15.015 29.554-31.991 32.135l-29.906 4.548-31.234 33.947c-6.323 6.871-5.878 17.567.994 23.889 6.877 6.327 17.572 5.873 23.889-.995l39.79-43.245a26.965 26.965 0 0013.107-.092c14.606-3.73 23.422-18.594 19.691-33.198z"></path>
                    <circle cx="311.401" cy="33.488" r="33.488"></circle>
                    <circle cx="196.996" cy="42.994" r="42.063"></circle>
                    <path d="M384.846 83.125c-3.73-14.605-18.602-23.421-33.198-19.689-9.754 2.492-16.918 9.95-19.494 18.978l10.49-4.446-22.247 16.408-28.685 2.885c-9.096.915-16.212 8.707-15.701 17.836.547 9.725 9.075 16.897 18.619 15.934l33.783-3.398c3.025-.304 5.944-1.376 8.361-3.222 27.426-20.942 33.701-26.538 33.701-26.538a38.252 38.252 0 0121.754 14.156l-7.383-28.904z"></path>
                  </svg>
                </div>
                {/* icon */}

                <div className="name">
                  <div className="a">
                    <p>Nom de la mère :</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    {/* si l'utilisateur a entrer le nom de la mere, on l'affiche ici */}
                    {nomMerePersonneConnecterIA && (
                      <>
                        <p>{nomMerePersonneConnecterIA}</p>
                      </>
                    )}

                    {/* si l'utilisateur n'a pas entrer le nom de la mere, 
                    alors on affiche juste les 3 points de suspension */}
                    {!nomMerePersonneConnecterIA && (
                      <>
                        <p>. . .</p>
                      </>
                    )}
                  </div>
                  {/* b */}
                </div>
                {/* name */}

                <div className="edit">
                  <svg
                    onClick={NomMereIA}
                    width="20px"
                    cursor="pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 30 30"
                  >
                    <g transform="translate(0 -289.063)">
                      <path
                        fill="#ccc"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="2"
                        d="M22.824 296.239a11.986 11.986 0 00-1.542-1.287l-2.665 2.665 2.828 2.828 2.666-2.665a11.986 11.986 0 00-1.287-1.541zm-5.621 2.792L6.596 309.638l-.707 3.535 3.536-.707L20.03 301.86z"
                        opacity="0.93"
                      ></path>
                    </g>
                  </svg>
                </div>
                {/* edit */}
              </div>
              {/* Nom de la mère */}

              {/* Modifier Nom de la mère : */}
              {/* Modifier Nom de la mère : */}
              {/* quand on clique, le card qui permet de modifier le Nom de la mère va 
              s'afficher */}
              {nomMereIA && (
                <>
                  <div className="editProfil">
                    <div className="card">
                      <div className="close">
                        <p onClick={CloseNomMereIA}>Nom de la mère</p>
                        <svg
                          onClick={CloseNomMereIA}
                          xmlns="http://www.w3.org/2000/svg"
                          x="0"
                          y="0"
                          cursor="pointer"
                          width="10px"
                          fill="#ccc"
                          enableBackground="new 0 0 25.93 25.93"
                          version="1.1"
                          viewBox="0 0 25.93 25.93"
                          xmlSpace="preserve"
                        >
                          <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
                        </svg>
                      </div>
                      {/* close */}

                      <div className="block-un">
                        <p>Entrer le nom de votre mère</p>
                      </div>
                      {/* block-un */}

                      {/* ca c'est le textarea qui nous permet d'entrer et de modifier 
                      le nom de la mere */}
                      <div className="block-deux">
                        <textarea
                          value={textareaNomMereIA}
                          onChange={(e) => setTextareaNomMereIA(e.target.value)}
                        ></textarea>
                      </div>
                      {/* block-deux */}

                      <div className="block-trois">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="#000"
                          data-name="Layer 2"
                          viewBox="0 0 32 32"
                        >
                          <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                        </svg>
                        <p onClick={EnregistrerNomMereIA}>Valider</p>
                      </div>
                      {/* block-trois */}
                    </div>
                    {/* card */}
                  </div>
                  {/* editProfil */}
                </>
              )}
              {/* Modifier Nom de la mère : */}
            </div>
            {/* block-dix */}

            <div className="block-onze">
              <p onClick={InformationImportanteIA}>Informations importante</p>
            </div> </>)}                                                                              
            {/* block-onze */}
          </div> 
          {/* profilIA */}
        </>
      )}
      {/* profil - IA */}

      {/* photo de profil popup - IA */}
      {/* quand on clique, on affiche la photo de profil dans la popup */}
      {popupImageProfilIA && (
        <>
          <div onClick={PopupImageProfilIA} className="popup-image-opacity">
            <div className="align">
              <div className="image"> <img src={photoPersonConnectedIA} alt="" /> </div>
              {/* image */}
            </div>
            {/* align */}
          </div>
          {/* popup-image-opacity */}
        </>
      )}
      {/* photo de profil popup - IA */}

      {/* mettre photo profil popup - IA */}
      {/* mettre photo profil popup - IA */}
      {/* la popup ci va permettre de mettre sa photo publique */}
      {mettrePhotoProfilIA && (
        <>
          <div className="mettrePhotoProfilIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p>Photo Publique</p>
                  </div>

                  <div className="b">
                    <svg
                      onClick={MettrePhotoProfilIA}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      fill="#000"
                      version="1.1"
                      viewBox="0 0 40 40"
                      xmlSpace="preserve"
                    >
                      <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                    </svg>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="block-un">
                  <hr />
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <input
                    onChange={(e) => setFilePhotoProfilIA(e.target.files[0])}
                    id="file"
                    type="file"
                    name="image"
                    accept=".jpg, .jpeg, .png"
                  />
                </div>
                {/* block-deux */}

                <div className="block-trois"> <p onClick={EnregistrerPhotoProfilIA}>Valider</p> </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* mettrePhotoProfilIA-opacity */}
        </>
      )}
      {/* mettre photo profil popup - IA */}

      {/* Information importante - IA */}
      {/* Information importante - IA */}
      {/* on affiche les informations importantes (tel que l'année d'identification du numéro virtuel, le nom du propriétaire du numéro virtuel, ... ) */}
      {informationImportanteIA && (
        <>
          <div
            onClick={InformationImportanteIA}
            className="informationImportante-opacity"
          >s
            <div className="align">
              <div className="card">

                <div className="block-un"> <p>Information importante</p> </div>
                {/* block-un */}

                {/* numero virtuel - IA */}
                {/* numero virtuel - IA */}
                <div className="block-deux"> <SvgVirtualNumber2 /> <p>{virtualNumberPersonConnectedIA}</p> </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="a"> <p>Votre Numéro virtuel est {virtualNumberPersonConnectedIA}</p> </div>
                  {identificationIA === "0" && (<><div className="b"> <p>Numéro virtuel non identifier</p> </div></>)}
                </div>
                {/* block-trois */}

                {identificationIA === "1" && typeAccountIA === "1" && (<><div className="block-quatre"> <p>Identifier au nom de :</p> <p>{nameAtIdentificationIA}</p> </div></>)}
                {/* block-quatre */}

                {dev && (<>
                <div className="block-cinq">
                  <p>Année : 2024</p>
                </div>
                {/* block-cinq */}

                <div className="block-six">
                  {/* bus stop - IA */}
                  {/* bus stop - IA */}
                  <div className="display">
                    <svg
                      onClick={BusStopPageIA}
                      xmlns="http://www.w3.org/2000/svg"
                      cursor="pointer"
                      width="20px"
                      fill="white"
                      viewBox="0 0 36 36"
                    >
                      <path
                        d="M32 13.22V30H4V8h3V6H3.75A1.78 1.78 0 002 7.81v22.38A1.78 1.78 0 003.75 32h28.5A1.78 1.78 0 0034 30.19V12.34a7.45 7.45 0 01-2 .88z"
                        className="clr-i-outline--badged clr-i-outline-path-1--badged"
                      ></path>
                      <path
                        d="M8 14H10V16H8z"
                        className="clr-i-outline--badged clr-i-outline-path-2--badged"
                      ></path>
                      <path
                        d="M14 14H16V16H14z"
                        className="clr-i-outline--badged clr-i-outline-path-3--badged"
                      ></path>
                      <path
                        d="M20 14H22V16H20z"
                        className="clr-i-outline--badged clr-i-outline-path-4--badged"
                      ></path>
                      <path
                        d="M26 14H28V16H26z"
                        className="clr-i-outline--badged clr-i-outline-path-5--badged"
                      ></path>
                      <path
                        d="M8 19H10V21H8z"
                        className="clr-i-outline--badged clr-i-outline-path-6--badged"
                      ></path>
                      <path
                        d="M14 19H16V21H14z"
                        className="clr-i-outline--badged clr-i-outline-path-7--badged"
                      ></path>
                      <path
                        d="M20 19H22V21H20z"
                        className="clr-i-outline--badged clr-i-outline-path-8--badged"
                      ></path>
                      <path
                        d="M26 19H28V21H26z"
                        className="clr-i-outline--badged clr-i-outline-path-9--badged"
                      ></path>
                      <path
                        d="M8 24H10V26H8z"
                        className="clr-i-outline--badged clr-i-outline-path-10--badged"
                      ></path>
                      <path
                        d="M14 24H16V26H14z"
                        className="clr-i-outline--badged clr-i-outline-path-11--badged"
                      ></path>
                      <path
                        d="M20 24H22V26H20z"
                        className="clr-i-outline--badged clr-i-outline-path-12--badged"
                      ></path>
                      <path
                        d="M26 24H28V26H26z"
                        className="clr-i-outline--badged clr-i-outline-path-13--badged"
                      ></path>
                      <path
                        d="M10 10a1 1 0 001-1V3a1 1 0 00-2 0v6a1 1 0 001 1z"
                        className="clr-i-outline--badged clr-i-outline-path-14--badged"
                      ></path>
                      <path
                        d="M22.5 6H13v2h9.78a7.49 7.49 0 01-.28-2z"
                        className="clr-i-outline--badged clr-i-outline-path-15--badged"
                      ></path>
                      <circle
                        cx="30"
                        cy="6"
                        r="5"
                        className="clr-i-outline--badged clr-i-outline-path-16--badged clr-i-badge"
                      ></circle>
                      <path fill="none" d="M0 0H36V36H0z"></path>
                    </svg>
                    {/* si l'utilisateur a entrer l'arret de bus, ca va s'afficher ici */}
                    {dateNaissancePersonneConnecterIA && (<> <p onClick={BusStopPageIA}>{dateNaissancePersonneConnecterIA}</p> </>)}

                    {/* si l'utilisateur n'a pas entrer l'arret de bus alors on affiche juste les 3 points de suspension */}
                    {!dateNaissancePersonneConnecterIA && (<> <p onClick={BusStopPageIA}>. . .</p> </>)}
                  </div>
                  {/* block-six */}

                  {/* adresse */}
                  {/* adresse */}
                  <div className="display">
                    <svg
                      onClick={AddressPageIA}
                      cursor="pointer"
                      width="20px"
                      fill="white"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10,1.375c-3.17,0-5.75,2.548-5.75,5.682c0,6.685,5.259,11.276,5.483,11.469c0.152,0.132,0.382,0.132,0.534,0c0.224-0.193,5.481-4.784,5.483-11.469C15.75,3.923,13.171,1.375,10,1.375 M10,17.653c-1.064-1.024-4.929-5.127-4.929-10.596c0-2.68,2.212-4.861,4.929-4.861s4.929,2.181,4.929,4.861C14.927,12.518,11.063,16.627,10,17.653 M10,3.839c-1.815,0-3.286,1.47-3.286,3.286s1.47,3.286,3.286,3.286s3.286-1.47,3.286-3.286S11.815,3.839,10,3.839 M10,9.589c-1.359,0-2.464-1.105-2.464-2.464S8.641,4.661,10,4.661s2.464,1.105,2.464,2.464S11.359,9.589,10,9.589"></path>
                    </svg>
                    {/* si l'utilisateur a entrer son adresse, on l'affiche ici */}
                    {adressePersonneConnecterIA && (<> <p onClick={AddressPageIA}>{adressePersonneConnecterIA}</p> </>)}

                    {/* si l'utilisateur n'a pas entrer son adresse on affiche juste les 3 points */}
                    {!adressePersonneConnecterIA && (<> <p onClick={AddressPageIA}>. . .</p> </>)}
                  </div>

                  {/* phone number */}
                  {/* phone number */}
                  <div className="display">
                    <svg
                      onClick={PhoneNumberPageIA}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      cursor="pointer"
                      width="20px"
                      fill="white"
                      enableBackground="new 0 0 512.001 512.001"
                      version="1.1"
                      viewBox="0 0 512.001 512.001"
                      xmlSpace="preserve"
                    >
                      <path d="M498.816 371.03c-24.32-24.32-77.278-46.976-115.618-59.75-54.741-18.244-36.497 72.994-72.994 72.994-18.244 0-63.863-36.497-104.926-77.551-41.054-41.062-77.551-86.682-77.551-104.926 0-36.497 91.238-18.253 72.994-72.994-12.783-38.349-35.43-91.298-59.759-115.618C130.56 2.783 119.86-2.389 109.483 1.067 54.742 19.32 0 74.062 0 110.559c0 72.986 18.244 164.224 127.735 273.715 109.483 109.474 200.721 127.727 273.707 127.727 36.497 0 91.238-54.741 109.483-109.491 3.456-10.368-1.706-21.078-12.109-31.48zm-97.365 115.166c-62.993 0-148.949-13.662-255.471-120.175C39.467 259.508 25.805 173.543 25.805 110.55c0-20.267 41.993-67.644 90.24-84.463 1.118.589 3.354 2.022 6.673 5.333 16.717 16.717 37.726 58.138 53.521 105.54.725 2.185.973 3.618 1.05 4.429-3.635 2.918-14.874 6.46-21.768 8.636-20.045 6.315-53.598 16.887-53.598 51.763 0 31.454 46.285 84.343 85.112 123.17s91.716 85.111 123.17 85.111c34.884 0 45.449-33.553 51.763-53.598 2.176-6.903 5.709-18.133 8.636-21.768.811.077 2.244.324 4.429 1.05 47.394 15.804 88.823 36.813 105.532 53.521 3.319 3.311 4.745 5.547 5.333 6.673-16.803 48.256-64.189 90.249-84.447 90.249zM256 102.401v25.6c70.69 0 128 57.31 128 128h25.6c0-84.694-68.906-153.6-153.6-153.6z"></path>
                      <path d="M256 51.201v25.6c98.97 0 179.2 80.23 179.2 179.2h25.6c0-112.93-91.869-204.8-204.8-204.8z"></path>
                      <path d="M256 .001v25.6c127.249 0 230.4 103.151 230.4 230.4H512c0-141.159-114.841-256-256-256z"></path>
                    </svg>
                    <p onClick={PhoneNumberPageIA}>{numeroTelephonePersonneConnecterIA}</p>
                  </div>
                  {/* display */}
                  {/* telephone - IA */}

                  {/* sexe - IA */}
                  {/* sexe - IA */}
                  {/* si sexe Masculin=1, alors ca sera active */}
                  {maleIA ? (
                    <>
                      <div className="display">
                        <svg
                          onClick={EditSexeIA}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="#fff"
                          viewBox="0 0 1024 1024"
                        >
                          <path d="M399.5 849.5a225 225 0 100-450 225 225 0 000 450zm0 56.25a281.25 281.25 0 110-562.5 281.25 281.25 0 010 562.5zm253.125-787.5h225q28.125 0 28.125 28.125T877.625 174.5h-225q-28.125 0-28.125-28.125t28.125-28.125z"></path>
                          <path d="M877.625 118.25q28.125 0 28.125 28.125v225q0 28.125-28.125 28.125T849.5 371.375v-225q0-28.125 28.125-28.125z"></path>
                          <path d="M604.813 458.9L565.1 419.131l292.613-292.668 39.825 39.824z"></path>
                        </svg>
                        <p onClick={EditSexeIA}>Masculin</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <p></p>
                    </>
                  )}

                  {/* si sexe feminin=1, alors ca sera active */}
                  {femaleIA ? (
                    <>
                      <div className="display">
                        <svg
                          onClick={EditSexeIA}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                            d="M9 18h6m-3-5v8m0-8a5 5 0 100-10 5 5 0 000 10z"
                          ></path>
                        </svg>
                        <p onClick={EditSexeIA}>Féminin</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <p></p>
                    </>
                  )}

                  {/* si l'utilisateur n'a pas entrer son sexe, 
                    alors, on affiche les 3 points */}
                  {!sexePersonneConnecterIA && (
                    <>
                      <div className="display">
                        <svg
                          onClick={EditSexeIA}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="#fff"
                          version="1.1"
                          viewBox="0 0 234.343 234.343"
                          xmlSpace="preserve"
                        >
                          <path d="M149.495 131.313c-22.28 0-40.404 18.124-40.404 40.404a4.04 4.04 0 008.08 0c0-17.823 14.501-32.323 32.323-32.323a4.04 4.04 0 00.001-8.081zM96.969 62.626c0-22.28-18.124-40.404-40.404-40.404a4.04 4.04 0 000 8.08c17.823.001 32.324 14.502 32.324 32.324a4.04 4.04 0 008.08 0z"></path>
                          <path d="M234.032 93.406a4.048 4.048 0 00-3.728-2.497H189.9a4.04 4.04 0 000 8.08h30.65l-31.487 31.487c-.163.163-.238.371-.367.553-10.177-9.808-23.982-15.878-39.2-15.878-31.191 0-56.566 25.375-56.566 56.566 0 31.191 25.375 56.566 56.566 56.566 31.191 0 56.566-25.375 56.566-56.566 0-13.189-4.574-25.309-12.169-34.94.306-.175.623-.326.884-.587l31.486-31.486v30.65a4.04 4.04 0 008.08 0V94.95a4.04 4.04 0 00-.311-1.544zm-36.052 78.311c0 26.734-21.751 48.485-48.485 48.485s-48.485-21.751-48.485-48.485 21.751-48.485 48.485-48.485 48.485 21.751 48.485 48.485zM74.971 147.475H60.606v-28.488c29.305-2.086 52.525-26.534 52.525-56.361 0-31.191-25.375-56.566-56.566-56.566S0 31.436 0 62.626c0 29.827 23.221 54.275 52.525 56.361v28.488H38.384a4.04 4.04 0 000 8.08h14.141v12.121a4.04 4.04 0 008.08 0v-12.121h14.364a4.04 4.04 0 00.002-8.08zm-18.405-36.364c-26.734 0-48.485-21.751-48.485-48.485s21.751-48.485 48.485-48.485c26.734 0 48.485 21.751 48.485 48.485S83.3 111.111 56.566 111.111z"></path>
                        </svg>

                        <p onClick={EditSexeIA}>. . .</p>
                      </div>
                    </>
                  )}
                  {/* sexe - IA */}

                 
                </div>
                {/* b */}

              </>)}
              {/* dev se ferme ici */}

              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* informationImportante-opacity */}
        </>
      )}
      {/* Information importante - IA */}

      {/* saisir l'adresse - IA */}
      {/* saisir l'adresse - IA */}
      {addressPageIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Adresse</p>
                  <svg
                    onClick={CloseAddressPageIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un"> <p>Saisir l'adresse pour se rendre dans votre Boutique</p> </div>
                {/* block-un */}

                <div className="block-deux"> <input type="text" value={writeAddress} onChange={(e) => setWriteAddress(e.target.value)} /> </div>
                {/* block-deux */}

                <div onClick={SaveAddressIA} className="block-trois">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p>Valider</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* saisir l'adresse - IA */}

      {/* saisir l'Arrêt de Bus - IA */}
      {/* saisir l'Arrêt de Bus - IA */}
      {busStopPageIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Arrêt de Bus</p>
                  <svg
                    onClick={CloseBusStopPageIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un"> <p>Écrivez l'Arrêt de Bus le plus proche de votre Boutique</p> </div>
                {/* block-un */}
                
                <div className="block-deux"> <input type="text" value={writeBusStop} onChange={(e) => setWriteBusStop(e.target.value)} /> </div>
                {/* block-deux */}

                <div onClick={SaveBusStopIA} className="block-trois">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p>Valider</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* saisir l'Arrêt de Bus - IA */}

      {/* saisir le numero de telephone - IA */}
      {/* saisir le numero de telephone - IA */}
      {phoneNumberPageIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Numéro de Téléphone</p>
                  <svg
                    onClick={ClosePhoneNumberPageIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un"> <p>Saisir le Numéro de Téléphone auquel on peut vous joindre</p> </div>
                {/* block-un */}

                <div className="block-deux"> <input type="text" value={writePhoneNumber} onChange={(e) => setWritePhoneNumber(e.target.value)} /> </div>
                {/* block-deux */}

                <div onClick={SavePhoneNumberIA} className="block-trois">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p>Valider</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* saisir le numero de telephone - IA */}

      {/* listes des occupations - IA */}
      {/* listes des occupations - IA */}
      {/* on affiche la listes des occupations - IA */}
      {listOccupationIA && (
        <>
          <div className="listOccupation-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p>.</p>
                  </div>

                  <div className="b">
                    <p>Occupation</p>
                  </div>

                  <div className="c">
                    <svg
                      onClick={ListOccupationIA}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      fill="#fff"
                      version="1.1"
                      viewBox="0 0 40 40"
                      xmlSpace="preserve"
                    >
                      <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                    </svg>
                  </div>
                  {/* c */}
                </div>
                {/* close */}

                <div className="block-un">
                  <hr />
                </div>
                {/* block-un" */}

                <div className="block-deux">
                  {/* entrepreneur */}
                  {valeurOccupationEntrepreneur === "1" ? (
                    <>
                      <div className="a-active">
                        <p onClick={EditOccupationEntrepreneurIA}>
                          Entrepreneur
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="a-noActive">
                        <p onClick={EditOccupationEntrepreneurIA}>
                          Entrepreneur
                        </p>
                      </div>
                    </>
                  )}

                  {/* Travailleur */}
                  {valeurOccupationTravailleur === "1" ? (
                    <>
                      <div className="a-active">
                        <p onClick={EditOccupationTravailleurIA}>Travailleur</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="a-noActive">
                        <p onClick={EditOccupationTravailleurIA}>Travailleur</p>
                      </div>
                    </>
                  )}

                  {/* Étudiant */}
                  {valeurOccupationEtudiant === "1" ? (
                    <>
                      <div className="a-active">
                        <p onClick={EditOccupationEtudiantIA}>Étudiant</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="a-noActive">
                        <p onClick={EditOccupationEtudiantIA}>Étudiant</p>
                      </div>
                    </>
                  )}

                  {/* Chomeur */}
                  {valeurOccupationChomeur === "1" ? (
                    <>
                      <div className="b-active">
                        <p>Chômeur</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="a-noActive">
                        <p onClick={EnregistrerOccupationChomeurIA}>Chômeur</p>
                      </div>
                    </>
                  )}
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* listOccupation-opacity */}
        </>
      )}
      {/* listes des occupations - IA */}

      {/* edit occupation entrepreneur - IA */}
      {/* edit occupation entrepreneur - IA */}
      {/* dans le cas ou c'est un entrepreneur, on affiche le card qui va lui permettre 
      d'entrer le nom de son entreprise */}
      {editOccupationEntrepreneurIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Entrepreneur</p>
                  <svg
                    onClick={CloseEditOccupationEntrepreneurIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un">
                  <p>Entrer le nom de votre entreprise</p>
                </div>
                {/* block-un */}

                {/* ca c'est l'input qui nous permet d'entrer ou de modifier le nom de 
                son entreprise. Entreprise appartenant a la personne connecter */}
                <div className="block-deux">
                  <input
                    type="text"
                    value={enregistrerOccupationEntrepreneurIA}
                    onChange={(e) =>
                      setEnregistrerOccupationEntrepreneurIA(e.target.value)
                    }
                  />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <svg
                    onClick={EnregistrerOccupationEntrepreneurIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p onClick={EnregistrerOccupationEntrepreneurIA}>Valider</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* edit occupation entrepreneur - IA */}

      {/* edit occupation Travailleur - IA */}
      {/* edit occupation Travailleur - IA */}
      {/* dans le cas ou c'est un Travailleur, on affiche le card qui va lui permettre 
      d'entrer le nom de l'entreprise pour laquelle il a travaillé */}
      {editOccupationTravailleurIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Travailleur</p>
                  <svg
                    onClick={CloseEditOccupationTravailleurIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}
                <div className="block-un">
                  <p>
                    Entrer le nom de l'entreprise pour laquelle vous travaillez
                  </p>
                </div>
                {/* block-un */}
                {/* ca c'est l'input qui nous permet d'entrer ou de modifier le nom de
                l'entreprise pour laquelle il a travaillé */}
                <div className="block-deux">
                  <input
                    type="text"
                    value={enregistrerOccupationTravailleurIA}
                    onChange={(e) =>
                      setEnregistrerOccupationTravailleurIA(e.target.value)
                    }
                  />
                </div>
                {/* block-deux */}
                <div className="block-trois">
                  <svg
                    onClick={EnregistrerOccupationTravailleurIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p onClick={EnregistrerOccupationTravailleurIA}>Valider</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* edit occupation travailleur - IA */}

      {/* edit occupation etudiant - IA */}
      {/* edit occupation etudiant - IA */}
      {/* dans le cas ou c'est un etudiant, on affiche le card qui va lui permettre 
      d'entrer le nom de l'ecole ou il a fait ses etudes */}
      {editOccupationEtudiantIA && (
        <>
          <div className="dateNaissanceIA-opacity">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>Étudiant</p>
                  <svg
                    onClick={CloseEditOccupationEtudiantIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    version="1.1"
                    viewBox="0 0 40 40"
                    xmlSpace="preserve"
                  >
                    <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un">
                  <p>Entrer le nom de l'école ou vous faites vos études</p>
                </div>
                {/* block-un */}

                {/* ca c'est l'input qui nous permet d'entrer ou de modifier
                le nom de l'ecole ou il a fait ses etudes */}
                <div className="block-deux">
                  <input
                    type="text"
                    value={enregistrerOccupationEtudiantIA}
                    onChange={(e) =>
                      setEnregistrerOccupationEtudiantIA(e.target.value)
                    }
                  />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <svg
                    onClick={EnregistrerOccupationEtudiantIA}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="#fff"
                    data-name="Layer 2"
                    viewBox="0 0 32 32"
                  >
                    <path d="M24.85 15.82a1.08 1.08 0 00-.11-.28 23.84 23.84 0 00-4.2-5.72c-1.13-1.15-2.9.62-1.76 1.77A21.4 21.4 0 0121.52 15a116.75 116.75 0 00-12 0c-1.6.09-1.61 2.59 0 2.5a118.88 118.88 0 0111.94-.05c-.76 1.3-1.46 2.55-2.17 3.86s1.41 2.69 2.15 1.26A60.71 60.71 0 0124.77 17a1.06 1.06 0 00.08-1.18z"></path>
                  </svg>
                  <p onClick={EnregistrerOccupationEtudiantIA}>Valider</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* dateNaissanceIA-opacity */}
        </>
      )}
      {/* edit occupation etudiant - IA */}

      {/* Compte Validé - (processusValidationCompteClientIA) */}
      {/* Compte Validé - (processusValidationCompteClientIA) */}
      {/* quand le compte du client a ete valider, ce message de success va s'afficher */}
      {compteValiderIA && (
        <>
          <div onClick={CloseCompteValiderIA} className="superIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Le compte a été validé !</p>
                </div>
                {/* block-un */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* superIA-opacity */}
        </>
      )}
      {/* Compte Validé - (processusValidationCompteClientIA) */}

      {/* super - IA */}
      {/* super - IA */}
      {/* quand une action a reussie, ce message de success va s'afficher.
      par exemple, apres avoir entrer la date de naissance */}
      {superIA && (
        <>
          <div onClick={CloseSuperIA} className="superIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Validé !</p>
                </div>
                {/* block-un */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* superIA-opacity */}
        </>
      )}
      {/* super - IA */}

      {/* numero Incorrect - IA */}
      {/* numero Incorrect - IA */}
      {/* en cas de numero Incorrect, on affiche ce message d'erreur */}
      {numeroIncorrectIA && (
        <>
          <div onClick={CloseNumeroIncorrectIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Une erreur s'est produite !</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <hr />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <p>
                    Entrer un numéro correct pour effectuer la recharge ou
                    essayer une autre méthode
                  </p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* numero Incorrect - IA */}


      {/* Numéro virtuel déjà identifié - IA */}
      {/* Numéro virtuel déjà identifié - IA */}
      {identificationAlreadyIA && (
        <>
          <div onClick={CloseIdentificationAlreadyIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>Numéro virtuel déjà identifié !</p> </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* Numéro virtuel déjà identifié - IA */}


      {/* codePinIncorrect - IA */}
      {/* codePinIncorrect - IA */}
      {/* en cas d'erreur, cette popup va afficher le message d'erreur */}
      {/* si par exemple l'agent veut demarrer le processus pour valider un compte et que 
  par erreur il entre un mauvais code, alors on va l'afficher ce message d'erreur */}
      {codePinIncorrectIA && (
        <>
          <div onClick={CloseCodePinIncorrectIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Une erreur s'est produite !</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <hr />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <p>Rééssayer à nouveau ou essayer avec un autre code PIN</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* codePinIncorrect - IA */}

      {/* erreur (Numero Virtuel Incorrect) - IA */}
      {/* erreur (Numero Virtuel Incorrect) - IA */}
      {/*on affiche ce message d'erreur si l'utilisateur a saisi un numero virtuel qui n'existe pas - IA */}
      {erreurNumeroVirtuelIncorrectIA && (
        <>
          <div
            onClick={CloseErreurNumeroVirtuelIncorrectIA}
            className="erreurIA-opacity"
          >
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>{t("--an error has occurred")}</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <hr />
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <p>{t("--check your virtual number")}</p>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>
      )}
      {/* erreur (Numero Virtuel Incorrect) - IA */}

      {/* erreur - IA */}
      {/* erreur - IA */}
      {/* en cas d'erreur, cette popup va afficher le message d'erreur */}
      {errorIA && (<>
          <div onClick={CloseErrorIA} className="erreurIA-opacity">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p>{t("--an error has occurred")}</p> </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois"> <p>{t("--please, try again later")}</p> </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIA-opacity */}
        </>)}
      {/* erreur - IA */}

      {/* ecran de demarrage - vb app */}
      {/* ecran de demarrage - vb app */}
      {/* ca c'est l'ecran de demarrage de l' application Veil Brillant */}
      {ecranDemarrageVB && (
        <>
          <div onClick={FermerEcranDemarrageVB} className="ecranDemarrageVB">
            <div className="align">
              <div className="display">
                {/* ici c'est le logo qui est en lettre */}
                {/* VEIL */}
                {/* VEIL */}
                <div className="block-un">
                  {lettreV && (
                    <>
                      <div className="lettreV">
                        <p>V</p>
                      </div>
                    </>
                  )}

                  {lettreE && (
                    <>
                      <div className="lettreE">
                        <p>E</p>
                      </div>
                    </>
                  )}

                  {premierI && (
                    <>
                      <div className="premierI">
                        <p>I</p>
                      </div>
                    </>
                  )}

                  {premierL && (
                    <>
                      <div className="premierL">
                        <p>L</p>
                      </div>
                    </>
                  )}
                </div>
                {/* block-un */}

                {/* BRILLANT */}
                {/* BRILLANT */}
                <div className="block-deux">
                  {lettreB && (
                    <>
                      <div className="lettreB">
                        <p>B</p>
                      </div>
                    </>
                  )}

                  {lettreR && (
                    <>
                      <div className="lettreR">
                        <p>r</p>
                      </div>
                    </>
                  )}

                  {deuxiemeI && (
                    <>
                      <div className="deuxiemeI">
                        <p>i</p>
                      </div>
                    </>
                  )}

                  {deuxiemeL && (
                    <>
                      <div className="deuxiemeL">
                        <p>l</p>
                      </div>
                    </>
                  )}

                  {troisiemeL && (
                    <>
                      <div className="deuxiemeL">
                        <p>l</p>
                      </div>
                    </>
                  )}

                  {lettreA && (
                    <>
                      <div className="lettreA">
                        <p>a</p>
                      </div>
                    </>
                  )}

                  {lettreN && (
                    <>
                      <div className="lettreN">
                        <p>n</p>
                      </div>
                    </>
                  )}

                  {lettreT && (
                    <>
                      <div className="lettreT">
                        <p>t</p>
                      </div>
                    </>
                  )}
                </div>
                {/* block-deux */}
              </div>
              {/* display */}
            </div>
            {/* align */}
          </div>
          {/* ecranDemarrageIA-opacity */}
        </>
      )}
      {/* ecran de demarrage - vb app */}

      {/* veil Brillant app */}
      {/* veil Brillant app */}
      {/* quand on clique, on est dans l'application veil Brillant */}
      {/* donc ca c'est l'application veil Brillant */}
      {veilBrillantApp && (
        <>
          <div className="veilBrillantApp">
            {/* head (la tete) - veilBrillantApp */}
            {/* ca c'est la tete de l'application, ici nous avons le logo et les icones de
            navigation entre les differents onglets */}
            <div className="head">
              {/* ici c'est le logo qui est en lettre */}
              <div className="logo">
                <div onClick={VeilBrillantApp} className="block-one">
                  {/* VEIL */}
                  <div className="a">
                    <div className="lettreV"> <p>V</p> </div>
                    <div className="lettreE"> <p>E</p> </div>
                    <div className="premierI"> <p>I</p> </div>
                    <div className="premierL"> <p>L</p> </div>
                  </div>
                  {/* a */}

                  {/* BRILLANT */}
                  <div className="b">
                    <div className="lettreB"> <p>B</p> </div>
                    <div className="lettreR"> <p>r</p> </div>
                    <div className="deuxiemeI"> <p>i</p> </div>
                    <div className="deuxiemeL"> <p>l</p> </div>
                    <div className="deuxiemeL"> <p>l</p> </div>
                    <div className="lettreA"> <p>a</p> </div>
                    <div className="lettreN"> <p>n</p> </div>
                    <div className="lettreT"> <p>t</p> </div>
                  </div>
                  {/* b */}
                </div>
                {/* block-one */}

                <div className="block-two"></div>
                {/* block-two */}
              </div>
              {/* logo */}

              {/* videos */}
              {/* videos */}
              {videoOngletVB && (
                <>
                  <div className="subNavbar">
                    <table id="tableau">
                      <tr>
                        <th>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000"
                            width="20px"
                            version="1.1"
                            viewBox="0 0 24 24"
                            xmlSpace="preserve"
                          >
                            <path d="M20 24H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4zM4 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z"></path>
                            <path d="M9 17c-.2 0-.3 0-.5-.1-.3-.2-.5-.5-.5-.9V8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0l7 4c.3.2.5.5.5.9s-.2.7-.5.9l-7 4c-.2.1-.3.1-.5.1zm1-7.3v4.6l4-2.3-4-2.3z"></path>
                          </svg>
                        </th>

                        <th onClick={SearchOngletVB}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#666"
                            viewBox="0 0 30 30"
                          >
                            <path d="M10.5 17a.506.506 0 00-.344.15L.64 26.652c-.896.893-.776 2.134-.105 2.81.67.674 1.913.795 2.81-.103l9.49-9.49c.492-.472-.25-1.182-.706-.708l-9.49 9.49c-.58.58-1.07.43-1.396.104-.326-.328-.47-.826.102-1.397l9.517-9.503c.326-.318.084-.857-.363-.857zm8.45-14.93a8 8 0 00-4.39 2.063c-.49.453.21 1.17.68.734a6.999 6.999 0 018.022-1.06c.58.332 1.053-.603.465-.885a7.994 7.994 0 00-4.776-.852zM20 0c-5.517 0-10 4.483-10 10s4.483 10 10 10 10-4.483 10-10S25.517 0 20 0zm0 1c4.976 0 9 4.024 9 9s-4.024 9-9 9-9-4.024-9-9 4.024-9 9-9z"></path>
                          </svg>
                        </th>

                        <th onClick={CompteOngletVB}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#a6a6a6"
                            width="20px"
                            data-name="Layer 1"
                            viewBox="0 0 48 48"
                          >
                            <path d="M24 21a10 10 0 1110-10 10 10 0 01-10 10zm0-16a6 6 0 106 6 6 6 0 00-6-6zM42 47H6a2 2 0 01-2-2v-6a16 16 0 0116-16h8a16 16 0 0116 16v6a2 2 0 01-2 2zM8 43h32v-4a12 12 0 00-12-12h-8A12 12 0 008 39z"></path>
                          </svg>
                        </th>
                      </tr>
                    </table>
                  </div>
                  {/* subNavbar */}
                </>
              )}
              {/* Videos */}

              {/* search */}
              {/* search */}
              {searchOngletVB && (
                <>
                  <div className="subNavbar">
                    <table id="tableau">
                      <tr>
                        <th onClick={VideoOngletVB}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#a6a6a6"
                            width="20px"
                            version="1.1"
                            viewBox="0 0 24 24"
                            xmlSpace="preserve"
                          >
                            <path d="M20 24H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4zM4 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z"></path>
                            <path d="M9 17c-.2 0-.3 0-.5-.1-.3-.2-.5-.5-.5-.9V8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0l7 4c.3.2.5.5.5.9s-.2.7-.5.9l-7 4c-.2.1-.3.1-.5.1zm1-7.3v4.6l4-2.3-4-2.3z"></path>
                          </svg>
                        </th>

                        <th>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#000"
                            viewBox="0 0 30 30"
                          >
                            <path d="M10.5 17a.506.506 0 00-.344.15L.64 26.652c-.896.893-.776 2.134-.105 2.81.67.674 1.913.795 2.81-.103l9.49-9.49c.492-.472-.25-1.182-.706-.708l-9.49 9.49c-.58.58-1.07.43-1.396.104-.326-.328-.47-.826.102-1.397l9.517-9.503c.326-.318.084-.857-.363-.857zm8.45-14.93a8 8 0 00-4.39 2.063c-.49.453.21 1.17.68.734a6.999 6.999 0 018.022-1.06c.58.332 1.053-.603.465-.885a7.994 7.994 0 00-4.776-.852zM20 0c-5.517 0-10 4.483-10 10s4.483 10 10 10 10-4.483 10-10S25.517 0 20 0zm0 1c4.976 0 9 4.024 9 9s-4.024 9-9 9-9-4.024-9-9 4.024-9 9-9z"></path>
                          </svg>
                        </th>

                        <th onClick={CompteOngletVB}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#a6a6a6"
                            width="20px"
                            data-name="Layer 1"
                            viewBox="0 0 48 48"
                          >
                            <path d="M24 21a10 10 0 1110-10 10 10 0 01-10 10zm0-16a6 6 0 106 6 6 6 0 00-6-6zM42 47H6a2 2 0 01-2-2v-6a16 16 0 0116-16h8a16 16 0 0116 16v6a2 2 0 01-2 2zM8 43h32v-4a12 12 0 00-12-12h-8A12 12 0 008 39z"></path>
                          </svg>
                        </th>
                      </tr>
                    </table>
                  </div>
                  {/* subNavbar */}
                </>
              )}
              {/* notifications */}

              {/* Compte */}
              {/* Compte */}
              {compteOngletVB && (
                <>
                  <div className="subNavbar">
                    <table id="tableau">
                      <tr>
                        <th onClick={VideoOngletVB}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#a6a6a6"
                            width="20px"
                            version="1.1"
                            viewBox="0 0 24 24"
                            xmlSpace="preserve"
                          >
                            <path d="M20 24H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4zM4 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z"></path>
                            <path d="M9 17c-.2 0-.3 0-.5-.1-.3-.2-.5-.5-.5-.9V8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0l7 4c.3.2.5.5.5.9s-.2.7-.5.9l-7 4c-.2.1-.3.1-.5.1zm1-7.3v4.6l4-2.3-4-2.3z"></path>
                          </svg>
                        </th>

                        <th onClick={SearchOngletVB}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            fill="#666"
                            viewBox="0 0 30 30"
                          >
                            <path d="M10.5 17a.506.506 0 00-.344.15L.64 26.652c-.896.893-.776 2.134-.105 2.81.67.674 1.913.795 2.81-.103l9.49-9.49c.492-.472-.25-1.182-.706-.708l-9.49 9.49c-.58.58-1.07.43-1.396.104-.326-.328-.47-.826.102-1.397l9.517-9.503c.326-.318.084-.857-.363-.857zm8.45-14.93a8 8 0 00-4.39 2.063c-.49.453.21 1.17.68.734a6.999 6.999 0 018.022-1.06c.58.332 1.053-.603.465-.885a7.994 7.994 0 00-4.776-.852zM20 0c-5.517 0-10 4.483-10 10s4.483 10 10 10 10-4.483 10-10S25.517 0 20 0zm0 1c4.976 0 9 4.024 9 9s-4.024 9-9 9-9-4.024-9-9 4.024-9 9-9z"></path>
                          </svg>
                        </th>

                        <th>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000"
                            width="20px"
                            data-name="Layer 1"
                            viewBox="0 0 48 48"
                          >
                            <path d="M24 21a10 10 0 1110-10 10 10 0 01-10 10zm0-16a6 6 0 106 6 6 6 0 00-6-6zM42 47H6a2 2 0 01-2-2v-6a16 16 0 0116-16h8a16 16 0 0116 16v6a2 2 0 01-2 2zM8 43h32v-4a12 12 0 00-12-12h-8A12 12 0 008 39z"></path>
                          </svg>
                        </th>
                      </tr>
                    </table>
                  </div>
                  {/* subNavbar */}
                </>
              )}
              {/* Compte */}
            </div>
            {/* head */}

            {/* body (corps) - veilBrillantApp */}
            {/* body (corps) - veilBrillantApp */}
            {/* body (corps) - veilBrillantApp */}
            <div className="body">
              {/* videos body - VB */}
              {/* videos body - VB */}
              {videoOngletVB && (
                <>
                  <div className="videos">
                    {/* Onglet videos - VB */}
                    {/*on affiche les videos dans cette petite api pour que lorsqu'on clique,
                    on puisse obtenir l'url de la video mais on va aussi afficher les autres
                    choses dans cette api car ici nous sommes au niveau de l'onglet video.
                    on affiche les choses dans l'enfant api dans l'objectif d'obtenir les
                    urls lorsqu'on clique */}
                    {idPersonConnectedVB && (<>
                    <div style={{ display: "flex" }}>
                      {filterVideoVB.map((api) => (
                        <>
                          <div onClick={VideoPageVB}>
                            <EnfantApiVideoVB api={api} />
                          </div>
                        </>))}
                    </div>
                    </>)} {/* idPersonConnectedVB se ferme ici */}

                    {!idPersonConnectedVB && (<>
                    <div style={{ display: "flex" }}>
                      {filterVideoVB.map((api) => (
                        <>
                          <div onClick={DisconnectedPersonWantSeeVideoVB}>
                            <EnfantApiVideoVB api={api} />
                          </div>
                        </>))}
                    </div>
                    </>)} {/* idPersonConnectedVB se ferme ici */}

                  </div>
                  {/* videos */}
                </>
              )}
              {/* videos body - VB */} 

              {/* search body - VB */}
              {/* search body - VB */}
              {searchOngletVB && (
                <> {/* ca c'est la barre de recherche */}
                  <div className="search">
                    
                    <div className="block-one">
                      <div className="a"> 
                        {!idPersonConnectedVB && (<><div className="aa"> <input value={mySearchVB} onChange={(e) => setMySearchVB(e.target.value)} type="text" /> </div></>)}
                        {dev && (<><div className="aa"> <input value={mySearchVB} onChange={(e) => setMySearchVB(e.target.value)} type="text" /> </div></>)}
                        {dev && (<><div className="bb"> <SvgSearch /> </div></>)}
                        {!idPersonConnectedVB && (<><div onClick={NonConnecterVB} className="bb"> <SvgSearch3 /> </div> </>)}
                      </div>
                      {/* a */}
                    </div>
                    {/* block-one */}

                    {/* mySearchVB c'est juste pour dire que on affiche rien si l'utilisateur n'a rien entrer dans la barre de recherche */}
                    {mySearchVB && idPersonConnectedVB && (
                    <>
                      {/* accountVB - body */}
                      {/* accountVB - body */}
                      {/* verifyAccountVB c'est pour dire que tu m'affiches ceci seulement s'il y'a des comptes liés à la recherche */}
                      {verifyAccountVB && (
                       <>
                        {/* comptes - resultat de la recherche */}
                        {/* on affiche les comptes trouver */}
                        {accountFindVB.map((api) => (<><div > <ChildApiSearchVB api={api} /> </div></>))}
                       </>
                      )}
                  
                      {/* videoVB - body */}
                      {/* videoVB - body */}
                      {/* verifyVideoVB c'est pour dire que tu m'affiches ceci seulement s'il y'a des videos liés à la recherche */}
                      {verifyVideoVB && (
                       <>
                        {/* videos - resultat de la recherche */}
                        {/* on affiche les videos trouver */}
                        {videoFindVB.map((api) => (<><div > <ChildApiSearchVB api={api} /> </div></>))}
                       </>
                      )}
                      
                      </>
                    )}
                    {/* mySearchVB */}
                    

                  {/* mySearchVB c'est juste pour dire que on affiche rien si l'utilisateur n'a rien entrer dans la barre de recherche */}
                  {mySearchVB && idPersonConnectedVB && (
                    <>
                    {/* accountVB - fin des resultats */}
                    {/* accountVB - fin des resultats */}
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyAccountVB ? (
                      <>
                        <div className="fin-des-resultats"> <p>Fin des résultats</p> </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats"> <p>Aucun résultat trouvé</p> </div>
                      </>
                    )}

                    {/* videoVB - fin des resultats */}        
                    {/* videoVB - fin des resultats */}        
                    {/* a la fin des resultats de chaque recherche on affiche ca: Fin des résultats */}
                    {verifyVideoVB ? (
                      <>
                        <div className="fin-des-resultats"> <p>Fin des résultats</p> </div>
                      </>
                    ) : (
                      <>
                        {/* si on a aucun resultat, on affiche: Aucun résultat trouvé */}
                        <div className="fin-des-resultats"> <p>Aucun résultat trouvé</p> </div>
                      </>
                    )}
                    
                    </>
                   )}
                   {/* mySearchVB */}

                  </div>
                  {/* search */}
                </>
              )}
              {/* search body - VB */}

              {/* compte body - VB */}
              {/* compte body - VB */}
              {compteOngletVB && (<>
              <div className="compte">
                <div className="information">
                  {/* profil de la personne connecter - VB */}
                  {idPersonConnectedVB && (<>MenuVB</>)}
                </div>
                {/* information */}

                    <div className="bottom">
                      <div className="center">
                        {/* connexion, deconnexion */}
                        <div className="block-one">
                          {idPersonConnectedVB && (<> <div onClick={DeconnexionPageVB} className="a"> <SvgLogout2 /> </div> </>)}
                          {!idPersonConnectedVB && (<> <div onClick={ConnexionPageVB} className="a"> <SvgLogout /> </div> </>)}
                        </div>

                        {/* favoris */}
                        <div className="block-two">
                          {idPersonConnectedVB && (<> <div onClick={FavoriteVB} className="a"> <SvgFavoris /> </div> </>)}
                          {!idPersonConnectedVB && (<> <div onClick={NonConnecterVB} className="a"> <SvgFavoris /> </div> </>)}
                        </div>

                        {/* block-two */}
                      </div>
                      {/* center */} 
                    </div>
                    {/* bottom */}
                  </div>
                  {/* compte */}
                </>
              )}
              {/* compte body - VB */}

            </div>
            {/* body */}
          </div>
          {/* veilBrillantApp */}
        </>
      )}
      {/* veil Brillant app */}


      {/* si la personne non connecter clique pour voir une video on va l'afficher ce message */}
      {/* si la personne non connecter clique pour voir une video on va l'afficher ce message */}
      {disconnectedPersonWantSeeVideoVB && (
        <>
          <div onClick={CloseDisconnectedPersonWantSeeVideoVB} className="deconnexionPageVB">
            <div className="align">
              <div className="card">
                <div className="a"> <p>Connectez-vous gratuitement pour voir la vidéo</p> </div>
                <div className="b"> <p onClick={ConnexionPageVB}>Se connecter</p> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* deconnexionPageVB */}
        </>
      )}
      {/* si la personne non connecter clique pour voir une video on va l'afficher ce message */}


      {/* error - VB */}
      {/* error - VB */}
      {/* on affiche cette page s'il y'a une erreur qui s'est produite */}
      {errorVB && (<>
          <div className="deconnexionPageVB">
            <div className="align">
              <div className="card">
                <div className="a"> <p>Une erreur s'est produite, veuillez réessayer plus tard !</p> </div>
                <div className="b"> <p onClick={CloseErrorVB}>D'accord</p> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* deconnexionPageVB */}
        </>)}
      {/* error - VB */}


      {/* videoPage - VB */}
      {/* videoPage (ici on affiche la page qui va permettre a l'utilisateur de voir la video sur laquelle il a cliquer sur la page d'accueil) */}
      {videoPageVB && (<>
        <div className="videoPageVB">
          <div className="close">
              <div className="a" onClick={CloseVideoPageVB}> <SvgLeft /> </div>
              <div className="b"> <SvgVertical /> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video - VB */}
              <video onEnded={LectureVideoTerminer} autoPlay={"autoplay"} muted onClick={ConfigurationVideo} ref={videoRef} src={urlVideoVB} />

              {/* on affiche le nom - VB */}
              {configurationVideo && (<><div className="nameOther"> <button onClick={ProfilOther666VideoPageVB}>{nameOtherVB}</button> </div></>)}

              {/* configurationVideo (bouton de configuration de la video). on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying && (<><div onClick={Play} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying && (<><div onClick={Play} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec} min="0" max={durationSec} default="0" onChange={(e) => { videoRef.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime[0]}:{currentTime[1]} / {duration[0]}:{duration[1]}</p> </div>
                      
                      <div onClick={FullScreen} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}
                      
                      {son && (<><div onClick={VolumeOff} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son && (<><div onClick={VolumeOn} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>
              )}
              {/* le code de configurationVideo se ferme ici (bouton de configuration de la video) - VB */}
            </div>
            {/* videoo */}

            {/* on affiche les videos suggérées - VB */}
            {filterVideoVB.map((api) => (<>
              <div onClick={SeeSuggestedVideoPageVB}>
                <ChildApiSuggestedVideoVB api={api} />
              </div>
            </>))}
          </div>
          {/* videoPageVB */}
        </>)}
      {/* videoPage - VB */}


      {/* seeSuggestedVideoPage - VB */}
      {/* seeSuggestedVideoPage (quand l'utilisateur clique, il va voir la video suggerer sur cette page) */}
      {seeSuggestedVideoPageVB && (<>
        <div className="videoPageVB">
            <div className="close">
              <div className="a" onClick={CloseSeeSuggestedVideoPageVB}> <SvgLeft /> </div>
              <div className="b"> <SvgVertical /> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video - VB */}
              <video onEnded={LectureVideoTerminer2VB} autoPlay={"autoplay"} muted onClick={ConfigurationVideo2VB} ref={videoRef2VB} src={urlSuggestedVideoVB} />

              {/* on affiche le nom - VB */}
              {configurationVideo2VB && (<><div className="nameOther"> <button onClick={ProfilOther666SuggestedVideoPageVB}>{nameOwnerSuggestedVideoVB}</button> </div></>)}

              {/* configurationVideo (bouton de configuration de la video). on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo2VB && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying2VB && (<><div onClick={Play2VB} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying2VB && (<><div onClick={Play2VB} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec2VB} min="0" max={durationSec2VB} default="0" onChange={(e) => { videoRef2VB.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime2VB[0]}:{currentTime2VB[1]} / {duration2VB[0]}:{duration2VB[1]}</p> </div>
                      
                      <div onClick={FullScreen2VB} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}
                      
                      {son2VB && (<><div onClick={VolumeOff2VB} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son2VB && (<><div onClick={VolumeOn2VB} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>)}
              {/* le code de configurationVideo se ferme ici (bouton de configuration de la video) - VB */}
            </div>
            {/* videoo */}

            {/* on affiche les videos suggérées - VB */}
            {filterVideoVB.map((api) => (<>
              <div onClick={SeeSuggestedVideoVB}>
                <ChildApiSuggestedVideoVB api={api} />
              </div>
            </>))}
          </div>
          {/* videoPageVB */}
        </>)}
      {/* seeSuggestedVideoPage - VB */}


      {/* ProfilOther (666VideoPageVB) */}
      {/* ProfilOther (666VideoPageVB) */}
      {profilOther666VideoPageVB && (<>
          <div className="profilOthersVB">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseProfilOther666VideoPageVB} className="b"> <SvgBottom5 /> </div>
            </div>
            {/* close */}

            <div className="photo-et-nom">
              <div className="photo"> <img onClick={SeePhoto666ProfilOther666VideoPageVB} src={photoOtherVB} alt="" /> </div>

              <div className="nom">
                <div className="a"> <p>{nameOtherVB}</p> </div>
                <div className="b"> <p>Artiste Rappeur</p> </div>
                <div className="c"> <p>5 personnes</p> </div>
                <div className="c"> <p>3 Vidéos</p> </div>
              </div>
            </div>
            {/* photo-et-nom */}

            <div className="hr"> <hr /> </div>
            <div className="align-desc">
              <div className="desc"> <p>Samedi rendez-vous sur mon OT pour un direct</p> </div>
            </div>
            {/* align-desc */}

            <div className="align-bigCard">
              <div className="bigCard">
                <div className="titre"> <SvgVideo10 /><p>Dernière vidéo publiée</p> </div>

                <div className="card">
                  <div className="a"> <img onClick={LastVideo1666Profil1666homeVB} src={tictac} alt="" /> </div>
                  <div className="b"> <p onClick={LastVideo1666Profil1666homeVB}>Black M - Tic Tac (Titre derniere video publier)</p> </div>
                </div>
              </div>
            </div>
            {/* align-bigCard */}

            <div className="block">
              <div onClick={VoirToutesLesVideos} className="a"> <p>Toutes les vidéos</p> </div>
              <div onClick={VoirToutesLesVideos} className="b"> <SvgRight5 /> </div>
            </div>
            {/* block */}
          </div>
          {/* profilOthersVB */}
        </>)}
      {/* ProfilOther (666VideoPageVB) */}


      {/* ProfilOther (666SuggestedVideoPageVB) */}
      {/* ProfilOther (666SuggestedVideoPageVB) */}
      {profilOther666SuggestedVideoPageVB && (<>
          <div className="profilOthersVB">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseProfilOther666SuggestedVideoPageVB} className="b"> <SvgBottom5 /> </div>
            </div>
            {/* close */}

            <div className="photo-et-nom">
              <div className="photo"> <img onClick={SeePhoto666ProfilOther666SuggestedVideoPageVB} src={photoOwnerSuggestedVideoVB} alt="" /> </div>

              <div className="nom">
                <div className="a"> <p>{nameOwnerSuggestedVideoVB}</p> </div>
                <div className="b"> <p>Artiste Rappeur</p> </div>
                <div className="c"> <p>5 personnes</p> </div>
                <div className="c"> <p>3 Vidéos</p> </div>
              </div>
            </div>
            {/* photo-et-nom */}

            <div className="hr"> <hr /> </div>
            <div className="align-desc">
              <div className="desc"> <p>Samedi rendez-vous sur mon OT pour un direct</p> </div>
            </div>
            {/* align-desc */}

            <div className="align-bigCard">
              <div className="bigCard">
                <div className="titre"> <SvgVideo10 /><p>Dernière vidéo publiée</p> </div>

                <div className="card">
                  <div className="a"> <img onClick={LastVideo1666Profil1666homeVB} src={tictac} alt="" /> </div>
                  <div className="b"> <p onClick={LastVideo1666Profil1666homeVB}>Black M - Tic Tac (Titre derniere video publier)</p> </div>
                </div>
              </div>
            </div>
            {/* align-bigCard */}

            <div className="block">
              <div className="a"> <p onClick={VoirToutesLesVideos}>Toutes les vidéos</p> </div>
              <div onClick={VoirToutesLesVideos} className="b"> <SvgRight5 /> </div>
            </div>
            {/* block */}
          </div>
          {/* profilOtherVB */}
        </>)}
      {/* ProfilOther (666SuggestedVideoPageVB) */}


      {/* seePhoto (666ProfilOther 666VideoPageVB) */}
      {/* seePhoto (666ProfilOther 666VideoPageVB). l'utilisateur clique pour voir la photo de profil */}
      {seePhoto666ProfilOther666VideoPageVB && (<>
          <div className="seePhotoPageVB">
            <div className="close">
              <div className="a"> </div>
              <div className="b" onClick={CloseSeePhoto666ProfilOther666VideoPageVB}> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={photoOwnerVideoVB} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhotoPageVB */}
        </>)}
      {/* seePhoto (666ProfilOther 666VideoPageVB) */}


      {/* seePhoto (666ProfilOther 666SuggestedVideoPageVB) */}
      {/* seePhoto (666ProfilOther 666SuggestedVideoPageVB). l'utilisateur clique pour voir la photo de profil */}
      {seePhoto666ProfilOther666SuggestedVideoPageVB && (<>
          <div className="seePhotoPageVB">
            <div className="close">
              <div className="a"> </div>
              <div className="b" onClick={CloseSeePhoto666ProfilOther666SuggestedVideoPageVB}> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={photoOwnerSuggestedVideoVB} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhotoPageVB */}
        </>)}
      {/* seePhoto (666ProfilOther 666SuggestedVideoPageVB) */}


      {/* voirToutesLesVideos - VB */}
      {/* voirToutesLesVideos - VB */}
      {/* on affiche toutes Les Videos de la personne */}
      {voirToutesLesVideos && (<>
          <div className="allVideosUserPageVB">
            <div className="close">
              <div className="block-un">
                <div className="a" onClick={CloseVoirToutesLesVideos}> <SvgLeft2 /> </div>
                <div className="b"> <p>{nameOtherVB} - 3 Vidéos</p> </div>
              </div>

              <div className="block-deux"> <p></p> </div>
            </div>
            {/* close */}

            <div className="cover"> <img src="https://play-lh.googleusercontent.com/lMU8pPZtGyHq60jWnWz5etzV1jO_BZTN04p0ETcQc1d6gKijHUsWCBs7f9fkV9Q2DzM=w3840-h2160-rw" alt=""/> </div>

            <div className="hr"> <hr /> </div>
            <div className="videos">
              {filterVideoOwnerVB.map((api) => (<>
                <div onClick={SeeVideo2666AllVideosUser1666homeVB}>
                  <ChildApiAllVideos1666Profil1666homeVB api={api} />
                </div>
              </>))}
            </div>
            {/* videos */}
          </div>
          {/* allVideosUserPageVB */}
        </>)}
      {/* voirToutesLesVideos - VB */}


      {/* SeeVideo2 (666AllVideosUser1 666homeVB) */}
      {/* SeeVideo2 (666AllVideosUser1 666homeVB) ici on affiche la page qui va permettre a l'utilisateur de voir la video sur laquelle il a cliquer*/}
      {seeVideo2666AllVideosUser1666homeVB && (<>
          <div className="seeVideoUserVB">
            <div className="close">
              <div className="a">
                <div className="aa" onClick={CloseSeeVideo2666AllVideosUser1666homeVB}> <SvgLeft /> </div>
                <div className="bb"> <p>{nameOtherVB}</p> </div>
              </div>

              <div className="b"> <SvgVertical /> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video - VB */}
              <video onEnded={LectureVideoTerminer3} autoPlay={"autoplay"} muted onClick={ConfigurationVideo3} ref={videoRef3} src={urlVideo3VB} />

              {/* configurationVideo (bouton de configuration de la video). on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo3 && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying3 && (<><div onClick={Play3} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying3 && (<><div onClick={Play3} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec3} min="0" max={durationSec3} default="0" onChange={(e) => { videoRef3.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime3[0]}:{currentTime3[1]} / {duration3[0]}:{duration3[1]}</p> </div>
                      
                      <div onClick={FullScreen3} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}

                      {son3 && (<><div onClick={VolumeOff3} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son3 && (<><div onClick={VolumeOn3} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>
              )}
              {/* le code de configurationVideo se ferme ici (bouton de configuration de la video) - VB */}
            </div>
            {/* videoo */}

            {/* on affiche les videos suggérées - VB */}
            {filterVideoVB.map((api) => (<>
            <div onClick={SeeSuggestedVideo2666SeeVideo2666homeVB}>
              <ChildApiSuggestedVideo2666SeeVideo2666homeVB api={api} />
            </div>
            </>))}
          </div>
          {/* seeVideoUserVB */}
        </>)}
      {/* SeeVideo2 (666AllVideosUser1 666homeVB) */}


      {/* lastVideo1 (666Profil1 666homeVB) */}
      {/* lastVideo1 (666Profil1 666homeVB). l'utilisateur clique pour voir la derrniere video publier */}
      {lastVideo1666Profil1666homeVB && ( <>
          <div className="seeLastVideoVB">
            <div onClick={CloseLastVideo1666Profil1666homeVB} className="close">
              <div className="a"> <p>{nameOtherVB}</p> </div>
              <div className="b"> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video - VB */}
              <video onEnded={LectureVideoTerminer4} autoPlay={"autoplay"} muted onClick={ConfigurationVideo4} ref={videoRef4} src={urlLastVideoVB} />

              {/* configurationVideo (bouton de configuration de la video). on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo4 && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying4 && (<><div onClick={Play4} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying4 && (<><div onClick={Play4} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec4} min="0" max={durationSec4} default="0" onChange={(e) => { videoRef4.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime4[0]}:{currentTime4[1]} / {duration4[0]}:{duration4[1]}</p> </div>

                      <div onClick={FullScreen4} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}

                      {son4 && (<><div onClick={VolumeOff4} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son4 && (<><div onClick={VolumeOn4} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>
              )}
              {/* le code de configurationVideo se ferme ici (bouton de configuration de la video) - VB */}
            </div>
            {/* videoo */}

            {/* il pourra cliquer pour aller sur la page qui contient toute les videos de l'autre - VB */}
            <div onClick={SeeVideo2666AllVideosUser1666homeVB} className="GoToAllVideos"> <SvgRight5 /><p>Voir toutes les vidéos de {nameOtherVB}</p> </div>
            {/* GoToAllVideos */}
          </div>
          {/* seeLastVideoVB */}
        </>)}
      {/* lastVideo1 (666profil1 666homeVB) */}


      {/* favoris (page) - VB */}
      {/* favoris (page) - VB */}
      {favoriteVB && (<>
          <div className="favoriteAA">
            <div className="close"> 
              <div className="a"> 
                <div onClick={CloseFavoriteVB} className="aa"> <SvgLeft /> </div>
                <div className="bb"> <p>Favoris</p> </div>
              </div>
              {/* a */}

              <div className="b">
                <div onClick={AddPhotoToFavoritePageVB} className="aa"> <SvgAdd5 /> </div>
                <div onClick={AddCoverVideoPageVB} className="aa"> <SvgVideo8 /> </div>
                <div onClick={Infos666favoriteVB} className="aa"> <SvgInfos /> </div>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="align">
              <div className="infos"> <p>Vidéos</p> </div>
              {/* infos */}

              <div className="display-videos">
                {apiFavoriteVB.map((api) => (
                <div onClick={PageRedirection666ChildApiVideo666favoriteVB}>
                  <ChildApiVideo666favoriteVB api={api} />
                </div>
                ))}
              </div>
              {/* display-videos */} 
            </div>
            {/* align */}
          </div>
          {/* favoriteAA */}
        </>)}
      {/* favoris (page) - VB */}

      {/* infos666favoriteVB (on passe une petite infos) */}
      {/* infos666favoriteVB (on passe une petite infos) */}
      {infos666favoriteVB && (<>
      <div onClick={CloseInfos666favoriteVB} className="infosLanguage">
        <div className="align">
          <div className="card"> <p>Ajouter vos vidéos à vos favoris pour les pubiées à n'importe quelle moment</p> </div>
        </div>
        {/* align */}
      </div>
      {/* infosLanguage */}
      </>)}
      {/* infos666favoriteVB (on passe une petite infos) */}


      {/* seeVideo (666 favoriteVB) */}
      {/* seeVideo (666 favoriteVB) */}
      {/* page pour voir la video sur laquelle j'ai cliqué (au niveau des favoris il clique sur une video) */}
      {seeVideo666favoriteVB && (<>
          <div className="videoPageVB">
            <div className="close">
              <div onClick={CloseSeeVideo666favoriteVB} className="aa"> <SvgLeft /> </div>
              <div onClick={PopupToRightVB} className="bb"> <SvgVertical /> </div>
            </div>
            {/* close */}

            <div className="videoo">
              {/* on affiche la video */}
              <video onEnded={LectureVideoTerminer} autoPlay={"autoplay"} muted onClick={ConfigurationVideo} ref={videoRef} src={urlVideoAA} />

              {/* configurationVideo (bouton de configuration de la video). on a mis la partie configurationVideo pour masquer/afficher les boutons de la video lorsque la video est en plein lecture */}
              {configurationVideo && (<>
                  <div className="align-configuration">
                    <div className="configuration">
                      {isPlaying && (<><div onClick={Play} className="a"> <SvgPause2 /> </div></>)} {/* mettre pause */}
                      {!isPlaying && (<><div onClick={Play} className="a"> <SvgPlay2 /> </div></>)} {/* mettre play */}

                      <div className="b"> <input type="range" value={currentTimeSec} min="0" max={durationSec} default="0" onChange={(e) => { videoRef.current.currentTime = e.target.value }} /> </div>

                      {/* duree de la video */}
                      <div className="c"> <p>{currentTime[0]}:{currentTime[1]} / {duration[0]}:{duration[1]}</p> </div>
                      
                      <div onClick={FullScreen} className="d"> <SvgFullScreen2 /> </div> {/* plein ecran */}
                      
                      {son && (<><div onClick={VolumeOff} className="e"> <SvgVolumeOn2 /> </div></>)} {/* jouer le son */}
                      {!son && (<><div onClick={VolumeOn} className="e"> <SvgVolumeOff2 /> </div></>)} {/* couper le son */}
                    </div>
                    {/* configuration */}
                  </div>
                  {/* align-configuration */}
                </>)} {/* le code de configurationVideo se ferme ici */}
            </div>
            {/* videoo */}
          </div>
          {/* videoPageVB */}
        </>)}
      {/* seeVideo666favoriteVB */} 

      {/* Popup To Right - VB */}
      {/* apres avoir cliquer sur une photo 666 favoris, dans la page qui va s'afficher il y'aura une PopupToRight */}
      {popupToRightVB && (<>
          <div onClick={ClosePopupToRightVB} className="popupToRightIA-opacity">
            <div className="block-un">
              <div onClick={PostVideoPageVB} className="icon"> <p>Publier cette vidéo</p> </div>
              {/*<div onClick={PostPhotoPageVB} className="icon"> <p>Publier cette photo</p> </div>*/}
              <div onClick={PhotoProfile666favoriteVB} className="icon-b"> <p>Mettre cette photo comme photo de profil</p> </div>
              {/* icon-b */}
            </div>
            {/* block-un */}
          </div>
          {/* popupToRightIA-opacity */}
        </>
      )}
      {/* Popup To Right - VB */}


      {/* seePhoto (666 favoriteVB) */}
      {/* seePhoto (666 favoriteVB) */}
      {/* page pour voir la photo sur laquelle j'ai cliqué au niveau des favoris */}
      {seePhoto666favoriteVB && (<>
          <div className="seePhoto666favoriteAA">
            <div className="close">
              <div onClick={CloseSeePhoto666favoriteVB} className="aa"> <SvgLeft /> </div>
              <div className="bb"></div>
            </div>
            {/* close */}

            <div className="block-one"> <img onClick={SeePhotoVB} src={urlPhotoVB} alt="" /> </div>
            {/* block-one */}

            <div className="block-two">
              {/*<button onClick={PostPhotoPageVB}>Publier cette photo</button>*/}
              <button onClick={PhotoProfile666favoriteVB}>Mettre cette photo comme photo de profil</button>
              <button onClick={AddVideoToPhotoPageVB}>Ajouter une vidéo à cette photo</button>
            </div>
            {/* block-two */} 
          </div>
          {/* videoPageVB */}
        </>)}
      {/* seePhoto (666 favoriteVB) */} 


      {/* seePhoto (page) - VB */}
      {/* seePhoto (page) - VB */}
      {/* on affiche une photo */}
      {seePhotoVB && (<>
        <div className="seePhotoPageAA">
          <div className="close">
            <div onClick={CloseSeePhotoVB} className="a"> <SvgLeft2 /> </div>
            <div className="b"> <p></p> </div>
          </div>
          {/* close */}

          <div className="card"> <img src={urlPhotoVB} alt="" /> </div>
          {/* card */}
        </div>
        {/* seePhotoPageAA */}
      </>)}
    {/* seePhoto (page) - VB */}

      {/* seePhotoVBreq (lors des requetes, on affiche la photo sur laquelle on a cliquer) */}
      {/* seePhotoVBreq (lors des requetes, on affiche la photo sur laquelle on a cliquer) */}
      {seePhotoVBreq && (<>
      <div className="seePhoto2AA">
          <div className="close">
            <div className="a"> </div>
            <div onClick={CloseSeePhotoVBreq} className="b"> <SvgClose2 /> </div>
          </div>
            {/* close */}

          <div className="card"> <img src={urlPhotoVBreq} alt="" /> </div>
          {/* card */}
        </div>
        {/* seePhoto2AA */}
      </>)}
      {/* seePhotoVBreq (lors des requetes, on affiche la photo sur laquelle on a cliquer) */}


      {/* page pour choisir la video a ajouter a une photo - VB  */}
      {/* page pour choisir la video a ajouter a une photo - VB  */}
      {addVideoToPhotoPageVB && (<>
          <div className="publier-video-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseAddVideoToPhotoPageVB} className="block">
                  <div className="a"> <SvgVideo9 /> </div>
                  <div className="b"> <p>Choisir la vidéo à Ajouter à cette photo</p> </div>
                </div>
                {/* block */}

                <div className="block-deux"> <input onChange={(e) => setFileVideoVB(e.target.files[0])} id="file" type="file" name="video" accept=".mp4" /> </div>
                {/* block-deux */}

                {isLoadingVideo666favoriteVB ? (<div style={{ align: "center", padding: "3px" }}> <p>Votre vidéo sera ajoutée à cette photo... Vous pouvez continuer à naviguer sur Alrani ou dans d'autres applications de votre Téléphone virtuel mais! Ne Recharger pas la page. Vous verez votre vidéo lorsqu'elle sera ajoutée à cette photo</p> </div>
                ):(<><div className="block-trois"> <button onClick={AddVideoVB}>Continuer</button> </div></>)}

                <div className="block-quatre"> <p>Max: 100MB</p> </div> 
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* publier-video-opacity */}
        </>)}
        {/* page pour choisir la video a ajouter a une photo - VB  */}


      {/* PhotoProfileVB (au niveau des favoris, selectionner une photo a mettre sur le profil) - VB */}
      {/* PhotoProfileVB (au niveau des favoris, selectionner une photo a mettre sur le profil) - VB */}
      {photoProfile666favoriteVB && (<>
      <div className="photoProfileAA">
        <div className="close">
          <div className="a"> <div onClick={ClosePhotoProfile666favoriteVB} className="aa"><SvgLeft /></div> </div>
          <div className="b"> <img onClick={SeePhotoWithNamePersonConnectedVB} src={photoPersonConnectedVB} alt="" /> </div>
        </div>
        {/* close */}

        <div className="block-one">
          <img onClick={SeePhotoVBreq} src={urlPhotoVBreq} alt="" />

          {isLoadingPhotoProfileVB ? (<> <Loader /> </>
          ):(<> <button onClick={PhotoProfileVB666favoriteVB}>Mettre sur le profil</button> </>)}
        </div>
        {/* block-one */}
      </div>
      {/* PhotoProfileAA */} 
      </>
      )}
      {/* PhotoProfileVB (au niveau des favoris, selectionner une photo a mettre sur le profil) - VB */}


      {/* voir photo + nom de la personne connecté - VB */}
      {/* voir photo + nom de la personne connecté - VB */}
      {seePhotoWithNamePersonConnectedVB && (<>
          <div onClick={CloseSeePhotoWithNamePersonConnectedVB} className="seePhotoWithNameAA">
            <div className="block-two">
              <div className="a">
                <div className="aa"> <img src={photoPersonConnectedVB} alt="" /> </div>
                <div className="bb"> <p>{namePersonConnectedVB}</p> </div>
              </div>
              {/* a */}

              <div className="b"> </div>
              {/* b */}
            </div>
            {/* block-two */}
          </div>
          {/* seePhotoWithNameAA */}
        </>
      )}
      {/* voir photo + nom de la personne connecté - VB */}


      {/* seePhoto2 (page pour voir la photo de la personne connecté) */}
      {/* seePhoto2 (page pour voir la photo de la personne connecté) */}
      {seePhoto2personConnectedVB && (<>
          <div className="seePhoto2AA">
            <div className="close">
              <div className="a"> </div>
              <div onClick={CloseSeePhoto2personConnectedVB} className="b"> <SvgClose2 /> </div>
            </div>
            {/* close */}

            <div className="card"> <img src={photoPersonConnectedVB} alt="" /> </div>
            {/* card */}
          </div>
          {/* seePhoto2AA */}
        </>)}
        {/* seePhoto2 (page pour voir la photo de la personne connecté) */}

      {/* ajouter une photo aux favoris - VB */}
      {/* ajouter une photo aux favoris - VB */}
      {addPhotoToFavoritePageVB && (<> 
      <div className="page-general-opacity"> 
        <div className="align"> 
          <div className="card"> 
            <div onClick={CloseAddPhotoToFavoritePageVB} className="center"> <Svg3Photo3 /> </div>
            <div onClick={CloseAddPhotoToFavoritePageVB} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px", textAlign: "center" }}>Ajouter une photo à vos Favoris</p> </div>

            <div className="capture-decran-du-contact">
              <div className="display"> <input onChange={(e) => setFilePhotoVB(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            </div>

            <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

            {isLoading ? (<><div className="loader-display-flex"> <Loader /> </div></>
            ):(<><div className="orange-btn"> <button onClick={AddPhotoToFavoriteVB}>Continuer</button> </div></>)}
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* page-general-opacity */}
    </>)}
    {/* ajouter une photo aux favoris - VB */}


      {/* success AddPhotoToFavorite - VB */}
      {/* success AddPhotoToFavorite - VB */}
      {/* message de succes (on affiche ce message de succes s'il a reussi a ajouter une photo aux favoris) */}
      {successAddPhotoToFavoriteVB && (<>
          <div onClick={CloseSuccessAddPhotoToFavoriteVB} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Photo ajoutée</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* success AddPhotoToFavorite - VB */}


      {/* page pour ajouter la photo de couverture de la video - VB */}
      {/* page pour ajouter la photo de couverture de la video - VB */}
      {addCoverVideoPageVB && (<>
      <div className="page-general-opacity"> 
        <div className="align">
          <div className="card">
            <div onClick={CloseAddCoverVideoPageVB} className="center"> <SvgOneImage3 /> </div>
            <div onClick={CloseAddCoverVideoPageVB} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px", textAlign: "center" }}>Photo de couverture de la Vidéo</p> </div>

            <div className="capture-decran-du-contact">
              <div className="display"> <input onChange={(e) => setFilePhotoVB(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
            </div>

            <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

            {isLoadingCoverVideo666favoriteVB ? (<><div className="loader-display-flex"> <Loader /> </div></>
            ):(<><div className="vert-btn"> <button onClick={AddCoverVideoVB}>Continuer</button> </div></>)}
          </div>
          {/* card */} 
        </div>
        {/* align */} 
      </div>
      {/* page-general-opacity */}
    </>)}
    {/* page pour ajouter la photo de couverture de la video - VB  */}

 
      {/* page pour choisir la video a publier - VB  */}
      {/* page pour choisir la video a publier - VB  */}
      {addVideoPageVB && (<>
          <div className="publier-video-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseAddVideoPageVB} className="block">
                  <div className="a"> <SvgVideo9 /> </div>
                  <div className="b"> <p>Choisir la vidéo à Publier</p> </div>
                </div>
                {/* block */}

                <div className="block-deux"> <input onChange={(e) => setFileVideoVB(e.target.files[0])} id="file" type="file" name="video" accept=".mp4" /> </div>
                {/* block-deux */}

                {isLoadingVideo666favoriteVB ? (<div style={{ align: "center", padding: "3px" }}> <p>Votre vidéo sera ajoutée aux favoris... Vous pouvez continuer à naviguer sur Alrani ou dans d'autres applications de votre Téléphone virtuel mais! Ne Recharger pas la page. Vous verez votre vidéo lorsqu'elle sera ajoutée à vos favoris</p> </div>
                ):(<><div className="block-trois"> <button onClick={AddVideoVB}>Continuer</button> </div></>)}

                <div className="block-quatre"> <p>Max: 100MB</p> </div> 
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* publier-video-opacity */}
        </>)}
      {/* page pour choisir la video a publier - VB  */}


      {/* page pour publié la video - VB */}
      {/* page pour publié la video - VB */}
      {postVideoPageVB && (<>
      <div className="postVideoPageAA">
      <p style={{ paddingTop: "40px" }}></p>

      <div onClick={ClosePostVideoPageVB} className="publier-publication">
        <div className="center"> <Svg3Photo3 /> </div>
        <div> <p style={{fontSize: "17px", paddingTop: "5px", textAlign: "center" }}>Publier une Vidéo..</p> </div>
        <div className="hr"> <hr /> </div>
      </div>
      {/* publier-publication */}

      <div className="post">
        <div className="block-one">
          <img onClick={SeePhotoProfil666ProfilVB} src={photoPersonConnectedVB} alt="" />
          <p>{namePersonConnectedVB}</p>
        </div>

        <div className="block-two"> <pre>{descriptionVB}</pre> </div>
      </div>
      {/* post */}

      <div className="block-one"> <video autoPlay={"autoplay"} muted loop controls><source src={urlVideoVB} type="video/mp4" /></video> </div>
      {/* block-one */}

      <div className="block-two">
        <div className="a"> <p>Photo de couverture de la vidéo</p> </div>
        <div className="b"> <img onClick={SeePhotoVBreq} src={urlPhotoVBreq} alt="" /> </div>
      </div>
      {/* block-two */}

      {isLoading666postVideoPageVB ? (<div className="loader-display-flex"> <Loader /> </div>
      ):(<><div className="vert-btn"> <button onClick={PostVideoVB}>Publier maintenant</button> </div></>)}

      <p style={{ paddingBottom: "100px" }}></p>

      {!isLoading666postVideoPageVB && (<>
        <div className="write">
          <div className="a"> <textarea type="text" placeholder="Titre de la vidéo.." value={descriptionVB} onChange={(e) => setDescriptionVB(e.target.value)}></textarea> </div>
        </div>
        {/* write */}
      </>)}
    </div>
    {/* postVideoPageAA */}
  </>)}
  {/* page pour publié la video - VB */}


      {/* voir photo profil (666 ProfilVB) */}
      {/* voir photo profil (666 ProfilVB) */}
      {/* on affiche la photo de profil */}
      {seePhotoProfil666ProfilVB && (<>
          <div onClick={CloseSeePhotoProfil666ProfilVB} className="popup-image-opacity">
            <div className="align">
              <div className="image"> <img src={photoPersonConnectedVB} alt=""/> </div>
            </div>
            {/* align */}
          </div>
          {/* popup-image-opacity */}
        </>)}
        {/* voir photo profil (666 ProfilVB) */}


      {/* choisir la photo a mettre sur le profil (page) - VB */}
      {/* choisir la photo a mettre sur le profil (page) - VB */}
      {choosePhotoProfilePageVB && (<>
          <div className="page-general-opacity">
            <div className="align">
              <div className="card">
                <div onClick={CloseChoosePhotoProfilePageVB} className="center"> <SvgCamera3 /> </div>
                <div onClick={CloseChoosePhotoProfilePageVB} className="center"> <p style={{ fontSize: "17px", paddingBottom: "16px", paddingTop: "5px" }}>Photo de Profil</p> </div>

                <div className="capture-decran-du-contact">
                  <div className="display">
                    <div style={{ paddingRight: "5px" }} className="aa"> <SvgImage /> </div>
                    <div className="bb"> <input onChange={(e) => setFileVB(e.target.files[0])} id="file" type="file" name="image" accept=".jpg, .jpeg, .png" /> </div>
                    <div onClick={InfosMettrePhotoProfilVB} style={{ paddingLeft: "10px" }} className="cc"> <SvgInfos4 /> </div>
                  </div>
                  {/* display */}
                </div>
                {/* capture-decran-du-contact */}
                <div style={{ paddingTop: "10px" }} className="hr"> <hr /> </div>

                {isLoadingPhotoProfileVB ? (<div className="loader-display-flex"> <Loader /> </div>
                ):(<><div className="vert-btn"> <button onClick={PhotoProfileVB}>Continuer</button> </div></>)}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* add-your-contact-opacity */}
        </>)}
        {/* choisir la photo a mettre sur le profil (page) - VB */}


      {/* infos: mettre photo profil - VB */}
      {/* infos: mettre photo profil - VB */}
      {infosMettrePhotoProfilVB && (<>
          <div onClick={CloseInfosMettrePhotoProfilVB} className="popup-infos-capture-decran-opacity">
            <div className="align">
              <div className="card"> <p>Choisir la photo à mettre sur le profil</p> </div>
            </div>
            {/* align */}
          </div>
          {/* popup-infos-capture-decran-opacity */}
        </>)}
        {/* infos: mettre photo profil - VB */}

      
      {/* photo de profil ajoutée (message de success) - VB */}
      {/* photo de profil ajoutée (message de success) - VB */}
      {photoProfileSuccessVB && (<>
          <div onClick={ClosePhotoProfileSuccessVB} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Photo mis sur le profil</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* photo de profil ajoutée (message de success) - VB */}


      {/* ici cest pour choisir parmi les options du miniMenu - VB */}
      {miniMenu && (<>
          <div onClick={CloseMiniMenu} className="miniMenuVB">
            <div className="align">
              <div className="card">
                <p onClick={Titre}>Titre</p>
                <p onClick={Photo}>Photo de couverture</p>
                {dev && (<>
                <p onClick={VideoNonVisible}>Visibilité</p>
                <p style={{ color: "#00cc00" }} onClick={VideoVisible}>Visibilité</p>
                <p style={{ color: "#00cc00" }} onClick={UpdateInfosVideoVB}>Actualiser infos</p>
                </>)}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* miniMenuVB */}
        </>)}

      {/* ici cest pour mettre le titre de la video - VB */}
      {titre && (<>
          <div className="titleVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <div className="a"> </div>
                  <div onClick={CloseTitre} className="b"> <SvgDash3 /> </div>
                </div>
                {/* block-un */}
              
                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="a">
                    <p>Saisir le Titre de la vidéo puis cliquer sur Valider</p>
                    <textarea value={titleVideoVB} onChange={(e) => setTitleVideoVB(e.target.value)}></textarea>
                  </div>

                  <div className="a">
                    <p>Durée de la vidéo</p>
                    <textarea value={durationVideoVB} onChange={(e) => setDurationVideoVB(e.target.value)} placeholder="Durée.."></textarea>
                  </div>

                  <div className="b"> <p onClick={SaveTitleVideoVB}>Valider</p> </div>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* titleVB */}
        </>)}
        
      {/*on affice ca si la vidéo nest pas visible au public - VB */}
      {videoNonVisible && (<>
          <div className="videoNonVisibleVB">
            <div className="align" onClick={AddCoverVideoVB}>
              <div className="card" onClick={ClosePhoto}>
                <div className="block-un">
                  <div className="a"> </div>
                  <div onClick={CloseVideoNonVisible} className="b"> <SvgDash3 /> </div>
                </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="a"> <p>Visibilité</p> </div>
                  <div className="b"> <p>Votre vidéo nest pas encore visible au public, en cliquant sur *Rendre visible* elle sera visible au public</p> </div>
                  <div className="c"> <p>Rendre visible</p> </div>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* videoNonVisibleVB */}
        </>)}

      {/*on affice ca si la vidéo est visible au public - VB */}
      {videoVisible && (<>
          <div className="videoVisibleVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <div className="a"> </div>
                  <div onClick={CloseVideoVisible} className="b"> <SvgDash3 /> </div>
                </div>
                {/* block-un */}

                <div className="block-deux"> <hr /> </div>
                {/* block-deux */}

                <div className="block-trois">
                  <div className="a"> <p>Visibilité</p> </div>
                  <div className="b"> <p>Votre vidéo est actuellement visible au public, en cliquant sur *Visible uniquement par moi* votre video ne sera plus visible au public </p> </div>
                  <div className="c">
                    <button>
                      <p>Visible uniquement par moi</p>
                      <hr />
                    </button>
                  </div>
                  {/* c */}
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* videoVisibleVB */}
        </>)}
      

      {/* menu - VB */}
      {/* menu - VB */}
      {/*on affiche le card qui contient le menu */}
      {menuVB && (<>
          <div onClick={CloseMenuVB} className="menuVB">
            <div className="align">
              <div className="card">
                {dev && (<>
                <div className="a">
                  <p onClick={MenuModificationsVB}>Actions</p>
                  <svg
                    onClick={MenuModificationsVB}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="10px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div>

                <div className="a">
                  <p>Notifications</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="10px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div></>)}

                <div className="a">
                  <p onClick={BusinessPageVB}>Business</p>
                  <svg
                    onClick={BusinessPageVB}
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="10px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div>

                {dev && (<>
                <div onClick={ToolsVB} className="a">
                  <p>Outils</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="10px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div>

                <div onClick={PlusVB} className="a">
                  <p>Plus</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    width="10px"
                    cursor="pointer"
                    fill="#000"
                    enableBackground="new 0 0 477.175 477.175"
                    version="1.1"
                    viewBox="0 0 477.175 477.175"
                    xmlSpace="preserve"
                  >
                    <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                  </svg>
                </div></>)}
                {/* a */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* menuVB */}
        </>
      )}
      {/* menu - VB */}

      {/* Tools -  VB */}
      {/* Tools -  VB */}
      {/* on affiche mes outils */}
      {toolsVB && (
        <>
          <div className="menuIAC">
            <div className="close">
              <svg
                onClick={CloseToolsVB}
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="20px"
                cursor="pointer"
                fill="#000"
                enableBackground="new 0 0 486.975 486.975"
                version="1.1"
                viewBox="0 0 486.975 486.975"
                xmlSpace="preserve"
              >
                <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
              </svg>
              <p>Outils</p>
            </div>
            {/* close */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="block-un">
              <p>Outils</p>
            </div>
            {/* block-un */}

            <div onClick={MonetizationVB} className="block-deux">
              <p>Monetization</p>
              <hr />
            </div>

            <div onClick={MonetizationDealsVB} className="block-deux">
              <p>Monetization Deals</p>
              <hr />
            </div>

            <div onClick={MonetizationFormationVB} className="block-deux">
              <p>Monetization Formation</p>
              <hr />
            </div>
            {/* block-deux */}
          </div>
          {/* menuIAC */}
        </>
      )}
      {/* Tools - VB */}

      {/* Plus - VB */}
      {/* Plus - VB */}
      {/* sur cette page on affiche les outils a activer */}
      {plusVB && (
        <>
          <div className="alraniPlusAA">
            <div className="close">
              <div className="a">
                <div onClick={ClosePlusVB} className="aa">
                  <SvgLeft />
                </div>
                {/* aa */}

                <div className="bb">
                  <p>Veil Brillant Plus</p>
                </div>
                {/* bb */}
              </div>
              {/* a */}
            </div>
            {/* close */}

            {/* VB Monetization */}
            <div onClick={ActivateMonetizationPageVB} className="language">
              <div className="block-deux">
                <div className="a">
                  <div className="aa">
                    <p>VB Monetization</p>
                  </div>
                  {/* aa */}

                  <div className="bb">
                    <p>Activer la monétisation pour être rémunérer sur chaque clic sur votre vidéo, chaque fois qu'une personne cliquera pour accéder à votre chaine, elle payera 1 FCFA à chaque clic</p>
                    <p>La monétisation est activé, vous êtes rémunéré sur chaque clic sur votre vidéo, chaque fois qu'une personne cliquera pour accéder à votre chaine, elle payera 1 FCFA à chaque clic</p>
                  </div>
                  {/* bb */}
                </div>
                {/* a */}
              </div>
              {/* block-deux */}
            </div>
            {/* language */}

            {/* Monetization Deals */}
            <div onClick={ActivateMonetizationDealsPageVB} className="language">
              <div className="block-deux">
                <div className="a">
                  <div className="aa">
                    <p>Monetization Deals</p>
                  </div>
                  {/* aa */}

                  <div className="bb">
                    <p>Celui qui veut activer la monétisation sur sa chaine utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lorsqu'il réactivera</p>
                  </div>
                  {/* bb */}
                </div>
                {/* a */}
              </div>
              {/* block-deux */}
            </div>
            {/* language */}

            {/* Monetization Formation */}
            <div onClick={ActivateMonetizationFormationPageVB} className="language">
              <div className="block-deux">
                <div className="a">
                  <div className="aa">
                    <p>Monetization Formation</p>
                  </div>
                  {/* aa */}

                  <div className="bb">
                    <p>Celui qui veut activer Monetization Deals utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lors de la réactivation</p>
                  </div>
                  {/* bb */}
                </div>
                {/* a */}
              </div>
              {/* block-deux */}
            </div>
            {/* language */}

          </div>
          {/* translation */}
        </>
      )}
      {/* plus - VB */}

      {/* activate Monetization (Page) - VB */}
      {/* activate Monetization (Page) - VB */}
      {/* sur cette page on paye et active la monetisation */}
      {activateMonetizationPageVB && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Veil Brillant <b>Monetization</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateMonetizationPageVB}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Soyez rémunérer sur chaque clic sur votre vidéo, chaque fois qu'une personne cliquera pour accéder à votre chaine, elle payera 1 FCFA à chaque clic</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Monetization (Page) - VB */}

      {/* activate Monetization Deals (Page) - VB */}
      {/* activate Monetization Deals (Page) - VB */}
      {/* sur cette page on paye et active Monetization Deals - VB */}
      {activateMonetizationDealsPageVB && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Monetization <b>Deals</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateMonetizationDealsPageVB}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Celui qui veut activer la monétisation sur sa chaine utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lorsqu'il réactivera</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Monetization Deals (Page) - VB */}

      {/* activate Monetization Formation (Page) - VB */}
      {/* activate Monetization Formation (Page) - VB */}
      {/* sur cette page on paye et active Monetization Formation - VB */}
      {activateMonetizationFormationPageVB && (
        <>
          <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>
                  Monetization <b>Formation</b>
                </p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseActivateMonetizationFormationPageVB}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Activer</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>Celui qui veut activer Monetization Deals utilisera votre super code et vous allez recevoir votre commission chaque 3 ans lors de la réactivation</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* activate Monetization Formation (Page) - VB */}

       {/* monetization - VB */}
       {/* monetization - VB */}
       {monetizationVB && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>VB <b>Monetization</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseMonetizationVB}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* monetization - VB */}

       {/* monetization Deals - VB */}
       {/* monetization Deals - VB */}
       {monetizationDealsVB && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>Monetization <b>Deals</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseMonetizationDealsVB}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* monetization Deals - VB */}

      {/* monetization Formation - VB */}
      {/* monetization Formation - VB */}
      {monetizationFormationVB && (
        <>
        <div className="activatePlusAA">
            <div className="close">
              <div className="a">
                <p>Monetization <b>Formation</b></p>
              </div>
              {/* a */}

              <div className="b">
                <button onClick={CloseMonetizationFormationVB}>Fermer</button>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="solde">
              <div className="a">
                <button>
                  <p>Envoyer dans mon compte izocash international</p>
                  <hr />
                </button>
              </div>
              {/* a */}

              <div className="b">
                <p>150 000 FCFA</p>
                <p>Solde disponible</p>
              </div>
              {/* b */}
            </div>
            {/* solde */}
          </div>
          {/* activatePlusAA */}
        </>
      )}
      {/* monetization Formation - VB */}

      {/* business Page VB */}
      {/* business Page VB */}
      {/*on affiche la page VB Business */}
      {businessPageVB && (
        <>
          <div className="businessPageVB">
            <div className="logo">
              <div className="display">
                {/* ici c'est le logo qui est en lettre */}
                {/* VEIL */}
                {/* VEIL */}
                <div onClick={CloseBusinessPageVB} className="block-un">
                  <div className="lettreV"> <p>V</p> </div>
                  <div className="lettreE"> <p>E</p> </div>
                  <div className="premierI"> <p>I</p> </div>
                  <div className="premierL"> <p>L</p> </div>
                </div>
                {/* block-un */}

                {/* BRILLANT */}
                {/* BRILLANT */}
                <div onClick={CloseBusinessPageVB} className="block-deux">
                  <div className="lettreB"> <p>B</p> </div>
                  <div className="lettreR"> <p>r</p> </div>
                  <div className="deuxiemeI"> <p>i</p> </div>
                  <div className="deuxiemeL"> <p>l</p> </div>
                  <div className="deuxiemeL"> <p>l</p> </div>
                  <div className="lettreA"> <p>a</p> </div>
                  <div className="lettreN"> <p>n</p> </div>
                  <div className="lettreT"> <p>t</p> </div>
                </div>
                {/* block-deux */}

                <div className="block-trois"> <p onClick={CloseBusinessPageVB}>Business</p> </div>
                {/* block-trois */}
              </div>
              {/* display */}
            </div>
            {/* logo */}

            <div className="hr"> <hr /> </div>

            {/* optionsBusinessPage - VBB */}
            {/* optionsBusinessPage - VBB */}
            {/*sur la page VBB, ici on affiche les differents options - VBB */}
            {!optionsBusinessPage && (
              <>
                <div className="optionsBusinessPage">
                  <div className="block">
                    <p onClick={OptionsVideoVBB}>Vidéo</p>
                    <svg
                      onClick={OptionsVideoVBB}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      width="10px"
                      cursor="pointer"
                      fill="#000"
                      enableBackground="new 0 0 477.175 477.175"
                      version="1.1"
                      viewBox="0 0 477.175 477.175"
                      xmlSpace="preserve"
                    >
                      <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                    </svg>
                  </div>
                  {/* block */}
                </div>
                {/* optionsBusinessPage */}
              </>
            )}
            {/* optionsBusinessPage - VBB */}

            {/* optionsVideo - VBB*/}
            {/* optionsVideo - VBB*/}
            {/*apres le clique sur Vidéo, on tombe ici, et ici on affiche les options - VBB */}
            {optionsVideoVBB && (
              <>
                <div className="optionsVideoVBB">
                  <div className="block-un">
                    <svg
                      onClick={CloseOptionsVideoVBB}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      width="15px"
                      cursor="pointer"
                      fill="#000"
                      enableBackground="new 0 0 486.975 486.975"
                      version="1.1"
                      viewBox="0 0 486.975 486.975"
                      xmlSpace="preserve"
                    >
                      <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                    </svg>
                  </div>
                  {/* block-un */}

                  <div className="block-deux">
                    <p onClick={PublierVideoPageVBB}>Publier une vidéo</p>
                    <svg
                      onClick={PublierVideoPageVBB}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0"
                      y="0"
                      width="10px"
                      cursor="pointer"
                      fill="#000"
                      enableBackground="new 0 0 477.175 477.175"
                      version="1.1"
                      viewBox="0 0 477.175 477.175"
                      xmlSpace="preserve"
                    >
                      <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                    </svg>
                  </div>
                  {/* block-deux */}
                </div>
                {/* optionsVideoVBB */}
              </>
            )}
            {/* optionsVideo - VBB*/}

            {/* publierVideoPage - VBB*/}
            {/* publierVideoPage - VBB*/}
            {/*ici la personne va pouvoir choisir la video et la publier - VBB */}
            {publierVideoPageVBB && (
              <>
                <div className="publierVideoPageVBB">
                  <div className="block-un">
                    <p></p>
                    <svg
                      onClick={ClosePublierVideoPageVBB}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      cursor="pointer"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="#444"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 12h12"
                      ></path>
                    </svg>
                  </div>
                  {/* block-un */}

                  <div className="block-deux">
                    <p>Choisissez la vidéo que vous voulez publier</p>
                    <button onClick={PostVideoVB}>
                      Publier la vidéo
                      <hr />
                    </button>
                  </div>
                  {/* block-deux */}
                </div>
                {/* publierVideoPageVBB */}
              </>
            )}
            {/* publierVideoPage - VBB*/}
          </div>
          {/*businessPageVB */}
        </>
      )}
      {/* business Page VB */}


      {/* post publié (message de success) - VB */}
      {/* post publié (message de success) - VB */}
      {postSuccessVB && (<>
          <div onClick={ClosePostSuccessVB} className="numeroOffertSuccessIAC">
            <div className="align">
              <div className="card">
                <div className="display"> <p>Publié</p> <SvgValidate3 /> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* rechargeOfferteSuccessIAC */}
        </>)}
      {/* post publié (message de success) - VB */}

      {/* menu Modifications - VB */}
      {/* menu Modifications - VB */}
      {/*on affiche le card qui contient le menu des modifications */}
      {menuModificationsVB && (
        <>
          <div className="menuModificationsVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Actions</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={CloseMenuModificationsVB}
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#444"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p onClick={MettrePhotoProfilPageVB}>Photo de Profil</p>
                  <p onClick={ModifierNomPageVB}>Nom</p>
                  <p onClick={ModifierTelephonePageVB}>Téléphone</p>
                  <p onClick={ModifierDescriptionPageVB}>Description</p>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/*menuModificationsVB*/}
        </>
      )}
      {/* menu Modifications - VB */}

      {/*modifier photo de profil - VB */}
      {/*modifier photo de profil - VB */}
      {/* on affiche le card qui permet a la personne de mettre ou de remplacer 
      sa photo de profil */}
      {mettrePhotoProfilPageVB && (
        <>
          <div className="mettrePhotoProfilVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Photo de profil</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={CloseMettrePhotoProfilPageVB}
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#444"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Choisissez la photo à mettre sur le profil</p>
                  <input
                    onChange={(e) => setFilePhotoProfilVB(e.target.files[0])}
                    id="file"
                    type="file"
                    name="image"
                    accept=".jpg, .jpeg, .png"
                  />
                  <button onClick={SavePhotoProfileVB}>Valider</button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* mettrePhotoProfilVB */}
        </>
      )}
      {/*modifier photo de profil- VB */}

      {/* modifier nom - VB */}
      {/* modifier nom - VB */}
      {/*on affiche le card qui permet a la personne connecter de modifier son propre nom */}
      {modifierNomPageVB && (
        <>
          <div className="modifierNomPageVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Modifier votre nom public</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={CloseModifierNomPageVB}
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#444"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Nom :</p>
                  <input
                    type="text"
                    value={changeNameVB}
                    onChange={(e) => setChangeNameVB(e.target.value)}
                  />
                  <button onClick={SaveNameVB}>Valider</button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* modifierNomPageVB */}
        </>
      )}
      {/* modifier nom - VB */}

      {/* modifier telephone - VB */}
      {/* modifier telephone - VB */}
      {/*on affiche le card qui permet a la personne connecter de modifier son numero de 
      telephone (le numero qui lui permet a se connecter a son compte Veil Brillant) */}
      {modifierTelephonePageVB && (
        <>
          <div className="modifierNomPageVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Téléphone</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={CloseModifierTelephonePageVB}
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#444"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* block-un */}

                <div className="block-trois">
                  <p>
                    Ici vous pourrez modifier votre numéro de téléphone (il
                    s'agit du numéro qui vous permet d'accéder à votre compte
                    Veil Brillant)
                  </p>
                </div>
                {/* block-trois */}

                <div className="block-deux">
                  <p>Téléphone :</p>
                  <input type="text" />
                  <button>Modifier</button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* modifierNomPageVB */}
        </>
      )}
      {/* modifier telephone - VB */}

      {/* modifier description - VB */}
      {/* modifier description - VB */}
      {/*on affiche le card qui permet a la personne connecter d"entrer sa description */}
      {modifierDescriptionPageVB && (
        <>
          <div className="modifierNomPageVB">
            <div className="align">
              <div className="card">
                <div className="block-un">
                  <p>Entrer votre description</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={CloseModifierDescriptionPageVB}
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#444"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <p>Dites un peu plus sur vous ou sur vos services</p>
                  <textarea></textarea>
                  <button>Valider</button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* modifierNomPageVB */}
        </>
      )}
      {/* modifier description - VB */}

      {/* connexion veil Brillant app */}
      {/* connexion veil Brillant app */}
      {/* ici on affiche la Page qui va permettre a la personne de se connecter 
      a son compte veil Brillant */}
      {connexionPageVB && (
        <> 
          <div className="connexionPageVB">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p onClick={CloseConnexionPageVB}> {t("--login to veil brillant")} </p> </div>
                {/* block-un */}

                <div className="block-deux">

                  {/* Numéro */}
                  <div className="input">
                    <div className="a"> <p>{t("--number")}</p> </div>
                    {rtl && (<> <div className="b-rtl"> <input type="text" value={numberLoginVB} onChange={(e) => setNumberLoginVB(e.target.value)} /> </div> </>)}
                    {!rtl && (<> <div className="b"> <input type="text" value={numberLoginVB} onChange={(e) => setNumberLoginVB(e.target.value)} /> </div> </>)}
                  </div>

                  {/* Mot de passe */}
                  <div className="input">
                    <div className="a"> <p>{t("--password")}</p> </div>
                    {rtl && (<> <div className="b-rtl"> <input type="text" value={passwordLoginVB} onChange={(e) => setPasswordLoginVB(e.target.value)} /> </div> </>)}
                    {!rtl && (<> <div className="b"> <input type="text" value={passwordLoginVB} onChange={(e) => setPasswordLoginVB(e.target.value)} /> </div> </>)}
                  </div>

                  {/* input */}
                </div>
                {/* block-deux */}

                <div className="block-trois"> <p onClick={LoginVB}>{t("--login")}</p> </div>
                {/* block-trois */}

                <div className="block-quatre"> <p onClick={InscriptionPageVB}>{t("--i don't have account")}</p> </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/*connexionPageVB*/}
        </>
      )}
      {/* connexion veil Brillant app */}

      {/* inscription veil Brillant app */}
      {/* inscription veil Brillant app */}
      {/*on affiche la Page qui va permettre a la personne de s'inscrire sur veil Brillant */}
      {inscriptionPageVB && (
        <>
          <div className="connexionPageVB">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p onClick={CloseInscriptionPageVB}>{t("--signup to veil brillant")}</p> </div>
                {/* block-un */}

                <div className="block-deux">

                  {/* nom */}
                  <div className="input">
                    <div className="a"> <p>{t("--name")}</p> </div>
                    {rtl && (<> <div className="b-rtl"> <input type="text" value={nameSignupVB} onChange={(e) => setNameSignupVB(e.target.value)} /> </div> </>)}
                    {!rtl && (<> <div className="b"> <input type="text" value={nameSignupVB} onChange={(e) => setNameSignupVB(e.target.value)} /> </div> </>)}
                  </div>

                  {/* Numéro */}
                  <div className="input">
                    <div className="a"> <p>{t("--number")}</p> </div>
                    {rtl && (<> <div className="b-rtl"> <input type="text" value={numberSignupVB} onChange={(e) => setNumberSignupVB(e.target.value)} /> </div> </>)}
                    {!rtl && (<> <div className="b"> <input type="text" value={numberSignupVB} onChange={(e) => setNumberSignupVB(e.target.value)} /> </div> </>)}
                  </div>

                  {/* Mot de passe */}
                  <div className="input">
                    <div className="a"> <p>{t("--password")}</p> </div>
                    {rtl && (<> <div className="b-rtl"> <input type="text" value={passwordSignupVB} onChange={(e) => setPasswordSignupVB(e.target.value)} /> </div> </>)}
                    {!rtl && (<> <div className="b"> <input type="text" value={passwordSignupVB} onChange={(e) => setPasswordSignupVB(e.target.value)} /> </div> </>)}
                  </div>

                  {/* input */}
                </div>
                {/* block-deux */}

                <div className="block-trois"> <p onClick={SignupVB}>{t("--signup")}</p> </div>
                {/* block-trois */}

                <div className="block-quatre"> <p onClick={ConnexionPageVB}>{t("--i have account")}</p> </div>
                {/* block-quatre */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/*connexionPageVB*/}
        </>
      )}
      {/* inscription veil Brillant app */}

      {/* NonConnecterVB */}
      {/* NonConnecterVB */}
      {/*si la personne n"est par connecter, on va lafficher un message pour lui dire quelle 
      doit se connecter a son compte veil Brillant pour avoir acces a cette fonctionnaliter */}
      {nonConnecterVB && (
        <>
          <div onClick={NonConnecterVB} className="connexionSuccessVB">
            <div className="align">
              <div className="card">
                <p style={{ color: "black", fontSize: "15px" }}>{t("--login for free to your veil brillant account")}</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/*connexionSuccessVB*/}
        </>
      )}
      {/* NonConnecterVB */}


      {/* inscription success - VB */}
      {/* inscription success - VB */}
      {/*on affiche ce message de success lorsque la personne a pu s'inscrire */}
      {inscriptionSuccessVB && (
        <>
          <div
            onClick={CloseInscriptionSuccessVB}
            className="connexionSuccessVB"
          >
            <div className="align">
              <div className="card">
                <p>{t("--signup success")}</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/*connexionSuccessVB*/}
        </>
      )}
      {/* inscription success - VB */}

      {/* connexion success - VB */}
      {/* connexion success - VB */}
      {/*on affiche ce message de success lorsque la personne a pu se connecter */}
      {connexionSuccessVB && (
        <>
          <div onClick={CloseConnexionSuccessVB} className="connexionSuccessVB">
            <div className="align">
              <div className="card">
                <p>{t("--login success")}</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/*connexionSuccessVB*/}
        </>
      )}
      {/* connexion success - VB */}

      {/* connectezVous - VB */}
      {/* connectezVous - VB */}
      {/*on affiche ce message apres le message de succes "Inscription reussie" - VB */}
      {connectezVousVB && (
        <>
          <div onClick={CloseConnectezVousVB} className="connexionSuccessVB">
            <div className="align">
              <div className="card">
                <p style={{ color: "black" }}>{t("--login now")}</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionSuccessVB */}
        </>
      )}
      {/* connectezVous - VB */}

      {/* erreur - VB */}
      {/* erreur - VB */}
      {/*on affiche ce message d'erreur s'il y'a une erreur */}
      {erreurVB && (
        <>
          <div onClick={CloseErreurVB} className="connexionSuccessVB">
            <div className="align">
              <div className="card">
                <p style={{ color: "black" }}>{t("--please, check your virtual number")}</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionSuccessVB */}
        </>
      )}
      {/* erreur - VB */}


      {/* deconnexion - VB */}
      {/* deconnexion - VB */}
      {/*on affiche le card qui va permettre a l'utilisateur de se deconnecter */}
      {deconnexionPageVB && (<>
          <div onClick={DeconnexionPageVB} className="deconnexionPageVB">
            <div className="align">
              <div className="card">
                <div className="a"> <p>{t("--by clicking on continue")}</p> </div>
                <div className="b"> <p onClick={LogoutVB}>{t("--continue")}</p> </div>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* deconnexionPageVB */}
        </>)}
      {/* deconnexion - VB */}


      {/* deconnexionSuccess - VB */}
      {/* deconnexionSuccess - VB */}
      {/*on affiche ce message de success lorsque la deconnexion a reussi */}
      {deconnexionSuccessVB && (
        <>
          <div
            onClick={CloseDeconnexionSuccessVB}
            className="connexionSuccessVB"
          >
            <div className="align">
              <div className="card">
                <p style={{ color: "black" }}>{t("--logout success")}</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionSuccessVB */}
        </>
      )}
      {/* deconnexionSuccess - VB */}

      {/* Wei-D App */}
      {/* Wei-D App */}
      {/* quand on clique, on est dans l'application Wei-D */}
      {/* donc ca c'est l'application Wei-D */}
      {weidApp && (
        <>
          <div className="weidApp">
            <div className="head">
              <div className="onglet">
                {/* onglet personnel active, alors on met l'icone personnel active */}
                {personnelOngletWA && (
                  <>
                    <div className="display">
                      <div className="a">
                        <div className="icon">
                          <button>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25px"
                              viewBox="0 0 60.601 60.601"
                              fill="blue"
                            >
                              <path
                                fill="#fff"
                                stroke="blue"
                                strokeWidth="0.606"
                                d="M7.786 56.032a3.218 3.218 0 01-3.217-3.217V7.785a3.217 3.217 0 013.217-3.216h45.03a3.215 3.215 0 013.216 3.216v45.03a3.217 3.217 0 01-3.216 3.217H7.786z"
                              ></path>
                              <path d="M34.607 16.325c0-2.128-.28-4.176-.777-6.149H30.58V22.54l3.249.007c.507-1.99.777-4.074.777-6.221M30.581 38.054v12.37h3.249c.507-1.99.777-4.077.777-6.224 0-2.126-.297-4.169-.795-6.14l-3.23-.006M21.291 30.3a35.212 35.212 0 006.276 20.125l1.415-.001V38.06a13.633 13.633 0 01-2.388-7.761c0-2.904.872-5.536 2.388-7.761V10.176l-1.415-.001A35.215 35.215 0 0021.291 30.3"></path>
                            </svg>
                            <p style={{ color: "blue" }}>Personnel</p>
                          </button>
                        </div>
                        {/* icon */}

                        <div className="icon">
                          <button onClick={ProfessionnelOngletWA}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0"
                              y="0"
                              width="25px"
                              fill="#fd7e14"
                              enableBackground="new 0 0 512 512"
                              version="1.1"
                              viewBox="0 0 512 512"
                              xmlSpace="preserve"
                            >
                              <path d="M389.376 0H122.624c-5.632 0-10.199 4.566-10.199 10.199v491.602c0 5.633 4.567 10.199 10.199 10.199h266.752c5.632 0 10.199-4.566 10.199-10.199V10.199C399.575 4.566 395.008 0 389.376 0zm-91.45 491.602h-31.727v-31.193c0-5.633-4.567-10.199-10.199-10.199s-10.199 4.566-10.199 10.199v31.193h-31.726v-85.383h83.851v85.383zm81.252 0h-60.855V396.02c0-5.633-4.567-10.199-10.199-10.199H203.876c-5.632 0-10.199 4.566-10.199 10.199v95.582h-60.854V20.398h246.355v471.204z"></path>
                              <path d="M230.96 43.436h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V53.636c0-5.633-4.567-10.2-10.199-10.2zm-10.199 63.367h-42.968V63.835h42.968v42.968zM344.407 43.436H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V53.636c0-5.633-4.567-10.2-10.199-10.2zm-10.199 63.367H291.24V63.835h42.968v42.968zM230.96 155.861h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V166.06c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367h-42.968V176.26h42.968v42.968zM344.407 155.861H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V166.06c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367H291.24V176.26h42.968v42.968zM230.96 268.286h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199v-63.367c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367h-42.968v-42.968h42.968v42.968zM344.407 268.286H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199v-63.367c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367H291.24v-42.968h42.968v42.968zM256 418.526c-5.632 0-10.199 4.566-10.199 10.199v1.022c0 5.633 4.567 10.199 10.199 10.199s10.199-4.566 10.199-10.199v-1.022c0-5.632-4.567-10.199-10.199-10.199z"></path>
                            </svg>
                            Professionnel
                          </button>
                        </div>
                        {/* icon */}
                      </div>
                      {/* a */}

                      <div className="b">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="blue"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 12a1 1 0 110 2 1 1 0 010-2zm0-10a4 4 0 011.19 7.82l-.19.054V14a1 1 0 01-1.993.117L11 14v-1a1 1 0 01.883-.993l.266-.012A2 2 0 1010 10a1 1 0 01-2 0 4 4 0 014-4z"
                          ></path>
                        </svg>
                      </div>
                      {/* b */}
                    </div>
                    {/* display */}
                  </>
                )}

                {/* onglet professionnel active, alors on met l'icone professionnel active */}
                {professionnelOngletWA && (
                  <>
                    <div className="display">
                      <div className="a">
                        <div className="icon">
                          <button onClick={PersonnelOngletWA}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25px"
                              viewBox="0 0 60.601 60.601"
                              fill="blue"
                            >
                              <path
                                fill="#fff"
                                stroke="blue"
                                strokeWidth="0.606"
                                d="M7.786 56.032a3.218 3.218 0 01-3.217-3.217V7.785a3.217 3.217 0 013.217-3.216h45.03a3.215 3.215 0 013.216 3.216v45.03a3.217 3.217 0 01-3.216 3.217H7.786z"
                              ></path>
                              <path d="M34.607 16.325c0-2.128-.28-4.176-.777-6.149H30.58V22.54l3.249.007c.507-1.99.777-4.074.777-6.221M30.581 38.054v12.37h3.249c.507-1.99.777-4.077.777-6.224 0-2.126-.297-4.169-.795-6.14l-3.23-.006M21.291 30.3a35.212 35.212 0 006.276 20.125l1.415-.001V38.06a13.633 13.633 0 01-2.388-7.761c0-2.904.872-5.536 2.388-7.761V10.176l-1.415-.001A35.215 35.215 0 0021.291 30.3"></path>
                            </svg>
                            Personnel
                          </button>
                        </div>
                        {/* icon */}

                        <div className="icon">
                          <button>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0"
                              y="0"
                              width="25px"
                              fill="#fd7e14"
                              enableBackground="new 0 0 512 512"
                              version="1.1"
                              viewBox="0 0 512 512"
                              xmlSpace="preserve"
                            >
                              <path d="M389.376 0H122.624c-5.632 0-10.199 4.566-10.199 10.199v491.602c0 5.633 4.567 10.199 10.199 10.199h266.752c5.632 0 10.199-4.566 10.199-10.199V10.199C399.575 4.566 395.008 0 389.376 0zm-91.45 491.602h-31.727v-31.193c0-5.633-4.567-10.199-10.199-10.199s-10.199 4.566-10.199 10.199v31.193h-31.726v-85.383h83.851v85.383zm81.252 0h-60.855V396.02c0-5.633-4.567-10.199-10.199-10.199H203.876c-5.632 0-10.199 4.566-10.199 10.199v95.582h-60.854V20.398h246.355v471.204z"></path>
                              <path d="M230.96 43.436h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V53.636c0-5.633-4.567-10.2-10.199-10.2zm-10.199 63.367h-42.968V63.835h42.968v42.968zM344.407 43.436H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V53.636c0-5.633-4.567-10.2-10.199-10.2zm-10.199 63.367H291.24V63.835h42.968v42.968zM230.96 155.861h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V166.06c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367h-42.968V176.26h42.968v42.968zM344.407 155.861H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199V166.06c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367H291.24V176.26h42.968v42.968zM230.96 268.286h-63.367c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.567 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199v-63.367c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367h-42.968v-42.968h42.968v42.968zM344.407 268.286H281.04c-5.632 0-10.199 4.566-10.199 10.199v63.367c0 5.633 4.566 10.199 10.199 10.199h63.367c5.632 0 10.199-4.566 10.199-10.199v-63.367c0-5.633-4.567-10.199-10.199-10.199zm-10.199 63.367H291.24v-42.968h42.968v42.968zM256 418.526c-5.632 0-10.199 4.566-10.199 10.199v1.022c0 5.633 4.567 10.199 10.199 10.199s10.199-4.566 10.199-10.199v-1.022c0-5.632-4.567-10.199-10.199-10.199z"></path>
                            </svg>
                            <p style={{ color: "#fd7e14" }}>Professionnel</p>
                          </button>
                        </div>
                        {/* icon */}
                      </div>
                      {/* a */}

                      <div className="b">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20px"
                          cursor="pointer"
                          fill="blue"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 12a1 1 0 110 2 1 1 0 010-2zm0-10a4 4 0 011.19 7.82l-.19.054V14a1 1 0 01-1.993.117L11 14v-1a1 1 0 01.883-.993l.266-.012A2 2 0 1010 10a1 1 0 01-2 0 4 4 0 014-4z"
                          ></path>
                        </svg>
                      </div>
                      {/* b */}
                    </div>
                    {/* display */}
                  </>
                )}
              </div>
              {/* onglet 
              <p>National</p>
              <p>international</p>
              */}
            </div>
            {/* head (la tete) - weidApp */}

            {/* body (corps) - weidApp */}
            {/* body (corps) - weidApp */}
            <div className="body">
              <div className="block-un">
                {personnelOngletWA && (
                  <>
                    <div className="a">
                      <p>Obtenir un numéro personnel</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <g
                          stroke="red"
                          strokeLinejoin="round"
                          strokeWidth="3"
                          clipPath="url(#clip0_105_1875)"
                        >
                          <path d="M12 12H12.01V12.01H12z"></path>
                          <path d="M12 5H12.01V5.01H12z"></path>
                          <path d="M12 19H12.01V19.01H12z"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_105_1875">
                            <path
                              fill="#fff"
                              d="M0 0H24V24H0z"
                              transform="translate(0 .001)"
                            ></path>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    {/* a */}
                  </>
                )}

                {professionnelOngletWA && (
                  <>
                    <div className="b">
                      <p>Obtenir un numéro professionnel</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <g
                          stroke="red"
                          strokeLinejoin="round"
                          strokeWidth="3"
                          clipPath="url(#clip0_105_1875)"
                        >
                          <path d="M12 12H12.01V12.01H12z"></path>
                          <path d="M12 5H12.01V5.01H12z"></path>
                          <path d="M12 19H12.01V19.01H12z"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_105_1875">
                            <path
                              fill="#fff"
                              d="M0 0H24V24H0z"
                              transform="translate(0 .001)"
                            ></path>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    {/* b */}
                  </>
                )}
              </div>
              {/* block-un */}

              <div className="block-deux">
                {personnelOngletWA && (
                  <>
                    <div className="a">
                      <hr />
                    </div>
                  </>
                )}

                {professionnelOngletWA && (
                  <>
                    <div className="b">
                      <hr />
                    </div>
                  </>
                )}
              </div>
              {/* block-deux */}

              {professionnelOngletWA && (
                <>
                  <div className="block-trois">
                    <p>National</p>
                    <p>International</p>
                  </div>
                  {/* block-trois */}
                </>
              )}
            </div>
            {/* body (corps) - weidApp */}

            {/* footer (pied) - izocashApp */}
          </div>
          {/* weidApp */}
        </>
      )}
      {/* Wei-D App */}

      {/* ecran de demarrage - vixinol store app */}
      {/* ecran de demarrage - vixinol store app */}
      {/* ca c'est l'ecran de demarrage de l' application Vixinol Store */}
      {ecranDemarrageVS && (
        <>
          <div className="ecranDemarrageVS">
            <div className="align">
              <div className="block-un">
                <div className="a">
                  <img src={vixinolLogoEcranDemarrage} alt="" />
                </div>

                <div className="b">
                  <p></p>
                </div>
                {/* b */}
              </div>
              {/* block-un */}

              <div className="block-deux">
                <p>{t("--platform 1 for virtual applications")}</p>
              </div>
              {/* block-deux */}
            </div>
            {/* align */}
          </div>
          {/* ecranDemarrageVS */}
        </>
      )}
      {/* ecran de demarrage - vixinol store app */}

      {/* inscription vixinol store - VS */}
      {/* inscription vixinol store - VS */}
      {/* on affiche la page qui va permettre a la personne de s'inscrire sur 
      vixinol store */}
      {inscriptionPageVS && (
        <>
          <div className="connexionVS">
            <div className="align">
              <div className="card">
                <div className="block-un "> <p onClick={CloseInscriptionPageVS}>{t("--signup to vixinol store")}</p> </div>
                {/* block-un */}

                <div className="align-tout">
                  <div className="tout">
                    {/* Nom d'utilisateur */}
                    {rtl && (<>
                    <div className="input-rtl">
                      <p>{t("--username")}</p>
                      <input type="text" placeholder={t("--username")} value={nameSignupVS} onChange={(e) => setNameSignupVS(e.target.value)} />
                    </div> </>)}

                    {!rtl && (<>
                    <div className="input">
                      <p>{t("--username")}</p>
                      <input type="text" placeholder={t("--username")} value={nameSignupVS} onChange={(e) => setNameSignupVS(e.target.value)} />
                    </div> </>)}

                    {/* Numéro Virtuel */}
                    {rtl && (<>
                    <div className="input-rtl">
                      <p>{t("--virtual number")}</p>
                      <input type="text" placeholder={t("--number")} value={numberSignupVS} onChange={(e) => setNumberSignupVS(e.target.value)} />
                    </div> </>)}

                    {!rtl && (<>
                    <div className="input">
                      <p>{t("--virtual number")}</p>
                      <input type="text" placeholder={t("--number")} value={numberSignupVS} onChange={(e) => setNumberSignupVS(e.target.value)} />
                    </div> </>)}

                    {/* Mot de passe */}
                    {rtl && (<>
                    <div className="input-rtl">
                      <p>{t("--password")}</p>
                      <input type="text" placeholder={t("--password")} value={passwordSignupVS} onChange={(e) => setPasswordSignupVS(e.target.value)} />
                    </div> </>)}

                    {!rtl && (<>
                    <div className="input">
                      <p>{t("--password")}</p>
                      <input type="text" placeholder={t("--password")} value={passwordSignupVS} onChange={(e) => setPasswordSignupVS(e.target.value)} />
                    </div> </>)}

                    <div className="button"> <p onClick={SignupVS}>{t("--signup for free")}</p> </div>
                    {/* button */}
                  </div>
                  {/* tout */}
                </div>
                {/* align-tout */}

                <div className="block-deux">
                  <div className="a"> <p>{t("--i have account")}.</p> </div>
                  <div className="b"> <p onClick={ConnexionPageVS}>{t("--login")}</p> </div>
                </div>
                {/* block-deux */}

              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionVS */}
        </>
      )}
      {/* inscription - VS */}

      {/* connexion - VS */}
      {/* connexion - VS */}
      {/* on affiche la page qui va permettre a la personne de se connecter sur 
      vixinol store */}
      {connexionPageVS && (
        <>
          <div className="connexionVS">
            <div className="align">
              <div className="card">
                <div className="block-un"> <p onClick={CloseConnexionPageVS}>{t("--login to vixinol store")}</p> </div>
                {/* block-un */}

                <div className="align-tout">
                  <div className="tout">
                    {/* Numéro virtuel */}
                    {rtl && (<>
                    <div className="input-rtl">
                      <p>{t("--virtual number")}</p>
                      <input type="text" placeholder={t("--number")} value={numberLoginVS} onChange={(e) => setNumberLoginVS(e.target.value)} />
                    </div> </>)}

                    {!rtl && (<>
                    <div className="input">
                      <p>{t("--virtual number")}</p>
                      <input type="text" placeholder={t("--number")} value={numberLoginVS} onChange={(e) => setNumberLoginVS(e.target.value)} />
                    </div> </>)}

                    {/* Mot de passe */}
                    {rtl && (<>
                    <div className="input-rtl">
                      <p>{t("--password")}</p>
                      <input type="text" placeholder={t("--password")} value={passwordLoginVS} onChange={(e) => setPasswordLoginVS(e.target.value)} />
                    </div> </>)}

                    {!rtl && (<>
                    <div className="input">
                      <p>{t("--password")}</p>
                      <input type="text" placeholder={t("--password")} value={passwordLoginVS} onChange={(e) => setPasswordLoginVS(e.target.value)} />
                    </div> </>)}

                    <div className="button"> <p onClick={LoginVS}>{t("--login")}</p> </div>
                    {/* button */}
                  </div>
                  {/* tout */}
                </div>
                {/* align-tout */}

                <div className="block-deux">
                  <div className="a"> <p>{t("--i don't have account")}.</p> </div>
                  <div className="b"> <p onClick={InscriptionPageVS}>{t("--signup")}</p> </div>
                </div>
                {/* block-deux */}

              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* connexionVS */}
        </>
      )}
      {/* connexion vixinol store - VS */}

      {/* Moyen de Paiement (page) - VS */}
      {/* Moyen de Paiement (page) - VS */}
      {/* le card ci va permettre a la personne d'entrer le code pin pour lier un moyen de
      paiement lors de l'inscription sur vixinol store */}
      {moyenPaiementPageVS && (
        <>
          <div className="moyenPaiementVS">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    <p onClick={CloseMoyenPaiementPageVS}>
                      Moyen de paiement virtuel
                    </p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p onClick={CloseMoyenPaiementPageVS}>
                      Ajouter un moyen de paiement virtuel compatible à votre
                      téléphone virtuel
                    </p>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="codePin">
                  <div className="block-un">
                    <p>Code PIN</p>
                  </div>
                  {/* block-un */}

                  <div className="block-deux">
                    <input
                      type="number"
                      placeholder="_ _ _ _ _ _"
                      value={codePinVS}
                      onChange={(e) => setCodePinVS(e.target.value)}
                    />
                  </div>
                  {/* block-deux */}

                  <div className="block-trois">
                    <button onClick={AjouterMoyenPaiementVS}>Ajouter</button>
                  </div>
                  {/* block-trois */}
                </div>
                {/* codePin */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* moyenPaiementVS */}
        </>
      )}
      {/* Moyen de Paiement (page) - VS */}

      {/* connexionSuccess - VS */}
      {/* connexionSuccess - VS */}
      {/* on va afficher cette page si l'utilisateur a pu se connecter 
      a son compte Vixinol */}
      {connexionSuccessVS && (
        <>
          <div className="connexionSuccessVS">
            <div className="block-un">
              <p>{t("--login success")}</p>
            </div>
            {/* block-un */}

            <div className="block-deux">
              <p>Vixinol Store ©2024</p>
            </div>
            {/* block-deux */}
          </div>
          {/* connexionSuccessVS */}
        </>
      )}
      {/* connexionSuccess - VS */}

      {/* inscriptionSuccess - VS */}
      {/* inscriptionSuccess - VS */}
      {/* on va afficher cette page si l'utilisateur a pu s'inscrire a sur Vixinol Store */}
      {inscriptionSuccessVS && (
        <>
          <div onClick={CloseInscriptionSuccessVS} className="erreurVS">
            <div className="align">
              <div className="card">
                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="a">
                  <p>{t("--signup success")}</p>
                </div>
                {/* a */}

                <div className="b">
                  <p>{t("--login now")}</p>
                </div>
                {/* b */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurVS */}
        </>
      )}
      {/* inscriptionSuccess - VS */}

      {/* message d'erreur - (codePinIncorrect) - VS */}
      {/* message d'erreur - (codePinIncorrect) - VS */}
      {/* lors de l'inscription sur vixinol, si l'utilisateur a entrer un code pin incorrect
      ou si au meme moment il y'a un autre utilisateur qui utilise le meme code que lui alors 
      on va afficher ce message d'erreur */}
      {codePinIncorrectVS && (
        <>
          <div onClick={CloseCodePinIncorrectVS} className="erreurVS">
            <div className="align">
              <div className="card">
                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="a">
                  <p>Une erreur s'est produite !</p>
                </div>
                {/* a */}

                <div className="b">
                  <p>Réessayer ou utiliser un autre code PIN</p>
                </div>
                {/* b */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurVS */}
        </>
      )}
      {/* message d'erreur - (codePinIncorrect) - VS */}

      {/* vixinol Store app */}
      {/* vixinol Store app */}
      {/* quand on clique, on est dans l'application vixinol Store */}
      {/* ca c'est l'application vixinol Store */}
      {vixinolStoreApp && (
        <>
          <div className="vixinolStore">
            {/* head (la tete) - vixinolStore */}

            {/* body (corps) - vixinolStore */}
            <div className="body">
              <div className="logo">
                <div className="block-un">
                  <div className="a">
                    <p onClick={VixinolStoreApp}>Vixinol</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <p onClick={VixinolStoreApp}>Store</p>
                  </div>
                  {/* b */}
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <svg
                    onClick={ProfilVS}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    cursor="pointer"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M12 1a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM8.5 6.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
                      clipRule="evenodd"
                    ></path>
                    <path
                      fill="#000"
                      d="M8 14a6 6 0 00-6 6v2a1 1 0 102 0v-2a4 4 0 014-4h8a4 4 0 014 4v2a1 1 0 102 0v-2a6 6 0 00-6-6H8z"
                    ></path>
                  </svg>
                </div>
                {/* block-deux */}
              </div>
              {/* logo */}

              <div className="hr">
                <hr />
              </div>
              {/* hr */}

              {apiListeApp.map((api) => (
                <>
                  <div onClick={SuperModule}>
                    <EnfantApiListeApp api={api} />
                  </div>
                </>
              ))}
            </div>
            {/* body */}

            {/* footer (pied) - vixinolStore */}
            <div className="footer"></div>
          </div>
          {/* vixinolStore */}
        </>
      )}
      {/* vixinol Store app */}

      {/* super module - VS */}
      {/* super module - VS */}
      {/*dans vixinol store, si l'utilisateur a cliquer sur une app, on va afficher 
      cette page superModule */}
      {superModule && (
        <>
          <div className="superModuleVS">
            <div className="close">
              <p>{nomApp}</p>
              <svg
                onClick={CloseSuperModule}
                xmlns="http://www.w3.org/2000/svg"
                width="17px"
                fill="#fff"
                cursor="pointer"
                version="1.1"
                viewBox="0 0 100 100"
                xmlSpace="preserve"
              >
                <path d="M78.466 35.559L50.15 63.633 22.078 35.317a2 2 0 00-2.84 2.815L48.432 67.58a1.993 1.993 0 001.727.568c.054.008.106.021.16.022a1.991 1.991 0 001.515-.576l29.447-29.196a1.999 1.999 0 10-2.815-2.839z"></path>
              </svg>
            </div>
            {/* close */}

            <div className="align-blockApp">
              <div className="blockApp">
                <div className="photo-et-nom">
                  <div className="photo">
                    <img src={vbLogo} alt="" />
                  </div>
                  {/* photo */}

                  <div className="nom">
                    <div className="a">
                      <p>{nomApp}</p>
                    </div>

                    {/*
                si installer=1, ca veut dire l'app est installer
                si installer=0, ca veut dire l'app n'est pas installer
                on affiche installée au niveau de l'app si l'app est installer. 
                    {filtreApiAppInstaller.map((api) => (
                      <> 
                        {api.installer === "1" && (
                          <> */}
                    <div className="b">
                      <p>installée</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15px"
                        cursor="pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M20 7L9 18l-5-5"
                        ></path>
                      </svg>
                    </div>
                    {/* b */}
                  </div>
                  {/* nom */}
                </div>
                {/* photo-et-nom */}

                <div className="desc">
                  <p>{descApp}</p>
                </div>
                {/* desc */}

                {/*
                installer 
                si installer=1, ca veut dire l'app est installer
                si installer=0, ca veut dire l'app n'est pas installer
                on affiche ca si l'app n'est pas installer. 
                {filtreApiAppInstaller.map((api) => (
                  <>
                    <div className="btnInstaller">
                      <button>Installer</button>
                    </div>
                  </>
                ))}
                */}
              </div>
              {/* blockApp */}
            </div>
            {/* align-blockApp */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="align-bigCard">
              <div className="bigCard">
                <div className="sousTitre">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    ariaHidden="true"
                    viewBox="0 0 128 128"
                  >
                    <path
                      fill="#888071"
                      d="M19.7 45.67c-.04 0-.08 0-.12-.01-.06-.01-1.56-.18-4.11-.64-2.78-.51-4.61-.72-4.63-.72-.6-.07-1.04-.61-.97-1.22.07-.6.62-1.04 1.22-.97.08.01 1.92.22 4.78.74 2.47.45 3.95.62 3.96.62.6.07 1.04.61.97 1.22-.07.56-.55.98-1.1.98zM10.78 50.08c-.55 0-1.03-.41-1.09-.97a1.1 1.1 0 01.97-1.22c.03 0 2.81-.33 4.22-.56 1.46-.23 4.74-.75 4.74-.75l.34 2.17-4.73.75c-1.46.24-4.2.56-4.32.57-.05 0-.09.01-.13.01zM12.51 54.68c-.48 0-.92-.31-1.06-.8-.17-.58.17-1.19.76-1.36l7.88-2.25a1.102 1.102 0 01.6 2.12l-7.88 2.25c-.09.02-.2.04-.3.04z"
                    ></path>
                    <path
                      fill="#b85c3e"
                      d="M53.29 84.41l-10.84 8.31s.42 17.32.14 18.02c-.28.7-4.08 5.07-3.66 7.6.33 1.97 1.83 2.67 5.91 2.82s12.39-1.69 12.39-1.69l-3.94-35.06zM85.11 91.02l-8.02 4.5s1.13 3.38 1.13 8.17-.42 7.79-.7 8.78c-.28.99-2.63 2.86-2.39 5.58.11 1.26 1.69 2.25 4.5 2.11s6.9-.42 6.9-.42l4.08-26.61-5.5-2.11z"
                    ></path>
                    <path
                      fill="#fb8b02"
                      d="M33.26 27.81s-1.31-4.6-.19-11.92c1.13-7.32 3-11.17 4.79-11.36 1.78-.19 5.16 3.19 7.79 7.23 2.63 4.04 4.79 11.17 4.79 11.17l-17.18 4.88zM63.85 97.26s.09 8.45.28 12.2c.19 3.75.01 12.08-.75 13-1.17 1.41-2.35 1.45-4.88 1.55-1.51.06.47-9.29.47-9.67s.09-22.81.09-22.81l4.79 5.73z"
                    ></path>
                    <path
                      fill="#ffb800"
                      d="M38.79 68.08s-2.25 7.13-1.69 12.48c.56 5.35 3.66 12.11 6.76 14.83s5.91 4.13 6.19 4.79c.28.66 1.41 9.95 1.03 11.92s-3.1 7.04-2.63 9.01c.47 1.97 2.33 3.21 7.13 3.1 6.24-.14 5.91-1.08 6.38-4.97.32-2.62-.09-20.74-.09-20.74s3.85.38 9.29 0c5.44-.38 12.2-2.82 12.2-2.82s3.85 12.01 2.53 15.67c-1.31 3.66-3.47 5.73-3.1 8.26.38 2.53 3.66 3.66 7.7 3.28 4.04-.38 7.13-3 7.32-6.48.19-3.47.09-22.71.66-24.21.56-1.5 2.63-6.66 2.44-11.83s-.56-7.23-.56-7.23 4.85-1.85 9.34-5.25c3.42-2.59 5.99-6 7.36-11.08 2.25-8.35-.84-16.61-7.04-19.43-5.96-2.71-11.83-1.69-12.01 2.63s3.66 3.38 6.57 4.5c2.91 1.13 6.19 6.29 2.72 11.36-3.47 5.07-9.57 6.66-11.45 6.85-1.88.19-5.35-2.72-12.58-2.91-7.23-.19-17.64 5.07-17.93 4.41-.28-.66 10.32-7.51 11.07-16.42.7-8.26-1.03-12.11-1.03-12.11s-1.31-13.98-3.19-20.55S67.7 3.69 66.01 3.79c-1.69.09-7.13 6.01-9.1 8.92s-4.13 7.6-4.13 7.6-8.4-.31-12.11 1.03c-3.38 1.22-7.23 3.28-9.67 7.13s-3.19 6.1-4.32 6.66c-1.13.56-6.48 1.69-6.95 2.35-.47.66-1.69 9.39-1.41 10.7s.5 4.37 2.06 6.1c1.78 1.97 6.71 5.3 10.61 7.79 3.77 2.4 7.43 4.32 7.8 6.01z"
                    ></path>
                    <path
                      fill="#ff9b31"
                      d="M73.38 77.27c3.47-.05 3.38-4.22 3.43-9.39.04-4.52-.14-7.18-.14-7.18s-1.99.27-3.75.94c-1.74.66-3.24 1.27-3.24 1.27v7.27c-.01 2.49.27 7.14 3.7 7.09zM79.48 60.05s0 4.36.05 8.07c.05 3.99-.33 8.31 3.66 8.26 3.43-.04 3.43-4.41 3.47-9.34.02-2.58.09-6.99.09-6.99s-1.69-.33-3.71-.28c-1.59.04-3.56.28-3.56.28z"
                    ></path>
                    <path
                      fill="#2c312c"
                      d="M44.81 41.02c-.73 1.77-2.3 4.3-4.89 3.64-1.66-.42-1.78-3.99-.81-6.11 1.15-2.5 2.68-3.63 4.47-3.42 1.97.24 2.16 3.62 1.23 5.89zM27.67 40.48c-.05-1.13-2.96-1.92-5.21-2.77-1.91-.71-2.96-.75-3.47-.28s-1.13 1.69-1.41 3.57-.18 5.06.28 7.04c.47 2.02 1.22 4.55 4.55 5.87 2.86 1.13 4.55-.42 5.77-1.27 1.55-1.07.88-3.61-1.31-2.3-1.64.99-2.77 1.27-4.04.33-1.74-1.29-2.16-5.11-2.02-5.44.61-1.43 3.05-1.78 4.04-2.16.99-.38 2.87-1.6 2.82-2.59z"
                    ></path>
                    <path
                      fill="#888071"
                      d="M47.34 50.45h-.08c-.03 0-3.19-.23-5.16-.28l-5.63-.14s-1.18.1-1.18-1.06c0-1.23 1.23-1.04 1.23-1.04l5.63.14c2.02.05 5.13.27 5.26.28.58.04 1.01.55.97 1.12-.04.56-.5.98-1.04.98zM45.55 57.3c-.15 0-.31-.03-.45-.1-.02-.01-2.51-1.2-4.76-1.97-2.34-.79-4.96-1.64-4.96-1.64-.55-.18-.86-.77-.68-1.32.18-.55.77-.86 1.32-.68 0 0 2.64.85 4.99 1.65 2.38.81 4.89 2.01 5 2.07.52.25.74.88.49 1.4-.18.37-.56.59-.95.59zM40.44 61.2c-.2 0-.41-.06-.59-.18-.02-.01-1.78-1.21-2.96-1.94-1.23-.75-3.44-2.17-3.44-2.17s-.99-.58-.35-1.5 1.48-.28 1.48-.28 2.2 1.4 3.41 2.15c1.23.75 2.97 1.95 3.05 2 .48.33.6.98.27 1.46-.21.3-.54.46-.87.46z"
                    ></path>
                    <path
                      fill="#fed0ab"
                      d="M64.35 12.33c-.48-.17-3.59 3.45-5.14 7.04-1.55 3.59-2.11 5.56-1.97 6.19.06.28 1.85 1.83 4.5 3.94 2.75 2.18 4.5 3.52 5.28 3.45.77-.07.99-6.05.35-11.47s-2.25-8.87-3.02-9.15z"
                    ></path>
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    ariaHidden="true"
                    viewBox="0 0 128 128"
                  >
                    <path
                      fill="#ffd2b1"
                      d="M28.94 63.15s-2.39 6.9-.99 14.22c1.41 7.32 3.38 14.08 3.38 14.08s.42 14.36 0 15.91c-.42 1.55-3.66 3.52-3.66 6.34s1.03 6.38 6.24 7.23 9.43-.89 11.17-3c2.51-3.05 2.02-5.21 2.02-7.46s.14-15.2.7-17.18c.56-1.97 1.41-3.1 2.96-2.96 1.55.14 3.24 2.53 3.38 7.04.14 4.5.28 12.39.14 13.94-.14 1.55-1.55 6.76-.42 8.87 1.13 2.11 6.24 4.16 10.18 3.94 5.16-.28 8.26-3.52 8.54-6.05.28-2.53-1.41-8.31-1.41-10 0-1.69 1.97-13.23 2.53-13.94.56-.7 2.28-.55 6.05-2.25 3.43-1.55 5.26-3.1 5.26-3.1s.09 10-.05 11.12c-.14 1.13-3.52 4.65-2.96 7.32s3.86 4.23 6.8 4.5c4.97.47 9.81-3.38 11.07-6.76 1.27-3.38.7-7.6.42-9.85-.28-2.25-.28-10.14 0-12.25.28-2.11.74-3.39.92-4.5.28-1.83.21-3.87.21-3.87s4.86 0 7.74-1.9 5.91-5.21 7.25-9.29c1.31-3.99.99-5.21-.14-5.35-1.13-.14-6.19 6.96-10.49 7.18-6.83.35-6.15-6.97-11.36-11.4-5.87-5-15.02-5.63-15.02-5.63s1.58-5.91 1.6-10.28c.07-19.08-9.22-25.55-9.22-25.55S60.61 3.95 47.94 4.51 25.98 15.14 25.98 15.14L19.01 45.9s1.76 5.91 4.58 10.21c2.96 4.5 5.35 7.04 5.35 7.04z"
                    ></path>
                    <path
                      fill="#865b52"
                      d="M20.14 8.32C9.79 8.53 4.32 17.35 4.16 22.75c-.09 3.17-1.34 26.21 11.4 26.68 5.11.19 8.91-5.74 10.84-12.46 2.43-8.47 2.32-16.96 2.6-19.22.45-3.61 1.2-6.26 1.2-6.26s-1.26-3.35-10.06-3.17zM75.54 4.8c11.26.42 15.1 5.41 16.19 8.31 1.2 3.17 2.25 14.48.49 22.03-1.43 6.16-3.59 9.29-8.66 9.08-4.64-.19-6.99-6.88-10.49-15.98-3.38-8.8-5.97-16.68-6.41-17.81-.56-1.48-1.76-2.11-1.76-2.11s2.25-3.84 10.64-3.52z"
                    ></path>
                    <path
                      fill="#d27856"
                      d="M62.66 27.67c-5.56.35-8.22 6.53-7.04 12.74 1.27 6.69 5.66 9.86 11.19 9.15 6.05-.77 7.88-7.67 7.11-12.88-.71-4.74-3.39-9.51-11.26-9.01z"
                    ></path>
                    <path
                      fill="#060401"
                      d="M69.2 39c0 2.92-1.62 5.36-4.19 5.29-3.49-.1-4.4-3.19-4.33-5.79.08-3.04 1.9-4.48 4.5-4.41 2.32.05 4.02 1.99 4.02 4.91zM39.85 40.61c0 3.04-1.62 5.58-4.19 5.5-3.49-.1-4.4-3.32-4.33-6.03.08-3.17 2.25-4.52 4.29-4.37 2.31.17 4.23 1.86 4.23 4.9zM53.22 57.59s6.12-.63 5.84-5.07c-.28-4.43-4.43-4.72-7.67-4.65-3.24.07-7.88 1.76-7.39 5.49.49 3.73 5.77 4.22 5.77 4.22s-.01 2.76-1.83 2.96c-1.97.21-4.79-2.82-5.56-3.59-.77-.77-1.97-.49-2.39.14s-.14 2.04 1.06 3.24 4.01 4.22 6.83 3.94c2.82-.28 2.89-1.76 4.01-1.83 1.13-.07 1.06 1.62 3.87 1.55 1.98-.05 5.97-3.53 6.69-4.15 1.62-1.41 2.04-2.82 1.34-3.73s-2.67.42-3.73 1.2c-1.06.77-2.77 2.59-4.43 2.89-2.76.49-2.41-2.61-2.41-2.61z"
                    ></path>
                    <path
                      fill="#d27856"
                      d="M78.21 50.99s-1.33 2.92-2.44 5.26c-1.34 2.82-3.26 5.28-3.26 5.28s2.17 14.84 15.08 13.56c4.62-.46 8.12-4.08 8.45-7.92.56-6.48-1.9-9.51-5.72-12.47-6.19-4.78-12.11-3.71-12.11-3.71zM69.27 74.2c-2.29 2.1-1.06 6.05 1.97 6.48 3.03.42 4.66-2.1 4.43-4.01-.34-2.96-3.79-4.86-6.4-2.47zM39.36 70.3s-2.02 5.54 2.25 12.48c1.82 2.95 5.87 4.61 8.73 4.5 3.02-.11 5.75-1.16 8.09-4.08 3.73-4.65 2.67-12.39 2.67-12.39s-5.91 2.43-11.33 2.25C44 72.88 39.36 70.3 39.36 70.3zM31.99 112.7c-1.47-.45-2.06 1.83-2.16 3.28s-.09 3.33 1.22 3.8c1.31.47 1.05-2.32 1.17-3.24.24-1.77 1.32-3.37-.23-3.84zM37.76 113.55c-.88-.04-1.81.85-1.92 3.43-.09 2.16 0 3.94 1.22 4.04 1.64.13 1.18-1.97 1.27-3.71.04-.99 1.26-3.67-.57-3.76zM60.15 116.36c-1.41 0-1.45 1.6-1.45 3.33 0 1.74-.36 3.89 1.22 4.08 1.92.23 1.55-2.35 1.55-3.8-.01-1.26.22-3.61-1.32-3.61zM66.53 116.04c-1.13.23-1.03 1.78-.99 3.66.05 1.88-.23 3.87 1.36 3.71 1.36-.14 1.27-2.35 1.22-4.04-.04-1.46.15-3.7-1.59-3.33zM85.86 103.81c-.97-.19-2.07.63-2.35 2.82-.23 1.88-.14 3.53 1.5 3.89.84.19.99-1.97 1.03-3.52.05-1.34 1.04-2.95-.18-3.19zM91.16 104.95c-.93-.15-1.84.42-2.08 2.75-.14 1.36-.64 3.8 1.05 3.89 1.31.06 1.21-2.09 1.33-3.21.19-1.77 1.23-3.17-.3-3.43z"
                    ></path>
                  </svg>
                  <p>Choisissez le Super module qui vous intéresse</p>
                </div>
                {/* sousTitre */}

                <div className="superModule">
                  {/*ici on affiche les supers modules en provenance de notre api */}
                  {filtreApiSuperModule.map((api) => (
                    <>
                      <div onClick={Module}>
                        <EnfantApiSuperModule api={api} />
                      </div>
                    </>
                  ))}
                </div>
                {/* superModule */}
              </div>
              {/* bigCard */}
            </div>
            {/* align-bigCard */}
          </div>
          {/* superModuleVS */}
        </>
      )}
      {/* super module - VS */}

      {/* module - VS */}
      {/* module - VS */}
      {/*dans vixinol store, si l'utilisateur a cliquer sur un super module, on va afficher
      cette page module */}
      {module && (
        <>
          <div className="moduleVS">
            <div className="close">
              <div className="block-un">
                {gratuitSuperModule && (
                  <>
                    <div className="a">
                      <p>{nomSuperModule}</p>
                    </div>
                    {/* a */}

                    <div className="b">
                      <button>Gratuit</button>
                    </div>
                    {/* b */}
                  </>
                )}

                {!gratuitSuperModule && (
                  <>
                    <div className="a">
                      <svg
                        onClick={ModuleAcheter}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="#fff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 12h10M4 18h5"
                        ></path>
                      </svg>
                      <p onClick={ModuleAcheter}>{nomSuperModule}</p>
                    </div>
                    {/* a */}
                  </>
                )}
              </div>
              {/* block-un */}

              <div className="block-deux">
                <svg
                  onClick={CloseModule}
                  xmlns="http://www.w3.org/2000/svg"
                  width="17px"
                  fill="#fff"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 100 100"
                  xmlSpace="preserve"
                >
                  <path d="M78.466 35.559L50.15 63.633 22.078 35.317a2 2 0 00-2.84 2.815L48.432 67.58a1.993 1.993 0 001.727.568c.054.008.106.021.16.022a1.991 1.991 0 001.515-.576l29.447-29.196a1.999 1.999 0 10-2.815-2.839z"></path>
                </svg>
              </div>
              {/* block-deux */}
            </div>
            {/* close */}

            <div className="sousTitre">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25px"
                fill="blue"
                viewBox="0 0 32 32"
              >
                <path d="M27.783 7.936a6.377 6.377 0 01-1.379 6.955c-2.071 2.071-5.201 2.395-7.634 1.022l-1.759 1.921 1.255 1.26.75-.75a.98.98 0 011.388 0l6.082 6.144a.98.98 0 010 1.388l-2.776 2.776a.98.98 0 01-1.388 0l-6.082-6.144a.98.98 0 010-1.388l.685-.685-1.196-1.199-8.411 9.189a1.962 1.962 0 01-2.776 0l-.694-.694a1.962 1.962 0 010-2.776l9.582-8.025-6.364-6.381-2.01-.001-2.326-3.74 1.872-1.875 3.825 2.341.025 1.968 6.438 6.463 1.873-1.568c-1.831-2.496-1.64-6.012.616-8.268a6.382 6.382 0 016.925-1.396L20.18 8.54l3.471 3.471 4.132-4.075zM6.15 25.934a.982.982 0 10-1.388 1.39.982.982 0 001.388-1.39z"></path>
              </svg>
              <p>Acheter votre module préféré</p>
            </div>
            {/* sousTitre */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            <div className="align-bigCard">
              <div className="bigCard">
                {/*ici on les modules en provenance de notre api */}
                <div className="module">
                  {filtreApiModule.map((api) => (
                    <>
                      <div onClick={DetailModule}>
                        <EnfantApiModule api={api} />
                      </div>
                    </>
                  ))}
                </div>
                {/* module */}
              </div>
              {/* bigCard */}
            </div>
            {/* align-bigCard */}
          </div>
          {/* moduleVS */}
        </>
      )}
      {/* module - VS */}

      {/* moduleAcheter - VS */}
      {/* moduleAcheter - VS */}
      {/*sur cette page on va afficher tout les modules que la personne connecter a acheter*/}
      {moduleAcheter && (
        <>
          <div className="moduleAcheterVS">
            <div className="close">
              <div className="a">
                <svg
                  onClick={CloseModuleAcheter}
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  width="20px"
                  cursor="pointer"
                  fill="#000"
                  enableBackground="new 0 0 486.975 486.975"
                  version="1.1"
                  viewBox="0 0 486.975 486.975"
                  xmlSpace="preserve"
                >
                  <path d="M473.475 230.025h-427.4l116-116c5.3-5.3 5.3-13.8 0-19.1-5.3-5.3-13.8-5.3-19.1 0l-139 139c-5.3 5.3-5.3 13.8 0 19.1l139 139c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-116-116h427.5c7.5 0 13.5-6 13.5-13.5s-6-13.4-13.5-13.4z"></path>
                </svg>
                <p>Module(s) acheté(s)</p>
              </div>

              <div className="b">
                <svg
                  onClick={DetailModule}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  fill="#000"
                  cursor="pointer"
                  version="1.1"
                  viewBox="0 0 484.955 484.955"
                  xmlSpace="preserve"
                >
                  <path d="M145.005 318.355h268.9c29.7 0 53.8-24.2 53.8-53.8v-113.3c0-6.6-5.4-12-12-12s-12 5.4-12 12v113.2c0 16.5-13.4 29.8-29.8 29.8h-268.9c-16.5 0-29.8-13.4-29.8-29.8v-221.2c0-.4 0-.8-.1-1.3v-.3c0-.3-.1-.6-.1-.8s-.1-.5-.2-.7c0-.1-.1-.3-.1-.4-.1-.3-.2-.5-.3-.7 0-.1-.1-.2-.1-.4-.1-.2-.2-.4-.3-.7-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5-.1-.2-.2-.3-.3-.5-.1-.1-.2-.3-.3-.4-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.2-.3-.2-.2-.3-.4-.5-.6-.1-.1-.2-.1-.2-.2l-.6-.6c-.1-.1-.2-.2-.3-.2-.2-.2-.4-.3-.6-.5-.2-.1-.4-.3-.7-.4-.1-.1-.2-.1-.3-.2-.4-.2-.8-.4-1.1-.6l-74.1-31c-6.1-2.6-13.1.3-15.7 6.4-2.6 6 .3 13.1 6.4 15.7l66.5 28.1v297.6c0 28.2 21.7 51.3 49.3 53.6-5.6 8.4-8.9 18.5-8.9 29.4 0 29.3 23.9 53.2 53.2 53.2s53.2-23.9 53.2-53.2c0-10.8-3.2-20.8-8.7-29.2h127.3c-5.5 8.4-8.7 18.4-8.7 29.2 0 29.3 23.9 53.2 53.2 53.2s53.2-23.9 53.2-53.2-23.9-53.2-53.2-53.2h-256c-16.5 0-29.8-13.4-29.8-29.8v-39.5c8.5 5.7 18.8 9.1 29.8 9.1zm68.9 113.4c0 16.1-13.1 29.2-29.2 29.2s-29.2-13.1-29.2-29.2 13.1-29.2 29.2-29.2 29.2 13.1 29.2 29.2zm216.2 0c0 16.1-13.1 29.2-29.2 29.2s-29.2-13.1-29.2-29.2 13.1-29.2 29.2-29.2 29.2 13.1 29.2 29.2z"></path>
                  <path d="M270.805 241.655s0 .1 0 0c.3.3.6.6.9.8.1.1.3.2.4.3.2.1.3.3.5.4s.4.2.5.3c.2.1.3.2.5.3.2.1.4.2.5.3.2.1.3.2.5.2.2.1.4.1.5.2.2.1.4.1.6.2s.4.1.5.1c.2 0 .4.1.6.1s.4.1.6.1.3.1.5.1c.4 0 .8.1 1.2.1s.8 0 1.2-.1c.2 0 .4-.1.5-.1.2 0 .4-.1.6-.1s.4-.1.6-.1.4-.1.6-.1c.2-.1.4-.1.6-.2s.4-.1.5-.2c.2-.1.3-.2.5-.2l.6-.3c.2-.1.3-.2.5-.3.2-.1.4-.2.5-.3.2-.1.3-.2.5-.4.2-.1.3-.2.5-.3.3-.2.5-.5.8-.7l.1-.1 47.6-47.6c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0l-27.1 27.1v-166.2c0-6.6-5.4-12-12-12s-12 5.4-12 12v166.2l-27-27c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17l47.6 47.5z"></path>
                </svg>
              </div>
              {/* b */}
            </div>
            {/* close */}

            <div className="titre">
              <p>{nomModuleGeneral}</p>
            </div>
            {/* titre */}

            <div className="hr">
              <hr />
            </div>
            {/* hr */}

            {/*ici on affiche les supers modules en provenance de notre api */}
            <div className="detailAchat">
              {filtreApiModuleAcheter.map((api) => (
                <>
                  <div className="card">
                    <div className="a">
                      <p>Achat éffectué</p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        fill="#000"
                        version="1.1"
                        viewBox="0 0 352.62 352.62"
                        xmlSpace="preserve"
                      >
                        <path d="M337.222 22.952c-15.912-8.568-33.66 7.956-44.064 17.748-23.867 23.256-44.063 50.184-66.708 74.664-25.092 26.928-48.348 53.856-74.052 80.173-14.688 14.688-30.6 30.6-40.392 48.96-22.032-21.421-41.004-44.677-65.484-63.648C28.774 167.385-.602 157.593.01 190.029c1.224 42.229 38.556 87.517 66.096 116.28 11.628 12.24 26.928 25.092 44.676 25.704 21.42 1.224 43.452-24.48 56.304-38.556 22.645-24.48 41.005-52.021 61.812-77.112 26.928-33.048 54.468-65.485 80.784-99.145 16.524-20.808 68.544-72.217 27.54-94.248zM26.937 187.581c-.612 0-1.224 0-2.448.611-2.448-.611-4.284-1.224-6.732-2.448 1.836-1.224 4.896-.612 9.18 1.837z"></path>
                      </svg>
                    </div>

                    <div className="b">
                      <p>Date : 10/09/2024</p>
                      <p>Validité : {api.validiter}</p>
                    </div>
                    {/* b */}

                    {/* on affiche ca si son abonnement est terminer ou si son abonnenent 
                    n'est plus valide.
                    si terminer=1, cela veut dire que l'abonnement au module qu'il a acheter 
                    est terminer */}
                    {api.terminer === "1" && (
                      <>
                        <div className="c">
                          <button>
                            <p>Abonnement Terminé</p>
                            <hr />
                          </button>
                        </div>
                        {/* c */}
                      </>
                    )}
                  </div>
                  {/* card */}
                </>
              ))}
            </div>
            {/* detailAchat */}
          </div>
          {/* moduleAcheterVS */}
        </>
      )}
      {/* moduleAcheter - VS */}

      {/* detail module - VS */}
      {/* ici on affiche les details du module */}
      {detailModule && (
        <>
          <div className="detailModuleVS">
            <div className="align">
              <div className="card">
                <div className="close">
                  <div className="a">
                    {typeDabonnement === "1" && (
                      <>
                        <p onClick={AbonnementAnnuel}>Annuel</p>
                        <svg
                          onClick={AbonnementAnnuel}
                          xmlns="http://www.w3.org/2000/svg"
                          x="0"
                          y="0"
                          width="7px"
                          cursor="pointer"
                          fill="#000"
                          enableBackground="new 0 0 477.175 477.175"
                          version="1.1"
                          viewBox="0 0 477.175 477.175"
                          xmlSpace="preserve"
                        >
                          <path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"></path>
                        </svg>
                      </>
                    )}
                  </div>
                  {/* a */}

                  <div className="b">
                    <svg
                      onClick={CloseDetailModule}
                      xmlns="http://www.w3.org/2000/svg"
                      width="15px"
                      fill="#000"
                      cursor="pointer"
                      version="1.1"
                      viewBox="0 0 100 100"
                      xmlSpace="preserve"
                    >
                      <path d="M78.466 35.559L50.15 63.633 22.078 35.317a2 2 0 00-2.84 2.815L48.432 67.58a1.993 1.993 0 001.727.568c.054.008.106.021.16.022a1.991 1.991 0 001.515-.576l29.447-29.196a1.999 1.999 0 10-2.815-2.839z"></path>
                    </svg>
                  </div>
                  {/* b */}
                </div>
                {/* close */}

                <div className="block-un">
                  <p>{nomModule}</p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <div className="a">
                    <p>{descModule}</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <button>Acheter</button>
                  </div>
                  {/* b */}

                  <div className="c">
                    <p>{prixModule}</p>
                  </div>
                  {/* c */}
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* detailModuleVS */}
        </>
      )}
      {/* detail module - VS */}

      {/* abonnementAnnuel - VS */}
      {/* abonnementAnnuel - VS */}
      {/* ici on affiche le card qui va permetre a la personne d'acheter 
      son abonnement annuel */}
      {abonnementAnnuel && (
        <>
          <div className="abonnementAnnuelVS">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p>{nomModule}</p>
                  <svg
                    onClick={CloseAbonnementAnnuel}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#444"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-deux">
                  <div className="a">
                    <p>{descAnnuelModule}</p>
                  </div>
                  {/* a */}

                  <div className="b">
                    <button>Acheter</button>
                  </div>
                  {/* b */}

                  <div className="c">
                    <p>{prixAnnuelModule}</p>
                  </div>
                  {/* c */}
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* abonnementAnnuelVS */}
        </>
      )}
      {/* abonnementAnnuel - VS */}

      {/* Profil - VS */}
      {/* Profil - VS */}
      {/*on affiche le profil de la personne connecter sur vixinol Store - VS */}
      {profilVS && (
        <>
          <div className="profilVS">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p></p>
                  <svg
                    onClick={CloseProfilVS}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    cursor="pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h12"
                    ></path>
                  </svg>
                </div>
                {/* close */}

                <div className="hr">
                  <hr />
                </div>
                {/* hr */}

                <div className="block-deux">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      d="M12 1a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM8.5 6.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
                      clipRule="evenodd"
                    ></path>
                    <path
                      fill="#fff"
                      d="M8 14a6 6 0 00-6 6v2a1 1 0 102 0v-2a4 4 0 014-4h8a4 4 0 014 4v2a1 1 0 102 0v-2a6 6 0 00-6-6H8z"
                    ></path>
                  </svg>
                  <p>{namePersonConnectedVS}</p>
                </div>
                {/* block-deux */}

                <div className="block-trois">
                  <button>
                    <div className="a">
                      <p onClick={DeconnexionVS}>Se déconnecter</p>
                      <svg
                        onClick={DeconnexionVS}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        cursor="pointer"
                        fill="#fff"
                        viewBox="0 0 24 24"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z"></path>
                      </svg>
                    </div>
                    {/* a */}

                    <div className="b">
                      <hr onClick={DeconnexionVS} />
                    </div>
                    {/* b */}
                  </button>
                </div>
                {/* block-trois */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* profilVS */}
        </>
      )}
      {/* Profil - VS */}

      {/* deconnexion - VS */}
      {/* deconnexion - VS */}
      {/*on affiche la page qui va permettre a l'utilisateur de se deconnecter de
      son compte Vixinol store */}
      {deconnexionVS && (
        <>
          <div className="deconnexionVS">
            <div className="align">
              <div className="card">
                <div className="close">
                  <p></p>
                  <svg
                    onClick={CloseDeconnexionVS}
                    xmlns="http://www.w3.org/2000/svg"
                    width="15px"
                    fill="#000"
                    cursor="pointer"
                    version="1.1"
                    viewBox="0 0 100 100"
                    xmlSpace="preserve"
                  >
                    <path d="M78.466 35.559L50.15 63.633 22.078 35.317a2 2 0 00-2.84 2.815L48.432 67.58a1.993 1.993 0 001.727.568c.054.008.106.021.16.022a1.991 1.991 0 001.515-.576l29.447-29.196a1.999 1.999 0 10-2.815-2.839z"></path>
                  </svg>
                </div>
                {/* close */}

                <div className="block-un">
                  <p>
                    Votre compte Vixinol Store contribue grandement au bon
                    foncionnement de votre téléphone virtuel. Si vous vous
                    déconnecter vous pourrez rencontrer des difficultés lors de
                    l'utilisation de certaines applications virtuelles
                  </p>
                </div>
                {/* block-un */}

                <div className="block-deux">
                  <button>Se déconnecter</button>
                </div>
                {/* block-deux */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* deconnexionVS */}
        </>
      )}
      {/* deconnexion - VS */}

      {/* erreur - VS */}
      {/* erreur - VS */}
      {/* si jamais il ya une erreur qui sest produite quelque part dans l'app vixinol,
            on pourra afficher cette page en fonction du type d'erreur */}
      {erreurVS && (
        <>
          <div onClick={CloseErreurVS} className="erreurVS">
            <div className="align">
              <div className="card">
                <div className="hr">
                  <hr />
                </div>

                <div className="a">
                  <p>{t("--an error has occurred")}</p>
                </div>
                {/* a */}

                <div className="b">
                  <p>{t("--try again")}</p>
                </div>
                {/* b */}
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurVS */}
        </>
      )}
      {/* erreur - VS */}

      {/* other app */}
      {/* other app */} 
      {/* ca c'est les test que je faisais, pour permettre aux autres aussi de publier leur applications  */}
      {otherApp && (
        <>
          <div className="otherApp">
            <div onClick={CloseOtherApp} className="close">
              <p></p>
            </div>
            {/* align */}

            <div className="application">
              <iframe
                src="https://omisify.netlify.app/"
                title="application virtuelle iframe"
              ></iframe>
            </div>
            {/* application */}
          </div>
          {/* otherApp */}
        </>
      )}
      {/* other app */}

      {/* erreur - IA */}
      {/* erreur - IA */}
      {/* on affiche ce message d'erreur si une erreur est rencontrer par exemple
      lorsque le collaborateur ajoute un pays, une langue,... et que ca ne fonctionne pas 
      pour telle ou telle raison alors ce message d'erreur s'affichera */}
      {erreurRencontrerIA && (
        <>
          <div onClick={CloseErreurRencontrerIA} className="erreurIAC">
            <div className="align">
              <div className="card">
                <p>Une erreur s'est produite. Réessayer !</p>
              </div>
              {/* card */}
            </div>
            {/* align */}
          </div>
          {/* erreurIAC */}
        </>
      )}
      {/* erreur - IA */}


      {/* erreur */}
      {/* erreur */}
      {erreur && (<>
        <div onClick={Erreur} className="page-general-opacity">
          <div className="align">
            <div className="card">
              <div className="center">
                <p>Vérifier votre connexion internet !</p>
              </div>
              {/* center */}
            </div>
            {/* card */}
          </div>
          {/* align */}
        </div>
        {/* page-general-opacity */}
      </>)}
      {/* erreur */}


      {/* erreur2 */}
      {/* erreur2 */}
      {erreur2 && (<>
        <div onClick={CloseErreur2} className="erreurIAC">
          <div className="align">
            <div className="card">
              <p>Une erreur s'est produite. Réessayer plus tard !</p>
            </div>
            {/* card */}
          </div>
          {/* align */}
        </div>
        {/* erreurIAC */}
      </>)}
      {/* erreur2 */}


      {/* opacity */}
      {/* opacity */}
      {opacity && (
        <>
          <div className="popup-notice-background">
            <div className="align">
              <p></p>
            </div>
          </div>
        </>
      )}
      {/* opacity */}

      {/* 
      Vos informations - informations de One Topzer

      Toutes vos vidéos publiées - Toutes les vidéos publiées par One Topzer
      */}

      {/* Sauvegarde réussie ! */}
    </>
  )
}
